/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		2:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({"0":"datacenter","1":"shortcode"}[chunkId]||chunkId) + "-2.0.88.bundle.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/wp-content/themes/kff-org-modern/static/js/apps/datacenter";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(152);
	__webpack_require__(156);
	__webpack_require__(157);
	__webpack_require__(159);
	__webpack_require__(111);
	__webpack_require__(13);
	__webpack_require__(77);
	__webpack_require__(95);
	__webpack_require__(94);
	__webpack_require__(158);
	__webpack_require__(14);
	__webpack_require__(72);
	__webpack_require__(19);
	__webpack_require__(84);
	__webpack_require__(54);
	__webpack_require__(96);
	__webpack_require__(12);
	module.exports = __webpack_require__(148);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports) {

	module.exports = angular;

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// ag-grid v5.4.0
	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.agGrid=t():e.agGrid=t()}(this,function(){return function(e){function t(i){if(o[i])return o[i].exports;var n=o[i]={exports:{},id:i,loaded:!1};return e[i].call(n.exports,n,n.exports,t),n.loaded=!0,n.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){var i=o(1).populateClientExports;i(t)},function(e,t,o){function i(e){e.BalancedColumnTreeBuilder=m.BalancedColumnTreeBuilder,e.ColumnController=a.ColumnController,e.ColumnKeyCreator=E.ColumnKeyCreator,e.ColumnUtils=A.ColumnUtils,e.DisplayedGroupCreator=w.DisplayedGroupCreator,e.GroupInstanceIdCreator=R.GroupInstanceIdCreator,e.ComponentUtil=l.ComponentUtil,e.initialiseAgGridWithAngular1=p.initialiseAgGridWithAngular1,e.initialiseAgGridWithWebComponents=d.initialiseAgGridWithWebComponents,e.Context=S.Context,e.Autowired=S.Autowired,e.PostConstruct=S.PostConstruct,e.PreDestroy=S.PreDestroy,e.Optional=S.Optional,e.Bean=S.Bean,e.Qualifier=S.Qualifier,e.Listener=Ie.Listener,e.QuerySelector=Ie.QuerySelector,e.DragAndDropService=O.DragAndDropService,e.DragService=N.DragService,e.DragSourceType=O.DragSourceType,e.Column=f.Column,e.ColumnGroup=g.ColumnGroup,e.GridCell=u.GridCell,e.GridRow=ye.GridRow,e.OriginalColumnGroup=h.OriginalColumnGroup,e.RowNode=c.RowNode,e.FilterManager=T.FilterManager,e.NumberFilter=D.NumberFilter,e.TextFilter=G.TextFilter,e.GridPanel=P.GridPanel,e.MouseEventService=b.MouseEventService,e.BodyDropPivotTarget=Me.BodyDropPivotTarget,e.BodyDropTarget=_e.BodyDropTarget,e.CssClassApplier=F.CssClassApplier,e.HeaderContainer=I.HeaderContainer,e.HeaderRenderer=L.HeaderRenderer,e.HeaderRowComp=Ve.HeaderRowComp,e.HeaderTemplateLoader=M.HeaderTemplateLoader,e.HorizontalDragService=_.HorizontalDragService,e.MoveColumnController=W.MoveColumnController,e.RenderedHeaderCell=U.RenderedHeaderCell,e.RenderedHeaderGroupCell=x.RenderedHeaderGroupCell,e.StandardMenuFactory=V.StandardMenuFactory,e.BorderLayout=B.BorderLayout,e.TabbedLayout=H.TabbedLayout,e.VerticalStack=k.VerticalStack,e.FocusService=We.FocusService,e.LargeTextCellEditor=Te.LargeTextCellEditor,e.PopupEditorWrapper=we.PopupEditorWrapper,e.PopupSelectCellEditor=Re.PopupSelectCellEditor,e.PopupTextCellEditor=Se.PopupTextCellEditor,e.SelectCellEditor=Oe.SelectCellEditor,e.TextCellEditor=Ne.TextCellEditor,e.AnimateShowChangeCellRenderer=Be.AnimateShowChangeCellRenderer,e.AnimateSlideCellRenderer=Ee.AnimateSlideCellRenderer,e.GroupCellRenderer=Ge.GroupCellRenderer,e.SetLeftFeature=Ue.SetLeftFeature,e.AutoWidthCalculator=j.AutoWidthCalculator,e.CellEditorFactory=Ae.CellEditorFactory,e.RenderedHeaderCell=U.RenderedHeaderCell,e.CellRendererFactory=De.CellRendererFactory,e.CellRendererService=Pe.CellRendererService,e.CheckboxSelectionComponent=Fe.CheckboxSelectionComponent,e.RenderedCell=xe.RenderedCell,e.RenderedRow=Y.RenderedRow,e.RowRenderer=Z.RowRenderer,e.ValueFormatterService=be.ValueFormatterService,e.FilterStage=Q.FilterStage,e.FlattenStage=z.FlattenStage,e.InMemoryRowModel=ve.InMemoryRowModel,e.SortStage=J.SortStage,e.InMemoryNodeManager=He.InMemoryNodeManager,e.FloatingRowModel=X.FloatingRowModel,e.PaginationController=q.PaginationController,e.VirtualPageRowModel=Ce.VirtualPageRowModel,e.VirtualPageCache=ke.VirtualPageCache,e.VirtualPage=je.VirtualPage,e.AgCheckbox=Le.AgCheckbox,e.Component=K.Component,e.PopupService=fe.PopupService,e.MenuItemComponent=me.MenuItemComponent,e.MenuList=$.MenuList,e.Listener=Ie.Listener,e.QuerySelector=Ie.QuerySelector,e.CellNavigationService=ee.CellNavigationService,e.ColumnChangeEvent=te.ColumnChangeEvent,e.Constants=oe.Constants,e.CsvCreator=ie.CsvCreator,e.Events=s.Events,e.EventService=ne.EventService,e.ExpressionService=re.ExpressionService,e.FocusedCellController=y.FocusedCellController,e.defaultGroupComparator=v.defaultGroupComparator,e.Grid=n.Grid,e.GridApi=r.GridApi,e.GridCore=se.GridCore,e.GridOptionsWrapper=C.GridOptionsWrapper,e.Logger=le.Logger,e.MasterSlaveService=ae.MasterSlaveService,e.SelectionController=pe.SelectionController,e.CheckboxSelectionComponent=Fe.CheckboxSelectionComponent,e.SortController=de.SortController,e.SvgFactory=ue.SvgFactory,e.TemplateService=ce.TemplateService,e.Utils=he.Utils,e.NumberSequence=he.NumberSequence,e.ValueService=ge.ValueService}/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var n=o(2),r=o(11),s=o(10),l=o(9),a=o(13),p=o(92),d=o(93),u=o(33),c=o(27),h=o(17),g=o(14),f=o(15),y=o(35),v=o(78),C=o(3),m=o(19),E=o(20),A=o(16),w=o(21),R=o(77),S=o(6),O=o(66),N=o(31),T=o(43),D=o(46),G=o(45),P=o(24),b=o(32),F=o(70),I=o(65),L=o(64),M=o(72),_=o(69),W=o(74),U=o(71),x=o(68),V=o(80),B=o(30),H=o(94),k=o(95),j=o(22),Y=o(37),Z=o(23),Q=o(81),z=o(83),J=o(82),X=o(26),q=o(41),K=o(47),$=o(96),ee=o(63),te=o(76),oe=o(8),ie=o(12),ne=o(4),re=o(18),se=o(40),le=o(5),ae=o(25),pe=o(28),de=o(42),ue=o(58),ce=o(36),he=o(7),ge=o(29),fe=o(44),ye=o(34),ve=o(87),Ce=o(84),me=o(97),Ee=o(55),Ae=o(48),we=o(51),Re=o(53),Se=o(52),Oe=o(50),Ne=o(49),Te=o(91),De=o(54),Ge=o(57),Pe=o(59),be=o(60),Fe=o(61),Ie=o(90),Le=o(89),Me=o(75),_e=o(73),We=o(39),Ue=o(62),xe=o(38),Ve=o(67),Be=o(56),He=o(88),ke=o(85),je=o(86);t.populateClientExports=i},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(3),n=o(41),r=o(26),s=o(28),l=o(13),a=o(23),p=o(64),d=o(43),u=o(29),c=o(25),h=o(4),g=o(79),f=o(24),y=o(11),v=o(72),C=o(19),m=o(21),E=o(18),A=o(36),w=o(44),R=o(5),S=o(16),O=o(22),N=o(69),T=o(6),D=o(12),G=o(40),P=o(80),b=o(66),F=o(31),I=o(42),L=o(35),M=o(32),_=o(63),W=o(7),U=o(81),x=o(82),V=o(83),B=o(39),H=o(48),k=o(10),j=o(84),Y=o(87),Z=o(54),Q=o(59),z=o(60),J=o(89),X=o(91),q=function(){function e(t,o,j,Y,q,K){void 0===j&&(j=null),void 0===Y&&(Y=null),void 0===q&&(q=null),void 0===K&&(K=null),t||console.error("ag-Grid: no div element provided to the grid"),o||console.error("ag-Grid: no gridOptions provided to the grid");var $=this.getRowModelClass(o),ee=W.Utils.exists(e.enterpriseBeans);this.context=new T.Context({overrideBeans:e.enterpriseBeans,seed:{enterprise:ee,gridOptions:o,eGridDiv:t,$scope:Y,$compile:q,quickFilterOnScope:K,globalEventListener:j},beans:[$,Z.CellRendererFactory,N.HorizontalDragService,v.HeaderTemplateLoader,r.FloatingRowModel,F.DragService,m.DisplayedGroupCreator,h.EventService,i.GridOptionsWrapper,s.SelectionController,d.FilterManager,l.ColumnController,a.RowRenderer,p.HeaderRenderer,E.ExpressionService,C.BalancedColumnTreeBuilder,D.CsvCreator,A.TemplateService,f.GridPanel,w.PopupService,u.ValueService,c.MasterSlaveService,R.LoggerFactory,g.OldToolPanelDragAndDropService,S.ColumnUtils,O.AutoWidthCalculator,y.GridApi,n.PaginationController,w.PopupService,G.GridCore,P.StandardMenuFactory,b.DragAndDropService,I.SortController,l.ColumnApi,L.FocusedCellController,M.MouseEventService,_.CellNavigationService,U.FilterStage,x.SortStage,V.FlattenStage,B.FocusService,H.CellEditorFactory,Q.CellRendererService,z.ValueFormatterService],components:[{componentName:"AgCheckbox",theClass:J.AgCheckbox}],debug:!!o.debug}),this.context.getBean("cellEditorFactory").addCellEditor(e.LARGE_TEXT,X.LargeTextCellEditor);var te=this.context.getBean("eventService"),oe={api:o.api,columnApi:o.columnApi};te.dispatchEvent(k.Events.EVENT_GRID_READY,oe),o.debug&&console.log("ag-Grid -> initialised successfully, enterprise = "+ee)}return e.setEnterpriseBeans=function(t,o){this.enterpriseBeans=t,W.Utils.iterateObject(o,function(t,o){return e.RowModelClasses[t]=o})},e.prototype.getRowModelClass=function(t){var o=t.rowModelType;if(W.Utils.exists(o)){var i=e.RowModelClasses[o];if(W.Utils.exists(i))return i;console.error("ag-Grid: count not find matching row model for rowModelType "+o),"viewport"===o&&console.error("ag-Grid: rowModelType viewport is only available in ag-Grid Enterprise")}return Y.InMemoryRowModel},e.prototype.destroy=function(){this.context.destroy()},e.LARGE_TEXT="largeText",e.RowModelClasses={virtual:j.VirtualPageRowModel,pagination:Y.InMemoryRowModel},e}();t.Grid=q},function(e,t,o){function i(e){return e===!0||"true"===e}function n(e,t){return e>0?e:t}/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var r=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},s=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},l=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},a=o(4),p=o(8),d=o(9),u=o(11),c=o(6),h=o(13),g=o(7),f=25,y=5,v=5,C=function(){function e(){this.propertyEventService=new a.EventService}return e.prototype.agWire=function(e,t){this.gridOptions.api=e,this.gridOptions.columnApi=t,this.checkForDeprecated()},e.prototype.destroy=function(){this.gridOptions.api=null,this.gridOptions.columnApi=null},e.prototype.init=function(){this.eventService.addGlobalListener(this.globalEventHandler.bind(this)),this.isGroupSelectsChildren()&&this.isSuppressParentsInRowNodes()&&console.warn("ag-Grid: groupSelectsChildren does not work wth suppressParentsInRowNodes, this selection method needs the part in rowNode to work"),this.isGroupSelectsChildren()&&!this.isRowSelectionMulti()&&console.warn("ag-Grid: rowSelectionMulti must be true for groupSelectsChildren to make sense")},e.prototype.isEnterprise=function(){return this.enterprise},e.prototype.isRowSelection=function(){return"single"===this.gridOptions.rowSelection||"multiple"===this.gridOptions.rowSelection},e.prototype.isRowDeselection=function(){return i(this.gridOptions.rowDeselection)},e.prototype.isRowSelectionMulti=function(){return"multiple"===this.gridOptions.rowSelection},e.prototype.getContext=function(){return this.gridOptions.context},e.prototype.isPivotMode=function(){return i(this.gridOptions.pivotMode)},e.prototype.isRowModelPagination=function(){return this.gridOptions.rowModelType===p.Constants.ROW_MODEL_TYPE_PAGINATION},e.prototype.isRowModelVirtual=function(){return this.gridOptions.rowModelType===p.Constants.ROW_MODEL_TYPE_VIRTUAL},e.prototype.isRowModelViewport=function(){return this.gridOptions.rowModelType===p.Constants.ROW_MODEL_TYPE_VIEWPORT},e.prototype.isRowModelDefault=function(){return!(this.isRowModelPagination()||this.isRowModelVirtual()||this.isRowModelViewport())},e.prototype.isSuppressFocusAfterRefresh=function(){return i(this.gridOptions.suppressFocusAfterRefresh)},e.prototype.isShowToolPanel=function(){return i(this.gridOptions.showToolPanel)},e.prototype.isToolPanelSuppressRowGroups=function(){return i(this.gridOptions.toolPanelSuppressRowGroups)},e.prototype.isToolPanelSuppressValues=function(){return i(this.gridOptions.toolPanelSuppressValues)},e.prototype.isToolPanelSuppressPivots=function(){return i(this.gridOptions.toolPanelSuppressPivots)},e.prototype.isToolPanelSuppressPivotMode=function(){return i(this.gridOptions.toolPanelSuppressPivotMode)},e.prototype.isEnableCellChangeFlash=function(){return i(this.gridOptions.enableCellChangeFlash)},e.prototype.isGroupSelectsChildren=function(){return i(this.gridOptions.groupSelectsChildren)},e.prototype.isGroupIncludeFooter=function(){return i(this.gridOptions.groupIncludeFooter)},e.prototype.isGroupSuppressBlankHeader=function(){return i(this.gridOptions.groupSuppressBlankHeader)},e.prototype.isSuppressRowClickSelection=function(){return i(this.gridOptions.suppressRowClickSelection)},e.prototype.isSuppressCellSelection=function(){return i(this.gridOptions.suppressCellSelection)},e.prototype.isSuppressMultiSort=function(){return i(this.gridOptions.suppressMultiSort)},e.prototype.isGroupSuppressAutoColumn=function(){return i(this.gridOptions.groupSuppressAutoColumn)},e.prototype.isSuppressDragLeaveHidesColumns=function(){return i(this.gridOptions.suppressDragLeaveHidesColumns)},e.prototype.isForPrint=function(){return i(this.gridOptions.forPrint)},e.prototype.isSuppressHorizontalScroll=function(){return i(this.gridOptions.suppressHorizontalScroll)},e.prototype.isSuppressLoadingOverlay=function(){return i(this.gridOptions.suppressLoadingOverlay)},e.prototype.isSuppressNoRowsOverlay=function(){return i(this.gridOptions.suppressNoRowsOverlay)},e.prototype.isSuppressFieldDotNotation=function(){return i(this.gridOptions.suppressFieldDotNotation)},e.prototype.getFloatingTopRowData=function(){return this.gridOptions.floatingTopRowData},e.prototype.getFloatingBottomRowData=function(){return this.gridOptions.floatingBottomRowData},e.prototype.isFunctionsPassive=function(){return i(this.gridOptions.functionsPassive)},e.prototype.getQuickFilterText=function(){return this.gridOptions.quickFilterText},e.prototype.isUnSortIcon=function(){return i(this.gridOptions.unSortIcon)},e.prototype.isSuppressMenuHide=function(){return i(this.gridOptions.suppressMenuHide)},e.prototype.getRowStyle=function(){return this.gridOptions.rowStyle},e.prototype.getRowClass=function(){return this.gridOptions.rowClass},e.prototype.getRowStyleFunc=function(){return this.gridOptions.getRowStyle},e.prototype.getRowClassFunc=function(){return this.gridOptions.getRowClass},e.prototype.getDoesDataFlowerFunc=function(){return this.gridOptions.doesDataFlower},e.prototype.getIsFullWidthCellFunc=function(){return this.gridOptions.isFullWidthCell},e.prototype.getFullWidthCellRenderer=function(){return this.gridOptions.fullWidthCellRenderer},e.prototype.getFullWidthCellRendererParams=function(){return this.gridOptions.fullWidthCellRendererParams},e.prototype.getBusinessKeyForNodeFunc=function(){return this.gridOptions.getBusinessKeyForNode},e.prototype.getHeaderCellRenderer=function(){return this.gridOptions.headerCellRenderer},e.prototype.getApi=function(){return this.gridOptions.api},e.prototype.getColumnApi=function(){return this.gridOptions.columnApi},e.prototype.isEnableColResize=function(){return i(this.gridOptions.enableColResize)},e.prototype.isSingleClickEdit=function(){return i(this.gridOptions.singleClickEdit)},e.prototype.getGroupDefaultExpanded=function(){return this.gridOptions.groupDefaultExpanded},e.prototype.getAutoSizePadding=function(){return this.gridOptions.autoSizePadding},e.prototype.getMaxConcurrentDatasourceRequests=function(){return this.gridOptions.maxConcurrentDatasourceRequests},e.prototype.getMaxPagesInCache=function(){return this.gridOptions.maxPagesInCache},e.prototype.getPaginationOverflowSize=function(){return this.gridOptions.paginationOverflowSize},e.prototype.getPaginationPageSize=function(){return this.gridOptions.paginationPageSize},e.prototype.getPaginationInitialRowCount=function(){return this.gridOptions.paginationInitialRowCount},e.prototype.getRowData=function(){return this.gridOptions.rowData},e.prototype.isGroupUseEntireRow=function(){return i(this.gridOptions.groupUseEntireRow)},e.prototype.getGroupColumnDef=function(){return this.gridOptions.groupColumnDef},e.prototype.isGroupSuppressRow=function(){return i(this.gridOptions.groupSuppressRow)},e.prototype.getRowGroupPanelShow=function(){return this.gridOptions.rowGroupPanelShow},e.prototype.getPivotPanelShow=function(){return this.gridOptions.pivotPanelShow},e.prototype.isAngularCompileRows=function(){return i(this.gridOptions.angularCompileRows)},e.prototype.isAngularCompileFilters=function(){return i(this.gridOptions.angularCompileFilters)},e.prototype.isAngularCompileHeaders=function(){return i(this.gridOptions.angularCompileHeaders)},e.prototype.isDebug=function(){return i(this.gridOptions.debug)},e.prototype.getColumnDefs=function(){return this.gridOptions.columnDefs},e.prototype.getDatasource=function(){return this.gridOptions.datasource},e.prototype.getViewportDatasource=function(){return this.gridOptions.viewportDatasource},e.prototype.isEnableSorting=function(){return i(this.gridOptions.enableSorting)||i(this.gridOptions.enableServerSideSorting)},e.prototype.isEnableCellExpressions=function(){return i(this.gridOptions.enableCellExpressions)},e.prototype.isSuppressMiddleClickScrolls=function(){return i(this.gridOptions.suppressMiddleClickScrolls)},e.prototype.isSuppressPreventDefaultOnMouseWheel=function(){return i(this.gridOptions.suppressPreventDefaultOnMouseWheel)},e.prototype.isEnableServerSideSorting=function(){return i(this.gridOptions.enableServerSideSorting)},e.prototype.isSuppressColumnVirtualisation=function(){return i(this.gridOptions.suppressColumnVirtualisation)},e.prototype.isSuppressContextMenu=function(){return i(this.gridOptions.suppressContextMenu)},e.prototype.isSuppressCopyRowsToClipboard=function(){return i(this.gridOptions.suppressCopyRowsToClipboard)},e.prototype.isEnableFilter=function(){return i(this.gridOptions.enableFilter)||i(this.gridOptions.enableServerSideFilter)},e.prototype.isEnableServerSideFilter=function(){return this.gridOptions.enableServerSideFilter},e.prototype.isSuppressScrollLag=function(){return i(this.gridOptions.suppressScrollLag)},e.prototype.isSuppressMovableColumns=function(){return i(this.gridOptions.suppressMovableColumns)},e.prototype.isSuppressColumnMoveAnimation=function(){return i(this.gridOptions.suppressColumnMoveAnimation)},e.prototype.isSuppressMenuColumnPanel=function(){return i(this.gridOptions.suppressMenuColumnPanel)},e.prototype.isSuppressMenuFilterPanel=function(){return i(this.gridOptions.suppressMenuFilterPanel)},e.prototype.isSuppressUseColIdForGroups=function(){return i(this.gridOptions.suppressUseColIdForGroups)},e.prototype.isSuppressAggFuncInHeader=function(){return i(this.gridOptions.suppressAggFuncInHeader)},e.prototype.isSuppressMenuMainPanel=function(){return i(this.gridOptions.suppressMenuMainPanel)},e.prototype.isEnableRangeSelection=function(){return i(this.gridOptions.enableRangeSelection)},e.prototype.isRememberGroupStateWhenNewData=function(){return i(this.gridOptions.rememberGroupStateWhenNewData)},e.prototype.getIcons=function(){return this.gridOptions.icons},e.prototype.getAggFuncs=function(){return this.gridOptions.aggFuncs},e.prototype.getIsScrollLag=function(){return this.gridOptions.isScrollLag},e.prototype.getSortingOrder=function(){return this.gridOptions.sortingOrder},e.prototype.getSlaveGrids=function(){return this.gridOptions.slaveGrids},e.prototype.getGroupRowRenderer=function(){return this.gridOptions.groupRowRenderer},e.prototype.getGroupRowRendererParams=function(){return this.gridOptions.groupRowRendererParams},e.prototype.getGroupRowInnerRenderer=function(){return this.gridOptions.groupRowInnerRenderer},e.prototype.getOverlayLoadingTemplate=function(){return this.gridOptions.overlayLoadingTemplate},e.prototype.getOverlayNoRowsTemplate=function(){return this.gridOptions.overlayNoRowsTemplate},e.prototype.getCheckboxSelection=function(){return this.gridOptions.checkboxSelection},e.prototype.isSuppressAutoSize=function(){return i(this.gridOptions.suppressAutoSize)},e.prototype.isSuppressParentsInRowNodes=function(){return i(this.gridOptions.suppressParentsInRowNodes)},e.prototype.isEnableStatusBar=function(){return i(this.gridOptions.enableStatusBar)},e.prototype.isFunctionsReadOnly=function(){return i(this.gridOptions.functionsReadOnly)},e.prototype.getHeaderCellTemplate=function(){return this.gridOptions.headerCellTemplate},e.prototype.getHeaderCellTemplateFunc=function(){return this.gridOptions.getHeaderCellTemplate},e.prototype.getNodeChildDetailsFunc=function(){return this.gridOptions.getNodeChildDetails},e.prototype.getGroupRowAggNodesFunc=function(){return this.gridOptions.groupRowAggNodes},e.prototype.getContextMenuItemsFunc=function(){return this.gridOptions.getContextMenuItems},e.prototype.getMainMenuItemsFunc=function(){return this.gridOptions.getMainMenuItems},e.prototype.getRowNodeIdFunc=function(){return this.gridOptions.getRowNodeId},e.prototype.getProcessCellForClipboardFunc=function(){return this.gridOptions.processCellForClipboard},e.prototype.getViewportRowModelPageSize=function(){return n(this.gridOptions.viewportRowModelPageSize,y)},e.prototype.getViewportRowModelBufferSize=function(){return n(this.gridOptions.viewportRowModelBufferSize,v)},e.prototype.setProperty=function(e,t){var o=this.gridOptions,i=o[e];o[e]=t,this.propertyEventService.dispatchEvent(e,{currentValue:t,previousValue:i})},e.prototype.addEventListener=function(e,t){this.propertyEventService.addEventListener(e,t)},e.prototype.removeEventListener=function(e,t){this.propertyEventService.removeEventListener(e,t)},e.prototype.executeProcessRowPostCreateFunc=function(e){this.gridOptions.processRowPostCreate&&this.gridOptions.processRowPostCreate(e)},e.prototype.getHeaderHeight=function(){return"number"==typeof this.gridOptions.headerHeight?this.gridOptions.headerHeight:25},e.prototype.isExternalFilterPresent=function(){return"function"==typeof this.gridOptions.isExternalFilterPresent&&this.gridOptions.isExternalFilterPresent()},e.prototype.doesExternalFilterPass=function(e){return"function"==typeof this.gridOptions.doesExternalFilterPass&&this.gridOptions.doesExternalFilterPass(e)},e.prototype.getLayoutInterval=function(){return"number"==typeof this.gridOptions.layoutInterval?this.gridOptions.layoutInterval:p.Constants.LAYOUT_INTERVAL},e.prototype.getMinColWidth=function(){return this.gridOptions.minColWidth>e.MIN_COL_WIDTH?this.gridOptions.minColWidth:e.MIN_COL_WIDTH},e.prototype.getMaxColWidth=function(){return this.gridOptions.maxColWidth>e.MIN_COL_WIDTH?this.gridOptions.maxColWidth:null},e.prototype.getColWidth=function(){return"number"!=typeof this.gridOptions.colWidth||this.gridOptions.colWidth<e.MIN_COL_WIDTH?200:this.gridOptions.colWidth},e.prototype.getRowBuffer=function(){return"number"==typeof this.gridOptions.rowBuffer?(this.gridOptions.rowBuffer<0&&console.warn("ag-Grid: rowBuffer should not be negative"),this.gridOptions.rowBuffer):p.Constants.ROW_BUFFER_SIZE},e.prototype.checkForDeprecated=function(){var e=this.gridOptions;e.suppressUnSort&&console.warn("ag-grid: as of v1.12.4 suppressUnSort is not used. Please use sortOrder instead."),e.suppressDescSort&&console.warn("ag-grid: as of v1.12.4 suppressDescSort is not used. Please use sortOrder instead."),e.groupAggFields&&console.warn("ag-grid: as of v3 groupAggFields is not used. Please add appropriate agg fields to your columns."),e.groupHidePivotColumns&&console.warn("ag-grid: as of v3 groupHidePivotColumns is not used as pivot columns are now called rowGroup columns. Please refer to the documentation"),e.groupKeys&&console.warn("ag-grid: as of v3 groupKeys is not used. You need to set rowGroupIndex on the columns to group. Please refer to the documentation"),(e.ready||e.onReady)&&console.warn("ag-grid: as of v3.3 ready event is now called gridReady, so the callback should be onGridReady"),"boolean"==typeof e.groupDefaultExpanded&&console.warn("ag-grid: groupDefaultExpanded can no longer be boolean. for groupDefaultExpanded=true, use groupDefaultExpanded=9999 instead, to expand all the groups"),(e.onRowDeselected||e.rowDeselected)&&console.warn("ag-grid: since version 3.4 event rowDeselected no longer exists, please check the docs"),e.rowsAlreadyGrouped&&console.warn("ag-grid: since version 3.4 rowsAlreadyGrouped no longer exists, please use getNodeChildDetails() instead"),e.groupAggFunction&&console.warn("ag-grid: since version 4.3.x groupAggFunction is now called groupRowAggNodes")},e.prototype.getLocaleTextFunc=function(){if(this.gridOptions.localeTextFunc)return this.gridOptions.localeTextFunc;var e=this;return function(t,o){var i=e.gridOptions.localeText;return i&&i[t]?i[t]:o}},e.prototype.globalEventHandler=function(e,t){var o=d.ComponentUtil.getCallbackForEvent(e);"function"==typeof this.gridOptions[o]&&this.gridOptions[o](t)},e.prototype.getRowHeightAsNumber=function(){var e=this.gridOptions.rowHeight;return g.Utils.missing(e)?f:"number"==typeof this.gridOptions.rowHeight?this.gridOptions.rowHeight:(console.warn("ag-Grid row height must be a number if not using standard row model"),f)},e.prototype.getRowHeightForNode=function(e){if("number"==typeof this.gridOptions.rowHeight)return this.gridOptions.rowHeight;if("function"==typeof this.gridOptions.getRowHeight){var t={node:e,data:e.data,api:this.gridOptions.api,context:this.gridOptions.context};return this.gridOptions.getRowHeight(t)}return f},e.MIN_COL_WIDTH=10,e.PROP_HEADER_HEIGHT="headerHeight",r([c.Autowired("gridOptions"),s("design:type",Object)],e.prototype,"gridOptions",void 0),r([c.Autowired("columnController"),s("design:type",h.ColumnController)],e.prototype,"columnController",void 0),r([c.Autowired("eventService"),s("design:type",a.EventService)],e.prototype,"eventService",void 0),r([c.Autowired("enterprise"),s("design:type",Boolean)],e.prototype,"enterprise",void 0),r([l(0,c.Qualifier("gridApi")),l(1,c.Qualifier("columnApi")),s("design:type",Function),s("design:paramtypes",[u.GridApi,h.ColumnApi]),s("design:returntype",void 0)],e.prototype,"agWire",null),r([c.PreDestroy,s("design:type",Function),s("design:paramtypes",[]),s("design:returntype",void 0)],e.prototype,"destroy",null),r([c.PostConstruct,s("design:type",Function),s("design:paramtypes",[]),s("design:returntype",void 0)],e.prototype,"init",null),e=r([c.Bean("gridOptionsWrapper"),s("design:paramtypes",[])],e)}();t.GridOptionsWrapper=C},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(5),l=o(7),a=o(6),p=o(6),d=function(){function e(){this.allListeners={},this.globalListeners=[]}return e.prototype.agWire=function(e,t){void 0===t&&(t=null),this.logger=e.create("EventService"),t&&this.addGlobalListener(t)},e.prototype.getListenerList=function(e){var t=this.allListeners[e];return t||(t=[],this.allListeners[e]=t),t},e.prototype.addEventListener=function(e,t){var o=this.getListenerList(e);o.indexOf(t)<0&&o.push(t)},e.prototype.addModalPriorityEventListener=function(t,o){this.addEventListener(t+e.PRIORITY,o)},e.prototype.addGlobalListener=function(e){this.globalListeners.push(e)},e.prototype.removeEventListener=function(e,t){var o=this.getListenerList(e);l.Utils.removeFromArray(o,t)},e.prototype.removeGlobalListener=function(e){l.Utils.removeFromArray(this.globalListeners,e)},e.prototype.dispatchEvent=function(t,o){o||(o={});var i=this.getListenerList(t+e.PRIORITY);i.forEach(function(e){e(o)});var n=this.getListenerList(t);n.forEach(function(e){e(o)}),this.globalListeners.forEach(function(e){e(t,o)})},e.PRIORITY="-P1",i([r(0,p.Qualifier("loggerFactory")),r(1,p.Qualifier("globalEventListener")),n("design:type",Function),n("design:paramtypes",[s.LoggerFactory,Function]),n("design:returntype",void 0)],e.prototype,"agWire",null),e=i([a.Bean("eventService"),n("design:paramtypes",[])],e)}();t.EventService=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(3),l=o(6),a=o(6),p=function(){function e(){}return e.prototype.setBeans=function(e){this.logging=e.isDebug()},e.prototype.create=function(e){return new d(e,this.logging)},i([r(0,a.Qualifier("gridOptionsWrapper")),n("design:type",Function),n("design:paramtypes",[s.GridOptionsWrapper]),n("design:returntype",void 0)],e.prototype,"setBeans",null),e=i([l.Bean("loggerFactory"),n("design:paramtypes",[])],e)}();t.LoggerFactory=p;var d=function(){function e(e,t){this.name=e,this.logging=t}return e.prototype.log=function(e){this.logging&&console.log("ag-Grid."+this.name+": "+e)},e}();t.Logger=d},function(e,t,o){function i(e,t){var o=[null].concat(t),i=e.bind.apply(e,o);return new i}function n(e,t,o){var i=u(e);i.postConstructMethods||(i.postConstructMethods=[]),i.postConstructMethods.push(t)}function r(e,t,o){var i=u(e);i.preDestroyMethods||(i.preDestroyMethods=[]),i.preDestroyMethods.push(t)}function s(e){return function(t){var o=u(t.prototype);o.beanName=e}}function l(e){return p.bind(this,e,!1)}function a(e){return p.bind(this,e,!0)}function p(e,t,o,i,n){if(null===e)return void console.error("ag-Grid: Autowired name should not be null");if("number"==typeof n)return void console.error("ag-Grid: Autowired should be on an attribute");var r=u(o);r.agClassAttributes||(r.agClassAttributes=[]),r.agClassAttributes.push({attributeName:i,beanName:e,optional:t})}function d(e){return function(t,o,i){var n;if("number"==typeof i){var r;o?(n=u(t),r=o):(n=u(t.prototype),r="agConstructor"),n.autowireMethods||(n.autowireMethods={}),n.autowireMethods[r]||(n.autowireMethods[r]={}),n.autowireMethods[r][i]=e}}}function u(e){var t=e.__agBeanMetaData;return t||(t={},e.__agBeanMetaData=t),t}/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var c=o(7),h=o(5),g=function(){function e(e){if(this.beans={},this.componentsMappedByName={},this.destroyed=!1,e&&e.beans){this.contextParams=e,this.logger=new h.Logger("Context",this.contextParams.debug),this.logger.log(">> creating ag-Application Context"),this.setupComponents(),this.createBeans();var t=c.Utils.mapObject(this.beans,function(e){return e.beanInstance});this.wireBeans(t),this.logger.log(">> ag-Application Context ready - component is alive")}}return e.prototype.setupComponents=function(){var e=this;this.contextParams.components&&this.contextParams.components.forEach(function(t){return e.addComponent(t)})},e.prototype.addComponent=function(e){var t=e.componentName.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase(),o=t.toUpperCase();this.componentsMappedByName[o]=e.theClass},e.prototype.createComponent=function(e){var t=e.nodeName;if(this.componentsMappedByName&&this.componentsMappedByName[t]){var o=new this.componentsMappedByName[t];return this.copyAttributesFromNode(e,o.getGui()),this.wireBean(o),o}return null},e.prototype.copyAttributesFromNode=function(e,t){if(e.attributes)for(var o=e.attributes.length,i=0;i<o;i++){var n=e.attributes[i];t.setAttribute(n.name,n.value)}},e.prototype.wireBean=function(e){this.wireBeans([e])},e.prototype.wireBeans=function(e){this.autoWireBeans(e),this.methodWireBeans(e),this.postConstruct(e)},e.prototype.createBeans=function(){var e=this;this.contextParams.beans.forEach(this.createBeanEntry.bind(this)),this.contextParams.overrideBeans&&this.contextParams.overrideBeans.forEach(this.createBeanEntry.bind(this)),c.Utils.iterateObject(this.beans,function(t,o){var n;o.bean.prototype.__agBeanMetaData&&o.bean.prototype.__agBeanMetaData.autowireMethods&&o.bean.prototype.__agBeanMetaData.autowireMethods.agConstructor&&(n=o.bean.prototype.__agBeanMetaData.autowireMethods.agConstructor);var r=e.getBeansForParameters(n,o.beanName),s=i(o.bean,r);o.beanInstance=s,e.logger.log("bean "+e.getBeanName(s)+" created")})},e.prototype.createBeanEntry=function(e){var t=e.prototype.__agBeanMetaData;if(!t){var o;return o=e.prototype.constructor?e.prototype.constructor.name:""+e,void console.error("context item "+o+" is not a bean")}var i={bean:e,beanInstance:null,beanName:t.beanName};this.beans[t.beanName]=i},e.prototype.autoWireBeans=function(e){var t=this;e.forEach(function(e){return t.autoWireBean(e)})},e.prototype.methodWireBeans=function(e){var t=this;e.forEach(function(e){return t.methodWireBean(e)})},e.prototype.autoWireBean=function(e){var t=this;if(e&&e.__agBeanMetaData&&e.__agBeanMetaData.agClassAttributes){var o=e.__agBeanMetaData.agClassAttributes;if(o){var i=this.getBeanName(e);o.forEach(function(o){var n=t.lookupBeanInstance(i,o.beanName,o.optional);e[o.attributeName]=n})}}},e.prototype.getBeanName=function(e){var t=e.constructor.toString(),o=t.substring(9,t.indexOf("("));return o},e.prototype.methodWireBean=function(e){var t,o=this;e.__agBeanMetaData&&(t=e.__agBeanMetaData.autowireMethods),c.Utils.iterateObject(t,function(t,i){if("agConstructor"!==t){var n=o.getBeanName(e),r=o.getBeansForParameters(i,n);e[t].apply(e,r)}})},e.prototype.getBeansForParameters=function(e,t){var o=this,i=[];return e&&c.Utils.iterateObject(e,function(e,n){var r=o.lookupBeanInstance(t,n);i[Number(e)]=r}),i},e.prototype.lookupBeanInstance=function(e,t,o){if(void 0===o&&(o=!1),"context"===t)return this;if(this.contextParams.seed&&this.contextParams.seed.hasOwnProperty(t))return this.contextParams.seed[t];var i=this.beans[t];return i?i.beanInstance:(o||console.error("ag-Grid: unable to find bean reference "+t+" while initialising "+e),null)},e.prototype.postConstruct=function(e){e.forEach(function(e){e.__agBeanMetaData&&e.__agBeanMetaData.postConstructMethods&&e.__agBeanMetaData.postConstructMethods.forEach(function(t){return e[t]()})})},e.prototype.getBean=function(e){return this.lookupBeanInstance("getBean",e,!0)},e.prototype.destroy=function(){this.destroyed||(this.logger.log(">> Shutting down ag-Application Context"),c.Utils.iterateObject(this.beans,function(e,t){var o=t.beanInstance;o.__agBeanMetaData&&o.__agBeanMetaData.preDestroyMethods&&o.__agBeanMetaData.preDestroyMethods.forEach(function(e){return o[e]()})}),this.destroyed=!0,this.logger.log(">> ag-Application Context shut down - component is dead"))},e}();t.Context=g,t.PostConstruct=n,t.PreDestroy=r,t.Bean=s,t.Autowired=l,t.Optional=a,t.Qualifier=d},function(e,t){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var o=/((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm,i=/([^\s,]+)/g,n=function(){function e(){this.timestamp=(new Date).getTime()}return e.prototype.print=function(e){var t=(new Date).getTime()-this.timestamp;console.log(e+" = "+t),this.timestamp=(new Date).getTime()},e}();t.Timer=n;var r=function(){function e(){}return e.getNameOfClass=function(e){var t=/function (.{1,})\(/,o=e.toString(),i=t.exec(o);return i&&i.length>1?i[1]:""},e.values=function(e){var t=[];return this.iterateObject(e,function(e,o){t.push(o)}),t},e.iterateObject=function(e,t){if(!this.missing(e))for(var o=Object.keys(e),i=0;i<o.length;i++){var n=o[i],r=e[n];t(n,r)}},e.cloneObject=function(e){for(var t={},o=Object.keys(e),i=0;i<o.length;i++){var n=o[i],r=e[n];t[n]=r}return t},e.map=function(e,t){for(var o=[],i=0;i<e.length;i++){var n=e[i],r=t(n);o.push(r)}return o},e.mapObject=function(t,o){var i=[];return e.iterateObject(t,function(e,t){i.push(o(t))}),i},e.forEach=function(e,t){if(e)for(var o=0;o<e.length;o++){var i=e[o];t(i,o)}},e.filter=function(e,t){var o=[];return e.forEach(function(e){t(e)&&o.push(e)}),o},e.assign=function(e,t){this.exists(t)&&this.iterateObject(t,function(t,o){e[t]=o})},e.getFunctionParameters=function(e){var t=e.toString().replace(o,""),n=t.slice(t.indexOf("(")+1,t.indexOf(")")).match(i);return null===n?[]:n},e.find=function(e,t,o){if(null===e||void 0===e)return null;for(var i,n=0;n<e.length;n++){var r=e[n];if("string"==typeof t){if(r[t]===o){i=r;break}}else{var s=t;if(s(r)){i=r;break}}}return i},e.toStrings=function(e){return this.map(e,function(e){return void 0!==e&&null!==e&&e.toString?e.toString():null})},e.iterateArray=function(e,t){for(var o=0;o<e.length;o++){var i=e[o];t(i,o)}},e.isNode=function(e){return"function"==typeof Node?e instanceof Node:e&&"object"==typeof e&&"number"==typeof e.nodeType&&"string"==typeof e.nodeName},e.isElement=function(e){return"function"==typeof HTMLElement?e instanceof HTMLElement:e&&"object"==typeof e&&null!==e&&1===e.nodeType&&"string"==typeof e.nodeName},e.isNodeOrElement=function(e){return this.isNode(e)||this.isElement(e)},e.addChangeListener=function(e,t){e.addEventListener("changed",t),e.addEventListener("paste",t),e.addEventListener("input",t),e.addEventListener("keydown",t),e.addEventListener("keyup",t)},e.makeNull=function(e){return null===e||void 0===e||""===e?null:e},e.missing=function(e){return!this.exists(e)},e.missingOrEmpty=function(e){return this.missing(e)||0===e.length},e.exists=function(e){return null!==e&&void 0!==e&&""!==e},e.existsAndNotEmpty=function(e){return this.exists(e)&&e.length>0},e.removeAllChildren=function(e){if(e)for(;e.hasChildNodes();)e.removeChild(e.lastChild)},e.removeElement=function(e,t){this.removeFromParent(e.querySelector(t))},e.removeFromParent=function(e){e&&e.parentNode&&e.parentNode.removeChild(e)},e.isVisible=function(e){return null!==e.offsetParent},e.loadTemplate=function(e){var t=document.createElement("div");return t.innerHTML=e,t.firstChild},e.addOrRemoveCssClass=function(e,t,o){o?this.addCssClass(e,t):this.removeCssClass(e,t)},e.callIfPresent=function(e){e&&e()},e.addCssClass=function(e,t){var o=this;if(t&&0!==t.length){if(t.indexOf(" ")>=0)return void t.split(" ").forEach(function(t){return o.addCssClass(e,t)});if(e.classList)e.classList.add(t);else if(e.className&&e.className.length>0){var i=e.className.split(" ");i.indexOf(t)<0&&(i.push(t),e.className=i.join(" "))}else e.className=t}},e.containsClass=function(e,t){if(e.classList)return e.classList.contains(t);if(e.className){var o=e.className===t,i=e.className.indexOf(" "+t+" ")>=0,n=0===e.className.indexOf(t+" "),r=e.className.lastIndexOf(" "+t)===e.className.length-t.length-1;return o||i||n||r}return!1},e.getElementAttribute=function(e,t){if(e.attributes){if(e.attributes[t]){var o=e.attributes[t];return o.value}return null}return null},e.offsetHeight=function(e){return e&&e.clientHeight?e.clientHeight:0},e.offsetWidth=function(e){return e&&e.clientWidth?e.clientWidth:0},e.removeCssClass=function(e,t){if(e.className&&e.className.length>0){var o=e.className.split(" "),i=o.indexOf(t);i>=0&&(o.splice(i,1),e.className=o.join(" "))}},e.removeRepeatsFromArray=function(e,t){if(e)for(var o=e.length-2;o>=0;o--){var i=e[o]===t,n=e[o+1]===t;i&&n&&e.splice(o+1,1)}},e.removeFromArray=function(e,t){e.indexOf(t)>=0&&e.splice(e.indexOf(t),1)},e.insertIntoArray=function(e,t,o){e.splice(o,0,t)},e.moveInArray=function(e,t,o){var i=this;t.forEach(function(t){i.removeFromArray(e,t)}),t.slice().reverse().forEach(function(t){i.insertIntoArray(e,t,o)})},e.defaultComparator=function(e,t){var o=null===e||void 0===e,i=null===t||void 0===t;if(o&&i)return 0;if(o)return-1;if(i)return 1;if("string"==typeof e)try{return e.localeCompare(t)}catch(n){}return e<t?-1:e>t?1:0},e.compareArrays=function(e,t){if(this.missing(e)&&this.missing(t))return!0;if(this.missing(e)||this.missing(t))return!1;if(e.length!==t.length)return!1;for(var o=0;o<e.length;o++)if(e[o]!==t[o])return!1;return!0},e.toStringOrNull=function(e){return this.exists(e)&&e.toString?e.toString():null},e.formatWidth=function(e){return"number"==typeof e?e+"px":e},e.formatNumberTwoDecimalPlacesAndCommas=function(e){return"number"==typeof e?(Math.round(100*e)/100).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,"):""},e.createIcon=function(e,t,o,i){var n=document.createElement("span");return n.appendChild(this.createIconNoSpan(e,t,o,i)),n},e.createIconNoSpan=function(e,t,o,i){var n;if(o&&o.getColDef().icons&&(n=o.getColDef().icons[e]),!n&&t.getIcons()&&(n=t.getIcons()[e]),n){var r;if("function"==typeof n)r=n();else{if("string"!=typeof n)throw"icon from grid options needs to be a string or a function";r=n}if("string"==typeof r)return this.loadTemplate(r);if(this.isNodeOrElement(r))return r;throw"iconRenderer should return back a string or a dom object"}return i?i():null},e.addStylesToElement=function(e,t){t&&Object.keys(t).forEach(function(o){e.style[o]=t[o]})},e.isScrollShowing=function(e){return e.clientHeight<e.scrollHeight},e.getScrollbarWidth=function(){var e=document.createElement("div");e.style.visibility="hidden",e.style.width="100px",e.style.msOverflowStyle="scrollbar",document.body.appendChild(e);var t=e.offsetWidth;e.style.overflow="scroll";var o=document.createElement("div");o.style.width="100%",e.appendChild(o);var i=o.offsetWidth;return e.parentNode.removeChild(e),t-i},e.isKeyPressed=function(e,t){var o=e.which||e.keyCode;return o===t},e.setVisible=function(e,t,o){t?this.exists(o)?e.style.display=o:e.style.display="inline":e.style.display="none"},e.isBrowserIE=function(){return void 0===this.isIE&&(this.isIE=!!document.documentMode),this.isIE},e.isBrowserSafari=function(){return void 0===this.isSafari&&(this.isSafari=Object.prototype.toString.call(window.HTMLElement).indexOf("Constructor")>0),this.isSafari},e.getTarget=function(e){var t=e;return t.target||t.srcElement},e.getBodyWidth=function(){return document.body?document.body.clientWidth:window.innerHeight?window.innerWidth:document.documentElement&&document.documentElement.clientWidth?document.documentElement.clientWidth:-1},e.getBodyHeight=function(){return document.body?document.body.clientHeight:window.innerHeight?window.innerHeight:document.documentElement&&document.documentElement.clientHeight?document.documentElement.clientHeight:-1},e.setCheckboxState=function(e,t){"boolean"==typeof t?(e.checked=t,e.indeterminate=!1):e.indeterminate=!0},e.traverseNodesWithKey=function(e,t){function o(e){e.forEach(function(e){if(e.group){i.push(e.key);var n=i.join("|");t(e,n),o(e.childrenAfterGroup),i.pop()}})}var i=[];o(e)},e.normalizeWheel=function(e){var t=10,o=40,i=800,n=0,r=0,s=0,l=0;return"detail"in e&&(r=e.detail),"wheelDelta"in e&&(r=-e.wheelDelta/120),"wheelDeltaY"in e&&(r=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(n=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(n=r,r=0),s=n*t,l=r*t,"deltaY"in e&&(l=e.deltaY),"deltaX"in e&&(s=e.deltaX),(s||l)&&e.deltaMode&&(1==e.deltaMode?(s*=o,l*=o):(s*=i,l*=i)),s&&!n&&(n=s<1?-1:1),l&&!r&&(r=l<1?-1:1),{spinX:n,spinY:r,pixelX:s,pixelY:l}},e}();t.Utils=r;var s=function(){function e(){this.nextValue=0}return e.prototype.next=function(){var e=this.nextValue;return this.nextValue++,e},e}();t.NumberSequence=s},function(e,t){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var o=function(){function e(){}return e.STEP_EVERYTHING=0,e.STEP_FILTER=1,e.STEP_SORT=2,e.STEP_MAP=3,e.STEP_AGGREGATE=4,e.STEP_PIVOT=5,e.ROW_BUFFER_SIZE=10,e.LAYOUT_INTERVAL=500,e.KEY_BACKSPACE=8,e.KEY_TAB=9,e.KEY_ENTER=13,e.KEY_SHIFT=16,e.KEY_ESCAPE=27,e.KEY_SPACE=32,e.KEY_LEFT=37,e.KEY_UP=38,e.KEY_RIGHT=39,e.KEY_DOWN=40,e.KEY_DELETE=46,e.KEY_A=65,e.KEY_C=67,e.KEY_V=86,e.KEY_D=68,e.KEY_F2=113,e.ROW_MODEL_TYPE_PAGINATION="pagination",e.ROW_MODEL_TYPE_VIRTUAL="virtual",e.ROW_MODEL_TYPE_VIEWPORT="viewport",e.ROW_MODEL_TYPE_NORMAL="normal",e.ALWAYS="always",e.ONLY_WHEN_GROUPING="onlyWhenGrouping",e.FLOATING_TOP="top",e.FLOATING_BOTTOM="bottom",e}();t.Constants=o},function(e,t,o){function i(e){(e.ready||e.onReady)&&console.warn("ag-grid: as of v3.3 ready event is now called gridReady, so the callback should be onGridReady"),(e.rowDeselected||e.onRowDeselected)&&console.warn("ag-grid: as of v3.4 rowDeselected no longer exists. Please check the docs.")}/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var n=o(10),r=o(7),s=function(){function e(){}return e.getEventCallbacks=function(){return e.EVENT_CALLBACKS||(e.EVENT_CALLBACKS=[],e.EVENTS.forEach(function(t){e.EVENT_CALLBACKS.push(e.getCallbackForEvent(t))})),e.EVENT_CALLBACKS},e.copyAttributesToGridOptions=function(t,o){i(o),"object"!=typeof t&&(t={});var n=t;return e.ARRAY_PROPERTIES.concat(e.STRING_PROPERTIES).concat(e.OBJECT_PROPERTIES).concat(e.FUNCTION_PROPERTIES).forEach(function(e){"undefined"!=typeof o[e]&&(n[e]=o[e])}),e.BOOLEAN_PROPERTIES.forEach(function(t){"undefined"!=typeof o[t]&&(n[t]=e.toBoolean(o[t]))}),e.NUMBER_PROPERTIES.forEach(function(t){"undefined"!=typeof o[t]&&(n[t]=e.toNumber(o[t]))}),e.getEventCallbacks().forEach(function(e){"undefined"!=typeof o[e]&&(n[e]=o[e])}),t},e.getCallbackForEvent=function(e){return!e||e.length<2?e:"on"+e[0].toUpperCase()+e.substr(1)},e.processOnChange=function(t,o,n,r){if(t){i(t);var s=o;e.ARRAY_PROPERTIES.concat(e.OBJECT_PROPERTIES).concat(e.STRING_PROPERTIES).forEach(function(e){t[e]&&(s[e]=t[e].currentValue)}),e.BOOLEAN_PROPERTIES.forEach(function(o){t[o]&&(s[o]=e.toBoolean(t[o].currentValue))}),e.NUMBER_PROPERTIES.forEach(function(o){t[o]&&(s[o]=e.toNumber(t[o].currentValue))}),e.getEventCallbacks().forEach(function(e){t[e]&&(s[e]=t[e].currentValue)}),t.showToolPanel&&n.showToolPanel(e.toBoolean(t.showToolPanel.currentValue)),t.quickFilterText&&n.setQuickFilter(t.quickFilterText.currentValue),t.rowData&&n.setRowData(t.rowData.currentValue),t.floatingTopRowData&&n.setFloatingTopRowData(t.floatingTopRowData.currentValue),t.floatingBottomRowData&&n.setFloatingBottomRowData(t.floatingBottomRowData.currentValue),t.columnDefs&&n.setColumnDefs(t.columnDefs.currentValue),t.datasource&&n.setDatasource(t.datasource.currentValue),t.headerHeight&&n.setHeaderHeight(e.toNumber(t.headerHeight.currentValue)),t.pivotMode&&r.setPivotMode(e.toBoolean(t.pivotMode.currentValue))}},e.toBoolean=function(e){return"boolean"==typeof e?e:"string"==typeof e&&("TRUE"===e.toUpperCase()||""==e)},e.toNumber=function(e){return"number"==typeof e?e:"string"==typeof e?Number(e):void 0},e.EVENTS=[],e.STRING_PROPERTIES=["sortingOrder","rowClass","rowSelection","overlayLoadingTemplate","overlayNoRowsTemplate","headerCellTemplate","quickFilterText","rowModelType"],e.OBJECT_PROPERTIES=["rowStyle","context","groupColumnDef","localeText","icons","datasource","viewportDatasource","groupRowRendererParams","aggFuncs","fullWidthCellRendererParams"],e.ARRAY_PROPERTIES=["slaveGrids","rowData","floatingTopRowData","floatingBottomRowData","columnDefs"],e.NUMBER_PROPERTIES=["rowHeight","rowBuffer","colWidth","headerHeight","groupDefaultExpanded","minColWidth","maxColWidth","viewportRowModelPageSize","viewportRowModelBufferSize","layoutInterval","autoSizePadding","maxPagesInCache","maxConcurrentDatasourceRequests","paginationOverflowSize","paginationPageSize","paginationInitialRowCount"],e.BOOLEAN_PROPERTIES=["toolPanelSuppressRowGroups","toolPanelSuppressValues","toolPanelSuppressPivots","toolPanelSuppressPivotMode","suppressRowClickSelection","suppressCellSelection","suppressHorizontalScroll","debug","enableColResize","enableCellExpressions","enableSorting","enableServerSideSorting","enableFilter","enableServerSideFilter","angularCompileRows","angularCompileFilters","angularCompileHeaders","groupSuppressAutoColumn","groupSelectsChildren","groupIncludeFooter","groupUseEntireRow","groupSuppressRow","groupSuppressBlankHeader","forPrint","suppressMenuHide","rowDeselection","unSortIcon","suppressMultiSort","suppressScrollLag","singleClickEdit","suppressLoadingOverlay","suppressNoRowsOverlay","suppressAutoSize","suppressParentsInRowNodes","showToolPanel","suppressColumnMoveAnimation","suppressMovableColumns","suppressFieldDotNotation","enableRangeSelection","suppressEnterprise","rowGroupPanelShow","pivotPanelShow","suppressContextMenu","suppressMenuFilterPanel","suppressMenuMainPanel","suppressMenuColumnPanel","enableStatusBar","rememberGroupStateWhenNewData","enableCellChangeFlash","suppressDragLeaveHidesColumns","suppressMiddleClickScrolls","suppressPreventDefaultOnMouseWheel","suppressUseColIdForGroups","suppressCopyRowsToClipboard","pivotMode","suppressAggFuncInHeader","suppressColumnVirtualisation","suppressFocusAfterRefresh","functionsPassive","functionsReadOnly"],e.FUNCTION_PROPERTIES=["headerCellRenderer","localeTextFunc","groupRowInnerRenderer","groupRowRenderer","isScrollLag","isExternalFilterPresent","getRowHeight","doesExternalFilterPass","getRowClass","getRowStyle","getHeaderCellTemplate","traverseNode","getContextMenuItems","getMainMenuItems","processRowPostCreate","processCellForClipboard","getNodeChildDetails","groupRowAggNodes","getRowNodeId","isFullWidthCell","fullWidthCellRenderer","doesDataFlower"],e.ALL_PROPERTIES=e.ARRAY_PROPERTIES.concat(e.OBJECT_PROPERTIES).concat(e.STRING_PROPERTIES).concat(e.NUMBER_PROPERTIES).concat(e.FUNCTION_PROPERTIES).concat(e.BOOLEAN_PROPERTIES),e}();t.ComponentUtil=s,r.Utils.iterateObject(n.Events,function(e,t){s.EVENTS.push(t)})},function(e,t){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var o=function(){function e(){}return e.EVENT_COLUMN_EVERYTHING_CHANGED="columnEverythingChanged",e.EVENT_NEW_COLUMNS_LOADED="newColumnsLoaded",e.EVENT_COLUMN_PIVOT_MODE_CHANGED="columnPivotModeChanged",e.EVENT_COLUMN_ROW_GROUP_CHANGED="columnRowGroupChanged",e.EVENT_COLUMN_PIVOT_CHANGED="columnPivotChanged",e.EVENT_GRID_COLUMNS_CHANGED="gridColumnsChanged",e.EVENT_COLUMN_VALUE_CHANGED="columnValueChanged",e.EVENT_COLUMN_MOVED="columnMoved",e.EVENT_COLUMN_VISIBLE="columnVisible",e.EVENT_COLUMN_PINNED="columnPinned",e.EVENT_COLUMN_GROUP_OPENED="columnGroupOpened",e.EVENT_COLUMN_RESIZED="columnResized",e.EVENT_DISPLAYED_COLUMNS_CHANGED="displayedColumnsChanged",e.EVENT_VIRTUAL_COLUMNS_CHANGED="virtualColumnsChanged",e.EVENT_ROW_GROUP_OPENED="rowGroupOpened",e.EVENT_ROW_DATA_CHANGED="rowDataChanged",e.EVENT_FLOATING_ROW_DATA_CHANGED="floatingRowDataChanged",e.EVENT_RANGE_SELECTION_CHANGED="rangeSelectionChanged",e.EVENT_COLUMN_ROW_GROUP_ADD_REQUEST="columnRowGroupAddRequest",e.EVENT_COLUMN_ROW_GROUP_REMOVE_REQUEST="columnRowGroupRemoveRequest",e.EVENT_COLUMN_PIVOT_ADD_REQUEST="columnPivotAddRequest",e.EVENT_COLUMN_PIVOT_REMOVE_REQUEST="columnPivotRemoveRequest",e.EVENT_COLUMN_VALUE_ADD_REQUEST="columnValueAddRequest",e.EVENT_COLUMN_VALUE_REMOVE_REQUEST="columnValueRemoveRequest",e.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST="columnAggFuncChangeRequest",e.EVENT_FLASH_CELLS="clipboardPaste",e.EVENT_MODEL_UPDATED="modelUpdated",e.EVENT_CELL_CLICKED="cellClicked",e.EVENT_CELL_DOUBLE_CLICKED="cellDoubleClicked",e.EVENT_CELL_CONTEXT_MENU="cellContextMenu",e.EVENT_CELL_VALUE_CHANGED="cellValueChanged",e.EVENT_CELL_FOCUSED="cellFocused",e.EVENT_ROW_SELECTED="rowSelected",e.EVENT_SELECTION_CHANGED="selectionChanged",e.EVENT_BEFORE_FILTER_CHANGED="beforeFilterChanged",e.EVENT_FILTER_CHANGED="filterChanged",e.EVENT_AFTER_FILTER_CHANGED="afterFilterChanged",e.EVENT_FILTER_MODIFIED="filterModified",e.EVENT_BEFORE_SORT_CHANGED="beforeSortChanged",e.EVENT_SORT_CHANGED="sortChanged",e.EVENT_AFTER_SORT_CHANGED="afterSortChanged",e.EVENT_VIRTUAL_ROW_REMOVED="virtualRowRemoved",e.EVENT_ROW_CLICKED="rowClicked",e.EVENT_ROW_DOUBLE_CLICKED="rowDoubleClicked",e.EVENT_GRID_READY="gridReady",e.EVENT_GRID_SIZE_CHANGED="gridSizeChanged",e.EVENT_VIEWPORT_CHANGED="viewportChanged",e.EVENT_DRAG_STARTED="dragStarted",e.EVENT_DRAG_STOPPED="dragStopped",e.EVENT_ITEMS_ADDED="itemsAdded",e.EVENT_ITEMS_REMOVED="itemsRemoved",e}();t.Events=o},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(12),s=o(23),l=o(64),a=o(43),p=o(13),d=o(28),u=o(3),c=o(24),h=o(29),g=o(25),f=o(4),y=o(26),v=o(8),C=o(6),m=o(40),E=o(42),A=o(41),w=o(35),R=o(33),S=o(7),O=o(54),N=o(48),T=function(){function e(){}return e.prototype.init=function(){switch(this.rowModel.getType()){case v.Constants.ROW_MODEL_TYPE_NORMAL:case v.Constants.ROW_MODEL_TYPE_PAGINATION:this.inMemoryRowModel=this.rowModel;break;case v.Constants.ROW_MODEL_TYPE_VIRTUAL:this.virtualPageRowModel=this.rowModel}},e.prototype.__getMasterSlaveService=function(){return this.masterSlaveService},e.prototype.getFirstRenderedRow=function(){return this.rowRenderer.getFirstVirtualRenderedRow()},e.prototype.getLastRenderedRow=function(){return this.rowRenderer.getLastVirtualRenderedRow()},e.prototype.getDataAsCsv=function(e){return this.csvCreator.getDataAsCsv(e)},e.prototype.exportDataAsCsv=function(e){this.csvCreator.exportDataAsCsv(e)},e.prototype.setDatasource=function(e){this.gridOptionsWrapper.isRowModelPagination()?this.paginationController.setDatasource(e):this.gridOptionsWrapper.isRowModelVirtual()?this.rowModel.setDatasource(e):console.warn("ag-Grid: you can only use a datasource when gridOptions.rowModelType is '"+v.Constants.ROW_MODEL_TYPE_VIRTUAL+"' or '"+v.Constants.ROW_MODEL_TYPE_PAGINATION+"'")},e.prototype.setViewportDatasource=function(e){this.gridOptionsWrapper.isRowModelViewport()?this.rowModel.setViewportDatasource(e):console.warn("ag-Grid: you can only use a datasource when gridOptions.rowModelType is '"+v.Constants.ROW_MODEL_TYPE_VIEWPORT+"'")},e.prototype.setRowData=function(e){this.gridOptionsWrapper.isRowModelDefault()?(this.selectionController.reset(),this.inMemoryRowModel.setRowData(e,!0)):console.log("cannot call setRowData unless using normal row model")},e.prototype.setFloatingTopRowData=function(e){this.floatingRowModel.setFloatingTopRowData(e)},e.prototype.setFloatingBottomRowData=function(e){this.floatingRowModel.setFloatingBottomRowData(e)},e.prototype.setColumnDefs=function(e){this.columnController.setColumnDefs(e)},e.prototype.refreshRows=function(e){this.rowRenderer.refreshRows(e)},e.prototype.refreshCells=function(e,t,o){void 0===o&&(o=!1),this.rowRenderer.refreshCells(e,t,o)},e.prototype.rowDataChanged=function(e){this.rowRenderer.rowDataChanged(e)},e.prototype.refreshView=function(){this.rowRenderer.refreshView()},e.prototype.setFunctionsReadOnly=function(e){this.gridOptionsWrapper.setProperty("functionsReadOnly",e)},e.prototype.softRefreshView=function(){this.rowRenderer.softRefreshView()},e.prototype.refreshGroupRows=function(){this.rowRenderer.refreshGroupRows()},e.prototype.refreshHeader=function(){this.headerRenderer.refreshHeader()},e.prototype.isAnyFilterPresent=function(){return this.filterManager.isAnyFilterPresent()},e.prototype.isAdvancedFilterPresent=function(){return this.filterManager.isAdvancedFilterPresent()},e.prototype.isQuickFilterPresent=function(){return this.filterManager.isQuickFilterPresent()},e.prototype.getModel=function(){return this.rowModel},e.prototype.onGroupExpandedOrCollapsed=function(e){S.Utils.missing(this.inMemoryRowModel)&&console.log("cannot call onGroupExpandedOrCollapsed unless using normal row model"),this.inMemoryRowModel.refreshModel(v.Constants.STEP_MAP,e)},e.prototype.refreshInMemoryRowModel=function(){S.Utils.missing(this.inMemoryRowModel)&&console.log("cannot call refreshInMemoryRowModel unless using normal row model"),this.inMemoryRowModel.refreshModel(v.Constants.STEP_EVERYTHING)},e.prototype.expandAll=function(){S.Utils.missing(this.inMemoryRowModel)&&console.log("cannot call expandAll unless using normal row model"),this.inMemoryRowModel.expandOrCollapseAll(!0)},e.prototype.collapseAll=function(){S.Utils.missing(this.inMemoryRowModel)&&console.log("cannot call collapseAll unless using normal row model"),this.inMemoryRowModel.expandOrCollapseAll(!1)},e.prototype.addVirtualRowListener=function(e,t,o){"string"!=typeof e&&console.log("ag-Grid: addVirtualRowListener is deprecated, please use addRenderedRowListener."),this.addRenderedRowListener(e,t,o)},e.prototype.addRenderedRowListener=function(e,t,o){"virtualRowRemoved"===e&&(console.log("ag-Grid: event virtualRowRemoved is deprecated, now called renderedRowRemoved"),e=""),"virtualRowSelected"===e&&console.log("ag-Grid: event virtualRowSelected is deprecated, to register for individual row selection events, add a listener directly to the row node."),this.rowRenderer.addRenderedRowListener(e,t,o)},e.prototype.setQuickFilter=function(e){this.filterManager.setQuickFilter(e)},e.prototype.selectIndex=function(e,t,o){console.log("ag-Grid: do not use api for selection, call node.setSelected(value) instead"),o&&console.log("ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it"),this.selectionController.selectIndex(e,t)},e.prototype.deselectIndex=function(e,t){void 0===t&&(t=!1),console.log("ag-Grid: do not use api for selection, call node.setSelected(value) instead"),t&&console.log("ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it"),this.selectionController.deselectIndex(e)},e.prototype.selectNode=function(e,t,o){void 0===t&&(t=!1),void 0===o&&(o=!1),console.log("ag-Grid: API for selection is deprecated, call node.setSelected(value) instead"),o&&console.log("ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it"),e.setSelectedParams({newValue:!0,clearSelection:!t})},e.prototype.deselectNode=function(e,t){void 0===t&&(t=!1),console.log("ag-Grid: API for selection is deprecated, call node.setSelected(value) instead"),t&&console.log("ag-Grid: suppressEvents is no longer supported, stop listening for the event if you no longer want it"),e.setSelectedParams({newValue:!1})},e.prototype.selectAll=function(){this.selectionController.selectAllRowNodes()},e.prototype.deselectAll=function(){this.selectionController.deselectAllRowNodes()},e.prototype.recomputeAggregates=function(){S.Utils.missing(this.inMemoryRowModel)&&console.log("cannot call recomputeAggregates unless using normal row model"),this.inMemoryRowModel.refreshModel(v.Constants.STEP_AGGREGATE)},e.prototype.sizeColumnsToFit=function(){return this.gridOptionsWrapper.isForPrint()?void console.warn("ag-grid: sizeColumnsToFit does not work when forPrint=true"):void this.gridPanel.sizeColumnsToFit()},e.prototype.showLoadingOverlay=function(){this.gridPanel.showLoadingOverlay()},e.prototype.showNoRowsOverlay=function(){this.gridPanel.showNoRowsOverlay()},e.prototype.hideOverlay=function(){this.gridPanel.hideOverlay()},e.prototype.isNodeSelected=function(e){return console.log("ag-Grid: no need to call api.isNodeSelected(), just call node.isSelected() instead"),e.isSelected()},e.prototype.getSelectedNodesById=function(){return console.error("ag-Grid: since version 3.4, getSelectedNodesById no longer exists, use getSelectedNodes() instead"),null},e.prototype.getSelectedNodes=function(){return this.selectionController.getSelectedNodes()},e.prototype.getSelectedRows=function(){return this.selectionController.getSelectedRows()},e.prototype.getBestCostNodeSelection=function(){return this.selectionController.getBestCostNodeSelection()},e.prototype.getRenderedNodes=function(){return this.rowRenderer.getRenderedNodes()},e.prototype.ensureColIndexVisible=function(e){console.warn("ag-Grid: ensureColIndexVisible(index) no longer supported, use ensureColumnVisible(colKey) instead.")},e.prototype.ensureColumnVisible=function(e){this.gridPanel.ensureColumnVisible(e)},e.prototype.ensureIndexVisible=function(e){this.gridPanel.ensureIndexVisible(e)},e.prototype.ensureNodeVisible=function(e){this.gridCore.ensureNodeVisible(e)},e.prototype.forEachLeafNode=function(e){S.Utils.missing(this.inMemoryRowModel)&&console.log("cannot call forEachNodeAfterFilter unless using normal row model"),this.inMemoryRowModel.forEachLeafNode(e)},e.prototype.forEachNode=function(e){this.rowModel.forEachNode(e)},e.prototype.forEachNodeAfterFilter=function(e){S.Utils.missing(this.inMemoryRowModel)&&console.log("cannot call forEachNodeAfterFilter unless using normal row model"),this.inMemoryRowModel.forEachNodeAfterFilter(e)},e.prototype.forEachNodeAfterFilterAndSort=function(e){S.Utils.missing(this.inMemoryRowModel)&&console.log("cannot call forEachNodeAfterFilterAndSort unless using normal row model"),this.inMemoryRowModel.forEachNodeAfterFilterAndSort(e)},e.prototype.getFilterApiForColDef=function(e){return console.warn("ag-grid API method getFilterApiForColDef deprecated, use getFilterApi instead"),this.getFilterApi(e)},e.prototype.getFilterApi=function(e){var t=this.columnController.getPrimaryColumn(e);if(t)return this.filterManager.getFilterApi(t)},e.prototype.destroyFilter=function(e){var t=this.columnController.getPrimaryColumn(e);if(t)return this.filterManager.destroyFilter(t)},e.prototype.getColumnDef=function(e){var t=this.columnController.getPrimaryColumn(e);return t?t.getColDef():null},e.prototype.onFilterChanged=function(){this.filterManager.onFilterChanged()},e.prototype.setSortModel=function(e){this.sortController.setSortModel(e)},e.prototype.getSortModel=function(){return this.sortController.getSortModel()},e.prototype.setFilterModel=function(e){this.filterManager.setFilterModel(e)},e.prototype.getFilterModel=function(){return this.filterManager.getFilterModel()},e.prototype.getFocusedCell=function(){return this.focusedCellController.getFocusedCell()},e.prototype.setFocusedCell=function(e,t,o){this.focusedCellController.setFocusedCell(e,t,o,!0)},e.prototype.setHeaderHeight=function(e){this.gridOptionsWrapper.setProperty(u.GridOptionsWrapper.PROP_HEADER_HEIGHT,e)},e.prototype.showToolPanel=function(e){this.gridCore.showToolPanel(e)},e.prototype.isToolPanelShowing=function(){return this.gridCore.isToolPanelShowing()},e.prototype.doLayout=function(){this.gridCore.doLayout()},e.prototype.getValue=function(e,t){var o=this.columnController.getPrimaryColumn(e);return this.valueService.getValue(o,t)},e.prototype.addEventListener=function(e,t){this.eventService.addEventListener(e,t)},e.prototype.addGlobalListener=function(e){this.eventService.addGlobalListener(e)},e.prototype.removeEventListener=function(e,t){this.eventService.removeEventListener(e,t)},e.prototype.removeGlobalListener=function(e){this.eventService.removeGlobalListener(e)},e.prototype.dispatchEvent=function(e,t){this.eventService.dispatchEvent(e,t)},e.prototype.destroy=function(){this.context.destroy()},e.prototype.resetQuickFilter=function(){this.rowModel.forEachNode(function(e){return e.quickFilterAggregateText=null})},e.prototype.getRangeSelections=function(){return this.rangeController?this.rangeController.getCellRanges():(console.warn("ag-Grid: cell range selection is only available in ag-Grid Enterprise"),null)},e.prototype.addRangeSelection=function(e){this.rangeController||console.warn("ag-Grid: cell range selection is only available in ag-Grid Enterprise"),this.rangeController.addRange(e)},e.prototype.clearRangeSelection=function(){this.rangeController||console.warn("ag-Grid: cell range selection is only available in ag-Grid Enterprise"),this.rangeController.clearSelection()},e.prototype.copySelectedRowsToClipboard=function(e,t){this.clipboardService||console.warn("ag-Grid: clipboard is only available in ag-Grid Enterprise");this.clipboardService.copySelectedRowsToClipboard(e,t)},e.prototype.copySelectedRangeToClipboard=function(e){this.clipboardService||console.warn("ag-Grid: clipboard is only available in ag-Grid Enterprise"),this.clipboardService.copySelectedRangeToClipboard(e)},e.prototype.copySelectedRangeDown=function(){this.clipboardService||console.warn("ag-Grid: clipboard is only available in ag-Grid Enterprise"),this.clipboardService.copyRangeDown()},e.prototype.showColumnMenuAfterButtonClick=function(e,t){var o=this.columnController.getPrimaryColumn(e);this.menuFactory.showMenuAfterButtonClick(o,t)},e.prototype.showColumnMenuAfterMouseClick=function(e,t){var o=this.columnController.getPrimaryColumn(e);this.menuFactory.showMenuAfterMouseEvent(o,t)},e.prototype.stopEditing=function(e){void 0===e&&(e=!1),this.rowRenderer.stopEditing(e)},e.prototype.startEditingCell=function(e){var t=this.columnController.getGridColumn(e.colKey),o=new R.GridCell(e.rowIndex,null,t);this.rowRenderer.startEditingCell(o,e.keyPress,e.charPress)},e.prototype.addAggFunc=function(e,t){this.aggFuncService&&this.aggFuncService.addAggFunc(e,t)},e.prototype.addAggFuncs=function(e){this.aggFuncService&&this.aggFuncService.addAggFuncs(e)},e.prototype.clearAggFuncs=function(){this.aggFuncService&&this.aggFuncService.clear()},e.prototype.insertItemsAtIndex=function(e,t){this.rowModel.insertItemsAtIndex(e,t)},e.prototype.removeItems=function(e){this.rowModel.removeItems(e)},e.prototype.addItems=function(e){this.rowModel.addItems(e)},e.prototype.refreshVirtualPageCache=function(){this.virtualPageRowModel?this.virtualPageRowModel.refreshVirtualPageCache():console.warn("ag-Grid: api.refreshVirtualPageCache is only available when rowModelType='virtual'.")},e.prototype.purgeVirtualPageCache=function(){this.virtualPageRowModel?this.virtualPageRowModel.purgeVirtualPageCache():console.warn("ag-Grid: api.refreshVirtualPageCache is only available when rowModelType='virtual'.")},e.prototype.getVirtualRowCount=function(){return this.virtualPageRowModel?this.virtualPageRowModel.getVirtualRowCount():void console.warn("ag-Grid: api.getVirtualRowCount is only available when rowModelType='virtual'.")},e.prototype.isMaxRowFound=function(){return this.virtualPageRowModel?this.virtualPageRowModel.isMaxRowFound():void console.warn("ag-Grid: api.isMaxRowFound is only available when rowModelType='virtual'.")},e.prototype.setVirtualRowCount=function(e,t){this.virtualPageRowModel?this.virtualPageRowModel.setVirtualRowCount(e,t):console.warn("ag-Grid: api.setVirtualRowCount is only available when rowModelType='virtual'.")},e.prototype.getVirtualPageState=function(){return this.virtualPageRowModel?this.virtualPageRowModel.getVirtualPageState():void console.warn("ag-Grid: api.getVirtualPageState is only available when rowModelType='virtual'.")},i([C.Autowired("csvCreator"),n("design:type",r.CsvCreator)],e.prototype,"csvCreator",void 0),i([C.Autowired("gridCore"),n("design:type",m.GridCore)],e.prototype,"gridCore",void 0),i([C.Autowired("rowRenderer"),n("design:type",s.RowRenderer)],e.prototype,"rowRenderer",void 0),i([C.Autowired("headerRenderer"),n("design:type",l.HeaderRenderer)],e.prototype,"headerRenderer",void 0),i([C.Autowired("filterManager"),n("design:type",a.FilterManager)],e.prototype,"filterManager",void 0),i([C.Autowired("columnController"),n("design:type",p.ColumnController)],e.prototype,"columnController",void 0),i([C.Autowired("selectionController"),n("design:type",d.SelectionController)],e.prototype,"selectionController",void 0),i([C.Autowired("gridOptionsWrapper"),n("design:type",u.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([C.Autowired("gridPanel"),n("design:type",c.GridPanel)],e.prototype,"gridPanel",void 0),i([C.Autowired("valueService"),n("design:type",h.ValueService)],e.prototype,"valueService",void 0),i([C.Autowired("masterSlaveService"),n("design:type",g.MasterSlaveService)],e.prototype,"masterSlaveService",void 0),i([C.Autowired("eventService"),n("design:type",f.EventService)],e.prototype,"eventService",void 0),i([C.Autowired("floatingRowModel"),n("design:type",y.FloatingRowModel)],e.prototype,"floatingRowModel",void 0),i([C.Autowired("context"),n("design:type",C.Context)],e.prototype,"context",void 0),i([C.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),i([C.Autowired("sortController"),n("design:type",E.SortController)],e.prototype,"sortController",void 0),i([C.Autowired("paginationController"),n("design:type",A.PaginationController)],e.prototype,"paginationController",void 0),i([C.Autowired("focusedCellController"),n("design:type",w.FocusedCellController)],e.prototype,"focusedCellController",void 0),i([C.Optional("rangeController"),n("design:type",Object)],e.prototype,"rangeController",void 0),i([C.Optional("clipboardService"),n("design:type",Object)],e.prototype,"clipboardService",void 0),i([C.Optional("aggFuncService"),n("design:type",Object)],e.prototype,"aggFuncService",void 0),i([C.Autowired("menuFactory"),n("design:type",Object)],e.prototype,"menuFactory",void 0),i([C.Autowired("cellRendererFactory"),n("design:type",O.CellRendererFactory)],e.prototype,"cellRendererFactory",void 0),i([C.Autowired("cellEditorFactory"),n("design:type",N.CellEditorFactory)],e.prototype,"cellEditorFactory",void 0),i([C.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e=i([C.Bean("gridApi"),n("design:paramtypes",[])],e)}();t.GridApi=T},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(13),s=o(29),l=o(6),a=o(3),p=o(8),d=o(26),u=o(7),c="\r\n",h=function(){function e(){}return e.prototype.exportDataAsCsv=function(e){var t=this.getDataAsCsv(e),o=e&&e.fileName&&0!==e.fileName.length,i=o?e.fileName:"export.csv",n=new Blob(["\ufeff",t],{type:"text/csv;charset=utf-8;"});if(window.navigator.msSaveOrOpenBlob)window.navigator.msSaveOrOpenBlob(n,i);else{var r=document.createElement("a");r.href=window.URL.createObjectURL(n),r.download=i,document.body.appendChild(r),r.click(),document.body.removeChild(r)}},e.prototype.getDataAsCsv=function(e){function t(e){if((!l||!e.group)&&(!d||!e.footer)&&(!C||e.isSelected())&&!(h&&"top"===e.floating||g&&"bottom"===e.floating)){var t=e.level===-1;t&&!e.leafGroup||(i.forEach(function(t,o){var i;i=e.group&&O&&0===o?r.createValueForGroupNode(e):r.valueService.getValue(t,e),i=r.processCell(e,t,i,w),null!==i&&void 0!==i||(i=""),0!=o&&(s+=m),s+=r.putInQuotes(i,E)}),s+=c)}}function o(e,t){var o=r.getHeaderName(R,e);null!==o&&void 0!==o||(o=""),0!=t&&(s+=m),s+=r.putInQuotes(o,E)}if(this.rowModel.getType()!==p.Constants.ROW_MODEL_TYPE_NORMAL)return console.log("ag-Grid: getDataAsCsv is only available for standard row model"),"";var i,n=this.rowModel,r=this,s="",l=e&&e.skipGroups,a=e&&e.skipHeader,d=e&&e.skipFooters,h=e&&e.skipFloatingTop,g=e&&e.skipFloatingBottom,f=e&&e.customHeader,y=e&&e.customFooter,v=e&&e.allColumns,C=e&&e.onlySelected,m=e&&e.columnSeparator||",",E=e&&e.suppressQuotes,A=e&&e.columnKeys,w=e&&e.processCellCallback,R=e&&e.processHeaderCallback,S=this.columnController.isPivotMode(),O=this.columnController.getRowGroupColumns().length>0;return i=u.Utils.existsAndNotEmpty(A)?this.columnController.getGridColumns(A):v&&!S?this.columnController.getAllPrimaryColumns():this.columnController.getAllDisplayedColumns(),i&&0!==i.length?(f&&(s+=e.customHeader),a||(i.forEach(o),s+=c),this.floatingRowModel.forEachFloatingTopRow(t),S?n.forEachPivotNode(t):n.forEachNodeAfterFilterAndSort(t),this.floatingRowModel.forEachFloatingBottomRow(t),y&&(s+=e.customFooter),s):""},e.prototype.getHeaderName=function(e,t){return e?e({column:t,api:this.gridOptionsWrapper.getApi(),columnApi:this.gridOptionsWrapper.getColumnApi(),context:this.gridOptionsWrapper.getContext()}):this.columnController.getDisplayNameForCol(t,!0)},e.prototype.processCell=function(e,t,o,i){return i?i({column:t,node:e,value:o,api:this.gridOptionsWrapper.getApi(),columnApi:this.gridOptionsWrapper.getColumnApi(),context:this.gridOptionsWrapper.getContext()}):o},e.prototype.createValueForGroupNode=function(e){for(var t=[e.key];e.parent;)e=e.parent,t.push(e.key);return t.reverse().join(" -> ")},e.prototype.putInQuotes=function(e,t){if(t)return e;if(null===e||void 0===e)return'""';var o;"string"==typeof e?o=e:"function"==typeof e.toString?o=e.toString():(console.warn("unknown value type during csv conversion"),o="");var i=o.replace(/"/g,'""');return'"'+i+'"'},i([l.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),i([l.Autowired("floatingRowModel"),n("design:type",d.FloatingRowModel)],e.prototype,"floatingRowModel",void 0),i([l.Autowired("columnController"),n("design:type",r.ColumnController)],e.prototype,"columnController",void 0),i([l.Autowired("valueService"),n("design:type",s.ValueService)],e.prototype,"valueService",void 0),i([l.Autowired("gridOptionsWrapper"),n("design:type",a.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),e=i([l.Bean("csvCreator"),n("design:paramtypes",[])],e)}();t.CsvCreator=h},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(7),l=o(14),a=o(15),p=o(3),d=o(18),u=o(19),c=o(21),h=o(22),g=o(4),f=o(16),y=o(5),v=o(10),C=o(76),m=o(17),E=o(77),A=o(78),w=o(6),R=o(24),S=function(){function e(){}return e.prototype.sizeColumnsToFit=function(e){this._columnController.sizeColumnsToFit(e)},e.prototype.setColumnGroupOpened=function(e,t,o){this._columnController.setColumnGroupOpened(e,t,o)},e.prototype.getColumnGroup=function(e,t){return this._columnController.getColumnGroup(e,t)},e.prototype.getDisplayNameForCol=function(e){return this._columnController.getDisplayNameForCol(e)},e.prototype.getColumn=function(e){return this._columnController.getPrimaryColumn(e)},e.prototype.setColumnState=function(e){return this._columnController.setColumnState(e)},e.prototype.getColumnState=function(){return this._columnController.getColumnState()},e.prototype.resetColumnState=function(){this._columnController.resetColumnState()},e.prototype.isPinning=function(){return this._columnController.isPinningLeft()||this._columnController.isPinningRight()},e.prototype.isPinningLeft=function(){return this._columnController.isPinningLeft()},e.prototype.isPinningRight=function(){return this._columnController.isPinningRight()},e.prototype.getDisplayedColAfter=function(e){return this._columnController.getDisplayedColAfter(e)},e.prototype.getDisplayedColBefore=function(e){return this._columnController.getDisplayedColBefore(e)},e.prototype.setColumnVisible=function(e,t){this._columnController.setColumnVisible(e,t)},e.prototype.setColumnsVisible=function(e,t){this._columnController.setColumnsVisible(e,t)},e.prototype.setColumnPinned=function(e,t){this._columnController.setColumnPinned(e,t)},e.prototype.setColumnsPinned=function(e,t){this._columnController.setColumnsPinned(e,t)},e.prototype.getAllColumns=function(){return this._columnController.getAllPrimaryColumns()},e.prototype.getAllGridColumns=function(){return this._columnController.getAllGridColumns()},e.prototype.getDisplayedLeftColumns=function(){return this._columnController.getDisplayedLeftColumns()},e.prototype.getDisplayedCenterColumns=function(){return this._columnController.getDisplayedCenterColumns()},e.prototype.getDisplayedRightColumns=function(){return this._columnController.getDisplayedRightColumns()},e.prototype.getAllDisplayedColumns=function(){return this._columnController.getAllDisplayedColumns()},e.prototype.getAllDisplayedVirtualColumns=function(){return this._columnController.getAllDisplayedVirtualColumns()},e.prototype.moveColumn=function(e,t){this._columnController.moveColumnByIndex(e,t)},e.prototype.moveRowGroupColumn=function(e,t){this._columnController.moveRowGroupColumn(e,t)},e.prototype.setColumnAggFunct=function(e,t){this._columnController.setColumnAggFunc(e,t)},e.prototype.setColumnWidth=function(e,t,o){void 0===o&&(o=!0),this._columnController.setColumnWidth(e,t,o)},e.prototype.setPivotMode=function(e){this._columnController.setPivotMode(e)},e.prototype.isPivotMode=function(){return this._columnController.isPivotMode()},e.prototype.getSecondaryPivotColumn=function(e,t){return this._columnController.getSecondaryPivotColumn(e,t)},e.prototype.getValueColumns=function(){return this._columnController.getValueColumns()},e.prototype.removeValueColumn=function(e){this._columnController.removeValueColumn(e)},e.prototype.removeValueColumns=function(e){this._columnController.removeValueColumns(e)},e.prototype.addValueColumn=function(e){this._columnController.addValueColumn(e)},e.prototype.addValueColumns=function(e){this._columnController.addValueColumns(e)},e.prototype.setRowGroupColumns=function(e){this._columnController.setRowGroupColumns(e)},e.prototype.removeRowGroupColumn=function(e){this._columnController.removeRowGroupColumn(e)},e.prototype.removeRowGroupColumns=function(e){this._columnController.removeRowGroupColumns(e)},e.prototype.addRowGroupColumn=function(e){this._columnController.addRowGroupColumn(e)},e.prototype.addRowGroupColumns=function(e){this._columnController.addRowGroupColumns(e)},e.prototype.getRowGroupColumns=function(){return this._columnController.getRowGroupColumns()},e.prototype.setPivotColumns=function(e){this._columnController.setPivotColumns(e)},e.prototype.removePivotColumn=function(e){this._columnController.removePivotColumn(e)},e.prototype.removePivotColumns=function(e){this._columnController.removePivotColumns(e)},e.prototype.addPivotColumn=function(e){this._columnController.addPivotColumn(e)},e.prototype.addPivotColumns=function(e){this._columnController.addPivotColumns(e)},e.prototype.getPivotColumns=function(){return this._columnController.getPivotColumns()},e.prototype.getLeftDisplayedColumnGroups=function(){return this._columnController.getLeftDisplayedColumnGroups()},e.prototype.getCenterDisplayedColumnGroups=function(){return this._columnController.getCenterDisplayedColumnGroups()},e.prototype.getRightDisplayedColumnGroups=function(){return this._columnController.getRightDisplayedColumnGroups()},e.prototype.getAllDisplayedColumnGroups=function(){return this._columnController.getAllDisplayedColumnGroups()},e.prototype.autoSizeColumn=function(e){return this._columnController.autoSizeColumn(e)},e.prototype.autoSizeColumns=function(e){return this._columnController.autoSizeColumns(e)},e.prototype.autoSizeAllColumns=function(){this._columnController.autoSizeAllColumns()},e.prototype.setSecondaryColumns=function(e){this._columnController.setSecondaryColumns(e)},e.prototype.columnGroupOpened=function(e,t){console.error("ag-Grid: columnGroupOpened no longer exists, use setColumnGroupOpened"),this.setColumnGroupOpened(e,t)},e.prototype.hideColumns=function(e,t){console.error("ag-Grid: hideColumns is deprecated, use setColumnsVisible"),this._columnController.setColumnsVisible(e,!t)},e.prototype.hideColumn=function(e,t){console.error("ag-Grid: hideColumn is deprecated, use setColumnVisible"),this._columnController.setColumnVisible(e,!t)},e.prototype.setState=function(e){return console.error("ag-Grid: setState is deprecated, use setColumnState"),this.setColumnState(e)},e.prototype.getState=function(){return console.error("ag-Grid: getState is deprecated, use getColumnState"),this.getColumnState()},e.prototype.resetState=function(){console.error("ag-Grid: resetState is deprecated, use resetColumnState"),this.resetColumnState()},e.prototype.getAggregationColumns=function(){return console.error("ag-Grid: getAggregationColumns is deprecated, use getValueColumns"),this._columnController.getValueColumns()},e.prototype.removeAggregationColumn=function(e){console.error("ag-Grid: removeAggregationColumn is deprecated, use removeValueColumn"),this._columnController.removeValueColumn(e)},e.prototype.removeAggregationColumns=function(e){console.error("ag-Grid: removeAggregationColumns is deprecated, use removeValueColumns"),this._columnController.removeValueColumns(e)},e.prototype.addAggregationColumn=function(e){console.error("ag-Grid: addAggregationColumn is deprecated, use addValueColumn"),this._columnController.addValueColumn(e)},e.prototype.addAggregationColumns=function(e){console.error("ag-Grid: addAggregationColumns is deprecated, use addValueColumns"),this._columnController.addValueColumns(e)},e.prototype.setColumnAggFunction=function(e,t){console.error("ag-Grid: setColumnAggFunction is deprecated, use setColumnAggFunc"),this._columnController.setColumnAggFunc(e,t)},i([w.Autowired("columnController"),n("design:type",O)],e.prototype,"_columnController",void 0),e=i([w.Bean("columnApi"),n("design:paramtypes",[])],e)}();t.ColumnApi=S;var O=function(){function e(){this.primaryHeaderRowCount=0,this.secondaryHeaderRowCount=0,this.secondaryColumnsPresent=!1,this.gridHeaderRowCount=0,this.displayedLeftColumns=[],this.displayedRightColumns=[],this.displayedCenterColumns=[],this.allDisplayedColumns=[],this.allDisplayedVirtualColumns=[],this.rowGroupColumns=[],this.valueColumns=[],this.pivotColumns=[],this.ready=!1,this.pivotMode=!1}return e.prototype.init=function(){this.pivotMode=this.gridOptionsWrapper.isPivotMode(),this.gridOptionsWrapper.getColumnDefs()&&this.setColumnDefs(this.gridOptionsWrapper.getColumnDefs())},e.prototype.setViewportLeftAndRight=function(){this.viewportLeft=this.scrollPosition,this.viewportRight=this.totalWidth+this.scrollPosition},e.prototype.checkDisplayedCenterColumns=function(){if(s.Utils.exists(this.displayedCenterColumns)){var e=this.allDisplayedVirtualColumns.map(function(e){return e.getId()}).join("#");this.updateVirtualSets();var t=this.allDisplayedVirtualColumns.map(function(e){return e.getId()}).join("#");e!==t&&this.eventService.dispatchEvent(v.Events.EVENT_VIRTUAL_COLUMNS_CHANGED)}},e.prototype.setWidthAndScrollPosition=function(e,t){e===this.totalWidth&&t===this.scrollPosition||(this.totalWidth=e,this.scrollPosition=t,this.setViewportLeftAndRight(),this.ready&&this.checkDisplayedCenterColumns())},e.prototype.isPivotMode=function(){return this.pivotMode},e.prototype.setPivotMode=function(e){if(e!==this.pivotMode){this.pivotMode=e,this.updateDisplayedColumns();var t=new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED);this.eventService.dispatchEvent(v.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,t)}},e.prototype.getSecondaryPivotColumn=function(e,t){if(!this.secondaryColumnsPresent)return null;var o=this.getPrimaryColumn(t),i=null;return this.secondaryColumns.forEach(function(t){var n=t.getColDef().pivotKeys,r=t.getColDef().pivotValueColumn,l=s.Utils.compareArrays(n,e),a=r===o;l&&a&&(i=t)}),i},e.prototype.setBeans=function(e){this.logger=e.create("ColumnController")},e.prototype.setFirstRightAndLastLeftPinned=function(){var e=this.displayedLeftColumns?this.displayedLeftColumns[this.displayedLeftColumns.length-1]:null,t=this.displayedRightColumns?this.displayedRightColumns[0]:null;this.gridColumns.forEach(function(o){o.setLastLeftPinned(o===e),o.setFirstRightPinned(o===t)})},e.prototype.autoSizeColumns=function(e){for(var t=this,o=[],i=-1;0!==i;)i=0,this.actionOnGridColumns(e,function(e){if(!(o.indexOf(e)>=0)){var n=t.autoWidthCalculator.getPreferredWidthForColumn(e);if(n>0){var r=t.normaliseColumnWidth(e,n);e.setActualWidth(r),o.push(e),i++}return!0}},function(){return new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_RESIZED).withFinished(!0)})},e.prototype.autoSizeColumn=function(e){this.autoSizeColumns([e])},e.prototype.autoSizeAllColumns=function(){var e=this.getAllDisplayedColumns();this.autoSizeColumns(e)},e.prototype.getColumnsFromTree=function(e){function t(e){for(var i=0;i<e.length;i++){var n=e[i];n instanceof a.Column?o.push(n):n instanceof m.OriginalColumnGroup&&t(n.getChildren())}}var o=[];return t(e),o},e.prototype.getAllDisplayedColumnGroups=function(){return this.displayedLeftColumnTree&&this.displayedRightColumnTree&&this.displayedCentreColumnTree?this.displayedLeftColumnTree.concat(this.displayedCentreColumnTree).concat(this.displayedRightColumnTree):null},e.prototype.getPrimaryColumnTree=function(){return this.primaryBalancedTree},e.prototype.getHeaderRowCount=function(){return this.gridHeaderRowCount},e.prototype.getLeftDisplayedColumnGroups=function(){return this.displayedLeftColumnTree},e.prototype.getRightDisplayedColumnGroups=function(){return this.displayedRightColumnTree},e.prototype.getCenterDisplayedColumnGroups=function(){return this.displayedCentreColumnTree},e.prototype.getDisplayedColumnGroups=function(e){switch(e){case a.Column.PINNED_LEFT:return this.getLeftDisplayedColumnGroups();case a.Column.PINNED_RIGHT:return this.getRightDisplayedColumnGroups();default:return this.getCenterDisplayedColumnGroups()}},e.prototype.isColumnDisplayed=function(e){return this.getAllDisplayedColumns().indexOf(e)>=0},e.prototype.getAllDisplayedColumns=function(){return this.allDisplayedColumns},e.prototype.getAllDisplayedVirtualColumns=function(){return this.allDisplayedVirtualColumns},e.prototype.getPinnedLeftContainerWidth=function(){return this.getWidthOfColsInList(this.displayedLeftColumns)},e.prototype.getPinnedRightContainerWidth=function(){return this.getWidthOfColsInList(this.displayedRightColumns)},e.prototype.addRowGroupColumns=function(e,t){var o=this;this.actionOnPrimaryColumns(e,function(e){return!e.isRowGroupActive()&&(o.rowGroupColumns.push(e),e.setRowGroupActive(!0),!0)},function(){return new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_ROW_GROUP_CHANGED)},t)},e.prototype.setRowGroupColumns=function(e){var t=[];this.rowGroupColumns.forEach(function(e){e.setRowGroupActive(!1),t.push(e)}),this.rowGroupColumns.length=0,this.addRowGroupColumns(e,t)},e.prototype.addRowGroupColumn=function(e){this.addRowGroupColumns([e])},e.prototype.removeRowGroupColumns=function(e){var t=this;this.actionOnPrimaryColumns(e,function(e){return!!e.isRowGroupActive()&&(s.Utils.removeFromArray(t.rowGroupColumns,e),e.setRowGroupActive(!1),!0)},function(){return new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_ROW_GROUP_CHANGED)})},e.prototype.removeRowGroupColumn=function(e){this.removeRowGroupColumns([e])},e.prototype.addPivotColumns=function(e,t){var o=this;this.actionOnPrimaryColumns(e,function(e){return!e.isPivotActive()&&(o.pivotColumns.push(e),e.setPivotActive(!0),!0)},function(){return new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_PIVOT_CHANGED)},t)},e.prototype.setPivotColumns=function(e){var t=[];this.pivotColumns.forEach(function(e){e.setPivotActive(!1),t.push(e)}),this.pivotColumns.length=0,this.addPivotColumns(e,t)},e.prototype.addPivotColumn=function(e){this.addPivotColumns([e])},e.prototype.removePivotColumns=function(e){var t=this;this.actionOnPrimaryColumns(e,function(e){return!!e.isPivotActive()&&(s.Utils.removeFromArray(t.pivotColumns,e),e.setPivotActive(!1),!0)},function(){return new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_PIVOT_CHANGED)})},e.prototype.removePivotColumn=function(e){this.removePivotColumns([e])},e.prototype.addValueColumns=function(e){var t=this;this.actionOnPrimaryColumns(e,function(e){if(e.isValueActive())return!1;if(!e.getAggFunc()){var o=t.aggFuncService.getDefaultAggFunc();e.setAggFunc(o)}return t.valueColumns.push(e),e.setValueActive(!0),!0},function(){return new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_VALUE_CHANGED)})},e.prototype.addValueColumn=function(e){this.addValueColumns([e])},e.prototype.removeValueColumn=function(e){this.removeValueColumns([e])},e.prototype.removeValueColumns=function(e){var t=this;this.actionOnPrimaryColumns(e,function(e){return!!e.isValueActive()&&(s.Utils.removeFromArray(t.valueColumns,e),e.setValueActive(!1),!0)},function(){return new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_VALUE_CHANGED)})},e.prototype.normaliseColumnWidth=function(e,t){return t<e.getMinWidth()&&(t=e.getMinWidth()),e.isGreaterThanMax(t)&&(t=e.getMaxWidth()),t},e.prototype.getPrimaryOrGridColumn=function(e){var t=this.getPrimaryColumn(e);return t?t:this.getGridColumn(e)},e.prototype.setColumnWidth=function(e,t,o){var i=this.getPrimaryOrGridColumn(e);if(i){t=this.normaliseColumnWidth(i,t);var n=i.getActualWidth()!==t;if(n&&(i.setActualWidth(t),this.setLeftValues()),o||n){var r=new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_RESIZED).withColumn(i).withFinished(o);this.eventService.dispatchEvent(v.Events.EVENT_COLUMN_RESIZED,r)}this.checkDisplayedCenterColumns()}},e.prototype.setColumnAggFunc=function(e,t){e.setAggFunc(t);var o=new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_VALUE_CHANGED).withColumn(e);this.eventService.dispatchEvent(v.Events.EVENT_COLUMN_VALUE_CHANGED,o)},e.prototype.moveRowGroupColumn=function(e,t){var o=this.rowGroupColumns[e];this.rowGroupColumns.splice(e,1),this.rowGroupColumns.splice(t,0,o);var i=new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_ROW_GROUP_CHANGED);this.eventService.dispatchEvent(v.Events.EVENT_COLUMN_ROW_GROUP_CHANGED,i)},e.prototype.moveColumns=function(e,t){if(t>this.gridColumns.length-e.length)return console.warn("ag-Grid: tried to insert columns in invalid location, toIndex = "+t),void console.warn("ag-Grid: remember that you should not count the moving columns when calculating the new index");var o=this.getGridColumns(e),i=!this.doesMovePassRules(o,t);if(!i){this.gridPanel.turnOnAnimationForABit(),s.Utils.moveInArray(this.gridColumns,o,t),this.updateDisplayedColumns();var n=new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_MOVED).withToIndex(t).withColumns(o);1===o.length&&n.withColumn(o[0]),this.eventService.dispatchEvent(v.Events.EVENT_COLUMN_MOVED,n)}},e.prototype.doesMovePassRules=function(e,t){var o=this.gridColumns.slice();s.Utils.moveInArray(o,e,t);for(var i=0;i<o.length-1;i++){var n=o[i],r=o[i+1];if(r.isVisible()){var l=this.columnUtils.getOriginalPathForColumn(n,this.gridBalancedTree),a=this.columnUtils.getOriginalPathForColumn(r,this.gridBalancedTree);a&&l||console.log("next path is missing");for(var p=0;p<l.length;p++){var d=l[p],u=a[p],c=d!==u,h=d.getColGroupDef(),g=h&&h.marryChildren,f=c&&g;if(f)for(var y=i+1;y<o.length;y++){var v=o[y],C=this.columnUtils.getOriginalPathForColumn(v,this.gridBalancedTree),m=C[p];if(m===d)return!1}}}}return!0},e.prototype.moveColumn=function(e,t){this.moveColumns([e],t)},e.prototype.moveColumnByIndex=function(e,t){var o=this.gridColumns[e];this.moveColumn(o,t)},e.prototype.getBodyContainerWidth=function(){var e=this.getWidthOfColsInList(this.displayedCenterColumns);return e},e.prototype.getValueColumns=function(){return this.valueColumns?this.valueColumns:[]},e.prototype.getPivotColumns=function(){return this.pivotColumns?this.pivotColumns:[]},e.prototype.isPivotActive=function(){return this.pivotColumns&&this.pivotColumns.length>0&&this.pivotMode},e.prototype.getRowGroupColumns=function(){return this.rowGroupColumns?this.rowGroupColumns:[]},e.prototype.getDisplayedCenterColumns=function(){return this.displayedCenterColumns.slice(0)},e.prototype.getDisplayedLeftColumns=function(){return this.displayedLeftColumns.slice(0)},e.prototype.getDisplayedRightColumns=function(){return this.displayedRightColumns.slice(0)},e.prototype.getDisplayedColumns=function(e){switch(e){case a.Column.PINNED_LEFT:return this.getDisplayedLeftColumns();case a.Column.PINNED_RIGHT:return this.getDisplayedRightColumns();default:return this.getDisplayedCenterColumns()}},e.prototype.getAllPrimaryColumns=function(){return this.primaryColumns},e.prototype.getAllGridColumns=function(){return this.gridColumns},e.prototype.isEmpty=function(){return s.Utils.missingOrEmpty(this.gridColumns)},e.prototype.isRowGroupEmpty=function(){return s.Utils.missingOrEmpty(this.rowGroupColumns)},e.prototype.setColumnVisible=function(e,t){this.setColumnsVisible([e],t)},e.prototype.setColumnsVisible=function(e,t){this.gridPanel.turnOnAnimationForABit(),this.actionOnGridColumns(e,function(e){return e.setVisible(t),!0},function(){return new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_VISIBLE).withVisible(t)})},e.prototype.setColumnPinned=function(e,t){this.setColumnsPinned([e],t)},e.prototype.setColumnsPinned=function(e,t){this.gridPanel.turnOnAnimationForABit();var o;o=t===!0||t===a.Column.PINNED_LEFT?a.Column.PINNED_LEFT:t===a.Column.PINNED_RIGHT?a.Column.PINNED_RIGHT:null,this.actionOnGridColumns(e,function(e){return e.setPinned(o),!0},function(){return new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_PINNED).withPinned(o)})},e.prototype.actionOnGridColumns=function(e,t,o,i){this.actionOnColumns(e,this.getGridColumn.bind(this),t,o,i)},e.prototype.actionOnPrimaryColumns=function(e,t,o,i){this.actionOnColumns(e,this.getPrimaryColumn.bind(this),t,o,i)},e.prototype.actionOnColumns=function(e,t,o,i,n){if(!s.Utils.missingOrEmpty(e)||!s.Utils.missingOrEmpty(n)){var r=[];if(e.forEach(function(e){var i=t(e);if(i){var n=o(i);n!==!1&&r.push(i)}}),0!==r.length||!s.Utils.missingOrEmpty(n)){s.Utils.existsAndNotEmpty(n)&&n.forEach(function(e){r.indexOf(e)<0&&r.push(e)}),this.updateDisplayedColumns();var l=i();l.withColumns(r),1===r.length&&l.withColumn(r[0]),this.eventService.dispatchEvent(l.getType(),l)}}},e.prototype.getDisplayedColBefore=function(e){var t=this.getAllDisplayedColumns(),o=t.indexOf(e);return o>0?t[o-1]:null},e.prototype.getDisplayedColAfter=function(e){var t=this.getAllDisplayedColumns(),o=t.indexOf(e);return o<t.length-1?t[o+1]:null},e.prototype.isPinningLeft=function(){return this.displayedLeftColumns.length>0},e.prototype.isPinningRight=function(){return this.displayedRightColumns.length>0},e.prototype.getPrimaryAndSecondaryAndAutoColumns=function(){var e=this.primaryColumns?this.primaryColumns.slice(0):[];return this.groupAutoColumnActive&&e.push(this.groupAutoColumn),this.secondaryColumnsPresent&&this.secondaryColumns.forEach(function(t){return e.push(t)}),e},e.prototype.createStateItemFromColumn=function(e){var t=e.isRowGroupActive()?this.rowGroupColumns.indexOf(e):null,o=e.isPivotActive()?this.pivotColumns.indexOf(e):null,i=e.isValueActive()?e.getAggFunc():null,n={colId:e.getColId(),hide:!e.isVisible(),aggFunc:i,width:e.getActualWidth(),pivotIndex:o,pinned:e.getPinned(),rowGroupIndex:t};return n},e.prototype.getColumnState=function(){if(s.Utils.missing(this.primaryColumns))return[];var e=this.primaryColumns.map(this.createStateItemFromColumn.bind(this));return this.pivotMode||this.orderColumnStateList(e),e},e.prototype.orderColumnStateList=function(e){var t=this.gridColumns.map(function(e){return e.getColId()});e.sort(function(e,o){var i=t.indexOf(e.colId),n=t.indexOf(o.colId);return i-n})},e.prototype.resetColumnState=function(){var e=this.getColumnsFromTree(this.primaryBalancedTree),t=[];e&&e.forEach(function(e){t.push({colId:e.getColId(),aggFunc:e.getColDef().aggFunc,hide:e.getColDef().hide,pinned:e.getColDef().pinned,rowGroupIndex:e.getColDef().rowGroupIndex,pivotIndex:e.getColDef().pivotIndex,width:e.getColDef().width})}),this.setColumnState(t)},e.prototype.setColumnState=function(e){var t=this;if(s.Utils.missingOrEmpty(this.primaryColumns))return!1;var o=this.primaryColumns.slice();this.rowGroupColumns=[],this.valueColumns=[],this.pivotColumns=[];var i=!0,n={},r={};e&&e.forEach(function(e){var l=t.getPrimaryColumn(e.colId);l?(t.syncColumnWithStateItem(l,e,n,r),s.Utils.removeFromArray(o,l)):(console.warn("ag-grid: column "+e.colId+" not found"),i=!1)}),o.forEach(this.syncColumnWithNoState.bind(this)),this.rowGroupColumns.sort(this.sortColumnListUsingIndexes.bind(this,n)),this.pivotColumns.sort(this.sortColumnListUsingIndexes.bind(this,r)),this.copyDownGridColumns();var l=e.map(function(e){return e.colId});this.gridColumns.sort(function(e,t){var o=l.indexOf(e.getId()),i=l.indexOf(t.getId());return o-i}),this.updateDisplayedColumns();var a=new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_EVERYTHING_CHANGED);return this.eventService.dispatchEvent(v.Events.EVENT_COLUMN_EVERYTHING_CHANGED,a),i},e.prototype.sortColumnListUsingIndexes=function(e,t,o){var i=e[t.getId()],n=e[o.getId()];return i-n},e.prototype.syncColumnWithNoState=function(e){e.setVisible(!1),e.setAggFunc(null),e.setPinned(null),e.setRowGroupActive(!1),e.setPivotActive(!1),e.setValueActive(!1)},e.prototype.syncColumnWithStateItem=function(e,t,o,i){e.setVisible(!t.hide),e.setPinned(t.pinned),t.width>=this.gridOptionsWrapper.getMinColWidth()&&e.setActualWidth(t.width),"string"==typeof t.aggFunc?(e.setAggFunc(t.aggFunc),e.setValueActive(!0),this.valueColumns.push(e)):(e.setAggFunc(null),e.setValueActive(!1)),"number"==typeof t.rowGroupIndex?(this.rowGroupColumns.push(e),e.setRowGroupActive(!0),o[e.getId()]=t.rowGroupIndex):e.setRowGroupActive(!1),"number"==typeof t.pivotIndex?(this.pivotColumns.push(e),e.setPivotActive(!0),i[e.getId()]=t.pivotIndex):e.setPivotActive(!1)},e.prototype.getGridColumns=function(e){return this.getColumns(e,this.getGridColumn.bind(this))},e.prototype.getColumns=function(e,t){var o=[];return e&&e.forEach(function(e){var i=t(e);i&&o.push(i)}),o},e.prototype.getColumnWithValidation=function(e){var t=this.getPrimaryColumn(e);return t||console.warn("ag-Grid: could not find column "+t),t},e.prototype.getPrimaryColumn=function(e){return this.getColumn(e,this.primaryColumns)},e.prototype.getGridColumn=function(e){return this.getColumn(e,this.gridColumns)},e.prototype.getColumn=function(e,t){function o(t){var o=t===e,i=t.getColDef()===e,n=t.getColId()==e;return o||i||n}if(!e)return null;for(var i=0;i<t.length;i++)if(o(t[i]))return t[i];return this.groupAutoColumnActive&&o(this.groupAutoColumn)?this.groupAutoColumn:null},e.prototype.getDisplayNameForCol=function(e,t){void 0===t&&(t=!1);var o=this.getHeaderName(e);return t?this.wrapHeaderNameWithAggFunc(e,o):o},e.prototype.getHeaderName=function(e){var t=e.getColDef(),o=t.headerValueGetter;if(o){var i={colDef:t,api:this.gridOptionsWrapper.getApi(),context:this.gridOptionsWrapper.getContext()};return"function"==typeof o?o(i):"string"==typeof o?this.expressionService.evaluate(o,i):(console.warn("ag-grid: headerValueGetter must be a function or a string"),"")}return t.headerName},e.prototype.wrapHeaderNameWithAggFunc=function(e,t){if(this.gridOptionsWrapper.isSuppressAggFuncInHeader())return t;var o,i=e.getColDef().pivotValueColumn,n=s.Utils.exists(i),r=null;if(n)r=i.getAggFunc(),o=!0;else{var l=e.isValueActive(),a=this.pivotMode||!this.isRowGroupEmpty();l&&a?(r=e.getAggFunc(),o=!0):o=!1}if(o){var p="string"==typeof r?r:"func";return p+"("+t+")"}return t},e.prototype.getColumnGroup=function(e,t){if(!e)return null;if(e instanceof l.ColumnGroup)return e;var o=this.getAllDisplayedColumnGroups(),i="number"==typeof t,n=null;return this.columnUtils.deptFirstAllColumnTreeSearch(o,function(o){if(o instanceof l.ColumnGroup){var r,s=o;r=i?e===s.getGroupId()&&t===s.getInstanceId():e===s.getGroupId(),r&&(n=s)}}),n},e.prototype.setColumnDefs=function(e){var t=this.balancedColumnTreeBuilder.createBalancedColumnGroups(e,!0);this.primaryBalancedTree=t.balancedTree,this.primaryHeaderRowCount=t.treeDept+1,this.primaryColumns=this.getColumnsFromTree(this.primaryBalancedTree),this.extractRowGroupColumns(),this.extractPivotColumns(),this.createValueColumns(),this.copyDownGridColumns(),this.updateDisplayedColumns(),this.ready=!0;var o=new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_EVERYTHING_CHANGED);this.eventService.dispatchEvent(v.Events.EVENT_COLUMN_EVERYTHING_CHANGED,o),this.eventService.dispatchEvent(v.Events.EVENT_NEW_COLUMNS_LOADED)},e.prototype.isReady=function(){return this.ready},e.prototype.extractRowGroupColumns=function(){var e=this;this.rowGroupColumns.forEach(function(e){return e.setRowGroupActive(!1)}),this.rowGroupColumns=[],this.primaryColumns.forEach(function(t){"number"==typeof t.getColDef().rowGroupIndex&&(e.rowGroupColumns.push(t),t.setRowGroupActive(!0))}),this.rowGroupColumns.sort(function(e,t){return e.getColDef().rowGroupIndex-t.getColDef().rowGroupIndex})},e.prototype.extractPivotColumns=function(){var e=this;this.pivotColumns.forEach(function(e){return e.setPivotActive(!1)}),this.pivotColumns=[],this.primaryColumns.forEach(function(t){"number"==typeof t.getColDef().pivotIndex&&(e.pivotColumns.push(t),t.setPivotActive(!0))}),this.pivotColumns.sort(function(e,t){return e.getColDef().pivotIndex-t.getColDef().pivotIndex})},e.prototype.setColumnGroupOpened=function(e,t,o){var i=this.getColumnGroup(e,o);if(i){this.logger.log("columnGroupOpened("+i.getGroupId()+","+t+")"),i.setExpanded(t),this.gridPanel.turnOnAnimationForABit(),this.updateGroupsAndDisplayedColumns();var n=new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_GROUP_OPENED).withColumnGroup(i);this.eventService.dispatchEvent(v.Events.EVENT_COLUMN_GROUP_OPENED,n)}},e.prototype.getColumnGroupState=function(){var e={};return this.columnUtils.deptFirstDisplayedColumnTreeSearch(this.getAllDisplayedColumnGroups(),function(t){if(t instanceof l.ColumnGroup){var o=t,i=o.getGroupId();e.hasOwnProperty(i)||(e[i]=o.isExpanded())}}),e},e.prototype.setColumnGroupState=function(e){this.columnUtils.deptFirstDisplayedColumnTreeSearch(this.getAllDisplayedColumnGroups(),function(t){if(t instanceof l.ColumnGroup){var o=t,i=o.getGroupId(),n=e[i]===!0&&o.isExpandable();n&&o.setExpanded(!0)}})},e.prototype.calculateColumnsForDisplay=function(){var e;return e=this.pivotMode&&!this.secondaryColumnsPresent?this.createColumnsToDisplayFromValueColumns():s.Utils.filter(this.gridColumns,function(e){return e.isVisible()}),this.createGroupAutoColumn(),this.groupAutoColumnActive&&e.unshift(this.groupAutoColumn),e},e.prototype.createColumnsToDisplayFromValueColumns=function(){var e=this,t=this.valueColumns.slice();return t.sort(function(t,o){return e.gridColumns.indexOf(t)-e.gridColumns.indexOf(o)}),t},e.prototype.updateDisplayedColumns=function(){var e=this.getColumnGroupState(),t=this.calculateColumnsForDisplay();this.buildDisplayedTrees(t),this.setColumnGroupState(e),this.updateGroupsAndDisplayedColumns(),this.setFirstRightAndLastLeftPinned()},e.prototype.isSecondaryColumnsPresent=function(){return this.secondaryColumnsPresent},e.prototype.setSecondaryColumns=function(e){var t=e&&e.length>0;if(t||this.secondaryColumnsPresent){if(t){var o=this.balancedColumnTreeBuilder.createBalancedColumnGroups(e,!1);this.secondaryBalancedTree=o.balancedTree,this.secondaryHeaderRowCount=o.treeDept+1,this.secondaryColumns=this.getColumnsFromTree(this.secondaryBalancedTree),this.secondaryColumnsPresent=!0}else this.secondaryBalancedTree=null,this.secondaryHeaderRowCount=-1,this.secondaryColumns=null,this.secondaryColumnsPresent=!1;this.copyDownGridColumns(),this.updateDisplayedColumns()}},e.prototype.copyDownGridColumns=function(){this.secondaryColumns?(this.gridBalancedTree=this.secondaryBalancedTree.slice(),this.gridHeaderRowCount=this.secondaryHeaderRowCount,this.gridColumns=this.secondaryColumns.slice()):(this.gridBalancedTree=this.primaryBalancedTree.slice(),this.gridHeaderRowCount=this.primaryHeaderRowCount,this.gridColumns=this.primaryColumns.slice()),this.clearDisplayedColumns();var e=new C.ColumnChangeEvent(v.Events.EVENT_GRID_COLUMNS_CHANGED);this.eventService.dispatchEvent(v.Events.EVENT_GRID_COLUMNS_CHANGED,e)},e.prototype.clearDisplayedColumns=function(){this.displayedLeftColumnTree=[],this.displayedRightColumnTree=[],this.displayedCentreColumnTree=[],this.displayedLeftHeaderRows={},this.displayedRightHeaderRows={},this.displayedCentreHeaderRows={},this.displayedLeftColumns=[],this.displayedRightColumns=[],this.displayedCenterColumns=[],this.allDisplayedColumns=[],this.allDisplayedVirtualColumns=[]},e.prototype.updateGroupsAndDisplayedColumns=function(){this.updateGroups(),this.updateDisplayedColumnsFromTrees(),this.updateVirtualSets();var e=new C.ColumnChangeEvent(v.Events.EVENT_DISPLAYED_COLUMNS_CHANGED);this.eventService.dispatchEvent(v.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,e)},e.prototype.updateDisplayedColumnsFromTrees=function(){this.addToDisplayedColumns(this.displayedLeftColumnTree,this.displayedLeftColumns),this.addToDisplayedColumns(this.displayedCentreColumnTree,this.displayedCenterColumns),this.addToDisplayedColumns(this.displayedRightColumnTree,this.displayedRightColumns),this.allDisplayedColumns=this.displayedLeftColumns.concat(this.displayedCenterColumns).concat(this.displayedRightColumns),this.setLeftValues()},e.prototype.setLeftValues=function(){this.setLeftValuesOfColumns(),this.setLeftValuesOfGroups()},e.prototype.setLeftValuesOfColumns=function(){var e=this.primaryColumns.slice(0);[this.displayedLeftColumns,this.displayedRightColumns,this.displayedCenterColumns].forEach(function(t){var o=0;t.forEach(function(t){t.setLeft(o),o+=t.getActualWidth(),s.Utils.removeFromArray(e,t)})}),e.forEach(function(e){e.setLeft(null)})},e.prototype.setLeftValuesOfGroups=function(){[this.displayedLeftColumnTree,this.displayedRightColumnTree,this.displayedCentreColumnTree].forEach(function(e){
	e.forEach(function(e){if(e instanceof l.ColumnGroup){var t=e;t.checkLeft()}})})},e.prototype.addToDisplayedColumns=function(e,t){t.length=0,this.columnUtils.deptFirstDisplayedColumnTreeSearch(e,function(e){e instanceof a.Column&&t.push(e)})},e.prototype.updateDisplayedCenterVirtualColumns=function(){var e,t=this.gridOptionsWrapper.isSuppressColumnVirtualisation()||this.gridOptionsWrapper.isForPrint();e=t?this.displayedCenterColumns:this.filterOutColumnsWithinViewport(this.displayedCenterColumns),this.allDisplayedVirtualColumns=e.concat(this.displayedLeftColumns).concat(this.displayedRightColumns);var o={};return this.allDisplayedVirtualColumns.forEach(function(e){o[e.getId()]=!0}),o},e.prototype.getVirtualHeaderGroupRow=function(e,t){var o;switch(e){case a.Column.PINNED_LEFT:o=this.displayedLeftHeaderRows[t];break;case a.Column.PINNED_RIGHT:o=this.displayedRightHeaderRows[t];break;default:o=this.displayedCentreHeaderRows[t]}return s.Utils.missing(o)&&(o=[]),o},e.prototype.updateDisplayedVirtualGroups=function(e){function t(o,i,n){for(var r=!1,s=0;s<o.length;s++){var l,p=o[s];if(p instanceof a.Column)l=e[p.getId()]===!0;else{var d=p;l=t(d.getDisplayedChildren(),i,n+1)}l&&(r=!0,i[n]||(i[n]=[]),i[n].push(p))}return r}this.displayedLeftHeaderRows={},this.displayedRightHeaderRows={},this.displayedCentreHeaderRows={},t(this.displayedLeftColumnTree,this.displayedLeftHeaderRows,0),t(this.displayedRightColumnTree,this.displayedRightHeaderRows,0),t(this.displayedCentreColumnTree,this.displayedCentreHeaderRows,0)},e.prototype.updateVirtualSets=function(){var e=this.updateDisplayedCenterVirtualColumns();this.updateDisplayedVirtualGroups(e)},e.prototype.filterOutColumnsWithinViewport=function(e){var t=this,o=s.Utils.filter(e,function(e){var o=e.getLeft(),i=e.getLeft()+e.getActualWidth(),n=o<t.viewportLeft&&i<t.viewportLeft,r=o>t.viewportRight&&i>t.viewportRight,s=!n&&!r;return s});return o},e.prototype.sizeColumnsToFit=function(e){function t(e){s.Utils.removeFromArray(l,e),r.push(e)}function o(e){for(var t=0,o=0;o<e.length;o++)t+=e[o].getActualWidth();return t}var i=this,n=this.getAllDisplayedColumns();if(!(e<=0||0===n.length)){for(var r=s.Utils.filter(n,function(e){return e.getColDef().suppressSizeToFit===!0}),l=s.Utils.filter(n,function(e){return e.getColDef().suppressSizeToFit!==!0}),a=l.slice(0),p=!1;!p;){p=!0;var d=e-o(r);if(d<=0)l.forEach(function(e){e.setMinimum()});else for(var u=d/o(l),c=d,h=l.length-1;h>=0;h--){var g=l[h],f=Math.round(g.getActualWidth()*u);if(f<g.getMinWidth())g.setMinimum(),t(g),p=!1;else if(g.isGreaterThanMax(f))g.setActualWidth(g.getMaxWidth()),t(g),p=!1;else{var y=0===h;y?g.setActualWidth(c):g.setActualWidth(f)}c-=f}}this.setLeftValues(),a.forEach(function(e){var t=new C.ColumnChangeEvent(v.Events.EVENT_COLUMN_RESIZED).withColumn(e);i.eventService.dispatchEvent(v.Events.EVENT_COLUMN_RESIZED,t)}),this.checkDisplayedCenterColumns()}},e.prototype.buildDisplayedTrees=function(e){var t=s.Utils.filter(e,function(e){return"left"===e.getPinned()}),o=s.Utils.filter(e,function(e){return"right"===e.getPinned()}),i=s.Utils.filter(e,function(e){return"left"!==e.getPinned()&&"right"!==e.getPinned()}),n=new E.GroupInstanceIdCreator;this.displayedLeftColumnTree=this.displayedGroupCreator.createDisplayedGroups(t,this.gridBalancedTree,n),this.displayedRightColumnTree=this.displayedGroupCreator.createDisplayedGroups(o,this.gridBalancedTree,n),this.displayedCentreColumnTree=this.displayedGroupCreator.createDisplayedGroups(i,this.gridBalancedTree,n)},e.prototype.updateGroups=function(){var e=this.getAllDisplayedColumnGroups();this.columnUtils.deptFirstAllColumnTreeSearch(e,function(e){if(e instanceof l.ColumnGroup){var t=e;t.calculateDisplayedColumns()}})},e.prototype.createGroupAutoColumn=function(){var t=this.rowGroupColumns.length>0&&!this.gridOptionsWrapper.isGroupSuppressAutoColumn()&&!this.gridOptionsWrapper.isGroupUseEntireRow()&&!this.gridOptionsWrapper.isGroupSuppressRow();if(this.groupAutoColumnActive=t,t&&!this.groupAutoColumn){var o=this.gridOptionsWrapper.getGroupColumnDef();if(!o){var i=this.gridOptionsWrapper.getLocaleTextFunc();o={headerName:i("group","Group"),comparator:A.defaultGroupComparator,valueGetter:function(e){return e.node.group?e.node.key:e.data&&e.colDef.field?e.data[e.colDef.field]:null},cellRenderer:"group"}}o.suppressMovable=!0;var n=e.GROUP_AUTO_COLUMN_ID;this.groupAutoColumn=new a.Column(o,n,(!0)),this.context.wireBean(this.groupAutoColumn)}},e.prototype.createValueColumns=function(){this.valueColumns.forEach(function(e){return e.setValueActive(!1)}),this.valueColumns=[];for(var e=0;e<this.primaryColumns.length;e++){var t=this.primaryColumns[e];t.getColDef().aggFunc&&(t.setAggFunc(t.getColDef().aggFunc),this.valueColumns.push(t),t.setValueActive(!0))}},e.prototype.getWidthOfColsInList=function(e){for(var t=0,o=0;o<e.length;o++)t+=e[o].getActualWidth();return t},e.GROUP_AUTO_COLUMN_ID="ag-Grid-AutoColumn",i([w.Autowired("gridOptionsWrapper"),n("design:type",p.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([w.Autowired("expressionService"),n("design:type",d.ExpressionService)],e.prototype,"expressionService",void 0),i([w.Autowired("balancedColumnTreeBuilder"),n("design:type",u.BalancedColumnTreeBuilder)],e.prototype,"balancedColumnTreeBuilder",void 0),i([w.Autowired("displayedGroupCreator"),n("design:type",c.DisplayedGroupCreator)],e.prototype,"displayedGroupCreator",void 0),i([w.Autowired("autoWidthCalculator"),n("design:type",h.AutoWidthCalculator)],e.prototype,"autoWidthCalculator",void 0),i([w.Autowired("eventService"),n("design:type",g.EventService)],e.prototype,"eventService",void 0),i([w.Autowired("columnUtils"),n("design:type",f.ColumnUtils)],e.prototype,"columnUtils",void 0),i([w.Autowired("gridPanel"),n("design:type",R.GridPanel)],e.prototype,"gridPanel",void 0),i([w.Autowired("context"),n("design:type",w.Context)],e.prototype,"context",void 0),i([w.Optional("aggFuncService"),n("design:type",Object)],e.prototype,"aggFuncService",void 0),i([w.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),i([r(0,w.Qualifier("loggerFactory")),n("design:type",Function),n("design:paramtypes",[y.LoggerFactory]),n("design:returntype",void 0)],e.prototype,"setBeans",null),e=i([w.Bean("columnController"),n("design:paramtypes",[])],e)}();t.ColumnController=O},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(15),n=o(4),r=function(){function e(e,t,o){this.displayedChildren=[],this.moving=!1,this.eventService=new n.EventService,this.groupId=t,this.instanceId=o,this.originalColumnGroup=e}return e.prototype.getUniqueId=function(){return this.groupId+"_"+this.instanceId},e.prototype.getHeaderName=function(){return this.originalColumnGroup.getColGroupDef()?this.originalColumnGroup.getColGroupDef().headerName:null},e.prototype.checkLeft=function(){if(this.displayedChildren.forEach(function(t){t instanceof e&&t.checkLeft()}),this.displayedChildren.length>0){var t=this.displayedChildren[0].getLeft();this.setLeft(t)}else this.setLeft(null)},e.prototype.getLeft=function(){return this.left},e.prototype.setLeft=function(t){this.left!==t&&(this.left=t,this.eventService.dispatchEvent(e.EVENT_LEFT_CHANGED))},e.prototype.addEventListener=function(e,t){this.eventService.addEventListener(e,t)},e.prototype.removeEventListener=function(e,t){this.eventService.removeEventListener(e,t)},e.prototype.setMoving=function(e){this.getDisplayedLeafColumns().forEach(function(t){return t.setMoving(e)})},e.prototype.isMoving=function(){return this.moving},e.prototype.getGroupId=function(){return this.groupId},e.prototype.getInstanceId=function(){return this.instanceId},e.prototype.isChildInThisGroupDeepSearch=function(t){var o=!1;return this.children.forEach(function(i){t===i&&(o=!0),i instanceof e&&i.isChildInThisGroupDeepSearch(t)&&(o=!0)}),o},e.prototype.getActualWidth=function(){var e=0;return this.displayedChildren&&this.displayedChildren.forEach(function(t){e+=t.getActualWidth()}),e},e.prototype.getMinWidth=function(){var e=0;return this.displayedChildren.forEach(function(t){e+=t.getMinWidth()}),e},e.prototype.addChild=function(e){this.children||(this.children=[]),this.children.push(e)},e.prototype.getDisplayedChildren=function(){return this.displayedChildren},e.prototype.getLeafColumns=function(){var e=[];return this.addLeafColumns(e),e},e.prototype.getDisplayedLeafColumns=function(){var e=[];return this.addDisplayedLeafColumns(e),e},e.prototype.getDefinition=function(){return this.originalColumnGroup.getColGroupDef()},e.prototype.getColGroupDef=function(){return this.originalColumnGroup.getColGroupDef()},e.prototype.isExpandable=function(){return this.originalColumnGroup.isExpandable()},e.prototype.isExpanded=function(){return this.originalColumnGroup.isExpanded()},e.prototype.setExpanded=function(e){this.originalColumnGroup.setExpanded(e)},e.prototype.addDisplayedLeafColumns=function(t){this.displayedChildren.forEach(function(o){o instanceof i.Column?t.push(o):o instanceof e&&o.addDisplayedLeafColumns(t)})},e.prototype.addLeafColumns=function(t){this.children.forEach(function(o){o instanceof i.Column?t.push(o):o instanceof e&&o.addLeafColumns(t)})},e.prototype.getChildren=function(){return this.children},e.prototype.getColumnGroupShow=function(){return this.originalColumnGroup.getColumnGroupShow()},e.prototype.getOriginalColumnGroup=function(){return this.originalColumnGroup},e.prototype.calculateDisplayedColumns=function(){if(this.displayedChildren=[],!this.originalColumnGroup.isExpandable())return void(this.displayedChildren=this.children);for(var t=0,o=this.children.length;t<o;t++){var i=this.children[t],n=i.getColumnGroupShow();switch(n){case e.HEADER_GROUP_SHOW_OPEN:this.originalColumnGroup.isExpanded()&&this.displayedChildren.push(i);break;case e.HEADER_GROUP_SHOW_CLOSED:this.originalColumnGroup.isExpanded()||this.displayedChildren.push(i);break;default:this.displayedChildren.push(i)}}},e.HEADER_GROUP_SHOW_OPEN="open",e.HEADER_GROUP_SHOW_CLOSED="closed",e.EVENT_LEFT_CHANGED="leftChanged",e}();t.ColumnGroup=r},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(4),s=o(7),l=o(6),a=o(3),p=o(16),d=function(){function e(e,t,o){this.moving=!1,this.filterActive=!1,this.eventService=new r.EventService,this.rowGroupActive=!1,this.pivotActive=!1,this.aggregationActive=!1,this.colDef=e,this.visible=!e.hide,this.sort=e.sort,this.sortedAt=e.sortedAt,this.colId=t,this.primary=o}return e.prototype.initialise=function(){this.setPinned(this.colDef.pinned);var e=this.gridOptionsWrapper.getMinColWidth(),t=this.gridOptionsWrapper.getMaxColWidth();this.colDef.minWidth?this.minWidth=this.colDef.minWidth:this.minWidth=e,this.colDef.maxWidth?this.maxWidth=this.colDef.maxWidth:this.maxWidth=t,this.actualWidth=this.columnUtils.calculateColInitialWidth(this.colDef);var o=this.gridOptionsWrapper.isSuppressFieldDotNotation();this.fieldContainsDots=s.Utils.exists(this.colDef.field)&&this.colDef.field.indexOf(".")>=0&&!o,this.validate()},e.prototype.getUniqueId=function(){return this.getId()},e.prototype.isPrimary=function(){return this.primary},e.prototype.isFilterAllowed=function(){return this.primary&&!this.colDef.suppressFilter},e.prototype.isFieldContainsDots=function(){return this.fieldContainsDots},e.prototype.validate=function(){this.gridOptionsWrapper.isEnterprise()||(s.Utils.exists(this.colDef.aggFunc)&&console.warn("ag-Grid: aggFunc is only valid in ag-Grid-Enterprise"),s.Utils.exists(this.colDef.rowGroupIndex)&&console.warn("ag-Grid: rowGroupIndex is only valid in ag-Grid-Enterprise")),s.Utils.exists(this.colDef.width)&&"number"!=typeof this.colDef.width&&console.warn("ag-Grid: colDef.width should be a number, not "+typeof this.colDef.width)},e.prototype.addEventListener=function(e,t){this.eventService.addEventListener(e,t)},e.prototype.removeEventListener=function(e,t){this.eventService.removeEventListener(e,t)},e.prototype.isCellEditable=function(e){if("boolean"==typeof this.colDef.editable)return this.colDef.editable;if("function"==typeof this.colDef.editable){var t={node:e,column:this,colDef:this.colDef,context:this.gridOptionsWrapper.getContext(),api:this.gridOptionsWrapper.getApi(),columnApi:this.gridOptionsWrapper.getColumnApi()},o=this.colDef.editable;return o(t)}return!1},e.prototype.setMoving=function(t){this.moving=t,this.eventService.dispatchEvent(e.EVENT_MOVING_CHANGED)},e.prototype.isMoving=function(){return this.moving},e.prototype.getSort=function(){return this.sort},e.prototype.setSort=function(t){this.sort!==t&&(this.sort=t,this.eventService.dispatchEvent(e.EVENT_SORT_CHANGED))},e.prototype.isSortAscending=function(){return this.sort===e.SORT_ASC},e.prototype.isSortDescending=function(){return this.sort===e.SORT_DESC},e.prototype.isSortNone=function(){return s.Utils.missing(this.sort)},e.prototype.getSortedAt=function(){return this.sortedAt},e.prototype.setSortedAt=function(e){this.sortedAt=e},e.prototype.setAggFunc=function(e){this.aggFunc=e},e.prototype.getAggFunc=function(){return this.aggFunc},e.prototype.getLeft=function(){return this.left},e.prototype.getRight=function(){return this.left+this.actualWidth},e.prototype.setLeft=function(t){this.left!==t&&(this.left=t,this.eventService.dispatchEvent(e.EVENT_LEFT_CHANGED))},e.prototype.isFilterActive=function(){return this.filterActive},e.prototype.setFilterActive=function(t){this.filterActive!==t&&(this.filterActive=t,this.eventService.dispatchEvent(e.EVENT_FILTER_ACTIVE_CHANGED))},e.prototype.setPinned=function(t){this.gridOptionsWrapper.isForPrint()||(t===!0||t===e.PINNED_LEFT?this.pinned=e.PINNED_LEFT:t===e.PINNED_RIGHT?this.pinned=e.PINNED_RIGHT:this.pinned=null)},e.prototype.setFirstRightPinned=function(t){this.firstRightPinned!==t&&(this.firstRightPinned=t,this.eventService.dispatchEvent(e.EVENT_FIRST_RIGHT_PINNED_CHANGED))},e.prototype.setLastLeftPinned=function(t){this.lastLeftPinned!==t&&(this.lastLeftPinned=t,this.eventService.dispatchEvent(e.EVENT_LAST_LEFT_PINNED_CHANGED))},e.prototype.isFirstRightPinned=function(){return this.firstRightPinned},e.prototype.isLastLeftPinned=function(){return this.lastLeftPinned},e.prototype.isPinned=function(){return this.pinned===e.PINNED_LEFT||this.pinned===e.PINNED_RIGHT},e.prototype.isPinnedLeft=function(){return this.pinned===e.PINNED_LEFT},e.prototype.isPinnedRight=function(){return this.pinned===e.PINNED_RIGHT},e.prototype.getPinned=function(){return this.pinned},e.prototype.setVisible=function(t){var o=t===!0;this.visible!==o&&(this.visible=o,this.eventService.dispatchEvent(e.EVENT_VISIBLE_CHANGED))},e.prototype.isVisible=function(){return this.visible},e.prototype.getColDef=function(){return this.colDef},e.prototype.getColumnGroupShow=function(){return this.colDef.columnGroupShow},e.prototype.getColId=function(){return this.colId},e.prototype.getId=function(){return this.getColId()},e.prototype.getDefinition=function(){return this.colDef},e.prototype.getActualWidth=function(){return this.actualWidth},e.prototype.setActualWidth=function(t){this.actualWidth!==t&&(this.actualWidth=t,this.eventService.dispatchEvent(e.EVENT_WIDTH_CHANGED))},e.prototype.isGreaterThanMax=function(e){return!!this.maxWidth&&e>this.maxWidth},e.prototype.getMinWidth=function(){return this.minWidth},e.prototype.getMaxWidth=function(){return this.maxWidth},e.prototype.setMinimum=function(){this.setActualWidth(this.minWidth)},e.prototype.setRowGroupActive=function(t){this.rowGroupActive!==t&&(this.rowGroupActive=t,this.eventService.dispatchEvent(e.EVENT_ROW_GROUP_CHANGED,this))},e.prototype.isRowGroupActive=function(){return this.rowGroupActive},e.prototype.setPivotActive=function(t){this.pivotActive!==t&&(this.pivotActive=t,this.eventService.dispatchEvent(e.EVENT_PIVOT_CHANGED,this))},e.prototype.isPivotActive=function(){return this.pivotActive},e.prototype.isAnyFunctionActive=function(){return this.isPivotActive()||this.isRowGroupActive()||this.isValueActive()},e.prototype.isAnyFunctionAllowed=function(){return this.isAllowPivot()||this.isAllowRowGroup()||this.isAllowValue()},e.prototype.setValueActive=function(t){this.aggregationActive!==t&&(this.aggregationActive=t,this.eventService.dispatchEvent(e.EVENT_VALUE_CHANGED,this))},e.prototype.isValueActive=function(){return this.aggregationActive},e.prototype.isAllowPivot=function(){return this.colDef.enablePivot===!0},e.prototype.isAllowValue=function(){return this.colDef.enableValue===!0},e.prototype.isAllowRowGroup=function(){return this.colDef.enableRowGroup===!0},e.EVENT_MOVING_CHANGED="movingChanged",e.EVENT_LEFT_CHANGED="leftChanged",e.EVENT_WIDTH_CHANGED="widthChanged",e.EVENT_LAST_LEFT_PINNED_CHANGED="lastLeftPinnedChanged",e.EVENT_FIRST_RIGHT_PINNED_CHANGED="firstRightPinnedChanged",e.EVENT_VISIBLE_CHANGED="visibleChanged",e.EVENT_FILTER_ACTIVE_CHANGED="filterChanged",e.EVENT_SORT_CHANGED="filterChanged",e.EVENT_ROW_GROUP_CHANGED="columnRowGroupChanged",e.EVENT_PIVOT_CHANGED="columnPivotChanged",e.EVENT_VALUE_CHANGED="columnValueChanged",e.PINNED_RIGHT="right",e.PINNED_LEFT="left",e.SORT_ASC="asc",e.SORT_DESC="desc",i([l.Autowired("gridOptionsWrapper"),n("design:type",a.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([l.Autowired("columnUtils"),n("design:type",p.ColumnUtils)],e.prototype,"columnUtils",void 0),i([l.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"initialise",null),e}();t.Column=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(3),s=o(14),l=o(17),a=o(6),p=o(6),d=function(){function e(){}return e.prototype.calculateColInitialWidth=function(e){return e.width?e.width<this.gridOptionsWrapper.getMinColWidth()?this.gridOptionsWrapper.getMinColWidth():e.width:this.gridOptionsWrapper.getColWidth()},e.prototype.getOriginalPathForColumn=function(e,t){function o(t,r){for(var s=0;s<t.length;s++){if(n)return;var a=t[s];if(a instanceof l.OriginalColumnGroup){var p=a;o(p.getChildren(),r+1),i[r]=a}else a===e&&(n=!0)}}var i=[],n=!1;return o(t,0),n?i:null},e.prototype.deptFirstOriginalTreeSearch=function(e,t){var o=this;e&&e.forEach(function(e){e instanceof l.OriginalColumnGroup&&o.deptFirstOriginalTreeSearch(e.getChildren(),t),t(e)})},e.prototype.deptFirstAllColumnTreeSearch=function(e,t){var o=this;e&&e.forEach(function(e){e instanceof s.ColumnGroup&&o.deptFirstAllColumnTreeSearch(e.getChildren(),t),t(e)})},e.prototype.deptFirstDisplayedColumnTreeSearch=function(e,t){var o=this;e&&e.forEach(function(e){e instanceof s.ColumnGroup&&o.deptFirstDisplayedColumnTreeSearch(e.getDisplayedChildren(),t),t(e)})},i([p.Autowired("gridOptionsWrapper"),n("design:type",r.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),e=i([a.Bean("columnUtils"),n("design:paramtypes",[])],e)}();t.ColumnUtils=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(14),n=o(15),r=function(){function e(e,t){this.expandable=!1,this.colGroupDef=e,this.groupId=t,this.expanded=e&&!!e.openByDefault}return e.prototype.setExpanded=function(e){this.expanded=e},e.prototype.isExpandable=function(){return this.expandable},e.prototype.isExpanded=function(){return this.expanded},e.prototype.getGroupId=function(){return this.groupId},e.prototype.getId=function(){return this.getGroupId()},e.prototype.setChildren=function(e){this.children=e},e.prototype.getChildren=function(){return this.children},e.prototype.getColGroupDef=function(){return this.colGroupDef},e.prototype.getLeafColumns=function(){var e=[];return this.addLeafColumns(e),e},e.prototype.addLeafColumns=function(t){this.children.forEach(function(o){o instanceof n.Column?t.push(o):o instanceof e&&o.addLeafColumns(t)})},e.prototype.getColumnGroupShow=function(){return this.colGroupDef?this.colGroupDef.columnGroupShow:this.children[0].getColumnGroupShow()},e.prototype.calculateExpandable=function(){for(var e=!1,t=!1,o=!1,n=0,r=this.children.length;n<r;n++){var s=this.children[n],l=s.getColumnGroupShow();l===i.ColumnGroup.HEADER_GROUP_SHOW_OPEN?(e=!0,o=!0):l===i.ColumnGroup.HEADER_GROUP_SHOW_CLOSED?(t=!0,o=!0):(e=!0,t=!0)}this.expandable=e&&t&&o},e}();t.OriginalColumnGroup=r},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(5),l=o(6),a=o(6),p=function(){function e(){this.expressionToFunctionCache={}}return e.prototype.setBeans=function(e){this.logger=e.create("ExpressionService")},e.prototype.evaluate=function(e,t){try{var o=this.createExpressionFunction(e),i=o(t.value,t.context,t.node,t.data,t.colDef,t.rowIndex,t.api,t.getValue);return i}catch(n){return this.logger.log("Processing of the expression failed"),this.logger.log("Expression = "+e),this.logger.log("Exception = "+n),null}},e.prototype.createExpressionFunction=function(e){if(this.expressionToFunctionCache[e])return this.expressionToFunctionCache[e];var t=this.createFunctionBody(e),o=new Function("x, ctx, node, data, colDef, rowIndex, api, getValue",t);return this.expressionToFunctionCache[e]=o,o},e.prototype.createFunctionBody=function(e){return e.indexOf("return")>=0?e:"return "+e+";"},i([r(0,a.Qualifier("loggerFactory")),n("design:type",Function),n("design:paramtypes",[s.LoggerFactory]),n("design:returntype",void 0)],e.prototype,"setBeans",null),e=i([l.Bean("expressionService"),n("design:paramtypes",[])],e)}();t.ExpressionService=p},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(3),l=o(5),a=o(16),p=o(20),d=o(17),u=o(15),c=o(6),h=o(6),g=o(6),f=o(6),y=function(){function e(){}return e.prototype.setBeans=function(e){this.logger=e.create("BalancedColumnTreeBuilder")},e.prototype.createBalancedColumnGroups=function(e,t){var o=new p.ColumnKeyCreator,i=this.recursivelyCreateColumns(e,0,o,t),n=this.findMaxDept(i,0);this.logger.log("Number of levels for grouped columns is "+n);var r=this.balanceColumnTree(i,0,n,o);return this.columnUtils.deptFirstOriginalTreeSearch(r,function(e){e instanceof d.OriginalColumnGroup&&e.calculateExpandable()}),{balancedTree:r,treeDept:n}},e.prototype.balanceColumnTree=function(e,t,o,i){var n=this,r=[];return e.forEach(function(e){if(e instanceof d.OriginalColumnGroup){var s=e,l=n.balanceColumnTree(s.getChildren(),t+1,o,i);s.setChildren(l),r.push(s)}else{for(var a=e,p=o-1;p>=t;p--){var u=i.getUniqueKey(null,null),c=new d.OriginalColumnGroup(null,u);c.setChildren([a]),a=c}r.push(a)}}),r},e.prototype.findMaxDept=function(e,t){for(var o=t,i=0;i<e.length;i++){var n=e[i];if(n instanceof d.OriginalColumnGroup){var r=n,s=this.findMaxDept(r.getChildren(),t+1);o<s&&(o=s)}}return o},e.prototype.recursivelyCreateColumns=function(e,t,o,i){var n=this,r=[];return e?(e.forEach(function(e){if(n.checkForDeprecatedItems(e),n.isColumnGroup(e)){var s=e,l=o.getUniqueKey(s.groupId,null),a=new d.OriginalColumnGroup(s,l),p=n.recursivelyCreateColumns(s.children,t+1,o,i);a.setChildren(p),r.push(a)}else{var c=e,h=o.getUniqueKey(c.colId,c.field),g=new u.Column(c,h,i);n.context.wireBean(g),r.push(g)}}),r):r},e.prototype.checkForDeprecatedItems=function(e){if(e){var t=e;void 0!==t.group&&console.warn("ag-grid: colDef.group is invalid, please check documentation on how to do grouping as it changed in version 3"),void 0!==t.headerGroup&&console.warn("ag-grid: colDef.headerGroup is invalid, please check documentation on how to do grouping as it changed in version 3"),void 0!==t.headerGroupShow&&console.warn("ag-grid: colDef.headerGroupShow is invalid, should be columnGroupShow, please check documentation on how to do grouping as it changed in version 3"),void 0!==t.suppressRowGroup&&console.warn("ag-grid: colDef.suppressRowGroup is deprecated, please use colDef.type instead"),void 0!==t.suppressAggregation&&console.warn("ag-grid: colDef.suppressAggregation is deprecated, please use colDef.type instead"),(t.suppressRowGroup||t.suppressAggregation)&&console.warn("ag-grid: colDef.suppressAggregation and colDef.suppressRowGroup are deprecated, use allowRowGroup, allowPivot and allowValue instead"),t.displayName&&(console.warn("ag-grid: Found displayName "+t.displayName+", please use headerName instead, displayName is deprecated."),t.headerName=t.displayName)}},e.prototype.isColumnGroup=function(e){return void 0!==e.children},i([g.Autowired("gridOptionsWrapper"),n("design:type",s.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([g.Autowired("columnUtils"),n("design:type",a.ColumnUtils)],e.prototype,"columnUtils",void 0),i([g.Autowired("context"),n("design:type",f.Context)],e.prototype,"context",void 0),i([r(0,h.Qualifier("loggerFactory")),n("design:type",Function),n("design:paramtypes",[l.LoggerFactory]),n("design:returntype",void 0)],e.prototype,"setBeans",null),e=i([c.Bean("balancedColumnTreeBuilder"),n("design:paramtypes",[])],e)}();t.BalancedColumnTreeBuilder=y},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(7),n=function(){function e(){this.existingKeys=[]}return e.prototype.getUniqueKey=function(e,t){e=i.Utils.toStringOrNull(e);for(var o=0;;){var n;if(e?(n=e,0!==o&&(n+="_"+o)):t?(n=t,0!==o&&(n+="_"+o)):n=""+o,this.existingKeys.indexOf(n)<0)return this.existingKeys.push(n),n;o++}},e}();t.ColumnKeyCreator=n},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(16),s=o(14),l=o(17),a=o(6),p=o(6),d=function(){function e(){}return e.prototype.createDisplayedGroups=function(e,t,o){var i,n,r=this,l=[];return e.forEach(function(e){for(var a=r.getOriginalPathForColumn(t,e),p=[],d=!n,u=0;u<a.length;u++)if(d||a[u]!==n[u]){var c=a[u],h=c.getGroupId(),g=o.getInstanceIdForKey(h),f=new s.ColumnGroup(c,h,g);p[u]=f,0==u?l.push(f):p[u-1].addChild(f)}else p[u]=i[u];var y=0===p.length;if(y)l.push(e);else{var v=p[p.length-1];v.addChild(e)}i=p,n=a}),l},e.prototype.createFakePath=function(e){for(var t=[],o=e,i=0;o&&o[0]&&o[0]instanceof l.OriginalColumnGroup;)t.push(new l.OriginalColumnGroup(null,"FAKE_PATH_"+i)),o=o[0].getChildren(),i++;return t},e.prototype.getOriginalPathForColumn=function(e,t){function o(e,r){for(var s=0;s<e.length;s++){if(n)return;var a=e[s];if(a instanceof l.OriginalColumnGroup){var p=a;o(p.getChildren(),r+1),i[r]=a}else a===t&&(n=!0)}}var i=[],n=!1;return o(e,0),n?i:this.createFakePath(e)},i([p.Autowired("columnUtils"),n("design:type",r.ColumnUtils)],e.prototype,"columnUtils",void 0),e=i([a.Bean("displayedGroupCreator"),n("design:paramtypes",[])],e)}();t.DisplayedGroupCreator=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(23),s=o(24),l=o(6),a=o(6),p=o(64),d=o(71),u=o(3),c=function(){function e(){}return e.prototype.getPreferredWidthForColumn=function(e){var t=this.getHeaderCellForColumn(e);if(!t)return-1;var o=document.createElement("span");o.style.position="fixed";var i=this.gridPanel.getBodyContainer();i.appendChild(o),this.putRowCellsIntoDummyContainer(e,o),this.cloneItemIntoDummy(t.getGui(),o);var n=o.offsetWidth;i.removeChild(o);var r=this.gridOptionsWrapper.getAutoSizePadding();return("number"!=typeof r||r<0)&&(r=4),n+r},e.prototype.getHeaderCellForColumn=function(e){var t=null;return this.headerRenderer.forEachHeaderElement(function(o){if(o instanceof d.RenderedHeaderCell){var i=o;i.getColumn()===e&&(t=i)}}),t},e.prototype.putRowCellsIntoDummyContainer=function(e,t){var o=this,i=this.rowRenderer.getAllCellsForColumn(e);i.forEach(function(e,i){o.cloneItemIntoDummy(e,t)})},e.prototype.cloneItemIntoDummy=function(e,t){var o=e.cloneNode(!0);o.style.width="",o.style.position="static",o.style.left="";var i=document.createElement("div");i.style.display="table-row",i.appendChild(o),t.appendChild(i)},i([a.Autowired("rowRenderer"),n("design:type",r.RowRenderer)],e.prototype,"rowRenderer",void 0),i([a.Autowired("headerRenderer"),n("design:type",p.HeaderRenderer)],e.prototype,"headerRenderer",void 0),i([a.Autowired("gridPanel"),n("design:type",s.GridPanel)],e.prototype,"gridPanel",void 0),i([a.Autowired("gridOptionsWrapper"),n("design:type",u.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),e=i([l.Bean("autoWidthCalculator"),n("design:paramtypes",[])],e)}();t.AutoWidthCalculator=c},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(7),l=o(3),a=o(24),p=o(18),d=o(36),u=o(29),c=o(4),h=o(26),g=o(37),f=o(10),y=o(8),v=o(6),C=o(40),m=o(13),E=o(5),A=o(35),w=o(63),R=o(33),S=function(){function e(){this.renderedRows={},this.renderedTopFloatingRows=[],this.renderedBottomFloatingRows=[],this.destroyFunctions=[]}return e.prototype.agWire=function(e){this.logger=this.loggerFactory.create("RowRenderer"),this.logger=e.create("BalancedColumnTreeBuilder")},e.prototype.init=function(){var e=this;this.getContainersFromGridPanel();var t=this.onColumnEvent.bind(this),o=this.refreshView.bind(this);this.eventService.addEventListener(f.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,t),this.eventService.addEventListener(f.Events.EVENT_COLUMN_RESIZED,t),this.eventService.addEventListener(f.Events.EVENT_MODEL_UPDATED,o),this.eventService.addEventListener(f.Events.EVENT_FLOATING_ROW_DATA_CHANGED,o),this.destroyFunctions.push(function(){e.eventService.removeEventListener(f.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,t),e.eventService.removeEventListener(f.Events.EVENT_COLUMN_RESIZED,t),e.eventService.removeEventListener(f.Events.EVENT_MODEL_UPDATED,o),e.eventService.removeEventListener(f.Events.EVENT_FLOATING_ROW_DATA_CHANGED,o)}),this.refreshView()},e.prototype.onColumnEvent=function(e){this.setMainRowWidths()},e.prototype.getContainersFromGridPanel=function(){this.eFullWidthContainer=this.gridPanel.getFullWidthCellContainer(),this.eBodyContainer=this.gridPanel.getBodyContainer(),this.ePinnedLeftColsContainer=this.gridPanel.getPinnedLeftColsContainer(),this.ePinnedRightColsContainer=this.gridPanel.getPinnedRightColsContainer(),this.eFloatingTopContainer=this.gridPanel.getFloatingTopContainer(),this.eFloatingTopPinnedLeftContainer=this.gridPanel.getPinnedLeftFloatingTop(),this.eFloatingTopPinnedRightContainer=this.gridPanel.getPinnedRightFloatingTop(),this.eFloatingTopFullWidthContainer=this.gridPanel.getFloatingTopFullWidthCellContainer(),this.eFloatingBottomContainer=this.gridPanel.getFloatingBottomContainer(),this.eFloatingBottomPinnedLeftContainer=this.gridPanel.getPinnedLeftFloatingBottom(),this.eFloatingBottomPinnedRightContainer=this.gridPanel.getPinnedRightFloatingBottom(),this.eFloatingBottomFullWithContainer=this.gridPanel.getFloatingBottomFullWidthCellContainer(),this.eBodyViewport=this.gridPanel.getBodyViewport(),this.eAllBodyContainers=[this.eBodyContainer,this.eFloatingBottomContainer,this.eFloatingTopContainer],this.eAllPinnedLeftContainers=[this.ePinnedLeftColsContainer,this.eFloatingBottomPinnedLeftContainer,this.eFloatingTopPinnedLeftContainer],this.eAllPinnedRightContainers=[this.ePinnedRightColsContainer,this.eFloatingBottomPinnedRightContainer,this.eFloatingTopPinnedRightContainer]},e.prototype.setRowModel=function(e){this.rowModel=e},e.prototype.getAllCellsForColumn=function(e){function t(t,i){var n=i.getCellForCol(e);n&&o.push(n)}var o=[];return s.Utils.iterateObject(this.renderedRows,t),s.Utils.iterateObject(this.renderedBottomFloatingRows,t),s.Utils.iterateObject(this.renderedBottomFloatingRows,t),o},e.prototype.setMainRowWidths=function(){var e=this.columnController.getBodyContainerWidth()+"px";this.eAllBodyContainers.forEach(function(t){for(var o=t.querySelectorAll(".ag-row"),i=0;i<o.length;i++)o[i].style.width=e})},e.prototype.refreshAllFloatingRows=function(){this.refreshFloatingRows(this.renderedTopFloatingRows,this.floatingRowModel.getFloatingTopRowData(),this.eFloatingTopPinnedLeftContainer,this.eFloatingTopPinnedRightContainer,this.eFloatingTopContainer,this.eFloatingTopFullWidthContainer),this.refreshFloatingRows(this.renderedBottomFloatingRows,this.floatingRowModel.getFloatingBottomRowData(),this.eFloatingBottomPinnedLeftContainer,this.eFloatingBottomPinnedRightContainer,this.eFloatingBottomContainer,this.eFloatingBottomFullWithContainer)},e.prototype.refreshFloatingRows=function(e,t,o,i,n,r){var l=this;e.forEach(function(e){e.destroy()}),e.length=0;var a=this.columnController.getAllDisplayedColumns();s.Utils.missingOrEmpty(a)||t&&t.forEach(function(t,s){var a=new g.RenderedRow(l.$scope,l,n,r,o,i,t,s);l.context.wireBean(a),e.push(a)})},e.prototype.refreshView=function(e){this.logger.log("refreshView");var t=this.focusedCellController.getFocusCellToUseAfterRefresh(),o=e?e.fromIndex:null;if(!this.gridOptionsWrapper.isForPrint()){var i=this.rowModel.getRowCombinedHeight();this.eBodyContainer.style.height=i+"px",this.eFullWidthContainer.style.height=i+"px",this.ePinnedLeftColsContainer.style.height=i+"px",this.ePinnedRightColsContainer.style.height=i+"px"}this.refreshAllVirtualRows(o),this.refreshAllFloatingRows(),this.restoreFocusedCell(t)},e.prototype.restoreFocusedCell=function(e){e&&this.focusedCellController.setFocusedCell(e.rowIndex,e.column,e.floating,!0)},e.prototype.softRefreshView=function(){var e=this.focusedCellController.getFocusCellToUseAfterRefresh();this.forEachRenderedCell(function(e){e.isVolatile()&&e.refreshCell()}),this.restoreFocusedCell(e)},e.prototype.stopEditing=function(e){void 0===e&&(e=!1),this.forEachRenderedCell(function(t){t.stopEditing(e)})},e.prototype.forEachRenderedCell=function(e){s.Utils.iterateObject(this.renderedRows,function(t,o){o.forEachRenderedCell(e)})},e.prototype.forEachRenderedRow=function(e){s.Utils.iterateObject(this.renderedRows,e),s.Utils.iterateObject(this.renderedTopFloatingRows,e),s.Utils.iterateObject(this.renderedBottomFloatingRows,e)},e.prototype.addRenderedRowListener=function(e,t,o){var i=this.renderedRows[t];i.addEventListener(e,o)},e.prototype.refreshRows=function(e){if(e&&0!=e.length){var t=this.focusedCellController.getFocusCellToUseAfterRefresh(),o=[];s.Utils.iterateObject(this.renderedRows,function(t,i){var n=i.getRowNode();e.indexOf(n)>=0&&o.push(t)}),this.removeVirtualRow(o),this.drawVirtualRows(),this.restoreFocusedCell(t)}},e.prototype.refreshCells=function(e,t,o){void 0===o&&(o=!1),e&&0!=e.length&&s.Utils.iterateObject(this.renderedRows,function(i,n){var r=n.getRowNode();e.indexOf(r)>=0&&n.refreshCells(t,o)})},e.prototype.rowDataChanged=function(e){var t=[],o=this.renderedRows;Object.keys(o).forEach(function(i){var n=o[i];n.isDataInList(e)&&t.push(i)}),this.removeVirtualRow(t),this.drawVirtualRows()},e.prototype.destroy=function(){this.destroyFunctions.forEach(function(e){return e()});var e=Object.keys(this.renderedRows);this.removeVirtualRow(e)},e.prototype.refreshAllVirtualRows=function(e){var t=Object.keys(this.renderedRows);this.removeVirtualRow(t,e),this.drawVirtualRows()},e.prototype.refreshGroupRows=function(){var e=this,t=[];Object.keys(this.renderedRows).forEach(function(o){var i=e.renderedRows[o];i.isGroup()&&t.push(o)}),this.removeVirtualRow(t),this.ensureRowsRendered()},e.prototype.removeVirtualRow=function(e,t){var o=this,i="number"==typeof t?t:-1;e.forEach(function(e){e>=i&&o.unbindVirtualRow(e)})},e.prototype.unbindVirtualRow=function(e){var t=this.renderedRows[e];t.destroy();var o={node:t.getRowNode(),rowIndex:e};this.eventService.dispatchEvent(f.Events.EVENT_VIRTUAL_ROW_REMOVED,o),delete this.renderedRows[e]},e.prototype.drawVirtualRows=function(){this.workOutFirstAndLastRowsToRender(),this.ensureRowsRendered()},e.prototype.workOutFirstAndLastRowsToRender=function(){var e,t;if(this.rowModel.isRowsToRender()){var o=this.rowModel.getRowCount();if(this.gridOptionsWrapper.isForPrint())e=0,t=o;else{var i=this.eBodyViewport.scrollTop,n=i+this.eBodyViewport.offsetHeight,r=this.rowModel.getRowIndexAtPixel(i),s=this.rowModel.getRowIndexAtPixel(n),l=this.gridOptionsWrapper.getRowBuffer();r-=l,s+=l,r<0&&(r=0),s>o-1&&(s=o-1),e=r,t=s}}else e=0,t=-1;var a=e!==this.firstRenderedRow,p=t!==this.lastRenderedRow;if(a||p){this.firstRenderedRow=e,this.lastRenderedRow=t;var d={firstRow:e,lastRow:t};this.eventService.dispatchEvent(f.Events.EVENT_VIEWPORT_CHANGED,d)}},e.prototype.getFirstVirtualRenderedRow=function(){return this.firstRenderedRow},e.prototype.getLastVirtualRenderedRow=function(){return this.lastRenderedRow},e.prototype.ensureRowsRendered=function(){for(var e=this,t=Object.keys(this.renderedRows),o=this.firstRenderedRow;o<=this.lastRenderedRow;o++)if(t.indexOf(o.toString())>=0)t.splice(t.indexOf(o.toString()),1);else{var i=this.rowModel.getRow(o);i&&this.insertRow(i,o)}this.removeVirtualRow(t),this.gridOptionsWrapper.isAngularCompileRows()&&setTimeout(function(){e.$scope.$apply()},0)},e.prototype.onMouseEvent=function(e,t,o){var i;switch(o.floating){case y.Constants.FLOATING_TOP:i=this.renderedTopFloatingRows[o.rowIndex];break;case y.Constants.FLOATING_BOTTOM:i=this.renderedBottomFloatingRows[o.rowIndex];break;default:i=this.renderedRows[o.rowIndex]}i&&i.onMouseEvent(e,t,o)},e.prototype.insertRow=function(e,t){var o=this.columnController.getAllDisplayedColumns();if(!s.Utils.missingOrEmpty(o)){var i=new g.RenderedRow(this.$scope,this,this.eBodyContainer,this.eFullWidthContainer,this.ePinnedLeftColsContainer,this.ePinnedRightColsContainer,e,t);this.context.wireBean(i),this.renderedRows[t]=i}},e.prototype.getRenderedNodes=function(){var e=this.renderedRows;return Object.keys(e).map(function(t){return e[t].getRowNode()})},e.prototype.navigateToNextCell=function(e,t,o,i){for(var n=new R.GridCell(t,i,o);;){if(n=this.cellNavigationService.getNextCellToFocus(e,n),s.Utils.missing(n))break;var r=this.gridOptionsWrapper.isGroupUseEntireRow();if(!r)break;var l=this.rowModel.getRow(n.rowIndex);if(!l.group)break}n&&(s.Utils.missing(n.floating)&&this.gridPanel.ensureIndexVisible(n.rowIndex),n.column.isPinned()||this.gridPanel.ensureColumnVisible(n.column),this.gridPanel.horizontallyScrollHeaderCenterAndFloatingCenter(),this.focusedCellController.setFocusedCell(n.rowIndex,n.column,n.floating,!0),this.rangeController&&this.rangeController.setRangeToCell(new R.GridCell(n.rowIndex,n.floating,n.column)))},e.prototype.startEditingCell=function(e,t,o){var i=this.getComponentForCell(e);i.startEditingIfEnabled(t,o)},e.prototype.getComponentForCell=function(e){var t;switch(e.floating){case y.Constants.FLOATING_TOP:t=this.renderedTopFloatingRows[e.rowIndex];break;case y.Constants.FLOATING_BOTTOM:t=this.renderedBottomFloatingRows[e.rowIndex];break;default:t=this.renderedRows[e.rowIndex]}if(!t)return null;var o=t.getRenderedCellForColumn(e.column);return o},e.prototype.moveFocusToNextCell=function(e,t,o,i,n){for(var r=new R.GridCell(e,o,t);;){if(r=this.cellNavigationService.getNextTabbedCell(r,i),!r)return!1;var l=s.Utils.missing(r.floating);l&&this.gridPanel.ensureIndexVisible(r.rowIndex),this.gridPanel.ensureColumnVisible(r.column),this.gridPanel.horizontallyScrollHeaderCenterAndFloatingCenter();var a=this.getComponentForCell(r);if(!n||a.isCellEditable())return n?(a.startEditingIfEnabled(),a.focusCell(!1)):a.focusCell(!0),this.rangeController&&this.rangeController.setRangeToCell(new R.GridCell(r.rowIndex,r.floating,r.column)),!0}},i([v.Autowired("columnController"),n("design:type",m.ColumnController)],e.prototype,"columnController",void 0),i([v.Autowired("gridOptionsWrapper"),n("design:type",l.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([v.Autowired("gridCore"),n("design:type",C.GridCore)],e.prototype,"gridCore",void 0),i([v.Autowired("gridPanel"),n("design:type",a.GridPanel)],e.prototype,"gridPanel",void 0),i([v.Autowired("$compile"),n("design:type",Object)],e.prototype,"$compile",void 0),i([v.Autowired("$scope"),n("design:type",Object)],e.prototype,"$scope",void 0),i([v.Autowired("expressionService"),n("design:type",p.ExpressionService)],e.prototype,"expressionService",void 0),i([v.Autowired("templateService"),n("design:type",d.TemplateService)],e.prototype,"templateService",void 0),i([v.Autowired("valueService"),n("design:type",u.ValueService)],e.prototype,"valueService",void 0),i([v.Autowired("eventService"),n("design:type",c.EventService)],e.prototype,"eventService",void 0),i([v.Autowired("floatingRowModel"),n("design:type",h.FloatingRowModel)],e.prototype,"floatingRowModel",void 0),i([v.Autowired("context"),n("design:type",v.Context)],e.prototype,"context",void 0),i([v.Autowired("loggerFactory"),n("design:type",E.LoggerFactory)],e.prototype,"loggerFactory",void 0),i([v.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),i([v.Autowired("focusedCellController"),n("design:type",A.FocusedCellController)],e.prototype,"focusedCellController",void 0),i([v.Optional("rangeController"),n("design:type",Object)],e.prototype,"rangeController",void 0),i([v.Autowired("cellNavigationService"),n("design:type",w.CellNavigationService)],e.prototype,"cellNavigationService",void 0),i([r(0,v.Qualifier("loggerFactory")),n("design:type",Function),n("design:paramtypes",[E.LoggerFactory]),n("design:returntype",void 0)],e.prototype,"agWire",null),i([v.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),i([v.PreDestroy,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"destroy",null),e=i([v.Bean("rowRenderer"),n("design:paramtypes",[])],e)}();t.RowRenderer=S},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(7),l=o(25),a=o(3),p=o(13),d=o(23),u=o(26),c=o(30),h=o(5),g=o(6),f=o(4),y=o(10),v=o(31),C=o(8),m=o(28),E=o(12),A=o(32),w=o(35),R='<div><div class="ag-header"><div class="ag-pinned-left-header"></div><div class="ag-pinned-right-header"></div><div class="ag-header-viewport"><div class="ag-header-container"></div></div><div class="ag-header-overlay"></div></div><div class="ag-floating-top"><div class="ag-pinned-left-floating-top"></div><div class="ag-pinned-right-floating-top"></div><div class="ag-floating-top-viewport"><div class="ag-floating-top-container"></div></div><div class="ag-floating-top-full-width-container"></div></div><div class="ag-floating-bottom"><div class="ag-pinned-left-floating-bottom"></div><div class="ag-pinned-right-floating-bottom"></div><div class="ag-floating-bottom-viewport"><div class="ag-floating-bottom-container"></div></div><div class="ag-floating-bottom-full-width-container"></div></div><div class="ag-body"><div class="ag-pinned-left-cols-viewport"><div class="ag-pinned-left-cols-container"></div></div><div class="ag-pinned-right-cols-viewport"><div class="ag-pinned-right-cols-container"></div></div><div class="ag-body-viewport-wrapper"><div class="ag-body-viewport"><div class="ag-body-container"></div></div></div><div class="ag-full-width-viewport"><div class="ag-full-width-container"></div></div></div></div>',S='<div><div class="ag-header-container"></div><div class="ag-floating-top-container"></div><div class="ag-body-container"></div><div class="ag-floating-bottom-container"></div></div>',O='<div class="ag-overlay-panel"><div class="ag-overlay-wrapper ag-overlay-[OVERLAY_NAME]-wrapper">[OVERLAY_TEMPLATE]</div></div>',N='<span class="ag-overlay-loading-center">[LOADING...]</span>',T='<span class="ag-overlay-no-rows-center">[NO_ROWS_TO_SHOW]</span>',D=function(){function e(){this.requestAnimationFrameExists="function"==typeof requestAnimationFrame,this.scrollLagCounter=0,this.scrollLagTicking=!1,this.lastLeftPosition=-1,this.lastTopPosition=-1,this.animationThreadCount=0,this.destroyFunctions=[]}return e.prototype.agWire=function(e){this.forPrint=this.gridOptionsWrapper.isForPrint(),this.scrollWidth=s.Utils.getScrollbarWidth(),this.logger=e.create("GridPanel"),this.findElements()},e.prototype.destroy=function(){this.destroyFunctions.forEach(function(e){return e()})},e.prototype.onRowDataChanged=function(){this.rowModel.isEmpty()&&!this.gridOptionsWrapper.isSuppressNoRowsOverlay()?this.showNoRowsOverlay():this.hideOverlay()},e.prototype.getLayout=function(){return this.layout},e.prototype.init=function(){this.addEventListeners(),this.addDragListeners(),this.useScrollLag=this.isUseScrollLag(),this.layout=new c.BorderLayout({overlays:{loading:s.Utils.loadTemplate(this.createLoadingOverlayTemplate()),noRows:s.Utils.loadTemplate(this.createNoRowsOverlayTemplate())},center:this.eRoot,dontFill:this.forPrint,name:"eGridPanel"}),this.layout.addSizeChangeListener(this.sizeHeaderAndBody.bind(this)),this.addScrollListener(),this.setLeftAndRightBounds(),this.gridOptionsWrapper.isSuppressHorizontalScroll()&&(this.eBodyViewport.style.overflowX="hidden"),this.gridOptionsWrapper.isRowModelDefault()&&!this.gridOptionsWrapper.getRowData()&&this.showLoadingOverlay(),this.setWidthsOfContainers(),this.showPinnedColContainersIfNeeded(),this.sizeHeaderAndBody(),this.disableBrowserDragging(),this.addShortcutKeyListeners(),this.addCellListeners(),this.addBodyViewportListener(),this.$scope&&this.addAngularApplyCheck()},e.prototype.addAngularApplyCheck=function(){var e=this,t=!1,o=function(){t||(t=!0,setTimeout(function(){t=!1,e.$scope.$apply()},0))};this.eventService.addEventListener(y.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,o),this.eventService.addEventListener(y.Events.EVENT_VIRTUAL_COLUMNS_CHANGED,o),this.destroyFunctions.push(function(){e.eventService.removeEventListener(y.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,o),e.eventService.removeEventListener(y.Events.EVENT_VIRTUAL_COLUMNS_CHANGED,o)})},e.prototype.disableBrowserDragging=function(){this.eRoot.addEventListener("dragstart",function(e){if(e.target instanceof HTMLImageElement)return e.preventDefault(),!1})},e.prototype.addEventListeners=function(){this.eventService.addEventListener(y.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,this.onDisplayedColumnsChanged.bind(this)),this.eventService.addEventListener(y.Events.EVENT_COLUMN_RESIZED,this.onColumnResized.bind(this)),this.eventService.addEventListener(y.Events.EVENT_FLOATING_ROW_DATA_CHANGED,this.sizeHeaderAndBody.bind(this)),this.gridOptionsWrapper.addEventListener(a.GridOptionsWrapper.PROP_HEADER_HEIGHT,this.sizeHeaderAndBody.bind(this)),this.eventService.addEventListener(y.Events.EVENT_ROW_DATA_CHANGED,this.onRowDataChanged.bind(this))},e.prototype.addDragListeners=function(){var e=this;if(!this.forPrint&&this.gridOptionsWrapper.isEnableRangeSelection()&&!s.Utils.missing(this.rangeController)){var t=[this.ePinnedLeftColsContainer,this.ePinnedRightColsContainer,this.eBodyContainer,this.eFloatingTop,this.eFloatingBottom];t.forEach(function(t){e.dragService.addDragSource({dragStartPixels:0,eElement:t,onDragStart:e.rangeController.onDragStart.bind(e.rangeController),onDragStop:e.rangeController.onDragStop.bind(e.rangeController),onDragging:e.rangeController.onDragging.bind(e.rangeController)})})}},e.prototype.addCellListeners=function(){var e=this,t=["click","mousedown","dblclick","contextmenu"];t.forEach(function(t){var o=e.processMouseEvent.bind(e,t);e.eAllCellContainers.forEach(function(i){i.addEventListener(t,o),e.destroyFunctions.push(function(){return i.removeEventListener(t,o)})})})},e.prototype.addBodyViewportListener=function(){var e=this;if(!this.gridOptionsWrapper.isForPrint()){var t=function(t){var o=s.Utils.getTarget(t);o===e.eBodyViewport&&(e.onContextMenu(t),e.preventDefaultOnContextMenu(t))};this.eBodyViewport.addEventListener("contextmenu",t),this.destroyFunctions.push(function(){return e.eBodyViewport.removeEventListener("contextmenu",t)})}},e.prototype.processMouseEvent=function(e,t){var o=this.mouseEventService.getCellForMouseEvent(t);s.Utils.exists(o)&&this.rowRenderer.onMouseEvent(e,t,o),this.preventDefaultOnContextMenu(t)},e.prototype.onContextMenu=function(e){e.ctrlKey||e.metaKey||this.contextMenuFactory&&!this.gridOptionsWrapper.isSuppressContextMenu()&&(this.contextMenuFactory.showMenu(null,null,null,e),e.preventDefault())},e.prototype.preventDefaultOnContextMenu=function(e){this.gridOptionsWrapper.isSuppressMiddleClickScrolls()&&2===e.which&&e.preventDefault()},e.prototype.addShortcutKeyListeners=function(){var e=this;this.eAllCellContainers.forEach(function(t){t.addEventListener("keydown",function(t){if(t.ctrlKey||t.metaKey)switch(t.which){case C.Constants.KEY_A:return e.onCtrlAndA(t);case C.Constants.KEY_C:return e.onCtrlAndC(t);case C.Constants.KEY_V:return e.onCtrlAndV(t);case C.Constants.KEY_D:return e.onCtrlAndD(t)}})})},e.prototype.onCtrlAndA=function(e){if(this.rangeController&&this.rowModel.isRowsToRender()){var t,o,i;o=this.floatingRowModel.isEmpty(C.Constants.FLOATING_TOP)?null:C.Constants.FLOATING_TOP,this.floatingRowModel.isEmpty(C.Constants.FLOATING_BOTTOM)?(i=null,t=this.rowModel.getRowCount()-1):(i=C.Constants.FLOATING_BOTTOM,t=this.floatingRowModel.getFloatingBottomRowData().length=1);var n=this.columnController.getAllDisplayedColumns();if(s.Utils.missingOrEmpty(n))return;this.rangeController.setRange({rowStart:0,floatingStart:o,rowEnd:t,floatingEnd:i,columnStart:n[0],columnEnd:n[n.length-1]})}return e.preventDefault(),!1},e.prototype.onCtrlAndC=function(e){if(this.clipboardService){var t=this.focusedCellController.getFocusedCell();return this.clipboardService.copyToClipboard(),e.preventDefault(),t&&this.focusedCellController.setFocusedCell(t.rowIndex,t.column,t.floating,!0),!1}},e.prototype.onCtrlAndV=function(e){if(this.rangeController)return this.clipboardService.pasteFromClipboard(),!1},e.prototype.onCtrlAndD=function(e){if(this.clipboardService)return this.clipboardService.copyRangeDown(),e.preventDefault(),!1},e.prototype.getPinnedLeftFloatingTop=function(){return this.ePinnedLeftFloatingTop},e.prototype.getPinnedRightFloatingTop=function(){return this.ePinnedRightFloatingTop},e.prototype.getFloatingTopContainer=function(){return this.eFloatingTopContainer},e.prototype.getPinnedLeftFloatingBottom=function(){return this.ePinnedLeftFloatingBottom},e.prototype.getPinnedRightFloatingBottom=function(){return this.ePinnedRightFloatingBottom},e.prototype.getFloatingBottomContainer=function(){return this.eFloatingBottomContainer},e.prototype.createOverlayTemplate=function(e,t,o){var i=O.replace("[OVERLAY_NAME]",e);return i=o?i.replace("[OVERLAY_TEMPLATE]",o):i.replace("[OVERLAY_TEMPLATE]",t)},e.prototype.createLoadingOverlayTemplate=function(){var e=this.gridOptionsWrapper.getOverlayLoadingTemplate(),t=this.createOverlayTemplate("loading",N,e),o=this.gridOptionsWrapper.getLocaleTextFunc(),i=t.replace("[LOADING...]",o("loadingOoo","Loading..."));return i},e.prototype.createNoRowsOverlayTemplate=function(){var e=this.gridOptionsWrapper.getOverlayNoRowsTemplate(),t=this.createOverlayTemplate("no-rows",T,e),o=this.gridOptionsWrapper.getLocaleTextFunc(),i=t.replace("[NO_ROWS_TO_SHOW]",o("noRowsToShow","No Rows To Show"));return i},e.prototype.ensureIndexVisible=function(e){this.logger.log("ensureIndexVisible: "+e);var t=this.rowModel.getRowCount();if("number"!=typeof e||e<0||e>=t)return void console.warn("invalid row index for ensureIndexVisible: "+e);var o=this.rowModel.getRow(e),i=o.rowTop,n=i+o.rowHeight,r=this.eBodyViewport.scrollTop,s=this.eBodyViewport.offsetHeight,l=this.isHorizontalScrollShowing();l&&(s-=this.scrollWidth);var a=r+s,p=r>i,d=a<n,u=this.columnController.isPinningRight()?this.ePinnedRightColsViewport:this.eBodyViewport;if(p)u.scrollTop=i;else if(d){var c=n-s;u.scrollTop=c}},e.prototype.getCenterWidth=function(){return this.eBodyViewport.clientWidth},e.prototype.isHorizontalScrollShowing=function(){var e=this.eBodyViewport.clientWidth<this.eBodyViewport.scrollWidth;return e},e.prototype.isVerticalScrollShowing=function(){return this.columnController.isPinningRight()?s.Utils.isScrollShowing(this.ePinnedRightColsViewport):s.Utils.isScrollShowing(this.eBodyViewport)},e.prototype.isBodyVerticalScrollShowing=function(){return!this.columnController.isPinningRight()&&s.Utils.isScrollShowing(this.eBodyViewport)},e.prototype.periodicallyCheck=function(){this.forPrint||(this.setBottomPaddingOnPinnedRight(),this.setMarginOnFullWidthCellContainer())},e.prototype.setBottomPaddingOnPinnedRight=function(){if(!this.forPrint&&this.columnController.isPinningRight()){var e=this.eBodyViewport.clientWidth<this.eBodyViewport.scrollWidth;e?this.ePinnedRightColsContainer.style.marginBottom=this.scrollWidth+"px":this.ePinnedRightColsContainer.style.marginBottom=""}},e.prototype.setMarginOnFullWidthCellContainer=function(){this.forPrint||(this.isVerticalScrollShowing()?this.eFullWidthCellViewport.style.borderRight=this.scrollWidth+"px solid transparent":this.eFullWidthCellViewport.style.borderRight="",this.isHorizontalScrollShowing()?this.eFullWidthCellViewport.style.borderBottom=this.scrollWidth+"px solid transparent":this.eFullWidthCellViewport.style.borderBottom="")},e.prototype.ensureColumnVisible=function(e){var t=this.columnController.getGridColumn(e);if(t){if(t.isPinned())return void console.warn("calling ensureIndexVisible on a "+t.getPinned()+" pinned column doesn't make sense for column "+t.getColId());if(!this.columnController.isColumnDisplayed(t))return void console.warn("column is not currently visible");var o=t.getLeft(),i=o+t.getActualWidth(),n=this.eBodyViewport.scrollLeft,r=this.eBodyViewport.offsetWidth,s=this.eBodyViewport.clientHeight<this.eBodyViewport.scrollHeight;s&&(r-=this.scrollWidth);var l=n+r,a=n>o,p=l<i;if(a)this.eBodyViewport.scrollLeft=o;else if(p){var d=i-r;this.eBodyViewport.scrollLeft=d}this.setLeftAndRightBounds()}},e.prototype.showLoadingOverlay=function(){this.gridOptionsWrapper.isSuppressLoadingOverlay()||this.layout.showOverlay("loading")},e.prototype.showNoRowsOverlay=function(){this.gridOptionsWrapper.isSuppressNoRowsOverlay()||this.layout.showOverlay("noRows")},e.prototype.hideOverlay=function(){this.layout.hideOverlay()},e.prototype.getWidthForSizeColsToFit=function(){var e=this.eBody.clientWidth,t=this.isBodyVerticalScrollShowing();return t&&(e-=this.scrollWidth),e},e.prototype.sizeColumnsToFit=function(e){var t=this,o=this.getWidthForSizeColsToFit();o>0?this.columnController.sizeColumnsToFit(o):void 0===e?setTimeout(function(){t.sizeColumnsToFit(100)},0):100===e?setTimeout(function(){t.sizeColumnsToFit(-1)},100):console.log("ag-Grid: tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?")},e.prototype.getBodyContainer=function(){return this.eBodyContainer},e.prototype.getFullWidthCellContainer=function(){return this.eFullWidthCellContainer},e.prototype.getFloatingTopFullWidthCellContainer=function(){return this.eFloatingTopFullWidthCellContainer},e.prototype.getFloatingBottomFullWidthCellContainer=function(){return this.eFloatingBottomFullWidthCellContainer},e.prototype.getDropTargetBodyContainers=function(){return this.forPrint?[this.eBodyContainer,this.eFloatingTopContainer,this.eFloatingBottomContainer]:[this.eBodyViewport,this.eFloatingTopViewport,this.eFloatingBottomViewport]},e.prototype.getBodyViewport=function(){return this.eBodyViewport},e.prototype.getPinnedLeftColsContainer=function(){return this.ePinnedLeftColsContainer},e.prototype.getDropTargetLeftContainers=function(){return this.forPrint?[]:[this.ePinnedLeftColsViewport,this.ePinnedLeftFloatingBottom,this.ePinnedLeftFloatingTop]},e.prototype.getPinnedRightColsContainer=function(){return this.ePinnedRightColsContainer},e.prototype.getDropTargetPinnedRightContainers=function(){return this.forPrint?[]:[this.ePinnedRightColsViewport,this.ePinnedRightFloatingBottom,this.ePinnedRightFloatingTop]},e.prototype.getHeaderContainer=function(){return this.eHeaderContainer},e.prototype.getHeaderOverlay=function(){return this.eHeaderOverlay},e.prototype.getRoot=function(){return this.eRoot},e.prototype.getPinnedLeftHeader=function(){return this.ePinnedLeftHeader},e.prototype.getPinnedRightHeader=function(){return this.ePinnedRightHeader},e.prototype.queryHtmlElement=function(e){return this.eRoot.querySelector(e)},e.prototype.findElements=function(){this.forPrint?(this.eRoot=s.Utils.loadTemplate(S),s.Utils.addCssClass(this.eRoot,"ag-root"),s.Utils.addCssClass(this.eRoot,"ag-font-style"),s.Utils.addCssClass(this.eRoot,"ag-no-scrolls")):(this.eRoot=s.Utils.loadTemplate(R),s.Utils.addCssClass(this.eRoot,"ag-root"),s.Utils.addCssClass(this.eRoot,"ag-font-style"),s.Utils.addCssClass(this.eRoot,"ag-scrolls")),this.forPrint?(this.eHeaderContainer=this.queryHtmlElement(".ag-header-container"),this.eBodyContainer=this.queryHtmlElement(".ag-body-container"),this.eFloatingTopContainer=this.queryHtmlElement(".ag-floating-top-container"),this.eFloatingBottomContainer=this.queryHtmlElement(".ag-floating-bottom-container"),this.eAllCellContainers=[this.eBodyContainer,this.eFloatingTopContainer,this.eFloatingBottomContainer],this.eFullWidthCellContainer=this.eBodyContainer,this.eFloatingBottomFullWidthCellContainer=this.eFloatingBottomContainer,this.eFloatingTopFullWidthCellContainer=this.eFloatingTopContainer):(this.eBody=this.queryHtmlElement(".ag-body"),this.eBodyContainer=this.queryHtmlElement(".ag-body-container"),this.eBodyViewport=this.queryHtmlElement(".ag-body-viewport"),this.eBodyViewportWrapper=this.queryHtmlElement(".ag-body-viewport-wrapper"),this.eFullWidthCellContainer=this.queryHtmlElement(".ag-full-width-container"),this.eFullWidthCellViewport=this.queryHtmlElement(".ag-full-width-viewport"),this.ePinnedLeftColsContainer=this.queryHtmlElement(".ag-pinned-left-cols-container"),this.ePinnedRightColsContainer=this.queryHtmlElement(".ag-pinned-right-cols-container"),this.ePinnedLeftColsViewport=this.queryHtmlElement(".ag-pinned-left-cols-viewport"),this.ePinnedRightColsViewport=this.queryHtmlElement(".ag-pinned-right-cols-viewport"),this.ePinnedLeftHeader=this.queryHtmlElement(".ag-pinned-left-header"),this.ePinnedRightHeader=this.queryHtmlElement(".ag-pinned-right-header"),this.eHeader=this.queryHtmlElement(".ag-header"),this.eHeaderContainer=this.queryHtmlElement(".ag-header-container"),this.eHeaderOverlay=this.queryHtmlElement(".ag-header-overlay"),this.eHeaderViewport=this.queryHtmlElement(".ag-header-viewport"),this.eFloatingTop=this.queryHtmlElement(".ag-floating-top"),this.ePinnedLeftFloatingTop=this.queryHtmlElement(".ag-pinned-left-floating-top"),this.ePinnedRightFloatingTop=this.queryHtmlElement(".ag-pinned-right-floating-top"),this.eFloatingTopContainer=this.queryHtmlElement(".ag-floating-top-container"),this.eFloatingTopViewport=this.queryHtmlElement(".ag-floating-top-viewport"),this.eFloatingTopFullWidthCellContainer=this.queryHtmlElement(".ag-floating-top-full-width-container"),this.eFloatingBottom=this.queryHtmlElement(".ag-floating-bottom"),this.ePinnedLeftFloatingBottom=this.queryHtmlElement(".ag-pinned-left-floating-bottom"),this.ePinnedRightFloatingBottom=this.queryHtmlElement(".ag-pinned-right-floating-bottom"),this.eFloatingBottomContainer=this.queryHtmlElement(".ag-floating-bottom-container"),this.eFloatingBottomViewport=this.queryHtmlElement(".ag-floating-bottom-viewport"),this.eFloatingBottomFullWidthCellContainer=this.queryHtmlElement(".ag-floating-bottom-full-width-container"),this.eAllCellContainers=[this.ePinnedLeftColsContainer,this.ePinnedRightColsContainer,this.eBodyContainer,this.eFloatingTop,this.eFloatingBottom],this.addMouseWheelEventListeners())},e.prototype.addMouseWheelEventListeners=function(){var e=this,t=this.genericMouseWheelListener.bind(this),o=this.centerMouseWheelListener.bind(this);this.ePinnedLeftColsViewport.addEventListener("mousewheel",t),this.eBodyViewport.addEventListener("mousewheel",o),this.ePinnedLeftColsViewport.addEventListener("DOMMouseScroll",t),this.eBodyViewport.addEventListener("DOMMouseScroll",o),this.destroyFunctions.push(function(){e.ePinnedLeftColsViewport.removeEventListener("mousewheel",t),e.eBodyViewport.removeEventListener("mousewheel",o),e.ePinnedLeftColsViewport.removeEventListener("DOMMouseScroll",t),e.eBodyViewport.removeEventListener("DOMMouseScroll",o)})},e.prototype.getHeaderViewport=function(){return this.eHeaderViewport},e.prototype.centerMouseWheelListener=function(e){if(this.columnController.isPinningRight())return this.generalMouseWheelListener(e,this.ePinnedRightColsViewport)},e.prototype.genericMouseWheelListener=function(e){var t;return t=this.columnController.isPinningRight()?this.ePinnedRightColsViewport:this.eBodyViewport,this.generalMouseWheelListener(e,t)},e.prototype.generalMouseWheelListener=function(e,t){var o=s.Utils.normalizeWheel(e);if(Math.abs(o.pixelX)>Math.abs(o.pixelY)){var i=this.eBodyViewport.scrollLeft+o.pixelX;this.eBodyViewport.scrollLeft=i}else{var n=this.eBodyViewport.scrollTop+o.pixelY;t.scrollTop=n}return this.gridOptionsWrapper.isSuppressPreventDefaultOnMouseWheel()||e.preventDefault(),!1},e.prototype.onColumnResized=function(){this.setWidthsOfContainers()},e.prototype.onDisplayedColumnsChanged=function(){this.setWidthsOfContainers(),this.showPinnedColContainersIfNeeded(),this.sizeHeaderAndBody()},e.prototype.setWidthsOfContainers=function(){this.logger.log("setWidthsOfContainers()"),this.showPinnedColContainersIfNeeded();var e=this.columnController.getBodyContainerWidth()+"px";if(this.eBodyContainer.style.width=e,!this.forPrint){this.eFloatingBottomContainer.style.width=e,this.eFloatingTopContainer.style.width=e;var t=this.columnController.getPinnedLeftContainerWidth()+"px";this.ePinnedLeftColsContainer.style.width=t,this.ePinnedLeftFloatingBottom.style.width=t,this.ePinnedLeftFloatingTop.style.width=t,this.eBodyViewportWrapper.style.marginLeft=t;var o=this.columnController.getPinnedRightContainerWidth()+"px";this.ePinnedRightColsContainer.style.width=o,this.ePinnedRightFloatingBottom.style.width=o,this.ePinnedRightFloatingTop.style.width=o,this.eBodyViewportWrapper.style.marginRight=o}},e.prototype.showPinnedColContainersIfNeeded=function(){this.forPrint||(this.columnController.isPinningLeft()?(this.ePinnedLeftHeader.style.display="inline-block",this.ePinnedLeftColsViewport.style.display="inline"):(this.ePinnedLeftHeader.style.display="none",this.ePinnedLeftColsViewport.style.display="none"),this.columnController.isPinningRight()?(this.ePinnedRightHeader.style.display="inline-block",this.ePinnedRightColsViewport.style.display="inline",this.eBodyViewport.style.overflowY="hidden"):(this.ePinnedRightHeader.style.display="none",this.ePinnedRightColsViewport.style.display="none",this.eBodyViewport.style.overflowY="auto"))},e.prototype.sizeHeaderAndBody=function(){if(!this.forPrint){this.setLeftAndRightBounds();var e=this.layout.getCentreHeight();if(e){var t=this.gridOptionsWrapper.getHeaderHeight(),o=this.columnController.getHeaderRowCount(),i=t*o;this.eHeader.style.height=i+"px";var n=this.floatingRowModel.getFloatingTopTotalHeight(),r=i+n,s=this.floatingRowModel.getFloatingBottomTotalHeight(),l=e-s,a=e-i-s-n;this.eBody.style.top=r+"px",this.eBody.style.height=a+"px",this.eFloatingTop.style.top=i+"px",this.eFloatingTop.style.height=n+"px",this.eFloatingBottom.style.height=s+"px",this.eFloatingBottom.style.top=l+"px",this.ePinnedLeftColsViewport.style.height=a+"px",this.ePinnedRightColsViewport.style.height=a+"px"}}},e.prototype.setHorizontalScrollPosition=function(e){this.eBodyViewport.scrollLeft=e},e.prototype.scrollHorizontally=function(e){var t=this.eBodyViewport.scrollLeft;this.setHorizontalScrollPosition(t+e);var o=this.eBodyViewport.scrollLeft;return o-t},e.prototype.getHorizontalScrollPosition=function(){return this.forPrint?0:this.eBodyViewport.scrollLeft},e.prototype.turnOnAnimationForABit=function(){var e=this;if(!this.gridOptionsWrapper.isSuppressColumnMoveAnimation()){this.animationThreadCount++;var t=this.animationThreadCount;s.Utils.addCssClass(this.eRoot,"ag-column-moving"),setTimeout(function(){e.animationThreadCount===t&&s.Utils.removeCssClass(e.eRoot,"ag-column-moving")},300)}},e.prototype.addScrollListener=function(){function e(){var e=i.eBodyViewport.scrollLeft;if(e!==i.lastLeftPosition&&(i.lastLeftPosition=e,i.horizontallyScrollHeaderCenterAndFloatingCenter(),i.masterSlaveService.fireHorizontalScrollEvent(e),i.setLeftAndRightBounds()),!i.columnController.isPinningRight()){var t=i.eBodyViewport.scrollTop;t!==i.lastTopPosition&&(i.lastTopPosition=t,i.verticallyScrollLeftPinned(t),i.verticallyScrollFullWidthCellContainer(t),i.rowRenderer.drawVirtualRows())}}function t(){var e=i.ePinnedRightColsViewport.scrollTop;e!==i.lastTopPosition&&(i.lastTopPosition=e,i.verticallyScrollLeftPinned(e),i.verticallyScrollFullWidthCellContainer(e),i.verticallyScrollBody(e),i.rowRenderer.drawVirtualRows())}var o=this;if(!this.forPrint){var i=this;this.useScrollLag?(this.eBodyViewport.addEventListener("scroll",this.debounce.bind(this,e)),this.ePinnedRightColsViewport.addEventListener("scroll",this.debounce.bind(this,t))):(this.eBodyViewport.addEventListener("scroll",e),this.ePinnedRightColsViewport.addEventListener("scroll",t)),this.ePinnedLeftColsViewport.addEventListener("scroll",function(){o.ePinnedLeftColsViewport.scrollTop=0})}},e.prototype.setLeftAndRightBounds=function(){if(!this.gridOptionsWrapper.isForPrint()){var e=this.eBodyViewport.scrollLeft,t=this.eBody.offsetWidth;this.columnController.setWidthAndScrollPosition(t,e)}},e.prototype.isUseScrollLag=function(){return!this.gridOptionsWrapper.isSuppressScrollLag()&&(this.gridOptionsWrapper.getIsScrollLag()?this.gridOptionsWrapper.getIsScrollLag()():s.Utils.isBrowserIE()||s.Utils.isBrowserSafari())},e.prototype.debounce=function(e){var t=this;if(this.requestAnimationFrameExists&&s.Utils.isBrowserSafari())this.scrollLagTicking||(this.scrollLagTicking=!0,requestAnimationFrame(function(){e(),t.scrollLagTicking=!1}));else{this.scrollLagCounter++;var o=this.scrollLagCounter;setTimeout(function(){t.scrollLagCounter===o&&e()},50)}},e.prototype.horizontallyScrollHeaderCenterAndFloatingCenter=function(){var e=this.eBodyViewport.scrollLeft;this.eHeaderContainer.style.left=-e+"px",this.eFloatingBottomContainer.style.left=-e+"px",this.eFloatingTopContainer.style.left=-e+"px"},e.prototype.verticallyScrollLeftPinned=function(e){this.ePinnedLeftColsContainer.style.top=-e+"px"},e.prototype.verticallyScrollFullWidthCellContainer=function(e){this.eFullWidthCellContainer.style.top=-e+"px"},e.prototype.verticallyScrollBody=function(e){this.eBodyViewport.scrollTop=e},e.prototype.getVerticalScrollPosition=function(){return this.forPrint?0:this.eBodyViewport.scrollTop},e.prototype.getBodyViewportClientRect=function(){return this.forPrint?this.eBodyContainer.getBoundingClientRect():this.eBodyViewport.getBoundingClientRect()},e.prototype.getFloatingTopClientRect=function(){return this.forPrint?this.eFloatingTopContainer.getBoundingClientRect():this.eFloatingTop.getBoundingClientRect()},e.prototype.getFloatingBottomClientRect=function(){return this.forPrint?this.eFloatingBottomContainer.getBoundingClientRect():this.eFloatingBottom.getBoundingClientRect()},e.prototype.getPinnedLeftColsViewportClientRect=function(){return this.ePinnedLeftColsViewport.getBoundingClientRect()},e.prototype.getPinnedRightColsViewportClientRect=function(){return this.ePinnedRightColsViewport.getBoundingClientRect()},e.prototype.addScrollEventListener=function(e){this.eBodyViewport.addEventListener("scroll",e)},e.prototype.removeScrollEventListener=function(e){this.eBodyViewport.removeEventListener("scroll",e)},i([g.Autowired("masterSlaveService"),n("design:type",l.MasterSlaveService)],e.prototype,"masterSlaveService",void 0),i([g.Autowired("gridOptionsWrapper"),n("design:type",a.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([g.Autowired("columnController"),n("design:type",p.ColumnController)],e.prototype,"columnController",void 0),i([g.Autowired("rowRenderer"),n("design:type",d.RowRenderer)],e.prototype,"rowRenderer",void 0),i([g.Autowired("floatingRowModel"),n("design:type",u.FloatingRowModel)],e.prototype,"floatingRowModel",void 0),i([g.Autowired("eventService"),n("design:type",f.EventService)],e.prototype,"eventService",void 0),i([g.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),i([g.Optional("rangeController"),n("design:type",Object)],e.prototype,"rangeController",void 0),i([g.Autowired("dragService"),n("design:type",v.DragService)],e.prototype,"dragService",void 0),i([g.Autowired("selectionController"),n("design:type",m.SelectionController)],e.prototype,"selectionController",void 0),i([g.Optional("clipboardService"),n("design:type",Object)],e.prototype,"clipboardService",void 0),i([g.Autowired("csvCreator"),n("design:type",E.CsvCreator)],e.prototype,"csvCreator",void 0),i([g.Autowired("mouseEventService"),n("design:type",A.MouseEventService)],e.prototype,"mouseEventService",void 0),i([g.Autowired("focusedCellController"),n("design:type",w.FocusedCellController)],e.prototype,"focusedCellController",void 0),i([g.Autowired("$scope"),n("design:type",Object)],e.prototype,"$scope",void 0),i([g.Optional("contextMenuFactory"),n("design:type",Object)],e.prototype,"contextMenuFactory",void 0),i([r(0,g.Qualifier("loggerFactory")),n("design:type",Function),n("design:paramtypes",[h.LoggerFactory]),n("design:returntype",void 0)],e.prototype,"agWire",null),i([g.PreDestroy,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"destroy",null),i([g.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e=i([g.Bean("gridPanel"),n("design:paramtypes",[])],e)}();t.GridPanel=D},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(3),l=o(13),a=o(24),p=o(4),d=o(5),u=o(10),c=o(6),h=o(6),g=o(6),f=o(6),y=function(){function e(){this.consuming=!1}return e.prototype.setBeans=function(e){this.logger=e.create("MasterSlaveService")},e.prototype.init=function(){this.eventService.addEventListener(u.Events.EVENT_COLUMN_MOVED,this.fireColumnEvent.bind(this)),this.eventService.addEventListener(u.Events.EVENT_COLUMN_VISIBLE,this.fireColumnEvent.bind(this)),this.eventService.addEventListener(u.Events.EVENT_COLUMN_PINNED,this.fireColumnEvent.bind(this)),this.eventService.addEventListener(u.Events.EVENT_COLUMN_GROUP_OPENED,this.fireColumnEvent.bind(this)),this.eventService.addEventListener(u.Events.EVENT_COLUMN_RESIZED,this.fireColumnEvent.bind(this))},e.prototype.fireEvent=function(e){if(!this.consuming){var t=this.gridOptionsWrapper.getSlaveGrids();t&&t.forEach(function(t){if(t.api){var o=t.api.__getMasterSlaveService();e(o)}})}},e.prototype.onEvent=function(e){this.consuming=!0,e(),this.consuming=!1},e.prototype.fireColumnEvent=function(e){this.fireEvent(function(t){t.onColumnEvent(e)})},e.prototype.fireHorizontalScrollEvent=function(e){this.fireEvent(function(t){t.onScrollEvent(e)})},e.prototype.onScrollEvent=function(e){var t=this;this.onEvent(function(){t.gridPanel.setHorizontalScrollPosition(e)})},e.prototype.getMasterColumns=function(e){var t=[];return e.getColumn()&&t.push(e.getColumn()),e.getColumns()&&e.getColumns().forEach(function(e){t.push(e)}),t},e.prototype.getColumnIds=function(e){var t=[];return e.getColumn()?t.push(e.getColumn().getColId()):e.getColumns()&&e.getColumns().forEach(function(e){t.push(e.getColId())}),t},e.prototype.onColumnEvent=function(e){var t=this;this.onEvent(function(){var o,i=e.getColumn();if(i&&(o=t.columnController.getPrimaryColumn(i.getColId())),!i||o){var n,r=e.getColumnGroup();if(r){var s=r.getGroupId(),l=r.getInstanceId();n=t.columnController.getColumnGroup(s,l)}if(!r||n){var a=t.getColumnIds(e),p=t.getMasterColumns(e);switch(e.getType()){case u.Events.EVENT_COLUMN_PIVOT_CHANGED:console.warn("ag-Grid: pivoting is not supported with Master / Slave grids. You can only use one of these features at a time in a grid.");break;case u.Events.EVENT_COLUMN_MOVED:t.logger.log("onColumnEvent-> processing "+e+" toIndex = "+e.getToIndex()),t.columnController.moveColumns(a,e.getToIndex());break;case u.Events.EVENT_COLUMN_VISIBLE:t.logger.log("onColumnEvent-> processing "+e+" visible = "+e.isVisible()),t.columnController.setColumnsVisible(a,e.isVisible());break;case u.Events.EVENT_COLUMN_PINNED:t.logger.log("onColumnEvent-> processing "+e+" pinned = "+e.getPinned()),t.columnController.setColumnsPinned(a,e.getPinned());break;case u.Events.EVENT_COLUMN_GROUP_OPENED:t.logger.log("onColumnEvent-> processing "+e+" expanded = "+r.isExpanded()),t.columnController.setColumnGroupOpened(n,r.isExpanded());break;case u.Events.EVENT_COLUMN_RESIZED:p.forEach(function(o){t.logger.log("onColumnEvent-> processing "+e+" actualWidth = "+o.getActualWidth()),t.columnController.setColumnWidth(o.getColId(),o.getActualWidth(),e.isFinished())})}}}})},i([g.Autowired("gridOptionsWrapper"),n("design:type",s.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([g.Autowired("columnController"),n("design:type",l.ColumnController)],e.prototype,"columnController",void 0),i([g.Autowired("gridPanel"),n("design:type",a.GridPanel)],e.prototype,"gridPanel",void 0),i([g.Autowired("eventService"),n("design:type",p.EventService)],e.prototype,"eventService",void 0),i([r(0,h.Qualifier("loggerFactory")),n("design:type",Function),n("design:paramtypes",[d.LoggerFactory]),n("design:returntype",void 0)],e.prototype,"setBeans",null),i([f.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e=i([c.Bean("masterSlaveService"),n("design:paramtypes",[])],e)}();t.MasterSlaveService=y},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(3),s=o(27),l=o(6),a=o(4),p=o(6),d=o(10),u=o(6),c=o(8),h=o(7),g=function(){function e(){}return e.prototype.init=function(){this.setFloatingTopRowData(this.gridOptionsWrapper.getFloatingTopRowData()),this.setFloatingBottomRowData(this.gridOptionsWrapper.getFloatingBottomRowData())},e.prototype.isEmpty=function(e){var t=e===c.Constants.FLOATING_TOP?this.floatingTopRows:this.floatingBottomRows;return h.Utils.missingOrEmpty(t)},e.prototype.isRowsToRender=function(e){return!this.isEmpty(e)},e.prototype.getRowAtPixel=function(e,t){var o=t===c.Constants.FLOATING_TOP?this.floatingTopRows:this.floatingBottomRows;if(h.Utils.missingOrEmpty(o))return 0;for(var i=0;i<o.length;i++){var n=o[i],r=n.rowTop+n.rowHeight-1;if(r>=e)return i}return o.length-1},e.prototype.setFloatingTopRowData=function(e){this.floatingTopRows=this.createNodesFromData(e,!0),this.eventService.dispatchEvent(d.Events.EVENT_FLOATING_ROW_DATA_CHANGED)},e.prototype.setFloatingBottomRowData=function(e){this.floatingBottomRows=this.createNodesFromData(e,!1),this.eventService.dispatchEvent(d.Events.EVENT_FLOATING_ROW_DATA_CHANGED)},e.prototype.createNodesFromData=function(e,t){var o=this,i=[];if(e){var n=0;e.forEach(function(e){var r=new s.RowNode;o.context.wireBean(r),r.data=e,r.floating=t?c.Constants.FLOATING_TOP:c.Constants.FLOATING_BOTTOM,r.rowTop=n,r.rowHeight=o.gridOptionsWrapper.getRowHeightForNode(r),n+=r.rowHeight,i.push(r)})}return i},e.prototype.getFloatingTopRowData=function(){return this.floatingTopRows},e.prototype.getFloatingBottomRowData=function(){return this.floatingBottomRows},e.prototype.getFloatingTopTotalHeight=function(){return this.getTotalHeight(this.floatingTopRows)},e.prototype.forEachFloatingTopRow=function(e){h.Utils.missingOrEmpty(this.floatingTopRows)||this.floatingTopRows.forEach(e)},e.prototype.forEachFloatingBottomRow=function(e){h.Utils.missingOrEmpty(this.floatingBottomRows)||this.floatingBottomRows.forEach(e)},e.prototype.getFloatingBottomTotalHeight=function(){return this.getTotalHeight(this.floatingBottomRows)},e.prototype.getTotalHeight=function(e){if(e&&0!==e.length){var t=e[e.length-1];return t.rowTop+t.rowHeight}return 0},i([p.Autowired("gridOptionsWrapper"),n("design:type",r.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([p.Autowired("eventService"),n("design:type",a.EventService)],e.prototype,"eventService",void 0),i([p.Autowired("context"),n("design:type",l.Context)],e.prototype,"context",void 0),i([u.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e=i([l.Bean("floatingRowModel"),n("design:paramtypes",[])],e)}();t.FloatingRowModel=g},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(4),s=o(10),l=o(3),a=o(28),p=o(29),d=o(13),u=o(6),c=o(8),h=function(){function e(){this.childrenMapped={},this.selected=!1}return e.prototype.setData=function(t){var o=this.data;this.data=t;var i={oldData:o,newData:t};this.dispatchLocalEvent(e.EVENT_DATA_CHANGED,i)},e.prototype.setDataAndId=function(t,o){var i=this.data;this.data=t,this.setId(o),this.selectionController.syncInRowNode(this);var n={oldData:i,newData:t};this.dispatchLocalEvent(e.EVENT_DATA_CHANGED,n)},e.prototype.setId=function(e){var t=this.gridOptionsWrapper.getRowNodeIdFunc();t?this.data?this.id=t(this.data):this.id=void 0:this.id=e},e.prototype.dispatchLocalEvent=function(e,t){this.eventService&&this.eventService.dispatchEvent(e,t)},e.prototype.setDataValue=function(t,o){var i=this.columnController.getGridColumn(t);this.valueService.setValue(this,i,o);var n={column:i,newValue:o};this.dispatchLocalEvent(e.EVENT_CELL_CHANGED,n)},e.prototype.resetQuickFilterAggregateText=function(){this.quickFilterAggregateText=null},e.prototype.isExpandable=function(){return this.group||this.canFlower},e.prototype.isSelected=function(){return this.footer?this.sibling.isSelected():this.selected},e.prototype.deptFirstSearch=function(e){this.childrenAfterGroup&&this.childrenAfterGroup.forEach(function(t){return t.deptFirstSearch(e)}),e(this)},e.prototype.calculateSelectedFromChildren=function(){var e,t=!1,o=!1,i=!1;if(this.childrenAfterGroup)for(var n=0;n<this.childrenAfterGroup.length;n++){var r=this.childrenAfterGroup[n].isSelected();switch(r){case!0:t=!0;break;case!1:o=!0;break;default:i=!0}}e=i?void 0:!(!t||o)||!(!t&&o)&&void 0,this.selectThisNode(e)},e.prototype.calculateSelectedFromChildrenBubbleUp=function(){this.calculateSelectedFromChildren(),this.parent&&this.parent.calculateSelectedFromChildrenBubbleUp()},e.prototype.setSelectedInitialValue=function(e){this.selected=e},e.prototype.setSelected=function(e,t,o){void 0===t&&(t=!1),void 0===o&&(o=!1),this.setSelectedParams({newValue:e,clearSelection:t,tailingNodeInSequence:o,rangeSelect:!1})},e.prototype.setSelectedParams=function(e){var t=e.newValue===!0,o=e.clearSelection===!0,i=e.tailingNodeInSequence===!0,n=e.rangeSelect===!0;if(void 0===this.id)return void console.warn("ag-Grid: cannot select node until id for node is known");if(this.floating)return void console.log("ag-Grid: cannot select floating rows");if(this.footer)return void this.sibling.setSelectedParams(e);if(n){var r=this.rowModel.getType()===c.Constants.ROW_MODEL_TYPE_NORMAL,l=this.selectionController.getLastSelectedNode()!==this,a=this.gridOptionsWrapper.isRowSelectionMulti();if(r&&l&&a)return void this.doRowRangeSelection()}this.selectThisNode(t);var p=this.gridOptionsWrapper.isGroupSelectsChildren();p&&this.group&&this.selectChildNodes(t);var d=!i;d&&(!t||!o&&this.gridOptionsWrapper.isRowSelectionMulti()||this.selectionController.clearOtherNodes(this),p&&this.parent&&this.parent.calculateSelectedFromChildrenBubbleUp(),this.mainEventService.dispatchEvent(s.Events.EVENT_SELECTION_CHANGED),t&&this.selectionController.setLastSelectedNode(this))},e.prototype.doRowRangeSelection=function(){var e,t=this,o=this.selectionController.getLastSelectedNode(),i=!o,n=!1,r=this.gridOptionsWrapper.isGroupSelectsChildren(),l=this.rowModel;l.forEachNodeAfterFilterAndSort(function(s){var l=i&&!n;i||s!==o&&s!==t||(i=!0);var a=s.group&&r;if(!a){var p=i&&!n,d=s.isParentOfNode(e);s.selectThisNode(p||d)}l&&(s!==o&&s!==t||(n=!0,e=s===o?o:t))}),r&&this.calculatedSelectedForAllGroupNodes(),this.mainEventService.dispatchEvent(s.Events.EVENT_SELECTION_CHANGED)},e.prototype.isParentOfNode=function(e){for(var t=this.parent;t;){if(t===e)return!0;t=t.parent}return!1},e.prototype.calculatedSelectedForAllGroupNodes=function(){var e=this.rowModel;e.getTopLevelNodes().forEach(function(e){e.group&&(e.deptFirstSearch(function(e){e.group&&e.calculateSelectedFromChildren()}),e.calculateSelectedFromChildren())})},e.prototype.selectThisNode=function(t){if(this.selected!==t){this.selected=t,this.eventService&&this.dispatchLocalEvent(e.EVENT_ROW_SELECTED);var o={node:this};this.mainEventService.dispatchEvent(s.Events.EVENT_ROW_SELECTED,o)}},e.prototype.selectChildNodes=function(e){for(var t=0;t<this.childrenAfterGroup.length;t++)this.childrenAfterGroup[t].setSelectedParams({newValue:e,clearSelection:!1,tailingNodeInSequence:!0})},e.prototype.addEventListener=function(e,t){this.eventService||(this.eventService=new r.EventService),this.eventService.addEventListener(e,t)},e.prototype.removeEventListener=function(e,t){this.eventService.removeEventListener(e,t)},e.prototype.onMouseEnter=function(){this.dispatchLocalEvent(e.EVENT_MOUSE_ENTER)},e.prototype.onMouseLeave=function(){this.dispatchLocalEvent(e.EVENT_MOUSE_LEAVE)},e.EVENT_ROW_SELECTED="rowSelected",e.EVENT_DATA_CHANGED="dataChanged",e.EVENT_CELL_CHANGED="cellChanged",e.EVENT_MOUSE_ENTER="mouseEnter",e.EVENT_MOUSE_LEAVE="mouseLeave",i([u.Autowired("eventService"),n("design:type",r.EventService)],e.prototype,"mainEventService",void 0),i([u.Autowired("gridOptionsWrapper"),n("design:type",l.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([u.Autowired("selectionController"),n("design:type",a.SelectionController)],e.prototype,"selectionController",void 0),i([u.Autowired("columnController"),n("design:type",d.ColumnController)],e.prototype,"columnController",void 0),i([u.Autowired("valueService"),n("design:type",p.ValueService)],e.prototype,"valueService",void 0),i([u.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),e}();t.RowNode=h},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(7),l=o(6),a=o(6),p=o(5),d=o(4),u=o(10),c=o(6),h=o(3),g=o(6),f=o(8),y=function(){function e(){}return e.prototype.setBeans=function(e){this.logger=e.create("SelectionController"),this.reset(),this.gridOptionsWrapper.isRowModelDefault()?this.eventService.addEventListener(u.Events.EVENT_ROW_DATA_CHANGED,this.reset.bind(this)):this.logger.log("dont know what to do here")},e.prototype.init=function(){this.groupSelectsChildren=this.gridOptionsWrapper.isGroupSelectsChildren(),this.eventService.addEventListener(u.Events.EVENT_ROW_SELECTED,this.onRowSelected.bind(this))},e.prototype.setLastSelectedNode=function(e){this.lastSelectedNode=e},e.prototype.getLastSelectedNode=function(){return this.lastSelectedNode},e.prototype.getSelectedNodes=function(){var e=[];return s.Utils.iterateObject(this.selectedNodes,function(t,o){o&&e.push(o)}),e},e.prototype.getSelectedRows=function(){var e=[];return s.Utils.iterateObject(this.selectedNodes,function(t,o){o&&e.push(o.data)}),e},e.prototype.removeGroupsFromSelection=function(){var e=this;s.Utils.iterateObject(this.selectedNodes,function(t,o){o&&o.group&&(e.selectedNodes[o.id]=void 0)})},e.prototype.updateGroupsFromChildrenSelections=function(){this.rowModel.getType()!==f.Constants.ROW_MODEL_TYPE_NORMAL&&console.warn("updateGroupsFromChildrenSelections not available when rowModel is not normal");var e=this.rowModel;e.getTopLevelNodes().forEach(function(e){e.deptFirstSearch(function(e){e.group&&e.calculateSelectedFromChildren()})})},e.prototype.getNodeForIdIfSelected=function(e){return this.selectedNodes[e]},e.prototype.clearOtherNodes=function(e){var t=this,o={};s.Utils.iterateObject(this.selectedNodes,function(i,n){n&&n.id!==e.id&&(t.selectedNodes[n.id].setSelectedParams({newValue:!1,clearSelection:!1,tailingNodeInSequence:!0}),t.groupSelectsChildren&&n.parent&&(o[n.parent.id]=n.parent))}),s.Utils.iterateObject(o,function(e,t){t.calculateSelectedFromChildren()})},e.prototype.onRowSelected=function(e){var t=e.node;this.groupSelectsChildren&&t.group||(t.isSelected()?this.selectedNodes[t.id]=t:this.selectedNodes[t.id]=void 0)},e.prototype.syncInRowNode=function(e){void 0!==this.selectedNodes[e.id]&&(e.setSelectedInitialValue(!0),this.selectedNodes[e.id]=e)},e.prototype.reset=function(){this.logger.log("reset"),this.selectedNodes={},this.lastSelectedNode=null},e.prototype.getBestCostNodeSelection=function(){function e(t){for(var o=0,n=t.length;o<n;o++){var r=t[o];r.isSelected()?i.push(r):r.group&&r.children&&e(r.children)}}this.rowModel.getType()!==f.Constants.ROW_MODEL_TYPE_NORMAL&&console.warn("getBestCostNodeSelection is only avilable when using normal row model");var t=this.rowModel,o=t.getTopLevelNodes();if(null===o)return void console.warn("selectAll not available doing rowModel=virtual");var i=[];return e(o),i},e.prototype.setRowModel=function(e){this.rowModel=e},e.prototype.isEmpty=function(){var e=0;return s.Utils.iterateObject(this.selectedNodes,function(t,o){o&&e++}),0===e},e.prototype.deselectAllRowNodes=function(){s.Utils.iterateObject(this.selectedNodes,function(e,t){t&&t.selectThisNode(!1)}),this.rowModel.getType()===f.Constants.ROW_MODEL_TYPE_NORMAL&&this.groupSelectsChildren&&this.updateGroupsFromChildrenSelections(),this.selectedNodes={},this.eventService.dispatchEvent(u.Events.EVENT_SELECTION_CHANGED)},e.prototype.selectAllRowNodes=function(){if(this.rowModel.getType()!==f.Constants.ROW_MODEL_TYPE_NORMAL)throw"selectAll only available with normal row model, ie not virtual pagination";this.rowModel.forEachNode(function(e){e.selectThisNode(!0)}),this.eventService.dispatchEvent(u.Events.EVENT_SELECTION_CHANGED)},e.prototype.selectNode=function(e,t){e.setSelectedParams({newValue:!0,clearSelection:!t})},e.prototype.deselectIndex=function(e){var t=this.rowModel.getRow(e);this.deselectNode(t)},e.prototype.deselectNode=function(e){e.setSelectedParams({newValue:!1,clearSelection:!1})},e.prototype.selectIndex=function(e,t){var o=this.rowModel.getRow(e);this.selectNode(o,t)},i([c.Autowired("eventService"),n("design:type",d.EventService)],e.prototype,"eventService",void 0),i([c.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),i([c.Autowired("gridOptionsWrapper"),n("design:type",h.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([r(0,a.Qualifier("loggerFactory")),n("design:type",Function),n("design:paramtypes",[p.LoggerFactory]),n("design:returntype",void 0)],e.prototype,"setBeans",null),i([g.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e=i([l.Bean("selectionController"),n("design:paramtypes",[])],e)}();t.SelectionController=y},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(3),s=o(18),l=o(13),a=o(6),p=o(7),d=o(10),u=o(4),c=function(){function e(){this.initialised=!1}return e.prototype.init=function(){this.suppressDotNotation=this.gridOptionsWrapper.isSuppressFieldDotNotation(),this.cellExpressions=this.gridOptionsWrapper.isEnableCellExpressions(),this.userProvidedTheGroups=p.Utils.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc()),this.suppressUseColIdForGroups=this.gridOptionsWrapper.isSuppressUseColIdForGroups(),this.initialised=!0},e.prototype.getValue=function(e,t){return this.getValueUsingSpecificData(e,t.data,t)},e.prototype.getValueUsingSpecificData=function(e,t,o){this.initialised||this.init();var i,n=e.getColDef(),r=n.field;if(i=t&&o.group&&!this.userProvidedTheGroups&&!this.suppressUseColIdForGroups?o.data?o.data[e.getId()]:void 0:n.valueGetter?this.executeValueGetter(n.valueGetter,t,e,o):r&&t?this.getValueUsingField(t,r,e.isFieldContainsDots()):void 0,this.cellExpressions&&"string"==typeof i&&0===i.indexOf("=")){var s=i.substring(1);i=this.executeValueGetter(s,t,e,o)}return i},e.prototype.getValueUsingField=function(e,t,o){if(t&&e){if(o){for(var i=t.split("."),n=e,r=0;r<i.length;r++)if(n=n[i[r]],p.Utils.missing(n))return null;return n}return e[t]}},e.prototype.setValue=function(e,t,o){var i=this.columnController.getPrimaryColumn(t);if(e&&i){var n=e.data;if(!p.Utils.missing(n)){var r=i.getColDef().field,s=i.getColDef().newValueHandler;if(p.Utils.missing(r)&&p.Utils.missing(s))return void console.warn("ag-Grid: you need either field or newValueHandler set on colDef for editing to work");var l={node:e,data:e.data,oldValue:this.getValue(i,e),newValue:o,colDef:i.getColDef(),api:this.gridOptionsWrapper.getApi(),context:this.gridOptionsWrapper.getContext()};s?s(l):this.setValueUsingField(n,r,o,i.isFieldContainsDots()),e.resetQuickFilterAggregateText(),l.newValue=this.getValue(i,e),"function"==typeof i.getColDef().onCellValueChanged&&i.getColDef().onCellValueChanged(l),this.eventService.dispatchEvent(d.Events.EVENT_CELL_VALUE_CHANGED,l)}}},e.prototype.setValueUsingField=function(e,t,o,i){if(i)for(var n=t.split("."),r=e;n.length>0&&r;){var s=n.shift();0===n.length?r[s]=o:r=r[s]}else e[t]=o},e.prototype.executeValueGetter=function(e,t,o,i){var n=this.gridOptionsWrapper.getContext(),r=this.gridOptionsWrapper.getApi(),s={data:t,node:i,colDef:o.getColDef(),api:r,context:n,getValue:this.getValueCallback.bind(this,t,i)};return"function"==typeof e?e(s):"string"==typeof e?this.expressionService.evaluate(e,s):void 0},e.prototype.getValueCallback=function(e,t,o){var i=this.columnController.getPrimaryColumn(o);return i?this.getValueUsingSpecificData(i,e,t):null},i([a.Autowired("gridOptionsWrapper"),n("design:type",r.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([a.Autowired("expressionService"),n("design:type",s.ExpressionService)],e.prototype,"expressionService",void 0),i([a.Autowired("columnController"),n("design:type",l.ColumnController)],e.prototype,"columnController",void 0),i([a.Autowired("eventService"),n("design:type",u.EventService)],e.prototype,"eventService",void 0),i([a.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e=i([a.Bean("valueService"),n("design:paramtypes",[])],e)}();t.ValueService=c},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(7),n=function(){function e(t){this.centerHeightLastTime=-1,this.centerWidthLastTime=-1,this.centerLeftMarginLastTime=-1,this.visibleLastTime=!1,this.sizeChangeListeners=[],this.isLayoutPanel=!0,this.fullHeight=!t.north&&!t.south;var o;t.dontFill?(o=e.TEMPLATE_DONT_FILL,this.layoutActive=!1):(o=this.fullHeight?e.TEMPLATE_FULL_HEIGHT:e.TEMPLATE_NORMAL,this.layoutActive=!0),this.eGui=i.Utils.loadTemplate(o),this.id="borderLayout",t.name&&(this.id+="_"+t.name),this.eGui.setAttribute("id",this.id),this.childPanels=[],t&&this.setupPanels(t),this.overlays=t.overlays,this.setupOverlays()}return e.prototype.addSizeChangeListener=function(e){this.sizeChangeListeners.push(e)},e.prototype.fireSizeChanged=function(){this.sizeChangeListeners.forEach(function(e){e()})},e.prototype.setupPanels=function(e){this.eNorthWrapper=this.eGui.querySelector("#north"),this.eSouthWrapper=this.eGui.querySelector("#south"),this.eEastWrapper=this.eGui.querySelector("#east"),this.eWestWrapper=this.eGui.querySelector("#west"),this.eCenterWrapper=this.eGui.querySelector("#center"),this.eOverlayWrapper=this.eGui.querySelector("#overlay"),this.eCenterRow=this.eGui.querySelector("#centerRow"),this.eNorthChildLayout=this.setupPanel(e.north,this.eNorthWrapper),this.eSouthChildLayout=this.setupPanel(e.south,this.eSouthWrapper),this.eEastChildLayout=this.setupPanel(e.east,this.eEastWrapper),this.eWestChildLayout=this.setupPanel(e.west,this.eWestWrapper),this.eCenterChildLayout=this.setupPanel(e.center,this.eCenterWrapper)},e.prototype.setupPanel=function(e,t){if(t)return e?e.isLayoutPanel?(this.childPanels.push(e),t.appendChild(e.getGui()),e):(t.appendChild(e),null):(t.parentNode.removeChild(t),null)},e.prototype.getGui=function(){return this.eGui},e.prototype.doLayout=function(){var e=this,t=i.Utils.isVisible(this.eGui);if(!t)return this.visibleLastTime=!1,!1;var o=!1;this.visibleLastTime!==t&&(o=!0),this.visibleLastTime=!0;var n=[this.eNorthChildLayout,this.eSouthChildLayout,this.eEastChildLayout,this.eWestChildLayout];if(n.forEach(function(t){var i=e.layoutChild(t);i&&(o=!0)}),this.layoutActive){var r=this.layoutHeight(),s=this.layoutWidth();(r||s)&&(o=!0)}var l=this.layoutChild(this.eCenterChildLayout);return l&&(o=!0),o&&this.fireSizeChanged(),o},e.prototype.layoutChild=function(e){return!!e&&e.doLayout()},e.prototype.layoutHeight=function(){return this.fullHeight?this.layoutHeightFullHeight():this.layoutHeightNormal()},e.prototype.layoutHeightFullHeight=function(){var e=i.Utils.offsetHeight(this.eGui);return e<0&&(e=0),this.centerHeightLastTime!==e&&(this.centerHeightLastTime=e,!0)},e.prototype.layoutHeightNormal=function(){var e=i.Utils.offsetHeight(this.eGui),t=i.Utils.offsetHeight(this.eNorthWrapper),o=i.Utils.offsetHeight(this.eSouthWrapper),n=e-t-o;return n<0&&(n=0),this.centerHeightLastTime!==n&&(this.eCenterRow.style.height=n+"px",this.centerHeightLastTime=n,!0)},e.prototype.getCentreHeight=function(){return this.centerHeightLastTime},e.prototype.layoutWidth=function(){var e=i.Utils.offsetWidth(this.eGui),t=i.Utils.offsetWidth(this.eEastWrapper),o=i.Utils.offsetWidth(this.eWestWrapper),n=e-t-o;n<0&&(n=0);var r=!1;return this.centerLeftMarginLastTime!==o&&(this.centerLeftMarginLastTime=o,this.eCenterWrapper.style.marginLeft=o+"px",r=!0),this.centerWidthLastTime!==n&&(this.centerWidthLastTime=n,this.eCenterWrapper.style.width=n+"px",r=!0),r},e.prototype.setEastVisible=function(e){this.eEastWrapper&&(this.eEastWrapper.style.display=e?"":"none"),this.doLayout()},e.prototype.setupOverlays=function(){return this.overlays?void this.hideOverlay():void this.eOverlayWrapper.parentNode.removeChild(this.eOverlayWrapper)},e.prototype.hideOverlay=function(){i.Utils.removeAllChildren(this.eOverlayWrapper),this.eOverlayWrapper.style.display="none"},e.prototype.showOverlay=function(e){var t=this.overlays?this.overlays[e]:null;t?(i.Utils.removeAllChildren(this.eOverlayWrapper),this.eOverlayWrapper.style.display="",this.eOverlayWrapper.appendChild(t)):(console.log("ag-Grid: unknown overlay"),this.hideOverlay())},e.TEMPLATE_FULL_HEIGHT='<div class="ag-bl ag-bl-full-height">  <div class="ag-bl-west ag-bl-full-height-west" id="west"></div>  <div class="ag-bl-east ag-bl-full-height-east" id="east"></div>  <div class="ag-bl-center ag-bl-full-height-center" id="center"></div>  <div class="ag-bl-overlay" id="overlay"></div></div>',e.TEMPLATE_NORMAL='<div class="ag-bl ag-bl-normal">  <div id="north"></div>  <div class="ag-bl-center-row ag-bl-normal-center-row" id="centerRow">    <div class="ag-bl-west ag-bl-normal-west" id="west"></div>    <div class="ag-bl-east ag-bl-normal-east" id="east"></div>    <div class="ag-bl-center ag-bl-normal-center" id="center"></div>  </div>  <div id="south"></div>  <div class="ag-bl-overlay" id="overlay"></div></div>',e.TEMPLATE_DONT_FILL='<div class="ag-bl ag-bl-dont-fill">  <div id="north"></div>  <div id="centerRow">    <div id="west"></div>    <div id="east"></div>    <div id="center"></div>  </div>  <div id="south"></div>  <div class="ag-bl-overlay" id="overlay"></div></div>',e}();t.BorderLayout=n},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(5),l=o(7),a=o(4),p=o(10),d=function(){function e(){this.onMouseUpListener=this.onMouseUp.bind(this),this.onMouseMoveListener=this.onMouseMove.bind(this),this.destroyFunctions=[]}return e.prototype.init=function(){this.logger=this.loggerFactory.create("DragService"),this.eBody=document.querySelector("body")},e.prototype.destroy=function(){this.destroyFunctions.forEach(function(e){return e()})},e.prototype.setNoSelectToBody=function(e){l.Utils.exists(this.eBody)&&l.Utils.addOrRemoveCssClass(this.eBody,"ag-body-no-select",e)},e.prototype.addDragSource=function(e){var t=this.onMouseDown.bind(this,e);e.eElement.addEventListener("mousedown",t),this.destroyFunctions.push(function(){return e.eElement.removeEventListener("mousedown",t)})},e.prototype.onMouseDown=function(e,t){0===t.button&&(this.currentDragParams=e,this.dragging=!1,this.eventLastTime=t,this.dragStartEvent=t,document.addEventListener("mousemove",this.onMouseMoveListener),document.addEventListener("mouseup",this.onMouseUpListener),0===e.dragStartPixels&&this.onMouseMove(t))},e.prototype.isEventNearStartEvent=function(e){var t=l.Utils.exists(this.currentDragParams.dragStartPixels)?this.currentDragParams.dragStartPixels:4;if(0===t)return!1;var o=Math.abs(e.clientX-this.dragStartEvent.clientX),i=Math.abs(e.clientY-this.dragStartEvent.clientY);return Math.max(o,i)<=t},e.prototype.onMouseMove=function(e){if(!this.dragging){var t=!this.dragging&&this.isEventNearStartEvent(e);if(t)return;this.dragging=!0,this.eventService.dispatchEvent(p.Events.EVENT_DRAG_STARTED),this.currentDragParams.onDragStart(this.dragStartEvent),this.setNoSelectToBody(!0)}this.currentDragParams.onDragging(e)},e.prototype.onMouseUp=function(e){document.removeEventListener("mouseup",this.onMouseUpListener),document.removeEventListener("mousemove",this.onMouseMoveListener),this.setNoSelectToBody(!1),this.dragStartEvent=null,this.eventLastTime=null,this.dragging&&(this.dragging=!1,this.currentDragParams.onDragStop(e),this.eventService.dispatchEvent(p.Events.EVENT_DRAG_STOPPED))},i([r.Autowired("loggerFactory"),n("design:type",s.LoggerFactory)],e.prototype,"loggerFactory",void 0),i([r.Autowired("eventService"),n("design:type",a.EventService)],e.prototype,"eventService",void 0),i([r.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),i([r.PreDestroy,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"destroy",null),e=i([r.Bean("dragService"),n("design:paramtypes",[])],e)}();t.DragService=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(6),l=o(24),a=o(13),p=o(15),d=o(8),u=o(26),c=o(7),h=o(33),g=o(3),f=function(){function e(){}return e.prototype.getCellForMouseEvent=function(e){var t=this.getFloating(e),o=this.getRowIndex(e,t),i=this.getColumn(e);return o>=0&&c.Utils.exists(i)?new h.GridCell(o,t,i):null},e.prototype.getFloating=function(e){var t=this.gridPanel.getFloatingTopClientRect(),o=this.gridPanel.getFloatingBottomClientRect(),i=!this.floatingRowModel.isEmpty(d.Constants.FLOATING_TOP),n=!this.floatingRowModel.isEmpty(d.Constants.FLOATING_BOTTOM);return i&&t.bottom>=e.clientY?d.Constants.FLOATING_TOP:n&&o.top<=e.clientY?d.Constants.FLOATING_BOTTOM:null},e.prototype.getFloatingRowIndex=function(e,t){var o;switch(t){case d.Constants.FLOATING_TOP:o=this.gridPanel.getFloatingTopClientRect();break;case d.Constants.FLOATING_BOTTOM:o=this.gridPanel.getFloatingBottomClientRect()}var i=e.clientY-o.top,n=this.floatingRowModel.getRowAtPixel(i,t);return n},e.prototype.getRowIndex=function(e,t){switch(t){case d.Constants.FLOATING_TOP:case d.Constants.FLOATING_BOTTOM:return this.getFloatingRowIndex(e,t);default:return this.getBodyRowIndex(e)}},e.prototype.getBodyRowIndex=function(e){var t=this.gridPanel.getBodyViewportClientRect(),o=this.gridPanel.getVerticalScrollPosition(),i=e.clientY-t.top+o,n=this.rowModel.getRowIndexAtPixel(i);return n},e.prototype.getContainer=function(e){var t=this.gridPanel.getBodyViewportClientRect(),o=e.clientX;return o<t.left&&this.columnController.isPinningLeft()?p.Column.PINNED_LEFT:o>t.right&&this.columnController.isPinningRight()?p.Column.PINNED_RIGHT:null},e.prototype.getColumn=function(e){if(this.columnController.isEmpty())return null;var t,o=this.getContainer(e),i=this.getColumnsForContainer(o),n=this.getXForContainer(o,e);return n<0&&(t=i[0]),i.forEach(function(e){var o=n>=e.getLeft(),i=n<=e.getRight();o&&i&&(t=e)}),t||(t=i[i.length-1]),t},e.prototype.getColumnsForContainer=function(e){switch(e){case p.Column.PINNED_LEFT:return this.columnController.getDisplayedLeftColumns();case p.Column.PINNED_RIGHT:return this.columnController.getDisplayedRightColumns();default:return this.columnController.getDisplayedCenterColumns()}},e.prototype.getXForContainer=function(e,t){var o;switch(e){case p.Column.PINNED_LEFT:o=this.gridPanel.getPinnedLeftColsViewportClientRect().left;break;case p.Column.PINNED_RIGHT:o=this.gridPanel.getPinnedRightColsViewportClientRect().left;break;default:var i=this.gridPanel.getBodyViewportClientRect(),n=this.gridPanel.getHorizontalScrollPosition();o=i.left-n}var r=t.clientX-o;return r},i([s.Autowired("gridPanel"),n("design:type",l.GridPanel)],e.prototype,"gridPanel",void 0),i([s.Autowired("columnController"),n("design:type",a.ColumnController)],e.prototype,"columnController",void 0),i([s.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),i([s.Autowired("floatingRowModel"),n("design:type",u.FloatingRowModel)],e.prototype,"floatingRowModel",void 0),i([s.Autowired("gridOptionsWrapper"),n("design:type",g.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),e=i([r.Bean("mouseEventService"),n("design:paramtypes",[])],e)}();t.MouseEventService=f},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(7),n=o(34),r=function(){function e(e,t,o){this.rowIndex=e,this.column=o,this.floating=i.Utils.makeNull(t)}return e.prototype.getGridRow=function(){return new n.GridRow(this.rowIndex,this.floating)},e.prototype.toString=function(){return"rowIndex = "+this.rowIndex+", floating = "+this.floating+", column = "+(this.column?this.column.getId():null)},e.prototype.createId=function(){return this.rowIndex+"."+this.floating+"."+this.column.getId()},e}();t.GridCell=r},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(8),n=o(7),r=o(33),s=function(){function e(e,t){this.rowIndex=e,this.floating=n.Utils.makeNull(t)}return e.prototype.isFloatingTop=function(){return this.floating===i.Constants.FLOATING_TOP},e.prototype.isFloatingBottom=function(){return this.floating===i.Constants.FLOATING_BOTTOM},e.prototype.isNotFloating=function(){return!this.isFloatingBottom()&&!this.isFloatingTop()},e.prototype.equals=function(e){return this.rowIndex===e.rowIndex&&this.floating===e.floating},e.prototype.toString=function(){return"rowIndex = "+this.rowIndex+", floating = "+this.floating},e.prototype.getGridCell=function(e){return new r.GridCell(this.rowIndex,this.floating,e)},e.prototype.before=function(e){var t=e.floating;switch(this.floating){case i.Constants.FLOATING_TOP:if(t!==i.Constants.FLOATING_TOP)return!0;break;case i.Constants.FLOATING_BOTTOM:if(t!==i.Constants.FLOATING_BOTTOM)return!1;break;default:if(n.Utils.exists(t))return t!==i.Constants.FLOATING_TOP}return this.rowIndex<=e.rowIndex},e}();t.GridRow=s},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(4),l=o(10),a=o(3),p=o(13),d=o(7),u=o(33),c=o(8),h=function(){function e(){}return e.prototype.init=function(){this.eventService.addEventListener(l.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,this.clearFocusedCell.bind(this)),this.eventService.addEventListener(l.Events.EVENT_COLUMN_EVERYTHING_CHANGED,this.clearFocusedCell.bind(this)),this.eventService.addEventListener(l.Events.EVENT_COLUMN_GROUP_OPENED,this.clearFocusedCell.bind(this)),this.eventService.addEventListener(l.Events.EVENT_COLUMN_MOVED,this.clearFocusedCell.bind(this)),this.eventService.addEventListener(l.Events.EVENT_COLUMN_PINNED,this.clearFocusedCell.bind(this)),this.eventService.addEventListener(l.Events.EVENT_COLUMN_ROW_GROUP_CHANGED,this.clearFocusedCell.bind(this)),this.eventService.addEventListener(l.Events.EVENT_COLUMN_VISIBLE,this.clearFocusedCell.bind(this))},e.prototype.clearFocusedCell=function(){this.focusedCell=null,this.onCellFocused(!1)},e.prototype.getFocusedCell=function(){return this.focusedCell},e.prototype.getFocusCellToUseAfterRefresh=function(){if(this.gridOptionsWrapper.isSuppressFocusAfterRefresh())return null;if(!this.focusedCell)return null;var e=this.getGridCellForDomElement(document.activeElement);if(!e)return null;var t=this.focusedCell.createId(),o=e.createId();return t===o?this.focusedCell:null},e.prototype.getGridCellForDomElement=function(e){function t(e){var t=d.Utils.getElementAttribute(e,"row");d.Utils.exists(t)&&d.Utils.containsClass(e,"ag-row")&&(0===t.indexOf("ft")?(r=c.Constants.FLOATING_TOP,t=t.substr(3)):0===t.indexOf("fb")?(r=c.Constants.FLOATING_BOTTOM,t=t.substr(3)):r=null,n=parseInt(t))}function o(e){var t=d.Utils.getElementAttribute(e,"colid");if(d.Utils.exists(t)&&d.Utils.containsClass(e,"ag-cell")){var o=s.columnController.getGridColumn(t);o&&(i=o)}}if(!e)return null;for(var i=null,n=null,r=null,s=this;e;)t(e),o(e),e=e.parentNode;if(d.Utils.exists(i)&&d.Utils.exists(n)){var l=new u.GridCell(n,r,i);return l}return null},e.prototype.setFocusedCell=function(e,t,o,i){if(void 0===i&&(i=!1),!this.gridOptionsWrapper.isSuppressCellSelection()){var n=d.Utils.makeNull(this.columnController.getGridColumn(t));this.focusedCell=new u.GridCell(e,d.Utils.makeNull(o),n),this.onCellFocused(i)}},e.prototype.isCellFocused=function(e){return!d.Utils.missing(this.focusedCell)&&(this.focusedCell.column===e.column&&this.isRowFocused(e.rowIndex,e.floating))},e.prototype.isRowFocused=function(e,t){if(d.Utils.missing(this.focusedCell))return!1;var o=d.Utils.makeNull(t);return this.focusedCell.rowIndex===e&&this.focusedCell.floating===o},e.prototype.onCellFocused=function(e){var t={rowIndex:null,column:null,floating:null,forceBrowserFocus:e};this.focusedCell&&(t.rowIndex=this.focusedCell.rowIndex,t.column=this.focusedCell.column,t.floating=this.focusedCell.floating),this.eventService.dispatchEvent(l.Events.EVENT_CELL_FOCUSED,t)},i([r.Autowired("eventService"),n("design:type",s.EventService)],e.prototype,"eventService",void 0),i([r.Autowired("gridOptionsWrapper"),n("design:type",a.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([r.Autowired("columnController"),n("design:type",p.ColumnController)],e.prototype,"columnController",void 0),i([r.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e=i([r.Bean("focusedCellController"),n("design:paramtypes",[])],e)}();t.FocusedCellController=h},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(6),l=function(){function e(){this.templateCache={},this.waitingCallbacks={}}return e.prototype.getTemplate=function(e,t){var o=this.templateCache[e];if(o)return o;var i=this.waitingCallbacks[e],n=this;if(!i){i=[],this.waitingCallbacks[e]=i;var r=new XMLHttpRequest;r.onload=function(){n.handleHttpResult(this,e)},r.open("GET",e),r.send()}return t&&i.push(t),null},e.prototype.handleHttpResult=function(e,t){if(200!==e.status||null===e.response)return void console.warn("Unable to get template error "+e.status+" - "+t);this.templateCache[t]=e.response||e.responseText;for(var o=this.waitingCallbacks[t],i=0;i<o.length;i++){var n=o[i];n()}if(this.$scope){var r=this;setTimeout(function(){r.$scope.$apply()},0)}},i([s.Autowired("$scope"),n("design:type",Object)],e.prototype,"$scope",void 0),e=i([r.Bean("templateService"),n("design:paramtypes",[])],e)}();t.TemplateService=l},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(38),l=o(27),a=o(3),p=o(13),d=o(15),u=o(10),c=o(4),h=o(6),g=o(35),f=o(8),y=o(59),v=o(54),C=o(24),m=function(){function e(e,t,o,i,n,r,s,l){this.eAllRowContainers=[],this.renderedCells={},this.destroyFunctions=[],this.initialised=!1,this.parentScope=e,this.rowRenderer=t,this.eBodyContainer=o,this.eFullWidthContainer=i,this.ePinnedLeftContainer=n,this.ePinnedRightContainer=r,this.rowIndex=l,this.rowNode=s}return e.prototype.setupRowContainers=function(){var e=this.gridOptionsWrapper.getIsFullWidthCellFunc(),t=!!e&&e(this.rowNode),o=this.rowNode.group&&this.gridOptionsWrapper.isGroupUseEntireRow();t?this.setupFullWidthContainers():o?this.setupFullWidthGroupContainers():this.setupNormalContainers()},e.prototype.setupFullWidthContainers=function(){this.fullWidthRow=!0,this.fullWidthCellRenderer=this.gridOptionsWrapper.getFullWidthCellRenderer(),this.fullWidthCellRendererParams=this.gridOptionsWrapper.getFullWidthCellRendererParams(),r.Utils.missing(this.fullWidthCellRenderer)&&console.warn("ag-Grid: you need to provide a fullWidthCellRenderer if using isFullWidthCell()"),this.eFullWidthRow=this.createRowContainer(this.eFullWidthContainer),this.gridOptionsWrapper.isForPrint()||this.addMouseWheelListenerToFullWidthRow()},e.prototype.addMouseWheelListenerToFullWidthRow=function(){var e=this,t=this.gridPanel.genericMouseWheelListener.bind(this.gridPanel);this.eFullWidthRow.addEventListener("mousewheel",t),this.eFullWidthRow.addEventListener("DOMMouseScroll",t),this.destroyFunctions.push(function(){e.eFullWidthRow.removeEventListener("mousewheel",t),e.eFullWidthRow.removeEventListener("DOMMouseScroll",t)})},e.prototype.setupFullWidthGroupContainers=function(){this.fullWidthRow=!0,this.fullWidthCellRenderer=this.gridOptionsWrapper.getGroupRowRenderer(),this.fullWidthCellRendererParams=this.gridOptionsWrapper.getGroupRowRendererParams(),this.fullWidthCellRenderer||(this.fullWidthCellRenderer=v.CellRendererFactory.GROUP,this.fullWidthCellRendererParams={innerRenderer:this.gridOptionsWrapper.getGroupRowInnerRenderer()}),this.eFullWidthRow=this.createRowContainer(this.eFullWidthContainer)},e.prototype.setupNormalContainers=function(){this.fullWidthRow=!1,this.eBodyRow=this.createRowContainer(this.eBodyContainer),this.gridOptionsWrapper.isForPrint()||(this.ePinnedLeftRow=this.createRowContainer(this.ePinnedLeftContainer),this.ePinnedRightRow=this.createRowContainer(this.ePinnedRightContainer))},e.prototype.init=function(){this.setupRowContainers(),this.scope=this.createChildScopeOrNull(this.rowNode.data),this.fullWidthRow?this.refreshFullWidthComponent():this.refreshCellsIntoRow(),this.addGridClasses(),this.addStyleFromRowStyle(),this.addStyleFromRowStyleFunc(),this.addClassesFromRowClass(),this.addClassesFromRowClassFunc(),this.addRowIds(),this.setTopAndHeightCss(),this.addRowSelectedListener(),this.addCellFocusedListener(),this.addNodeDataChangedListener(),this.addColumnListener(),this.addHoverFunctionality(),this.gridOptionsWrapper.executeProcessRowPostCreateFunc({eRow:this.eBodyRow,ePinnedLeftRow:this.ePinnedLeftRow,ePinnedRightRow:this.ePinnedRightRow,node:this.rowNode,api:this.gridOptionsWrapper.getApi(),rowIndex:this.rowIndex,addRenderedRowListener:this.addEventListener.bind(this),columnApi:this.gridOptionsWrapper.getColumnApi(),context:this.gridOptionsWrapper.getContext()}),this.addDataChangedListener(),this.initialised=!0},e.prototype.addDataChangedListener=function(){var e=this,t=function(){e.addStyleFromRowStyleFunc(),e.addClassesFromRowClass()};this.rowNode.addEventListener(l.RowNode.EVENT_DATA_CHANGED,t),this.destroyFunctions.push(function(){return e.rowNode.removeEventListener(l.RowNode.EVENT_DATA_CHANGED,t)})},e.prototype.angular1Compile=function(e){this.scope&&this.$compile(e)(this.scope)},e.prototype.addColumnListener=function(){var e=this,t=this.onDisplayedColumnsChanged.bind(this),o=this.onVirtualColumnsChanged.bind(this),i=this.onGridColumnsChanged.bind(this);this.mainEventService.addEventListener(u.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,t),this.mainEventService.addEventListener(u.Events.EVENT_VIRTUAL_COLUMNS_CHANGED,o),this.mainEventService.addEventListener(u.Events.EVENT_COLUMN_RESIZED,t),this.mainEventService.addEventListener(u.Events.EVENT_GRID_COLUMNS_CHANGED,i),this.destroyFunctions.push(function(){e.mainEventService.removeEventListener(u.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,t),e.mainEventService.removeEventListener(u.Events.EVENT_VIRTUAL_COLUMNS_CHANGED,o),e.mainEventService.removeEventListener(u.Events.EVENT_COLUMN_RESIZED,t),e.mainEventService.removeEventListener(u.Events.EVENT_GRID_COLUMNS_CHANGED,i)})},e.prototype.onDisplayedColumnsChanged=function(e){if(this.fullWidthRow){var t=e.getType()===u.Events.EVENT_COLUMN_PINNED;t&&this.refreshFullWidthComponent()}else this.refreshCellsIntoRow()},e.prototype.onVirtualColumnsChanged=function(e){this.fullWidthRow||this.refreshCellsIntoRow()},e.prototype.onGridColumnsChanged=function(){var e=Object.keys(this.renderedCells);this.removeRenderedCells(e)},e.prototype.refreshCellsIntoRow=function(){var e=this,t=this.columnController.getAllDisplayedVirtualColumns(),o=Object.keys(this.renderedCells);t.forEach(function(t){var i=e.getOrCreateCell(t);e.ensureCellInCorrectRow(i),r.Utils.removeFromArray(o,t.getColId())}),this.removeRenderedCells(o)},e.prototype.removeRenderedCells=function(e){var t=this;e.forEach(function(e){var o=t.renderedCells[e];r.Utils.missing(o)||(o.getParentRow()&&(o.getParentRow().removeChild(o.getGui()),o.setParentRow(null)),o.destroy(),t.renderedCells[e]=null)})},e.prototype.ensureCellInCorrectRow=function(e){var t,o=e.getGui(),i=e.getColumn();switch(i.getPinned()){case d.Column.PINNED_LEFT:t=this.ePinnedLeftRow;break;case d.Column.PINNED_RIGHT:t=this.ePinnedRightRow;break;default:t=this.eBodyRow}var n=e.getParentRow(),r=n!==t;r&&(n&&n.removeChild(o),t.appendChild(o),e.setParentRow(t))},e.prototype.getOrCreateCell=function(e){var t=e.getColId();if(this.renderedCells[t])return this.renderedCells[t];var o=new s.RenderedCell(e,this.rowNode,this.rowIndex,this.scope,this);return this.context.wireBean(o),this.renderedCells[t]=o,this.angular1Compile(o.getGui()),o},e.prototype.onRowSelected=function(){var e=this.rowNode.isSelected();this.eAllRowContainers.forEach(function(t){return r.Utils.addOrRemoveCssClass(t,"ag-row-selected",e)})},e.prototype.addRowSelectedListener=function(){var e=this,t=this.onRowSelected.bind(this);this.rowNode.addEventListener(l.RowNode.EVENT_ROW_SELECTED,t),this.destroyFunctions.push(function(){e.rowNode.removeEventListener(l.RowNode.EVENT_ROW_SELECTED,t)})},e.prototype.addHoverFunctionality=function(){var e=this,t=this.rowNode.onMouseEnter.bind(this.rowNode),o=this.rowNode.onMouseLeave.bind(this.rowNode);this.eAllRowContainers.forEach(function(e){e.addEventListener("mouseenter",t),e.addEventListener("mouseleave",o)});var i=this.addHoverClass.bind(this,!0),n=this.addHoverClass.bind(this,!1);this.rowNode.addEventListener(l.RowNode.EVENT_MOUSE_ENTER,i),this.rowNode.addEventListener(l.RowNode.EVENT_MOUSE_LEAVE,n),this.destroyFunctions.push(function(){e.eAllRowContainers.forEach(function(e){e.removeEventListener("mouseenter",t),e.removeEventListener("mouseleave",o)}),e.rowNode.removeEventListener(l.RowNode.EVENT_MOUSE_ENTER,i),e.rowNode.removeEventListener(l.RowNode.EVENT_MOUSE_LEAVE,n)})},e.prototype.addHoverClass=function(e){this.eAllRowContainers.forEach(function(t){return r.Utils.addOrRemoveCssClass(t,"ag-row-hover",e)})},e.prototype.addCellFocusedListener=function(){var e=this,t=null,o=function(){var o=e.focusedCellController.isRowFocused(e.rowIndex,e.rowNode.floating);o!==t&&(e.eAllRowContainers.forEach(function(e){return r.Utils.addOrRemoveCssClass(e,"ag-row-focus",o)}),e.eAllRowContainers.forEach(function(e){return r.Utils.addOrRemoveCssClass(e,"ag-row-no-focus",!o)}),t=o)};this.mainEventService.addEventListener(u.Events.EVENT_CELL_FOCUSED,o),this.destroyFunctions.push(function(){e.mainEventService.removeEventListener(u.Events.EVENT_CELL_FOCUSED,o)}),o()},e.prototype.forEachRenderedCell=function(e){r.Utils.iterateObject(this.renderedCells,function(t,o){o&&e(o)})},e.prototype.addNodeDataChangedListener=function(){var e=this,t=function(){var t=!1,o=!0;e.forEachRenderedCell(function(e){return e.refreshCell(t,o)}),e.onRowSelected()};this.rowNode.addEventListener(l.RowNode.EVENT_DATA_CHANGED,t),this.destroyFunctions.push(function(){e.rowNode.removeEventListener(l.RowNode.EVENT_DATA_CHANGED,t)})},e.prototype.onMouseEvent=function(e,t,o){var i=this.renderedCells[o.column.getId()];i&&i.onMouseEvent(e,t)},e.prototype.setTopAndHeightCss=function(){if(!this.gridOptionsWrapper.isForPrint()){var e=this.rowNode.rowTop+"px";this.eAllRowContainers.forEach(function(t){return t.style.top=e})}var t=this.rowNode.rowHeight+"px";this.eAllRowContainers.forEach(function(e){return e.style.height=t})},e.prototype.addRowIds=function(){var e=this.rowIndex.toString();if(this.rowNode.floating===f.Constants.FLOATING_BOTTOM?e="fb-"+e:this.rowNode.floating===f.Constants.FLOATING_TOP&&(e="ft-"+e),this.eAllRowContainers.forEach(function(t){return t.setAttribute("row",e)}),"function"==typeof this.gridOptionsWrapper.getBusinessKeyForNodeFunc()){var t=this.gridOptionsWrapper.getBusinessKeyForNodeFunc()(this.rowNode);"string"!=typeof t&&"number"!=typeof t||this.eAllRowContainers.forEach(function(e){return e.setAttribute("row-id",t)})}},e.prototype.addEventListener=function(e,t){this.renderedRowEventService||(this.renderedRowEventService=new c.EventService),this.renderedRowEventService.addEventListener(e,t)},e.prototype.removeEventListener=function(e,t){this.renderedRowEventService.removeEventListener(e,t)},e.prototype.getRenderedCellForColumn=function(e){return this.renderedCells[e.getColId()]},e.prototype.getCellForCol=function(e){var t=this.renderedCells[e.getColId()];return t?t.getGui():null},e.prototype.destroy=function(){this.destroyScope(),this.destroyFullWidthComponent(),this.forEachRenderedCell(function(e){return e.destroy()}),this.destroyFunctions.forEach(function(e){return e()}),this.renderedRowEventService&&this.renderedRowEventService.dispatchEvent(e.EVENT_RENDERED_ROW_REMOVED,{node:this.rowNode})},e.prototype.destroyScope=function(){this.scope&&(this.scope.$destroy(),this.scope=null)},e.prototype.isDataInList=function(e){return e.indexOf(this.rowNode.data)>=0},e.prototype.isGroup=function(){return this.rowNode.group===!0},e.prototype.refreshFullWidthComponent=function(){this.destroyFullWidthComponent(),this.createFullWidthComponent()},e.prototype.createFullWidthComponent=function(){var e=this.createFullWidthParams(this.eFullWidthRow);this.fullWidthRowComponent=this.cellRendererService.useCellRenderer(this.fullWidthCellRenderer,this.eFullWidthRow,e),this.angular1Compile(this.eFullWidthRow)},e.prototype.destroyFullWidthComponent=function(){this.fullWidthRowComponent&&this.fullWidthRowComponent.destroy&&(this.fullWidthRowComponent.destroy(),this.fullWidthRowComponent=null),r.Utils.removeAllChildren(this.eFullWidthRow)},e.prototype.createFullWidthParams=function(e){var t={data:this.rowNode.data,node:this.rowNode,$scope:this.scope,rowIndex:this.rowIndex,api:this.gridOptionsWrapper.getApi(),columnApi:this.gridOptionsWrapper.getColumnApi(),context:this.gridOptionsWrapper.getContext(),eGridCell:e,eParentOfValue:e,addRenderedRowListener:this.addEventListener.bind(this),colDef:{cellRenderer:this.fullWidthCellRenderer,cellRendererParams:this.fullWidthCellRendererParams}};return this.fullWidthCellRendererParams&&r.Utils.assign(t,this.fullWidthCellRendererParams),t},e.prototype.createGroupSpanningEntireRowCell=function(e){var t=document.createElement("span");if(!e){var o=this.createFullWidthParams(t),i=this.cellRendererService.useCellRenderer(this.fullWidthCellRenderer,t,o);i&&i.destroy&&this.destroyFunctions.push(function(){return i.destroy()})}return this.rowNode.footer?r.Utils.addCssClass(t,"ag-footer-cell-entire-row"):r.Utils.addCssClass(t,"ag-group-cell-entire-row"),t},e.prototype.createChildScopeOrNull=function(e){if(this.gridOptionsWrapper.isAngularCompileRows()){var t=this.parentScope.$new();return t.data=e,t.rowNode=this.rowNode,t.context=this.gridOptionsWrapper.getContext(),t}return null},e.prototype.addStyleFromRowStyle=function(){var e=this.gridOptionsWrapper.getRowStyle();e&&("function"==typeof e?console.log("ag-Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead"):this.eAllRowContainers.forEach(function(t){return r.Utils.addStylesToElement(t,e)}))},e.prototype.addStyleFromRowStyleFunc=function(){var e=this.gridOptionsWrapper.getRowStyleFunc();if(e){var t={data:this.rowNode.data,node:this.rowNode,api:this.gridOptionsWrapper.getApi(),context:this.gridOptionsWrapper.getContext(),$scope:this.scope},o=e(t);this.eAllRowContainers.forEach(function(e){return r.Utils.addStylesToElement(e,o)})}},e.prototype.createParams=function(){var e={node:this.rowNode,data:this.rowNode.data,rowIndex:this.rowIndex,$scope:this.scope,context:this.gridOptionsWrapper.getContext(),api:this.gridOptionsWrapper.getApi()};return e},e.prototype.createEvent=function(e,t){var o=this.createParams();return o.event=e,o.eventSource=t,o},e.prototype.createRowContainer=function(e){var t=document.createElement("div"),o=this.onRowClick.bind(this),i=this.onRowDblClick.bind(this);return t.addEventListener("click",o),t.addEventListener("dblclick",i),e.appendChild(t),this.eAllRowContainers.push(t),this.destroyFunctions.push(function(){t.removeEventListener("click",o),t.removeEventListener("dblclick",i),e.removeChild(t)}),t},e.prototype.onRowDblClick=function(e){var t=this.createEvent(e,this);this.mainEventService.dispatchEvent(u.Events.EVENT_ROW_DOUBLE_CLICKED,t)},e.prototype.onRowClick=function(e){var t=this.createEvent(e,this);this.mainEventService.dispatchEvent(u.Events.EVENT_ROW_CLICKED,t);var o=e.ctrlKey||e.metaKey,i=e.shiftKey;if(!this.rowNode.group&&!this.rowNode.floating){var n=this.gridOptionsWrapper;n.isRowSelection()&&(n.isSuppressRowClickSelection()||(this.rowNode.isSelected()?o?n.isRowDeselection()&&this.rowNode.setSelectedParams({newValue:!1}):this.rowNode.setSelectedParams({newValue:!0,clearSelection:!0}):this.rowNode.setSelectedParams({newValue:!0,clearSelection:!o,rangeSelect:i})))}},e.prototype.getRowNode=function(){return this.rowNode},e.prototype.refreshCells=function(e,t){if(e){var o=this.columnController.getGridColumns(e);this.forEachRenderedCell(function(e){var i=e.getColumn();o.indexOf(i)>=0&&e.refreshCell(t)})}},e.prototype.addClassesFromRowClassFunc=function(){var e=this,t=[],o=this.gridOptionsWrapper.getRowClassFunc();if(o){var i={node:this.rowNode,data:this.rowNode.data,rowIndex:this.rowIndex,context:this.gridOptionsWrapper.getContext(),api:this.gridOptionsWrapper.getApi()},n=o(i);n&&("string"==typeof n?t.push(n):Array.isArray(n)&&n.forEach(function(e){t.push(e)}))}t.forEach(function(t){e.eAllRowContainers.forEach(function(e){return r.Utils.addCssClass(e,t)})})},e.prototype.addGridClasses=function(){var e=this,t=[];t.push("ag-row"),t.push("ag-row-no-focus"),t.push(this.rowIndex%2==0?"ag-row-even":"ag-row-odd"),this.rowNode.isSelected()&&t.push("ag-row-selected"),this.rowNode.group?(t.push("ag-row-group"),t.push("ag-row-level-"+this.rowNode.level),!this.rowNode.footer&&this.rowNode.expanded&&t.push("ag-row-group-expanded"),this.rowNode.footer||this.rowNode.expanded||t.push("ag-row-group-contracted"),this.rowNode.footer&&t.push("ag-row-footer")):this.rowNode.parent?t.push("ag-row-level-"+(this.rowNode.parent.level+1)):t.push("ag-row-level-0"),this.fullWidthRow&&t.push("ag-full-width-row"),t.forEach(function(t){e.eAllRowContainers.forEach(function(e){return r.Utils.addCssClass(e,t)})})},e.prototype.addClassesFromRowClass=function(){var e=this,t=[],o=this.gridOptionsWrapper.getRowClass();o&&("function"==typeof o?console.warn("ag-Grid: rowClass should not be a function, please use getRowClass instead"):"string"==typeof o?t.push(o):Array.isArray(o)&&o.forEach(function(e){t.push(e)})),t.forEach(function(t){e.eAllRowContainers.forEach(function(e){return r.Utils.addCssClass(e,t)})})},e.EVENT_RENDERED_ROW_REMOVED="renderedRowRemoved",i([h.Autowired("gridOptionsWrapper"),n("design:type",a.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([h.Autowired("columnController"),n("design:type",p.ColumnController)],e.prototype,"columnController",void 0),i([h.Autowired("$compile"),n("design:type",Object)],e.prototype,"$compile",void 0),i([h.Autowired("eventService"),n("design:type",c.EventService)],e.prototype,"mainEventService",void 0),i([h.Autowired("context"),n("design:type",h.Context)],e.prototype,"context",void 0),i([h.Autowired("focusedCellController"),n("design:type",g.FocusedCellController)],e.prototype,"focusedCellController",void 0),i([h.Autowired("cellRendererService"),n("design:type",y.CellRendererService)],e.prototype,"cellRendererService",void 0),i([h.Autowired("gridPanel"),n("design:type",C.GridPanel)],e.prototype,"gridPanel",void 0),i([h.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e}();t.RenderedRow=m},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},r=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},s=o(7),l=o(15),a=o(27),p=o(3),d=o(18),u=o(23),c=o(36),h=o(13),g=o(29),f=o(4),y=o(8),v=o(10),C=o(6),m=o(11),E=o(35),A=o(33),w=o(39),R=o(48),S=o(47),O=o(44),N=o(54),T=o(59),D=o(60),G=o(61),P=o(62),b=function(e){function t(t,o,i,n,r){e.call(this,"<div/>"),this.firstRightPinned=!1,this.lastLeftPinned=!1,this.eGridCell=this.getGui(),this.column=t,this.node=o,this.rowIndex=i,this.scope=n,this.renderedRow=r,this.gridCell=new A.GridCell(i,o.floating,t)}return i(t,e),t.prototype.destroy=function(){e.prototype.destroy.call(this),this.cellEditor&&this.cellEditor.destroy&&this.cellEditor.destroy(),this.cellRenderer&&this.cellRenderer.destroy&&this.cellRenderer.destroy()},t.prototype.setPinnedClasses=function(){var e=this,t=function(){e.firstRightPinned!==e.column.isFirstRightPinned()&&(e.firstRightPinned=e.column.isFirstRightPinned(),s.Utils.addOrRemoveCssClass(e.eGridCell,"ag-cell-first-right-pinned",e.firstRightPinned)),e.lastLeftPinned!==e.column.isLastLeftPinned()&&(e.lastLeftPinned=e.column.isLastLeftPinned(),s.Utils.addOrRemoveCssClass(e.eGridCell,"ag-cell-last-left-pinned",e.lastLeftPinned))};this.column.addEventListener(l.Column.EVENT_FIRST_RIGHT_PINNED_CHANGED,t),this.column.addEventListener(l.Column.EVENT_LAST_LEFT_PINNED_CHANGED,t),this.addDestroyFunc(function(){e.column.removeEventListener(l.Column.EVENT_FIRST_RIGHT_PINNED_CHANGED,t),e.column.removeEventListener(l.Column.EVENT_LAST_LEFT_PINNED_CHANGED,t)}),t()},t.prototype.getParentRow=function(){return this.eParentRow},t.prototype.setParentRow=function(e){this.eParentRow=e},t.prototype.calculateCheckboxSelection=function(){if(this.node.floating)return!1;var e=this.column.getColDef();if("boolean"==typeof e.checkboxSelection)return e.checkboxSelection;var t;if("function"==typeof e.checkboxSelection&&(t=e.checkboxSelection),!t&&this.gridOptionsWrapper.getCheckboxSelection()&&(t=this.gridOptionsWrapper.getCheckboxSelection()),t){var o=this.createParams();return t(o)}return!1},t.prototype.getColumn=function(){return this.column},t.prototype.getValue=function(){var e=this.getDataForRow();return this.valueService.getValueUsingSpecificData(this.column,e,this.node)},t.prototype.getDataForRow=function(){if(this.node.footer)return this.node.data;if(this.node.group){var e=this.gridOptionsWrapper.isGroupIncludeFooter(),t=this.gridOptionsWrapper.isGroupSuppressBlankHeader();return this.node.expanded&&e&&!t?void 0:this.node.data}return this.node.data},t.prototype.addRangeSelectedListener=function(){var e=this;if(this.rangeController){var t=0,o=function(){var o=e.rangeController.getCellRangeCount(e.gridCell);t!==o&&(s.Utils.addOrRemoveCssClass(e.eGridCell,"ag-cell-range-selected",0!==o),s.Utils.addOrRemoveCssClass(e.eGridCell,"ag-cell-range-selected-1",1===o),s.Utils.addOrRemoveCssClass(e.eGridCell,"ag-cell-range-selected-2",2===o),s.Utils.addOrRemoveCssClass(e.eGridCell,"ag-cell-range-selected-3",3===o),s.Utils.addOrRemoveCssClass(e.eGridCell,"ag-cell-range-selected-4",o>=4),t=o)};this.eventService.addEventListener(v.Events.EVENT_RANGE_SELECTION_CHANGED,o),this.addDestroyFunc(function(){e.eventService.removeEventListener(v.Events.EVENT_RANGE_SELECTION_CHANGED,o)}),o()}},t.prototype.addHighlightListener=function(){var e=this;if(this.rangeController){var t=function(t){var o=e.gridCell.createId(),i=t.cells[o];i&&e.animateCellWithHighlight()};this.eventService.addEventListener(v.Events.EVENT_FLASH_CELLS,t),this.addDestroyFunc(function(){e.eventService.removeEventListener(v.Events.EVENT_FLASH_CELLS,t)})}},t.prototype.addChangeListener=function(){var e=this,t=function(t){t.column===e.column&&(e.refreshCell(),e.animateCellWithDataChanged())};this.addDestroyableEventListener(this.node,a.RowNode.EVENT_CELL_CHANGED,t)},t.prototype.animateCellWithDataChanged=function(){(this.gridOptionsWrapper.isEnableCellChangeFlash()||this.column.getColDef().enableCellChangeFlash)&&this.animateCell("data-changed")},t.prototype.animateCellWithHighlight=function(){this.animateCell("highlight")},t.prototype.animateCell=function(e){var t=this,o="ag-cell-"+e,i="ag-cell-"+e+"-animation";s.Utils.addCssClass(this.eGridCell,o),s.Utils.removeCssClass(this.eGridCell,i),setTimeout(function(){s.Utils.removeCssClass(t.eGridCell,o),s.Utils.addCssClass(t.eGridCell,i),setTimeout(function(){s.Utils.removeCssClass(t.eGridCell,i)},1e3)},500)},t.prototype.addCellFocusedListener=function(){var e=this,t=null,o=function(o){var i=e.focusedCellController.isCellFocused(e.gridCell);i!==t&&(s.Utils.addOrRemoveCssClass(e.eGridCell,"ag-cell-focus",i),s.Utils.addOrRemoveCssClass(e.eGridCell,"ag-cell-no-focus",!i),t=i),i&&o&&o.forceBrowserFocus&&e.eGridCell.focus(),e.editingCell&&!i&&e.stopEditing()};this.eventService.addEventListener(v.Events.EVENT_CELL_FOCUSED,o),this.addDestroyFunc(function(){e.eventService.removeEventListener(v.Events.EVENT_CELL_FOCUSED,o)}),o()},t.prototype.setWidthOnCell=function(){var e=this,t=function(){e.eGridCell.style.width=e.column.getActualWidth()+"px"};this.column.addEventListener(l.Column.EVENT_WIDTH_CHANGED,t),this.addDestroyFunc(function(){e.column.removeEventListener(l.Column.EVENT_WIDTH_CHANGED,t)}),t()},t.prototype.init=function(){this.value=this.getValue(),this.checkboxSelection=this.calculateCheckboxSelection(),this.setWidthOnCell(),this.setPinnedClasses(),this.addRangeSelectedListener(),this.addHighlightListener(),this.addChangeListener(),this.addCellFocusedListener(),this.addKeyDownListener(),this.addKeyPressListener();var e=new P.SetLeftFeature(this.column,this.eGridCell);this.addDestroyFunc(e.destroy.bind(e)),this.gridOptionsWrapper.isSuppressCellSelection()||this.eGridCell.setAttribute("tabindex","-1"),this.addClasses(),this.setInlineEditingClass(),this.createParentOfValue(),this.populateCell()},t.prototype.onEnterKeyDown=function(){this.editingCell?(this.stopEditing(),this.focusCell(!0)):this.startEditingIfEnabled(y.Constants.KEY_ENTER)},t.prototype.onF2KeyDown=function(){this.editingCell||this.startEditingIfEnabled(y.Constants.KEY_F2)},t.prototype.onEscapeKeyDown=function(){this.editingCell&&(this.stopEditing(!0),this.focusCell(!0))},t.prototype.onPopupEditorClosed=function(){this.editingCell&&(this.stopEditing(!0),this.focusedCellController.isCellFocused(this.gridCell)&&this.focusCell(!0))},t.prototype.onTabKeyDown=function(e){var t;this.editingCell?(this.stopEditing(),t=!0):t=!1;var o=this.rowRenderer.moveFocusToNextCell(this.rowIndex,this.column,this.node.floating,e.shiftKey,t);o&&e.preventDefault()},t.prototype.onBackspaceOrDeleteKeyPressed=function(e){this.editingCell||this.startEditingIfEnabled(e)},t.prototype.onSpaceKeyPressed=function(e){if(!this.editingCell&&this.gridOptionsWrapper.isRowSelection()){var t=this.node.isSelected();this.node.setSelected(!t)}e.preventDefault()},t.prototype.onNavigationKeyPressed=function(e,t){this.editingCell&&this.stopEditing(),this.rowRenderer.navigateToNextCell(t,this.rowIndex,this.column,this.node.floating),e.preventDefault()},t.prototype.addKeyPressListener=function(){var e=this,o=function(o){var i=s.Utils.getTarget(o),n=i!==e.getGui();if(!n&&!e.editingCell){var r=String.fromCharCode(o.charCode);" "===r?e.onSpaceKeyPressed(o):t.PRINTABLE_CHARACTERS.indexOf(r)>=0&&(e.startEditingIfEnabled(null,r),o.preventDefault())}};this.eGridCell.addEventListener("keypress",o),this.addDestroyFunc(function(){e.eGridCell.removeEventListener("keypress",o)})},t.prototype.onKeyDown=function(e){var t=e.which||e.keyCode;switch(t){case y.Constants.KEY_ENTER:this.onEnterKeyDown();break;case y.Constants.KEY_F2:this.onF2KeyDown();break;case y.Constants.KEY_ESCAPE:this.onEscapeKeyDown();break;case y.Constants.KEY_TAB:this.onTabKeyDown(e);break;case y.Constants.KEY_BACKSPACE:case y.Constants.KEY_DELETE:this.onBackspaceOrDeleteKeyPressed(t);break;case y.Constants.KEY_DOWN:case y.Constants.KEY_UP:case y.Constants.KEY_RIGHT:case y.Constants.KEY_LEFT:this.onNavigationKeyPressed(e,t)}},t.prototype.addKeyDownListener=function(){var e=this,t=this.onKeyDown.bind(this);this.eGridCell.addEventListener("keydown",t),this.addDestroyFunc(function(){e.eGridCell.removeEventListener("keydown",t)})},t.prototype.createCellEditor=function(e,t){var o=this.column.getColDef(),i=this.cellEditorFactory.createCellEditor(o.cellEditor);if(i.init){var n={value:this.getValue(),keyPress:e,charPress:t,column:this.column,node:this.node,api:this.gridOptionsWrapper.getApi(),columnApi:this.gridOptionsWrapper.getColumnApi(),context:this.gridOptionsWrapper.getContext(),onKeyDown:this.onKeyDown.bind(this),stopEditing:this.stopEditingAndFocus.bind(this),eGridCell:this.eGridCell};o.cellEditorParams&&s.Utils.assign(n,o.cellEditorParams),i.init&&i.init(n)}return i},t.prototype.stopEditingAndFocus=function(){this.stopEditing(),this.focusCell(!0)},t.prototype.startEditingIfEnabled=function(e,t){if(this.isCellEditable()){var o=this.createCellEditor(e,t);if(o.isCancelBeforeStart&&o.isCancelBeforeStart())return void(o.destroy&&o.destroy());if(!o.getGui)return void console.warn("ag-Grid: cellEditor for column "+this.column.getId()+" is missing getGui() method");this.cellEditor=o,this.editingCell=!0,this.cellEditorInPopup=this.cellEditor.isPopup&&this.cellEditor.isPopup(),this.setInlineEditingClass(),this.cellEditorInPopup?this.addPopupCellEditor():this.addInCellEditor(),o.afterGuiAttached&&o.afterGuiAttached()}},t.prototype.addInCellEditor=function(){s.Utils.removeAllChildren(this.eGridCell),this.eGridCell.appendChild(this.cellEditor.getGui()),this.gridOptionsWrapper.isAngularCompileRows()&&this.$compile(this.eGridCell)(this.scope)},t.prototype.addPopupCellEditor=function(){var e=this,t=this.cellEditor.getGui();this.hideEditorPopup=this.popupService.addAsModalPopup(t,!0,function(){e.editingCell&&e.onPopupEditorClosed()}),this.popupService.positionPopupOverComponent({eventSource:this.eGridCell,ePopup:t,keepWithinBounds:!0}),this.gridOptionsWrapper.isAngularCompileRows()&&this.$compile(t)(this.scope)},t.prototype.focusCell=function(e){this.focusedCellController.setFocusedCell(this.rowIndex,this.column,this.node.floating,e)},t.prototype.stopEditing=function(e){if(void 0===e&&(e=!1),this.editingCell){this.editingCell=!1;var t=this.cellEditor.isCancelAfterEnd&&this.cellEditor.isCancelAfterEnd(),o=!e&&!t;if(o){var i=this.cellEditor.getValue();this.valueService.setValue(this.node,this.column,i),this.value=this.getValue()}this.cellEditor.destroy&&this.cellEditor.destroy(),this.cellEditorInPopup?(this.hideEditorPopup(),this.hideEditorPopup=null):(s.Utils.removeAllChildren(this.eGridCell),this.checkboxSelection?this.eGridCell.appendChild(this.eCellWrapper):this.cellRenderer&&this.eGridCell.appendChild(this.cellRenderer.getGui())),this.setInlineEditingClass(),this.refreshCell()}},t.prototype.createParams=function(){var e={node:this.node,data:this.node.data,value:this.value,rowIndex:this.rowIndex,colDef:this.column.getColDef(),$scope:this.scope,context:this.gridOptionsWrapper.getContext(),api:this.gridApi,columnApi:this.columnApi};return e},t.prototype.createEvent=function(e){var t=this.createParams();return t.event=e,t},t.prototype.isCellEditable=function(){return!this.editingCell&&(!this.node.group&&this.column.isCellEditable(this.node))},t.prototype.onMouseEvent=function(e,t){switch(e){case"click":this.onCellClicked(t);break;case"mousedown":this.onMouseDown();break;case"dblclick":this.onCellDoubleClicked(t);break;case"contextmenu":this.onContextMenu(t)}},t.prototype.onContextMenu=function(e){if(!e.ctrlKey&&!e.metaKey){var t=this.column.getColDef(),o=this.createEvent(e);this.eventService.dispatchEvent(v.Events.EVENT_CELL_CONTEXT_MENU,o),t.onCellContextMenu&&t.onCellContextMenu(o),this.contextMenuFactory&&!this.gridOptionsWrapper.isSuppressContextMenu()&&(this.contextMenuFactory.showMenu(this.node,this.column,this.value,e),e.preventDefault())}},t.prototype.onCellDoubleClicked=function(e){var t=this.column.getColDef(),o=this.createEvent(e);this.eventService.dispatchEvent(v.Events.EVENT_CELL_DOUBLE_CLICKED,o),"function"==typeof t.onCellDoubleClicked&&t.onCellDoubleClicked(o),this.gridOptionsWrapper.isSingleClickEdit()||this.startEditingIfEnabled()},t.prototype.onMouseDown=function(){if(this.focusCell(!1),this.rangeController){var e=this.gridCell,t=this.rangeController.isCellInAnyRange(e);t||this.rangeController.setRangeToCell(e)}},t.prototype.onCellClicked=function(e){var t=this.createEvent(e);this.eventService.dispatchEvent(v.Events.EVENT_CELL_CLICKED,t);var o=this.column.getColDef();o.onCellClicked&&o.onCellClicked(t),this.gridOptionsWrapper.isSingleClickEdit()&&this.startEditingIfEnabled()},t.prototype.setInlineEditingClass=function(){var e=this.editingCell&&!this.cellEditorInPopup;s.Utils.addOrRemoveCssClass(this.eGridCell,"ag-cell-inline-editing",e),s.Utils.addOrRemoveCssClass(this.eGridCell,"ag-cell-not-inline-editing",!e)},t.prototype.populateCell=function(){this.putDataIntoCell(),this.addStylesFromColDef(),this.addClassesFromColDef(),this.addClassesFromRules()},t.prototype.addStylesFromColDef=function(){var e=this.column.getColDef();if(e.cellStyle){var t;if("function"==typeof e.cellStyle){var o={value:this.value,data:this.node.data,node:this.node,colDef:e,column:this.column,$scope:this.scope,context:this.gridOptionsWrapper.getContext(),api:this.gridOptionsWrapper.getApi()},i=e.cellStyle;t=i(o)}else t=e.cellStyle;t&&s.Utils.addStylesToElement(this.eGridCell,t)}},t.prototype.addClassesFromColDef=function(){var e=this,t=this.column.getColDef();if(t.cellClass){var o;if("function"==typeof t.cellClass){var i={value:this.value,data:this.node.data,node:this.node,colDef:t,$scope:this.scope,context:this.gridOptionsWrapper.getContext(),api:this.gridOptionsWrapper.getApi()},n=t.cellClass;o=n(i)}else o=t.cellClass;"string"==typeof o?s.Utils.addCssClass(this.eGridCell,o):Array.isArray(o)&&o.forEach(function(t){s.Utils.addCssClass(e.eGridCell,t)})}},t.prototype.addClassesFromRules=function(){var e=this.column.getColDef(),t=e.cellClassRules;if("object"==typeof t&&null!==t)for(var o={value:this.value,data:this.node.data,node:this.node,colDef:e,rowIndex:this.rowIndex,api:this.gridOptionsWrapper.getApi(),context:this.gridOptionsWrapper.getContext()},i=Object.keys(t),n=0;n<i.length;n++){var r,l=i[n],a=t[l];"string"==typeof a?r=this.expressionService.evaluate(a,o):"function"==typeof a&&(r=a(o)),r?s.Utils.addCssClass(this.eGridCell,l):s.Utils.removeCssClass(this.eGridCell,l)}},t.prototype.createParentOfValue=function(){if(this.checkboxSelection){this.eCellWrapper=document.createElement("span"),s.Utils.addCssClass(this.eCellWrapper,"ag-cell-wrapper"),this.eGridCell.appendChild(this.eCellWrapper);var e=new G.CheckboxSelectionComponent;this.context.wireBean(e),e.init({rowNode:this.node}),this.eCellWrapper.appendChild(e.getGui()),this.addDestroyFunc(function(){return e.destroy()}),this.eSpanWithValue=document.createElement("span"),s.Utils.addCssClass(this.eSpanWithValue,"ag-cell-value"),this.eCellWrapper.appendChild(this.eSpanWithValue),this.eParentOfValue=this.eSpanWithValue}else s.Utils.addCssClass(this.eGridCell,"ag-cell-value"),this.eParentOfValue=this.eGridCell},t.prototype.isVolatile=function(){return this.column.getColDef()["volatile"]},t.prototype.refreshCell=function(e,t){if(void 0===e&&(e=!1),void 0===t&&(t=!1),this.value=this.getValue(),!t&&this.cellRenderer&&this.cellRenderer.refresh){var o=this.formatValue(this.value),i=this.column.getColDef().cellRendererParams,n=this.createRendererAndRefreshParams(o,i);this.cellRenderer.refresh(n),this.addClassesFromRules()}else s.Utils.removeAllChildren(this.eParentOfValue),this.cellRenderer&&this.cellRenderer.destroy&&this.cellRenderer.destroy(),this.cellRenderer=null,this.populateCell(),this.gridOptionsWrapper.isAngularCompileRows()&&this.$compile(this.eGridCell)(this.scope);e&&this.animateCellWithDataChanged()},t.prototype.putDataIntoCell=function(){var e=this.column.getColDef(),t=this.valueFormatterService.formatValue(this.column,this.node,this.scope,this.rowIndex,this.value);if(e.template)this.eParentOfValue.innerHTML=e.template;else if(e.templateUrl){var o=this.templateService.getTemplate(e.templateUrl,this.refreshCell.bind(this,!0));o&&(this.eParentOfValue.innerHTML=o)}else if(e.floatingCellRenderer&&this.node.floating)this.useCellRenderer(e.floatingCellRenderer,e.floatingCellRendererParams,t);else if(e.cellRenderer)this.useCellRenderer(e.cellRenderer,e.cellRendererParams,t);else{var i=s.Utils.exists(t)?t:this.value;s.Utils.exists(i)&&""!==i&&(this.eParentOfValue.textContent=i.toString())}if(e.tooltipField){var n=this.getDataForRow();if(s.Utils.exists(n)){var r=n[e.tooltipField];this.eParentOfValue.setAttribute("title",r)}}},t.prototype.formatValue=function(e){return this.valueFormatterService.formatValue(this.column,this.node,this.scope,this.rowIndex,e)},t.prototype.createRendererAndRefreshParams=function(e,t){var o={value:this.value,valueFormatted:e,valueGetter:this.getValue,formatValue:this.formatValue.bind(this),data:this.node.data,node:this.node,colDef:this.column.getColDef(),column:this.column,$scope:this.scope,rowIndex:this.rowIndex,api:this.gridOptionsWrapper.getApi(),columnApi:this.gridOptionsWrapper.getColumnApi(),context:this.gridOptionsWrapper.getContext(),refreshCell:this.refreshCell.bind(this),eGridCell:this.eGridCell,eParentOfValue:this.eParentOfValue,addRenderedRowListener:this.renderedRow.addEventListener.bind(this.renderedRow)};return t&&s.Utils.assign(o,t),o},t.prototype.useCellRenderer=function(e,t,o){var i=this.createRendererAndRefreshParams(o,t);this.cellRenderer=this.cellRendererService.useCellRenderer(e,this.eParentOfValue,i)},t.prototype.addClasses=function(){s.Utils.addCssClass(this.eGridCell,"ag-cell"),this.eGridCell.setAttribute("colId",this.column.getColId()),this.node.group&&this.node.footer&&s.Utils.addCssClass(this.eGridCell,"ag-footer-cell"),this.node.group&&!this.node.footer&&s.Utils.addCssClass(this.eGridCell,"ag-group-cell")},t.PRINTABLE_CHARACTERS="qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890!\"£$%^&*()_+-=[];'#,./|<>?:@~{}",n([C.Autowired("context"),r("design:type",C.Context)],t.prototype,"context",void 0),n([C.Autowired("columnApi"),r("design:type",h.ColumnApi)],t.prototype,"columnApi",void 0),n([C.Autowired("gridApi"),r("design:type",m.GridApi)],t.prototype,"gridApi",void 0),n([C.Autowired("gridOptionsWrapper"),r("design:type",p.GridOptionsWrapper)],t.prototype,"gridOptionsWrapper",void 0),n([C.Autowired("expressionService"),r("design:type",d.ExpressionService)],t.prototype,"expressionService",void 0),n([C.Autowired("rowRenderer"),r("design:type",u.RowRenderer)],t.prototype,"rowRenderer",void 0),n([C.Autowired("$compile"),r("design:type",Object)],t.prototype,"$compile",void 0),n([C.Autowired("templateService"),r("design:type",c.TemplateService)],t.prototype,"templateService",void 0),n([C.Autowired("valueService"),r("design:type",g.ValueService)],t.prototype,"valueService",void 0),n([C.Autowired("eventService"),r("design:type",f.EventService)],t.prototype,"eventService",void 0),n([C.Autowired("columnController"),r("design:type",h.ColumnController)],t.prototype,"columnController",void 0),n([C.Optional("rangeController"),r("design:type",Object)],t.prototype,"rangeController",void 0),n([C.Autowired("focusedCellController"),r("design:type",E.FocusedCellController)],t.prototype,"focusedCellController",void 0),n([C.Optional("contextMenuFactory"),r("design:type",Object)],t.prototype,"contextMenuFactory",void 0),n([C.Autowired("focusService"),r("design:type",w.FocusService)],t.prototype,"focusService",void 0),n([C.Autowired("cellEditorFactory"),r("design:type",R.CellEditorFactory)],t.prototype,"cellEditorFactory",void 0),n([C.Autowired("cellRendererFactory"),r("design:type",N.CellRendererFactory)],t.prototype,"cellRendererFactory",void 0),n([C.Autowired("popupService"),r("design:type",O.PopupService)],t.prototype,"popupService",void 0),n([C.Autowired("cellRendererService"),r("design:type",T.CellRendererService)],t.prototype,"cellRendererService",void 0),n([C.Autowired("valueFormatterService"),r("design:type",D.ValueFormatterService)],t.prototype,"valueFormatterService",void 0),n([C.PostConstruct,r("design:type",Function),r("design:paramtypes",[]),r("design:returntype",void 0)],t.prototype,"init",null),t}(S.Component);t.RenderedCell=b},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(7),l=o(40),a=o(13),p=o(8),d=o(33),u=function(){function e(){this.destroyMethods=[],this.listeners=[]}return e.prototype.addListener=function(e){this.listeners.push(e)},e.prototype.removeListener=function(e){s.Utils.removeFromArray(this.listeners,e)},e.prototype.init=function(){var e=this,t=function(t){var o=e.getCellForFocus(t);o&&e.informListeners({gridCell:o})},o=this.gridCore.getRootGui();o.addEventListener("focus",t,!0),this.destroyMethods.push(function(){o.removeEventListener("focus",t)})},e.prototype.getCellForFocus=function(e){function t(e){var t=s.Utils.getElementAttribute(e,"row");s.Utils.exists(t)&&s.Utils.containsClass(e,"ag-row")&&(0===t.indexOf("ft")?(r=p.Constants.FLOATING_TOP,t=t.substr(3)):0===t.indexOf("fb")?(r=p.Constants.FLOATING_BOTTOM,t=t.substr(3)):r=null,n=parseInt(t))}function o(e){var t=s.Utils.getElementAttribute(e,"colid");if(s.Utils.exists(t)&&s.Utils.containsClass(e,"ag-cell")){var o=l.columnController.getGridColumn(t);o&&(i=o)}}for(var i=null,n=null,r=null,l=this,a=e.target;a;)t(a),o(a),a=a.parentNode;if(s.Utils.exists(i)&&s.Utils.exists(n)){var u=new d.GridCell(n,r,i);return u}return null},e.prototype.informListeners=function(e){this.listeners.forEach(function(t){return t(e)})},e.prototype.destroy=function(){this.destroyMethods.forEach(function(e){return e()})},i([r.Autowired("gridCore"),n("design:type",l.GridCore)],e.prototype,"gridCore",void 0),i([r.Autowired("columnController"),n("design:type",a.ColumnController)],e.prototype,"columnController",void 0),i([r.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),i([r.PreDestroy,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"destroy",null),e=i([r.Bean("focusService"),n("design:paramtypes",[])],e)}();t.FocusService=u},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(3),l=o(41),a=o(13),p=o(23),d=o(43),u=o(4),c=o(24),h=o(5),g=o(8),f=o(44),y=o(10),v=o(30),C=o(6),m=o(35),E=o(47),A=function(){function e(e){this.destroyFunctions=[],this.logger=e.create("GridCore")}return e.prototype.init=function(){var e,t=this,o=this.createSouthPanel();this.toolPanel&&!this.gridOptionsWrapper.isForPrint()&&(e=this.toolPanel.getGui());var i=this.createNorthPanel();this.eRootPanel=new v.BorderLayout({center:this.gridPanel.getLayout(),east:e,north:i,south:o,dontFill:this.gridOptionsWrapper.isForPrint(),name:"eRootPanel"}),this.showToolPanel(this.gridOptionsWrapper.isShowToolPanel()),this.eGridDiv.appendChild(this.eRootPanel.getGui()),this.$scope&&this.$scope.$watch(this.quickFilterOnScope,function(e){return t.filterManager.setQuickFilter(e)}),this.gridOptionsWrapper.isForPrint()||this.addWindowResizeListener(),this.doLayout(),this.finished=!1,this.periodicallyDoLayout(),this.eventService.addEventListener(y.Events.EVENT_COLUMN_ROW_GROUP_CHANGED,this.onRowGroupChanged.bind(this)),this.eventService.addEventListener(y.Events.EVENT_COLUMN_EVERYTHING_CHANGED,this.onRowGroupChanged.bind(this)),this.onRowGroupChanged(),this.logger.log("ready")},e.prototype.createNorthPanel=function(){var e=this;if(!this.gridOptionsWrapper.isEnterprise())return null;var t=document.createElement("div"),o=this.onDropPanelVisible.bind(this);return this.rowGroupComp=this.rowGroupCompFactory.create(),this.pivotComp=this.pivotCompFactory.create(),t.appendChild(this.rowGroupComp.getGui()),t.appendChild(this.pivotComp.getGui()),this.rowGroupComp.addEventListener(E.Component.EVENT_VISIBLE_CHANGED,o),this.pivotComp.addEventListener(E.Component.EVENT_VISIBLE_CHANGED,o),this.destroyFunctions.push(function(){e.rowGroupComp.removeEventListener(E.Component.EVENT_VISIBLE_CHANGED,o),e.pivotComp.removeEventListener(E.Component.EVENT_VISIBLE_CHANGED,o)}),this.onDropPanelVisible(),t},e.prototype.onDropPanelVisible=function(){var e=this.rowGroupComp.isVisible()&&this.pivotComp.isVisible();this.rowGroupComp.addOrRemoveCssClass("ag-width-half",e),this.pivotComp.addOrRemoveCssClass("ag-width-half",e)},e.prototype.getRootGui=function(){return this.eRootPanel.getGui()},e.prototype.createSouthPanel=function(){!this.statusBar&&this.gridOptionsWrapper.isEnableStatusBar()&&console.warn("ag-Grid: status bar is only available in ag-Grid-Enterprise");var e=this.statusBar&&this.gridOptionsWrapper.isEnableStatusBar(),t=this.gridOptionsWrapper.isRowModelPagination()&&!this.gridOptionsWrapper.isForPrint();if(!e&&!t)return null;var o=document.createElement("div");return e&&o.appendChild(this.statusBar.getGui()),t&&o.appendChild(this.paginationController.getGui()),o},e.prototype.onRowGroupChanged=function(){if(this.rowGroupComp){var e=this.gridOptionsWrapper.getRowGroupPanelShow();if(e===g.Constants.ALWAYS)this.rowGroupComp.setVisible(!0);else if(e===g.Constants.ONLY_WHEN_GROUPING){var t=!this.columnController.isRowGroupEmpty();this.rowGroupComp.setVisible(t)}else this.rowGroupComp.setVisible(!1);this.eRootPanel.doLayout()}},e.prototype.addWindowResizeListener=function(){var e=this.doLayout.bind(this);window.addEventListener("resize",e),this.destroyFunctions.push(function(){return window.removeEventListener("resize",e)})},e.prototype.periodicallyDoLayout=function(){var e=this;if(!this.finished){var t=this.gridOptionsWrapper.getLayoutInterval();t>0?setTimeout(function(){e.doLayout(),e.gridPanel.periodicallyCheck(),e.periodicallyDoLayout()},t):setTimeout(function(){e.periodicallyDoLayout()},5e3)}},e.prototype.showToolPanel=function(e){return e&&!this.toolPanel?(console.warn("ag-Grid: toolPanel is only available in ag-Grid Enterprise"),void(this.toolPanelShowing=!1)):(this.toolPanelShowing=e,void(this.toolPanel&&(this.toolPanel.setVisible(e),this.eRootPanel.doLayout())))},e.prototype.isToolPanelShowing=function(){return this.toolPanelShowing},e.prototype.destroy=function(){this.finished=!0,this.eGridDiv.removeChild(this.eRootPanel.getGui()),this.logger.log("Grid DOM removed"),this.destroyFunctions.forEach(function(e){return e()})},e.prototype.ensureNodeVisible=function(e){if(this.doingVirtualPaging)throw"Cannot use ensureNodeVisible when doing virtual paging, as we cannot check rows that are not in memory";for(var t=this.rowModel.getRowCount(),o="function"==typeof e,i=-1,n=0;n<t;n++){var r=this.rowModel.getRow(n);if(o){if(e(r)){i=n;break}}else if(e===r||e===r.data){i=n;break}}i>=0&&this.gridPanel.ensureIndexVisible(i)},e.prototype.doLayout=function(){var e=this.eRootPanel.doLayout();if(e){this.rowRenderer.drawVirtualRows();var t={clientWidth:this.eRootPanel.getGui().clientWidth,clientHeight:this.eRootPanel.getGui().clientHeight};this.eventService.dispatchEvent(y.Events.EVENT_GRID_SIZE_CHANGED,t)}},i([C.Autowired("gridOptions"),n("design:type",Object)],e.prototype,"gridOptions",void 0),i([C.Autowired("gridOptionsWrapper"),n("design:type",s.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([C.Autowired("paginationController"),n("design:type",l.PaginationController)],e.prototype,"paginationController",void 0),i([C.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),i([C.Autowired("columnController"),n("design:type",a.ColumnController)],e.prototype,"columnController",void 0),i([C.Autowired("rowRenderer"),n("design:type",p.RowRenderer)],e.prototype,"rowRenderer",void 0),i([C.Autowired("filterManager"),n("design:type",d.FilterManager)],e.prototype,"filterManager",void 0),i([C.Autowired("eventService"),n("design:type",u.EventService)],e.prototype,"eventService",void 0),i([C.Autowired("gridPanel"),n("design:type",c.GridPanel)],e.prototype,"gridPanel",void 0),i([C.Autowired("eGridDiv"),n("design:type",HTMLElement)],e.prototype,"eGridDiv",void 0),i([C.Autowired("$scope"),n("design:type",Object)],e.prototype,"$scope",void 0),i([C.Autowired("quickFilterOnScope"),n("design:type",String)],e.prototype,"quickFilterOnScope",void 0),i([C.Autowired("popupService"),n("design:type",f.PopupService)],e.prototype,"popupService",void 0),i([C.Autowired("focusedCellController"),n("design:type",m.FocusedCellController)],e.prototype,"focusedCellController",void 0),i([C.Optional("rowGroupCompFactory"),n("design:type",Object)],e.prototype,"rowGroupCompFactory",void 0),i([C.Optional("pivotCompFactory"),n("design:type",Object)],e.prototype,"pivotCompFactory",void 0),i([C.Optional("toolPanel"),n("design:type",E.Component)],e.prototype,"toolPanel",void 0),i([C.Optional("statusBar"),n("design:type",E.Component)],e.prototype,"statusBar",void 0),i([C.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),i([C.PreDestroy,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"destroy",null),e=i([C.Bean("gridCore"),r(0,C.Qualifier("loggerFactory")),n("design:paramtypes",[h.LoggerFactory])],e)}();t.GridCore=A},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(3),l=o(6),a=o(24),p=o(28),d=o(42),u=o(4),c=o(10),h=o(43),g=o(8),f='<div class="ag-paging-panel ag-font-style"><span id="pageRowSummaryPanel" class="ag-paging-row-summary-panel"><span id="firstRowOnPage"></span> [TO] <span id="lastRowOnPage"></span> [OF] <span id="recordCount"></span></span><span class="ag-paging-page-summary-panel"><button type="button" class="ag-paging-button" id="btFirst">[FIRST]</button><button type="button" class="ag-paging-button" id="btPrevious">[PREVIOUS]</button>[PAGE] <span id="current"></span> [OF] <span id="total"></span><button type="button" class="ag-paging-button" id="btNext">[NEXT]</button><button type="button" class="ag-paging-button" id="btLast">[LAST]</button></span></div>',y=function(){function e(){}return e.prototype.init=function(){var e=this;this.rowModel.getType()===g.Constants.ROW_MODEL_TYPE_NORMAL&&(this.inMemoryRowModel=this.rowModel),this.setupComponents(),this.callVersion=0;var t=this.gridOptionsWrapper.isRowModelPagination();this.eventService.addEventListener(c.Events.EVENT_FILTER_CHANGED,function(){t&&e.gridOptionsWrapper.isEnableServerSideFilter()&&e.reset(!1)}),this.eventService.addEventListener(c.Events.EVENT_SORT_CHANGED,function(){t&&e.gridOptionsWrapper.isEnableServerSideSorting()&&e.reset(!1)}),t&&this.gridOptionsWrapper.getDatasource()&&this.setDatasource(this.gridOptionsWrapper.getDatasource())},e.prototype.setDatasource=function(e){this.datasource=e,e&&this.reset(!0)},e.prototype.checkForDeprecated=function(){var e=this.datasource;r.Utils.exists(e.pageSize)&&console.error("ag-Grid: since version 5.1.x, pageSize is replaced with grid property paginationPageSize")},e.prototype.reset=function(e){if(!r.Utils.missing(this.datasource)){this.checkForDeprecated();var t=r.Utils.exists(this.gridOptionsWrapper.getRowNodeIdFunc()),o=e||!t;o&&this.selectionController.reset(),this.pageSize=this.gridOptionsWrapper.getPaginationPageSize(),this.pageSize>=1||(this.pageSize=100),"number"==typeof this.datasource.rowCount&&this.datasource.rowCount>=0?(this.rowCount=this.datasource.rowCount,this.foundMaxRow=!0,this.calculateTotalPages()):(this.rowCount=0,this.foundMaxRow=!1,this.totalPages=null),this.currentPage=0,this.ePageRowSummaryPanel.style.visibility="hidden",this.setTotalLabels(),this.loadPage()}},e.prototype.myToLocaleString=function(e){return"number"!=typeof e?"":e.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,")},e.prototype.setTotalLabels=function(){if(this.foundMaxRow)this.lbTotal.innerHTML=this.myToLocaleString(this.totalPages),this.lbRecordCount.innerHTML=this.myToLocaleString(this.rowCount);else{var e=this.gridOptionsWrapper.getLocaleTextFunc()("more","more");this.lbTotal.innerHTML=e,this.lbRecordCount.innerHTML=e}},e.prototype.calculateTotalPages=function(){this.totalPages=Math.floor((this.rowCount-1)/this.pageSize)+1},e.prototype.pageLoaded=function(e,t){var o=this.currentPage*this.pageSize;this.inMemoryRowModel.setRowData(e,!0,o),!this.foundMaxRow&&"number"==typeof t&&t>=0&&(this.foundMaxRow=!0,this.rowCount=t,this.calculateTotalPages(),this.setTotalLabels(),this.currentPage>this.totalPages&&(this.currentPage=this.totalPages-1,this.loadPage())),this.enableOrDisableButtons(),this.updateRowLabels()},e.prototype.updateRowLabels=function(){var e,t;this.isZeroPagesToDisplay()?(e=0,t=0):(e=this.pageSize*this.currentPage+1,t=e+this.pageSize-1,this.foundMaxRow&&t>this.rowCount&&(t=this.rowCount)),this.lbFirstRowOnPage.innerHTML=this.myToLocaleString(e),this.lbLastRowOnPage.innerHTML=this.myToLocaleString(t),this.ePageRowSummaryPanel.style.visibility=""},e.prototype.loadPage=function(){function e(e,t){l.isCallDaemon(s)||l.pageLoaded(e,t)}function t(){l.isCallDaemon(s)||l.inMemoryRowModel.setRowData([],!0)}var o=this;this.enableOrDisableButtons();var i=this.currentPage*this.pageSize,n=(this.currentPage+1)*this.pageSize;this.lbCurrent.innerHTML=this.myToLocaleString(this.currentPage+1),this.callVersion++;var s=this.callVersion,l=this;this.gridPanel.showLoadingOverlay();var a;this.gridOptionsWrapper.isEnableServerSideSorting()&&(a=this.sortController.getSortModel());var p;this.gridOptionsWrapper.isEnableServerSideFilter()&&(p=this.filterManager.getFilterModel());var d={startRow:i,endRow:n,successCallback:e,failCallback:t,sortModel:a,filterModel:p,context:this.gridOptionsWrapper.getContext()},u=r.Utils.getFunctionParameters(this.datasource.getRows);u.length>1&&(console.warn("ag-grid: It looks like your paging datasource is of the old type, taking more than one parameter."),console.warn("ag-grid: From ag-grid 1.9.0, now the getRows takes one parameter. See the documentation for details.")),setTimeout(function(){o.datasource.getRows(d)},0)},e.prototype.isCallDaemon=function(e){return e!==this.callVersion},e.prototype.onBtNext=function(){this.currentPage++,this.loadPage()},e.prototype.onBtPrevious=function(){this.currentPage--,this.loadPage()},e.prototype.onBtFirst=function(){this.currentPage=0,this.loadPage()},e.prototype.onBtLast=function(){this.currentPage=this.totalPages-1,this.loadPage()},e.prototype.isZeroPagesToDisplay=function(){return this.foundMaxRow&&0===this.totalPages},e.prototype.enableOrDisableButtons=function(){var e=0===this.currentPage;this.btPrevious.disabled=e,this.btFirst.disabled=e;var t=this.isZeroPagesToDisplay(),o=this.foundMaxRow&&this.currentPage===this.totalPages-1,i=o||t;this.btNext.disabled=i;var n=!this.foundMaxRow||t||this.currentPage===this.totalPages-1;this.btLast.disabled=n},e.prototype.createTemplate=function(){var e=this.gridOptionsWrapper.getLocaleTextFunc();return f.replace("[PAGE]",e("page","Page")).replace("[TO]",e("to","to")).replace("[OF]",e("of","of")).replace("[OF]",e("of","of")).replace("[FIRST]",e("first","First")).replace("[PREVIOUS]",e("previous","Previous")).replace("[NEXT]",e("next","Next")).replace("[LAST]",e("last","Last"))},e.prototype.getGui=function(){return this.eGui},e.prototype.setupComponents=function(){this.eGui=r.Utils.loadTemplate(this.createTemplate()),this.btNext=this.eGui.querySelector("#btNext"),this.btPrevious=this.eGui.querySelector("#btPrevious"),this.btFirst=this.eGui.querySelector("#btFirst"),this.btLast=this.eGui.querySelector("#btLast"),this.lbCurrent=this.eGui.querySelector("#current"),this.lbTotal=this.eGui.querySelector("#total"),this.lbRecordCount=this.eGui.querySelector("#recordCount"),this.lbFirstRowOnPage=this.eGui.querySelector("#firstRowOnPage"),this.lbLastRowOnPage=this.eGui.querySelector("#lastRowOnPage"),this.ePageRowSummaryPanel=this.eGui.querySelector("#pageRowSummaryPanel");var e=this;this.btNext.addEventListener("click",function(){e.onBtNext()}),this.btPrevious.addEventListener("click",function(){e.onBtPrevious()}),this.btFirst.addEventListener("click",function(){e.onBtFirst()}),this.btLast.addEventListener("click",function(){e.onBtLast()})},i([l.Autowired("filterManager"),n("design:type",h.FilterManager)],e.prototype,"filterManager",void 0),i([l.Autowired("gridPanel"),n("design:type",a.GridPanel)],e.prototype,"gridPanel",void 0),i([l.Autowired("gridOptionsWrapper"),n("design:type",s.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([l.Autowired("selectionController"),n("design:type",p.SelectionController)],e.prototype,"selectionController",void 0),i([l.Autowired("sortController"),n("design:type",d.SortController)],e.prototype,"sortController",void 0),i([l.Autowired("eventService"),n("design:type",u.EventService)],e.prototype,"eventService",void 0),i([l.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),i([l.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e=i([l.Bean("paginationController"),n("design:paramtypes",[])],e)}();t.PaginationController=y},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(15),s=o(6),l=o(3),a=o(13),p=o(4),d=o(10),u=o(6),c=o(7),h=function(){function e(){}return e.prototype.progressSort=function(e,t){e.setSort(this.getNextSortDirection(e)),e.getSort()?e.setSortedAt((new Date).valueOf()):e.setSortedAt(null);var o=t&&!this.gridOptionsWrapper.isSuppressMultiSort();o||this.clearSortBarThisColumn(e),this.dispatchSortChangedEvents()},e.prototype.dispatchSortChangedEvents=function(){this.eventService.dispatchEvent(d.Events.EVENT_BEFORE_SORT_CHANGED),this.eventService.dispatchEvent(d.Events.EVENT_SORT_CHANGED),this.eventService.dispatchEvent(d.Events.EVENT_AFTER_SORT_CHANGED)},e.prototype.clearSortBarThisColumn=function(e){this.columnController.getPrimaryAndSecondaryAndAutoColumns().forEach(function(t){t!==e&&t.setSort(null)})},e.prototype.getNextSortDirection=function(t){var o;if(o=t.getColDef().sortingOrder?t.getColDef().sortingOrder:this.gridOptionsWrapper.getSortingOrder()?this.gridOptionsWrapper.getSortingOrder():e.DEFAULT_SORTING_ORDER,!Array.isArray(o)||o.length<=0)return void console.warn("ag-grid: sortingOrder must be an array with at least one element, currently it's "+o);var i,n=o.indexOf(t.getSort()),r=n<0,s=n==o.length-1;return i=r||s?o[0]:o[n+1],e.DEFAULT_SORTING_ORDER.indexOf(i)<0?(console.warn("ag-grid: invalid sort type "+i),null):i},e.prototype.getSortModel=function(){var e=this.getColumnsWithSortingOrdered();return c.Utils.map(e,function(e){return{colId:e.getColId(),sort:e.getSort()}})},e.prototype.setSortModel=function(e){if(!this.gridOptionsWrapper.isEnableSorting())return void console.warn("ag-grid: You are setting the sort model on a grid that does not have sorting enabled");var t=e&&e.length>0,o=this.columnController.getPrimaryAndSecondaryAndAutoColumns();o.forEach(function(o){var i=null,n=-1;if(t&&!o.getColDef().suppressSorting)for(var r=0;r<e.length;r++){var s=e[r];"string"==typeof s.colId&&"string"==typeof o.getColId()&&s.colId===o.getColId()&&(i=s.sort,n=r)}i?(o.setSort(i),o.setSortedAt(n)):(o.setSort(null),o.setSortedAt(null))}),this.dispatchSortChangedEvents()},e.prototype.getColumnsWithSortingOrdered=function(){var e=this.columnController.getPrimaryAndSecondaryAndAutoColumns(),t=c.Utils.filter(e,function(e){return!!e.getSort()});return t.sort(function(e,t){return e.sortedAt-t.sortedAt}),t},e.prototype.getSortForRowController=function(){var e=this.getColumnsWithSortingOrdered();return c.Utils.map(e,function(e){var t=e.getSort()===r.Column.SORT_ASC;return{inverter:t?1:-1,column:e}})},e.DEFAULT_SORTING_ORDER=[r.Column.SORT_ASC,r.Column.SORT_DESC,null],i([s.Autowired("gridOptionsWrapper"),n("design:type",l.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([s.Autowired("columnController"),n("design:type",a.ColumnController)],e.prototype,"columnController",void 0),i([s.Autowired("eventService"),n("design:type",p.EventService)],e.prototype,"eventService",void 0),e=i([u.Bean("sortController"),n("design:paramtypes",[])],e)}();t.SortController=h},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(3),l=o(44),a=o(29),p=o(13),d=o(45),u=o(46),c=o(6),h=o(4),g=o(10),f=function(){function e(){this.allFilters={},this.quickFilter=null,this.availableFilters={text:d.TextFilter,number:u.NumberFilter}}return e.prototype.init=function(){this.eventService.addEventListener(g.Events.EVENT_ROW_DATA_CHANGED,this.onNewRowsLoaded.bind(this)),this.eventService.addEventListener(g.Events.EVENT_NEW_COLUMNS_LOADED,this.onNewColumnsLoaded.bind(this)),this.quickFilter=this.parseQuickFilter(this.gridOptionsWrapper.getQuickFilterText()),this.checkExternalFilter()},e.prototype.registerFilter=function(e,t){this.availableFilters[e]=t},e.prototype.setFilterModel=function(e){var t=this;if(e){var o=Object.keys(e);r.Utils.iterateObject(this.allFilters,function(i,n){r.Utils.removeFromArray(o,i);var s=e[i];t.setModelOnFilterWrapper(n.filter,s)}),r.Utils.iterateArray(o,function(o){var i=t.columnController.getPrimaryColumn(o);if(!i)return void console.warn("Warning ag-grid setFilterModel - no column found for colId "+o);var n=t.getOrCreateFilterWrapper(i);t.setModelOnFilterWrapper(n.filter,e[o])})}else r.Utils.iterateObject(this.allFilters,function(e,o){t.setModelOnFilterWrapper(o.filter,null)});this.onFilterChanged()},e.prototype.setModelOnFilterWrapper=function(e,t){if("function"!=typeof e.getApi)return void console.warn("Warning ag-grid - filter missing getApi method, which is needed for getFilterModel");var o=e.getApi();return"function"!=typeof o.setModel?void console.warn("Warning ag-grid - filter API missing setModel method, which is needed for setFilterModel"):void o.setModel(t)},e.prototype.getFilterModel=function(){var e={};return r.Utils.iterateObject(this.allFilters,function(t,o){if("function"!=typeof o.filter.getApi)return void console.warn("Warning ag-grid - filter missing getApi method, which is needed for getFilterModel");var i=o.filter.getApi();if("function"!=typeof i.getModel)return void console.warn("Warning ag-grid - filter API missing getModel method, which is needed for getFilterModel");var n=i.getModel();r.Utils.exists(n)&&(e[t]=n)}),e},e.prototype.isAdvancedFilterPresent=function(){var e=!1;return r.Utils.iterateObject(this.allFilters,function(t,o){o.filter.isFilterActive||console.error("Filter is missing method isFilterActive"),o.filter.isFilterActive()?(e=!0,o.column.setFilterActive(!0)):o.column.setFilterActive(!1)}),e},e.prototype.isAnyFilterPresent=function(){return this.isQuickFilterPresent()||this.advancedFilterPresent||this.externalFilterPresent},e.prototype.doesFilterPass=function(e,t){for(var o=e.data,i=Object.keys(this.allFilters),n=0,r=i.length;n<r;n++){var s=i[n],l=this.allFilters[s];if(void 0!==l&&l.filter!==t&&l.filter.isFilterActive()){l.filter.doesFilterPass||console.error("Filter is missing method doesFilterPass");var a={node:e,data:o};if(!l.filter.doesFilterPass(a))return!1}}return!0},e.prototype.parseQuickFilter=function(e){return r.Utils.missing(e)||""===e?null:this.gridOptionsWrapper.isRowModelVirtual()?(console.warn("ag-grid: cannot do quick filtering when doing virtual paging"),null):e.toUpperCase()},e.prototype.setQuickFilter=function(e){var t=this.parseQuickFilter(e);this.quickFilter!==t&&(this.quickFilter=t,this.onFilterChanged())},e.prototype.checkExternalFilter=function(){this.externalFilterPresent=this.gridOptionsWrapper.isExternalFilterPresent()},e.prototype.onFilterChanged=function(){this.eventService.dispatchEvent(g.Events.EVENT_BEFORE_FILTER_CHANGED),this.advancedFilterPresent=this.isAdvancedFilterPresent(),this.checkExternalFilter(),r.Utils.iterateObject(this.allFilters,function(e,t){t.filter.onAnyFilterChanged&&t.filter.onAnyFilterChanged()}),this.eventService.dispatchEvent(g.Events.EVENT_FILTER_CHANGED),this.eventService.dispatchEvent(g.Events.EVENT_AFTER_FILTER_CHANGED)},e.prototype.isQuickFilterPresent=function(){return null!==this.quickFilter},e.prototype.doesRowPassOtherFilters=function(e,t){return this.doesRowPassFilter(t,e)},e.prototype.doesRowPassFilter=function(e,t){return!(this.isQuickFilterPresent()&&(e.quickFilterAggregateText||this.aggregateRowForQuickFilter(e),e.quickFilterAggregateText.indexOf(this.quickFilter)<0))&&(!(this.externalFilterPresent&&!this.gridOptionsWrapper.doesExternalFilterPass(e))&&!(this.advancedFilterPresent&&!this.doesFilterPass(e,t)))},e.prototype.aggregateRowForQuickFilter=function(e){var t="",o=this;this.columnController.getAllPrimaryColumns().forEach(function(i){var n=o.valueService.getValue(i,e);n&&""!==n&&(t=t+n.toString().toUpperCase()+"_")}),e.quickFilterAggregateText=t},e.prototype.onNewRowsLoaded=function(){var e=this;Object.keys(this.allFilters).forEach(function(t){var o=e.allFilters[t].filter;o.onNewRowsLoaded&&o.onNewRowsLoaded()})},e.prototype.createValueGetter=function(e){var t=this;return function(o){return t.valueService.getValue(e,o)}},e.prototype.getFilterApi=function(e){var t=this.getOrCreateFilterWrapper(e);if(t&&"function"==typeof t.filter.getApi)return t.filter.getApi()},e.prototype.getOrCreateFilterWrapper=function(e){var t=this.allFilters[e.getColId()];return t||(t=this.createFilterWrapper(e),this.allFilters[e.getColId()]=t),t},e.prototype.destroyFilter=function(e){var t=this.allFilters[e.getColId()];t&&(t.destroy&&t.destroy(),delete this.allFilters[e.getColId()],this.onFilterChanged(),t.column.setFilterActive(!1))},e.prototype.createFilterWrapper=function(e){var t=this,o=e.getColDef(),i={column:e,filter:null,scope:null,gui:null};if("function"==typeof o.filter)this.gridOptionsWrapper.isAngularCompileFilters()&&(i.scope=this.$scope.$new(),i.scope.context=this.gridOptionsWrapper.getContext()),this.assertMethodHasNoParameters(o.filter),i.filter=new o.filter;else if(r.Utils.missing(o.filter)||"string"==typeof o.filter){var n=this.getFilterFromCache(o.filter);i.filter=new n}else console.error("ag-Grid: colDef.filter should be function or a string");this.context.wireBean(i.filter);var s=this.onFilterChanged.bind(this),l=function(){return t.eventService.dispatchEvent(g.Events.EVENT_FILTER_MODIFIED)},a=this.doesRowPassOtherFilters.bind(this,i.filter),p=o.filterParams,d={column:e,colDef:o,rowModel:this.rowModel,filterChangedCallback:s,filterModifiedCallback:l,filterParams:p,localeTextFunc:this.gridOptionsWrapper.getLocaleTextFunc(),valueGetter:this.createValueGetter(e),doesRowPassOtherFilter:a,context:this.gridOptionsWrapper.getContext(),$scope:i.scope};if(!i.filter.init)throw"Filter is missing method init";if(i.filter.init(d),!i.filter.getGui)throw"Filter is missing method getGui";var u=document.createElement("div");u.className="ag-filter";var c=i.filter.getGui();if(r.Utils.isNodeOrElement(c))u.appendChild(c);else{var h=document.createElement("span");h.innerHTML=c,u.appendChild(h)}return i.scope?i.gui=this.$compile(u)(i.scope)[0]:i.gui=u,i},e.prototype.getFilterFromCache=function(e){var t=this.enterprise?"set":"text",o=this.availableFilters[t];return r.Utils.missing(e)?o:(this.enterprise||"set"!==e||(console.warn("ag-Grid: Set filter is only available in Enterprise ag-Grid"),e="text"),this.availableFilters[e]?this.availableFilters[e]:(console.error("ag-Grid: Could not find filter type "+e),this.availableFilters[o]))},e.prototype.onNewColumnsLoaded=function(){this.destroy()},e.prototype.destroy=function(){r.Utils.iterateObject(this.allFilters,function(e,t){t.filter.destroy&&(t.filter.destroy(),t.column.setFilterActive(!1))}),this.allFilters={}},e.prototype.assertMethodHasNoParameters=function(e){var t=r.Utils.getFunctionParameters(e);t.length>0&&(console.warn("ag-grid: It looks like your filter is of the old type and expecting parameters in the constructor."),console.warn("ag-grid: From ag-grid 1.14, the constructor should take no parameters and init() used instead."))},i([c.Autowired("$compile"),n("design:type",Object)],e.prototype,"$compile",void 0),i([c.Autowired("$scope"),n("design:type",Object)],e.prototype,"$scope",void 0),i([c.Autowired("gridOptionsWrapper"),n("design:type",s.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([c.Autowired("gridCore"),n("design:type",Object)],e.prototype,"gridCore",void 0),i([c.Autowired("popupService"),n("design:type",l.PopupService)],e.prototype,"popupService",void 0),i([c.Autowired("valueService"),n("design:type",a.ValueService)],e.prototype,"valueService",void 0),i([c.Autowired("columnController"),n("design:type",p.ColumnController)],e.prototype,"columnController",void 0),i([c.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),i([c.Autowired("eventService"),n("design:type",h.EventService)],e.prototype,"eventService",void 0),i([c.Autowired("enterprise"),n("design:type",Boolean)],e.prototype,"enterprise",void 0),i([c.Autowired("context"),n("design:type",c.Context)],e.prototype,"context",void 0),i([c.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),i([c.PreDestroy,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"destroy",null),e=i([c.Bean("filterManager"),n("design:paramtypes",[])],e)}();t.FilterManager=f},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(8),l=o(6),a=o(40),p=function(){function e(){}return e.prototype.getPopupParent=function(){return this.gridCore.getRootGui()},e.prototype.positionPopupForMenu=function(e){var t,o=e.eventSource.getBoundingClientRect(),i=this.getPopupParent().getBoundingClientRect(),n=o.right-i.left-2,r=o.top-i.top;t=e.ePopup.clientWidth>0?e.ePopup.clientWidth:200;var s=i.right-i.left,l=s-t;n>l&&(n=o.left-i.left-t),n<0&&(n=0),e.ePopup.style.left=n+"px",e.ePopup.style.top=r+"px"},e.prototype.positionPopupUnderMouseEvent=function(e){var t=this.getPopupParent().getBoundingClientRect();this.positionPopup({ePopup:e.ePopup,x:e.mouseEvent.clientX-t.left,y:e.mouseEvent.clientY-t.top,keepWithinBounds:!0})},e.prototype.positionPopupUnderComponent=function(e){var t=e.eventSource.getBoundingClientRect(),o=this.getPopupParent().getBoundingClientRect();this.positionPopup({ePopup:e.ePopup,minWidth:e.minWidth,nudgeX:e.nudgeX,nudgeY:e.nudgeY,x:t.left-o.left,y:t.top-o.top+t.height,keepWithinBounds:e.keepWithinBounds})},e.prototype.positionPopupOverComponent=function(e){var t=e.eventSource.getBoundingClientRect(),o=this.getPopupParent().getBoundingClientRect();this.positionPopup({ePopup:e.ePopup,minWidth:e.minWidth,nudgeX:e.nudgeX,nudgeY:e.nudgeY,x:t.left-o.left,y:t.top-o.top,keepWithinBounds:e.keepWithinBounds})},e.prototype.positionPopup=function(e){function t(){var t;t=e.minWidth>0?e.minWidth:e.ePopup.clientWidth>0?e.ePopup.clientWidth:200;var o=i.right-i.left,r=o-t-5;n>r&&(n=r),n<0&&(n=0)}function o(){var t;t=e.ePopup.clientWidth>0?e.ePopup.clientHeight:200;var o=i.bottom-i.top,n=o-t-5;r>n&&(r=n),r<0&&(r=0)}var i=this.getPopupParent().getBoundingClientRect(),n=e.x,r=e.y;e.nudgeX&&(n+=e.nudgeX),e.nudgeY&&(r+=e.nudgeY),e.keepWithinBounds&&(t(),o()),e.ePopup.style.left=n+"px",e.ePopup.style.top=r+"px"},e.prototype.addAsModalPopup=function(e,t,o){function i(e){var t=e.which||e.keyCode;t===s.Constants.KEY_ESCAPE&&n(null)}function n(t){t&&t===c||u||(u=!0,d.getPopupParent().removeChild(e),a.removeEventListener("keydown",i),a.removeEventListener("click",n),a.removeEventListener("contextmenu",n),e.removeEventListener("click",l),o&&o())}function l(e){c=e}var a=document.body;if(!a)return void console.warn("ag-grid: could not find the body of the document, document.body is empty");e.style.top="0px",e.style.left="0px";var p=r.Utils.isVisible(e);if(!p){this.getPopupParent().appendChild(e);var d=this,u=!1;setTimeout(function(){t&&a.addEventListener("keydown",i),a.addEventListener("click",n),a.addEventListener("contextmenu",n),e.addEventListener("click",l)},0);var c=null;return n}},i([l.Autowired("gridCore"),n("design:type",a.GridCore)],e.prototype,"gridCore",void 0),e=i([l.Bean("popupService"),n("design:paramtypes",[])],e)}();t.PopupService=p},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(7),n='<div><div><select class="ag-filter-select" id="filterType"><option value="1">[CONTAINS]</option><option value="2">[EQUALS]</option><option value="3">[NOT EQUALS]</option><option value="4">[STARTS WITH]</option><option value="5">[ENDS WITH]</option></select></div><div><input class="ag-filter-filter" id="filterText" type="text" placeholder="[FILTER...]"/></div><div class="ag-filter-apply-panel" id="applyPanel"><button type="button" id="applyButton">[APPLY FILTER]</button></div></div>',r=1,s=2,l=3,a=4,p=5,d=function(){function e(){}return e.prototype.init=function(e){this.filterParams=e.filterParams,this.applyActive=this.filterParams&&this.filterParams.apply===!0,this.filterChangedCallback=e.filterChangedCallback,this.filterModifiedCallback=e.filterModifiedCallback,this.localeTextFunc=e.localeTextFunc,this.valueGetter=e.valueGetter,this.createGui(),this.filterText=null,this.filterType=r,this.createApi()},e.prototype.onNewRowsLoaded=function(){var e=this.filterParams&&"keep"===this.filterParams.newRowsAction;e||(this.api.setType(r),this.api.setFilter(null))},e.prototype.afterGuiAttached=function(){this.eFilterTextField.focus()},e.prototype.doesFilterPass=function(e){if(!this.filterText)return!0;var t=this.valueGetter(e);if(!t)return!1;var o=t.toString().toLowerCase();switch(this.filterType){case r:return o.indexOf(this.filterText)>=0;case s:return o===this.filterText;case l:return o!=this.filterText;case a:return 0===o.indexOf(this.filterText);case p:var i=o.lastIndexOf(this.filterText);return i>=0&&i===o.length-this.filterText.length;default:return console.warn("invalid filter type "+this.filterType),!1}},e.prototype.getGui=function(){return this.eGui},e.prototype.isFilterActive=function(){return null!==this.filterText},e.prototype.createTemplate=function(){return n.replace("[FILTER...]",this.localeTextFunc("filterOoo","Filter...")).replace("[EQUALS]",this.localeTextFunc("equals","Equals")).replace("[NOT EQUALS]",this.localeTextFunc("notEquals","Not equals")).replace("[CONTAINS]",this.localeTextFunc("contains","Contains")).replace("[STARTS WITH]",this.localeTextFunc("startsWith","Starts with")).replace("[ENDS WITH]",this.localeTextFunc("endsWith","Ends with")).replace("[APPLY FILTER]",this.localeTextFunc("applyFilter","Apply Filter"))},e.prototype.createGui=function(){this.eGui=i.Utils.loadTemplate(this.createTemplate()),this.eFilterTextField=this.eGui.querySelector("#filterText"),this.eTypeSelect=this.eGui.querySelector("#filterType"),i.Utils.addChangeListener(this.eFilterTextField,this.onFilterChanged.bind(this)),this.eTypeSelect.addEventListener("change",this.onTypeChanged.bind(this)),this.setupApply()},e.prototype.setupApply=function(){var e=this;this.applyActive?(this.eApplyButton=this.eGui.querySelector("#applyButton"),this.eApplyButton.addEventListener("click",function(){e.filterChangedCallback()})):i.Utils.removeElement(this.eGui,"#applyPanel")},e.prototype.onTypeChanged=function(){this.filterType=parseInt(this.eTypeSelect.value),this.filterChanged()},e.prototype.onFilterChanged=function(){var e=i.Utils.makeNull(this.eFilterTextField.value);e&&""===e.trim()&&(e=null);var t;t=null!==e&&void 0!==e?e.toLowerCase():null,this.filterText!==t&&(this.filterText=t,this.filterChanged())},e.prototype.filterChanged=function(){this.filterModifiedCallback(),this.applyActive||this.filterChangedCallback()},e.prototype.createApi=function(){var e=this;this.api={EQUALS:s,NOT_EQUALS:l,CONTAINS:r,STARTS_WITH:a,ENDS_WITH:p,setType:function(t){e.filterType=t,e.eTypeSelect.value=t},setFilter:function(t){t=i.Utils.makeNull(t),t?(e.filterText=t.toLowerCase(),e.eFilterTextField.value=t):(e.filterText=null,e.eFilterTextField.value=null)},getType:function(){return e.filterType},getFilter:function(){return e.filterText},getModel:function(){return e.isFilterActive()?{type:e.filterType,filter:e.filterText}:null},setModel:function(e){e?(this.setType(e.type),this.setFilter(e.filter)):this.setFilter(null)}}},e.prototype.getApi=function(){return this.api},e}();t.TextFilter=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(7),n='<div><div><select class="ag-filter-select" id="filterType"><option value="1">[EQUALS]</option><option value="2">[NOT EQUAL]</option><option value="3">[LESS THAN]</option><option value="4">[LESS THAN OR EQUAL]</option><option value="5">[GREATER THAN]</option><option value="6">[GREATER THAN OR EQUAL]</option></select></div><div><input class="ag-filter-filter" id="filterText" type="text" placeholder="[FILTER...]"/></div><div class="ag-filter-apply-panel" id="applyPanel"><button type="button" id="applyButton">[APPLY FILTER]</button></div></div>',r=1,s=2,l=3,a=4,p=5,d=6,u=function(){function e(){}return e.prototype.init=function(e){this.filterParams=e.filterParams,this.applyActive=this.filterParams&&this.filterParams.apply===!0,this.filterChangedCallback=e.filterChangedCallback,this.filterModifiedCallback=e.filterModifiedCallback,this.localeTextFunc=e.localeTextFunc,this.valueGetter=e.valueGetter,this.createGui(),this.filterNumber=null,this.filterType=r,this.createApi()},e.prototype.onNewRowsLoaded=function(){var e=this.filterParams&&"keep"===this.filterParams.newRowsAction;e||(this.api.setType(r),this.api.setFilter(null))},e.prototype.afterGuiAttached=function(){this.eFilterTextField.focus()},e.prototype.doesFilterPass=function(e){if(null===this.filterNumber)return!0;var t=this.valueGetter(e);if(!t&&0!==t)return!1;var o;switch(o="number"==typeof t?t:parseFloat(t),this.filterType){case r:return o===this.filterNumber;case l:return o<this.filterNumber;case p:return o>this.filterNumber;case a:return o<=this.filterNumber;case d:return o>=this.filterNumber;case s:return o!=this.filterNumber;default:return console.warn("invalid filter type "+this.filterType),!1}},e.prototype.getGui=function(){return this.eGui},e.prototype.isFilterActive=function(){return null!==this.filterNumber},e.prototype.createTemplate=function(){return n.replace("[FILTER...]",this.localeTextFunc("filterOoo","Filter...")).replace("[EQUALS]",this.localeTextFunc("equals","Equals")).replace("[LESS THAN]",this.localeTextFunc("lessThan","Less than")).replace("[GREATER THAN]",this.localeTextFunc("greaterThan","Greater than")).replace("[LESS THAN OR EQUAL]",this.localeTextFunc("lessThanOrEqual","Less than or equal")).replace("[GREATER THAN OR EQUAL]",this.localeTextFunc("greaterThanOrEqual","Greater than or equal")).replace("[NOT EQUAL]",this.localeTextFunc("notEqual","Not equal")).replace("[APPLY FILTER]",this.localeTextFunc("applyFilter","Apply Filter"))},e.prototype.createGui=function(){this.eGui=i.Utils.loadTemplate(this.createTemplate()),this.eFilterTextField=this.eGui.querySelector("#filterText"),this.eTypeSelect=this.eGui.querySelector("#filterType"),i.Utils.addChangeListener(this.eFilterTextField,this.onFilterChanged.bind(this)),this.eTypeSelect.addEventListener("change",this.onTypeChanged.bind(this)),this.setupApply()},e.prototype.setupApply=function(){var e=this;this.applyActive?(this.eApplyButton=this.eGui.querySelector("#applyButton"),this.eApplyButton.addEventListener("click",function(){e.filterChangedCallback()})):i.Utils.removeElement(this.eGui,"#applyPanel")},e.prototype.onTypeChanged=function(){this.filterType=parseInt(this.eTypeSelect.value),this.filterChanged()},e.prototype.filterChanged=function(){this.filterModifiedCallback(),this.applyActive||this.filterChangedCallback()},e.prototype.onFilterChanged=function(){var e=i.Utils.makeNull(this.eFilterTextField.value);e&&""===e.trim()&&(e=null);var t;t=null!==e&&void 0!==e?parseFloat(e):null,this.filterNumber!==t&&(this.filterNumber=t,this.filterChanged())},e.prototype.createApi=function(){var e=this;this.api={EQUALS:r,NOT_EQUAL:s,LESS_THAN:l,GREATER_THAN:p,LESS_THAN_OR_EQUAL:a,GREATER_THAN_OR_EQUAL:d,setType:function(t){e.filterType=t,e.eTypeSelect.value=t},setFilter:function(t){t=i.Utils.makeNull(t),null!==t&&"number"!=typeof t&&(t=parseFloat(t)),e.filterNumber=t,e.eFilterTextField.value=t},getType:function(){return e.filterType},getFilter:function(){return e.filterNumber},getModel:function(){return e.isFilterActive()?{type:e.filterType,filter:e.filterNumber}:null},setModel:function(e){e?(this.setType(e.type),this.setFilter(e.filter)):this.setFilter(null)}}},e.prototype.getApi=function(){return this.api},e}();t.NumberFilter=u},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(7),n=o(4),r=o(3),s=function(){function e(e){this.destroyFunctions=[],this.childComponents=[],this.annotatedEventListeners=[],this.visible=!0,e&&this.setTemplate(e)}return e.prototype.instantiate=function(e){this.instantiateRecurse(this.getGui(),e)},e.prototype.instantiateRecurse=function(e,t){for(var o=e.childNodes?e.childNodes.length:0,i=0;i<o;i++){var n=e.childNodes[i],r=t.createComponent(n);r?this.swapComponentForNode(r,e,n):n.childNodes&&this.instantiateRecurse(n,t)}},e.prototype.swapComponentForNode=function(e,t,o){t.replaceChild(e.getGui(),o),this.childComponents.push(e),this.swapInComponentForQuerySelectors(e,o)},e.prototype.swapInComponentForQuerySelectors=function(e,t){var o=this.__agComponentMetaData;if(o&&o.querySelectors){var i=this;o.querySelectors.forEach(function(o){i[o.attributeName]===t&&(i[o.attributeName]=e)})}},e.prototype.setTemplate=function(e){this.eGui=i.Utils.loadTemplate(e),this.eGui.__agComponent=this,this.addAnnotatedEventListeners(),this.wireQuerySelectors()},e.prototype.wireQuerySelectors=function(){var e=this,t=this.__agComponentMetaData;if(t&&t.querySelectors&&this.eGui){var o=this;t.querySelectors.forEach(function(t){var i=e.eGui.querySelector(t.querySelector);if(i){var n=i.__agComponent;n?o[t.attributeName]=n:o[t.attributeName]=i}})}},e.prototype.addAnnotatedEventListeners=function(){var e=this;this.removeAnnotatedEventListeners();var t=this.__agComponentMetaData;t&&t.listenerMethods&&this.eGui&&(this.annotatedEventListeners||(this.annotatedEventListeners=[]),t.listenerMethods.forEach(function(t){var o=e[t.methodName].bind(e);e.eGui.addEventListener(t.eventName,o),e.annotatedEventListeners.push({eventName:t.eventName,listener:o})}))},e.prototype.removeAnnotatedEventListeners=function(){var e=this;this.annotatedEventListeners&&this.eGui&&(this.annotatedEventListeners.forEach(function(t){e.eGui.removeEventListener(t.eventName,t.listener)}),this.annotatedEventListeners=null)},e.prototype.addEventListener=function(e,t){this.localEventService||(this.localEventService=new n.EventService),this.localEventService.addEventListener(e,t)},e.prototype.removeEventListener=function(e,t){this.localEventService&&this.localEventService.removeEventListener(e,t)},e.prototype.dispatchEventAsync=function(e,t){var o=this;setTimeout(function(){return o.dispatchEvent(e,t)},0)},e.prototype.dispatchEvent=function(e,t){this.localEventService&&this.localEventService.dispatchEvent(e,t)},e.prototype.getGui=function(){return this.eGui},e.prototype.queryForHtmlElement=function(e){return this.eGui.querySelector(e)},e.prototype.queryForHtmlInputElement=function(e){return this.eGui.querySelector(e)},e.prototype.appendChild=function(e){if(i.Utils.isNodeOrElement(e))this.eGui.appendChild(e);else{var t=e;this.eGui.appendChild(t.getGui()),this.childComponents.push(t)}},e.prototype.isVisible=function(){return this.visible},e.prototype.setVisible=function(t){t!==this.visible&&(this.visible=t,i.Utils.addOrRemoveCssClass(this.eGui,"ag-hidden",!t),this.dispatchEvent(e.EVENT_VISIBLE_CHANGED,{visible:this.visible}))},e.prototype.addOrRemoveCssClass=function(e,t){i.Utils.addOrRemoveCssClass(this.eGui,e,t)},e.prototype.destroy=function(){this.childComponents.forEach(function(e){return e.destroy()}),this.destroyFunctions.forEach(function(e){return e()}),this.removeAnnotatedEventListeners()},e.prototype.addGuiEventListener=function(e,t){var o=this;this.getGui().addEventListener(e,t),this.destroyFunctions.push(function(){return o.getGui().removeEventListener(e,t)})},e.prototype.addDestroyableEventListener=function(e,t,o){e instanceof HTMLElement?e.addEventListener(t,o):e instanceof r.GridOptionsWrapper?e.addEventListener(t,o):e.addEventListener(t,o),this.destroyFunctions.push(function(){e instanceof HTMLElement?e.removeEventListener(t,o):e instanceof r.GridOptionsWrapper?e.removeEventListener(t,o):e.removeEventListener(t,o)})},e.prototype.addDestroyFunc=function(e){this.destroyFunctions.push(e)},e.prototype.addCssClass=function(e){i.Utils.addCssClass(this.getGui(),e)},e.prototype.getAttribute=function(e){var t=this.getGui();return t?t.getAttribute(e):null},e.EVENT_VISIBLE_CHANGED="visibleChanged",e}();t.Component=s},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(7),l=o(49),a=o(50),p=o(51),d=o(52),u=o(53),c=o(3),h=function(){function e(){this.cellEditorMap={}}return e.prototype.init=function(){this.cellEditorMap[e.TEXT]=l.TextCellEditor,this.cellEditorMap[e.SELECT]=a.SelectCellEditor,this.cellEditorMap[e.POPUP_TEXT]=d.PopupTextCellEditor,this.cellEditorMap[e.POPUP_SELECT]=u.PopupSelectCellEditor},e.prototype.addCellEditor=function(e,t){this.cellEditorMap[e]=t},e.prototype.createCellEditor=function(t){var o;s.Utils.missing(t)?o=this.cellEditorMap[e.TEXT]:"string"==typeof t?(o=this.cellEditorMap[t],s.Utils.missing(o)&&(console.warn("ag-Grid: unable to find cellEditor for key "+t),o=this.cellEditorMap[e.TEXT])):o=t;var i=new o;return this.context.wireBean(i),i.isPopup&&i.isPopup()&&(i=new p.PopupEditorWrapper(i)),i},e.TEXT="text",e.SELECT="select",e.POPUP_TEXT="popupText",e.POPUP_SELECT="popupSelect",i([r.Autowired("context"),n("design:type",r.Context)],e.prototype,"context",void 0),i([r.Autowired("gridOptionsWrapper"),n("design:type",c.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([r.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e=i([r.Bean("cellEditorFactory"),n("design:paramtypes",[])],e)}();t.CellEditorFactory=h},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=o(8),r=o(47),s=o(7),l=function(e){function t(){e.call(this,t.TEMPLATE)}return i(t,e),t.prototype.init=function(e){var t,o=this.getGui(),i=e.keyPress===n.Constants.KEY_BACKSPACE||e.keyPress===n.Constants.KEY_DELETE;i?t="":e.charPress?t=e.charPress:(t=e.value,e.keyPress===n.Constants.KEY_F2?this.putCursorAtEndOnFocus=!0:this.highlightAllOnFocus=!0),s.Utils.exists(t)&&(o.value=t),this.addDestroyableEventListener(o,"keydown",function(e){var t=e.keyCode===n.Constants.KEY_LEFT||e.keyCode===n.Constants.KEY_RIGHT;t&&e.stopPropagation()})},t.prototype.afterGuiAttached=function(){var e=this.getGui();if(e.focus(),this.highlightAllOnFocus)e.select();else{var t=e.value?e.value.length:0;t>0&&e.setSelectionRange(t,t)}},t.prototype.getValue=function(){var e=this.getGui();return e.value},t.TEMPLATE='<input class="ag-cell-edit-input" type="text"/>',t}(r.Component);t.TextCellEditor=l},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=o(47),r=o(7),s=o(8),l=function(e){function t(){e.call(this,'<div class="ag-cell-edit-input"><select class="ag-cell-edit-input"/></div>')}return i(t,e),t.prototype.init=function(e){var t=this.getGui().querySelector("select");return r.Utils.missing(e.values)?void console.log("ag-Grid: no values found for select cellEditor"):(e.values.forEach(function(o){var i=document.createElement("option");i.value=o,i.text=o,e.value===o&&(i.selected=!0),t.appendChild(i)}),this.addDestroyableEventListener(t,"change",function(){return e.stopEditing()}),this.addDestroyableEventListener(t,"keydown",function(e){var t=e.keyCode===s.Constants.KEY_UP||e.keyCode===s.Constants.KEY_DOWN;t&&e.stopPropagation()}),void this.addDestroyableEventListener(t,"mousedown",function(e){e.stopPropagation()}))},t.prototype.afterGuiAttached=function(){var e=this.getGui().querySelector("select");e.focus()},t.prototype.getValue=function(){var e=this.getGui().querySelector("select");return e.value},t}(n.Component);t.SelectCellEditor=l},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=o(47),r=function(e){function t(t){e.call(this,'<div class="ag-popup-editor"/>'),this.getGuiCalledOnChild=!1,this.cellEditor=t,this.addDestroyFunc(function(){return t.destroy()}),this.addDestroyableEventListener(e.prototype.getGui.call(this),"keydown",this.onKeyDown.bind(this))}return i(t,e),t.prototype.onKeyDown=function(e){this.params.onKeyDown(e)},t.prototype.getGui=function(){return this.getGuiCalledOnChild||(this.appendChild(this.cellEditor.getGui()),this.getGuiCalledOnChild=!0),e.prototype.getGui.call(this)},t.prototype.init=function(e){this.params=e,this.cellEditor.init&&this.cellEditor.init(e)},t.prototype.afterGuiAttached=function(){this.cellEditor.afterGuiAttached&&this.cellEditor.afterGuiAttached()},t.prototype.getValue=function(){return this.cellEditor.getValue()},t.prototype.isPopup=function(){return!0},t.prototype.isCancelBeforeStart=function(){if(this.cellEditor.isCancelBeforeStart)return this.cellEditor.isCancelBeforeStart()},t.prototype.isCancelAfterEnd=function(){if(this.cellEditor.isCancelAfterEnd)return this.cellEditor.isCancelAfterEnd()},t}(n.Component);t.PopupEditorWrapper=r},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=o(49),r=function(e){function t(){e.apply(this,arguments)}return i(t,e),t.prototype.isPopup=function(){return!0},t}(n.TextCellEditor);t.PopupTextCellEditor=r},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=o(50),r=function(e){function t(){e.apply(this,arguments)}return i(t,e),t.prototype.isPopup=function(){return!0},t}(n.SelectCellEditor);t.PopupSelectCellEditor=r},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(7),l=o(3),a=o(4),p=o(18),d=o(55),u=o(56),c=o(57),h=function(){function e(){this.cellRendererMap={}}return e.prototype.init=function(){this.cellRendererMap[e.ANIMATE_SLIDE]=d.AnimateSlideCellRenderer,this.cellRendererMap[e.ANIMATE_SHOW_CHANGE]=u.AnimateShowChangeCellRenderer,this.cellRendererMap[e.GROUP]=c.GroupCellRenderer},e.prototype.addCellRenderer=function(e,t){this.cellRendererMap[e]=t},e.prototype.getCellRenderer=function(e){var t=this.cellRendererMap[e];return s.Utils.missing(t)?(console.warn("ag-Grid: unable to find cellRenderer for key "+e),null):t},e.ANIMATE_SLIDE="animateSlide",e.ANIMATE_SHOW_CHANGE="animateShowChange",e.GROUP="group",i([r.Autowired("gridOptionsWrapper"),n("design:type",l.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([r.Autowired("expressionService"),n("design:type",p.ExpressionService)],e.prototype,"expressionService",void 0),i([r.Autowired("eventService"),n("design:type",a.EventService)],e.prototype,"eventService",void 0),i([r.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e=i([r.Bean("cellRendererFactory"),n("design:paramtypes",[])],e)}();t.CellRendererFactory=h},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=o(7),r=o(47),s=function(e){function t(){e.call(this,t.TEMPLATE),this.refreshCount=0,this.eCurrent=this.queryForHtmlElement(".ag-value-slide-current")}return i(t,e),t.prototype.init=function(e){this.params=e,this.refresh(e)},t.prototype.addSlideAnimation=function(){var e=this;this.refreshCount++;var t=this.refreshCount;this.ePrevious&&this.getGui().removeChild(this.ePrevious),this.ePrevious=n.Utils.loadTemplate('<span class="ag-value-slide-previous ag-fade-out"></span>'),this.ePrevious.innerHTML=this.eCurrent.innerHTML,this.getGui().insertBefore(this.ePrevious,this.eCurrent),setTimeout(function(){t===e.refreshCount&&n.Utils.addCssClass(e.ePrevious,"ag-fade-out-end")},50),setTimeout(function(){t===e.refreshCount&&(e.getGui().removeChild(e.ePrevious),e.ePrevious=null)},3e3)},t.prototype.refresh=function(e){var t=e.value;n.Utils.missing(t)&&(t=""),t!==this.lastValue&&(this.addSlideAnimation(),this.lastValue=t,n.Utils.exists(e.valueFormatted)?this.eCurrent.innerHTML=e.valueFormatted:n.Utils.exists(e.value)?this.eCurrent.innerHTML=t:this.eCurrent.innerHTML="")},t.TEMPLATE='<span><span class="ag-value-slide-current"></span></span>',t}(r.Component);t.AnimateSlideCellRenderer=s},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=o(7),r=o(47),s="&#65514;",l="&#65516;",a=function(e){function t(){e.call(this,t.TEMPLATE),this.refreshCount=0}return i(t,e),t.prototype.init=function(e){this.params=e,this.eValue=this.queryForHtmlElement(".ag-value-change-value"),this.eDelta=this.queryForHtmlElement(".ag-value-change-delta"),this.refresh(e)},t.prototype.showDelta=function(e,t){var o=Math.abs(t),i=e.formatValue(o),r=n.Utils.exists(i)?i:o,a=t>=0;a?this.eDelta.innerHTML=s+r:this.eDelta.innerHTML=l+r,n.Utils.addOrRemoveCssClass(this.eDelta,"ag-value-change-delta-up",a),n.Utils.addOrRemoveCssClass(this.eDelta,"ag-value-change-delta-down",!a)},t.prototype.setTimerToRemoveDelta=function(){var e=this;this.refreshCount++;var t=this.refreshCount;setTimeout(function(){t===e.refreshCount&&e.hideDeltaValue()},2e3)},t.prototype.hideDeltaValue=function(){n.Utils.removeCssClass(this.eValue,"ag-value-change-value-highlight"),this.eDelta.innerHTML=""},t.prototype.refresh=function(e){var t=e.value;if(t!==this.lastValue){if(n.Utils.exists(e.valueFormatted)?this.eValue.innerHTML=e.valueFormatted:n.Utils.exists(e.value)?this.eValue.innerHTML=t:this.eValue.innerHTML="","number"==typeof t&&"number"==typeof this.lastValue){var o=t-this.lastValue;this.showDelta(e,o)}this.lastValue&&n.Utils.addCssClass(this.eValue,"ag-value-change-value-highlight"),this.setTimerToRemoveDelta(),this.lastValue=t}},t.TEMPLATE='<span><span class="ag-value-change-delta"></span><span class="ag-value-change-value"></span></span>',t}(r.Component);t.AnimateShowChangeCellRenderer=a},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},r=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},s=o(58),l=o(3),a=o(18),p=o(4),d=o(8),u=o(7),c=o(10),h=o(6),g=o(47),f=o(59),y=o(60),v=o(61),C=o(13),m=s.SvgFactory.getInstance(),E=function(e){function t(){e.call(this,t.TEMPLATE),this.eExpanded=this.queryForHtmlElement(".ag-group-expanded"),this.eContracted=this.queryForHtmlElement(".ag-group-contracted"),this.eCheckbox=this.queryForHtmlElement(".ag-group-checkbox"),this.eValue=this.queryForHtmlElement(".ag-group-value"),this.eChildCount=this.queryForHtmlElement(".ag-group-child-count")}return i(t,e),t.prototype.init=function(e){this.rowNode=e.node,this.rowIndex=e.rowIndex,this.gridApi=e.api,this.addExpandAndContract(e.eGridCell),this.addCheckboxIfNeeded(e),this.addValueElement(e),this.addPadding(e)},t.prototype.addPadding=function(e){var t=this.rowNode,o=e.suppressPadding;if(!o&&(t.footer||t.level>0)){var i;i=e.colDef&&e.padding>=0?e.padding:10;var n=t.level*i,r=this.columnController.isPivotMode()&&this.rowNode.leafGroup;t.footer?n+=15:t.isExpandable()&&!r||(n+=10),this.getGui().style.paddingLeft=n+"px"}},t.prototype.addValueElement=function(e){e.innerRenderer?this.createFromInnerRenderer(e):this.rowNode.footer?this.createFooterCell(e):this.rowNode.group?(this.createGroupCell(e),this.addChildCount(e)):this.createLeafCell(e)},t.prototype.createFromInnerRenderer=function(e){this.cellRendererService.useCellRenderer(e.innerRenderer,this.eValue,e)},t.prototype.createFooterCell=function(e){var t,o=this.getGroupName(e);if(e.footerValueGetter){var i=e.footerValueGetter,n=u.Utils.cloneObject(e);n.value=o,"function"==typeof i?t=i(n):"string"==typeof i?t=this.expressionService.evaluate(i,n):console.warn("ag-Grid: footerValueGetter should be either a function or a string (expression)")}else t="Total "+o;this.eValue.innerHTML=t},t.prototype.createGroupCell=function(e){var t=e.columnApi.getRowGroupColumns(),o=t[e.node.level];u.Utils.missing(o)&&(o=e.column);var i=o.getColDef(),n=this.getGroupName(e),r=this.valueFormatterService.formatValue(o,e.node,e.scope,this.rowIndex,n);if(i&&"function"==typeof i.cellRenderer)e.value=n,e.valueFormatted=r,i.cellRendererParams&&u.Utils.assign(e,i.cellRendererParams),this.cellRendererService.useCellRenderer(i.cellRenderer,this.eValue,e);else{var s=u.Utils.exists(r)?r:n;u.Utils.exists(s)&&""!==s&&this.eValue.appendChild(document.createTextNode(s))}},t.prototype.addChildCount=function(e){var t=e.suppressCount;!t&&e.node.allChildrenCount>=0&&(this.eChildCount.innerHTML="("+e.node.allChildrenCount+")")},t.prototype.getGroupName=function(e){if(e.keyMap&&"object"==typeof e.keyMap){var t=e.keyMap[e.node.key];return t?t:e.node.key}return e.node.key},t.prototype.createLeafCell=function(e){u.Utils.exists(e.value)&&(this.eValue.innerHTML=e.value)},t.prototype.addCheckboxIfNeeded=function(e){var t=e.checkbox&&!this.rowNode.footer&&!this.rowNode.floating&&!this.rowNode.flower;if(t){var o=new v.CheckboxSelectionComponent;this.context.wireBean(o),o.init({rowNode:this.rowNode}),this.eCheckbox.appendChild(o.getGui()),this.addDestroyFunc(function(){return o.destroy()})}},t.prototype.addExpandAndContract=function(e){var t=u.Utils.createIconNoSpan("groupExpanded",this.gridOptionsWrapper,null,m.createGroupContractedIcon),o=u.Utils.createIconNoSpan("groupContracted",this.gridOptionsWrapper,null,m.createGroupExpandedIcon);this.eExpanded.appendChild(t),this.eContracted.appendChild(o),this.addDestroyableEventListener(this.eExpanded,"click",this.onExpandOrContract.bind(this)),this.addDestroyableEventListener(this.eContracted,"click",this.onExpandOrContract.bind(this)),this.addDestroyableEventListener(e,"dblclick",this.onExpandOrContract.bind(this)),this.addDestroyableEventListener(e,"keydown",this.onKeyDown.bind(this)),this.showExpandAndContractIcons()},t.prototype.onKeyDown=function(e){u.Utils.isKeyPressed(e,d.Constants.KEY_ENTER)&&(this.onExpandOrContract(),e.preventDefault())},t.prototype.onExpandOrContract=function(){this.rowNode.expanded=!this.rowNode.expanded;var e=this.getRefreshFromIndex();this.gridApi.onGroupExpandedOrCollapsed(e),this.showExpandAndContractIcons();var t={node:this.rowNode};this.eventService.dispatchEvent(c.Events.EVENT_ROW_GROUP_OPENED,t)},t.prototype.showExpandAndContractIcons=function(){var e=this.columnController.isPivotMode()&&this.rowNode.leafGroup,t=this.rowNode.isExpandable()&&!this.rowNode.footer&&!e;t?(u.Utils.setVisible(this.eExpanded,this.rowNode.expanded),u.Utils.setVisible(this.eContracted,!this.rowNode.expanded)):(u.Utils.setVisible(this.eExpanded,!1),u.Utils.setVisible(this.eContracted,!1))},t.prototype.getRefreshFromIndex=function(){return this.gridOptionsWrapper.isGroupIncludeFooter()?this.rowIndex:this.rowIndex+1},t.TEMPLATE='<span><span class="ag-group-expanded"></span><span class="ag-group-contracted"></span><span class="ag-group-checkbox"></span><span class="ag-group-value"></span><span class="ag-group-child-count"></span></span>',n([h.Autowired("gridOptionsWrapper"),r("design:type",l.GridOptionsWrapper)],t.prototype,"gridOptionsWrapper",void 0),n([h.Autowired("expressionService"),r("design:type",a.ExpressionService)],t.prototype,"expressionService",void 0),n([h.Autowired("eventService"),r("design:type",p.EventService)],t.prototype,"eventService",void 0),n([h.Autowired("cellRendererService"),r("design:type",f.CellRendererService)],t.prototype,"cellRendererService",void 0),n([h.Autowired("valueFormatterService"),r("design:type",y.ValueFormatterService)],t.prototype,"valueFormatterService",void 0),n([h.Autowired("context"),r("design:type",h.Context)],t.prototype,"context",void 0),n([h.Autowired("columnController"),r("design:type",C.ColumnController)],t.prototype,"columnController",void 0),t}(g.Component);t.GroupCellRenderer=E},function(e,t){function o(e,t){var o=i(t),r=document.createElementNS(n,"polygon");return r.setAttribute("points",e),o.appendChild(r),o}function i(e){var t=document.createElementNS(n,"svg");return e>0?(t.setAttribute("width",e),t.setAttribute("height",e)):(t.setAttribute("width","10"),t.setAttribute("height","10")),t}/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var n="http://www.w3.org/2000/svg",r=function(){function e(){}return e.getInstance=function(){return this.theInstance||(this.theInstance=new e),this.theInstance},e.prototype.createFilterSvg=function(){var e=i(),t=document.createElementNS(n,"polygon");return t.setAttribute("points","0,0 4,4 4,10 6,10 6,4 10,0"),t.setAttribute("class","ag-header-icon"),e.appendChild(t),e},e.prototype.createFilterSvg12=function(){var e=i(12),t=document.createElementNS(n,"polygon");return t.setAttribute("points","0,0 5,5 5,12 7,12 7,5 12,0"),t.setAttribute("class","ag-header-icon"),e.appendChild(t),e},e.prototype.createMenuSvg=function(){var e=document.createElementNS(n,"svg"),t="12";return e.setAttribute("width",t),e.setAttribute("height",t),["0","5","10"].forEach(function(o){var i=document.createElementNS(n,"rect");i.setAttribute("y",o),i.setAttribute("width",t),i.setAttribute("height","2"),i.setAttribute("class","ag-header-icon"),e.appendChild(i)}),e},e.prototype.createColumnsSvg12=function(){var e=i(12);return[0,4,8].forEach(function(t){[0,7].forEach(function(o){var i=document.createElementNS(n,"rect");i.setAttribute("y",t.toString()),i.setAttribute("x",o.toString()),i.setAttribute("width","5"),i.setAttribute("height","3"),i.setAttribute("class","ag-header-icon"),e.appendChild(i)})}),e},e.prototype.createArrowUpSvg=function(){return o("0,10 5,0 10,10")},e.prototype.createArrowLeftSvg=function(){return o("10,0 0,5 10,10")},e.prototype.createArrowDownSvg=function(){return o("0,0 5,10 10,0")},e.prototype.createArrowRightSvg=function(){return o("0,0 10,5 0,10")},e.prototype.createSmallArrowRightSvg=function(){return o("0,0 6,3 0,6",6)},e.prototype.createSmallArrowDownSvg=function(){return o("0,0 3,6 6,0",6)},e.prototype.createArrowUpDownSvg=function(){var e=i(),t=document.createElementNS(n,"polygon");t.setAttribute("points","0,4 5,0 10,4"),e.appendChild(t);var o=document.createElementNS(n,"polygon");return o.setAttribute("points","0,6 5,10 10,6"),e.appendChild(o),e},e.prototype.createFolderOpen=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAZpJREFUeNqkU0tLQkEUPjN3ShAzF66CaNGiaNEviFpLgbSpXf2ACIqgFkELaVFhtAratQ8qokU/oFVbMQtJvWpWGvYwtet9TWfu1QorvOGBb84M5/WdOTOEcw7tCKHBlT8sMIhr4BfLGXC4BrALM8QUoveHG9oPQ/NhwVCQbOjp0C5F6zDiwE7Aed/p5tKWruufTlY8bkqliqVN8wvH6wvhydWd5UYdkYCqqgaKotQTCEewnJuDBSqVmshOrWhKgCJVqeHcKtiGKdqTgGIOQmwGum7AxVUKinXKzX1/1y5Xp6g8gpe8iBxuGZhcKjyXQZIkmBkfczS62YnRQCKX75/b3t8QDNhD8QX83V5Ipe7Bybug2Pt5NJ7A4nEqGOQKT+Bzu0HTDNB1syUYYxCJy0kwzIRogb0rKjAiQVXXHLVQrqqvsZtsFu8hbyXwe73WeMQtO5GonJGxuiyeC+Oa4fF5PEirw9nbx9FdxtN5eMwkzcgRnoeCa9DVM/CvH/R2l+axkz3clQguOFjw1f+FUzEQCqJG2v3OHwIMAOW1JPnAAAJxAAAAAElFTkSuQmCC",e},e.prototype.createFolderClosed=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARlJREFUeNqsUz1PwzAUPDtOUASpYKkQVWcQA/+DhbLA32CoKAMSTAwgFsQfQWLoX4GRDFXGIiqiyk4e7wUWmg8phJPOtvzunc6WrYgIXaD06KKhij0eD2uqUxBeDC9OmcNKCYd7ujm7ryodXz5ong6UPpqcP9+O76y1vwS+7yOOY1jr0OttlQyiaB0n148TAyK9XFqkaboiSTEYDNnkDUkyKxkkiSQkzQbwsiyHcBXz+Tv6/W1m+QiSEDT1igTO5RBWYbH4rNwPw/AnQU5ek0EdCj33SgLjHEHYzoAkgfmHBDmZuktsQqHPvxN0MyCbbWjtIQjWWhlIj/QqtT+6QrSz+6ef9DF7VTwFzE2madnu5K2prt/5S4ABADcIlSf6Ag8YAAAAAElFTkSuQmCC",e},e.prototype.createColumnIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAOCAYAAAAMn20lAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RTcwQ0JFMzlENjZEMTFFNUFEQ0U5RDRCNjFFRENGMUMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTcwQ0JFM0FENjZEMTFFNUFEQ0U5RDRCNjFFRENGMUMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpFNzBDQkUzN0Q2NkQxMUU1QURDRTlENEI2MUVEQ0YxQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpFNzBDQkUzOEQ2NkQxMUU1QURDRTlENEI2MUVEQ0YxQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PqDOrJYAAABxSURBVHjalJBBDsAgCAQXxXvj2/o/X9Cvmd4lUpV4MXroJMTAuihQSklVMSCysxSBW4uWKzjG6zZLDxrlWis5EVEThoWmi3N+nxAYs2WnXQY34L3HisMWPQlHB+2FPtNW6D/8+ziBRcroOXc0B/wEGABY6TPS1FU0bwAAAABJRU5ErkJggg==",e},e.prototype.createColumnsIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OENFQkI4NDhENzJDMTFFNUJDNEVFRjgwRDI3MkU1Q0EiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OENFQkI4NDlENzJDMTFFNUJDNEVFRjgwRDI3MkU1Q0EiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo4Q0VCQjg0NkQ3MkMxMUU1QkM0RUVGODBEMjcyRTVDQSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo4Q0VCQjg0N0Q3MkMxMUU1QkM0RUVGODBEMjcyRTVDQSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pj6ozGQAAAAuSURBVHjaYmRgYPjPgBswQml8anBK/idGDQsxNpCghnTAOBoGo2EwGgZgABBgAHbrH/l4grETAAAAAElFTkSuQmCC",e},e.prototype.createPinIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAedJREFUeNqkUktLG1EYPTN31CIN0oWbIAWhKJR0FXcG6gOqkKGKVvEXCKULC91YSBcK7jXgQoIbFxn3ErFgFlIfCxUsQsCoIJYEm9LWNsGmJjPTM+Oo44Aa6IUzd+bec77H+UYyTRP/s5SsLFfCCxEjOhD9CXw64ccXJj7nLleYaMSvaa/+Au9Y73P3RUUBDIuXyaAxGu35A7xnkM57A7icCZXIO8/nkVleRn1/f9cv0xzjfVclFdi9N8ZivfnDQxQKBTwoFvFicLCVQSesJIpHMEY8dSqQWa54Eov1fF9ZQVHXsZNMblhnNE/wPmJPIX1zjOG2+fkgslnozHR2eopLcSIe3yoD48y45FbIxoVJNjimyMehoW3T58PvdBq53V18zeWwFo+vUfyBlCVvj0Li4/M1DnaAUtXCQkNDR4f/294eaoTAwdHRCROMWlzJZfC+1cKcJF07b5o+btWvV1eDyVBouyUcDj5UFDg924tVYtERpz0mCkmSulOp1GQgEIj0yvKPYiKBlwMDQXfPU47walEEmb8z0a5p2qaiKMPEoz6ezQLdM8DWNDDzltym24YthHimquoshSoDicvzZkK9S+h48pjCN4ZhrBPHTptlD0qevezwdCtAHVHrMti4A7rr3eb+E2AAoGnGkgkzpg8AAAAASUVORK5CYII=",e},e.prototype.createPlusIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAatJREFUeNqkU71KA0EQ/vaiib+lWCiordidpSg+QHwDBSt7n8DGhwhYCPoEgqCCINomARuLVIqgYKFG5f6z68xOzrvzYuXA3P7MzLffN7unjDH4jw3xx91bQXuxU4woNDjUX7VgsFOIH3/BnHgC0J65AzwFjDpZgoG7vb7lMsPDq6MiuK+B+kjGwFpCUjwK1DIQ3/dl0ssVh5TTM0UJP8aBgBKGleSGIWyP0oKYRm3KPSgYJ0Q0EpEgCASA2WmWZQY3kazBmjP9UhBFEbTWAgA0f9W2yHeG+vrd+tqGy5r5xNTT9erSqpvfdxwHN7fXOQZ0QhzH1oWArLsfXXieJ/KTGEZLcbVaTVn9ALTOLk9L+mYX5lxd0Xh6eGyVgspK6APwI8n3x9hmNpORJOuBo5ah8GcTc7dAHmkhNpYQlpHr47Hq2NspA1yEwHkoO/MVYLMmWJNarjEUQBzQw7rPvardFC8tZuOEwwB4p9PHqXgCdm738sUDJPB8mnwKj7qCTtJ527+XyAs6tOf2Bb6SP0OeGxRTVMp2h9nweWMoKS20l3+QT/vwqfZbgAEAUCrnlLQ+w4QAAAAASUVORK5CYII=",e},e.prototype.createMinusIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKVJREFUeNpi/P//PwMlgImBQjBqAAMDy3JGRgZGBoaZQGxMikZg3J0F4nSWHxC+cUBamvHXr18Zfv36Bca/f/8G43///oExKLphmImJieHagQMQF7QDiSwg/vnzJ8P3799RDPj79y+KRhhmBLr6I1DPNJABtxkYZM4xMFx7uXAhSX5/CtQD0gv0OgMfyCAgZgViZiL1/wXi30D8h3E0KVNuAECAAQDr51qtGxzf1wAAAABJRU5ErkJggg==",e},e.prototype.createMoveIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoZJREFUeNpsU81rE0EUf7uzu2lNVJL6Eb0IBWusepqcKm3wEFkvxqDgQbwUtYeeg5cccwj4F7QKChEPipRcdMGDiaAoJAexLYViwYsfbU1JYkx3Zz98b8220Wbg7ez7vXm/mffmN9Kh1G2QGQOmMDiRyYEkSaCoKjDGdAAooOUdxzFsIcDzPPhSvgeO7YDrOLBRmQdlJHULVE0DNRSCvqFjUuHqhWP8+etvhR5m0CeengVhmiAsywdl2Dt03K1wZSrO220XaCaf8AFrQel32s0mrDcaWfovrq3Vc9OTvHj/Tb0Xzh6JxQwNyxtIgPXpqqJk94fDM+1Oh6CaEF4QTiIOGJ/DdQtBObsEmGxbll/rkCyDPDwMzW4XhHD88EH0NcRxDUeX4/qdnsi0s8Aas+kEp8Zg82pMkmpDigKbjSbQTD7hFL94/jin9ZRHBNLo3Wrt+uUkbzQsiEZVMPGKfv76DaawodnahkhY86+PNnXxs77ZgVOjMahWVuufi1NJRZhWvvT0beHGtQn++Nm7en+DzqXO8vfVxX+wsYnT/JWxWEe95P0eILsvkkdPKn4PUEBJmunILab5992PLVU++skoNmOniT7JX2Fkt5GM1EjqbMohXzQmqo7KwCQ6zYKiabu30PpQAnZ0HKSRMcMRwnBddw4ZOO4GLRYKFFdDhrrteTMMdWB9/QTdH8sIp0EKmNT4GWDjGZAPJ3TcrbBv+ibfwtwDqBvzYck/truxYjjLZRDflwLt7JUmEoAymdPV7INa5IXn0Uw+4f8PIqATMLQIWpQ0E/RFTmQ4nLx0B1Zfzrsr5eAmbLQW2hYpHwkcqfegNBJhzwY9sGC4aCZaF81CAvePAAMAcwtApJX/Wo0AAAAASUVORK5CYII=",e},e.prototype.createLeftIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAe9JREFUeNqkUz1oE2EYfu7uuyRKLCFt6g+4VNQWWod+mQRRR1En0UFOHKoNCMKNju4SEQsOzsFNcRGl4CS42AzaKhKcsqhk0Etj7u+773y/6+USbOLSF5574b33eX+e906L4xh7MaYeC/c/IFcowMznEzDTBGPMoldnqEFtkPy708mIqvHHe0s7BcaYJYSwRwPu9vbYRH1XJI4tEYb2jYtHOHko9LvdxE9cYZQcBoF9+9oJ7jgRQt+HFAJSyv9rkO6UkGvXF3mr9QelkpkUINsYR6T8Jrkay8i+b9+5yfnmppMmSFw6e4yrIynBBsdS3jQ1PH/zeTiBIt+9dZpvbTlZh1+Oh/Z3F33XRUj7R1GUxA3DwMx0EYHnDUUMPe9Rfe1tc26uiL6M8aXno+UH6O7PIShPIapMQx6sQMxW4JbL+MkKCKhwNgGN2FD7Pnz82j63coF/aoc4ekDHtxfrzUniaZrW/FfEBomI9Scv7fnVq7zdBwIqajBWpeTd99d3vgBNCaQSzMOLyJ+6ApSPWxSzD61a/MfThupSjVuvxk2A3sazYYGBGbML0OcvW9rMyeRLFO8eVGXnKyacMiug5ikSplLs05dXzqNQWpbv6/URjpK+m6JH3GhQQI2QI+RTmBO0EwQ/RUBcqe31d/4rwAB0lPTXqN6HzgAAAABJRU5ErkJggg==",e},e.prototype.createRightIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAfBJREFUeNqkUz1s00AU/hwSh1SEhiFCYuhCVSExgHRiYKjEVCEyMMGAsjCxZunesWM7dIgEA8JISPyoUhFDFoZOSE2GgtrSIAYWSEPb1HUS23c+8+7iuE5/JKQ+6fOdz/e+970fG2EY4jyWVo9b819hGEZ8WCgW4z2dV2lZFUJYgnNwz9PwXRebc3cGBMfN6XSQy+eHryyCMuv43dRpBCpSz7b1qlB+cI3RWkEYlv+LQFkgBLxuV8s9OAhQLk0w7vsnSHQKVMhqQuYRSRBouK5AqyXwpHSdvfywUYkKb8UEFIU9fXybOY6A+jbszGAP7O/7RBKg2eR4dH+KvV5ej0k0gaqobXO0214c3acUDnt99Pp9cKqDUqLsx68LuHd3gtU+b1eOCOiSaaZQKJjgMsSOy7EnJcSYCZnLwKbojic1weTVMXz81KhTexeSKdSXqrUzh2X84Qxr9SQmx1P48q6mnTPZrJUs4jMp5QlHlSd1Y203fRGFK8DPV28HzqZpjXShW3+D00bamCrpNU9DuvvcGsjea1rO+nvw39+AxRCGckyO8ciQFG8gPT27ptX8/b4gt1asYGdzRGE6MVCXCJcj5NShbG9B/NnYhttpyMYL5XmTYEdw1KgMFSgJJiEbIXNGPQXBi+CTrzTO+zv/E2AA3Y8Nbp4Kn1sAAAAASUVORK5CYII=",e},e.prototype.createColumnVisibleIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAdhJREFUeNrUk01LAlEUhu845QdRUxZBhIIWtFBso2AwRAVNLqKltHCb63b9A/9AixZCELhyYdAmEyYCBcOlNa1CSQoxog/DMY3x9p5B27Zw1YGH8XrO+55759wROOdsmLCwIWNoAwFh/ugfZQKsAQV4gbNf9woqIAeuQHOgGxgIMNix2Wx7iqIsxmKxWU3TxgqFgpWSsix3fT5fK5VKPedyuftOp5OE7oz60hHsYD8UCh3k83k5k8ksGYYx5XK5rK2WzgiIrPQf5aiGakljakVRjKDrZaPR6Oi6zglVVTlFMnnMZXmdK8o2x674IE+1pCHtCFx2w+GwE9u3drtd81yJRAKdDXZ4eGSuFxb87PHxjg3yVEsaNNolg5NSqTTVbDaX7Agq8Hg8TFWLbGVl0xTY7TY2Our5NfhCQPNAWtFisdSr1WqvWCwawWBwRpKkcZyXadoN83qXmSQ50V1jGxurpnGlUqnH4/FzvItTmoo5ApjQNMIOh2MrEon4o9Gov1arzZXL5XHKBwKBT7fbXU+n07fZbPa23W5f4BVd93o9TgYimATTMHHCbB5PN9ZSf0LmrsEHRDWInvB8w/oFvAv920iFDkBzF/64fHTjvoFOxsL//5h+BBgAwjbgRLl5ImwAAAAASUVORK5CYII=",e},e.prototype.createColumnHiddenIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N0ZGNDRBMkJENkU3MTFFNUIwOTBGRTc0MTA3OTI2OEYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6N0ZGNDRBMkNENkU3MTFFNUIwOTBGRTc0MTA3OTI2OEYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3RkY0NEEyOUQ2RTcxMUU1QjA5MEZFNzQxMDc5MjY4RiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3RkY0NEEyQUQ2RTcxMUU1QjA5MEZFNzQxMDc5MjY4RiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjQ0mkwAAACISURBVHjaYvz//z8DJYCJgUIwDAxgKSwspMwAIOYDYlcgtgNiJSBWBGJhIGaHyoHAJyD+CcRvgfg+EN8D4kNAvBtkwGEg1iNgkSCUlgBibSg7D4gvgwywRXKBChArALEIELMCsQBU8Qcg/g3Eb4D4ARDfBeKDMBeAnLcWikkGjKMpcRAYABBgACqXGpPEq63VAAAAAElFTkSuQmCC",e},e.prototype.createColumnIndeterminateIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OUY1QTkyNDUxRTkzMTFFNkFEQzVDNjE1NDE4RDlEQUMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OUY1QTkyNDYxRTkzMTFFNkFEQzVDNjE1NDE4RDlEQUMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo5RjVBOTI0MzFFOTMxMUU2QURDNUM2MTU0MThEOURBQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo5RjVBOTI0NDFFOTMxMUU2QURDNUM2MTU0MThEOURBQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Por9Q7gAAAGzSURBVHja1JOxSwJRHMffqXcqSoVBQ0FDNN7iIBxO5WA3NYoEjm0u/T2Bkw2ONZlgNEk4Bw6GiGiippmRnp76+n4PbWhpcOoHH57P+36/7/e8n4qUUmxSLrFhbRygoJwPq6tsgRMQB0cgtNINQA0UwCMYrX3rAAUB516v9zIejx+nUqm90WgUDIfDaq1WE9PpdK6q6mc2m+0WCoUX7K/hu+O5TPCBq0gkUiqXy0PbtqVlWXK5XDqwuE4mEzmfzyU11NJDr3C73SZOfeh0OtPxeCyR7oixlzhdVqtV2ev1nCB+Tw219NDrQRtJwzBCaF+bzWbsSGQyGVEsFoWmacLj8YjBYCBisZhIp9MC3Qhq6YEmyQ5OTdO8bTQak263K8m69d+FIOc5tfTQywAvTrmIRqM3pVLptd1uy3q9/nN3slgsZLPZlHxGDbX00Ou8ApfLxbdh+P3+MyTriURC7/f7+7hCsFKpCF3XvwKBQCuXyz3n8/ln/Bb3yH9iOAPcYAfsIiSEsAOsh9hvA99qDizwAVMDphbWd+zfwFBZTSOFfqBxJv4YPk6cDcYMVv7/n+lbgAEAtdcjOjP715MAAAAASUVORK5CYII=",e},e.prototype.createGroupIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NUVCNUI1OUNENkYwMTFFNThGNjJDNUE3ODIwMEZERDciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NUVCNUI1OURENkYwMTFFNThGNjJDNUE3ODIwMEZERDciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1RUI1QjU5QUQ2RjAxMUU1OEY2MkM1QTc4MjAwRkRENyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo1RUI1QjU5QkQ2RjAxMUU1OEY2MkM1QTc4MjAwRkRENyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PlkCTGoAAACDSURBVHjaYmRgYPjPgBswQun/+BT8X3x5DoZErG4KCj/3/DcMNZMNuRiYGPADRiRX4HYBJV5AB0QrhAGW//8hehgZES6FiaGLYzUAq7sxNf0nxQCsinHFAguegCPKBYxoYfAfWQxNnPgwINJVYMDEQCEYfLHASGoKRQlxPN7BqQggwAAN+SopPnDCwgAAAABJRU5ErkJggg==",e},e.prototype.createPivotIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAitJREFUeNqcU01rE1EUPfPVJjFqdYw2pJQkNS2hYhQUiwj+AaugKFYUBWutG3HjokgNrroRKYKbglBBFF0o1IW404qClGIDxpYKTQgULZJmmpiYkPnwvmtNspPmweOcmXnnvPPufSOdjsf7AfjR3PiOU6OjV50mh9CqtmVJDlkNjWU3tPXEiA6hlS3Lkm3HQbFYxO5hnTF0pQ3Bwa3MAxc98F9wMd95TsOOswpzoRFa1TJNyaKHtTUD07cNdv9wx6jtNDNW53N369xyOiC0qmmanMAwcjh+/yimrr/D28kjf8WLizjY3c38YzKJw729zKcTCU4gtLUE+Xwejy+94gWfl5agKQr8uo4Eccu2USr48SWVQq5QWE/gcAJZuIgF5XIF5yf7GfcGg9Cos4O3UoiFw2jFLrx+/wtRet+3nkJoOAEbkJtty5g484I+yUivrODekxb4tmuInZhCuFPHyHAXZubnUTXNWgKhlc1qlY+gaZsw9PwkY4fPhxsDXvxcrWL25TE8G+8DFAOxSAQHotG6AWlrRXS52vD08ifGr5kM1+BBPIBkOo3flQpaNA2zCwug+8MGdkMCPoLbvQ0DDw8xRgIBBNvbsUoF6yK+h+pQJpN91JH9PT2NCWS1Ui4rNhtswZubPxi/LS9TTWxemKTK/9t1jtramEBo1Vw226pRvEfj3oaL6v3vVRYaoZXcodA12ePpbOZXtEuljEToprmZprpBvehn4Y8AAwDB0mLL0M405wAAAABJRU5ErkJggg==",e},e.prototype.createAggregationIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAMZJREFUeNpi/P//PwMlgImBQjDwBrCgmMYENq8RiLVxqL8KxPX//v1DiIACEYYZGRlBmBOIe4B4PRDrQMUYoGyQGIoebAbADJkAxFuAWA9JXJdYA0CYC4inAPFOINZHlkPWgxKIcFMhQA0aFveB+DbOUERxDhQAbTEC4qNAPBfqEmRx3F6AAhOgojNAvBikGckumDiKHhY0B3ECcTVQQhRIg/B1NNeeB1IgQ7/BXYvmdE6oAnYcPv4NxF+BerAbMDTzAkCAAQChYIl8b86M1gAAAABJRU5ErkJggg==",e},e.prototype.createDropNotAllowedIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MjUyQ0MxNDY0NjBDMTFFNkEzMUVGQUE3NkQzQzU4MjYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MjUyQ0MxNDc0NjBDMTFFNkEzMUVGQUE3NkQzQzU4MjYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyNTJDQzE0NDQ2MEMxMUU2QTMxRUZBQTc2RDNDNTgyNiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyNTJDQzE0NTQ2MEMxMUU2QTMxRUZBQTc2RDNDNTgyNiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PstpFisAAAGLSURBVHjalJNPKERRFMbnvRmKpAnjhURKWXjJLNQsqDE7KxI1NhYU2cjKxtbGZpSNqSFT/qxkYafmLWyU2LElCwYLo0SS8J36rk7XbJz61f33nXPuuec6ad8PWdYHJsEAaOPaDTgGeXCqD0cs8TqYCf21bjIHsmC2nIMCGOT4C3yCV44rQRXPS4BOkNIOchTL4RI4A0fggvtdYAj0g2qeFc10hKlNUXwF1sAOeALfdHCuxMZEsyoOFrjwTK8bTN3YMGvjcf7BzF3RukxHIl2DfSVuALvgQIn3wCJ44zwpDpqY/i2458YouARpzmV9BEyAExWk2RTRARUgxiuMqytsg3nWRCzMgL/PWATtoJfVr+PeHd/70OoJ6bxajotyhYCTmBJv8XVssdRljD0hFoiDDCcyfgcrjFyyxFGwBBI8K5YJ+573iEEriHOjBdSr55KoSbDM4ppekFrlHPWZCupJpcoP4IWCRt7bRA5MK7sqxRQ/irxIDegAPez7qDqbNeJyv1Huvvmf7/wjwABtLlYtICx9HQAAAABJRU5ErkJggg==",e},e.prototype.createGroupIcon12=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MTNFQzE0NTdEOTk1MTFFNUI4MjJGMjBFRDk4MkMxNjAiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MTNFQzE0NThEOTk1MTFFNUI4MjJGMjBFRDk4MkMxNjAiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoxM0VDMTQ1NUQ5OTUxMUU1QjgyMkYyMEVEOTgyQzE2MCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoxM0VDMTQ1NkQ5OTUxMUU1QjgyMkYyMEVEOTgyQzE2MCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PiInRbAAAAEjSURBVHjaYuTi5XqkpKvI9/fXHwZWDlaGZ/eeM7x59raDAQj4pOQrBBUVGP78+MfAzMbE8PLKhU8Mhnb6/6//P/f/8N/d/x8AWUn1cf+BaleCsFPt5P/T/v//3/zj//8JQFrB1vM/I5IN3EAbfgBt+Au0QRBqw3sMG0DiQMwPxFuB2BzKZmLAAViA+BOU/QOI7wPxRyhfCIhT0NT/ZETi7AZiZiD+DOXL6EdlGdkWFzF8evaDgUuIg2F9eiTYBrhuIJ4NxHegfDsgnobuJGQbNgBxMRDfhfLFgDgB3UnInPVALMxAACDbcBGItwDxAyhfCRismejBiuyHiUBsDMQmUL6cSXIJf0hTDsNboEN42RkYJth58TPisV0eaMNFdBsAAgwANVJzd8zQrUcAAAAASUVORK5CYII=",e},e.prototype.createCutIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlRJREFUeNqkU09okmEcfj6ThNRhjUEJDhxDZ1t4sI3lDrKDhESHpC6x6yBoh52GfcdBJDvtElEUdKhOSq1JjF0SabSton9OmIeRxVKIrUgdU5xvv8e+hXXYpRcefv+e5/mh7/tpSin8z9Gi0Sg0TTsv+edarfa+Wq2iUqmgXC6DudVqhd1uh81ma+UWi8Uv3G5ZPJ9MJmGq1+twOBynBOek6T9oG+fkkU8djymVSiGTyWBiYuL6QSb7YvLIp679+D0ej57NZpX8JD0QCPj7+vrgcrnAyJp9zskj3zD928Tr9er5fF5FIhFdiH4aMLJmn/N98R+Dq5qGSUFQwKFs1AuFggqFQrrT6bzIyJp9zoMGn7qWQU6ST4JNQeK3kd/n8+nFYlGFw+HFdDqtWLOfMHjk5wwDjckRwGYGeJVnBMdXgaNrbveJKysr/etu91pHtVo8BnyXWUnwsgHM7wAVX7MJ0cEmjWvW4eGzjpGRXnNnZ8cFeRi9pRI+dnXtjMbj/cLp57rG1tbPH0tLwd3l5QHp3RBU8E7Txr4MDb1V8bh60tOzfhN4vTc9rRYkCm4tGDX7nJNHPnWt/+CFpt1rF9emptScxKfA2DNZwThn9NtNWjoxMH1Tqru+va02NzbK47FY4PHMzJtdYPYD8OChGDCyZp9z8sinrnWXt4E7q4ODRbrelw0x2Xjyn1fImn3OySOfutYt+IDRSeCycAZeAYm7wKLkshR87A1+cILDAss4EDkNXJI8Ows8yin1nENn+5MXNA3hnpHzHBKYjWhqe4lffwkwAMRcPMqRQZ4vAAAAAElFTkSuQmCC",e},e.prototype.createCopyIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAgBJREFUeNqMk79rFEEcxd/M7V2QAzVFEOMFGwNiIGCjEdIEhYODmEawsFf8G4QQSCPYyqUWCdhY2qSQECSpInvFJYT8Ki6dZO8Sb2P29pfvu+4sm+UKv/AYZna/b95ndla9WFyEUmoewG0Mr+9hGB5EYYhypZIseO0fCHa3sP/LhxVFkazd+by0tOIFAQac+3w5imPYto1Pa2tv+VxR+8bRuv8EevIRxn5uQoszpWI2RjSIBgMMLi/hui76/T6+Li+v8Pkz9k0Wo409pFHAJooUCiWqYlk46nTQ2ttD+/gY75pNPKjVmmfd7gf2vKbu5U0sMWBpzWatNcAkv7n789lZ1GdmMqQ3cbxApIUikg58H5S0JgkSE/L/L1JmoNJmMZEDzCNdK5cxwtFxHHxcXcXTqalm27Zf7rRaRKBBhkAhxcgjiYlUo16HfKlqtYpv29u95Az81EClCFLyaQ0SCib/dtNJ6qsGfDmJnRqoXIKiyVUDz8sSSGy5VnI3ikh5k1KplBnog/V19BxnRCZmV15dGCSdO1wziphcS3rrT7d71zk5Ob8+Pf3eMN4aH3/8qtGYM0hp7iyJbO0bBOrMPTz8kl6OpGoTEzEncwapaCLrRNfu6Wli0Etl6mbfdb0MiYrlXsjZyAUTE0qwOxsbo9aQ3/dGEWlYRRcX5xxG/wowAC8cIjzfyA4lAAAAAElFTkSuQmCC",e},e.prototype.createPasteIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAadJREFUeNpinGLPAAaMjAxwcJ9Tk+0Bt7YPkCkKFXqt8PXqFsXv13/B1Pz/D6FZENoYZgKxMYgh9OI6i567q5hFUp4kiH9i3qTnT3auqWPgZ/gDVXsWiNPBFk+2hxtwxi0syfjy5csM0vFzGTg42Bj4+XnAEh8/fmH48eMXw9OFyQy6uroMu1bNAxlgAnbB338IJ6hlzWU4uXgJw6FDO4Ga+Rl4eXkZWFlZGb58/crw6eNHBjG7Iga1yAiG7SvmwfWw/P2LMADkraiYaIb79+4xYAOKSkpgNch6UFzwFxgy//79Y5BTUMBqwF+g3H8mJgZkPSgu+Ac04M+/fwz4AAswulBc8Ocfqg1/kGWxAEagAch6WP78RfUCIQOYmJkZ/qC44A+qAb8JeIEZZMkfXC4gwgsQNUgG/CbRC2BXIhvw8AsDgzQnkgEEvACxBMJ++h0YJmufMTA8ABry8xckGkFOxIdBakBqQXpAekGZiXPTSwbeUAEgB5hsObm58acDoJp3nxkYNn1gEANyP4MNAGKxh18ZbsXxsjMQA97/Z7gF0gPEfwACDAB/y9xB1I3/FQAAAABJRU5ErkJggg==",e},e.prototype.createMenuIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QjM3MUVBMzlERkJEMTFFNUEwMjFFNDJDMDlCMUY3OTciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QjM3MUVBM0FERkJEMTFFNUEwMjFFNDJDMDlCMUY3OTciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpCMzcxRUEzN0RGQkQxMUU1QTAyMUU0MkMwOUIxRjc5NyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpCMzcxRUEzOERGQkQxMUU1QTAyMUU0MkMwOUIxRjc5NyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pux7nZcAAAGtSURBVHjalFM9a8JQFL0veYkfYJUQEYuIIF07uToVpGuHOgid3dJN+i+K4C6CXQqFjplcCoKbXZ0EqRUFP/CTxCS9NzTdNOmBx32P3Nx3zj33sXq9/tRqtbRYLCaLomhBANi2La5WK7NSqTRYNpt1LMsCLACO47iLMXY2CoIAm80GZFkGoVQqfWy3WzBNE6gQVveNhmHAbreDYrHYZaPRKKTr+i0ykTDBPnUzgfYEvFkYDAZWoVDQWb/fB9QD6XQajscjBCkQDodhOBzCcrkEVq1WXfoEL9EPlEdSZrMZ8Pl8frVYLO7QgRB+sPx+/GUk4qUGNvOdYSO+JpPJJdHyc8ADnUluIpH45vv9XiFbiFIQC71IjuBe5ZlM5gYlPHLOL7C4AcEgofXbXC7X4PF4vKuqahf+AWJxOBwgEokA6/V67kFRFFcGLU/SqShJkusATSNbr9fQ6XSuU6mUQP3BBIaJZyM6BuPx2Mnn85+sVqu9ttvt+2QyGXgOqInT6RTK5fIbwwl0iFI0Gv2btCA9QPdcOVzTtOdms/mAnnKkaAexES0UcG/hc375EWAA94tOP0vEOEcAAAAASUVORK5CYII=",e},e.prototype.createCheckboxCheckedIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpFQ0VGQkU3ODM4MTFFNjExQjlCQzhERUVDNkNGMzFDMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpBRkJCRDU1MTEyM0ExMUU2ODE4MUUyOTNBNTRGQkIxNyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpBRkJCRDU1MDEyM0ExMUU2ODE4MUUyOTNBNTRGQkIxNyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjIzMkM4M0M1M0MxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkVDRUZCRTc4MzgxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+riMaEQAAAL5JREFUeNqUks0JhDAQhSd7tgtLMDUIyTXF2IdNWIE3c0ruYg9LtgcPzvpEF8SfHR8MGR75hpcwRERmrjQXCyutDKUQAkuFu2AUpsyiJ1JK0UtycRgGMsbsPBFYVRVZaw/+7Zu895znOY/j+PPWT7oGp2lirTU3TbPz/4IAAGLALeic47Ztlx7RELHrusPAAwgoy7LlrOuay7I8TXIadYOLouC+7+XgBiP2lTbw0crFGAF9ANq1kS75G8xXgAEAiqu9OeWZ/voAAAAASUVORK5CYII=",e},e.prototype.createCheckboxCheckedReadOnlyIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTZENDVDNkY0NDVFMTFFNkI1MjZCRkJDQ0FEMUEyNDMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTZENDVDNzA0NDVFMTFFNkI1MjZCRkJDQ0FEMUEyNDMiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo1NkQ0NUM2RDQ0NUUxMUU2QjUyNkJGQkNDQUQxQTI0MyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo1NkQ0NUM2RTQ0NUUxMUU2QjUyNkJGQkNDQUQxQTI0MyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PiE1TFsAAAGLSURBVHjadJI9a8JQFIbfSFBBakDaDg5O0nay4OSPsEFoCq4JODhUShd3F9emFreKqJOlS6Xg4OB/cIkZijjXwRa/uthzLokESS683I+cJ+fec15pv9/DHfP5/JSmR1KedOEcW6QP0nMqlfp2YyUXJOiWpleSAv/xQzIIfudNyAO9+UHr9Rrtdhuz2SzOMU4sQrQ4o7nF2f3SDIdD1Ot19Ho9ODEtYs454z0p7gdNp1OYpontdot0Ou0ec+wDgyrvlsslxuPxAdpsNmg0GnxFVCoVaJrm/WeewSte9ft9lMtljEYj8YWvNhgMkMvloOs6ZFn2gpeHnaIoohDNZhO73Q7dbhfRaBTVahWJROL4FX+y06frQqGAyWSCTqcDy7KwWq1Qq9WQzWb9nv8VcpqLcDgsrprJZASkqiqKxWJAS/HJ4IvTXCSTSRiGISpYKpUQiUSCjPAknOMxgLRYLGDbtsgci8WOIbbZHbvHaznNMcJJwPV+SbprOSnA5Ddccq4eyeY3kUyvyf8FGAAA/p3KIKgjXwAAAABJRU5ErkJggg==",e},e.prototype.createCheckboxUncheckedIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpFQ0VGQkU3ODM4MTFFNjExQjlCQzhERUVDNkNGMzFDMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo2MkU1Rjk1NDExNDExMUU2ODhEQkMyRTJGOUNGODYyQyIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo2MkU1Rjk1MzExNDExMUU2ODhEQkMyRTJGOUNGODYyQyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjI1MkM4M0M1M0MxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkVDRUZCRTc4MzgxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+t+CXswAAAFBJREFUeNrsksENwDAIA023a9YGNqlItkixlAFIn1VOMv5wvACAOxOZWUwsB6Gqswp36QivJNhBRHDhI0f8j9jNrCy4O2twNMobT/7QeQUYAFaKU1yE2OfhAAAAAElFTkSuQmCC",e},e.prototype.createCheckboxUncheckedReadOnlyIcon=function(){
	var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjE4MjE1MTc0NDVFMTFFNjgyNzA5QzQ5MjBBRTM0QTkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjE4MjE1MTg0NDVFMTFFNjgyNzA5QzQ5MjBBRTM0QTkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTgyMTUxNTQ0NUUxMUU2ODI3MDlDNDkyMEFFMzRBOSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo2MTgyMTUxNjQ0NUUxMUU2ODI3MDlDNDkyMEFFMzRBOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoIZc5kAAADFSURBVHjaYvz//z8DDDx69EgESBUBsQ8Qq0GFbwDxJiCeJCcn9wamlhGmEagpGEjNBWJ+BuzgExAnATWvhWuEaloN4jPgByBbQkGaGR8+fCgK5NwBYj4G4gDIZlUmIJFLgiYGqNoCkEY/BtKBD0ijBhka1ZkYyAO/mKDxRCq4xwSNXFLBVlB0iAEZt0mODmBkvgKlCGjkMhCRAECp5xU4cKDJKAyIP+PR9BmWalDSKloi9wUFOSj0gPgWyE9APBE5kQMEGAD0/UBfnjaiGAAAAABJRU5ErkJggg==",e},e.prototype.createCheckboxIndeterminateIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA2ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpFQ0VGQkU3ODM4MTFFNjExQjlCQzhERUVDNkNGMzFDMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDpGMjU4MzhGQjEyM0ExMUU2QjAxM0Q2QjZFQ0IzNzM4NiIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDpGMjU4MzhGQTEyM0ExMUU2QjAxM0Q2QjZFQ0IzNzM4NiIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M2IChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjIzMkM4M0M1M0MxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkVDRUZCRTc4MzgxMUU2MTFCOUJDOERFRUM2Q0YzMUMzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+2Xml2QAAAGBJREFUeNpiYGBg8ATiZ0D8n0j8DKqH4dnhw4f/EwtAakF6GEGmAAEDKYCRkZGBiYFMQH+NLNjcjw2ghwMLIQWDx48Do/H5kSNHiNZw9OhREPUCRHiBNJOQyJ+A9AAEGACqkFldNkPUwwAAAABJRU5ErkJggg==",e},e.prototype.createCheckboxIndeterminateReadOnlyIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6Nzg3RjczNTA0NDVFMTFFNkE4Q0NDN0E3NUI3Qjk5QjIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6Nzg3RjczNTE0NDVFMTFFNkE4Q0NDN0E3NUI3Qjk5QjIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3ODdGNzM0RTQ0NUUxMUU2QThDQ0M3QTc1QjdCOTlCMiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3ODdGNzM0RjQ0NUUxMUU2QThDQ0M3QTc1QjdCOTlCMiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhD2+R8AAADRSURBVHjaYvz//z8DDDx69EgESBUBsQ8Qq0GFbwDxJiCeJCcn9wamlhGmEagpGEjNBWJ+BuzgExAnATWvhWuEaloN4jPgByBbQkGaGR8+fCgK5NwBYj4G4gDIZlUmIJFLgiYGqNoCkEY/BtKBDwuQ0IDx5OXl8aoGegvGVGdiIA/8YoHGkz6aiYTAPSZo5JIKtoKiQwzIuE1ydAAj8xUoRUAjl4GIBABKPa/AgQNNRmFA/BmPps+wVIOSVtESuS8oyEGhB8S3QH4C4onIiRwgwABzikY1hHfO+QAAAABJRU5ErkJggg==",e},e.prototype.createGroupExpandedIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NzBBODQ4M0ExMjM4MTFFNkFDNEJDMjUzQUJBQ0I2QjkiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NzBBODQ4M0IxMjM4MTFFNkFDNEJDMjUzQUJBQ0I2QjkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3MEE4NDgzODEyMzgxMUU2QUM0QkMyNTNBQkFDQjZCOSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3MEE4NDgzOTEyMzgxMUU2QUM0QkMyNTNBQkFDQjZCOSIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhKAo60AAADVSURBVHjajFC9DkRgEJzzFhqiligURKcjR+UFJK7wGN7jOq+glXgCvSgUCnyVn47GHsVdcURsss3s7OzOPEzTdB3HeTPGeMMw0DQNOI4Dz/PI8xyWZSGO4y4MwxeSJGnruqarGseRNE1r4fv+YSgIwgErioJwpgrggHmeR7Bt+xZ5GAbCNE2/0zvpv78v6bpOUFX1lvK6roQz92dkWZYJiqLcSmOeZ9qDb6uqusx5WRaSJIlBFEUnTdNuC536vifXdaksSwqCgLIsoyiKdnNs23l+BBgAK/54I/P5bhMAAAAASUVORK5CYII=",e},e.prototype.createGroupContractedIcon=function(){var e=document.createElement("img");return e.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N0U2QUVBRDYxMjM4MTFFNjk3NjVBRUM0MUJDRjFCODgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6N0U2QUVBRDcxMjM4MTFFNjk3NjVBRUM0MUJDRjFCODgiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo3RTZBRUFENDEyMzgxMUU2OTc2NUFFQzQxQkNGMUI4OCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo3RTZBRUFENTEyMzgxMUU2OTc2NUFFQzQxQkNGMUI4OCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhjzsKsAAADSSURBVHjajJAvioVgFMXPuAuLYhYMBsVmU54mNyA4wWW4j2luwSq4ArsYDAZ9X/JP0+KZ58CkgTffD264l3MPnPPh+34cRdGXEEL1PA/TNEFRFKiqirZtEQQByrJ85nn+iaqq5nEc+Y5t2+g4zow0TSlD13XEf66/JElChGEoJV7Xldj3/WfRNI0A/sx9v3Fdl7BtW8r5ui6CkpimSViWJSU+joN38fMwDG+F53nSMAwBXdejuq6fr9K5LAvjOGbf98yyjE3TsCiKO5x4/Ty+BRgA3R6JXc/jqsQAAAAASUVORK5CYII=",e},e}();t.SvgFactory=r},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(6),l=o(54),a=function(){function e(){}return e.prototype.useCellRenderer=function(e,t,o){var i=this.lookUpCellRenderer(e);if(!r.Utils.missing(i)){var n,s=null;this.checkForDeprecatedItems(i);var l=this.doesImplementICellRenderer(i);if(l){var a=i;s=new a,this.context.wireBean(s),s.init&&s.init(o),n=s.getGui()}else{var p=i;n=p(o)}if(null!==n&&""!==n)return r.Utils.isNodeOrElement(n)?t.appendChild(n):t.innerHTML=n,s}},e.prototype.checkForDeprecatedItems=function(e){e&&e.renderer&&console.warn("ag-grid: colDef.cellRenderer should not be an object, it should be a string, function or class. this changed in v4.1.x, please check the documentation on Cell Rendering, or if you are doing grouping, look at the grouping examples.")},e.prototype.doesImplementICellRenderer=function(e){return e.prototype&&"getGui"in e.prototype},e.prototype.lookUpCellRenderer=function(e){return"string"==typeof e?this.cellRendererFactory.getCellRenderer(e):e},i([s.Autowired("cellRendererFactory"),n("design:type",l.CellRendererFactory)],e.prototype,"cellRendererFactory",void 0),i([s.Autowired("context"),n("design:type",s.Context)],e.prototype,"context",void 0),e=i([s.Bean("cellRendererService"),n("design:paramtypes",[])],e)}();t.CellRendererService=a},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(3),l=function(){function e(){}return e.prototype.formatValue=function(e,t,o,i,n){var r,s=e.getColDef();r=t.floating&&s.floatingCellFormatter?s.floatingCellFormatter:s.cellFormatter;var l=null;if(r){var a={value:n,node:t,column:e,$scope:o,rowIndex:i,api:this.gridOptionsWrapper.getApi(),context:this.gridOptionsWrapper.getContext()};l=r(a)}return l},i([r.Autowired("gridOptionsWrapper"),n("design:type",s.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),e=i([r.Bean("valueFormatterService"),n("design:paramtypes",[])],e)}();t.ValueFormatterService=l},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},r=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},s=o(47),l=o(27),a=o(7),p=o(6),d=o(3),u=o(58),c=u.SvgFactory.getInstance(),h=function(e){function t(){e.call(this,'<span class="ag-selection-checkbox"/>')}return i(t,e),t.prototype.createAndAddIcons=function(){this.eCheckedIcon=a.Utils.createIconNoSpan("checkboxChecked",this.gridOptionsWrapper,null,c.createCheckboxCheckedIcon),this.eUncheckedIcon=a.Utils.createIconNoSpan("checkboxUnchecked",this.gridOptionsWrapper,null,c.createCheckboxUncheckedIcon),this.eIndeterminateIcon=a.Utils.createIconNoSpan("checkboxIndeterminate",this.gridOptionsWrapper,null,c.createCheckboxIndeterminateIcon);var e=this.getGui();e.appendChild(this.eCheckedIcon),e.appendChild(this.eUncheckedIcon),e.appendChild(this.eIndeterminateIcon)},t.prototype.onSelectionChanged=function(){var e=this.rowNode.isSelected();a.Utils.setVisible(this.eCheckedIcon,e===!0),a.Utils.setVisible(this.eUncheckedIcon,e===!1),a.Utils.setVisible(this.eIndeterminateIcon,"boolean"!=typeof e)},t.prototype.onCheckedClicked=function(){this.rowNode.setSelected(!1)},t.prototype.onUncheckedClicked=function(e){this.rowNode.setSelectedParams({newValue:!0,rangeSelect:e.shiftKey})},t.prototype.onIndeterminateClicked=function(e){this.rowNode.setSelectedParams({newValue:!0,rangeSelect:e.shiftKey})},t.prototype.init=function(e){this.createAndAddIcons(),this.rowNode=e.rowNode,this.onSelectionChanged(),this.addGuiEventListener("click",function(e){return e.stopPropagation()}),this.addGuiEventListener("dblclick",function(e){return e.stopPropagation()}),this.addDestroyableEventListener(this.eCheckedIcon,"click",this.onCheckedClicked.bind(this)),this.addDestroyableEventListener(this.eUncheckedIcon,"click",this.onUncheckedClicked.bind(this)),this.addDestroyableEventListener(this.eIndeterminateIcon,"click",this.onIndeterminateClicked.bind(this)),this.addDestroyableEventListener(this.rowNode,l.RowNode.EVENT_ROW_SELECTED,this.onSelectionChanged.bind(this))},n([p.Autowired("gridOptionsWrapper"),r("design:type",d.GridOptionsWrapper)],t.prototype,"gridOptionsWrapper",void 0),t}(s.Component);t.CheckboxSelectionComponent=h},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(7),n=o(15),r=function(){function e(e,t){this.destroyFunctions=[],this.columnOrGroup=e,this.eCell=t,this.init()}return e.prototype.init=function(){var e=this,t=this.onLeftChanged.bind(this);this.columnOrGroup.addEventListener(n.Column.EVENT_LEFT_CHANGED,t),this.destroyFunctions.push(function(){e.columnOrGroup.removeEventListener(n.Column.EVENT_LEFT_CHANGED,t)}),this.onLeftChanged()},e.prototype.onLeftChanged=function(){var e=this.columnOrGroup.getLeft();i.Utils.exists(e)?this.eCell.style.left=this.columnOrGroup.getLeft()+"px":this.eCell.style.left=""},e.prototype.destroy=function(){this.destroyFunctions.forEach(function(e){e()})},e}();t.SetLeftFeature=r},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(8),l=o(13),a=o(26),p=o(7),d=o(34),u=o(33),c=function(){function e(){}return e.prototype.getNextCellToFocus=function(e,t){switch(e){case s.Constants.KEY_UP:return this.getCellAbove(t);case s.Constants.KEY_DOWN:return this.getCellBelow(t);case s.Constants.KEY_RIGHT:return this.getCellToRight(t);case s.Constants.KEY_LEFT:return this.getCellToLeft(t);default:console.log("ag-Grid: unknown key for navigation "+e)}},e.prototype.getCellToLeft=function(e){var t=this.columnController.getDisplayedColBefore(e.column);return t?new u.GridCell(e.rowIndex,e.floating,t):null},e.prototype.getCellToRight=function(e){var t=this.columnController.getDisplayedColAfter(e.column);return t?new u.GridCell(e.rowIndex,e.floating,t):null},e.prototype.getRowBelow=function(e){return this.isLastRowInContainer(e)?e.isFloatingBottom()?null:e.isNotFloating()?this.floatingRowModel.isRowsToRender(s.Constants.FLOATING_BOTTOM)?new d.GridRow(0,s.Constants.FLOATING_BOTTOM):null:this.rowModel.isRowsToRender()?new d.GridRow(0,null):this.floatingRowModel.isRowsToRender(s.Constants.FLOATING_BOTTOM)?new d.GridRow(0,s.Constants.FLOATING_BOTTOM):null:new d.GridRow(e.rowIndex+1,e.floating)},e.prototype.getCellBelow=function(e){var t=this.getRowBelow(e.getGridRow());return t?new u.GridCell(t.rowIndex,t.floating,e.column):null},e.prototype.isLastRowInContainer=function(e){if(e.isFloatingTop()){var t=this.floatingRowModel.getFloatingTopRowData().length-1;return t===e.rowIndex}if(e.isFloatingBottom()){var o=this.floatingRowModel.getFloatingBottomRowData().length-1;return o===e.rowIndex}var i=this.rowModel.getRowCount()-1;return i===e.rowIndex},e.prototype.getRowAbove=function(e){return 0===e.rowIndex?e.isFloatingTop()?null:e.isNotFloating()?this.floatingRowModel.isRowsToRender(s.Constants.FLOATING_TOP)?this.getLastFloatingTopRow():null:this.rowModel.isRowsToRender()?this.getLastBodyCell():this.floatingRowModel.isRowsToRender(s.Constants.FLOATING_TOP)?this.getLastFloatingTopRow():null:new d.GridRow(e.rowIndex-1,e.floating)},e.prototype.getCellAbove=function(e){var t=this.getRowAbove(e.getGridRow());return t?new u.GridCell(t.rowIndex,t.floating,e.column):null},e.prototype.getLastBodyCell=function(){var e=this.rowModel.getRowCount()-1;return new d.GridRow(e,null)},e.prototype.getLastFloatingTopRow=function(){var e=this.floatingRowModel.getFloatingTopRowData().length-1;return new d.GridRow(e,s.Constants.FLOATING_TOP)},e.prototype.getNextTabbedCell=function(e,t){return t?this.getNextTabbedCellBackwards(e):this.getNextTabbedCellForwards(e)},e.prototype.getNextTabbedCellForwards=function(e){var t=this.columnController.getAllDisplayedColumns(),o=e.rowIndex,i=e.floating,n=this.columnController.getDisplayedColAfter(e.column);if(!n){n=t[0];var r=this.getRowBelow(e.getGridRow());if(p.Utils.missing(r))return;o=r.rowIndex,i=r.floating}return new u.GridCell(o,i,n)},e.prototype.getNextTabbedCellBackwards=function(e){var t=this.columnController.getAllDisplayedColumns(),o=e.rowIndex,i=e.floating,n=this.columnController.getDisplayedColBefore(e.column);if(!n){n=t[t.length-1];var r=this.getRowAbove(e.getGridRow());if(p.Utils.missing(r))return;o=r.rowIndex,i=r.floating}return new u.GridCell(o,i,n)},i([r.Autowired("columnController"),n("design:type",l.ColumnController)],e.prototype,"columnController",void 0),i([r.Autowired("rowModel"),n("design:type",Object)],e.prototype,"rowModel",void 0),i([r.Autowired("floatingRowModel"),n("design:type",a.FloatingRowModel)],e.prototype,"floatingRowModel",void 0),e=i([r.Bean("cellNavigationService"),n("design:paramtypes",[])],e)}();t.CellNavigationService=c},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(3),s=o(13),l=o(24),a=o(15),p=o(6),d=o(65),u=o(4),c=o(10),h=function(){function e(){}return e.prototype.init=function(){var e=this;this.eHeaderViewport=this.gridPanel.getHeaderViewport(),this.eRoot=this.gridPanel.getRoot(),this.eHeaderOverlay=this.gridPanel.getHeaderOverlay(),this.centerContainer=new d.HeaderContainer(this.gridPanel.getHeaderContainer(),this.gridPanel.getHeaderViewport(),this.eRoot,null),this.childContainers=[this.centerContainer],this.gridOptionsWrapper.isForPrint()||(this.pinnedLeftContainer=new d.HeaderContainer(this.gridPanel.getPinnedLeftHeader(),null,this.eRoot,a.Column.PINNED_LEFT),this.pinnedRightContainer=new d.HeaderContainer(this.gridPanel.getPinnedRightHeader(),null,this.eRoot,a.Column.PINNED_RIGHT),this.childContainers.push(this.pinnedLeftContainer),this.childContainers.push(this.pinnedRightContainer)),this.childContainers.forEach(function(t){return e.context.wireBean(t)}),this.eventService.addEventListener(c.Events.EVENT_GRID_COLUMNS_CHANGED,this.onGridColumnsChanged.bind(this)),this.eventService.addEventListener(c.Events.EVENT_COLUMN_VALUE_CHANGED,this.refreshHeader.bind(this)),this.eventService.addEventListener(c.Events.EVENT_COLUMN_RESIZED,this.setPinnedColContainerWidth.bind(this)),this.eventService.addEventListener(c.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,this.setPinnedColContainerWidth.bind(this)),this.columnController.isReady()&&this.refreshHeader()},e.prototype.forEachHeaderElement=function(e){this.childContainers.forEach(function(t){return t.forEachHeaderElement(e)})},e.prototype.destroy=function(){this.childContainers.forEach(function(e){return e.destroy()})},e.prototype.onGridColumnsChanged=function(){this.setHeight()},e.prototype.refreshHeader=function(){this.setHeight(),this.childContainers.forEach(function(e){return e.refresh()}),this.setPinnedColContainerWidth()},e.prototype.setHeight=function(){if(this.eHeaderOverlay){var e=this.gridOptionsWrapper.getHeaderHeight(),t=this.columnController.getHeaderRowCount();this.eHeaderOverlay.style.height=e+"px",this.eHeaderOverlay.style.top=(t-1)*e+"px"}},e.prototype.setPinnedColContainerWidth=function(){if(!this.gridOptionsWrapper.isForPrint()){var e=this.columnController.getPinnedLeftContainerWidth();this.eHeaderViewport.style.marginLeft=e+"px",this.pinnedLeftContainer.setWidth(e);var t=this.columnController.getPinnedRightContainerWidth();this.eHeaderViewport.style.marginRight=t+"px",this.pinnedRightContainer.setWidth(t)}},i([p.Autowired("gridOptionsWrapper"),n("design:type",r.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([p.Autowired("columnController"),n("design:type",s.ColumnController)],e.prototype,"columnController",void 0),i([p.Autowired("gridPanel"),n("design:type",l.GridPanel)],e.prototype,"gridPanel",void 0),i([p.Autowired("context"),n("design:type",p.Context)],e.prototype,"context",void 0),i([p.Autowired("eventService"),n("design:type",u.EventService)],e.prototype,"eventService",void 0),i([p.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),i([p.PreDestroy,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"destroy",null),e=i([p.Bean("headerRenderer"),n("design:paramtypes",[])],e)}();t.HeaderRenderer=h},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(3),l=o(6),a=o(66),p=o(13),d=o(24),u=o(4),c=o(10),h=o(67),g=o(73),f=function(){function e(e,t,o,i){this.headerRowComps=[],this.eContainer=e,this.eRoot=o,this.pinned=i,this.eViewport=t}return e.prototype.setWidth=function(e){this.eContainer.style.width=e+"px"},e.prototype.forEachHeaderElement=function(e){this.headerRowComps.forEach(function(t){return t.forEachHeaderElement(e)})},e.prototype.init=function(){this.setupDragAndDrop(),this.eventService.addEventListener(c.Events.EVENT_COLUMN_VALUE_CHANGED,this.onGridColumnsChanged.bind(this)),this.eventService.addEventListener(c.Events.EVENT_GRID_COLUMNS_CHANGED,this.onGridColumnsChanged.bind(this))},e.prototype.destroy=function(){this.removeHeaderRowComps()},e.prototype.onGridColumnsChanged=function(){this.removeHeaderRowComps(),this.createHeaderRowComps()},e.prototype.refresh=function(){this.onGridColumnsChanged()},e.prototype.setupDragAndDrop=function(){var e=this.eViewport?this.eViewport:this.eContainer,t=new g.BodyDropTarget(this.pinned,e);this.context.wireBean(t)},e.prototype.removeHeaderRowComps=function(){this.headerRowComps.forEach(function(e){e.destroy()}),this.headerRowComps.length=0,r.Utils.removeAllChildren(this.eContainer)},e.prototype.createHeaderRowComps=function(){for(var e=this.columnController.getHeaderRowCount(),t=0;t<e;t++){var o=t!==e-1,i=new h.HeaderRowComp(t,o,this.pinned,this.eRoot,this.dropTarget);this.context.wireBean(i),this.headerRowComps.push(i),this.eContainer.appendChild(i.getGui())}},i([l.Autowired("gridOptionsWrapper"),n("design:type",s.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([l.Autowired("context"),n("design:type",l.Context)],e.prototype,"context",void 0),i([l.Autowired("$scope"),n("design:type",Object)],e.prototype,"$scope",void 0),i([l.Autowired("dragAndDropService"),n("design:type",a.DragAndDropService)],e.prototype,"dragAndDropService",void 0),i([l.Autowired("columnController"),n("design:type",p.ColumnController)],e.prototype,"columnController",void 0),i([l.Autowired("gridPanel"),n("design:type",d.GridPanel)],e.prototype,"gridPanel",void 0),i([l.Autowired("eventService"),n("design:type",u.EventService)],e.prototype,"eventService",void 0),i([l.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e}();t.HeaderContainer=f},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(5),l=o(6),a=o(7),p=o(3),d=o(58),u=o(31),c=o(13),h=d.SvgFactory.getInstance();!function(e){e[e.ToolPanel=0]="ToolPanel",e[e.HeaderCell=1]="HeaderCell"}(t.DragSourceType||(t.DragSourceType={}));var g=(t.DragSourceType,function(){function e(){this.dropTargets=[]}return e.prototype.init=function(){this.ePinnedIcon=a.Utils.createIcon("columnMovePin",this.gridOptionsWrapper,null,h.createPinIcon),this.ePlusIcon=a.Utils.createIcon("columnMoveAdd",this.gridOptionsWrapper,null,h.createPlusIcon),this.eHiddenIcon=a.Utils.createIcon("columnMoveHide",this.gridOptionsWrapper,null,h.createColumnHiddenIcon),this.eMoveIcon=a.Utils.createIcon("columnMoveMove",this.gridOptionsWrapper,null,h.createMoveIcon),this.eLeftIcon=a.Utils.createIcon("columnMoveLeft",this.gridOptionsWrapper,null,h.createLeftIcon),this.eRightIcon=a.Utils.createIcon("columnMoveRight",this.gridOptionsWrapper,null,h.createRightIcon),this.eGroupIcon=a.Utils.createIcon("columnMoveGroup",this.gridOptionsWrapper,null,h.createGroupIcon),this.eAggregateIcon=a.Utils.createIcon("columnMoveValue",this.gridOptionsWrapper,null,h.createAggregationIcon),this.ePivotIcon=a.Utils.createIcon("columnMovePivot",this.gridOptionsWrapper,null,h.createPivotIcon),this.eDropNotAllowedIcon=a.Utils.createIcon("dropNotAllowed",this.gridOptionsWrapper,null,h.createDropNotAllowedIcon)},e.prototype.setBeans=function(e){this.logger=e.create("OldToolPanelDragAndDropService"),this.eBody=document.querySelector("body"),this.eBody||console.warn("ag-Grid: could not find document body, it is needed for dragging columns")},e.prototype.addDragSource=function(e){this.dragService.addDragSource({eElement:e.eElement,onDragStart:this.onDragStart.bind(this,e),onDragStop:this.onDragStop.bind(this),onDragging:this.onDragging.bind(this)})},e.prototype.nudge=function(){this.dragging&&this.onDragging(this.eventLastTime,!0)},e.prototype.onDragStart=function(e,t){this.dragging=!0,this.dragSource=e,this.eventLastTime=t,this.dragSource.dragItem.forEach(function(e){return e.setMoving(!0)}),this.dragItem=this.dragSource.dragItem,this.lastDropTarget=this.dragSource.dragSourceDropTarget,this.createGhost()},e.prototype.onDragStop=function(e){if(this.eventLastTime=null,this.dragging=!1,this.dragItem.forEach(function(e){return e.setMoving(!1)}),this.lastDropTarget&&this.lastDropTarget.onDragStop){var t=this.createDropTargetEvent(this.lastDropTarget,e,null,!1);this.lastDropTarget.onDragStop(t)}this.lastDropTarget=null,this.dragItem=null,this.removeGhost()},e.prototype.onDragging=function(e,t){var o=this.workOutDirection(e);this.eventLastTime=e,this.positionGhost(e);var i=a.Utils.find(this.dropTargets,this.isMouseOnDropTarget.bind(this,e));if(i!==this.lastDropTarget)this.leaveLastTargetIfExists(e,o,t),this.enterDragTargetIfExists(i,e,o,t),this.lastDropTarget=i;else if(i){var n=this.createDropTargetEvent(i,e,o,t);i.onDragging(n)}},e.prototype.enterDragTargetIfExists=function(e,t,o,i){if(e){var n=this.createDropTargetEvent(e,t,o,i);e.onDragEnter(n),this.setGhostIcon(e.getIconName?e.getIconName():null)}},e.prototype.leaveLastTargetIfExists=function(e,t,o){if(this.lastDropTarget){var i=this.createDropTargetEvent(this.lastDropTarget,e,t,o);this.lastDropTarget.onDragLeave(i),this.setGhostIcon(null)}},e.prototype.getAllContainersFromDropTarget=function(e){var t=[e.getContainer()],o=e.getSecondaryContainers?e.getSecondaryContainers():null;return o&&(t=t.concat(o)),t},e.prototype.isMouseOnDropTarget=function(e,t){var o=this.getAllContainersFromDropTarget(t),i=!1;return o.forEach(function(t){if(t){var o=t.getBoundingClientRect();if(0!==o.width&&0!==o.height){var n=e.clientX>=o.left&&e.clientX<=o.right,r=e.clientY>=o.top&&e.clientY<=o.bottom;n&&r&&(i=!0)}}}),i},e.prototype.addDropTarget=function(e){this.dropTargets.push(e)},e.prototype.workOutDirection=function(t){var o;return o=this.eventLastTime.clientX>t.clientX?e.DIRECTION_LEFT:this.eventLastTime.clientX<t.clientX?e.DIRECTION_RIGHT:null},e.prototype.createDropTargetEvent=function(e,t,o,i){var n=e.getContainer().getBoundingClientRect(),r=t.clientX-n.left,s=t.clientY-n.top,l={event:t,x:r,y:s,direction:o,dragSource:this.dragSource,fromNudge:i};return l},e.prototype.positionGhost=function(e){var t=this.eGhost.getBoundingClientRect(),o=t.height,i=a.Utils.getBodyWidth()-2,n=a.Utils.getBodyHeight()-2,r=e.pageY-o/2,s=e.pageX-30,l=window.pageYOffset||document.documentElement.scrollTop,p=window.pageXOffset||document.documentElement.scrollLeft;i>0&&s+this.eGhost.clientWidth>i+p&&(s=i+p-this.eGhost.clientWidth),s<0&&(s=0),n>0&&r+this.eGhost.clientHeight>n+l&&(r=n+l-this.eGhost.clientHeight),r<0&&(r=0),this.eGhost.style.left=s+"px",this.eGhost.style.top=r+"px"},e.prototype.removeGhost=function(){this.eGhost&&this.eBody.removeChild(this.eGhost),this.eGhost=null},e.prototype.createGhost=function(){this.eGhost=a.Utils.loadTemplate(e.GHOST_TEMPLATE),this.eGhostIcon=this.eGhost.querySelector(".ag-dnd-ghost-icon"),this.lastDropTarget&&this.setGhostIcon(this.lastDropTarget.getIconName?this.lastDropTarget.getIconName():null);var t=this.eGhost.querySelector(".ag-dnd-ghost-label");t.innerHTML=this.dragSource.dragItemName,this.eGhost.style.height=this.gridOptionsWrapper.getHeaderHeight()+"px",this.eGhost.style.top="20px",this.eGhost.style.left="20px",this.eBody.appendChild(this.eGhost)},e.prototype.setGhostIcon=function(t,o){void 0===o&&(o=!1),a.Utils.removeAllChildren(this.eGhostIcon);var i;switch(t){case e.ICON_ADD:i=this.ePlusIcon;break;case e.ICON_PINNED:i=this.ePinnedIcon;break;case e.ICON_MOVE:i=this.eMoveIcon;break;case e.ICON_LEFT:i=this.eLeftIcon;break;case e.ICON_RIGHT:i=this.eRightIcon;break;case e.ICON_GROUP:i=this.eGroupIcon;break;case e.ICON_AGGREGATE:i=this.eAggregateIcon;break;case e.ICON_PIVOT:i=this.ePivotIcon;break;case e.ICON_NOT_ALLOWED:i=this.eDropNotAllowedIcon;break;default:i=this.eHiddenIcon}this.eGhostIcon.appendChild(i),a.Utils.addOrRemoveCssClass(this.eGhostIcon,"ag-shake-left-to-right",o)},e.DIRECTION_LEFT="left",e.DIRECTION_RIGHT="right",e.ICON_PINNED="pinned",e.ICON_ADD="add",e.ICON_MOVE="move",e.ICON_LEFT="left",e.ICON_RIGHT="right",e.ICON_GROUP="group",e.ICON_AGGREGATE="aggregate",e.ICON_PIVOT="pivot",e.ICON_NOT_ALLOWED="notAllowed",e.GHOST_TEMPLATE='<div class="ag-dnd-ghost">  <span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>  <div class="ag-dnd-ghost-label">  </div></div>',i([l.Autowired("gridOptionsWrapper"),n("design:type",p.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([l.Autowired("dragService"),n("design:type",u.DragService)],e.prototype,"dragService",void 0),i([l.Autowired("columnController"),n("design:type",c.ColumnController)],e.prototype,"columnController",void 0),i([l.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),i([r(0,l.Qualifier("loggerFactory")),n("design:type",Function),n("design:paramtypes",[s.LoggerFactory]),n("design:returntype",void 0)],e.prototype,"setBeans",null),e=i([l.Bean("dragAndDropService"),n("design:paramtypes",[])],e)}());t.DragAndDropService=g},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},r=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},s=o(47),l=o(6),a=o(3),p=o(14),d=o(13),u=o(68),c=o(71),h=o(4),g=o(10),f=o(7),y=function(e){function t(t,o,i,n,r){e.call(this,'<div class="ag-header-row"/>'),this.headerElements={},this.dept=t,this.showingGroups=o,this.pinned=i,this.eRoot=n,this.dropTarget=r}return i(t,e),t.prototype.forEachHeaderElement=function(e){var t=this;Object.keys(this.headerElements).forEach(function(o){var i=t.headerElements[o];e(i)})},t.prototype.destroy=function(){var t=Object.keys(this.headerElements);this.removeAndDestroyChildComponents(t),e.prototype.destroy.call(this)},t.prototype.removeAndDestroyChildComponents=function(e){var t=this;e.forEach(function(e){var o=t.headerElements[e];t.getGui().removeChild(o.getGui()),o.destroy(),delete t.headerElements[e]})},t.prototype.onRowHeightChanged=function(){var e=this.gridOptionsWrapper.getHeaderHeight();this.getGui().style.top=this.dept*e+"px",this.getGui().style.height=e+"px"},t.prototype.init=function(){this.onRowHeightChanged(),this.onVirtualColumnsChanged(),this.addDestroyableEventListener(this.gridOptionsWrapper,a.GridOptionsWrapper.PROP_HEADER_HEIGHT,this.onRowHeightChanged.bind(this)),this.addDestroyableEventListener(this.eventService,g.Events.EVENT_VIRTUAL_COLUMNS_CHANGED,this.onVirtualColumnsChanged.bind(this)),this.addDestroyableEventListener(this.eventService,g.Events.EVENT_DISPLAYED_COLUMNS_CHANGED,this.onDisplayedColumnsChanged.bind(this))},t.prototype.onDisplayedColumnsChanged=function(){if(this.showingGroups){var e=Object.keys(this.headerElements);this.removeAndDestroyChildComponents(e)}this.onVirtualColumnsChanged()},t.prototype.onVirtualColumnsChanged=function(){var e=this,t=Object.keys(this.headerElements),o=this.columnController.getVirtualHeaderGroupRow(this.pinned,this.dept);o.forEach(function(o){var i=o.getUniqueId();if(t.indexOf(i)>=0)return void f.Utils.removeFromArray(t,i);if(!(o instanceof p.ColumnGroup&&0===o.getDisplayedChildren().length)){var n=e.createHeaderElement(o);e.headerElements[i]=n,e.getGui().appendChild(n.getGui())}}),this.removeAndDestroyChildComponents(t)},t.prototype.createHeaderElement=function(e){var t;return t=e instanceof p.ColumnGroup?new u.RenderedHeaderGroupCell(e,this.eRoot,this.dropTarget):new c.RenderedHeaderCell(e,this.eRoot,this.dropTarget),this.context.wireBean(t),t},n([l.Autowired("gridOptionsWrapper"),r("design:type",a.GridOptionsWrapper)],t.prototype,"gridOptionsWrapper",void 0),n([l.Autowired("columnController"),r("design:type",d.ColumnController)],t.prototype,"columnController",void 0),n([l.Autowired("context"),r("design:type",l.Context)],t.prototype,"context",void 0),n([l.Autowired("eventService"),r("design:type",h.EventService)],t.prototype,"eventService",void 0),n([l.PostConstruct,r("design:type",Function),r("design:paramtypes",[]),r("design:returntype",void 0)],t.prototype,"init",null),t}(s.Component);t.HeaderRowComp=y},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(58),l=o(13),a=o(43),p=o(3),d=o(15),u=o(69),c=o(6),h=o(70),g=o(66),f=o(62),y=s.SvgFactory.getInstance(),v=function(){function e(e,t,o){this.destroyFunctions=[],this.columnGroup=e,this.eRoot=t,this.dragSourceDropTarget=o}return e.prototype.getGui=function(){return this.eHeaderGroupCell},e.prototype.onIndividualColumnResized=function(e){this.columnGroup.isChildInThisGroupDeepSearch(e)&&this.setWidth()},e.prototype.init=function(){this.eHeaderGroupCell=document.createElement("div"),h.CssClassApplier.addHeaderClassesFromCollDef(this.columnGroup.getColGroupDef(),this.eHeaderGroupCell,this.gridOptionsWrapper),this.displayName=this.columnGroup.getHeaderName(),this.setupResize(),this.addClasses(),this.setupLabel(),this.setupMove(),this.setWidth();var e=new f.SetLeftFeature(this.columnGroup,this.eHeaderGroupCell);this.destroyFunctions.push(e.destroy.bind(e))},e.prototype.setupLabel=function(){if(this.displayName&&""!==this.displayName){var e=document.createElement("div");e.className="ag-header-group-cell-label",this.eHeaderGroupCell.appendChild(e),r.Utils.isBrowserSafari()&&(e.style.display="table-cell");var t=document.createElement("span");t.className="ag-header-group-text",t.innerHTML=this.displayName,e.appendChild(t),this.columnGroup.isExpandable()&&this.addGroupExpandIcon(e)}},e.prototype.addClasses=function(){r.Utils.addCssClass(this.eHeaderGroupCell,"ag-header-group-cell"),this.columnGroup.getColGroupDef()?r.Utils.addCssClass(this.eHeaderGroupCell,"ag-header-group-cell-with-group"):r.Utils.addCssClass(this.eHeaderGroupCell,"ag-header-group-cell-no-group")},e.prototype.setupResize=function(){var e=this;this.gridOptionsWrapper.isEnableColResize()&&(this.eHeaderCellResize=document.createElement("div"),this.eHeaderCellResize.className="ag-header-cell-resize",this.eHeaderGroupCell.appendChild(this.eHeaderCellResize),this.dragService.addDragHandling({eDraggableElement:this.eHeaderCellResize,eBody:this.eRoot,cursor:"col-resize",startAfterPixels:0,onDragStart:this.onDragStart.bind(this),onDragging:this.onDragging.bind(this)}),this.gridOptionsWrapper.isSuppressAutoSize()||this.eHeaderCellResize.addEventListener("dblclick",function(t){var o=[];e.columnGroup.getDisplayedLeafColumns().forEach(function(e){e.getColDef().suppressAutoSize||o.push(e.getColId())}),o.length>0&&e.columnController.autoSizeColumns(o)}))},e.prototype.isSuppressMoving=function(){var e=!1;this.columnGroup.getLeafColumns().forEach(function(t){t.getColDef().suppressMovable&&(e=!0)});var t=e||this.gridOptionsWrapper.isSuppressMovableColumns()||this.gridOptionsWrapper.isForPrint();return t},e.prototype.setupMove=function(){var e=this.eHeaderGroupCell.querySelector(".ag-header-group-cell-label");if(e&&!this.isSuppressMoving()&&e){var t={type:g.DragSourceType.HeaderCell,eElement:e,dragItemName:this.displayName,dragItem:this.getAllColumnsInThisGroup(),dragSourceDropTarget:this.dragSourceDropTarget};this.dragAndDropService.addDragSource(t)}},e.prototype.getAllColumnsInThisGroup=function(){var e=this.columnGroup.getOriginalColumnGroup().getLeafColumns(),t=[];return this.columnController.getAllDisplayedColumns().forEach(function(o){e.indexOf(o)>=0&&(t.push(o),r.Utils.removeFromArray(e,o))}),e.forEach(function(e){return t.push(e)}),t},e.prototype.setWidth=function(){var e=this,t=function(){e.eHeaderGroupCell.style.width=e.columnGroup.getActualWidth()+"px"};this.columnGroup.getLeafColumns().forEach(function(o){o.addEventListener(d.Column.EVENT_WIDTH_CHANGED,t),e.destroyFunctions.push(function(){o.removeEventListener(d.Column.EVENT_WIDTH_CHANGED,t)})}),t()},e.prototype.destroy=function(){this.destroyFunctions.forEach(function(e){e()})},e.prototype.addGroupExpandIcon=function(e){var t;t=this.columnGroup.isExpanded()?r.Utils.createIcon("columnGroupOpened",this.gridOptionsWrapper,null,y.createGroupContractedIcon):r.Utils.createIcon("columnGroupClosed",this.gridOptionsWrapper,null,y.createGroupExpandedIcon),t.className="ag-header-expand-icon",e.appendChild(t);var o=this;t.onclick=function(){var e=!o.columnGroup.isExpanded();o.columnController.setColumnGroupOpened(o.columnGroup,e)}},e.prototype.onDragStart=function(){var e=this;this.groupWidthStart=this.columnGroup.getActualWidth(),this.childrenWidthStarts=[],this.columnGroup.getDisplayedLeafColumns().forEach(function(t){e.childrenWidthStarts.push(t.getActualWidth())})},e.prototype.onDragging=function(e,t){var o=this,i=this.groupWidthStart+e,n=this.columnGroup.getMinWidth();i<n&&(i=n);var r=i/this.groupWidthStart,s=i,l=this.columnGroup.getDisplayedLeafColumns();l.forEach(function(e,i){var n,a=i!==l.length-1;if(a){var p=o.childrenWidthStarts[i];n=p*r,n<e.getMinWidth()&&(n=e.getMinWidth()),s-=n}else n=s;o.columnController.setColumnWidth(e,n,t)})},i([c.Autowired("filterManager"),n("design:type",a.FilterManager)],e.prototype,"filterManager",void 0),i([c.Autowired("gridOptionsWrapper"),n("design:type",p.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([c.Autowired("horizontalDragService"),n("design:type",u.HorizontalDragService)],e.prototype,"dragService",void 0),i([c.Autowired("columnController"),n("design:type",l.ColumnController)],e.prototype,"columnController",void 0),i([c.Autowired("dragAndDropService"),n("design:type",g.DragAndDropService)],e.prototype,"dragAndDropService",void 0),i([c.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e}();t.RenderedHeaderGroupCell=v},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=function(){function e(){}return e.prototype.addDragHandling=function(e){e.eDraggableElement.addEventListener("mousedown",function(t){new l(e,t)})},e=i([r.Bean("horizontalDragService"),n("design:paramtypes",[])],e)}();t.HorizontalDragService=s;var l=function(){function e(e,t){this.mouseMove=this.onMouseMove.bind(this),this.mouseUp=this.onMouseUp.bind(this),this.mouseLeave=this.onMouseLeave.bind(this),this.lastDelta=0,this.params=e,this.eDragParent=document.querySelector("body"),this.dragStartX=t.clientX,this.startEvent=t,this.eDragParent.addEventListener("mousemove",this.mouseMove),this.eDragParent.addEventListener("mouseup",this.mouseUp),this.eDragParent.addEventListener("mouseleave",this.mouseLeave),this.draggingStarted=!1;var o="number"==typeof e.startAfterPixels&&e.startAfterPixels>0;o||this.startDragging()}return e.prototype.startDragging=function(){this.draggingStarted=!0,this.oldBodyCursor=this.params.eBody.style.cursor,this.oldParentCursor=this.eDragParent.style.cursor,this.oldMsUserSelect=this.eDragParent.style.msUserSelect,this.oldWebkitUserSelect=this.eDragParent.style.webkitUserSelect,this.params.eBody.style.cursor=this.params.cursor,this.eDragParent.style.cursor=this.params.cursor,this.eDragParent.style.msUserSelect="none",this.eDragParent.style.webkitUserSelect="none",this.params.onDragStart(this.startEvent)},e.prototype.onMouseMove=function(e){var t=e.clientX;if(this.lastDelta=t-this.dragStartX,!this.draggingStarted){var o=Math.abs(this.lastDelta)>=this.params.startAfterPixels;o&&this.startDragging()}this.draggingStarted&&this.params.onDragging(this.lastDelta,!1)},e.prototype.onMouseUp=function(){this.stopDragging()},e.prototype.onMouseLeave=function(){this.stopDragging()},e.prototype.stopDragging=function(){this.draggingStarted&&(this.params.eBody.style.cursor=this.oldBodyCursor,this.eDragParent.style.cursor=this.oldParentCursor,this.eDragParent.style.msUserSelect=this.oldMsUserSelect,this.eDragParent.style.webkitUserSelect=this.oldWebkitUserSelect,this.params.onDragging(this.lastDelta,!0)),this.eDragParent.removeEventListener("mousemove",this.mouseMove),this.eDragParent.removeEventListener("mouseup",this.mouseUp),this.eDragParent.removeEventListener("mouseleave",this.mouseLeave)},e}()},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(7),n=function(){function e(){}return e.addHeaderClassesFromCollDef=function(e,t,o){if(e&&e.headerClass){var n;if("function"==typeof e.headerClass){var r={colDef:e,context:o.getContext(),api:o.getApi()},s=e.headerClass;n=s(r)}else n=e.headerClass;"string"==typeof n?i.Utils.addCssClass(t,n):Array.isArray(n)&&n.forEach(function(e){i.Utils.addCssClass(t,e)})}},e}();t.CssClassApplier=n},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(15),l=o(43),a=o(13),p=o(72),d=o(3),u=o(69),c=o(40),h=o(6),g=o(70),f=o(66),y=o(42),v=o(62),C=function(){function e(e,t,o){this.destroyFunctions=[],this.column=e,this.eRoot=t,this.dragSourceDropTarget=o}return e.prototype.getColumn=function(){return this.column},e.prototype.init=function(){this.eHeaderCell=this.headerTemplateLoader.createHeaderElement(this.column),r.Utils.addCssClass(this.eHeaderCell,"ag-header-cell"),this.createScope(),this.addAttributes(),g.CssClassApplier.addHeaderClassesFromCollDef(this.column.getColDef(),this.eHeaderCell,this.gridOptionsWrapper);var e=this.eHeaderCell.querySelector("#agHeaderCellLabel");this.displayName=this.columnController.getDisplayNameForCol(this.column,!0),this.setupMovingCss(),this.setupTooltip(),this.setupResize(),this.setupMove(e),this.setupMenu(),this.setupSort(e),this.setupFilterIcon(),this.setupText(),this.setupWidth();var t=new v.SetLeftFeature(this.column,this.eHeaderCell);this.destroyFunctions.push(t.destroy.bind(t))},e.prototype.setupTooltip=function(){var e=this.column.getColDef();e.headerTooltip&&(this.eHeaderCell.title=e.headerTooltip)},e.prototype.setupText=function(){var e,t=this.column.getColDef();t.headerCellRenderer?e=t.headerCellRenderer:this.gridOptionsWrapper.getHeaderCellRenderer()&&(e=this.gridOptionsWrapper.getHeaderCellRenderer());var o=this.eHeaderCell.querySelector("#agText");o&&(e?this.useRenderer(this.displayName,e,o):(o.className="ag-header-cell-text",o.innerHTML=this.displayName))},e.prototype.setupFilterIcon=function(){var e=this,t=this.eHeaderCell.querySelector("#agFilter");if(t){var o=function(){var o=e.column.isFilterActive();r.Utils.addOrRemoveCssClass(e.eHeaderCell,"ag-header-cell-filtered",o),r.Utils.addOrRemoveCssClass(t,"ag-hidden",!o)};this.column.addEventListener(s.Column.EVENT_FILTER_ACTIVE_CHANGED,o),this.destroyFunctions.push(function(){e.column.removeEventListener(s.Column.EVENT_FILTER_ACTIVE_CHANGED,o)}),o()}},e.prototype.setupWidth=function(){var e=this,t=function(){e.eHeaderCell.style.width=e.column.getActualWidth()+"px"};this.column.addEventListener(s.Column.EVENT_WIDTH_CHANGED,t),this.destroyFunctions.push(function(){e.column.removeEventListener(s.Column.EVENT_WIDTH_CHANGED,t)}),t()},e.prototype.getGui=function(){return this.eHeaderCell},e.prototype.destroy=function(){this.destroyFunctions.forEach(function(e){e()})},e.prototype.createScope=function(){var e=this;this.gridOptionsWrapper.isAngularCompileHeaders()&&(this.childScope=this.$scope.$new(),this.childScope.colDef=this.column.getColDef(),this.childScope.colDefWrapper=this.column,this.childScope.context=this.gridOptionsWrapper.getContext(),this.destroyFunctions.push(function(){e.childScope.$destroy()}))},e.prototype.addAttributes=function(){this.eHeaderCell.setAttribute("colId",this.column.getColId())},e.prototype.setupMenu=function(){var e=this,t=this.eHeaderCell.querySelector("#agMenu");if(t){var o=!this.menuFactory.isMenuEnabled(this.column)||this.column.getColDef().suppressMenu;if(o)return void r.Utils.removeFromParent(t);t.addEventListener("click",function(){return e.showMenu(t)}),this.gridOptionsWrapper.isSuppressMenuHide()||(t.style.opacity="0",this.eHeaderCell.addEventListener("mouseover",function(){t.style.opacity="1"}),this.eHeaderCell.addEventListener("mouseout",function(){t.style.opacity="0"}));var i=t.style;i.transition="opacity 0.2s, border 0.2s",i["-webkit-transition"]="opacity 0.2s, border 0.2s"}},e.prototype.showMenu=function(e){this.menuFactory.showMenuAfterButtonClick(this.column,e)},e.prototype.setupMovingCss=function(){var e=this,t=function(){e.column.isMoving()?r.Utils.addCssClass(e.eHeaderCell,"ag-header-cell-moving"):r.Utils.removeCssClass(e.eHeaderCell,"ag-header-cell-moving")};t(),this.column.addEventListener(s.Column.EVENT_MOVING_CHANGED,t),this.destroyFunctions.push(function(){e.column.removeEventListener(s.Column.EVENT_MOVING_CHANGED,t)})},e.prototype.setupMove=function(e){var t=this.gridOptionsWrapper.isSuppressMovableColumns()||this.column.getColDef().suppressMovable||this.gridOptionsWrapper.isForPrint();if(!t&&e){var o={type:f.DragSourceType.HeaderCell,eElement:e,dragItem:[this.column],dragItemName:this.displayName,dragSourceDropTarget:this.dragSourceDropTarget};this.dragAndDropService.addDragSource(o)}},e.prototype.setupResize=function(){var e=this,t=this.column.getColDef(),o=this.eHeaderCell.querySelector("#agResizeBar");if(o){var i=this.gridOptionsWrapper.isEnableColResize()&&!t.suppressResize;if(!i)return void r.Utils.removeFromParent(o);this.horizontalDragService.addDragHandling({eDraggableElement:o,eBody:this.eRoot,cursor:"col-resize",startAfterPixels:0,onDragStart:this.onDragStart.bind(this),onDragging:this.onDragging.bind(this)});var n=!this.gridOptionsWrapper.isSuppressAutoSize()&&!t.suppressAutoSize;n&&o.addEventListener("dblclick",function(){e.columnController.autoSizeColumn(e.column)})}},e.prototype.useRenderer=function(e,t,o){var i,n={colDef:this.column.getColDef(),$scope:this.childScope,context:this.gridOptionsWrapper.getContext(),value:e,api:this.gridOptionsWrapper.getApi(),eHeaderCell:this.eHeaderCell},s=t(n);if(r.Utils.isNodeOrElement(s))i=s;else{var l=document.createElement("span");l.innerHTML=s,i=l}if(this.gridOptionsWrapper.isAngularCompileHeaders()){var a=this.$compile(i)(this.childScope)[0];o.appendChild(a)}else o.appendChild(i)},e.prototype.setupSort=function(e){var t=this,o=this.gridOptionsWrapper.isEnableSorting()&&!this.column.getColDef().suppressSorting;if(!o)return r.Utils.removeFromParent(this.eHeaderCell.querySelector("#agSortAsc")),r.Utils.removeFromParent(this.eHeaderCell.querySelector("#agSortDesc")),void r.Utils.removeFromParent(this.eHeaderCell.querySelector("#agNoSort"));r.Utils.addCssClass(this.eHeaderCell,"ag-header-cell-sortable"),e&&e.addEventListener("click",function(e){t.sortController.progressSort(t.column,e.shiftKey)});var i=this.eHeaderCell.querySelector("#agSortAsc"),n=this.eHeaderCell.querySelector("#agSortDesc"),l=this.eHeaderCell.querySelector("#agNoSort"),a=function(){if(r.Utils.addOrRemoveCssClass(t.eHeaderCell,"ag-header-cell-sorted-asc",t.column.isSortAscending()),r.Utils.addOrRemoveCssClass(t.eHeaderCell,"ag-header-cell-sorted-desc",t.column.isSortDescending()),r.Utils.addOrRemoveCssClass(t.eHeaderCell,"ag-header-cell-sorted-none",t.column.isSortNone()),i&&r.Utils.addOrRemoveCssClass(i,"ag-hidden",!t.column.isSortAscending()),n&&r.Utils.addOrRemoveCssClass(n,"ag-hidden",!t.column.isSortDescending()),l){var e=!t.column.getColDef().unSortIcon&&!t.gridOptionsWrapper.isUnSortIcon();r.Utils.addOrRemoveCssClass(l,"ag-hidden",e||!t.column.isSortNone())}};this.column.addEventListener(s.Column.EVENT_SORT_CHANGED,a),this.destroyFunctions.push(function(){t.column.removeEventListener(s.Column.EVENT_SORT_CHANGED,a)}),a()},e.prototype.onDragStart=function(){this.startWidth=this.column.getActualWidth()},e.prototype.onDragging=function(e,t){var o=this.startWidth+e;this.columnController.setColumnWidth(this.column,o,t)},e.prototype.onIndividualColumnResized=function(e){if(this.column===e){var t=e.getActualWidth()+"px";this.eHeaderCell.style.width=t}},i([h.Autowired("context"),n("design:type",h.Context)],e.prototype,"context",void 0),i([h.Autowired("filterManager"),n("design:type",l.FilterManager)],e.prototype,"filterManager",void 0),i([h.Autowired("columnController"),n("design:type",a.ColumnController)],e.prototype,"columnController",void 0),i([h.Autowired("$compile"),n("design:type",Object)],e.prototype,"$compile",void 0),i([h.Autowired("gridCore"),n("design:type",c.GridCore)],e.prototype,"gridCore",void 0),i([h.Autowired("headerTemplateLoader"),n("design:type",p.HeaderTemplateLoader)],e.prototype,"headerTemplateLoader",void 0),i([h.Autowired("horizontalDragService"),n("design:type",u.HorizontalDragService)],e.prototype,"horizontalDragService",void 0),i([h.Autowired("menuFactory"),n("design:type",Object)],e.prototype,"menuFactory",void 0),i([h.Autowired("gridOptionsWrapper"),n("design:type",d.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([h.Autowired("dragAndDropService"),n("design:type",f.DragAndDropService)],e.prototype,"dragAndDropService",void 0),i([h.Autowired("sortController"),n("design:type",y.SortController)],e.prototype,"sortController",void 0),i([h.Autowired("$scope"),n("design:type",Object)],e.prototype,"$scope",void 0),i([h.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e}();t.RenderedHeaderCell=C},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(58),l=o(3),a=o(6),p=s.SvgFactory.getInstance(),d=function(){function e(){}return e.prototype.createHeaderElement=function(e){var t={column:e,colDef:e.getColDef,context:this.gridOptionsWrapper.getContext(),api:this.gridOptionsWrapper.getApi()},o=e.getColDef().headerCellTemplate;if("function"==typeof o){var i=o;o=i(t)}if(!o&&this.gridOptionsWrapper.getHeaderCellTemplate()&&(o=this.gridOptionsWrapper.getHeaderCellTemplate()),!o&&this.gridOptionsWrapper.getHeaderCellTemplateFunc()){var n=this.gridOptionsWrapper.getHeaderCellTemplateFunc();o=n(t)}o||(o=this.createDefaultHeaderElement(e));var s;return"string"==typeof o?s=r.Utils.loadTemplate(o):r.Utils.isNodeOrElement(o)?s=o:console.error("ag-Grid: header template must be a string or an HTML element"),s},e.prototype.createDefaultHeaderElement=function(t){var o=r.Utils.loadTemplate(e.HEADER_CELL_TEMPLATE);return this.addInIcon(o,"sortAscending","#agSortAsc",t,p.createArrowUpSvg),this.addInIcon(o,"sortDescending","#agSortDesc",t,p.createArrowDownSvg),this.addInIcon(o,"sortUnSort","#agNoSort",t,p.createArrowUpDownSvg),this.addInIcon(o,"menu","#agMenu",t,p.createMenuSvg),this.addInIcon(o,"filter","#agFilter",t,p.createFilterSvg),o},e.prototype.addInIcon=function(e,t,o,i,n){var s=r.Utils.createIconNoSpan(t,this.gridOptionsWrapper,i,n);e.querySelector(o).appendChild(s)},e.HEADER_CELL_TEMPLATE='<div class="ag-header-cell">  <div id="agResizeBar" class="ag-header-cell-resize"></div>  <span id="agMenu" class="ag-header-icon ag-header-cell-menu-button"></span>  <div id="agHeaderCellLabel" class="ag-header-cell-label">    <span id="agSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>    <span id="agSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>    <span id="agNoSort" class="ag-header-icon ag-sort-none-icon"></span>    <span id="agFilter" class="ag-header-icon ag-filter-icon"></span>    <span id="agText" class="ag-header-cell-text"></span>  </div></div>',i([a.Autowired("gridOptionsWrapper"),n("design:type",l.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),e=i([a.Bean("headerTemplateLoader"),n("design:paramtypes",[])],e)}();t.HeaderTemplateLoader=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(66),s=o(6),l=o(74),a=o(15),p=o(24),d=o(75),u=o(13),c=function(){function e(e,t){this.pinned=e,this.eContainer=t}return e.prototype.getSecondaryContainers=function(){return this.eSecondaryContainers},e.prototype.getContainer=function(){return this.eContainer},e.prototype.init=function(){switch(this.moveColumnController=new l.MoveColumnController(this.pinned),this.context.wireBean(this.moveColumnController),this.bodyDropPivotTarget=new d.BodyDropPivotTarget(this.pinned),this.context.wireBean(this.bodyDropPivotTarget),this.pinned){case a.Column.PINNED_LEFT:this.eSecondaryContainers=this.gridPanel.getDropTargetLeftContainers();break;case a.Column.PINNED_RIGHT:this.eSecondaryContainers=this.gridPanel.getDropTargetPinnedRightContainers();break;default:this.eSecondaryContainers=this.gridPanel.getDropTargetBodyContainers()}this.dragAndDropService.addDropTarget(this)},e.prototype.getIconName=function(){return this.currentDropListener.getIconName()},e.prototype.isUseBodyDropPivotTarget=function(e){return!!this.columnController.isPivotMode()&&e.dragSource.type===r.DragSourceType.ToolPanel},e.prototype.onDragEnter=function(e){var t=this.isUseBodyDropPivotTarget(e);t?this.currentDropListener=this.bodyDropPivotTarget:this.currentDropListener=this.moveColumnController,this.currentDropListener.onDragEnter(e)},e.prototype.onDragLeave=function(e){this.currentDropListener.onDragLeave(e)},e.prototype.onDragging=function(e){this.currentDropListener.onDragging(e)},e.prototype.onDragStop=function(e){this.currentDropListener.onDragStop(e)},i([s.Autowired("context"),n("design:type",s.Context)],e.prototype,"context",void 0),i([s.Autowired("gridPanel"),n("design:type",p.GridPanel)],e.prototype,"gridPanel",void 0),i([s.Autowired("dragAndDropService"),n("design:type",r.DragAndDropService)],e.prototype,"dragAndDropService",void 0),i([s.Autowired("columnController"),n("design:type",u.ColumnController)],e.prototype,"columnController",void 0),i([s.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e}();t.BodyDropTarget=c},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(5),l=o(13),a=o(15),p=o(7),d=o(66),u=o(24),c=o(3),h=function(){function e(e){this.needToMoveLeft=!1,this.needToMoveRight=!1,this.pinned=e,this.centerContainer=!p.Utils.exists(e)}return e.prototype.init=function(){this.logger=this.loggerFactory.create("MoveColumnController")},e.prototype.getIconName=function(){return this.pinned?d.DragAndDropService.ICON_PINNED:d.DragAndDropService.ICON_MOVE},e.prototype.onDragEnter=function(e){var t=e.dragSource.dragItem;this.columnController.setColumnsVisible(t,!0),this.columnController.setColumnsPinned(t,this.pinned),this.onDragging(e,!0)},e.prototype.onDragLeave=function(e){var t=!this.gridOptionsWrapper.isSuppressDragLeaveHidesColumns()&&!e.fromNudge;if(t){var o=e.dragSource.dragItem;this.columnController.setColumnsVisible(o,!1)}this.ensureIntervalCleared()},e.prototype.onDragStop=function(){this.ensureIntervalCleared()},e.prototype.adjustXForScroll=function(e){return this.centerContainer?e.x+this.gridPanel.getHorizontalScrollPosition():e.x},e.prototype.workOutNewIndex=function(e,t,o,i,n){return i===d.DragAndDropService.DIRECTION_LEFT?this.getNewIndexForColMovingLeft(e,t,o,n):this.getNewIndexForColMovingRight(e,t,o,n)},e.prototype.checkCenterForScrolling=function(e){if(this.centerContainer){var t=this.gridPanel.getHorizontalScrollPosition(),o=t+this.gridPanel.getCenterWidth();this.needToMoveLeft=e<t+50,this.needToMoveRight=e>o-50,this.needToMoveLeft||this.needToMoveRight?this.ensureIntervalStarted():this.ensureIntervalCleared()}},e.prototype.onDragging=function(e,t){if(void 0===t&&(t=!1),this.lastDraggingEvent=e,e.direction){var o=this.adjustXForScroll(e);t||this.checkCenterForScrolling(o);var i=e.dragSource.dragItem;this.attemptMoveColumns(i,e.direction,o,t)}},e.prototype.attemptMoveColumns=function(e,t,o,i){var n,r=this.columnController.getDisplayedColumns(this.pinned),s=this.columnController.getAllGridColumns(),l=t===d.DragAndDropService.DIRECTION_LEFT,a=t===d.DragAndDropService.DIRECTION_RIGHT,u=p.Utils.filter(e,function(e){return r.indexOf(e)>=0});n=l?u[0]:u[u.length-1];var c=this.workOutNewIndex(r,s,n,t,o),h=s.indexOf(n);!i&&l&&c>=h||!i&&a&&c<=h||(a&&(c=c-e.length+1),this.columnController.moveColumns(e,c))},e.prototype.getNewIndexForColMovingLeft=function(e,t,o,i){for(var n=0,r=null,s=0;s<e.length;s++){var l=e[s];if(l!==o){if(n+=l.getActualWidth(),n>i)break;r=l}}var a;if(r){a=t.indexOf(r)+1;var p=t.indexOf(o);p<a&&a--}else a=0;return a},e.prototype.getNewIndexForColMovingRight=function(e,t,o,i){for(var n=o,r=n.getActualWidth(),s=null,l=0;l<e.length&&!(r>i);l++){var a=e[l];a!==n&&(r+=a.getActualWidth(),s=a)}var p;if(s){p=t.indexOf(s)+1;var d=t.indexOf(n);d<p&&p--}else p=0;return p},e.prototype.ensureIntervalStarted=function(){this.movingIntervalId||(this.intervalCount=0,this.failedMoveAttempts=0,this.movingIntervalId=setInterval(this.moveInterval.bind(this),100),this.needToMoveLeft?this.dragAndDropService.setGhostIcon(d.DragAndDropService.ICON_LEFT,!0):this.dragAndDropService.setGhostIcon(d.DragAndDropService.ICON_RIGHT,!0))},e.prototype.ensureIntervalCleared=function(){this.moveInterval&&(clearInterval(this.movingIntervalId),this.movingIntervalId=null,this.dragAndDropService.setGhostIcon(d.DragAndDropService.ICON_MOVE))},e.prototype.moveInterval=function(){var e;this.intervalCount++,e=10+5*this.intervalCount,e>100&&(e=100);var t;if(this.needToMoveLeft?t=this.gridPanel.scrollHorizontally(-e):this.needToMoveRight&&(t=this.gridPanel.scrollHorizontally(e)),0!==t)this.onDragging(this.lastDraggingEvent),this.failedMoveAttempts=0;else if(this.failedMoveAttempts++,this.dragAndDropService.setGhostIcon(d.DragAndDropService.ICON_PINNED),this.failedMoveAttempts>7){var o=this.lastDraggingEvent.dragSource.dragItem,i=this.needToMoveLeft?a.Column.PINNED_LEFT:a.Column.PINNED_RIGHT;this.columnController.setColumnsPinned(o,i),this.dragAndDropService.nudge()}},i([r.Autowired("loggerFactory"),n("design:type",s.LoggerFactory)],e.prototype,"loggerFactory",void 0),i([r.Autowired("columnController"),n("design:type",l.ColumnController)],e.prototype,"columnController",void 0),i([r.Autowired("gridPanel"),n("design:type",u.GridPanel)],e.prototype,"gridPanel",void 0),i([r.Autowired("dragAndDropService"),n("design:type",d.DragAndDropService)],e.prototype,"dragAndDropService",void 0),i([r.Autowired("gridOptionsWrapper"),n("design:type",c.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([r.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e}();t.MoveColumnController=h},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(66),s=o(13),l=o(6),a=o(3),p=function(){function e(e){this.columnsToAggregate=[],this.columnsToGroup=[],this.columnsToPivot=[],this.pinned=e}return e.prototype.onDragEnter=function(e){var t=this;if(this.clearColumnsList(),!this.gridOptionsWrapper.isFunctionsReadOnly()){var o=e.dragSource.dragItem;o.forEach(function(e){e.isPrimary()&&(e.isAnyFunctionActive()||(e.isAllowValue()?t.columnsToAggregate.push(e):e.isAllowRowGroup()?t.columnsToGroup.push(e):e.isAllowRowGroup()&&t.columnsToPivot.push(e)))})}},e.prototype.getIconName=function(){var e=this.columnsToAggregate.length+this.columnsToGroup.length+this.columnsToPivot.length;return e>0?this.pinned?r.DragAndDropService.ICON_PINNED:r.DragAndDropService.ICON_MOVE:null},e.prototype.onDragLeave=function(e){this.clearColumnsList()},e.prototype.clearColumnsList=function(){this.columnsToAggregate.length=0,this.columnsToGroup.length=0,this.columnsToPivot.length=0},e.prototype.onDragging=function(e){},e.prototype.onDragStop=function(e){this.columnsToAggregate.length>0&&this.columnController.addValueColumns(this.columnsToAggregate),this.columnsToGroup.length>0&&this.columnController.addRowGroupColumns(this.columnsToGroup),this.columnsToPivot.length>0&&this.columnController.addPivotColumns(this.columnsToPivot)},i([l.Autowired("columnController"),n("design:type",s.ColumnController)],e.prototype,"columnController",void 0),i([l.Autowired("gridOptionsWrapper"),n("design:type",a.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),e}();t.BodyDropPivotTarget=p},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=function(){function e(e){this.type=e}return e.prototype.toString=function(){var e="ColumnChangeEvent {type: "+this.type;return this.column&&(e+=", column: "+this.column.getColId()),this.columnGroup&&(e+=this.columnGroup.getColGroupDef().headerName),this.toIndex&&(e+=", toIndex: "+this.toIndex),this.visible&&(e+=", visible: "+this.visible),this.pinned&&(e+=", pinned: "+this.pinned),"boolean"==typeof this.finished&&(e+=", finished: "+this.finished),e+="}"},e.prototype.withPinned=function(e){return this.pinned=e,this},e.prototype.withVisible=function(e){return this.visible=e,this},e.prototype.isVisible=function(){return this.visible},e.prototype.getPinned=function(){return this.pinned},e.prototype.withColumn=function(e){return this.column=e,this},e.prototype.withColumns=function(e){return this.columns=e,this},e.prototype.withFinished=function(e){return this.finished=e,this},e.prototype.withColumnGroup=function(e){return this.columnGroup=e,this},e.prototype.withToIndex=function(e){return this.toIndex=e,this},e.prototype.getToIndex=function(){return this.toIndex},e.prototype.getType=function(){return this.type},e.prototype.getColumn=function(){return this.column},e.prototype.getColumns=function(){return this.columns},e.prototype.getColumnGroup=function(){return this.columnGroup},e.prototype.isFinished=function(){return this.finished},e}();t.ColumnChangeEvent=i},function(e,t){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var o=function(){function e(){this.existingIds={}}return e.prototype.getInstanceIdForKey=function(e){var t,o=this.existingIds[e];return t="number"!=typeof o?0:o+1,this.existingIds[e]=t,t},e}();t.GroupInstanceIdCreator=o},function(e,t,o){function i(e,t,o,i){var r=n.Utils.exists(o)&&o.group,s=n.Utils.exists(i)&&i.group,l=r&&s,a=!r&&!s;return l?n.Utils.defaultComparator(o.key,i.key):a?n.Utils.defaultComparator(e,t):r?1:-1}/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var n=o(7);t.defaultGroupComparator=i},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(7),l=o(5),a=o(6),p=o(6),d=function(){function e(){this.destroyFunctions=[]}return e.prototype.agWire=function(e){this.logger=e.create("OldToolPanelDragAndDropService");var t=this.stopDragging.bind(this);document.addEventListener("mouseup",t),this.destroyFunctions.push(function(){document.removeEventListener("mouseup",t)})},e.prototype.destroy=function(){this.destroyFunctions.forEach(function(e){return e()}),document.removeEventListener("mouseup",this.mouseUpEventListener)},e.prototype.stopDragging=function(){this.dragItem&&(this.setDragCssClasses(this.dragItem.eDragSource,!1),this.dragItem=null)},e.prototype.setDragCssClasses=function(e,t){s.Utils.addOrRemoveCssClass(e,"ag-dragging",t),s.Utils.addOrRemoveCssClass(e,"ag-not-dragging",!t)},e.prototype.addDragSource=function(e,t){this.setDragCssClasses(e,!1),e.addEventListener("mousedown",this.onMouseDownDragSource.bind(this,e,t))},e.prototype.onMouseDownDragSource=function(e,t){this.dragItem&&this.stopDragging();var o;t.getData&&(o=t.getData());var i;t.getContainerId&&(i=t.getContainerId()),this.dragItem={eDragSource:e,data:o,containerId:i},this.setDragCssClasses(this.dragItem.eDragSource,!0)},e.prototype.addDropTarget=function(e,t){var o=this,i=!1,n=!1;e.addEventListener("mouseover",function(){i||(i=!0,n=!!o.dragItem&&t.acceptDrag(o.dragItem))}),e.addEventListener("mouseout",function(){n&&t.noDrop(),i=!1,n=!1}),e.addEventListener("mouseup",function(){n&&o.dragItem&&t.drop(o.dragItem)})},i([r(0,p.Qualifier("loggerFactory")),n("design:type",Function),n("design:paramtypes",[l.LoggerFactory]),n("design:returntype",void 0)],e.prototype,"agWire",null),i([a.PreDestroy,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"destroy",null),e=i([a.Bean("oldToolPanelDragAndDropService"),n("design:paramtypes",[])],e)}();t.OldToolPanelDragAndDropService=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(43),l=o(7),a=o(44),p=o(3),d=function(){function e(){}return e.prototype.showMenuAfterMouseEvent=function(e,t){var o=this;this.showPopup(e,function(e){o.popupService.positionPopupUnderMouseEvent({mouseEvent:t,ePopup:e})})},e.prototype.showMenuAfterButtonClick=function(e,t){var o=this;this.showPopup(e,function(e){o.popupService.positionPopupUnderComponent({eventSource:t,ePopup:e,keepWithinBounds:!0})})},e.prototype.showPopup=function(e,t){var o=this.filterManager.getOrCreateFilterWrapper(e),i=document.createElement("div");l.Utils.addCssClass(i,"ag-menu"),i.appendChild(o.gui);var n=this.popupService.addAsModalPopup(i,!0);if(t(i),o.filter.afterGuiAttached){var r={hidePopup:n};o.filter.afterGuiAttached(r)}},e.prototype.isMenuEnabled=function(e){return this.gridOptionsWrapper.isEnableFilter()&&e.isFilterAllowed()},i([r.Autowired("filterManager"),n("design:type",s.FilterManager)],e.prototype,"filterManager",void 0),i([r.Autowired("popupService"),n("design:type",a.PopupService)],e.prototype,"popupService",void 0),i([r.Autowired("gridOptionsWrapper"),n("design:type",p.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),e=i([r.Bean("menuFactory"),n("design:paramtypes",[])],e)}();t.StandardMenuFactory=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(6),l=o(3),a=o(43),p=function(){function e(){}return e.prototype.execute=function(e){var t;t=!this.gridOptionsWrapper.isEnableServerSideFilter()&&this.filterManager.isAnyFilterPresent(),this.recursivelyFilter(e,t)},e.prototype.recursivelyFilter=function(e,t){var o=this;e.childrenAfterGroup.forEach(function(e){e.group&&o.recursivelyFilter(e,t)});var i;t?(i=[],e.childrenAfterGroup.forEach(function(e){e.group?e.childrenAfterFilter.length>0&&i.push(e):o.filterManager.doesRowPassFilter(e)&&i.push(e)})):i=e.childrenAfterGroup,e.childrenAfterFilter=i,this.setAllChildrenCount(e)},e.prototype.setAllChildrenCount=function(e){var t=0;e.childrenAfterFilter.forEach(function(e){e.group?t+=e.allChildrenCount:t++}),e.allChildrenCount=t},i([s.Autowired("gridOptionsWrapper"),n("design:type",l.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([s.Autowired("filterManager"),n("design:type",a.FilterManager)],e.prototype,"filterManager",void 0),e=i([r.Bean("filterStage"),n("design:paramtypes",[])],e)}();t.FilterStage=p},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(3),l=o(42),a=o(29),p=o(7),d=function(){function e(){}return e.prototype.execute=function(e){var t;this.gridOptionsWrapper.isEnableServerSideSorting()||(t=this.sortController.getSortForRowController()),this.sortRowNode(e,t)},e.prototype.sortRowNode=function(e,t){var o=this;e.childrenAfterFilter.forEach(function(e){e.group&&o.sortRowNode(e,t)}),e.childrenAfterSort=e.childrenAfterFilter.slice(0);var i=p.Utils.exists(t)&&t.length>0;i&&e.childrenAfterSort.sort(this.compareRowNodes.bind(this,t)),this.updateChildIndexes(e)},e.prototype.compareRowNodes=function(e,t,o){for(var i=0,n=e.length;i<n;i++){var r,s=e[i],l=s.inverter===-1,a=this.valueService.getValue(s.column,t),d=this.valueService.getValue(s.column,o);if(r=s.column.getColDef().comparator?s.column.getColDef().comparator(a,d,t,o,l):p.Utils.defaultComparator(a,d),0!==r)return r*s.inverter}return 0},e.prototype.updateChildIndexes=function(e){p.Utils.missing(e.childrenAfterSort)||e.childrenAfterSort.forEach(function(t,o){t.firstChild=0===o,t.lastChild=o===e.childrenAfterSort.length-1,t.childIndex=o})},i([r.Autowired("gridOptionsWrapper"),n("design:type",s.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([r.Autowired("sortController"),n("design:type",l.SortController)],e.prototype,"sortController",void 0),i([r.Autowired("valueService"),n("design:type",a.ValueService)],e.prototype,"valueService",void 0),e=i([r.Bean("sortStage"),n("design:paramtypes",[])],e)}();t.SortStage=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(6),s=o(27),l=o(7),a=o(3),p=o(28),d=o(4),u=o(13),c=function(){function e(){}return e.prototype.execute=function(e){var t=[],o={value:0},i=this.columnController.isPivotMode(),n=i&&e.leafGroup,r=n?[e]:e.childrenAfterSort;return this.recursivelyAddToRowsToDisplay(r,t,o,i),t},e.prototype.recursivelyAddToRowsToDisplay=function(e,t,o,i){if(!l.Utils.missingOrEmpty(e))for(var n=this.gridOptionsWrapper.isGroupSuppressRow(),r=0;r<e.length;r++){var s=e[r],a=n&&s.group,p=i&&!s.group,d=p||a;if(d||this.addRowNodeToRowsToDisplay(s,t,o),s.group&&s.expanded&&(this.recursivelyAddToRowsToDisplay(s.childrenAfterSort,t,o,i),this.gridOptionsWrapper.isGroupIncludeFooter())){var u=this.createFooterNode(s);this.addRowNodeToRowsToDisplay(u,t,o)}if(s.canFlower&&s.expanded){var c=this.createFlowerNode(s);this.addRowNodeToRowsToDisplay(c,t,o)}}},e.prototype.addRowNodeToRowsToDisplay=function(e,t,o){t.push(e),e.rowHeight=this.gridOptionsWrapper.getRowHeightForNode(e),e.rowTop=o.value,o.value+=e.rowHeight},e.prototype.createFooterNode=function(e){var t=new s.RowNode;return this.context.wireBean(t),Object.keys(e).forEach(function(o){t[o]=e[o]}),t.footer=!0,t.sibling=e,e.sibling=t,t},e.prototype.createFlowerNode=function(e){var t=new s.RowNode;return this.context.wireBean(t),t.flower=!0,t.parent=e,t.data=e.data,t.level=e.level+1,t},i([r.Autowired("gridOptionsWrapper"),n("design:type",a.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([r.Autowired("selectionController"),n("design:type",p.SelectionController)],e.prototype,"selectionController",void 0),i([r.Autowired("eventService"),n("design:type",d.EventService)],e.prototype,"eventService",void 0),i([r.Autowired("context"),n("design:type",r.Context)],e.prototype,"context",void 0),i([r.Autowired("columnController"),n("design:type",u.ColumnController)],e.prototype,"columnController",void 0),e=i([r.Bean("flattenStage"),n("design:paramtypes",[])],e)}();t.FlattenStage=c},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(3),l=o(6),a=o(4),p=o(28),d=o(10),u=o(42),c=o(43),h=o(8),g=o(85),f=function(){function e(){this.destroyFunctions=[]}return e.prototype.init=function(){this.gridOptionsWrapper.isRowModelVirtual()&&(this.addEventListeners(),this.setDatasource(this.gridOptionsWrapper.getDatasource()))},e.prototype.addEventListeners=function(){var e=this,t=this.onSortChanged.bind(this),o=this.onFilterChanged.bind(this);this.eventService.addEventListener(d.Events.EVENT_FILTER_CHANGED,o),this.eventService.addEventListener(d.Events.EVENT_SORT_CHANGED,t),this.destroyFunctions.push(function(){e.eventService.removeEventListener(d.Events.EVENT_FILTER_CHANGED,o),e.eventService.removeEventListener(d.Events.EVENT_SORT_CHANGED,t)})},e.prototype.onFilterChanged=function(){this.gridOptionsWrapper.isEnableServerSideFilter()&&this.reset()},e.prototype.onSortChanged=function(){this.gridOptionsWrapper.isEnableServerSideSorting()&&this.reset()},e.prototype.destroy=function(){this.destroyFunctions.forEach(function(e){return e()})},e.prototype.getType=function(){return h.Constants.ROW_MODEL_TYPE_VIRTUAL},e.prototype.setDatasource=function(e){this.datasource=e,e&&(this.checkForDeprecated(),this.reset())},e.prototype.checkForDeprecated=function(){var e=this.datasource;r.Utils.exists(e.maxConcurrentRequests)&&console.error("ag-Grid: since version 5.1.x, maxConcurrentRequests is replaced with grid property maxConcurrentDatasourceRequests"),r.Utils.exists(e.maxPagesInCache)&&console.error("ag-Grid: since version 5.1.x, maxPagesInCache is replaced with grid property maxPagesInPaginationCache"),r.Utils.exists(e.overflowSize)&&console.error("ag-Grid: since version 5.1.x, overflowSize is replaced with grid property paginationOverflowSize"),r.Utils.exists(e.pageSize)&&console.error("ag-Grid: since version 5.1.x, pageSize is replaced with grid property paginationPageSize")},e.prototype.isEmpty=function(){return r.Utils.missing(this.virtualPageCache)},e.prototype.isRowsToRender=function(){return r.Utils.exists(this.virtualPageCache)},e.prototype.reset=function(){if(!r.Utils.missing(this.datasource)){var e=r.Utils.exists(this.gridOptionsWrapper.getRowNodeIdFunc());e||this.selectionController.reset(),this.resetCache(),this.eventService.dispatchEvent(d.Events.EVENT_MODEL_UPDATED)}},e.prototype.resetCache=function(){var e={datasource:this.datasource,filterModel:this.filterManager.getFilterModel(),sortModel:this.sortController.getSortModel(),maxConcurrentDatasourceRequests:this.gridOptionsWrapper.getMaxConcurrentDatasourceRequests(),paginationOverflowSize:this.gridOptionsWrapper.getPaginationOverflowSize(),paginationInitialRowCount:this.gridOptionsWrapper.getPaginationInitialRowCount(),maxPagesInCache:this.gridOptionsWrapper.getMaxPagesInCache(),pageSize:this.gridOptionsWrapper.getPaginationPageSize(),rowHeight:this.gridOptionsWrapper.getRowHeightAsNumber(),lastAccessedSequence:new r.NumberSequence};e.maxConcurrentDatasourceRequests>=1||(e.maxConcurrentDatasourceRequests=2),e.pageSize>=1||(e.pageSize=100),e.paginationInitialRowCount>=1||(e.paginationInitialRowCount=0),e.paginationOverflowSize>=1||(e.paginationOverflowSize=1),this.virtualPageCache&&this.virtualPageCache.destroy(),this.virtualPageCache=new g.VirtualPageCache(e),this.context.wireBean(this.virtualPageCache)},e.prototype.getRow=function(e){return this.virtualPageCache?this.virtualPageCache.getRow(e):null},e.prototype.forEachNode=function(e){this.virtualPageCache&&this.virtualPageCache.forEachNode(e)},e.prototype.getRowCombinedHeight=function(){return this.virtualPageCache?this.virtualPageCache.getRowCombinedHeight():0},e.prototype.getRowIndexAtPixel=function(e){return this.virtualPageCache?this.virtualPageCache.getRowIndexAtPixel(e):-1},e.prototype.getRowCount=function(){return this.virtualPageCache?this.virtualPageCache.getRowCount():0},e.prototype.insertItemsAtIndex=function(e,t){this.virtualPageCache&&this.virtualPageCache.insertItemsAtIndex(e,t)},e.prototype.removeItems=function(e){console.log("ag-Grid: it is not possible to removeItems when using virtual pagination. Instead use the API to refresh the cache")},e.prototype.addItems=function(e){console.log("ag-Grid: it is not possible to add items when using virtual pagination as the grid does not know that last index of your data - instead either use insertItemsAtIndex OR refresh the cache.")},e.prototype.refreshVirtualPageCache=function(){this.virtualPageCache&&this.virtualPageCache.refreshVirtualPageCache()},e.prototype.purgeVirtualPageCache=function(){this.virtualPageCache&&this.virtualPageCache.purgeVirtualPageCache()},e.prototype.getVirtualRowCount=function(){return this.virtualPageCache?this.virtualPageCache.getVirtualRowCount():null},e.prototype.isMaxRowFound=function(){if(this.virtualPageCache)return this.virtualPageCache.isMaxRowFound()},e.prototype.setVirtualRowCount=function(e,t){this.virtualPageCache&&this.virtualPageCache.setVirtualRowCount(e,t)},e.prototype.getVirtualPageState=function(){return this.virtualPageCache?this.virtualPageCache.getPageState():null},i([l.Autowired("gridOptionsWrapper"),n("design:type",s.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([l.Autowired("filterManager"),n("design:type",c.FilterManager)],e.prototype,"filterManager",void 0),i([l.Autowired("sortController"),n("design:type",u.SortController)],e.prototype,"sortController",void 0),i([l.Autowired("selectionController"),n("design:type",p.SelectionController)],e.prototype,"selectionController",void 0),i([l.Autowired("eventService"),n("design:type",a.EventService)],e.prototype,"eventService",void 0),i([l.Autowired("context"),n("design:type",l.Context)],e.prototype,"context",void 0),i([l.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),i([l.PreDestroy,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"destroy",null),e=i([l.Bean("rowModel"),n("design:paramtypes",[])],e)}();t.VirtualPageRowModel=f},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=this&&this.__param||function(e,t){return function(o,i){t(o,i,e)}},s=o(7),l=o(6),a=o(4),p=o(10),d=o(5),u=o(86),c=function(){function e(e){this.pages={},this.activePageLoadsCount=0,this.pagesInCacheCount=0,this.maxRowFound=!1,this.active=!0,this.cacheParams=e,this.virtualRowCount=e.paginationInitialRowCount}return e.prototype.setBeans=function(e){this.logger=e.create("VirtualPageCache")},e.prototype.init=function(){this.getRow(0)},e.prototype.getRowCombinedHeight=function(){return this.virtualRowCount*this.cacheParams.rowHeight},e.prototype.forEachNode=function(e){var t=this,o=0;s.Utils.iterateObject(this.pages,function(i,n){for(var r=n.getStartRow(),s=n.getEndRow(),l=r;l<s;l++)if(l<t.virtualRowCount){var a=n.getRow(l);e(a,o),o++}})},e.prototype.getRowIndexAtPixel=function(e){return 0!==this.cacheParams.rowHeight?Math.floor(e/this.cacheParams.rowHeight):0},e.prototype.moveItemsDown=function(e,t,o){for(var i=e.getStartRow(),n=e.getEndRow(),r=t+o,s=n-1;s>=i;s--)if(!(s<r)){var l=s-o,a=this.getRow(l,!0);a?e.setRowNode(s,a):(e.setBlankRowNode(s),e.setDirty())}},e.prototype.insertItems=function(e,t,o){for(var i=e.getStartRow(),n=e.getEndRow(),r=[],s=0;s<o.length;s++){var l=t+s,a=l>=i&&l<n;if(a){var p=o[s],d=e.setNewData(l,p);r.push(d)}}return r},e.prototype.insertItemsAtIndex=function(e,t){var o=this,i=Object.keys(this.pages).map(function(e){return parseInt(e)}).sort().reverse(),n=[];i.forEach(function(i){var r=o.pages[i],s=r.getEndRow();if(!(s<=e)){o.moveItemsDown(r,e,t.length);var l=o.insertItems(r,e,t);l.forEach(function(e){return n.push(e)})}}),this.maxRowFound&&(this.virtualRowCount+=t.length),this.dispatchModelUpdated(),this.eventService.dispatchEvent(p.Events.EVENT_ITEMS_ADDED,n)},e.prototype.getRowCount=function(){return this.virtualRowCount},e.prototype.onPageLoaded=function(e){this.active&&(this.logger.log("onPageLoaded: page = "+e.page.getPageNumber()+", lastRow = "+e.lastRow),this.activePageLoadsCount--,this.checkPageToLoad(),e.success&&this.checkVirtualRowCount(e.page,e.lastRow))},e.prototype.destroy=function(){this.active=!1},e.prototype.getRow=function(e,t){void 0===t&&(t=!1);var o=Math.floor(e/this.cacheParams.pageSize),i=this.pages[o];if(!i){if(t)return null;i=this.createPage(o)}return i.getRow(e)},e.prototype.createPage=function(e){var t=new u.VirtualPage(e,this.cacheParams);this.context.wireBean(t),t.addEventListener(u.VirtualPage.EVENT_LOAD_COMPLETE,this.onPageLoaded.bind(this)),this.pages[e]=t,this.pagesInCacheCount++;var o=s.Utils.exists(this.cacheParams.maxPagesInCache)&&this.pagesInCacheCount>this.cacheParams.maxPagesInCache;if(o){var i=this.findLeastRecentlyUsedPage(t);this.removePageFromCache(i)}return this.checkPageToLoad(),t},e.prototype.removePageFromCache=function(e){e&&(delete this.pages[e.getPageNumber()],this.pagesInCacheCount--)},e.prototype.printCacheStatus=function(){this.logger.log("checkPageToLoad: activePageLoadsCount = "+this.activePageLoadsCount+", pages = "+JSON.stringify(this.getPageState()))},e.prototype.checkPageToLoad=function(){if(this.printCacheStatus(),this.activePageLoadsCount>=this.cacheParams.maxConcurrentDatasourceRequests)return void this.logger.log("checkPageToLoad: max loads exceeded");var e=null;s.Utils.iterateObject(this.pages,function(t,o){o.getState()===u.VirtualPage.STATE_DIRTY&&(e=o)}),e?(e.load(),this.activePageLoadsCount++,this.logger.log("checkPageToLoad: loading page "+e.getPageNumber()),this.printCacheStatus()):this.logger.log("checkPageToLoad: no pages to load")},e.prototype.findLeastRecentlyUsedPage=function(e){var t=null;return s.Utils.iterateObject(this.pages,function(o,i){i!==e&&(s.Utils.missing(t)||i.getLastAccessed()<t.getLastAccessed())&&(t=i)}),t},e.prototype.checkVirtualRowCount=function(e,t){if("number"==typeof t&&t>=0)this.virtualRowCount=t,this.maxRowFound=!0,this.dispatchModelUpdated();else if(!this.maxRowFound){var o=(e.getPageNumber()+1)*this.cacheParams.pageSize,i=o+this.cacheParams.paginationOverflowSize;this.virtualRowCount<i&&(this.virtualRowCount=i,this.dispatchModelUpdated())}},e.prototype.dispatchModelUpdated=function(){this.active&&this.eventService.dispatchEvent(p.Events.EVENT_MODEL_UPDATED)},e.prototype.getPageState=function(){var e=[];return s.Utils.iterateObject(this.pages,function(t,o){e.push({pageNumber:t,startRow:o.getStartRow(),endRow:o.getEndRow(),pageStatus:o.getState()})}),e},e.prototype.refreshVirtualPageCache=function(){s.Utils.iterateObject(this.pages,function(e,t){t.setDirty()}),this.checkPageToLoad()},e.prototype.purgeVirtualPageCache=function(){var e=this,t=s.Utils.values(this.pages);t.forEach(function(t){return e.removePageFromCache(t)}),this.dispatchModelUpdated()},e.prototype.getVirtualRowCount=function(){return this.virtualRowCount},e.prototype.isMaxRowFound=function(){return this.maxRowFound},e.prototype.setVirtualRowCount=function(e,t){this.virtualRowCount=e,s.Utils.exists(t)&&(this.maxRowFound=t),this.maxRowFound||this.virtualRowCount%this.cacheParams.pageSize===0&&this.virtualRowCount++,this.dispatchModelUpdated()},i([l.Autowired("eventService"),n("design:type",a.EventService)],e.prototype,"eventService",void 0),i([l.Autowired("context"),n("design:type",l.Context)],e.prototype,"context",void 0),i([r(0,l.Qualifier("loggerFactory")),n("design:type",Function),n("design:paramtypes",[d.LoggerFactory]),n("design:returntype",void 0)],e.prototype,"setBeans",null),i([l.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e}();t.VirtualPageCache=c},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},n=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},r=o(7),s=o(3),l=o(27),a=o(6),p=o(4),d=function(){function e(t,o){this.state=e.STATE_DIRTY,this.version=0,this.localEventService=new p.EventService,this.pageNumber=t,this.cacheParams=o,this.startRow=t*o.pageSize,this.endRow=this.startRow+o.pageSize}return e.prototype.setDirty=function(){this.version++,this.state=e.STATE_DIRTY},e.prototype.setDirtyAndPurge=function(){this.setDirty(),this.rowNodes.forEach(function(e){e.setData(null)})},e.prototype.getStartRow=function(){return this.startRow},e.prototype.getEndRow=function(){return this.endRow},e.prototype.getPageNumber=function(){return this.pageNumber},e.prototype.addEventListener=function(e,t){this.localEventService.addEventListener(e,t)},e.prototype.removeEventListener=function(e,t){this.localEventService.removeEventListener(e,t)},e.prototype.getLastAccessed=function(){return this.lastAccessed},e.prototype.getState=function(){return this.state},e.prototype.setRowNode=function(e,t){var o=e-this.startRow;this.rowNodes[o]=t,this.setTopOnRowNode(t,e)},e.prototype.setBlankRowNode=function(e){var t=e-this.startRow,o=this.createBlankRowNode(e);return this.rowNodes[t]=o,o},e.prototype.setNewData=function(e,t){var o=this.setBlankRowNode(e);return o.setDataAndId(t,e.toString()),o},e.prototype.init=function(){this.createRowNodes()},e.prototype.createRowNodes=function(){this.rowNodes=[];for(var e=0;e<this.cacheParams.pageSize;e++){var t=this.startRow+e,o=this.createBlankRowNode(t);this.rowNodes.push(o)}},e.prototype.setTopOnRowNode=function(e,t){e.rowTop=this.cacheParams.rowHeight*t},e.prototype.createBlankRowNode=function(e){var t=new l.RowNode;return this.context.wireBean(t),t.rowHeight=this.cacheParams.rowHeight,this.setTopOnRowNode(t,e),t},e.prototype.getRow=function(e){this.lastAccessed=this.cacheParams.lastAccessedSequence.next();var t=e-this.startRow;return this.rowNodes[t]},e.prototype.load=function(){var t=this;this.state=e.STATE_LOADING;var o={startRow:this.startRow,endRow:this.endRow,successCallback:this.pageLoaded.bind(this,this.version),failCallback:this.pageLoadFailed.bind(this),sortModel:this.cacheParams.sortModel,filterModel:this.cacheParams.filterModel,context:this.gridOptionsWrapper.getContext()};if(r.Utils.missing(this.cacheParams.datasource.getRows))return void console.warn("ag-Grid: datasource is missing getRows method");var i=r.Utils.getFunctionParameters(this.cacheParams.datasource.getRows);i.length>1&&(console.warn("ag-grid: It looks like your paging datasource is of the old type, taking more than one parameter."),console.warn("ag-grid: From ag-grid 1.9.0, now the getRows takes one parameter. See the documentation for details.")),setTimeout(function(){t.cacheParams.datasource.getRows(o)},0)},e.prototype.pageLoadFailed=function(){this.state=e.STATE_FAILED;var t={success:!0,page:this};this.localEventService.dispatchEvent(e.EVENT_LOAD_COMPLETE,t)},e.prototype.populateWithRowData=function(e){var t=this;this.rowNodes.forEach(function(o,i){var n=e[i];if(r.Utils.exists(n)){var s=t.startRow+i;o.setDataAndId(n,s.toString())}else o.setDataAndId(void 0,void 0)})},e.prototype.pageLoaded=function(t,o,i){t===this.version&&(this.state=e.STATE_LOADED,this.populateWithRowData(o));var n={success:!0,page:this,lastRow:i};this.localEventService.dispatchEvent(e.EVENT_LOAD_COMPLETE,n)},e.EVENT_LOAD_COMPLETE="loadComplete",e.STATE_DIRTY="dirty",e.STATE_LOADING="loading",e.STATE_LOADED="loaded",e.STATE_FAILED="failed",i([a.Autowired("gridOptionsWrapper"),n("design:type",s.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),i([a.Autowired("context"),n("design:type",a.Context)],e.prototype,"context",void 0),i([a.PostConstruct,n("design:type",Function),n("design:paramtypes",[]),n("design:returntype",void 0)],e.prototype,"init",null),e}();t.VirtualPage=d},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i,n=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},r=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},s=o(7),l=o(8),a=o(3),p=o(13),d=o(43),u=o(27),c=o(4),h=o(10),g=o(6),f=o(28),y=o(88);!function(e){e[e.Normal=0]="Normal",e[e.AfterFilter=1]="AfterFilter",e[e.AfterFilterAndSort=2]="AfterFilterAndSort",e[e.PivotNodes=3]="PivotNodes"}(i||(i={}));var v=function(){function e(){}return e.prototype.init=function(){this.eventService.addModalPriorityEventListener(h.Events.EVENT_COLUMN_EVERYTHING_CHANGED,this.refreshModel.bind(this,l.Constants.STEP_EVERYTHING)),this.eventService.addModalPriorityEventListener(h.Events.EVENT_COLUMN_ROW_GROUP_CHANGED,this.refreshModel.bind(this,l.Constants.STEP_EVERYTHING)),this.eventService.addModalPriorityEventListener(h.Events.EVENT_COLUMN_VALUE_CHANGED,this.onValueChanged.bind(this)),this.eventService.addModalPriorityEventListener(h.Events.EVENT_COLUMN_PIVOT_CHANGED,this.refreshModel.bind(this,l.Constants.STEP_PIVOT)),this.eventService.addModalPriorityEventListener(h.Events.EVENT_FILTER_CHANGED,this.refreshModel.bind(this,l.Constants.STEP_FILTER)),this.eventService.addModalPriorityEventListener(h.Events.EVENT_SORT_CHANGED,this.refreshModel.bind(this,l.Constants.STEP_SORT)),this.eventService.addModalPriorityEventListener(h.Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,this.refreshModel.bind(this,l.Constants.STEP_PIVOT)),this.rootNode=new u.RowNode,this.nodeManager=new y.InMemoryNodeManager(this.rootNode,this.gridOptionsWrapper,this.context,this.eventService),this.context.wireBean(this.rootNode),this.gridOptionsWrapper.isRowModelDefault()&&this.setRowData(this.gridOptionsWrapper.getRowData(),this.columnController.isReady())},e.prototype.getType=function(){return l.Constants.ROW_MODEL_TYPE_NORMAL},e.prototype.onValueChanged=function(){this.columnController.isPivotActive()?this.refreshModel(l.Constants.STEP_PIVOT):this.refreshModel(l.Constants.STEP_AGGREGATE)},e.prototype.refreshModel=function(e,t,o){var i=this;switch(e){case l.Constants.STEP_EVERYTHING:this.doRowGrouping(o);case l.Constants.STEP_FILTER:this.doFilter();case l.Constants.STEP_PIVOT:this.doPivot();case l.Constants.STEP_AGGREGATE:this.doAggregate();case l.Constants.STEP_SORT:this.doSort();case l.Constants.STEP_MAP:this.doRowsToDisplay()}this.eventService.dispatchEvent(h.Events.EVENT_MODEL_UPDATED,{fromIndex:t}),this.$scope&&setTimeout(function(){i.$scope.$apply()},0)},e.prototype.isEmpty=function(){return s.Utils.missing(this.rootNode)||s.Utils.missing(this.rootNode.allLeafChildren)||0===this.rootNode.allLeafChildren.length||!this.columnController.isReady()},e.prototype.isRowsToRender=function(){return s.Utils.exists(this.rowsToDisplay)&&this.rowsToDisplay.length>0},e.prototype.setDatasource=function(e){console.error("ag-Grid: should never call setDatasource on inMemoryRowController")},e.prototype.getTopLevelNodes=function(){return this.rootNode?this.rootNode.childrenAfterGroup:null},e.prototype.getRow=function(e){return this.rowsToDisplay[e]},e.prototype.getVirtualRowCount=function(){return console.warn("ag-Grid: rowModel.getVirtualRowCount() is not longer a function, use rowModel.getRowCount() instead"),this.getRowCount()},e.prototype.getRowCount=function(){return this.rowsToDisplay?this.rowsToDisplay.length:0},e.prototype.getRowIndexAtPixel=function(e){if(this.isEmpty())return-1;var t=0,o=this.rowsToDisplay.length-1;if(e<=0)return 0;var i=this.rowsToDisplay[this.rowsToDisplay.length-1];if(i.rowTop<=e)return this.rowsToDisplay.length-1;for(;;){var n=Math.floor((t+o)/2),r=this.rowsToDisplay[n];if(this.isRowInPixel(r,e))return n;r.rowTop<e?t=n+1:r.rowTop>e&&(o=n-1)}},e.prototype.isRowInPixel=function(e,t){var o=e.rowTop,i=e.rowTop+e.rowHeight,n=o<=t&&i>t;return n},e.prototype.getRowCombinedHeight=function(){if(this.rowsToDisplay&&this.rowsToDisplay.length>0){var e=this.rowsToDisplay[this.rowsToDisplay.length-1],t=e.rowTop+e.rowHeight;return t}return 0},e.prototype.forEachLeafNode=function(e){this.rootNode.allLeafChildren&&this.rootNode.allLeafChildren.forEach(function(t,o){return e(t,o)})},e.prototype.forEachNode=function(e){this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterGroup,e,i.Normal,0)},e.prototype.forEachNodeAfterFilter=function(e){this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterFilter,e,i.AfterFilter,0)},e.prototype.forEachNodeAfterFilterAndSort=function(e){this.recursivelyWalkNodesAndCallback(this.rootNode.childrenAfterSort,e,i.AfterFilterAndSort,0)},e.prototype.forEachPivotNode=function(e){this.recursivelyWalkNodesAndCallback([this.rootNode],e,i.PivotNodes,0)},e.prototype.recursivelyWalkNodesAndCallback=function(e,t,o,n){if(e)for(var r=0;r<e.length;r++){var s=e[r];if(t(s,n++),s.group){var l;switch(o){case i.Normal:l=s.childrenAfterGroup;break;case i.AfterFilter:l=s.childrenAfterFilter;break;case i.AfterFilterAndSort:l=s.childrenAfterSort;break;case i.PivotNodes:l=s.leafGroup?null:s.childrenAfterSort}l&&(n=this.recursivelyWalkNodesAndCallback(l,t,o,n))}}return n},e.prototype.doAggregate=function(){this.aggregationStage&&this.aggregationStage.execute(this.rootNode)},e.prototype.expandOrCollapseAll=function(e){function t(o){o&&o.forEach(function(o){o.group&&(o.expanded=e,t(o.childrenAfterGroup))})}this.rootNode&&t(this.rootNode.childrenAfterGroup),this.refreshModel(l.Constants.STEP_MAP)},e.prototype.doSort=function(){this.sortStage.execute(this.rootNode)},e.prototype.doRowGrouping=function(e){var t=s.Utils.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());t||(this.groupStage?(this.selectionController.removeGroupsFromSelection(),this.groupStage.execute(this.rootNode),this.restoreGroupState(e),this.gridOptionsWrapper.isGroupSelectsChildren()&&this.selectionController.updateGroupsFromChildrenSelections()):this.rootNode.childrenAfterGroup=this.rootNode.allLeafChildren)},e.prototype.restoreGroupState=function(e){e&&s.Utils.traverseNodesWithKey(this.rootNode.childrenAfterGroup,function(t,o){"boolean"==typeof e[o]&&(t.expanded=e[o])})},e.prototype.doFilter=function(){this.filterStage.execute(this.rootNode)},e.prototype.doPivot=function(){this.pivotStage&&this.pivotStage.execute(this.rootNode)},e.prototype.getGroupState=function(){if(!this.rootNode.childrenAfterGroup||!this.gridOptionsWrapper.isRememberGroupStateWhenNewData())return null;var e={};return s.Utils.traverseNodesWithKey(this.rootNode.childrenAfterGroup,function(t,o){return e[o]=t.expanded}),e},e.prototype.setRowData=function(e,t,o){var i=this.getGroupState();this.nodeManager.setRowData(e,o),this.eventService.dispatchEvent(h.Events.EVENT_ROW_DATA_CHANGED),t&&this.refreshModel(l.Constants.STEP_EVERYTHING,null,i)},e.prototype.doRowsToDisplay=function(){this.rowsToDisplay=this.flattenStage.execute(this.rootNode)},e.prototype.insertItemsAtIndex=function(e,t){var o=this.getGroupState(),i=this.nodeManager.insertItemsAtIndex(e,t);this.refreshAndFireEvent(h.Events.EVENT_ITEMS_ADDED,i,o)},e.prototype.removeItems=function(e){var t=this.getGroupState(),o=this.nodeManager.removeItems(e);this.refreshAndFireEvent(h.Events.EVENT_ITEMS_REMOVED,o,t)},e.prototype.addItems=function(e){var t=this.getGroupState(),o=this.nodeManager.addItems(e);this.refreshAndFireEvent(h.Events.EVENT_ITEMS_ADDED,o,t)},e.prototype.refreshAndFireEvent=function(e,t,o){t&&(this.refreshModel(l.Constants.STEP_EVERYTHING,null,o),this.eventService.dispatchEvent(e,{rowNodes:t}))},n([g.Autowired("gridOptionsWrapper"),r("design:type",a.GridOptionsWrapper)],e.prototype,"gridOptionsWrapper",void 0),n([g.Autowired("columnController"),r("design:type",p.ColumnController)],e.prototype,"columnController",void 0),n([g.Autowired("filterManager"),r("design:type",d.FilterManager)],e.prototype,"filterManager",void 0),n([g.Autowired("$scope"),r("design:type",Object)],e.prototype,"$scope",void 0),n([g.Autowired("selectionController"),r("design:type",f.SelectionController)],e.prototype,"selectionController",void 0),n([g.Autowired("eventService"),r("design:type",c.EventService)],e.prototype,"eventService",void 0),n([g.Autowired("context"),r("design:type",g.Context)],e.prototype,"context",void 0),n([g.Autowired("filterStage"),r("design:type",Object)],e.prototype,"filterStage",void 0),n([g.Autowired("sortStage"),r("design:type",Object)],e.prototype,"sortStage",void 0),n([g.Autowired("flattenStage"),r("design:type",Object)],e.prototype,"flattenStage",void 0),n([g.Optional("groupStage"),r("design:type",Object)],e.prototype,"groupStage",void 0),n([g.Optional("aggregationStage"),r("design:type",Object)],e.prototype,"aggregationStage",void 0),n([g.Optional("pivotStage"),r("design:type",Object)],e.prototype,"pivotStage",void 0),n([g.PostConstruct,r("design:type",Function),r("design:paramtypes",[]),r("design:returntype",void 0)],e.prototype,"init",null),e=n([g.Bean("rowModel"),r("design:paramtypes",[])],e)}();t.InMemoryRowModel=v},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(27),n=o(7),r=function(){function e(e,t,o,i){this.nextId=0,this.rootNode=e,this.gridOptionsWrapper=t,this.context=o,this.eventService=i,this.rootNode.group=!0,this.rootNode.level=-1,this.rootNode.allLeafChildren=[],this.rootNode.childrenAfterGroup=[],this.rootNode.childrenAfterSort=[],this.rootNode.childrenAfterFilter=[]}return e.prototype.setRowData=function(t,o){if(this.rootNode.childrenAfterFilter=null,this.rootNode.childrenAfterGroup=null,this.rootNode.childrenAfterSort=null,this.rootNode.childrenMapped=null,this.nextId=n.Utils.exists(o)?o:0,!t)return this.rootNode.allLeafChildren=[],void(this.rootNode.childrenAfterGroup=[]);this.getNodeChildDetails=this.gridOptionsWrapper.getNodeChildDetailsFunc(),this.suppressParentsInRowNodes=this.gridOptionsWrapper.isSuppressParentsInRowNodes(),this.doesDataFlower=this.gridOptionsWrapper.getDoesDataFlowerFunc();var i=n.Utils.exists(this.getNodeChildDetails),r=this.recursiveFunction(t,null,e.TOP_LEVEL);i?(this.rootNode.childrenAfterGroup=r,this.setLeafChildren(this.rootNode)):this.rootNode.allLeafChildren=r},e.prototype.recursiveFunction=function(e,t,o){var i=this;if("string"==typeof e)return void console.warn("ag-Grid: rowData must be an array, however you passed in a string. If you are loading JSON, make sure you convert the JSON string to JavaScript objects first");var n=[];return e.forEach(function(e){var r=i.createNode(e,t,o),s=i.getNodeChildDetails?i.getNodeChildDetails(e):null;s&&s.group&&(r.group=!0,r.childrenAfterGroup=i.recursiveFunction(s.children,r,o+1),r.expanded=s.expanded===!0,r.field=s.field,r.key=s.key,i.setLeafChildren(r)),n.push(r)}),n},e.prototype.createNode=function(e,t,o){var n=new i.RowNode;this.context.wireBean(n);var r=this.getNodeChildDetails?this.getNodeChildDetails(e):null;return r&&r.group?(n.group=!0,n.childrenAfterGroup=this.recursiveFunction(r.children,n,o+1),n.expanded=r.expanded===!0,n.field=r.field,n.key=r.key,n.canFlower=!1,this.setLeafChildren(n)):(n.group=!1,n.canFlower=!!this.doesDataFlower&&this.doesDataFlower(e),n.canFlower&&(n.expanded=!1)),t&&!this.suppressParentsInRowNodes&&(n.parent=t),n.level=o,n.setDataAndId(e,this.nextId.toString()),this.nextId++,n},e.prototype.setLeafChildren=function(e){e.allLeafChildren=[],e.childrenAfterGroup&&e.childrenAfterGroup.forEach(function(t){t.group?t.allLeafChildren&&t.allLeafChildren.forEach(function(t){return e.allLeafChildren.push(t)}):e.allLeafChildren.push(t)})},e.prototype.insertItemsAtIndex=function(t,o){var i=this;if(this.isRowsAlreadyGrouped())return null;var r=this.rootNode.allLeafChildren;if(t>r.length)return void console.warn("ag-Grid: invalid index "+t+", max index is "+r.length);var s=[];return o.forEach(function(o){var l=i.createNode(o,null,e.TOP_LEVEL);n.Utils.insertIntoArray(r,l,t),s.push(l)}),s.length>0?s:null},e.prototype.removeItems=function(e){if(!this.isRowsAlreadyGrouped()){var t=this.rootNode.allLeafChildren,o=[];return e.forEach(function(e){var i=t.indexOf(e);i>=0&&(e.setSelected(!1),t.splice(i,1)),o.push(e)}),o.length>0?o:null}},e.prototype.addItems=function(e){var t=this.rootNode.allLeafChildren;return this.insertItemsAtIndex(t.length,e)},e.prototype.isRowsAlreadyGrouped=function(){var e=n.Utils.exists(this.gridOptionsWrapper.getNodeChildDetailsFunc());return!!e&&(console.warn("ag-Grid: adding and removing rows is not supported when using nodeChildDetailsFunc, ie it is not supported if providing groups"),!0)},e.TOP_LEVEL=0,e}();t.InMemoryNodeManager=r},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},r=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},s=o(47),l=o(90),a=o(7),p=o(6),d=o(3),u=o(58),c=u.SvgFactory.getInstance(),h=function(e){function t(){e.call(this,t.TEMPLATE),this.selected=!1,this.readOnly=!1,this.passive=!1}return i(t,e),t.prototype.init=function(){this.loadIcons(),this.updateIcons();var e=this.getAttribute("label");e&&(this.eLabel.innerText=e)},t.prototype.loadIcons=function(){a.Utils.removeAllChildren(this.eChecked),a.Utils.removeAllChildren(this.eUnchecked),a.Utils.removeAllChildren(this.eIndeterminate),this.readOnly?(this.eChecked.appendChild(a.Utils.createIconNoSpan("checkboxCheckedReadOnly",this.gridOptionsWrapper,null,c.createCheckboxCheckedReadOnlyIcon)),this.eUnchecked.appendChild(a.Utils.createIconNoSpan("checkboxUncheckedReadOnly",this.gridOptionsWrapper,null,c.createCheckboxUncheckedReadOnlyIcon)),this.eIndeterminate.appendChild(a.Utils.createIconNoSpan("checkboxIndeterminateReadOnly",this.gridOptionsWrapper,null,c.createCheckboxIndeterminateReadOnlyIcon))):(this.eChecked.appendChild(a.Utils.createIconNoSpan("checkboxChecked",this.gridOptionsWrapper,null,c.createCheckboxCheckedIcon)),this.eUnchecked.appendChild(a.Utils.createIconNoSpan("checkboxUnchecked",this.gridOptionsWrapper,null,c.createCheckboxUncheckedIcon)),this.eIndeterminate.appendChild(a.Utils.createIconNoSpan("checkboxIndeterminate",this.gridOptionsWrapper,null,c.createCheckboxIndeterminateIcon)))},t.prototype.onClick=function(){this.readOnly||this.toggle()},t.prototype.getNextValue=function(){return void 0===this.selected||!this.selected},t.prototype.setPassive=function(e){this.passive=e},t.prototype.setReadOnly=function(e){this.readOnly=e,this.loadIcons()},t.prototype.isReadOnly=function(){return this.readOnly},t.prototype.isSelected=function(){return this.selected},t.prototype.toggle=function(){var e=this.getNextValue();this.passive?this.dispatchEvent(t.EVENT_CHANGED,{selected:e}):this.setSelected(e)},t.prototype.setSelected=function(e){this.selected!==e&&(e===!0?this.selected=!0:e===!1?this.selected=!1:this.selected=void 0,this.updateIcons(),this.dispatchEvent(t.EVENT_CHANGED,{selected:this.selected}))},t.prototype.updateIcons=function(){a.Utils.setVisible(this.eChecked,this.selected===!0),a.Utils.setVisible(this.eUnchecked,this.selected===!1),a.Utils.setVisible(this.eIndeterminate,void 0===this.selected)},t.EVENT_CHANGED="change",t.TEMPLATE='<span class="ag-checkbox">  <span class="ag-checkbox-checked"></span>  <span class="ag-checkbox-unchecked"></span>  <span class="ag-checkbox-indeterminate"></span>  <span class="ag-checkbox-label"></span></span>',n([p.Autowired("gridOptionsWrapper"),r("design:type",d.GridOptionsWrapper)],t.prototype,"gridOptionsWrapper",void 0),n([l.QuerySelector(".ag-checkbox-checked"),r("design:type",HTMLElement)],t.prototype,"eChecked",void 0),n([l.QuerySelector(".ag-checkbox-unchecked"),r("design:type",HTMLElement)],t.prototype,"eUnchecked",void 0),n([l.QuerySelector(".ag-checkbox-indeterminate"),r("design:type",HTMLElement)],t.prototype,"eIndeterminate",void 0),n([l.QuerySelector(".ag-checkbox-label"),r("design:type",HTMLElement)],t.prototype,"eLabel",void 0),n([p.PostConstruct,r("design:type",Function),r("design:paramtypes",[]),r("design:returntype",void 0)],t.prototype,"init",null),n([l.Listener("click"),r("design:type",Function),r("design:paramtypes",[]),r("design:returntype",void 0)],t.prototype,"onClick",null),t}(s.Component);t.AgCheckbox=h},function(e,t){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	function o(e){return i.bind(this,e)}function i(e,t,o,i){if(null===e)return void console.error("ag-Grid: QuerySelector selector should not be null");if("number"==typeof i)return void console.error("ag-Grid: QuerySelector should be on an attribute");var n=s(t);n.querySelectors||(n.querySelectors=[]),n.querySelectors.push({attributeName:o,querySelector:e})}function n(e){return r.bind(this,e)}function r(e,t,o,i){if(null===e)return void console.error("ag-Grid: EventListener eventName should not be null");var n=s(t);n.listenerMethods||(n.listenerMethods=[]),n.listenerMethods.push({methodName:o,eventName:e})}function s(e){var t=e.__agComponentMetaData;return t||(t={},e.__agComponentMetaData=t),t}t.QuerySelector=o,t.Listener=n},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=o(47),r=o(8),s=o(7),l=function(e){function t(){e.call(this,t.TEMPLATE)}return i(t,e),t.prototype.init=function(e){this.params=e,this.textarea=document.createElement("textarea"),this.textarea.maxLength=e.maxLength?e.maxLength:"200",this.textarea.cols=e.cols?e.cols:"60",this.textarea.rows=e.rows?e.rows:"10",s.Utils.exists(e.value)&&(this.textarea.value=e.value.toString()),this.getGui().querySelector(".ag-large-textarea").appendChild(this.textarea),this.addGuiEventListener("keydown",this.onKeyDown.bind(this))},t.prototype.onKeyDown=function(e){var t=e.which||e.keyCode;(t==r.Constants.KEY_LEFT||t==r.Constants.KEY_UP||t==r.Constants.KEY_RIGHT||t==r.Constants.KEY_DOWN||e.shiftKey&&t==r.Constants.KEY_ENTER)&&e.stopPropagation()},t.prototype.afterGuiAttached=function(){this.textarea.focus()},t.prototype.getValue=function(){return this.textarea.value},t.prototype.isPopup=function(){return!0},t.TEMPLATE='<div class="ag-large-text" tabindex="0"><div class="ag-large-textarea"></div></div>',t}(n.Component);t.LargeTextCellEditor=l},function(e,t,o){function i(e){var t=e.module("agGrid",[]);t.directive("agGrid",function(){return{restrict:"A",controller:["$element","$scope","$compile","$attrs",n],scope:!0}})}function n(e,t,o,i){var n,s,l=i.agGrid;if(s=l+".quickFilterText",n=t.$eval(l),!n)return void console.warn("WARNING - grid options for ag-Grid not found. Please ensure the attribute ag-grid points to a valid object on the scope");var a=e[0],p=new r.Grid(a,n,null,t,o,s);t.$on("$destroy",function(){p.destroy()})}/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var r=o(2);t.initialiseAgGridWithAngular1=i},function(e,t,o){function i(){if(!l){l=!0,"undefined"!=typeof document&&document.registerElement||console.error("ag-Grid: unable to find document.registerElement() function, unable to initialise ag-Grid as a Web Component");var e=Object.create(HTMLElement.prototype);r.ComponentUtil.ALL_PROPERTIES.forEach(function(t){Object.defineProperty(e,t,{set:function(e){this.__agGridSetProperty(t,e)},get:function(){return this.__agGridGetProperty(t)}})}),e.__agGridSetProperty=function(e,t){this.__attributes||(this.__attributes={}),this.__attributes[e]=t;var o={};o[e]={currentValue:t},this.onChange(o)},e.onChange=function(e){this._initialised&&r.ComponentUtil.processOnChange(e,this._gridOptions,this.api,this.columnApi)},e.__agGridGetProperty=function(e){return this.__attributes||(this.__attributes={}),this.__attributes[e]},e.setGridOptions=function(e){var t=this.globalEventListener.bind(this);this._gridOptions=r.ComponentUtil.copyAttributesToGridOptions(e,this),this._agGrid=new s.Grid(this,this._gridOptions,t),this.api=e.api,this.columnApi=e.columnApi,this._initialised=!0},e.createdCallback=function(){for(var e=0;e<this.attributes.length;e++){var t=this.attributes[e];this.setPropertyFromAttribute(t)}},e.setPropertyFromAttribute=function(e){var t=n(e.nodeName),o=e.nodeValue;r.ComponentUtil.ALL_PROPERTIES.indexOf(t)>=0&&(this[t]=o)},e.attachedCallback=function(e){},e.detachedCallback=function(e){},e.attributeChangedCallback=function(e){var t=this.attributes[e];this.setPropertyFromAttribute(t)},e.globalEventListener=function(e,t){var o=e.toLowerCase(),i=new Event(o),n=i;n.agGridDetails=t,this.dispatchEvent(i);var r="on"+o;"function"==typeof this[r]&&this[r](i)},document.registerElement("ag-grid",{prototype:e})}}function n(e){if("string"==typeof e){var t=e.replace(/-([a-z])/g,function(e){return e[1].toUpperCase()});return t}return e}/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var r=o(9),s=o(2),l=!1;t.initialiseAgGridWithWebComponents=i},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=o(7),n=function(){function e(t){var o=this;this.items=[],this.params=t,this.eGui=document.createElement("div"),this.eGui.innerHTML=e.TEMPLATE,this.eHeader=this.eGui.querySelector("#tabHeader"),this.eBody=this.eGui.querySelector("#tabBody"),i.Utils.addCssClass(this.eGui,t.cssClass),t.items&&t.items.forEach(function(e){return o.addItem(e)})}return e.prototype.setAfterAttachedParams=function(e){this.afterAttachedParams=e},e.prototype.getMinWidth=function(){var e=document.createElement("span");e.style.position="fixed",this.eGui.appendChild(e);var t=0;return this.items.forEach(function(o){i.Utils.removeAllChildren(e);var n=o.tabbedItem.body.cloneNode(!0);e.appendChild(n),t<e.offsetWidth&&(t=e.offsetWidth)}),this.eGui.removeChild(e),t},e.prototype.showFirstItem=function(){this.items.length>0&&this.showItemWrapper(this.items[0])},e.prototype.addItem=function(e){var t=document.createElement("span");t.appendChild(e.title),i.Utils.addCssClass(t,"ag-tab"),this.eHeader.appendChild(t);var o={tabbedItem:e,eHeaderButton:t};this.items.push(o),t.addEventListener("click",this.showItemWrapper.bind(this,o))},e.prototype.showItem=function(e){var t=i.Utils.find(this.items,function(t){return t.tabbedItem===e});t&&this.showItemWrapper(t)},e.prototype.showItemWrapper=function(e){return this.params.onItemClicked&&this.params.onItemClicked({item:e.tabbedItem}),this.activeItem===e?void i.Utils.callIfPresent(this.params.onActiveItemClicked):(i.Utils.removeAllChildren(this.eBody),this.eBody.appendChild(e.tabbedItem.body),this.activeItem&&i.Utils.removeCssClass(this.activeItem.eHeaderButton,"ag-tab-selected"),i.Utils.addCssClass(e.eHeaderButton,"ag-tab-selected"),this.activeItem=e,void(e.tabbedItem.afterAttachedCallback&&e.tabbedItem.afterAttachedCallback(this.afterAttachedParams)))},e.prototype.getGui=function(){return this.eGui},e.TEMPLATE='<div><div id="tabHeader" class="ag-tab-header"></div><div id="tabBody" class="ag-tab-body"></div></div>',e}();t.TabbedLayout=n},function(e,t){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var o=function(){function e(){this.isLayoutPanel=!0,this.childPanels=[],this.eGui=document.createElement("div"),this.eGui.style.height="100%"}return e.prototype.addPanel=function(e,t){var o;e.isLayoutPanel?(this.childPanels.push(e),o=e.getGui()):o=e,t&&(o.style.height=t),this.eGui.appendChild(o)},e.prototype.getGui=function(){return this.eGui},e.prototype.doLayout=function(){for(var e=0;e<this.childPanels.length;e++)this.childPanels[e].doLayout()},e}();t.VerticalStack=o},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},r=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},s=o(47),l=o(6),a=o(7),p=o(44),d=o(97),u=function(e){function t(){e.call(this,t.TEMPLATE),this.timerCount=0}return i(t,e),t.prototype.clearActiveItem=function(){this.removeActiveItem(),this.removeOldChildPopup()},t.prototype.addMenuItems=function(e,t){var o=this;a.Utils.missing(e)||e.forEach(function(e){if("separator"===e)o.addSeparator();else{var i;i="string"==typeof e?t[e]:e,o.addItem(i)}})},t.prototype.addItem=function(e){var t=this,o=new d.MenuItemComponent(e);this.context.wireBean(o),this.getGui().appendChild(o.getGui()),o.addEventListener(d.MenuItemComponent.EVENT_ITEM_SELECTED,function(i){e.childMenu?t.showChildMenu(e,o):t.dispatchEvent(d.MenuItemComponent.EVENT_ITEM_SELECTED,i)}),o.addGuiEventListener("mouseenter",this.mouseEnterItem.bind(this,e,o)),o.addGuiEventListener("mouseleave",function(){return t.timerCount++}),e.childMenu&&this.addDestroyFunc(function(){return e.childMenu.destroy()})},t.prototype.mouseEnterItem=function(e,t){e.disabled||(this.activeMenuItemParams!==e&&this.removeOldChildPopup(),this.removeActiveItem(),this.activeMenuItemParams=e,this.activeMenuItem=t,a.Utils.addCssClass(this.activeMenuItem.getGui(),"ag-menu-option-active"),e.childMenu&&this.addHoverForChildPopup(e,t))},t.prototype.removeActiveItem=function(){this.activeMenuItem&&(a.Utils.removeCssClass(this.activeMenuItem.getGui(),"ag-menu-option-active"),this.activeMenuItem=null,this.activeMenuItemParams=null)},t.prototype.addHoverForChildPopup=function(e,t){var o=this,i=this.timerCount;setTimeout(function(){var n=i===o.timerCount,r=o.showingChildMenu===e.childMenu;n&&!r&&o.showChildMenu(e,t)},500)},t.prototype.showChildMenu=function(e,t){this.removeOldChildPopup();var o=a.Utils.loadTemplate('<div class="ag-menu"></div>');o.appendChild(e.childMenu.getGui()),this.childPopupRemoveFunc=this.popupService.addAsModalPopup(o,!0),this.popupService.positionPopupForMenu({eventSource:t.getGui(),ePopup:o}),this.showingChildMenu=e.childMenu},t.prototype.addSeparator=function(){this.getGui().appendChild(a.Utils.loadTemplate(t.SEPARATOR_TEMPLATE))},t.prototype.removeOldChildPopup=function(){this.childPopupRemoveFunc&&(this.showingChildMenu.clearActiveItem(),this.childPopupRemoveFunc(),this.childPopupRemoveFunc=null,this.showingChildMenu=null)},t.prototype.destroy=function(){this.removeOldChildPopup(),e.prototype.destroy.call(this)},t.TEMPLATE='<div class="ag-menu-list"></div>',t.SEPARATOR_TEMPLATE='<div class="ag-menu-separator">  <span class="ag-menu-separator-cell"></span>  <span class="ag-menu-separator-cell"></span>  <span class="ag-menu-separator-cell"></span>  <span class="ag-menu-separator-cell"></span></div>',n([l.Autowired("context"),r("design:type",l.Context)],t.prototype,"context",void 0),n([l.Autowired("popupService"),r("design:type",p.PopupService)],t.prototype,"popupService",void 0),t}(s.Component);t.MenuList=u},function(e,t,o){/**
		 * ag-grid - Advanced Data Grid / Data Table supporting Javascript / React / AngularJS / Web Components
		 * @version v5.4.0
		 * @link http://www.ag-grid.com/
		 * @license MIT
		 */
	var i=this&&this.__extends||function(e,t){function o(){this.constructor=e}for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);e.prototype=null===t?Object.create(t):(o.prototype=t.prototype,new o)},n=this&&this.__decorate||function(e,t,o,i){var n,r=arguments.length,s=r<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var l=e.length-1;l>=0;l--)(n=e[l])&&(s=(r<3?n(s):r>3?n(t,o,s):n(t,o))||s);return r>3&&s&&Object.defineProperty(t,o,s),s},r=this&&this.__metadata||function(e,t){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(e,t)},s=o(47),l=o(6),a=o(44),p=o(7),d=o(58),u=d.SvgFactory.getInstance(),c=function(e){function t(o){e.call(this,t.TEMPLATE),this.params=o,o.checked?this.queryForHtmlElement("#eIcon").innerHTML="&#10004;":o.icon?p.Utils.isNodeOrElement(o.icon)?this.queryForHtmlElement("#eIcon").appendChild(o.icon):"string"==typeof o.icon?this.queryForHtmlElement("#eIcon").innerHTML=o.icon:console.log("ag-Grid: menu item icon must be DOM node or string"):this.queryForHtmlElement("#eIcon").innerHTML="&nbsp;",o.shortcut&&(this.queryForHtmlElement("#eShortcut").innerHTML=o.shortcut),o.childMenu?this.queryForHtmlElement("#ePopupPointer").appendChild(u.createSmallArrowRightSvg()):this.queryForHtmlElement("#ePopupPointer").innerHTML="&nbsp;",this.queryForHtmlElement("#eName").innerHTML=o.name,o.disabled?p.Utils.addCssClass(this.getGui(),"ag-menu-option-disabled"):this.addGuiEventListener("click",this.onOptionSelected.bind(this))}return i(t,e),t.prototype.onOptionSelected=function(){this.dispatchEvent(t.EVENT_ITEM_SELECTED,this.params),this.params.action&&this.params.action()},t.TEMPLATE='<div class="ag-menu-option">  <span id="eIcon" class="ag-menu-option-icon"></span>  <span id="eName" class="ag-menu-option-text"></span>  <span id="eShortcut" class="ag-menu-option-shortcut"></span>  <span id="ePopupPointer" class="ag-menu-option-popup-pointer"></span></div>',t.EVENT_ITEM_SELECTED="itemSelected",n([l.Autowired("popupService"),r("design:type",a.PopupService)],t.prototype,"popupService",void 0),t}(s.Component);t.MenuItemComponent=c}])});

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.2.18
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	/*jshint globalstrict:true*/
	/*global angular:false*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    toJson = angular.toJson;
	
	function inherit(parent, extra) {
	  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
	}
	
	function merge(dst) {
	  forEach(arguments, function(obj) {
	    if (obj !== dst) {
	      forEach(obj, function(value, key) {
	        if (!dst.hasOwnProperty(key)) dst[key] = value;
	      });
	    }
	  });
	  return dst;
	}
	
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  forEach(object, function(val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */
	function indexOf(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i] || !parents[i].params) continue;
	    parentParams = objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */
	function equalForKeys(a, b, keys) {
	  if (!keys) {
	    keys = [];
	    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	  }
	
	  for (var i=0; i<keys.length; i++) {
	    var k = keys[i];
	    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	  }
	  return true;
	}
	
	/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */
	function filterByKeys(keys, values) {
	  var filtered = {};
	
	  forEach(keys, function (name) {
	    filtered[name] = values[name];
	  });
	  return filtered;
	}
	
	// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array, propName) {
	  var result = {};
	  forEach(array, function(item) {
	    result[item[propName]] = item;
	  });
	  return result;
	}
	
	// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  forEach(keys, function(key) {
	    if (key in obj) copy[key] = obj[key];
	  });
	  return copy;
	}
	
	// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  for (var key in obj) {
	    if (indexOf(keys, key) == -1) copy[key] = obj[key];
	  }
	  return copy;
	}
	
	function pluck(collection, key) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = isFunction(key) ? key(val) : val[key];
	  });
	  return result;
	}
	
	function filter(collection, callback) {
	  var array = isArray(collection);
	  var result = array ? [] : {};
	  forEach(collection, function(val, i) {
	    if (callback(val, i)) {
	      result[array ? result.length : i] = val;
	    }
	  });
	  return result;
	}
	
	function map(collection, callback) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = callback(val, i);
	  });
	  return result;
	}
	
	/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */
	angular.module('ui.router.util', ['ng']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */
	angular.module('ui.router.router', ['ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */
	angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */
	angular.module('ui.router', ['ui.router.state']);
	
	angular.module('ui.router.compat', ['ui.router']);
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */
	$Resolve.$inject = ['$q', '$injector'];
	function $Resolve(  $q,    $injector) {
	  
	  var VISIT_IN_PROGRESS = 1,
	      VISIT_DONE = 2,
	      NOTHING = {},
	      NO_DEPENDENCIES = [],
	      NO_LOCALS = NOTHING,
	      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	  
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */
	  this.study = function (invocables) {
	    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	    var invocableKeys = objectKeys(invocables || {});
	    
	    // Perform a topological sort of invocables to build an ordered plan
	    var plan = [], cycle = [], visited = {};
	    function visit(value, key) {
	      if (visited[key] === VISIT_DONE) return;
	      
	      cycle.push(key);
	      if (visited[key] === VISIT_IN_PROGRESS) {
	        cycle.splice(0, indexOf(cycle, key));
	        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	      }
	      visited[key] = VISIT_IN_PROGRESS;
	      
	      if (isString(value)) {
	        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
	      } else {
	        var params = $injector.annotate(value);
	        forEach(params, function (param) {
	          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	        });
	        plan.push(key, value, params);
	      }
	      
	      cycle.pop();
	      visited[key] = VISIT_DONE;
	    }
	    forEach(invocables, visit);
	    invocables = cycle = visited = null; // plan is all that's required
	    
	    function isResolve(value) {
	      return isObject(value) && value.then && value.$$promises;
	    }
	    
	    return function (locals, parent, self) {
	      if (isResolve(locals) && self === undefined) {
	        self = parent; parent = locals; locals = null;
	      }
	      if (!locals) locals = NO_LOCALS;
	      else if (!isObject(locals)) {
	        throw new Error("'locals' must be an object");
	      }       
	      if (!parent) parent = NO_PARENT;
	      else if (!isResolve(parent)) {
	        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	      }
	      
	      // To complete the overall resolution, we have to wait for the parent
	      // promise and for the promise for each invokable in our plan.
	      var resolution = $q.defer(),
	          result = resolution.promise,
	          promises = result.$$promises = {},
	          values = extend({}, locals),
	          wait = 1 + plan.length/3,
	          merged = false;
	          
	      function done() {
	        // Merge parent values we haven't got yet and publish our own $$values
	        if (!--wait) {
	          if (!merged) merge(values, parent.$$values); 
	          result.$$values = values;
	          result.$$promises = result.$$promises || true; // keep for isResolve()
	          delete result.$$inheritedValues;
	          resolution.resolve(values);
	        }
	      }
	      
	      function fail(reason) {
	        result.$$failure = reason;
	        resolution.reject(reason);
	      }
	
	      // Short-circuit if parent has already failed
	      if (isDefined(parent.$$failure)) {
	        fail(parent.$$failure);
	        return result;
	      }
	      
	      if (parent.$$inheritedValues) {
	        merge(values, omit(parent.$$inheritedValues, invocableKeys));
	      }
	
	      // Merge parent values if the parent has already resolved, or merge
	      // parent promises and wait if the parent resolve is still in progress.
	      extend(promises, parent.$$promises);
	      if (parent.$$values) {
	        merged = merge(values, omit(parent.$$values, invocableKeys));
	        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	        done();
	      } else {
	        if (parent.$$inheritedValues) {
	          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	        }        
	        parent.then(done, fail);
	      }
	      
	      // Process each invocable in the plan, but ignore any where a local of the same name exists.
	      for (var i=0, ii=plan.length; i<ii; i+=3) {
	        if (locals.hasOwnProperty(plan[i])) done();
	        else invoke(plan[i], plan[i+1], plan[i+2]);
	      }
	      
	      function invoke(key, invocable, params) {
	        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	        var invocation = $q.defer(), waitParams = 0;
	        function onfailure(reason) {
	          invocation.reject(reason);
	          fail(reason);
	        }
	        // Wait for any parameter that we have a promise for (either from parent or from this
	        // resolve; in that case study() will have made sure it's ordered before us in the plan).
	        forEach(params, function (dep) {
	          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	            waitParams++;
	            promises[dep].then(function (result) {
	              values[dep] = result;
	              if (!(--waitParams)) proceed();
	            }, onfailure);
	          }
	        });
	        if (!waitParams) proceed();
	        function proceed() {
	          if (isDefined(result.$$failure)) return;
	          try {
	            invocation.resolve($injector.invoke(invocable, self, values));
	            invocation.promise.then(function (result) {
	              values[key] = result;
	              done();
	            }, onfailure);
	          } catch (e) {
	            onfailure(e);
	          }
	        }
	        // Publish promise synchronously; invocations further down in the plan may depend on it.
	        promises[key] = invocation.promise;
	      }
	      
	      return result;
	    };
	  };
	  
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */
	  this.resolve = function (invocables, locals, parent, self) {
	    return this.study(invocables)(locals, parent, self);
	  };
	}
	
	angular.module('ui.router.util').service('$resolve', $Resolve);
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */
	$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
	function $TemplateFactory(  $http,   $templateCache,   $injector) {
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */
	  this.fromConfig = function (config, params, locals) {
	    return (
	      isDefined(config.template) ? this.fromString(config.template, params) :
	      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
	      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
	      null
	    );
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */
	  this.fromString = function (template, params) {
	    return isFunction(template) ? template(params) : template;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromUrl = function (url, params) {
	    if (isFunction(url)) url = url(params);
	    if (url == null) return null;
	    else return $http
	        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
	        .then(function(response) { return response.data; });
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromProvider = function (provider, params, locals) {
	    return $injector.invoke(provider, null, locals || { params: params });
	  };
	}
	
	angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);
	
	var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 *
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */
	function UrlMatcher(pattern, config, parentMatcher) {
	  config = extend({ params: {} }, isObject(config) ? config : {});
	
	  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	  //   '*' name
	  //   ':' name
	  //   '{' name '}'
	  //   '{' name ':' regexp '}'
	  // The regular expression is somewhat complicated due to the need to allow curly braces
	  // inside the regular expression. The placeholder regexp breaks down as follows:
	  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	  //    [^{}\\]+                       - anything other than curly braces or backslash
	  //    \\.                            - a backslash escape
	  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      compiled = '^', last = 0, m,
	      segments = this.segments = [],
	      parentParams = parentMatcher ? parentMatcher.params : {},
	      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	      paramNames = [];
	
	  function addParameter(id, type, config, location) {
	    paramNames.push(id);
	    if (parentParams[id]) return parentParams[id];
	    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	    params[id] = new $$UMFP.Param(id, type, config, location);
	    return params[id];
	  }
	
	  function quoteRegExp(string, pattern, squash, optional) {
	    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!pattern) return result;
	    switch(squash) {
	      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
	      case true:
	        result = result.replace(/\/$/, '');
	        surroundPattern = ['(?:\/(', ')|\/)?'];
	      break;
	      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
	    }
	    return result + surroundPattern[0] + pattern + surroundPattern[1];
	  }
	
	  this.source = pattern;
	
	  // Split into static segments separated by path parameter placeholders.
	  // The number of segments is always 1 more than the number of parameters.
	  function matchDetails(m, isSearch) {
	    var id, regexp, segment, type, cfg, arrayMode;
	    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	    cfg         = config.params[id];
	    segment     = pattern.substring(last, m.index);
	    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	    if (regexp) {
	      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	    }
	
	    return {
	      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	    };
	  }
	
	  var p, param, segment;
	  while ((m = placeholder.exec(pattern))) {
	    p = matchDetails(m, false);
	    if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	    param = addParameter(p.id, p.type, p.cfg, "path");
	    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	    segments.push(p.segment);
	    last = placeholder.lastIndex;
	  }
	  segment = pattern.substring(last);
	
	  // Find any search parameter names and remove them from the last segment
	  var i = segment.indexOf('?');
	
	  if (i >= 0) {
	    var search = this.sourceSearch = segment.substring(i);
	    segment = segment.substring(0, i);
	    this.sourcePath = pattern.substring(0, last + i);
	
	    if (search.length > 0) {
	      last = 0;
	      while ((m = searchPlaceholder.exec(search))) {
	        p = matchDetails(m, true);
	        param = addParameter(p.id, p.type, p.cfg, "search");
	        last = placeholder.lastIndex;
	        // check if ?&
	      }
	    }
	  } else {
	    this.sourcePath = pattern;
	    this.sourceSearch = '';
	  }
	
	  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	  segments.push(segment);
	
	  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	  this.prefix = segments[0];
	  this.$$paramNames = paramNames;
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */
	UrlMatcher.prototype.concat = function (pattern, config) {
	  // Because order of search parameters is irrelevant, we can add our own search
	  // parameters to the end of the new pattern. Parse the new pattern by itself
	  // and then join the bits together, but it's much easier to do this on a string level.
	  var defaultConfig = {
	    caseInsensitive: $$UMFP.caseInsensitive(),
	    strict: $$UMFP.strictMode(),
	    squash: $$UMFP.defaultSquashPolicy()
	  };
	  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	};
	
	UrlMatcher.prototype.toString = function () {
	  return this.source;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */
	UrlMatcher.prototype.exec = function (path, searchParams) {
	  var m = this.regexp.exec(path);
	  if (!m) return null;
	  searchParams = searchParams || {};
	
	  var paramNames = this.parameters(), nTotal = paramNames.length,
	    nPath = this.segments.length - 1,
	    values = {}, i, j, cfg, paramName;
	
	  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	  function decodePathArray(string) {
	    function reverseString(str) { return str.split("").reverse().join(""); }
	    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }
	
	    var split = reverseString(string).split(/-(?!\\)/);
	    var allReversed = map(split, reverseString);
	    return map(allReversed, unquoteDashes).reverse();
	  }
	
	  var param, paramVal;
	  for (i = 0; i < nPath; i++) {
	    paramName = paramNames[i];
	    param = this.params[paramName];
	    paramVal = m[i+1];
	    // if the param value matches a pre-replace pair, replace the value before decoding.
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	  for (/**/; i < nTotal; i++) {
	    paramName = paramNames[i];
	    values[paramName] = this.params[paramName].value(searchParams[paramName]);
	    param = this.params[paramName];
	    paramVal = searchParams[paramName];
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	
	  return values;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 *
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */
	UrlMatcher.prototype.parameters = function (param) {
	  if (!isDefined(param)) return this.$$paramNames;
	  return this.params[param] || null;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validates
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */
	UrlMatcher.prototype.validates = function (params) {
	  return this.params.$$validates(params);
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */
	UrlMatcher.prototype.format = function (values) {
	  values = values || {};
	  var segments = this.segments, params = this.parameters(), paramset = this.params;
	  if (!this.validates(values)) return null;
	
	  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
	
	  function encodeDashes(str) { // Replace dashes with encoded "\-"
	    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
	  }
	
	  for (i = 0; i < nTotal; i++) {
	    var isPathParam = i < nPath;
	    var name = params[i], param = paramset[name], value = param.value(values[name]);
	    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	    var squash = isDefaultValue ? param.squash : false;
	    var encoded = param.type.encode(value);
	
	    if (isPathParam) {
	      var nextSegment = segments[i + 1];
	      var isFinalPathParam = i + 1 === nPath;
	
	      if (squash === false) {
	        if (encoded != null) {
	          if (isArray(encoded)) {
	            result += map(encoded, encodeDashes).join("-");
	          } else {
	            result += encodeURIComponent(encoded);
	          }
	        }
	        result += nextSegment;
	      } else if (squash === true) {
	        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	        result += nextSegment.match(capture)[1];
	      } else if (isString(squash)) {
	        result += squash + nextSegment;
	      }
	
	      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	    } else {
	      if (encoded == null || (isDefaultValue && squash !== false)) continue;
	      if (!isArray(encoded)) encoded = [ encoded ];
	      if (encoded.length === 0) continue;
	      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	      result += (search ? '&' : '?') + (name + '=' + encoded);
	      search = true;
	    }
	  }
	
	  return result;
	};
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */
	function Type(config) {
	  extend(this, config);
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */
	Type.prototype.is = function(val, key) {
	  return true;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */
	Type.prototype.encode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */
	Type.prototype.decode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */
	Type.prototype.equals = function(a, b) {
	  return a == b;
	};
	
	Type.prototype.$subPattern = function() {
	  var sub = this.pattern.toString();
	  return sub.substr(1, sub.length - 2);
	};
	
	Type.prototype.pattern = /.*/;
	
	Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };
	
	/** Given an encoded string, or a decoded object, returns a decoded object */
	Type.prototype.$normalize = function(val) {
	  return this.is(val) ? val : this.decode(val);
	};
	
	/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */
	Type.prototype.$asArray = function(mode, isSearch) {
	  if (!mode) return this;
	  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	  function ArrayType(type, mode) {
	    function bindTo(type, callbackName) {
	      return function() {
	        return type[callbackName].apply(type, arguments);
	      };
	    }
	
	    // Wrap non-array value as array
	    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	      switch(val.length) {
	        case 0: return undefined;
	        case 1: return mode === "auto" ? val[0] : val;
	        default: return val;
	      }
	    }
	    function falsey(val) { return !val; }
	
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	      return function handleArray(val) {
	        if (isArray(val) && val.length === 0) return val;
	        val = arrayWrap(val);
	        var result = map(val, callback);
	        if (allTruthyMode === true)
	          return filter(result, falsey).length === 0;
	        return arrayUnwrap(result);
	      };
	    }
	
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	      return function handleArray(val1, val2) {
	        var left = arrayWrap(val1), right = arrayWrap(val2);
	        if (left.length !== right.length) return false;
	        for (var i = 0; i < left.length; i++) {
	          if (!callback(left[i], right[i])) return false;
	        }
	        return true;
	      };
	    }
	
	    this.encode = arrayHandler(bindTo(type, 'encode'));
	    this.decode = arrayHandler(bindTo(type, 'decode'));
	    this.is     = arrayHandler(bindTo(type, 'is'), true);
	    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	    this.pattern = type.pattern;
	    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	    this.name = type.name;
	    this.$arrayMode = mode;
	  }
	
	  return new ArrayType(this, mode);
	};
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */
	function $UrlMatcherFactory() {
	  $$UMFP = this;
	
	  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
	
	  // Use tildes to pre-encode slashes.
	  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	  // and bidirectional encoding/decoding fails.
	  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	  function valToString(val) { return val != null ? val.toString().replace(/~/g, "~~").replace(/\//g, "~2F") : val; }
	  function valFromString(val) { return val != null ? val.toString().replace(/~2F/g, "/").replace(/~~/g, "~") : val; }
	
	  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
	    "string": {
	      encode: valToString,
	      decode: valFromString,
	      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	      // In 0.2.x, string params are optional by default for backwards compat
	      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
	      pattern: /[^/]*/
	    },
	    "int": {
	      encode: valToString,
	      decode: function(val) { return parseInt(val, 10); },
	      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
	      pattern: /\d+/
	    },
	    "bool": {
	      encode: function(val) { return val ? 1 : 0; },
	      decode: function(val) { return parseInt(val, 10) !== 0; },
	      is: function(val) { return val === true || val === false; },
	      pattern: /0|1/
	    },
	    "date": {
	      encode: function (val) {
	        if (!this.is(val))
	          return undefined;
	        return [ val.getFullYear(),
	          ('0' + (val.getMonth() + 1)).slice(-2),
	          ('0' + val.getDate()).slice(-2)
	        ].join("-");
	      },
	      decode: function (val) {
	        if (this.is(val)) return val;
	        var match = this.capture.exec(val);
	        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	      },
	      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
	      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
	      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	    },
	    "json": {
	      encode: angular.toJson,
	      decode: angular.fromJson,
	      is: angular.isObject,
	      equals: angular.equals,
	      pattern: /[^/]*/
	    },
	    "any": { // does not encode/decode
	      encode: angular.identity,
	      decode: angular.identity,
	      equals: angular.equals,
	      pattern: /.*/
	    }
	  };
	
	  function getDefaultConfig() {
	    return {
	      strict: isStrictMode,
	      caseInsensitive: isCaseInsensitive
	    };
	  }
	
	  function isInjectable(value) {
	    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
	  }
	
	  /**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */
	  $UrlMatcherFactory.$$getDefaultValue = function(config) {
	    if (!isInjectable(config.value)) return config.value;
	    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	    return injector.invoke(config.value);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */
	  this.caseInsensitive = function(value) {
	    if (isDefined(value))
	      isCaseInsensitive = value;
	    return isCaseInsensitive;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */
	  this.strictMode = function(value) {
	    if (isDefined(value))
	      isStrictMode = value;
	    return isStrictMode;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */
	  this.defaultSquashPolicy = function(value) {
	    if (!isDefined(value)) return defaultSquashPolicy;
	    if (value !== true && value !== false && !isString(value))
	      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	    defaultSquashPolicy = value;
	    return value;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */
	  this.compile = function (pattern, config) {
	    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */
	  this.isMatcher = function (o) {
	    if (!isObject(o)) return false;
	    var result = true;
	
	    forEach(UrlMatcher.prototype, function(val, name) {
	      if (isFunction(val)) {
	        result = result && (isDefined(o[name]) && isFunction(o[name]));
	      }
	    });
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */
	  this.type = function (name, definition, definitionFn) {
	    if (!isDefined(definition)) return $types[name];
	    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	    $types[name] = new Type(extend({ name: name }, definition));
	    if (definitionFn) {
	      typeQueue.push({ name: name, def: definitionFn });
	      if (!enqueue) flushTypeQueue();
	    }
	    return this;
	  };
	
	  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	  function flushTypeQueue() {
	    while(typeQueue.length) {
	      var type = typeQueue.shift();
	      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	      angular.extend($types[type.name], injector.invoke(type.def));
	    }
	  }
	
	  // Register default types. Store them in the prototype of $types.
	  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
	  $types = inherit($types, {});
	
	  /* No need to document $get, since it returns this */
	  this.$get = ['$injector', function ($injector) {
	    injector = $injector;
	    enqueue = false;
	    flushTypeQueue();
	
	    forEach(defaultTypes, function(type, name) {
	      if (!$types[name]) $types[name] = new Type(type);
	    });
	    return this;
	  }];
	
	  this.Param = function Param(id, type, config, location) {
	    var self = this;
	    config = unwrapShorthand(config);
	    type = getType(config, type, location);
	    var arrayMode = getArrayMode();
	    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
	      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	    var isOptional = config.value !== undefined;
	    var squash = getSquashPolicy(config, isOptional);
	    var replace = getReplace(config, arrayMode, isOptional, squash);
	
	    function unwrapShorthand(config) {
	      var keys = isObject(config) ? objectKeys(config) : [];
	      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
	                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	      if (isShorthand) config = { value: config };
	      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
	      return config;
	    }
	
	    function getType(config, urlType, location) {
	      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
	      if (urlType) return urlType;
	      if (!config.type) return (location === "config" ? $types.any : $types.string);
	
	      if (angular.isString(config.type))
	        return $types[config.type];
	      if (config.type instanceof Type)
	        return config.type;
	      return new Type(config.type);
	    }
	
	    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	    function getArrayMode() {
	      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
	      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	      return extend(arrayDefaults, arrayParamNomenclature, config).array;
	    }
	
	    /**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */
	    function getSquashPolicy(config, isOptional) {
	      var squash = config.squash;
	      if (!isOptional || squash === false) return false;
	      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	      if (squash === true || isString(squash)) return squash;
	      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	    }
	
	    function getReplace(config, arrayMode, isOptional, squash) {
	      var replace, configuredKeys, defaultPolicy = [
	        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	      ];
	      replace = isArray(config.replace) ? config.replace : [];
	      if (isString(squash))
	        replace.push({ from: squash, to: undefined });
	      configuredKeys = map(replace, function(item) { return item.from; } );
	      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    function $$getDefaultValue() {
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      var defaultValue = injector.invoke(config.$$fn);
	      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
	        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	      return defaultValue;
	    }
	
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    function $value(value) {
	      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
	      function $replace(value) {
	        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
	        return replacement.length ? replacement[0] : value;
	      }
	      value = $replace(value);
	      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	    }
	
	    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }
	
	    extend(this, {
	      id: id,
	      type: type,
	      location: location,
	      array: arrayMode,
	      squash: squash,
	      replace: replace,
	      isOptional: isOptional,
	      value: $value,
	      dynamic: undefined,
	      config: config,
	      toString: toString
	    });
	  };
	
	  function ParamSet(params) {
	    extend(this, params || {});
	  }
	
	  ParamSet.prototype = {
	    $$new: function() {
	      return inherit(this, extend(new ParamSet(), { $$parent: this}));
	    },
	    $$keys: function () {
	      var keys = [], chain = [], parent = this,
	        ignore = objectKeys(ParamSet.prototype);
	      while (parent) { chain.push(parent); parent = parent.$$parent; }
	      chain.reverse();
	      forEach(chain, function(paramset) {
	        forEach(objectKeys(paramset), function(key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	        });
	      });
	      return keys;
	    },
	    $$values: function(paramValues) {
	      var values = {}, self = this;
	      forEach(self.$$keys(), function(key) {
	        values[key] = self[key].value(paramValues && paramValues[key]);
	      });
	      return values;
	    },
	    $$equals: function(paramValues1, paramValues2) {
	      var equal = true, self = this;
	      forEach(self.$$keys(), function(key) {
	        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
	        if (!self[key].type.equals(left, right)) equal = false;
	      });
	      return equal;
	    },
	    $$validates: function $$validate(paramValues) {
	      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
	      for (i = 0; i < keys.length; i++) {
	        param = this[keys[i]];
	        rawVal = paramValues[keys[i]];
	        if ((rawVal === undefined || rawVal === null) && param.isOptional)
	          break; // There was no parameter value, but the param is optional
	        normalized = param.type.$normalize(rawVal);
	        if (!param.type.is(normalized))
	          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	        encoded = param.type.encode(normalized);
	        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
	          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	      }
	      return true;
	    },
	    $$parent: undefined
	  };
	
	  this.ParamSet = ParamSet;
	}
	
	// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);
	
	/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */
	$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
	  var rules = [], otherwise = null, interceptDeferred = false, listener;
	
	  // Returns a string that is a prefix of all strings matching the RegExp
	  function regExpPrefix(re) {
	    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
	  }
	
	  // Interpolates matched values into a String.replace()-style pattern
	  function interpolate(pattern, match) {
	    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	      return match[what === '$' ? 0 : Number(what)];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {function} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.rule = function (rule) {
	    if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    rules.push(rule);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|function} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.otherwise = function (rule) {
	    if (isString(rule)) {
	      var redirect = rule;
	      rule = function () { return redirect; };
	    }
	    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    otherwise = rule;
	    return this;
	  };
	
	
	  function handleIfMatch($injector, handler, match) {
	    if (!match) return false;
	    var result = $injector.invoke(handler, handler, { $match: match });
	    return isDefined(result) ? result : true;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. 
	   * 
	   * If the handler is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|function} handler The path you want to redirect your user to.
	   */
	  this.when = function (what, handler) {
	    var redirect, handlerIsString = isString(handler);
	    if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
	      throw new Error("invalid 'handler' in when()");
	
	    var strategies = {
	      matcher: function (what, handler) {
	        if (handlerIsString) {
	          redirect = $urlMatcherFactory.compile(handler);
	          handler = ['$match', function ($match) { return redirect.format($match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	        }, {
	          prefix: isString(what.prefix) ? what.prefix : ''
	        });
	      },
	      regex: function (what, handler) {
	        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	        if (handlerIsString) {
	          redirect = handler;
	          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path()));
	        }, {
	          prefix: regExpPrefix(what)
	        });
	      }
	    };
	
	    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	    for (var n in check) {
	      if (check[n]) return this.rule(strategies[n](what, handler));
	    }
	
	    throw new Error("invalid 'what' in when()");
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */
	  this.deferIntercept = function (defer) {
	    if (defer === undefined) defer = true;
	    interceptDeferred = defer;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */
	  this.$get = $get;
	  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {
	
	    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
	
	    function appendBasePath(url, isHtml5, absolute) {
	      if (baseHref === '/') return url;
	      if (isHtml5) return baseHref.slice(0, -1) + url;
	      if (absolute) return baseHref.slice(1) + url;
	      return url;
	    }
	
	    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	    function update(evt) {
	      if (evt && evt.defaultPrevented) return;
	      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	      lastPushedUrl = undefined;
	      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	      //if (ignoreUpdate) return true;
	
	      function check(rule) {
	        var handled = rule($injector, $location);
	
	        if (!handled) return false;
	        if (isString(handled)) $location.replace().url(handled);
	        return true;
	      }
	      var n = rules.length, i;
	
	      for (i = 0; i < n; i++) {
	        if (check(rules[i])) return;
	      }
	      // always check otherwise last to allow dynamic updates to the set of rules
	      if (otherwise) check(otherwise);
	    }
	
	    function listen() {
	      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	      return listener;
	    }
	
	    if (!interceptDeferred) listen();
	
	    return {
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */
	      sync: function() {
	        update();
	      },
	
	      listen: function() {
	        return listen();
	      },
	
	      update: function(read) {
	        if (read) {
	          location = $location.url();
	          return;
	        }
	        if ($location.url() === location) return;
	
	        $location.url(location);
	        $location.replace();
	      },
	
	      push: function(urlMatcher, params, options) {
	         var url = urlMatcher.format(params || {});
	
	        // Handle the special hash param, if needed
	        if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	        }
	
	        $location.url(url);
	        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	        if (options && options.replace) $location.replace();
	      },
	
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */
	      href: function(urlMatcher, params, options) {
	        if (!urlMatcher.validates(params)) return null;
	
	        var isHtml5 = $locationProvider.html5Mode();
	        if (angular.isObject(isHtml5)) {
	          isHtml5 = isHtml5.enabled;
	        }
	
	        isHtml5 = isHtml5 && $sniffer.history;
	        
	        var url = urlMatcher.format(params);
	        options = options || {};
	
	        if (!isHtml5 && url !== null) {
	          url = "#" + $locationProvider.hashPrefix() + url;
	        }
	
	        // Handle special hash param, if needed
	        if (url !== null && params && params['#']) {
	          url += '#' + params['#'];
	        }
	
	        url = appendBasePath(url, isHtml5, options.absolute);
	
	        if (!options.absolute || !url) {
	          return url;
	        }
	
	        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	
	        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	      }
	    };
	  }
	}
	
	angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {
	
	  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';
	
	  // Builds state properties from definition passed to registerState()
	  var stateBuilder = {
	
	    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	    // state.children = [];
	    // if (parent) parent.children.push(state);
	    parent: function(state) {
	      if (isDefined(state.parent) && state.parent) return findState(state.parent);
	      // regex matches any valid composite state name
	      // would match "contact.list" but not "contacts"
	      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	      return compositeName ? findState(compositeName[1]) : root;
	    },
	
	    // inherit 'data' from parent and override by own values (if any)
	    data: function(state) {
	      if (state.parent && state.parent.data) {
	        state.data = state.self.data = inherit(state.parent.data, state.data);
	      }
	      return state.data;
	    },
	
	    // Build a URLMatcher if necessary, either via a relative or absolute URL
	    url: function(state) {
	      var url = state.url, config = { params: state.params || {} };
	
	      if (isString(url)) {
	        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	        return (state.parent.navigable || root).url.concat(url, config);
	      }
	
	      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	    },
	
	    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	    navigable: function(state) {
	      return state.url ? state : (state.parent ? state.parent.navigable : null);
	    },
	
	    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	    ownParams: function(state) {
	      var params = state.url && state.url.params || new $$UMFP.ParamSet();
	      forEach(state.params || {}, function(config, id) {
	        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	      });
	      return params;
	    },
	
	    // Derive parameters for this state and ensure they're a super-set of parent's parameters
	    params: function(state) {
	      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	    },
	
	    // If there is no explicit multi-view configuration, make one up so we don't have
	    // to handle both cases in the view directive later. Note that having an explicit
	    // 'views' property will mean the default unnamed view properties are ignored. This
	    // is also a good time to resolve view names to absolute names, so everything is a
	    // straight lookup at link time.
	    views: function(state) {
	      var views = {};
	
	      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	        views[name] = view;
	      });
	      return views;
	    },
	
	    // Keep a full path from the root down to this state as this is needed for state activation.
	    path: function(state) {
	      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	    },
	
	    // Speed up $state.contains() as it's used a lot
	    includes: function(state) {
	      var includes = state.parent ? extend({}, state.parent.includes) : {};
	      includes[state.name] = true;
	      return includes;
	    },
	
	    $delegates: {}
	  };
	
	  function isRelative(stateName) {
	    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	  }
	
	  function findState(stateOrName, base) {
	    if (!stateOrName) return undefined;
	
	    var isStr = isString(stateOrName),
	        name  = isStr ? stateOrName : stateOrName.name,
	        path  = isRelative(name);
	
	    if (path) {
	      if (!base) throw new Error("No reference point given for path '"  + name + "'");
	      base = findState(base);
	      
	      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
	
	      for (; i < pathLength; i++) {
	        if (rel[i] === "" && i === 0) {
	          current = base;
	          continue;
	        }
	        if (rel[i] === "^") {
	          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	          current = current.parent;
	          continue;
	        }
	        break;
	      }
	      rel = rel.slice(i).join(".");
	      name = current.name + (current.name && rel ? "." : "") + rel;
	    }
	    var state = states[name];
	
	    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	      return state;
	    }
	    return undefined;
	  }
	
	  function queueState(parentName, state) {
	    if (!queue[parentName]) {
	      queue[parentName] = [];
	    }
	    queue[parentName].push(state);
	  }
	
	  function flushQueuedChildren(parentName) {
	    var queued = queue[parentName] || [];
	    while(queued.length) {
	      registerState(queued.shift());
	    }
	  }
	
	  function registerState(state) {
	    // Wrap a new object around the state so we can store our private details easily.
	    state = inherit(state, {
	      self: state,
	      resolve: state.resolve || {},
	      toString: function() { return this.name; }
	    });
	
	    var name = state.name;
	    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	    // Get parent name
	    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
	        : (isString(state.parent)) ? state.parent
	        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
	        : '';
	
	    // If parent is not registered yet, add state to queue and register later
	    if (parentName && !states[parentName]) {
	      return queueState(parentName, state.self);
	    }
	
	    for (var key in stateBuilder) {
	      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	    }
	    states[name] = state;
	
	    // Register the state in the global state list and with $urlRouter if necessary.
	    if (!state[abstractKey] && state.url) {
	      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	          $state.transitionTo(state, $match, { inherit: true, location: false });
	        }
	      }]);
	    }
	
	    // Register any queued children
	    flushQueuedChildren(name);
	
	    return state;
	  }
	
	  // Checks text to see if it looks like a glob.
	  function isGlob (text) {
	    return text.indexOf('*') > -1;
	  }
	
	  // Returns true if glob matches current $state name.
	  function doesStateMatchGlob (glob) {
	    var globSegments = glob.split('.'),
	        segments = $state.$current.name.split('.');
	
	    //match single stars
	    for (var i = 0, l = globSegments.length; i < l; i++) {
	      if (globSegments[i] === '*') {
	        segments[i] = '*';
	      }
	    }
	
	    //match greedy starts
	    if (globSegments[0] === '**') {
	       segments = segments.slice(indexOf(segments, globSegments[1]));
	       segments.unshift('**');
	    }
	    //match greedy ends
	    if (globSegments[globSegments.length - 1] === '**') {
	       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	       segments.push('**');
	    }
	
	    if (globSegments.length != segments.length) {
	      return false;
	    }
	
	    return segments.join('') === globSegments.join('');
	  }
	
	
	  // Implicit root state that is always active
	  root = registerState({
	    name: '',
	    url: '^',
	    views: null,
	    'abstract': true
	  });
	  root.navigable = null;
	
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */
	  this.decorator = decorator;
	  function decorator(name, func) {
	    /*jshint validthis: true */
	    if (isString(name) && !isDefined(func)) {
	      return stateBuilder[name];
	    }
	    if (!isFunction(func) || !isString(name)) {
	      return this;
	    }
	    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	      stateBuilder.$delegates[name] = stateBuilder[name];
	    }
	    stateBuilder[name] = func;
	    return this;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {string|object=} stateConfig.parent
	   * <a id='parent'></a>
	   * Optionally specifies the parent state of this state.
	   *
	   * <pre>parent: 'parentState'</pre>
	   * <pre>parent: parentState // JS variable</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	   *   more details on acceptable patterns )
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   * </pre>
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */
	  this.state = state;
	  function state(name, definition) {
	    /*jshint validthis: true */
	    if (isObject(name)) definition = name;
	    else definition.name = name;
	    registerState(definition);
	    return this;
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */
	  this.$get = $get;
	  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {
	
	    var TransitionSuperseded = $q.reject(new Error('transition superseded'));
	    var TransitionPrevented = $q.reject(new Error('transition prevented'));
	    var TransitionAborted = $q.reject(new Error('transition aborted'));
	    var TransitionFailed = $q.reject(new Error('transition failed'));
	
	    // Handles the case where a state which is the target of a transition is not found, and the user
	    // can optionally retry or defer the transition
	    function handleRedirect(redirect, state, params, options) {
	      /**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */
	      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	      if (evt.defaultPrevented) {
	        $urlRouter.update();
	        return TransitionAborted;
	      }
	
	      if (!evt.retry) {
	        return null;
	      }
	
	      // Allow the handler to return a promise to defer state lookup retry
	      if (options.$retry) {
	        $urlRouter.update();
	        return TransitionFailed;
	      }
	      var retryTransition = $state.transition = $q.when(evt.retry);
	
	      retryTransition.then(function() {
	        if (retryTransition !== $state.transition) return TransitionSuperseded;
	        redirect.options.$retry = true;
	        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	      }, function() {
	        return TransitionAborted;
	      });
	      $urlRouter.update();
	
	      return retryTransition;
	    }
	
	    root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	    $state = {
	      params: {},
	      current: root.self,
	      $current: root,
	      transition: null
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved,
	     * controllers reinstantiated, and events re-fired.
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	     * @example
	     * <pre>
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	     * //and current state is 'contacts.detail.item'
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.reload = function reload(state) {
	      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. Only parameters specified in the state definition can be overridden, new 
	     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	     *    have changed.  It will reload the resolves and views of the current state and parent states.
	     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	     *    the transition reloads the resolves and views for that matched state, and all its children states.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */
	    $state.go = function go(to, params, options) {
	      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *    if String, then will reload the state with the name given in reload, and any children.
	     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.transitionTo = function transitionTo(to, toParams, options) {
	      toParams = toParams || {};
	      options = extend({
	        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	      }, options || {});
	
	      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
	      var evt, toState = findState(to, options.relative);
	
	      // Store the hash param for later (since it will be stripped out by various methods)
	      var hash = toParams['#'];
	
	      if (!isDefined(toState)) {
	        var redirect = { to: to, toParams: toParams, options: options };
	        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	        if (redirectResult) {
	          return redirectResult;
	        }
	
	        // Always retry once if the $stateNotFound was not prevented
	        // (handles either redirect changed or state lazy-definition)
	        to = redirect.to;
	        toParams = redirect.toParams;
	        options = redirect.options;
	        toState = findState(to, options.relative);
	
	        if (!isDefined(toState)) {
	          if (!options.relative) throw new Error("No such state '" + to + "'");
	          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	        }
	      }
	      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	      if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	      toParams = toState.params.$$values(toParams);
	      to = toState;
	
	      var toPath = to.path;
	
	      // Starting from the root of the path, keep all levels that haven't changed
	      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
	
	      if (!options.reload) {
	        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      } else if (isString(options.reload) || isObject(options.reload)) {
	        if (isObject(options.reload) && !options.reload.name) {
	          throw new Error('Invalid reload state object');
	        }
	        
	        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	        if (options.reload && !reloadState) {
	          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	        }
	
	        while (state && state === fromPath[keep] && state !== reloadState) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      }
	
	      // If we're going to the same state and all locals are kept, we've got nothing to do.
	      // But clear 'transition', as we still want to cancel any other pending transitions.
	      // TODO: We may not want to bump 'transition' if we're called from a location change
	      // that we've initiated ourselves, because we might accidentally abort a legitimate
	      // transition initiated from code?
	      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	        if (hash) toParams['#'] = hash;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	        if (options.location && to.navigable && to.navigable.url) {
	          $urlRouter.push(to.navigable.url, toParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	          $urlRouter.update(true);
	        }
	        $state.transition = null;
	        return $q.when($state.current);
	      }
	
	      // Filter parameters before we pass them to event handlers etc.
	      toParams = filterByKeys(to.params.$$keys(), toParams || {});
	      
	      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	      if (hash) toParams['#'] = hash;
	      
	      // Broadcast start event and cancel the transition if requested
	      if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */
	        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	          if ($state.transition == null) $urlRouter.update();
	          return TransitionPrevented;
	        }
	      }
	
	      // Resolve locals for the remaining states, but don't update any global state just
	      // yet -- if anything fails to resolve the current state needs to remain untouched.
	      // We also set up an inheritance chain for the locals here. This allows the view directive
	      // to quickly look up the correct definition for each view in the current state. Even
	      // though we create the locals object itself outside resolveState(), it is initially
	      // empty and gets filled asynchronously. We need to keep track of the promise for the
	      // (fully resolved) current locals, and pass this down the chain.
	      var resolved = $q.when(locals);
	
	      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	        locals = toLocals[l] = inherit(locals);
	        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	      }
	
	      // Once everything is resolved, we are ready to perform the actual transition
	      // and return a promise for the new state. We also keep track of what the
	      // current promise is, so that we can detect overlapping transitions and
	      // keep only the outcome of the last transition.
	      var transition = $state.transition = resolved.then(function () {
	        var l, entering, exiting;
	
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Exit 'from' states not kept
	        for (l = fromPath.length - 1; l >= keep; l--) {
	          exiting = fromPath[l];
	          if (exiting.self.onExit) {
	            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	          }
	          exiting.locals = null;
	        }
	
	        // Enter 'to' states not kept
	        for (l = keep; l < toPath.length; l++) {
	          entering = toPath[l];
	          entering.locals = toLocals[l];
	          if (entering.self.onEnter) {
	            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	          }
	        }
	
	        // Run it again, to catch any transitions in callbacks
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        // Update globals in $state
	        $state.$current = to;
	        $state.current = to.self;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        $state.transition = null;
	
	        if (options.location && to.navigable) {
	          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	        }
	
	        if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */
	          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	        }
	        $urlRouter.update(true);
	
	        return $state.current;
	      }, function (error) {
	        if ($state.transition !== transition) return TransitionSuperseded;
	
	        $state.transition = null;
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */
	        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	        if (!evt.defaultPrevented) {
	            $urlRouter.update();
	        }
	
	        return $q.reject(error);
	      });
	
	      return transition;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */
	    $state.is = function is(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) { return undefined; }
	      if ($state.$current !== state) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    $state.includes = function includes(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      if (isString(stateOrName) && isGlob(stateOrName)) {
	        if (!doesStateMatchGlob(stateOrName)) {
	          return false;
	        }
	        stateOrName = $state.$current.name;
	      }
	
	      var state = findState(stateOrName, options.relative);
	      if (!isDefined(state)) { return undefined; }
	      if (!isDefined($state.$current.includes[state.name])) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams, objectKeys(params)) : true;
	    };
	
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */
	    $state.href = function href(stateOrName, params, options) {
	      options = extend({
	        lossy:    true,
	        inherit:  true,
	        absolute: false,
	        relative: $state.$current
	      }, options || {});
	
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) return null;
	      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	      
	      var nav = (state && options.lossy) ? state.navigable : state;
	
	      if (!nav || nav.url === undefined || nav.url === null) {
	        return null;
	      }
	      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	        absolute: options.absolute
	      });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */
	    $state.get = function (stateOrName, context) {
	      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
	      var state = findState(stateOrName, context || $state.$current);
	      return (state && state.self) ? state.self : null;
	    };
	
	    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	      // Make a restricted $stateParams with only the parameters that apply to this state if
	      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	      // we also need $stateParams to be available for any $injector calls we make during the
	      // dependency resolution process.
	      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
	      var locals = { $stateParams: $stateParams };
	
	      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	      // We're also including $stateParams in this; that way the parameters are restricted
	      // to the set that should be visible to the state, and are independent of when we update
	      // the global $state and $stateParams values.
	      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	      var promises = [dst.resolve.then(function (globals) {
	        dst.globals = globals;
	      })];
	      if (inherited) promises.push(inherited);
	
	      function resolveViews() {
	        var viewsPromises = [];
	
	        // Resolve template and dependencies for all views.
	        forEach(state.views, function (view, name) {
	          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
	          injectables.$template = [ function () {
	            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	          }];
	
	          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	            // References to the controller (only instantiated at link time)
	            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	              var injectLocals = angular.extend({}, injectables, dst.globals);
	              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	            } else {
	              result.$$controller = view.controller;
	            }
	            // Provide access to the state itself for internal use
	            result.$$state = state;
	            result.$$controllerAs = view.controllerAs;
	            dst[name] = result;
	          }));
	        });
	
	        return $q.all(viewsPromises).then(function(){
	          return dst.globals;
	        });
	      }
	
	      // Wait for all the promises and then return the activation object
	      return $q.all(promises).then(resolveViews).then(function (values) {
	        return dst;
	      });
	    }
	
	    return $state;
	  }
	
	  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	    // Return true if there are no differences in non-search (path/object) params, false if there are differences
	    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	      function notSearchParam(key) {
	        return fromAndToState.params[key].location != "search";
	      }
	      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	      return nonQueryParamSet.$$equals(fromParams, toParams);
	    }
	
	    // If reload was not explicitly requested
	    // and we're transitioning to the same state we're already in
	    // and    the locals didn't change
	    //     or they changed in a way that doesn't merit reloading
	    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	    // Then return true.
	    if (!options.reload && to === from &&
	      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
	      return true;
	    }
	  }
	}
	
	angular.module('ui.router.state')
	  .factory('$stateParams', function () { return {}; })
	  .provider('$state', $StateProvider);
	
	
	$ViewProvider.$inject = [];
	function $ViewProvider() {
	
	  this.$get = $get;
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */
	  $get.$inject = ['$rootScope', '$templateFactory'];
	  function $get(   $rootScope,   $templateFactory) {
	    return {
	      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */
	      load: function load(name, options) {
	        var result, defaults = {
	          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	        };
	        options = extend(defaults, options);
	
	        if (options.view) {
	          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	        }
	        return result;
	      }
	    };
	  }
	}
	
	angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */
	function $ViewScrollProvider() {
	
	  var useAnchorScroll = false;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */
	  this.useAnchorScroll = function () {
	    useAnchorScroll = true;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */
	  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	    if (useAnchorScroll) {
	      return $anchorScroll;
	    }
	
	    return function ($element) {
	      return $timeout(function () {
	        $element[0].scrollIntoView();
	      }, 0, false);
	    };
	  }];
	}
	
	angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	var ngMajorVer = angular.version.major;
	var ngMinorVer = angular.version.minor;
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * @param {string=} noanimation If truthy, the non-animated renderer will be selected (no animations
	 * will be applied to the ui-view)
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 * 
	 * @example
	 * A view can be unnamed or named. 
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div> 
	 * 
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a 
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div> 
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 * 
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * But typically you'll only use the views property if you name your view or have more than one view 
	 * in the same template. There's not really a compelling reason to name a view if its the only one, 
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre> 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 * 
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div> 
	 * <div ui-view="data"></div> 
	 * </pre>
	 * 
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 */
	$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate'];
	function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate) {
	
	  function getService() {
	    return ($injector.has) ? function(service) {
	      return $injector.has(service) ? $injector.get(service) : null;
	    } : function(service) {
	      try {
	        return $injector.get(service);
	      } catch (e) {
	        return null;
	      }
	    };
	  }
	
	  var service = getService(),
	      $animator = service('$animator'),
	      $animate = service('$animate');
	
	  // Returns a set of DOM manipulation functions based on which Angular version
	  // it should use
	  function getRenderer(attrs, scope) {
	    var statics = {
	      enter: function (element, target, cb) { target.after(element); cb(); },
	      leave: function (element, cb) { element.remove(); cb(); }
	    };
	
	    if (!!attrs.noanimation) return statics;
	
	    function animEnabled(element) {
	      if (ngMajorVer === 1 && ngMinorVer >= 4) return !!$animate.enabled(element);
	      if (ngMajorVer === 1 && ngMinorVer >= 2) return !!$animate.enabled();
	      return (!!$animator);
	    }
	
	    // ng 1.2+
	    if ($animate) {
	      return {
	        enter: function(element, target, cb) {
	          if (!animEnabled(element)) {
	            statics.enter(element, target, cb);
	          } else if (angular.version.minor > 2) {
	            $animate.enter(element, null, target).then(cb);
	          } else {
	            $animate.enter(element, null, target, cb);
	          }
	        },
	        leave: function(element, cb) {
	          if (!animEnabled(element)) {
	            statics.leave(element, cb);
	          } else if (angular.version.minor > 2) {
	            $animate.leave(element).then(cb);
	          } else {
	            $animate.leave(element, cb);
	          }
	        }
	      };
	    }
	
	    // ng 1.1.5
	    if ($animator) {
	      var animate = $animator && $animator(scope, attrs);
	
	      return {
	        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
	        leave: function(element, cb) { animate.leave(element); cb(); }
	      };
	    }
	
	    return statics;
	  }
	
	  var directive = {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    compile: function (tElement, tAttrs, $transclude) {
	      return function (scope, $element, attrs) {
	        var previousEl, currentEl, currentScope, latestLocals,
	            onloadExp     = attrs.onload || '',
	            autoScrollExp = attrs.autoscroll,
	            renderer      = getRenderer(attrs, scope);
	
	        scope.$on('$stateChangeSuccess', function() {
	          updateView(false);
	        });
	
	        updateView(true);
	
	        function cleanupLastView() {
	          var _previousEl = previousEl;
	          var _currentScope = currentScope;
	
	          if (_currentScope) {
	            _currentScope._willBeDestroyed = true;
	          }
	
	          function cleanOld() {
	            if (_previousEl) {
	              _previousEl.remove();
	            }
	
	            if (_currentScope) {
	              _currentScope.$destroy();
	            }
	          }
	
	          if (currentEl) {
	            renderer.leave(currentEl, function() {
	              cleanOld();
	              previousEl = null;
	            });
	
	            previousEl = currentEl;
	          } else {
	            cleanOld();
	            previousEl = null;
	          }
	
	          currentEl = null;
	          currentScope = null;
	        }
	
	        function updateView(firstTime) {
	          var newScope,
	              name            = getUiViewName(scope, attrs, $element, $interpolate),
	              previousLocals  = name && $state.$current && $state.$current.locals[name];
	
	          if (!firstTime && previousLocals === latestLocals || scope._willBeDestroyed) return; // nothing to do
	          newScope = scope.$new();
	          latestLocals = $state.$current.locals[name];
	
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoading
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           *
	           * Fired once the view **begins loading**, *before* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          newScope.$emit('$viewContentLoading', name);
	
	          var clone = $transclude(newScope, function(clone) {
	            renderer.enter(clone, $element, function onUiViewEnter() {
	              if(currentScope) {
	                currentScope.$emit('$viewContentAnimationEnded');
	              }
	
	              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                $uiViewScroll(clone);
	              }
	            });
	            cleanupLastView();
	          });
	
	          currentEl = clone;
	          currentScope = newScope;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          currentScope.$emit('$viewContentLoaded', name);
	          currentScope.$eval(onloadExp);
	        }
	      };
	    }
	  };
	
	  return directive;
	}
	
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    compile: function (tElement) {
	      var initial = tElement.html();
	      return function (scope, $element, attrs) {
	        var current = $state.$current,
	            name = getUiViewName(scope, attrs, $element, $interpolate),
	            locals  = current && current.locals[name];
	
	        if (! locals) {
	          return;
	        }
	
	        $element.data('$uiView', { name: name, state: locals.$$state });
	        $element.html(locals.$template ? locals.$template : initial);
	
	        var link = $compile($element.contents());
	
	        if (locals.$$controller) {
	          locals.$scope = scope;
	          locals.$element = $element;
	          var controller = $controller(locals.$$controller, locals);
	          if (locals.$$controllerAs) {
	            scope[locals.$$controllerAs] = controller;
	          }
	          $element.data('$ngControllerController', controller);
	          $element.children().data('$ngControllerController', controller);
	        }
	
	        link(scope);
	      };
	    }
	  };
	}
	
	/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */
	function getUiViewName(scope, attrs, element, $interpolate) {
	  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	  var inherited = element.inheritedData('$uiView');
	  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (inherited ? inherited.state.name : ''));
	}
	
	angular.module('ui.router.state').directive('uiView', $ViewDirective);
	angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	function parseStateRef(ref, current) {
	  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	  if (preparsed) ref = current + '(' + preparsed[1] + ')';
	  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	  return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function stateContext(el) {
	  var stateData = el.parent().inheritedData('$uiView');
	
	  if (stateData && stateData.state && stateData.state.name) {
	    return stateData.state;
	  }
	}
	
	function getTypeInfo(el) {
	  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	  var isForm = el[0].nodeName === "FORM";
	
	  return {
	    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
	    isAnchor: el.prop("tagName").toUpperCase() === "A",
	    clickable: !isForm
	  };
	}
	
	function clickHook(el, $state, $timeout, type, current) {
	  return function(e) {
	    var button = e.which || e.button, target = current();
	
	    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	      var transition = $timeout(function() {
	        $state.go(target.state, target.params, target.options);
	      });
	      e.preventDefault();
	
	      // if the state has no URL, ignore one preventDefault from the <a> directive.
	      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;
	
	      e.preventDefault = function() {
	        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	      };
	    }
	  };
	}
	
	function defaultOpts(el, $state) {
	  return { relative: stateContext(el) || $state.$current, inherit: true };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	 * URL, the directive will automatically generate & update the `href` attribute via
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	 * the link will trigger a state transition with optional parameters.
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 *
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */
	$StateRefDirective.$inject = ['$state', '$timeout'];
	function $StateRefDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
	      var def    = { state: ref.state, href: null, params: null };
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	
	      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	      var update = function(val) {
	        if (val) def.params = angular.copy(val);
	        def.href = $state.href(ref.state, def.params, def.options);
	
	        if (active) active.$$addStateInfo(ref.state, def.params);
	        if (def.href !== null) attrs.$set(type.attr, def.href);
	      };
	
	      if (ref.paramExpr) {
	        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
	        def.params = angular.copy(scope.$eval(ref.paramExpr));
	      }
	      update();
	
	      if (!type.clickable) return;
	      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-state
	 *
	 * @requires ui.router.state.uiSref
	 *
	 * @restrict A
	 *
	 * @description
	 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	 * params and override options.
	 *
	 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#href $state.href()}
	 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#go $state.go()}
	 */
	$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	function $StateRefDynamicDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
	      var def    = { state: null, params: null, options: null, href: null };
	
	      function runStateRefLink (group) {
	        def.state = group[0]; def.params = group[1]; def.options = group[2];
	        def.href = $state.href(def.state, def.params, def.options);
	
	        if (active) active.$$addStateInfo(def.state, def.params);
	        if (def.href) attrs.$set(type.attr, def.href);
	      }
	
	      scope.$watch(watch, runStateRefLink, true);
	      runStateRefLink(scope.$eval(watch));
	
	      if (!type.clickable) return;
	      element.bind("click", clickHook(element, $state, $timeout, type, function() { return def; }));
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * It is also possible to pass ui-sref-active an expression that evaluates
	 * to an object hash, whose keys represent active class names and whose
	 * values represent the respective state names/globs.
	 * ui-sref-active will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * @Example
	 * Given the following template, with "admin" being an abstract state:
	 * <pre>
	 * <div ui-sref-active="{'active': 'admin.*'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * </pre>
	 *
	 * When the current state is "admin.roles" the "active" class will be applied
	 * to both the <div> and <a> elements. It is important to note that the state
	 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */
	$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	  return  {
	    restrict: "A",
	    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;
	
	      // There probably isn't much point in $observing this
	      // uiSrefActive and uiSrefActiveEq share the same directive object with some
	      // slight difference in logic routing
	      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	      try {
	        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	      } catch (e) {
	        // Do nothing. uiSrefActive is not a valid expression.
	        // Fall back to using $interpolate below
	      }
	      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	      if (isObject(uiSrefActive)) {
	        forEach(uiSrefActive, function(stateOrName, activeClass) {
	          if (isString(stateOrName)) {
	            var ref = parseStateRef(stateOrName, $state.current.name);
	            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	          }
	        });
	      }
	
	      // Allow uiSref to communicate with uiSrefActive[Equals]
	      this.$$addStateInfo = function (newState, newParams) {
	        // we already got an explicit state provided by ui-sref-active, so we
	        // shadow the one that comes from ui-sref
	        if (isObject(uiSrefActive) && states.length > 0) {
	          return;
	        }
	        addState(newState, newParams, uiSrefActive);
	        update();
	      };
	
	      $scope.$on('$stateChangeSuccess', update);
	
	      function addState(stateName, stateParams, activeClass) {
	        var state = $state.get(stateName, stateContext($element));
	        var stateHash = createStateHash(stateName, stateParams);
	
	        states.push({
	          state: state || { name: stateName },
	          params: stateParams,
	          hash: stateHash
	        });
	
	        activeClasses[stateHash] = activeClass;
	      }
	
	      /**
	       * @param {string} state
	       * @param {Object|string} [params]
	       * @return {string}
	       */
	      function createStateHash(state, params) {
	        if (!isString(state)) {
	          throw new Error('state should be a string');
	        }
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        params = $scope.$eval(params);
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        return state;
	      }
	
	      // Update route state
	      function update() {
	        for (var i = 0; i < states.length; i++) {
	          if (anyMatch(states[i].state, states[i].params)) {
	            addClass($element, activeClasses[states[i].hash]);
	          } else {
	            removeClass($element, activeClasses[states[i].hash]);
	          }
	
	          if (exactMatch(states[i].state, states[i].params)) {
	            addClass($element, activeEqClass);
	          } else {
	            removeClass($element, activeEqClass);
	          }
	        }
	      }
	
	      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
	      function removeClass(el, className) { el.removeClass(className); }
	      function anyMatch(state, params) { return $state.includes(state.name, params); }
	      function exactMatch(state, params) { return $state.is(state.name, params); }
	
	      update();
	    }]
	  };
	}
	
	angular.module('ui.router.state')
	  .directive('uiSref', $StateRefDirective)
	  .directive('uiSrefActive', $StateRefActiveDirective)
	  .directive('uiSrefActiveEq', $StateRefActiveDirective)
	  .directive('uiState', $StateRefDynamicDirective);
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	  var isFilter = function (state, params) {
	    return $state.is(state, params);
	  };
	  isFilter.$stateful = true;
	  return isFilter;
	}
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	  var includesFilter = function (state, params, options) {
	    return $state.includes(state, params, options);
	  };
	  includesFilter.$stateful = true;
	  return  includesFilter;
	}
	
	angular.module('ui.router.state')
	  .filter('isState', $IsStateFilter)
	  .filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ngRedux = __webpack_require__(15);
	
	var _ngRedux2 = _interopRequireDefault(_ngRedux);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('ngRedux', []).provider('$ngRedux', _ngRedux2.default).name;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.__esModule = true;
	exports.default = ngReduxProvider;
	
	var _connector = __webpack_require__(16);
	
	var _connector2 = _interopRequireDefault(_connector);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _redux = __webpack_require__(19);
	
	var _digestMiddleware = __webpack_require__(53);
	
	var _digestMiddleware2 = _interopRequireDefault(_digestMiddleware);
	
	var _lodash = __webpack_require__(44);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(41);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _lodash5 = __webpack_require__(42);
	
	var _lodash6 = _interopRequireDefault(_lodash5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ngReduxProvider() {
	  var _reducer = undefined;
	  var _middlewares = undefined;
	  var _storeEnhancers = undefined;
	  var _initialState = undefined;
	
	  this.createStoreWith = function (reducer, middlewares, storeEnhancers, initialState) {
	    (0, _invariant2.default)((0, _lodash6.default)(reducer), 'The reducer parameter passed to createStoreWith must be a Function. Instead received %s.', typeof reducer === 'undefined' ? 'undefined' : _typeof(reducer));
	
	    (0, _invariant2.default)(!storeEnhancers || (0, _lodash4.default)(storeEnhancers), 'The storeEnhancers parameter passed to createStoreWith must be an Array. Instead received %s.', typeof storeEnhancers === 'undefined' ? 'undefined' : _typeof(storeEnhancers));
	
	    _reducer = reducer;
	    _storeEnhancers = storeEnhancers;
	    _middlewares = middlewares || [];
	    _initialState = initialState;
	  };
	
	  this.$get = function ($injector) {
	    var store = undefined,
	        resolvedMiddleware = [];
	
	    for (var _iterator = _middlewares, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var middleware = _ref;
	
	      if (typeof middleware === 'string') {
	        resolvedMiddleware.push($injector.get(middleware));
	      } else {
	        resolvedMiddleware.push(middleware);
	      }
	    }
	
	    var finalCreateStore = _storeEnhancers ? _redux.compose.apply(undefined, _storeEnhancers)(_redux.createStore) : _redux.createStore;
	
	    //digestMiddleware needs to be the last one.
	    resolvedMiddleware.push((0, _digestMiddleware2.default)($injector.get('$rootScope')));
	
	    store = _initialState ? _redux.applyMiddleware.apply(undefined, resolvedMiddleware)(finalCreateStore)(_reducer, _initialState) : _redux.applyMiddleware.apply(undefined, resolvedMiddleware)(finalCreateStore)(_reducer);
	
	    return (0, _lodash2.default)({}, store, { connect: (0, _connector2.default)(store) });
	  };
	
	  this.$get.$inject = ['$injector'];
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Connector;
	
	var _shallowEqual = __webpack_require__(17);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(18);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _invariant = __webpack_require__(36);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodash = __webpack_require__(37);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(42);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _lodash5 = __webpack_require__(43);
	
	var _lodash6 = _interopRequireDefault(_lodash5);
	
	var _lodash7 = __webpack_require__(44);
	
	var _lodash8 = _interopRequireDefault(_lodash7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultMapStateToTarget = function defaultMapStateToTarget() {
	  return {};
	};
	var defaultMapDispatchToTarget = function defaultMapDispatchToTarget(dispatch) {
	  return { dispatch: dispatch };
	};
	
	function Connector(store) {
	  return function (mapStateToTarget, mapDispatchToTarget) {
	
	    var finalMapStateToTarget = mapStateToTarget || defaultMapStateToTarget;
	
	    var finalMapDispatchToTarget = (0, _lodash2.default)(mapDispatchToTarget) ? (0, _wrapActionCreators2.default)(mapDispatchToTarget) : mapDispatchToTarget || defaultMapDispatchToTarget;
	
	    (0, _invariant2.default)((0, _lodash4.default)(finalMapStateToTarget), 'mapStateToTarget must be a Function. Instead received $s.', finalMapStateToTarget);
	
	    (0, _invariant2.default)((0, _lodash2.default)(finalMapDispatchToTarget) || (0, _lodash4.default)(finalMapDispatchToTarget), 'mapDispatchToTarget must be a plain Object or a Function. Instead received $s.', finalMapDispatchToTarget);
	
	    var slice = getStateSlice(store.getState(), finalMapStateToTarget);
	
	    var boundActionCreators = finalMapDispatchToTarget(store.dispatch);
	
	    return function (target) {
	
	      (0, _invariant2.default)((0, _lodash4.default)(target) || (0, _lodash6.default)(target), 'The target parameter passed to connect must be a Function or a object.');
	
	      //Initial update
	      updateTarget(target, slice, boundActionCreators);
	
	      var unsubscribe = store.subscribe(function () {
	        var nextSlice = getStateSlice(store.getState(), finalMapStateToTarget);
	        if (!(0, _shallowEqual2.default)(slice, nextSlice)) {
	          slice = nextSlice;
	          updateTarget(target, slice, boundActionCreators);
	        }
	      });
	      return unsubscribe;
	    };
	  };
	}
	
	function updateTarget(target, StateSlice, dispatch) {
	  if ((0, _lodash4.default)(target)) {
	    target(StateSlice, dispatch);
	  } else {
	    (0, _lodash8.default)(target, StateSlice, dispatch);
	  }
	}
	
	function getStateSlice(state, mapStateToScope) {
	  var slice = mapStateToScope(state);
	
	  (0, _invariant2.default)((0, _lodash2.default)(slice), '`mapStateToScope` must return an object. Instead received %s.', slice);
	
	  return slice;
	}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  /* $$hashKey is added by angular when using ng-repeat, we ignore that*/
	  var keysA = Object.keys(objA).filter(function (k) {
	    return k !== '$$hashKey';
	  });
	  var keysB = Object.keys(objB).filter(function (k) {
	    return k !== '$$hashKey';
	  });
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = wrapActionCreators;
	
	var _redux = __webpack_require__(19);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(20);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(31);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(33);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(34);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(35);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(21);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all states changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  };
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(22),
	    getPrototype = __webpack_require__(28),
	    isObjectLike = __webpack_require__(30);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(23),
	    getRawTag = __webpack_require__(26),
	    objectToString = __webpack_require__(27);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(24);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(25);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(23);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(29);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(20);
	
	var _isPlainObject = __webpack_require__(21);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(32);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Reducer "' + key + '" returned undefined handling ' + actionName + '. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(35);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing functions from right to
	 * left. For example, compose(f, g, h) is identical to arg => f(g(h(arg))).
	 */
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return function () {
	    if (funcs.length === 0) {
	      return arguments.length <= 0 ? undefined : arguments[0];
	    }
	
	    var last = funcs[funcs.length - 1];
	    var rest = funcs.slice(0, -1);
	
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseFor = __webpack_require__(38),
	    isArguments = __webpack_require__(39),
	    keysIn = __webpack_require__(40);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * Creates a base function for methods like `_.forIn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = baseFor;


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var isArguments = __webpack_require__(39),
	    isArray = __webpack_require__(41);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    nullTag = '[object Null]',
	    proxyTag = '[object Proxy]',
	    undefinedTag = '[object Undefined]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isFunction;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseAssign = __webpack_require__(45),
	    createAssigner = __webpack_require__(49),
	    keys = __webpack_require__(47);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it is invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseCopy = __webpack_require__(46),
	    keys = __webpack_require__(47);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(48),
	    isArguments = __webpack_require__(39),
	    isArray = __webpack_require__(41);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var bindCallback = __webpack_require__(50),
	    isIterateeCall = __webpack_require__(51),
	    restParam = __webpack_require__(52);
	
	/**
	 * Creates a function that assigns properties of source object(s) to a given
	 * destination object.
	 *
	 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = bindCallback;


/***/ }),
/* 51 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = digestMiddleware;
	function digestMiddleware($rootScope) {
	  return function (store) {
	    return function (next) {
	      return function (action) {
	        if (!$rootScope.$$phase) {
	          $rootScope.$apply(next(action));
	        } else {
	          next(action);
	        }
	      };
	    };
	  };
	}

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _angular = __webpack_require__(10);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(13);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _routerStateReducer = __webpack_require__(55);
	
	var _routerStateReducer2 = _interopRequireDefault(_routerStateReducer);
	
	var _stateGo = __webpack_require__(57);
	
	var _stateGo2 = _interopRequireDefault(_stateGo);
	
	var _stateReload = __webpack_require__(58);
	
	var _stateReload2 = _interopRequireDefault(_stateReload);
	
	var _stateTransitionTo = __webpack_require__(59);
	
	var _stateTransitionTo2 = _interopRequireDefault(_stateTransitionTo);
	
	var _routerMiddleware = __webpack_require__(60);
	
	var _routerMiddleware2 = _interopRequireDefault(_routerMiddleware);
	
	var _routerListener = __webpack_require__(61);
	
	var _routerListener2 = _interopRequireDefault(_routerListener);
	
	var _stateChangeActions = __webpack_require__(62);
	
	var _stateChangeActions2 = _interopRequireDefault(_stateChangeActions);
	
	exports['default'] = _angular2['default'].module('ng-ui-router-middleware', [_angularUiRouter2['default']]).provider('ngUiStateChangeActions', _stateChangeActions2['default']).factory('ngUiRouterMiddleware', _routerMiddleware2['default']).run(_routerListener2['default']).name;
	var router = _routerStateReducer2['default'];
	
	exports.router = router;
	exports.stateGo = _stateGo2['default'];
	exports.stateReload = _stateReload2['default'];
	exports.stateTransitionTo = _stateTransitionTo2['default'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = routerStateReducer;
	
	var _actionTypes = __webpack_require__(56);
	
	var INITIAL_STATE = {
	  currentState: {},
	  currentParams: {},
	  prevState: {},
	  prevParams: {}
	};
	
	/**
	 * Reducer of STATE_CHANGE_SUCCESS actions. Returns a state object
	 * with { currentState, currentParams, prevState, prevParams }
	 *
	 * @param  {Object} state - Previous state
	 * @param  {Object} action - Action
	 * @return {Object} New state
	 */
	
	function routerStateReducer(state, action) {
	  if (state === undefined) state = INITIAL_STATE;
	
	  if (action.type !== _actionTypes.STATE_CHANGE_SUCCESS) {
	    return state;
	  }
	  delete action.payload.evt;
	  return action.payload;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	// Exports the constants used for triggering transitions using Angular UI Router
	//
	// STATE_GO: Action for triggering a $state.go
	// STATE_RELOAD: Action for triggering a $state.reload
	// STATE_TRANSITION_TO: Action for triggering a $state.transitionTo
	//
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var STATE_GO = '@@reduxUiRouter/stateGo';
	exports.STATE_GO = STATE_GO;
	var STATE_RELOAD = '@@reduxUiRouter/stateReload';
	exports.STATE_RELOAD = STATE_RELOAD;
	var STATE_TRANSITION_TO = '@@reduxUiRouter/transitionTo';
	
	exports.STATE_TRANSITION_TO = STATE_TRANSITION_TO;
	// UI Router Events
	var STATE_CHANGE_START = '@@reduxUiRouter/$stateChangeStart';
	exports.STATE_CHANGE_START = STATE_CHANGE_START;
	var STATE_CHANGE_SUCCESS = '@@reduxUiRouter/$stateChangeSuccess';
	exports.STATE_CHANGE_SUCCESS = STATE_CHANGE_SUCCESS;
	var STATE_CHANGE_ERROR = '@@reduxUiRouter/$stateChangeError';
	exports.STATE_CHANGE_ERROR = STATE_CHANGE_ERROR;
	var STATE_NOT_FOUND = '@@reduxUiRouter/$stateNotFound';
	exports.STATE_NOT_FOUND = STATE_NOT_FOUND;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = stateGo;
	
	var _actionTypes = __webpack_require__(56);
	
	/**
	 * This action create will trigger a $state.go in the UiRouter Middleware.
	 * Accepts a payload which matches the UI Router $state.go function.
	 *
	 * http://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state
	 *
	 * @param  {String} to - State name
	 * @param  {Object} params - (optional) Parameters to send with state
	 * @param  {Object} options - (optional) Options object
	 * @return {Object} Action object
	 */
	
	function stateGo(to, params, options) {
	  return {
	    type: _actionTypes.STATE_GO,
	    payload: {
	      to: to,
	      params: params,
	      options: options
	    }
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = stateReload;
	
	var _actionTypes = __webpack_require__(56);
	
	/**
	 * This action create will trigger a $state.reload in the UiRouter Middleware.
	 * Accepts a payload which matches the UI Router $state.reload function.
	 *
	 * http://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state
	 *
	 * @param  {String} state - (optional) Root of the resolves to be re-resolved
	 * @return {Object} Action object
	 */
	
	function stateReload(state) {
	  return {
	    type: _actionTypes.STATE_RELOAD,
	    payload: state
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = stateTransitionTo;
	
	var _actionTypes = __webpack_require__(56);
	
	/**
	 * This action create will trigger a $state.transitionTo in the UiRouter Middleware.
	 * Accepts a payload which matches the UI Router $state.transitionTo function.
	 *
	 * http://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state
	 *
	 * @param  {String} to - State name
	 * @param  {Object} toParams - (optional) Parameters to send with state
	 * @param  {Object} options - (optional) Options object
	 * @return {Object} Action object
	 */
	
	function stateTransitionTo(to, toParams, options) {
	  return {
	    type: _actionTypes.STATE_TRANSITION_TO,
	    payload: {
	      to: to,
	      toParams: toParams,
	      options: options
	    }
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actionTypes = __webpack_require__(56);
	
	function routerMiddleware($state) {
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        var payload = action.payload;
	
	        switch (action.type) {
	          case _actionTypes.STATE_GO:
	            return $state.go(payload.to, payload.params, payload.options).then(next(action));
	
	          case _actionTypes.STATE_RELOAD:
	            return $state.reload(payload).then(next(action));
	
	          case _actionTypes.STATE_TRANSITION_TO:
	            return $state.transitionTo(payload.to, payload.params, payload.options).then(next(action));
	
	          case _actionTypes.STATE_CHANGE_SUCCESS:
	            return next({
	              type: _actionTypes.STATE_CHANGE_SUCCESS,
	              payload: {
	                currentState: $state.current,
	                currentParams: $state.params,
	                prevState: getState().router.currentState,
	                prevParams: getState().router.currentParams
	              }
	            });
	
	          default:
	            next(action);
	        }
	      };
	    };
	  };
	}
	
	routerMiddleware.$inject = ['$state'];
	module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	/**
	 * Listens for events emitted from Angular UI Router and fires redux events
	 *
	 * @param {object} $rootScope Dependency
	 * @param {object} $urlRouter Dependency
	 * @param {object} $stateParams Dependency
	 * @param {object} ngUiStateChangeActions Dependency
	 * @return {undefined} undefined
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = RouterListener;
	
	function RouterListener($rootScope, $urlRouter, $stateParams, ngUiStateChangeActions) {
	  $rootScope.$on('$stateChangeStart', ngUiStateChangeActions.onStateChangeStart);
	
	  $rootScope.$on('$stateChangeSuccess', function () {
	    ngUiStateChangeActions.onStateChangeSuccess();
	  });
	
	  var unsubcribeStateChangeListener = $rootScope.$on('$locationChangeSuccess', function () {
	    ngUiStateChangeActions.onStateChangeSuccess();
	    unsubcribeStateChangeListener();
	  });
	
	  $rootScope.$on('$stateChangeError', ngUiStateChangeActions.onStateChangeError);
	  $rootScope.$on('$stateNotFound', ngUiStateChangeActions.onStateNotFound);
	}
	
	RouterListener.$inject = ['$rootScope', '$urlRouter', '$stateParams', 'ngUiStateChangeActions'];
	module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	// Event Actions
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = stateChangeActions;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _stateChangeStart = __webpack_require__(63);
	
	var _stateChangeStart2 = _interopRequireDefault(_stateChangeStart);
	
	var _stateChangeSuccess = __webpack_require__(64);
	
	var _stateChangeSuccess2 = _interopRequireDefault(_stateChangeSuccess);
	
	var _stateChangeError = __webpack_require__(65);
	
	var _stateChangeError2 = _interopRequireDefault(_stateChangeError);
	
	var _stateNotFound = __webpack_require__(66);
	
	var _stateNotFound2 = _interopRequireDefault(_stateNotFound);
	
	var _redux = __webpack_require__(19);
	
	function stateChangeActions() {
	  this.$get = function ($ngRedux) {
	    var actionCreator = {
	      onStateChangeStart: _stateChangeStart2['default'],
	      onStateChangeSuccess: _stateChangeSuccess2['default'],
	      onStateChangeError: _stateChangeError2['default'],
	      onStateNotFound: _stateNotFound2['default']
	    };
	
	    return (0, _redux.bindActionCreators)(actionCreator, $ngRedux.dispatch);
	  };
	
	  this.$get.$inject = ['$ngRedux'];
	}
	
	module.exports = exports['default'];

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = onStateChangeStart;
	
	var _actionTypes = __webpack_require__(56);
	
	/**
	 * This action is triggered when a $stateChangeStart event is broadcast.
	 * Accepts a payload which matches the UI Router $stateChangeStart event.
	 *
	 * http://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state
	 *
	 * @param {Object} evt event details
	 * @param {Object} toState To state definition
	 * @param {Object} toParams To params object
	 * @param {Object} fromState From state definition
	 * @param {Object} fromParams From params object
	 * @return {Object} Action object
	 */
	
	function onStateChangeStart(evt, toState, toParams, fromState, fromParams) {
	  return {
	    type: _actionTypes.STATE_CHANGE_START,
	    payload: {
	      evt: evt,
	      toState: toState,
	      toParams: toParams,
	      fromState: fromState,
	      fromParams: fromParams
	    }
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = onStateChangeSuccess;
	
	var _actionTypes = __webpack_require__(56);
	
	/**
	 * This action is triggered when a $stateChangeSuccess event is broadcast.
	 * Accepts a payload which matches the UI Router $stateChangeSuccess event.
	 *
	 * http://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state
	 *
	 * @return {Object} Action object
	 */
	
	function onStateChangeSuccess() {
	  return {
	    type: _actionTypes.STATE_CHANGE_SUCCESS
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = onStateChangeError;
	
	var _actionTypes = __webpack_require__(56);
	
	/**
	 * This action is triggered when a $stateChangeError event is broadcast.
	 * Accepts a payload which matches the UI Router $stateChangeError event.
	 *
	 * http://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state
	 *
	 * @param {Object} evt event details
	 * @param {Object} toState To state definition
	 * @param {Object} toParams To params object
	 * @param {Object} fromState From state definition
	 * @param {Object} fromParams From params object
	 * @param {Object} err Error resolve object
	 * @return {Object} Action object
	 */
	
	function onStateChangeError(evt, toState, toParams, fromState, fromParams, err) {
	  return {
	    type: _actionTypes.STATE_CHANGE_ERROR,
	    payload: {
	      evt: evt,
	      toState: toState,
	      toParams: toParams,
	      fromState: fromState,
	      fromParams: fromParams,
	      err: err
	    }
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = onStateNotFound;
	
	var _actionTypes = __webpack_require__(56);
	
	/**
	 * This action is triggered when a $stateNotFound event is broadcast.
	 * Accepts a payload which matches the UI Router $stateNotFound event.
	 *
	 * http://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state
	 *
	 * @param {Object} evt event details
	 * @param {Object} unfoundState The unfound state definition
	 * @param {Object} fromState From state definition
	 * @param {Object} fromParams From params object
	 * @return {Object} Action object
	 */
	
	function onStateNotFound(evt, unfoundState, fromState, fromParams) {
	  return {
	    type: _actionTypes.STATE_NOT_FOUND,
	    payload: {
	      evt: evt,
	      unfoundState: unfoundState,
	      fromState: fromState,
	      fromParams: fromParams
	    }
	  };
	}
	
	module.exports = exports['default'];

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	(function(definition){if(true){module.exports=definition();}else if(typeof define==="function"&&define.amd){define(definition);}else{mori=definition();}})(function(){return function(){
	if(typeof Math.imul == "undefined" || (Math.imul(0xffffffff,5) == 0)) {
	    Math.imul = function (a, b) {
	        var ah  = (a >>> 16) & 0xffff;
	        var al = a & 0xffff;
	        var bh  = (b >>> 16) & 0xffff;
	        var bl = b & 0xffff;
	        // the shift by 0 fixes the sign on the high part
	        // the final |0 converts the unsigned value into a signed value
	        return ((al * bl) + (((ah * bl + al * bh) << 16) >>> 0)|0);
	    }
	}
	
	var k,aa=this;
	function n(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";else if("function"==
	b&&"undefined"==typeof a.call)return"object";return b}var ba="closure_uid_"+(1E9*Math.random()>>>0),ca=0;function r(a,b){var c=a.split("."),d=aa;c[0]in d||!d.execScript||d.execScript("var "+c[0]);for(var e;c.length&&(e=c.shift());)c.length||void 0===b?d=d[e]?d[e]:d[e]={}:d[e]=b};function da(a){return Array.prototype.join.call(arguments,"")};function ea(a,b){for(var c in a)b.call(void 0,a[c],c,a)};function fa(a,b){null!=a&&this.append.apply(this,arguments)}fa.prototype.Za="";fa.prototype.append=function(a,b,c){this.Za+=a;if(null!=b)for(var d=1;d<arguments.length;d++)this.Za+=arguments[d];return this};fa.prototype.clear=function(){this.Za=""};fa.prototype.toString=function(){return this.Za};function ga(a,b){a.sort(b||ha)}function ia(a,b){for(var c=0;c<a.length;c++)a[c]={index:c,value:a[c]};var d=b||ha;ga(a,function(a,b){return d(a.value,b.value)||a.index-b.index});for(c=0;c<a.length;c++)a[c]=a[c].value}function ha(a,b){return a>b?1:a<b?-1:0};var ja;if("undefined"===typeof ka)var ka=function(){throw Error("No *print-fn* fn set for evaluation environment");};var la=null,ma=null;if("undefined"===typeof na)var na=null;function oa(){return new pa(null,5,[sa,!0,ua,!0,wa,!1,ya,!1,za,la],null)}function t(a){return null!=a&&!1!==a}function Aa(a){return t(a)?!1:!0}function w(a,b){return a[n(null==b?null:b)]?!0:a._?!0:!1}function Ba(a){return null==a?null:a.constructor}
	function x(a,b){var c=Ba(b),c=t(t(c)?c.Yb:c)?c.Xb:n(b);return Error(["No protocol method ",a," defined for type ",c,": ",b].join(""))}function Da(a){var b=a.Xb;return t(b)?b:""+z(a)}var Ea="undefined"!==typeof Symbol&&"function"===n(Symbol)?Symbol.Cc:"@@iterator";function Fa(a){for(var b=a.length,c=Array(b),d=0;;)if(d<b)c[d]=a[d],d+=1;else break;return c}function Ha(a){for(var b=Array(arguments.length),c=0;;)if(c<b.length)b[c]=arguments[c],c+=1;else return b}
	var Ia=function(){function a(a,b){function c(a,b){a.push(b);return a}var g=[];return A.c?A.c(c,g,b):A.call(null,c,g,b)}function b(a){return c.a(null,a)}var c=null,c=function(d,c){switch(arguments.length){case 1:return b.call(this,d);case 2:return a.call(this,0,c)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Ja={},La={};function Ma(a){if(a?a.L:a)return a.L(a);var b;b=Ma[n(null==a?null:a)];if(!b&&(b=Ma._,!b))throw x("ICounted.-count",a);return b.call(null,a)}
	function Na(a){if(a?a.J:a)return a.J(a);var b;b=Na[n(null==a?null:a)];if(!b&&(b=Na._,!b))throw x("IEmptyableCollection.-empty",a);return b.call(null,a)}var Qa={};function Ra(a,b){if(a?a.G:a)return a.G(a,b);var c;c=Ra[n(null==a?null:a)];if(!c&&(c=Ra._,!c))throw x("ICollection.-conj",a);return c.call(null,a,b)}
	var Ta={},C=function(){function a(a,b,c){if(a?a.$:a)return a.$(a,b,c);var g;g=C[n(null==a?null:a)];if(!g&&(g=C._,!g))throw x("IIndexed.-nth",a);return g.call(null,a,b,c)}function b(a,b){if(a?a.Q:a)return a.Q(a,b);var c;c=C[n(null==a?null:a)];if(!c&&(c=C._,!c))throw x("IIndexed.-nth",a);return c.call(null,a,b)}var c=null,c=function(d,c,f){switch(arguments.length){case 2:return b.call(this,d,c);case 3:return a.call(this,d,c,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),
	Ua={};function Va(a){if(a?a.N:a)return a.N(a);var b;b=Va[n(null==a?null:a)];if(!b&&(b=Va._,!b))throw x("ISeq.-first",a);return b.call(null,a)}function Wa(a){if(a?a.S:a)return a.S(a);var b;b=Wa[n(null==a?null:a)];if(!b&&(b=Wa._,!b))throw x("ISeq.-rest",a);return b.call(null,a)}
	var Xa={},Za={},$a=function(){function a(a,b,c){if(a?a.s:a)return a.s(a,b,c);var g;g=$a[n(null==a?null:a)];if(!g&&(g=$a._,!g))throw x("ILookup.-lookup",a);return g.call(null,a,b,c)}function b(a,b){if(a?a.t:a)return a.t(a,b);var c;c=$a[n(null==a?null:a)];if(!c&&(c=$a._,!c))throw x("ILookup.-lookup",a);return c.call(null,a,b)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=
	a;return c}(),ab={};function bb(a,b){if(a?a.rb:a)return a.rb(a,b);var c;c=bb[n(null==a?null:a)];if(!c&&(c=bb._,!c))throw x("IAssociative.-contains-key?",a);return c.call(null,a,b)}function cb(a,b,c){if(a?a.Ka:a)return a.Ka(a,b,c);var d;d=cb[n(null==a?null:a)];if(!d&&(d=cb._,!d))throw x("IAssociative.-assoc",a);return d.call(null,a,b,c)}var db={};function eb(a,b){if(a?a.wb:a)return a.wb(a,b);var c;c=eb[n(null==a?null:a)];if(!c&&(c=eb._,!c))throw x("IMap.-dissoc",a);return c.call(null,a,b)}var fb={};
	function hb(a){if(a?a.hb:a)return a.hb(a);var b;b=hb[n(null==a?null:a)];if(!b&&(b=hb._,!b))throw x("IMapEntry.-key",a);return b.call(null,a)}function ib(a){if(a?a.ib:a)return a.ib(a);var b;b=ib[n(null==a?null:a)];if(!b&&(b=ib._,!b))throw x("IMapEntry.-val",a);return b.call(null,a)}var jb={};function kb(a,b){if(a?a.Eb:a)return a.Eb(a,b);var c;c=kb[n(null==a?null:a)];if(!c&&(c=kb._,!c))throw x("ISet.-disjoin",a);return c.call(null,a,b)}
	function lb(a){if(a?a.La:a)return a.La(a);var b;b=lb[n(null==a?null:a)];if(!b&&(b=lb._,!b))throw x("IStack.-peek",a);return b.call(null,a)}function mb(a){if(a?a.Ma:a)return a.Ma(a);var b;b=mb[n(null==a?null:a)];if(!b&&(b=mb._,!b))throw x("IStack.-pop",a);return b.call(null,a)}var nb={};function pb(a,b,c){if(a?a.Ua:a)return a.Ua(a,b,c);var d;d=pb[n(null==a?null:a)];if(!d&&(d=pb._,!d))throw x("IVector.-assoc-n",a);return d.call(null,a,b,c)}
	function qb(a){if(a?a.Ra:a)return a.Ra(a);var b;b=qb[n(null==a?null:a)];if(!b&&(b=qb._,!b))throw x("IDeref.-deref",a);return b.call(null,a)}var rb={};function sb(a){if(a?a.H:a)return a.H(a);var b;b=sb[n(null==a?null:a)];if(!b&&(b=sb._,!b))throw x("IMeta.-meta",a);return b.call(null,a)}var tb={};function ub(a,b){if(a?a.F:a)return a.F(a,b);var c;c=ub[n(null==a?null:a)];if(!c&&(c=ub._,!c))throw x("IWithMeta.-with-meta",a);return c.call(null,a,b)}
	var vb={},wb=function(){function a(a,b,c){if(a?a.O:a)return a.O(a,b,c);var g;g=wb[n(null==a?null:a)];if(!g&&(g=wb._,!g))throw x("IReduce.-reduce",a);return g.call(null,a,b,c)}function b(a,b){if(a?a.R:a)return a.R(a,b);var c;c=wb[n(null==a?null:a)];if(!c&&(c=wb._,!c))throw x("IReduce.-reduce",a);return c.call(null,a,b)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}();
	function xb(a,b,c){if(a?a.gb:a)return a.gb(a,b,c);var d;d=xb[n(null==a?null:a)];if(!d&&(d=xb._,!d))throw x("IKVReduce.-kv-reduce",a);return d.call(null,a,b,c)}function yb(a,b){if(a?a.A:a)return a.A(a,b);var c;c=yb[n(null==a?null:a)];if(!c&&(c=yb._,!c))throw x("IEquiv.-equiv",a);return c.call(null,a,b)}function zb(a){if(a?a.B:a)return a.B(a);var b;b=zb[n(null==a?null:a)];if(!b&&(b=zb._,!b))throw x("IHash.-hash",a);return b.call(null,a)}var Bb={};
	function Cb(a){if(a?a.D:a)return a.D(a);var b;b=Cb[n(null==a?null:a)];if(!b&&(b=Cb._,!b))throw x("ISeqable.-seq",a);return b.call(null,a)}var Db={},Eb={},Fb={};function Gb(a){if(a?a.ab:a)return a.ab(a);var b;b=Gb[n(null==a?null:a)];if(!b&&(b=Gb._,!b))throw x("IReversible.-rseq",a);return b.call(null,a)}function Hb(a,b){if(a?a.Hb:a)return a.Hb(a,b);var c;c=Hb[n(null==a?null:a)];if(!c&&(c=Hb._,!c))throw x("ISorted.-sorted-seq",a);return c.call(null,a,b)}
	function Ib(a,b,c){if(a?a.Ib:a)return a.Ib(a,b,c);var d;d=Ib[n(null==a?null:a)];if(!d&&(d=Ib._,!d))throw x("ISorted.-sorted-seq-from",a);return d.call(null,a,b,c)}function Jb(a,b){if(a?a.Gb:a)return a.Gb(a,b);var c;c=Jb[n(null==a?null:a)];if(!c&&(c=Jb._,!c))throw x("ISorted.-entry-key",a);return c.call(null,a,b)}function Kb(a){if(a?a.Fb:a)return a.Fb(a);var b;b=Kb[n(null==a?null:a)];if(!b&&(b=Kb._,!b))throw x("ISorted.-comparator",a);return b.call(null,a)}
	function Lb(a,b){if(a?a.Wb:a)return a.Wb(0,b);var c;c=Lb[n(null==a?null:a)];if(!c&&(c=Lb._,!c))throw x("IWriter.-write",a);return c.call(null,a,b)}var Mb={};function Nb(a,b,c){if(a?a.v:a)return a.v(a,b,c);var d;d=Nb[n(null==a?null:a)];if(!d&&(d=Nb._,!d))throw x("IPrintWithWriter.-pr-writer",a);return d.call(null,a,b,c)}function Ob(a){if(a?a.$a:a)return a.$a(a);var b;b=Ob[n(null==a?null:a)];if(!b&&(b=Ob._,!b))throw x("IEditableCollection.-as-transient",a);return b.call(null,a)}
	function Pb(a,b){if(a?a.Sa:a)return a.Sa(a,b);var c;c=Pb[n(null==a?null:a)];if(!c&&(c=Pb._,!c))throw x("ITransientCollection.-conj!",a);return c.call(null,a,b)}function Qb(a){if(a?a.Ta:a)return a.Ta(a);var b;b=Qb[n(null==a?null:a)];if(!b&&(b=Qb._,!b))throw x("ITransientCollection.-persistent!",a);return b.call(null,a)}function Rb(a,b,c){if(a?a.kb:a)return a.kb(a,b,c);var d;d=Rb[n(null==a?null:a)];if(!d&&(d=Rb._,!d))throw x("ITransientAssociative.-assoc!",a);return d.call(null,a,b,c)}
	function Sb(a,b){if(a?a.Jb:a)return a.Jb(a,b);var c;c=Sb[n(null==a?null:a)];if(!c&&(c=Sb._,!c))throw x("ITransientMap.-dissoc!",a);return c.call(null,a,b)}function Tb(a,b,c){if(a?a.Ub:a)return a.Ub(0,b,c);var d;d=Tb[n(null==a?null:a)];if(!d&&(d=Tb._,!d))throw x("ITransientVector.-assoc-n!",a);return d.call(null,a,b,c)}function Ub(a){if(a?a.Vb:a)return a.Vb();var b;b=Ub[n(null==a?null:a)];if(!b&&(b=Ub._,!b))throw x("ITransientVector.-pop!",a);return b.call(null,a)}
	function Vb(a,b){if(a?a.Tb:a)return a.Tb(0,b);var c;c=Vb[n(null==a?null:a)];if(!c&&(c=Vb._,!c))throw x("ITransientSet.-disjoin!",a);return c.call(null,a,b)}function Xb(a){if(a?a.Pb:a)return a.Pb();var b;b=Xb[n(null==a?null:a)];if(!b&&(b=Xb._,!b))throw x("IChunk.-drop-first",a);return b.call(null,a)}function Yb(a){if(a?a.Cb:a)return a.Cb(a);var b;b=Yb[n(null==a?null:a)];if(!b&&(b=Yb._,!b))throw x("IChunkedSeq.-chunked-first",a);return b.call(null,a)}
	function Zb(a){if(a?a.Db:a)return a.Db(a);var b;b=Zb[n(null==a?null:a)];if(!b&&(b=Zb._,!b))throw x("IChunkedSeq.-chunked-rest",a);return b.call(null,a)}function $b(a){if(a?a.Bb:a)return a.Bb(a);var b;b=$b[n(null==a?null:a)];if(!b&&(b=$b._,!b))throw x("IChunkedNext.-chunked-next",a);return b.call(null,a)}function ac(a,b){if(a?a.bb:a)return a.bb(0,b);var c;c=ac[n(null==a?null:a)];if(!c&&(c=ac._,!c))throw x("IVolatile.-vreset!",a);return c.call(null,a,b)}var bc={};
	function cc(a){if(a?a.fb:a)return a.fb(a);var b;b=cc[n(null==a?null:a)];if(!b&&(b=cc._,!b))throw x("IIterable.-iterator",a);return b.call(null,a)}function dc(a){this.qc=a;this.q=0;this.j=1073741824}dc.prototype.Wb=function(a,b){return this.qc.append(b)};function ec(a){var b=new fa;a.v(null,new dc(b),oa());return""+z(b)}
	var fc="undefined"!==typeof Math.imul&&0!==(Math.imul.a?Math.imul.a(4294967295,5):Math.imul.call(null,4294967295,5))?function(a,b){return Math.imul.a?Math.imul.a(a,b):Math.imul.call(null,a,b)}:function(a,b){var c=a&65535,d=b&65535;return c*d+((a>>>16&65535)*d+c*(b>>>16&65535)<<16>>>0)|0};function gc(a){a=fc(a,3432918353);return fc(a<<15|a>>>-15,461845907)}function hc(a,b){var c=a^b;return fc(c<<13|c>>>-13,5)+3864292196}
	function ic(a,b){var c=a^b,c=fc(c^c>>>16,2246822507),c=fc(c^c>>>13,3266489909);return c^c>>>16}var kc={},lc=0;function mc(a){255<lc&&(kc={},lc=0);var b=kc[a];if("number"!==typeof b){a:if(null!=a)if(b=a.length,0<b){for(var c=0,d=0;;)if(c<b)var e=c+1,d=fc(31,d)+a.charCodeAt(c),c=e;else{b=d;break a}b=void 0}else b=0;else b=0;kc[a]=b;lc+=1}return a=b}
	function nc(a){a&&(a.j&4194304||a.vc)?a=a.B(null):"number"===typeof a?a=(Math.floor.b?Math.floor.b(a):Math.floor.call(null,a))%2147483647:!0===a?a=1:!1===a?a=0:"string"===typeof a?(a=mc(a),0!==a&&(a=gc(a),a=hc(0,a),a=ic(a,4))):a=a instanceof Date?a.valueOf():null==a?0:zb(a);return a}
	function oc(a){var b;b=a.name;var c;a:{c=1;for(var d=0;;)if(c<b.length){var e=c+2,d=hc(d,gc(b.charCodeAt(c-1)|b.charCodeAt(c)<<16));c=e}else{c=d;break a}c=void 0}c=1===(b.length&1)?c^gc(b.charCodeAt(b.length-1)):c;b=ic(c,fc(2,b.length));a=mc(a.ba);return b^a+2654435769+(b<<6)+(b>>2)}function pc(a,b){if(a.ta===b.ta)return 0;var c=Aa(a.ba);if(t(c?b.ba:c))return-1;if(t(a.ba)){if(Aa(b.ba))return 1;c=ha(a.ba,b.ba);return 0===c?ha(a.name,b.name):c}return ha(a.name,b.name)}
	function qc(a,b,c,d,e){this.ba=a;this.name=b;this.ta=c;this.Ya=d;this.Z=e;this.j=2154168321;this.q=4096}k=qc.prototype;k.v=function(a,b){return Lb(b,this.ta)};k.B=function(){var a=this.Ya;return null!=a?a:this.Ya=a=oc(this)};k.F=function(a,b){return new qc(this.ba,this.name,this.ta,this.Ya,b)};k.H=function(){return this.Z};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return $a.c(c,this,null);case 3:return $a.c(c,this,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return $a.c(c,this,null)};a.c=function(a,c,d){return $a.c(c,this,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return $a.c(a,this,null)};k.a=function(a,b){return $a.c(a,this,b)};k.A=function(a,b){return b instanceof qc?this.ta===b.ta:!1};
	k.toString=function(){return this.ta};var rc=function(){function a(a,b){var c=null!=a?[z(a),z("/"),z(b)].join(""):b;return new qc(a,b,c,null,null)}function b(a){return a instanceof qc?a:c.a(null,a)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();
	function D(a){if(null==a)return null;if(a&&(a.j&8388608||a.mc))return a.D(null);if(a instanceof Array||"string"===typeof a)return 0===a.length?null:new F(a,0);if(w(Bb,a))return Cb(a);throw Error([z(a),z(" is not ISeqable")].join(""));}function G(a){if(null==a)return null;if(a&&(a.j&64||a.jb))return a.N(null);a=D(a);return null==a?null:Va(a)}function H(a){return null!=a?a&&(a.j&64||a.jb)?a.S(null):(a=D(a))?Wa(a):J:J}function K(a){return null==a?null:a&&(a.j&128||a.xb)?a.T(null):D(H(a))}
	var sc=function(){function a(a,b){return null==a?null==b:a===b||yb(a,b)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){for(;;)if(b.a(a,d))if(K(e))a=d,d=G(e),e=K(e);else return b.a(d,G(e));else return!1}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return!0;
	case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(){return!0};b.a=a;b.d=c.d;return b}();function tc(a){this.C=a}tc.prototype.next=function(){if(null!=this.C){var a=G(this.C);this.C=K(this.C);return{done:!1,value:a}}return{done:!0,value:null}};function uc(a){return new tc(D(a))}
	function vc(a,b){var c=gc(a),c=hc(0,c);return ic(c,b)}function wc(a){var b=0,c=1;for(a=D(a);;)if(null!=a)b+=1,c=fc(31,c)+nc(G(a))|0,a=K(a);else return vc(c,b)}function xc(a){var b=0,c=0;for(a=D(a);;)if(null!=a)b+=1,c=c+nc(G(a))|0,a=K(a);else return vc(c,b)}La["null"]=!0;Ma["null"]=function(){return 0};Date.prototype.A=function(a,b){return b instanceof Date&&this.toString()===b.toString()};yb.number=function(a,b){return a===b};rb["function"]=!0;sb["function"]=function(){return null};
	Ja["function"]=!0;zb._=function(a){return a[ba]||(a[ba]=++ca)};function yc(a){this.o=a;this.q=0;this.j=32768}yc.prototype.Ra=function(){return this.o};function Ac(a){return a instanceof yc}function Bc(a){return Ac(a)?L.b?L.b(a):L.call(null,a):a}function L(a){return qb(a)}
	var Cc=function(){function a(a,b,c,d){for(var l=Ma(a);;)if(d<l){var m=C.a(a,d);c=b.a?b.a(c,m):b.call(null,c,m);if(Ac(c))return qb(c);d+=1}else return c}function b(a,b,c){var d=Ma(a),l=c;for(c=0;;)if(c<d){var m=C.a(a,c),l=b.a?b.a(l,m):b.call(null,l,m);if(Ac(l))return qb(l);c+=1}else return l}function c(a,b){var c=Ma(a);if(0===c)return b.l?b.l():b.call(null);for(var d=C.a(a,0),l=1;;)if(l<c){var m=C.a(a,l),d=b.a?b.a(d,m):b.call(null,d,m);if(Ac(d))return qb(d);l+=1}else return d}var d=null,d=function(d,
	f,g,h){switch(arguments.length){case 2:return c.call(this,d,f);case 3:return b.call(this,d,f,g);case 4:return a.call(this,d,f,g,h)}throw Error("Invalid arity: "+arguments.length);};d.a=c;d.c=b;d.n=a;return d}(),Dc=function(){function a(a,b,c,d){for(var l=a.length;;)if(d<l){var m=a[d];c=b.a?b.a(c,m):b.call(null,c,m);if(Ac(c))return qb(c);d+=1}else return c}function b(a,b,c){var d=a.length,l=c;for(c=0;;)if(c<d){var m=a[c],l=b.a?b.a(l,m):b.call(null,l,m);if(Ac(l))return qb(l);c+=1}else return l}function c(a,
	b){var c=a.length;if(0===a.length)return b.l?b.l():b.call(null);for(var d=a[0],l=1;;)if(l<c){var m=a[l],d=b.a?b.a(d,m):b.call(null,d,m);if(Ac(d))return qb(d);l+=1}else return d}var d=null,d=function(d,f,g,h){switch(arguments.length){case 2:return c.call(this,d,f);case 3:return b.call(this,d,f,g);case 4:return a.call(this,d,f,g,h)}throw Error("Invalid arity: "+arguments.length);};d.a=c;d.c=b;d.n=a;return d}();function Ec(a){return a?a.j&2||a.cc?!0:a.j?!1:w(La,a):w(La,a)}
	function Fc(a){return a?a.j&16||a.Qb?!0:a.j?!1:w(Ta,a):w(Ta,a)}function Gc(a,b){this.e=a;this.m=b}Gc.prototype.ga=function(){return this.m<this.e.length};Gc.prototype.next=function(){var a=this.e[this.m];this.m+=1;return a};function F(a,b){this.e=a;this.m=b;this.j=166199550;this.q=8192}k=F.prototype;k.toString=function(){return ec(this)};k.Q=function(a,b){var c=b+this.m;return c<this.e.length?this.e[c]:null};k.$=function(a,b,c){a=b+this.m;return a<this.e.length?this.e[a]:c};k.vb=!0;
	k.fb=function(){return new Gc(this.e,this.m)};k.T=function(){return this.m+1<this.e.length?new F(this.e,this.m+1):null};k.L=function(){return this.e.length-this.m};k.ab=function(){var a=Ma(this);return 0<a?new Hc(this,a-1,null):null};k.B=function(){return wc(this)};k.A=function(a,b){return Ic.a?Ic.a(this,b):Ic.call(null,this,b)};k.J=function(){return J};k.R=function(a,b){return Dc.n(this.e,b,this.e[this.m],this.m+1)};k.O=function(a,b,c){return Dc.n(this.e,b,c,this.m)};k.N=function(){return this.e[this.m]};
	k.S=function(){return this.m+1<this.e.length?new F(this.e,this.m+1):J};k.D=function(){return this};k.G=function(a,b){return M.a?M.a(b,this):M.call(null,b,this)};F.prototype[Ea]=function(){return uc(this)};
	var Jc=function(){function a(a,b){return b<a.length?new F(a,b):null}function b(a){return c.a(a,0)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Kc=function(){function a(a,b){return Jc.a(a,b)}function b(a){return Jc.a(a,0)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+
	arguments.length);};c.b=b;c.a=a;return c}();function Hc(a,b,c){this.qb=a;this.m=b;this.k=c;this.j=32374990;this.q=8192}k=Hc.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.T=function(){return 0<this.m?new Hc(this.qb,this.m-1,null):null};k.L=function(){return this.m+1};k.B=function(){return wc(this)};k.A=function(a,b){return Ic.a?Ic.a(this,b):Ic.call(null,this,b)};k.J=function(){var a=this.k;return O.a?O.a(J,a):O.call(null,J,a)};
	k.R=function(a,b){return P.a?P.a(b,this):P.call(null,b,this)};k.O=function(a,b,c){return P.c?P.c(b,c,this):P.call(null,b,c,this)};k.N=function(){return C.a(this.qb,this.m)};k.S=function(){return 0<this.m?new Hc(this.qb,this.m-1,null):J};k.D=function(){return this};k.F=function(a,b){return new Hc(this.qb,this.m,b)};k.G=function(a,b){return M.a?M.a(b,this):M.call(null,b,this)};Hc.prototype[Ea]=function(){return uc(this)};function Lc(a){return G(K(a))}yb._=function(a,b){return a===b};
	var Nc=function(){function a(a,b){return null!=a?Ra(a,b):Ra(J,b)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){for(;;)if(t(e))a=b.a(a,d),d=G(e),e=K(e);else return b.a(a,d)}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 0:return Mc;case 1:return b;
	case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.l=function(){return Mc};b.b=function(a){return a};b.a=a;b.d=c.d;return b}();function Oc(a){return null==a?null:Na(a)}
	function Q(a){if(null!=a)if(a&&(a.j&2||a.cc))a=a.L(null);else if(a instanceof Array)a=a.length;else if("string"===typeof a)a=a.length;else if(w(La,a))a=Ma(a);else a:{a=D(a);for(var b=0;;){if(Ec(a)){a=b+Ma(a);break a}a=K(a);b+=1}a=void 0}else a=0;return a}
	var Pc=function(){function a(a,b,c){for(;;){if(null==a)return c;if(0===b)return D(a)?G(a):c;if(Fc(a))return C.c(a,b,c);if(D(a))a=K(a),b-=1;else return c}}function b(a,b){for(;;){if(null==a)throw Error("Index out of bounds");if(0===b){if(D(a))return G(a);throw Error("Index out of bounds");}if(Fc(a))return C.a(a,b);if(D(a)){var c=K(a),g=b-1;a=c;b=g}else throw Error("Index out of bounds");}}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,
	c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),R=function(){function a(a,b,c){if("number"!==typeof b)throw Error("index argument to nth must be a number.");if(null==a)return c;if(a&&(a.j&16||a.Qb))return a.$(null,b,c);if(a instanceof Array||"string"===typeof a)return b<a.length?a[b]:c;if(w(Ta,a))return C.a(a,b);if(a?a.j&64||a.jb||(a.j?0:w(Ua,a)):w(Ua,a))return Pc.c(a,b,c);throw Error([z("nth not supported on this type "),z(Da(Ba(a)))].join(""));}function b(a,b){if("number"!==
	typeof b)throw Error("index argument to nth must be a number");if(null==a)return a;if(a&&(a.j&16||a.Qb))return a.Q(null,b);if(a instanceof Array||"string"===typeof a)return b<a.length?a[b]:null;if(w(Ta,a))return C.a(a,b);if(a?a.j&64||a.jb||(a.j?0:w(Ua,a)):w(Ua,a))return Pc.a(a,b);throw Error([z("nth not supported on this type "),z(Da(Ba(a)))].join(""));}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+
	arguments.length);};c.a=b;c.c=a;return c}(),S=function(){function a(a,b,c){return null!=a?a&&(a.j&256||a.Rb)?a.s(null,b,c):a instanceof Array?b<a.length?a[b]:c:"string"===typeof a?b<a.length?a[b]:c:w(Za,a)?$a.c(a,b,c):c:c}function b(a,b){return null==a?null:a&&(a.j&256||a.Rb)?a.t(null,b):a instanceof Array?b<a.length?a[b]:null:"string"===typeof a?b<a.length?a[b]:null:w(Za,a)?$a.a(a,b):null}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,
	c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),Rc=function(){function a(a,b,c){if(null!=a)a=cb(a,b,c);else a:{a=[b];c=[c];b=a.length;for(var g=0,h=Ob(Qc);;)if(g<b)var l=g+1,h=h.kb(null,a[g],c[g]),g=l;else{a=Qb(h);break a}a=void 0}return a}var b=null,c=function(){function a(b,d,h,l){var m=null;if(3<arguments.length){for(var m=0,p=Array(arguments.length-3);m<p.length;)p[m]=arguments[m+3],++m;m=new F(p,0)}return c.call(this,b,d,h,m)}function c(a,d,e,l){for(;;)if(a=b.c(a,
	d,e),t(l))d=G(l),e=Lc(l),l=K(K(l));else return a}a.i=3;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=K(a);var l=G(a);a=H(a);return c(b,d,l,a)};a.d=c;return a}(),b=function(b,e,f,g){switch(arguments.length){case 3:return a.call(this,b,e,f);default:var h=null;if(3<arguments.length){for(var h=0,l=Array(arguments.length-3);h<l.length;)l[h]=arguments[h+3],++h;h=new F(l,0)}return c.d(b,e,f,h)}throw Error("Invalid arity: "+arguments.length);};b.i=3;b.f=c.f;b.c=a;b.d=c.d;return b}(),Sc=function(){function a(a,
	b){return null==a?null:eb(a,b)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){for(;;){if(null==a)return null;a=b.a(a,d);if(t(e))d=G(e),e=K(e);else return a}}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return b;case 2:return a.call(this,b,e);
	default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(a){return a};b.a=a;b.d=c.d;return b}();function Tc(a){var b="function"==n(a);return t(b)?b:a?t(t(null)?null:a.bc)?!0:a.yb?!1:w(Ja,a):w(Ja,a)}function Uc(a,b){this.h=a;this.k=b;this.q=0;this.j=393217}k=Uc.prototype;
	k.call=function(){function a(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra,I){a=this.h;return T.ub?T.ub(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra,I):T.call(null,a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra,I)}function b(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra){a=this;return a.h.Fa?a.h.Fa(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y,ra)}function c(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y){a=this;return a.h.Ea?a.h.Ea(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,
	Y):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N,Y)}function d(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N){a=this;return a.h.Da?a.h.Da(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E,N)}function e(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E){a=this;return a.h.Ca?a.h.Ca(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B,E)}function f(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B){a=this;return a.h.Ba?a.h.Ba(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B):a.h.call(null,
	b,c,d,e,f,g,h,l,m,p,q,u,s,v,y,B)}function g(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y){a=this;return a.h.Aa?a.h.Aa(b,c,d,e,f,g,h,l,m,p,q,u,s,v,y):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v,y)}function h(a,b,c,d,e,f,g,h,l,m,p,q,u,s,v){a=this;return a.h.za?a.h.za(b,c,d,e,f,g,h,l,m,p,q,u,s,v):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s,v)}function l(a,b,c,d,e,f,g,h,l,m,p,q,u,s){a=this;return a.h.ya?a.h.ya(b,c,d,e,f,g,h,l,m,p,q,u,s):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u,s)}function m(a,b,c,d,e,f,g,h,l,m,p,q,u){a=this;
	return a.h.xa?a.h.xa(b,c,d,e,f,g,h,l,m,p,q,u):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q,u)}function p(a,b,c,d,e,f,g,h,l,m,p,q){a=this;return a.h.wa?a.h.wa(b,c,d,e,f,g,h,l,m,p,q):a.h.call(null,b,c,d,e,f,g,h,l,m,p,q)}function q(a,b,c,d,e,f,g,h,l,m,p){a=this;return a.h.va?a.h.va(b,c,d,e,f,g,h,l,m,p):a.h.call(null,b,c,d,e,f,g,h,l,m,p)}function s(a,b,c,d,e,f,g,h,l,m){a=this;return a.h.Ha?a.h.Ha(b,c,d,e,f,g,h,l,m):a.h.call(null,b,c,d,e,f,g,h,l,m)}function u(a,b,c,d,e,f,g,h,l){a=this;return a.h.Ga?a.h.Ga(b,c,
	d,e,f,g,h,l):a.h.call(null,b,c,d,e,f,g,h,l)}function v(a,b,c,d,e,f,g,h){a=this;return a.h.ia?a.h.ia(b,c,d,e,f,g,h):a.h.call(null,b,c,d,e,f,g,h)}function y(a,b,c,d,e,f,g){a=this;return a.h.P?a.h.P(b,c,d,e,f,g):a.h.call(null,b,c,d,e,f,g)}function B(a,b,c,d,e,f){a=this;return a.h.r?a.h.r(b,c,d,e,f):a.h.call(null,b,c,d,e,f)}function E(a,b,c,d,e){a=this;return a.h.n?a.h.n(b,c,d,e):a.h.call(null,b,c,d,e)}function N(a,b,c,d){a=this;return a.h.c?a.h.c(b,c,d):a.h.call(null,b,c,d)}function Y(a,b,c){a=this;
	return a.h.a?a.h.a(b,c):a.h.call(null,b,c)}function ra(a,b){a=this;return a.h.b?a.h.b(b):a.h.call(null,b)}function Pa(a){a=this;return a.h.l?a.h.l():a.h.call(null)}var I=null,I=function(I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc,Gd,De,Wf,dh){switch(arguments.length){case 1:return Pa.call(this,I);case 2:return ra.call(this,I,qa);case 3:return Y.call(this,I,qa,ta);case 4:return N.call(this,I,qa,ta,va);case 5:return E.call(this,I,qa,ta,va,xa);case 6:return B.call(this,I,qa,ta,va,xa,Ca);case 7:return y.call(this,
	I,qa,ta,va,xa,Ca,Ga);case 8:return v.call(this,I,qa,ta,va,xa,Ca,Ga,Ka);case 9:return u.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa);case 10:return s.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa);case 11:return q.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya);case 12:return p.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb);case 13:return m.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob);case 14:return l.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab);case 15:return h.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,
	ob,Ab,Wb);case 16:return g.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc);case 17:return f.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc);case 18:return e.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc);case 19:return d.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc,Gd);case 20:return c.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc,Gd,De);case 21:return b.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc,Gd,De,
	Wf);case 22:return a.call(this,I,qa,ta,va,xa,Ca,Ga,Ka,Oa,Sa,Ya,gb,ob,Ab,Wb,jc,zc,Zc,Gd,De,Wf,dh)}throw Error("Invalid arity: "+arguments.length);};I.b=Pa;I.a=ra;I.c=Y;I.n=N;I.r=E;I.P=B;I.ia=y;I.Ga=v;I.Ha=u;I.va=s;I.wa=q;I.xa=p;I.ya=m;I.za=l;I.Aa=h;I.Ba=g;I.Ca=f;I.Da=e;I.Ea=d;I.Fa=c;I.hc=b;I.ub=a;return I}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.l=function(){return this.h.l?this.h.l():this.h.call(null)};
	k.b=function(a){return this.h.b?this.h.b(a):this.h.call(null,a)};k.a=function(a,b){return this.h.a?this.h.a(a,b):this.h.call(null,a,b)};k.c=function(a,b,c){return this.h.c?this.h.c(a,b,c):this.h.call(null,a,b,c)};k.n=function(a,b,c,d){return this.h.n?this.h.n(a,b,c,d):this.h.call(null,a,b,c,d)};k.r=function(a,b,c,d,e){return this.h.r?this.h.r(a,b,c,d,e):this.h.call(null,a,b,c,d,e)};k.P=function(a,b,c,d,e,f){return this.h.P?this.h.P(a,b,c,d,e,f):this.h.call(null,a,b,c,d,e,f)};
	k.ia=function(a,b,c,d,e,f,g){return this.h.ia?this.h.ia(a,b,c,d,e,f,g):this.h.call(null,a,b,c,d,e,f,g)};k.Ga=function(a,b,c,d,e,f,g,h){return this.h.Ga?this.h.Ga(a,b,c,d,e,f,g,h):this.h.call(null,a,b,c,d,e,f,g,h)};k.Ha=function(a,b,c,d,e,f,g,h,l){return this.h.Ha?this.h.Ha(a,b,c,d,e,f,g,h,l):this.h.call(null,a,b,c,d,e,f,g,h,l)};k.va=function(a,b,c,d,e,f,g,h,l,m){return this.h.va?this.h.va(a,b,c,d,e,f,g,h,l,m):this.h.call(null,a,b,c,d,e,f,g,h,l,m)};
	k.wa=function(a,b,c,d,e,f,g,h,l,m,p){return this.h.wa?this.h.wa(a,b,c,d,e,f,g,h,l,m,p):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p)};k.xa=function(a,b,c,d,e,f,g,h,l,m,p,q){return this.h.xa?this.h.xa(a,b,c,d,e,f,g,h,l,m,p,q):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q)};k.ya=function(a,b,c,d,e,f,g,h,l,m,p,q,s){return this.h.ya?this.h.ya(a,b,c,d,e,f,g,h,l,m,p,q,s):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s)};
	k.za=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u){return this.h.za?this.h.za(a,b,c,d,e,f,g,h,l,m,p,q,s,u):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u)};k.Aa=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v){return this.h.Aa?this.h.Aa(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v)};k.Ba=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y){return this.h.Ba?this.h.Ba(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y)};
	k.Ca=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B){return this.h.Ca?this.h.Ca(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B)};k.Da=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E){return this.h.Da?this.h.Da(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E)};
	k.Ea=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N){return this.h.Ea?this.h.Ea(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N)};k.Fa=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y){return this.h.Fa?this.h.Fa(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y):this.h.call(null,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y)};
	k.hc=function(a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra){var Pa=this.h;return T.ub?T.ub(Pa,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra):T.call(null,Pa,a,b,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra)};k.bc=!0;k.F=function(a,b){return new Uc(this.h,b)};k.H=function(){return this.k};function O(a,b){return Tc(a)&&!(a?a.j&262144||a.Bc||(a.j?0:w(tb,a)):w(tb,a))?new Uc(a,b):null==a?null:ub(a,b)}function Vc(a){var b=null!=a;return(b?a?a.j&131072||a.kc||(a.j?0:w(rb,a)):w(rb,a):b)?sb(a):null}
	function Wc(a){return null==a?null:lb(a)}
	var Xc=function(){function a(a,b){return null==a?null:kb(a,b)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){for(;;){if(null==a)return null;a=b.a(a,d);if(t(e))d=G(e),e=K(e);else return a}}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return b;case 2:return a.call(this,
	b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(a){return a};b.a=a;b.d=c.d;return b}();function Yc(a){return null==a||Aa(D(a))}function $c(a){return null==a?!1:a?a.j&8||a.tc?!0:a.j?!1:w(Qa,a):w(Qa,a)}function ad(a){return null==a?!1:a?a.j&4096||a.zc?!0:a.j?!1:w(jb,a):w(jb,a)}
	function bd(a){return a?a.j&512||a.rc?!0:a.j?!1:w(ab,a):w(ab,a)}function cd(a){return a?a.j&16777216||a.yc?!0:a.j?!1:w(Db,a):w(Db,a)}function dd(a){return null==a?!1:a?a.j&1024||a.ic?!0:a.j?!1:w(db,a):w(db,a)}function ed(a){return a?a.j&16384||a.Ac?!0:a.j?!1:w(nb,a):w(nb,a)}function fd(a){return a?a.q&512||a.sc?!0:!1:!1}function gd(a){var b=[];ea(a,function(a,b){return function(a,c){return b.push(c)}}(a,b));return b}function hd(a,b,c,d,e){for(;0!==e;)c[d]=a[b],d+=1,e-=1,b+=1}
	function id(a,b,c,d,e){b+=e-1;for(d+=e-1;0!==e;)c[d]=a[b],d-=1,e-=1,b-=1}var jd={};function kd(a){return null==a?!1:a?a.j&64||a.jb?!0:a.j?!1:w(Ua,a):w(Ua,a)}function ld(a){return a?a.j&8388608||a.mc?!0:a.j?!1:w(Bb,a):w(Bb,a)}function md(a){return t(a)?!0:!1}function nd(a,b){return S.c(a,b,jd)===jd?!1:!0}
	function od(a,b){if(a===b)return 0;if(null==a)return-1;if(null==b)return 1;if(Ba(a)===Ba(b))return a&&(a.q&2048||a.sb)?a.tb(null,b):ha(a,b);throw Error("compare on non-nil objects of different types");}
	var pd=function(){function a(a,b,c,g){for(;;){var h=od(R.a(a,g),R.a(b,g));if(0===h&&g+1<c)g+=1;else return h}}function b(a,b){var f=Q(a),g=Q(b);return f<g?-1:f>g?1:c.n(a,b,f,0)}var c=null,c=function(c,e,f,g){switch(arguments.length){case 2:return b.call(this,c,e);case 4:return a.call(this,c,e,f,g)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.n=a;return c}();
	function qd(a){return sc.a(a,od)?od:function(b,c){var d=a.a?a.a(b,c):a.call(null,b,c);return"number"===typeof d?d:t(d)?-1:t(a.a?a.a(c,b):a.call(null,c,b))?1:0}}
	var sd=function(){function a(a,b){if(D(b)){var c=rd.b?rd.b(b):rd.call(null,b),g=qd(a);ia(c,g);return D(c)}return J}function b(a){return c.a(od,a)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),td=function(){function a(a,b,c){return sd.a(function(c,f){return qd(b).call(null,a.b?a.b(c):a.call(null,c),a.b?a.b(f):a.call(null,f))},c)}function b(a,b){return c.c(a,od,
	b)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),P=function(){function a(a,b,c){for(c=D(c);;)if(c){var g=G(c);b=a.a?a.a(b,g):a.call(null,b,g);if(Ac(b))return qb(b);c=K(c)}else return b}function b(a,b){var c=D(b);if(c){var g=G(c),c=K(c);return A.c?A.c(a,g,c):A.call(null,a,g,c)}return a.l?a.l():a.call(null)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,
	c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),A=function(){function a(a,b,c){return c&&(c.j&524288||c.Sb)?c.O(null,a,b):c instanceof Array?Dc.c(c,a,b):"string"===typeof c?Dc.c(c,a,b):w(vb,c)?wb.c(c,a,b):P.c(a,b,c)}function b(a,b){return b&&(b.j&524288||b.Sb)?b.R(null,a):b instanceof Array?Dc.a(b,a):"string"===typeof b?Dc.a(b,a):w(vb,b)?wb.a(b,a):P.a(a,b)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,
	c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}();function ud(a){return a}
	var vd=function(){function a(a,b){return function(){function c(b,e){return a.a?a.a(b,e):a.call(null,b,e)}function g(a){return b.b?b.b(a):b.call(null,a)}function h(){return a.l?a.l():a.call(null)}var l=null,l=function(a,b){switch(arguments.length){case 0:return h.call(this);case 1:return g.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};l.l=h;l.b=g;l.a=c;return l}()}function b(a){return c.a(a,ud)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,
	c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),wd=function(){function a(a,b,c,g){a=a.b?a.b(b):a.call(null,b);c=A.c(a,c,g);return a.b?a.b(c):a.call(null,c)}function b(a,b,f){return c.n(a,b,b.l?b.l():b.call(null),f)}var c=null,c=function(c,e,f,g){switch(arguments.length){case 3:return b.call(this,c,e,f);case 4:return a.call(this,c,e,f,g)}throw Error("Invalid arity: "+arguments.length);};c.c=b;c.n=a;return c}(),xd=function(){var a=null,b=function(){function b(a,
	c,g){var h=null;if(2<arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return d.call(this,a,c,h)}function d(b,c,d){return A.c(a,b+c,d)}b.i=2;b.f=function(a){var b=G(a);a=K(a);var c=G(a);a=H(a);return d(b,c,a)};b.d=d;return b}(),a=function(a,d,e){switch(arguments.length){case 0:return 0;case 1:return a;case 2:return a+d;default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,
	0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.l=function(){return 0};a.b=function(a){return a};a.a=function(a,b){return a+b};a.d=b.d;return a}(),yd=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a<c)if(K(d))a=c,c=G(d),d=K(d);else return c<G(d);else return!1}a.i=2;a.f=function(a){var c=
	G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 1:return!0;case 2:return a<d;default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.b=function(){return!0};a.a=function(a,b){return a<b};a.d=b.d;return a}(),zd=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<
	arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a<=c)if(K(d))a=c,c=G(d),d=K(d);else return c<=G(d);else return!1}a.i=2;a.f=function(a){var c=G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 1:return!0;case 2:return a<=d;default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+
	2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.b=function(){return!0};a.a=function(a,b){return a<=b};a.d=b.d;return a}(),Ad=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a>c)if(K(d))a=c,c=G(d),d=K(d);else return c>G(d);else return!1}a.i=2;a.f=function(a){var c=
	G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 1:return!0;case 2:return a>d;default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.b=function(){return!0};a.a=function(a,b){return a>b};a.d=b.d;return a}(),Bd=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<
	arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a>=c)if(K(d))a=c,c=G(d),d=K(d);else return c>=G(d);else return!1}a.i=2;a.f=function(a){var c=G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 1:return!0;case 2:return a>=d;default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+
	2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.b=function(){return!0};a.a=function(a,b){return a>=b};a.d=b.d;return a}();function Cd(a,b){var c=(a-a%b)/b;return 0<=c?Math.floor.b?Math.floor.b(c):Math.floor.call(null,c):Math.ceil.b?Math.ceil.b(c):Math.ceil.call(null,c)}function Dd(a){a-=a>>1&1431655765;a=(a&858993459)+(a>>2&858993459);return 16843009*(a+(a>>4)&252645135)>>24}
	function Ed(a){var b=1;for(a=D(a);;)if(a&&0<b)b-=1,a=K(a);else return a}
	var z=function(){function a(a){return null==a?"":da(a)}var b=null,c=function(){function a(b,d){var h=null;if(1<arguments.length){for(var h=0,l=Array(arguments.length-1);h<l.length;)l[h]=arguments[h+1],++h;h=new F(l,0)}return c.call(this,b,h)}function c(a,d){for(var e=new fa(b.b(a)),l=d;;)if(t(l))e=e.append(b.b(G(l))),l=K(l);else return e.toString()}a.i=1;a.f=function(a){var b=G(a);a=H(a);return c(b,a)};a.d=c;return a}(),b=function(b,e){switch(arguments.length){case 0:return"";case 1:return a.call(this,
	b);default:var f=null;if(1<arguments.length){for(var f=0,g=Array(arguments.length-1);f<g.length;)g[f]=arguments[f+1],++f;f=new F(g,0)}return c.d(b,f)}throw Error("Invalid arity: "+arguments.length);};b.i=1;b.f=c.f;b.l=function(){return""};b.b=a;b.d=c.d;return b}();function Ic(a,b){var c;if(cd(b))if(Ec(a)&&Ec(b)&&Q(a)!==Q(b))c=!1;else a:{c=D(a);for(var d=D(b);;){if(null==c){c=null==d;break a}if(null!=d&&sc.a(G(c),G(d)))c=K(c),d=K(d);else{c=!1;break a}}c=void 0}else c=null;return md(c)}
	function Fd(a,b,c,d,e){this.k=a;this.first=b;this.M=c;this.count=d;this.p=e;this.j=65937646;this.q=8192}k=Fd.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.T=function(){return 1===this.count?null:this.M};k.L=function(){return this.count};k.La=function(){return this.first};k.Ma=function(){return Wa(this)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return ub(J,this.k)};
	k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return this.first};k.S=function(){return 1===this.count?J:this.M};k.D=function(){return this};k.F=function(a,b){return new Fd(b,this.first,this.M,this.count,this.p)};k.G=function(a,b){return new Fd(this.k,b,this,this.count+1,null)};Fd.prototype[Ea]=function(){return uc(this)};function Hd(a){this.k=a;this.j=65937614;this.q=8192}k=Hd.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};
	k.T=function(){return null};k.L=function(){return 0};k.La=function(){return null};k.Ma=function(){throw Error("Can't pop empty list");};k.B=function(){return 0};k.A=function(a,b){return Ic(this,b)};k.J=function(){return this};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return null};k.S=function(){return J};k.D=function(){return null};k.F=function(a,b){return new Hd(b)};k.G=function(a,b){return new Fd(this.k,b,null,1,null)};var J=new Hd(null);
	Hd.prototype[Ea]=function(){return uc(this)};function Id(a){return a?a.j&134217728||a.xc?!0:a.j?!1:w(Fb,a):w(Fb,a)}function Jd(a){return Id(a)?Gb(a):A.c(Nc,J,a)}
	var Kd=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){var b;if(a instanceof F&&0===a.m)b=a.e;else a:{for(b=[];;)if(null!=a)b.push(a.N(null)),a=a.T(null);else break a;b=void 0}a=b.length;for(var e=J;;)if(0<a){var f=a-1,e=e.G(null,b[a-1]);a=f}else return e}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}();
	function Ld(a,b,c,d){this.k=a;this.first=b;this.M=c;this.p=d;this.j=65929452;this.q=8192}k=Ld.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.T=function(){return null==this.M?null:D(this.M)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return this.first};
	k.S=function(){return null==this.M?J:this.M};k.D=function(){return this};k.F=function(a,b){return new Ld(b,this.first,this.M,this.p)};k.G=function(a,b){return new Ld(null,b,this,this.p)};Ld.prototype[Ea]=function(){return uc(this)};function M(a,b){var c=null==b;return(c?c:b&&(b.j&64||b.jb))?new Ld(null,a,b,null):new Ld(null,a,D(b),null)}
	function Md(a,b){if(a.pa===b.pa)return 0;var c=Aa(a.ba);if(t(c?b.ba:c))return-1;if(t(a.ba)){if(Aa(b.ba))return 1;c=ha(a.ba,b.ba);return 0===c?ha(a.name,b.name):c}return ha(a.name,b.name)}function U(a,b,c,d){this.ba=a;this.name=b;this.pa=c;this.Ya=d;this.j=2153775105;this.q=4096}k=U.prototype;k.v=function(a,b){return Lb(b,[z(":"),z(this.pa)].join(""))};k.B=function(){var a=this.Ya;return null!=a?a:this.Ya=a=oc(this)+2654435769|0};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return S.a(c,this);case 3:return S.c(c,this,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return S.a(c,this)};a.c=function(a,c,d){return S.c(c,this,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return S.a(a,this)};k.a=function(a,b){return S.c(a,this,b)};k.A=function(a,b){return b instanceof U?this.pa===b.pa:!1};
	k.toString=function(){return[z(":"),z(this.pa)].join("")};function Nd(a,b){return a===b?!0:a instanceof U&&b instanceof U?a.pa===b.pa:!1}
	var Pd=function(){function a(a,b){return new U(a,b,[z(t(a)?[z(a),z("/")].join(""):null),z(b)].join(""),null)}function b(a){if(a instanceof U)return a;if(a instanceof qc){var b;if(a&&(a.q&4096||a.lc))b=a.ba;else throw Error([z("Doesn't support namespace: "),z(a)].join(""));return new U(b,Od.b?Od.b(a):Od.call(null,a),a.ta,null)}return"string"===typeof a?(b=a.split("/"),2===b.length?new U(b[0],b[1],a,null):new U(null,b[0],a,null)):null}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,
	c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();function V(a,b,c,d){this.k=a;this.cb=b;this.C=c;this.p=d;this.q=0;this.j=32374988}k=V.prototype;k.toString=function(){return ec(this)};function Qd(a){null!=a.cb&&(a.C=a.cb.l?a.cb.l():a.cb.call(null),a.cb=null);return a.C}k.H=function(){return this.k};k.T=function(){Cb(this);return null==this.C?null:K(this.C)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};
	k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){Cb(this);return null==this.C?null:G(this.C)};k.S=function(){Cb(this);return null!=this.C?H(this.C):J};k.D=function(){Qd(this);if(null==this.C)return null;for(var a=this.C;;)if(a instanceof V)a=Qd(a);else return this.C=a,D(this.C)};k.F=function(a,b){return new V(b,this.cb,this.C,this.p)};k.G=function(a,b){return M(b,this)};
	V.prototype[Ea]=function(){return uc(this)};function Rd(a,b){this.Ab=a;this.end=b;this.q=0;this.j=2}Rd.prototype.L=function(){return this.end};Rd.prototype.add=function(a){this.Ab[this.end]=a;return this.end+=1};Rd.prototype.ca=function(){var a=new Sd(this.Ab,0,this.end);this.Ab=null;return a};function Td(a){return new Rd(Array(a),0)}function Sd(a,b,c){this.e=a;this.V=b;this.end=c;this.q=0;this.j=524306}k=Sd.prototype;k.R=function(a,b){return Dc.n(this.e,b,this.e[this.V],this.V+1)};
	k.O=function(a,b,c){return Dc.n(this.e,b,c,this.V)};k.Pb=function(){if(this.V===this.end)throw Error("-drop-first of empty chunk");return new Sd(this.e,this.V+1,this.end)};k.Q=function(a,b){return this.e[this.V+b]};k.$=function(a,b,c){return 0<=b&&b<this.end-this.V?this.e[this.V+b]:c};k.L=function(){return this.end-this.V};
	var Ud=function(){function a(a,b,c){return new Sd(a,b,c)}function b(a,b){return new Sd(a,b,a.length)}function c(a){return new Sd(a,0,a.length)}var d=null,d=function(d,f,g){switch(arguments.length){case 1:return c.call(this,d);case 2:return b.call(this,d,f);case 3:return a.call(this,d,f,g)}throw Error("Invalid arity: "+arguments.length);};d.b=c;d.a=b;d.c=a;return d}();function Vd(a,b,c,d){this.ca=a;this.ra=b;this.k=c;this.p=d;this.j=31850732;this.q=1536}k=Vd.prototype;k.toString=function(){return ec(this)};
	k.H=function(){return this.k};k.T=function(){if(1<Ma(this.ca))return new Vd(Xb(this.ca),this.ra,this.k,null);var a=Cb(this.ra);return null==a?null:a};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.N=function(){return C.a(this.ca,0)};k.S=function(){return 1<Ma(this.ca)?new Vd(Xb(this.ca),this.ra,this.k,null):null==this.ra?J:this.ra};k.D=function(){return this};k.Cb=function(){return this.ca};
	k.Db=function(){return null==this.ra?J:this.ra};k.F=function(a,b){return new Vd(this.ca,this.ra,b,this.p)};k.G=function(a,b){return M(b,this)};k.Bb=function(){return null==this.ra?null:this.ra};Vd.prototype[Ea]=function(){return uc(this)};function Wd(a,b){return 0===Ma(a)?b:new Vd(a,b,null,null)}function Xd(a,b){a.add(b)}function rd(a){for(var b=[];;)if(D(a))b.push(G(a)),a=K(a);else return b}function Yd(a,b){if(Ec(a))return Q(a);for(var c=a,d=b,e=0;;)if(0<d&&D(c))c=K(c),d-=1,e+=1;else return e}
	var $d=function Zd(b){return null==b?null:null==K(b)?D(G(b)):M(G(b),Zd(K(b)))},ae=function(){function a(a,b){return new V(null,function(){var c=D(a);return c?fd(c)?Wd(Yb(c),d.a(Zb(c),b)):M(G(c),d.a(H(c),b)):b},null,null)}function b(a){return new V(null,function(){return a},null,null)}function c(){return new V(null,function(){return null},null,null)}var d=null,e=function(){function a(c,d,e){var f=null;if(2<arguments.length){for(var f=0,q=Array(arguments.length-2);f<q.length;)q[f]=arguments[f+2],++f;
	f=new F(q,0)}return b.call(this,c,d,f)}function b(a,c,e){return function q(a,b){return new V(null,function(){var c=D(a);return c?fd(c)?Wd(Yb(c),q(Zb(c),b)):M(G(c),q(H(c),b)):t(b)?q(G(b),K(b)):null},null,null)}(d.a(a,c),e)}a.i=2;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=H(a);return b(c,d,a)};a.d=b;return a}(),d=function(d,g,h){switch(arguments.length){case 0:return c.call(this);case 1:return b.call(this,d);case 2:return a.call(this,d,g);default:var l=null;if(2<arguments.length){for(var l=0,m=
	Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return e.d(d,g,l)}throw Error("Invalid arity: "+arguments.length);};d.i=2;d.f=e.f;d.l=c;d.b=b;d.a=a;d.d=e.d;return d}(),be=function(){function a(a,b,c,d){return M(a,M(b,M(c,d)))}function b(a,b,c){return M(a,M(b,c))}var c=null,d=function(){function a(c,d,e,m,p){var q=null;if(4<arguments.length){for(var q=0,s=Array(arguments.length-4);q<s.length;)s[q]=arguments[q+4],++q;q=new F(s,0)}return b.call(this,c,d,e,m,q)}function b(a,
	c,d,e,f){return M(a,M(c,M(d,M(e,$d(f)))))}a.i=4;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var p=G(a);a=H(a);return b(c,d,e,p,a)};a.d=b;return a}(),c=function(c,f,g,h,l){switch(arguments.length){case 1:return D(c);case 2:return M(c,f);case 3:return b.call(this,c,f,g);case 4:return a.call(this,c,f,g,h);default:var m=null;if(4<arguments.length){for(var m=0,p=Array(arguments.length-4);m<p.length;)p[m]=arguments[m+4],++m;m=new F(p,0)}return d.d(c,f,g,h,m)}throw Error("Invalid arity: "+
	arguments.length);};c.i=4;c.f=d.f;c.b=function(a){return D(a)};c.a=function(a,b){return M(a,b)};c.c=b;c.n=a;c.d=d.d;return c}();function ce(a){return Qb(a)}
	var de=function(){function a(){return Ob(Mc)}var b=null,c=function(){function a(c,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return b.call(this,c,d,l)}function b(a,c,d){for(;;)if(a=Pb(a,c),t(d))c=G(d),d=K(d);else return a}a.i=2;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=H(a);return b(c,d,a)};a.d=b;return a}(),b=function(b,e,f){switch(arguments.length){case 0:return a.call(this);case 1:return b;case 2:return Pb(b,
	e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.l=a;b.b=function(a){return a};b.a=function(a,b){return Pb(a,b)};b.d=c.d;return b}(),ee=function(){var a=null,b=function(){function a(c,f,g,h){var l=null;if(3<arguments.length){for(var l=0,m=Array(arguments.length-3);l<m.length;)m[l]=arguments[l+3],++l;l=new F(m,0)}return b.call(this,
	c,f,g,l)}function b(a,c,d,h){for(;;)if(a=Rb(a,c,d),t(h))c=G(h),d=Lc(h),h=K(K(h));else return a}a.i=3;a.f=function(a){var c=G(a);a=K(a);var g=G(a);a=K(a);var h=G(a);a=H(a);return b(c,g,h,a)};a.d=b;return a}(),a=function(a,d,e,f){switch(arguments.length){case 3:return Rb(a,d,e);default:var g=null;if(3<arguments.length){for(var g=0,h=Array(arguments.length-3);g<h.length;)h[g]=arguments[g+3],++g;g=new F(h,0)}return b.d(a,d,e,g)}throw Error("Invalid arity: "+arguments.length);};a.i=3;a.f=b.f;a.c=function(a,
	b,e){return Rb(a,b,e)};a.d=b.d;return a}(),fe=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a=Sb(a,c),t(d))c=G(d),d=K(d);else return a}a.i=2;a.f=function(a){var c=G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 2:return Sb(a,d);default:var f=null;if(2<
	arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.a=function(a,b){return Sb(a,b)};a.d=b.d;return a}(),ge=function(){var a=null,b=function(){function a(c,f,g){var h=null;if(2<arguments.length){for(var h=0,l=Array(arguments.length-2);h<l.length;)l[h]=arguments[h+2],++h;h=new F(l,0)}return b.call(this,c,f,h)}function b(a,c,d){for(;;)if(a=Vb(a,c),t(d))c=G(d),d=K(d);
	else return a}a.i=2;a.f=function(a){var c=G(a);a=K(a);var g=G(a);a=H(a);return b(c,g,a)};a.d=b;return a}(),a=function(a,d,e){switch(arguments.length){case 2:return Vb(a,d);default:var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return b.d(a,d,f)}throw Error("Invalid arity: "+arguments.length);};a.i=2;a.f=b.f;a.a=function(a,b){return Vb(a,b)};a.d=b.d;return a}();
	function he(a,b,c){var d=D(c);if(0===b)return a.l?a.l():a.call(null);c=Va(d);var e=Wa(d);if(1===b)return a.b?a.b(c):a.b?a.b(c):a.call(null,c);var d=Va(e),f=Wa(e);if(2===b)return a.a?a.a(c,d):a.a?a.a(c,d):a.call(null,c,d);var e=Va(f),g=Wa(f);if(3===b)return a.c?a.c(c,d,e):a.c?a.c(c,d,e):a.call(null,c,d,e);var f=Va(g),h=Wa(g);if(4===b)return a.n?a.n(c,d,e,f):a.n?a.n(c,d,e,f):a.call(null,c,d,e,f);var g=Va(h),l=Wa(h);if(5===b)return a.r?a.r(c,d,e,f,g):a.r?a.r(c,d,e,f,g):a.call(null,c,d,e,f,g);var h=Va(l),
	m=Wa(l);if(6===b)return a.P?a.P(c,d,e,f,g,h):a.P?a.P(c,d,e,f,g,h):a.call(null,c,d,e,f,g,h);var l=Va(m),p=Wa(m);if(7===b)return a.ia?a.ia(c,d,e,f,g,h,l):a.ia?a.ia(c,d,e,f,g,h,l):a.call(null,c,d,e,f,g,h,l);var m=Va(p),q=Wa(p);if(8===b)return a.Ga?a.Ga(c,d,e,f,g,h,l,m):a.Ga?a.Ga(c,d,e,f,g,h,l,m):a.call(null,c,d,e,f,g,h,l,m);var p=Va(q),s=Wa(q);if(9===b)return a.Ha?a.Ha(c,d,e,f,g,h,l,m,p):a.Ha?a.Ha(c,d,e,f,g,h,l,m,p):a.call(null,c,d,e,f,g,h,l,m,p);var q=Va(s),u=Wa(s);if(10===b)return a.va?a.va(c,d,e,
	f,g,h,l,m,p,q):a.va?a.va(c,d,e,f,g,h,l,m,p,q):a.call(null,c,d,e,f,g,h,l,m,p,q);var s=Va(u),v=Wa(u);if(11===b)return a.wa?a.wa(c,d,e,f,g,h,l,m,p,q,s):a.wa?a.wa(c,d,e,f,g,h,l,m,p,q,s):a.call(null,c,d,e,f,g,h,l,m,p,q,s);var u=Va(v),y=Wa(v);if(12===b)return a.xa?a.xa(c,d,e,f,g,h,l,m,p,q,s,u):a.xa?a.xa(c,d,e,f,g,h,l,m,p,q,s,u):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u);var v=Va(y),B=Wa(y);if(13===b)return a.ya?a.ya(c,d,e,f,g,h,l,m,p,q,s,u,v):a.ya?a.ya(c,d,e,f,g,h,l,m,p,q,s,u,v):a.call(null,c,d,e,f,g,h,l,m,p,
	q,s,u,v);var y=Va(B),E=Wa(B);if(14===b)return a.za?a.za(c,d,e,f,g,h,l,m,p,q,s,u,v,y):a.za?a.za(c,d,e,f,g,h,l,m,p,q,s,u,v,y):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y);var B=Va(E),N=Wa(E);if(15===b)return a.Aa?a.Aa(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B):a.Aa?a.Aa(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B);var E=Va(N),Y=Wa(N);if(16===b)return a.Ba?a.Ba(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E):a.Ba?a.Ba(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E);var N=
	Va(Y),ra=Wa(Y);if(17===b)return a.Ca?a.Ca(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N):a.Ca?a.Ca(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N);var Y=Va(ra),Pa=Wa(ra);if(18===b)return a.Da?a.Da(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y):a.Da?a.Da(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y);ra=Va(Pa);Pa=Wa(Pa);if(19===b)return a.Ea?a.Ea(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra):a.Ea?a.Ea(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra):a.call(null,
	c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra);var I=Va(Pa);Wa(Pa);if(20===b)return a.Fa?a.Fa(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra,I):a.Fa?a.Fa(c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra,I):a.call(null,c,d,e,f,g,h,l,m,p,q,s,u,v,y,B,E,N,Y,ra,I);throw Error("Only up to 20 arguments supported on functions");}
	var T=function(){function a(a,b,c,d,e){b=be.n(b,c,d,e);c=a.i;return a.f?(d=Yd(b,c+1),d<=c?he(a,d,b):a.f(b)):a.apply(a,rd(b))}function b(a,b,c,d){b=be.c(b,c,d);c=a.i;return a.f?(d=Yd(b,c+1),d<=c?he(a,d,b):a.f(b)):a.apply(a,rd(b))}function c(a,b,c){b=be.a(b,c);c=a.i;if(a.f){var d=Yd(b,c+1);return d<=c?he(a,d,b):a.f(b)}return a.apply(a,rd(b))}function d(a,b){var c=a.i;if(a.f){var d=Yd(b,c+1);return d<=c?he(a,d,b):a.f(b)}return a.apply(a,rd(b))}var e=null,f=function(){function a(c,d,e,f,g,u){var v=null;
	if(5<arguments.length){for(var v=0,y=Array(arguments.length-5);v<y.length;)y[v]=arguments[v+5],++v;v=new F(y,0)}return b.call(this,c,d,e,f,g,v)}function b(a,c,d,e,f,g){c=M(c,M(d,M(e,M(f,$d(g)))));d=a.i;return a.f?(e=Yd(c,d+1),e<=d?he(a,e,c):a.f(c)):a.apply(a,rd(c))}a.i=5;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var f=G(a);a=K(a);var g=G(a);a=H(a);return b(c,d,e,f,g,a)};a.d=b;return a}(),e=function(e,h,l,m,p,q){switch(arguments.length){case 2:return d.call(this,e,h);case 3:return c.call(this,
	e,h,l);case 4:return b.call(this,e,h,l,m);case 5:return a.call(this,e,h,l,m,p);default:var s=null;if(5<arguments.length){for(var s=0,u=Array(arguments.length-5);s<u.length;)u[s]=arguments[s+5],++s;s=new F(u,0)}return f.d(e,h,l,m,p,s)}throw Error("Invalid arity: "+arguments.length);};e.i=5;e.f=f.f;e.a=d;e.c=c;e.n=b;e.r=a;e.d=f.d;return e}(),ie=function(){function a(a,b,c,d,e,f){var g=O,v=Vc(a);b=b.r?b.r(v,c,d,e,f):b.call(null,v,c,d,e,f);return g(a,b)}function b(a,b,c,d,e){var f=O,g=Vc(a);b=b.n?b.n(g,
	c,d,e):b.call(null,g,c,d,e);return f(a,b)}function c(a,b,c,d){var e=O,f=Vc(a);b=b.c?b.c(f,c,d):b.call(null,f,c,d);return e(a,b)}function d(a,b,c){var d=O,e=Vc(a);b=b.a?b.a(e,c):b.call(null,e,c);return d(a,b)}function e(a,b){var c=O,d;d=Vc(a);d=b.b?b.b(d):b.call(null,d);return c(a,d)}var f=null,g=function(){function a(c,d,e,f,g,h,y){var B=null;if(6<arguments.length){for(var B=0,E=Array(arguments.length-6);B<E.length;)E[B]=arguments[B+6],++B;B=new F(E,0)}return b.call(this,c,d,e,f,g,h,B)}function b(a,
	c,d,e,f,g,h){return O(a,T.d(c,Vc(a),d,e,f,Kc([g,h],0)))}a.i=6;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var f=G(a);a=K(a);var g=G(a);a=K(a);var h=G(a);a=H(a);return b(c,d,e,f,g,h,a)};a.d=b;return a}(),f=function(f,l,m,p,q,s,u){switch(arguments.length){case 2:return e.call(this,f,l);case 3:return d.call(this,f,l,m);case 4:return c.call(this,f,l,m,p);case 5:return b.call(this,f,l,m,p,q);case 6:return a.call(this,f,l,m,p,q,s);default:var v=null;if(6<arguments.length){for(var v=
	0,y=Array(arguments.length-6);v<y.length;)y[v]=arguments[v+6],++v;v=new F(y,0)}return g.d(f,l,m,p,q,s,v)}throw Error("Invalid arity: "+arguments.length);};f.i=6;f.f=g.f;f.a=e;f.c=d;f.n=c;f.r=b;f.P=a;f.d=g.d;return f}(),je=function(){function a(a,b){return!sc.a(a,b)}var b=null,c=function(){function a(c,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return b.call(this,c,d,l)}function b(a,c,d){return Aa(T.n(sc,a,c,d))}a.i=
	2;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=H(a);return b(c,d,a)};a.d=b;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return!1;case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(){return!1};b.a=a;b.d=c.d;return b}(),qe=function ke(){"undefined"===typeof ja&&(ja=function(b,c){this.pc=
	b;this.oc=c;this.q=0;this.j=393216},ja.prototype.ga=function(){return!1},ja.prototype.next=function(){return Error("No such element")},ja.prototype.H=function(){return this.oc},ja.prototype.F=function(b,c){return new ja(this.pc,c)},ja.Yb=!0,ja.Xb="cljs.core/t12660",ja.nc=function(b){return Lb(b,"cljs.core/t12660")});return new ja(ke,new pa(null,5,[le,54,me,2998,ne,3,oe,2994,pe,"/Users/davidnolen/development/clojure/mori/out-mori-adv/cljs/core.cljs"],null))};function re(a,b){this.C=a;this.m=b}
	re.prototype.ga=function(){return this.m<this.C.length};re.prototype.next=function(){var a=this.C.charAt(this.m);this.m+=1;return a};function se(a,b){this.e=a;this.m=b}se.prototype.ga=function(){return this.m<this.e.length};se.prototype.next=function(){var a=this.e[this.m];this.m+=1;return a};var te={},ue={};function ve(a,b){this.eb=a;this.Qa=b}ve.prototype.ga=function(){this.eb===te?(this.eb=ue,this.Qa=D(this.Qa)):this.eb===this.Qa&&(this.Qa=K(this.eb));return null!=this.Qa};
	ve.prototype.next=function(){if(Aa(this.ga()))throw Error("No such element");this.eb=this.Qa;return G(this.Qa)};function we(a){if(null==a)return qe();if("string"===typeof a)return new re(a,0);if(a instanceof Array)return new se(a,0);if(a?t(t(null)?null:a.vb)||(a.yb?0:w(bc,a)):w(bc,a))return cc(a);if(ld(a))return new ve(te,a);throw Error([z("Cannot create iterator from "),z(a)].join(""));}function xe(a,b){this.fa=a;this.$b=b}
	xe.prototype.step=function(a){for(var b=this;;){if(t(function(){var c=null!=a.X;return c?b.$b.ga():c}()))if(Ac(function(){var c=b.$b.next();return b.fa.a?b.fa.a(a,c):b.fa.call(null,a,c)}()))null!=a.M&&(a.M.X=null);else continue;break}return null==a.X?null:b.fa.b?b.fa.b(a):b.fa.call(null,a)};
	function ye(a,b){var c=function(){function a(b,c){b.first=c;b.M=new ze(b.X,null,null,null);b.X=null;return b.M}function b(a){(Ac(a)?qb(a):a).X=null;return a}var c=null,c=function(c,f){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,f)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();return new xe(a.b?a.b(c):a.call(null,c),b)}function Ae(a,b,c){this.fa=a;this.Kb=b;this.ac=c}
	Ae.prototype.ga=function(){for(var a=D(this.Kb);;)if(null!=a){var b=G(a);if(Aa(b.ga()))return!1;a=K(a)}else return!0};Ae.prototype.next=function(){for(var a=this.Kb.length,b=0;;)if(b<a)this.ac[b]=this.Kb[b].next(),b+=1;else break;return Jc.a(this.ac,0)};Ae.prototype.step=function(a){for(;;){var b;b=(b=null!=a.X)?this.ga():b;if(t(b))if(Ac(T.a(this.fa,M(a,this.next()))))null!=a.M&&(a.M.X=null);else continue;break}return null==a.X?null:this.fa.b?this.fa.b(a):this.fa.call(null,a)};
	var Be=function(){function a(a,b,c){var g=function(){function a(b,c){b.first=c;b.M=new ze(b.X,null,null,null);b.X=null;return b.M}function b(a){a=Ac(a)?qb(a):a;a.X=null;return a}var c=null,c=function(c,d){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,d)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();return new Ae(a.b?a.b(g):a.call(null,g),b,c)}function b(a,b){return c.c(a,b,Array(b.length))}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,
	c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}();function ze(a,b,c,d){this.X=a;this.first=b;this.M=c;this.k=d;this.q=0;this.j=31719628}k=ze.prototype;k.T=function(){null!=this.X&&Cb(this);return null==this.M?null:Cb(this.M)};k.N=function(){null!=this.X&&Cb(this);return null==this.M?null:this.first};k.S=function(){null!=this.X&&Cb(this);return null==this.M?J:this.M};
	k.D=function(){null!=this.X&&this.X.step(this);return null==this.M?null:this};k.B=function(){return wc(this)};k.A=function(a,b){return null!=Cb(this)?Ic(this,b):cd(b)&&null==D(b)};k.J=function(){return J};k.G=function(a,b){return M(b,Cb(this))};k.F=function(a,b){return new ze(this.X,this.first,this.M,b)};ze.prototype[Ea]=function(){return uc(this)};
	var Ce=function(){function a(a){return kd(a)?a:(a=D(a))?a:J}var b=null,c=function(){function a(c,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return b.call(this,c,d,l)}function b(a,c,d){d=rd(M(c,d));c=[];d=D(d);for(var e=null,m=0,p=0;;)if(p<m){var q=e.Q(null,p);c.push(we(q));p+=1}else if(d=D(d))e=d,fd(e)?(d=Yb(e),p=Zb(e),e=d,m=Q(d),d=p):(d=G(e),c.push(we(d)),d=K(e),e=null,m=0),p=0;else break;return new ze(Be.c(a,c,
	Array(c.length)),null,null,null)}a.i=2;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=H(a);return b(c,d,a)};a.d=b;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return a.call(this,b);case 2:return new ze(ye(b,we(e)),null,null,null);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=a;b.a=function(a,b){return new ze(ye(a,
	we(b)),null,null,null)};b.d=c.d;return b}();function Ee(a,b){for(;;){if(null==D(b))return!0;var c;c=G(b);c=a.b?a.b(c):a.call(null,c);if(t(c)){c=a;var d=K(b);a=c;b=d}else return!1}}function Fe(a,b){for(;;)if(D(b)){var c;c=G(b);c=a.b?a.b(c):a.call(null,c);if(t(c))return c;c=a;var d=K(b);a=c;b=d}else return null}function Ge(a){if("number"===typeof a&&Aa(isNaN(a))&&Infinity!==a&&parseFloat(a)===parseInt(a,10))return 0===(a&1);throw Error([z("Argument must be an integer: "),z(a)].join(""));}
	function He(a){return function(){function b(b,c){return Aa(a.a?a.a(b,c):a.call(null,b,c))}function c(b){return Aa(a.b?a.b(b):a.call(null,b))}function d(){return Aa(a.l?a.l():a.call(null))}var e=null,f=function(){function b(a,d,e){var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return c.call(this,a,d,f)}function c(b,d,e){return Aa(T.n(a,b,d,e))}b.i=2;b.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};b.d=c;
	return b}(),e=function(a,e,l){switch(arguments.length){case 0:return d.call(this);case 1:return c.call(this,a);case 2:return b.call(this,a,e);default:var m=null;if(2<arguments.length){for(var m=0,p=Array(arguments.length-2);m<p.length;)p[m]=arguments[m+2],++m;m=new F(p,0)}return f.d(a,e,m)}throw Error("Invalid arity: "+arguments.length);};e.i=2;e.f=f.f;e.l=d;e.b=c;e.a=b;e.d=f.d;return e}()}
	var Ie=function(){function a(a,b,c){return function(){function d(h,l,m){h=c.c?c.c(h,l,m):c.call(null,h,l,m);h=b.b?b.b(h):b.call(null,h);return a.b?a.b(h):a.call(null,h)}function l(d,h){var l;l=c.a?c.a(d,h):c.call(null,d,h);l=b.b?b.b(l):b.call(null,l);return a.b?a.b(l):a.call(null,l)}function m(d){d=c.b?c.b(d):c.call(null,d);d=b.b?b.b(d):b.call(null,d);return a.b?a.b(d):a.call(null,d)}function p(){var d;d=c.l?c.l():c.call(null);d=b.b?b.b(d):b.call(null,d);return a.b?a.b(d):a.call(null,d)}var q=null,
	s=function(){function d(a,b,c,e){var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-3);f<g.length;)g[f]=arguments[f+3],++f;f=new F(g,0)}return h.call(this,a,b,c,f)}function h(d,l,m,p){d=T.r(c,d,l,m,p);d=b.b?b.b(d):b.call(null,d);return a.b?a.b(d):a.call(null,d)}d.i=3;d.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var d=G(a);a=H(a);return h(b,c,d,a)};d.d=h;return d}(),q=function(a,b,c,e){switch(arguments.length){case 0:return p.call(this);case 1:return m.call(this,a);case 2:return l.call(this,
	a,b);case 3:return d.call(this,a,b,c);default:var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-3);f<g.length;)g[f]=arguments[f+3],++f;f=new F(g,0)}return s.d(a,b,c,f)}throw Error("Invalid arity: "+arguments.length);};q.i=3;q.f=s.f;q.l=p;q.b=m;q.a=l;q.c=d;q.d=s.d;return q}()}function b(a,b){return function(){function c(d,g,h){d=b.c?b.c(d,g,h):b.call(null,d,g,h);return a.b?a.b(d):a.call(null,d)}function d(c,g){var h=b.a?b.a(c,g):b.call(null,c,g);return a.b?a.b(h):a.call(null,h)}
	function l(c){c=b.b?b.b(c):b.call(null,c);return a.b?a.b(c):a.call(null,c)}function m(){var c=b.l?b.l():b.call(null);return a.b?a.b(c):a.call(null,c)}var p=null,q=function(){function c(a,b,e,f){var g=null;if(3<arguments.length){for(var g=0,h=Array(arguments.length-3);g<h.length;)h[g]=arguments[g+3],++g;g=new F(h,0)}return d.call(this,a,b,e,g)}function d(c,g,h,l){c=T.r(b,c,g,h,l);return a.b?a.b(c):a.call(null,c)}c.i=3;c.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var e=G(a);a=H(a);return d(b,
	c,e,a)};c.d=d;return c}(),p=function(a,b,e,f){switch(arguments.length){case 0:return m.call(this);case 1:return l.call(this,a);case 2:return d.call(this,a,b);case 3:return c.call(this,a,b,e);default:var p=null;if(3<arguments.length){for(var p=0,E=Array(arguments.length-3);p<E.length;)E[p]=arguments[p+3],++p;p=new F(E,0)}return q.d(a,b,e,p)}throw Error("Invalid arity: "+arguments.length);};p.i=3;p.f=q.f;p.l=m;p.b=l;p.a=d;p.c=c;p.d=q.d;return p}()}var c=null,d=function(){function a(c,d,e,m){var p=null;
	if(3<arguments.length){for(var p=0,q=Array(arguments.length-3);p<q.length;)q[p]=arguments[p+3],++p;p=new F(q,0)}return b.call(this,c,d,e,p)}function b(a,c,d,e){return function(a){return function(){function b(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return c.call(this,d)}function c(b){b=T.a(G(a),b);for(var d=K(a);;)if(d)b=G(d).call(null,b),d=K(d);else return b}b.i=0;b.f=function(a){a=D(a);return c(a)};b.d=c;return b}()}(Jd(be.n(a,
	c,d,e)))}a.i=3;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=H(a);return b(c,d,e,a)};a.d=b;return a}(),c=function(c,f,g,h){switch(arguments.length){case 0:return ud;case 1:return c;case 2:return b.call(this,c,f);case 3:return a.call(this,c,f,g);default:var l=null;if(3<arguments.length){for(var l=0,m=Array(arguments.length-3);l<m.length;)m[l]=arguments[l+3],++l;l=new F(m,0)}return d.d(c,f,g,l)}throw Error("Invalid arity: "+arguments.length);};c.i=3;c.f=d.f;c.l=function(){return ud};
	c.b=function(a){return a};c.a=b;c.c=a;c.d=d.d;return c}(),Je=function(){function a(a,b,c,d){return function(){function e(m,p,q){return a.P?a.P(b,c,d,m,p,q):a.call(null,b,c,d,m,p,q)}function p(e,m){return a.r?a.r(b,c,d,e,m):a.call(null,b,c,d,e,m)}function q(e){return a.n?a.n(b,c,d,e):a.call(null,b,c,d,e)}function s(){return a.c?a.c(b,c,d):a.call(null,b,c,d)}var u=null,v=function(){function e(a,b,c,d){var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-3);f<g.length;)g[f]=arguments[f+
	3],++f;f=new F(g,0)}return m.call(this,a,b,c,f)}function m(e,p,q,s){return T.d(a,b,c,d,e,Kc([p,q,s],0))}e.i=3;e.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var d=G(a);a=H(a);return m(b,c,d,a)};e.d=m;return e}(),u=function(a,b,c,d){switch(arguments.length){case 0:return s.call(this);case 1:return q.call(this,a);case 2:return p.call(this,a,b);case 3:return e.call(this,a,b,c);default:var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-3);f<g.length;)g[f]=arguments[f+3],++f;f=
	new F(g,0)}return v.d(a,b,c,f)}throw Error("Invalid arity: "+arguments.length);};u.i=3;u.f=v.f;u.l=s;u.b=q;u.a=p;u.c=e;u.d=v.d;return u}()}function b(a,b,c){return function(){function d(e,l,m){return a.r?a.r(b,c,e,l,m):a.call(null,b,c,e,l,m)}function e(d,l){return a.n?a.n(b,c,d,l):a.call(null,b,c,d,l)}function p(d){return a.c?a.c(b,c,d):a.call(null,b,c,d)}function q(){return a.a?a.a(b,c):a.call(null,b,c)}var s=null,u=function(){function d(a,b,c,f){var g=null;if(3<arguments.length){for(var g=0,h=Array(arguments.length-
	3);g<h.length;)h[g]=arguments[g+3],++g;g=new F(h,0)}return e.call(this,a,b,c,g)}function e(d,l,m,p){return T.d(a,b,c,d,l,Kc([m,p],0))}d.i=3;d.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var d=G(a);a=H(a);return e(b,c,d,a)};d.d=e;return d}(),s=function(a,b,c,f){switch(arguments.length){case 0:return q.call(this);case 1:return p.call(this,a);case 2:return e.call(this,a,b);case 3:return d.call(this,a,b,c);default:var g=null;if(3<arguments.length){for(var g=0,h=Array(arguments.length-3);g<h.length;)h[g]=
	arguments[g+3],++g;g=new F(h,0)}return u.d(a,b,c,g)}throw Error("Invalid arity: "+arguments.length);};s.i=3;s.f=u.f;s.l=q;s.b=p;s.a=e;s.c=d;s.d=u.d;return s}()}function c(a,b){return function(){function c(d,e,h){return a.n?a.n(b,d,e,h):a.call(null,b,d,e,h)}function d(c,e){return a.c?a.c(b,c,e):a.call(null,b,c,e)}function e(c){return a.a?a.a(b,c):a.call(null,b,c)}function p(){return a.b?a.b(b):a.call(null,b)}var q=null,s=function(){function c(a,b,e,f){var g=null;if(3<arguments.length){for(var g=0,
	h=Array(arguments.length-3);g<h.length;)h[g]=arguments[g+3],++g;g=new F(h,0)}return d.call(this,a,b,e,g)}function d(c,e,h,l){return T.d(a,b,c,e,h,Kc([l],0))}c.i=3;c.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var e=G(a);a=H(a);return d(b,c,e,a)};c.d=d;return c}(),q=function(a,b,f,g){switch(arguments.length){case 0:return p.call(this);case 1:return e.call(this,a);case 2:return d.call(this,a,b);case 3:return c.call(this,a,b,f);default:var q=null;if(3<arguments.length){for(var q=0,N=Array(arguments.length-
	3);q<N.length;)N[q]=arguments[q+3],++q;q=new F(N,0)}return s.d(a,b,f,q)}throw Error("Invalid arity: "+arguments.length);};q.i=3;q.f=s.f;q.l=p;q.b=e;q.a=d;q.c=c;q.d=s.d;return q}()}var d=null,e=function(){function a(c,d,e,f,q){var s=null;if(4<arguments.length){for(var s=0,u=Array(arguments.length-4);s<u.length;)u[s]=arguments[s+4],++s;s=new F(u,0)}return b.call(this,c,d,e,f,s)}function b(a,c,d,e,f){return function(){function b(a){var c=null;if(0<arguments.length){for(var c=0,d=Array(arguments.length-
	0);c<d.length;)d[c]=arguments[c+0],++c;c=new F(d,0)}return g.call(this,c)}function g(b){return T.r(a,c,d,e,ae.a(f,b))}b.i=0;b.f=function(a){a=D(a);return g(a)};b.d=g;return b}()}a.i=4;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var f=G(a);a=H(a);return b(c,d,e,f,a)};a.d=b;return a}(),d=function(d,g,h,l,m){switch(arguments.length){case 1:return d;case 2:return c.call(this,d,g);case 3:return b.call(this,d,g,h);case 4:return a.call(this,d,g,h,l);default:var p=null;if(4<arguments.length){for(var p=
	0,q=Array(arguments.length-4);p<q.length;)q[p]=arguments[p+4],++p;p=new F(q,0)}return e.d(d,g,h,l,p)}throw Error("Invalid arity: "+arguments.length);};d.i=4;d.f=e.f;d.b=function(a){return a};d.a=c;d.c=b;d.n=a;d.d=e.d;return d}(),Ke=function(){function a(a,b,c,d){return function(){function l(l,m,p){l=null==l?b:l;m=null==m?c:m;p=null==p?d:p;return a.c?a.c(l,m,p):a.call(null,l,m,p)}function m(d,h){var l=null==d?b:d,m=null==h?c:h;return a.a?a.a(l,m):a.call(null,l,m)}var p=null,q=function(){function l(a,
	b,c,d){var e=null;if(3<arguments.length){for(var e=0,f=Array(arguments.length-3);e<f.length;)f[e]=arguments[e+3],++e;e=new F(f,0)}return m.call(this,a,b,c,e)}function m(l,p,q,s){return T.r(a,null==l?b:l,null==p?c:p,null==q?d:q,s)}l.i=3;l.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var d=G(a);a=H(a);return m(b,c,d,a)};l.d=m;return l}(),p=function(a,b,c,d){switch(arguments.length){case 2:return m.call(this,a,b);case 3:return l.call(this,a,b,c);default:var e=null;if(3<arguments.length){for(var e=
	0,f=Array(arguments.length-3);e<f.length;)f[e]=arguments[e+3],++e;e=new F(f,0)}return q.d(a,b,c,e)}throw Error("Invalid arity: "+arguments.length);};p.i=3;p.f=q.f;p.a=m;p.c=l;p.d=q.d;return p}()}function b(a,b,c){return function(){function d(h,l,m){h=null==h?b:h;l=null==l?c:l;return a.c?a.c(h,l,m):a.call(null,h,l,m)}function l(d,h){var l=null==d?b:d,m=null==h?c:h;return a.a?a.a(l,m):a.call(null,l,m)}var m=null,p=function(){function d(a,b,c,e){var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-
	3);f<g.length;)g[f]=arguments[f+3],++f;f=new F(g,0)}return h.call(this,a,b,c,f)}function h(d,l,m,p){return T.r(a,null==d?b:d,null==l?c:l,m,p)}d.i=3;d.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var d=G(a);a=H(a);return h(b,c,d,a)};d.d=h;return d}(),m=function(a,b,c,e){switch(arguments.length){case 2:return l.call(this,a,b);case 3:return d.call(this,a,b,c);default:var f=null;if(3<arguments.length){for(var f=0,g=Array(arguments.length-3);f<g.length;)g[f]=arguments[f+3],++f;f=new F(g,0)}return p.d(a,
	b,c,f)}throw Error("Invalid arity: "+arguments.length);};m.i=3;m.f=p.f;m.a=l;m.c=d;m.d=p.d;return m}()}function c(a,b){return function(){function c(d,g,h){d=null==d?b:d;return a.c?a.c(d,g,h):a.call(null,d,g,h)}function d(c,g){var h=null==c?b:c;return a.a?a.a(h,g):a.call(null,h,g)}function l(c){c=null==c?b:c;return a.b?a.b(c):a.call(null,c)}var m=null,p=function(){function c(a,b,e,f){var g=null;if(3<arguments.length){for(var g=0,h=Array(arguments.length-3);g<h.length;)h[g]=arguments[g+3],++g;g=new F(h,
	0)}return d.call(this,a,b,e,g)}function d(c,g,h,l){return T.r(a,null==c?b:c,g,h,l)}c.i=3;c.f=function(a){var b=G(a);a=K(a);var c=G(a);a=K(a);var e=G(a);a=H(a);return d(b,c,e,a)};c.d=d;return c}(),m=function(a,b,e,f){switch(arguments.length){case 1:return l.call(this,a);case 2:return d.call(this,a,b);case 3:return c.call(this,a,b,e);default:var m=null;if(3<arguments.length){for(var m=0,B=Array(arguments.length-3);m<B.length;)B[m]=arguments[m+3],++m;m=new F(B,0)}return p.d(a,b,e,m)}throw Error("Invalid arity: "+
	arguments.length);};m.i=3;m.f=p.f;m.b=l;m.a=d;m.c=c;m.d=p.d;return m}()}var d=null,d=function(d,f,g,h){switch(arguments.length){case 2:return c.call(this,d,f);case 3:return b.call(this,d,f,g);case 4:return a.call(this,d,f,g,h)}throw Error("Invalid arity: "+arguments.length);};d.a=c;d.c=b;d.n=a;return d}(),Le=function(){function a(a,b){return new V(null,function(){var f=D(b);if(f){if(fd(f)){for(var g=Yb(f),h=Q(g),l=Td(h),m=0;;)if(m<h){var p=function(){var b=C.a(g,m);return a.b?a.b(b):a.call(null,b)}();
	null!=p&&l.add(p);m+=1}else break;return Wd(l.ca(),c.a(a,Zb(f)))}h=function(){var b=G(f);return a.b?a.b(b):a.call(null,b)}();return null==h?c.a(a,H(f)):M(h,c.a(a,H(f)))}return null},null,null)}function b(a){return function(b){return function(){function c(f,g){var h=a.b?a.b(g):a.call(null,g);return null==h?f:b.a?b.a(f,h):b.call(null,f,h)}function g(a){return b.b?b.b(a):b.call(null,a)}function h(){return b.l?b.l():b.call(null)}var l=null,l=function(a,b){switch(arguments.length){case 0:return h.call(this);
	case 1:return g.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};l.l=h;l.b=g;l.a=c;return l}()}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();function Me(a){this.state=a;this.q=0;this.j=32768}Me.prototype.Ra=function(){return this.state};Me.prototype.bb=function(a,b){return this.state=b};
	var Ne=function(){function a(a,b){return function g(b,c){return new V(null,function(){var e=D(c);if(e){if(fd(e)){for(var p=Yb(e),q=Q(p),s=Td(q),u=0;;)if(u<q){var v=function(){var c=b+u,e=C.a(p,u);return a.a?a.a(c,e):a.call(null,c,e)}();null!=v&&s.add(v);u+=1}else break;return Wd(s.ca(),g(b+q,Zb(e)))}q=function(){var c=G(e);return a.a?a.a(b,c):a.call(null,b,c)}();return null==q?g(b+1,H(e)):M(q,g(b+1,H(e)))}return null},null,null)}(0,b)}function b(a){return function(b){return function(c){return function(){function g(g,
	h){var l=c.bb(0,c.Ra(null)+1),l=a.a?a.a(l,h):a.call(null,l,h);return null==l?g:b.a?b.a(g,l):b.call(null,g,l)}function h(a){return b.b?b.b(a):b.call(null,a)}function l(){return b.l?b.l():b.call(null)}var m=null,m=function(a,b){switch(arguments.length){case 0:return l.call(this);case 1:return h.call(this,a);case 2:return g.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};m.l=l;m.b=h;m.a=g;return m}()}(new Me(-1))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,
	c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Oe=function(){function a(a,b,c,d){return new V(null,function(){var f=D(b),q=D(c),s=D(d);if(f&&q&&s){var u=M,v;v=G(f);var y=G(q),B=G(s);v=a.c?a.c(v,y,B):a.call(null,v,y,B);f=u(v,e.n(a,H(f),H(q),H(s)))}else f=null;return f},null,null)}function b(a,b,c){return new V(null,function(){var d=D(b),f=D(c);if(d&&f){var q=M,s;s=G(d);var u=G(f);s=a.a?a.a(s,u):a.call(null,s,u);d=q(s,e.c(a,H(d),H(f)))}else d=
	null;return d},null,null)}function c(a,b){return new V(null,function(){var c=D(b);if(c){if(fd(c)){for(var d=Yb(c),f=Q(d),q=Td(f),s=0;;)if(s<f)Xd(q,function(){var b=C.a(d,s);return a.b?a.b(b):a.call(null,b)}()),s+=1;else break;return Wd(q.ca(),e.a(a,Zb(c)))}return M(function(){var b=G(c);return a.b?a.b(b):a.call(null,b)}(),e.a(a,H(c)))}return null},null,null)}function d(a){return function(b){return function(){function c(d,e){var f=a.b?a.b(e):a.call(null,e);return b.a?b.a(d,f):b.call(null,d,f)}function d(a){return b.b?
	b.b(a):b.call(null,a)}function e(){return b.l?b.l():b.call(null)}var f=null,s=function(){function c(a,b,e){var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return d.call(this,a,b,f)}function d(c,e,f){e=T.c(a,e,f);return b.a?b.a(c,e):b.call(null,c,e)}c.i=2;c.f=function(a){var b=G(a);a=K(a);var c=G(a);a=H(a);return d(b,c,a)};c.d=d;return c}(),f=function(a,b,f){switch(arguments.length){case 0:return e.call(this);case 1:return d.call(this,
	a);case 2:return c.call(this,a,b);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return s.d(a,b,g)}throw Error("Invalid arity: "+arguments.length);};f.i=2;f.f=s.f;f.l=e;f.b=d;f.a=c;f.d=s.d;return f}()}}var e=null,f=function(){function a(c,d,e,f,g){var u=null;if(4<arguments.length){for(var u=0,v=Array(arguments.length-4);u<v.length;)v[u]=arguments[u+4],++u;u=new F(v,0)}return b.call(this,c,d,e,f,u)}function b(a,c,d,
	f,g){var h=function y(a){return new V(null,function(){var b=e.a(D,a);return Ee(ud,b)?M(e.a(G,b),y(e.a(H,b))):null},null,null)};return e.a(function(){return function(b){return T.a(a,b)}}(h),h(Nc.d(g,f,Kc([d,c],0))))}a.i=4;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var f=G(a);a=H(a);return b(c,d,e,f,a)};a.d=b;return a}(),e=function(e,h,l,m,p){switch(arguments.length){case 1:return d.call(this,e);case 2:return c.call(this,e,h);case 3:return b.call(this,e,h,l);case 4:return a.call(this,
	e,h,l,m);default:var q=null;if(4<arguments.length){for(var q=0,s=Array(arguments.length-4);q<s.length;)s[q]=arguments[q+4],++q;q=new F(s,0)}return f.d(e,h,l,m,q)}throw Error("Invalid arity: "+arguments.length);};e.i=4;e.f=f.f;e.b=d;e.a=c;e.c=b;e.n=a;e.d=f.d;return e}(),Pe=function(){function a(a,b){return new V(null,function(){if(0<a){var f=D(b);return f?M(G(f),c.a(a-1,H(f))):null}return null},null,null)}function b(a){return function(b){return function(a){return function(){function c(d,g){var h=qb(a),
	l=a.bb(0,a.Ra(null)-1),h=0<h?b.a?b.a(d,g):b.call(null,d,g):d;return 0<l?h:Ac(h)?h:new yc(h)}function d(a){return b.b?b.b(a):b.call(null,a)}function l(){return b.l?b.l():b.call(null)}var m=null,m=function(a,b){switch(arguments.length){case 0:return l.call(this);case 1:return d.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};m.l=l;m.b=d;m.a=c;return m}()}(new Me(a))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,
	c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Qe=function(){function a(a,b){return new V(null,function(c){return function(){return c(a,b)}}(function(a,b){for(;;){var c=D(b);if(0<a&&c){var d=a-1,c=H(c);a=d;b=c}else return c}}),null,null)}function b(a){return function(b){return function(a){return function(){function c(d,g){var h=qb(a);a.bb(0,a.Ra(null)-1);return 0<h?d:b.a?b.a(d,g):b.call(null,d,g)}function d(a){return b.b?b.b(a):b.call(null,a)}function l(){return b.l?
	b.l():b.call(null)}var m=null,m=function(a,b){switch(arguments.length){case 0:return l.call(this);case 1:return d.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};m.l=l;m.b=d;m.a=c;return m}()}(new Me(a))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Re=function(){function a(a,b){return new V(null,function(c){return function(){return c(a,
	b)}}(function(a,b){for(;;){var c=D(b),d;if(d=c)d=G(c),d=a.b?a.b(d):a.call(null,d);if(t(d))d=a,c=H(c),a=d,b=c;else return c}}),null,null)}function b(a){return function(b){return function(c){return function(){function g(g,h){var l=qb(c);if(t(t(l)?a.b?a.b(h):a.call(null,h):l))return g;ac(c,null);return b.a?b.a(g,h):b.call(null,g,h)}function h(a){return b.b?b.b(a):b.call(null,a)}function l(){return b.l?b.l():b.call(null)}var m=null,m=function(a,b){switch(arguments.length){case 0:return l.call(this);case 1:return h.call(this,
	a);case 2:return g.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};m.l=l;m.b=h;m.a=g;return m}()}(new Me(!0))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Se=function(){function a(a,b){return Pe.a(a,c.b(b))}function b(a){return new V(null,function(){return M(a,c.b(a))},null,null)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,
	c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Te=function(){function a(a,b){return Pe.a(a,c.b(b))}function b(a){return new V(null,function(){return M(a.l?a.l():a.call(null),c.b(a))},null,null)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Ue=function(){function a(a,c){return new V(null,function(){var f=
	D(a),g=D(c);return f&&g?M(G(f),M(G(g),b.a(H(f),H(g)))):null},null,null)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){return new V(null,function(){var c=Oe.a(D,Nc.d(e,d,Kc([a],0)));return Ee(ud,c)?ae.a(Oe.a(G,c),T.a(b,Oe.a(H,c))):null},null,null)}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),
	b=function(b,e,f){switch(arguments.length){case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.a=a;b.d=c.d;return b}(),We=function(){function a(a){return Ie.a(Oe.b(a),Ve)}var b=null,c=function(){function a(c,d){var h=null;if(1<arguments.length){for(var h=0,l=Array(arguments.length-1);h<l.length;)l[h]=arguments[h+
	1],++h;h=new F(l,0)}return b.call(this,c,h)}function b(a,c){return T.a(ae,T.c(Oe,a,c))}a.i=1;a.f=function(a){var c=G(a);a=H(a);return b(c,a)};a.d=b;return a}(),b=function(b,e){switch(arguments.length){case 1:return a.call(this,b);default:var f=null;if(1<arguments.length){for(var f=0,g=Array(arguments.length-1);f<g.length;)g[f]=arguments[f+1],++f;f=new F(g,0)}return c.d(b,f)}throw Error("Invalid arity: "+arguments.length);};b.i=1;b.f=c.f;b.b=a;b.d=c.d;return b}(),Xe=function(){function a(a,b){return new V(null,
	function(){var f=D(b);if(f){if(fd(f)){for(var g=Yb(f),h=Q(g),l=Td(h),m=0;;)if(m<h){var p;p=C.a(g,m);p=a.b?a.b(p):a.call(null,p);t(p)&&(p=C.a(g,m),l.add(p));m+=1}else break;return Wd(l.ca(),c.a(a,Zb(f)))}g=G(f);f=H(f);return t(a.b?a.b(g):a.call(null,g))?M(g,c.a(a,f)):c.a(a,f)}return null},null,null)}function b(a){return function(b){return function(){function c(f,g){return t(a.b?a.b(g):a.call(null,g))?b.a?b.a(f,g):b.call(null,f,g):f}function g(a){return b.b?b.b(a):b.call(null,a)}function h(){return b.l?
	b.l():b.call(null)}var l=null,l=function(a,b){switch(arguments.length){case 0:return h.call(this);case 1:return g.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};l.l=h;l.b=g;l.a=c;return l}()}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),Ye=function(){function a(a,b){return Xe.a(He(a),b)}function b(a){return Xe.b(He(a))}
	var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();function Ze(a){var b=$e;return function d(a){return new V(null,function(){return M(a,t(b.b?b.b(a):b.call(null,a))?We.d(d,Kc([D.b?D.b(a):D.call(null,a)],0)):null)},null,null)}(a)}
	var af=function(){function a(a,b,c){return a&&(a.q&4||a.dc)?O(ce(wd.n(b,de,Ob(a),c)),Vc(a)):wd.n(b,Nc,a,c)}function b(a,b){return null!=a?a&&(a.q&4||a.dc)?O(ce(A.c(Pb,Ob(a),b)),Vc(a)):A.c(Ra,a,b):A.c(Nc,J,b)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),bf=function(){function a(a,b,c,h){return new V(null,function(){var l=D(h);if(l){var m=Pe.a(a,l);return a===
	Q(m)?M(m,d.n(a,b,c,Qe.a(b,l))):Ra(J,Pe.a(a,ae.a(m,c)))}return null},null,null)}function b(a,b,c){return new V(null,function(){var h=D(c);if(h){var l=Pe.a(a,h);return a===Q(l)?M(l,d.c(a,b,Qe.a(b,h))):null}return null},null,null)}function c(a,b){return d.c(a,a,b)}var d=null,d=function(d,f,g,h){switch(arguments.length){case 2:return c.call(this,d,f);case 3:return b.call(this,d,f,g);case 4:return a.call(this,d,f,g,h)}throw Error("Invalid arity: "+arguments.length);};d.a=c;d.c=b;d.n=a;return d}(),cf=function(){function a(a,
	b,c){var g=jd;for(b=D(b);;)if(b){var h=a;if(h?h.j&256||h.Rb||(h.j?0:w(Za,h)):w(Za,h)){a=S.c(a,G(b),g);if(g===a)return c;b=K(b)}else return c}else return a}function b(a,b){return c.c(a,b,null)}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}(),df=function(){function a(a,b,c,d,f,q){var s=R.c(b,0,null);return(b=Ed(b))?Rc.c(a,s,e.P(S.a(a,s),b,c,d,f,q)):Rc.c(a,s,
	function(){var b=S.a(a,s);return c.n?c.n(b,d,f,q):c.call(null,b,d,f,q)}())}function b(a,b,c,d,f){var q=R.c(b,0,null);return(b=Ed(b))?Rc.c(a,q,e.r(S.a(a,q),b,c,d,f)):Rc.c(a,q,function(){var b=S.a(a,q);return c.c?c.c(b,d,f):c.call(null,b,d,f)}())}function c(a,b,c,d){var f=R.c(b,0,null);return(b=Ed(b))?Rc.c(a,f,e.n(S.a(a,f),b,c,d)):Rc.c(a,f,function(){var b=S.a(a,f);return c.a?c.a(b,d):c.call(null,b,d)}())}function d(a,b,c){var d=R.c(b,0,null);return(b=Ed(b))?Rc.c(a,d,e.c(S.a(a,d),b,c)):Rc.c(a,d,function(){var b=
	S.a(a,d);return c.b?c.b(b):c.call(null,b)}())}var e=null,f=function(){function a(c,d,e,f,g,u,v){var y=null;if(6<arguments.length){for(var y=0,B=Array(arguments.length-6);y<B.length;)B[y]=arguments[y+6],++y;y=new F(B,0)}return b.call(this,c,d,e,f,g,u,y)}function b(a,c,d,f,g,h,v){var y=R.c(c,0,null);return(c=Ed(c))?Rc.c(a,y,T.d(e,S.a(a,y),c,d,f,Kc([g,h,v],0))):Rc.c(a,y,T.d(d,S.a(a,y),f,g,h,Kc([v],0)))}a.i=6;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=K(a);var e=G(a);a=K(a);var f=G(a);a=K(a);var g=
	G(a);a=K(a);var v=G(a);a=H(a);return b(c,d,e,f,g,v,a)};a.d=b;return a}(),e=function(e,h,l,m,p,q,s){switch(arguments.length){case 3:return d.call(this,e,h,l);case 4:return c.call(this,e,h,l,m);case 5:return b.call(this,e,h,l,m,p);case 6:return a.call(this,e,h,l,m,p,q);default:var u=null;if(6<arguments.length){for(var u=0,v=Array(arguments.length-6);u<v.length;)v[u]=arguments[u+6],++u;u=new F(v,0)}return f.d(e,h,l,m,p,q,u)}throw Error("Invalid arity: "+arguments.length);};e.i=6;e.f=f.f;e.c=d;e.n=c;
	e.r=b;e.P=a;e.d=f.d;return e}();function ef(a,b){this.u=a;this.e=b}function ff(a){return new ef(a,[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null])}function gf(a){return new ef(a.u,Fa(a.e))}function hf(a){a=a.g;return 32>a?0:a-1>>>5<<5}function jf(a,b,c){for(;;){if(0===b)return c;var d=ff(a);d.e[0]=c;c=d;b-=5}}
	var lf=function kf(b,c,d,e){var f=gf(d),g=b.g-1>>>c&31;5===c?f.e[g]=e:(d=d.e[g],b=null!=d?kf(b,c-5,d,e):jf(null,c-5,e),f.e[g]=b);return f};function mf(a,b){throw Error([z("No item "),z(a),z(" in vector of length "),z(b)].join(""));}function nf(a,b){if(b>=hf(a))return a.W;for(var c=a.root,d=a.shift;;)if(0<d)var e=d-5,c=c.e[b>>>d&31],d=e;else return c.e}function of(a,b){return 0<=b&&b<a.g?nf(a,b):mf(b,a.g)}
	var qf=function pf(b,c,d,e,f){var g=gf(d);if(0===c)g.e[e&31]=f;else{var h=e>>>c&31;b=pf(b,c-5,d.e[h],e,f);g.e[h]=b}return g},sf=function rf(b,c,d){var e=b.g-2>>>c&31;if(5<c){b=rf(b,c-5,d.e[e]);if(null==b&&0===e)return null;d=gf(d);d.e[e]=b;return d}if(0===e)return null;d=gf(d);d.e[e]=null;return d};function tf(a,b,c,d,e,f){this.m=a;this.zb=b;this.e=c;this.oa=d;this.start=e;this.end=f}tf.prototype.ga=function(){return this.m<this.end};
	tf.prototype.next=function(){32===this.m-this.zb&&(this.e=nf(this.oa,this.m),this.zb+=32);var a=this.e[this.m&31];this.m+=1;return a};function W(a,b,c,d,e,f){this.k=a;this.g=b;this.shift=c;this.root=d;this.W=e;this.p=f;this.j=167668511;this.q=8196}k=W.prototype;k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){return"number"===typeof b?C.c(this,b,c):c};
	k.gb=function(a,b,c){a=0;for(var d=c;;)if(a<this.g){var e=nf(this,a);c=e.length;a:{for(var f=0;;)if(f<c){var g=f+a,h=e[f],d=b.c?b.c(d,g,h):b.call(null,d,g,h);if(Ac(d)){e=d;break a}f+=1}else{e=d;break a}e=void 0}if(Ac(e))return b=e,L.b?L.b(b):L.call(null,b);a+=c;d=e}else return d};k.Q=function(a,b){return of(this,b)[b&31]};k.$=function(a,b,c){return 0<=b&&b<this.g?nf(this,b)[b&31]:c};
	k.Ua=function(a,b,c){if(0<=b&&b<this.g)return hf(this)<=b?(a=Fa(this.W),a[b&31]=c,new W(this.k,this.g,this.shift,this.root,a,null)):new W(this.k,this.g,this.shift,qf(this,this.shift,this.root,b,c),this.W,null);if(b===this.g)return Ra(this,c);throw Error([z("Index "),z(b),z(" out of bounds  [0,"),z(this.g),z("]")].join(""));};k.vb=!0;k.fb=function(){var a=this.g;return new tf(0,0,0<Q(this)?nf(this,0):null,this,0,a)};k.H=function(){return this.k};k.L=function(){return this.g};
	k.hb=function(){return C.a(this,0)};k.ib=function(){return C.a(this,1)};k.La=function(){return 0<this.g?C.a(this,this.g-1):null};
	k.Ma=function(){if(0===this.g)throw Error("Can't pop empty vector");if(1===this.g)return ub(Mc,this.k);if(1<this.g-hf(this))return new W(this.k,this.g-1,this.shift,this.root,this.W.slice(0,-1),null);var a=nf(this,this.g-2),b=sf(this,this.shift,this.root),b=null==b?uf:b,c=this.g-1;return 5<this.shift&&null==b.e[1]?new W(this.k,c,this.shift-5,b.e[0],a,null):new W(this.k,c,this.shift,b,a,null)};k.ab=function(){return 0<this.g?new Hc(this,this.g-1,null):null};
	k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){if(b instanceof W)if(this.g===Q(b))for(var c=cc(this),d=cc(b);;)if(t(c.ga())){var e=c.next(),f=d.next();if(!sc.a(e,f))return!1}else return!0;else return!1;else return Ic(this,b)};k.$a=function(){var a=this;return new vf(a.g,a.shift,function(){var b=a.root;return wf.b?wf.b(b):wf.call(null,b)}(),function(){var b=a.W;return xf.b?xf.b(b):xf.call(null,b)}())};k.J=function(){return O(Mc,this.k)};
	k.R=function(a,b){return Cc.a(this,b)};k.O=function(a,b,c){a=0;for(var d=c;;)if(a<this.g){var e=nf(this,a);c=e.length;a:{for(var f=0;;)if(f<c){var g=e[f],d=b.a?b.a(d,g):b.call(null,d,g);if(Ac(d)){e=d;break a}f+=1}else{e=d;break a}e=void 0}if(Ac(e))return b=e,L.b?L.b(b):L.call(null,b);a+=c;d=e}else return d};k.Ka=function(a,b,c){if("number"===typeof b)return pb(this,b,c);throw Error("Vector's key for assoc must be a number.");};
	k.D=function(){if(0===this.g)return null;if(32>=this.g)return new F(this.W,0);var a;a:{a=this.root;for(var b=this.shift;;)if(0<b)b-=5,a=a.e[0];else{a=a.e;break a}a=void 0}return yf.n?yf.n(this,a,0,0):yf.call(null,this,a,0,0)};k.F=function(a,b){return new W(b,this.g,this.shift,this.root,this.W,this.p)};
	k.G=function(a,b){if(32>this.g-hf(this)){for(var c=this.W.length,d=Array(c+1),e=0;;)if(e<c)d[e]=this.W[e],e+=1;else break;d[c]=b;return new W(this.k,this.g+1,this.shift,this.root,d,null)}c=(d=this.g>>>5>1<<this.shift)?this.shift+5:this.shift;d?(d=ff(null),d.e[0]=this.root,e=jf(null,this.shift,new ef(null,this.W)),d.e[1]=e):d=lf(this,this.shift,this.root,new ef(null,this.W));return new W(this.k,this.g+1,c,d,[b],null)};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.Q(null,c);case 3:return this.$(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.Q(null,c)};a.c=function(a,c,d){return this.$(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.Q(null,a)};k.a=function(a,b){return this.$(null,a,b)};
	var uf=new ef(null,[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null]),Mc=new W(null,0,5,uf,[],0);W.prototype[Ea]=function(){return uc(this)};function zf(a){return Qb(A.c(Pb,Ob(Mc),a))}
	var Af=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){if(a instanceof F&&0===a.m)a:{a=a.e;var b=a.length;if(32>b)a=new W(null,b,5,uf,a,null);else{for(var e=32,f=(new W(null,32,5,uf,a.slice(0,32),null)).$a(null);;)if(e<b)var g=e+1,f=de.a(f,a[e]),e=g;else{a=Qb(f);break a}a=void 0}}else a=zf(a);return a}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}();
	function Bf(a,b,c,d,e,f){this.ha=a;this.Ja=b;this.m=c;this.V=d;this.k=e;this.p=f;this.j=32375020;this.q=1536}k=Bf.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.T=function(){if(this.V+1<this.Ja.length){var a;a=this.ha;var b=this.Ja,c=this.m,d=this.V+1;a=yf.n?yf.n(a,b,c,d):yf.call(null,a,b,c,d);return null==a?null:a}return $b(this)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(Mc,this.k)};
	k.R=function(a,b){var c=this;return Cc.a(function(){var a=c.ha,b=c.m+c.V,f=Q(c.ha);return Cf.c?Cf.c(a,b,f):Cf.call(null,a,b,f)}(),b)};k.O=function(a,b,c){var d=this;return Cc.c(function(){var a=d.ha,b=d.m+d.V,c=Q(d.ha);return Cf.c?Cf.c(a,b,c):Cf.call(null,a,b,c)}(),b,c)};k.N=function(){return this.Ja[this.V]};k.S=function(){if(this.V+1<this.Ja.length){var a;a=this.ha;var b=this.Ja,c=this.m,d=this.V+1;a=yf.n?yf.n(a,b,c,d):yf.call(null,a,b,c,d);return null==a?J:a}return Zb(this)};k.D=function(){return this};
	k.Cb=function(){return Ud.a(this.Ja,this.V)};k.Db=function(){var a=this.m+this.Ja.length;if(a<Ma(this.ha)){var b=this.ha,c=nf(this.ha,a);return yf.n?yf.n(b,c,a,0):yf.call(null,b,c,a,0)}return J};k.F=function(a,b){var c=this.ha,d=this.Ja,e=this.m,f=this.V;return yf.r?yf.r(c,d,e,f,b):yf.call(null,c,d,e,f,b)};k.G=function(a,b){return M(b,this)};k.Bb=function(){var a=this.m+this.Ja.length;if(a<Ma(this.ha)){var b=this.ha,c=nf(this.ha,a);return yf.n?yf.n(b,c,a,0):yf.call(null,b,c,a,0)}return null};
	Bf.prototype[Ea]=function(){return uc(this)};var yf=function(){function a(a,b,c,d,l){return new Bf(a,b,c,d,l,null)}function b(a,b,c,d){return new Bf(a,b,c,d,null,null)}function c(a,b,c){return new Bf(a,of(a,b),b,c,null,null)}var d=null,d=function(d,f,g,h,l){switch(arguments.length){case 3:return c.call(this,d,f,g);case 4:return b.call(this,d,f,g,h);case 5:return a.call(this,d,f,g,h,l)}throw Error("Invalid arity: "+arguments.length);};d.c=c;d.n=b;d.r=a;return d}();
	function Df(a,b,c,d,e){this.k=a;this.oa=b;this.start=c;this.end=d;this.p=e;this.j=166617887;this.q=8192}k=Df.prototype;k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){return"number"===typeof b?C.c(this,b,c):c};k.Q=function(a,b){return 0>b||this.end<=this.start+b?mf(b,this.end-this.start):C.a(this.oa,this.start+b)};k.$=function(a,b,c){return 0>b||this.end<=this.start+b?c:C.c(this.oa,this.start+b,c)};
	k.Ua=function(a,b,c){var d=this.start+b;a=this.k;c=Rc.c(this.oa,d,c);b=this.start;var e=this.end,d=d+1,d=e>d?e:d;return Ef.r?Ef.r(a,c,b,d,null):Ef.call(null,a,c,b,d,null)};k.H=function(){return this.k};k.L=function(){return this.end-this.start};k.La=function(){return C.a(this.oa,this.end-1)};k.Ma=function(){if(this.start===this.end)throw Error("Can't pop empty vector");var a=this.k,b=this.oa,c=this.start,d=this.end-1;return Ef.r?Ef.r(a,b,c,d,null):Ef.call(null,a,b,c,d,null)};
	k.ab=function(){return this.start!==this.end?new Hc(this,this.end-this.start-1,null):null};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(Mc,this.k)};k.R=function(a,b){return Cc.a(this,b)};k.O=function(a,b,c){return Cc.c(this,b,c)};k.Ka=function(a,b,c){if("number"===typeof b)return pb(this,b,c);throw Error("Subvec's key for assoc must be a number.");};
	k.D=function(){var a=this;return function(b){return function d(e){return e===a.end?null:M(C.a(a.oa,e),new V(null,function(){return function(){return d(e+1)}}(b),null,null))}}(this)(a.start)};k.F=function(a,b){var c=this.oa,d=this.start,e=this.end,f=this.p;return Ef.r?Ef.r(b,c,d,e,f):Ef.call(null,b,c,d,e,f)};k.G=function(a,b){var c=this.k,d=pb(this.oa,this.end,b),e=this.start,f=this.end+1;return Ef.r?Ef.r(c,d,e,f,null):Ef.call(null,c,d,e,f,null)};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.Q(null,c);case 3:return this.$(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.Q(null,c)};a.c=function(a,c,d){return this.$(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.Q(null,a)};k.a=function(a,b){return this.$(null,a,b)};Df.prototype[Ea]=function(){return uc(this)};
	function Ef(a,b,c,d,e){for(;;)if(b instanceof Df)c=b.start+c,d=b.start+d,b=b.oa;else{var f=Q(b);if(0>c||0>d||c>f||d>f)throw Error("Index out of bounds");return new Df(a,b,c,d,e)}}var Cf=function(){function a(a,b,c){return Ef(null,a,b,c,null)}function b(a,b){return c.c(a,b,Q(a))}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}();
	function Ff(a,b){return a===b.u?b:new ef(a,Fa(b.e))}function wf(a){return new ef({},Fa(a.e))}function xf(a){var b=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null];hd(a,0,b,0,a.length);return b}
	var Hf=function Gf(b,c,d,e){d=Ff(b.root.u,d);var f=b.g-1>>>c&31;if(5===c)b=e;else{var g=d.e[f];b=null!=g?Gf(b,c-5,g,e):jf(b.root.u,c-5,e)}d.e[f]=b;return d},Jf=function If(b,c,d){d=Ff(b.root.u,d);var e=b.g-2>>>c&31;if(5<c){b=If(b,c-5,d.e[e]);if(null==b&&0===e)return null;d.e[e]=b;return d}if(0===e)return null;d.e[e]=null;return d};function vf(a,b,c,d){this.g=a;this.shift=b;this.root=c;this.W=d;this.j=275;this.q=88}k=vf.prototype;
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};k.t=function(a,b){return $a.c(this,b,null)};
	k.s=function(a,b,c){return"number"===typeof b?C.c(this,b,c):c};k.Q=function(a,b){if(this.root.u)return of(this,b)[b&31];throw Error("nth after persistent!");};k.$=function(a,b,c){return 0<=b&&b<this.g?C.a(this,b):c};k.L=function(){if(this.root.u)return this.g;throw Error("count after persistent!");};
	k.Ub=function(a,b,c){var d=this;if(d.root.u){if(0<=b&&b<d.g)return hf(this)<=b?d.W[b&31]=c:(a=function(){return function f(a,h){var l=Ff(d.root.u,h);if(0===a)l.e[b&31]=c;else{var m=b>>>a&31,p=f(a-5,l.e[m]);l.e[m]=p}return l}}(this).call(null,d.shift,d.root),d.root=a),this;if(b===d.g)return Pb(this,c);throw Error([z("Index "),z(b),z(" out of bounds for TransientVector of length"),z(d.g)].join(""));}throw Error("assoc! after persistent!");};
	k.Vb=function(){if(this.root.u){if(0===this.g)throw Error("Can't pop empty vector");if(1===this.g)this.g=0;else if(0<(this.g-1&31))this.g-=1;else{var a;a:if(a=this.g-2,a>=hf(this))a=this.W;else{for(var b=this.root,c=b,d=this.shift;;)if(0<d)c=Ff(b.u,c.e[a>>>d&31]),d-=5;else{a=c.e;break a}a=void 0}b=Jf(this,this.shift,this.root);b=null!=b?b:new ef(this.root.u,[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,
	null,null,null,null]);5<this.shift&&null==b.e[1]?(this.root=Ff(this.root.u,b.e[0]),this.shift-=5):this.root=b;this.g-=1;this.W=a}return this}throw Error("pop! after persistent!");};k.kb=function(a,b,c){if("number"===typeof b)return Tb(this,b,c);throw Error("TransientVector's key for assoc! must be a number.");};
	k.Sa=function(a,b){if(this.root.u){if(32>this.g-hf(this))this.W[this.g&31]=b;else{var c=new ef(this.root.u,this.W),d=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null];d[0]=b;this.W=d;if(this.g>>>5>1<<this.shift){var d=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null],e=this.shift+
	5;d[0]=this.root;d[1]=jf(this.root.u,this.shift,c);this.root=new ef(this.root.u,d);this.shift=e}else this.root=Hf(this,this.shift,this.root,c)}this.g+=1;return this}throw Error("conj! after persistent!");};k.Ta=function(){if(this.root.u){this.root.u=null;var a=this.g-hf(this),b=Array(a);hd(this.W,0,b,0,a);return new W(null,this.g,this.shift,this.root,b,null)}throw Error("persistent! called twice");};function Kf(a,b,c,d){this.k=a;this.ea=b;this.sa=c;this.p=d;this.q=0;this.j=31850572}k=Kf.prototype;
	k.toString=function(){return ec(this)};k.H=function(){return this.k};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.N=function(){return G(this.ea)};k.S=function(){var a=K(this.ea);return a?new Kf(this.k,a,this.sa,null):null==this.sa?Na(this):new Kf(this.k,this.sa,null,null)};k.D=function(){return this};k.F=function(a,b){return new Kf(b,this.ea,this.sa,this.p)};k.G=function(a,b){return M(b,this)};
	Kf.prototype[Ea]=function(){return uc(this)};function Lf(a,b,c,d,e){this.k=a;this.count=b;this.ea=c;this.sa=d;this.p=e;this.j=31858766;this.q=8192}k=Lf.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.L=function(){return this.count};k.La=function(){return G(this.ea)};k.Ma=function(){if(t(this.ea)){var a=K(this.ea);return a?new Lf(this.k,this.count-1,a,this.sa,null):new Lf(this.k,this.count-1,D(this.sa),Mc,null)}return this};
	k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(Mf,this.k)};k.N=function(){return G(this.ea)};k.S=function(){return H(D(this))};k.D=function(){var a=D(this.sa),b=this.ea;return t(t(b)?b:a)?new Kf(null,this.ea,D(a),null):null};k.F=function(a,b){return new Lf(b,this.count,this.ea,this.sa,this.p)};
	k.G=function(a,b){var c;t(this.ea)?(c=this.sa,c=new Lf(this.k,this.count+1,this.ea,Nc.a(t(c)?c:Mc,b),null)):c=new Lf(this.k,this.count+1,Nc.a(this.ea,b),Mc,null);return c};var Mf=new Lf(null,0,null,Mc,0);Lf.prototype[Ea]=function(){return uc(this)};function Nf(){this.q=0;this.j=2097152}Nf.prototype.A=function(){return!1};var Of=new Nf;function Pf(a,b){return md(dd(b)?Q(a)===Q(b)?Ee(ud,Oe.a(function(a){return sc.a(S.c(b,G(a),Of),Lc(a))},a)):null:null)}
	function Qf(a,b){var c=a.e;if(b instanceof U)a:{for(var d=c.length,e=b.pa,f=0;;){if(d<=f){c=-1;break a}var g=c[f];if(g instanceof U&&e===g.pa){c=f;break a}f+=2}c=void 0}else if(d="string"==typeof b,t(t(d)?d:"number"===typeof b))a:{d=c.length;for(e=0;;){if(d<=e){c=-1;break a}if(b===c[e]){c=e;break a}e+=2}c=void 0}else if(b instanceof qc)a:{d=c.length;e=b.ta;for(f=0;;){if(d<=f){c=-1;break a}g=c[f];if(g instanceof qc&&e===g.ta){c=f;break a}f+=2}c=void 0}else if(null==b)a:{d=c.length;for(e=0;;){if(d<=
	e){c=-1;break a}if(null==c[e]){c=e;break a}e+=2}c=void 0}else a:{d=c.length;for(e=0;;){if(d<=e){c=-1;break a}if(sc.a(b,c[e])){c=e;break a}e+=2}c=void 0}return c}function Rf(a,b,c){this.e=a;this.m=b;this.Z=c;this.q=0;this.j=32374990}k=Rf.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.Z};k.T=function(){return this.m<this.e.length-2?new Rf(this.e,this.m+2,this.Z):null};k.L=function(){return(this.e.length-this.m)/2};k.B=function(){return wc(this)};
	k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.Z)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return new W(null,2,5,uf,[this.e[this.m],this.e[this.m+1]],null)};k.S=function(){return this.m<this.e.length-2?new Rf(this.e,this.m+2,this.Z):J};k.D=function(){return this};k.F=function(a,b){return new Rf(this.e,this.m,b)};k.G=function(a,b){return M(b,this)};Rf.prototype[Ea]=function(){return uc(this)};
	function Sf(a,b,c){this.e=a;this.m=b;this.g=c}Sf.prototype.ga=function(){return this.m<this.g};Sf.prototype.next=function(){var a=new W(null,2,5,uf,[this.e[this.m],this.e[this.m+1]],null);this.m+=2;return a};function pa(a,b,c,d){this.k=a;this.g=b;this.e=c;this.p=d;this.j=16647951;this.q=8196}k=pa.prototype;k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){a=Qf(this,b);return-1===a?c:this.e[a+1]};
	k.gb=function(a,b,c){a=this.e.length;for(var d=0;;)if(d<a){var e=this.e[d],f=this.e[d+1];c=b.c?b.c(c,e,f):b.call(null,c,e,f);if(Ac(c))return b=c,L.b?L.b(b):L.call(null,b);d+=2}else return c};k.vb=!0;k.fb=function(){return new Sf(this.e,0,2*this.g)};k.H=function(){return this.k};k.L=function(){return this.g};k.B=function(){var a=this.p;return null!=a?a:this.p=a=xc(this)};
	k.A=function(a,b){if(b&&(b.j&1024||b.ic)){var c=this.e.length;if(this.g===b.L(null))for(var d=0;;)if(d<c){var e=b.s(null,this.e[d],jd);if(e!==jd)if(sc.a(this.e[d+1],e))d+=2;else return!1;else return!1}else return!0;else return!1}else return Pf(this,b)};k.$a=function(){return new Tf({},this.e.length,Fa(this.e))};k.J=function(){return ub(Uf,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};
	k.wb=function(a,b){if(0<=Qf(this,b)){var c=this.e.length,d=c-2;if(0===d)return Na(this);for(var d=Array(d),e=0,f=0;;){if(e>=c)return new pa(this.k,this.g-1,d,null);sc.a(b,this.e[e])||(d[f]=this.e[e],d[f+1]=this.e[e+1],f+=2);e+=2}}else return this};
	k.Ka=function(a,b,c){a=Qf(this,b);if(-1===a){if(this.g<Vf){a=this.e;for(var d=a.length,e=Array(d+2),f=0;;)if(f<d)e[f]=a[f],f+=1;else break;e[d]=b;e[d+1]=c;return new pa(this.k,this.g+1,e,null)}return ub(cb(af.a(Qc,this),b,c),this.k)}if(c===this.e[a+1])return this;b=Fa(this.e);b[a+1]=c;return new pa(this.k,this.g,b,null)};k.rb=function(a,b){return-1!==Qf(this,b)};k.D=function(){var a=this.e;return 0<=a.length-2?new Rf(a,0,null):null};k.F=function(a,b){return new pa(b,this.g,this.e,this.p)};
	k.G=function(a,b){if(ed(b))return cb(this,C.a(b,0),C.a(b,1));for(var c=this,d=D(b);;){if(null==d)return c;var e=G(d);if(ed(e))c=cb(c,C.a(e,0),C.a(e,1)),d=K(d);else throw Error("conj on a map takes map entries or seqables of map entries");}};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};var Uf=new pa(null,0,[],null),Vf=8;pa.prototype[Ea]=function(){return uc(this)};
	function Tf(a,b,c){this.Va=a;this.qa=b;this.e=c;this.q=56;this.j=258}k=Tf.prototype;k.Jb=function(a,b){if(t(this.Va)){var c=Qf(this,b);0<=c&&(this.e[c]=this.e[this.qa-2],this.e[c+1]=this.e[this.qa-1],c=this.e,c.pop(),c.pop(),this.qa-=2);return this}throw Error("dissoc! after persistent!");};
	k.kb=function(a,b,c){var d=this;if(t(d.Va)){a=Qf(this,b);if(-1===a)return d.qa+2<=2*Vf?(d.qa+=2,d.e.push(b),d.e.push(c),this):ee.c(function(){var a=d.qa,b=d.e;return Xf.a?Xf.a(a,b):Xf.call(null,a,b)}(),b,c);c!==d.e[a+1]&&(d.e[a+1]=c);return this}throw Error("assoc! after persistent!");};
	k.Sa=function(a,b){if(t(this.Va)){if(b?b.j&2048||b.jc||(b.j?0:w(fb,b)):w(fb,b))return Rb(this,Yf.b?Yf.b(b):Yf.call(null,b),Zf.b?Zf.b(b):Zf.call(null,b));for(var c=D(b),d=this;;){var e=G(c);if(t(e))var f=e,c=K(c),d=Rb(d,function(){var a=f;return Yf.b?Yf.b(a):Yf.call(null,a)}(),function(){var a=f;return Zf.b?Zf.b(a):Zf.call(null,a)}());else return d}}else throw Error("conj! after persistent!");};
	k.Ta=function(){if(t(this.Va))return this.Va=!1,new pa(null,Cd(this.qa,2),this.e,null);throw Error("persistent! called twice");};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){if(t(this.Va))return a=Qf(this,b),-1===a?c:this.e[a+1];throw Error("lookup after persistent!");};k.L=function(){if(t(this.Va))return Cd(this.qa,2);throw Error("count after persistent!");};function Xf(a,b){for(var c=Ob(Qc),d=0;;)if(d<a)c=ee.c(c,b[d],b[d+1]),d+=2;else return c}function $f(){this.o=!1}
	function ag(a,b){return a===b?!0:Nd(a,b)?!0:sc.a(a,b)}var bg=function(){function a(a,b,c,g,h){a=Fa(a);a[b]=c;a[g]=h;return a}function b(a,b,c){a=Fa(a);a[b]=c;return a}var c=null,c=function(c,e,f,g,h){switch(arguments.length){case 3:return b.call(this,c,e,f);case 5:return a.call(this,c,e,f,g,h)}throw Error("Invalid arity: "+arguments.length);};c.c=b;c.r=a;return c}();function cg(a,b){var c=Array(a.length-2);hd(a,0,c,0,2*b);hd(a,2*(b+1),c,2*b,c.length-2*b);return c}
	var dg=function(){function a(a,b,c,g,h,l){a=a.Na(b);a.e[c]=g;a.e[h]=l;return a}function b(a,b,c,g){a=a.Na(b);a.e[c]=g;return a}var c=null,c=function(c,e,f,g,h,l){switch(arguments.length){case 4:return b.call(this,c,e,f,g);case 6:return a.call(this,c,e,f,g,h,l)}throw Error("Invalid arity: "+arguments.length);};c.n=b;c.P=a;return c}();
	function eg(a,b,c){for(var d=a.length,e=0,f=c;;)if(e<d){c=a[e];if(null!=c){var g=a[e+1];c=b.c?b.c(f,c,g):b.call(null,f,c,g)}else c=a[e+1],c=null!=c?c.Xa(b,f):f;if(Ac(c))return a=c,L.b?L.b(a):L.call(null,a);e+=2;f=c}else return f}function fg(a,b,c){this.u=a;this.w=b;this.e=c}k=fg.prototype;k.Na=function(a){if(a===this.u)return this;var b=Dd(this.w),c=Array(0>b?4:2*(b+1));hd(this.e,0,c,0,2*b);return new fg(a,this.w,c)};
	k.nb=function(a,b,c,d,e){var f=1<<(c>>>b&31);if(0===(this.w&f))return this;var g=Dd(this.w&f-1),h=this.e[2*g],l=this.e[2*g+1];return null==h?(b=l.nb(a,b+5,c,d,e),b===l?this:null!=b?dg.n(this,a,2*g+1,b):this.w===f?null:gg(this,a,f,g)):ag(d,h)?(e[0]=!0,gg(this,a,f,g)):this};function gg(a,b,c,d){if(a.w===c)return null;a=a.Na(b);b=a.e;var e=b.length;a.w^=c;hd(b,2*(d+1),b,2*d,e-2*(d+1));b[e-2]=null;b[e-1]=null;return a}k.lb=function(){var a=this.e;return hg.b?hg.b(a):hg.call(null,a)};
	k.Xa=function(a,b){return eg(this.e,a,b)};k.Oa=function(a,b,c,d){var e=1<<(b>>>a&31);if(0===(this.w&e))return d;var f=Dd(this.w&e-1),e=this.e[2*f],f=this.e[2*f+1];return null==e?f.Oa(a+5,b,c,d):ag(c,e)?f:d};
	k.la=function(a,b,c,d,e,f){var g=1<<(c>>>b&31),h=Dd(this.w&g-1);if(0===(this.w&g)){var l=Dd(this.w);if(2*l<this.e.length){var m=this.Na(a),p=m.e;f.o=!0;id(p,2*h,p,2*(h+1),2*(l-h));p[2*h]=d;p[2*h+1]=e;m.w|=g;return m}if(16<=l){g=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null];g[c>>>b&31]=ig.la(a,b+5,c,d,e,f);for(m=h=0;;)if(32>h)0!==(this.w>>>h&1)&&(g[h]=null!=this.e[m]?ig.la(a,b+5,nc(this.e[m]),
	this.e[m],this.e[m+1],f):this.e[m+1],m+=2),h+=1;else break;return new jg(a,l+1,g)}p=Array(2*(l+4));hd(this.e,0,p,0,2*h);p[2*h]=d;p[2*h+1]=e;hd(this.e,2*h,p,2*(h+1),2*(l-h));f.o=!0;m=this.Na(a);m.e=p;m.w|=g;return m}var q=this.e[2*h],s=this.e[2*h+1];if(null==q)return l=s.la(a,b+5,c,d,e,f),l===s?this:dg.n(this,a,2*h+1,l);if(ag(d,q))return e===s?this:dg.n(this,a,2*h+1,e);f.o=!0;return dg.P(this,a,2*h,null,2*h+1,function(){var f=b+5;return kg.ia?kg.ia(a,f,q,s,c,d,e):kg.call(null,a,f,q,s,c,d,e)}())};
	k.ka=function(a,b,c,d,e){var f=1<<(b>>>a&31),g=Dd(this.w&f-1);if(0===(this.w&f)){var h=Dd(this.w);if(16<=h){f=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null];f[b>>>a&31]=ig.ka(a+5,b,c,d,e);for(var l=g=0;;)if(32>g)0!==(this.w>>>g&1)&&(f[g]=null!=this.e[l]?ig.ka(a+5,nc(this.e[l]),this.e[l],this.e[l+1],e):this.e[l+1],l+=2),g+=1;else break;return new jg(null,h+1,f)}l=Array(2*(h+1));hd(this.e,
	0,l,0,2*g);l[2*g]=c;l[2*g+1]=d;hd(this.e,2*g,l,2*(g+1),2*(h-g));e.o=!0;return new fg(null,this.w|f,l)}var m=this.e[2*g],p=this.e[2*g+1];if(null==m)return h=p.ka(a+5,b,c,d,e),h===p?this:new fg(null,this.w,bg.c(this.e,2*g+1,h));if(ag(c,m))return d===p?this:new fg(null,this.w,bg.c(this.e,2*g+1,d));e.o=!0;return new fg(null,this.w,bg.r(this.e,2*g,null,2*g+1,function(){var e=a+5;return kg.P?kg.P(e,m,p,b,c,d):kg.call(null,e,m,p,b,c,d)}()))};
	k.mb=function(a,b,c){var d=1<<(b>>>a&31);if(0===(this.w&d))return this;var e=Dd(this.w&d-1),f=this.e[2*e],g=this.e[2*e+1];return null==f?(a=g.mb(a+5,b,c),a===g?this:null!=a?new fg(null,this.w,bg.c(this.e,2*e+1,a)):this.w===d?null:new fg(null,this.w^d,cg(this.e,e))):ag(c,f)?new fg(null,this.w^d,cg(this.e,e)):this};var ig=new fg(null,0,[]);
	function lg(a,b,c){var d=a.e,e=d.length;a=Array(2*(a.g-1));for(var f=0,g=1,h=0;;)if(f<e)f!==c&&null!=d[f]&&(a[g]=d[f],g+=2,h|=1<<f),f+=1;else return new fg(b,h,a)}function jg(a,b,c){this.u=a;this.g=b;this.e=c}k=jg.prototype;k.Na=function(a){return a===this.u?this:new jg(a,this.g,Fa(this.e))};
	k.nb=function(a,b,c,d,e){var f=c>>>b&31,g=this.e[f];if(null==g)return this;b=g.nb(a,b+5,c,d,e);if(b===g)return this;if(null==b){if(8>=this.g)return lg(this,a,f);a=dg.n(this,a,f,b);a.g-=1;return a}return dg.n(this,a,f,b)};k.lb=function(){var a=this.e;return mg.b?mg.b(a):mg.call(null,a)};k.Xa=function(a,b){for(var c=this.e.length,d=0,e=b;;)if(d<c){var f=this.e[d];if(null!=f&&(e=f.Xa(a,e),Ac(e)))return c=e,L.b?L.b(c):L.call(null,c);d+=1}else return e};
	k.Oa=function(a,b,c,d){var e=this.e[b>>>a&31];return null!=e?e.Oa(a+5,b,c,d):d};k.la=function(a,b,c,d,e,f){var g=c>>>b&31,h=this.e[g];if(null==h)return a=dg.n(this,a,g,ig.la(a,b+5,c,d,e,f)),a.g+=1,a;b=h.la(a,b+5,c,d,e,f);return b===h?this:dg.n(this,a,g,b)};k.ka=function(a,b,c,d,e){var f=b>>>a&31,g=this.e[f];if(null==g)return new jg(null,this.g+1,bg.c(this.e,f,ig.ka(a+5,b,c,d,e)));a=g.ka(a+5,b,c,d,e);return a===g?this:new jg(null,this.g,bg.c(this.e,f,a))};
	k.mb=function(a,b,c){var d=b>>>a&31,e=this.e[d];return null!=e?(a=e.mb(a+5,b,c),a===e?this:null==a?8>=this.g?lg(this,null,d):new jg(null,this.g-1,bg.c(this.e,d,a)):new jg(null,this.g,bg.c(this.e,d,a))):this};function ng(a,b,c){b*=2;for(var d=0;;)if(d<b){if(ag(c,a[d]))return d;d+=2}else return-1}function og(a,b,c,d){this.u=a;this.Ia=b;this.g=c;this.e=d}k=og.prototype;k.Na=function(a){if(a===this.u)return this;var b=Array(2*(this.g+1));hd(this.e,0,b,0,2*this.g);return new og(a,this.Ia,this.g,b)};
	k.nb=function(a,b,c,d,e){b=ng(this.e,this.g,d);if(-1===b)return this;e[0]=!0;if(1===this.g)return null;a=this.Na(a);e=a.e;e[b]=e[2*this.g-2];e[b+1]=e[2*this.g-1];e[2*this.g-1]=null;e[2*this.g-2]=null;a.g-=1;return a};k.lb=function(){var a=this.e;return hg.b?hg.b(a):hg.call(null,a)};k.Xa=function(a,b){return eg(this.e,a,b)};k.Oa=function(a,b,c,d){a=ng(this.e,this.g,c);return 0>a?d:ag(c,this.e[a])?this.e[a+1]:d};
	k.la=function(a,b,c,d,e,f){if(c===this.Ia){b=ng(this.e,this.g,d);if(-1===b){if(this.e.length>2*this.g)return a=dg.P(this,a,2*this.g,d,2*this.g+1,e),f.o=!0,a.g+=1,a;c=this.e.length;b=Array(c+2);hd(this.e,0,b,0,c);b[c]=d;b[c+1]=e;f.o=!0;f=this.g+1;a===this.u?(this.e=b,this.g=f,a=this):a=new og(this.u,this.Ia,f,b);return a}return this.e[b+1]===e?this:dg.n(this,a,b+1,e)}return(new fg(a,1<<(this.Ia>>>b&31),[null,this,null,null])).la(a,b,c,d,e,f)};
	k.ka=function(a,b,c,d,e){return b===this.Ia?(a=ng(this.e,this.g,c),-1===a?(a=2*this.g,b=Array(a+2),hd(this.e,0,b,0,a),b[a]=c,b[a+1]=d,e.o=!0,new og(null,this.Ia,this.g+1,b)):sc.a(this.e[a],d)?this:new og(null,this.Ia,this.g,bg.c(this.e,a+1,d))):(new fg(null,1<<(this.Ia>>>a&31),[null,this])).ka(a,b,c,d,e)};k.mb=function(a,b,c){a=ng(this.e,this.g,c);return-1===a?this:1===this.g?null:new og(null,this.Ia,this.g-1,cg(this.e,Cd(a,2)))};
	var kg=function(){function a(a,b,c,g,h,l,m){var p=nc(c);if(p===h)return new og(null,p,2,[c,g,l,m]);var q=new $f;return ig.la(a,b,p,c,g,q).la(a,b,h,l,m,q)}function b(a,b,c,g,h,l){var m=nc(b);if(m===g)return new og(null,m,2,[b,c,h,l]);var p=new $f;return ig.ka(a,m,b,c,p).ka(a,g,h,l,p)}var c=null,c=function(c,e,f,g,h,l,m){switch(arguments.length){case 6:return b.call(this,c,e,f,g,h,l);case 7:return a.call(this,c,e,f,g,h,l,m)}throw Error("Invalid arity: "+arguments.length);};c.P=b;c.ia=a;return c}();
	function pg(a,b,c,d,e){this.k=a;this.Pa=b;this.m=c;this.C=d;this.p=e;this.q=0;this.j=32374860}k=pg.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return null==this.C?new W(null,2,5,uf,[this.Pa[this.m],this.Pa[this.m+1]],null):G(this.C)};
	k.S=function(){if(null==this.C){var a=this.Pa,b=this.m+2;return hg.c?hg.c(a,b,null):hg.call(null,a,b,null)}var a=this.Pa,b=this.m,c=K(this.C);return hg.c?hg.c(a,b,c):hg.call(null,a,b,c)};k.D=function(){return this};k.F=function(a,b){return new pg(b,this.Pa,this.m,this.C,this.p)};k.G=function(a,b){return M(b,this)};pg.prototype[Ea]=function(){return uc(this)};
	var hg=function(){function a(a,b,c){if(null==c)for(c=a.length;;)if(b<c){if(null!=a[b])return new pg(null,a,b,null,null);var g=a[b+1];if(t(g)&&(g=g.lb(),t(g)))return new pg(null,a,b+2,g,null);b+=2}else return null;else return new pg(null,a,b,c,null)}function b(a){return c.c(a,0,null)}var c=null,c=function(c,e,f){switch(arguments.length){case 1:return b.call(this,c);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.c=a;return c}();
	function qg(a,b,c,d,e){this.k=a;this.Pa=b;this.m=c;this.C=d;this.p=e;this.q=0;this.j=32374860}k=qg.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return G(this.C)};
	k.S=function(){var a=this.Pa,b=this.m,c=K(this.C);return mg.n?mg.n(null,a,b,c):mg.call(null,null,a,b,c)};k.D=function(){return this};k.F=function(a,b){return new qg(b,this.Pa,this.m,this.C,this.p)};k.G=function(a,b){return M(b,this)};qg.prototype[Ea]=function(){return uc(this)};
	var mg=function(){function a(a,b,c,g){if(null==g)for(g=b.length;;)if(c<g){var h=b[c];if(t(h)&&(h=h.lb(),t(h)))return new qg(a,b,c+1,h,null);c+=1}else return null;else return new qg(a,b,c,g,null)}function b(a){return c.n(null,a,0,null)}var c=null,c=function(c,e,f,g){switch(arguments.length){case 1:return b.call(this,c);case 4:return a.call(this,c,e,f,g)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.n=a;return c}();
	function rg(a,b,c,d,e,f){this.k=a;this.g=b;this.root=c;this.U=d;this.da=e;this.p=f;this.j=16123663;this.q=8196}k=rg.prototype;k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){return null==b?this.U?this.da:c:null==this.root?c:this.root.Oa(0,nc(b),b,c)};k.gb=function(a,b,c){this.U&&(a=this.da,c=b.c?b.c(c,null,a):b.call(null,c,null,a));return Ac(c)?L.b?L.b(c):L.call(null,c):null!=this.root?this.root.Xa(b,c):c};k.H=function(){return this.k};k.L=function(){return this.g};
	k.B=function(){var a=this.p;return null!=a?a:this.p=a=xc(this)};k.A=function(a,b){return Pf(this,b)};k.$a=function(){return new sg({},this.root,this.g,this.U,this.da)};k.J=function(){return ub(Qc,this.k)};k.wb=function(a,b){if(null==b)return this.U?new rg(this.k,this.g-1,this.root,!1,null,null):this;if(null==this.root)return this;var c=this.root.mb(0,nc(b),b);return c===this.root?this:new rg(this.k,this.g-1,c,this.U,this.da,null)};
	k.Ka=function(a,b,c){if(null==b)return this.U&&c===this.da?this:new rg(this.k,this.U?this.g:this.g+1,this.root,!0,c,null);a=new $f;b=(null==this.root?ig:this.root).ka(0,nc(b),b,c,a);return b===this.root?this:new rg(this.k,a.o?this.g+1:this.g,b,this.U,this.da,null)};k.rb=function(a,b){return null==b?this.U:null==this.root?!1:this.root.Oa(0,nc(b),b,jd)!==jd};k.D=function(){if(0<this.g){var a=null!=this.root?this.root.lb():null;return this.U?M(new W(null,2,5,uf,[null,this.da],null),a):a}return null};
	k.F=function(a,b){return new rg(b,this.g,this.root,this.U,this.da,this.p)};k.G=function(a,b){if(ed(b))return cb(this,C.a(b,0),C.a(b,1));for(var c=this,d=D(b);;){if(null==d)return c;var e=G(d);if(ed(e))c=cb(c,C.a(e,0),C.a(e,1)),d=K(d);else throw Error("conj on a map takes map entries or seqables of map entries");}};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};var Qc=new rg(null,0,null,!1,null,0);rg.prototype[Ea]=function(){return uc(this)};
	function sg(a,b,c,d,e){this.u=a;this.root=b;this.count=c;this.U=d;this.da=e;this.q=56;this.j=258}k=sg.prototype;k.Jb=function(a,b){if(this.u)if(null==b)this.U&&(this.U=!1,this.da=null,this.count-=1);else{if(null!=this.root){var c=new $f,d=this.root.nb(this.u,0,nc(b),b,c);d!==this.root&&(this.root=d);t(c[0])&&(this.count-=1)}}else throw Error("dissoc! after persistent!");return this};k.kb=function(a,b,c){return tg(this,b,c)};k.Sa=function(a,b){return ug(this,b)};
	k.Ta=function(){var a;if(this.u)this.u=null,a=new rg(null,this.count,this.root,this.U,this.da,null);else throw Error("persistent! called twice");return a};k.t=function(a,b){return null==b?this.U?this.da:null:null==this.root?null:this.root.Oa(0,nc(b),b)};k.s=function(a,b,c){return null==b?this.U?this.da:c:null==this.root?c:this.root.Oa(0,nc(b),b,c)};k.L=function(){if(this.u)return this.count;throw Error("count after persistent!");};
	function ug(a,b){if(a.u){if(b?b.j&2048||b.jc||(b.j?0:w(fb,b)):w(fb,b))return tg(a,Yf.b?Yf.b(b):Yf.call(null,b),Zf.b?Zf.b(b):Zf.call(null,b));for(var c=D(b),d=a;;){var e=G(c);if(t(e))var f=e,c=K(c),d=tg(d,function(){var a=f;return Yf.b?Yf.b(a):Yf.call(null,a)}(),function(){var a=f;return Zf.b?Zf.b(a):Zf.call(null,a)}());else return d}}else throw Error("conj! after persistent");}
	function tg(a,b,c){if(a.u){if(null==b)a.da!==c&&(a.da=c),a.U||(a.count+=1,a.U=!0);else{var d=new $f;b=(null==a.root?ig:a.root).la(a.u,0,nc(b),b,c,d);b!==a.root&&(a.root=b);d.o&&(a.count+=1)}return a}throw Error("assoc! after persistent!");}function vg(a,b,c){for(var d=b;;)if(null!=a)b=c?a.left:a.right,d=Nc.a(d,a),a=b;else return d}function wg(a,b,c,d,e){this.k=a;this.stack=b;this.pb=c;this.g=d;this.p=e;this.q=0;this.j=32374862}k=wg.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.k};
	k.L=function(){return 0>this.g?Q(K(this))+1:this.g};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return Wc(this.stack)};k.S=function(){var a=G(this.stack),a=vg(this.pb?a.right:a.left,K(this.stack),this.pb);return null!=a?new wg(null,a,this.pb,this.g-1,null):J};k.D=function(){return this};
	k.F=function(a,b){return new wg(b,this.stack,this.pb,this.g,this.p)};k.G=function(a,b){return M(b,this)};wg.prototype[Ea]=function(){return uc(this)};function xg(a,b,c){return new wg(null,vg(a,null,b),b,c,null)}
	function yg(a,b,c,d){return c instanceof X?c.left instanceof X?new X(c.key,c.o,c.left.ua(),new Z(a,b,c.right,d,null),null):c.right instanceof X?new X(c.right.key,c.right.o,new Z(c.key,c.o,c.left,c.right.left,null),new Z(a,b,c.right.right,d,null),null):new Z(a,b,c,d,null):new Z(a,b,c,d,null)}
	function zg(a,b,c,d){return d instanceof X?d.right instanceof X?new X(d.key,d.o,new Z(a,b,c,d.left,null),d.right.ua(),null):d.left instanceof X?new X(d.left.key,d.left.o,new Z(a,b,c,d.left.left,null),new Z(d.key,d.o,d.left.right,d.right,null),null):new Z(a,b,c,d,null):new Z(a,b,c,d,null)}
	function Ag(a,b,c,d){if(c instanceof X)return new X(a,b,c.ua(),d,null);if(d instanceof Z)return zg(a,b,c,d.ob());if(d instanceof X&&d.left instanceof Z)return new X(d.left.key,d.left.o,new Z(a,b,c,d.left.left,null),zg(d.key,d.o,d.left.right,d.right.ob()),null);throw Error("red-black tree invariant violation");}
	var Cg=function Bg(b,c,d){d=null!=b.left?Bg(b.left,c,d):d;if(Ac(d))return L.b?L.b(d):L.call(null,d);var e=b.key,f=b.o;d=c.c?c.c(d,e,f):c.call(null,d,e,f);if(Ac(d))return L.b?L.b(d):L.call(null,d);b=null!=b.right?Bg(b.right,c,d):d;return Ac(b)?L.b?L.b(b):L.call(null,b):b};function Z(a,b,c,d,e){this.key=a;this.o=b;this.left=c;this.right=d;this.p=e;this.q=0;this.j=32402207}k=Z.prototype;k.Mb=function(a){return a.Ob(this)};k.ob=function(){return new X(this.key,this.o,this.left,this.right,null)};
	k.ua=function(){return this};k.Lb=function(a){return a.Nb(this)};k.replace=function(a,b,c,d){return new Z(a,b,c,d,null)};k.Nb=function(a){return new Z(a.key,a.o,this,a.right,null)};k.Ob=function(a){return new Z(a.key,a.o,a.left,this,null)};k.Xa=function(a,b){return Cg(this,a,b)};k.t=function(a,b){return C.c(this,b,null)};k.s=function(a,b,c){return C.c(this,b,c)};k.Q=function(a,b){return 0===b?this.key:1===b?this.o:null};k.$=function(a,b,c){return 0===b?this.key:1===b?this.o:c};
	k.Ua=function(a,b,c){return(new W(null,2,5,uf,[this.key,this.o],null)).Ua(null,b,c)};k.H=function(){return null};k.L=function(){return 2};k.hb=function(){return this.key};k.ib=function(){return this.o};k.La=function(){return this.o};k.Ma=function(){return new W(null,1,5,uf,[this.key],null)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return Mc};k.R=function(a,b){return Cc.a(this,b)};k.O=function(a,b,c){return Cc.c(this,b,c)};
	k.Ka=function(a,b,c){return Rc.c(new W(null,2,5,uf,[this.key,this.o],null),b,c)};k.D=function(){return Ra(Ra(J,this.o),this.key)};k.F=function(a,b){return O(new W(null,2,5,uf,[this.key,this.o],null),b)};k.G=function(a,b){return new W(null,3,5,uf,[this.key,this.o,b],null)};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};Z.prototype[Ea]=function(){return uc(this)};
	function X(a,b,c,d,e){this.key=a;this.o=b;this.left=c;this.right=d;this.p=e;this.q=0;this.j=32402207}k=X.prototype;k.Mb=function(a){return new X(this.key,this.o,this.left,a,null)};k.ob=function(){throw Error("red-black tree invariant violation");};k.ua=function(){return new Z(this.key,this.o,this.left,this.right,null)};k.Lb=function(a){return new X(this.key,this.o,a,this.right,null)};k.replace=function(a,b,c,d){return new X(a,b,c,d,null)};
	k.Nb=function(a){return this.left instanceof X?new X(this.key,this.o,this.left.ua(),new Z(a.key,a.o,this.right,a.right,null),null):this.right instanceof X?new X(this.right.key,this.right.o,new Z(this.key,this.o,this.left,this.right.left,null),new Z(a.key,a.o,this.right.right,a.right,null),null):new Z(a.key,a.o,this,a.right,null)};
	k.Ob=function(a){return this.right instanceof X?new X(this.key,this.o,new Z(a.key,a.o,a.left,this.left,null),this.right.ua(),null):this.left instanceof X?new X(this.left.key,this.left.o,new Z(a.key,a.o,a.left,this.left.left,null),new Z(this.key,this.o,this.left.right,this.right,null),null):new Z(a.key,a.o,a.left,this,null)};k.Xa=function(a,b){return Cg(this,a,b)};k.t=function(a,b){return C.c(this,b,null)};k.s=function(a,b,c){return C.c(this,b,c)};
	k.Q=function(a,b){return 0===b?this.key:1===b?this.o:null};k.$=function(a,b,c){return 0===b?this.key:1===b?this.o:c};k.Ua=function(a,b,c){return(new W(null,2,5,uf,[this.key,this.o],null)).Ua(null,b,c)};k.H=function(){return null};k.L=function(){return 2};k.hb=function(){return this.key};k.ib=function(){return this.o};k.La=function(){return this.o};k.Ma=function(){return new W(null,1,5,uf,[this.key],null)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};
	k.A=function(a,b){return Ic(this,b)};k.J=function(){return Mc};k.R=function(a,b){return Cc.a(this,b)};k.O=function(a,b,c){return Cc.c(this,b,c)};k.Ka=function(a,b,c){return Rc.c(new W(null,2,5,uf,[this.key,this.o],null),b,c)};k.D=function(){return Ra(Ra(J,this.o),this.key)};k.F=function(a,b){return O(new W(null,2,5,uf,[this.key,this.o],null),b)};k.G=function(a,b){return new W(null,3,5,uf,[this.key,this.o,b],null)};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};X.prototype[Ea]=function(){return uc(this)};
	var Eg=function Dg(b,c,d,e,f){if(null==c)return new X(d,e,null,null,null);var g;g=c.key;g=b.a?b.a(d,g):b.call(null,d,g);if(0===g)return f[0]=c,null;if(0>g)return b=Dg(b,c.left,d,e,f),null!=b?c.Lb(b):null;b=Dg(b,c.right,d,e,f);return null!=b?c.Mb(b):null},Gg=function Fg(b,c){if(null==b)return c;if(null==c)return b;if(b instanceof X){if(c instanceof X){var d=Fg(b.right,c.left);return d instanceof X?new X(d.key,d.o,new X(b.key,b.o,b.left,d.left,null),new X(c.key,c.o,d.right,c.right,null),null):new X(b.key,
	b.o,b.left,new X(c.key,c.o,d,c.right,null),null)}return new X(b.key,b.o,b.left,Fg(b.right,c),null)}if(c instanceof X)return new X(c.key,c.o,Fg(b,c.left),c.right,null);d=Fg(b.right,c.left);return d instanceof X?new X(d.key,d.o,new Z(b.key,b.o,b.left,d.left,null),new Z(c.key,c.o,d.right,c.right,null),null):Ag(b.key,b.o,b.left,new Z(c.key,c.o,d,c.right,null))},Ig=function Hg(b,c,d,e){if(null!=c){var f;f=c.key;f=b.a?b.a(d,f):b.call(null,d,f);if(0===f)return e[0]=c,Gg(c.left,c.right);if(0>f)return b=Hg(b,
	c.left,d,e),null!=b||null!=e[0]?c.left instanceof Z?Ag(c.key,c.o,b,c.right):new X(c.key,c.o,b,c.right,null):null;b=Hg(b,c.right,d,e);if(null!=b||null!=e[0])if(c.right instanceof Z)if(e=c.key,d=c.o,c=c.left,b instanceof X)c=new X(e,d,c,b.ua(),null);else if(c instanceof Z)c=yg(e,d,c.ob(),b);else if(c instanceof X&&c.right instanceof Z)c=new X(c.right.key,c.right.o,yg(c.key,c.o,c.left.ob(),c.right.left),new Z(e,d,c.right.right,b,null),null);else throw Error("red-black tree invariant violation");else c=
	new X(c.key,c.o,c.left,b,null);else c=null;return c}return null},Kg=function Jg(b,c,d,e){var f=c.key,g=b.a?b.a(d,f):b.call(null,d,f);return 0===g?c.replace(f,e,c.left,c.right):0>g?c.replace(f,c.o,Jg(b,c.left,d,e),c.right):c.replace(f,c.o,c.left,Jg(b,c.right,d,e))};function Lg(a,b,c,d,e){this.aa=a;this.na=b;this.g=c;this.k=d;this.p=e;this.j=418776847;this.q=8192}k=Lg.prototype;k.toString=function(){return ec(this)};
	function Mg(a,b){for(var c=a.na;;)if(null!=c){var d;d=c.key;d=a.aa.a?a.aa.a(b,d):a.aa.call(null,b,d);if(0===d)return c;c=0>d?c.left:c.right}else return null}k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){a=Mg(this,b);return null!=a?a.o:c};k.gb=function(a,b,c){return null!=this.na?Cg(this.na,b,c):c};k.H=function(){return this.k};k.L=function(){return this.g};k.ab=function(){return 0<this.g?xg(this.na,!1,this.g):null};k.B=function(){var a=this.p;return null!=a?a:this.p=a=xc(this)};
	k.A=function(a,b){return Pf(this,b)};k.J=function(){return new Lg(this.aa,null,0,this.k,0)};k.wb=function(a,b){var c=[null],d=Ig(this.aa,this.na,b,c);return null==d?null==R.a(c,0)?this:new Lg(this.aa,null,0,this.k,null):new Lg(this.aa,d.ua(),this.g-1,this.k,null)};k.Ka=function(a,b,c){a=[null];var d=Eg(this.aa,this.na,b,c,a);return null==d?(a=R.a(a,0),sc.a(c,a.o)?this:new Lg(this.aa,Kg(this.aa,this.na,b,c),this.g,this.k,null)):new Lg(this.aa,d.ua(),this.g+1,this.k,null)};
	k.rb=function(a,b){return null!=Mg(this,b)};k.D=function(){return 0<this.g?xg(this.na,!0,this.g):null};k.F=function(a,b){return new Lg(this.aa,this.na,this.g,b,this.p)};k.G=function(a,b){if(ed(b))return cb(this,C.a(b,0),C.a(b,1));for(var c=this,d=D(b);;){if(null==d)return c;var e=G(d);if(ed(e))c=cb(c,C.a(e,0),C.a(e,1)),d=K(d);else throw Error("conj on a map takes map entries or seqables of map entries");}};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};k.Hb=function(a,b){return 0<this.g?xg(this.na,b,this.g):null};
	k.Ib=function(a,b,c){if(0<this.g){a=null;for(var d=this.na;;)if(null!=d){var e;e=d.key;e=this.aa.a?this.aa.a(b,e):this.aa.call(null,b,e);if(0===e)return new wg(null,Nc.a(a,d),c,-1,null);t(c)?0>e?(a=Nc.a(a,d),d=d.left):d=d.right:0<e?(a=Nc.a(a,d),d=d.right):d=d.left}else return null==a?null:new wg(null,a,c,-1,null)}else return null};k.Gb=function(a,b){return Yf.b?Yf.b(b):Yf.call(null,b)};k.Fb=function(){return this.aa};var Ng=new Lg(od,null,0,null,0);Lg.prototype[Ea]=function(){return uc(this)};
	var Og=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){a=D(a);for(var b=Ob(Qc);;)if(a){var e=K(K(a)),b=ee.c(b,G(a),Lc(a));a=e}else return Qb(b)}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}(),Pg=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,
	d)}function b(a){a:{a=T.a(Ha,a);for(var b=a.length,e=0,f=Ob(Uf);;)if(e<b)var g=e+2,f=Rb(f,a[e],a[e+1]),e=g;else{a=Qb(f);break a}a=void 0}return a}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}(),Qg=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){a=D(a);for(var b=Ng;;)if(a){var e=K(K(a)),b=Rc.c(b,G(a),Lc(a));a=e}else return b}a.i=0;a.f=function(a){a=D(a);
	return b(a)};a.d=b;return a}(),Rg=function(){function a(a,d){var e=null;if(1<arguments.length){for(var e=0,f=Array(arguments.length-1);e<f.length;)f[e]=arguments[e+1],++e;e=new F(f,0)}return b.call(this,a,e)}function b(a,b){for(var e=D(b),f=new Lg(qd(a),null,0,null,0);;)if(e)var g=K(K(e)),f=Rc.c(f,G(e),Lc(e)),e=g;else return f}a.i=1;a.f=function(a){var d=G(a);a=H(a);return b(d,a)};a.d=b;return a}();function Sg(a,b){this.Y=a;this.Z=b;this.q=0;this.j=32374988}k=Sg.prototype;k.toString=function(){return ec(this)};
	k.H=function(){return this.Z};k.T=function(){var a=this.Y,a=(a?a.j&128||a.xb||(a.j?0:w(Xa,a)):w(Xa,a))?this.Y.T(null):K(this.Y);return null==a?null:new Sg(a,this.Z)};k.B=function(){return wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.Z)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return this.Y.N(null).hb(null)};
	k.S=function(){var a=this.Y,a=(a?a.j&128||a.xb||(a.j?0:w(Xa,a)):w(Xa,a))?this.Y.T(null):K(this.Y);return null!=a?new Sg(a,this.Z):J};k.D=function(){return this};k.F=function(a,b){return new Sg(this.Y,b)};k.G=function(a,b){return M(b,this)};Sg.prototype[Ea]=function(){return uc(this)};function Tg(a){return(a=D(a))?new Sg(a,null):null}function Yf(a){return hb(a)}function Ug(a,b){this.Y=a;this.Z=b;this.q=0;this.j=32374988}k=Ug.prototype;k.toString=function(){return ec(this)};k.H=function(){return this.Z};
	k.T=function(){var a=this.Y,a=(a?a.j&128||a.xb||(a.j?0:w(Xa,a)):w(Xa,a))?this.Y.T(null):K(this.Y);return null==a?null:new Ug(a,this.Z)};k.B=function(){return wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.Z)};k.R=function(a,b){return P.a(b,this)};k.O=function(a,b,c){return P.c(b,c,this)};k.N=function(){return this.Y.N(null).ib(null)};k.S=function(){var a=this.Y,a=(a?a.j&128||a.xb||(a.j?0:w(Xa,a)):w(Xa,a))?this.Y.T(null):K(this.Y);return null!=a?new Ug(a,this.Z):J};
	k.D=function(){return this};k.F=function(a,b){return new Ug(this.Y,b)};k.G=function(a,b){return M(b,this)};Ug.prototype[Ea]=function(){return uc(this)};function Vg(a){return(a=D(a))?new Ug(a,null):null}function Zf(a){return ib(a)}
	var Wg=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){return t(Fe(ud,a))?A.a(function(a,b){return Nc.a(t(a)?a:Uf,b)},a):null}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}(),Xg=function(){function a(a,d){var e=null;if(1<arguments.length){for(var e=0,f=Array(arguments.length-1);e<f.length;)f[e]=arguments[e+1],++e;e=new F(f,0)}return b.call(this,a,e)}function b(a,
	b){return t(Fe(ud,b))?A.a(function(a){return function(b,c){return A.c(a,t(b)?b:Uf,D(c))}}(function(b,d){var g=G(d),h=Lc(d);return nd(b,g)?Rc.c(b,g,function(){var d=S.a(b,g);return a.a?a.a(d,h):a.call(null,d,h)}()):Rc.c(b,g,h)}),b):null}a.i=1;a.f=function(a){var d=G(a);a=H(a);return b(d,a)};a.d=b;return a}();function Yg(a,b){for(var c=Uf,d=D(b);;)if(d)var e=G(d),f=S.c(a,e,Zg),c=je.a(f,Zg)?Rc.c(c,e,f):c,d=K(d);else return O(c,Vc(a))}
	function $g(a,b,c){this.k=a;this.Wa=b;this.p=c;this.j=15077647;this.q=8196}k=$g.prototype;k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){return bb(this.Wa,b)?b:c};k.H=function(){return this.k};k.L=function(){return Ma(this.Wa)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=xc(this)};k.A=function(a,b){return ad(b)&&Q(this)===Q(b)&&Ee(function(a){return function(b){return nd(a,b)}}(this),b)};k.$a=function(){return new ah(Ob(this.Wa))};
	k.J=function(){return O(bh,this.k)};k.Eb=function(a,b){return new $g(this.k,eb(this.Wa,b),null)};k.D=function(){return Tg(this.Wa)};k.F=function(a,b){return new $g(b,this.Wa,this.p)};k.G=function(a,b){return new $g(this.k,Rc.c(this.Wa,b,null),null)};
	k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};var bh=new $g(null,Uf,0);$g.prototype[Ea]=function(){return uc(this)};
	function ah(a){this.ma=a;this.j=259;this.q=136}k=ah.prototype;k.call=function(){function a(a,b,c){return $a.c(this.ma,b,jd)===jd?c:b}function b(a,b){return $a.c(this.ma,b,jd)===jd?null:b}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+arguments.length);};c.a=b;c.c=a;return c}();k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};
	k.b=function(a){return $a.c(this.ma,a,jd)===jd?null:a};k.a=function(a,b){return $a.c(this.ma,a,jd)===jd?b:a};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){return $a.c(this.ma,b,jd)===jd?c:b};k.L=function(){return Q(this.ma)};k.Tb=function(a,b){this.ma=fe.a(this.ma,b);return this};k.Sa=function(a,b){this.ma=ee.c(this.ma,b,null);return this};k.Ta=function(){return new $g(null,Qb(this.ma),null)};function ch(a,b,c){this.k=a;this.ja=b;this.p=c;this.j=417730831;this.q=8192}k=ch.prototype;
	k.toString=function(){return ec(this)};k.t=function(a,b){return $a.c(this,b,null)};k.s=function(a,b,c){a=Mg(this.ja,b);return null!=a?a.key:c};k.H=function(){return this.k};k.L=function(){return Q(this.ja)};k.ab=function(){return 0<Q(this.ja)?Oe.a(Yf,Gb(this.ja)):null};k.B=function(){var a=this.p;return null!=a?a:this.p=a=xc(this)};k.A=function(a,b){return ad(b)&&Q(this)===Q(b)&&Ee(function(a){return function(b){return nd(a,b)}}(this),b)};k.J=function(){return new ch(this.k,Na(this.ja),0)};
	k.Eb=function(a,b){return new ch(this.k,Sc.a(this.ja,b),null)};k.D=function(){return Tg(this.ja)};k.F=function(a,b){return new ch(b,this.ja,this.p)};k.G=function(a,b){return new ch(this.k,Rc.c(this.ja,b,null),null)};k.call=function(){var a=null,a=function(a,c,d){switch(arguments.length){case 2:return this.t(null,c);case 3:return this.s(null,c,d)}throw Error("Invalid arity: "+arguments.length);};a.a=function(a,c){return this.t(null,c)};a.c=function(a,c,d){return this.s(null,c,d)};return a}();
	k.apply=function(a,b){return this.call.apply(this,[this].concat(Fa(b)))};k.b=function(a){return this.t(null,a)};k.a=function(a,b){return this.s(null,a,b)};k.Hb=function(a,b){return Oe.a(Yf,Hb(this.ja,b))};k.Ib=function(a,b,c){return Oe.a(Yf,Ib(this.ja,b,c))};k.Gb=function(a,b){return b};k.Fb=function(){return Kb(this.ja)};var eh=new ch(null,Ng,0);ch.prototype[Ea]=function(){return uc(this)};
	function fh(a){a=D(a);if(null==a)return bh;if(a instanceof F&&0===a.m){a=a.e;a:{for(var b=0,c=Ob(bh);;)if(b<a.length)var d=b+1,c=c.Sa(null,a[b]),b=d;else{a=c;break a}a=void 0}return a.Ta(null)}for(d=Ob(bh);;)if(null!=a)b=a.T(null),d=d.Sa(null,a.N(null)),a=b;else return d.Ta(null)}
	var gh=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){return A.c(Ra,eh,a)}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}(),hh=function(){function a(a,d){var e=null;if(1<arguments.length){for(var e=0,f=Array(arguments.length-1);e<f.length;)f[e]=arguments[e+1],++e;e=new F(f,0)}return b.call(this,a,e)}function b(a,b){return A.c(Ra,new ch(null,Rg(a),0),b)}
	a.i=1;a.f=function(a){var d=G(a);a=H(a);return b(d,a)};a.d=b;return a}();function Od(a){if(a&&(a.q&4096||a.lc))return a.name;if("string"===typeof a)return a;throw Error([z("Doesn't support name: "),z(a)].join(""));}
	var ih=function(){function a(a,b,c){return(a.b?a.b(b):a.call(null,b))>(a.b?a.b(c):a.call(null,c))?b:c}var b=null,c=function(){function a(b,d,h,l){var m=null;if(3<arguments.length){for(var m=0,p=Array(arguments.length-3);m<p.length;)p[m]=arguments[m+3],++m;m=new F(p,0)}return c.call(this,b,d,h,m)}function c(a,d,e,l){return A.c(function(c,d){return b.c(a,c,d)},b.c(a,d,e),l)}a.i=3;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=K(a);var l=G(a);a=H(a);return c(b,d,l,a)};a.d=c;return a}(),b=function(b,
	e,f,g){switch(arguments.length){case 2:return e;case 3:return a.call(this,b,e,f);default:var h=null;if(3<arguments.length){for(var h=0,l=Array(arguments.length-3);h<l.length;)l[h]=arguments[h+3],++h;h=new F(l,0)}return c.d(b,e,f,h)}throw Error("Invalid arity: "+arguments.length);};b.i=3;b.f=c.f;b.a=function(a,b){return b};b.c=a;b.d=c.d;return b}();function jh(a){this.e=a}jh.prototype.add=function(a){return this.e.push(a)};jh.prototype.size=function(){return this.e.length};
	jh.prototype.clear=function(){return this.e=[]};
	var kh=function(){function a(a,b,c){return new V(null,function(){var h=D(c);return h?M(Pe.a(a,h),d.c(a,b,Qe.a(b,h))):null},null,null)}function b(a,b){return d.c(a,a,b)}function c(a){return function(b){return function(c){return function(){function d(h,l){c.add(l);if(a===c.size()){var m=zf(c.e);c.clear();return b.a?b.a(h,m):b.call(null,h,m)}return h}function l(a){if(!t(0===c.e.length)){var d=zf(c.e);c.clear();a=Bc(b.a?b.a(a,d):b.call(null,a,d))}return b.b?b.b(a):b.call(null,a)}function m(){return b.l?
	b.l():b.call(null)}var p=null,p=function(a,b){switch(arguments.length){case 0:return m.call(this);case 1:return l.call(this,a);case 2:return d.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};p.l=m;p.b=l;p.a=d;return p}()}(new jh([]))}}var d=null,d=function(d,f,g){switch(arguments.length){case 1:return c.call(this,d);case 2:return b.call(this,d,f);case 3:return a.call(this,d,f,g)}throw Error("Invalid arity: "+arguments.length);};d.b=c;d.a=b;d.c=a;return d}(),lh=function(){function a(a,
	b){return new V(null,function(){var f=D(b);if(f){var g;g=G(f);g=a.b?a.b(g):a.call(null,g);f=t(g)?M(G(f),c.a(a,H(f))):null}else f=null;return f},null,null)}function b(a){return function(b){return function(){function c(f,g){return t(a.b?a.b(g):a.call(null,g))?b.a?b.a(f,g):b.call(null,f,g):new yc(f)}function g(a){return b.b?b.b(a):b.call(null,a)}function h(){return b.l?b.l():b.call(null)}var l=null,l=function(a,b){switch(arguments.length){case 0:return h.call(this);case 1:return g.call(this,a);case 2:return c.call(this,
	a,b)}throw Error("Invalid arity: "+arguments.length);};l.l=h;l.b=g;l.a=c;return l}()}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();function mh(a,b,c){return function(d){var e=Kb(a);d=Jb(a,d);e=e.a?e.a(d,c):e.call(null,d,c);return b.a?b.a(e,0):b.call(null,e,0)}}
	var nh=function(){function a(a,b,c,g,h){var l=Ib(a,c,!0);if(t(l)){var m=R.c(l,0,null);return lh.a(mh(a,g,h),t(mh(a,b,c).call(null,m))?l:K(l))}return null}function b(a,b,c){var g=mh(a,b,c),h;a:{h=[Ad,Bd];var l=h.length;if(l<=Vf)for(var m=0,p=Ob(Uf);;)if(m<l)var q=m+1,p=Rb(p,h[m],null),m=q;else{h=new $g(null,Qb(p),null);break a}else for(m=0,p=Ob(bh);;)if(m<l)q=m+1,p=Pb(p,h[m]),m=q;else{h=Qb(p);break a}h=void 0}return t(h.call(null,b))?(a=Ib(a,c,!0),t(a)?(b=R.c(a,0,null),t(g.b?g.b(b):g.call(null,b))?
	a:K(a)):null):lh.a(g,Hb(a,!0))}var c=null,c=function(c,e,f,g,h){switch(arguments.length){case 3:return b.call(this,c,e,f);case 5:return a.call(this,c,e,f,g,h)}throw Error("Invalid arity: "+arguments.length);};c.c=b;c.r=a;return c}();function oh(a,b,c){this.m=a;this.end=b;this.step=c}oh.prototype.ga=function(){return 0<this.step?this.m<this.end:this.m>this.end};oh.prototype.next=function(){var a=this.m;this.m+=this.step;return a};
	function ph(a,b,c,d,e){this.k=a;this.start=b;this.end=c;this.step=d;this.p=e;this.j=32375006;this.q=8192}k=ph.prototype;k.toString=function(){return ec(this)};k.Q=function(a,b){if(b<Ma(this))return this.start+b*this.step;if(this.start>this.end&&0===this.step)return this.start;throw Error("Index out of bounds");};k.$=function(a,b,c){return b<Ma(this)?this.start+b*this.step:this.start>this.end&&0===this.step?this.start:c};k.vb=!0;k.fb=function(){return new oh(this.start,this.end,this.step)};k.H=function(){return this.k};
	k.T=function(){return 0<this.step?this.start+this.step<this.end?new ph(this.k,this.start+this.step,this.end,this.step,null):null:this.start+this.step>this.end?new ph(this.k,this.start+this.step,this.end,this.step,null):null};k.L=function(){if(Aa(Cb(this)))return 0;var a=(this.end-this.start)/this.step;return Math.ceil.b?Math.ceil.b(a):Math.ceil.call(null,a)};k.B=function(){var a=this.p;return null!=a?a:this.p=a=wc(this)};k.A=function(a,b){return Ic(this,b)};k.J=function(){return O(J,this.k)};
	k.R=function(a,b){return Cc.a(this,b)};k.O=function(a,b,c){for(a=this.start;;)if(0<this.step?a<this.end:a>this.end){var d=a;c=b.a?b.a(c,d):b.call(null,c,d);if(Ac(c))return b=c,L.b?L.b(b):L.call(null,b);a+=this.step}else return c};k.N=function(){return null==Cb(this)?null:this.start};k.S=function(){return null!=Cb(this)?new ph(this.k,this.start+this.step,this.end,this.step,null):J};k.D=function(){return 0<this.step?this.start<this.end?this:null:this.start>this.end?this:null};
	k.F=function(a,b){return new ph(b,this.start,this.end,this.step,this.p)};k.G=function(a,b){return M(b,this)};ph.prototype[Ea]=function(){return uc(this)};
	var qh=function(){function a(a,b,c){return new ph(null,a,b,c,null)}function b(a,b){return e.c(a,b,1)}function c(a){return e.c(0,a,1)}function d(){return e.c(0,Number.MAX_VALUE,1)}var e=null,e=function(e,g,h){switch(arguments.length){case 0:return d.call(this);case 1:return c.call(this,e);case 2:return b.call(this,e,g);case 3:return a.call(this,e,g,h)}throw Error("Invalid arity: "+arguments.length);};e.l=d;e.b=c;e.a=b;e.c=a;return e}(),rh=function(){function a(a,b){return new V(null,function(){var f=
	D(b);return f?M(G(f),c.a(a,Qe.a(a,f))):null},null,null)}function b(a){return function(b){return function(c){return function(){function g(g,h){var l=c.bb(0,c.Ra(null)+1),m=Cd(l,a);return 0===l-a*m?b.a?b.a(g,h):b.call(null,g,h):g}function h(a){return b.b?b.b(a):b.call(null,a)}function l(){return b.l?b.l():b.call(null)}var m=null,m=function(a,b){switch(arguments.length){case 0:return l.call(this);case 1:return h.call(this,a);case 2:return g.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);
	};m.l=l;m.b=h;m.a=g;return m}()}(new Me(-1))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),th=function(){function a(a,b){return new V(null,function(){var f=D(b);if(f){var g=G(f),h=a.b?a.b(g):a.call(null,g),g=M(g,lh.a(function(b,c){return function(b){return sc.a(c,a.b?a.b(b):a.call(null,b))}}(g,h,f,f),K(f)));return M(g,c.a(a,D(Qe.a(Q(g),f))))}return null},null,
	null)}function b(a){return function(b){return function(c,g){return function(){function h(h,l){var m=L.b?L.b(g):L.call(null,g),p=a.b?a.b(l):a.call(null,l);ac(g,p);if(Nd(m,sh)||sc.a(p,m))return c.add(l),h;m=zf(c.e);c.clear();m=b.a?b.a(h,m):b.call(null,h,m);Ac(m)||c.add(l);return m}function l(a){if(!t(0===c.e.length)){var d=zf(c.e);c.clear();a=Bc(b.a?b.a(a,d):b.call(null,a,d))}return b.b?b.b(a):b.call(null,a)}function m(){return b.l?b.l():b.call(null)}var p=null,p=function(a,b){switch(arguments.length){case 0:return m.call(this);
	case 1:return l.call(this,a);case 2:return h.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};p.l=m;p.b=l;p.a=h;return p}()}(new jh([]),new Me(sh))}}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),uh=function(){function a(a,b){for(;;)if(D(b)&&0<a){var c=a-1,g=K(b);a=c;b=g}else return null}function b(a){for(;;)if(D(a))a=K(a);else return null}var c=
	null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}(),vh=function(){function a(a,b){uh.a(a,b);return b}function b(a){uh.b(a);return a}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}();
	function wh(a,b,c,d,e,f,g){var h=ma;try{ma=null==ma?null:ma-1;if(null!=ma&&0>ma)return Lb(a,"#");Lb(a,c);if(D(g)){var l=G(g);b.c?b.c(l,a,f):b.call(null,l,a,f)}for(var m=K(g),p=za.b(f)-1;;)if(!m||null!=p&&0===p){D(m)&&0===p&&(Lb(a,d),Lb(a,"..."));break}else{Lb(a,d);var q=G(m);c=a;g=f;b.c?b.c(q,c,g):b.call(null,q,c,g);var s=K(m);c=p-1;m=s;p=c}return Lb(a,e)}finally{ma=h}}
	var xh=function(){function a(a,d){var e=null;if(1<arguments.length){for(var e=0,f=Array(arguments.length-1);e<f.length;)f[e]=arguments[e+1],++e;e=new F(f,0)}return b.call(this,a,e)}function b(a,b){for(var e=D(b),f=null,g=0,h=0;;)if(h<g){var l=f.Q(null,h);Lb(a,l);h+=1}else if(e=D(e))f=e,fd(f)?(e=Yb(f),g=Zb(f),f=e,l=Q(e),e=g,g=l):(l=G(f),Lb(a,l),e=K(f),f=null,g=0),h=0;else return null}a.i=1;a.f=function(a){var d=G(a);a=H(a);return b(d,a)};a.d=b;return a}(),yh={'"':'\\"',"\\":"\\\\","\b":"\\b","\f":"\\f",
	"\n":"\\n","\r":"\\r","\t":"\\t"};function zh(a){return[z('"'),z(a.replace(RegExp('[\\\\"\b\f\n\r\t]',"g"),function(a){return yh[a]})),z('"')].join("")}
	var $=function Ah(b,c,d){if(null==b)return Lb(c,"nil");if(void 0===b)return Lb(c,"#\x3cundefined\x3e");t(function(){var c=S.a(d,wa);return t(c)?(c=b?b.j&131072||b.kc?!0:b.j?!1:w(rb,b):w(rb,b))?Vc(b):c:c}())&&(Lb(c,"^"),Ah(Vc(b),c,d),Lb(c," "));if(null==b)return Lb(c,"nil");if(b.Yb)return b.nc(c);if(b&&(b.j&2147483648||b.I))return b.v(null,c,d);if(Ba(b)===Boolean||"number"===typeof b)return Lb(c,""+z(b));if(null!=b&&b.constructor===Object){Lb(c,"#js ");var e=Oe.a(function(c){return new W(null,2,5,
	uf,[Pd.b(c),b[c]],null)},gd(b));return Bh.n?Bh.n(e,Ah,c,d):Bh.call(null,e,Ah,c,d)}return b instanceof Array?wh(c,Ah,"#js ["," ","]",d,b):t("string"==typeof b)?t(ua.b(d))?Lb(c,zh(b)):Lb(c,b):Tc(b)?xh.d(c,Kc(["#\x3c",""+z(b),"\x3e"],0)):b instanceof Date?(e=function(b,c){for(var d=""+z(b);;)if(Q(d)<c)d=[z("0"),z(d)].join("");else return d},xh.d(c,Kc(['#inst "',""+z(b.getUTCFullYear()),"-",e(b.getUTCMonth()+1,2),"-",e(b.getUTCDate(),2),"T",e(b.getUTCHours(),2),":",e(b.getUTCMinutes(),2),":",e(b.getUTCSeconds(),
	2),".",e(b.getUTCMilliseconds(),3),"-",'00:00"'],0))):b instanceof RegExp?xh.d(c,Kc(['#"',b.source,'"'],0)):(b?b.j&2147483648||b.I||(b.j?0:w(Mb,b)):w(Mb,b))?Nb(b,c,d):xh.d(c,Kc(["#\x3c",""+z(b),"\x3e"],0))},Ch=function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){var b=oa();if(Yc(a))b="";else{var e=z,f=new fa;a:{var g=new dc(f);$(G(a),g,b);a=D(K(a));for(var h=null,l=0,
	m=0;;)if(m<l){var p=h.Q(null,m);Lb(g," ");$(p,g,b);m+=1}else if(a=D(a))h=a,fd(h)?(a=Yb(h),l=Zb(h),h=a,p=Q(a),a=l,l=p):(p=G(h),Lb(g," "),$(p,g,b),a=K(h),h=null,l=0),m=0;else break a}b=""+e(f)}return b}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}();function Bh(a,b,c,d){return wh(c,function(a,c,d){var h=hb(a);b.c?b.c(h,c,d):b.call(null,h,c,d);Lb(c," ");a=ib(a);return b.c?b.c(a,c,d):b.call(null,a,c,d)},"{",", ","}",d,D(a))}Me.prototype.I=!0;
	Me.prototype.v=function(a,b,c){Lb(b,"#\x3cVolatile: ");$(this.state,b,c);return Lb(b,"\x3e")};F.prototype.I=!0;F.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};V.prototype.I=!0;V.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};wg.prototype.I=!0;wg.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};pg.prototype.I=!0;pg.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Z.prototype.I=!0;
	Z.prototype.v=function(a,b,c){return wh(b,$,"["," ","]",c,this)};Rf.prototype.I=!0;Rf.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};ch.prototype.I=!0;ch.prototype.v=function(a,b,c){return wh(b,$,"#{"," ","}",c,this)};Bf.prototype.I=!0;Bf.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Ld.prototype.I=!0;Ld.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Hc.prototype.I=!0;Hc.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};
	rg.prototype.I=!0;rg.prototype.v=function(a,b,c){return Bh(this,$,b,c)};qg.prototype.I=!0;qg.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Df.prototype.I=!0;Df.prototype.v=function(a,b,c){return wh(b,$,"["," ","]",c,this)};Lg.prototype.I=!0;Lg.prototype.v=function(a,b,c){return Bh(this,$,b,c)};$g.prototype.I=!0;$g.prototype.v=function(a,b,c){return wh(b,$,"#{"," ","}",c,this)};Vd.prototype.I=!0;Vd.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Ug.prototype.I=!0;
	Ug.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};X.prototype.I=!0;X.prototype.v=function(a,b,c){return wh(b,$,"["," ","]",c,this)};W.prototype.I=!0;W.prototype.v=function(a,b,c){return wh(b,$,"["," ","]",c,this)};Kf.prototype.I=!0;Kf.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Hd.prototype.I=!0;Hd.prototype.v=function(a,b){return Lb(b,"()")};ze.prototype.I=!0;ze.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Lf.prototype.I=!0;
	Lf.prototype.v=function(a,b,c){return wh(b,$,"#queue ["," ","]",c,D(this))};pa.prototype.I=!0;pa.prototype.v=function(a,b,c){return Bh(this,$,b,c)};ph.prototype.I=!0;ph.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Sg.prototype.I=!0;Sg.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Fd.prototype.I=!0;Fd.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};W.prototype.sb=!0;W.prototype.tb=function(a,b){return pd.a(this,b)};Df.prototype.sb=!0;
	Df.prototype.tb=function(a,b){return pd.a(this,b)};U.prototype.sb=!0;U.prototype.tb=function(a,b){return Md(this,b)};qc.prototype.sb=!0;qc.prototype.tb=function(a,b){return pc(this,b)};var Dh=function(){function a(a,d,e){var f=null;if(2<arguments.length){for(var f=0,g=Array(arguments.length-2);f<g.length;)g[f]=arguments[f+2],++f;f=new F(g,0)}return b.call(this,a,d,f)}function b(a,b,e){return a.k=T.c(b,a.k,e)}a.i=2;a.f=function(a){var d=G(a);a=K(a);var e=G(a);a=H(a);return b(d,e,a)};a.d=b;return a}();
	function Eh(a){return function(b,c){var d=a.a?a.a(b,c):a.call(null,b,c);return Ac(d)?new yc(d):d}}
	function Ve(a){return function(b){return function(){function c(a,c){return A.c(b,a,c)}function d(b){return a.b?a.b(b):a.call(null,b)}function e(){return a.l?a.l():a.call(null)}var f=null,f=function(a,b){switch(arguments.length){case 0:return e.call(this);case 1:return d.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);};f.l=e;f.b=d;f.a=c;return f}()}(Eh(a))}
	var Fh=function(){function a(a){return Ce.a(c.l(),a)}function b(){return function(a){return function(b){return function(){function c(f,g){var h=L.b?L.b(b):L.call(null,b);ac(b,g);return sc.a(h,g)?f:a.a?a.a(f,g):a.call(null,f,g)}function g(b){return a.b?a.b(b):a.call(null,b)}function h(){return a.l?a.l():a.call(null)}var l=null,l=function(a,b){switch(arguments.length){case 0:return h.call(this);case 1:return g.call(this,a);case 2:return c.call(this,a,b)}throw Error("Invalid arity: "+arguments.length);
	};l.l=h;l.b=g;l.a=c;return l}()}(new Me(sh))}}var c=null,c=function(c){switch(arguments.length){case 0:return b.call(this);case 1:return a.call(this,c)}throw Error("Invalid arity: "+arguments.length);};c.l=b;c.b=a;return c}();function Gh(a,b){this.fa=a;this.Zb=b;this.q=0;this.j=2173173760}Gh.prototype.v=function(a,b,c){return wh(b,$,"("," ",")",c,this)};Gh.prototype.O=function(a,b,c){return wd.n(this.fa,b,c,this.Zb)};Gh.prototype.D=function(){return D(Ce.a(this.fa,this.Zb))};Gh.prototype[Ea]=function(){return uc(this)};
	var Hh={};function Ih(a){if(a?a.gc:a)return a.gc(a);var b;b=Ih[n(null==a?null:a)];if(!b&&(b=Ih._,!b))throw x("IEncodeJS.-clj-\x3ejs",a);return b.call(null,a)}function Jh(a){return(a?t(t(null)?null:a.fc)||(a.yb?0:w(Hh,a)):w(Hh,a))?Ih(a):"string"===typeof a||"number"===typeof a||a instanceof U||a instanceof qc?Kh.b?Kh.b(a):Kh.call(null,a):Ch.d(Kc([a],0))}
	var Kh=function Lh(b){if(null==b)return null;if(b?t(t(null)?null:b.fc)||(b.yb?0:w(Hh,b)):w(Hh,b))return Ih(b);if(b instanceof U)return Od(b);if(b instanceof qc)return""+z(b);if(dd(b)){var c={};b=D(b);for(var d=null,e=0,f=0;;)if(f<e){var g=d.Q(null,f),h=R.c(g,0,null),g=R.c(g,1,null);c[Jh(h)]=Lh(g);f+=1}else if(b=D(b))fd(b)?(e=Yb(b),b=Zb(b),d=e,e=Q(e)):(e=G(b),d=R.c(e,0,null),e=R.c(e,1,null),c[Jh(d)]=Lh(e),b=K(b),d=null,e=0),f=0;else break;return c}if($c(b)){c=[];b=D(Oe.a(Lh,b));d=null;for(f=e=0;;)if(f<
	e)h=d.Q(null,f),c.push(h),f+=1;else if(b=D(b))d=b,fd(d)?(b=Yb(d),f=Zb(d),d=b,e=Q(b),b=f):(b=G(d),c.push(b),b=K(d),d=null,e=0),f=0;else break;return c}return b},Mh={};function Nh(a,b){if(a?a.ec:a)return a.ec(a,b);var c;c=Nh[n(null==a?null:a)];if(!c&&(c=Nh._,!c))throw x("IEncodeClojure.-js-\x3eclj",a);return c.call(null,a,b)}
	var Ph=function(){function a(a){return b.d(a,Kc([new pa(null,1,[Oh,!1],null)],0))}var b=null,c=function(){function a(c,d){var h=null;if(1<arguments.length){for(var h=0,l=Array(arguments.length-1);h<l.length;)l[h]=arguments[h+1],++h;h=new F(l,0)}return b.call(this,c,h)}function b(a,c){var d=kd(c)?T.a(Og,c):c,e=S.a(d,Oh);return function(a,b,d,e){return function v(f){return(f?t(t(null)?null:f.uc)||(f.yb?0:w(Mh,f)):w(Mh,f))?Nh(f,T.a(Pg,c)):kd(f)?vh.b(Oe.a(v,f)):$c(f)?af.a(Oc(f),Oe.a(v,f)):f instanceof
	Array?zf(Oe.a(v,f)):Ba(f)===Object?af.a(Uf,function(){return function(a,b,c,d){return function Pa(e){return new V(null,function(a,b,c,d){return function(){for(;;){var a=D(e);if(a){if(fd(a)){var b=Yb(a),c=Q(b),g=Td(c);return function(){for(var a=0;;)if(a<c){var e=C.a(b,a),h=g,l=uf,m;m=e;m=d.b?d.b(m):d.call(null,m);e=new W(null,2,5,l,[m,v(f[e])],null);h.add(e);a+=1}else return!0}()?Wd(g.ca(),Pa(Zb(a))):Wd(g.ca(),null)}var h=G(a);return M(new W(null,2,5,uf,[function(){var a=h;return d.b?d.b(a):d.call(null,
	a)}(),v(f[h])],null),Pa(H(a)))}return null}}}(a,b,c,d),null,null)}}(a,b,d,e)(gd(f))}()):f}}(c,d,e,t(e)?Pd:z)(a)}a.i=1;a.f=function(a){var c=G(a);a=H(a);return b(c,a)};a.d=b;return a}(),b=function(b,e){switch(arguments.length){case 1:return a.call(this,b);default:var f=null;if(1<arguments.length){for(var f=0,g=Array(arguments.length-1);f<g.length;)g[f]=arguments[f+1],++f;f=new F(g,0)}return c.d(b,f)}throw Error("Invalid arity: "+arguments.length);};b.i=1;b.f=c.f;b.b=a;b.d=c.d;return b}();var wa=new U(null,"meta","meta",1499536964),ya=new U(null,"dup","dup",556298533),sh=new U("cljs.core","none","cljs.core/none",926646439),pe=new U(null,"file","file",-1269645878),le=new U(null,"end-column","end-column",1425389514),sa=new U(null,"flush-on-newline","flush-on-newline",-151457939),ne=new U(null,"column","column",2078222095),ua=new U(null,"readably","readably",1129599760),oe=new U(null,"line","line",212345235),za=new U(null,"print-length","print-length",1931866356),me=new U(null,"end-line",
	"end-line",1837326455),Oh=new U(null,"keywordize-keys","keywordize-keys",1310784252),Zg=new U("cljs.core","not-found","cljs.core/not-found",-1572889185);function Qh(a,b){var c=T.c(ih,a,b);return M(c,Ye.a(function(a){return function(b){return a===b}}(c),b))}
	var Rh=function(){function a(a,b){return Q(a)<Q(b)?A.c(Nc,b,a):A.c(Nc,a,b)}var b=null,c=function(){function a(c,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return b.call(this,c,d,l)}function b(a,c,d){a=Qh(Q,Nc.d(d,c,Kc([a],0)));return A.c(af,G(a),H(a))}a.i=2;a.f=function(a){var c=G(a);a=K(a);var d=G(a);a=H(a);return b(c,d,a)};a.d=b;return a}(),b=function(b,e,f){switch(arguments.length){case 0:return bh;case 1:return b;
	case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.l=function(){return bh};b.b=function(a){return a};b.a=a;b.d=c.d;return b}(),Sh=function(){function a(a,b){for(;;)if(Q(b)<Q(a)){var c=a;a=b;b=c}else return A.c(function(a,b){return function(a,c){return nd(b,c)?a:Xc.a(a,c)}}(a,b),a,a)}var b=null,c=function(){function a(b,
	d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,e){a=Qh(function(a){return-Q(a)},Nc.d(e,d,Kc([a],0)));return A.c(b,G(a),H(a))}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return b;case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-
	2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(a){return a};b.a=a;b.d=c.d;return b}(),Th=function(){function a(a,b){return Q(a)<Q(b)?A.c(function(a,c){return nd(b,c)?Xc.a(a,c):a},a,a):A.c(Xc,a,b)}var b=null,c=function(){function a(b,d,h){var l=null;if(2<arguments.length){for(var l=0,m=Array(arguments.length-2);l<m.length;)m[l]=arguments[l+2],++l;l=new F(m,0)}return c.call(this,b,d,l)}function c(a,d,
	e){return A.c(b,a,Nc.a(e,d))}a.i=2;a.f=function(a){var b=G(a);a=K(a);var d=G(a);a=H(a);return c(b,d,a)};a.d=c;return a}(),b=function(b,e,f){switch(arguments.length){case 1:return b;case 2:return a.call(this,b,e);default:var g=null;if(2<arguments.length){for(var g=0,h=Array(arguments.length-2);g<h.length;)h[g]=arguments[g+2],++g;g=new F(h,0)}return c.d(b,e,g)}throw Error("Invalid arity: "+arguments.length);};b.i=2;b.f=c.f;b.b=function(a){return a};b.a=a;b.d=c.d;return b}();
	function Uh(a,b){return A.c(function(b,d){var e=R.c(d,0,null),f=R.c(d,1,null);return nd(a,e)?Rc.c(b,f,S.a(a,e)):b},T.c(Sc,a,Tg(b)),b)}function Vh(a,b){return A.c(function(a,d){var e=Yg(d,b);return Rc.c(a,e,Nc.a(S.c(a,e,bh),d))},Uf,a)}function Wh(a){return A.c(function(a,c){var d=R.c(c,0,null),e=R.c(c,1,null);return Rc.c(a,e,d)},Uf,a)}
	var Xh=function(){function a(a,b,c){a=Q(a)<=Q(b)?new W(null,3,5,uf,[a,b,Wh(c)],null):new W(null,3,5,uf,[b,a,c],null);b=R.c(a,0,null);c=R.c(a,1,null);var g=R.c(a,2,null),h=Vh(b,Vg(g));return A.c(function(a,b,c,d,e){return function(f,g){var h=function(){var a=Uh(Yg(g,Tg(d)),d);return e.b?e.b(a):e.call(null,a)}();return t(h)?A.c(function(){return function(a,b){return Nc.a(a,Wg.d(Kc([b,g],0)))}}(h,a,b,c,d,e),f,h):f}}(a,b,c,g,h),bh,c)}function b(a,b){if(D(a)&&D(b)){var c=Sh.a(fh(Tg(G(a))),fh(Tg(G(b)))),
	g=Q(a)<=Q(b)?new W(null,2,5,uf,[a,b],null):new W(null,2,5,uf,[b,a],null),h=R.c(g,0,null),l=R.c(g,1,null),m=Vh(h,c);return A.c(function(a,b,c,d,e){return function(f,g){var h=function(){var b=Yg(g,a);return e.b?e.b(b):e.call(null,b)}();return t(h)?A.c(function(){return function(a,b){return Nc.a(a,Wg.d(Kc([b,g],0)))}}(h,a,b,c,d,e),f,h):f}}(c,g,h,l,m),bh,l)}return bh}var c=null,c=function(c,e,f){switch(arguments.length){case 2:return b.call(this,c,e);case 3:return a.call(this,c,e,f)}throw Error("Invalid arity: "+
	arguments.length);};c.a=b;c.c=a;return c}();r("mori.apply",T);r("mori.apply.f2",T.a);r("mori.apply.f3",T.c);r("mori.apply.f4",T.n);r("mori.apply.f5",T.r);r("mori.apply.fn",T.K);r("mori.count",Q);r("mori.distinct",function(a){return function c(a,e){return new V(null,function(){return function(a,d){for(;;){var e=a,l=R.c(e,0,null);if(e=D(e))if(nd(d,l))l=H(e),e=d,a=l,d=e;else return M(l,c(H(e),Nc.a(d,l)));else return null}}.call(null,a,e)},null,null)}(a,bh)});r("mori.empty",Oc);r("mori.first",G);r("mori.second",Lc);r("mori.next",K);
	r("mori.rest",H);r("mori.seq",D);r("mori.conj",Nc);r("mori.conj.f0",Nc.l);r("mori.conj.f1",Nc.b);r("mori.conj.f2",Nc.a);r("mori.conj.fn",Nc.K);r("mori.cons",M);r("mori.find",function(a,b){return null!=a&&bd(a)&&nd(a,b)?new W(null,2,5,uf,[b,S.a(a,b)],null):null});r("mori.nth",R);r("mori.nth.f2",R.a);r("mori.nth.f3",R.c);r("mori.last",function(a){for(;;){var b=K(a);if(null!=b)a=b;else return G(a)}});r("mori.assoc",Rc);r("mori.assoc.f3",Rc.c);r("mori.assoc.fn",Rc.K);r("mori.dissoc",Sc);
	r("mori.dissoc.f1",Sc.b);r("mori.dissoc.f2",Sc.a);r("mori.dissoc.fn",Sc.K);r("mori.getIn",cf);r("mori.getIn.f2",cf.a);r("mori.getIn.f3",cf.c);r("mori.updateIn",df);r("mori.updateIn.f3",df.c);r("mori.updateIn.f4",df.n);r("mori.updateIn.f5",df.r);r("mori.updateIn.f6",df.P);r("mori.updateIn.fn",df.K);r("mori.assocIn",function Yh(b,c,d){var e=R.c(c,0,null);return(c=Ed(c))?Rc.c(b,e,Yh(S.a(b,e),c,d)):Rc.c(b,e,d)});r("mori.fnil",Ke);r("mori.fnil.f2",Ke.a);r("mori.fnil.f3",Ke.c);r("mori.fnil.f4",Ke.n);
	r("mori.disj",Xc);r("mori.disj.f1",Xc.b);r("mori.disj.f2",Xc.a);r("mori.disj.fn",Xc.K);r("mori.pop",function(a){return null==a?null:mb(a)});r("mori.peek",Wc);r("mori.hash",nc);r("mori.get",S);r("mori.get.f2",S.a);r("mori.get.f3",S.c);r("mori.hasKey",nd);r("mori.isEmpty",Yc);r("mori.reverse",Jd);r("mori.take",Pe);r("mori.take.f1",Pe.b);r("mori.take.f2",Pe.a);r("mori.drop",Qe);r("mori.drop.f1",Qe.b);r("mori.drop.f2",Qe.a);r("mori.takeNth",rh);r("mori.takeNth.f1",rh.b);r("mori.takeNth.f2",rh.a);
	r("mori.partition",bf);r("mori.partition.f2",bf.a);r("mori.partition.f3",bf.c);r("mori.partition.f4",bf.n);r("mori.partitionAll",kh);r("mori.partitionAll.f1",kh.b);r("mori.partitionAll.f2",kh.a);r("mori.partitionAll.f3",kh.c);r("mori.partitionBy",th);r("mori.partitionBy.f1",th.b);r("mori.partitionBy.f2",th.a);r("mori.iterate",function Zh(b,c){return M(c,new V(null,function(){return Zh(b,b.b?b.b(c):b.call(null,c))},null,null))});r("mori.into",af);r("mori.into.f2",af.a);r("mori.into.f3",af.c);
	r("mori.merge",Wg);r("mori.mergeWith",Xg);r("mori.subvec",Cf);r("mori.subvec.f2",Cf.a);r("mori.subvec.f3",Cf.c);r("mori.takeWhile",lh);r("mori.takeWhile.f1",lh.b);r("mori.takeWhile.f2",lh.a);r("mori.dropWhile",Re);r("mori.dropWhile.f1",Re.b);r("mori.dropWhile.f2",Re.a);r("mori.groupBy",function(a,b){return ce(A.c(function(b,d){var e=a.b?a.b(d):a.call(null,d);return ee.c(b,e,Nc.a(S.c(b,e,Mc),d))},Ob(Uf),b))});r("mori.interpose",function(a,b){return Qe.a(1,Ue.a(Se.b(a),b))});r("mori.interleave",Ue);
	r("mori.interleave.f2",Ue.a);r("mori.interleave.fn",Ue.K);r("mori.concat",ae);r("mori.concat.f0",ae.l);r("mori.concat.f1",ae.b);r("mori.concat.f2",ae.a);r("mori.concat.fn",ae.K);function $e(a){return a instanceof Array||cd(a)}r("mori.flatten",function(a){return Xe.a(function(a){return!$e(a)},H(Ze(a)))});r("mori.lazySeq",function(a){return new V(null,a,null,null)});r("mori.keys",Tg);r("mori.selectKeys",Yg);r("mori.vals",Vg);r("mori.primSeq",Jc);r("mori.primSeq.f1",Jc.b);r("mori.primSeq.f2",Jc.a);
	r("mori.map",Oe);r("mori.map.f1",Oe.b);r("mori.map.f2",Oe.a);r("mori.map.f3",Oe.c);r("mori.map.f4",Oe.n);r("mori.map.fn",Oe.K);
	r("mori.mapIndexed",function(a,b){return function d(b,f){return new V(null,function(){var g=D(f);if(g){if(fd(g)){for(var h=Yb(g),l=Q(h),m=Td(l),p=0;;)if(p<l)Xd(m,function(){var d=b+p,f=C.a(h,p);return a.a?a.a(d,f):a.call(null,d,f)}()),p+=1;else break;return Wd(m.ca(),d(b+l,Zb(g)))}return M(function(){var d=G(g);return a.a?a.a(b,d):a.call(null,b,d)}(),d(b+1,H(g)))}return null},null,null)}(0,b)});r("mori.mapcat",We);r("mori.mapcat.f1",We.b);r("mori.mapcat.fn",We.K);r("mori.reduce",A);
	r("mori.reduce.f2",A.a);r("mori.reduce.f3",A.c);r("mori.reduceKV",function(a,b,c){return null!=c?xb(c,a,b):b});r("mori.keep",Le);r("mori.keep.f1",Le.b);r("mori.keep.f2",Le.a);r("mori.keepIndexed",Ne);r("mori.keepIndexed.f1",Ne.b);r("mori.keepIndexed.f2",Ne.a);r("mori.filter",Xe);r("mori.filter.f1",Xe.b);r("mori.filter.f2",Xe.a);r("mori.remove",Ye);r("mori.remove.f1",Ye.b);r("mori.remove.f2",Ye.a);r("mori.some",Fe);r("mori.every",Ee);r("mori.equals",sc);r("mori.equals.f1",sc.b);
	r("mori.equals.f2",sc.a);r("mori.equals.fn",sc.K);r("mori.range",qh);r("mori.range.f0",qh.l);r("mori.range.f1",qh.b);r("mori.range.f2",qh.a);r("mori.range.f3",qh.c);r("mori.repeat",Se);r("mori.repeat.f1",Se.b);r("mori.repeat.f2",Se.a);r("mori.repeatedly",Te);r("mori.repeatedly.f1",Te.b);r("mori.repeatedly.f2",Te.a);r("mori.sort",sd);r("mori.sort.f1",sd.b);r("mori.sort.f2",sd.a);r("mori.sortBy",td);r("mori.sortBy.f2",td.a);r("mori.sortBy.f3",td.c);r("mori.intoArray",Ia);r("mori.intoArray.f1",Ia.b);
	r("mori.intoArray.f2",Ia.a);r("mori.subseq",nh);r("mori.subseq.f3",nh.c);r("mori.subseq.f5",nh.r);r("mori.dedupe",Fh);r("mori.dedupe.f0",Fh.l);r("mori.dedupe.f1",Fh.b);r("mori.transduce",wd);r("mori.transduce.f3",wd.c);r("mori.transduce.f4",wd.n);r("mori.eduction",function(a,b){return new Gh(a,b)});r("mori.sequence",Ce);r("mori.sequence.f1",Ce.b);r("mori.sequence.f2",Ce.a);r("mori.sequence.fn",Ce.K);r("mori.completing",vd);r("mori.completing.f1",vd.b);r("mori.completing.f2",vd.a);r("mori.list",Kd);
	r("mori.vector",Af);r("mori.hashMap",Pg);r("mori.set",fh);r("mori.sortedSet",gh);r("mori.sortedSetBy",hh);r("mori.sortedMap",Qg);r("mori.sortedMapBy",Rg);r("mori.queue",function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){return af.a?af.a(Mf,a):af.call(null,Mf,a)}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}());r("mori.keyword",Pd);r("mori.keyword.f1",Pd.b);
	r("mori.keyword.f2",Pd.a);r("mori.symbol",rc);r("mori.symbol.f1",rc.b);r("mori.symbol.f2",rc.a);r("mori.zipmap",function(a,b){for(var c=Ob(Uf),d=D(a),e=D(b);;)if(d&&e)c=ee.c(c,G(d),G(e)),d=K(d),e=K(e);else return Qb(c)});r("mori.isList",function(a){return a?a.j&33554432||a.wc?!0:a.j?!1:w(Eb,a):w(Eb,a)});r("mori.isSeq",kd);r("mori.isVector",ed);r("mori.isMap",dd);r("mori.isSet",ad);r("mori.isKeyword",function(a){return a instanceof U});r("mori.isSymbol",function(a){return a instanceof qc});
	r("mori.isCollection",$c);r("mori.isSequential",cd);r("mori.isAssociative",bd);r("mori.isCounted",Ec);r("mori.isIndexed",Fc);r("mori.isReduceable",function(a){return a?a.j&524288||a.Sb?!0:a.j?!1:w(vb,a):w(vb,a)});r("mori.isSeqable",ld);r("mori.isReversible",Id);r("mori.union",Rh);r("mori.union.f0",Rh.l);r("mori.union.f1",Rh.b);r("mori.union.f2",Rh.a);r("mori.union.fn",Rh.K);r("mori.intersection",Sh);r("mori.intersection.f1",Sh.b);r("mori.intersection.f2",Sh.a);r("mori.intersection.fn",Sh.K);
	r("mori.difference",Th);r("mori.difference.f1",Th.b);r("mori.difference.f2",Th.a);r("mori.difference.fn",Th.K);r("mori.join",Xh);r("mori.join.f2",Xh.a);r("mori.join.f3",Xh.c);r("mori.index",Vh);r("mori.project",function(a,b){return fh(Oe.a(function(a){return Yg(a,b)},a))});r("mori.mapInvert",Wh);r("mori.rename",function(a,b){return fh(Oe.a(function(a){return Uh(a,b)},a))});r("mori.renameKeys",Uh);r("mori.isSubset",function(a,b){return Q(a)<=Q(b)&&Ee(function(a){return nd(b,a)},a)});
	r("mori.isSuperset",function(a,b){return Q(a)>=Q(b)&&Ee(function(b){return nd(a,b)},b)});r("mori.notEquals",je);r("mori.notEquals.f1",je.b);r("mori.notEquals.f2",je.a);r("mori.notEquals.fn",je.K);r("mori.gt",Ad);r("mori.gt.f1",Ad.b);r("mori.gt.f2",Ad.a);r("mori.gt.fn",Ad.K);r("mori.gte",Bd);r("mori.gte.f1",Bd.b);r("mori.gte.f2",Bd.a);r("mori.gte.fn",Bd.K);r("mori.lt",yd);r("mori.lt.f1",yd.b);r("mori.lt.f2",yd.a);r("mori.lt.fn",yd.K);r("mori.lte",zd);r("mori.lte.f1",zd.b);r("mori.lte.f2",zd.a);
	r("mori.lte.fn",zd.K);r("mori.compare",od);r("mori.partial",Je);r("mori.partial.f1",Je.b);r("mori.partial.f2",Je.a);r("mori.partial.f3",Je.c);r("mori.partial.f4",Je.n);r("mori.partial.fn",Je.K);r("mori.comp",Ie);r("mori.comp.f0",Ie.l);r("mori.comp.f1",Ie.b);r("mori.comp.f2",Ie.a);r("mori.comp.f3",Ie.c);r("mori.comp.fn",Ie.K);
	r("mori.pipeline",function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){function b(a,c){return c.b?c.b(a):c.call(null,a)}return A.a?A.a(b,a):A.call(null,b,a)}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}());
	r("mori.curry",function(){function a(a,d){var e=null;if(1<arguments.length){for(var e=0,f=Array(arguments.length-1);e<f.length;)f[e]=arguments[e+1],++e;e=new F(f,0)}return b.call(this,a,e)}function b(a,b){return function(e){return T.a(a,M.a?M.a(e,b):M.call(null,e,b))}}a.i=1;a.f=function(a){var d=G(a);a=H(a);return b(d,a)};a.d=b;return a}());
	r("mori.juxt",function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){return function(){function b(a){var c=null;if(0<arguments.length){for(var c=0,d=Array(arguments.length-0);c<d.length;)d[c]=arguments[c+0],++c;c=new F(d,0)}return e.call(this,c)}function e(b){var d=function(){function d(a){return T.a(a,b)}return Oe.a?Oe.a(d,a):Oe.call(null,d,a)}();return Ia.b?Ia.b(d):Ia.call(null,
	d)}b.i=0;b.f=function(a){a=D(a);return e(a)};b.d=e;return b}()}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}());
	r("mori.knit",function(){function a(a){var d=null;if(0<arguments.length){for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;d=new F(e,0)}return b.call(this,d)}function b(a){return function(b){var e=function(){function e(a,b){return a.b?a.b(b):a.call(null,b)}return Oe.c?Oe.c(e,a,b):Oe.call(null,e,a,b)}();return Ia.b?Ia.b(e):Ia.call(null,e)}}a.i=0;a.f=function(a){a=D(a);return b(a)};a.d=b;return a}());r("mori.sum",xd);r("mori.sum.f0",xd.l);r("mori.sum.f1",xd.b);
	r("mori.sum.f2",xd.a);r("mori.sum.fn",xd.K);r("mori.inc",function(a){return a+1});r("mori.dec",function(a){return a-1});r("mori.isEven",Ge);r("mori.isOdd",function(a){return!Ge(a)});r("mori.each",function(a,b){for(var c=D(a),d=null,e=0,f=0;;)if(f<e){var g=d.Q(null,f);b.b?b.b(g):b.call(null,g);f+=1}else if(c=D(c))fd(c)?(e=Yb(c),c=Zb(c),d=e,e=Q(e)):(d=g=G(c),b.b?b.b(d):b.call(null,d),c=K(c),d=null,e=0),f=0;else return null});r("mori.identity",ud);
	r("mori.constantly",function(a){return function(){function b(b){if(0<arguments.length)for(var d=0,e=Array(arguments.length-0);d<e.length;)e[d]=arguments[d+0],++d;return a}b.i=0;b.f=function(b){D(b);return a};b.d=function(){return a};return b}()});r("mori.toJs",Kh);
	r("mori.toClj",function(){function a(a,b){return Ph.d(a,Kc([Oh,b],0))}function b(a){return Ph.b(a)}var c=null,c=function(c,e){switch(arguments.length){case 1:return b.call(this,c);case 2:return a.call(this,c,e)}throw Error("Invalid arity: "+arguments.length);};c.b=b;c.a=a;return c}());r("mori.configure",function(a,b){switch(a){case "print-length":return la=b;case "print-level":return ma=b;default:throw Error([z("No matching clause: "),z(a)].join(""));}});r("mori.meta",Vc);r("mori.withMeta",O);
	r("mori.varyMeta",ie);r("mori.varyMeta.f2",ie.a);r("mori.varyMeta.f3",ie.c);r("mori.varyMeta.f4",ie.n);r("mori.varyMeta.f5",ie.r);r("mori.varyMeta.f6",ie.P);r("mori.varyMeta.fn",ie.K);r("mori.alterMeta",Dh);r("mori.resetMeta",function(a,b){return a.k=b});V.prototype.inspect=function(){return this.toString()};F.prototype.inspect=function(){return this.toString()};Hc.prototype.inspect=function(){return this.toString()};wg.prototype.inspect=function(){return this.toString()};pg.prototype.inspect=function(){return this.toString()};
	qg.prototype.inspect=function(){return this.toString()};Fd.prototype.inspect=function(){return this.toString()};Ld.prototype.inspect=function(){return this.toString()};Hd.prototype.inspect=function(){return this.toString()};W.prototype.inspect=function(){return this.toString()};Vd.prototype.inspect=function(){return this.toString()};Bf.prototype.inspect=function(){return this.toString()};Df.prototype.inspect=function(){return this.toString()};Z.prototype.inspect=function(){return this.toString()};
	X.prototype.inspect=function(){return this.toString()};pa.prototype.inspect=function(){return this.toString()};rg.prototype.inspect=function(){return this.toString()};Lg.prototype.inspect=function(){return this.toString()};$g.prototype.inspect=function(){return this.toString()};ch.prototype.inspect=function(){return this.toString()};ph.prototype.inspect=function(){return this.toString()};U.prototype.inspect=function(){return this.toString()};qc.prototype.inspect=function(){return this.toString()};
	Lf.prototype.inspect=function(){return this.toString()};Kf.prototype.inspect=function(){return this.toString()};r("mori.mutable.thaw",function(a){return Ob(a)});r("mori.mutable.freeze",ce);r("mori.mutable.conj",de);r("mori.mutable.conj.f0",de.l);r("mori.mutable.conj.f1",de.b);r("mori.mutable.conj.f2",de.a);r("mori.mutable.conj.fn",de.K);r("mori.mutable.assoc",ee);r("mori.mutable.assoc.f3",ee.c);r("mori.mutable.assoc.fn",ee.K);r("mori.mutable.dissoc",fe);r("mori.mutable.dissoc.f2",fe.a);r("mori.mutable.dissoc.fn",fe.K);r("mori.mutable.pop",function(a){return Ub(a)});r("mori.mutable.disj",ge);
	r("mori.mutable.disj.f2",ge.a);r("mori.mutable.disj.fn",ge.K);;return this.mori;}.call({});});


/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = thunkMiddleware;
	function thunkMiddleware(_ref) {
	  var dispatch = _ref.dispatch;
	  var getState = _ref.getState;
	
	  return function (next) {
	    return function (action) {
	      if (typeof action === 'function') {
	        return action(dispatch, getState);
	      }
	
	      return next(action);
	    };
	  };
	}

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var d3VanDerGrinten = __webpack_require__(95);
	var d3 = __webpack_require__(77);
	var topojson = __webpack_require__(96);
	
	//TODO - this was brought from node_modules to fix a very simple MS Edge bug.
	// Once a fix is in place, revert back to node_modules and update
	
	// Updated regex on Line 254
	// if ( ! /((MSIE)|(Trident)|(Edge))/.test(navigator.userAgent) ) {
	
	(function() {
	  var svg;
	
	  //save off default references
	  var d3 = window.d3, topojson = window.topojson;
	
	  var defaultOptions = {
	    scope: 'world',
	    responsive: false,
	    aspectRatio: 0.5625,
	    setProjection: setProjection,
	    projection: 'equirectangular',
	    dataType: 'json',
	    data: {},
	    done: function() {},
	    fills: {
	      defaultFill: '#ABDDA4'
	    },
	    filters: {},
	    geographyConfig: {
	        dataUrl: null,
	        hideAntarctica: true,
	        hideHawaiiAndAlaska : false,
	        borderWidth: 1,
	        borderOpacity: 1,
	        borderColor: '#FDFDFD',
	        popupTemplate: function(geography, data) {
	          return '<div class="hoverinfo"><strong>' + geography.properties.name + '</strong></div>';
	        },
	        popupOnHover: true,
	        highlightOnHover: true,
	        highlightFillColor: '#FC8D59',
	        highlightBorderColor: 'rgba(250, 15, 160, 0.2)',
	        highlightBorderWidth: 2,
	        highlightBorderOpacity: 1
	    },
	    projectionConfig: {
	      rotation: [97, 0]
	    },
	    bubblesConfig: {
	        borderWidth: 2,
	        borderOpacity: 1,
	        borderColor: '#FFFFFF',
	        popupOnHover: true,
	        radius: null,
	        popupTemplate: function(geography, data) {
	          return '<div class="hoverinfo"><strong>' + data.name + '</strong></div>';
	        },
	        fillOpacity: 0.75,
	        animate: true,
	        highlightOnHover: true,
	        highlightFillColor: '#FC8D59',
	        highlightBorderColor: 'rgba(250, 15, 160, 0.2)',
	        highlightBorderWidth: 2,
	        highlightBorderOpacity: 1,
	        highlightFillOpacity: 0.85,
	        exitDelay: 100,
	        key: JSON.stringify
	    },
	    arcConfig: {
	      strokeColor: '#DD1C77',
	      strokeWidth: 1,
	      arcSharpness: 1,
	      animationSpeed: 600
	    }
	  };
	
	  /*
	    Getter for value. If not declared on datumValue, look up the chain into optionsValue
	  */
	  function val( datumValue, optionsValue, context ) {
	    if ( typeof context === 'undefined' ) {
	      context = optionsValue;
	      optionsValues = undefined;
	    }
	    var value = typeof datumValue !== 'undefined' ? datumValue : optionsValue;
	
	    if (typeof value === 'undefined') {
	      return  null;
	    }
	
	    if ( typeof value === 'function' ) {
	      var fnContext = [context];
	      if ( context.geography ) {
	        fnContext = [context.geography, context.data];
	      }
	      return value.apply(null, fnContext);
	    }
	    else {
	      return value;
	    }
	  }
	
	  function addContainer( element, height, width ) {
	    this.svg = d3.select( element ).append('svg')
	      .attr('width', width || element.offsetWidth)
	      .attr('data-width', width || element.offsetWidth)
	      .attr('class', 'datamap')
	      .attr('height', height || element.offsetHeight)
	      .style('overflow', 'hidden'); // IE10+ doesn't respect height/width when map is zoomed in
	
	    if (this.options.responsive) {
	      d3.select(this.options.element).style({'position': 'relative', 'padding-bottom': (this.options.aspectRatio*100) + '%'});
	      d3.select(this.options.element).select('svg').style({'position': 'absolute', 'width': '100%', 'height': '100%'});
	      d3.select(this.options.element).select('svg').select('g').selectAll('path').style('vector-effect', 'non-scaling-stroke');
	
	    }
	
	    return this.svg;
	  }
	
	  // setProjection takes the svg element and options
	  function setProjection( element, options ) {
	    var width = options.width || element.offsetWidth;
	    var height = options.height || element.offsetHeight;
	    var projection, path;
	    var svg = this.svg;
	
	    if ( options && typeof options.scope === 'undefined') {
	      options.scope = 'world';
	    }
	
	    if ( options.scope === 'usa' ) {
	      projection = d3.geo.albersUsa()
	        .scale(width)
	        .translate([width / 2, height / 2]);
	    }
	    else if ( options.scope === 'world' ) {
	      projection = d3.geo[options.projection]()
	        .scale((width + 1) / 2 / Math.PI)
	        .translate([width / 2, height / (options.projection === "mercator" ? 1.45 : 1.8)]);
	    }
	
	    if ( options.projection === 'orthographic' ) {
	
	      svg.append("defs").append("path")
	        .datum({type: "Sphere"})
	        .attr("id", "sphere")
	        .attr("d", path);
	
	      svg.append("use")
	          .attr("class", "stroke")
	          .attr("xlink:href", "#sphere");
	
	      svg.append("use")
	          .attr("class", "fill")
	          .attr("xlink:href", "#sphere");
	      projection.scale(250).clipAngle(90).rotate(options.projectionConfig.rotation)
	    }
	
	    path = d3.geo.path()
	      .projection( projection );
	
	    return {path: path, projection: projection};
	  }
	
	  function addStyleBlock() {
	    if ( d3.select('.datamaps-style-block').empty() ) {
	      d3.select('head').append('style').attr('class', 'datamaps-style-block')
	      .html('.datamap path.datamaps-graticule { fill: none; stroke: #777; stroke-width: 0.5px; stroke-opacity: .5; pointer-events: none; } .datamap .labels {pointer-events: none;} .datamap path {stroke: #FFFFFF; stroke-width: 1px;} .datamaps-legend dt, .datamaps-legend dd { float: left; margin: 0 3px 0 0;} .datamaps-legend dd {width: 20px; margin-right: 6px; border-radius: 3px;} .datamaps-legend {padding-bottom: 20px; z-index: 1001; position: absolute; left: 4px; font-size: 12px; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;} .datamaps-hoverover {display: none; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; } .hoverinfo {padding: 4px; border-radius: 1px; background-color: #FFF; box-shadow: 1px 1px 5px #CCC; font-size: 12px; border: 1px solid #CCC; } .hoverinfo hr {border:1px dotted #CCC; }');
	    }
	  }
	
	  function drawSubunits( data ) {
	    var fillData = this.options.fills,
	        colorCodeData = this.options.data || {},
	        geoConfig = this.options.geographyConfig;
	
	
	    var subunits = this.svg.select('g.datamaps-subunits');
	    if ( subunits.empty() ) {
	      subunits = this.addLayer('datamaps-subunits', null, true);
	    }
	
	    var geoData = topojson.feature( data, data.objects[ this.options.scope ] ).features;
	    if ( geoConfig.hideAntarctica ) {
	      geoData = geoData.filter(function(feature) {
	        return feature.id !== "ATA";
	      });
	    }
	
	    if ( geoConfig.hideHawaiiAndAlaska ) {
	      geoData = geoData.filter(function(feature) {
	        return feature.id !== "HI" && feature.id !== 'AK';
	      });
	    }
	
	    var geo = subunits.selectAll('path.datamaps-subunit').data( geoData );
	
	    geo.enter()
	      .append('path')
	      .attr('d', this.path)
	      .attr('class', function(d) {
	        return 'datamaps-subunit ' + d.id;
	      })
	      .attr('data-info', function(d) {
	        return JSON.stringify( colorCodeData[d.id]);
	      })
	      .style('fill', function(d) {
	        //if fillKey - use that
	        //otherwise check 'fill'
	        //otherwise check 'defaultFill'
	        var fillColor;
	
	        var datum = colorCodeData[d.id];
	        if ( datum && datum.fillKey ) {
	          fillColor = fillData[ val(datum.fillKey, {data: colorCodeData[d.id], geography: d}) ];
	        }
	
	        if ( typeof fillColor === 'undefined' ) {
	          fillColor = val(datum && datum.fillColor, fillData.defaultFill, {data: colorCodeData[d.id], geography: d});
	        }
	
	        return fillColor;
	      })
	      .style('stroke-width', geoConfig.borderWidth)
	      .style('stroke-opacity', geoConfig.borderOpacity)
	      .style('stroke', geoConfig.borderColor);
	  }
	
	  function handleGeographyConfig () {
	    var hoverover;
	    var svg = this.svg;
	    var self = this;
	    var options = this.options.geographyConfig;
	
	    if ( options.highlightOnHover || options.popupOnHover ) {
	      svg.selectAll('.datamaps-subunit')
	        .on('mouseover', function(d) {
	          var $this = d3.select(this);
	          var datum = self.options.data[d.id] || {};
	          if ( options.highlightOnHover ) {
	            var previousAttributes = {
	              'fill':  $this.style('fill'),
	              'stroke': $this.style('stroke'),
	              'stroke-width': $this.style('stroke-width'),
	              'fill-opacity': $this.style('fill-opacity')
	            };
	
	            $this
	              .style('fill', val(datum.highlightFillColor, options.highlightFillColor, datum))
	              .style('stroke', val(datum.highlightBorderColor, options.highlightBorderColor, datum))
	              .style('stroke-width', val(datum.highlightBorderWidth, options.highlightBorderWidth, datum))
	              .style('stroke-opacity', val(datum.highlightBorderOpacity, options.highlightBorderOpacity, datum))
	              .style('fill-opacity', val(datum.highlightFillOpacity, options.highlightFillOpacity, datum))
	              .attr('data-previousAttributes', JSON.stringify(previousAttributes));
	
	            //as per discussion on https://github.com/markmarkoh/datamaps/issues/19
	            //if ( ! /((MSIE)|(Trident)|(Edge))/.test(navigator.userAgent) ) {
	             //moveToFront.call(this);
	            //}
	          }
	
	          if ( options.popupOnHover ) {
	            self.updatePopup($this, d, options, svg);
	          }
	        })
	        .on('mouseout', function() {
	          var $this = d3.select(this);
	
	          if (options.highlightOnHover) {
	            //reapply previous attributes
	            var previousAttributes = JSON.parse( $this.attr('data-previousAttributes') );
	            for ( var attr in previousAttributes ) {
	              $this.style(attr, previousAttributes[attr]);
	            }
	          }
	          $this.on('mousemove', null);
	          d3.selectAll('.datamaps-hoverover').style('display', 'none');
	        });
	    }
	
	    function moveToFront() {
	      this.parentNode.appendChild(this);
	    }
	  }
	
	  //plugin to add a simple map legend
	  function addLegend(layer, data, options) {
	    data = data || {};
	    if ( !this.options.fills ) {
	      return;
	    }
	
	    var html = '<dl>';
	    var label = '';
	    if ( data.legendTitle ) {
	      html = '<h2>' + data.legendTitle + '</h2>' + html;
	    }
	    for ( var fillKey in this.options.fills ) {
	
	      if ( fillKey === 'defaultFill') {
	        if (! data.defaultFillName ) {
	          continue;
	        }
	        label = data.defaultFillName;
	      } else {
	        if (data.labels && data.labels[fillKey]) {
	          label = data.labels[fillKey];
	        } else {
	          label= fillKey + ': ';
	        }
	      }
	      html += '<dt>' + label + '</dt>';
	      html += '<dd style="background-color:' +  this.options.fills[fillKey] + '">&nbsp;</dd>';
	    }
	    html += '</dl>';
	
	    var hoverover = d3.select( this.options.element ).append('div')
	      .attr('class', 'datamaps-legend')
	      .html(html);
	  }
	
	    function addGraticule ( layer, options ) {
	      var graticule = d3.geo.graticule();
	      this.svg.insert("path", '.datamaps-subunits')
	        .datum(graticule)
	        .attr("class", "datamaps-graticule")
	        .attr("d", this.path);
	  }
	
	  function handleArcs (layer, data, options) {
	    var self = this,
	        svg = this.svg;
	
	    if ( !data || (data && !data.slice) ) {
	      throw "Datamaps Error - arcs must be an array";
	    }
	
	    // For some reason arc options were put in an `options` object instead of the parent arc
	    // I don't like this, so to match bubbles and other plugins I'm moving it
	    // This is to keep backwards compatability
	    for ( var i = 0; i < data.length; i++ ) {
	      data[i] = defaults(data[i], data[i].options);
	      delete data[i].options;
	    }
	
	    if ( typeof options === "undefined" ) {
	      options = defaultOptions.arcConfig;
	    }
	
	    var arcs = layer.selectAll('path.datamaps-arc').data( data, JSON.stringify );
	
	    var path = d3.geo.path()
	        .projection(self.projection);
	
	    arcs
	      .enter()
	        .append('svg:path')
	        .attr('class', 'datamaps-arc')
	        .style('stroke-linecap', 'round')
	        .style('stroke', function(datum) {
	          return val(datum.strokeColor, options.strokeColor, datum);
	        })
	        .style('fill', 'none')
	        .style('stroke-width', function(datum) {
	            return val(datum.strokeWidth, options.strokeWidth, datum);
	        })
	        .attr('d', function(datum) {
	            var originXY = self.latLngToXY(val(datum.origin.latitude, datum), val(datum.origin.longitude, datum))
	            var destXY = self.latLngToXY(val(datum.destination.latitude, datum), val(datum.destination.longitude, datum));
	            var midXY = [ (originXY[0] + destXY[0]) / 2, (originXY[1] + destXY[1]) / 2];
	            if (options.greatArc) {
	                  // TODO: Move this to inside `if` clause when setting attr `d`
	              var greatArc = d3.geo.greatArc()
	                  .source(function(d) { return [val(d.origin.longitude, d), val(d.origin.latitude, d)]; })
	                  .target(function(d) { return [val(d.destination.longitude, d), val(d.destination.latitude, d)]; });
	
	              return path(greatArc(datum))
	            }
	            var sharpness = val(datum.arcSharpness, options.arcSharpness, datum);
	            return "M" + originXY[0] + ',' + originXY[1] + "S" + (midXY[0] + (50 * sharpness)) + "," + (midXY[1] - (75 * sharpness)) + "," + destXY[0] + "," + destXY[1];
	        })
	        .attr('data-info', function(datum) {
	          return JSON.stringify(datum);
	        })
	        .transition()
	          .delay(100)
	          .style('fill', function(datum) {
	            /*
	              Thank you Jake Archibald, this is awesome.
	              Source: http://jakearchibald.com/2013/animated-line-drawing-svg/
	            */
	            var length = this.getTotalLength();
	            this.style.transition = this.style.WebkitTransition = 'none';
	            this.style.strokeDasharray = length + ' ' + length;
	            this.style.strokeDashoffset = length;
	            this.getBoundingClientRect();
	            this.style.transition = this.style.WebkitTransition = 'stroke-dashoffset ' + val(datum.animationSpeed, options.animationSpeed, datum) + 'ms ease-out';
	            this.style.strokeDashoffset = '0';
	            return 'none';
	          })
	
	    arcs.exit()
	      .transition()
	      .style('opacity', 0)
	      .remove();
	  }
	
	  function handleLabels ( layer, options ) {
	    var self = this;
	    options = options || {};
	    var labelStartCoodinates = this.projection([-67.707617, 42.722131]);
	    this.svg.selectAll(".datamaps-subunit")
	      .attr("data-foo", function(d) {
	        var center = self.path.centroid(d);
	        var xOffset = 7.5, yOffset = 5;
	
	        if ( ["FL", "KY", "MI"].indexOf(d.id) > -1 ) xOffset = -2.5;
	        if ( d.id === "NY" ) xOffset = -1;
	        if ( d.id === "MI" ) yOffset = 18;
	        if ( d.id === "LA" ) xOffset = 13;
	
	        var x,y;
	
	        x = center[0] - xOffset;
	        y = center[1] + yOffset;
	
	        var smallStateIndex = ["VT", "NH", "MA", "RI", "CT", "NJ", "DE", "MD", "DC"].indexOf(d.id);
	        if ( smallStateIndex > -1) {
	          var yStart = labelStartCoodinates[1];
	          x = labelStartCoodinates[0];
	          y = yStart + (smallStateIndex * (2+ (options.fontSize || 12)));
	          layer.append("line")
	            .attr("x1", x - 3)
	            .attr("y1", y - 5)
	            .attr("x2", center[0])
	            .attr("y2", center[1])
	            .style("stroke", options.labelColor || "#000")
	            .style("stroke-width", options.lineWidth || 1)
	        }
	
	          layer.append("text")
	              .attr("x", x)
	              .attr("y", y)
	              .style("font-size", (options.fontSize || 10) + 'px')
	              .style("font-family", options.fontFamily || "Verdana")
	              .style("fill", options.labelColor || "#000")
	              .text(function() {
	                  if (options.customLabelText && options.customLabelText[d.id]) {
	                      return options.customLabelText[d.id]
	                  } else {
	                      return d.id
	                  }
	              });
	
	        return "bar";
	      });
	  }
	
	
	  function handleBubbles (layer, data, options ) {
	    var self = this,
	        fillData = this.options.fills,
	        filterData = this.options.filters,
	        svg = this.svg;
	
	    if ( !data || (data && !data.slice) ) {
	      throw "Datamaps Error - bubbles must be an array";
	    }
	
	    var bubbles = layer.selectAll('circle.datamaps-bubble').data( data, options.key );
	
	    bubbles
	      .enter()
	        .append('svg:circle')
	        .attr('class', 'datamaps-bubble')
	        .attr('cx', function ( datum ) {
	          var latLng;
	          if ( datumHasCoords(datum) ) {
	            latLng = self.latLngToXY(datum.latitude, datum.longitude);
	          }
	          else if ( datum.centered ) {
	            latLng = self.path.centroid(svg.select('path.' + datum.centered).data()[0]);
	          }
	          if ( latLng ) return latLng[0];
	        })
	        .attr('cy', function ( datum ) {
	          var latLng;
	          if ( datumHasCoords(datum) ) {
	            latLng = self.latLngToXY(datum.latitude, datum.longitude);
	          }
	          else if ( datum.centered ) {
	            latLng = self.path.centroid(svg.select('path.' + datum.centered).data()[0]);
	          }
	          if ( latLng ) return latLng[1];
	        })
	        .attr('r', function(datum) {
	          // if animation enabled start with radius 0, otherwise use full size.
	          return options.animate ? 0 : val(datum.radius, options.radius, datum);
	        })
	        .attr('data-info', function(datum) {
	          return JSON.stringify(datum);
	        })
	        .attr('filter', function (datum) {
	          var filterKey = filterData[ val(datum.filterKey, options.filterKey, datum) ];
	
	          if (filterKey) {
	            return filterKey;
	          }
	        })
	        .style('stroke', function ( datum ) {
	          return val(datum.borderColor, options.borderColor, datum);
	        })
	        .style('stroke-width', function ( datum ) {
	          return val(datum.borderWidth, options.borderWidth, datum);
	        })
	        .style('stroke-opacity', function ( datum ) {
	          return val(datum.borderOpacity, options.borderOpacity, datum);
	        })
	        .style('fill-opacity', function ( datum ) {
	          return val(datum.fillOpacity, options.fillOpacity, datum);
	        })
	        .style('fill', function ( datum ) {
	          var fillColor = fillData[ val(datum.fillKey, options.fillKey, datum) ];
	          return fillColor || fillData.defaultFill;
	        })
	        .on('mouseover', function ( datum ) {
	          var $this = d3.select(this);
	
	          if (options.highlightOnHover) {
	            //save all previous attributes for mouseout
	            var previousAttributes = {
	              'fill':  $this.style('fill'),
	              'stroke': $this.style('stroke'),
	              'stroke-width': $this.style('stroke-width'),
	              'fill-opacity': $this.style('fill-opacity')
	            };
	
	            $this
	              .style('fill', val(datum.highlightFillColor, options.highlightFillColor, datum))
	              .style('stroke', val(datum.highlightBorderColor, options.highlightBorderColor, datum))
	              .style('stroke-width', val(datum.highlightBorderWidth, options.highlightBorderWidth, datum))
	              .style('stroke-opacity', val(datum.highlightBorderOpacity, options.highlightBorderOpacity, datum))
	              .style('fill-opacity', val(datum.highlightFillOpacity, options.highlightFillOpacity, datum))
	              .attr('data-previousAttributes', JSON.stringify(previousAttributes));
	          }
	
	          if (options.popupOnHover) {
	            self.updatePopup($this, datum, options, svg);
	          }
	        })
	        .on('mouseout', function ( datum ) {
	          var $this = d3.select(this);
	
	          if (options.highlightOnHover) {
	            //reapply previous attributes
	            var previousAttributes = JSON.parse( $this.attr('data-previousAttributes') );
	            for ( var attr in previousAttributes ) {
	              $this.style(attr, previousAttributes[attr]);
	            }
	          }
	
	          d3.selectAll('.datamaps-hoverover').style('display', 'none');
	        })
	
	    bubbles.transition()
	      .duration(400)
	      .attr('r', function ( datum ) {
	        return val(datum.radius, options.radius, datum);
	      })
	    .transition()
	      .duration(0)
	      .attr('data-info', function(d) {
	        return JSON.stringify(d);
	      });
	
	    bubbles.exit()
	      .transition()
	        .delay(options.exitDelay)
	        .attr("r", 0)
	        .remove();
	
	    function datumHasCoords (datum) {
	      return typeof datum !== 'undefined' && typeof datum.latitude !== 'undefined' && typeof datum.longitude !== 'undefined';
	    }
	  }
	
	  //stolen from underscore.js
	  function defaults(obj) {
	    Array.prototype.slice.call(arguments, 1).forEach(function(source) {
	      if (source) {
	        for (var prop in source) {
	          if (obj[prop] == null) obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  }
	  /**************************************
	             Public Functions
	  ***************************************/
	
	  function Datamap( options ) {
	
	    if ( typeof d3 === 'undefined' || typeof topojson === 'undefined' ) {
	      throw new Error('Include d3.js (v3.0.3 or greater) and topojson on this page before creating a new map');
	   }
	    //set options for global use
	    this.options = defaults(options, defaultOptions);
	    this.options.geographyConfig = defaults(options.geographyConfig, defaultOptions.geographyConfig);
	    this.options.projectionConfig = defaults(options.projectionConfig, defaultOptions.projectionConfig);
	    this.options.bubblesConfig = defaults(options.bubblesConfig, defaultOptions.bubblesConfig);
	    this.options.arcConfig = defaults(options.arcConfig, defaultOptions.arcConfig);
	
	    //add the SVG container
	    if ( d3.select( this.options.element ).select('svg').length > 0 ) {
	      addContainer.call(this, this.options.element, this.options.height, this.options.width );
	    }
	
	    /* Add core plugins to this instance */
	    this.addPlugin('bubbles', handleBubbles);
	    this.addPlugin('legend', addLegend);
	    this.addPlugin('arc', handleArcs);
	    this.addPlugin('labels', handleLabels);
	    this.addPlugin('graticule', addGraticule);
	
	    //append style block with basic hoverover styles
	    if ( ! this.options.disableDefaultStyles ) {
	      addStyleBlock();
	    }
	
	    return this.draw();
	  }
	
	  // resize map
	  Datamap.prototype.resize = function () {
	
	    var self = this;
	    var options = self.options;
	
	    if (options.responsive) {
	      var newsize = options.element.clientWidth,
	          oldsize = d3.select( options.element).select('svg').attr('data-width');
	
	      d3.select(options.element).select('svg').selectAll('g').attr('transform', 'scale(' + (newsize / oldsize) + ')');
	    }
	  }
	
	  // actually draw the features(states & countries)
	  Datamap.prototype.draw = function() {
	    //save off in a closure
	    var self = this;
	    var options = self.options;
	
	    //set projections and paths based on scope
	    var pathAndProjection = options.setProjection.apply(self, [options.element, options] );
	
	    this.path = pathAndProjection.path;
	    this.projection = pathAndProjection.projection;
	
	    //if custom URL for topojson data, retrieve it and render
	    if ( options.geographyConfig.dataUrl ) {
	      d3.json( options.geographyConfig.dataUrl, function(error, results) {
	        if ( error ) throw new Error(error);
	        self.customTopo = results;
	        draw( results );
	      });
	    }
	    else {
	      draw( this[options.scope + 'Topo'] || options.geographyConfig.dataJson);
	    }
	
	    return this;
	
	      function draw (data) {
	        // if fetching remote data, draw the map first then call `updateChoropleth`
	        if ( self.options.dataUrl ) {
	          //allow for csv or json data types
	          d3[self.options.dataType](self.options.dataUrl, function(data) {
	            //in the case of csv, transform data to object
	            if ( self.options.dataType === 'csv' && (data && data.slice) ) {
	              var tmpData = {};
	              for(var i = 0; i < data.length; i++) {
	                tmpData[data[i].id] = data[i];
	              }
	              data = tmpData;
	            }
	            Datamaps.prototype.updateChoropleth.call(self, data);
	          });
	        }
	        drawSubunits.call(self, data);
	        handleGeographyConfig.call(self);
	
	        if ( self.options.geographyConfig.popupOnHover || self.options.bubblesConfig.popupOnHover) {
	          hoverover = d3.select( self.options.element ).append('div')
	            .attr('class', 'datamaps-hoverover')
	            .style('z-index', 10001)
	            .style('position', 'absolute');
	        }
	
	        //fire off finished callback
	        self.options.done(self);
	      }
	  };
	  /**************************************
	                TopoJSON
	  ***************************************/
	  Datamap.prototype.worldTopo = {
	    "type": "Topology",
	    "objects": {
	        "world": {
	            "type": "GeometryCollection",
	            "geometries": [{
	                "type": "Polygon",
	                "properties": {
	                    "name": "Afghanistan"
	                },
	                "id": "AFG",
	                "arcs": [
	                    [0, 1, 2, 3, 4, 5]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Angola"
	                },
	                "id": "AGO",
	                "arcs": [
	                    [
	                        [6, 7, 8, 9]
	                    ],
	                    [
	                        [10, 11, 12]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Albania"
	                },
	                "id": "ALB",
	                "arcs": [
	                    [13, 14, 15, 16, 17]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "United Arab Emirates"
	                },
	                "id": "ARE",
	                "arcs": [
	                    [18, 19, 20, 21, 22]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Argentina"
	                },
	                "id": "ARG",
	                "arcs": [
	                    [
	                        [23, 24]
	                    ],
	                    [
	                        [25, 26, 27, 28, 29, 30]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Armenia"
	                },
	                "id": "ARM",
	                "arcs": [
	                    [31, 32, 33, 34, 35]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Antarctica"
	                },
	                "id": "ATA",
	                "arcs": [
	                    [
	                        [36]
	                    ],
	                    [
	                        [37]
	                    ],
	                    [
	                        [38]
	                    ],
	                    [
	                        [39]
	                    ],
	                    [
	                        [40]
	                    ],
	                    [
	                        [41]
	                    ],
	                    [
	                        [42]
	                    ],
	                    [
	                        [43]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "French Southern and Antarctic Lands"
	                },
	                "id": "ATF",
	                "arcs": [
	                    [44]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Australia"
	                },
	                "id": "AUS",
	                "arcs": [
	                    [
	                        [45]
	                    ],
	                    [
	                        [46]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Austria"
	                },
	                "id": "AUT",
	                "arcs": [
	                    [47, 48, 49, 50, 51, 52, 53]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Azerbaijan"
	                },
	                "id": "AZE",
	                "arcs": [
	                    [
	                        [54, -35]
	                    ],
	                    [
	                        [55, 56, -33, 57, 58]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Burundi"
	                },
	                "id": "BDI",
	                "arcs": [
	                    [59, 60, 61]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Belgium"
	                },
	                "id": "BEL",
	                "arcs": [
	                    [62, 63, 64, 65, 66]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Benin"
	                },
	                "id": "BEN",
	                "arcs": [
	                    [67, 68, 69, 70, 71]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Burkina Faso"
	                },
	                "id": "BFA",
	                "arcs": [
	                    [72, 73, 74, -70, 75, 76]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Bangladesh"
	                },
	                "id": "BGD",
	                "arcs": [
	                    [77, 78, 79]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Bulgaria"
	                },
	                "id": "BGR",
	                "arcs": [
	                    [80, 81, 82, 83, 84, 85]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "The Bahamas"
	                },
	                "id": "BHS",
	                "arcs": [
	                    [
	                        [86]
	                    ],
	                    [
	                        [87]
	                    ],
	                    [
	                        [88]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Bosnia and Herzegovina"
	                },
	                "id": "BIH",
	                "arcs": [
	                    [89, 90, 91]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Belarus"
	                },
	                "id": "BLR",
	                "arcs": [
	                    [92, 93, 94, 95, 96]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Belize"
	                },
	                "id": "BLZ",
	                "arcs": [
	                    [97, 98, 99]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Bolivia"
	                },
	                "id": "BOL",
	                "arcs": [
	                    [100, 101, 102, 103, -31]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Brazil"
	                },
	                "id": "BRA",
	                "arcs": [
	                    [-27, 104, -103, 105, 106, 107, 108, 109, 110, 111, 112]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Brunei"
	                },
	                "id": "BRN",
	                "arcs": [
	                    [113, 114]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Bhutan"
	                },
	                "id": "BTN",
	                "arcs": [
	                    [115, 116]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Botswana"
	                },
	                "id": "BWA",
	                "arcs": [
	                    [117, 118, 119, 120]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Central African Republic"
	                },
	                "id": "CAF",
	                "arcs": [
	                    [121, 122, 123, 124, 125, 126, 127]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Canada"
	                },
	                "id": "CAN",
	                "arcs": [
	                    [
	                        [128]
	                    ],
	                    [
	                        [129]
	                    ],
	                    [
	                        [130]
	                    ],
	                    [
	                        [131]
	                    ],
	                    [
	                        [132]
	                    ],
	                    [
	                        [133]
	                    ],
	                    [
	                        [134]
	                    ],
	                    [
	                        [135]
	                    ],
	                    [
	                        [136]
	                    ],
	                    [
	                        [137]
	                    ],
	                    [
	                        [138, 139, 140, 141]
	                    ],
	                    [
	                        [142]
	                    ],
	                    [
	                        [143]
	                    ],
	                    [
	                        [144]
	                    ],
	                    [
	                        [145]
	                    ],
	                    [
	                        [146]
	                    ],
	                    [
	                        [147]
	                    ],
	                    [
	                        [148]
	                    ],
	                    [
	                        [149]
	                    ],
	                    [
	                        [150]
	                    ],
	                    [
	                        [151]
	                    ],
	                    [
	                        [152]
	                    ],
	                    [
	                        [153]
	                    ],
	                    [
	                        [154]
	                    ],
	                    [
	                        [155]
	                    ],
	                    [
	                        [156]
	                    ],
	                    [
	                        [157]
	                    ],
	                    [
	                        [158]
	                    ],
	                    [
	                        [159]
	                    ],
	                    [
	                        [160]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Switzerland"
	                },
	                "id": "CHE",
	                "arcs": [
	                    [-51, 161, 162, 163]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Chile"
	                },
	                "id": "CHL",
	                "arcs": [
	                    [
	                        [-24, 164]
	                    ],
	                    [
	                        [-30, 165, 166, -101]
	                    ]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "China"
	                },
	                "id": "CHN",
	                "arcs": [
	                    [
	                        [167]
	                    ],
	                    [
	                        [168, 169, 170, 171, 172, 173, -117, 174, 175, 176, 177, -4, 178, 179, 180, 181, 182, 183]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Ivory Coast"
	                },
	                "id": "CIV",
	                "arcs": [
	                    [184, 185, 186, 187, -73, 188]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Cameroon"
	                },
	                "id": "CMR",
	                "arcs": [
	                    [189, 190, 191, 192, 193, 194, -128, 195]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Democratic Republic of the Congo"
	                },
	                "id": "COD",
	                "arcs": [
	                    [196, 197, -60, 198, 199, -10, 200, -13, 201, -126, 202]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Republic of the Congo"
	                },
	                "id": "COG",
	                "arcs": [
	                    [-12, 203, 204, -196, -127, -202]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Colombia"
	                },
	                "id": "COL",
	                "arcs": [
	                    [205, 206, 207, 208, 209, -107, 210]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Costa Rica"
	                },
	                "id": "CRI",
	                "arcs": [
	                    [211, 212, 213, 214]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Cuba"
	                },
	                "id": "CUB",
	                "arcs": [
	                    [215]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Northern Cyprus"
	                },
	                "id": "-99",
	                "arcs": [
	                    [216, 217]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Cyprus"
	                },
	                "id": "CYP",
	                "arcs": [
	                    [218, -218]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Czech Republic"
	                },
	                "id": "CZE",
	                "arcs": [
	                    [-53, 219, 220, 221]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Germany"
	                },
	                "id": "DEU",
	                "arcs": [
	                    [222, 223, -220, -52, -164, 224, 225, -64, 226, 227, 228]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Djibouti"
	                },
	                "id": "DJI",
	                "arcs": [
	                    [229, 230, 231, 232]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Denmark"
	                },
	                "id": "DNK",
	                "arcs": [
	                    [
	                        [233]
	                    ],
	                    [
	                        [-229, 234]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Dominican Republic"
	                },
	                "id": "DOM",
	                "arcs": [
	                    [235, 236]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Algeria"
	                },
	                "id": "DZA",
	                "arcs": [
	                    [237, 238, 239, 240, 241, 242, 243, 244]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Ecuador"
	                },
	                "id": "ECU",
	                "arcs": [
	                    [245, -206, 246]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Egypt"
	                },
	                "id": "EGY",
	                "arcs": [
	                    [247, 248, 249, 250, 251]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Eritrea"
	                },
	                "id": "ERI",
	                "arcs": [
	                    [252, 253, 254, -233]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Spain"
	                },
	                "id": "ESP",
	                "arcs": [
	                    [255, 256, 257, 258]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Estonia"
	                },
	                "id": "EST",
	                "arcs": [
	                    [259, 260, 261]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Ethiopia"
	                },
	                "id": "ETH",
	                "arcs": [
	                    [-232, 262, 263, 264, 265, 266, 267, -253]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Finland"
	                },
	                "id": "FIN",
	                "arcs": [
	                    [268, 269, 270, 271]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Fiji"
	                },
	                "id": "FJI",
	                "arcs": [
	                    [
	                        [272]
	                    ],
	                    [
	                        [273, 274]
	                    ],
	                    [
	                        [275, -275]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Falkland Islands"
	                },
	                "id": "FLK",
	                "arcs": [
	                    [276]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "France"
	                },
	                "id": "FRA",
	                "arcs": [
	                    [
	                        [277]
	                    ],
	                    [
	                        [278, -225, -163, 279, 280, -257, 281, -66]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "French Guiana"
	                },
	                "id": "GUF",
	                "arcs": [
	                    [282, 283, 284, 285, -111]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Gabon"
	                },
	                "id": "GAB",
	                "arcs": [
	                    [286, 287, -190, -205]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "United Kingdom"
	                },
	                "id": "GBR",
	                "arcs": [
	                    [
	                        [288, 289]
	                    ],
	                    [
	                        [290]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Georgia"
	                },
	                "id": "GEO",
	                "arcs": [
	                    [291, 292, -58, -32, 293]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Ghana"
	                },
	                "id": "GHA",
	                "arcs": [
	                    [294, -189, -77, 295]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Guinea"
	                },
	                "id": "GIN",
	                "arcs": [
	                    [296, 297, 298, 299, 300, 301, -187]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Gambia"
	                },
	                "id": "GMB",
	                "arcs": [
	                    [302, 303]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Guinea Bissau"
	                },
	                "id": "GNB",
	                "arcs": [
	                    [304, 305, -300]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Equatorial Guinea"
	                },
	                "id": "GNQ",
	                "arcs": [
	                    [306, -191, -288]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Greece"
	                },
	                "id": "GRC",
	                "arcs": [
	                    [
	                        [307]
	                    ],
	                    [
	                        [308, -15, 309, -84, 310]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Greenland"
	                },
	                "id": "GRL",
	                "arcs": [
	                    [311]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Guatemala"
	                },
	                "id": "GTM",
	                "arcs": [
	                    [312, 313, -100, 314, 315, 316]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Guyana"
	                },
	                "id": "GUY",
	                "arcs": [
	                    [317, 318, -109, 319]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Honduras"
	                },
	                "id": "HND",
	                "arcs": [
	                    [320, 321, -316, 322, 323]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Croatia"
	                },
	                "id": "HRV",
	                "arcs": [
	                    [324, -92, 325, 326, 327, 328]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Haiti"
	                },
	                "id": "HTI",
	                "arcs": [
	                    [-237, 329]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Hungary"
	                },
	                "id": "HUN",
	                "arcs": [
	                    [-48, 330, 331, 332, 333, -329, 334]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Indonesia"
	                },
	                "id": "IDN",
	                "arcs": [
	                    [
	                        [335]
	                    ],
	                    [
	                        [336, 337]
	                    ],
	                    [
	                        [338]
	                    ],
	                    [
	                        [339]
	                    ],
	                    [
	                        [340]
	                    ],
	                    [
	                        [341]
	                    ],
	                    [
	                        [342]
	                    ],
	                    [
	                        [343]
	                    ],
	                    [
	                        [344, 345]
	                    ],
	                    [
	                        [346]
	                    ],
	                    [
	                        [347]
	                    ],
	                    [
	                        [348, 349]
	                    ],
	                    [
	                        [350]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "India"
	                },
	                "id": "IND",
	                "arcs": [
	                    [-177, 351, -175, -116, -174, 352, -80, 353, 354]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Ireland"
	                },
	                "id": "IRL",
	                "arcs": [
	                    [355, -289]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Iran"
	                },
	                "id": "IRN",
	                "arcs": [
	                    [356, -6, 357, 358, 359, 360, -55, -34, -57, 361]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Iraq"
	                },
	                "id": "IRQ",
	                "arcs": [
	                    [362, 363, 364, 365, 366, 367, -360]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Iceland"
	                },
	                "id": "ISL",
	                "arcs": [
	                    [368]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Israel"
	                },
	                "id": "ISR",
	                "arcs": [
	                    [369, 370, 371, -252, 372, 373, 374]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Italy"
	                },
	                "id": "ITA",
	                "arcs": [
	                    [
	                        [375]
	                    ],
	                    [
	                        [376]
	                    ],
	                    [
	                        [377, 378, -280, -162, -50]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Jamaica"
	                },
	                "id": "JAM",
	                "arcs": [
	                    [379]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Jordan"
	                },
	                "id": "JOR",
	                "arcs": [
	                    [-370, 380, -366, 381, 382, -372, 383]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Japan"
	                },
	                "id": "JPN",
	                "arcs": [
	                    [
	                        [384]
	                    ],
	                    [
	                        [385]
	                    ],
	                    [
	                        [386]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Kazakhstan"
	                },
	                "id": "KAZ",
	                "arcs": [
	                    [387, 388, 389, 390, -181, 391]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Kenya"
	                },
	                "id": "KEN",
	                "arcs": [
	                    [392, 393, 394, 395, -265, 396]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Kyrgyzstan"
	                },
	                "id": "KGZ",
	                "arcs": [
	                    [-392, -180, 397, 398]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Cambodia"
	                },
	                "id": "KHM",
	                "arcs": [
	                    [399, 400, 401, 402]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "South Korea"
	                },
	                "id": "KOR",
	                "arcs": [
	                    [403, 404]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Kosovo"
	                },
	                "id": "-99",
	                "arcs": [
	                    [-18, 405, 406, 407]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Kuwait"
	                },
	                "id": "KWT",
	                "arcs": [
	                    [408, 409, -364]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Laos"
	                },
	                "id": "LAO",
	                "arcs": [
	                    [410, 411, -172, 412, -401]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Lebanon"
	                },
	                "id": "LBN",
	                "arcs": [
	                    [-374, 413, 414]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Liberia"
	                },
	                "id": "LBR",
	                "arcs": [
	                    [415, 416, -297, -186]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Libya"
	                },
	                "id": "LBY",
	                "arcs": [
	                    [417, -245, 418, 419, -250, 420, 421]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Sri Lanka"
	                },
	                "id": "LKA",
	                "arcs": [
	                    [422]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Lesotho"
	                },
	                "id": "LSO",
	                "arcs": [
	                    [423]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Lithuania"
	                },
	                "id": "LTU",
	                "arcs": [
	                    [424, 425, 426, -93, 427]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Luxembourg"
	                },
	                "id": "LUX",
	                "arcs": [
	                    [-226, -279, -65]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Latvia"
	                },
	                "id": "LVA",
	                "arcs": [
	                    [428, -262, 429, -94, -427]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Morocco"
	                },
	                "id": "MAR",
	                "arcs": [
	                    [-242, 430, 431]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Moldova"
	                },
	                "id": "MDA",
	                "arcs": [
	                    [432, 433]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Madagascar"
	                },
	                "id": "MDG",
	                "arcs": [
	                    [434]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Mexico"
	                },
	                "id": "MEX",
	                "arcs": [
	                    [435, -98, -314, 436, 437]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Macedonia"
	                },
	                "id": "MKD",
	                "arcs": [
	                    [-408, 438, -85, -310, -14]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Mali"
	                },
	                "id": "MLI",
	                "arcs": [
	                    [439, -239, 440, -74, -188, -302, 441]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Myanmar"
	                },
	                "id": "MMR",
	                "arcs": [
	                    [442, -78, -353, -173, -412, 443]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Montenegro"
	                },
	                "id": "MNE",
	                "arcs": [
	                    [444, -326, -91, 445, -406, -17]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Mongolia"
	                },
	                "id": "MNG",
	                "arcs": [
	                    [446, -183]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Mozambique"
	                },
	                "id": "MOZ",
	                "arcs": [
	                    [447, 448, 449, 450, 451, 452, 453, 454]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Mauritania"
	                },
	                "id": "MRT",
	                "arcs": [
	                    [455, 456, 457, -240, -440]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Malawi"
	                },
	                "id": "MWI",
	                "arcs": [
	                    [-455, 458, 459]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Malaysia"
	                },
	                "id": "MYS",
	                "arcs": [
	                    [
	                        [460, 461]
	                    ],
	                    [
	                        [-349, 462, -115, 463]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Namibia"
	                },
	                "id": "NAM",
	                "arcs": [
	                    [464, -8, 465, -119, 466]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "New Caledonia"
	                },
	                "id": "NCL",
	                "arcs": [
	                    [467]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Niger"
	                },
	                "id": "NER",
	                "arcs": [
	                    [-75, -441, -238, -418, 468, -194, 469, -71]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Nigeria"
	                },
	                "id": "NGA",
	                "arcs": [
	                    [470, -72, -470, -193]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Nicaragua"
	                },
	                "id": "NIC",
	                "arcs": [
	                    [471, -324, 472, -213]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Netherlands"
	                },
	                "id": "NLD",
	                "arcs": [
	                    [-227, -63, 473]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Norway"
	                },
	                "id": "NOR",
	                "arcs": [
	                    [
	                        [474, -272, 475, 476]
	                    ],
	                    [
	                        [477]
	                    ],
	                    [
	                        [478]
	                    ],
	                    [
	                        [479]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Nepal"
	                },
	                "id": "NPL",
	                "arcs": [
	                    [-352, -176]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "New Zealand"
	                },
	                "id": "NZL",
	                "arcs": [
	                    [
	                        [480]
	                    ],
	                    [
	                        [481]
	                    ]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Oman"
	                },
	                "id": "OMN",
	                "arcs": [
	                    [
	                        [482, 483, -22, 484]
	                    ],
	                    [
	                        [-20, 485]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Pakistan"
	                },
	                "id": "PAK",
	                "arcs": [
	                    [-178, -355, 486, -358, -5]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Panama"
	                },
	                "id": "PAN",
	                "arcs": [
	                    [487, -215, 488, -208]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Peru"
	                },
	                "id": "PER",
	                "arcs": [
	                    [-167, 489, -247, -211, -106, -102]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Philippines"
	                },
	                "id": "PHL",
	                "arcs": [
	                    [
	                        [490]
	                    ],
	                    [
	                        [491]
	                    ],
	                    [
	                        [492]
	                    ],
	                    [
	                        [493]
	                    ],
	                    [
	                        [494]
	                    ],
	                    [
	                        [495]
	                    ],
	                    [
	                        [496]
	                    ]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Papua New Guinea"
	                },
	                "id": "PNG",
	                "arcs": [
	                    [
	                        [497]
	                    ],
	                    [
	                        [498]
	                    ],
	                    [
	                        [-345, 499]
	                    ],
	                    [
	                        [500]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Poland"
	                },
	                "id": "POL",
	                "arcs": [
	                    [-224, 501, 502, -428, -97, 503, 504, -221]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Puerto Rico"
	                },
	                "id": "PRI",
	                "arcs": [
	                    [505]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "North Korea"
	                },
	                "id": "PRK",
	                "arcs": [
	                    [506, 507, -405, 508, -169]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Portugal"
	                },
	                "id": "PRT",
	                "arcs": [
	                    [-259, 509]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Paraguay"
	                },
	                "id": "PRY",
	                "arcs": [
	                    [-104, -105, -26]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Qatar"
	                },
	                "id": "QAT",
	                "arcs": [
	                    [510, 511]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Romania"
	                },
	                "id": "ROU",
	                "arcs": [
	                    [512, -434, 513, 514, -81, 515, -333]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Russia"
	                },
	                "id": "RUS",
	                "arcs": [
	                    [
	                        [516]
	                    ],
	                    [
	                        [-503, 517, -425]
	                    ],
	                    [
	                        [518, 519]
	                    ],
	                    [
	                        [520]
	                    ],
	                    [
	                        [521]
	                    ],
	                    [
	                        [522]
	                    ],
	                    [
	                        [523]
	                    ],
	                    [
	                        [524]
	                    ],
	                    [
	                        [525]
	                    ],
	                    [
	                        [526, -507, -184, -447, -182, -391, 527, -59, -293, 528, 529, -95, -430, -261, 530, -269, -475, 531, -520]
	                    ],
	                    [
	                        [532]
	                    ],
	                    [
	                        [533]
	                    ],
	                    [
	                        [534]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Rwanda"
	                },
	                "id": "RWA",
	                "arcs": [
	                    [535, -61, -198, 536]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Western Sahara"
	                },
	                "id": "ESH",
	                "arcs": [
	                    [-241, -458, 537, -431]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Saudi Arabia"
	                },
	                "id": "SAU",
	                "arcs": [
	                    [538, -382, -365, -410, 539, -512, 540, -23, -484, 541]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Sudan"
	                },
	                "id": "SDN",
	                "arcs": [
	                    [542, 543, -123, 544, -421, -249, 545, -254, -268, 546]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "South Sudan"
	                },
	                "id": "SSD",
	                "arcs": [
	                    [547, -266, -396, 548, -203, -125, 549, -543]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Senegal"
	                },
	                "id": "SEN",
	                "arcs": [
	                    [550, -456, -442, -301, -306, 551, -304]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Solomon Islands"
	                },
	                "id": "SLB",
	                "arcs": [
	                    [
	                        [552]
	                    ],
	                    [
	                        [553]
	                    ],
	                    [
	                        [554]
	                    ],
	                    [
	                        [555]
	                    ],
	                    [
	                        [556]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Sierra Leone"
	                },
	                "id": "SLE",
	                "arcs": [
	                    [557, -298, -417]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "El Salvador"
	                },
	                "id": "SLV",
	                "arcs": [
	                    [558, -317, -322]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Somaliland"
	                },
	                "id": "-99",
	                "arcs": [
	                    [-263, -231, 559, 560]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Somalia"
	                },
	                "id": "SOM",
	                "arcs": [
	                    [-397, -264, -561, 561]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Republic of Serbia"
	                },
	                "id": "SRB",
	                "arcs": [
	                    [-86, -439, -407, -446, -90, -325, -334, -516]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Suriname"
	                },
	                "id": "SUR",
	                "arcs": [
	                    [562, -285, 563, -283, -110, -319]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Slovakia"
	                },
	                "id": "SVK",
	                "arcs": [
	                    [-505, 564, -331, -54, -222]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Slovenia"
	                },
	                "id": "SVN",
	                "arcs": [
	                    [-49, -335, -328, 565, -378]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Sweden"
	                },
	                "id": "SWE",
	                "arcs": [
	                    [-476, -271, 566]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Swaziland"
	                },
	                "id": "SWZ",
	                "arcs": [
	                    [567, -451]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Syria"
	                },
	                "id": "SYR",
	                "arcs": [
	                    [-381, -375, -415, 568, 569, -367]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Chad"
	                },
	                "id": "TCD",
	                "arcs": [
	                    [-469, -422, -545, -122, -195]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Togo"
	                },
	                "id": "TGO",
	                "arcs": [
	                    [570, -296, -76, -69]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Thailand"
	                },
	                "id": "THA",
	                "arcs": [
	                    [571, -462, 572, -444, -411, -400]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Tajikistan"
	                },
	                "id": "TJK",
	                "arcs": [
	                    [-398, -179, -3, 573]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Turkmenistan"
	                },
	                "id": "TKM",
	                "arcs": [
	                    [-357, 574, -389, 575, -1]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "East Timor"
	                },
	                "id": "TLS",
	                "arcs": [
	                    [576, -337]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Trinidad and Tobago"
	                },
	                "id": "TTO",
	                "arcs": [
	                    [577]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Tunisia"
	                },
	                "id": "TUN",
	                "arcs": [
	                    [-244, 578, -419]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Turkey"
	                },
	                "id": "TUR",
	                "arcs": [
	                    [
	                        [-294, -36, -361, -368, -570, 579]
	                    ],
	                    [
	                        [-311, -83, 580]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Taiwan"
	                },
	                "id": "TWN",
	                "arcs": [
	                    [581]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "United Republic of Tanzania"
	                },
	                "id": "TZA",
	                "arcs": [
	                    [-394, 582, -448, -460, 583, -199, -62, -536, 584]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Uganda"
	                },
	                "id": "UGA",
	                "arcs": [
	                    [-537, -197, -549, -395, -585]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Ukraine"
	                },
	                "id": "UKR",
	                "arcs": [
	                    [-530, 585, -514, -433, -513, -332, -565, -504, -96]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Uruguay"
	                },
	                "id": "URY",
	                "arcs": [
	                    [-113, 586, -28]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "United States of America"
	                },
	                "id": "USA",
	                "arcs": [
	                    [
	                        [587]
	                    ],
	                    [
	                        [588]
	                    ],
	                    [
	                        [589]
	                    ],
	                    [
	                        [590]
	                    ],
	                    [
	                        [591]
	                    ],
	                    [
	                        [592, -438, 593, -139]
	                    ],
	                    [
	                        [594]
	                    ],
	                    [
	                        [595]
	                    ],
	                    [
	                        [596]
	                    ],
	                    [
	                        [-141, 597]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Uzbekistan"
	                },
	                "id": "UZB",
	                "arcs": [
	                    [-576, -388, -399, -574, -2]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Venezuela"
	                },
	                "id": "VEN",
	                "arcs": [
	                    [598, -320, -108, -210]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Vietnam"
	                },
	                "id": "VNM",
	                "arcs": [
	                    [599, -402, -413, -171]
	                ]
	            }, {
	                "type": "MultiPolygon",
	                "properties": {
	                    "name": "Vanuatu"
	                },
	                "id": "VUT",
	                "arcs": [
	                    [
	                        [600]
	                    ],
	                    [
	                        [601]
	                    ]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "West Bank"
	                },
	                "id": "PSE",
	                "arcs": [
	                    [-384, -371]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Yemen"
	                },
	                "id": "YEM",
	                "arcs": [
	                    [602, -542, -483]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "South Africa"
	                },
	                "id": "ZAF",
	                "arcs": [
	                    [-467, -118, 603, -452, -568, -450, 604],
	                    [-424]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Zambia"
	                },
	                "id": "ZMB",
	                "arcs": [
	                    [-459, -454, 605, -120, -466, -7, -200, -584]
	                ]
	            }, {
	                "type": "Polygon",
	                "properties": {
	                    "name": "Zimbabwe"
	                },
	                "id": "ZWE",
	                "arcs": [
	                    [-604, -121, -606, -453]
	                ]
	            }]
	        }
	    },
	    "arcs": [
	        [
	            [6700, 7164],
	            [28, -23],
	            [21, 8],
	            [6, 27],
	            [22, 9],
	            [15, 18],
	            [6, 47],
	            [23, 11],
	            [5, 21],
	            [13, -15],
	            [8, -2]
	        ],
	        [
	            [6847, 7265],
	            [16, -1],
	            [20, -12]
	        ],
	        [
	            [6883, 7252],
	            [9, -7],
	            [20, 19],
	            [9, -12],
	            [9, 27],
	            [17, -1],
	            [4, 9],
	            [3, 24],
	            [12, 20],
	            [15, -13],
	            [-3, -18],
	            [9, -3],
	            [-3, -50],
	            [11, -19],
	            [10, 12],
	            [12, 6],
	            [17, 27],
	            [19, -5],
	            [29, 0]
	        ],
	        [
	            [7082, 7268],
	            [5, -17]
	        ],
	        [
	            [7087, 7251],
	            [-16, -6],
	            [-14, -11],
	            [-32, -7],
	            [-30, -13],
	            [-16, -25],
	            [6, -25],
	            [4, -30],
	            [-14, -25],
	            [1, -22],
	            [-8, -22],
	            [-26, 2],
	            [11, -39],
	            [-18, -15],
	            [-12, -35],
	            [2, -36],
	            [-11, -16],
	            [-10, 5],
	            [-22, -8],
	            [-3, -16],
	            [-20, 0],
	            [-16, -34],
	            [-1, -50],
	            [-36, -24],
	            [-19, 5],
	            [-6, -13],
	            [-16, 7],
	            [-28, -8],
	            [-47, 30]
	        ],
	        [
	            [6690, 6820],
	            [25, 53],
	            [-2, 38],
	            [-21, 10],
	            [-2, 38],
	            [-9, 47],
	            [12, 32],
	            [-12, 9],
	            [7, 43],
	            [12, 74]
	        ],
	        [
	            [5664, 4412],
	            [3, -18],
	            [-4, -29],
	            [5, -28],
	            [-4, -22],
	            [3, -20],
	            [-58, 1],
	            [-2, -188],
	            [19, -49],
	            [18, -37]
	        ],
	        [
	            [5644, 4022],
	            [-51, -24],
	            [-67, 9],
	            [-19, 28],
	            [-113, -3],
	            [-4, -4],
	            [-17, 27],
	            [-18, 2],
	            [-16, -10],
	            [-14, -12]
	        ],
	        [
	            [5325, 4035],
	            [-2, 38],
	            [4, 51],
	            [9, 55],
	            [2, 25],
	            [9, 53],
	            [6, 24],
	            [16, 39],
	            [9, 26],
	            [3, 44],
	            [-1, 34],
	            [-9, 21],
	            [-7, 36],
	            [-7, 35],
	            [2, 12],
	            [8, 24],
	            [-8, 57],
	            [-6, 39],
	            [-14, 38],
	            [3, 11]
	        ],
	        [
	            [5342, 4697],
	            [11, 8],
	            [8, -1],
	            [10, 7],
	            [82, -1],
	            [7, -44],
	            [8, -35],
	            [6, -19],
	            [11, -31],
	            [18, 5],
	            [9, 8],
	            [16, -8],
	            [4, 14],
	            [7, 35],
	            [17, 2],
	            [2, 10],
	            [14, 1],
	            [-3, -22],
	            [34, 1],
	            [1, -37],
	            [5, -23],
	            [-4, -36],
	            [2, -36],
	            [9, -22],
	            [-1, -70],
	            [7, 5],
	            [12, -1],
	            [17, 8],
	            [13, -3]
	        ],
	        [
	            [5338, 4715],
	            [-8, 45]
	        ],
	        [
	            [5330, 4760],
	            [12, 25],
	            [8, 10],
	            [10, -20]
	        ],
	        [
	            [5360, 4775],
	            [-10, -12],
	            [-4, -16],
	            [-1, -25],
	            [-7, -7]
	        ],
	        [
	            [5571, 7530],
	            [-3, -20],
	            [4, -25],
	            [11, -15]
	        ],
	        [
	            [5583, 7470],
	            [0, -15],
	            [-9, -9],
	            [-2, -19],
	            [-13, -29]
	        ],
	        [
	            [5559, 7398],
	            [-5, 5],
	            [0, 13],
	            [-15, 19],
	            [-3, 29],
	            [2, 40],
	            [4, 18],
	            [-4, 10]
	        ],
	        [
	            [5538, 7532],
	            [-2, 18],
	            [12, 29],
	            [1, -11],
	            [8, 6]
	        ],
	        [
	            [5557, 7574],
	            [6, -16],
	            [7, -6],
	            [1, -22]
	        ],
	        [
	            [6432, 6490],
	            [5, 3],
	            [1, -16],
	            [22, 9],
	            [23, -2],
	            [17, -1],
	            [19, 39],
	            [20, 38],
	            [18, 37]
	        ],
	        [
	            [6557, 6597],
	            [5, -20]
	        ],
	        [
	            [6562, 6577],
	            [4, -47]
	        ],
	        [
	            [6566, 6530],
	            [-14, 0],
	            [-3, -39],
	            [5, -8],
	            [-12, -12],
	            [0, -24],
	            [-8, -24],
	            [-1, -24]
	        ],
	        [
	            [6533, 6399],
	            [-6, -12],
	            [-83, 29],
	            [-11, 60],
	            [-1, 14]
	        ],
	        [
	            [3140, 1814],
	            [-17, 2],
	            [-30, 0],
	            [0, 132]
	        ],
	        [
	            [3093, 1948],
	            [11, -27],
	            [14, -45],
	            [36, -35],
	            [39, -15],
	            [-13, -30],
	            [-26, -2],
	            [-14, 20]
	        ],
	        [
	            [3258, 3743],
	            [51, -96],
	            [23, -9],
	            [34, -44],
	            [29, -23],
	            [4, -26],
	            [-28, -90],
	            [28, -16],
	            [32, -9],
	            [22, 10],
	            [25, 45],
	            [4, 52]
	        ],
	        [
	            [3482, 3537],
	            [14, 11],
	            [14, -34],
	            [-1, -47],
	            [-23, -33],
	            [-19, -24],
	            [-31, -57],
	            [-37, -81]
	        ],
	        [
	            [3399, 3272],
	            [-7, -47],
	            [-7, -61],
	            [0, -58],
	            [-6, -14],
	            [-2, -38]
	        ],
	        [
	            [3377, 3054],
	            [-2, -31],
	            [35, -50],
	            [-4, -41],
	            [18, -26],
	            [-2, -29],
	            [-26, -75],
	            [-42, -32],
	            [-55, -12],
	            [-31, 6],
	            [6, -36],
	            [-6, -44],
	            [5, -30],
	            [-16, -20],
	            [-29, -8],
	            [-26, 21],
	            [-11, -15],
	            [4, -59],
	            [18, -18],
	            [16, 19],
	            [8, -31],
	            [-26, -18],
	            [-22, -37],
	            [-4, -59],
	            [-7, -32],
	            [-26, 0],
	            [-22, -31],
	            [-8, -44],
	            [28, -43],
	            [26, -12],
	            [-9, -53],
	            [-33, -33],
	            [-18, -70],
	            [-25, -23],
	            [-12, -28],
	            [9, -61],
	            [19, -34],
	            [-12, 3]
	        ],
	        [
	            [3095, 1968],
	            [-26, 9],
	            [-67, 8],
	            [-11, 34],
	            [0, 45],
	            [-18, -4],
	            [-10, 21],
	            [-3, 63],
	            [22, 26],
	            [9, 37],
	            [-4, 30],
	            [15, 51],
	            [10, 78],
	            [-3, 35],
	            [12, 11],
	            [-3, 22],
	            [-13, 12],
	            [10, 25],
	            [-13, 22],
	            [-6, 68],
	            [11, 12],
	            [-5, 72],
	            [7, 61],
	            [7, 52],
	            [17, 22],
	            [-9, 58],
	            [0, 54],
	            [21, 38],
	            [-1, 50],
	            [16, 57],
	            [0, 55],
	            [-7, 11],
	            [-13, 102],
	            [17, 60],
	            [-2, 58],
	            [10, 53],
	            [18, 56],
	            [20, 36],
	            [-9, 24],
	            [6, 19],
	            [-1, 98],
	            [30, 29],
	            [10, 62],
	            [-3, 14]
	        ],
	        [
	            [3136, 3714],
	            [23, 54],
	            [36, -15],
	            [16, -42],
	            [11, 47],
	            [32, -2],
	            [4, -13]
	        ],
	        [
	            [6210, 7485],
	            [39, 9]
	        ],
	        [
	            [6249, 7494],
	            [5, -15],
	            [11, -10],
	            [-6, -15],
	            [15, -21],
	            [-8, -18],
	            [12, -16],
	            [13, -10],
	            [0, -41]
	        ],
	        [
	            [6291, 7348],
	            [-10, -2]
	        ],
	        [
	            [6281, 7346],
	            [-11, 34],
	            [0, 10],
	            [-12, -1],
	            [-9, 16],
	            [-5, -1]
	        ],
	        [
	            [6244, 7404],
	            [-11, 17],
	            [-21, 15],
	            [3, 28],
	            [-5, 21]
	        ],
	        [
	            [3345, 329],
	            [-8, -30],
	            [-8, -27],
	            [-59, 8],
	            [-62, -3],
	            [-34, 20],
	            [0, 2],
	            [-16, 17],
	            [63, -2],
	            [60, -6],
	            [20, 24],
	            [15, 21],
	            [29, -24]
	        ],
	        [
	            [577, 361],
	            [-53, -8],
	            [-36, 21],
	            [-17, 21],
	            [-1, 3],
	            [-18, 16],
	            [17, 22],
	            [52, -9],
	            [28, -18],
	            [21, -21],
	            [7, -27]
	        ],
	        [
	            [3745, 447],
	            [35, -26],
	            [12, -36],
	            [3, -25],
	            [1, -30],
	            [-43, -19],
	            [-45, -15],
	            [-52, -14],
	            [-59, -11],
	            [-65, 3],
	            [-37, 20],
	            [5, 24],
	            [59, 16],
	            [24, 20],
	            [18, 26],
	            [12, 22],
	            [17, 20],
	            [18, 25],
	            [14, 0],
	            [41, 12],
	            [42, -12]
	        ],
	        [
	            [1633, 715],
	            [36, -9],
	            [33, 10],
	            [-16, -20],
	            [-26, -15],
	            [-39, 4],
	            [-27, 21],
	            [6, 20],
	            [33, -11]
	        ],
	        [
	            [1512, 716],
	            [43, -23],
	            [-17, 3],
	            [-36, 5],
	            [-38, 17],
	            [20, 12],
	            [28, -14]
	        ],
	        [
	            [2250, 808],
	            [31, -8],
	            [30, 7],
	            [17, -34],
	            [-22, 5],
	            [-34, -2],
	            [-34, 2],
	            [-38, -4],
	            [-28, 12],
	            [-15, 24],
	            [18, 11],
	            [35, -8],
	            [40, -5]
	        ],
	        [
	            [3098, 866],
	            [4, -27],
	            [-5, -23],
	            [-8, -22],
	            [-33, -8],
	            [-31, -12],
	            [-36, 1],
	            [14, 24],
	            [-33, -9],
	            [-31, -8],
	            [-21, 18],
	            [-2, 24],
	            [30, 23],
	            [20, 7],
	            [32, -2],
	            [8, 30],
	            [1, 22],
	            [0, 47],
	            [16, 28],
	            [25, 9],
	            [15, -22],
	            [6, -22],
	            [12, -26],
	            [10, -26],
	            [7, -26]
	        ],
	        [
	            [3371, 1268],
	            [-11, -13],
	            [-21, 9],
	            [-23, -6],
	            [-19, -14],
	            [-20, -15],
	            [-14, -17],
	            [-4, -23],
	            [2, -22],
	            [13, -20],
	            [-19, -14],
	            [-26, -4],
	            [-15, -20],
	            [-17, -19],
	            [-17, -25],
	            [-4, -22],
	            [9, -24],
	            [15, -19],
	            [23, -14],
	            [21, -18],
	            [12, -23],
	            [6, -22],
	            [8, -24],
	            [13, -19],
	            [8, -22],
	            [4, -55],
	            [8, -22],
	            [2, -23],
	            [9, -23],
	            [-4, -31],
	            [-15, -24],
	            [-17, -20],
	            [-37, -8],
	            [-12, -21],
	            [-17, -20],
	            [-42, -22],
	            [-37, -9],
	            [-35, -13],
	            [-37, -13],
	            [-22, -24],
	            [-45, -2],
	            [-49, 2],
	            [-44, -4],
	            [-47, 0],
	            [9, -24],
	            [42, -10],
	            [31, -16],
	            [18, -21],
	            [-31, -19],
	            [-48, 6],
	            [-40, -15],
	            [-2, -24],
	            [-1, -23],
	            [33, -20],
	            [6, -22],
	            [35, -22],
	            [59, -9],
	            [50, -16],
	            [40, -19],
	            [50, -18],
	            [70, -10],
	            [68, -16],
	            [47, -17],
	            [52, -20],
	            [27, -28],
	            [13, -22],
	            [34, 21],
	            [46, 17],
	            [48, 19],
	            [58, 15],
	            [49, 16],
	            [69, 1],
	            [68, -8],
	            [56, -14],
	            [18, 26],
	            [39, 17],
	            [70, 1],
	            [55, 13],
	            [52, 13],
	            [58, 8],
	            [62, 10],
	            [43, 15],
	            [-20, 21],
	            [-12, 21],
	            [0, 22],
	            [-54, -2],
	            [-57, -10],
	            [-54, 0],
	            [-8, 22],
	            [4, 44],
	            [12, 13],
	            [40, 14],
	            [47, 14],
	            [34, 17],
	            [33, 18],
	            [25, 23],
	            [38, 10],
	            [38, 8],
	            [19, 5],
	            [43, 2],
	            [41, 8],
	            [34, 12],
	            [34, 14],
	            [30, 14],
	            [39, 18],
	            [24, 20],
	            [26, 17],
	            [9, 24],
	            [-30, 13],
	            [10, 25],
	            [18, 18],
	            [29, 12],
	            [31, 14],
	            [28, 18],
	            [22, 23],
	            [13, 28],
	            [21, 16],
	            [33, -3],
	            [13, -20],
	            [34, -2],
	            [1, 22],
	            [14, 23],
	            [30, -6],
	            [7, -22],
	            [33, -3],
	            [36, 10],
	            [35, 7],
	            [31, -3],
	            [12, -25],
	            [31, 20],
	            [28, 10],
	            [31, 9],
	            [31, 8],
	            [29, 14],
	            [31, 9],
	            [24, 13],
	            [17, 20],
	            [20, -15],
	            [29, 8],
	            [20, -27],
	            [16, -21],
	            [32, 11],
	            [12, 24],
	            [28, 16],
	            [37, -4],
	            [11, -22],
	            [22, 22],
	            [30, 7],
	            [33, 3],
	            [29, -2],
	            [31, -7],
	            [30, -3],
	            [13, -20],
	            [18, -17],
	            [31, 10],
	            [32, 3],
	            [32, 0],
	            [31, 1],
	            [28, 8],
	            [29, 7],
	            [25, 16],
	            [26, 11],
	            [28, 5],
	            [21, 17],
	            [15, 32],
	            [16, 20],
	            [29, -10],
	            [11, -21],
	            [24, -13],
	            [29, 4],
	            [19, -21],
	            [21, -15],
	            [28, 14],
	            [10, 26],
	            [25, 10],
	            [29, 20],
	            [27, 8],
	            [33, 11],
	            [22, 13],
	            [22, 14],
	            [22, 13],
	            [26, -7],
	            [25, 21],
	            [18, 16],
	            [26, -1],
	            [23, 14],
	            [6, 21],
	            [23, 16],
	            [23, 11],
	            [28, 10],
	            [25, 4],
	            [25, -3],
	            [26, -6],
	            [22, -16],
	            [3, -26],
	            [24, -19],
	            [17, -17],
	            [33, -7],
	            [19, -16],
	            [23, -16],
	            [26, -3],
	            [23, 11],
	            [24, 24],
	            [26, -12],
	            [27, -7],
	            [26, -7],
	            [27, -5],
	            [28, 0],
	            [23, -61],
	            [-1, -15],
	            [-4, -27],
	            [-26, -15],
	            [-22, -22],
	            [4, -23],
	            [31, 1],
	            [-4, -23],
	            [-14, -22],
	            [-13, -24],
	            [21, -19],
	            [32, -6],
	            [32, 11],
	            [15, 23],
	            [10, 22],
	            [15, 18],
	            [17, 18],
	            [7, 21],
	            [15, 29],
	            [18, 5],
	            [31, 3],
	            [28, 7],
	            [28, 9],
	            [14, 23],
	            [8, 22],
	            [19, 22],
	            [27, 15],
	            [23, 12],
	            [16, 19],
	            [15, 11],
	            [21, 9],
	            [27, -6],
	            [25, 6],
	            [28, 7],
	            [30, -4],
	            [20, 17],
	            [14, 39],
	            [11, -16],
	            [13, -28],
	            [23, -12],
	            [27, -4],
	            [26, 7],
	            [29, -5],
	            [26, -1],
	            [17, 6],
	            [24, -4],
	            [21, -12],
	            [25, 8],
	            [30, 0],
	            [25, 8],
	            [29, -8],
	            [19, 19],
	            [14, 20],
	            [19, 16],
	            [35, 44],
	            [18, -8],
	            [21, -16],
	            [18, -21],
	            [36, -36],
	            [27, -1],
	            [25, 0],
	            [30, 7],
	            [30, 8],
	            [23, 16],
	            [19, 18],
	            [31, 2],
	            [21, 13],
	            [22, -12],
	            [14, -18],
	            [19, -19],
	            [31, 2],
	            [19, -15],
	            [33, -15],
	            [35, -5],
	            [29, 4],
	            [21, 19],
	            [19, 18],
	            [25, 5],
	            [25, -8],
	            [29, -6],
	            [26, 9],
	            [25, 0],
	            [24, -6],
	            [26, -5],
	            [25, 10],
	            [30, 9],
	            [28, 3],
	            [32, 0],
	            [25, 5],
	            [25, 5],
	            [8, 29],
	            [1, 24],
	            [17, -16],
	            [5, -27],
	            [10, -24],
	            [11, -20],
	            [23, -10],
	            [32, 4],
	            [36, 1],
	            [25, 3],
	            [37, 0],
	            [26, 1],
	            [36, -2],
	            [31, -5],
	            [20, -18],
	            [-5, -22],
	            [18, -18],
	            [30, -13],
	            [31, -15],
	            [35, -11],
	            [38, -9],
	            [28, -9],
	            [32, -2],
	            [18, 20],
	            [24, -16],
	            [21, -19],
	            [25, -13],
	            [34, -6],
	            [32, -7],
	            [13, -23],
	            [32, -14],
	            [21, -21],
	            [31, -9],
	            [32, 1],
	            [30, -4],
	            [33, 1],
	            [34, -4],
	            [31, -8],
	            [28, -14],
	            [29, -12],
	            [20, -17],
	            [-3, -23],
	            [-15, -21],
	            [-13, -27],
	            [-9, -21],
	            [-14, -24],
	            [-36, -9],
	            [-16, -21],
	            [-36, -13],
	            [-13, -23],
	            [-19, -22],
	            [-20, -18],
	            [-11, -25],
	            [-7, -22],
	            [-3, -26],
	            [0, -22],
	            [16, -23],
	            [6, -22],
	            [13, -21],
	            [52, -8],
	            [11, -26],
	            [-50, -9],
	            [-43, -13],
	            [-52, -2],
	            [-24, -34],
	            [-5, -27],
	            [-12, -22],
	            [-14, -22],
	            [37, -20],
	            [14, -24],
	            [24, -22],
	            [33, -20],
	            [39, -19],
	            [42, -18],
	            [64, -19],
	            [14, -29],
	            [80, -12],
	            [5, -5],
	            [21, -17],
	            [77, 15],
	            [63, -19],
	            [48, -14],
	            [-9997, -1],
	            [24, 35],
	            [50, -19],
	            [3, 2],
	            [30, 19],
	            [4, 0],
	            [3, -1],
	            [40, -25],
	            [35, 25],
	            [7, 3],
	            [81, 11],
	            [27, -14],
	            [13, -7],
	            [41, -20],
	            [79, -15],
	            [63, -18],
	            [107, -14],
	            [80, 16],
	            [118, -11],
	            [67, -19],
	            [73, 17],
	            [78, 17],
	            [6, 27],
	            [-110, 3],
	            [-89, 14],
	            [-24, 23],
	            [-74, 12],
	            [5, 27],
	            [10, 24],
	            [10, 22],
	            [-5, 25],
	            [-46, 16],
	            [-22, 21],
	            [-43, 18],
	            [68, -3],
	            [64, 9],
	            [40, -20],
	            [50, 18],
	            [45, 22],
	            [23, 19],
	            [-10, 25],
	            [-36, 16],
	            [-41, 17],
	            [-57, 4],
	            [-50, 8],
	            [-54, 6],
	            [-18, 22],
	            [-36, 18],
	            [-21, 21],
	            [-9, 67],
	            [14, -6],
	            [25, -18],
	            [45, 6],
	            [44, 8],
	            [23, -26],
	            [44, 6],
	            [37, 13],
	            [35, 16],
	            [32, 20],
	            [41, 5],
	            [-1, 22],
	            [-9, 22],
	            [8, 21],
	            [36, 11],
	            [16, -20],
	            [42, 12],
	            [32, 15],
	            [40, 1],
	            [38, 6],
	            [37, 13],
	            [30, 13],
	            [34, 13],
	            [22, -4],
	            [19, -4],
	            [41, 8],
	            [37, -10],
	            [38, 1],
	            [37, 8],
	            [37, -6],
	            [41, -6],
	            [39, 3],
	            [40, -2],
	            [42, -1],
	            [38, 3],
	            [28, 17],
	            [34, 9],
	            [35, -13],
	            [33, 11],
	            [30, 21],
	            [18, -19],
	            [9, -21],
	            [18, -19],
	            [29, 17],
	            [33, -22],
	            [38, -7],
	            [32, -16],
	            [39, 3],
	            [36, 11],
	            [41, -3],
	            [38, -8],
	            [38, -10],
	            [15, 25],
	            [-18, 20],
	            [-14, 21],
	            [-36, 5],
	            [-15, 22],
	            [-6, 22],
	            [-10, 43],
	            [21, -8],
	            [36, -3],
	            [36, 3],
	            [33, -9],
	            [28, -17],
	            [12, -21],
	            [38, -4],
	            [36, 9],
	            [38, 11],
	            [34, 7],
	            [28, -14],
	            [37, 5],
	            [24, 45],
	            [23, -27],
	            [32, -10],
	            [34, 6],
	            [23, -23],
	            [37, -3],
	            [33, -7],
	            [34, -12],
	            [21, 22],
	            [11, 20],
	            [28, -23],
	            [38, 6],
	            [28, -13],
	            [19, -19],
	            [37, 5],
	            [29, 13],
	            [29, 15],
	            [33, 8],
	            [39, 7],
	            [36, 8],
	            [27, 13],
	            [16, 19],
	            [7, 25],
	            [-3, 24],
	            [-9, 24],
	            [-10, 23],
	            [-9, 23],
	            [-7, 21],
	            [-1, 23],
	            [2, 23],
	            [13, 22],
	            [11, 24],
	            [5, 23],
	            [-6, 26],
	            [-3, 23],
	            [14, 27],
	            [15, 17],
	            [18, 22],
	            [19, 19],
	            [22, 17],
	            [11, 25],
	            [15, 17],
	            [18, 15],
	            [26, 3],
	            [18, 19],
	            [19, 11],
	            [23, 7],
	            [20, 15],
	            [16, 19],
	            [22, 7],
	            [16, -15],
	            [-10, -20],
	            [-29, -17]
	        ],
	        [
	            [6914, 2185],
	            [18, -19],
	            [26, -7],
	            [1, -11],
	            [-7, -27],
	            [-43, -4],
	            [-1, 31],
	            [4, 25],
	            [2, 12]
	        ],
	        [
	            [9038, 2648],
	            [27, -21],
	            [15, 8],
	            [22, 12],
	            [16, -4],
	            [2, -70],
	            [-9, -21],
	            [-3, -47],
	            [-10, 16],
	            [-19, -41],
	            [-6, 3],
	            [-17, 2],
	            [-17, 50],
	            [-4, 39],
	            [-16, 52],
	            [1, 27],
	            [18, -5]
	        ],
	        [
	            [8987, 4244],
	            [10, -46],
	            [18, 22],
	            [9, -25],
	            [13, -23],
	            [-3, -26],
	            [6, -51],
	            [5, -29],
	            [7, -7],
	            [7, -51],
	            [-3, -30],
	            [9, -40],
	            [31, -31],
	            [19, -28],
	            [19, -26],
	            [-4, -14],
	            [16, -37],
	            [11, -64],
	            [11, 13],
	            [11, -26],
	            [7, 9],
	            [5, -63],
	            [19, -36],
	            [13, -22],
	            [22, -48],
	            [8, -48],
	            [1, -33],
	            [-2, -37],
	            [13, -50],
	            [-2, -52],
	            [-5, -28],
	            [-7, -52],
	            [1, -34],
	            [-6, -43],
	            [-12, -53],
	            [-21, -29],
	            [-10, -46],
	            [-9, -29],
	            [-8, -51],
	            [-11, -30],
	            [-7, -44],
	            [-4, -41],
	            [2, -18],
	            [-16, -21],
	            [-31, -2],
	            [-26, -24],
	            [-13, -23],
	            [-17, -26],
	            [-23, 27],
	            [-17, 10],
	            [5, 31],
	            [-15, -11],
	            [-25, -43],
	            [-24, 16],
	            [-15, 9],
	            [-16, 4],
	            [-27, 17],
	            [-18, 37],
	            [-5, 45],
	            [-7, 30],
	            [-13, 24],
	            [-27, 7],
	            [9, 28],
	            [-7, 44],
	            [-13, -41],
	            [-25, -11],
	            [14, 33],
	            [5, 34],
	            [10, 29],
	            [-2, 44],
	            [-22, -50],
	            [-18, -21],
	            [-10, -47],
	            [-22, 25],
	            [1, 31],
	            [-18, 43],
	            [-14, 22],
	            [5, 14],
	            [-36, 35],
	            [-19, 2],
	            [-27, 29],
	            [-50, -6],
	            [-36, -21],
	            [-31, -20],
	            [-27, 4],
	            [-29, -30],
	            [-24, -14],
	            [-6, -31],
	            [-10, -24],
	            [-23, -1],
	            [-18, -5],
	            [-24, 10],
	            [-20, -6],
	            [-19, -3],
	            [-17, -31],
	            [-8, 2],
	            [-14, -16],
	            [-13, -19],
	            [-21, 2],
	            [-18, 0],
	            [-30, 38],
	            [-15, 11],
	            [1, 34],
	            [14, 8],
	            [4, 14],
	            [-1, 21],
	            [4, 41],
	            [-3, 35],
	            [-15, 60],
	            [-4, 33],
	            [1, 34],
	            [-11, 38],
	            [-1, 18],
	            [-12, 23],
	            [-4, 47],
	            [-16, 46],
	            [-4, 26],
	            [13, -26],
	            [-10, 55],
	            [14, -17],
	            [8, -23],
	            [0, 30],
	            [-14, 47],
	            [-3, 18],
	            [-6, 18],
	            [3, 34],
	            [6, 15],
	            [4, 29],
	            [-3, 35],
	            [11, 42],
	            [2, -45],
	            [12, 41],
	            [22, 20],
	            [14, 25],
	            [21, 22],
	            [13, 4],
	            [7, -7],
	            [22, 22],
	            [17, 6],
	            [4, 13],
	            [8, 6],
	            [15, -2],
	            [29, 18],
	            [15, 26],
	            [7, 31],
	            [17, 30],
	            [1, 24],
	            [1, 32],
	            [19, 50],
	            [12, -51],
	            [12, 12],
	            [-10, 28],
	            [9, 29],
	            [12, -13],
	            [3, 45],
	            [15, 29],
	            [7, 23],
	            [14, 10],
	            [0, 17],
	            [13, -7],
	            [0, 15],
	            [12, 8],
	            [14, 8],
	            [20, -27],
	            [16, -35],
	            [17, 0],
	            [18, -6],
	            [-6, 33],
	            [13, 47],
	            [13, 15],
	            [-5, 15],
	            [12, 34],
	            [17, 21],
	            [14, -7],
	            [24, 11],
	            [-1, 30],
	            [-20, 19],
	            [15, 9],
	            [18, -15],
	            [15, -24],
	            [23, -15],
	            [8, 6],
	            [17, -18],
	            [17, 17],
	            [10, -5],
	            [7, 11],
	            [12, -29],
	            [-7, -32],
	            [-11, -24],
	            [-9, -2],
	            [3, -23],
	            [-8, -30],
	            [-10, -29],
	            [2, -17],
	            [22, -32],
	            [21, -19],
	            [15, -20],
	            [20, -35],
	            [8, 0],
	            [14, -15],
	            [4, -19],
	            [27, -20],
	            [18, 20],
	            [6, 32],
	            [5, 26],
	            [4, 33],
	            [8, 47],
	            [-4, 28],
	            [2, 17],
	            [-3, 34],
	            [4, 45],
	            [5, 12],
	            [-4, 20],
	            [7, 31],
	            [5, 32],
	            [1, 17],
	            [10, 22],
	            [8, -29],
	            [2, -37],
	            [7, -7],
	            [1, -25],
	            [10, -30],
	            [2, -33],
	            [-1, -22]
	        ],
	        [
	            [5471, 7900],
	            [-2, -24],
	            [-16, 0],
	            [6, -13],
	            [-9, -38]
	        ],
	        [
	            [5450, 7825],
	            [-6, -10],
	            [-24, -1],
	            [-14, -13],
	            [-23, 4]
	        ],
	        [
	            [5383, 7805],
	            [-40, 15],
	            [-6, 21],
	            [-27, -10],
	            [-4, -12],
	            [-16, 9]
	        ],
	        [
	            [5290, 7828],
	            [-15, 1],
	            [-12, 11],
	            [4, 15],
	            [-1, 10]
	        ],
	        [
	            [5266, 7865],
	            [8, 3],
	            [14, -16],
	            [4, 16],
	            [25, -3],
	            [20, 11],
	            [13, -2],
	            [9, -12],
	            [2, 10],
	            [-4, 38],
	            [10, 8],
	            [10, 27]
	        ],
	        [
	            [5377, 7945],
	            [21, -19],
	            [15, 24],
	            [10, 5],
	            [22, -18],
	            [13, 3],
	            [13, -12]
	        ],
	        [
	            [5471, 7928],
	            [-3, -7],
	            [3, -21]
	        ],
	        [
	            [6281, 7346],
	            [-19, 8],
	            [-14, 27],
	            [-4, 23]
	        ],
	        [
	            [6349, 7527],
	            [15, -31],
	            [14, -42],
	            [13, -2],
	            [8, -16],
	            [-23, -5],
	            [-5, -46],
	            [-4, -21],
	            [-11, -13],
	            [1, -30]
	        ],
	        [
	            [6357, 7321],
	            [-7, -3],
	            [-17, 31],
	            [10, 30],
	            [-9, 17],
	            [-10, -4],
	            [-33, -44]
	        ],
	        [
	            [6249, 7494],
	            [6, 10],
	            [21, -17],
	            [15, -4],
	            [4, 7],
	            [-14, 32],
	            [7, 9]
	        ],
	        [
	            [6288, 7531],
	            [8, -2],
	            [19, -36],
	            [13, -4],
	            [4, 15],
	            [17, 23]
	        ],
	        [
	            [5814, 4792],
	            [-1, 71],
	            [-7, 27]
	        ],
	        [
	            [5806, 4890],
	            [17, -5],
	            [8, 34],
	            [15, -4]
	        ],
	        [
	            [5846, 4915],
	            [1, -23],
	            [6, -14],
	            [1, -19],
	            [-7, -12],
	            [-11, -31],
	            [-10, -22],
	            [-12, -2]
	        ],
	        [
	            [5092, 8091],
	            [20, -5],
	            [26, 12],
	            [17, -25],
	            [16, -14]
	        ],
	        [
	            [5171, 8059],
	            [-4, -40]
	        ],
	        [
	            [5167, 8019],
	            [-7, -2],
	            [-3, -33]
	        ],
	        [
	            [5157, 7984],
	            [-24, 26],
	            [-14, -4],
	            [-20, 28],
	            [-13, 23],
	            [-13, 1],
	            [-4, 21]
	        ],
	        [
	            [5069, 8079],
	            [23, 12]
	        ],
	        [
	            [5074, 5427],
	            [-23, -7]
	        ],
	        [
	            [5051, 5420],
	            [-7, 41],
	            [2, 136],
	            [-6, 12],
	            [-1, 29],
	            [-10, 21],
	            [-8, 17],
	            [3, 31]
	        ],
	        [
	            [5024, 5707],
	            [10, 7],
	            [6, 26],
	            [13, 5],
	            [6, 18]
	        ],
	        [
	            [5059, 5763],
	            [10, 17],
	            [10, 0],
	            [21, -34]
	        ],
	        [
	            [5100, 5746],
	            [-1, -19],
	            [6, -35],
	            [-6, -24],
	            [3, -16],
	            [-13, -37],
	            [-9, -18],
	            [-5, -37],
	            [1, -38],
	            [-2, -95]
	        ],
	        [
	            [4921, 5627],
	            [-19, 15],
	            [-13, -2],
	            [-10, -15],
	            [-12, 13],
	            [-5, 19],
	            [-13, 13]
	        ],
	        [
	            [4849, 5670],
	            [-1, 34],
	            [7, 26],
	            [-1, 20],
	            [23, 48],
	            [4, 41],
	            [7, 14],
	            [14, -8],
	            [11, 12],
	            [4, 16],
	            [22, 26],
	            [5, 19],
	            [26, 24],
	            [15, 9],
	            [7, -12],
	            [18, 0]
	        ],
	        [
	            [5010, 5939],
	            [-2, -28],
	            [3, -27],
	            [16, -39],
	            [1, -28],
	            [32, -14],
	            [-1, -40]
	        ],
	        [
	            [5024, 5707],
	            [-24, 1]
	        ],
	        [
	            [5000, 5708],
	            [-13, 5],
	            [-9, -9],
	            [-12, 4],
	            [-48, -3],
	            [-1, -33],
	            [4, -45]
	        ],
	        [
	            [7573, 6360],
	            [0, -43],
	            [-10, 9],
	            [2, -47]
	        ],
	        [
	            [7565, 6279],
	            [-8, 30],
	            [-1, 31],
	            [-6, 28],
	            [-11, 34],
	            [-26, 3],
	            [3, -25],
	            [-9, -32],
	            [-12, 12],
	            [-4, -11],
	            [-8, 6],
	            [-11, 5]
	        ],
	        [
	            [7472, 6360],
	            [-4, 49],
	            [-10, 45],
	            [5, 35],
	            [-17, 16],
	            [6, 22],
	            [18, 22],
	            [-20, 31],
	            [9, 40],
	            [22, -26],
	            [14, -3],
	            [2, -41],
	            [26, -8],
	            [26, 1],
	            [16, -10],
	            [-13, -50],
	            [-12, -3],
	            [-9, -34],
	            [16, -31],
	            [4, 38],
	            [8, 0],
	            [14, -93]
	        ],
	        [
	            [5629, 7671],
	            [8, -25],
	            [11, 5],
	            [21, -9],
	            [41, -4],
	            [13, 16],
	            [33, 13],
	            [20, -21],
	            [17, -6]
	        ],
	        [
	            [5793, 7640],
	            [-15, -25],
	            [-10, -42],
	            [9, -34]
	        ],
	        [
	            [5777, 7539],
	            [-24, 8],
	            [-28, -18]
	        ],
	        [
	            [5725, 7529],
	            [0, -30],
	            [-26, -5],
	            [-19, 20],
	            [-22, -16],
	            [-21, 2]
	        ],
	        [
	            [5637, 7500],
	            [-2, 39],
	            [-14, 19]
	        ],
	        [
	            [5621, 7558],
	            [5, 8],
	            [-3, 7],
	            [4, 19],
	            [11, 18],
	            [-14, 26],
	            [-2, 21],
	            [7, 14]
	        ],
	        [
	            [2846, 6461],
	            [-7, -3],
	            [-7, 34],
	            [-10, 17],
	            [6, 38],
	            [8, -3],
	            [10, -49],
	            [0, -34]
	        ],
	        [
	            [2838, 6628],
	            [-30, -10],
	            [-2, 22],
	            [13, 5],
	            [18, -2],
	            [1, -15]
	        ],
	        [
	            [2861, 6628],
	            [-5, -42],
	            [-5, 8],
	            [0, 31],
	            [-12, 23],
	            [0, 7],
	            [22, -27]
	        ],
	        [
	            [5527, 7708],
	            [10, 0],
	            [-7, -26],
	            [14, -23],
	            [-4, -28],
	            [-7, -2]
	        ],
	        [
	            [5533, 7629],
	            [-5, -6],
	            [-9, -13],
	            [-4, -33]
	        ],
	        [
	            [5515, 7577],
	            [-25, 23],
	            [-10, 24],
	            [-11, 13],
	            [-12, 22],
	            [-6, 19],
	            [-14, 27],
	            [6, 25],
	            [10, -14],
	            [6, 12],
	            [13, 2],
	            [24, -10],
	            [19, 1],
	            [12, -13]
	        ],
	        [
	            [5652, 8242],
	            [27, 0],
	            [30, 22],
	            [6, 34],
	            [23, 19],
	            [-3, 26]
	        ],
	        [
	            [5735, 8343],
	            [17, 10],
	            [30, 23]
	        ],
	        [
	            [5782, 8376],
	            [29, -15],
	            [4, -15],
	            [15, 7],
	            [27, -14],
	            [3, -27],
	            [-6, -16],
	            [17, -39],
	            [12, -11],
	            [-2, -11],
	            [19, -10],
	            [8, -16],
	            [-11, -13],
	            [-23, 2],
	            [-5, -5],
	            [7, -20],
	            [6, -37]
	        ],
	        [
	            [5882, 8136],
	            [-23, -4],
	            [-9, -13],
	            [-2, -30],
	            [-11, 6],
	            [-25, -3],
	            [-7, 14],
	            [-11, -10],
	            [-10, 8],
	            [-22, 1],
	            [-31, 15],
	            [-28, 4],
	            [-22, -1],
	            [-15, -16],
	            [-13, -2]
	        ],
	        [
	            [5653, 8105],
	            [-1, 26],
	            [-8, 27],
	            [17, 12],
	            [0, 24],
	            [-8, 22],
	            [-1, 26]
	        ],
	        [
	            [2524, 6110],
	            [-1, 8],
	            [4, 3],
	            [5, -7],
	            [10, 36],
	            [5, 0]
	        ],
	        [
	            [2547, 6150],
	            [0, -8],
	            [5, -1],
	            [0, -16],
	            [-5, -25],
	            [3, -9],
	            [-3, -21],
	            [2, -6],
	            [-4, -30],
	            [-5, -16],
	            [-5, -1],
	            [-6, -21]
	        ],
	        [
	            [2529, 5996],
	            [-8, 0],
	            [2, 67],
	            [1, 47]
	        ],
	        [
	            [3136, 3714],
	            [-20, -8],
	            [-11, 82],
	            [-15, 66],
	            [9, 57],
	            [-15, 25],
	            [-4, 43],
	            [-13, 40]
	        ],
	        [
	            [3067, 4019],
	            [17, 64],
	            [-12, 49],
	            [7, 20],
	            [-5, 22],
	            [10, 30],
	            [1, 50],
	            [1, 41],
	            [6, 20],
	            [-24, 96]
	        ],
	        [
	            [3068, 4411],
	            [21, -5],
	            [14, 1],
	            [6, 18],
	            [25, 24],
	            [14, 22],
	            [37, 10],
	            [-3, -44],
	            [3, -23],
	            [-2, -40],
	            [30, -53],
	            [31, -9],
	            [11, -23],
	            [19, -11],
	            [11, -17],
	            [18, 0],
	            [16, -17],
	            [1, -34],
	            [6, -18],
	            [0, -25],
	            [-8, -1],
	            [11, -69],
	            [53, -2],
	            [-4, -35],
	            [3, -23],
	            [15, -16],
	            [6, -37],
	            [-4, -47],
	            [-8, -26],
	            [3, -33],
	            [-9, -12]
	        ],
	        [
	            [3384, 3866],
	            [-1, 18],
	            [-25, 30],
	            [-26, 1],
	            [-49, -17],
	            [-13, -52],
	            [-1, -32],
	            [-11, -71]
	        ],
	        [
	            [3482, 3537],
	            [6, 34],
	            [3, 35],
	            [1, 32],
	            [-10, 11],
	            [-11, -9],
	            [-10, 2],
	            [-4, 23],
	            [-2, 54],
	            [-5, 18],
	            [-19, 16],
	            [-11, -12],
	            [-30, 11],
	            [2, 81],
	            [-8, 33]
	        ],
	        [
	            [3068, 4411],
	            [-15, -11],
	            [-13, 7],
	            [2, 90],
	            [-23, -35],
	            [-24, 2],
	            [-11, 31],
	            [-18, 4],
	            [5, 25],
	            [-15, 36],
	            [-11, 53],
	            [7, 11],
	            [0, 25],
	            [17, 17],
	            [-3, 32],
	            [7, 20],
	            [2, 28],
	            [32, 40],
	            [22, 11],
	            [4, 9],
	            [25, -2]
	        ],
	        [
	            [3058, 4804],
	            [13, 162],
	            [0, 25],
	            [-4, 34],
	            [-12, 22],
	            [0, 42],
	            [15, 10],
	            [6, -6],
	            [1, 23],
	            [-16, 6],
	            [-1, 37],
	            [54, -2],
	            [10, 21],
	            [7, -19],
	            [6, -35],
	            [5, 8]
	        ],
	        [
	            [3142, 5132],
	            [15, -32],
	            [22, 4],
	            [5, 18],
	            [21, 14],
	            [11, 10],
	            [4, 25],
	            [19, 17],
	            [-1, 12],
	            [-24, 5],
	            [-3, 37],
	            [1, 40],
	            [-13, 15],
	            [5, 6],
	            [21, -8],
	            [22, -15],
	            [8, 14],
	            [20, 9],
	            [31, 23],
	            [10, 22],
	            [-3, 17]
	        ],
	        [
	            [3313, 5365],
	            [14, 2],
	            [7, -13],
	            [-4, -26],
	            [9, -9],
	            [7, -28],
	            [-8, -20],
	            [-4, -51],
	            [7, -30],
	            [2, -27],
	            [17, -28],
	            [14, -3],
	            [3, 12],
	            [8, 3],
	            [13, 10],
	            [9, 16],
	            [15, -5],
	            [7, 2]
	        ],
	        [
	            [3429, 5170],
	            [15, -5],
	            [3, 12],
	            [-5, 12],
	            [3, 17],
	            [11, -5],
	            [13, 6],
	            [16, -13]
	        ],
	        [
	            [3485, 5194],
	            [12, -12],
	            [9, 16],
	            [6, -3],
	            [4, -16],
	            [13, 4],
	            [11, 22],
	            [8, 44],
	            [17, 54]
	        ],
	        [
	            [3565, 5303],
	            [9, 3],
	            [7, -33],
	            [16, -103],
	            [14, -10],
	            [1, -41],
	            [-21, -48],
	            [9, -18],
	            [49, -9],
	            [1, -60],
	            [21, 39],
	            [35, -21],
	            [46, -36],
	            [14, -35],
	            [-5, -32],
	            [33, 18],
	            [54, -32],
	            [41, 3],
	            [41, -49],
	            [36, -66],
	            [21, -17],
	            [24, -3],
	            [10, -18],
	            [9, -76],
	            [5, -35],
	            [-11, -98],
	            [-14, -39],
	            [-39, -82],
	            [-18, -67],
	            [-21, -51],
	            [-7, -1],
	            [-7, -43],
	            [2, -111],
	            [-8, -91],
	            [-3, -39],
	            [-9, -23],
	            [-5, -79],
	            [-28, -77],
	            [-5, -61],
	            [-22, -26],
	            [-7, -35],
	            [-30, 0],
	            [-44, -23],
	            [-19, -26],
	            [-31, -18],
	            [-33, -47],
	            [-23, -58],
	            [-5, -44],
	            [5, -33],
	            [-5, -60],
	            [-6, -28],
	            [-20, -33],
	            [-31, -104],
	            [-24, -47],
	            [-19, -27],
	            [-13, -57],
	            [-18, -33]
	        ],
	        [
	            [3517, 3063],
	            [-8, 33],
	            [13, 28],
	            [-16, 40],
	            [-22, 33],
	            [-29, 38],
	            [-10, -2],
	            [-28, 46],
	            [-18, -7]
	        ],
	        [
	            [8172, 5325],
	            [11, 22],
	            [23, 32]
	        ],
	        [
	            [8206, 5379],
	            [-1, -29],
	            [-2, -37],
	            [-13, 1],
	            [-6, -20],
	            [-12, 31]
	        ],
	        [
	            [7546, 6698],
	            [12, -19],
	            [-2, -36],
	            [-23, -2],
	            [-23, 4],
	            [-18, -9],
	            [-25, 22],
	            [-1, 12]
	        ],
	        [
	            [7466, 6670],
	            [19, 44],
	            [15, 15],
	            [20, -14],
	            [14, -1],
	            [12, -16]
	        ],
	        [
	            [5817, 3752],
	            [-39, -43],
	            [-25, -44],
	            [-10, -40],
	            [-8, -22],
	            [-15, -4],
	            [-5, -29],
	            [-3, -18],
	            [-17, -14],
	            [-23, 3],
	            [-13, 17],
	            [-12, 7],
	            [-14, -14],
	            [-6, -28],
	            [-14, -18],
	            [-13, -26],
	            [-20, -6],
	            [-6, 20],
	            [2, 36],
	            [-16, 56],
	            [-8, 9]
	        ],
	        [
	            [5552, 3594],
	            [0, 173],
	            [27, 2],
	            [1, 210],
	            [21, 2],
	            [43, 21],
	            [10, -24],
	            [18, 23],
	            [9, 0],
	            [15, 13]
	        ],
	        [
	            [5696, 4014],
	            [5, -4]
	        ],
	        [
	            [5701, 4010],
	            [11, -48],
	            [5, -10],
	            [9, -34],
	            [32, -65],
	            [12, -7],
	            [0, -20],
	            [8, -38],
	            [21, -9],
	            [18, -27]
	        ],
	        [
	            [5424, 5496],
	            [23, 4],
	            [5, 16],
	            [5, -2],
	            [7, -13],
	            [34, 23],
	            [12, 23],
	            [15, 20],
	            [-3, 21],
	            [8, 6],
	            [27, -4],
	            [26, 27],
	            [20, 65],
	            [14, 24],
	            [18, 10]
	        ],
	        [
	            [5635, 5716],
	            [3, -26],
	            [16, -36],
	            [0, -25],
	            [-5, -24],
	            [2, -18],
	            [10, -18]
	        ],
	        [
	            [5661, 5569],
	            [21, -25]
	        ],
	        [
	            [5682, 5544],
	            [15, -24],
	            [0, -19],
	            [19, -31],
	            [12, -26],
	            [7, -35],
	            [20, -24],
	            [5, -18]
	        ],
	        [
	            [5760, 5367],
	            [-9, -7],
	            [-18, 2],
	            [-21, 6],
	            [-10, -5],
	            [-5, -14],
	            [-9, -2],
	            [-10, 12],
	            [-31, -29],
	            [-13, 6],
	            [-4, -5],
	            [-8, -35],
	            [-21, 11],
	            [-20, 6],
	            [-18, 22],
	            [-23, 20],
	            [-15, -19],
	            [-10, -30],
	            [-3, -41]
	        ],
	        [
	            [5512, 5265],
	            [-18, 3],
	            [-19, 10],
	            [-16, -32],
	            [-15, -55]
	        ],
	        [
	            [5444, 5191],
	            [-3, 18],
	            [-1, 27],
	            [-13, 19],
	            [-10, 30],
	            [-2, 21],
	            [-13, 31],
	            [2, 18],
	            [-3, 25],
	            [2, 45],
	            [7, 11],
	            [14, 60]
	        ],
	        [
	            [3231, 7808],
	            [20, -8],
	            [26, 1],
	            [-14, -24],
	            [-10, -4],
	            [-35, 25],
	            [-7, 20],
	            [10, 18],
	            [10, -28]
	        ],
	        [
	            [3283, 7958],
	            [-14, -1],
	            [-36, 19],
	            [-26, 28],
	            [10, 5],
	            [37, -15],
	            [28, -25],
	            [1, -11]
	        ],
	        [
	            [1569, 7923],
	            [-14, -8],
	            [-46, 27],
	            [-8, 21],
	            [-25, 21],
	            [-5, 16],
	            [-28, 11],
	            [-11, 32],
	            [2, 14],
	            [30, -13],
	            [17, -9],
	            [26, -6],
	            [9, -21],
	            [14, -28],
	            [28, -24],
	            [11, -33]
	        ],
	        [
	            [3440, 8052],
	            [-18, -52],
	            [18, 20],
	            [19, -12],
	            [-10, -21],
	            [25, -16],
	            [12, 14],
	            [28, -18],
	            [-8, -43],
	            [19, 10],
	            [4, -32],
	            [8, -36],
	            [-11, -52],
	            [-13, -2],
	            [-18, 11],
	            [6, 48],
	            [-8, 8],
	            [-32, -52],
	            [-17, 2],
	            [20, 28],
	            [-27, 14],
	            [-30, -3],
	            [-54, 2],
	            [-4, 17],
	            [17, 21],
	            [-12, 16],
	            [24, 36],
	            [28, 94],
	            [18, 33],
	            [24, 21],
	            [13, -3],
	            [-6, -16],
	            [-15, -37]
	        ],
	        [
	            [1313, 8250],
	            [27, 5],
	            [-8, -67],
	            [24, -48],
	            [-11, 0],
	            [-17, 27],
	            [-10, 27],
	            [-14, 19],
	            [-5, 26],
	            [1, 19],
	            [13, -8]
	        ],
	        [
	            [2798, 8730],
	            [-11, -31],
	            [-12, 5],
	            [-8, 17],
	            [2, 4],
	            [10, 18],
	            [12, -1],
	            [7, -12]
	        ],
	        [
	            [2725, 8762],
	            [-33, -32],
	            [-19, 1],
	            [-6, 16],
	            [20, 27],
	            [38, 0],
	            [0, -12]
	        ],
	        [
	            [2634, 8936],
	            [5, -26],
	            [15, 9],
	            [16, -15],
	            [30, -20],
	            [32, -19],
	            [2, -28],
	            [21, 5],
	            [20, -20],
	            [-25, -18],
	            [-43, 14],
	            [-16, 26],
	            [-27, -31],
	            [-40, -31],
	            [-9, 35],
	            [-38, -6],
	            [24, 30],
	            [4, 46],
	            [9, 54],
	            [20, -5]
	        ],
	        [
	            [2892, 9024],
	            [-31, -3],
	            [-7, 29],
	            [12, 34],
	            [26, 8],
	            [21, -17],
	            [1, -25],
	            [-4, -8],
	            [-18, -18]
	        ],
	        [
	            [2343, 9140],
	            [-17, -21],
	            [-38, 18],
	            [-22, -6],
	            [-38, 26],
	            [24, 19],
	            [19, 25],
	            [30, -16],
	            [17, -11],
	            [8, -11],
	            [17, -23]
	        ],
	        [
	            [3135, 7724],
	            [-18, 33],
	            [0, 81],
	            [-13, 17],
	            [-18, -10],
	            [-10, 16],
	            [-21, -45],
	            [-8, -46],
	            [-10, -27],
	            [-12, -9],
	            [-9, -3],
	            [-3, -15],
	            [-51, 0],
	            [-42, 0],
	            [-12, -11],
	            [-30, -42],
	            [-3, -5],
	            [-9, -23],
	            [-26, 0],
	            [-27, 0],
	            [-12, -10],
	            [4, -11],
	            [2, -18],
	            [0, -6],
	            [-36, -30],
	            [-29, -9],
	            [-32, -31],
	            [-7, 0],
	            [-10, 9],
	            [-3, 8],
	            [1, 6],
	            [6, 21],
	            [13, 33],
	            [8, 35],
	            [-5, 51],
	            [-6, 53],
	            [-29, 28],
	            [3, 11],
	            [-4, 7],
	            [-8, 0],
	            [-5, 9],
	            [-2, 14],
	            [-5, -6],
	            [-7, 2],
	            [1, 6],
	            [-6, 6],
	            [-3, 15],
	            [-21, 19],
	            [-23, 20],
	            [-27, 23],
	            [-26, 21],
	            [-25, -17],
	            [-9, 0],
	            [-34, 15],
	            [-23, -8],
	            [-27, 19],
	            [-28, 9],
	            [-19, 4],
	            [-9, 10],
	            [-5, 32],
	            [-9, 0],
	            [-1, -23],
	            [-57, 0],
	            [-95, 0],
	            [-94, 0],
	            [-84, 0],
	            [-83, 0],
	            [-82, 0],
	            [-85, 0],
	            [-27, 0],
	            [-82, 0],
	            [-79, 0]
	        ],
	        [
	            [1588, 7952],
	            [-4, 0],
	            [-54, 58],
	            [-20, 26],
	            [-50, 24],
	            [-15, 53],
	            [3, 36],
	            [-35, 25],
	            [-5, 48],
	            [-34, 43],
	            [0, 30]
	        ],
	        [
	            [1374, 8295],
	            [15, 29],
	            [0, 37],
	            [-48, 37],
	            [-28, 68],
	            [-17, 42],
	            [-26, 27],
	            [-19, 24],
	            [-14, 31],
	            [-28, -20],
	            [-27, -33],
	            [-25, 39],
	            [-19, 26],
	            [-27, 16],
	            [-28, 2],
	            [0, 337],
	            [1, 219]
	        ],
	        [
	            [1084, 9176],
	            [51, -14],
	            [44, -29],
	            [29, -5],
	            [24, 24],
	            [34, 19],
	            [41, -7],
	            [42, 26],
	            [45, 14],
	            [20, -24],
	            [20, 14],
	            [6, 27],
	            [20, -6],
	            [47, -53],
	            [37, 40],
	            [3, -45],
	            [34, 10],
	            [11, 17],
	            [34, -3],
	            [42, -25],
	            [65, -22],
	            [38, -10],
	            [28, 4],
	            [37, -30],
	            [-39, -29],
	            [50, -13],
	            [75, 7],
	            [24, 11],
	            [29, -36],
	            [31, 30],
	            [-29, 25],
	            [18, 20],
	            [34, 3],
	            [22, 6],
	            [23, -14],
	            [28, -32],
	            [31, 5],
	            [49, -27],
	            [43, 9],
	            [40, -1],
	            [-3, 37],
	            [25, 10],
	            [43, -20],
	            [0, -56],
	            [17, 47],
	            [23, -1],
	            [12, 59],
	            [-30, 36],
	            [-32, 24],
	            [2, 65],
	            [33, 43],
	            [37, -9],
	            [28, -26],
	            [38, -67],
	            [-25, -29],
	            [52, -12],
	            [-1, -60],
	            [38, 46],
	            [33, -38],
	            [-9, -44],
	            [27, -40],
	            [29, 43],
	            [21, 51],
	            [1, 65],
	            [40, -5],
	            [41, -8],
	            [37, -30],
	            [2, -29],
	            [-21, -31],
	            [20, -32],
	            [-4, -29],
	            [-54, -41],
	            [-39, -9],
	            [-29, 18],
	            [-8, -30],
	            [-27, -50],
	            [-8, -26],
	            [-32, -40],
	            [-40, -4],
	            [-22, -25],
	            [-2, -38],
	            [-32, -7],
	            [-34, -48],
	            [-30, -67],
	            [-11, -46],
	            [-1, -69],
	            [40, -10],
	            [13, -55],
	            [13, -45],
	            [39, 12],
	            [51, -26],
	            [28, -22],
	            [20, -28],
	            [35, -17],
	            [29, -24],
	            [46, -4],
	            [30, -6],
	            [-4, -51],
	            [8, -59],
	            [21, -66],
	            [41, -56],
	            [21, 19],
	            [15, 61],
	            [-14, 93],
	            [-20, 31],
	            [45, 28],
	            [31, 41],
	            [16, 41],
	            [-3, 40],
	            [-19, 50],
	            [-33, 44],
	            [32, 62],
	            [-12, 54],
	            [-9, 92],
	            [19, 14],
	            [48, -16],
	            [29, -6],
	            [23, 15],
	            [25, -20],
	            [35, -34],
	            [8, -23],
	            [50, -4],
	            [-1, -50],
	            [9, -74],
	            [25, -10],
	            [21, -35],
	            [40, 33],
	            [26, 65],
	            [19, 28],
	            [21, -53],
	            [36, -75],
	            [31, -71],
	            [-11, -37],
	            [37, -33],
	            [25, -34],
	            [44, -15],
	            [18, -19],
	            [11, -50],
	            [22, -8],
	            [11, -22],
	            [2, -67],
	            [-20, -22],
	            [-20, -21],
	            [-46, -21],
	            [-35, -48],
	            [-47, -10],
	            [-59, 13],
	            [-42, 0],
	            [-29, -4],
	            [-23, -43],
	            [-35, -26],
	            [-40, -78],
	            [-32, -54],
	            [23, 9],
	            [45, 78],
	            [58, 49],
	            [42, 6],
	            [24, -29],
	            [-26, -40],
	            [9, -63],
	            [9, -45],
	            [36, -29],
	            [46, 8],
	            [28, 67],
	            [2, -43],
	            [17, -22],
	            [-34, -38],
	            [-61, -36],
	            [-28, -23],
	            [-31, -43],
	            [-21, 4],
	            [-1, 50],
	            [48, 49],
	            [-44, -2],
	            [-31, -7]
	        ],
	        [
	            [1829, 9377],
	            [-14, -27],
	            [61, 17],
	            [39, -29],
	            [31, 30],
	            [26, -20],
	            [23, -58],
	            [14, 25],
	            [-20, 60],
	            [24, 9],
	            [28, -9],
	            [31, -24],
	            [17, -58],
	            [9, -41],
	            [47, -30],
	            [50, -28],
	            [-3, -26],
	            [-46, -4],
	            [18, -23],
	            [-9, -22],
	            [-51, 9],
	            [-48, 16],
	            [-32, -3],
	            [-52, -20],
	            [-70, -9],
	            [-50, -6],
	            [-15, 28],
	            [-38, 16],
	            [-24, -6],
	            [-35, 47],
	            [19, 6],
	            [43, 10],
	            [39, -3],
	            [36, 11],
	            [-54, 13],
	            [-59, -4],
	            [-39, 1],
	            [-15, 22],
	            [64, 23],
	            [-42, -1],
	            [-49, 16],
	            [23, 44],
	            [20, 24],
	            [74, 36],
	            [29, -12]
	        ],
	        [
	            [2097, 9395],
	            [-24, -39],
	            [-44, 41],
	            [10, 9],
	            [37, 2],
	            [21, -13]
	        ],
	        [
	            [2879, 9376],
	            [3, -16],
	            [-30, 2],
	            [-30, 1],
	            [-30, -8],
	            [-8, 3],
	            [-31, 32],
	            [1, 21],
	            [14, 4],
	            [63, -6],
	            [48, -33]
	        ],
	        [
	            [2595, 9379],
	            [22, -36],
	            [26, 47],
	            [70, 24],
	            [48, -61],
	            [-4, -38],
	            [55, 17],
	            [26, 23],
	            [62, -30],
	            [38, -28],
	            [3, -25],
	            [52, 13],
	            [29, -38],
	            [67, -23],
	            [24, -24],
	            [26, -55],
	            [-51, -28],
	            [66, -38],
	            [44, -13],
	            [40, -55],
	            [44, -3],
	            [-9, -42],
	            [-49, -69],
	            [-34, 26],
	            [-44, 57],
	            [-36, -8],
	            [-3, -34],
	            [29, -34],
	            [38, -27],
	            [11, -16],
	            [18, -58],
	            [-9, -43],
	            [-35, 16],
	            [-70, 47],
	            [39, -51],
	            [29, -35],
	            [5, -21],
	            [-76, 24],
	            [-59, 34],
	            [-34, 29],
	            [10, 17],
	            [-42, 30],
	            [-40, 29],
	            [0, -18],
	            [-80, -9],
	            [-23, 20],
	            [18, 44],
	            [52, 1],
	            [57, 7],
	            [-9, 21],
	            [10, 30],
	            [36, 57],
	            [-8, 27],
	            [-11, 20],
	            [-42, 29],
	            [-57, 20],
	            [18, 15],
	            [-29, 36],
	            [-25, 4],
	            [-22, 20],
	            [-14, -18],
	            [-51, -7],
	            [-101, 13],
	            [-59, 17],
	            [-45, 9],
	            [-23, 21],
	            [29, 27],
	            [-39, 0],
	            [-9, 60],
	            [21, 53],
	            [29, 24],
	            [72, 16],
	            [-21, -39]
	        ],
	        [
	            [2212, 9420],
	            [33, -12],
	            [50, 7],
	            [7, -17],
	            [-26, -28],
	            [42, -26],
	            [-5, -53],
	            [-45, -23],
	            [-27, 5],
	            [-19, 23],
	            [-69, 45],
	            [0, 19],
	            [57, -7],
	            [-31, 38],
	            [33, 29]
	        ],
	        [
	            [2411, 9357],
	            [-30, -45],
	            [-32, 3],
	            [-17, 52],
	            [1, 29],
	            [14, 25],
	            [28, 16],
	            [58, -2],
	            [53, -14],
	            [-42, -53],
	            [-33, -11]
	        ],
	        [
	            [1654, 9275],
	            [-73, -29],
	            [-15, 26],
	            [-64, 31],
	            [12, 25],
	            [19, 43],
	            [24, 39],
	            [-27, 36],
	            [94, 10],
	            [39, -13],
	            [71, -3],
	            [27, -17],
	            [30, -25],
	            [-35, -15],
	            [-68, -41],
	            [-34, -42],
	            [0, -25]
	        ],
	        [
	            [2399, 9487],
	            [-15, -23],
	            [-40, 5],
	            [-34, 15],
	            [15, 27],
	            [40, 16],
	            [24, -21],
	            [10, -19]
	        ],
	        [
	            [2264, 9590],
	            [21, -27],
	            [1, -31],
	            [-13, -44],
	            [-46, -6],
	            [-30, 10],
	            [1, 34],
	            [-45, -4],
	            [-2, 45],
	            [30, -2],
	            [41, 21],
	            [40, -4],
	            [2, 8]
	        ],
	        [
	            [1994, 9559],
	            [11, -21],
	            [25, 10],
	            [29, -2],
	            [5, -29],
	            [-17, -28],
	            [-94, -10],
	            [-70, -25],
	            [-43, -2],
	            [-3, 20],
	            [57, 26],
	            [-125, -7],
	            [-39, 10],
	            [38, 58],
	            [26, 17],
	            [78, -20],
	            [50, -35],
	            [48, -5],
	            [-40, 57],
	            [26, 21],
	            [29, -7],
	            [9, -28]
	        ],
	        [
	            [2370, 9612],
	            [30, -19],
	            [55, 0],
	            [24, -19],
	            [-6, -22],
	            [32, -14],
	            [17, -14],
	            [38, -2],
	            [40, -5],
	            [44, 13],
	            [57, 5],
	            [45, -5],
	            [30, -22],
	            [6, -24],
	            [-17, -16],
	            [-42, -13],
	            [-35, 8],
	            [-80, -10],
	            [-57, -1],
	            [-45, 8],
	            [-74, 19],
	            [-9, 32],
	            [-4, 29],
	            [-27, 26],
	            [-58, 7],
	            [-32, 19],
	            [10, 24],
	            [58, -4]
	        ],
	        [
	            [1772, 9645],
	            [-4, -46],
	            [-21, -20],
	            [-26, -3],
	            [-52, -26],
	            [-44, -9],
	            [-38, 13],
	            [47, 44],
	            [57, 39],
	            [43, -1],
	            [38, 9]
	        ],
	        [
	            [2393, 9637],
	            [-13, -2],
	            [-52, 4],
	            [-7, 17],
	            [56, -1],
	            [19, -11],
	            [-3, -7]
	        ],
	        [
	            [1939, 9648],
	            [-52, -17],
	            [-41, 19],
	            [23, 19],
	            [40, 6],
	            [39, -10],
	            [-9, -17]
	        ],
	        [
	            [1954, 9701],
	            [-34, -11],
	            [-46, 0],
	            [0, 8],
	            [29, 18],
	            [14, -3],
	            [37, -12]
	        ],
	        [
	            [2338, 9669],
	            [-41, -12],
	            [-23, 13],
	            [-12, 23],
	            [-2, 24],
	            [36, -2],
	            [16, -4],
	            [33, -21],
	            [-7, -21]
	        ],
	        [
	            [2220, 9685],
	            [11, -25],
	            [-45, 7],
	            [-46, 19],
	            [-62, 2],
	            [27, 18],
	            [-34, 14],
	            [-2, 22],
	            [55, -8],
	            [75, -21],
	            [21, -28]
	        ],
	        [
	            [2583, 9764],
	            [33, -20],
	            [-38, -17],
	            [-51, -45],
	            [-50, -4],
	            [-57, 8],
	            [-30, 24],
	            [0, 21],
	            [22, 16],
	            [-50, 0],
	            [-31, 19],
	            [-18, 27],
	            [20, 26],
	            [19, 18],
	            [28, 4],
	            [-12, 14],
	            [65, 3],
	            [35, -32],
	            [47, -12],
	            [46, -11],
	            [22, -39]
	        ],
	        [
	            [3097, 9967],
	            [74, -4],
	            [60, -8],
	            [51, -16],
	            [-2, -16],
	            [-67, -25],
	            [-68, -12],
	            [-25, -14],
	            [61, 1],
	            [-66, -36],
	            [-45, -17],
	            [-48, -48],
	            [-57, -10],
	            [-18, -12],
	            [-84, -6],
	            [39, -8],
	            [-20, -10],
	            [23, -29],
	            [-26, -21],
	            [-43, -16],
	            [-13, -24],
	            [-39, -17],
	            [4, -14],
	            [48, 3],
	            [0, -15],
	            [-74, -35],
	            [-73, 16],
	            [-81, -9],
	            [-42, 7],
	            [-52, 3],
	            [-4, 29],
	            [52, 13],
	            [-14, 43],
	            [17, 4],
	            [74, -26],
	            [-38, 38],
	            [-45, 11],
	            [23, 23],
	            [49, 14],
	            [8, 21],
	            [-39, 23],
	            [-12, 31],
	            [76, -3],
	            [22, -6],
	            [43, 21],
	            [-62, 7],
	            [-98, -4],
	            [-49, 20],
	            [-23, 24],
	            [-32, 17],
	            [-6, 21],
	            [41, 11],
	            [32, 2],
	            [55, 9],
	            [41, 22],
	            [34, -3],
	            [30, -16],
	            [21, 32],
	            [37, 9],
	            [50, 7],
	            [85, 2],
	            [14, -6],
	            [81, 10],
	            [60, -4],
	            [60, -4]
	        ],
	        [
	            [5290, 7828],
	            [-3, -24],
	            [-12, -10],
	            [-20, 7],
	            [-6, -24],
	            [-14, -2],
	            [-5, 10],
	            [-15, -20],
	            [-13, -3],
	            [-12, 13]
	        ],
	        [
	            [5190, 7775],
	            [-10, 25],
	            [-13, -9],
	            [0, 27],
	            [21, 33],
	            [-1, 15],
	            [12, -5],
	            [8, 10]
	        ],
	        [
	            [5207, 7871],
	            [24, -1],
	            [5, 13],
	            [30, -18]
	        ],
	        [
	            [3140, 1814],
	            [-10, -24],
	            [-23, -18],
	            [-14, 2],
	            [-16, 5],
	            [-21, 18],
	            [-29, 8],
	            [-35, 33],
	            [-28, 32],
	            [-38, 66],
	            [23, -12],
	            [39, -40],
	            [36, -21],
	            [15, 27],
	            [9, 41],
	            [25, 24],
	            [20, -7]
	        ],
	        [
	            [3095, 1968],
	            [-25, 0],
	            [-13, -14],
	            [-25, -22],
	            [-5, -55],
	            [-11, -1],
	            [-32, 19],
	            [-32, 41],
	            [-34, 34],
	            [-9, 37],
	            [8, 35],
	            [-14, 39],
	            [-4, 101],
	            [12, 57],
	            [30, 45],
	            [-43, 18],
	            [27, 52],
	            [9, 98],
	            [31, -21],
	            [15, 123],
	            [-19, 15],
	            [-9, -73],
	            [-17, 8],
	            [9, 84],
	            [9, 110],
	            [13, 40],
	            [-8, 58],
	            [-2, 66],
	            [11, 2],
	            [17, 96],
	            [20, 94],
	            [11, 88],
	            [-6, 89],
	            [8, 49],
	            [-3, 72],
	            [16, 73],
	            [5, 114],
	            [9, 123],
	            [9, 132],
	            [-2, 96],
	            [-6, 84]
	        ],
	        [
	            [3045, 3974],
	            [14, 15],
	            [8, 30]
	        ],
	        [
	            [8064, 6161],
	            [-24, -28],
	            [-23, 18],
	            [0, 51],
	            [13, 26],
	            [31, 17],
	            [16, -1],
	            [6, -23],
	            [-12, -26],
	            [-7, -34]
	        ],
	        [
	            [8628, 7562],
	            [-18, 35],
	            [-11, -33],
	            [-43, -26],
	            [4, -31],
	            [-24, 2],
	            [-13, 19],
	            [-19, -42],
	            [-30, -32],
	            [-23, -38]
	        ],
	        [
	            [8451, 7416],
	            [-39, -17],
	            [-20, -27],
	            [-30, -17],
	            [15, 28],
	            [-6, 23],
	            [22, 40],
	            [-15, 30],
	            [-24, -20],
	            [-32, -41],
	            [-17, -39],
	            [-27, -2],
	            [-14, -28],
	            [15, -40],
	            [22, -10],
	            [1, -26],
	            [22, -17],
	            [31, 42],
	            [25, -23],
	            [18, -2],
	            [4, -31],
	            [-39, -16],
	            [-13, -32],
	            [-27, -30],
	            [-14, -41],
	            [30, -33],
	            [11, -58],
	            [17, -54],
	            [18, -45],
	            [0, -44],
	            [-17, -16],
	            [6, -32],
	            [17, -18],
	            [-5, -48],
	            [-7, -47],
	            [-15, -5],
	            [-21, -64],
	            [-22, -78],
	            [-26, -70],
	            [-38, -55],
	            [-39, -50],
	            [-31, -6],
	            [-17, -27],
	            [-10, 20],
	            [-15, -30],
	            [-39, -29],
	            [-29, -9],
	            [-10, -63],
	            [-15, -3],
	            [-8, 43],
	            [7, 22],
	            [-37, 19],
	            [-13, -9]
	        ],
	        [
	            [8001, 6331],
	            [-28, 15],
	            [-14, 24],
	            [5, 34],
	            [-26, 11],
	            [-13, 22],
	            [-24, -31],
	            [-27, -7],
	            [-22, 0],
	            [-15, -14]
	        ],
	        [
	            [7837, 6385],
	            [-14, -9],
	            [4, -68],
	            [-15, 2],
	            [-2, 14]
	        ],
	        [
	            [7810, 6324],
	            [-1, 24],
	            [-20, -17],
	            [-12, 11],
	            [-21, 22],
	            [8, 49],
	            [-18, 12],
	            [-6, 54],
	            [-30, -10],
	            [4, 70],
	            [26, 50],
	            [1, 48],
	            [-1, 46],
	            [-12, 14],
	            [-9, 35],
	            [-16, -5]
	        ],
	        [
	            [7703, 6727],
	            [-30, 9],
	            [9, 25],
	            [-13, 36],
	            [-20, -24],
	            [-23, 14],
	            [-32, -37],
	            [-25, -44],
	            [-23, -8]
	        ],
	        [
	            [7466, 6670],
	            [-2, 47],
	            [-17, -13]
	        ],
	        [
	            [7447, 6704],
	            [-32, 6],
	            [-32, 14],
	            [-22, 26],
	            [-22, 11],
	            [-9, 29],
	            [-16, 8],
	            [-28, 39],
	            [-22, 18],
	            [-12, -14]
	        ],
	        [
	            [7252, 6841],
	            [-38, 41],
	            [-28, 37],
	            [-7, 65],
	            [20, -7],
	            [1, 30],
	            [-12, 30],
	            [3, 48],
	            [-30, 69]
	        ],
	        [
	            [7161, 7154],
	            [-45, 24],
	            [-8, 46],
	            [-21, 27]
	        ],
	        [
	            [7082, 7268],
	            [-4, 34],
	            [1, 23],
	            [-17, 13],
	            [-9, -6],
	            [-7, 55]
	        ],
	        [
	            [7046, 7387],
	            [8, 13],
	            [-4, 14],
	            [26, 28],
	            [20, 12],
	            [29, -8],
	            [11, 38],
	            [35, 7],
	            [10, 23],
	            [44, 32],
	            [4, 13]
	        ],
	        [
	            [7229, 7559],
	            [-2, 34],
	            [19, 15],
	            [-25, 103],
	            [55, 24],
	            [14, 13],
	            [20, 106],
	            [55, -20],
	            [15, 27],
	            [2, 59],
	            [23, 6],
	            [21, 39]
	        ],
	        [
	            [7426, 7965],
	            [11, 5]
	        ],
	        [
	            [7437, 7970],
	            [7, -41],
	            [23, -32],
	            [40, -22],
	            [19, -47],
	            [-10, -70],
	            [10, -25],
	            [33, -10],
	            [37, -8],
	            [33, -37],
	            [18, -7],
	            [12, -54],
	            [17, -35],
	            [30, 1],
	            [58, -13],
	            [36, 8],
	            [28, -9],
	            [41, -36],
	            [34, 0],
	            [12, -18],
	            [32, 32],
	            [45, 20],
	            [42, 2],
	            [32, 21],
	            [20, 32],
	            [20, 20],
	            [-5, 19],
	            [-9, 23],
	            [15, 38],
	            [15, -5],
	            [29, -12],
	            [28, 31],
	            [42, 23],
	            [20, 39],
	            [20, 17],
	            [40, 8],
	            [22, -7],
	            [3, 21],
	            [-25, 41],
	            [-22, 19],
	            [-22, -22],
	            [-27, 10],
	            [-16, -8],
	            [-7, 24],
	            [20, 59],
	            [13, 45]
	        ],
	        [
	            [8240, 8005],
	            [34, -23],
	            [39, 38],
	            [-1, 26],
	            [26, 62],
	            [15, 19],
	            [0, 33],
	            [-16, 14],
	            [23, 29],
	            [35, 11],
	            [37, 2],
	            [41, -18],
	            [25, -22],
	            [17, -59],
	            [10, -26],
	            [10, -36],
	            [10, -58],
	            [49, -19],
	            [32, -42],
	            [12, -55],
	            [42, 0],
	            [24, 23],
	            [46, 17],
	            [-15, -53],
	            [-11, -21],
	            [-9, -65],
	            [-19, -58],
	            [-33, 11],
	            [-24, -21],
	            [7, -51],
	            [-4, -69],
	            [-14, -2],
	            [0, -30]
	        ],
	        [
	            [4920, 5353],
	            [-12, -1],
	            [-20, 12],
	            [-18, -1],
	            [-33, -10],
	            [-19, -18],
	            [-27, -21],
	            [-6, 1]
	        ],
	        [
	            [4785, 5315],
	            [2, 49],
	            [3, 7],
	            [-1, 24],
	            [-12, 24],
	            [-8, 4],
	            [-8, 17],
	            [6, 26],
	            [-3, 28],
	            [1, 18]
	        ],
	        [
	            [4765, 5512],
	            [5, 0],
	            [1, 25],
	            [-2, 12],
	            [3, 8],
	            [10, 7],
	            [-7, 47],
	            [-6, 25],
	            [2, 20],
	            [5, 4]
	        ],
	        [
	            [4776, 5660],
	            [4, 6],
	            [8, -9],
	            [21, -1],
	            [5, 18],
	            [5, -1],
	            [8, 6],
	            [4, -25],
	            [7, 7],
	            [11, 9]
	        ],
	        [
	            [4921, 5627],
	            [7, -84],
	            [-11, -50],
	            [-8, -66],
	            [12, -51],
	            [-1, -23]
	        ],
	        [
	            [5363, 5191],
	            [-4, 4],
	            [-16, -8],
	            [-17, 8],
	            [-13, -4]
	        ],
	        [
	            [5313, 5191],
	            [-45, 1]
	        ],
	        [
	            [5268, 5192],
	            [4, 47],
	            [-11, 39],
	            [-13, 10],
	            [-6, 27],
	            [-7, 8],
	            [1, 16]
	        ],
	        [
	            [5236, 5339],
	            [7, 42],
	            [13, 57],
	            [8, 1],
	            [17, 34],
	            [10, 1],
	            [16, -24],
	            [19, 20],
	            [2, 25],
	            [7, 23],
	            [4, 30],
	            [15, 25],
	            [5, 41],
	            [6, 13],
	            [4, 31],
	            [7, 37],
	            [24, 46],
	            [1, 20],
	            [3, 10],
	            [-11, 24]
	        ],
	        [
	            [5393, 5795],
	            [1, 19],
	            [8, 3]
	        ],
	        [
	            [5402, 5817],
	            [11, -38],
	            [2, -39],
	            [-1, -39],
	            [15, -54],
	            [-15, 1],
	            [-8, -4],
	            [-13, 6],
	            [-6, -28],
	            [16, -35],
	            [13, -10],
	            [3, -24],
	            [9, -41],
	            [-4, -16]
	        ],
	        [
	            [5444, 5191],
	            [-2, -31],
	            [-22, 14],
	            [-22, 15],
	            [-35, 2]
	        ],
	        [
	            [5856, 5265],
	            [-2, -69],
	            [11, -8],
	            [-9, -21],
	            [-10, -16],
	            [-11, -31],
	            [-6, -27],
	            [-1, -48],
	            [-7, -22],
	            [0, -45]
	        ],
	        [
	            [5821, 4978],
	            [-8, -16],
	            [-1, -35],
	            [-4, -5],
	            [-2, -32]
	        ],
	        [
	            [5814, 4792],
	            [5, -55],
	            [-2, -30],
	            [5, -35],
	            [16, -33],
	            [15, -74]
	        ],
	        [
	            [5853, 4565],
	            [-11, 6],
	            [-37, -10],
	            [-7, -7],
	            [-8, -38],
	            [6, -26],
	            [-5, -70],
	            [-3, -59],
	            [7, -11],
	            [19, -23],
	            [8, 11],
	            [2, -64],
	            [-21, 1],
	            [-11, 32],
	            [-10, 25],
	            [-22, 9],
	            [-6, 31],
	            [-17, -19],
	            [-22, 8],
	            [-10, 27],
	            [-17, 6],
	            [-13, -2],
	            [-2, 19],
	            [-9, 1]
	        ],
	        [
	            [5342, 4697],
	            [-4, 18]
	        ],
	        [
	            [5360, 4775],
	            [8, -6],
	            [9, 23],
	            [15, -1],
	            [2, -17],
	            [11, -10],
	            [16, 37],
	            [16, 29],
	            [7, 19],
	            [-1, 48],
	            [12, 58],
	            [13, 30],
	            [18, 29],
	            [3, 18],
	            [1, 22],
	            [5, 21],
	            [-2, 33],
	            [4, 52],
	            [5, 37],
	            [8, 32],
	            [2, 36]
	        ],
	        [
	            [5760, 5367],
	            [17, -49],
	            [12, -7],
	            [8, 10],
	            [12, -4],
	            [16, 12],
	            [6, -25],
	            [25, -39]
	        ],
	        [
	            [5330, 4760],
	            [-22, 62]
	        ],
	        [
	            [5308, 4822],
	            [21, 33],
	            [-11, 39],
	            [10, 15],
	            [19, 7],
	            [2, 26],
	            [15, -28],
	            [24, -2],
	            [9, 27],
	            [3, 40],
	            [-3, 46],
	            [-13, 35],
	            [12, 68],
	            [-7, 12],
	            [-21, -5],
	            [-7, 31],
	            [2, 25]
	        ],
	        [
	            [2906, 5049],
	            [-12, 14],
	            [-14, 19],
	            [-7, -9],
	            [-24, 8],
	            [-7, 25],
	            [-5, -1],
	            [-28, 34]
	        ],
	        [
	            [2809, 5139],
	            [-3, 18],
	            [10, 5],
	            [-1, 29],
	            [6, 22],
	            [14, 4],
	            [12, 37],
	            [10, 31],
	            [-10, 14],
	            [5, 34],
	            [-6, 54],
	            [6, 16],
	            [-4, 50],
	            [-12, 31]
	        ],
	        [
	            [2836, 5484],
	            [4, 29],
	            [9, -4],
	            [5, 17],
	            [-6, 35],
	            [3, 9]
	        ],
	        [
	            [2851, 5570],
	            [14, -2],
	            [21, 41],
	            [12, 6],
	            [0, 20],
	            [5, 50],
	            [16, 27],
	            [17, 1],
	            [3, 13],
	            [21, -5],
	            [22, 30],
	            [11, 13],
	            [14, 28],
	            [9, -3],
	            [8, -16],
	            [-6, -20]
	        ],
	        [
	            [3018, 5753],
	            [-18, -10],
	            [-7, -29],
	            [-10, -17],
	            [-8, -22],
	            [-4, -42],
	            [-8, -35],
	            [15, -4],
	            [3, -27],
	            [6, -13],
	            [3, -24],
	            [-4, -22],
	            [1, -12],
	            [7, -5],
	            [7, -20],
	            [36, 5],
	            [16, -7],
	            [19, -51],
	            [11, 6],
	            [20, -3],
	            [16, 7],
	            [10, -10],
	            [-5, -32],
	            [-6, -20],
	            [-2, -42],
	            [5, -40],
	            [8, -17],
	            [1, -13],
	            [-14, -30],
	            [10, -13],
	            [8, -21],
	            [8, -58]
	        ],
	        [
	            [3058, 4804],
	            [-14, 31],
	            [-8, 1],
	            [18, 61],
	            [-21, 27],
	            [-17, -5],
	            [-10, 10],
	            [-15, -15],
	            [-21, 7],
	            [-16, 62],
	            [-13, 15],
	            [-9, 28],
	            [-19, 28],
	            [-7, -5]
	        ],
	        [
	            [2695, 5543],
	            [-15, 14],
	            [-6, 12],
	            [4, 10],
	            [-1, 13],
	            [-8, 14],
	            [-11, 12],
	            [-10, 8],
	            [-1, 17],
	            [-8, 10],
	            [2, -17],
	            [-5, -14],
	            [-7, 17],
	            [-9, 5],
	            [-4, 12],
	            [1, 18],
	            [3, 19],
	            [-8, 8],
	            [7, 12]
	        ],
	        [
	            [2619, 5713],
	            [4, 7],
	            [18, -15],
	            [7, 7],
	            [9, -5],
	            [4, -12],
	            [8, -4],
	            [7, 13]
	        ],
	        [
	            [2676, 5704],
	            [7, -32],
	            [11, -24],
	            [13, -25]
	        ],
	        [
	            [2707, 5623],
	            [-11, -6],
	            [0, -23],
	            [6, -9],
	            [-4, -7],
	            [1, -11],
	            [-2, -12],
	            [-2, -12]
	        ],
	        [
	            [2715, 6427],
	            [23, -4],
	            [22, 0],
	            [26, -21],
	            [11, -21],
	            [26, 6],
	            [10, -13],
	            [24, -37],
	            [17, -27],
	            [9, 1],
	            [17, -12],
	            [-2, -17],
	            [20, -2],
	            [21, -24],
	            [-3, -14],
	            [-19, -7],
	            [-18, -3],
	            [-19, 4],
	            [-40, -5],
	            [18, 32],
	            [-11, 16],
	            [-18, 4],
	            [-9, 17],
	            [-7, 33],
	            [-16, -2],
	            [-26, 16],
	            [-8, 12],
	            [-36, 10],
	            [-10, 11],
	            [11, 15],
	            [-28, 3],
	            [-20, -31],
	            [-11, -1],
	            [-4, -14],
	            [-14, -7],
	            [-12, 6],
	            [15, 18],
	            [6, 22],
	            [13, 13],
	            [14, 11],
	            [21, 6],
	            [7, 6]
	        ],
	        [
	            [5909, 7133],
	            [2, 1],
	            [4, 14],
	            [20, -1],
	            [25, 18],
	            [-19, -25],
	            [2, -11]
	        ],
	        [
	            [5943, 7129],
	            [-3, 2],
	            [-5, -5],
	            [-4, 1],
	            [-2, -2],
	            [0, 6],
	            [-2, 4],
	            [-6, 0],
	            [-7, -5],
	            [-5, 3]
	        ],
	        [
	            [5943, 7129],
	            [1, -5],
	            [-28, -24],
	            [-14, 8],
	            [-7, 23],
	            [14, 2]
	        ],
	        [
	            [5377, 7945],
	            [-16, 25],
	            [-14, 15],
	            [-3, 25],
	            [-5, 17],
	            [21, 13],
	            [10, 15],
	            [20, 11],
	            [7, 11],
	            [7, -6],
	            [13, 6]
	        ],
	        [
	            [5417, 8077],
	            [13, -19],
	            [21, -5],
	            [-2, -17],
	            [15, -12],
	            [4, 15],
	            [19, -6],
	            [3, -19],
	            [20, -3],
	            [13, -29]
	        ],
	        [
	            [5523, 7982],
	            [-8, 0],
	            [-4, -11],
	            [-7, -3],
	            [-2, -13],
	            [-5, -3],
	            [-1, -5],
	            [-9, -7],
	            [-12, 1],
	            [-4, -13]
	        ],
	        [
	            [5275, 8306],
	            [1, -23],
	            [28, -14],
	            [-1, -21],
	            [29, 11],
	            [15, 16],
	            [32, -23],
	            [13, -19]
	        ],
	        [
	            [5392, 8233],
	            [6, -30],
	            [-8, -16],
	            [11, -21],
	            [6, -31],
	            [-2, -21],
	            [12, -37]
	        ],
	        [
	            [5207, 7871],
	            [3, 42],
	            [14, 40],
	            [-40, 11],
	            [-13, 16]
	        ],
	        [
	            [5171, 7980],
	            [2, 26],
	            [-6, 13]
	        ],
	        [
	            [5171, 8059],
	            [-5, 62],
	            [17, 0],
	            [7, 22],
	            [6, 54],
	            [-5, 20]
	        ],
	        [
	            [5191, 8217],
	            [6, 13],
	            [23, 3],
	            [5, -13],
	            [19, 29],
	            [-6, 22],
	            [-2, 34]
	        ],
	        [
	            [5236, 8305],
	            [21, -8],
	            [18, 9]
	        ],
	        [
	            [6196, 5808],
	            [7, -19],
	            [-1, -24],
	            [-16, -14],
	            [12, -16]
	        ],
	        [
	            [6198, 5735],
	            [-10, -32]
	        ],
	        [
	            [6188, 5703],
	            [-7, 11],
	            [-6, -5],
	            [-16, 1],
	            [0, 18],
	            [-2, 17],
	            [9, 27],
	            [10, 26]
	        ],
	        [
	            [6176, 5798],
	            [12, -5],
	            [8, 15]
	        ],
	        [
	            [5352, 8343],
	            [-17, -48],
	            [-29, 33],
	            [-4, 25],
	            [41, 19],
	            [9, -29]
	        ],
	        [
	            [5236, 8305],
	            [-11, 32],
	            [-1, 61],
	            [5, 16],
	            [8, 17],
	            [24, 4],
	            [10, 16],
	            [22, 17],
	            [-1, -30],
	            [-8, -20],
	            [4, -16],
	            [15, -9],
	            [-7, -22],
	            [-8, 6],
	            [-20, -42],
	            [7, -29]
	        ],
	        [
	            [3008, 6222],
	            [3, 10],
	            [22, 0],
	            [16, -15],
	            [8, 1],
	            [5, -21],
	            [15, 1],
	            [-1, -17],
	            [12, -2],
	            [14, -22],
	            [-10, -24],
	            [-14, 13],
	            [-12, -3],
	            [-9, 3],
	            [-5, -11],
	            [-11, -3],
	            [-4, 14],
	            [-10, -8],
	            [-11, -41],
	            [-7, 10],
	            [-1, 17]
	        ],
	        [
	            [3008, 6124],
	            [0, 16],
	            [-7, 17],
	            [7, 10],
	            [2, 23],
	            [-2, 32]
	        ],
	        [
	            [5333, 6444],
	            [-95, -112],
	            [-81, -117],
	            [-39, -26]
	        ],
	        [
	            [5118, 6189],
	            [-31, -6],
	            [0, 38],
	            [-13, 10],
	            [-17, 16],
	            [-7, 28],
	            [-94, 129],
	            [-93, 129]
	        ],
	        [
	            [4863, 6533],
	            [-105, 143]
	        ],
	        [
	            [4758, 6676],
	            [1, 11],
	            [0, 4]
	        ],
	        [
	            [4759, 6691],
	            [0, 70],
	            [44, 44],
	            [28, 9],
	            [23, 16],
	            [11, 29],
	            [32, 24],
	            [1, 44],
	            [16, 5],
	            [13, 22],
	            [36, 9],
	            [5, 23],
	            [-7, 13],
	            [-10, 62],
	            [-1, 36],
	            [-11, 38]
	        ],
	        [
	            [4939, 7135],
	            [27, 32],
	            [30, 11],
	            [17, 24],
	            [27, 18],
	            [47, 11],
	            [46, 4],
	            [14, -8],
	            [26, 23],
	            [30, 0],
	            [11, -13],
	            [19, 3]
	        ],
	        [
	            [5233, 7240],
	            [-5, -30],
	            [4, -56],
	            [-6, -49],
	            [-18, -33],
	            [3, -45],
	            [23, -35],
	            [0, -14],
	            [17, -24],
	            [12, -106]
	        ],
	        [
	            [5263, 6848],
	            [9, -52],
	            [1, -28],
	            [-5, -48],
	            [2, -27],
	            [-3, -32],
	            [2, -37],
	            [-11, -25],
	            [17, -43],
	            [1, -25],
	            [10, -33],
	            [13, 11],
	            [22, -28],
	            [12, -37]
	        ],
	        [
	            [2769, 4856],
	            [15, 45],
	            [-6, 25],
	            [-11, -27],
	            [-16, 26],
	            [5, 16],
	            [-4, 54],
	            [9, 9],
	            [5, 37],
	            [11, 38],
	            [-2, 24],
	            [15, 13],
	            [19, 23]
	        ],
	        [
	            [2906, 5049],
	            [4, -45],
	            [-9, -39],
	            [-30, -62],
	            [-33, -23],
	            [-17, -51],
	            [-6, -40],
	            [-15, -24],
	            [-12, 29],
	            [-11, 7],
	            [-12, -5],
	            [-1, 22],
	            [8, 14],
	            [-3, 24]
	        ],
	        [
	            [5969, 6800],
	            [-7, -23],
	            [-6, -45],
	            [-8, -31],
	            [-6, -10],
	            [-10, 19],
	            [-12, 26],
	            [-20, 85],
	            [-3, -5],
	            [12, -63],
	            [17, -59],
	            [21, -92],
	            [10, -32],
	            [9, -34],
	            [25, -65],
	            [-6, -10],
	            [1, -39],
	            [33, -53],
	            [4, -12]
	        ],
	        [
	            [6023, 6357],
	            [-110, 0],
	            [-107, 0],
	            [-112, 0]
	        ],
	        [
	            [5694, 6357],
	            [0, 218],
	            [0, 210],
	            [-8, 47],
	            [7, 37],
	            [-5, 25],
	            [10, 29]
	        ],
	        [
	            [5698, 6923],
	            [37, 0],
	            [27, -15],
	            [28, -18],
	            [13, -9],
	            [21, 19],
	            [11, 17],
	            [25, 5],
	            [20, -8],
	            [7, -29],
	            [7, 19],
	            [22, -14],
	            [22, -3],
	            [13, 15]
	        ],
	        [
	            [5951, 6902],
	            [18, -102]
	        ],
	        [
	            [6176, 5798],
	            [-10, 20],
	            [-11, 34],
	            [-12, 19],
	            [-8, 21],
	            [-24, 23],
	            [-19, 1],
	            [-7, 12],
	            [-16, -14],
	            [-17, 27],
	            [-8, -44],
	            [-33, 13]
	        ],
	        [
	            [6011, 5910],
	            [-3, 23],
	            [12, 87],
	            [3, 39],
	            [9, 18],
	            [20, 10],
	            [14, 34]
	        ],
	        [
	            [6066, 6121],
	            [16, -69],
	            [8, -54],
	            [15, -29],
	            [38, -55],
	            [16, -34],
	            [15, -34],
	            [8, -20],
	            [14, -18]
	        ],
	        [
	            [4749, 7532],
	            [1, 42],
	            [-11, 25],
	            [39, 43],
	            [34, -11],
	            [37, 1],
	            [30, -10],
	            [23, 3],
	            [45, -2]
	        ],
	        [
	            [4947, 7623],
	            [11, -23],
	            [51, -27],
	            [10, 13],
	            [31, -27],
	            [32, 8]
	        ],
	        [
	            [5082, 7567],
	            [2, -35],
	            [-26, -39],
	            [-36, -12],
	            [-2, -20],
	            [-18, -33],
	            [-10, -48],
	            [11, -34],
	            [-16, -26],
	            [-6, -39],
	            [-21, -11],
	            [-20, -46],
	            [-35, -1],
	            [-27, 1],
	            [-17, -21],
	            [-11, -22],
	            [-13, 5],
	            [-11, 20],
	            [-8, 34],
	            [-26, 9]
	        ],
	        [
	            [4792, 7249],
	            [-2, 20],
	            [10, 22],
	            [4, 16],
	            [-9, 17],
	            [7, 39],
	            [-11, 36],
	            [12, 5],
	            [1, 27],
	            [5, 9],
	            [0, 46],
	            [13, 16],
	            [-8, 30],
	            [-16, 2],
	            [-5, -8],
	            [-16, 0],
	            [-7, 29],
	            [-11, -8],
	            [-10, -15]
	        ],
	        [
	            [5675, 8472],
	            [3, 35],
	            [-10, -8],
	            [-18, 21],
	            [-2, 34],
	            [35, 17],
	            [35, 8],
	            [30, -10],
	            [29, 2]
	        ],
	        [
	            [5777, 8571],
	            [4, -10],
	            [-20, -34],
	            [8, -55],
	            [-12, -19]
	        ],
	        [
	            [5757, 8453],
	            [-22, 0],
	            [-24, 22],
	            [-13, 7],
	            [-23, -10]
	        ],
	        [
	            [6188, 5703],
	            [-6, -21],
	            [10, -32],
	            [10, -29],
	            [11, -21],
	            [90, -70],
	            [24, 0]
	        ],
	        [
	            [6327, 5530],
	            [-79, -177],
	            [-36, -3],
	            [-25, -41],
	            [-17, -1],
	            [-8, -19]
	        ],
	        [
	            [6162, 5289],
	            [-19, 0],
	            [-11, 20],
	            [-26, -25],
	            [-8, -24],
	            [-18, 4],
	            [-6, 7],
	            [-7, -1],
	            [-9, 0],
	            [-35, 50],
	            [-19, 0],
	            [-10, 20],
	            [0, 33],
	            [-14, 10]
	        ],
	        [
	            [5980, 5383],
	            [-17, 64],
	            [-12, 14],
	            [-5, 23],
	            [-14, 29],
	            [-17, 4],
	            [9, 34],
	            [15, 2],
	            [4, 18]
	        ],
	        [
	            [5943, 5571],
	            [0, 53]
	        ],
	        [
	            [5943, 5624],
	            [8, 62],
	            [13, 16],
	            [3, 24],
	            [12, 45],
	            [17, 30],
	            [11, 58],
	            [4, 51]
	        ],
	        [
	            [5794, 9138],
	            [-4, -42],
	            [42, -39],
	            [-26, -45],
	            [33, -67],
	            [-19, -51],
	            [25, -43],
	            [-11, -39],
	            [41, -40],
	            [-11, -31],
	            [-25, -34],
	            [-60, -75]
	        ],
	        [
	            [5779, 8632],
	            [-50, -5],
	            [-49, -21],
	            [-45, -13],
	            [-16, 32],
	            [-27, 20],
	            [6, 58],
	            [-14, 53],
	            [14, 35],
	            [25, 37],
	            [63, 64],
	            [19, 12],
	            [-3, 25],
	            [-39, 28]
	        ],
	        [
	            [5663, 8957],
	            [-9, 23],
	            [-1, 91],
	            [-43, 40],
	            [-37, 29]
	        ],
	        [
	            [5573, 9140],
	            [17, 16],
	            [30, -32],
	            [37, 3],
	            [30, -14],
	            [26, 26],
	            [14, 44],
	            [43, 20],
	            [35, -24],
	            [-11, -41]
	        ],
	        [
	            [9954, 4033],
	            [9, -17],
	            [-4, -31],
	            [-17, -8],
	            [-16, 7],
	            [-2, 26],
	            [10, 21],
	            [13, -8],
	            [7, 10]
	        ],
	        [
	            [0, 4079],
	            [9981, -14],
	            [-17, -13],
	            [-4, 23],
	            [14, 12],
	            [9, 3],
	            [-9983, 18]
	        ],
	        [
	            [0, 4108],
	            [0, -29]
	        ],
	        [
	            [0, 4108],
	            [6, 3],
	            [-4, -28],
	            [-2, -4]
	        ],
	        [
	            [3300, 1994],
	            [33, 36],
	            [24, -15],
	            [16, 24],
	            [22, -27],
	            [-8, -21],
	            [-37, -17],
	            [-13, 20],
	            [-23, -26],
	            [-14, 26]
	        ],
	        [
	            [5265, 7548],
	            [-9, -46],
	            [-13, 12],
	            [-6, 40],
	            [5, 22],
	            [18, 22],
	            [5, -50]
	        ],
	        [
	            [5157, 7984],
	            [6, -6],
	            [8, 2]
	        ],
	        [
	            [5190, 7775],
	            [-2, -17],
	            [9, -22],
	            [-10, -18],
	            [7, -46],
	            [15, -8],
	            [-3, -25]
	        ],
	        [
	            [5206, 7639],
	            [-25, -34],
	            [-55, 16],
	            [-40, -19],
	            [-4, -35]
	        ],
	        [
	            [4947, 7623],
	            [14, 35],
	            [5, 118],
	            [-28, 62],
	            [-21, 30],
	            [-42, 23],
	            [-3, 43],
	            [36, 12],
	            [47, -15],
	            [-9, 67],
	            [26, -25],
	            [65, 46],
	            [8, 48],
	            [24, 12]
	        ],
	        [
	            [3485, 5194],
	            [7, 25],
	            [3, 27]
	        ],
	        [
	            [3495, 5246],
	            [4, 26],
	            [-10, 34]
	        ],
	        [
	            [3489, 5306],
	            [-3, 41],
	            [15, 51]
	        ],
	        [
	            [3501, 5398],
	            [9, -7],
	            [21, -14],
	            [29, -50],
	            [5, -24]
	        ],
	        [
	            [5308, 4822],
	            [-29, 60],
	            [-18, 49],
	            [-17, 61],
	            [1, 19],
	            [6, 19],
	            [7, 43],
	            [5, 44]
	        ],
	        [
	            [5263, 5117],
	            [10, 4],
	            [40, -1],
	            [0, 71]
	        ],
	        [
	            [4827, 8240],
	            [-21, 12],
	            [-17, -1],
	            [6, 32],
	            [-6, 32]
	        ],
	        [
	            [4789, 8315],
	            [23, 2],
	            [30, -37],
	            [-15, -40]
	        ],
	        [
	            [4916, 8521],
	            [-30, -63],
	            [29, 8],
	            [30, -1],
	            [-7, -48],
	            [-25, -53],
	            [29, -4],
	            [2, -6],
	            [25, -69],
	            [19, -10],
	            [17, -67],
	            [8, -24],
	            [33, -11],
	            [-3, -38],
	            [-14, -17],
	            [11, -30],
	            [-25, -31],
	            [-37, 0],
	            [-48, -16],
	            [-13, 12],
	            [-18, -28],
	            [-26, 7],
	            [-19, -23],
	            [-15, 12],
	            [41, 62],
	            [25, 13],
	            [-1, 0],
	            [-43, 9],
	            [-8, 24],
	            [29, 18],
	            [-15, 32],
	            [5, 39],
	            [42, -6],
	            [4, 35],
	            [-19, 36],
	            [0, 1],
	            [-34, 10],
	            [-7, 16],
	            [10, 27],
	            [-9, 16],
	            [-15, -28],
	            [-1, 57],
	            [-14, 30],
	            [10, 61],
	            [21, 48],
	            [23, -4],
	            [33, 4]
	        ],
	        [
	            [6154, 7511],
	            [4, 26],
	            [-7, 40],
	            [-16, 22],
	            [-16, 6],
	            [-10, 19]
	        ],
	        [
	            [6109, 7624],
	            [4, 6],
	            [23, -10],
	            [41, -9],
	            [38, -28],
	            [5, -11],
	            [17, 9],
	            [25, -13],
	            [9, -24],
	            [17, -13]
	        ],
	        [
	            [6210, 7485],
	            [-27, 29],
	            [-29, -3]
	        ],
	        [
	            [5029, 5408],
	            [-44, -35],
	            [-15, -20],
	            [-25, -17],
	            [-25, 17]
	        ],
	        [
	            [5000, 5708],
	            [-2, -18],
	            [12, -30],
	            [0, -43],
	            [2, -47],
	            [7, -21],
	            [-6, -54],
	            [2, -29],
	            [8, -37],
	            [6, -21]
	        ],
	        [
	            [4765, 5512],
	            [-8, 1],
	            [-5, -24],
	            [-8, 1],
	            [-6, 12],
	            [2, 24],
	            [-11, 36],
	            [-8, -7],
	            [-6, -1]
	        ],
	        [
	            [4715, 5554],
	            [-7, -3],
	            [0, 21],
	            [-4, 16],
	            [0, 17],
	            [-6, 25],
	            [-7, 21],
	            [-23, 0],
	            [-6, -11],
	            [-8, -1],
	            [-4, -13],
	            [-4, -17],
	            [-14, -26]
	        ],
	        [
	            [4632, 5583],
	            [-13, 35],
	            [-10, 24],
	            [-8, 7],
	            [-6, 12],
	            [-4, 26],
	            [-4, 13],
	            [-8, 10]
	        ],
	        [
	            [4579, 5710],
	            [13, 29],
	            [8, -2],
	            [7, 10],
	            [6, 0],
	            [5, 8],
	            [-3, 20],
	            [3, 6],
	            [1, 20]
	        ],
	        [
	            [4619, 5801],
	            [13, -1],
	            [20, -14],
	            [6, 1],
	            [3, 7],
	            [15, -5],
	            [4, 4]
	        ],
	        [
	            [4680, 5793],
	            [1, -22],
	            [5, 0],
	            [7, 8],
	            [5, -2],
	            [7, -15],
	            [12, -5],
	            [8, 13],
	            [9, 8],
	            [6, 8],
	            [6, -1],
	            [6, -13],
	            [3, -17],
	            [12, -24],
	            [-6, -16],
	            [-1, -19],
	            [6, 6],
	            [3, -7],
	            [-1, -17],
	            [8, -18]
	        ],
	        [
	            [4532, 5834],
	            [3, 27]
	        ],
	        [
	            [4535, 5861],
	            [31, 1],
	            [6, 14],
	            [9, 1],
	            [11, -14],
	            [8, -1],
	            [9, 10],
	            [6, -17],
	            [-12, -13],
	            [-12, 1],
	            [-12, 13],
	            [-10, -14],
	            [-5, -1],
	            [-7, -8],
	            [-25, 1]
	        ],
	        [
	            [4579, 5710],
	            [-15, 24],
	            [-11, 4],
	            [-7, 17],
	            [1, 9],
	            [-9, 13],
	            [-2, 12]
	        ],
	        [
	            [4536, 5789],
	            [15, 10],
	            [9, -2],
	            [8, 7],
	            [51, -3]
	        ],
	        [
	            [5263, 5117],
	            [-5, 9],
	            [10, 66]
	        ],
	        [
	            [5658, 7167],
	            [15, -20],
	            [22, 3],
	            [20, -4],
	            [0, -10],
	            [15, 7],
	            [-4, -18],
	            [-40, -5],
	            [1, 10],
	            [-34, 12],
	            [5, 25]
	        ],
	        [
	            [5723, 7469],
	            [-17, 2],
	            [-14, 6],
	            [-34, -16],
	            [19, -33],
	            [-14, -10],
	            [-15, 0],
	            [-15, 31],
	            [-5, -13],
	            [6, -36],
	            [14, -27],
	            [-10, -13],
	            [15, -27],
	            [14, -18],
	            [0, -33],
	            [-25, 16],
	            [8, -30],
	            [-18, -7],
	            [11, -52],
	            [-19, -1],
	            [-23, 26],
	            [-10, 47],
	            [-5, 40],
	            [-11, 27],
	            [-14, 34],
	            [-2, 16]
	        ],
	        [
	            [5583, 7470],
	            [18, 6],
	            [11, 13],
	            [15, -2],
	            [5, 11],
	            [5, 2]
	        ],
	        [
	            [5725, 7529],
	            [13, -16],
	            [-8, -37],
	            [-7, -7]
	        ],
	        [
	            [3701, 9939],
	            [93, 35],
	            [97, -2],
	            [36, 21],
	            [98, 6],
	            [222, -7],
	            [174, -47],
	            [-52, -23],
	            [-106, -3],
	            [-150, -5],
	            [14, -11],
	            [99, 7],
	            [83, -21],
	            [54, 18],
	            [23, -21],
	            [-30, -34],
	            [71, 22],
	            [135, 23],
	            [83, -12],
	            [15, -25],
	            [-113, -42],
	            [-16, -14],
	            [-88, -10],
	            [64, -3],
	            [-32, -43],
	            [-23, -38],
	            [1, -66],
	            [33, -38],
	            [-43, -3],
	            [-46, -19],
	            [52, -31],
	            [6, -50],
	            [-30, -6],
	            [36, -50],
	            [-61, -5],
	            [32, -24],
	            [-9, -20],
	            [-39, -10],
	            [-39, 0],
	            [35, -40],
	            [0, -26],
	            [-55, 24],
	            [-14, -15],
	            [37, -15],
	            [37, -36],
	            [10, -48],
	            [-49, -11],
	            [-22, 22],
	            [-34, 34],
	            [10, -40],
	            [-33, -31],
	            [73, -2],
	            [39, -3],
	            [-75, -52],
	            [-75, -46],
	            [-81, -21],
	            [-31, 0],
	            [-29, -23],
	            [-38, -62],
	            [-60, -42],
	            [-19, -2],
	            [-37, -15],
	            [-40, -13],
	            [-24, -37],
	            [0, -41],
	            [-15, -39],
	            [-45, -47],
	            [11, -47],
	            [-12, -48],
	            [-14, -58],
	            [-39, -4],
	            [-41, 49],
	            [-56, 0],
	            [-27, 32],
	            [-18, 58],
	            [-49, 73],
	            [-14, 39],
	            [-3, 53],
	            [-39, 54],
	            [10, 44],
	            [-18, 21],
	            [27, 69],
	            [42, 22],
	            [11, 25],
	            [6, 46],
	            [-32, -21],
	            [-15, -9],
	            [-25, -8],
	            [-34, 19],
	            [-2, 40],
	            [11, 31],
	            [25, 1],
	            [57, -15],
	            [-48, 37],
	            [-24, 20],
	            [-28, -8],
	            [-23, 15],
	            [31, 55],
	            [-17, 22],
	            [-22, 41],
	            [-34, 62],
	            [-35, 23],
	            [0, 25],
	            [-74, 34],
	            [-59, 5],
	            [-74, -3],
	            [-68, -4],
	            [-32, 19],
	            [-49, 37],
	            [73, 19],
	            [56, 3],
	            [-119, 15],
	            [-62, 24],
	            [3, 23],
	            [106, 28],
	            [101, 29],
	            [11, 21],
	            [-75, 22],
	            [24, 23],
	            [97, 41],
	            [40, 7],
	            [-12, 26],
	            [66, 16],
	            [86, 9],
	            [85, 1],
	            [30, -19],
	            [74, 33],
	            [66, -22],
	            [39, -5],
	            [58, -19],
	            [-66, 32],
	            [4, 25]
	        ],
	        [
	            [2497, 5869],
	            [-14, 10],
	            [-17, 1],
	            [-13, 12],
	            [-15, 24]
	        ],
	        [
	            [2438, 5916],
	            [1, 18],
	            [3, 13],
	            [-4, 12],
	            [13, 48],
	            [36, 0],
	            [1, 20],
	            [-5, 4],
	            [-3, 12],
	            [-10, 14],
	            [-11, 20],
	            [13, 0],
	            [0, 33],
	            [26, 0],
	            [26, 0]
	        ],
	        [
	            [2529, 5996],
	            [10, -11],
	            [2, 9],
	            [8, -7]
	        ],
	        [
	            [2549, 5987],
	            [-13, -23],
	            [-13, -16],
	            [-2, -12],
	            [2, -11],
	            [-5, -15]
	        ],
	        [
	            [2518, 5910],
	            [-7, -4],
	            [2, -7],
	            [-6, -6],
	            [-9, -15],
	            [-1, -9]
	        ],
	        [
	            [3340, 5552],
	            [18, -22],
	            [17, -38],
	            [1, -31],
	            [10, -1],
	            [15, -29],
	            [11, -21]
	        ],
	        [
	            [3412, 5410],
	            [-4, -53],
	            [-17, -15],
	            [1, -14],
	            [-5, -31],
	            [13, -42],
	            [9, -1],
	            [3, -33],
	            [17, -51]
	        ],
	        [
	            [3313, 5365],
	            [-19, 45],
	            [7, 16],
	            [0, 27],
	            [17, 10],
	            [7, 11],
	            [-10, 22],
	            [3, 21],
	            [22, 35]
	        ],
	        [
	            [2574, 5825],
	            [-5, 18],
	            [-8, 5]
	        ],
	        [
	            [2561, 5848],
	            [2, 24],
	            [-4, 6],
	            [-6, 4],
	            [-12, -7],
	            [-1, 8],
	            [-8, 10],
	            [-6, 12],
	            [-8, 5]
	        ],
	        [
	            [2549, 5987],
	            [3, -3],
	            [6, 11],
	            [8, 1],
	            [3, -5],
	            [4, 3],
	            [13, -6],
	            [13, 2],
	            [9, 6],
	            [3, 7],
	            [9, -3],
	            [6, -4],
	            [8, 1],
	            [5, 5],
	            [13, -8],
	            [4, -1],
	            [9, -11],
	            [8, -13],
	            [10, -9],
	            [7, -17]
	        ],
	        [
	            [2690, 5943],
	            [-9, 2],
	            [-4, -8],
	            [-10, -8],
	            [-7, 0],
	            [-6, -8],
	            [-6, 3],
	            [-4, 9],
	            [-3, -2],
	            [-4, -14],
	            [-3, 1],
	            [0, -12],
	            [-10, -17],
	            [-5, -7],
	            [-3, -7],
	            [-8, 12],
	            [-6, -16],
	            [-6, 1],
	            [-6, -2],
	            [0, -29],
	            [-4, 0],
	            [-3, -14],
	            [-9, -2]
	        ],
	        [
	            [5522, 7770],
	            [7, -23],
	            [9, -17],
	            [-11, -22]
	        ],
	        [
	            [5515, 7577],
	            [-3, -10]
	        ],
	        [
	            [5512, 7567],
	            [-26, 22],
	            [-16, 21],
	            [-26, 18],
	            [-23, 43],
	            [6, 5],
	            [-13, 25],
	            [-1, 19],
	            [-17, 10],
	            [-9, -26],
	            [-8, 20],
	            [0, 21],
	            [1, 1]
	        ],
	        [
	            [5380, 7746],
	            [20, -2],
	            [5, 9],
	            [9, -9],
	            [11, -1],
	            [0, 16],
	            [10, 6],
	            [2, 24],
	            [23, 16]
	        ],
	        [
	            [5460, 7805],
	            [8, -7],
	            [21, -26],
	            [23, -11],
	            [10, 9]
	        ],
	        [
	            [3008, 6124],
	            [-19, 10],
	            [-13, -5],
	            [-17, 5],
	            [-13, -11],
	            [-15, 18],
	            [3, 19],
	            [25, -8],
	            [21, -5],
	            [10, 13],
	            [-12, 26],
	            [0, 23],
	            [-18, 9],
	            [7, 16],
	            [17, -3],
	            [24, -9]
	        ],
	        [
	            [5471, 7900],
	            [14, -15],
	            [10, -6],
	            [24, 7],
	            [2, 12],
	            [11, 2],
	            [14, 9],
	            [3, -4],
	            [13, 8],
	            [6, 13],
	            [9, 4],
	            [30, -18],
	            [6, 6]
	        ],
	        [
	            [5613, 7918],
	            [15, -16],
	            [2, -16]
	        ],
	        [
	            [5630, 7886],
	            [-17, -12],
	            [-13, -40],
	            [-17, -40],
	            [-22, -11]
	        ],
	        [
	            [5561, 7783],
	            [-17, 2],
	            [-22, -15]
	        ],
	        [
	            [5460, 7805],
	            [-6, 20],
	            [-4, 0]
	        ],
	        [
	            [8352, 4453],
	            [-11, -2],
	            [-37, 42],
	            [26, 11],
	            [14, -18],
	            [10, -17],
	            [-2, -16]
	        ],
	        [
	            [8471, 4532],
	            [2, -11],
	            [1, -18]
	        ],
	        [
	            [8474, 4503],
	            [-18, -45],
	            [-24, -13],
	            [-3, 8],
	            [2, 20],
	            [12, 36],
	            [28, 23]
	        ],
	        [
	            [8274, 4579],
	            [10, -16],
	            [17, 5],
	            [7, -25],
	            [-32, -12],
	            [-19, -8],
	            [-15, 1],
	            [10, 34],
	            [15, 0],
	            [7, 21]
	        ],
	        [
	            [8413, 4579],
	            [-4, -32],
	            [-42, -17],
	            [-37, 7],
	            [0, 22],
	            [22, 12],
	            [18, -18],
	            [18, 5],
	            [25, 21]
	        ],
	        [
	            [8017, 4657],
	            [53, -6],
	            [6, 25],
	            [51, -29],
	            [10, -38],
	            [42, -11],
	            [34, -35],
	            [-31, -23],
	            [-31, 24],
	            [-25, -1],
	            [-29, 4],
	            [-26, 11],
	            [-32, 22],
	            [-21, 6],
	            [-11, -7],
	            [-51, 24],
	            [-5, 25],
	            [-25, 5],
	            [19, 56],
	            [34, -3],
	            [22, -23],
	            [12, -5],
	            [4, -21]
	        ],
	        [
	            [8741, 4690],
	            [-14, -40],
	            [-3, 45],
	            [5, 21],
	            [6, 20],
	            [7, -17],
	            [-1, -29]
	        ],
	        [
	            [8534, 4853],
	            [-11, -19],
	            [-19, 10],
	            [-5, 26],
	            [28, 3],
	            [7, -20]
	        ],
	        [
	            [8623, 4875],
	            [10, -45],
	            [-23, 24],
	            [-23, 5],
	            [-16, -4],
	            [-19, 2],
	            [6, 33],
	            [35, 2],
	            [30, -17]
	        ],
	        [
	            [8916, 4904],
	            [0, -193],
	            [1, -192]
	        ],
	        [
	            [8917, 4519],
	            [-25, 48],
	            [-28, 12],
	            [-7, -17],
	            [-35, -1],
	            [12, 48],
	            [17, 16],
	            [-7, 64],
	            [-14, 50],
	            [-53, 50],
	            [-23, 5],
	            [-42, 54],
	            [-8, -28],
	            [-11, -5],
	            [-6, 21],
	            [0, 26],
	            [-21, 29],
	            [29, 21],
	            [20, -1],
	            [-2, 16],
	            [-41, 0],
	            [-11, 35],
	            [-25, 11],
	            [-11, 29],
	            [37, 14],
	            [14, 20],
	            [45, -25],
	            [4, -22],
	            [8, -95],
	            [29, -35],
	            [23, 62],
	            [32, 36],
	            [25, 0],
	            [23, -21],
	            [21, -21],
	            [30, -11]
	        ],
	        [
	            [8478, 5141],
	            [-22, -58],
	            [-21, -12],
	            [-27, 12],
	            [-46, -3],
	            [-24, -8],
	            [-4, -45],
	            [24, -53],
	            [15, 27],
	            [52, 20],
	            [-2, -27],
	            [-12, 9],
	            [-12, -35],
	            [-25, -23],
	            [27, -76],
	            [-5, -20],
	            [25, -68],
	            [-1, -39],
	            [-14, -17],
	            [-11, 20],
	            [13, 49],
	            [-27, -23],
	            [-7, 16],
	            [3, 23],
	            [-20, 35],
	            [3, 57],
	            [-19, -18],
	            [2, -69],
	            [1, -84],
	            [-17, -9],
	            [-12, 18],
	            [8, 54],
	            [-4, 57],
	            [-12, 1],
	            [-9, 40],
	            [12, 39],
	            [4, 47],
	            [14, 89],
	            [5, 24],
	            [24, 44],
	            [22, -18],
	            [35, -8],
	            [32, 3],
	            [27, 43],
	            [5, -14]
	        ],
	        [
	            [8574, 5124],
	            [-2, -51],
	            [-14, 6],
	            [-4, -36],
	            [11, -32],
	            [-8, -7],
	            [-11, 38],
	            [-8, 75],
	            [6, 47],
	            [9, 22],
	            [2, -32],
	            [16, -5],
	            [3, -25]
	        ],
	        [
	            [8045, 5176],
	            [5, -39],
	            [19, -34],
	            [18, 12],
	            [18, -4],
	            [16, 30],
	            [13, 5],
	            [26, -17],
	            [23, 13],
	            [14, 82],
	            [11, 21],
	            [10, 67],
	            [32, 0],
	            [24, -10]
	        ],
	        [
	            [8274, 5302],
	            [-16, -53],
	            [20, -56],
	            [-5, -28],
	            [32, -54],
	            [-33, -7],
	            [-10, -40],
	            [2, -54],
	            [-27, -40],
	            [-1, -59],
	            [-10, -91],
	            [-5, 21],
	            [-31, -26],
	            [-11, 36],
	            [-20, 3],
	            [-14, 19],
	            [-33, -21],
	            [-10, 29],
	            [-18, -4],
	            [-23, 7],
	            [-4, 79],
	            [-14, 17],
	            [-13, 50],
	            [-4, 52],
	            [3, 55],
	            [16, 39]
	        ],
	        [
	            [7939, 4712],
	            [-31, -1],
	            [-24, 49],
	            [-35, 48],
	            [-12, 36],
	            [-21, 48],
	            [-14, 44],
	            [-21, 83],
	            [-24, 49],
	            [-9, 51],
	            [-10, 46],
	            [-25, 37],
	            [-14, 51],
	            [-21, 33],
	            [-29, 65],
	            [-3, 30],
	            [18, -2],
	            [43, -12],
	            [25, -57],
	            [21, -40],
	            [16, -25],
	            [26, -63],
	            [28, -1],
	            [23, -41],
	            [16, -49],
	            [22, -27],
	            [-12, -49],
	            [16, -20],
	            [10, -2],
	            [5, -41],
	            [10, -33],
	            [20, -5],
	            [14, -37],
	            [-7, -74],
	            [-1, -91]
	        ],
	        [
	            [7252, 6841],
	            [-17, -27],
	            [-11, -55],
	            [27, -23],
	            [26, -29],
	            [36, -33],
	            [38, -8],
	            [16, -30],
	            [22, -5],
	            [33, -14],
	            [23, 1],
	            [4, 23],
	            [-4, 38],
	            [2, 25]
	        ],
	        [
	            [7703, 6727],
	            [2, -22],
	            [-10, -11],
	            [2, -36],
	            [-19, 10],
	            [-36, -41],
	            [0, -33],
	            [-15, -50],
	            [-1, -29],
	            [-13, -48],
	            [-21, 13],
	            [-1, -61],
	            [-7, -20],
	            [3, -25],
	            [-14, -14]
	        ],
	        [
	            [7472, 6360],
	            [-4, -21],
	            [-19, 1],
	            [-34, -13],
	            [2, -44],
	            [-15, -35],
	            [-40, -40],
	            [-31, -69],
	            [-21, -38],
	            [-28, -38],
	            [0, -27],
	            [-13, -15],
	            [-26, -21],
	            [-12, -3],
	            [-9, -45],
	            [6, -77],
	            [1, -49],
	            [-11, -56],
	            [0, -101],
	            [-15, -2],
	            [-12, -46],
	            [8, -19],
	            [-25, -17],
	            [-10, -40],
	            [-11, -17],
	            [-26, 55],
	            [-13, 83],
	            [-11, 60],
	            [-9, 28],
	            [-15, 56],
	            [-7, 74],
	            [-5, 37],
	            [-25, 81],
	            [-12, 115],
	            [-8, 75],
	            [0, 72],
	            [-5, 55],
	            [-41, -35],
	            [-19, 7],
	            [-36, 71],
	            [13, 22],
	            [-8, 23],
	            [-33, 50]
	        ],
	        [
	            [6893, 6457],
	            [19, 40],
	            [61, -1],
	            [-6, 51],
	            [-15, 30],
	            [-4, 46],
	            [-18, 26],
	            [31, 62],
	            [32, -4],
	            [29, 61],
	            [18, 60],
	            [27, 60],
	            [-1, 42],
	            [24, 34],
	            [-23, 29],
	            [-9, 40],
	            [-10, 52],
	            [14, 25],
	            [42, -14],
	            [31, 9],
	            [26, 49]
	        ],
	        [
	            [4827, 8240],
	            [5, -42],
	            [-21, -53],
	            [-49, -35],
	            [-40, 9],
	            [23, 62],
	            [-15, 60],
	            [38, 46],
	            [21, 28]
	        ],
	        [
	            [6497, 7255],
	            [25, 12],
	            [19, 33],
	            [19, -1],
	            [12, 11],
	            [20, -6],
	            [31, -30],
	            [22, -6],
	            [31, -53],
	            [21, -2],
	            [3, -49]
	        ],
	        [
	            [6690, 6820],
	            [14, -31],
	            [11, -36],
	            [27, -26],
	            [1, -52],
	            [13, -10],
	            [2, -27],
	            [-40, -30],
	            [-10, -69]
	        ],
	        [
	            [6708, 6539],
	            [-53, 18],
	            [-30, 13],
	            [-31, 8],
	            [-12, 73],
	            [-13, 10],
	            [-22, -11],
	            [-28, -28],
	            [-34, 20],
	            [-28, 45],
	            [-27, 17],
	            [-18, 56],
	            [-21, 79],
	            [-15, -10],
	            [-17, 20],
	            [-11, -24]
	        ],
	        [
	            [6348, 6825],
	            [-15, 32],
	            [0, 31],
	            [-9, 0],
	            [5, 43],
	            [-15, 45],
	            [-34, 32],
	            [-19, 56],
	            [6, 46],
	            [14, 21],
	            [-2, 34],
	            [-18, 18],
	            [-18, 70]
	        ],
	        [
	            [6243, 7253],
	            [-15, 48],
	            [5, 18],
	            [-8, 68],
	            [19, 17]
	        ],
	        [
	            [6357, 7321],
	            [9, -43],
	            [26, -13],
	            [20, -29],
	            [39, -10],
	            [44, 15],
	            [2, 14]
	        ],
	        [
	            [6348, 6825],
	            [-16, 3]
	        ],
	        [
	            [6332, 6828],
	            [-19, 5],
	            [-20, -56]
	        ],
	        [
	            [6293, 6777],
	            [-52, 4],
	            [-78, 119],
	            [-41, 41],
	            [-34, 16]
	        ],
	        [
	            [6088, 6957],
	            [-11, 72]
	        ],
	        [
	            [6077, 7029],
	            [61, 62],
	            [11, 71],
	            [-3, 43],
	            [16, 15],
	            [14, 37]
	        ],
	        [
	            [6176, 7257],
	            [12, 9],
	            [32, -8],
	            [10, -15],
	            [13, 10]
	        ],
	        [
	            [4597, 8984],
	            [-7, -39],
	            [31, -40],
	            [-36, -45],
	            [-80, -41],
	            [-24, -10],
	            [-36, 8],
	            [-78, 19],
	            [28, 26],
	            [-61, 29],
	            [49, 12],
	            [-1, 17],
	            [-58, 14],
	            [19, 38],
	            [42, 9],
	            [43, -40],
	            [42, 32],
	            [35, -17],
	            [45, 32],
	            [47, -4]
	        ],
	        [
	            [5992, 6990],
	            [-5, -19]
	        ],
	        [
	            [5987, 6971],
	            [-10, 8],
	            [-6, -39],
	            [7, -7],
	            [-7, -8],
	            [-1, -15],
	            [13, 8]
	        ],
	        [
	            [5983, 6918],
	            [0, -23],
	            [-14, -95]
	        ],
	        [
	            [5951, 6902],
	            [8, 19],
	            [-2, 4],
	            [8, 27],
	            [5, 45],
	            [4, 15],
	            [1, 0]
	        ],
	        [
	            [5975, 7012],
	            [9, 0],
	            [3, 11],
	            [7, 0]
	        ],
	        [
	            [5994, 7023],
	            [1, -24],
	            [-4, -9],
	            [1, 0]
	        ],
	        [
	            [5431, 7316],
	            [-10, -46],
	            [4, -19],
	            [-6, -30],
	            [-21, 22],
	            [-14, 7],
	            [-39, 30],
	            [4, 30],
	            [32, -6],
	            [28, 7],
	            [22, 5]
	        ],
	        [
	            [5255, 7492],
	            [17, -42],
	            [-4, -78],
	            [-13, 4],
	            [-11, -20],
	            [-10, 16],
	            [-2, 71],
	            [-6, 34],
	            [15, -3],
	            [14, 18]
	        ],
	        [
	            [5383, 7805],
	            [-3, -29],
	            [7, -25]
	        ],
	        [
	            [5387, 7751],
	            [-22, 8],
	            [-23, -20],
	            [1, -30],
	            [-3, -17],
	            [9, -30],
	            [26, -29],
	            [14, -49],
	            [31, -48],
	            [22, 0],
	            [7, -13],
	            [-8, -11],
	            [25, -22],
	            [20, -18],
	            [24, -30],
	            [3, -11],
	            [-5, -22],
	            [-16, 28],
	            [-24, 10],
	            [-12, -39],
	            [20, -21],
	            [-3, -31],
	            [-11, -4],
	            [-15, -50],
	            [-12, -5],
	            [0, 18],
	            [6, 32],
	            [6, 12],
	            [-11, 35],
	            [-8, 29],
	            [-12, 8],
	            [-8, 25],
	            [-18, 11],
	            [-12, 24],
	            [-21, 4],
	            [-21, 26],
	            [-26, 39],
	            [-19, 34],
	            [-8, 58],
	            [-14, 7],
	            [-23, 20],
	            [-12, -8],
	            [-16, -28],
	            [-12, -4]
	        ],
	        [
	            [2845, 6150],
	            [19, -5],
	            [14, -15],
	            [5, -16],
	            [-19, -1],
	            [-9, -10],
	            [-15, 10],
	            [-16, 21],
	            [3, 14],
	            [12, 4],
	            [6, -2]
	        ],
	        [
	            [5992, 6990],
	            [31, -24],
	            [54, 63]
	        ],
	        [
	            [6088, 6957],
	            [-5, -8],
	            [-56, -30],
	            [28, -59],
	            [-9, -10],
	            [-5, -20],
	            [-21, -8],
	            [-7, -21],
	            [-12, -19],
	            [-31, 10]
	        ],
	        [
	            [5970, 6792],
	            [-1, 8]
	        ],
	        [
	            [5983, 6918],
	            [4, 17],
	            [0, 36]
	        ],
	        [
	            [8739, 7075],
	            [4, -20],
	            [-16, -36],
	            [-11, 19],
	            [-15, -14],
	            [-7, -34],
	            [-18, 16],
	            [0, 28],
	            [15, 36],
	            [16, -7],
	            [12, 25],
	            [20, -13]
	        ],
	        [
	            [8915, 7252],
	            [-10, -47],
	            [4, -30],
	            [-14, -42],
	            [-35, -27],
	            [-49, -4],
	            [-40, -67],
	            [-19, 22],
	            [-1, 44],
	            [-48, -13],
	            [-33, -27],
	            [-32, -2],
	            [28, -43],
	            [-19, -101],
	            [-18, -24],
	            [-13, 23],
	            [7, 53],
	            [-18, 17],
	            [-11, 41],
	            [26, 18],
	            [15, 37],
	            [28, 30],
	            [20, 41],
	            [55, 17],
	            [30, -12],
	            [29, 105],
	            [19, -28],
	            [40, 59],
	            [16, 23],
	            [18, 72],
	            [-5, 67],
	            [11, 37],
	            [30, 11],
	            [15, -82],
	            [-1, -48],
	            [-25, -59],
	            [0, -61]
	        ],
	        [
	            [8997, 7667],
	            [19, -12],
	            [20, 25],
	            [6, -67],
	            [-41, -16],
	            [-25, -59],
	            [-43, 41],
	            [-15, -65],
	            [-31, -1],
	            [-4, 59],
	            [14, 46],
	            [29, 3],
	            [8, 82],
	            [9, 46],
	            [32, -62],
	            [22, -20]
	        ],
	        [
	            [6970, 7554],
	            [-15, -10],
	            [-37, -42],
	            [-12, -42],
	            [-11, 0],
	            [-7, 28],
	            [-36, 2],
	            [-5, 48],
	            [-14, 0],
	            [2, 60],
	            [-33, 43],
	            [-48, -5],
	            [-32, -8],
	            [-27, 53],
	            [-22, 22],
	            [-43, 43],
	            [-6, 5],
	            [-71, -35],
	            [1, -218]
	        ],
	        [
	            [6554, 7498],
	            [-14, -3],
	            [-20, 46],
	            [-18, 17],
	            [-32, -12],
	            [-12, -20]
	        ],
	        [
	            [6458, 7526],
	            [-2, 14],
	            [7, 25],
	            [-5, 21],
	            [-32, 20],
	            [-13, 53],
	            [-15, 15],
	            [-1, 19],
	            [27, -6],
	            [1, 44],
	            [23, 9],
	            [25, -9],
	            [5, 58],
	            [-5, 36],
	            [-28, -2],
	            [-24, 14],
	            [-32, -26],
	            [-26, -12]
	        ],
	        [
	            [6363, 7799],
	            [-14, 9],
	            [3, 31],
	            [-18, 39],
	            [-20, -2],
	            [-24, 40],
	            [16, 45],
	            [-8, 12],
	            [22, 65],
	            [29, -34],
	            [3, 43],
	            [58, 64],
	            [43, 2],
	            [61, -41],
	            [33, -24],
	            [30, 25],
	            [44, 1],
	            [35, -30],
	            [8, 17],
	            [39, -2],
	            [7, 28],
	            [-45, 40],
	            [27, 29],
	            [-5, 16],
	            [26, 15],
	            [-20, 41],
	            [13, 20],
	            [104, 21],
	            [13, 14],
	            [70, 22],
	            [25, 24],
	            [50, -12],
	            [9, -61],
	            [29, 14],
	            [35, -20],
	            [-2, -32],
	            [27, 3],
	            [69, 56],
	            [-10, -19],
	            [35, -46],
	            [62, -150],
	            [15, 31],
	            [39, -34],
	            [39, 16],
	            [16, -11],
	            [13, -34],
	            [20, -12],
	            [11, -25],
	            [36, 8],
	            [15, -36]
	        ],
	        [
	            [7229, 7559],
	            [-17, 9],
	            [-14, 21],
	            [-42, 6],
	            [-46, 2],
	            [-10, -6],
	            [-39, 24],
	            [-16, -12],
	            [-4, -35],
	            [-46, 21],
	            [-18, -9],
	            [-7, -26]
	        ],
	        [
	            [6155, 4958],
	            [-20, -24],
	            [-7, -24],
	            [-10, -4],
	            [-4, -42],
	            [-9, -24],
	            [-5, -39],
	            [-12, -20]
	        ],
	        [
	            [6088, 4781],
	            [-40, 59],
	            [-1, 35],
	            [-101, 120],
	            [-5, 6]
	        ],
	        [
	            [5941, 5001],
	            [0, 63],
	            [8, 24],
	            [14, 39],
	            [10, 43],
	            [-13, 68],
	            [-3, 30],
	            [-13, 41]
	        ],
	        [
	            [5944, 5309],
	            [17, 35],
	            [19, 39]
	        ],
	        [
	            [6162, 5289],
	            [-24, -67],
	            [0, -215],
	            [17, -49]
	        ],
	        [
	            [7046, 7387],
	            [-53, -9],
	            [-34, 19],
	            [-30, -4],
	            [3, 34],
	            [30, -10],
	            [10, 18]
	        ],
	        [
	            [6972, 7435],
	            [21, -6],
	            [36, 43],
	            [-33, 31],
	            [-20, -15],
	            [-21, 22],
	            [24, 39],
	            [-9, 5]
	        ],
	        [
	            [7849, 5777],
	            [-7, 72],
	            [18, 49],
	            [36, 11],
	            [26, -8]
	        ],
	        [
	            [7922, 5901],
	            [23, -23],
	            [12, 40],
	            [25, -21]
	        ],
	        [
	            [7982, 5897],
	            [6, -40],
	            [-3, -71],
	            [-47, -45],
	            [13, -36],
	            [-30, -4],
	            [-24, -24]
	        ],
	        [
	            [7897, 5677],
	            [-23, 9],
	            [-11, 30],
	            [-14, 61]
	        ],
	        [
	            [8564, 7339],
	            [24, -70],
	            [7, -38],
	            [0, -68],
	            [-10, -33],
	            [-25, -11],
	            [-22, -25],
	            [-25, -5],
	            [-3, 32],
	            [5, 45],
	            [-13, 61],
	            [21, 10],
	            [-19, 51]
	        ],
	        [
	            [8504, 7288],
	            [2, 5],
	            [12, -2],
	            [11, 27],
	            [20, 2],
	            [11, 4],
	            [4, 15]
	        ],
	        [
	            [5557, 7574],
	            [5, 13]
	        ],
	        [
	            [5562, 7587],
	            [7, 4],
	            [4, 20],
	            [5, 3],
	            [4, -8],
	            [5, -4],
	            [3, -10],
	            [5, -2],
	            [5, -11],
	            [4, 0],
	            [-3, -14],
	            [-3, -7],
	            [1, -5]
	        ],
	        [
	            [5599, 7553],
	            [-6, -2],
	            [-17, -9],
	            [-1, -12],
	            [-4, 0]
	        ],
	        [
	            [6332, 6828],
	            [6, -26],
	            [-3, -13],
	            [9, -45]
	        ],
	        [
	            [6344, 6744],
	            [-19, -1],
	            [-7, 28],
	            [-25, 6]
	        ],
	        [
	            [7922, 5901],
	            [9, 26],
	            [1, 50],
	            [-22, 52],
	            [-2, 58],
	            [-21, 48],
	            [-21, 4],
	            [-6, -20],
	            [-16, -2],
	            [-8, 10],
	            [-30, -35],
	            [0, 53],
	            [7, 62],
	            [-19, 3],
	            [-2, 36],
	            [-12, 18]
	        ],
	        [
	            [7780, 6264],
	            [6, 21],
	            [24, 39]
	        ],
	        [
	            [7837, 6385],
	            [17, -47],
	            [12, -54],
	            [34, 0],
	            [11, -52],
	            [-18, -15],
	            [-8, -21],
	            [34, -36],
	            [23, -70],
	            [17, -52],
	            [21, -41],
	            [7, -41],
	            [-5, -59]
	        ],
	        [
	            [5975, 7012],
	            [10, 49],
	            [14, 41],
	            [0, 2]
	        ],
	        [
	            [5999, 7104],
	            [13, -3],
	            [4, -23],
	            [-15, -22],
	            [-7, -33]
	        ],
	        [
	            [4785, 5315],
	            [-7, 0],
	            [-29, 28],
	            [-25, 45],
	            [-24, 32],
	            [-18, 38]
	        ],
	        [
	            [4682, 5458],
	            [6, 19],
	            [2, 17],
	            [12, 33],
	            [13, 27]
	        ],
	        [
	            [5412, 6408],
	            [-20, -22],
	            [-15, 33],
	            [-44, 25]
	        ],
	        [
	            [5263, 6848],
	            [13, 14],
	            [3, 25],
	            [-3, 24],
	            [19, 23],
	            [8, 19],
	            [14, 17],
	            [2, 45]
	        ],
	        [
	            [5319, 7015],
	            [32, -20],
	            [12, 5],
	            [23, -10],
	            [37, -26],
	            [13, -53],
	            [25, -11],
	            [39, -25],
	            [30, -29],
	            [13, 15],
	            [13, 27],
	            [-6, 45],
	            [9, 29],
	            [20, 28],
	            [19, 8],
	            [37, -12],
	            [10, -27],
	            [10, 0],
	            [9, -10],
	            [28, -7],
	            [6, -19]
	        ],
	        [
	            [5694, 6357],
	            [0, -118],
	            [-32, 0],
	            [0, -25]
	        ],
	        [
	            [5662, 6214],
	            [-111, 113],
	            [-111, 113],
	            [-28, -32]
	        ],
	        [
	            [7271, 5502],
	            [-4, -62],
	            [-12, -16],
	            [-24, -14],
	            [-13, 47],
	            [-5, 85],
	            [13, 96],
	            [19, -33],
	            [13, -42],
	            [13, -61]
	        ],
	        [
	            [5804, 3347],
	            [10, -18],
	            [-9, -29],
	            [-4, -19],
	            [-16, -9],
	            [-5, -19],
	            [-10, -6],
	            [-21, 46],
	            [15, 37],
	            [15, 23],
	            [13, 12],
	            [12, -18]
	        ],
	        [
	            [5631, 8267],
	            [-2, 15],
	            [3, 16],
	            [-13, 10],
	            [-29, 10]
	        ],
	        [
	            [5590, 8318],
	            [-6, 50]
	        ],
	        [
	            [5584, 8368],
	            [32, 18],
	            [47, -4],
	            [27, 6],
	            [4, -12],
	            [15, -4],
	            [26, -29]
	        ],
	        [
	            [5652, 8242],
	            [-7, 19],
	            [-14, 6]
	        ],
	        [
	            [5584, 8368],
	            [1, 44],
	            [14, 37],
	            [26, 20],
	            [22, -44],
	            [22, 1],
	            [6, 46]
	        ],
	        [
	            [5757, 8453],
	            [14, -14],
	            [2, -28],
	            [9, -35]
	        ],
	        [
	            [4759, 6691],
	            [-4, 0],
	            [0, -31],
	            [-17, -2],
	            [-9, -14],
	            [-13, 0],
	            [-10, 8],
	            [-23, -6],
	            [-9, -46],
	            [-9, -5],
	            [-13, -74],
	            [-38, -64],
	            [-9, -81],
	            [-12, -27],
	            [-3, -21],
	            [-63, -5]
	        ],
	        [
	            [4527, 6323],
	            [1, 27],
	            [11, 17],
	            [9, 30],
	            [-2, 20],
	            [10, 42],
	            [15, 38],
	            [9, 9],
	            [8, 35],
	            [0, 31],
	            [10, 37],
	            [19, 21],
	            [18, 60],
	            [0, 1],
	            [14, 23],
	            [26, 6],
	            [22, 41],
	            [14, 16],
	            [23, 49],
	            [-7, 73],
	            [10, 51],
	            [4, 31],
	            [18, 40],
	            [28, 27],
	            [21, 25],
	            [18, 61],
	            [9, 36],
	            [20, 0],
	            [17, -25],
	            [26, 4],
	            [29, -13],
	            [12, -1]
	        ],
	        [
	            [5739, 7906],
	            [6, 9],
	            [19, 6],
	            [20, -19],
	            [12, -2],
	            [12, -16],
	            [-2, -20],
	            [11, -9],
	            [4, -25],
	            [9, -15],
	            [-2, -9],
	            [5, -6],
	            [-7, -4],
	            [-16, 1],
	            [-3, 9],
	            [-6, -5],
	            [2, -11],
	            [-7, -19],
	            [-5, -20],
	            [-7, -6]
	        ],
	        [
	            [5784, 7745],
	            [-5, 27],
	            [3, 25],
	            [-1, 26],
	            [-16, 35],
	            [-9, 25],
	            [-9, 17],
	            [-8, 6]
	        ],
	        [
	            [6376, 4321],
	            [7, -25],
	            [7, -39],
	            [4, -71],
	            [7, -28],
	            [-2, -28],
	            [-5, -18],
	            [-10, 35],
	            [-5, -18],
	            [5, -43],
	            [-2, -25],
	            [-8, -14],
	            [-1, -50],
	            [-11, -69],
	            [-14, -81],
	            [-17, -112],
	            [-11, -82],
	            [-12, -69],
	            [-23, -14],
	            [-24, -25],
	            [-16, 15],
	            [-22, 21],
	            [-8, 31],
	            [-2, 53],
	            [-10, 47],
	            [-2, 42],
	            [5, 43],
	            [13, 10],
	            [0, 20],
	            [13, 45],
	            [2, 37],
	            [-6, 28],
	            [-5, 38],
	            [-2, 54],
	            [9, 33],
	            [4, 38],
	            [14, 2],
	            [15, 12],
	            [11, 10],
	            [12, 1],
	            [16, 34],
	            [23, 36],
	            [8, 30],
	            [-4, 25],
	            [12, -7],
	            [15, 41],
	            [1, 36],
	            [9, 26],
	            [10, -25]
	        ],
	        [
	            [2301, 6586],
	            [-10, -52],
	            [-5, -43],
	            [-2, -79],
	            [-3, -29],
	            [5, -32],
	            [9, -29],
	            [5, -45],
	            [19, -44],
	            [6, -34],
	            [11, -29],
	            [29, -16],
	            [12, -25],
	            [24, 17],
	            [21, 6],
	            [21, 11],
	            [18, 10],
	            [17, 24],
	            [7, 34],
	            [2, 50],
	            [5, 17],
	            [19, 16],
	            [29, 13],
	            [25, -2],
	            [17, 5],
	            [6, -12],
	            [-1, -29],
	            [-15, -35],
	            [-6, -36],
	            [5, -10],
	            [-4, -26],
	            [-7, -46],
	            [-7, 15],
	            [-6, -1]
	        ],
	        [
	            [2438, 5916],
	            [-32, 64],
	            [-14, 19],
	            [-23, 16],
	            [-15, -5],
	            [-22, -22],
	            [-14, -6],
	            [-20, 16],
	            [-21, 11],
	            [-26, 27],
	            [-21, 8],
	            [-31, 28],
	            [-23, 28],
	            [-7, 16],
	            [-16, 3],
	            [-28, 19],
	            [-12, 27],
	            [-30, 34],
	            [-14, 37],
	            [-6, 29],
	            [9, 5],
	            [-3, 17],
	            [7, 16],
	            [0, 20],
	            [-10, 27],
	            [-2, 23],
	            [-9, 30],
	            [-25, 59],
	            [-28, 46],
	            [-13, 37],
	            [-24, 24],
	            [-5, 14],
	            [4, 37],
	            [-14, 13],
	            [-17, 29],
	            [-7, 41],
	            [-14, 5],
	            [-17, 31],
	            [-13, 29],
	            [-1, 19],
	            [-15, 44],
	            [-10, 45],
	            [1, 23],
	            [-20, 23],
	            [-10, -2],
	            [-15, 16],
	            [-5, -24],
	            [5, -28],
	            [2, -45],
	            [10, -24],
	            [21, -41],
	            [4, -14],
	            [4, -4],
	            [4, -20],
	            [5, 1],
	            [6, -38],
	            [8, -15],
	            [6, -21],
	            [17, -30],
	            [10, -55],
	            [8, -26],
	            [8, -28],
	            [1, -31],
	            [13, -2],
	            [12, -27],
	            [10, -26],
	            [-1, -11],
	            [-12, -21],
	            [-5, 0],
	            [-7, 36],
	            [-18, 33],
	            [-20, 29],
	            [-14, 15],
	            [1, 43],
	            [-5, 32],
	            [-13, 19],
	            [-19, 26],
	            [-4, -8],
	            [-7, 16],
	            [-17, 14],
	            [-16, 34],
	            [2, 5],
	            [11, -4],
	            [11, 22],
	            [1, 27],
	            [-22, 42],
	            [-16, 17],
	            [-10, 36],
	            [-11, 39],
	            [-12, 47],
	            [-12, 54]
	        ],
	        [
	            [1746, 6980],
	            [32, 4],
	            [35, 7],
	            [-2, -12],
	            [41, -29],
	            [64, -41],
	            [55, 0],
	            [22, 0],
	            [0, 24],
	            [48, 0],
	            [10, -20],
	            [15, -19],
	            [16, -26],
	            [9, -31],
	            [7, -32],
	            [15, -18],
	            [23, -18],
	            [17, 47],
	            [23, 1],
	            [19, -24],
	            [14, -40],
	            [10, -35],
	            [16, -34],
	            [6, -41],
	            [8, -28],
	            [22, -18],
	            [20, -13],
	            [10, 2]
	        ],
	        [
	            [5599, 7553],
	            [9, 4],
	            [13, 1]
	        ],
	        [
	            [4661, 5921],
	            [10, 11],
	            [4, 35],
	            [9, 1],
	            [20, -16],
	            [15, 11],
	            [11, -4],
	            [4, 13],
	            [112, 1],
	            [6, 42],
	            [-5, 7],
	            [-13, 255],
	            [-14, 255],
	            [43, 1]
	        ],
	        [
	            [5118, 6189],
	            [0, -136],
	            [-15, -39],
	            [-2, -37],
	            [-25, -9],
	            [-38, -5],
	            [-10, -21],
	            [-18, -3]
	        ],
	        [
	            [4680, 5793],
	            [1, 18],
	            [-2, 23],
	            [-11, 16],
	            [-5, 34],
	            [-2, 37]
	        ],
	        [
	            [7737, 5644],
	            [-3, 44],
	            [9, 45],
	            [-10, 35],
	            [3, 65],
	            [-12, 30],
	            [-9, 71],
	            [-5, 75],
	            [-12, 49],
	            [-18, -30],
	            [-32, -42],
	            [-15, 5],
	            [-17, 14],
	            [9, 73],
	            [-6, 56],
	            [-21, 68],
	            [3, 21],
	            [-16, 7],
	            [-20, 49]
	        ],
	        [
	            [7780, 6264],
	            [-16, -14],
	            [-16, -26],
	            [-20, -2],
	            [-12, -64],
	            [-12, -11],
	            [14, -52],
	            [17, -43],
	            [12, -39],
	            [-11, -51],
	            [-9, -11],
	            [6, -30],
	            [19, -47],
	            [3, -33],
	            [0, -27],
	            [11, -54],
	            [-16, -55],
	            [-13, -61]
	        ],
	        [
	            [5538, 7532],
	            [-6, 4],
	            [-8, 19],
	            [-12, 12]
	        ],
	        [
	            [5533, 7629],
	            [8, -10],
	            [4, -9],
	            [9, -6],
	            [10, -12],
	            [-2, -5]
	        ],
	        [
	            [7437, 7970],
	            [29, 10],
	            [53, 51],
	            [42, 28],
	            [24, -18],
	            [29, -1],
	            [19, -28],
	            [28, -2],
	            [40, -15],
	            [27, 41],
	            [-11, 35],
	            [28, 61],
	            [31, -24],
	            [26, -7],
	            [32, -15],
	            [6, -44],
	            [39, -25],
	            [26, 11],
	            [36, 7],
	            [27, -7],
	            [28, -29],
	            [16, -30],
	            [26, 1],
	            [35, -10],
	            [26, 15],
	            [36, 9],
	            [41, 42],
	            [17, -6],
	            [14, -20],
	            [33, 5]
	        ],
	        [
	            [5959, 4377],
	            [21, 5],
	            [34, -17],
	            [7, 8],
	            [19, 1],
	            [10, 18],
	            [17, -1],
	            [30, 23],
	            [22, 34]
	        ],
	        [
	            [6119, 4448],
	            [5, -26],
	            [-1, -59],
	            [3, -52],
	            [1, -92],
	            [5, -29],
	            [-8, -43],
	            [-11, -41],
	            [-18, -36],
	            [-25, -23],
	            [-31, -28],
	            [-32, -64],
	            [-10, -11],
	            [-20, -42],
	            [-11, -13],
	            [-3, -42],
	            [14, -45],
	            [5, -35],
	            [0, -17],
	            [5, 3],
	            [-1, -58],
	            [-4, -28],
	            [6, -10],
	            [-4, -25],
	            [-11, -21],
	            [-23, -20],
	            [-34, -32],
	            [-12, -21],
	            [3, -25],
	            [7, -4],
	            [-3, -31]
	        ],
	        [
	            [5911, 3478],
	            [-21, 0]
	        ],
	        [
	            [5890, 3478],
	            [-2, 26],
	            [-4, 27]
	        ],
	        [
	            [5884, 3531],
	            [-3, 21],
	            [5, 66],
	            [-7, 42],
	            [-13, 83]
	        ],
	        [
	            [5866, 3743],
	            [29, 67],
	            [7, 43],
	            [5, 5],
	            [3, 35],
	            [-5, 17],
	            [1, 44],
	            [6, 41],
	            [0, 75],
	            [-15, 19],
	            [-13, 4],
	            [-6, 15],
	            [-13, 12],
	            [-23, -1],
	            [-2, 22]
	        ],
	        [
	            [5840, 4141],
	            [-2, 42],
	            [84, 49]
	        ],
	        [
	            [5922, 4232],
	            [16, -28],
	            [8, 5],
	            [11, -15],
	            [1, -23],
	            [-6, -28],
	            [2, -42],
	            [19, -36],
	            [8, 41],
	            [12, 12],
	            [-2, 76],
	            [-12, 43],
	            [-10, 19],
	            [-10, -1],
	            [-7, 77],
	            [7, 45]
	        ],
	        [
	            [4661, 5921],
	            [-18, 41],
	            [-17, 43],
	            [-18, 16],
	            [-13, 17],
	            [-16, -1],
	            [-13, -12],
	            [-14, 5],
	            [-10, -19]
	        ],
	        [
	            [4542, 6011],
	            [-2, 32],
	            [8, 29],
	            [3, 55],
	            [-3, 59],
	            [-3, 29],
	            [2, 30],
	            [-7, 28],
	            [-14, 25]
	        ],
	        [
	            [4526, 6298],
	            [6, 20],
	            [108, -1],
	            [-5, 86],
	            [7, 30],
	            [26, 5],
	            [-1, 152],
	            [91, -4],
	            [0, 90]
	        ],
	        [
	            [5922, 4232],
	            [-15, 15],
	            [9, 55],
	            [9, 21],
	            [-6, 49],
	            [6, 48],
	            [5, 16],
	            [-7, 50],
	            [-14, 26]
	        ],
	        [
	            [5909, 4512],
	            [28, -11],
	            [5, -16],
	            [10, -28],
	            [7, -80]
	        ],
	        [
	            [7836, 5425],
	            [7, -5],
	            [16, -36],
	            [12, -40],
	            [2, -39],
	            [-3, -27],
	            [2, -21],
	            [2, -35],
	            [10, -16],
	            [11, -52],
	            [-1, -20],
	            [-19, -4],
	            [-27, 44],
	            [-32, 47],
	            [-4, 30],
	            [-16, 39],
	            [-4, 49],
	            [-10, 32],
	            [4, 43],
	            [-7, 25]
	        ],
	        [
	            [7779, 5439],
	            [5, 11],
	            [23, -26],
	            [2, -30],
	            [18, 7],
	            [9, 24]
	        ],
	        [
	            [8045, 5176],
	            [21, -20],
	            [21, 11],
	            [6, 50],
	            [12, 11],
	            [33, 13],
	            [20, 47],
	            [14, 37]
	        ],
	        [
	            [8206, 5379],
	            [22, 41],
	            [14, 47],
	            [11, 0],
	            [14, -30],
	            [1, -26],
	            [19, -16],
	            [23, -18],
	            [-2, -23],
	            [-19, -3],
	            [5, -29],
	            [-20, -20]
	        ],
	        [
	            [5453, 3369],
	            [-20, 45],
	            [-11, 43],
	            [-6, 58],
	            [-7, 42],
	            [-9, 91],
	            [-1, 71],
	            [-3, 32],
	            [-11, 25],
	            [-15, 48],
	            [-14, 71],
	            [-6, 37],
	            [-23, 58],
	            [-2, 45]
	        ],
	        [
	            [5644, 4022],
	            [23, 14],
	            [18, -4],
	            [11, -13],
	            [0, -5]
	        ],
	        [
	            [5552, 3594],
	            [0, -218],
	            [-25, -30],
	            [-15, -4],
	            [-17, 11],
	            [-13, 4],
	            [-4, 25],
	            [-11, 17],
	            [-14, -30]
	        ],
	        [
	            [9604, 3812],
	            [23, -36],
	            [14, -28],
	            [-10, -14],
	            [-16, 16],
	            [-19, 27],
	            [-18, 31],
	            [-19, 42],
	            [-4, 20],
	            [12, -1],
	            [16, -20],
	            [12, -20],
	            [9, -17]
	        ],
	        [
	            [5412, 6408],
	            [7, -92],
	            [10, -15],
	            [1, -19],
	            [11, -20],
	            [-6, -25],
	            [-11, -120],
	            [-1, -77],
	            [-35, -56],
	            [-12, -78],
	            [11, -22],
	            [0, -38],
	            [18, -1],
	            [-3, -28]
	        ],
	        [
	            [5393, 5795],
	            [-5, -1],
	            [-19, 64],
	            [-6, 3],
	            [-22, -33],
	            [-21, 17],
	            [-15, 3],
	            [-8, -8],
	            [-17, 2],
	            [-16, -25],
	            [-14, -2],
	            [-34, 31],
	            [-13, -15],
	            [-14, 1],
	            [-10, 23],
	            [-28, 22],
	            [-30, -7],
	            [-7, -13],
	            [-4, -34],
	            [-8, -24],
	            [-2, -53]
	        ],
	        [
	            [5236, 5339],
	            [-29, -21],
	            [-11, 3],
	            [-10, -13],
	            [-23, 1],
	            [-15, 37],
	            [-9, 43],
	            [-19, 39],
	            [-21, -1],
	            [-25, 0]
	        ],
	        [
	            [2619, 5713],
	            [-10, 18],
	            [-13, 24],
	            [-6, 20],
	            [-12, 19],
	            [-13, 26],
	            [3, 9],
	            [4, -9],
	            [2, 5]
	        ],
	        [
	            [2690, 5943],
	            [-2, -5],
	            [-2, -13],
	            [3, -22],
	            [-6, -20],
	            [-3, -24],
	            [-1, -26],
	            [1, -15],
	            [1, -27],
	            [-4, -6],
	            [-3, -25],
	            [2, -15],
	            [-6, -16],
	            [2, -16],
	            [4, -9]
	        ],
	        [
	            [5092, 8091],
	            [14, 16],
	            [24, 87],
	            [38, 25],
	            [23, -2]
	        ],
	        [
	            [5863, 9167],
	            [-47, -24],
	            [-22, -5]
	        ],
	        [
	            [5573, 9140],
	            [-17, -2],
	            [-4, -39],
	            [-53, 9],
	            [-7, -33],
	            [-27, 1],
	            [-18, -42],
	            [-28, -66],
	            [-43, -83],
	            [10, -20],
	            [-10, -24],
	            [-27, 1],
	            [-18, -55],
	            [2, -79],
	            [17, -29],
	            [-9, -70],
	            [-23, -40],
	            [-12, -34]
	        ],
	        [
	            [5306, 8535],
	            [-19, 36],
	            [-55, -69],
	            [-37, -13],
	            [-38, 30],
	            [-10, 63],
	            [-9, 137],
	            [26, 38],
	            [73, 49],
	            [55, 61],
	            [51, 82],
	            [66, 115],
	            [47, 44],
	            [76, 74],
	            [61, 26],
	            [46, -3],
	            [42, 49],
	            [51, -3],
	            [50, 12],
	            [87, -43],
	            [-36, -16],
	            [30, -37]
	        ],
	        [
	            [5686, 9657],
	            [-62, -24],
	            [-49, 13],
	            [19, 16],
	            [-16, 19],
	            [57, 11],
	            [11, -22],
	            [40, -13]
	        ],
	        [
	            [5506, 9766],
	            [92, -44],
	            [-70, -23],
	            [-15, -44],
	            [-25, -11],
	            [-13, -49],
	            [-34, -2],
	            [-59, 36],
	            [25, 21],
	            [-42, 17],
	            [-54, 50],
	            [-21, 46],
	            [75, 21],
	            [16, -20],
	            [39, 0],
	            [11, 21],
	            [40, 2],
	            [35, -21]
	        ],
	        [
	            [5706, 9808],
	            [55, -21],
	            [-41, -32],
	            [-81, -7],
	            [-82, 10],
	            [-5, 16],
	            [-40, 1],
	            [-30, 27],
	            [86, 17],
	            [40, -14],
	            [28, 17],
	            [70, -14]
	        ],
	        [
	            [9805, 2640],
	            [6, -24],
	            [20, 24],
	            [8, -25],
	            [0, -25],
	            [-10, -27],
	            [-18, -44],
	            [-14, -24],
	            [10, -28],
	            [-22, -1],
	            [-23, -22],
	            [-8, -39],
	            [-16, -60],
	            [-21, -26],
	            [-14, -17],
	            [-26, 1],
	            [-18, 20],
	            [-30, 4],
	            [-5, 22],
	            [15, 43],
	            [35, 59],
	            [18, 11],
	            [20, 22],
	            [24, 31],
	            [16, 31],
	            [13, 44],
	            [10, 15],
	            [5, 33],
	            [19, 27],
	            [6, -25]
	        ],
	        [
	            [9849, 2922],
	            [20, -63],
	            [1, 41],
	            [13, -16],
	            [4, -45],
	            [22, -19],
	            [19, -5],
	            [16, 22],
	            [14, -6],
	            [-7, -53],
	            [-8, -34],
	            [-22, 1],
	            [-7, -18],
	            [3, -25],
	            [-4, -11],
	            [-11, -32],
	            [-14, -41],
	            [-21, -23],
	            [-5, 15],
	            [-12, 9],
	            [16, 48],
	            [-9, 33],
	            [-30, 23],
	            [1, 22],
	            [20, 20],
	            [5, 46],
	            [-1, 38],
	            [-12, 40],
	            [1, 10],
	            [-13, 25],
	            [-22, 52],
	            [-12, 42],
	            [11, 4],
	            [15, -33],
	            [21, -15],
	            [8, -52]
	        ],
	        [
	            [6475, 6041],
	            [-9, 41],
	            [-22, 98]
	        ],
	        [
	            [6444, 6180],
	            [83, 59],
	            [19, 118],
	            [-13, 42]
	        ],
	        [
	            [6566, 6530],
	            [12, -40],
	            [16, -22],
	            [20, -8],
	            [17, -10],
	            [12, -34],
	            [8, -20],
	            [10, -7],
	            [0, -13],
	            [-10, -36],
	            [-5, -16],
	            [-12, -19],
	            [-10, -41],
	            [-13, 3],
	            [-5, -14],
	            [-5, -30],
	            [4, -39],
	            [-3, -7],
	            [-13, 0],
	            [-17, -22],
	            [-3, -29],
	            [-6, -12],
	            [-18, 0],
	            [-10, -15],
	            [0, -24],
	            [-14, -16],
	            [-15, 5],
	            [-19, -19],
	            [-12, -4]
	        ],
	        [
	            [6557, 6597],
	            [8, 20],
	            [3, -5],
	            [-2, -25],
	            [-4, -10]
	        ],
	        [
	            [6893, 6457],
	            [-20, 15],
	            [-9, 43],
	            [-21, 45],
	            [-51, -12],
	            [-45, -1],
	            [-39, -8]
	        ],
	        [
	            [2836, 5484],
	            [-9, 17],
	            [-6, 32],
	            [7, 16],
	            [-7, 4],
	            [-5, 20],
	            [-14, 16],
	            [-12, -4],
	            [-6, -20],
	            [-11, -15],
	            [-6, -2],
	            [-3, -13],
	            [13, -32],
	            [-7, -7],
	            [-4, -9],
	            [-13, -3],
	            [-5, 35],
	            [-4, -10],
	            [-9, 4],
	            [-5, 24],
	            [-12, 3],
	            [-7, 7],
	            [-12, 0],
	            [-1, -13],
	            [-3, 9]
	        ],
	        [
	            [2707, 5623],
	            [10, -22],
	            [-1, -12],
	            [11, -3],
	            [3, 5],
	            [8, -14],
	            [13, 4],
	            [12, 15],
	            [17, 12],
	            [9, 17],
	            [16, -3],
	            [-1, -6],
	            [15, -2],
	            [12, -10],
	            [10, -18],
	            [10, -16]
	        ],
	        [
	            [3045, 3974],
	            [-28, 33],
	            [-2, 25],
	            [-55, 59],
	            [-50, 65],
	            [-22, 36],
	            [-11, 49],
	            [4, 17],
	            [-23, 77],
	            [-28, 109],
	            [-26, 118],
	            [-11, 27],
	            [-9, 43],
	            [-21, 39],
	            [-20, 24],
	            [9, 26],
	            [-14, 57],
	            [9, 41],
	            [22, 37]
	        ],
	        [
	            [8510, 5555],
	            [2, -40],
	            [2, -33],
	            [-9, -54],
	            [-11, 60],
	            [-13, -30],
	            [9, -43],
	            [-8, -28],
	            [-32, 35],
	            [-8, 42],
	            [8, 28],
	            [-17, 28],
	            [-9, -24],
	            [-13, 2],
	            [-21, -33],
	            [-4, 17],
	            [11, 50],
	            [17, 17],
	            [15, 22],
	            [10, -27],
	            [21, 17],
	            [5, 26],
	            [19, 1],
	            [-1, 46],
	            [22, -28],
	            [3, -30],
	            [2, -21]
	        ],
	        [
	            [8443, 5665],
	            [-10, -20],
	            [-9, -37],
	            [-8, -17],
	            [-17, 40],
	            [5, 16],
	            [7, 17],
	            [3, 36],
	            [16, 4],
	            [-5, -40],
	            [21, 57],
	            [-3, -56]
	        ],
	        [
	            [8291, 5608],
	            [-37, -56],
	            [14, 41],
	            [20, 37],
	            [16, 41],
	            [15, 58],
	            [5, -48],
	            [-18, -33],
	            [-15, -40]
	        ],
	        [
	            [8385, 5760],
	            [16, -18],
	            [18, 0],
	            [0, -25],
	            [-13, -25],
	            [-18, -18],
	            [-1, 28],
	            [2, 30],
	            [-4, 28]
	        ],
	        [
	            [8485, 5776],
	            [8, -66],
	            [-21, 16],
	            [0, -20],
	            [7, -37],
	            [-13, -13],
	            [-1, 42],
	            [-9, 3],
	            [-4, 36],
	            [16, -5],
	            [0, 22],
	            [-17, 45],
	            [27, -1],
	            [7, -22]
	        ],
	        [
	            [8375, 5830],
	            [-7, -51],
	            [-12, 29],
	            [-15, 45],
	            [24, -2],
	            [10, -21]
	        ],
	        [
	            [8369, 6151],
	            [17, -17],
	            [9, 15],
	            [2, -15],
	            [-4, -24],
	            [9, -43],
	            [-7, -49],
	            [-16, -19],
	            [-5, -48],
	            [7, -47],
	            [14, -7],
	            [13, 7],
	            [34, -32],
	            [-2, -32],
	            [9, -15],
	            [-3, -27],
	            [-22, 29],
	            [-10, 31],
	            [-7, -22],
	            [-18, 36],
	            [-25, -9],
	            [-14, 13],
	            [1, 25],
	            [9, 15],
	            [-8, 13],
	            [-4, -21],
	            [-14, 34],
	            [-4, 26],
	            [-1, 56],
	            [11, -19],
	            [3, 92],
	            [9, 54],
	            [17, 0]
	        ],
	        [
	            [9329, 4655],
	            [-8, -6],
	            [-12, 22],
	            [-12, 38],
	            [-6, 45],
	            [4, 6],
	            [3, -18],
	            [8, -13],
	            [14, -38],
	            [13, -20],
	            [-4, -16]
	        ],
	        [
	            [9221, 4734],
	            [-15, -5],
	            [-4, -17],
	            [-15, -14],
	            [-15, -14],
	            [-14, 0],
	            [-23, 18],
	            [-16, 16],
	            [2, 18],
	            [25, -8],
	            [15, 4],
	            [5, 29],
	            [4, 1],
	            [2, -31],
	            [16, 4],
	            [8, 20],
	            [16, 21],
	            [-4, 35],
	            [17, 1],
	            [6, -9],
	            [-1, -33],
	            [-9, -36]
	        ],
	        [
	            [8916, 4904],
	            [48, -41],
	            [51, -34],
	            [19, -30],
	            [16, -30],
	            [4, -34],
	            [46, -37],
	            [7, -31],
	            [-25, -7],
	            [6, -39],
	            [25, -39],
	            [18, -62],
	            [15, 2],
	            [-1, -27],
	            [22, -10],
	            [-9, -11],
	            [30, -25],
	            [-3, -17],
	            [-18, -4],
	            [-7, 16],
	            [-24, 6],
	            [-28, 9],
	            [-22, 38],
	            [-16, 32],
	            [-14, 52],
	            [-36, 26],
	            [-24, -17],
	            [-17, -20],
	            [4, -43],
	            [-22, -20],
	            [-16, 9],
	            [-28, 3]
	        ],
	        [
	            [9253, 4792],
	            [-9, -16],
	            [-5, 35],
	            [-6, 23],
	            [-13, 19],
	            [-16, 25],
	            [-20, 18],
	            [8, 14],
	            [15, -17],
	            [9, -13],
	            [12, -14],
	            [11, -25],
	            [11, -19],
	            [3, -30]
	        ],
	        [
	            [5392, 8233],
	            [19, 18],
	            [43, 27],
	            [35, 20],
	            [28, -10],
	            [2, -14],
	            [27, -1]
	        ],
	        [
	            [5546, 8273],
	            [34, -7],
	            [51, 1]
	        ],
	        [
	            [5653, 8105],
	            [14, -52],
	            [-3, -17],
	            [-14, -6],
	            [-25, -50],
	            [7, -26],
	            [-6, 3]
	        ],
	        [
	            [5626, 7957],
	            [-26, 23],
	            [-20, -8],
	            [-13, 6],
	            [-17, -13],
	            [-14, 21],
	            [-11, -8],
	            [-2, 4]
	        ],
	        [
	            [3159, 6151],
	            [14, -5],
	            [5, -12],
	            [-7, -15],
	            [-21, 1],
	            [-17, -2],
	            [-1, 25],
	            [4, 9],
	            [23, -1]
	        ],
	        [
	            [8628, 7562],
	            [4, -10]
	        ],
	        [
	            [8632, 7552],
	            [-11, 3],
	            [-12, -20],
	            [-8, -20],
	            [1, -42],
	            [-14, -13],
	            [-5, -11],
	            [-11, -17],
	            [-18, -10],
	            [-12, -16],
	            [-1, -25],
	            [-3, -7],
	            [11, -9],
	            [15, -26]
	        ],
	        [
	            [8504, 7288],
	            [-13, 11],
	            [-4, -11],
	            [-8, -5],
	            [-1, 11],
	            [-7, 5],
	            [-8, 10],
	            [8, 26],
	            [7, 7],
	            [-3, 11],
	            [7, 31],
	            [-2, 10],
	            [-16, 7],
	            [-13, 15]
	        ],
	        [
	            [4792, 7249],
	            [-11, -15],
	            [-14, 8],
	            [-15, -6],
	            [5, 46],
	            [-3, 36],
	            [-12, 6],
	            [-7, 22],
	            [2, 39],
	            [11, 21],
	            [2, 24],
	            [6, 36],
	            [-1, 25],
	            [-5, 21],
	            [-1, 20]
	        ],
	        [
	            [6411, 6520],
	            [-2, 43],
	            [7, 31],
	            [8, 6],
	            [8, -18],
	            [1, -35],
	            [-6, -35]
	        ],
	        [
	            [6427, 6512],
	            [-8, -4],
	            [-8, 12]
	        ],
	        [
	            [5630, 7886],
	            [12, 13],
	            [17, -7],
	            [18, 0],
	            [13, -14],
	            [10, 9],
	            [20, 5],
	            [7, 14],
	            [12, 0]
	        ],
	        [
	            [5784, 7745],
	            [12, -11],
	            [13, 9],
	            [13, -10]
	        ],
	        [
	            [5822, 7733],
	            [0, -15],
	            [-13, -13],
	            [-9, 6],
	            [-7, -71]
	        ],
	        [
	            [5629, 7671],
	            [-5, 10],
	            [6, 10],
	            [-7, 7],
	            [-8, -13],
	            [-17, 17],
	            [-2, 25],
	            [-17, 14],
	            [-3, 18],
	            [-15, 24]
	        ],
	        [
	            [8989, 8056],
	            [28, -105],
	            [-41, 19],
	            [-17, -85],
	            [27, -61],
	            [-1, -41],
	            [-21, 36],
	            [-18, -46],
	            [-5, 50],
	            [3, 57],
	            [-3, 64],
	            [6, 45],
	            [2, 79],
	            [-17, 58],
	            [3, 80],
	            [25, 28],
	            [-11, 27],
	            [13, 8],
	            [7, -39],
	            [10, -57],
	            [-1, -58],
	            [11, -59]
	        ],
	        [
	            [5546, 8273],
	            [6, 26],
	            [38, 19]
	        ],
	        [
	            [0, 9132],
	            [68, -45],
	            [73, -59],
	            [-3, -37],
	            [19, -15],
	            [-6, 43],
	            [75, -8],
	            [55, -56],
	            [-28, -26],
	            [-46, -6],
	            [0, -57],
	            [-11, -13],
	            [-26, 2],
	            [-22, 21],
	            [-36, 17],
	            [-7, 26],
	            [-28, 9],
	            [-31, -7],
	            [-16, 20],
	            [6, 22],
	            [-33, -14],
	            [13, -28],
	            [-16, -25]
	        ],
	        [
	            [0, 8896],
	            [0, 236]
	        ],
	        [
	            [0, 9282],
	            [9999, -40],
	            [-30, -3],
	            [-5, 19],
	            [-9964, 24]
	        ],
	        [
	            [0, 9282],
	            [4, 3],
	            [23, 0],
	            [40, -17],
	            [-2, -8],
	            [-29, -14],
	            [-36, -4],
	            [0, 40]
	        ],
	        [
	            [8988, 9383],
	            [-42, -1],
	            [-57, 7],
	            [-5, 3],
	            [27, 23],
	            [34, 6],
	            [40, -23],
	            [3, -15]
	        ],
	        [
	            [9186, 9493],
	            [-32, -23],
	            [-44, 5],
	            [-52, 23],
	            [7, 20],
	            [51, -9],
	            [70, -16]
	        ],
	        [
	            [9029, 9522],
	            [-22, -44],
	            [-102, 1],
	            [-46, -14],
	            [-55, 39],
	            [15, 40],
	            [37, 11],
	            [73, -2],
	            [100, -31]
	        ],
	        [
	            [6598, 9235],
	            [-17, -5],
	            [-91, 8],
	            [-7, 26],
	            [-50, 16],
	            [-4, 32],
	            [28, 13],
	            [-1, 32],
	            [55, 50],
	            [-25, 7],
	            [66, 52],
	            [-7, 27],
	            [62, 31],
	            [91, 38],
	            [93, 11],
	            [48, 22],
	            [54, 8],
	            [19, -23],
	            [-19, -19],
	            [-98, -29],
	            [-85, -28],
	            [-86, -57],
	            [-42, -57],
	            [-43, -57],
	            [5, -49],
	            [54, -49]
	        ],
	        [
	            [0, 8896],
	            [9963, -26],
	            [-36, 4],
	            [25, -31],
	            [17, -49],
	            [13, -16],
	            [3, -24],
	            [-7, -16],
	            [-52, 13],
	            [-78, -44],
	            [-25, -7],
	            [-42, -42],
	            [-40, -36],
	            [-11, -27],
	            [-39, 41],
	            [-73, -46],
	            [-12, 22],
	            [-27, -26],
	            [-37, 8],
	            [-9, -38],
	            [-33, -58],
	            [1, -24],
	            [31, -13],
	            [-4, -86],
	            [-25, -2],
	            [-12, -49],
	            [11, -26],
	            [-48, -30],
	            [-10, -67],
	            [-41, -15],
	            [-9, -60],
	            [-40, -55],
	            [-10, 41],
	            [-12, 86],
	            [-15, 131],
	            [13, 82],
	            [23, 35],
	            [2, 28],
	            [43, 13],
	            [50, 75],
	            [47, 60],
	            [50, 48],
	            [23, 83],
	            [-34, -5],
	            [-17, -49],
	            [-70, -65],
	            [-23, 73],
	            [-72, -20],
	            [-69, -99],
	            [23, -36],
	            [-62, -16],
	            [-43, -6],
	            [2, 43],
	            [-43, 9],
	            [-35, -29],
	            [-85, 10],
	            [-91, -18],
	            [-90, -115],
	            [-106, -139],
	            [43, -8],
	            [14, -37],
	            [27, -13],
	            [18, 30],
	            [30, -4],
	            [40, -65],
	            [1, -50],
	            [-21, -59],
	            [-3, -71],
	            [-12, -94],
	            [-42, -86],
	            [-9, -41],
	            [-38, -69],
	            [-38, -68],
	            [-18, -35],
	            [-37, -34],
	            [-17, -1],
	            [-17, 29],
	            [-38, -44],
	            [-4, -19]
	        ],
	        [
	            [6363, 7799],
	            [-12, -35],
	            [-27, -10],
	            [-28, -61],
	            [25, -56],
	            [-2, -40],
	            [30, -70]
	        ],
	        [
	            [6109, 7624],
	            [-35, 49],
	            [-32, 23],
	            [-24, 34],
	            [20, 10],
	            [23, 49],
	            [-15, 24],
	            [41, 24],
	            [-1, 13],
	            [-25, -10]
	        ],
	        [
	            [6061, 7840],
	            [1, 26],
	            [14, 17],
	            [27, 4],
	            [5, 20],
	            [-7, 33],
	            [12, 30],
	            [-1, 18],
	            [-41, 19],
	            [-16, -1],
	            [-17, 28],
	            [-21, -9],
	            [-35, 20],
	            [0, 12],
	            [-10, 26],
	            [-22, 3],
	            [-2, 18],
	            [7, 12],
	            [-18, 33],
	            [-29, -5],
	            [-8, 3],
	            [-7, -14],
	            [-11, 3]
	        ],
	        [
	            [5777, 8571],
	            [31, 33],
	            [-29, 28]
	        ],
	        [
	            [5863, 9167],
	            [29, 20],
	            [46, -35],
	            [76, -14],
	            [105, -67],
	            [21, -28],
	            [2, -40],
	            [-31, -31],
	            [-45, -15],
	            [-124, 44],
	            [-21, -7],
	            [45, -43],
	            [2, -28],
	            [2, -60],
	            [36, -18],
	            [22, -15],
	            [3, 28],
	            [-17, 26],
	            [18, 22],
	            [67, -37],
	            [24, 15],
	            [-19, 43],
	            [65, 58],
	            [25, -4],
	            [26, -20],
	            [16, 40],
	            [-23, 35],
	            [14, 36],
	            [-21, 36],
	            [78, -18],
	            [16, -34],
	            [-35, -7],
	            [0, -33],
	            [22, -20],
	            [43, 13],
	            [7, 38],
	            [58, 28],
	            [97, 50],
	            [20, -3],
	            [-27, -35],
	            [35, -7],
	            [19, 21],
	            [52, 1],
	            [42, 25],
	            [31, -36],
	            [32, 39],
	            [-29, 35],
	            [14, 19],
	            [82, -18],
	            [39, -18],
	            [100, -68],
	            [19, 31],
	            [-28, 31],
	            [-1, 13],
	            [-34, 6],
	            [10, 28],
	            [-15, 46],
	            [-1, 19],
	            [51, 53],
	            [18, 54],
	            [21, 11],
	            [74, -15],
	            [5, -33],
	            [-26, -48],
	            [17, -19],
	            [9, -41],
	            [-6, -81],
	            [31, -36],
	            [-12, -40],
	            [-55, -84],
	            [32, -8],
	            [11, 21],
	            [31, 15],
	            [7, 29],
	            [24, 29],
	            [-16, 33],
	            [13, 39],
	            [-31, 5],
	            [-6, 33],
	            [22, 59],
	            [-36, 48],
	            [50, 40],
	            [-7, 42],
	            [14, 2],
	            [15, -33],
	            [-11, -57],
	            [29, -11],
	            [-12, 43],
	            [46, 23],
	            [58, 3],
	            [51, -34],
	            [-25, 49],
	            [-2, 63],
	            [48, 12],
	            [67, -2],
	            [60, 7],
	            [-23, 31],
	            [33, 39],
	            [31, 2],
	            [54, 29],
	            [74, 8],
	            [9, 16],
	            [73, 6],
	            [23, -14],
	            [62, 32],
	            [51, -1],
	            [8, 25],
	            [26, 25],
	            [66, 25],
	            [48, -19],
	            [-38, -15],
	            [63, -9],
	            [7, -29],
	            [25, 14],
	            [82, -1],
	            [62, -29],
	            [23, -22],
	            [-7, -30],
	            [-31, -18],
	            [-73, -33],
	            [-21, -17],
	            [35, -8],
	            [41, -15],
	            [25, 11],
	            [14, -38],
	            [12, 15],
	            [44, 10],
	            [90, -10],
	            [6, -28],
	            [116, -9],
	            [2, 46],
	            [59, -11],
	            [44, 1],
	            [45, -32],
	            [13, -37],
	            [-17, -25],
	            [35, -47],
	            [44, -24],
	            [27, 62],
	            [44, -26],
	            [48, 16],
	            [53, -18],
	            [21, 16],
	            [45, -8],
	            [-20, 55],
	            [37, 25],
	            [251, -38],
	            [24, -35],
	            [72, -45],
	            [112, 11],
	            [56, -10],
	            [23, -24],
	            [-4, -44],
	            [35, -16],
	            [37, 12],
	            [49, 1],
	            [52, -11],
	            [53, 6],
	            [49, -52],
	            [34, 19],
	            [-23, 37],
	            [13, 27],
	            [88, -17],
	            [58, 4],
	            [80, -29],
	            [-9960, -25]
	        ],
	        [
	            [7918, 9684],
	            [-157, -23],
	            [51, 77],
	            [23, 7],
	            [21, -4],
	            [70, -33],
	            [-8, -24]
	        ],
	        [
	            [6420, 9816],
	            [-37, -8],
	            [-25, -4],
	            [-4, -10],
	            [-33, -10],
	            [-30, 14],
	            [16, 19],
	            [-62, 2],
	            [54, 10],
	            [43, 1],
	            [5, -16],
	            [16, 14],
	            [26, 10],
	            [42, -13],
	            [-11, -9]
	        ],
	        [
	            [7775, 9718],
	            [-60, -8],
	            [-78, 17],
	            [-46, 23],
	            [-21, 42],
	            [-38, 12],
	            [72, 40],
	            [60, 14],
	            [54, -30],
	            [64, -57],
	            [-7, -53]
	        ],
	        [
	            [5844, 4990],
	            [11, -33],
	            [-1, -35],
	            [-8, -7]
	        ],
	        [
	            [5821, 4978],
	            [7, -6],
	            [16, 18]
	        ],
	        [
	            [4526, 6298],
	            [1, 25]
	        ],
	        [
	            [6188, 6023],
	            [-4, 26],
	            [-8, 17],
	            [-2, 24],
	            [-15, 21],
	            [-15, 50],
	            [-7, 48],
	            [-20, 40],
	            [-12, 10],
	            [-18, 56],
	            [-4, 41],
	            [2, 35],
	            [-16, 66],
	            [-13, 23],
	            [-15, 12],
	            [-10, 34],
	            [2, 13],
	            [-8, 31],
	            [-8, 13],
	            [-11, 44],
	            [-17, 48],
	            [-14, 40],
	            [-14, 0],
	            [5, 33],
	            [1, 20],
	            [3, 24]
	        ],
	        [
	            [6344, 6744],
	            [11, -51],
	            [14, -13],
	            [5, -21],
	            [18, -25],
	            [2, -24],
	            [-3, -20],
	            [4, -20],
	            [8, -16],
	            [4, -20],
	            [4, -14]
	        ],
	        [
	            [6427, 6512],
	            [5, -22]
	        ],
	        [
	            [6444, 6180],
	            [-80, -23],
	            [-26, -26],
	            [-20, -62],
	            [-13, -10],
	            [-7, 20],
	            [-11, -3],
	            [-27, 6],
	            [-5, 5],
	            [-32, -1],
	            [-7, -5],
	            [-12, 15],
	            [-7, -29],
	            [3, -25],
	            [-12, -19]
	        ],
	        [
	            [5943, 5617],
	            [-4, 1],
	            [0, 29],
	            [-3, 20],
	            [-14, 24],
	            [-4, 42],
	            [4, 44],
	            [-13, 4],
	            [-2, -13],
	            [-17, -3],
	            [7, -17],
	            [2, -36],
	            [-15, -32],
	            [-14, -43],
	            [-14, -6],
	            [-23, 34],
	            [-11, -12],
	            [-3, -17],
	            [-14, -11],
	            [-1, -12],
	            [-28, 0],
	            [-3, 12],
	            [-20, 2],
	            [-10, -10],
	            [-8, 5],
	            [-14, 34],
	            [-5, 17],
	            [-20, -9],
	            [-8, -27],
	            [-7, -53],
	            [-10, -11],
	            [-8, -6]
	        ],
	        [
	            [5663, 5567],
	            [-2, 2]
	        ],
	        [
	            [5635, 5716],
	            [0, 14],
	            [-10, 17],
	            [-1, 35],
	            [-5, 23],
	            [-10, -4],
	            [3, 22],
	            [7, 25],
	            [-3, 24],
	            [9, 18],
	            [-6, 14],
	            [7, 36],
	            [13, 44],
	            [24, -4],
	            [-1, 234]
	        ],
	        [
	            [6023, 6357],
	            [9, -58],
	            [-6, -10],
	            [4, -61],
	            [11, -71],
	            [10, -14],
	            [15, -22]
	        ],
	        [
	            [5943, 5624],
	            [0, -7]
	        ],
	        [
	            [5943, 5617],
	            [0, -46]
	        ],
	        [
	            [5944, 5309],
	            [-17, -28],
	            [-20, 1],
	            [-22, -14],
	            [-18, 13],
	            [-11, -16]
	        ],
	        [
	            [5682, 5544],
	            [-19, 23]
	        ],
	        [
	            [4535, 5861],
	            [-11, 46],
	            [-14, 21],
	            [12, 11],
	            [14, 41],
	            [6, 31]
	        ],
	        [
	            [4536, 5789],
	            [-4, 45]
	        ],
	        [
	            [9502, 4438],
	            [8, -20],
	            [-19, 0],
	            [-11, 37],
	            [17, -15],
	            [5, -2]
	        ],
	        [
	            [9467, 4474],
	            [-11, -1],
	            [-17, 6],
	            [-5, 9],
	            [1, 23],
	            [19, -9],
	            [9, -12],
	            [4, -16]
	        ],
	        [
	            [9490, 4490],
	            [-4, -11],
	            [-21, 52],
	            [-5, 35],
	            [9, 0],
	            [10, -47],
	            [11, -29]
	        ],
	        [
	            [9440, 4565],
	            [1, -12],
	            [-22, 25],
	            [-15, 21],
	            [-10, 20],
	            [4, 6],
	            [13, -14],
	            [23, -27],
	            [6, -19]
	        ],
	        [
	            [9375, 4623],
	            [-5, -3],
	            [-13, 14],
	            [-11, 24],
	            [1, 10],
	            [17, -25],
	            [11, -20]
	        ],
	        [
	            [4682, 5458],
	            [-8, 5],
	            [-20, 24],
	            [-14, 31],
	            [-5, 22],
	            [-3, 43]
	        ],
	        [
	            [2561, 5848],
	            [-3, -14],
	            [-16, 1],
	            [-10, 6],
	            [-12, 12],
	            [-15, 3],
	            [-8, 13]
	        ],
	        [
	            [6198, 5735],
	            [9, -11],
	            [5, -25],
	            [13, -24],
	            [14, -1],
	            [26, 16],
	            [30, 7],
	            [25, 18],
	            [13, 4],
	            [10, 11],
	            [16, 2]
	        ],
	        [
	            [6359, 5732],
	            [0, -1],
	            [0, -25],
	            [0, -59],
	            [0, -31],
	            [-13, -36],
	            [-19, -50]
	        ],
	        [
	            [6359, 5732],
	            [9, 1],
	            [13, 9],
	            [14, 6],
	            [14, 20],
	            [10, 0],
	            [1, -16],
	            [-3, -35],
	            [0, -31],
	            [-6, -21],
	            [-7, -64],
	            [-14, -66],
	            [-17, -75],
	            [-24, -87],
	            [-23, -66],
	            [-33, -81],
	            [-28, -48],
	            [-42, -58],
	            [-25, -45],
	            [-31, -72],
	            [-6, -31],
	            [-6, -14]
	        ],
	        [
	            [3412, 5410],
	            [34, -11],
	            [2, 10],
	            [23, 4],
	            [30, -15]
	        ],
	        [
	            [3489, 5306],
	            [10, -35],
	            [-4, -25]
	        ],
	        [
	            [5626, 7957],
	            [-8, -15],
	            [-5, -24]
	        ],
	        [
	            [5380, 7746],
	            [7, 5]
	        ],
	        [
	            [5663, 8957],
	            [-47, -17],
	            [-27, -41],
	            [4, -36],
	            [-44, -48],
	            [-54, -50],
	            [-20, -84],
	            [20, -41],
	            [26, -33],
	            [-25, -67],
	            [-29, -14],
	            [-11, -99],
	            [-15, -55],
	            [-34, 6],
	            [-16, -47],
	            [-32, -3],
	            [-9, 56],
	            [-23, 67],
	            [-21, 84]
	        ],
	        [
	            [5890, 3478],
	            [-5, -26],
	            [-17, -6],
	            [-16, 32],
	            [0, 20],
	            [7, 22],
	            [3, 17],
	            [8, 5],
	            [14, -11]
	        ],
	        [
	            [5999, 7104],
	            [-2, 45],
	            [7, 25]
	        ],
	        [
	            [6004, 7174],
	            [7, 13],
	            [7, 13],
	            [2, 33],
	            [9, -12],
	            [31, 17],
	            [14, -12],
	            [23, 1],
	            [32, 22],
	            [15, -1],
	            [32, 9]
	        ],
	        [
	            [5051, 5420],
	            [-22, -12]
	        ],
	        [
	            [7849, 5777],
	            [-25, 28],
	            [-24, -2],
	            [4, 47],
	            [-24, 0],
	            [-2, -65],
	            [-15, -87],
	            [-10, -52],
	            [2, -43],
	            [18, -2],
	            [12, -53],
	            [5, -52],
	            [15, -33],
	            [17, -7],
	            [14, -31]
	        ],
	        [
	            [7779, 5439],
	            [-11, 23],
	            [-4, 29],
	            [-15, 34],
	            [-14, 28],
	            [-4, -35],
	            [-5, 33],
	            [3, 37],
	            [8, 56]
	        ],
	        [
	            [6883, 7252],
	            [16, 60],
	            [-6, 44],
	            [-20, 14],
	            [7, 26],
	            [23, -3],
	            [13, 33],
	            [9, 38],
	            [37, 13],
	            [-6, -27],
	            [4, -17],
	            [12, 2]
	        ],
	        [
	            [6497, 7255],
	            [-5, 42],
	            [4, 62],
	            [-22, 20],
	            [8, 40],
	            [-19, 4],
	            [6, 49],
	            [26, -14],
	            [25, 19],
	            [-20, 35],
	            [-8, 34],
	            [-23, -15],
	            [-3, -43],
	            [-8, 38]
	        ],
	        [
	            [6554, 7498],
	            [31, 1],
	            [-4, 29],
	            [24, 21],
	            [23, 34],
	            [37, -31],
	            [3, -47],
	            [11, -12],
	            [30, 2],
	            [9, -10],
	            [14, -61],
	            [32, -41],
	            [18, -28],
	            [29, -29],
	            [37, -25],
	            [-1, -36]
	        ],
	        [
	            [8471, 4532],
	            [3, 14],
	            [24, 13],
	            [19, 2],
	            [9, 8],
	            [10, -8],
	            [-10, -16],
	            [-29, -25],
	            [-23, -17]
	        ],
	        [
	            [3286, 5693],
	            [16, 8],
	            [6, -2],
	            [-1, -44],
	            [-23, -7],
	            [-5, 6],
	            [8, 16],
	            [-1, 23]
	        ],
	        [
	            [5233, 7240],
	            [31, 24],
	            [19, -7],
	            [-1, -30],
	            [24, 22],
	            [2, -12],
	            [-14, -29],
	            [0, -27],
	            [9, -15],
	            [-3, -51],
	            [-19, -29],
	            [6, -33],
	            [14, -1],
	            [7, -28],
	            [11, -9]
	        ],
	        [
	            [6004, 7174],
	            [-11, 27],
	            [11, 22],
	            [-17, -5],
	            [-23, 13],
	            [-19, -34],
	            [-43, -6],
	            [-22, 31],
	            [-30, 2],
	            [-6, -24],
	            [-20, -7],
	            [-26, 31],
	            [-31, -1],
	            [-16, 59],
	            [-21, 33],
	            [14, 46],
	            [-18, 28],
	            [31, 56],
	            [43, 3],
	            [12, 45],
	            [53, -8],
	            [33, 38],
	            [32, 17],
	            [46, 1],
	            [49, -42],
	            [40, -22],
	            [32, 9],
	            [24, -6],
	            [33, 31]
	        ],
	        [
	            [5777, 7539],
	            [3, -23],
	            [25, -19],
	            [-5, -14],
	            [-33, -3],
	            [-12, -19],
	            [-23, -31],
	            [-9, 27],
	            [0, 12]
	        ],
	        [
	            [8382, 6499],
	            [-17, -95],
	            [-12, -49],
	            [-14, 50],
	            [-4, 44],
	            [17, 58],
	            [22, 45],
	            [13, -18],
	            [-5, -35]
	        ],
	        [
	            [6088, 4781],
	            [-12, -73],
	            [1, -33],
	            [18, -22],
	            [1, -15],
	            [-8, -36],
	            [2, -18],
	            [-2, -28],
	            [10, -37],
	            [11, -58],
	            [10, -13]
	        ],
	        [
	            [5909, 4512],
	            [-15, 18],
	            [-18, 10],
	            [-11, 10],
	            [-12, 15]
	        ],
	        [
	            [5844, 4990],
	            [10, 8],
	            [31, -1],
	            [56, 4]
	        ],
	        [
	            [6061, 7840],
	            [-22, -5],
	            [-18, -19],
	            [-26, -3],
	            [-24, -22],
	            [1, -37],
	            [14, -14],
	            [28, 4],
	            [-5, -21],
	            [-31, -11],
	            [-37, -34],
	            [-16, 12],
	            [6, 28],
	            [-30, 17],
	            [5, 12],
	            [26, 19],
	            [-8, 14],
	            [-43, 15],
	            [-2, 22],
	            [-25, -8],
	            [-11, -32],
	            [-21, -44]
	        ],
	        [
	            [3517, 3063],
	            [-12, -38],
	            [-31, -32],
	            [-21, 11],
	            [-15, -6],
	            [-26, 25],
	            [-18, -1],
	            [-17, 32]
	        ],
	        [
	            [679, 6185],
	            [-4, -10],
	            [-7, 8],
	            [1, 17],
	            [-4, 21],
	            [1, 7],
	            [5, 10],
	            [-2, 11],
	            [1, 6],
	            [3, -1],
	            [10, -10],
	            [5, -5],
	            [5, -8],
	            [7, -21],
	            [-1, -3],
	            [-11, -13],
	            [-9, -9]
	        ],
	        [
	            [664, 6277],
	            [-9, -4],
	            [-5, 12],
	            [-3, 5],
	            [0, 4],
	            [3, 5],
	            [9, -6],
	            [8, -9],
	            [-3, -7]
	        ],
	        [
	            [646, 6309],
	            [-1, -7],
	            [-15, 2],
	            [2, 7],
	            [14, -2]
	        ],
	        [
	            [621, 6317],
	            [-2, -3],
	            [-2, 1],
	            [-9, 2],
	            [-4, 13],
	            [-1, 2],
	            [7, 8],
	            [3, -3],
	            [8, -20]
	        ],
	        [
	            [574, 6356],
	            [-4, -6],
	            [-9, 11],
	            [1, 4],
	            [5, 6],
	            [6, -1],
	            [1, -14]
	        ],
	        [
	            [3135, 7724],
	            [5, -19],
	            [-30, -29],
	            [-29, -20],
	            [-29, -18],
	            [-15, -35],
	            [-4, -13],
	            [-1, -31],
	            [10, -32],
	            [11, -1],
	            [-3, 21],
	            [8, -13],
	            [-2, -17],
	            [-19, -9],
	            [-13, 1],
	            [-20, -10],
	            [-12, -3],
	            [-17, -3],
	            [-23, -17],
	            [41, 11],
	            [8, -11],
	            [-39, -18],
	            [-17, 0],
	            [0, 7],
	            [-8, -16],
	            [8, -3],
	            [-6, -43],
	            [-20, -45],
	            [-2, 15],
	            [-6, 3],
	            [-9, 15],
	            [5, -32],
	            [7, -10],
	            [1, -23],
	            [-9, -23],
	            [-16, -47],
	            [-2, 3],
	            [8, 40],
	            [-14, 22],
	            [-3, 49],
	            [-5, -25],
	            [5, -38],
	            [-18, 10],
	            [19, -19],
	            [1, -57],
	            [8, -4],
	            [3, -20],
	            [4, -59],
	            [-17, -44],
	            [-29, -18],
	            [-18, -34],
	            [-14, -4],
	            [-14, -22],
	            [-4, -20],
	            [-31, -38],
	            [-16, -28],
	            [-13, -35],
	            [-4, -42],
	            [5, -41],
	            [9, -51],
	            [13, -41],
	            [0, -26],
	            [13, -69],
	            [-1, -39],
	            [-1, -23],
	            [-7, -36],
	            [-8, -8],
	            [-14, 7],
	            [-4, 26],
	            [-11, 14],
	            [-15, 51],
	            [-13, 45],
	            [-4, 23],
	            [6, 39],
	            [-8, 33],
	            [-22, 49],
	            [-10, 9],
	            [-28, -27],
	            [-5, 3],
	            [-14, 28],
	            [-17, 14],
	            [-32, -7],
	            [-24, 7],
	            [-21, -5],
	            [-12, -9],
	            [5, -15],
	            [0, -24],
	            [5, -12],
	            [-5, -8],
	            [-10, 9],
	            [-11, -11],
	            [-20, 2],
	            [-20, 31],
	            [-25, -8],
	            [-20, 14],
	            [-17, -4],
	            [-24, -14],
	            [-25, -44],
	            [-27, -25],
	            [-16, -28],
	            [-6, -27],
	            [0, -41],
	            [1, -28],
	            [5, -20]
	        ],
	        [
	            [1746, 6980],
	            [-4, 30],
	            [-18, 34],
	            [-13, 7],
	            [-3, 17],
	            [-16, 3],
	            [-10, 16],
	            [-26, 6],
	            [-7, 9],
	            [-3, 32],
	            [-27, 60],
	            [-23, 82],
	            [1, 14],
	            [-13, 19],
	            [-21, 50],
	            [-4, 48],
	            [-15, 32],
	            [6, 49],
	            [-1, 51],
	            [-8, 45],
	            [10, 56],
	            [4, 53],
	            [3, 54],
	            [-5, 79],
	            [-9, 51],
	            [-8, 27],
	            [4, 12],
	            [40, -20],
	            [15, -56],
	            [7, 15],
	            [-5, 49],
	            [-9, 48]
	        ],
	        [
	            [750, 8432],
	            [-28, -23],
	            [-14, 15],
	            [-4, 28],
	            [25, 21],
	            [15, 9],
	            [18, -4],
	            [12, -18],
	            [-24, -28]
	        ],
	        [
	            [401, 8597],
	            [-18, -9],
	            [-18, 11],
	            [-17, 16],
	            [28, 10],
	            [22, -6],
	            [3, -22]
	        ],
	        [
	            [230, 8826],
	            [17, -12],
	            [17, 6],
	            [23, -15],
	            [27, -8],
	            [-2, -7],
	            [-21, -12],
	            [-21, 13],
	            [-11, 11],
	            [-24, -4],
	            [-7, 5],
	            [2, 23]
	        ],
	        [
	            [1374, 8295],
	            [-15, 22],
	            [-25, 19],
	            [-8, 52],
	            [-36, 47],
	            [-15, 56],
	            [-26, 4],
	            [-44, 2],
	            [-33, 17],
	            [-57, 61],
	            [-27, 11],
	            [-49, 21],
	            [-38, -5],
	            [-55, 27],
	            [-33, 25],
	            [-30, -12],
	            [5, -41],
	            [-15, -4],
	            [-32, -12],
	            [-25, -20],
	            [-30, -13],
	            [-4, 35],
	            [12, 58],
	            [30, 18],
	            [-8, 15],
	            [-35, -33],
	            [-19, -39],
	            [-40, -42],
	            [20, -29],
	            [-26, -42],
	            [-30, -25],
	            [-28, -18],
	            [-7, -26],
	            [-43, -31],
	            [-9, -28],
	            [-32, -25],
	            [-20, 5],
	            [-25, -17],
	            [-29, -20],
	            [-23, -20],
	            [-47, -16],
	            [-5, 9],
	            [31, 28],
	            [27, 18],
	            [29, 33],
	            [35, 6],
	            [14, 25],
	            [38, 35],
	            [6, 12],
	            [21, 21],
	            [5, 44],
	            [14, 35],
	            [-32, -18],
	            [-9, 11],
	            [-15, -22],
	            [-18, 30],
	            [-8, -21],
	            [-10, 29],
	            [-28, -23],
	            [-17, 0],
	            [-3, 35],
	            [5, 21],
	            [-17, 22],
	            [-37, -12],
	            [-23, 28],
	            [-19, 14],
	            [0, 34],
	            [-22, 25],
	            [11, 34],
	            [23, 33],
	            [10, 30],
	            [22, 4],
	            [19, -9],
	            [23, 28],
	            [20, -5],
	            [21, 19],
	            [-5, 27],
	            [-16, 10],
	            [21, 23],
	            [-17, -1],
	            [-30, -13],
	            [-8, -13],
	            [-22, 13],
	            [-39, -6],
	            [-41, 14],
	            [-12, 24],
	            [-35, 34],
	            [39, 25],
	            [62, 29],
	            [23, 0],
	            [-4, -30],
	            [59, 2],
	            [-23, 37],
	            [-34, 23],
	            [-20, 29],
	            [-26, 25],
	            [-38, 19],
	            [15, 31],
	            [49, 2],
	            [35, 27],
	            [7, 29],
	            [28, 28],
	            [28, 6],
	            [52, 27],
	            [26, -4],
	            [42, 31],
	            [42, -12],
	            [21, -27],
	            [12, 11],
	            [47, -3],
	            [-2, -14],
	            [43, -10],
	            [28, 6],
	            [59, -18],
	            [53, -6],
	            [21, -8],
	            [37, 10],
	            [42, -18],
	            [31, -8]
	        ],
	        [
	            [3018, 5753],
	            [-1, -14],
	            [-16, -7],
	            [9, -26],
	            [0, -31],
	            [-12, -35],
	            [10, -47],
	            [12, 4],
	            [6, 43],
	            [-8, 21],
	            [-2, 45],
	            [35, 24],
	            [-4, 27],
	            [10, 19],
	            [10, -41],
	            [19, -1],
	            [18, -33],
	            [1, -20],
	            [25, 0],
	            [30, 6],
	            [16, -27],
	            [21, -7],
	            [16, 18],
	            [0, 15],
	            [34, 4],
	            [34, 1],
	            [-24, -18],
	            [10, -28],
	            [22, -4],
	            [21, -29],
	            [4, -48],
	            [15, 2],
	            [11, -14]
	        ],
	        [
	            [8001, 6331],
	            [-37, -51],
	            [-24, -56],
	            [-6, -41],
	            [22, -62],
	            [25, -77],
	            [26, -37],
	            [17, -47],
	            [12, -109],
	            [-3, -104],
	            [-24, -39],
	            [-31, -38],
	            [-23, -49],
	            [-35, -55],
	            [-10, 37],
	            [8, 40],
	            [-21, 34]
	        ],
	        [
	            [9661, 4085],
	            [-9, -8],
	            [-9, 26],
	            [1, 16],
	            [17, -34]
	        ],
	        [
	            [9641, 4175],
	            [4, -47],
	            [-7, 7],
	            [-6, -3],
	            [-4, 16],
	            [0, 45],
	            [13, -18]
	        ],
	        [
	            [6475, 6041],
	            [-21, -16],
	            [-5, -26],
	            [-1, -20],
	            [-27, -25],
	            [-45, -28],
	            [-24, -41],
	            [-13, -3],
	            [-8, 3],
	            [-16, -25],
	            [-18, -11],
	            [-23, -3],
	            [-7, -3],
	            [-6, -16],
	            [-8, -4],
	            [-4, -15],
	            [-14, 1],
	            [-9, -8],
	            [-19, 3],
	            [-7, 35],
	            [1, 32],
	            [-5, 17],
	            [-5, 44],
	            [-8, 24],
	            [5, 3],
	            [-2, 27],
	            [3, 12],
	            [-1, 25]
	        ],
	        [
	            [5817, 3752],
	            [11, 0],
	            [14, -10],
	            [9, 7],
	            [15, -6]
	        ],
	        [
	            [5911, 3478],
	            [-7, -43],
	            [-3, -49],
	            [-7, -27],
	            [-19, -30],
	            [-5, -8],
	            [-12, -30],
	            [-8, -31],
	            [-16, -42],
	            [-31, -61],
	            [-20, -36],
	            [-21, -26],
	            [-29, -23],
	            [-14, -3],
	            [-3, -17],
	            [-17, 9],
	            [-14, -11],
	            [-30, 11],
	            [-17, -7],
	            [-12, 3],
	            [-28, -23],
	            [-24, -10],
	            [-17, -22],
	            [-13, -1],
	            [-11, 21],
	            [-10, 1],
	            [-12, 26],
	            [-1, -8],
	            [-4, 16],
	            [0, 34],
	            [-9, 40],
	            [9, 11],
	            [0, 45],
	            [-19, 55],
	            [-14, 50],
	            [0, 1],
	            [-20, 76]
	        ],
	        [
	            [5840, 4141],
	            [-21, -8],
	            [-15, -23],
	            [-4, -21],
	            [-10, -4],
	            [-24, -49],
	            [-15, -38],
	            [-10, -2],
	            [-9, 7],
	            [-31, 7]
	        ]
	    ],
	    "transform": {
	        "scale": [0.036003600360036005, 0.016927109510951093],
	        "translate": [-180, -85.609038]
	    }
	}
	;
	  Datamap.prototype.abwTopo = '__ABW__';
	  Datamap.prototype.afgTopo = '__AFG__';
	  Datamap.prototype.agoTopo = '__AGO__';
	  Datamap.prototype.aiaTopo = '__AIA__';
	  Datamap.prototype.albTopo = '__ALB__';
	  Datamap.prototype.aldTopo = '__ALD__';
	  Datamap.prototype.andTopo = '__AND__';
	  Datamap.prototype.areTopo = '__ARE__';
	  Datamap.prototype.argTopo = '__ARG__';
	  Datamap.prototype.armTopo = '__ARM__';
	  Datamap.prototype.asmTopo = '__ASM__';
	  Datamap.prototype.ataTopo = '__ATA__';
	  Datamap.prototype.atcTopo = '__ATC__';
	  Datamap.prototype.atfTopo = '__ATF__';
	  Datamap.prototype.atgTopo = '__ATG__';
	  Datamap.prototype.ausTopo = '__AUS__';
	  Datamap.prototype.autTopo = '__AUT__';
	  Datamap.prototype.azeTopo = '__AZE__';
	  Datamap.prototype.bdiTopo = '__BDI__';
	  Datamap.prototype.belTopo = '__BEL__';
	  Datamap.prototype.benTopo = '__BEN__';
	  Datamap.prototype.bfaTopo = '__BFA__';
	  Datamap.prototype.bgdTopo = '__BGD__';
	  Datamap.prototype.bgrTopo = '__BGR__';
	  Datamap.prototype.bhrTopo = '__BHR__';
	  Datamap.prototype.bhsTopo = '__BHS__';
	  Datamap.prototype.bihTopo = '__BIH__';
	  Datamap.prototype.bjnTopo = '__BJN__';
	  Datamap.prototype.blmTopo = '__BLM__';
	  Datamap.prototype.blrTopo = '__BLR__';
	  Datamap.prototype.blzTopo = '__BLZ__';
	  Datamap.prototype.bmuTopo = '__BMU__';
	  Datamap.prototype.bolTopo = '__BOL__';
	  Datamap.prototype.braTopo = '__BRA__';
	  Datamap.prototype.brbTopo = '__BRB__';
	  Datamap.prototype.brnTopo = '__BRN__';
	  Datamap.prototype.btnTopo = '__BTN__';
	  Datamap.prototype.norTopo = '__NOR__';
	  Datamap.prototype.bwaTopo = '__BWA__';
	  Datamap.prototype.cafTopo = '__CAF__';
	  Datamap.prototype.canTopo = '__CAN__';
	  Datamap.prototype.cheTopo = '__CHE__';
	  Datamap.prototype.chlTopo = '__CHL__';
	  Datamap.prototype.chnTopo = '__CHN__';
	  Datamap.prototype.civTopo = '__CIV__';
	  Datamap.prototype.clpTopo = '__CLP__';
	  Datamap.prototype.cmrTopo = '__CMR__';
	  Datamap.prototype.codTopo = '__COD__';
	  Datamap.prototype.cogTopo = '__COG__';
	  Datamap.prototype.cokTopo = '__COK__';
	  Datamap.prototype.colTopo = '__COL__';
	  Datamap.prototype.comTopo = '__COM__';
	  Datamap.prototype.cpvTopo = '__CPV__';
	  Datamap.prototype.criTopo = '__CRI__';
	  Datamap.prototype.csiTopo = '__CSI__';
	  Datamap.prototype.cubTopo = '__CUB__';
	  Datamap.prototype.cuwTopo = '__CUW__';
	  Datamap.prototype.cymTopo = '__CYM__';
	  Datamap.prototype.cynTopo = '__CYN__';
	  Datamap.prototype.cypTopo = '__CYP__';
	  Datamap.prototype.czeTopo = '__CZE__';
	  Datamap.prototype.deuTopo = '__DEU__';
	  Datamap.prototype.djiTopo = '__DJI__';
	  Datamap.prototype.dmaTopo = '__DMA__';
	  Datamap.prototype.dnkTopo = '__DNK__';
	  Datamap.prototype.domTopo = '__DOM__';
	  Datamap.prototype.dzaTopo = '__DZA__';
	  Datamap.prototype.ecuTopo = '__ECU__';
	  Datamap.prototype.egyTopo = '__EGY__';
	  Datamap.prototype.eriTopo = '__ERI__';
	  Datamap.prototype.esbTopo = '__ESB__';
	  Datamap.prototype.espTopo = '__ESP__';
	  Datamap.prototype.estTopo = '__EST__';
	  Datamap.prototype.ethTopo = '__ETH__';
	  Datamap.prototype.finTopo = '__FIN__';
	  Datamap.prototype.fjiTopo = '__FJI__';
	  Datamap.prototype.flkTopo = '__FLK__';
	  Datamap.prototype.fraTopo = '__FRA__';
	  Datamap.prototype.froTopo = '__FRO__';
	  Datamap.prototype.fsmTopo = '__FSM__';
	  Datamap.prototype.gabTopo = '__GAB__';
	  Datamap.prototype.psxTopo = '__PSX__';
	  Datamap.prototype.gbrTopo = '__GBR__';
	  Datamap.prototype.geoTopo = '__GEO__';
	  Datamap.prototype.ggyTopo = '__GGY__';
	  Datamap.prototype.ghaTopo = '__GHA__';
	  Datamap.prototype.gibTopo = '__GIB__';
	  Datamap.prototype.ginTopo = '__GIN__';
	  Datamap.prototype.gmbTopo = '__GMB__';
	  Datamap.prototype.gnbTopo = '__GNB__';
	  Datamap.prototype.gnqTopo = '__GNQ__';
	  Datamap.prototype.grcTopo = '__GRC__';
	  Datamap.prototype.grdTopo = '__GRD__';
	  Datamap.prototype.grlTopo = '__GRL__';
	  Datamap.prototype.gtmTopo = '__GTM__';
	  Datamap.prototype.gumTopo = '__GUM__';
	  Datamap.prototype.guyTopo = '__GUY__';
	  Datamap.prototype.hkgTopo = '__HKG__';
	  Datamap.prototype.hmdTopo = '__HMD__';
	  Datamap.prototype.hndTopo = '__HND__';
	  Datamap.prototype.hrvTopo = '__HRV__';
	  Datamap.prototype.htiTopo = '__HTI__';
	  Datamap.prototype.hunTopo = '__HUN__';
	  Datamap.prototype.idnTopo = '__IDN__';
	  Datamap.prototype.imnTopo = '__IMN__';
	  Datamap.prototype.indTopo = '__IND__';
	  Datamap.prototype.ioaTopo = '__IOA__';
	  Datamap.prototype.iotTopo = '__IOT__';
	  Datamap.prototype.irlTopo = '__IRL__';
	  Datamap.prototype.irnTopo = '__IRN__';
	  Datamap.prototype.irqTopo = '__IRQ__';
	  Datamap.prototype.islTopo = '__ISL__';
	  Datamap.prototype.isrTopo = '__ISR__';
	  Datamap.prototype.itaTopo = '__ITA__';
	  Datamap.prototype.jamTopo = '__JAM__';
	  Datamap.prototype.jeyTopo = '__JEY__';
	  Datamap.prototype.jorTopo = '__JOR__';
	  Datamap.prototype.jpnTopo = '__JPN__';
	  Datamap.prototype.kabTopo = '__KAB__';
	  Datamap.prototype.kasTopo = '__KAS__';
	  Datamap.prototype.kazTopo = '__KAZ__';
	  Datamap.prototype.kenTopo = '__KEN__';
	  Datamap.prototype.kgzTopo = '__KGZ__';
	  Datamap.prototype.khmTopo = '__KHM__';
	  Datamap.prototype.kirTopo = '__KIR__';
	  Datamap.prototype.knaTopo = '__KNA__';
	  Datamap.prototype.korTopo = '__KOR__';
	  Datamap.prototype.kosTopo = '__KOS__';
	  Datamap.prototype.kwtTopo = '__KWT__';
	  Datamap.prototype.laoTopo = '__LAO__';
	  Datamap.prototype.lbnTopo = '__LBN__';
	  Datamap.prototype.lbrTopo = '__LBR__';
	  Datamap.prototype.lbyTopo = '__LBY__';
	  Datamap.prototype.lcaTopo = '__LCA__';
	  Datamap.prototype.lieTopo = '__LIE__';
	  Datamap.prototype.lkaTopo = '__LKA__';
	  Datamap.prototype.lsoTopo = '__LSO__';
	  Datamap.prototype.ltuTopo = '__LTU__';
	  Datamap.prototype.luxTopo = '__LUX__';
	  Datamap.prototype.lvaTopo = '__LVA__';
	  Datamap.prototype.macTopo = '__MAC__';
	  Datamap.prototype.mafTopo = '__MAF__';
	  Datamap.prototype.marTopo = '__MAR__';
	  Datamap.prototype.mcoTopo = '__MCO__';
	  Datamap.prototype.mdaTopo = '__MDA__';
	  Datamap.prototype.mdgTopo = '__MDG__';
	  Datamap.prototype.mdvTopo = '__MDV__';
	  Datamap.prototype.mexTopo = '__MEX__';
	  Datamap.prototype.mhlTopo = '__MHL__';
	  Datamap.prototype.mkdTopo = '__MKD__';
	  Datamap.prototype.mliTopo = '__MLI__';
	  Datamap.prototype.mltTopo = '__MLT__';
	  Datamap.prototype.mmrTopo = '__MMR__';
	  Datamap.prototype.mneTopo = '__MNE__';
	  Datamap.prototype.mngTopo = '__MNG__';
	  Datamap.prototype.mnpTopo = '__MNP__';
	  Datamap.prototype.mozTopo = '__MOZ__';
	  Datamap.prototype.mrtTopo = '__MRT__';
	  Datamap.prototype.msrTopo = '__MSR__';
	  Datamap.prototype.musTopo = '__MUS__';
	  Datamap.prototype.mwiTopo = '__MWI__';
	  Datamap.prototype.mysTopo = '__MYS__';
	  Datamap.prototype.namTopo = '__NAM__';
	  Datamap.prototype.nclTopo = '__NCL__';
	  Datamap.prototype.nerTopo = '__NER__';
	  Datamap.prototype.nfkTopo = '__NFK__';
	  Datamap.prototype.ngaTopo = '__NGA__';
	  Datamap.prototype.nicTopo = '__NIC__';
	  Datamap.prototype.niuTopo = '__NIU__';
	  Datamap.prototype.nldTopo = '__NLD__';
	  Datamap.prototype.nplTopo = '__NPL__';
	  Datamap.prototype.nruTopo = '__NRU__';
	  Datamap.prototype.nulTopo = '__NUL__';
	  Datamap.prototype.nzlTopo = '__NZL__';
	  Datamap.prototype.omnTopo = '__OMN__';
	  Datamap.prototype.pakTopo = '__PAK__';
	  Datamap.prototype.panTopo = '__PAN__';
	  Datamap.prototype.pcnTopo = '__PCN__';
	  Datamap.prototype.perTopo = '__PER__';
	  Datamap.prototype.pgaTopo = '__PGA__';
	  Datamap.prototype.phlTopo = '__PHL__';
	  Datamap.prototype.plwTopo = '__PLW__';
	  Datamap.prototype.pngTopo = '__PNG__';
	  Datamap.prototype.polTopo = '__POL__';
	  Datamap.prototype.priTopo = '__PRI__';
	  Datamap.prototype.prkTopo = '__PRK__';
	  Datamap.prototype.prtTopo = '__PRT__';
	  Datamap.prototype.pryTopo = '__PRY__';
	  Datamap.prototype.pyfTopo = '__PYF__';
	  Datamap.prototype.qatTopo = '__QAT__';
	  Datamap.prototype.rouTopo = '__ROU__';
	  Datamap.prototype.rusTopo = '__RUS__';
	  Datamap.prototype.rwaTopo = '__RWA__';
	  Datamap.prototype.sahTopo = '__SAH__';
	  Datamap.prototype.sauTopo = '__SAU__';
	  Datamap.prototype.scrTopo = '__SCR__';
	  Datamap.prototype.sdnTopo = '__SDN__';
	  Datamap.prototype.sdsTopo = '__SDS__';
	  Datamap.prototype.senTopo = '__SEN__';
	  Datamap.prototype.serTopo = '__SER__';
	  Datamap.prototype.sgpTopo = '__SGP__';
	  Datamap.prototype.sgsTopo = '__SGS__';
	  Datamap.prototype.shnTopo = '__SHN__';
	  Datamap.prototype.slbTopo = '__SLB__';
	  Datamap.prototype.sleTopo = '__SLE__';
	  Datamap.prototype.slvTopo = '__SLV__';
	  Datamap.prototype.smrTopo = '__SMR__';
	  Datamap.prototype.solTopo = '__SOL__';
	  Datamap.prototype.somTopo = '__SOM__';
	  Datamap.prototype.spmTopo = '__SPM__';
	  Datamap.prototype.srbTopo = '__SRB__';
	  Datamap.prototype.stpTopo = '__STP__';
	  Datamap.prototype.surTopo = '__SUR__';
	  Datamap.prototype.svkTopo = '__SVK__';
	  Datamap.prototype.svnTopo = '__SVN__';
	  Datamap.prototype.sweTopo = '__SWE__';
	  Datamap.prototype.swzTopo = '__SWZ__';
	  Datamap.prototype.sxmTopo = '__SXM__';
	  Datamap.prototype.sycTopo = '__SYC__';
	  Datamap.prototype.syrTopo = '__SYR__';
	  Datamap.prototype.tcaTopo = '__TCA__';
	  Datamap.prototype.tcdTopo = '__TCD__';
	  Datamap.prototype.tgoTopo = '__TGO__';
	  Datamap.prototype.thaTopo = '__THA__';
	  Datamap.prototype.tjkTopo = '__TJK__';
	  Datamap.prototype.tkmTopo = '__TKM__';
	  Datamap.prototype.tlsTopo = '__TLS__';
	  Datamap.prototype.tonTopo = '__TON__';
	  Datamap.prototype.ttoTopo = '__TTO__';
	  Datamap.prototype.tunTopo = '__TUN__';
	  Datamap.prototype.turTopo = '__TUR__';
	  Datamap.prototype.tuvTopo = '__TUV__';
	  Datamap.prototype.twnTopo = '__TWN__';
	  Datamap.prototype.tzaTopo = '__TZA__';
	  Datamap.prototype.ugaTopo = '__UGA__';
	  Datamap.prototype.ukrTopo = '__UKR__';
	  Datamap.prototype.umiTopo = '__UMI__';
	  Datamap.prototype.uryTopo = '__URY__';
	  Datamap.prototype.usaTopo = {"type":"Topology","transform":{"scale":[0.03514630243024302,0.005240860686068607],"translate":[-178.123152,18.948267]},"objects":{"usa":{"type":"GeometryCollection","geometries":[{"type":"Polygon","id":"AL","arcs":[[0,1,2,3,4]],"properties":{"name":"Alabama"}},{"type":"MultiPolygon","id":"AK","arcs":[[[5]],[[6]],[[7]],[[8]],[[9]],[[10]],[[11]],[[12]],[[13]],[[14]],[[15]],[[16]],[[17]],[[18]],[[19]],[[20]],[[21]],[[22]],[[23]],[[24]],[[25]],[[26]],[[27]],[[28]],[[29]],[[30]],[[31]],[[32]],[[33]],[[34]],[[35]],[[36]],[[37]],[[38]],[[39]],[[40]],[[41]],[[42]],[[43]]],"properties":{"name":"Alaska"}},{"type":"Polygon","id":"AZ","arcs":[[44,45,46,47,48]],"properties":{"name":"Arizona"}},{"type":"Polygon","id":"AR","arcs":[[49,50,51,52,53,54]],"properties":{"name":"Arkansas"}},{"type":"Polygon","id":"CA","arcs":[[55,-47,56,57]],"properties":{"name":"California"}},{"type":"Polygon","id":"CO","arcs":[[58,59,60,61,62,63]],"properties":{"name":"Colorado"}},{"type":"Polygon","id":"CT","arcs":[[64,65,66,67]],"properties":{"name":"Connecticut"}},{"type":"Polygon","id":"DE","arcs":[[68,69,70,71]],"properties":{"name":"Delaware"}},{"type":"Polygon","id":"DC","arcs":[[72,73]],"properties":{"name":"District of Columbia"}},{"type":"Polygon","id":"FL","arcs":[[74,75,-2]],"properties":{"name":"Florida"}},{"type":"Polygon","id":"GA","arcs":[[76,77,-75,-1,78,79]],"properties":{"name":"Georgia"}},{"type":"MultiPolygon","id":"HI","arcs":[[[80]],[[81]],[[82]],[[83]],[[84]]],"properties":{"name":"Hawaii"}},{"type":"Polygon","id":"ID","arcs":[[85,86,87,88,89,90,91]],"properties":{"name":"Idaho"}},{"type":"Polygon","id":"IL","arcs":[[92,93,94,95,96,97]],"properties":{"name":"Illinois"}},{"type":"Polygon","id":"IN","arcs":[[98,99,-95,100,101]],"properties":{"name":"Indiana"}},{"type":"Polygon","id":"IA","arcs":[[102,-98,103,104,105,106]],"properties":{"name":"Iowa"}},{"type":"Polygon","id":"KS","arcs":[[107,108,-60,109]],"properties":{"name":"Kansas"}},{"type":"Polygon","id":"KY","arcs":[[110,111,112,113,-96,-100,114]],"properties":{"name":"Kentucky"}},{"type":"Polygon","id":"LA","arcs":[[115,116,117,-52]],"properties":{"name":"Louisiana"}},{"type":"Polygon","id":"ME","arcs":[[118,119]],"properties":{"name":"Maine"}},{"type":"MultiPolygon","id":"MD","arcs":[[[120]],[[-71,121,122,123,124,-74,125,126,127]]],"properties":{"name":"Maryland"}},{"type":"Polygon","id":"MA","arcs":[[128,129,130,131,-68,132,133,134]],"properties":{"name":"Massachusetts"}},{"type":"MultiPolygon","id":"MI","arcs":[[[-102,135,136]],[[137]],[[138,139]],[[140]]],"properties":{"name":"Michigan"}},{"type":"Polygon","id":"MN","arcs":[[-107,141,142,143,144]],"properties":{"name":"Minnesota"}},{"type":"Polygon","id":"MS","arcs":[[-4,145,-116,-51,146]],"properties":{"name":"Mississippi"}},{"type":"Polygon","id":"MO","arcs":[[-97,-114,147,-55,148,-108,149,-104]],"properties":{"name":"Missouri"}},{"type":"Polygon","id":"MT","arcs":[[150,151,-92,152,153]],"properties":{"name":"Montana"}},{"type":"Polygon","id":"NE","arcs":[[-105,-150,-110,-59,154,155]],"properties":{"name":"Nebraska"}},{"type":"Polygon","id":"NV","arcs":[[156,-48,-56,157,-88]],"properties":{"name":"Nevada"}},{"type":"Polygon","id":"NH","arcs":[[-135,158,159,-120,160]],"properties":{"name":"New Hampshire"}},{"type":"Polygon","id":"NJ","arcs":[[161,-69,162,163]],"properties":{"name":"New Jersey"}},{"type":"Polygon","id":"NM","arcs":[[164,165,166,-45,-62]],"properties":{"name":"New Mexico"}},{"type":"Polygon","id":"NY","arcs":[[-133,-67,167,-164,168,169,170]],"properties":{"name":"New York"}},{"type":"Polygon","id":"NC","arcs":[[171,172,-80,173,174]],"properties":{"name":"North Carolina"}},{"type":"Polygon","id":"ND","arcs":[[175,-154,176,-143]],"properties":{"name":"North Dakota"}},{"type":"Polygon","id":"OH","arcs":[[177,-115,-99,-137,178,179]],"properties":{"name":"Ohio"}},{"type":"Polygon","id":"OK","arcs":[[-149,-54,180,-165,-61,-109]],"properties":{"name":"Oklahoma"}},{"type":"Polygon","id":"OR","arcs":[[-89,-158,-58,181,182]],"properties":{"name":"Oregon"}},{"type":"Polygon","id":"PA","arcs":[[-163,-72,-128,183,-180,184,-169]],"properties":{"name":"Pennsylvania"}},{"type":"MultiPolygon","id":"RI","arcs":[[[185,-130]],[[186,-65,-132]]],"properties":{"name":"Rhode Island"}},{"type":"Polygon","id":"SC","arcs":[[187,-77,-173]],"properties":{"name":"South Carolina"}},{"type":"Polygon","id":"SD","arcs":[[-142,-106,-156,188,-151,-176]],"properties":{"name":"South Dakota"}},{"type":"Polygon","id":"TN","arcs":[[189,-174,-79,-5,-147,-50,-148,-113]],"properties":{"name":"Tennessee"}},{"type":"Polygon","id":"TX","arcs":[[-53,-118,190,-166,-181]],"properties":{"name":"Texas"}},{"type":"Polygon","id":"UT","arcs":[[191,-63,-49,-157,-87]],"properties":{"name":"Utah"}},{"type":"Polygon","id":"VT","arcs":[[-134,-171,192,-159]],"properties":{"name":"Vermont"}},{"type":"MultiPolygon","id":"VA","arcs":[[[193,-123]],[[120]],[[-126,-73,-125,194,-175,-190,-112,195]]],"properties":{"name":"Virginia"}},{"type":"MultiPolygon","id":"WA","arcs":[[[-183,196,-90]],[[197]],[[198]]],"properties":{"name":"Washington"}},{"type":"Polygon","id":"WV","arcs":[[-184,-127,-196,-111,-178]],"properties":{"name":"West Virginia"}},{"type":"Polygon","id":"WI","arcs":[[199,-93,-103,-145,200,-140]],"properties":{"name":"Wisconsin"}},{"type":"Polygon","id":"WY","arcs":[[-189,-155,-64,-192,-86,-152]],"properties":{"name":"Wyoming"}}]}},"arcs":[[[2632,3060],[5,-164],[7,-242],[4,-53],[3,-30],[-2,-19],[4,-11],[-5,-25],[0,-24],[-2,-32],[2,-57],[-2,-51],[3,-52]],[[2649,2300],[-14,-1],[-59,0],[-1,-25],[6,-37],[-1,-31],[2,-16],[-4,-28]],[[2578,2162],[-4,-6],[-7,31],[-1,47],[-2,6],[-3,-36],[-1,-34],[-7,9]],[[2553,2179],[-2,291],[6,363],[4,209],[-3,20]],[[2558,3062],[24,1],[50,-3]],[[1324,6901],[1,32],[6,-19],[-1,-32],[-8,4],[2,15]],[[1317,6960],[5,-23],[-3,-33],[-2,11],[0,45]],[[1285,7153],[6,5],[3,-8],[-1,-28],[-6,-6],[-5,17],[3,20]],[[1267,7137],[12,-7],[3,-36],[13,-41],[4,-25],[0,-21],[3,-4],[1,-27],[5,-27],[0,-25],[3,8],[2,-19],[1,-74],[-3,-17],[-7,3],[-3,38],[-2,-3],[-6,28],[-2,-10],[-5,10],[1,-28],[5,7],[3,-10],[-2,-39],[-5,4],[-9,49],[-2,25],[1,26],[-7,-2],[0,20],[5,2],[5,18],[-2,31],[-6,7],[-1,50],[-2,25],[-4,-18],[-2,28],[4,14],[-3,32],[2,8]],[[1263,6985],[5,-12],[4,15],[4,-7],[-4,-28],[-6,8],[-3,24]],[[1258,7247],[-4,19],[5,13],[15,-18],[7,1],[5,-36],[9,-29],[-1,-22],[-5,-11],[-6,5],[-5,-14],[-6,9],[-7,-9],[-1,45],[0,30],[-5,1],[-1,16]],[[1252,7162],[-4,14],[-4,32],[0,24],[3,11],[4,-11],[0,20],[12,-35],[1,-33],[-4,-5],[-3,-37],[3,-11],[-3,-43],[-5,9],[0,-27],[-3,13],[-2,54],[5,25]],[[1207,7331],[8,38],[3,-16],[7,-13],[6,-2],[0,-30],[6,-99],[0,-85],[-1,-22],[-4,13],[-10,84],[-7,25],[3,20],[-3,48],[-8,39]],[[1235,7494],[10,-15],[5,2],[0,-14],[8,-52],[-5,8],[-2,-18],[6,-27],[2,-48],[-6,-13],[-2,-16],[-10,-35],[-3,1],[-1,37],[2,22],[-1,32],[-3,40],[0,21],[-2,51],[-4,22],[-1,38],[7,-36]],[[1203,7324],[4,0],[4,-35],[-2,-24],[-6,-5],[0,38],[0,26]],[[1207,7331],[-5,7],[-3,26],[-6,18],[-5,37],[-6,17],[1,30],[4,10],[1,26],[3,-11],[8,-1],[6,17],[8,-23],[-5,-26],[2,-9],[4,28],[10,-9],[5,-21],[-3,-38],[3,-3],[3,-50],[-7,-7],[-14,41],[0,-42],[-4,-17]],[[883,7871],[-12,-48],[-1,-19],[-9,-12],[2,29],[10,30],[7,34],[3,-14]],[[870,7943],[-2,-39],[-4,-41],[-6,14],[5,47],[7,19]],[[863,9788],[3,-8],[15,-9],[8,5],[10,0],[12,-7],[7,4],[7,-15],[12,-18],[16,-4],[5,10],[11,6],[4,14],[12,2],[0,-9],[7,5],[15,-15],[9,-24],[10,-11],[2,-11],[8,-2],[8,-18],[1,-11],[5,9],[6,-7],[0,-1783],[13,-16],[2,17],[14,-24],[8,30],[18,4],[-3,-52],[4,-17],[10,-17],[2,-27],[29,-101],[4,-63],[6,17],[12,31],[7,1],[3,23],[0,34],[5,0],[1,31],[9,7],[13,26],[13,-45],[-1,-27],[3,-27],[7,-7],[10,-40],[-1,-12],[4,-22],[12,-25],[19,-110],[3,-29],[6,-29],[8,-65],[9,-55],[-3,-23],[9,-9],[-2,-33],[7,-14],[1,-38],[7,2],[14,-40],[9,-7],[5,-19],[4,-5],[1,-19],[9,-5],[3,-23],[-4,-43],[1,-36],[4,-58],[-4,-15],[-6,-53],[-10,-39],[-3,20],[-4,-6],[-3,39],[1,17],[-3,20],[7,21],[-2,7],[-7,-26],[-3,17],[-4,-10],[-12,42],[4,46],[-8,-15],[0,-23],[-6,17],[-1,22],[4,24],[-1,24],[-6,-19],[-6,42],[-3,-8],[-2,36],[5,23],[6,0],[-2,28],[3,36],[-5,-1],[-9,32],[-6,37],[-15,27],[0,77],[-4,9],[1,31],[-5,9],[-8,42],[-2,22],[-12,7],[-14,56],[-6,132],[-3,-30],[1,-27],[6,-53],[-1,-8],[3,-43],[0,-28],[-6,6],[-4,31],[-6,6],[-8,-9],[0,45],[-5,38],[-5,-12],[-17,40],[-2,-11],[10,-13],[7,-31],[3,-1],[1,-25],[4,-30],[-10,-16],[-5,10],[0,-26],[-8,20],[-2,14],[-5,0],[-13,38],[-10,33],[-1,20],[-5,30],[-14,21],[-9,21],[-14,26],[-9,24],[1,26],[2,-9],[3,17],[-3,38],[4,21],[-2,9],[-7,-40],[-14,-26],[-18,10],[-14,24],[-1,18],[-7,-4],[-7,14],[-17,12],[-9,1],[-21,-10],[-8,-7],[-10,27],[-12,12],[-3,17],[-2,28],[-8,-2],[-3,-25],[-15,34],[-2,14],[-15,-27],[-7,-32],[-3,30],[3,17],[4,-5],[14,22],[-2,17],[-6,-8],[-3,22],[-6,3],[-6,55],[-3,-13],[-8,-8],[-3,8],[-3,-18],[-11,6],[-1,-20],[-7,-5],[-3,7],[2,36],[-3,-1],[-5,-38],[7,-12],[1,-27],[4,-30],[-3,-31],[-5,10],[-2,-15],[6,-7],[3,-41],[-8,-9],[-4,9],[-7,-12],[-3,10],[-9,-2],[0,16],[-4,-10],[-3,-20],[-3,18],[-5,-25],[2,-12],[-6,-15],[-6,-2],[-3,-20],[-6,-17],[-4,6],[-5,-21],[-4,1],[-8,-43],[-9,-3],[-3,14],[-5,-23],[-11,17],[2,33],[8,11],[4,-2],[2,13],[8,25],[0,21],[-11,-28],[-9,16],[-1,12],[5,48],[8,34],[1,29],[2,5],[1,30],[-4,34],[10,12],[19,48],[4,-19],[6,-5],[9,20],[-10,26],[-4,20],[-7,-2],[-5,9],[-2,-8],[-9,-14],[-4,-26],[-9,-6],[-9,-30],[-1,-20],[-7,-11],[-2,-22],[-5,-13],[-2,-39],[-10,-25],[5,-20],[-4,-29],[-9,-5],[-1,-38],[-8,-13],[-3,15],[-4,-29],[-5,-1],[1,-21],[-11,-13],[-2,-57],[12,-3],[10,-16],[3,-19],[-4,-30],[-7,-19],[-6,-1],[0,-17],[-4,-6],[1,-21],[-4,-31],[-9,-29],[-5,0],[-5,-11],[-5,2],[-4,-11],[2,-16],[-7,-8],[-2,-23],[-5,14],[-5,-45],[-9,4],[1,-24],[-6,6],[-3,-11],[0,-32],[-6,-50],[-10,-6],[-7,-23],[-2,-13],[-5,18],[-8,-48],[-2,13],[-5,-4],[-1,-27],[-5,-10],[-6,4],[-4,-27],[8,-9],[-9,-60],[-25,-20],[-6,-54],[-2,12],[1,33],[-5,6],[-6,-13],[-1,-14],[-10,-22],[-4,-25],[-1,18],[-2,-21],[-6,14],[-10,-33],[-8,2],[1,25],[-4,24],[-3,-20],[1,-21],[-11,-64],[-3,16],[-1,-24],[-8,4],[-1,38],[-4,8],[-2,-14],[4,-16],[-2,-27],[-5,-13],[-5,29],[-5,2],[-1,-11],[5,-17],[-9,-27],[6,-7],[0,-13],[-5,9],[-7,-25],[-15,1],[-7,-16],[0,-13],[-8,-15],[-6,6],[-2,35],[6,12],[4,43],[6,1],[13,28],[10,1],[4,-27],[3,20],[-1,23],[6,10],[7,0],[8,50],[10,45],[12,40],[15,18],[6,-9],[6,12],[1,-17],[-3,-19],[4,-14],[1,23],[7,2],[2,-15],[5,-5],[0,18],[-8,15],[0,11],[5,49],[6,28],[9,27],[15,24],[10,35],[5,-13],[4,5],[-1,22],[1,21],[8,44],[11,28],[8,38],[0,21],[7,148],[11,40],[-1,31],[-27,-45],[-8,6],[-2,18],[-5,9],[-1,21],[-4,-10],[-3,-32],[5,-41],[-6,-18],[-5,7],[-9,64],[-6,33],[-4,0],[-2,-24],[-3,-4],[-4,19],[-5,4],[-2,32],[-16,-37],[-13,-26],[-1,-14],[-11,-22],[-6,20],[5,23],[-1,54],[-4,57],[7,24],[-6,49],[-5,27],[-4,39],[-6,17],[-2,-34],[-7,-8],[-12,-22],[-14,-9],[-7,2],[-7,12],[-1,30],[-5,9],[-9,42],[-8,8],[-8,46],[6,21],[1,39],[-5,-8],[0,24],[2,19],[-6,18],[0,-19],[-7,8],[-1,32],[-6,4],[-3,22],[0,27],[-5,-12],[-1,26],[7,6],[-6,30],[10,2],[0,35],[2,24],[18,77],[4,23],[3,-5],[-2,33],[7,55],[6,22],[11,9],[8,-9],[12,-33],[8,4],[11,32],[11,49],[6,6],[1,-13],[13,0],[12,10],[11,52],[0,12],[-5,48],[-1,28],[-8,31],[-3,26],[8,-7],[8,22],[0,20],[-10,39],[-8,-30],[-7,5],[-6,-17],[-8,-4],[-2,-11],[-9,-17],[-2,-28],[-5,-12],[-2,34],[-5,7],[-4,-26],[-2,12],[-10,19],[-20,-1],[-14,-21],[-6,-3],[-11,13],[-22,14],[-6,12],[-3,19],[2,26],[-8,22],[2,24],[5,12],[-2,31],[-8,0],[-6,8],[-13,6],[-7,16],[-10,16],[-1,19],[16,27],[20,43],[15,27],[8,-15],[8,-3],[2,21],[-5,3],[-1,18],[20,29],[22,22],[12,2],[7,-7],[-4,-32],[2,-22],[-3,-15],[4,-26],[8,5],[10,-5],[11,6],[4,-10],[7,-2],[7,10],[8,-11],[9,42],[5,2],[5,-8],[2,24],[-12,11],[-11,-9],[1,31],[-8,34],[-10,10],[-2,30],[7,8],[9,-31],[-1,-24],[4,-18],[10,-22],[2,23],[-11,30],[5,54],[-4,10],[-11,-12],[-11,3],[-2,10],[-6,-10],[-24,23],[0,24],[-7,54],[-6,19],[-9,17],[-19,46],[-9,18],[-8,4],[-13,31],[-12,18],[-1,6],[9,10],[4,29],[1,59],[25,-4],[31,13],[8,11],[12,29],[12,45],[3,45],[5,38],[10,33],[5,24],[13,38],[2,-10],[11,-3],[16,20],[10,21],[24,64],[9,4],[1,-10],[9,7],[9,-2],[18,9],[17,28],[17,58],[7,13],[2,-10],[26,-24],[2,-17],[-9,-22],[-4,-1],[0,-29],[14,9],[0,16],[6,14],[2,-8],[5,33],[13,-30],[-2,-23],[8,-6],[5,-14],[7,22],[13,1],[7,7],[18,-7],[10,-8],[-5,-45],[17,-12],[2,-11],[16,-20],[1,9],[12,13],[11,-1],[0,-11],[7,-1],[7,15],[11,2],[9,-6],[11,-16],[5,3],[7,-22],[4,9],[7,-7],[5,-13]],[[717,7456],[-1,-8],[-9,13],[7,49],[6,4],[4,45],[5,-40],[4,14],[8,-22],[0,-31],[-11,-4],[-5,-13],[-8,-7]],[[688,7363],[8,25],[-8,6],[0,22],[6,14],[5,-10],[0,-22],[3,15],[0,32],[5,-15],[1,21],[5,-12],[5,0],[5,11],[7,-20],[0,-55],[9,4],[-6,-37],[-11,15],[4,-24],[-3,-20],[-6,10],[0,-38],[-8,-10],[-3,-16],[-5,15],[-6,-40],[-4,-4],[-5,-18],[-2,43],[-6,-23],[-1,13],[-6,14],[0,39],[-6,15],[4,45],[11,28],[7,-2],[1,-21]],[[671,7185],[-6,-39],[-2,6],[8,33]],[[640,7055],[4,-2],[-1,-40],[-8,6],[-1,13],[6,23]],[[519,6933],[-2,-41],[-9,-33],[5,51],[2,-5],[4,28]],[[501,6947],[5,0],[0,-20],[-5,-23],[-5,15],[-3,-14],[-2,35],[2,12],[8,-5]],[[451,6875],[1,-16],[-3,-11],[-3,18],[5,9]],[[447,8527],[-4,-19],[-2,16],[6,3]],[[436,6781],[6,-7],[-1,-16],[-5,1],[0,22]],[[358,6745],[2,-22],[-5,-10],[-1,23],[4,9]],[[352,6718],[-8,-21],[-2,14],[3,19],[7,-12]],[[335,7902],[6,7],[2,-14],[5,3],[6,-12],[1,-54],[-3,-18],[-7,-11],[-2,-18],[-11,20],[-5,-1],[-10,28],[-4,0],[-6,15],[-3,25],[4,7],[10,-7],[5,20],[5,2],[3,14],[4,-6]],[[334,6690],[5,-14],[-10,-36],[1,-6],[12,26],[0,-15],[-5,-17],[-8,-12],[-1,-18],[-8,-18],[-7,-1],[-5,-18],[-9,-16],[-5,17],[9,20],[3,-3],[8,16],[-2,19],[4,20],[6,-9],[1,12],[-7,4],[-4,14],[4,23],[11,13],[2,-26],[5,25]],[[266,6527],[10,37],[1,16],[4,17],[7,9],[3,-10],[1,-25],[-12,-27],[-6,-40],[-6,-13],[-2,36]],[[238,6477],[2,-19],[-8,-1],[-1,13],[7,7]],[[227,7303],[-4,-18],[-1,18],[5,0]],[[212,6440],[2,-18],[-5,-13],[-1,19],[4,12]],[[182,8542],[22,-28],[13,24],[6,-2],[5,-14],[2,-23],[11,-12],[4,-12],[15,-5],[8,-8],[-4,-28],[-7,6],[-8,-5],[-4,-13],[-4,-28],[-5,26],[-6,18],[-6,2],[-3,20],[-15,25],[-6,1],[-11,-22],[-7,11],[-4,23],[4,44]],[[162,6381],[0,-22],[-5,-4],[1,19],[4,7]],[[128,6335],[4,-8],[10,1],[1,-7],[-13,-9],[-2,23]],[[108,6360],[0,19],[4,7],[6,-19],[-2,-17],[-4,1],[1,-20],[-5,-2],[-12,-21],[-6,6],[2,15],[7,-2],[9,33]],[[47,6279],[5,3],[0,-24],[-6,3],[-8,-28],[-4,37],[4,1],[0,29],[5,1],[0,-21],[4,-1]],[[28,6296],[3,-9],[-2,-32],[-5,-10],[0,20],[4,31]],[[0,6291],[5,-1],[4,-23],[-4,-27],[-5,51]],[[9993,6496],[6,-13],[0,-19],[-11,-12],[-8,31],[0,15],[13,-2]],[[1966,3444],[-1,-1081]],[[1965,2363],[-57,0],[-34,71],[-73,150],[3,43]],[[1804,2627],[6,8],[1,16],[-1,36],[-4,1],[-2,71],[6,27],[0,28],[-1,45],[4,34],[4,12],[4,25],[-6,27],[-4,51],[-5,31],[0,24]],[[1806,3063],[2,26],[0,36],[-3,36],[-2,112],[11,7],[3,-23],[3,1],[3,33],[0,153]],[[1823,3444],[101,2],[42,-2]],[[2515,3253],[-1,-35],[-4,-11],[-1,-29],[-5,-31],[0,-46],[-3,-34],[-3,-5]],[[2498,3062],[2,-17],[-4,-14],[-2,-33],[-3,-8],[0,-38],[-5,-10],[0,-13],[-6,-31],[2,-21],[-5,-30],[-5,-59],[5,-25],[-2,-16],[1,-39],[-2,-26]],[[2474,2682],[-69,3],[-13,0]],[[2392,2685],[0,101],[-4,8],[-5,-9],[-3,18]],[[2380,2803],[1,335],[-5,211]],[[2376,3349],[4,0],[123,-1],[2,-36],[-4,-23],[-4,-36],[18,0]],[[1654,4398],[0,-331],[0,-241],[36,-171],[35,-169],[27,-137],[20,-101],[34,-185]],[[1804,2627],[-38,-18],[-30,-16],[-4,25],[0,40],[-2,47],[-4,33],[-9,46],[-12,43],[-2,-12],[-4,8],[1,18],[-5,39],[-7,-8],[-12,28],[-2,23],[-8,28],[-9,-1],[-7,13],[-10,-6],[-5,26],[1,53],[-1,8],[1,38],[-8,28],[0,39],[-3,2],[-4,33],[-4,8],[-1,20],[-11,79],[-5,23],[-1,61],[2,-5],[2,37],[-4,33],[-5,-4],[-7,30],[-2,24],[0,23],[-3,31],[0,50],[5,0],[-2,70],[-2,-7],[-1,-35],[-5,-7],[-7,26],[-1,45],[-4,35],[-6,22],[-3,25],[-9,50],[2,14],[-4,64],[2,35],[-3,54],[-7,52],[-7,29],[-2,35],[7,83],[2,29],[-2,22],[3,57],[-2,52],[-3,13],[1,42]],[[1534,4399],[28,1],[24,1],[38,-3],[30,0]],[[2107,4208],[57,0],[0,-191]],[[2164,4017],[1,-574]],[[2165,3443],[-28,1]],[[2137,3444],[-38,-1],[-72,0],[-15,1],[-46,0]],[[1966,3444],[0,223],[-1,21],[0,162],[0,357]],[[1965,4207],[32,1],[63,-1],[47,1]],[[3025,4400],[0,-113],[-2,-18]],[[3023,4269],[-2,3],[-12,-14],[-15,4],[-7,-26],[-7,-9],[-8,-22]],[[2972,4205],[-2,22],[7,21],[-2,16],[2,144]],[[2977,4408],[12,-2],[36,-3],[0,-3]],[[2922,3980],[-2,-23]],[[2920,3957],[-3,-13],[0,-30],[5,-29],[1,-47],[6,-49],[3,-2],[1,-66]],[[2933,3721],[-19,2],[-2,241]],[[2912,3964],[5,21],[5,-5]],[[2876,3786],[-2,27]],[[2874,3813],[2,12],[4,-19],[-4,-20]],[[2649,2300],[4,-55],[39,-13],[37,-14],[1,-41],[4,1],[1,39],[-1,35],[2,15],[7,-16],[8,-7]],[[2751,2244],[1,-83],[4,-93],[8,-122],[13,-131],[-2,-9],[1,-61],[5,-68],[8,-137],[2,-42],[0,-44],[-3,-158],[-3,-3],[-3,-49],[1,-16],[-5,-36],[-2,9],[-6,-15],[-9,-8],[-2,20],[1,29],[-7,85],[-5,15],[-4,-11],[-3,47],[-1,38],[-6,43],[-2,28],[1,41],[-3,8],[1,-24],[-3,-7],[-9,104],[-4,26],[9,76],[-6,-4],[-4,-24],[-3,38],[5,104],[1,87],[-4,21],[-1,28],[-5,6],[-7,46],[-5,19],[0,28],[-4,11],[-3,31],[-11,42],[-9,-10],[0,-29],[-3,5],[-12,-35],[-12,-9],[0,21],[-3,25],[-15,57],[-10,24],[-10,6],[-8,-4],[-17,-18]],[[2703,3063],[-6,-41],[0,-20],[9,-40],[3,3],[5,-42],[1,-22],[4,-40],[7,-24],[3,-35],[8,-33],[0,-22],[5,-35],[7,-29],[2,-32],[1,-40],[3,-14],[5,-51],[0,-33],[7,-16]],[[2767,2497],[-7,-65],[-2,-34],[-3,-29],[0,-30],[-3,-14],[-1,-81]],[[2632,3060],[37,1]],[[2669,3061],[20,-1],[14,3]],[[640,0],[-7,17],[-1,16],[1,43],[-5,73],[4,24],[2,34],[-2,22],[1,23],[8,-27],[9,-20],[5,-29],[0,-26],[8,-40],[-5,-34],[-8,-15],[-7,-25],[-3,-36]],[[613,397],[3,-26],[4,11],[9,-30],[-1,-27],[-9,-14],[-2,6],[-1,33],[-5,7],[-1,19],[3,21]],[[602,432],[-3,-20],[-7,0],[2,22],[8,-2]],[[574,525],[3,-45],[-2,-26],[-6,-5],[-4,54],[4,1],[5,21]],[[531,626],[3,-2],[2,-20],[-1,-28],[-4,-18],[-9,22],[1,31],[8,15]],[[1908,4871],[0,-472]],[[1908,4399],[-31,-1],[-54,0]],[[1823,4398],[-85,1]],[[1738,4399],[0,349],[4,62],[-2,16],[-6,3],[-2,26],[6,68],[3,6],[3,29],[-1,17],[4,23],[1,34],[6,56],[-2,26],[-7,14],[-4,32]],[[1741,5160],[0,34],[-3,33],[0,16],[0,255],[0,236]],[[1738,5734],[28,0]],[[1766,5734],[0,-195],[9,-54],[1,-52],[5,-23],[6,-8],[0,-14],[11,-51],[1,-21],[8,-20],[0,-12],[8,1],[-4,-71],[-1,-45],[3,-29],[-5,-21],[2,-20],[-1,-21],[6,-20],[7,26],[3,21],[5,-19],[-1,-15],[3,-37],[5,-39],[3,-13],[0,-37],[3,-16],[6,-2],[4,-61],[3,-11],[3,18],[9,-1],[7,17],[3,-10],[7,9],[2,-11],[5,8],[7,39],[4,-33],[5,-20]],[[2489,4496],[53,-3],[28,0]],[[2570,4493],[-1,-37],[4,-43],[5,-70]],[[2578,4343],[0,-450],[-3,-35],[3,-40],[1,-34],[-4,-27],[-1,-25],[-5,-41],[-3,-3],[0,-24],[-2,-9],[-1,-45],[0,-13]],[[2563,3597],[-3,-27],[2,-34],[-11,-17],[-1,-20],[2,-25],[-3,-16],[-11,29],[-3,-2],[-4,-33],[1,-11]],[[2532,3441],[-5,2],[-6,55],[2,12],[-2,37],[0,29],[-9,41],[-3,-4],[-3,25],[-9,38],[0,31],[5,49],[-1,18],[3,23],[-4,13],[-6,9],[-3,-18],[-3,11],[-1,63],[-10,41],[-9,49],[-3,58],[-1,39],[3,27]],[[2467,4089],[0,35],[8,21],[1,29],[4,19],[0,33],[-4,27],[2,34],[11,9],[9,24],[0,29],[4,13],[1,37],[0,24],[-7,18],[-1,20],[-6,35]],[[2655,4340],[0,-228],[0,-266]],[[2655,3846],[-2,-9],[2,-52],[-5,-1],[-5,-18],[-8,9],[1,-38],[-5,-16],[-2,-24],[-5,-9],[-3,-48],[-3,-13],[-6,18],[-1,22],[-7,-24],[1,-21],[-7,-7],[-1,19],[-8,-19],[-2,-20],[-7,28],[-4,-6],[-2,13],[-3,-13],[-7,-2],[-3,-18]],[[2578,4343],[3,-12],[8,0],[9,22]],[[2598,4353],[23,0],[34,0],[0,-13]],[[2473,4685],[0,-28],[4,-19],[-3,-23],[1,-43],[2,-30],[10,-22],[2,-24]],[[2467,4089],[-3,7],[-6,38],[-3,-1],[-40,-5],[-39,-2],[-33,3]],[[2343,4129],[-3,25],[2,49],[-3,43],[0,48],[-5,17],[-1,26],[2,23],[-2,33],[-4,13],[-5,86]],[[2324,4492],[-5,41],[2,29],[1,37],[2,14],[-3,19],[1,33],[-2,16],[4,4]],[[2324,4685],[144,0],[5,0]],[[2356,4017],[3,-18],[9,-14],[-6,-56],[4,-18],[4,-45],[6,-10],[0,-412]],[[2376,3444],[-156,0],[-55,-1]],[[2164,4017],[5,0],[187,0]],[[2718,3716],[-1,-57],[4,-37],[4,-28],[2,-22],[5,-22],[4,-3]],[[2736,3547],[-11,-51],[-11,-29],[0,-14],[-4,-13],[0,-16],[-6,-8],[-1,-21],[-16,-27]],[[2687,3368],[0,-3],[-24,2],[-22,6],[-5,-2],[-32,8],[-36,-5],[-6,9],[1,-35],[-36,2],[-3,-2]],[[2524,3348],[1,24],[5,-8],[2,77]],[[2655,3846],[11,0],[5,-40],[1,-17],[9,-7],[6,-26],[5,13],[10,-14],[4,19],[4,6],[1,-32],[3,-6],[4,-26]],[[2474,2682],[3,-22],[-2,-9],[-1,-38],[5,-24],[0,-57],[-3,-44],[-7,-27],[-2,-43],[-2,4],[-1,-70],[-3,-2],[2,-37],[-2,-14],[54,0],[-3,-63],[4,-41],[1,-32],[4,-20]],[[2521,2143],[-9,-26],[0,-19],[7,-12],[3,30],[6,-30],[-1,-24],[-3,-11],[-7,10],[1,-18],[-2,-27],[5,-24],[9,-7],[3,-29],[3,-4],[-5,-32],[-5,6],[-4,33],[-10,18],[0,33],[-6,-11],[1,-27],[-3,-25],[-3,-4],[-3,28],[-7,1],[-2,-29],[-4,-9],[-5,18],[-4,2],[-3,47],[-7,21],[-2,-3],[-3,40],[-7,-5],[0,24],[-8,-23],[1,-18],[-5,-17],[-9,8],[-10,27],[-7,11],[-16,-9],[-2,-8]],[[2398,2049],[-2,19],[6,68],[-2,37],[2,20],[-1,26],[3,19],[3,50],[0,40],[-8,78],[0,41],[-7,42],[0,196]],[[3046,5029],[12,26],[-2,13],[5,30],[4,13],[-1,12],[5,18],[-1,33],[2,50],[5,17],[1,53],[22,147],[6,-7],[0,-35],[4,-13],[9,21],[6,0],[4,14],[8,-31],[4,-25],[1,-214],[-1,-51],[10,-14],[-2,-22],[3,-21],[-2,-18],[4,-30],[5,7],[5,-68],[-6,-31],[-3,12],[-3,-21],[-4,5],[0,-18],[-6,2],[-8,-40],[-2,28],[-3,2],[1,-30],[-6,-15],[-2,24],[-3,-12],[-7,0],[0,28],[-5,-6],[1,-20],[-4,-42],[1,-12],[-6,-23],[-5,9],[-3,-24],[-4,-3],[-4,-20],[-4,4],[-1,21],[-7,-34],[2,-21],[-5,-7],[0,-18],[-5,-22],[-5,-50]],[[3056,4600],[-3,14],[0,19],[-4,22],[-2,250],[-1,124]],[[2904,3626],[2,0],[-1,0],[-1,0]],[[2933,3721],[-6,-80]],[[2927,3641],[-4,-3],[-8,-12]],[[2915,3626],[-6,-8],[0,31],[-2,13],[3,13],[-4,32],[-2,-14],[-6,3],[-2,35],[2,0],[0,45],[2,18],[-2,60],[3,36],[5,6],[0,37],[-3,-5],[0,-18],[-8,-25],[-2,-21],[0,-56],[-3,-26],[1,-44],[4,-30],[-1,-23],[3,-23],[-2,-16],[-6,30],[-10,15],[-2,29],[-6,-16],[-2,23],[5,29]],[[2874,3756],[2,30]],[[2874,3813],[-4,18],[-6,10],[0,28],[-3,15],[-4,4]],[[2857,3888],[-4,53],[-4,0],[-5,18],[-3,-15],[-5,1],[-1,-21],[-8,14],[-6,-28],[-3,6],[-6,-33],[-6,-17],[1,98]],[[2807,3964],[105,0]],[[3053,4565],[1,-34],[-1,-27],[-5,-25],[0,-29],[6,-4],[4,-31],[0,-24],[3,-6],[0,-22],[8,-19],[9,18],[-2,-26],[-13,-23],[-5,-1],[-3,18],[-5,-6],[0,-13],[-5,-9]],[[3045,4302],[-3,35]],[[3042,4337],[0,6]],[[3042,4343],[-3,14],[-2,45],[-4,0],[-8,-2]],[[2977,4408],[0,7],[6,126]],[[2983,4541],[23,-3]],[[3006,4538],[34,-7],[3,18],[7,19],[3,-3]],[[2598,4353],[5,25],[4,43],[4,26],[3,36],[1,52],[0,57],[-9,111],[3,42],[-2,50],[6,51],[2,43],[-1,23],[5,9],[0,31],[8,9],[5,34],[0,-69],[3,-3],[3,35],[1,58],[2,15],[8,9],[-3,41],[5,35],[7,2],[7,-22],[7,-3],[3,-28],[6,-2],[9,-25],[3,1],[4,-41],[-3,-21],[3,-29],[2,-32],[-2,-71],[-6,-18],[-1,-37],[-7,-12],[-4,-44],[2,-17],[6,-15],[6,24],[6,49],[10,19],[5,-15],[3,-27],[3,-80],[0,-39],[3,-48],[-3,-69],[-4,-11],[-1,25],[-3,-7],[-3,-58],[-6,-21],[-2,-44],[-7,-37],[0,-16]],[[2694,4347],[-39,-7]],[[2635,5110],[1,-23],[-4,-4],[1,33],[2,-6]],[[2496,5270],[11,20],[5,23],[12,9],[8,29],[4,1],[3,20],[9,28],[4,24],[7,15],[6,-13],[-11,-59],[-2,-19],[0,-36],[5,27],[10,-4],[8,-19],[7,-52],[3,-10],[7,9],[2,-12],[7,-6],[16,44],[8,4],[10,-2],[7,15],[6,1],[1,-54],[5,-7],[6,8],[2,-12],[4,16],[8,5],[1,-67],[3,-28],[6,-8],[1,19],[5,0],[3,-20],[-3,-14],[-15,12],[-8,-8],[-8,23],[-2,-21],[1,-18],[-4,4],[-5,27],[-9,15],[-5,1],[-4,-25],[-8,-6],[-8,5],[-3,-10],[-1,-21],[-9,-18],[1,25],[-4,5],[-2,-26],[-6,-1],[-3,-11],[-5,-45],[-8,-58],[1,-5]],[[2576,4989],[-4,20],[2,27],[-7,4],[3,26],[0,34],[-5,23],[-4,24],[-12,19],[-4,-7],[-12,29],[-29,38],[-3,33],[-5,11]],[[2541,5539],[-7,-24],[-4,-3],[1,19],[18,45],[-4,-31],[-4,-6]],[[2324,4685],[0,343],[-7,22],[-5,36],[8,41],[1,22]],[[2321,5149],[-1,76],[-4,20],[-2,42],[0,51],[-1,8],[-1,123],[-5,65],[-3,36],[0,77],[1,27],[-3,60]],[[2302,5734],[59,0],[0,73],[5,-2],[4,-14],[4,-100],[3,-11],[9,-3],[1,-10],[11,-4],[1,-21],[10,5],[0,9],[7,10],[6,-4],[8,-16],[2,-19],[4,2],[4,-43],[2,18],[7,8],[1,-18],[9,-12],[0,-17],[4,-14],[8,8],[5,18],[8,12],[2,-28],[5,6],[6,-6],[6,4],[8,-24],[7,4],[0,-10],[-10,-24],[-13,-19],[-9,-20],[-12,-49],[-5,-31],[-8,-34],[-13,-46],[2,-16]],[[2450,5296],[-2,9],[-6,-16],[0,-113],[-2,-11],[-8,-16],[-6,-41],[-1,-27],[3,-2],[4,-24],[-3,-29],[0,-33],[-2,-70],[8,-34],[6,-3],[3,-21],[8,-21],[2,-25],[8,-33],[5,-7],[5,-42],[-1,-30],[2,-22]],[[2553,2179],[-3,-8],[-7,4],[-3,12],[-7,-8],[-9,-22],[-3,-14]],[[2498,3062],[53,0],[7,0]],[[2524,3348],[-2,0],[-2,0],[1,-47],[-6,-48]],[[2376,3349],[0,95]],[[2356,4017],[-7,50],[-6,62]],[[2108,5151],[0,-181],[-1,0]],[[2107,4970],[-53,1],[-90,0],[-56,0],[0,-100]],[[1766,5734],[130,-1],[58,1],[154,0]],[[2108,5734],[0,-217],[0,-366]],[[2107,4208],[0,382]],[[2107,4590],[21,0],[49,-1],[88,0],[1,-10],[15,-34],[4,19],[4,-4],[13,0],[15,-36],[2,-27],[5,-5]],[[1823,4398],[0,-954]],[[1654,4398],[37,-1],[47,2]],[[3006,4538],[-2,14],[0,28],[3,11],[-1,27],[3,81],[5,37],[2,43],[3,16],[-1,47],[10,17],[5,33],[-3,31],[4,32],[0,18]],[[3034,4973],[4,49],[6,-5],[2,12]],[[3056,4600],[-3,-35]],[[2962,4152],[-5,-13],[-2,-29],[8,-14],[0,-22],[-3,-103],[-9,-76],[-6,-22],[-5,-48],[-3,31],[-8,16],[-10,42],[-1,28],[0,4],[2,11]],[[2922,3980],[8,15],[0,15],[9,31],[2,17],[-9,39],[0,24],[-3,6],[-1,22],[5,33],[-3,20],[7,40],[2,21],[4,13]],[[2943,4276],[13,-41],[9,-28],[-3,-55]],[[2137,3444],[0,-95]],[[2137,3349],[-1,0],[0,-474],[0,-193],[0,-192],[-101,0],[-1,-18],[3,-22]],[[2037,2450],[-48,0],[0,-87],[-24,0]],[[2972,4205],[13,-15],[2,11],[10,0],[6,6],[8,31],[1,-22],[5,-10],[-11,-28],[-22,-42],[-9,-8],[-6,2],[-5,-9],[-2,31]],[[2943,4276],[-2,14],[-4,1],[-5,32],[1,29],[-4,22],[-2,-2],[-3,27],[-125,0],[0,48],[0,3]],[[2799,4450],[17,54],[3,26],[5,18],[-2,32],[-2,7],[-2,52],[17,22],[15,-1],[6,-5],[6,-21],[4,8],[12,-1],[8,14],[8,34],[5,1],[0,52],[3,31],[-7,21],[2,24],[11,32],[4,28],[14,64],[13,32],[19,-5],[23,4]],[[2981,4973],[1,-39],[-2,-36],[3,-34],[-1,-37],[-3,-39],[2,-52],[-1,-16],[4,-31],[-1,-132],[0,-16]],[[2909,3359],[4,-77],[-8,8],[-1,-10],[-10,-11],[-1,-11],[-7,-3],[0,-13],[8,9],[1,-8],[9,9],[3,-18],[5,8],[2,-46],[-2,-22],[-3,-2],[-8,-47],[-9,-2],[-2,-33],[4,-32],[4,-6],[-6,-54],[-6,7],[-9,-6],[-6,-11],[-10,-37],[-7,-48],[-4,-60],[-6,13],[-11,-12]],[[2833,2844],[-32,181],[-32,4],[1,21],[-5,33],[-3,-12],[0,20],[-35,10],[-8,-8],[-6,-17],[-10,-13]],[[2669,3061],[1,45],[5,4],[3,31],[7,29],[7,1],[7,29],[8,10],[6,43],[4,13],[1,-19],[11,37],[5,-8],[4,36],[5,9],[1,45]],[[2744,3366],[20,-5],[19,-3],[23,-1],[103,2]],[[2321,5149],[-213,2]],[[2108,5734],[194,0]],[[2777,4138],[-4,-10],[2,-21],[0,-29],[-4,-46],[-3,-70],[-11,-62],[-3,-8],[-4,12],[-3,-27],[-3,1],[-4,-36],[1,-22],[-3,-18],[-4,29],[-5,-46],[1,-29],[-3,-11],[-1,-25],[-8,-4]],[[2694,4347],[11,-26],[3,-15],[3,14],[6,-30],[4,-9],[14,25],[7,-6],[9,36],[12,34],[14,24]],[[2777,4394],[0,-256]],[[2380,2803],[-11,21],[-3,22],[-7,18],[-2,-16],[-8,1],[-1,10],[-7,-19],[-3,11],[-6,-10],[-5,-29],[-2,17],[-6,14],[-7,0],[-2,21],[-7,-42],[-2,24],[-3,-8],[-3,16],[-7,15],[-5,-25],[-2,26],[-4,3],[-2,21],[-6,8],[-3,-18],[-3,16],[-5,-2],[-6,17],[-6,-2],[-2,36],[-9,2],[-4,-6],[-6,37],[-2,-3],[0,370],[-52,0],[-34,0]],[[1534,4399],[-4,22],[-2,61],[0,43],[-4,33],[3,32],[2,51],[4,54],[2,48],[3,162],[0,22],[3,71],[1,99],[-2,54],[1,32],[12,29]],[[1553,5212],[5,-22],[4,5],[3,2],[6,-20],[3,-23],[1,-57],[15,-21],[12,30],[8,3],[9,-10],[1,-13],[16,27],[3,-9],[9,5],[7,19],[12,17],[12,4],[4,12],[58,-1]],[[2807,3964],[-30,0],[0,174]],[[2777,4394],[5,11],[17,45]],[[3045,4302],[-6,-4],[3,39]],[[3042,4343],[-4,3],[-3,-28],[-1,-40],[-11,-9]],[[2833,2844],[-5,-10],[-6,-31],[-6,-49],[-1,-40],[-5,-31],[-6,0],[-2,-23],[-6,-25],[-4,-28],[-6,-11],[-6,-29],[-1,-14],[-6,-16],[-6,-40]],[[2107,4590],[0,380]],[[2687,3368],[57,-2]],[[2398,2049],[-5,-1],[-14,-26],[-6,15],[-1,31],[-3,-22],[-3,5],[-1,-27],[3,-11],[0,-36],[-5,-37],[-9,-47],[-17,-51],[-2,9],[-5,-13],[0,12],[-7,-9],[-3,24],[-2,-5],[7,-49],[-5,-16],[-5,10],[-1,-35],[-7,-35],[-6,-66],[-4,-69],[-3,5],[-1,-25],[3,6],[-2,-50],[-2,-2],[0,-28],[3,-16],[1,-57],[3,-20],[0,-37],[3,-32],[-9,-20],[-3,25],[-7,10],[-9,-3],[-8,32],[-5,3],[-5,25],[-6,8],[-4,24],[-2,58],[-5,34],[0,30],[-2,31],[1,27],[-4,30],[-3,4],[-5,27],[-1,34],[-5,32],[-6,26],[-3,57],[-2,16],[-4,46],[-1,38],[-4,27],[-6,24],[-1,16],[-6,15],[-4,42],[-13,9],[-7,-2],[-7,15],[-1,-20],[-7,-6],[-5,-40],[-3,-64],[-2,-1],[-4,-37],[-5,-1],[-7,29],[-17,47],[-4,25],[-6,24],[-5,54],[-1,49],[-4,40],[-2,35],[-3,22],[-11,32],[-6,44],[-4,15],[-6,38],[-7,20],[-5,50],[-4,11]],[[1908,4399],[0,-192],[57,0]],[[2981,4973],[30,-2],[23,2]],[[2927,3641],[-4,-32],[-3,-12],[-3,-44],[-6,-71],[-5,-15],[-1,27],[2,58],[8,74]],[[2874,3756],[-4,-8],[-2,-28],[1,-19],[8,6],[1,-31],[10,-12],[3,-24],[8,-26],[-4,-54],[4,-41],[-4,-20],[-1,-24],[4,-15],[-4,-23],[-6,30],[-1,-10],[5,-22],[14,-5],[3,-71]],[[2736,3547],[-1,-16],[4,-32],[5,-16],[4,1],[5,25],[4,-20],[7,11],[13,36],[1,-11],[5,17],[0,34],[4,30],[5,29],[2,34],[6,36],[2,44],[5,-27],[4,-8],[3,16],[6,68],[4,-17],[13,77],[2,57],[15,-64],[3,37]],[[1553,5212],[-5,7],[-4,-12],[-6,17],[1,26],[4,14],[-6,40],[-4,103],[-2,14],[-3,73],[-6,28],[-2,56],[3,38],[6,-18],[11,-24],[8,1],[8,-9],[8,9],[3,-16],[7,1],[5,-42],[3,3],[1,-56],[2,-52],[3,6],[-3,43],[1,43],[4,44],[-3,18],[-1,31],[-3,35],[2,25],[-2,29],[-5,4],[-4,22],[1,21],[163,0]],[[1576,5602],[4,9],[0,-39],[-5,15],[1,15]],[[1568,5655],[3,25],[4,-30],[-1,-27],[-7,8],[1,24]],[[2576,4989],[-1,-23],[-6,-4],[-4,-44],[-2,-30],[3,-6],[5,20],[4,38],[6,15],[5,48],[6,10],[-1,-25],[-4,-23],[-8,-79],[-2,-44],[0,-32],[-3,-10],[-2,-43],[1,-37],[-3,-24],[-3,-59],[0,-47],[4,-42],[-1,-55]],[[2450,5296],[6,-2],[20,33],[8,17],[2,-13],[-4,-25],[9,-33],[5,-3]]]};
	  Datamap.prototype.usgTopo = '__USG__';
	  Datamap.prototype.uzbTopo = '__UZB__';
	  Datamap.prototype.vatTopo = '__VAT__';
	  Datamap.prototype.vctTopo = '__VCT__';
	  Datamap.prototype.venTopo = '__VEN__';
	  Datamap.prototype.vgbTopo = '__VGB__';
	  Datamap.prototype.virTopo = '__VIR__';
	  Datamap.prototype.vnmTopo = '__VNM__';
	  Datamap.prototype.vutTopo = '__VUT__';
	  Datamap.prototype.wlfTopo = '__WLF__';
	  Datamap.prototype.wsbTopo = '__WSB__';
	  Datamap.prototype.wsmTopo = '__WSM__';
	  Datamap.prototype.yemTopo = '__YEM__';
	  Datamap.prototype.zafTopo = '__ZAF__';
	  Datamap.prototype.zmbTopo = '__ZMB__';
	  Datamap.prototype.zweTopo = '__ZWE__';
	
	  /**************************************
	                Utilities
	  ***************************************/
	
	  //convert lat/lng coords to X / Y coords
	  Datamap.prototype.latLngToXY = function(lat, lng) {
	     return this.projection([lng, lat]);
	  };
	
	  //add <g> layer to root SVG
	  Datamap.prototype.addLayer = function( className, id, first ) {
	    var layer;
	    if ( first ) {
	      layer = this.svg.insert('g', ':first-child')
	    }
	    else {
	      layer = this.svg.append('g')
	    }
	    return layer.attr('id', id || '')
	      .attr('class', className || '');
	  };
	
	  Datamap.prototype.updateChoropleth = function(data, options) {
	    var svg = this.svg;
	    var that = this;
	
	    // when options.reset = true, reset all the fill colors to the defaultFill and kill all data-info
	    if ( options && options.reset === true ) {
	      svg.selectAll('.datamaps-subunit')
	        .attr('data-info', function() {
	           return "{}"
	        })
	        .transition().style('fill', this.options.fills.defaultFill)
	    }
	
	    for ( var subunit in data ) {
	      if ( data.hasOwnProperty(subunit) ) {
	        var color;
	        var subunitData = data[subunit]
	        if ( ! subunit ) {
	          continue;
	        }
	        else if ( typeof subunitData === "string" ) {
	          color = subunitData;
	        }
	        else if ( typeof subunitData.color === "string" ) {
	          color = subunitData.color;
	        }
	        else if ( typeof subunitData.fillColor === "string" ) {
	          color = subunitData.fillColor;
	        }
	        else {
	          color = this.options.fills[ subunitData.fillKey ];
	        }
	        //if it's an object, overriding the previous data
	        if ( subunitData === Object(subunitData) ) {
	          this.options.data[subunit] = defaults(subunitData, this.options.data[subunit] || {});
	          var geo = this.svg.select('.' + subunit).attr('data-info', JSON.stringify(this.options.data[subunit]));
	        }
	        svg
	          .selectAll('.' + subunit)
	          .transition()
	            .style('fill', color);
	      }
	    }
	  };
	
	  Datamap.prototype.updatePopup = function (element, d, options) {
	    var self = this;
	    element.on('mousemove', null);
	    element.on('mousemove', function() {
	      var position = d3.mouse(self.options.element);
	      d3.select(self.svg[0][0].parentNode).select('.datamaps-hoverover')
	        .style('top', ( (position[1] + 30)) + "px")
	        .html(function() {
	          var data = JSON.parse(element.attr('data-info'));
	          try {
	            return options.popupTemplate(d, data);
	          } catch (e) {
	            return "";
	          }
	        })
	        .style('left', ( position[0]) + "px");
	    });
	
	    d3.select(self.svg[0][0].parentNode).select('.datamaps-hoverover').style('display', 'block');
	  };
	
	  Datamap.prototype.addPlugin = function( name, pluginFn ) {
	    var self = this;
	    if ( typeof Datamap.prototype[name] === "undefined" ) {
	      Datamap.prototype[name] = function(data, options, callback, createNewLayer) {
	        var layer;
	        if ( typeof createNewLayer === "undefined" ) {
	          createNewLayer = false;
	        }
	
	        if ( typeof options === 'function' ) {
	          callback = options;
	          options = undefined;
	        }
	
	        options = defaults(options || {}, self.options[name + 'Config']);
	
	        //add a single layer, reuse the old layer
	        if ( !createNewLayer && this.options[name + 'Layer'] ) {
	          layer = this.options[name + 'Layer'];
	          options = options || this.options[name + 'Options'];
	        }
	        else {
	          layer = this.addLayer(name);
	          this.options[name + 'Layer'] = layer;
	          this.options[name + 'Options'] = options;
	        }
	        pluginFn.apply(this, [layer, data, options]);
	        if ( callback ) {
	          callback(layer);
	        }
	      };
	    }
	  };
	
	  // expose library
	  if (true) {
	    d3 = __webpack_require__(77);
	    topojson = __webpack_require__(96);
	    module.exports = Datamap;
	  }
	  else if ( typeof define === "function" && define.amd ) {
	    define( "datamaps", ["require", "d3", "topojson"], function(require) {
	      d3 = require('d3');
	      topojson = require('topojson');
	
	      return Datamap;
	    });
	  }
	  else {
	    window.Datamap = window.Datamaps = Datamap;
	  }
	
	  if ( window.jQuery ) {
	    window.jQuery.fn.datamaps = function(options, callback) {
	      options = options || {};
	      options.element = this[0];
	      var datamap = new Datamap(options);
	      if ( typeof callback === "function" ) {
	        callback(datamap, options);
	      }
	      return this;
	    };
	  }
	})();
	
	
	
	/*** EXPORTS FROM exports-loader ***/
	exports["Datamap"] = (window.Datamap);

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/*** IMPORTS FROM imports-loader ***/
	var d3 = __webpack_require__(77);
	
	!function () {
	  function t(t, e) {
	    return { type: "Feature", id: t.id, properties: t.properties, geometry: n(t.geometry, e) };
	  }function n(t, e) {
	    if (!t) return null;if ("GeometryCollection" === t.type) return { type: "GeometryCollection", geometries: object.geometries.map(function (t) {
	        return n(t, e);
	      }) };if (!y.hasOwnProperty(t.type)) return null;var r = y[t.type];return d3.geo.stream(t, e(r)), r.result();
	  }function e() {}function r(t) {
	    if ((n = t.length) < 4) return !1;for (var n, e = 0, r = t[n - 1][1] * t[0][0] - t[n - 1][0] * t[0][1]; ++e < n;) {
	      r += t[e - 1][1] * t[e][0] - t[e - 1][0] * t[e][1];
	    }return 0 >= r;
	  }function o(t, n) {
	    for (var e = n[0], r = n[1], o = !1, i = 0, u = t.length, a = u - 1; u > i; a = i++) {
	      var l = t[i],
	          c = l[0],
	          f = l[1],
	          p = t[a],
	          s = p[0],
	          h = p[1];f > r ^ h > r && (s - c) * (r - f) / (h - f) + c > e && (o = !o);
	    }return o;
	  }function i(t) {
	    return t > 0 ? 1 : 0 > t ? -1 : 0;
	  }function u(t) {
	    return t > 1 ? v : -1 > t ? -v : Math.asin(t);
	  }function a(t) {
	    return t > 0 ? Math.sqrt(t) : 0;
	  }function l(t, n) {
	    if (Math.abs(n) < M) return [t, 0];var e = n / v,
	        r = u(e);if (Math.abs(t) < M || Math.abs(Math.abs(n) - v) < M) return [0, d * Math.tan(r / 2)];var o = (d / t - t / d) / 2,
	        l = e / (1 + Math.cos(r));return [d * (i(t) * a(o * o + 1 - l * l) - o), d * l];
	  }d3.geo.project = function (t, e) {
	    var r = e.stream;if (!r) throw new Error("not yet supported");return (t && c.hasOwnProperty(t.type) ? c[t.type] : n)(t, r);
	  };var c = { Feature: t, FeatureCollection: function FeatureCollection(n, e) {
	      return { type: "FeatureCollection", features: n.features.map(function (n) {
	          return t(n, e);
	        }) };
	    } },
	      f = [],
	      p = [],
	      s = { point: function point(t, n) {
	      f.push([t, n]);
	    }, result: function result() {
	      var t = f.length ? f.length < 2 ? { type: "Point", coordinates: f[0] } : { type: "MultiPoint", coordinates: f } : null;return f = [], t;
	    } },
	      h = { lineStart: e, point: function point(t, n) {
	      f.push([t, n]);
	    }, lineEnd: function lineEnd() {
	      f.length && (p.push(f), f = []);
	    }, result: function result() {
	      var t = p.length ? p.length < 2 ? { type: "LineString", coordinates: p[0] } : { type: "MultiLineString", coordinates: p } : null;return p = [], t;
	    } },
	      g = { polygonStart: e, lineStart: e, point: function point(t, n) {
	      f.push([t, n]);
	    }, lineEnd: function lineEnd() {
	      var t = f.length;if (t) {
	        do {
	          f.push(f[0].slice());
	        } while (++t < 4);p.push(f), f = [];
	      }
	    }, polygonEnd: e, result: function result() {
	      if (!p.length) return null;var t = [],
	          n = [];return p.forEach(function (e) {
	        r(e) ? t.push([e]) : n.push(e);
	      }), n.forEach(function (n) {
	        var e = n[0];t.some(function (t) {
	          return o(t[0], e) ? (t.push(n), !0) : void 0;
	        }) || t.push([n]);
	      }), p = [], t.length ? t.length > 1 ? { type: "MultiPolygon", coordinates: t } : { type: "Polygon", coordinates: t[0] } : null;
	    } },
	      y = { Point: s, MultiPoint: s, LineString: h, MultiLineString: h, Polygon: g, MultiPolygon: g, Sphere: g },
	      M = 1e-6,
	      d = Math.PI,
	      v = d / 2;Math.sqrt(d);var m = d3.geo.projection;d3.geo.projectionMutator, l.invert = function (t, n) {
	    if (!n) return [t, 0];var e = n / d,
	        r = (d * d * (1 - e * e) - t * t) / (2 * d * t);return [t ? d * (i(t) * Math.sqrt(r * r + 1) - r) : 0, v * Math.sin(2 * Math.atan(e))];
	  }, (d3.geo.vanDerGrinten3 = function () {
	    return m(l);
	  }).raw = l;
	}();

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.topojson = global.topojson || {})));
	}(this, (function (exports) { 'use strict';
	
	function noop() {}
	
	function transformAbsolute(transform) {
	  if (!transform) return noop;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(point, i) {
	    if (!i) x0 = y0 = 0;
	    point[0] = (x0 += point[0]) * kx + dx;
	    point[1] = (y0 += point[1]) * ky + dy;
	  };
	}
	
	function transformRelative(transform) {
	  if (!transform) return noop;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(point, i) {
	    if (!i) x0 = y0 = 0;
	    var x1 = Math.round((point[0] - dx) / kx),
	        y1 = Math.round((point[1] - dy) / ky);
	    point[0] = x1 - x0;
	    point[1] = y1 - y0;
	    x0 = x1;
	    y0 = y1;
	  };
	}
	
	function reverse(array, n) {
	  var t, j = array.length, i = j - n;
	  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	}
	
	function bisect(a, x) {
	  var lo = 0, hi = a.length;
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	    if (a[mid] < x) lo = mid + 1;
	    else hi = mid;
	  }
	  return lo;
	}
	
	function feature(topology, o) {
	  return o.type === "GeometryCollection" ? {
	    type: "FeatureCollection",
	    features: o.geometries.map(function(o) { return feature$1(topology, o); })
	  } : feature$1(topology, o);
	}
	
	function feature$1(topology, o) {
	  var f = {
	    type: "Feature",
	    id: o.id,
	    properties: o.properties || {},
	    geometry: object(topology, o)
	  };
	  if (o.id == null) delete f.id;
	  return f;
	}
	
	function object(topology, o) {
	  var absolute = transformAbsolute(topology.transform),
	      arcs = topology.arcs;
	
	  function arc(i, points) {
	    if (points.length) points.pop();
	    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length, p; k < n; ++k) {
	      points.push(p = a[k].slice());
	      absolute(p, k);
	    }
	    if (i < 0) reverse(points, n);
	  }
	
	  function point(p) {
	    p = p.slice();
	    absolute(p, 0);
	    return p;
	  }
	
	  function line(arcs) {
	    var points = [];
	    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
	    if (points.length < 2) points.push(points[0].slice());
	    return points;
	  }
	
	  function ring(arcs) {
	    var points = line(arcs);
	    while (points.length < 4) points.push(points[0].slice());
	    return points;
	  }
	
	  function polygon(arcs) {
	    return arcs.map(ring);
	  }
	
	  function geometry(o) {
	    var t = o.type;
	    return t === "GeometryCollection" ? {type: t, geometries: o.geometries.map(geometry)}
	        : t in geometryType ? {type: t, coordinates: geometryType[t](o)}
	        : null;
	  }
	
	  var geometryType = {
	    Point: function(o) { return point(o.coordinates); },
	    MultiPoint: function(o) { return o.coordinates.map(point); },
	    LineString: function(o) { return line(o.arcs); },
	    MultiLineString: function(o) { return o.arcs.map(line); },
	    Polygon: function(o) { return polygon(o.arcs); },
	    MultiPolygon: function(o) { return o.arcs.map(polygon); }
	  };
	
	  return geometry(o);
	}
	
	function stitchArcs(topology, arcs) {
	  var stitchedArcs = {},
	      fragmentByStart = {},
	      fragmentByEnd = {},
	      fragments = [],
	      emptyIndex = -1;
	
	  // Stitch empty arcs first, since they may be subsumed by other arcs.
	  arcs.forEach(function(i, j) {
	    var arc = topology.arcs[i < 0 ? ~i : i], t;
	    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
	      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
	    }
	  });
	
	  arcs.forEach(function(i) {
	    var e = ends(i),
	        start = e[0],
	        end = e[1],
	        f, g;
	
	    if (f = fragmentByEnd[start]) {
	      delete fragmentByEnd[f.end];
	      f.push(i);
	      f.end = end;
	      if (g = fragmentByStart[end]) {
	        delete fragmentByStart[g.start];
	        var fg = g === f ? f : f.concat(g);
	        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else if (f = fragmentByStart[end]) {
	      delete fragmentByStart[f.start];
	      f.unshift(i);
	      f.start = start;
	      if (g = fragmentByEnd[start]) {
	        delete fragmentByEnd[g.end];
	        var gf = g === f ? f : g.concat(f);
	        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else {
	      f = [i];
	      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
	    }
	  });
	
	  function ends(i) {
	    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
	    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
	    else p1 = arc[arc.length - 1];
	    return i < 0 ? [p1, p0] : [p0, p1];
	  }
	
	  function flush(fragmentByEnd, fragmentByStart) {
	    for (var k in fragmentByEnd) {
	      var f = fragmentByEnd[k];
	      delete fragmentByStart[f.start];
	      delete f.start;
	      delete f.end;
	      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
	      fragments.push(f);
	    }
	  }
	
	  flush(fragmentByEnd, fragmentByStart);
	  flush(fragmentByStart, fragmentByEnd);
	  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
	
	  return fragments;
	}
	
	function mesh(topology) {
	  return object(topology, meshArcs.apply(this, arguments));
	}
	
	function meshArcs(topology, o, filter) {
	  var arcs = [];
	
	  function arc(i) {
	    var j = i < 0 ? ~i : i;
	    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
	  }
	
	  function line(arcs) {
	    arcs.forEach(arc);
	  }
	
	  function polygon(arcs) {
	    arcs.forEach(line);
	  }
	
	  function geometry(o) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(geometry);
	    else if (o.type in geometryType) geom = o, geometryType[o.type](o.arcs);
	  }
	
	  if (arguments.length > 1) {
	    var geomsByArc = [],
	        geom;
	
	    var geometryType = {
	      LineString: line,
	      MultiLineString: polygon,
	      Polygon: polygon,
	      MultiPolygon: function(arcs) { arcs.forEach(polygon); }
	    };
	
	    geometry(o);
	
	    geomsByArc.forEach(arguments.length < 3
	        ? function(geoms) { arcs.push(geoms[0].i); }
	        : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
	  } else {
	    for (var i = 0, n = topology.arcs.length; i < n; ++i) arcs.push(i);
	  }
	
	  return {type: "MultiLineString", arcs: stitchArcs(topology, arcs)};
	}
	
	function cartesianTriangleArea(triangle) {
	  var a = triangle[0], b = triangle[1], c = triangle[2];
	  return Math.abs((a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]));
	}
	
	function ring(ring) {
	  var i = -1,
	      n = ring.length,
	      a,
	      b = ring[n - 1],
	      area = 0;
	
	  while (++i < n) {
	    a = b;
	    b = ring[i];
	    area += a[0] * b[1] - a[1] * b[0];
	  }
	
	  return area / 2;
	}
	
	function merge(topology) {
	  return object(topology, mergeArcs.apply(this, arguments));
	}
	
	function mergeArcs(topology, objects) {
	  var polygonsByArc = {},
	      polygons = [],
	      components = [];
	
	  objects.forEach(function(o) {
	    if (o.type === "Polygon") register(o.arcs);
	    else if (o.type === "MultiPolygon") o.arcs.forEach(register);
	  });
	
	  function register(polygon) {
	    polygon.forEach(function(ring$$) {
	      ring$$.forEach(function(arc) {
	        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
	      });
	    });
	    polygons.push(polygon);
	  }
	
	  function area(ring$$) {
	    return Math.abs(ring(object(topology, {type: "Polygon", arcs: [ring$$]}).coordinates[0]));
	  }
	
	  polygons.forEach(function(polygon) {
	    if (!polygon._) {
	      var component = [],
	          neighbors = [polygon];
	      polygon._ = 1;
	      components.push(component);
	      while (polygon = neighbors.pop()) {
	        component.push(polygon);
	        polygon.forEach(function(ring$$) {
	          ring$$.forEach(function(arc) {
	            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
	              if (!polygon._) {
	                polygon._ = 1;
	                neighbors.push(polygon);
	              }
	            });
	          });
	        });
	      }
	    }
	  });
	
	  polygons.forEach(function(polygon) {
	    delete polygon._;
	  });
	
	  return {
	    type: "MultiPolygon",
	    arcs: components.map(function(polygons) {
	      var arcs = [], n;
	
	      // Extract the exterior (unique) arcs.
	      polygons.forEach(function(polygon) {
	        polygon.forEach(function(ring$$) {
	          ring$$.forEach(function(arc) {
	            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
	              arcs.push(arc);
	            }
	          });
	        });
	      });
	
	      // Stitch the arcs into one or more rings.
	      arcs = stitchArcs(topology, arcs);
	
	      // If more than one ring is returned,
	      // at most one of these rings can be the exterior;
	      // choose the one with the greatest absolute area.
	      if ((n = arcs.length) > 1) {
	        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
	          if ((ki = area(arcs[i])) > k) {
	            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
	          }
	        }
	      }
	
	      return arcs;
	    })
	  };
	}
	
	function neighbors(objects) {
	  var indexesByArc = {}, // arc index -> array of object indexes
	      neighbors = objects.map(function() { return []; });
	
	  function line(arcs, i) {
	    arcs.forEach(function(a) {
	      if (a < 0) a = ~a;
	      var o = indexesByArc[a];
	      if (o) o.push(i);
	      else indexesByArc[a] = [i];
	    });
	  }
	
	  function polygon(arcs, i) {
	    arcs.forEach(function(arc) { line(arc, i); });
	  }
	
	  function geometry(o, i) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
	    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
	  }
	
	  var geometryType = {
	    LineString: line,
	    MultiLineString: polygon,
	    Polygon: polygon,
	    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
	  };
	
	  objects.forEach(geometry);
	
	  for (var i in indexesByArc) {
	    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
	      for (var k = j + 1; k < m; ++k) {
	        var ij = indexes[j], ik = indexes[k], n;
	        if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
	        if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
	      }
	    }
	  }
	
	  return neighbors;
	}
	
	function compareArea(a, b) {
	  return a[1][2] - b[1][2];
	}
	
	function minAreaHeap() {
	  var heap = {},
	      array = [],
	      size = 0;
	
	  heap.push = function(object) {
	    up(array[object._ = size] = object, size++);
	    return size;
	  };
	
	  heap.pop = function() {
	    if (size <= 0) return;
	    var removed = array[0], object;
	    if (--size > 0) object = array[size], down(array[object._ = 0] = object, 0);
	    return removed;
	  };
	
	  heap.remove = function(removed) {
	    var i = removed._, object;
	    if (array[i] !== removed) return; // invalid request
	    if (i !== --size) object = array[size], (compareArea(object, removed) < 0 ? up : down)(array[object._ = i] = object, i);
	    return i;
	  };
	
	  function up(object, i) {
	    while (i > 0) {
	      var j = ((i + 1) >> 1) - 1,
	          parent = array[j];
	      if (compareArea(object, parent) >= 0) break;
	      array[parent._ = i] = parent;
	      array[object._ = i = j] = object;
	    }
	  }
	
	  function down(object, i) {
	    while (true) {
	      var r = (i + 1) << 1,
	          l = r - 1,
	          j = i,
	          child = array[j];
	      if (l < size && compareArea(array[l], child) < 0) child = array[j = l];
	      if (r < size && compareArea(array[r], child) < 0) child = array[j = r];
	      if (j === i) break;
	      array[child._ = i] = child;
	      array[object._ = i = j] = object;
	    }
	  }
	
	  return heap;
	}
	
	function presimplify(topology, triangleArea) {
	  var absolute = transformAbsolute(topology.transform),
	      relative = transformRelative(topology.transform),
	      heap = minAreaHeap();
	
	  if (!triangleArea) triangleArea = cartesianTriangleArea;
	
	  topology.arcs.forEach(function(arc) {
	    var triangles = [],
	        maxArea = 0,
	        triangle,
	        i,
	        n,
	        p;
	
	    // To store each point’s effective area, we create a new array rather than
	    // extending the passed-in point to workaround a Chrome/V8 bug (getting
	    // stuck in smi mode). For midpoints, the initial effective area of
	    // Infinity will be computed in the next step.
	    for (i = 0, n = arc.length; i < n; ++i) {
	      p = arc[i];
	      absolute(arc[i] = [p[0], p[1], Infinity], i);
	    }
	
	    for (i = 1, n = arc.length - 1; i < n; ++i) {
	      triangle = arc.slice(i - 1, i + 2);
	      triangle[1][2] = triangleArea(triangle);
	      triangles.push(triangle);
	      heap.push(triangle);
	    }
	
	    for (i = 0, n = triangles.length; i < n; ++i) {
	      triangle = triangles[i];
	      triangle.previous = triangles[i - 1];
	      triangle.next = triangles[i + 1];
	    }
	
	    while (triangle = heap.pop()) {
	      var previous = triangle.previous,
	          next = triangle.next;
	
	      // If the area of the current point is less than that of the previous point
	      // to be eliminated, use the latter's area instead. This ensures that the
	      // current point cannot be eliminated without eliminating previously-
	      // eliminated points.
	      if (triangle[1][2] < maxArea) triangle[1][2] = maxArea;
	      else maxArea = triangle[1][2];
	
	      if (previous) {
	        previous.next = next;
	        previous[2] = triangle[2];
	        update(previous);
	      }
	
	      if (next) {
	        next.previous = previous;
	        next[0] = triangle[0];
	        update(next);
	      }
	    }
	
	    arc.forEach(relative);
	  });
	
	  function update(triangle) {
	    heap.remove(triangle);
	    triangle[1][2] = triangleArea(triangle);
	    heap.push(triangle);
	  }
	
	  return topology;
	}
	
	var version = "1.6.27";
	
	exports.version = version;
	exports.mesh = mesh;
	exports.meshArcs = meshArcs;
	exports.merge = merge;
	exports.mergeArcs = mergeArcs;
	exports.feature = feature;
	exports.neighbors = neighbors;
	exports.presimplify = presimplify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */
/***/ (function(module, exports) {

	/**
	 * angular-slugify -- provides slugification for AngularJS
	 *
	 * Copyright © 2013 Paul Smith <paulsmith@pobox.com>
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the “Software”), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	
	(function() {
	    "use strict";
	
	    var mod = angular.module("slugifier", []);
	
	    // Unicode (non-control) characters in the Latin-1 Supplement and Latin
	    // Extended-A blocks, transliterated into ASCII characters.
	    var charmap = {
	        ' ': " ",
	        '¡': "!",
	        '¢': "c",
	        '£': "lb",
	        '¥': "yen",
	        '¦': "|",
	        '§': "SS",
	        '¨': "\"",
	        '©': "(c)",
	        'ª': "a",
	        '«': "<<",
	        '¬': "not",
	        '­': "-",
	        '®': "(R)",
	        '°': "^0",
	        '±': "+/-",
	        '²': "^2",
	        '³': "^3",
	        '´': "'",
	        'µ': "u",
	        '¶': "P",
	        '·': ".",
	        '¸': ",",
	        '¹': "^1",
	        'º': "o",
	        '»': ">>",
	        '¼': " 1/4 ",
	        '½': " 1/2 ",
	        '¾': " 3/4 ",
	        '¿': "?",
	        'À': "`A",
	        'Á': "'A",
	        'Â': "^A",
	        'Ã': "~A",
	        'Ä': '"A',
	        'Å': "A",
	        'Æ': "AE",
	        'Ç': "C",
	        'È': "`E",
	        'É': "'E",
	        'Ê': "^E",
	        'Ë': '"E',
	        'Ì': "`I",
	        'Í': "'I",
	        'Î': "^I",
	        'Ï': '"I',
	        'Ð': "D",
	        'Ñ': "~N",
	        'Ò': "`O",
	        'Ó': "'O",
	        'Ô': "^O",
	        'Õ': "~O",
	        'Ö': '"O',
	        '×': "x",
	        'Ø': "O",
	        'Ù': "`U",
	        'Ú': "'U",
	        'Û': "^U",
	        'Ü': '"U',
	        'Ý': "'Y",
	        'Þ': "Th",
	        'ß': "ss",
	        'à': "`a",
	        'á': "'a",
	        'â': "^a",
	        'ã': "~a",
	        'ä': '"a',
	        'å': "a",
	        'æ': "ae",
	        'ç': "c",
	        'è': "`e",
	        'é': "'e",
	        'ê': "^e",
	        'ë': '"e',
	        'ì': "`i",
	        'í': "'i",
	        'î': "^i",
	        'ï': '"i',
	        'ð': "d",
	        'ñ': "~n",
	        'ò': "`o",
	        'ó': "'o",
	        'ô': "^o",
	        'õ': "~o",
	        'ö': '"o',
	        '÷': ":",
	        'ø': "o",
	        'ù': "`u",
	        'ú': "'u",
	        'û': "^u",
	        'ü': '"u',
	        'ý': "'y",
	        'þ': "th",
	        'ÿ': '"y',
	        'Ā': "A",
	        'ā': "a",
	        'Ă': "A",
	        'ă': "a",
	        'Ą': "A",
	        'ą': "a",
	        'Ć': "'C",
	        'ć': "'c",
	        'Ĉ': "^C",
	        'ĉ': "^c",
	        'Ċ': "C",
	        'ċ': "c",
	        'Č': "C",
	        'č': "c",
	        'Ď': "D",
	        'ď': "d",
	        'Đ': "D",
	        'đ': "d",
	        'Ē': "E",
	        'ē': "e",
	        'Ĕ': "E",
	        'ĕ': "e",
	        'Ė': "E",
	        'ė': "e",
	        'Ę': "E",
	        'ę': "e",
	        'Ě': "E",
	        'ě': "e",
	        'Ĝ': "^G",
	        'ĝ': "^g",
	        'Ğ': "G",
	        'ğ': "g",
	        'Ġ': "G",
	        'ġ': "g",
	        'Ģ': "G",
	        'ģ': "g",
	        'Ĥ': "^H",
	        'ĥ': "^h",
	        'Ħ': "H",
	        'ħ': "h",
	        'Ĩ': "~I",
	        'ĩ': "~i",
	        'Ī': "I",
	        'ī': "i",
	        'Ĭ': "I",
	        'ĭ': "i",
	        'Į': "I",
	        'į': "i",
	        'İ': "I",
	        'ı': "i",
	        'Ĳ': "IJ",
	        'ĳ': "ij",
	        'Ĵ': "^J",
	        'ĵ': "^j",
	        'Ķ': "K",
	        'ķ': "k",
	        'Ĺ': "L",
	        'ĺ': "l",
	        'Ļ': "L",
	        'ļ': "l",
	        'Ľ': "L",
	        'ľ': "l",
	        'Ŀ': "L",
	        'ŀ': "l",
	        'Ł': "L",
	        'ł': "l",
	        'Ń': "'N",
	        'ń': "'n",
	        'Ņ': "N",
	        'ņ': "n",
	        'Ň': "N",
	        'ň': "n",
	        'ŉ': "'n",
	        'Ō': "O",
	        'ō': "o",
	        'Ŏ': "O",
	        'ŏ': "o",
	        'Ő': '"O',
	        'ő': '"o',
	        'Œ': "OE",
	        'œ': "oe",
	        'Ŕ': "'R",
	        'ŕ': "'r",
	        'Ŗ': "R",
	        'ŗ': "r",
	        'Ř': "R",
	        'ř': "r",
	        'Ś': "'S",
	        'ś': "'s",
	        'Ŝ': "^S",
	        'ŝ': "^s",
	        'Ş': "S",
	        'ş': "s",
	        'Š': "S",
	        'š': "s",
	        'Ţ': "T",
	        'ţ': "t",
	        'Ť': "T",
	        'ť': "t",
	        'Ŧ': "T",
	        'ŧ': "t",
	        'Ũ': "~U",
	        'ũ': "~u",
	        'Ū': "U",
	        'ū': "u",
	        'Ŭ': "U",
	        'ŭ': "u",
	        'Ů': "U",
	        'ů': "u",
	        'Ű': '"U',
	        'ű': '"u',
	        'Ų': "U",
	        'ų': "u",
	        'Ŵ': "^W",
	        'ŵ': "^w",
	        'Ŷ': "^Y",
	        'ŷ': "^y",
	        'Ÿ': '"Y',
	        'Ź': "'Z",
	        'ź': "'z",
	        'Ż': "Z",
	        'ż': "z",
	        'Ž': "Z",
	        'ž': "z",
	        'ſ': "s"
	    };
	
	    function _slugify(s) {
	        if (!s) return "";
	        var ascii = [];
	        var ch, cp;
	        for (var i = 0; i < s.length; i++) {
	            if ((cp = s.charCodeAt(i)) < 0x180) {
	                ch = String.fromCharCode(cp);
	                ascii.push(charmap[ch] || ch);
	            }
	        }
	        s = ascii.join("");
	        s = s.replace(/[^\w\s-]/g, "").trim().toLowerCase();
	        return s.replace(/[-\s]+/g, "-");
	    }
	
	    mod.factory("Slug", function() {
	        return {
	            slugify: _slugify
	        };
	    });
	
	    mod.directive("slug", ["Slug", function(Slug) {
	        return {
	            restrict: "E",
	            scope: {
	                to: "=",
	            },
	            transclude: true,
	            replace: true,
	            template: "<div ng-transclude></div>",
	            link: function(scope, elem, attrs) {
	                if (!attrs.from) {
	                    throw "must set attribute 'from'";
	                }
	                scope.$parent.$watch(attrs.from, function(val) {
	                    scope.to = Slug.slugify(val);
	                });
	            }
	        };
	    }]);
	
	    mod.filter("slugify", ["Slug", function(Slug) {
	        return function(input) {
	            return Slug.slugify(input);
	        };
	    }]);
	
	    module.exports = mod;
	})();


/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(149) !== null) && (__webpack_require__(150) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ }),
/* 149 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 150 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	  if (true) {
	    // AMD
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node, CommonJS-like
	    module.exports = factory(require('angular'));
	  } else {
	    // Browser globals (root is window)
	    root.returnExports = factory(root.angular);
	  }
	}(this, function(angular) {
	
	  'use strict';
	
	  /**
	   * @ngdoc service
	   * @Loads in google docs for data code
	   * # gdocsLoader
	   */
	  var app = angular.module('angularDatacenterLoader', [])
	    .config(['$httpProvider', function($httpProvider) {
	      $httpProvider.interceptors.push('jsonpInterceptor');
	    }])
	    // use custom callback names for medicare json data
	    // see http://stackoverflow.com/questions/25400891/how-to-custom-set-angularjs-jsonp-callback-name
	    .factory('jsonpInterceptor', ['$window', '$q', '$rootScope',
	      function($window, $q, $rootScope) {
	        return {
	          request: function(config) {
	            if (config.method === 'JSONP') {
	              var callbackId = angular.callbacks.counter.toString(36);
	              config.callbackName = config.callbackName || 'JSON_CALLBACK';
	              config.url = config.url.replace('JSON_CALLBACK', config.callbackName);
	
	              // @TODO - at some point we can send this through an ES6 preprocessor
	              $rootScope.$watch(
	                function() {
	                  return angular.callbacks;
	                },
	                function() {
	                  $window[config.callbackName] =
	                    angular.callbacks['_' + callbackId];
	                }
	              );
	            }
	
	            return config;
	          },
	
	          response: function(response) {
	            var config = response.config;
	            if (config.method === 'JSONP') {
	              delete $window[config.callbackName]; // cleanup
	            }
	
	            return response;
	          },
	
	          responseError: function(rejection) {
	            var config = rejection.config;
	            if (config.method === 'JSONP') {
	              delete $window[config.callbackName]; // cleanup
	            }
	
	            return $q.reject(rejection);
	          }
	        };
	      }
	    ])
	    .service('Loader', ['$http', '$q', '$window', '$location', '$timeout',
	      function gdocsLoader($http, $q, $window, $location, $timeout) {
	        // Returns a single promise to resolver
	        this.get = function() {
	          var q = $q.defer(),
	            _this = this;
	
	          var localDataSource = $location.search().localDataSource || false;
	
	          // Use data object from transient cache, or try hitting middleware directly
	          if (($window.appJs || {}).dsn && ($window.appJs || {}).geo_url) {
	            this.medicareData().then(function(data) {
	              q.resolve(data);
	            });
	          } else if (!($window.appJs || {}).gdocsObject && !localDataSource) {
	            this.spreadsheetData().then(function(data) {
	              q.resolve(data);
	            });
	          } else if (localDataSource) {
	            $http.jsonp('/wp-content/themes/vip/kaiser-foundation-2016/static/js/apps/datacenter/sample_data/' + localDataSource + '?callback=JSON_CALLBACK')
	              .success(function(data) {
	                q.resolve(data);
	              });
	          } else {
	            q.resolve($window.appJs.gdocsObject);
	          }
	
	          return q.promise;
	        };
	
	        this.medicareData = function() {
	          var q = $q.defer();
	
	          // Ugly nested promises because of custom callback wonkery
	          // Also, generated JSON should have proper labels mapped on already
	          $http.jsonp($window.appJs.geo_url + '?callback=JSON_CALLBACK', { callbackName: 'kff_load_medicare_geos' })
	            .then(function(geoDefinitions) {
	              $http.jsonp($window.appJs.dsn + '?callback=JSON_CALLBACK', { callbackName: 'kff_indicator_data' })
	                .then(function(data) {
	                  q.resolve({
	                    data: data.data,
	                    geoDefinitions: geoDefinitions.data
	                  });
	                });
	            });
	
	          return q.promise;
	        };
	        // Pull titles and feed in from spreadsheet
	        this.spreadsheetData = function() {
	          var q = $q.defer();
	
	          fetch(this.URL)
	          .then(function(response) { return response.json(); })
	          .then(function(gdata) {
	            q.resolve(gdata);
	          })
	          .catch(function() {
	            q.reject('Error Retrieving Data');
	          });
	
	          return q.promise;
	        };
	
	      }
	    ]);
	}));


/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var Datamap = __webpack_require__(94);
	
	'use strict';
	angular.module('datamaps', []);
	'use strict';
	angular.module('datamaps').directive('datamap', [
	  '$window',
	  function ($window) {
	    return {
	      restrict: 'EA',
	      scope: {
	        map: '=',
	        plugins: '=?',
	        zoomable: '@?',
	        onClick: '&?',
	        pluginData: '='
	      },
	      link: function (scope, element, attrs) {
	        // Generate base map options
	        function mapOptions() {
	          return {
	            element: element[0],
	            scope: 'usa',
	            height: scope.height,
	            width: scope.width,
	            fills: { defaultFill: '#b9b9b9' },
	            data: {},
	            done: function (datamap) {
	              function redraw() {
	                datamap.svg.selectAll('g').attr('transform', 'translate(' + d3.event.translate + ')scale(' + d3.event.scale + ')');
	              }
	              if (angular.isDefined(attrs.onClick)) {
	                datamap.svg.selectAll('.datamaps-subunit').on('click', function (geography) {
	                  scope.onClick()(geography);
	                });
	              }
	              if (angular.isDefined(attrs.zoomable)) {
	                datamap.svg.call(d3.behavior.zoom().on('zoom', redraw));
	              }
	            }
	          };
	        }
	        scope.api = {
	          refresh: function (map) {
	            scope.api.updateWithOptions(map);
	          },
	          updateWithOptions: function (map) {
	            // Clearing
	            scope.api.clearElement();
	            // Update bounding box
	            scope.width = (map.options || {}).width || null;
	            scope.height = (map.options || {}).height || (scope.width ? scope.width * 0.5 : null);
	            scope.legendHeight = (map.options || {}).legendHeight || 50;
	            // Set a few defaults for the directive
	            scope.mapOptions = mapOptions();
	            // Add the good stuff
	            scope.mapOptions = angular.extend(scope.mapOptions, map);
	            scope.datamap = new Datamap(scope.mapOptions);
	            // Add responsive listeners
	            if (scope.mapOptions.responsive) {
	              $window.addEventListener('resize', scope.api.resize);
	            } else {
	              $window.removeEventListener('resize', scope.api.resize);
	            }
	            // Update plugins
	            scope.api.updatePlugins(scope.datamap);
	            // Update options and choropleth
	            scope.api.refreshOptions(map.options);
	            scope.api.updateWithData(map.data);
	          },
	          updatePlugins: function (datamap) {
	            if (!scope.plugins) {
	              return;
	            }
	            var pluginData = scope.pluginData || {};
	            angular.forEach(scope.plugins, function (plugin, name) {
	              datamap.addPlugin(name, plugin);
	              datamap[name](pluginData[name]);
	            });
	          },
	          refreshOptions: function (options) {
	            if (!options) {
	              return;
	            }
	            // set labels
	            if (options.labels) {
	              scope.datamap.labels({
	                labelColor: options.labelColor ? options.labelColor : '#333333',
	                fontSize: options.labelSize ? options.labelSize : 12
	              });
	            }
	            // set legend
	            if (options.legend) {
	              scope.datamap.legend();
	            }
	          },
	          resize: function () {
	            scope.datamap.resize();
	          },
	          updateWithData: function (data) {
	            scope.datamap.updateChoropleth(data);
	            scope.api.updatePlugins(scope.datamap);
	          },
	          clearElement: function () {
	            scope.datamap = null;
	            element.empty().css({
	              'position': 'relative',
	              'display': 'block',
	              'padding-bottom': scope.legendHeight + 'px'
	            });
	          }
	        };
	        // Watch data changing
	        scope.$watch('map', function (map, old) {
	          // Return if no data
	          if (!map || angular.equals({}, map)) {
	            return;
	          }
	          // Allow animated transition when geos don't change
	          // or fully refresh
	          if (!scope.datamap || angular.equals(map.data, old.data)) {
	            scope.api.refresh(map);
	          } else if ((map.options || {}).staticGeoData) {
	            scope.api.updateWithData(map.data);
	          } else {
	            scope.api.refresh(map);
	          }
	        }, true);
	        //update the plugins if the pluginData has changed
	        scope.$watch('pluginData', function () {
	          scope.api.updatePlugins(scope.datamap);
	        }, true);
	      }
	    };
	  }
	]);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var nv = __webpack_require__(158);
	var d3 = __webpack_require__(77);
	
	!function(window){"use strict";var nv=window.nv;"undefined"!=typeof exports&&(nv=__webpack_require__(158)),angular.module("nvd3",[]).directive("nvd3",["nvd3Utils",function(nvd3Utils){return{restrict:"AE",scope:{data:"=",options:"=",api:"=?",events:"=?",config:"=?",onReady:"&?"},link:function(scope,element,attrs){function configure(chart,options,chartType){chart&&options&&angular.forEach(chart,function(value,key){"_"===key[0]||("dispatch"===key?(void 0!==options[key]&&null!==options[key]||scope._config.extended&&(options[key]={}),configureEvents(value,options[key])):"tooltip"===key?(void 0!==options[key]&&null!==options[key]||scope._config.extended&&(options[key]={}),configure(chart[key],options[key],chartType)):"contentGenerator"===key?options[key]&&chart[key](options[key]):-1===["axis","clearHighlights","defined","highlightPoint","nvPointerEventsClass","options","rangeBand","rangeBands","scatter","open","close","node"].indexOf(key)&&(void 0===options[key]||null===options[key]?scope._config.extended&&(options[key]=value()):chart[key](options[key])))})}function configureEvents(dispatch,options){dispatch&&options&&angular.forEach(dispatch,function(value,key){void 0===options[key]||null===options[key]?scope._config.extended&&(options[key]=value.on):dispatch.on(key+"._",options[key])})}function configureWrapper(name){var _=nvd3Utils.deepExtend(defaultWrapper(name),scope.options[name]||{});scope._config.extended&&(scope.options[name]=_);var wrapElement=angular.element("<div></div>").html(_.html||"").addClass(name).addClass(_.className).removeAttr("style").css(_.css);_.html||wrapElement.text(_.text),_.enable&&("title"===name?element.prepend(wrapElement):"subtitle"===name?angular.element(element[0].querySelector(".title")).after(wrapElement):"caption"===name&&element.append(wrapElement))}function configureStyles(){var _=nvd3Utils.deepExtend(defaultStyles(),scope.options.styles||{});scope._config.extended&&(scope.options.styles=_),angular.forEach(_.classes,function(value,key){value?element.addClass(key):element.removeClass(key)}),element.removeAttr("style").css(_.css)}function defaultWrapper(_){switch(_){case"title":return{enable:!1,text:"Write Your Title",className:"h4",css:{width:scope.options.chart.width+"px",textAlign:"center"}};case"subtitle":return{enable:!1,text:"Write Your Subtitle",css:{width:scope.options.chart.width+"px",textAlign:"center"}};case"caption":return{enable:!1,text:"Figure 1. Write Your Caption text.",css:{width:scope.options.chart.width+"px",textAlign:"center"}}}}function defaultStyles(){return{classes:{"with-3d-shadow":!0,"with-transitions":!0,gallery:!1},css:{}}}function dataWatchFn(newData,oldData){newData!==oldData&&(scope._config.disabled||(scope._config.refreshDataOnly?scope.api.update():scope.api.refresh()))}var defaultConfig={extended:!1,visible:!0,disabled:!1,refreshDataOnly:!0,deepWatchOptions:!0,deepWatchData:!0,deepWatchDataDepth:2,debounce:10,debounceImmediate:!0};scope.isReady=!1,scope._config=angular.extend(defaultConfig,scope.config),scope.api={refresh:function(){scope.api.updateWithOptions(),scope.isReady=!0},refreshWithTimeout:function(t){setTimeout(function(){scope.api.refresh()},t)},update:function(){scope.chart&&scope.svg?"sunburstChart"===scope.options.chart.type?scope.svg.datum(angular.copy(scope.data)).call(scope.chart):scope.svg.datum(scope.data).call(scope.chart):scope.api.refresh()},updateWithTimeout:function(t){setTimeout(function(){scope.api.update()},t)},updateWithOptions:function(options){if(arguments.length){if(scope.options=options,scope._config.deepWatchOptions&&!scope._config.disabled)return}else options=scope.options;scope.api.clearElement(),angular.isDefined(options)!==!1&&scope._config.visible&&(scope.chart=nv.models[options.chart.type](),scope.chart.id=Math.random().toString(36).substr(2,15),angular.forEach(scope.chart,function(value,key){"_"===key[0]||["clearHighlights","highlightPoint","id","options","resizeHandler","state","open","close","tooltipContent"].indexOf(key)>=0||("dispatch"===key?(void 0!==options.chart[key]&&null!==options.chart[key]||scope._config.extended&&(options.chart[key]={}),configureEvents(scope.chart[key],options.chart[key])):["bars","bars1","bars2","boxplot","bullet","controls","discretebar","distX","distY","focus","interactiveLayer","legend","lines","lines1","lines2","multibar","pie","scatter","scatters1","scatters2","sparkline","stack1","stack2","sunburst","tooltip","x2Axis","xAxis","y1Axis","y2Axis","y3Axis","y4Axis","yAxis","yAxis1","yAxis2"].indexOf(key)>=0||"stacked"===key&&"stackedAreaChart"===options.chart.type?(void 0!==options.chart[key]&&null!==options.chart[key]||scope._config.extended&&(options.chart[key]={}),configure(scope.chart[key],options.chart[key],options.chart.type)):"focusHeight"===key&&"lineChart"===options.chart.type||"focusHeight"===key&&"lineWithFocusChart"===options.chart.type||("xTickFormat"!==key&&"yTickFormat"!==key||"lineWithFocusChart"!==options.chart.type)&&("tooltips"===key&&"boxPlotChart"===options.chart.type||("tooltipXContent"!==key&&"tooltipYContent"!==key||"scatterChart"!==options.chart.type)&&("x"!==key&&"y"!==key||"forceDirectedGraph"!==options.chart.type)&&(void 0===options.chart[key]||null===options.chart[key]?scope._config.extended&&("barColor"===key?options.chart[key]=value()():options.chart[key]=value()):scope.chart[key](options.chart[key]))))}),scope.api.updateWithData(),(options.title||scope._config.extended)&&configureWrapper("title"),(options.subtitle||scope._config.extended)&&configureWrapper("subtitle"),(options.caption||scope._config.extended)&&configureWrapper("caption"),(options.styles||scope._config.extended)&&configureStyles(),nv.addGraph(function(){return scope.chart?(scope.chart.resizeHandler&&scope.chart.resizeHandler.clear(),scope.chart.resizeHandler=nv.utils.windowResize(function(){scope.chart&&scope.chart.update&&scope.chart.update()}),void 0!==options.chart.zoom&&["scatterChart","lineChart","candlestickBarChart","cumulativeLineChart","historicalBarChart","ohlcBarChart","stackedAreaChart"].indexOf(options.chart.type)>-1&&nvd3Utils.zoom(scope,options),scope.chart):void 0},options.chart.callback))},updateWithData:function(data){if(arguments.length){if(scope.data=data,scope._config.deepWatchData&&!scope._config.disabled)return}else data="sunburstChart"===scope.options.chart.type?angular.copy(scope.data):scope.data;if(data){d3.select(element[0]).select("svg").remove();var h,w;scope.svg=d3.select(element[0]).insert("svg",".caption"),(h=scope.options.chart.height)&&(isNaN(+h)||(h+="px"),scope.svg.attr("height",h).style({height:h})),(w=scope.options.chart.width)?(isNaN(+w)||(w+="px"),scope.svg.attr("width",w).style({width:w})):scope.svg.attr("width","100%").style({width:"100%"}),scope.svg.datum(data).call(scope.chart),scope.chart&&scope.chart.zoomRender&&scope.chart.zoomRender()}},clearElement:function(){if(element.find(".title").remove(),element.find(".subtitle").remove(),element.find(".caption").remove(),element.empty(),scope.chart&&scope.chart.tooltip&&scope.chart.tooltip.id&&d3.select("#"+scope.chart.tooltip.id()).remove(),nv.graphs&&scope.chart)for(var i=nv.graphs.length-1;i>=0;i--)nv.graphs[i]&&nv.graphs[i].id===scope.chart.id&&nv.graphs.splice(i,1);nv.tooltip&&nv.tooltip.cleanup&&nv.tooltip.cleanup(),scope.chart&&scope.chart.resizeHandler&&scope.chart.resizeHandler.clear(),scope.chart=null},getScope:function(){return scope},getElement:function(){return element}},scope._config.deepWatchOptions&&scope.$watch("options",nvd3Utils.debounce(function(newOptions){scope._config.disabled||scope.api.refresh()},scope._config.debounce,scope._config.debounceImmediate),!0),scope._config.deepWatchData&&(1===scope._config.deepWatchDataDepth?scope.$watchCollection("data",dataWatchFn):scope.$watch("data",dataWatchFn,2===scope._config.deepWatchDataDepth)),scope.$watch("config",function(newConfig,oldConfig){newConfig!==oldConfig&&(scope._config=angular.extend(defaultConfig,newConfig),scope.api.refresh())},!0),scope._config.deepWatchOptions||scope._config.deepWatchData||scope.api.refresh(),angular.forEach(scope.events,function(eventHandler,event){scope.$on(event,function(e,args){return eventHandler(e,scope,args)})}),element.on("$destroy",function(){scope.api.clearElement()}),scope.$watch("isReady",function(isReady){isReady&&scope.onReady&&"function"==typeof scope.onReady()&&scope.onReady()(scope,element)})}}}]).factory("nvd3Utils",function(){return{debounce:function(func,wait,immediate){var timeout;return function(){var context=this,args=arguments,later=function(){timeout=null,immediate||func.apply(context,args)},callNow=immediate&&!timeout;clearTimeout(timeout),timeout=setTimeout(later,wait),callNow&&func.apply(context,args)}},deepExtend:function(dst){var me=this;return angular.forEach(arguments,function(obj){obj!==dst&&angular.forEach(obj,function(value,key){dst[key]&&dst[key].constructor&&dst[key].constructor===Object?me.deepExtend(dst[key],value):dst[key]=value})}),dst},zoom:function(scope,options){var zoom=options.chart.zoom,enabled="undefined"==typeof zoom.enabled||null===zoom.enabled?!0:zoom.enabled;if(enabled){var fixDomain,d3zoom,zoomed,unzoomed,zoomend,xScale=scope.chart.xAxis.scale(),yScale=scope.chart.yAxis.scale(),xDomain=scope.chart.xDomain||xScale.domain,yDomain=scope.chart.yDomain||yScale.domain,x_boundary=xScale.domain().slice(),y_boundary=yScale.domain().slice(),scale=zoom.scale||1,translate=zoom.translate||[0,0],scaleExtent=zoom.scaleExtent||[1,10],useFixedDomain=zoom.useFixedDomain||!1,useNiceScale=zoom.useNiceScale||!1,horizontalOff=zoom.horizontalOff||!1,verticalOff=zoom.verticalOff||!1,unzoomEventType=zoom.unzoomEventType||"dblclick.zoom";useNiceScale&&(xScale.nice(),yScale.nice()),fixDomain=function(domain,boundary){return domain[0]=Math.min(Math.max(domain[0],boundary[0]),boundary[1]-boundary[1]/scaleExtent[1]),domain[1]=Math.max(boundary[0]+boundary[1]/scaleExtent[1],Math.min(domain[1],boundary[1])),domain},zoomed=function(){if(void 0!==zoom.zoomed){var domains=zoom.zoomed(xScale.domain(),yScale.domain());horizontalOff||xDomain([domains.x1,domains.x2]),verticalOff||yDomain([domains.y1,domains.y2])}else horizontalOff||xDomain(useFixedDomain?fixDomain(xScale.domain(),x_boundary):xScale.domain()),verticalOff||yDomain(useFixedDomain?fixDomain(yScale.domain(),y_boundary):yScale.domain());scope.chart&&scope.chart.update()},unzoomed=function(){if(void 0!==zoom.unzoomed){var domains=zoom.unzoomed(xScale.domain(),yScale.domain());horizontalOff||xDomain([domains.x1,domains.x2]),verticalOff||yDomain([domains.y1,domains.y2])}else horizontalOff||xDomain(x_boundary),verticalOff||yDomain(y_boundary);d3zoom.scale(scale).translate(translate),scope.chart&&scope.chart.update()},zoomend=function(){void 0!==zoom.zoomend&&zoom.zoomend()},d3zoom=d3.behavior.zoom().x(xScale).y(yScale).scaleExtent(scaleExtent).on("zoom",zoomed).on("zoomend",zoomend),scope.svg&&(scope.svg.call(d3zoom),d3zoom.scale(scale).translate(translate).event(scope.svg),"none"!==unzoomEventType&&scope.svg.on(unzoomEventType,unzoomed)),scope.chart&&(scope.chart.zoomRender=function(){d3zoom.scale(scale).translate(translate),xScale=scope.chart.xAxis.scale(),yScale=scope.chart.yAxis.scale(),xDomain=scope.chart.xDomain||xScale.domain,yDomain=scope.chart.yDomain||yScale.domain,x_boundary=xScale.domain().slice(),y_boundary=yScale.domain().slice(),d3zoom.x(xScale).y(yScale),scope.svg.call(d3zoom),"none"!==unzoomEventType&&scope.svg.on(unzoomEventType,unzoomed)})}}}})}(window);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var d3 = __webpack_require__(77);
	
	/* nvd3 version 1.8.6 (https://github.com/novus/nvd3) 2017-08-23 */
	(function(){
	
	// set up main nv object
	var nv = {};
	
	// the major global objects under the nv namespace
	nv.dev = false; //set false when in production
	nv.tooltip = nv.tooltip || {}; // For the tooltip system
	nv.utils = nv.utils || {}; // Utility subsystem
	nv.models = nv.models || {}; //stores all the possible models/components
	nv.charts = {}; //stores all the ready to use charts
	nv.logs = {}; //stores some statistics and potential error messages
	nv.dom = {}; //DOM manipulation functions
	
	// Node/CommonJS - require D3
	if (typeof(module) !== 'undefined' && typeof(exports) !== 'undefined' && typeof(d3) == 'undefined') {
	    d3 = __webpack_require__(77);
	}
	
	nv.dispatch = d3.dispatch('render_start', 'render_end');
	
	// Function bind polyfill
	// Needed ONLY for phantomJS as it's missing until version 2.0 which is unreleased as of this comment
	// https://github.com/ariya/phantomjs/issues/10522
	// http://kangax.github.io/compat-table/es5/#Function.prototype.bind
	// phantomJS is used for running the test suite
	if (!Function.prototype.bind) {
	    Function.prototype.bind = function (oThis) {
	        if (typeof this !== "function") {
	            // closest thing possible to the ECMAScript 5 internal IsCallable function
	            throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
	        }
	
	        var aArgs = Array.prototype.slice.call(arguments, 1),
	            fToBind = this,
	            fNOP = function () {},
	            fBound = function () {
	                return fToBind.apply(this instanceof fNOP && oThis
	                        ? this
	                        : oThis,
	                    aArgs.concat(Array.prototype.slice.call(arguments)));
	            };
	
	        fNOP.prototype = this.prototype;
	        fBound.prototype = new fNOP();
	        return fBound;
	    };
	}
	
	//  Development render timers - disabled if dev = false
	if (nv.dev) {
	    nv.dispatch.on('render_start', function(e) {
	        nv.logs.startTime = +new Date();
	    });
	
	    nv.dispatch.on('render_end', function(e) {
	        nv.logs.endTime = +new Date();
	        nv.logs.totalTime = nv.logs.endTime - nv.logs.startTime;
	        nv.log('total', nv.logs.totalTime); // used for development, to keep track of graph generation times
	    });
	}
	
	// Logs all arguments, and returns the last so you can test things in place
	// Note: in IE8 console.log is an object not a function, and if modernizr is used
	// then calling Function.prototype.bind with with anything other than a function
	// causes a TypeError to be thrown.
	nv.log = function() {
	    if (nv.dev && window.console && console.log && console.log.apply)
	        console.log.apply(console, arguments);
	    else if (nv.dev && window.console && typeof console.log == "function" && Function.prototype.bind) {
	        var log = Function.prototype.bind.call(console.log, console);
	        log.apply(console, arguments);
	    }
	    return arguments[arguments.length - 1];
	};
	
	// print console warning, should be used by deprecated functions
	nv.deprecated = function(name, info) {
	    if (console && console.warn) {
	        console.warn('nvd3 warning: `' + name + '` has been deprecated. ', info || '');
	    }
	};
	
	// The nv.render function is used to queue up chart rendering
	// in non-blocking async functions.
	// When all queued charts are done rendering, nv.dispatch.render_end is invoked.
	nv.render = function render(step) {
	    // number of graphs to generate in each timeout loop
	    step = step || 1;
	
	    nv.render.active = true;
	    nv.dispatch.render_start();
	
	    var renderLoop = function() {
	        var chart, graph;
	
	        for (var i = 0; i < step && (graph = nv.render.queue[i]); i++) {
	            chart = graph.generate();
	            if (typeof graph.callback == typeof(Function)) graph.callback(chart);
	        }
	
	        nv.render.queue.splice(0, i);
	
	        if (nv.render.queue.length) {
	            setTimeout(renderLoop);
	        }
	        else {
	            nv.dispatch.render_end();
	            nv.render.active = false;
	        }
	    };
	
	    setTimeout(renderLoop);
	};
	
	nv.render.active = false;
	nv.render.queue = [];
	
	/*
	Adds a chart to the async rendering queue. This method can take arguments in two forms:
	nv.addGraph({
	    generate: <Function>
	    callback: <Function>
	})
	
	or
	
	nv.addGraph(<generate Function>, <callback Function>)
	
	The generate function should contain code that creates the NVD3 model, sets options
	on it, adds data to an SVG element, and invokes the chart model. The generate function
	should return the chart model.  See examples/lineChart.html for a usage example.
	
	The callback function is optional, and it is called when the generate function completes.
	*/
	nv.addGraph = function(obj) {
	    if (typeof arguments[0] === typeof(Function)) {
	        obj = {generate: arguments[0], callback: arguments[1]};
	    }
	
	    nv.render.queue.push(obj);
	
	    if (!nv.render.active) {
	        nv.render();
	    }
	};
	
	// Node/CommonJS exports
	if (true) {
	  module.exports = nv;
	}
	
	if (typeof(window) !== 'undefined') {
	  window.nv = nv;
	}
	/* Facade for queueing DOM write operations
	 * with Fastdom (https://github.com/wilsonpage/fastdom)
	 * if available.
	 * This could easily be extended to support alternate
	 * implementations in the future.
	 */
	nv.dom.write = function(callback) {
		if (window.fastdom !== undefined) {
			return fastdom.mutate(callback);
		}
		return callback();
	};
	
	/* Facade for queueing DOM read operations
	 * with Fastdom (https://github.com/wilsonpage/fastdom)
	 * if available.
	 * This could easily be extended to support alternate
	 * implementations in the future.
	 */
	nv.dom.read = function(callback) {
		if (window.fastdom !== undefined) {
			return fastdom.measure(callback);
		}
		return callback();
	};
	/* Utility class to handle creation of an interactive layer.
	 This places a rectangle on top of the chart. When you mouse move over it, it sends a dispatch
	 containing the X-coordinate. It can also render a vertical line where the mouse is located.
	
	 dispatch.elementMousemove is the important event to latch onto.  It is fired whenever the mouse moves over
	 the rectangle. The dispatch is given one object which contains the mouseX/Y location.
	 It also has 'pointXValue', which is the conversion of mouseX to the x-axis scale.
	 */
	nv.interactiveGuideline = function() {
	    "use strict";
	
	    var margin = { left: 0, top: 0 } //Pass the chart's top and left magins. Used to calculate the mouseX/Y.
	        ,   width = null
	        ,   height = null
	        ,   xScale = d3.scale.linear()
	        ,   dispatch = d3.dispatch('elementMousemove', 'elementMouseout', 'elementClick', 'elementDblclick', 'elementMouseDown', 'elementMouseUp')
	        ,   showGuideLine = true
	        ,   svgContainer = null // Must pass the chart's svg, we'll use its mousemove event.
	        ,   tooltip = nv.models.tooltip()
	        ,   isMSIE =  window.ActiveXObject// Checkt if IE by looking for activeX. (excludes IE11)
	    ;
	
	    tooltip
	        .duration(0)
	        .hideDelay(0)
	        .hidden(false);
	
	    function layer(selection) {
	        selection.each(function(data) {
	            var container = d3.select(this);
	            var availableWidth = (width || 960), availableHeight = (height || 400);
	            var wrap = container.selectAll("g.nv-wrap.nv-interactiveLineLayer")
	                .data([data]);
	            var wrapEnter = wrap.enter()
	                .append("g").attr("class", " nv-wrap nv-interactiveLineLayer");
	            wrapEnter.append("g").attr("class","nv-interactiveGuideLine");
	
	            if (!svgContainer) {
	                return;
	            }
	
	            function mouseHandler() {
	                var mouseX = d3.event.clientX - this.getBoundingClientRect().left;
	                var mouseY = d3.event.clientY - this.getBoundingClientRect().top;
	
	                var subtractMargin = true;
	                var mouseOutAnyReason = false;
	                if (isMSIE) {
	                    /*
	                     D3.js (or maybe SVG.getScreenCTM) has a nasty bug in Internet Explorer 10.
	                     d3.mouse() returns incorrect X,Y mouse coordinates when mouse moving
	                     over a rect in IE 10.
	                     However, d3.event.offsetX/Y also returns the mouse coordinates
	                     relative to the triggering <rect>. So we use offsetX/Y on IE.
	                     */
	                    mouseX = d3.event.offsetX;
	                    mouseY = d3.event.offsetY;
	
	                    /*
	                     On IE, if you attach a mouse event listener to the <svg> container,
	                     it will actually trigger it for all the child elements (like <path>, <circle>, etc).
	                     When this happens on IE, the offsetX/Y is set to where ever the child element
	                     is located.
	                     As a result, we do NOT need to subtract margins to figure out the mouse X/Y
	                     position under this scenario. Removing the line below *will* cause
	                     the interactive layer to not work right on IE.
	                     */
	                    if(d3.event.target.tagName !== "svg") {
	                        subtractMargin = false;
	                    }
	
	                    if (d3.event.target.className.baseVal.match("nv-legend")) {
	                        mouseOutAnyReason = true;
	                    }
	
	                }
	
	                if(subtractMargin) {
	                    mouseX -= margin.left;
	                    mouseY -= margin.top;
	                }
	
	                /* If mouseX/Y is outside of the chart's bounds,
	                 trigger a mouseOut event.
	                 */
	                if (d3.event.type === 'mouseout'
	                    || mouseX < 0 || mouseY < 0
	                    || mouseX > availableWidth || mouseY > availableHeight
	                    || (d3.event.relatedTarget && d3.event.relatedTarget.ownerSVGElement === undefined)
	                    || mouseOutAnyReason
	                    ) {
	
	                    if (isMSIE) {
	                        if (d3.event.relatedTarget
	                            && d3.event.relatedTarget.ownerSVGElement === undefined
	                            && (d3.event.relatedTarget.className === undefined
	                                || d3.event.relatedTarget.className.match(tooltip.nvPointerEventsClass))) {
	
	                            return;
	                        }
	                    }
	                    dispatch.elementMouseout({
	                        mouseX: mouseX,
	                        mouseY: mouseY
	                    });
	                    layer.renderGuideLine(null); //hide the guideline
	                    tooltip.hidden(true);
	                    return;
	                } else {
	                    tooltip.hidden(false);
	                }
	
	
	                var scaleIsOrdinal = typeof xScale.rangeBands === 'function';
	                var pointXValue = undefined;
	
	                // Ordinal scale has no invert method
	                if (scaleIsOrdinal) {
	                    var elementIndex = d3.bisect(xScale.range(), mouseX) - 1;
	                    // Check if mouseX is in the range band
	                    if (xScale.range()[elementIndex] + xScale.rangeBand() >= mouseX) {
	                        pointXValue = xScale.domain()[d3.bisect(xScale.range(), mouseX) - 1];
	                    }
	                    else {
	                        dispatch.elementMouseout({
	                            mouseX: mouseX,
	                            mouseY: mouseY
	                        });
	                        layer.renderGuideLine(null); //hide the guideline
	                        tooltip.hidden(true);
	                        return;
	                    }
	                }
	                else {
	                    pointXValue = xScale.invert(mouseX);
	                }
	
	                dispatch.elementMousemove({
	                    mouseX: mouseX,
	                    mouseY: mouseY,
	                    pointXValue: pointXValue
	                });
	
	                //If user double clicks the layer, fire a elementDblclick
	                if (d3.event.type === "dblclick") {
	                    dispatch.elementDblclick({
	                        mouseX: mouseX,
	                        mouseY: mouseY,
	                        pointXValue: pointXValue
	                    });
	                }
	
	                // if user single clicks the layer, fire elementClick
	                if (d3.event.type === 'click') {
	                    dispatch.elementClick({
	                        mouseX: mouseX,
	                        mouseY: mouseY,
	                        pointXValue: pointXValue
	                    });
	                }
	
	                // if user presses mouse down the layer, fire elementMouseDown
	                if (d3.event.type === 'mousedown') {
	                	dispatch.elementMouseDown({
	                		mouseX: mouseX,
	                		mouseY: mouseY,
	                		pointXValue: pointXValue
	                	});
	                }
	
	                // if user presses mouse down the layer, fire elementMouseUp
	                if (d3.event.type === 'mouseup') {
	                	dispatch.elementMouseUp({
	                		mouseX: mouseX,
	                		mouseY: mouseY,
	                		pointXValue: pointXValue
	                	});
	                }
	            }
	
	            svgContainer
	                .on("touchmove",mouseHandler)
	                .on("mousemove",mouseHandler, true)
	                .on("mouseout" ,mouseHandler,true)
	                .on("mousedown" ,mouseHandler,true)
	                .on("mouseup" ,mouseHandler,true)
	                .on("dblclick" ,mouseHandler)
	                .on("click", mouseHandler)
	            ;
	
	            layer.guideLine = null;
	            //Draws a vertical guideline at the given X postion.
	            layer.renderGuideLine = function(x) {
	                if (!showGuideLine) return;
	                if (layer.guideLine && layer.guideLine.attr("x1") === x) return;
	                nv.dom.write(function() {
	                    var line = wrap.select(".nv-interactiveGuideLine")
	                        .selectAll("line")
	                        .data((x != null) ? [nv.utils.NaNtoZero(x)] : [], String);
	                    line.enter()
	                        .append("line")
	                        .attr("class", "nv-guideline")
	                        .attr("x1", function(d) { return d;})
	                        .attr("x2", function(d) { return d;})
	                        .attr("y1", availableHeight)
	                        .attr("y2",0);
	                    line.exit().remove();
	                });
	            }
	        });
	    }
	
	    layer.dispatch = dispatch;
	    layer.tooltip = tooltip;
	
	    layer.margin = function(_) {
	        if (!arguments.length) return margin;
	        margin.top    = typeof _.top    != 'undefined' ? _.top    : margin.top;
	        margin.left   = typeof _.left   != 'undefined' ? _.left   : margin.left;
	        return layer;
	    };
	
	    layer.width = function(_) {
	        if (!arguments.length) return width;
	        width = _;
	        return layer;
	    };
	
	    layer.height = function(_) {
	        if (!arguments.length) return height;
	        height = _;
	        return layer;
	    };
	
	    layer.xScale = function(_) {
	        if (!arguments.length) return xScale;
	        xScale = _;
	        return layer;
	    };
	
	    layer.showGuideLine = function(_) {
	        if (!arguments.length) return showGuideLine;
	        showGuideLine = _;
	        return layer;
	    };
	
	    layer.svgContainer = function(_) {
	        if (!arguments.length) return svgContainer;
	        svgContainer = _;
	        return layer;
	    };
	
	    return layer;
	};
	
	/* Utility class that uses d3.bisect to find the index in a given array, where a search value can be inserted.
	 This is different from normal bisectLeft; this function finds the nearest index to insert the search value.
	
	 For instance, lets say your array is [1,2,3,5,10,30], and you search for 28.
	 Normal d3.bisectLeft will return 4, because 28 is inserted after the number 10.  But interactiveBisect will return 5
	 because 28 is closer to 30 than 10.
	
	 Unit tests can be found in: interactiveBisectTest.html
	
	 Has the following known issues:
	 * Will not work if the data points move backwards (ie, 10,9,8,7, etc) or if the data points are in random order.
	 * Won't work if there are duplicate x coordinate values.
	 */
	nv.interactiveBisect = function (values, searchVal, xAccessor) {
	    "use strict";
	    if (! (values instanceof Array)) {
	        return null;
	    }
	    var _xAccessor;
	    if (typeof xAccessor !== 'function') {
	        _xAccessor = function(d) {
	            return d.x;
	        }
	    } else {
	        _xAccessor = xAccessor;
	    }
	    var _cmp = function(d, v) {
	        // Accessors are no longer passed the index of the element along with
	        // the element itself when invoked by d3.bisector.
	        //
	        // Starting at D3 v3.4.4, d3.bisector() started inspecting the
	        // function passed to determine if it should consider it an accessor
	        // or a comparator. This meant that accessors that take two arguments
	        // (expecting an index as the second parameter) are treated as
	        // comparators where the second argument is the search value against
	        // which the first argument is compared.
	        return _xAccessor(d) - v;
	    };
	
	    var bisect = d3.bisector(_cmp).left;
	    var index = d3.max([0, bisect(values,searchVal) - 1]);
	    var currentValue = _xAccessor(values[index]);
	
	    if (typeof currentValue === 'undefined') {
	        currentValue = index;
	    }
	
	    if (currentValue === searchVal) {
	        return index; //found exact match
	    }
	
	    var nextIndex = d3.min([index+1, values.length - 1]);
	    var nextValue = _xAccessor(values[nextIndex]);
	
	    if (typeof nextValue === 'undefined') {
	        nextValue = nextIndex;
	    }
	
	    if (Math.abs(nextValue - searchVal) >= Math.abs(currentValue - searchVal)) {
	        return index;
	    } else {
	        return nextIndex
	    }
	};
	
	/*
	 Returns the index in the array "values" that is closest to searchVal.
	 Only returns an index if searchVal is within some "threshold".
	 Otherwise, returns null.
	 */
	nv.nearestValueIndex = function (values, searchVal, threshold) {
	    "use strict";
	    var yDistMax = Infinity, indexToHighlight = null;
	    values.forEach(function(d,i) {
	        var delta = Math.abs(searchVal - d);
	        if ( d != null && delta <= yDistMax && delta < threshold) {
	            yDistMax = delta;
	            indexToHighlight = i;
	        }
	    });
	    return indexToHighlight;
	};
	
	/* Model which can be instantiated to handle tooltip rendering.
	 Example usage:
	 var tip = nv.models.tooltip().gravity('w').distance(23)
	 .data(myDataObject);
	
	 tip();    //just invoke the returned function to render tooltip.
	 */
	nv.models.tooltip = function() {
	    "use strict";
	
	    /*
	    Tooltip data. If data is given in the proper format, a consistent tooltip is generated.
	    Example Format of data:
	    {
	        key: "Date",
	        value: "August 2009",
	        series: [
	            {key: "Series 1", value: "Value 1", color: "#000"},
	            {key: "Series 2", value: "Value 2", color: "#00f"}
	        ]
	    }
	    */
	    var id = "nvtooltip-" + Math.floor(Math.random() * 100000) // Generates a unique id when you create a new tooltip() object.
	        ,   data = null
	        ,   gravity = 'w'   // Can be 'n','s','e','w'. Determines how tooltip is positioned.
	        ,   distance = 25 // Distance to offset tooltip from the mouse location.
	        ,   snapDistance = 0   // Tolerance allowed before tooltip is moved from its current position (creates 'snapping' effect)
	        ,   classes = null  // Attaches additional CSS classes to the tooltip DIV that is created.
	        ,   hidden = true  // Start off hidden, toggle with hide/show functions below.
	        ,   hideDelay = 200  // Delay (in ms) before the tooltip hides after calling hide().
	        ,   tooltip = null // d3 select of the tooltip div.
	        ,   lastPosition = { left: null, top: null } // Last position the tooltip was in.
	        ,   enabled = true  // True -> tooltips are rendered. False -> don't render tooltips.
	        ,   duration = 100 // Tooltip movement duration, in ms.
	        ,   headerEnabled = true // If is to show the tooltip header.
	        ,   nvPointerEventsClass = "nv-pointer-events-none" // CSS class to specify whether element should not have mouse events.
	    ;
	
	    // Format function for the tooltip values column.
	    // d is value,
	    // i is series index
	    // p is point containing the value
	    var valueFormatter = function(d, i, p) {
	        return d;
	    };
	
	    // Format function for the tooltip header value.
	    var headerFormatter = function(d) {
	        return d;
	    };
	
	    var keyFormatter = function(d, i) {
	        return d;
	    };
	
	    // By default, the tooltip model renders a beautiful table inside a DIV, returned as HTML
	    // You can override this function if a custom tooltip is desired. For instance, you could directly manipulate
	    // the DOM by accessing elem and returning false.
	    var contentGenerator = function(d, elem) {
	        if (d === null) {
	            return '';
	        }
	
	        var table = d3.select(document.createElement("table"));
	        if (headerEnabled) {
	            var theadEnter = table.selectAll("thead")
	                .data([d])
	                .enter().append("thead");
	
	            theadEnter.append("tr")
	                .append("td")
	                .attr("colspan", 3)
	                .append("strong")
	                .classed("x-value", true)
	                .html(headerFormatter(d.value));
	        }
	
	        var tbodyEnter = table.selectAll("tbody")
	            .data([d])
	            .enter().append("tbody");
	
	        var trowEnter = tbodyEnter.selectAll("tr")
	                .data(function(p) { return p.series})
	                .enter()
	                .append("tr")
	                .classed("highlight", function(p) { return p.highlight});
	
	        trowEnter.append("td")
	            .classed("legend-color-guide",true)
	            .append("div")
	            .style("background-color", function(p) { return p.color});
	
	        trowEnter.append("td")
	            .classed("key",true)
	            .classed("total",function(p) { return !!p.total})
	            .html(function(p, i) { return keyFormatter(p.key, i)});
	
	        trowEnter.append("td")
	            .classed("value",true)
	            .html(function(p, i) { return valueFormatter(p.value, i, p) });
	
	        trowEnter.filter(function (p,i) { return p.percent !== undefined }).append("td")
	            .classed("percent", true)
	            .html(function(p, i) { return "(" + d3.format('%')(p.percent) + ")" });
	
	        trowEnter.selectAll("td").each(function(p) {
	            if (p.highlight) {
	                var opacityScale = d3.scale.linear().domain([0,1]).range(["#fff",p.color]);
	                var opacity = 0.6;
	                d3.select(this)
	                    .style("border-bottom-color", opacityScale(opacity))
	                    .style("border-top-color", opacityScale(opacity))
	                ;
	            }
	        });
	
	        var html = table.node().outerHTML;
	        if (d.footer !== undefined)
	            html += "<div class='footer'>" + d.footer + "</div>";
	        return html;
	
	    };
	
	    /*
	     Function that returns the position (relative to the viewport/document.body)
	     the tooltip should be placed in.
	     Should return: {
	        left: <leftPos>,
	        top: <topPos>
	     }
	     */
	    var position = function() {
	        var pos = {
	            left: d3.event !== null ? d3.event.clientX : 0,
	            top: d3.event !== null ? d3.event.clientY : 0
	        };
	
	        if(getComputedStyle(document.body).transform != 'none') {
	            // Take the offset into account, as now the tooltip is relative
	            // to document.body.
	            var client = document.body.getBoundingClientRect();
	            pos.left -= client.left;
	            pos.top -= client.top;
	        }
	
	        return pos;
	    };
	
	    var dataSeriesExists = function(d) {
	        if (d && d.series) {
	            if (nv.utils.isArray(d.series)) {
	                return true;
	            }
	            // if object, it's okay just convert to array of the object
	            if (nv.utils.isObject(d.series)) {
	                d.series = [d.series];
	                return true;
	            }
	        }
	        return false;
	    };
	
	    // Calculates the gravity offset of the tooltip. Parameter is position of tooltip
	    // relative to the viewport.
	    var calcGravityOffset = function(pos) {
	        var height = tooltip.node().offsetHeight,
	            width = tooltip.node().offsetWidth,
	            clientWidth = document.documentElement.clientWidth, // Don't want scrollbars.
	            clientHeight = document.documentElement.clientHeight, // Don't want scrollbars.
	            left, top, tmp;
	
	        // calculate position based on gravity
	        switch (gravity) {
	            case 'e':
	                left = - width - distance;
	                top = - (height / 2);
	                if(pos.left + left < 0) left = distance;
	                if((tmp = pos.top + top) < 0) top -= tmp;
	                if((tmp = pos.top + top + height) > clientHeight) top -= tmp - clientHeight;
	                break;
	            case 'w':
	                left = distance;
	                top = - (height / 2);
	                if (pos.left + left + width > clientWidth) left = - width - distance;
	                if ((tmp = pos.top + top) < 0) top -= tmp;
	                if ((tmp = pos.top + top + height) > clientHeight) top -= tmp - clientHeight;
	                break;
	            case 'n':
	                left = - (width / 2) - 5; // - 5 is an approximation of the mouse's height.
	                top = distance;
	                if (pos.top + top + height > clientHeight) top = - height - distance;
	                if ((tmp = pos.left + left) < 0) left -= tmp;
	                if ((tmp = pos.left + left + width) > clientWidth) left -= tmp - clientWidth;
	                break;
	            case 's':
	                left = - (width / 2);
	                top = - height - distance;
	                if (pos.top + top < 0) top = distance;
	                if ((tmp = pos.left + left) < 0) left -= tmp;
	                if ((tmp = pos.left + left + width) > clientWidth) left -= tmp - clientWidth;
	                break;
	            case 'center':
	                left = - (width / 2);
	                top = - (height / 2);
	                break;
	            default:
	                left = 0;
	                top = 0;
	                break;
	        }
	
	        return { 'left': left, 'top': top };
	    };
	
	    /*
	     Positions the tooltip in the correct place, as given by the position() function.
	     */
	    var positionTooltip = function() {
	        nv.dom.read(function() {
	            var pos = position(),
	                gravityOffset = calcGravityOffset(pos),
	                left = pos.left + gravityOffset.left,
	                top = pos.top + gravityOffset.top;
	
	            // delay hiding a bit to avoid flickering
	            if (hidden) {
	                tooltip
	                    .interrupt()
	                    .transition()
	                    .delay(hideDelay)
	                    .duration(0)
	                    .style('opacity', 0);
	            } else {
	                // using tooltip.style('transform') returns values un-usable for tween
	                var old_translate = 'translate(' + lastPosition.left + 'px, ' + lastPosition.top + 'px)';
	                var new_translate = 'translate(' + Math.round(left) + 'px, ' + Math.round(top) + 'px)';
	                var translateInterpolator = d3.interpolateString(old_translate, new_translate);
	                var is_hidden = tooltip.style('opacity') < 0.1;
	
	                tooltip
	                    .interrupt() // cancel running transitions
	                    .transition()
	                    .duration(is_hidden ? 0 : duration)
	                    // using tween since some versions of d3 can't auto-tween a translate on a div
	                    .styleTween('transform', function (d) {
	                        return translateInterpolator;
	                    }, 'important')
	                    // Safari has its own `-webkit-transform` and does not support `transform`
	                    .styleTween('-webkit-transform', function (d) {
	                        return translateInterpolator;
	                    })
	                    .style('-ms-transform', new_translate)
	                    .style('opacity', 1);
	            }
	
	            lastPosition.left = left;
	            lastPosition.top = top;
	        });
	    };
	
	    // Creates new tooltip container, or uses existing one on DOM.
	    function initTooltip() {
	        if (!tooltip || !tooltip.node()) {
	            // Create new tooltip div if it doesn't exist on DOM.
	
	            var data = [1];
	            tooltip = d3.select(document.body).select('#'+id).data(data);
	
	            tooltip.enter().append('div')
	                   .attr("class", "nvtooltip " + (classes ? classes : "xy-tooltip"))
	                   .attr("id", id)
	                   .style("top", 0).style("left", 0)
	                   .style('opacity', 0)
	                   .style('position', 'fixed')
	                   .selectAll("div, table, td, tr").classed(nvPointerEventsClass, true)
	                   .classed(nvPointerEventsClass, true);
	
	            tooltip.exit().remove()
	        }
	    }
	
	    // Draw the tooltip onto the DOM.
	    function nvtooltip() {
	        if (!enabled) return;
	        if (!dataSeriesExists(data)) return;
	
	        nv.dom.write(function () {
	            initTooltip();
	            // Generate data and set it into tooltip.
	            // Bonus - If you override contentGenerator and return false, you can use something like
	            //         Angular, React or Knockout to bind the data for your tooltip directly to the DOM.
	            var newContent = contentGenerator(data, tooltip.node());
	            if (newContent) {
	                tooltip.node().innerHTML = newContent;
	            }
	
	            positionTooltip();
	        });
	
	        return nvtooltip;
	    }
	
	    nvtooltip.nvPointerEventsClass = nvPointerEventsClass;
	    nvtooltip.options = nv.utils.optionsFunc.bind(nvtooltip);
	
	    nvtooltip._options = Object.create({}, {
	        // simple read/write options
	        duration: {get: function(){return duration;}, set: function(_){duration=_;}},
	        gravity: {get: function(){return gravity;}, set: function(_){gravity=_;}},
	        distance: {get: function(){return distance;}, set: function(_){distance=_;}},
	        snapDistance: {get: function(){return snapDistance;}, set: function(_){snapDistance=_;}},
	        classes: {get: function(){return classes;}, set: function(_){classes=_;}},
	        enabled: {get: function(){return enabled;}, set: function(_){enabled=_;}},
	        hideDelay: {get: function(){return hideDelay;}, set: function(_){hideDelay=_;}},
	        contentGenerator: {get: function(){return contentGenerator;}, set: function(_){contentGenerator=_;}},
	        valueFormatter: {get: function(){return valueFormatter;}, set: function(_){valueFormatter=_;}},
	        headerFormatter: {get: function(){return headerFormatter;}, set: function(_){headerFormatter=_;}},
	        keyFormatter: {get: function(){return keyFormatter;}, set: function(_){keyFormatter=_;}},
	        headerEnabled: {get: function(){return headerEnabled;}, set: function(_){headerEnabled=_;}},
	        position: {get: function(){return position;}, set: function(_){position=_;}},
	
	        // Deprecated options
	        chartContainer: {get: function(){return document.body;}, set: function(_){
	            // deprecated after 1.8.3
	            nv.deprecated('chartContainer', 'feature removed after 1.8.3');
	        }},
	        fixedTop: {get: function(){return null;}, set: function(_){
	            // deprecated after 1.8.1
	            nv.deprecated('fixedTop', 'feature removed after 1.8.1');
	        }},
	        offset: {get: function(){return {left: 0, top: 0};}, set: function(_){
	            // deprecated after 1.8.1
	            nv.deprecated('offset', 'use chart.tooltip.distance() instead');
	        }},
	
	        // options with extra logic
	        hidden: {get: function(){return hidden;}, set: function(_){
	            if (hidden != _) {
	                hidden = !!_;
	                nvtooltip();
	            }
	        }},
	        data: {get: function(){return data;}, set: function(_){
	            // if showing a single data point, adjust data format with that
	            if (_.point) {
	                _.value = _.point.x;
	                _.series = _.series || {};
	                _.series.value = _.point.y;
	                _.series.color = _.point.color || _.series.color;
	            }
	            data = _;
	        }},
	
	        // read only properties
	        node: {get: function(){return tooltip.node();}, set: function(_){}},
	        id: {get: function(){return id;}, set: function(_){}}
	    });
	
	    nv.utils.initOptions(nvtooltip);
	    return nvtooltip;
	};
	
	
	/*
	Gets the browser window size
	
	Returns object with height and width properties
	 */
	nv.utils.windowSize = function() {
	    // Sane defaults
	    var size = {width: 640, height: 480};
	
	    // Most recent browsers use
	    if (window.innerWidth && window.innerHeight) {
	        size.width = window.innerWidth;
	        size.height = window.innerHeight;
	        return (size);
	    }
	
	    // IE can use depending on mode it is in
	    if (document.compatMode=='CSS1Compat' &&
	        document.documentElement &&
	        document.documentElement.offsetWidth ) {
	
	        size.width = document.documentElement.offsetWidth;
	        size.height = document.documentElement.offsetHeight;
	        return (size);
	    }
	
	    // Earlier IE uses Doc.body
	    if (document.body && document.body.offsetWidth) {
	        size.width = document.body.offsetWidth;
	        size.height = document.body.offsetHeight;
	        return (size);
	    }
	
	    return (size);
	};
	
	
	/* handle dumb browser quirks...  isinstance breaks if you use frames
	typeof returns 'object' for null, NaN is a number, etc.
	 */
	nv.utils.isArray = Array.isArray;
	nv.utils.isObject = function(a) {
	    return a !== null && typeof a === 'object';
	};
	nv.utils.isFunction = function(a) {
	    return typeof a === 'function';
	};
	nv.utils.isDate = function(a) {
	    return toString.call(a) === '[object Date]';
	};
	nv.utils.isNumber = function(a) {
	    return !isNaN(a) && typeof a === 'number';
	};
	
	
	/*
	Binds callback function to run when window is resized
	 */
	nv.utils.windowResize = function(handler) {
	    if (window.addEventListener) {
	        window.addEventListener('resize', handler);
	    } else {
	        nv.log("ERROR: Failed to bind to window.resize with: ", handler);
	    }
	    // return object with clear function to remove the single added callback.
	    return {
	        callback: handler,
	        clear: function() {
	            window.removeEventListener('resize', handler);
	        }
	    }
	};
	
	
	/*
	Backwards compatible way to implement more d3-like coloring of graphs.
	Can take in nothing, an array, or a function/scale
	To use a normal scale, get the range and pass that because we must be able
	to take two arguments and use the index to keep backward compatibility
	*/
	nv.utils.getColor = function(color) {
	    //if you pass in nothing, get default colors back
	    if (color === undefined) {
	        return nv.utils.defaultColor();
	
	    //if passed an array, turn it into a color scale
	    } else if(nv.utils.isArray(color)) {
	        var color_scale = d3.scale.ordinal().range(color);
	        return function(d, i) {
	            var key = i === undefined ? d : i;
	            return d.color || color_scale(key);
	        };
	
	    //if passed a function or scale, return it, or whatever it may be
	    //external libs, such as angularjs-nvd3-directives use this
	    } else {
	        //can't really help it if someone passes rubbish as color
	        return color;
	    }
	};
	
	
	/*
	Default color chooser uses a color scale of 20 colors from D3
	 https://github.com/mbostock/d3/wiki/Ordinal-Scales#categorical-colors
	 */
	nv.utils.defaultColor = function() {
	    // get range of the scale so we'll turn it into our own function.
	    return nv.utils.getColor(d3.scale.category20().range());
	};
	
	
	/*
	Returns a color function that takes the result of 'getKey' for each series and
	looks for a corresponding color from the dictionary
	*/
	nv.utils.customTheme = function(dictionary, getKey, defaultColors) {
	    // use default series.key if getKey is undefined
	    getKey = getKey || function(series) { return series.key };
	    defaultColors = defaultColors || d3.scale.category20().range();
	
	    // start at end of default color list and walk back to index 0
	    var defIndex = defaultColors.length;
	
	    return function(series, index) {
	        var key = getKey(series);
	        if (nv.utils.isFunction(dictionary[key])) {
	            return dictionary[key]();
	        } else if (dictionary[key] !== undefined) {
	            return dictionary[key];
	        } else {
	            // no match in dictionary, use a default color
	            if (!defIndex) {
	                // used all the default colors, start over
	                defIndex = defaultColors.length;
	            }
	            defIndex = defIndex - 1;
	            return defaultColors[defIndex];
	        }
	    };
	};
	
	
	/*
	From the PJAX example on d3js.org, while this is not really directly needed
	it's a very cool method for doing pjax, I may expand upon it a little bit,
	open to suggestions on anything that may be useful
	*/
	nv.utils.pjax = function(links, content) {
	
	    var load = function(href) {
	        d3.html(href, function(fragment) {
	            var target = d3.select(content).node();
	            target.parentNode.replaceChild(
	                d3.select(fragment).select(content).node(),
	                target);
	            nv.utils.pjax(links, content);
	        });
	    };
	
	    d3.selectAll(links).on("click", function() {
	        history.pushState(this.href, this.textContent, this.href);
	        load(this.href);
	        d3.event.preventDefault();
	    });
	
	    d3.select(window).on("popstate", function() {
	        if (d3.event.state) {
	            load(d3.event.state);
	        }
	    });
	};
	
	
	/*
	For when we want to approximate the width in pixels for an SVG:text element.
	Most common instance is when the element is in a display:none; container.
	Forumla is : text.length * font-size * constant_factor
	*/
	nv.utils.calcApproxTextWidth = function (svgTextElem) {
	    if (nv.utils.isFunction(svgTextElem.style) && nv.utils.isFunction(svgTextElem.text)) {
	        var fontSize = parseInt(svgTextElem.style("font-size").replace("px",""), 10);
	        var textLength = svgTextElem.text().length;
	        return nv.utils.NaNtoZero(textLength * fontSize * 0.5);
	    }
	    return 0;
	};
	
	
	/*
	Numbers that are undefined, null or NaN, convert them to zeros.
	*/
	nv.utils.NaNtoZero = function(n) {
	    if (!nv.utils.isNumber(n)
	        || isNaN(n)
	        || n === null
	        || n === Infinity
	        || n === -Infinity) {
	
	        return 0;
	    }
	    return n;
	};
	
	/*
	Add a way to watch for d3 transition ends to d3
	*/
	d3.selection.prototype.watchTransition = function(renderWatch){
	    var args = [this].concat([].slice.call(arguments, 1));
	    return renderWatch.transition.apply(renderWatch, args);
	};
	
	
	/*
	Helper object to watch when d3 has rendered something
	*/
	nv.utils.renderWatch = function(dispatch, duration) {
	    if (!(this instanceof nv.utils.renderWatch)) {
	        return new nv.utils.renderWatch(dispatch, duration);
	    }
	
	    var _duration = duration !== undefined ? duration : 250;
	    var renderStack = [];
	    var self = this;
	
	    this.models = function(models) {
	        models = [].slice.call(arguments, 0);
	        models.forEach(function(model){
	            model.__rendered = false;
	            (function(m){
	                m.dispatch.on('renderEnd', function(arg){
	                    m.__rendered = true;
	                    self.renderEnd('model');
	                });
	            })(model);
	
	            if (renderStack.indexOf(model) < 0) {
	                renderStack.push(model);
	            }
	        });
	    return this;
	    };
	
	    this.reset = function(duration) {
	        if (duration !== undefined) {
	            _duration = duration;
	        }
	        renderStack = [];
	    };
	
	    this.transition = function(selection, args, duration) {
	        args = arguments.length > 1 ? [].slice.call(arguments, 1) : [];
	
	        if (args.length > 1) {
	            duration = args.pop();
	        } else {
	            duration = _duration !== undefined ? _duration : 250;
	        }
	        selection.__rendered = false;
	
	        if (renderStack.indexOf(selection) < 0) {
	            renderStack.push(selection);
	        }
	
	        if (duration === 0) {
	            selection.__rendered = true;
	            selection.delay = function() { return this; };
	            selection.duration = function() { return this; };
	            return selection;
	        } else {
	            if (selection.length === 0) {
	                selection.__rendered = true;
	            } else if (selection.every( function(d){ return !d.length; } )) {
	                selection.__rendered = true;
	            } else {
	                selection.__rendered = false;
	            }
	
	            var n = 0;
	            return selection
	                .transition()
	                .duration(duration)
	                .each(function(){ ++n; })
	                .each('end', function(d, i) {
	                    if (--n === 0) {
	                        selection.__rendered = true;
	                        self.renderEnd.apply(this, args);
	                    }
	                });
	        }
	    };
	
	    this.renderEnd = function() {
	        if (renderStack.every( function(d){ return d.__rendered; } )) {
	            renderStack.forEach( function(d){ d.__rendered = false; });
	            dispatch.renderEnd.apply(this, arguments);
	        }
	    }
	
	};
	
	
	/*
	Takes multiple objects and combines them into the first one (dst)
	example:  nv.utils.deepExtend({a: 1}, {a: 2, b: 3}, {c: 4});
	gives:  {a: 2, b: 3, c: 4}
	*/
	nv.utils.deepExtend = function(dst){
	    var sources = arguments.length > 1 ? [].slice.call(arguments, 1) : [];
	    sources.forEach(function(source) {
	        for (var key in source) {
	            var isArray = nv.utils.isArray(dst[key]);
	            var isObject = nv.utils.isObject(dst[key]);
	            var srcObj = nv.utils.isObject(source[key]);
	
	            if (isObject && !isArray && srcObj) {
	                nv.utils.deepExtend(dst[key], source[key]);
	            } else {
	                dst[key] = source[key];
	            }
	        }
	    });
	};
	
	
	/*
	state utility object, used to track d3 states in the models
	*/
	nv.utils.state = function(){
	    if (!(this instanceof nv.utils.state)) {
	        return new nv.utils.state();
	    }
	    var state = {};
	    var _self = this;
	    var _setState = function(){};
	    var _getState = function(){ return {}; };
	    var init = null;
	    var changed = null;
	
	    this.dispatch = d3.dispatch('change', 'set');
	
	    this.dispatch.on('set', function(state){
	        _setState(state, true);
	    });
	
	    this.getter = function(fn){
	        _getState = fn;
	        return this;
	    };
	
	    this.setter = function(fn, callback) {
	        if (!callback) {
	            callback = function(){};
	        }
	        _setState = function(state, update){
	            fn(state);
	            if (update) {
	                callback();
	            }
	        };
	        return this;
	    };
	
	    this.init = function(state){
	        init = init || {};
	        nv.utils.deepExtend(init, state);
	    };
	
	    var _set = function(){
	        var settings = _getState();
	
	        if (JSON.stringify(settings) === JSON.stringify(state)) {
	            return false;
	        }
	
	        for (var key in settings) {
	            if (state[key] === undefined) {
	                state[key] = {};
	            }
	            state[key] = settings[key];
	            changed = true;
	        }
	        return true;
	    };
	
	    this.update = function(){
	        if (init) {
	            _setState(init, false);
	            init = null;
	        }
	        if (_set.call(this)) {
	            this.dispatch.change(state);
	        }
	    };
	
	};
	
	
	/*
	Snippet of code you can insert into each nv.models.* to give you the ability to
	do things like:
	chart.options({
	  showXAxis: true,
	  tooltips: true
	});
	
	To enable in the chart:
	chart.options = nv.utils.optionsFunc.bind(chart);
	*/
	nv.utils.optionsFunc = function(args) {
	    if (args) {
	        d3.map(args).forEach((function(key,value) {
	            if (nv.utils.isFunction(this[key])) {
	                this[key](value);
	            }
	        }).bind(this));
	    }
	    return this;
	};
	
	
	/*
	numTicks:  requested number of ticks
	data:  the chart data
	
	returns the number of ticks to actually use on X axis, based on chart data
	to avoid duplicate ticks with the same value
	*/
	nv.utils.calcTicksX = function(numTicks, data) {
	    // find max number of values from all data streams
	    var numValues = 1;
	    var i = 0;
	    for (i; i < data.length; i += 1) {
	        var stream_len = data[i] && data[i].values ? data[i].values.length : 0;
	        numValues = stream_len > numValues ? stream_len : numValues;
	    }
	    nv.log("Requested number of ticks: ", numTicks);
	    nv.log("Calculated max values to be: ", numValues);
	    // make sure we don't have more ticks than values to avoid duplicates
	    numTicks = numTicks > numValues ? numTicks = numValues - 1 : numTicks;
	    // make sure we have at least one tick
	    numTicks = numTicks < 1 ? 1 : numTicks;
	    // make sure it's an integer
	    numTicks = Math.floor(numTicks);
	    nv.log("Calculating tick count as: ", numTicks);
	    return numTicks;
	};
	
	
	/*
	returns number of ticks to actually use on Y axis, based on chart data
	*/
	nv.utils.calcTicksY = function(numTicks, data) {
	    // currently uses the same logic but we can adjust here if needed later
	    return nv.utils.calcTicksX(numTicks, data);
	};
	
	
	/*
	Add a particular option from an options object onto chart
	Options exposed on a chart are a getter/setter function that returns chart
	on set to mimic typical d3 option chaining, e.g. svg.option1('a').option2('b');
	
	option objects should be generated via Object.create() to provide
	the option of manipulating data via get/set functions.
	*/
	nv.utils.initOption = function(chart, name) {
	    // if it's a call option, just call it directly, otherwise do get/set
	    if (chart._calls && chart._calls[name]) {
	        chart[name] = chart._calls[name];
	    } else {
	        chart[name] = function (_) {
	            if (!arguments.length) return chart._options[name];
	            chart._overrides[name] = true;
	            chart._options[name] = _;
	            return chart;
	        };
	        // calling the option as _option will ignore if set by option already
	        // so nvd3 can set options internally but the stop if set manually
	        chart['_' + name] = function(_) {
	            if (!arguments.length) return chart._options[name];
	            if (!chart._overrides[name]) {
	                chart._options[name] = _;
	            }
	            return chart;
	        }
	    }
	};
	
	
	/*
	Add all options in an options object to the chart
	*/
	nv.utils.initOptions = function(chart) {
	    chart._overrides = chart._overrides || {};
	    var ops = Object.getOwnPropertyNames(chart._options || {});
	    var calls = Object.getOwnPropertyNames(chart._calls || {});
	    ops = ops.concat(calls);
	    for (var i in ops) {
	        nv.utils.initOption(chart, ops[i]);
	    }
	};
	
	
	/*
	Inherit options from a D3 object
	d3.rebind makes calling the function on target actually call it on source
	Also use _d3options so we can track what we inherit for documentation and chained inheritance
	*/
	nv.utils.inheritOptionsD3 = function(target, d3_source, oplist) {
	    target._d3options = oplist.concat(target._d3options || []);
	    // Find unique d3 options (string) and update d3options
	    target._d3options = (target._d3options || []).filter(function(item, i, ar){ return ar.indexOf(item) === i; });
	    oplist.unshift(d3_source);
	    oplist.unshift(target);
	    d3.rebind.apply(this, oplist);
	};
	
	
	/*
	Remove duplicates from an array
	*/
	nv.utils.arrayUnique = function(a) {
	    return a.sort().filter(function(item, pos) {
	        return !pos || item != a[pos - 1];
	    });
	};
	
	
	/*
	Keeps a list of custom symbols to draw from in addition to d3.svg.symbol
	Necessary since d3 doesn't let you extend its list -_-
	Add new symbols by doing nv.utils.symbols.set('name', function(size){...});
	*/
	nv.utils.symbolMap = d3.map();
	
	
	/*
	Replaces d3.svg.symbol so that we can look both there and our own map
	 */
	nv.utils.symbol = function() {
	    var type,
	        size = 64;
	    function symbol(d,i) {
	        var t = type.call(this,d,i);
	        var s = size.call(this,d,i);
	        if (d3.svg.symbolTypes.indexOf(t) !== -1) {
	            return d3.svg.symbol().type(t).size(s)();
	        } else {
	            return nv.utils.symbolMap.get(t)(s);
	        }
	    }
	    symbol.type = function(_) {
	        if (!arguments.length) return type;
	        type = d3.functor(_);
	        return symbol;
	    };
	    symbol.size = function(_) {
	        if (!arguments.length) return size;
	        size = d3.functor(_);
	        return symbol;
	    };
	    return symbol;
	};
	
	
	/*
	Inherit option getter/setter functions from source to target
	d3.rebind makes calling the function on target actually call it on source
	Also track via _inherited and _d3options so we can track what we inherit
	for documentation generation purposes and chained inheritance
	*/
	nv.utils.inheritOptions = function(target, source) {
	    // inherit all the things
	    var ops = Object.getOwnPropertyNames(source._options || {});
	    var calls = Object.getOwnPropertyNames(source._calls || {});
	    var inherited = source._inherited || [];
	    var d3ops = source._d3options || [];
	    var args = ops.concat(calls).concat(inherited).concat(d3ops);
	    args.unshift(source);
	    args.unshift(target);
	    d3.rebind.apply(this, args);
	    // pass along the lists to keep track of them, don't allow duplicates
	    target._inherited = nv.utils.arrayUnique(ops.concat(calls).concat(inherited).concat(ops).concat(target._inherited || []));
	    target._d3options = nv.utils.arrayUnique(d3ops.concat(target._d3options || []));
	};
	
	
	/*
	Runs common initialize code on the svg before the chart builds
	*/
	nv.utils.initSVG = function(svg) {
	    svg.classed({'nvd3-svg':true});
	};
	
	
	/*
	Sanitize and provide default for the container height.
	*/
	nv.utils.sanitizeHeight = function(height, container) {
	    return (height || parseInt(container.style('height'), 10) || 400);
	};
	
	
	/*
	Sanitize and provide default for the container width.
	*/
	nv.utils.sanitizeWidth = function(width, container) {
	    return (width || parseInt(container.style('width'), 10) || 960);
	};
	
	
	/*
	Calculate the available height for a chart.
	*/
	nv.utils.availableHeight = function(height, container, margin) {
	    return Math.max(0,nv.utils.sanitizeHeight(height, container) - margin.top - margin.bottom);
	};
	
	/*
	Calculate the available width for a chart.
	*/
	nv.utils.availableWidth = function(width, container, margin) {
	    return Math.max(0,nv.utils.sanitizeWidth(width, container) - margin.left - margin.right);
	};
	
	/*
	Clear any rendered chart components and display a chart's 'noData' message
	*/
	nv.utils.noData = function(chart, container) {
	    var opt = chart.options(),
	        margin = opt.margin(),
	        noData = opt.noData(),
	        data = (noData == null) ? ["No Data Available."] : [noData],
	        height = nv.utils.availableHeight(null, container, margin),
	        width = nv.utils.availableWidth(null, container, margin),
	        x = margin.left + width/2,
	        y = margin.top + height/2;
	
	    //Remove any previously created chart components
	    container.selectAll('g').remove();
	
	    var noDataText = container.selectAll('.nv-noData').data(data);
	
	    noDataText.enter().append('text')
	        .attr('class', 'nvd3 nv-noData')
	        .attr('dy', '-.7em')
	        .style('text-anchor', 'middle');
	
	    noDataText
	        .attr('x', x)
	        .attr('y', y)
	        .text(function(t){ return t; });
	};
	
	/*
	 Wrap long labels.
	 */
	nv.utils.wrapTicks = function (text, width) {
	    text.each(function() {
	        var text = d3.select(this),
	            words = text.text().split(/\s+/).reverse(),
	            word,
	            line = [],
	            lineNumber = 0,
	            lineHeight = 1.1,
	            y = text.attr("y"),
	            dy = parseFloat(text.attr("dy")),
	            tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
	        while (word = words.pop()) {
	            line.push(word);
	            tspan.text(line.join(" "));
	            if (tspan.node().getComputedTextLength() > width) {
	                line.pop();
	                tspan.text(line.join(" "));
	                line = [word];
	                tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
	            }
	        }
	    });
	};
	
	/*
	Check equality of 2 array
	*/
	nv.utils.arrayEquals = function (array1, array2) {
	    if (array1 === array2)
	        return true;
	
	    if (!array1 || !array2)
	        return false;
	
	    // compare lengths - can save a lot of time
	    if (array1.length != array2.length)
	        return false;
	
	    for (var i = 0,
	        l = array1.length; i < l; i++) {
	        // Check if we have nested arrays
	        if (array1[i] instanceof Array && array2[i] instanceof Array) {
	            // recurse into the nested arrays
	            if (!nv.arrayEquals(array1[i], array2[i]))
	                return false;
	        } else if (array1[i] != array2[i]) {
	            // Warning - two different object instances will never be equal: {x:20} != {x:20}
	            return false;
	        }
	    }
	    return true;
	};
	
	/*
	 Check if a point within an arc
	 */
	nv.utils.pointIsInArc = function(pt, ptData, d3Arc) {
	    // Center of the arc is assumed to be 0,0
	    // (pt.x, pt.y) are assumed to be relative to the center
	    var r1 = d3Arc.innerRadius()(ptData), // Note: Using the innerRadius
	      r2 = d3Arc.outerRadius()(ptData),
	      theta1 = d3Arc.startAngle()(ptData),
	      theta2 = d3Arc.endAngle()(ptData);
	
	    var dist = pt.x * pt.x + pt.y * pt.y,
	      angle = Math.atan2(pt.x, -pt.y); // Note: different coordinate system.
	
	    angle = (angle < 0) ? (angle + Math.PI * 2) : angle;
	
	    return (r1 * r1 <= dist) && (dist <= r2 * r2) &&
	      (theta1 <= angle) && (angle <= theta2);
	};
	
	nv.models.axis = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var axis = d3.svg.axis();
	    var scale = d3.scale.linear();
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = 75 //only used for tickLabel currently
	        , height = 60 //only used for tickLabel currently
	        , axisLabelText = null
	        , showMaxMin = true //TODO: showMaxMin should be disabled on all ordinal scaled axes
	        , rotateLabels = 0
	        , rotateYLabel = true
	        , staggerLabels = false
	        , isOrdinal = false
	        , ticks = null
	        , axisLabelDistance = 0
	        , fontSize = undefined
	        , duration = 250
	        , dispatch = d3.dispatch('renderEnd')
	        , tickFormatMaxMin
	        ;
	    axis
	        .scale(scale)
	        .orient('bottom')
	        .tickFormat(function(d) { return d })
	    ;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var scale0;
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    function chart(selection) {
	        renderWatch.reset();
	        selection.each(function(data) {
	            var container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-axis').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-axis');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            if (ticks !== null)
	                axis.ticks(ticks);
	            else if (axis.orient() == 'top' || axis.orient() == 'bottom')
	                axis.ticks(Math.abs(scale.range()[1] - scale.range()[0]) / 100);
	
	            //TODO: consider calculating width/height based on whether or not label is added, for reference in charts using this component
	            g.watchTransition(renderWatch, 'axis').call(axis);
	
	            scale0 = scale0 || axis.scale();
	
	            var fmt = axis.tickFormat();
	            if (fmt == null) {
	                fmt = scale0.tickFormat();
	            }
	
	            var axisLabel = g.selectAll('text.nv-axislabel')
	                .data([axisLabelText || null]);
	            axisLabel.exit().remove();
	
	            //only skip when fontSize is undefined so it can be cleared with a null or blank string
	            if (fontSize !== undefined) {
	                g.selectAll('g').select("text").style('font-size', fontSize);
	            }
	
	            var xLabelMargin;
	            var axisMaxMin;
	            var w;
	            switch (axis.orient()) {
	                case 'top':
	                    axisLabel.enter().append('text').attr('class', 'nv-axislabel');
	                  w = 0;
	                  if (scale.range().length === 1) {
	                    w = isOrdinal ? scale.range()[0] * 2 + scale.rangeBand() : 0;
	                  } else if (scale.range().length === 2) {
	                    w = isOrdinal ? scale.range()[0] + scale.range()[1] + scale.rangeBand() : scale.range()[1];
	                  } else if ( scale.range().length > 2){
	                    w = scale.range()[scale.range().length-1]+(scale.range()[1]-scale.range()[0]);
	                  };
	                    axisLabel
	                        .attr('text-anchor', 'middle')
	                        .attr('y', 0)
	                        .attr('x', w/2);
	                    if (showMaxMin) {
	                        axisMaxMin = wrap.selectAll('g.nv-axisMaxMin')
	                            .data(scale.domain());
	                        axisMaxMin.enter().append('g').attr('class',function(d,i){
	                                return ['nv-axisMaxMin','nv-axisMaxMin-x',(i == 0 ? 'nv-axisMin-x':'nv-axisMax-x')].join(' ')
	                        }).append('text');
	                        axisMaxMin.exit().remove();
	                        axisMaxMin
	                            .attr('transform', function(d,i) {
	                                return 'translate(' + nv.utils.NaNtoZero(scale(d)) + ',0)'
	                            })
	                            .select('text')
	                            .attr('dy', '-0.5em')
	                            .attr('y', -axis.tickPadding())
	                            .attr('text-anchor', 'middle')
	                            .text(function(d,i) {
	                                var formatter = tickFormatMaxMin || fmt;
	                                var v = formatter(d);
	                                return ('' + v).match('NaN') ? '' : v;
	                            });
	                        axisMaxMin.watchTransition(renderWatch, 'min-max top')
	                            .attr('transform', function(d,i) {
	                                return 'translate(' + nv.utils.NaNtoZero(scale.range()[i]) + ',0)'
	                            });
	                    }
	                    break;
	                case 'bottom':
	                    xLabelMargin = axisLabelDistance + 36;
	                    var maxTextWidth = 30;
	                    var textHeight = 0;
	                    var xTicks = g.selectAll('g').select("text");
	                    var rotateLabelsRule = '';
	                    if (rotateLabels%360) {
	                        //Reset transform on ticks so textHeight can be calculated correctly
	                        xTicks.attr('transform', '');
	                        //Calculate the longest xTick width
	                        xTicks.each(function(d,i){
	                            var box = this.getBoundingClientRect();
	                            var width = box.width;
	                            textHeight = box.height;
	                            if(width > maxTextWidth) maxTextWidth = width;
	                        });
	                        rotateLabelsRule = 'rotate(' + rotateLabels + ' 0,' + (textHeight/2 + axis.tickPadding()) + ')';
	                        //Convert to radians before calculating sin. Add 30 to margin for healthy padding.
	                        var sin = Math.abs(Math.sin(rotateLabels*Math.PI/180));
	                        xLabelMargin = (sin ? sin*maxTextWidth : maxTextWidth)+30;
	                        //Rotate all xTicks
	                        xTicks
	                            .attr('transform', rotateLabelsRule)
	                            .style('text-anchor', rotateLabels%360 > 0 ? 'start' : 'end');
	                    } else {
	                        if (staggerLabels) {
	                            xTicks
	                                .attr('transform', function(d,i) {
	                                    return 'translate(0,' + (i % 2 == 0 ? '0' : '12') + ')'
	                                });
	                        } else {
	                            xTicks.attr('transform', "translate(0,0)");
	                        }
	                    }
	                    axisLabel.enter().append('text').attr('class', 'nv-axislabel');
	                    w = 0;
	                    if (scale.range().length === 1) {
	                        w = isOrdinal ? scale.range()[0] * 2 + scale.rangeBand() : 0;
	                    } else if (scale.range().length === 2) {
	                        w = isOrdinal ? scale.range()[0] + scale.range()[1] + scale.rangeBand() : scale.range()[1];
	                    } else if ( scale.range().length > 2){
	                        w = scale.range()[scale.range().length-1]+(scale.range()[1]-scale.range()[0]);
	                    };
	                    axisLabel
	                        .attr('text-anchor', 'middle')
	                        .attr('y', xLabelMargin)
	                        .attr('x', w/2);
	                    if (showMaxMin) {
	                        //if (showMaxMin && !isOrdinal) {
	                        axisMaxMin = wrap.selectAll('g.nv-axisMaxMin')
	                            //.data(scale.domain())
	                            .data([scale.domain()[0], scale.domain()[scale.domain().length - 1]]);
	                        axisMaxMin.enter().append('g').attr('class',function(d,i){
	                                return ['nv-axisMaxMin','nv-axisMaxMin-x',(i == 0 ? 'nv-axisMin-x':'nv-axisMax-x')].join(' ')
	                        }).append('text');
	                        axisMaxMin.exit().remove();
	                        axisMaxMin
	                            .attr('transform', function(d,i) {
	                                return 'translate(' + nv.utils.NaNtoZero((scale(d) + (isOrdinal ? scale.rangeBand() / 2 : 0))) + ',0)'
	                            })
	                            .select('text')
	                            .attr('dy', '.71em')
	                            .attr('y', axis.tickPadding())
	                            .attr('transform', rotateLabelsRule)
	                            .style('text-anchor', rotateLabels ? (rotateLabels%360 > 0 ? 'start' : 'end') : 'middle')
	                            .text(function(d,i) {
	                                var formatter = tickFormatMaxMin || fmt;
	                                var v = formatter(d);
	                                return ('' + v).match('NaN') ? '' : v;
	                            });
	                        axisMaxMin.watchTransition(renderWatch, 'min-max bottom')
	                            .attr('transform', function(d,i) {
	                                return 'translate(' + nv.utils.NaNtoZero((scale(d) + (isOrdinal ? scale.rangeBand() / 2 : 0))) + ',0)'
	                            });
	                    }
	
	                    break;
	                case 'right':
	                    axisLabel.enter().append('text').attr('class', 'nv-axislabel');
	                    axisLabel
	                        .style('text-anchor', rotateYLabel ? 'middle' : 'begin')
	                        .attr('transform', rotateYLabel ? 'rotate(90)' : '')
	                        .attr('y', rotateYLabel ? (-Math.max(margin.right, width) + 12 - (axisLabelDistance || 0)) : -10) //TODO: consider calculating this based on largest tick width... OR at least expose this on chart
	                        .attr('x', rotateYLabel ? (d3.max(scale.range()) / 2) : axis.tickPadding());
	                    if (showMaxMin) {
	                        axisMaxMin = wrap.selectAll('g.nv-axisMaxMin')
	                            .data(scale.domain());
	                       	axisMaxMin.enter().append('g').attr('class',function(d,i){
	                                return ['nv-axisMaxMin','nv-axisMaxMin-y',(i == 0 ? 'nv-axisMin-y':'nv-axisMax-y')].join(' ')
	                        }).append('text')
	                            .style('opacity', 0);
	                        axisMaxMin.exit().remove();
	                        axisMaxMin
	                            .attr('transform', function(d,i) {
	                                return 'translate(0,' + nv.utils.NaNtoZero(scale(d)) + ')'
	                            })
	                            .select('text')
	                            .attr('dy', '.32em')
	                            .attr('y', 0)
	                            .attr('x', axis.tickPadding())
	                            .style('text-anchor', 'start')
	                            .text(function(d, i) {
	                                var formatter = tickFormatMaxMin || fmt;
	                                var v = formatter(d);
	                                return ('' + v).match('NaN') ? '' : v;
	                            });
	                        axisMaxMin.watchTransition(renderWatch, 'min-max right')
	                            .attr('transform', function(d,i) {
	                                return 'translate(0,' + nv.utils.NaNtoZero(scale.range()[i]) + ')'
	                            })
	                            .select('text')
	                            .style('opacity', 1);
	                    }
	                    break;
	                case 'left':
	                    /*
	                     //For dynamically placing the label. Can be used with dynamically-sized chart axis margins
	                     var yTicks = g.selectAll('g').select("text");
	                     yTicks.each(function(d,i){
	                     var labelPadding = this.getBoundingClientRect().width + axis.tickPadding() + 16;
	                     if(labelPadding > width) width = labelPadding;
	                     });
	                     */
	                    axisLabel.enter().append('text').attr('class', 'nv-axislabel');
	                    axisLabel
	                        .style('text-anchor', rotateYLabel ? 'middle' : 'end')
	                        .attr('transform', rotateYLabel ? 'rotate(-90)' : '')
	                        .attr('y', rotateYLabel ? (-Math.max(margin.left, width) + 25 - (axisLabelDistance || 0)) : -10)
	                        .attr('x', rotateYLabel ? (-d3.max(scale.range()) / 2) : -axis.tickPadding());
	                    if (showMaxMin) {
	                        axisMaxMin = wrap.selectAll('g.nv-axisMaxMin')
	                            .data(scale.domain());
	                        axisMaxMin.enter().append('g').attr('class',function(d,i){
	                                return ['nv-axisMaxMin','nv-axisMaxMin-y',(i == 0 ? 'nv-axisMin-y':'nv-axisMax-y')].join(' ')
	                        }).append('text')
	                            .style('opacity', 0);
	                        axisMaxMin.exit().remove();
	                        axisMaxMin
	                            .attr('transform', function(d,i) {
	                                return 'translate(0,' + nv.utils.NaNtoZero(scale0(d)) + ')'
	                            })
	                            .select('text')
	                            .attr('dy', '.32em')
	                            .attr('y', 0)
	                            .attr('x', -axis.tickPadding())
	                            .attr('text-anchor', 'end')
	                            .text(function(d,i) {
	                                var formatter = tickFormatMaxMin || fmt;
	                                var v = formatter(d);
	                                return ('' + v).match('NaN') ? '' : v;
	                            });
	                        axisMaxMin.watchTransition(renderWatch, 'min-max right')
	                            .attr('transform', function(d,i) {
	                                return 'translate(0,' + nv.utils.NaNtoZero(scale.range()[i]) + ')'
	                            })
	                            .select('text')
	                            .style('opacity', 1);
	                    }
	                    break;
	            }
	            axisLabel.text(function(d) { return d });
	
	            if (showMaxMin && (axis.orient() === 'left' || axis.orient() === 'right')) {
	                //check if max and min overlap other values, if so, hide the values that overlap
	                g.selectAll('g') // the g's wrapping each tick
	                    .each(function(d,i) {
	                        d3.select(this).select('text').attr('opacity', 1);
	                        if (scale(d) < scale.range()[1] + 10 || scale(d) > scale.range()[0] - 10) { // 10 is assuming text height is 16... if d is 0, leave it!
	                            if (d > 1e-10 || d < -1e-10) // accounts for minor floating point errors... though could be problematic if the scale is EXTREMELY SMALL
	                                d3.select(this).attr('opacity', 0);
	
	                            d3.select(this).select('text').attr('opacity', 0); // Don't remove the ZERO line!!
	                        }
	                    });
	
	                //if Max and Min = 0 only show min, Issue #281
	                if (scale.domain()[0] == scale.domain()[1] && scale.domain()[0] == 0) {
	                    wrap.selectAll('g.nv-axisMaxMin').style('opacity', function (d, i) {
	                        return !i ? 1 : 0
	                    });
	                }
	            }
	
	            if (showMaxMin && (axis.orient() === 'top' || axis.orient() === 'bottom')) {
	                var maxMinRange = [];
	                wrap.selectAll('g.nv-axisMaxMin')
	                    .each(function(d,i) {
	                        try {
	                            if (i) // i== 1, max position
	                                maxMinRange.push(scale(d) - this.getBoundingClientRect().width - 4);  //assuming the max and min labels are as wide as the next tick (with an extra 4 pixels just in case)
	                            else // i==0, min position
	                                maxMinRange.push(scale(d) + this.getBoundingClientRect().width + 4)
	                        }catch (err) {
	                            if (i) // i== 1, max position
	                                maxMinRange.push(scale(d) - 4);  //assuming the max and min labels are as wide as the next tick (with an extra 4 pixels just in case)
	                            else // i==0, min position
	                                maxMinRange.push(scale(d) + 4);
	                        }
	                    });
	                // the g's wrapping each tick
	                g.selectAll('g').each(function(d, i) {
	                    if (scale(d) < maxMinRange[0] || scale(d) > maxMinRange[1]) {
	                        if (d > 1e-10 || d < -1e-10) // accounts for minor floating point errors... though could be problematic if the scale is EXTREMELY SMALL
	                            d3.select(this).remove();
	                        else
	                            d3.select(this).select('text').remove(); // Don't remove the ZERO line!!
	                    }
	                });
	            }
	
	            //Highlight zero tick line
	            g.selectAll('.tick')
	                .filter(function (d) {
	                    /*
	                    The filter needs to return only ticks at or near zero.
	                    Numbers like 0.00001 need to count as zero as well,
	                    and the arithmetic trick below solves that.
	                    */
	                    return !parseFloat(Math.round(d * 100000) / 1000000) && (d !== undefined)
	                })
	                .classed('zero', true);
	
	            //store old scales for use in transitions on update
	            scale0 = scale.copy();
	
	        });
	
	        renderWatch.renderEnd('axis immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.axis = axis;
	    chart.dispatch = dispatch;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        axisLabelDistance: {get: function(){return axisLabelDistance;}, set: function(_){axisLabelDistance=_;}},
	        staggerLabels:     {get: function(){return staggerLabels;}, set: function(_){staggerLabels=_;}},
	        rotateLabels:      {get: function(){return rotateLabels;}, set: function(_){rotateLabels=_;}},
	        rotateYLabel:      {get: function(){return rotateYLabel;}, set: function(_){rotateYLabel=_;}},
	        showMaxMin:        {get: function(){return showMaxMin;}, set: function(_){showMaxMin=_;}},
	        axisLabel:         {get: function(){return axisLabelText;}, set: function(_){axisLabelText=_;}},
	        height:            {get: function(){return height;}, set: function(_){height=_;}},
	        ticks:             {get: function(){return ticks;}, set: function(_){ticks=_;}},
	        width:             {get: function(){return width;}, set: function(_){width=_;}},
	        fontSize:          {get: function(){return fontSize;}, set: function(_){fontSize=_;}},
	        tickFormatMaxMin:  {get: function(){return tickFormatMaxMin;}, set: function(_){tickFormatMaxMin=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top !== undefined    ? _.top    : margin.top;
	            margin.right  = _.right !== undefined  ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left !== undefined   ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration=_;
	            renderWatch.reset(duration);
	        }},
	        scale: {get: function(){return scale;}, set: function(_){
	            scale = _;
	            axis.scale(scale);
	            isOrdinal = typeof scale.rangeBands === 'function';
	            nv.utils.inheritOptionsD3(chart, scale, ['domain', 'range', 'rangeBand', 'rangeBands']);
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	    nv.utils.inheritOptionsD3(chart, axis, ['orient', 'tickValues', 'tickSubdivide', 'tickSize', 'tickPadding', 'tickFormat']);
	    nv.utils.inheritOptionsD3(chart, scale, ['domain', 'range', 'rangeBand', 'rangeBands']);
	
	    return chart;
	};
	nv.models.boxPlot = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0},
	        width = 960,
	        height = 500,
	        id = Math.floor(Math.random() * 10000), // Create semi-unique ID in case user doesn't select one
	        xScale = d3.scale.ordinal(),
	        yScale = d3.scale.linear(),
	        getX  = function(d) { return d.label }, // Default data model selectors.
	        getQ1 = function(d) { return d.values.Q1 },
	        getQ2 = function(d) { return d.values.Q2 },
	        getQ3 = function(d) { return d.values.Q3 },
	        getWl = function(d) { return d.values.whisker_low },
	        getWh = function(d) { return d.values.whisker_high },
	        getColor = function(d) { return d.color },
	        getOlItems  = function(d) { return d.values.outliers },
	        getOlValue = function(d, i, j) { return d },
	        getOlLabel = function(d, i, j) { return d },
	        getOlColor = function(d, i, j) { return undefined },
	        color = nv.utils.defaultColor(),
	        container = null,
	        xDomain, xRange,
	        yDomain, yRange,
	        dispatch = d3.dispatch('elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd'),
	        duration = 250,
	        maxBoxWidth = null;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var xScale0, yScale0;
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    function chart(selection) {
	        renderWatch.reset();
	        selection.each(function(data) {
	            var availableWidth = width - margin.left - margin.right,
	                availableHeight = height - margin.top - margin.bottom;
	
	            container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            // Setup Scales
	            xScale.domain(xDomain || data.map(function(d,i) { return getX(d,i); }))
	                .rangeBands(xRange || [0, availableWidth], 0.1);
	
	            // if we know yDomain, no need to calculate
	            var yData = []
	            if (!yDomain) {
	                // (y-range is based on quartiles, whiskers and outliers)
	                var values = [], yMin, yMax;
	                data.forEach(function (d, i) {
	                    var q1 = getQ1(d), q3 = getQ3(d), wl = getWl(d), wh = getWh(d);
	                    var olItems = getOlItems(d);
	                    if (olItems) {
	                        olItems.forEach(function (e, i) {
	                            values.push(getOlValue(e, i, undefined));
	                        });
	                    }
	                    if (wl) { values.push(wl) }
	                    if (q1) { values.push(q1) }
	                    if (q3) { values.push(q3) }
	                    if (wh) { values.push(wh) }
	                });
	                yMin = d3.min(values);
	                yMax = d3.max(values);
	                yData = [ yMin, yMax ] ;
	            }
	
	            yScale.domain(yDomain || yData);
	            yScale.range(yRange || [availableHeight, 0]);
	
	            //store old scales if they exist
	            xScale0 = xScale0 || xScale;
	            yScale0 = yScale0 || yScale.copy().range([yScale(0),yScale(0)]);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap');
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            var boxplots = wrap.selectAll('.nv-boxplot').data(function(d) { return d });
	            var boxEnter = boxplots.enter().append('g').style('stroke-opacity', 1e-6).style('fill-opacity', 1e-6);
	            boxplots
	                .attr('class', 'nv-boxplot')
	                .attr('transform', function(d,i,j) { return 'translate(' + (xScale(getX(d,i)) + xScale.rangeBand() * 0.05) + ', 0)'; })
	                .classed('hover', function(d) { return d.hover });
	            boxplots
	                .watchTransition(renderWatch, 'nv-boxplot: boxplots')
	                .style('stroke-opacity', 1)
	                .style('fill-opacity', 0.75)
	                .delay(function(d,i) { return i * duration / data.length })
	                .attr('transform', function(d,i) {
	                    return 'translate(' + (xScale(getX(d,i)) + xScale.rangeBand() * 0.05) + ', 0)';
	                });
	            boxplots.exit().remove();
	
	            // ----- add the SVG elements for each boxPlot -----
	
	            // conditionally append whisker lines
	            boxEnter.each(function(d,i) {
	                var box = d3.select(this);
	                [getWl, getWh].forEach(function (f) {
	                    if (f(d) !== undefined && f(d) !== null) {
	                        var key = (f === getWl) ? 'low' : 'high';
	                        box.append('line')
	                          .style('stroke', getColor(d) || color(d,i))
	                          .attr('class', 'nv-boxplot-whisker nv-boxplot-' + key);
	                        box.append('line')
	                          .style('stroke', getColor(d) || color(d,i))
	                          .attr('class', 'nv-boxplot-tick nv-boxplot-' + key);
	                    }
	                });
	            });
	
	            var box_width = function() { return (maxBoxWidth === null ? xScale.rangeBand() * 0.9 : Math.min(75, xScale.rangeBand() * 0.9)); };
	            var box_left  = function() { return xScale.rangeBand() * 0.45 - box_width()/2; };
	            var box_right = function() { return xScale.rangeBand() * 0.45 + box_width()/2; };
	
	            // update whisker lines and ticks
	            [getWl, getWh].forEach(function (f) {
	                var key = (f === getWl) ? 'low' : 'high';
	                var endpoint = (f === getWl) ? getQ1 : getQ3;
	                boxplots.select('line.nv-boxplot-whisker.nv-boxplot-' + key)
	                  .watchTransition(renderWatch, 'nv-boxplot: boxplots')
	                    .attr('x1', xScale.rangeBand() * 0.45 )
	                    .attr('y1', function(d,i) { return yScale(f(d)); })
	                    .attr('x2', xScale.rangeBand() * 0.45 )
	                    .attr('y2', function(d,i) { return yScale(endpoint(d)); });
	                boxplots.select('line.nv-boxplot-tick.nv-boxplot-' + key)
	                  .watchTransition(renderWatch, 'nv-boxplot: boxplots')
	                    .attr('x1', box_left )
	                    .attr('y1', function(d,i) { return yScale(f(d)); })
	                    .attr('x2', box_right )
	                    .attr('y2', function(d,i) { return yScale(f(d)); });
	            });
	
	            [getWl, getWh].forEach(function (f) {
	                var key = (f === getWl) ? 'low' : 'high';
	                boxEnter.selectAll('.nv-boxplot-' + key)
	                  .on('mouseover', function(d,i,j) {
	                      d3.select(this).classed('hover', true);
	                      dispatch.elementMouseover({
	                          series: { key: f(d), color: getColor(d) || color(d,j) },
	                          e: d3.event
	                      });
	                  })
	                  .on('mouseout', function(d,i,j) {
	                      d3.select(this).classed('hover', false);
	                      dispatch.elementMouseout({
	                          series: { key: f(d), color: getColor(d) || color(d,j) },
	                          e: d3.event
	                      });
	                  })
	                  .on('mousemove', function(d,i) {
	                      dispatch.elementMousemove({e: d3.event});
	                  });
	            });
	
	            // boxes
	            boxEnter.append('rect')
	                .attr('class', 'nv-boxplot-box')
	                // tooltip events
	                .on('mouseover', function(d,i) {
	                    d3.select(this).classed('hover', true);
	                    dispatch.elementMouseover({
	                        key: getX(d),
	                        value: getX(d),
	                        series: [
	                            { key: 'Q3', value: getQ3(d), color: getColor(d) || color(d,i) },
	                            { key: 'Q2', value: getQ2(d), color: getColor(d) || color(d,i) },
	                            { key: 'Q1', value: getQ1(d), color: getColor(d) || color(d,i) }
	                        ],
	                        data: d,
	                        index: i,
	                        e: d3.event
	                    });
	                })
	                .on('mouseout', function(d,i) {
	                    d3.select(this).classed('hover', false);
	                    dispatch.elementMouseout({
	                        key: getX(d),
	                        value: getX(d),
	                        series: [
	                            { key: 'Q3', value: getQ3(d), color: getColor(d) || color(d,i) },
	                            { key: 'Q2', value: getQ2(d), color: getColor(d) || color(d,i) },
	                            { key: 'Q1', value: getQ1(d), color: getColor(d) || color(d,i) }
	                        ],
	                        data: d,
	                        index: i,
	                        e: d3.event
	                    });
	                })
	                .on('mousemove', function(d,i) {
	                    dispatch.elementMousemove({e: d3.event});
	                });
	
	            // box transitions
	            boxplots.select('rect.nv-boxplot-box')
	              .watchTransition(renderWatch, 'nv-boxplot: boxes')
	                .attr('y', function(d,i) { return yScale(getQ3(d)); })
	                .attr('width', box_width)
	                .attr('x', box_left )
	                .attr('height', function(d,i) { return Math.abs(yScale(getQ3(d)) - yScale(getQ1(d))) || 1 })
	                .style('fill', function(d,i) { return getColor(d) || color(d,i) })
	                .style('stroke', function(d,i) { return getColor(d) || color(d,i) });
	
	            // median line
	            boxEnter.append('line').attr('class', 'nv-boxplot-median');
	
	            boxplots.select('line.nv-boxplot-median')
	              .watchTransition(renderWatch, 'nv-boxplot: boxplots line')
	                .attr('x1', box_left)
	                .attr('y1', function(d,i) { return yScale(getQ2(d)); })
	                .attr('x2', box_right)
	                .attr('y2', function(d,i) { return yScale(getQ2(d)); });
	
	            // outliers
	            var outliers = boxplots.selectAll('.nv-boxplot-outlier').data(function(d) {
	                return getOlItems(d) || [];
	            });
	            outliers.enter().append('circle')
	                .style('fill', function(d,i,j) { return getOlColor(d,i,j) || color(d,j) })
	                .style('stroke', function(d,i,j) { return getOlColor(d,i,j) || color(d,j) })
	                .style('z-index', 9000)
	                .on('mouseover', function(d,i,j) {
	                    d3.select(this).classed('hover', true);
	                    dispatch.elementMouseover({
	                        series: { key: getOlLabel(d,i,j), color: getOlColor(d,i,j) || color(d,j) },
	                        e: d3.event
	                    });
	                })
	                .on('mouseout', function(d,i,j) {
	                    d3.select(this).classed('hover', false);
	                    dispatch.elementMouseout({
	                        series: { key: getOlLabel(d,i,j), color: getOlColor(d,i,j) || color(d,j) },
	                        e: d3.event
	                    });
	                })
	                .on('mousemove', function(d,i) {
	                    dispatch.elementMousemove({e: d3.event});
	                });
	            outliers.attr('class', 'nv-boxplot-outlier');
	            outliers
	              .watchTransition(renderWatch, 'nv-boxplot: nv-boxplot-outlier')
	                .attr('cx', xScale.rangeBand() * 0.45)
	                .attr('cy', function(d,i,j) { return yScale(getOlValue(d,i,j)); })
	                .attr('r', '3');
	            outliers.exit().remove();
	
	            //store old scales for use in transitions on update
	            xScale0 = xScale.copy();
	            yScale0 = yScale.copy();
	        });
	
	        renderWatch.renderEnd('nv-boxplot immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:       {get: function(){return width;}, set: function(_){width=_;}},
	        height:      {get: function(){return height;}, set: function(_){height=_;}},
	        maxBoxWidth: {get: function(){return maxBoxWidth;}, set: function(_){maxBoxWidth=_;}},
	        x:           {get: function(){return getX;}, set: function(_){getX=_;}},
	        q1: {get: function(){return getQ1;}, set: function(_){getQ1=_;}},
	        q2: {get: function(){return getQ2;}, set: function(_){getQ2=_;}},
	        q3: {get: function(){return getQ3;}, set: function(_){getQ3=_;}},
	        wl: {get: function(){return getWl;}, set: function(_){getWl=_;}},
	        wh: {get: function(){return getWh;}, set: function(_){getWh=_;}},
	        itemColor:    {get: function(){return getColor;}, set: function(_){getColor=_;}},
	        outliers:     {get: function(){return getOlItems;}, set: function(_){getOlItems=_;}},
	        outlierValue: {get: function(){return getOlValue;}, set: function(_){getOlValue=_;}},
	        outlierLabel: {get: function(){return getOlLabel;}, set: function(_){getOlLabel=_;}},
	        outlierColor: {get: function(){return getOlColor;}, set: function(_){getOlColor=_;}},
	        xScale:  {get: function(){return xScale;}, set: function(_){xScale=_;}},
	        yScale:  {get: function(){return yScale;}, set: function(_){yScale=_;}},
	        xDomain: {get: function(){return xDomain;}, set: function(_){xDomain=_;}},
	        yDomain: {get: function(){return yDomain;}, set: function(_){yDomain=_;}},
	        xRange:  {get: function(){return xRange;}, set: function(_){xRange=_;}},
	        yRange:  {get: function(){return yRange;}, set: function(_){yRange=_;}},
	        id:          {get: function(){return id;}, set: function(_){id=_;}},
	        // rectClass: {get: function(){return rectClass;}, set: function(_){rectClass=_;}},
	        y: {
	            get: function() {
	                console.warn('BoxPlot \'y\' chart option is deprecated. Please use model overrides instead.');
	                return {};
	            },
	            set: function(_) {
	                console.warn('BoxPlot \'y\' chart option is deprecated. Please use model overrides instead.');
	            }
	        },
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	nv.models.boxPlotChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var boxplot = nv.models.boxPlot(),
	        xAxis = nv.models.axis(),
	        yAxis = nv.models.axis();
	
	    var margin = {top: 15, right: 10, bottom: 50, left: 60},
	        width = null,
	        height = null,
	        color = nv.utils.getColor(),
	        showXAxis = true,
	        showYAxis = true,
	        rightAlignYAxis = false,
	        staggerLabels = false,
	        tooltip = nv.models.tooltip(),
	        x, y,
	        noData = 'No Data Available.',
	        dispatch = d3.dispatch('beforeUpdate', 'renderEnd'),
	        duration = 250;
	
	    xAxis
	        .orient('bottom')
	        .showMaxMin(false)
	        .tickFormat(function(d) { return d })
	    ;
	    yAxis
	        .orient((rightAlignYAxis) ? 'right' : 'left')
	        .tickFormat(d3.format(',.1f'))
	    ;
	
	    tooltip.duration(0);
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(boxplot);
	        if (showXAxis) renderWatch.models(xAxis);
	        if (showYAxis) renderWatch.models(yAxis);
	
	        selection.each(function(data) {
	            var container = d3.select(this), that = this;
	            nv.utils.initSVG(container);
	            var availableWidth = (width  || parseInt(container.style('width')) || 960) - margin.left - margin.right;
	            var availableHeight = (height || parseInt(container.style('height')) || 400) - margin.top - margin.bottom;
	
	            chart.update = function() {
	                dispatch.beforeUpdate();
	                container.transition().duration(duration).call(chart);
	            };
	            chart.container = this;
	
	            // TODO still need to find a way to validate quartile data presence using boxPlot callbacks.
	            // Display No Data message if there's nothing to show. (quartiles required at minimum).
	            if (!data || !data.length) {
	                var noDataText = container.selectAll('.nv-noData').data([noData]);
	
	                noDataText.enter().append('text')
	                    .attr('class', 'nvd3 nv-noData')
	                    .attr('dy', '-.7em')
	                    .style('text-anchor', 'middle');
	
	                noDataText
	                    .attr('x', margin.left + availableWidth / 2)
	                    .attr('y', margin.top + availableHeight / 2)
	                    .text(function(d) { return d });
	
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            // Setup Scales
	            x = boxplot.xScale();
	            y = boxplot.yScale().clamp(true);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-boxPlotWithAxes').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-boxPlotWithAxes').append('g');
	            var defsEnter = gEnter.append('defs');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-x nv-axis');
	            gEnter.append('g').attr('class', 'nv-y nv-axis')
	                .append('g').attr('class', 'nv-zeroLine')
	                .append('line');
	
	            gEnter.append('g').attr('class', 'nv-barsWrap');
	            g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            if (rightAlignYAxis) {
	                g.select('.nv-y.nv-axis')
	                    .attr('transform', 'translate(' + availableWidth + ',0)');
	            }
	
	            // Main Chart Component(s)
	            boxplot.width(availableWidth).height(availableHeight);
	
	            var barsWrap = g.select('.nv-barsWrap')
	                .datum(data.filter(function(d) { return !d.disabled }))
	
	            barsWrap.transition().call(boxplot);
	
	            defsEnter.append('clipPath')
	                .attr('id', 'nv-x-label-clip-' + boxplot.id())
	                .append('rect');
	
	            g.select('#nv-x-label-clip-' + boxplot.id() + ' rect')
	                .attr('width', x.rangeBand() * (staggerLabels ? 2 : 1))
	                .attr('height', 16)
	                .attr('x', -x.rangeBand() / (staggerLabels ? 1 : 2 ));
	
	            // Setup Axes
	            if (showXAxis) {
	                xAxis
	                    .scale(x)
	                    .ticks( nv.utils.calcTicksX(availableWidth/100, data) )
	                    .tickSize(-availableHeight, 0);
	
	                g.select('.nv-x.nv-axis').attr('transform', 'translate(0,' + y.range()[0] + ')');
	                g.select('.nv-x.nv-axis').call(xAxis);
	
	                var xTicks = g.select('.nv-x.nv-axis').selectAll('g');
	                if (staggerLabels) {
	                    xTicks
	                        .selectAll('text')
	                        .attr('transform', function(d,i,j) { return 'translate(0,' + (j % 2 === 0 ? '5' : '17') + ')' })
	                }
	            }
	
	            if (showYAxis) {
	                yAxis
	                    .scale(y)
	                    .ticks( Math.floor(availableHeight/36) ) // can't use nv.utils.calcTicksY with Object data
	                    .tickSize( -availableWidth, 0);
	
	                g.select('.nv-y.nv-axis').call(yAxis);
	            }
	
	            // Zero line
	            g.select('.nv-zeroLine line')
	                .attr('x1',0)
	                .attr('x2',availableWidth)
	                .attr('y1', y(0))
	                .attr('y2', y(0))
	            ;
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	        });
	
	        renderWatch.renderEnd('nv-boxplot chart immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    boxplot.dispatch.on('elementMouseover.tooltip', function(evt) {
	        tooltip.data(evt).hidden(false);
	    });
	
	    boxplot.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.data(evt).hidden(true);
	    });
	
	    boxplot.dispatch.on('elementMousemove.tooltip', function(evt) {
	        tooltip();
	    });
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.boxplot = boxplot;
	    chart.xAxis = xAxis;
	    chart.yAxis = yAxis;
	    chart.tooltip = tooltip;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        staggerLabels: {get: function(){return staggerLabels;}, set: function(_){staggerLabels=_;}},
	        showXAxis: {get: function(){return showXAxis;}, set: function(_){showXAxis=_;}},
	        showYAxis: {get: function(){return showYAxis;}, set: function(_){showYAxis=_;}},
	        tooltipContent:    {get: function(){return tooltip;}, set: function(_){tooltip=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	            boxplot.duration(duration);
	            xAxis.duration(duration);
	            yAxis.duration(duration);
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            boxplot.color(color);
	        }},
	        rightAlignYAxis: {get: function(){return rightAlignYAxis;}, set: function(_){
	            rightAlignYAxis = _;
	            yAxis.orient( (_) ? 'right' : 'left');
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, boxplot);
	    nv.utils.initOptions(chart);
	
	    return chart;
	}
	
	// Chart design based on the recommendations of Stephen Few. Implementation
	// based on the work of Clint Ivy, Jamie Love, and Jason Davies.
	// http://projects.instantcognition.com/protovis/bulletchart/
	
	nv.models.bullet = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , orient = 'left' // TODO top & bottom
	        , reverse = false
	        , ranges = function(d) { return d.ranges }
	        , markers = function(d) { return d.markers ? d.markers : [] }
	        , markerLines = function(d) { return d.markerLines ? d.markerLines : [0] }
	        , measures = function(d) { return d.measures }
	        , rangeLabels = function(d) { return d.rangeLabels ? d.rangeLabels : [] }
	        , markerLabels = function(d) { return d.markerLabels ? d.markerLabels : []  }
	        , markerLineLabels = function(d) { return d.markerLineLabels ? d.markerLineLabels : []  }
	        , measureLabels = function(d) { return d.measureLabels ? d.measureLabels : []  }
	        , forceX = [0] // List of numbers to Force into the X scale (ie. 0, or a max / min, etc.)
	        , width = 380
	        , height = 30
	        , container = null
	        , tickFormat = null
	        , color = nv.utils.getColor(['#1f77b4'])
	        , dispatch = d3.dispatch('elementMouseover', 'elementMouseout', 'elementMousemove')
	        , defaultRangeLabels = ["Maximum", "Mean", "Minimum"]
	        , legacyRangeClassNames = ["Max", "Avg", "Min"]
	        , duration = 1000
	        ;
	
	    function sortLabels(labels, values){
	        var lz = labels.slice();
	        labels.sort(function(a, b){
	            var iA = lz.indexOf(a);
	            var iB = lz.indexOf(b);
	            return d3.descending(values[iA], values[iB]);
	        });
	    };
	
	    function chart(selection) {
	        selection.each(function(d, i) {
	            var availableWidth = width - margin.left - margin.right,
	                availableHeight = height - margin.top - margin.bottom;
	
	            container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            var rangez = ranges.call(this, d, i).slice(),
	                markerz = markers.call(this, d, i).slice(),
	                markerLinez = markerLines.call(this, d, i).slice(),
	                measurez = measures.call(this, d, i).slice(),
	                rangeLabelz = rangeLabels.call(this, d, i).slice(),
	                markerLabelz = markerLabels.call(this, d, i).slice(),
	                markerLineLabelz = markerLineLabels.call(this, d, i).slice(),
	                measureLabelz = measureLabels.call(this, d, i).slice();
	
	            // Sort labels according to their sorted values
	            sortLabels(rangeLabelz, rangez);
	            sortLabels(markerLabelz, markerz);
	            sortLabels(markerLineLabelz, markerLinez);
	            sortLabels(measureLabelz, measurez);
	
	            // sort values descending
	            rangez.sort(d3.descending);
	            markerz.sort(d3.descending);
	            markerLinez.sort(d3.descending);
	            measurez.sort(d3.descending);
	
	            // Setup Scales
	            // Compute the new x-scale.
	            var x1 = d3.scale.linear()
	                .domain( d3.extent(d3.merge([forceX, rangez])) )
	                .range(reverse ? [availableWidth, 0] : [0, availableWidth]);
	
	            // Retrieve the old x-scale, if this is an update.
	            var x0 = this.__chart__ || d3.scale.linear()
	                .domain([0, Infinity])
	                .range(x1.range());
	
	            // Stash the new scale.
	            this.__chart__ = x1;
	
	            var rangeMin = d3.min(rangez), //rangez[2]
	                rangeMax = d3.max(rangez), //rangez[0]
	                rangeAvg = rangez[1];
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-bullet').data([d]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-bullet');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            for(var i=0,il=rangez.length; i<il; i++){
	                var rangeClassNames = 'nv-range nv-range'+i;
	                if(i <= 2){
	                    rangeClassNames = rangeClassNames + ' nv-range'+legacyRangeClassNames[i];
	                }
	                gEnter.append('rect').attr('class', rangeClassNames);
	            }
	
	            gEnter.append('rect').attr('class', 'nv-measure');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            var w0 = function(d) { return Math.abs(x0(d) - x0(0)) }, // TODO: could optimize by precalculating x0(0) and x1(0)
	                w1 = function(d) { return Math.abs(x1(d) - x1(0)) };
	            var xp0 = function(d) { return d < 0 ? x0(d) : x0(0) },
	                xp1 = function(d) { return d < 0 ? x1(d) : x1(0) };
	
	            for(var i=0,il=rangez.length; i<il; i++){
	                var range = rangez[i];
	                g.select('rect.nv-range'+i)
	                    .datum(range)
	                    .attr('height', availableHeight)
	                    .transition()
	                    .duration(duration)
	                    .attr('width', w1(range))
	                    .attr('x', xp1(range))
	            }
	
	            g.select('rect.nv-measure')
	                .style('fill', color)
	                .attr('height', availableHeight / 3)
	                .attr('y', availableHeight / 3)
	                .on('mouseover', function() {
	                    dispatch.elementMouseover({
	                        value: measurez[0],
	                        label: measureLabelz[0] || 'Current',
	                        color: d3.select(this).style("fill")
	                    })
	                })
	                .on('mousemove', function() {
	                    dispatch.elementMousemove({
	                        value: measurez[0],
	                        label: measureLabelz[0] || 'Current',
	                        color: d3.select(this).style("fill")
	                    })
	                })
	                .on('mouseout', function() {
	                    dispatch.elementMouseout({
	                        value: measurez[0],
	                        label: measureLabelz[0] || 'Current',
	                        color: d3.select(this).style("fill")
	                    })
	                })
	                .transition()
	                .duration(duration)
	                .attr('width', measurez < 0 ?
	                    x1(0) - x1(measurez[0])
	                    : x1(measurez[0]) - x1(0))
	                .attr('x', xp1(measurez));
	
	            var h3 =  availableHeight / 6;
	
	            var markerData = markerz.map( function(marker, index) {
	                return {value: marker, label: markerLabelz[index]}
	            });
	            gEnter
	              .selectAll("path.nv-markerTriangle")
	              .data(markerData)
	              .enter()
	              .append('path')
	              .attr('class', 'nv-markerTriangle')
	              .attr('d', 'M0,' + h3 + 'L' + h3 + ',' + (-h3) + ' ' + (-h3) + ',' + (-h3) + 'Z')
	              .on('mouseover', function(d) {
	                dispatch.elementMouseover({
	                  value: d.value,
	                  label: d.label || 'Previous',
	                  color: d3.select(this).style("fill"),
	                  pos: [x1(d.value), availableHeight/2]
	                })
	
	              })
	              .on('mousemove', function(d) {
	                  dispatch.elementMousemove({
	                      value: d.value,
	                      label: d.label || 'Previous',
	                      color: d3.select(this).style("fill")
	                  })
	              })
	              .on('mouseout', function(d, i) {
	                  dispatch.elementMouseout({
	                      value: d.value,
	                      label: d.label || 'Previous',
	                      color: d3.select(this).style("fill")
	                  })
	              });
	
	            g.selectAll("path.nv-markerTriangle")
	              .data(markerData)
	              .transition()
	              .duration(duration)
	              .attr('transform', function(d) { return 'translate(' + x1(d.value) + ',' + (availableHeight / 2) + ')' });
	
	            var markerLinesData = markerLinez.map( function(marker, index) {
	                return {value: marker, label: markerLineLabelz[index]}
	            });
	            gEnter
	              .selectAll("line.nv-markerLine")
	              .data(markerLinesData)
	              .enter()
	              .append('line')
	              .attr('cursor', '')
	              .attr('class', 'nv-markerLine')
	              .attr('x1', function(d) { return x1(d.value) })
	              .attr('y1', '2')
	              .attr('x2', function(d) { return x1(d.value) })
	              .attr('y2', availableHeight - 2)
	              .on('mouseover', function(d) {
	                dispatch.elementMouseover({
	                  value: d.value,
	                  label: d.label || 'Previous',
	                  color: d3.select(this).style("fill"),
	                  pos: [x1(d.value), availableHeight/2]
	                })
	
	              })
	              .on('mousemove', function(d) {
	                  dispatch.elementMousemove({
	                      value: d.value,
	                      label: d.label || 'Previous',
	                      color: d3.select(this).style("fill")
	                  })
	              })
	              .on('mouseout', function(d, i) {
	                  dispatch.elementMouseout({
	                      value: d.value,
	                      label: d.label || 'Previous',
	                      color: d3.select(this).style("fill")
	                  })
	              });
	
	            g.selectAll("line.nv-markerLine")
	              .data(markerLinesData)
	              .transition()
	              .duration(duration)
	              .attr('x1', function(d) { return x1(d.value) })
	              .attr('x2', function(d) { return x1(d.value) });
	
	            wrap.selectAll('.nv-range')
	                .on('mouseover', function(d,i) {
	                    var label = rangeLabelz[i] || defaultRangeLabels[i];
	                    dispatch.elementMouseover({
	                        value: d,
	                        label: label,
	                        color: d3.select(this).style("fill")
	                    })
	                })
	                .on('mousemove', function() {
	                    dispatch.elementMousemove({
	                        value: measurez[0],
	                        label: measureLabelz[0] || 'Previous',
	                        color: d3.select(this).style("fill")
	                    })
	                })
	                .on('mouseout', function(d,i) {
	                    var label = rangeLabelz[i] || defaultRangeLabels[i];
	                    dispatch.elementMouseout({
	                        value: d,
	                        label: label,
	                        color: d3.select(this).style("fill")
	                    })
	                });
	        });
	
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        ranges:      {get: function(){return ranges;}, set: function(_){ranges=_;}}, // ranges (bad, satisfactory, good)
	        markers:     {get: function(){return markers;}, set: function(_){markers=_;}}, // markers (previous, goal)
	        measures: {get: function(){return measures;}, set: function(_){measures=_;}}, // measures (actual, forecast)
	        forceX:      {get: function(){return forceX;}, set: function(_){forceX=_;}},
	        width:    {get: function(){return width;}, set: function(_){width=_;}},
	        height:    {get: function(){return height;}, set: function(_){height=_;}},
	        tickFormat:    {get: function(){return tickFormat;}, set: function(_){tickFormat=_;}},
	        duration:    {get: function(){return duration;}, set: function(_){duration=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        orient: {get: function(){return orient;}, set: function(_){ // left, right, top, bottom
	            orient = _;
	            reverse = orient == 'right' || orient == 'bottom';
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	    return chart;
	};
	
	
	
	// Chart design based on the recommendations of Stephen Few. Implementation
	// based on the work of Clint Ivy, Jamie Love, and Jason Davies.
	// http://projects.instantcognition.com/protovis/bulletchart/
	nv.models.bulletChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var bullet = nv.models.bullet();
	    var tooltip = nv.models.tooltip();
	
	    var orient = 'left' // TODO top & bottom
	        , reverse = false
	        , margin = {top: 5, right: 40, bottom: 20, left: 120}
	        , ranges = function(d) { return d.ranges }
	        , markers = function(d) { return d.markers ? d.markers : [] }
	        , measures = function(d) { return d.measures }
	        , width = null
	        , height = 55
	        , tickFormat = null
	        , ticks = null
	        , noData = null
	        , dispatch = d3.dispatch()
	        ;
	
	    tooltip
	        .duration(0)
	        .headerEnabled(false);
	
	    function chart(selection) {
	        selection.each(function(d, i) {
	            var container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = height - margin.top - margin.bottom,
	                that = this;
	
	            chart.update = function() { chart(selection) };
	            chart.container = this;
	
	            // Display No Data message if there's nothing to show.
	            if (!d || !ranges.call(this, d, i)) {
	                nv.utils.noData(chart, container)
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            var rangez = ranges.call(this, d, i).slice().sort(d3.descending),
	                markerz = markers.call(this, d, i).slice().sort(d3.descending),
	                measurez = measures.call(this, d, i).slice().sort(d3.descending);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-bulletChart').data([d]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-bulletChart');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-bulletWrap');
	            gEnter.append('g').attr('class', 'nv-titles');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            // Compute the new x-scale.
	            var x1 = d3.scale.linear()
	                .domain([0, Math.max(rangez[0], (markerz[0] || 0), measurez[0])])  // TODO: need to allow forceX and forceY, and xDomain, yDomain
	                .range(reverse ? [availableWidth, 0] : [0, availableWidth]);
	
	            // Retrieve the old x-scale, if this is an update.
	            var x0 = this.__chart__ || d3.scale.linear()
	                .domain([0, Infinity])
	                .range(x1.range());
	
	            // Stash the new scale.
	            this.__chart__ = x1;
	
	            var w0 = function(d) { return Math.abs(x0(d) - x0(0)) }, // TODO: could optimize by precalculating x0(0) and x1(0)
	                w1 = function(d) { return Math.abs(x1(d) - x1(0)) };
	
	            var title = gEnter.select('.nv-titles').append('g')
	                .attr('text-anchor', 'end')
	                .attr('transform', 'translate(-6,' + (height - margin.top - margin.bottom) / 2 + ')');
	            title.append('text')
	                .attr('class', 'nv-title')
	                .text(function(d) { return d.title; });
	
	            title.append('text')
	                .attr('class', 'nv-subtitle')
	                .attr('dy', '1em')
	                .text(function(d) { return d.subtitle; });
	
	            bullet
	                .width(availableWidth)
	                .height(availableHeight);
	
	            var bulletWrap = g.select('.nv-bulletWrap');
	            d3.transition(bulletWrap).call(bullet);
	
	            // Compute the tick format.
	            var format = tickFormat || x1.tickFormat( availableWidth / 100 );
	
	            // Update the tick groups.
	            var tick = g.selectAll('g.nv-tick')
	                .data(x1.ticks( ticks ? ticks : (availableWidth / 50) ), function(d) {
	                    return this.textContent || format(d);
	                });
	
	            // Initialize the ticks with the old scale, x0.
	            var tickEnter = tick.enter().append('g')
	                .attr('class', 'nv-tick')
	                .attr('transform', function(d) { return 'translate(' + x0(d) + ',0)' })
	                .style('opacity', 1e-6);
	
	            tickEnter.append('line')
	                .attr('y1', availableHeight)
	                .attr('y2', availableHeight * 7 / 6);
	
	            tickEnter.append('text')
	                .attr('text-anchor', 'middle')
	                .attr('dy', '1em')
	                .attr('y', availableHeight * 7 / 6)
	                .text(format);
	
	            // Transition the updating ticks to the new scale, x1.
	            var tickUpdate = d3.transition(tick)
	                .transition()
	                .duration(bullet.duration())
	                .attr('transform', function(d) { return 'translate(' + x1(d) + ',0)' })
	                .style('opacity', 1);
	
	            tickUpdate.select('line')
	                .attr('y1', availableHeight)
	                .attr('y2', availableHeight * 7 / 6);
	
	            tickUpdate.select('text')
	                .attr('y', availableHeight * 7 / 6);
	
	            // Transition the exiting ticks to the new scale, x1.
	            d3.transition(tick.exit())
	                .transition()
	                .duration(bullet.duration())
	                .attr('transform', function(d) { return 'translate(' + x1(d) + ',0)' })
	                .style('opacity', 1e-6)
	                .remove();
	        });
	
	        d3.timer.flush();
	        return chart;
	    }
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    bullet.dispatch.on('elementMouseover.tooltip', function(evt) {
	        evt['series'] = {
	            key: evt.label,
	            value: evt.value,
	            color: evt.color
	        };
	        tooltip.data(evt).hidden(false);
	    });
	
	    bullet.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true);
	    });
	
	    bullet.dispatch.on('elementMousemove.tooltip', function(evt) {
	        tooltip();
	    });
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.bullet = bullet;
	    chart.dispatch = dispatch;
	    chart.tooltip = tooltip;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        ranges:      {get: function(){return ranges;}, set: function(_){ranges=_;}}, // ranges (bad, satisfactory, good)
	        markers:     {get: function(){return markers;}, set: function(_){markers=_;}}, // markers (previous, goal)
	        measures: {get: function(){return measures;}, set: function(_){measures=_;}}, // measures (actual, forecast)
	        width:    {get: function(){return width;}, set: function(_){width=_;}},
	        height:    {get: function(){return height;}, set: function(_){height=_;}},
	        tickFormat:    {get: function(){return tickFormat;}, set: function(_){tickFormat=_;}},
	        ticks:    {get: function(){return ticks;}, set: function(_){ticks=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        orient: {get: function(){return orient;}, set: function(_){ // left, right, top, bottom
	            orient = _;
	            reverse = orient == 'right' || orient == 'bottom';
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, bullet);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	
	
	nv.models.candlestickBar = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = null
	        , height = null
	        , id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
	        , container
	        , x = d3.scale.linear()
	        , y = d3.scale.linear()
	        , getX = function(d) { return d.x }
	        , getY = function(d) { return d.y }
	        , getOpen = function(d) { return d.open }
	        , getClose = function(d) { return d.close }
	        , getHigh = function(d) { return d.high }
	        , getLow = function(d) { return d.low }
	        , forceX = []
	        , forceY = []
	        , padData     = false // If true, adds half a data points width to front and back, for lining up a line chart with a bar chart
	        , clipEdge = true
	        , color = nv.utils.defaultColor()
	        , interactive = false
	        , xDomain
	        , yDomain
	        , xRange
	        , yRange
	        , dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd', 'chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove')
	        ;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    function chart(selection) {
	        selection.each(function(data) {
	            container = d3.select(this);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            nv.utils.initSVG(container);
	
	            // Width of the candlestick bars.
	            var barWidth = (availableWidth / data[0].values.length) * .45;
	
	            // Setup Scales
	            x.domain(xDomain || d3.extent(data[0].values.map(getX).concat(forceX) ));
	
	            if (padData)
	                x.range(xRange || [availableWidth * .5 / data[0].values.length, availableWidth * (data[0].values.length - .5)  / data[0].values.length ]);
	            else
	                x.range(xRange || [5 + barWidth / 2, availableWidth - barWidth / 2 - 5]);
	
	            y.domain(yDomain || [
	                    d3.min(data[0].values.map(getLow).concat(forceY)),
	                    d3.max(data[0].values.map(getHigh).concat(forceY))
	                ]
	            ).range(yRange || [availableHeight, 0]);
	
	            // If scale's domain don't have a range, slightly adjust to make one... so a chart can show a single data point
	            if (x.domain()[0] === x.domain()[1])
	                x.domain()[0] ?
	                    x.domain([x.domain()[0] - x.domain()[0] * 0.01, x.domain()[1] + x.domain()[1] * 0.01])
	                    : x.domain([-1,1]);
	
	            if (y.domain()[0] === y.domain()[1])
	                y.domain()[0] ?
	                    y.domain([y.domain()[0] + y.domain()[0] * 0.01, y.domain()[1] - y.domain()[1] * 0.01])
	                    : y.domain([-1,1]);
	
	            // Setup containers and skeleton of chart
	            var wrap = d3.select(this).selectAll('g.nv-wrap.nv-candlestickBar').data([data[0].values]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-candlestickBar');
	            var defsEnter = wrapEnter.append('defs');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-ticks');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            container
	                .on('click', function(d,i) {
	                    dispatch.chartClick({
	                        data: d,
	                        index: i,
	                        pos: d3.event,
	                        id: id
	                    });
	                });
	
	            defsEnter.append('clipPath')
	                .attr('id', 'nv-chart-clip-path-' + id)
	                .append('rect');
	
	            wrap.select('#nv-chart-clip-path-' + id + ' rect')
	                .attr('width', availableWidth)
	                .attr('height', availableHeight);
	
	            g   .attr('clip-path', clipEdge ? 'url(#nv-chart-clip-path-' + id + ')' : '');
	
	            var ticks = wrap.select('.nv-ticks').selectAll('.nv-tick')
	                .data(function(d) { return d });
	            ticks.exit().remove();
	
	            var tickGroups = ticks.enter().append('g');
	
	            // The colors are currently controlled by CSS.
	            ticks
	                .attr('class', function(d, i, j) { return (getOpen(d, i) > getClose(d, i) ? 'nv-tick negative' : 'nv-tick positive') + ' nv-tick-' + j + '-' + i});
	
	            var lines = tickGroups.append('line')
	                .attr('class', 'nv-candlestick-lines')
	                .attr('transform', function(d, i) { return 'translate(' + x(getX(d, i)) + ',0)'; })
	                .attr('x1', 0)
	                .attr('y1', function(d, i) { return y(getHigh(d, i)); })
	                .attr('x2', 0)
	                .attr('y2', function(d, i) { return y(getLow(d, i)); });
	
	            var rects = tickGroups.append('rect')
	                .attr('class', 'nv-candlestick-rects nv-bars')
	                .attr('transform', function(d, i) {
	                    return 'translate(' + (x(getX(d, i)) - barWidth/2) + ','
	                    + (y(getY(d, i)) - (getOpen(d, i) > getClose(d, i) ? (y(getClose(d, i)) - y(getOpen(d, i))) : 0))
	                    + ')';
	                })
	                .attr('x', 0)
	                .attr('y', 0)
	                .attr('width', barWidth)
	                .attr('height', function(d, i) {
	                    var open = getOpen(d, i);
	                    var close = getClose(d, i);
	                    return open > close ? y(close) - y(open) : y(open) - y(close);
	                });
	
	            ticks.select('.nv-candlestick-lines').transition()
	                .attr('transform', function(d, i) { return 'translate(' + x(getX(d, i)) + ',0)'; })
	                .attr('x1', 0)
	                .attr('y1', function(d, i) { return y(getHigh(d, i)); })
	                .attr('x2', 0)
	                .attr('y2', function(d, i) { return y(getLow(d, i)); });
	
	            ticks.select('.nv-candlestick-rects').transition()
	                .attr('transform', function(d, i) {
	                    return 'translate(' + (x(getX(d, i)) - barWidth/2) + ','
	                    + (y(getY(d, i)) - (getOpen(d, i) > getClose(d, i) ? (y(getClose(d, i)) - y(getOpen(d, i))) : 0))
	                    + ')';
	                })
	                .attr('x', 0)
	                .attr('y', 0)
	                .attr('width', barWidth)
	                .attr('height', function(d, i) {
	                    var open = getOpen(d, i);
	                    var close = getClose(d, i);
	                    return open > close ? y(close) - y(open) : y(open) - y(close);
	                });
	        });
	
	        return chart;
	    }
	
	
	    //Create methods to allow outside functions to highlight a specific bar.
	    chart.highlightPoint = function(pointIndex, isHoverOver) {
	        chart.clearHighlights();
	        container.select(".nv-candlestickBar .nv-tick-0-" + pointIndex)
	            .classed("hover", isHoverOver)
	        ;
	    };
	
	    chart.clearHighlights = function() {
	        container.select(".nv-candlestickBar .nv-tick.hover")
	            .classed("hover", false)
	        ;
	    };
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:    {get: function(){return width;}, set: function(_){width=_;}},
	        height:   {get: function(){return height;}, set: function(_){height=_;}},
	        xScale:   {get: function(){return x;}, set: function(_){x=_;}},
	        yScale:   {get: function(){return y;}, set: function(_){y=_;}},
	        xDomain:  {get: function(){return xDomain;}, set: function(_){xDomain=_;}},
	        yDomain:  {get: function(){return yDomain;}, set: function(_){yDomain=_;}},
	        xRange:   {get: function(){return xRange;}, set: function(_){xRange=_;}},
	        yRange:   {get: function(){return yRange;}, set: function(_){yRange=_;}},
	        forceX:   {get: function(){return forceX;}, set: function(_){forceX=_;}},
	        forceY:   {get: function(){return forceY;}, set: function(_){forceY=_;}},
	        padData:  {get: function(){return padData;}, set: function(_){padData=_;}},
	        clipEdge: {get: function(){return clipEdge;}, set: function(_){clipEdge=_;}},
	        id:       {get: function(){return id;}, set: function(_){id=_;}},
	        interactive: {get: function(){return interactive;}, set: function(_){interactive=_;}},
	
	        x:     {get: function(){return getX;}, set: function(_){getX=_;}},
	        y:     {get: function(){return getY;}, set: function(_){getY=_;}},
	        open:  {get: function(){return getOpen();}, set: function(_){getOpen=_;}},
	        close: {get: function(){return getClose();}, set: function(_){getClose=_;}},
	        high:  {get: function(){return getHigh;}, set: function(_){getHigh=_;}},
	        low:   {get: function(){return getLow;}, set: function(_){getLow=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    != undefined ? _.top    : margin.top;
	            margin.right  = _.right  != undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom != undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   != undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	    return chart;
	};
	
	nv.models.cumulativeLineChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var lines = nv.models.line()
	        , xAxis = nv.models.axis()
	        , yAxis = nv.models.axis()
	        , legend = nv.models.legend()
	        , controls = nv.models.legend()
	        , interactiveLayer = nv.interactiveGuideline()
	        , tooltip = nv.models.tooltip()
	        ;
	
	    var margin = {top: 30, right: 30, bottom: 50, left: 60}
	        , marginTop = null
	        , color = nv.utils.defaultColor()
	        , width = null
	        , height = null
	        , showLegend = true
	        , showXAxis = true
	        , showYAxis = true
	        , rightAlignYAxis = false
	        , showControls = true
	        , useInteractiveGuideline = false
	        , rescaleY = true
	        , x //can be accessed via chart.xScale()
	        , y //can be accessed via chart.yScale()
	        , id = lines.id()
	        , state = nv.utils.state()
	        , defaultState = null
	        , noData = null
	        , average = function(d) { return d.average }
	        , dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd')
	        , transitionDuration = 250
	        , duration = 250
	        , noErrorCheck = false  //if set to TRUE, will bypass an error check in the indexify function.
	        ;
	
	    state.index = 0;
	    state.rescaleY = rescaleY;
	
	    xAxis.orient('bottom').tickPadding(7);
	    yAxis.orient((rightAlignYAxis) ? 'right' : 'left');
	
	    tooltip.valueFormatter(function(d, i) {
	        return yAxis.tickFormat()(d, i);
	    }).headerFormatter(function(d, i) {
	        return xAxis.tickFormat()(d, i);
	    });
	
	    controls.updateState(false);
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var dx = d3.scale.linear()
	        , index = {i: 0, x: 0}
	        , renderWatch = nv.utils.renderWatch(dispatch, duration)
	        , currentYDomain
	        ;
	
	    var stateGetter = function(data) {
	        return function(){
	            return {
	                active: data.map(function(d) { return !d.disabled }),
	                index: index.i,
	                rescaleY: rescaleY
	            };
	        }
	    };
	
	    var stateSetter = function(data) {
	        return function(state) {
	            if (state.index !== undefined)
	                index.i = state.index;
	            if (state.rescaleY !== undefined)
	                rescaleY = state.rescaleY;
	            if (state.active !== undefined)
	                data.forEach(function(series,i) {
	                    series.disabled = !state.active[i];
	                });
	        }
	    };
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(lines);
	        if (showXAxis) renderWatch.models(xAxis);
	        if (showYAxis) renderWatch.models(yAxis);
	        selection.each(function(data) {
	            var container = d3.select(this);
	            nv.utils.initSVG(container);
	            container.classed('nv-chart-' + id, true);
	            var that = this;
	
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            chart.update = function() {
	                if (duration === 0)
	                    container.call(chart);
	                else
	                    container.transition().duration(duration).call(chart)
	            };
	            chart.container = this;
	
	            state
	                .setter(stateSetter(data), chart.update)
	                .getter(stateGetter(data))
	                .update();
	
	            // DEPRECATED set state.disableddisabled
	            state.disabled = data.map(function(d) { return !!d.disabled });
	
	            if (!defaultState) {
	                var key;
	                defaultState = {};
	                for (key in state) {
	                    if (state[key] instanceof Array)
	                        defaultState[key] = state[key].slice(0);
	                    else
	                        defaultState[key] = state[key];
	                }
	            }
	
	            var indexDrag = d3.behavior.drag()
	                .on('dragstart', dragStart)
	                .on('drag', dragMove)
	                .on('dragend', dragEnd);
	
	
	            function dragStart(d,i) {
	                d3.select(chart.container)
	                    .style('cursor', 'ew-resize');
	            }
	
	            function dragMove(d,i) {
	                index.x = d3.event.x;
	                index.i = Math.round(dx.invert(index.x));
	                updateZero();
	            }
	
	            function dragEnd(d,i) {
	                d3.select(chart.container)
	                    .style('cursor', 'auto');
	
	                // update state and send stateChange with new index
	                state.index = index.i;
	                dispatch.stateChange(state);
	            }
	
	            // Display No Data message if there's nothing to show.
	            if (!data || !data.length || !data.filter(function(d) { return d.values.length }).length) {
	                nv.utils.noData(chart, container)
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            // Setup Scales
	            x = lines.xScale();
	            y = lines.yScale();
	
	
	            dx.domain([0, data[0].values.length - 1]) //Assumes all series have same length
	                .range([0, availableWidth])
	                .clamp(true);
	
	            var data = indexify(index.i, data);
	
	            // initialize the starting yDomain for the not-rescale case after indexify (to have calculated point.display)
	            if (typeof(currentYDomain) === "undefined") {
	                currentYDomain = getCurrentYDomain(data);
	            }
	
	            if (!rescaleY) {
	                lines.yDomain(currentYDomain);
	                lines.clipEdge(true);
	            } else {
	                lines.yDomain(null);
	            }
	
	            // Setup containers and skeleton of chart
	            var interactivePointerEvents = (useInteractiveGuideline) ? "none" : "all";
	            var wrap = container.selectAll('g.nv-wrap.nv-cumulativeLine').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-cumulativeLine').append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-interactive');
	            gEnter.append('g').attr('class', 'nv-x nv-axis').style("pointer-events","none");
	            gEnter.append('g').attr('class', 'nv-y nv-axis');
	            gEnter.append('g').attr('class', 'nv-background');
	            gEnter.append('g').attr('class', 'nv-linesWrap').style("pointer-events",interactivePointerEvents);
	            gEnter.append('g').attr('class', 'nv-avgLinesWrap').style("pointer-events","none");
	            gEnter.append('g').attr('class', 'nv-legendWrap');
	            gEnter.append('g').attr('class', 'nv-controlsWrap');
	
	            // Legend
	            if (!showLegend) {
	                g.select('.nv-legendWrap').selectAll('*').remove();
	            } else {
	                legend.width(availableWidth);
	
	                g.select('.nv-legendWrap')
	                    .datum(data)
	                    .call(legend);
	
	                if (!marginTop && legend.height() !== margin.top) {
	                    margin.top = legend.height();
	                    availableHeight = nv.utils.availableHeight(height, container, margin);
	                }
	
	                g.select('.nv-legendWrap')
	                    .attr('transform', 'translate(0,' + (-margin.top) +')')
	            }
	
	            // Controls
	            if (!showControls) {
	                 g.select('.nv-controlsWrap').selectAll('*').remove();
	            } else {
	                var controlsData = [
	                    { key: 'Re-scale y-axis', disabled: !rescaleY }
	                ];
	
	                controls
	                    .width(140)
	                    .color(['#444', '#444', '#444'])
	                    .rightAlign(false)
	                    .margin({top: 5, right: 0, bottom: 5, left: 20})
	                ;
	
	                g.select('.nv-controlsWrap')
	                    .datum(controlsData)
	                    .attr('transform', 'translate(0,' + (-margin.top) +')')
	                    .call(controls);
	            }
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            if (rightAlignYAxis) {
	                g.select(".nv-y.nv-axis")
	                    .attr("transform", "translate(" + availableWidth + ",0)");
	            }
	
	            // Show error if index point value is 0 (division by zero avoided)
	            var tempDisabled = data.filter(function(d) { return d.tempDisabled });
	
	            wrap.select('.tempDisabled').remove(); //clean-up and prevent duplicates
	            if (tempDisabled.length) {
	                wrap.append('text').attr('class', 'tempDisabled')
	                    .attr('x', availableWidth / 2)
	                    .attr('y', '-.71em')
	                    .style('text-anchor', 'end')
	                    .text(tempDisabled.map(function(d) { return d.key }).join(', ') + ' values cannot be calculated for this time period.');
	            }
	
	            //Set up interactive layer
	            if (useInteractiveGuideline) {
	                interactiveLayer
	                    .width(availableWidth)
	                    .height(availableHeight)
	                    .margin({left:margin.left,top:margin.top})
	                    .svgContainer(container)
	                    .xScale(x);
	                wrap.select(".nv-interactive").call(interactiveLayer);
	            }
	
	            gEnter.select('.nv-background')
	                .append('rect');
	
	            g.select('.nv-background rect')
	                .attr('width', availableWidth)
	                .attr('height', availableHeight);
	
	            lines
	                //.x(function(d) { return d.x })
	                .y(function(d) { return d.display.y })
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(data.map(function(d,i) {
	                    return d.color || color(d, i);
	                }).filter(function(d,i) { return !data[i].disabled && !data[i].tempDisabled; }));
	
	            var linesWrap = g.select('.nv-linesWrap')
	                .datum(data.filter(function(d) { return  !d.disabled && !d.tempDisabled }));
	
	            linesWrap.call(lines);
	
	            //Store a series index number in the data array.
	            data.forEach(function(d,i) {
	                d.seriesIndex = i;
	            });
	
	            var avgLineData = data.filter(function(d) {
	                return !d.disabled && !!average(d);
	            });
	
	            var avgLines = g.select(".nv-avgLinesWrap").selectAll("line")
	                .data(avgLineData, function(d) { return d.key; });
	
	            var getAvgLineY = function(d) {
	                //If average lines go off the svg element, clamp them to the svg bounds.
	                var yVal = y(average(d));
	                if (yVal < 0) return 0;
	                if (yVal > availableHeight) return availableHeight;
	                return yVal;
	            };
	
	            avgLines.enter()
	                .append('line')
	                .style('stroke-width',2)
	                .style('stroke-dasharray','10,10')
	                .style('stroke',function (d,i) {
	                    return lines.color()(d,d.seriesIndex);
	                })
	                .attr('x1',0)
	                .attr('x2',availableWidth)
	                .attr('y1', getAvgLineY)
	                .attr('y2', getAvgLineY);
	
	            avgLines
	                .style('stroke-opacity',function(d){
	                    //If average lines go offscreen, make them transparent
	                    var yVal = y(average(d));
	                    if (yVal < 0 || yVal > availableHeight) return 0;
	                    return 1;
	                })
	                .attr('x1',0)
	                .attr('x2',availableWidth)
	                .attr('y1', getAvgLineY)
	                .attr('y2', getAvgLineY);
	
	            avgLines.exit().remove();
	
	            //Create index line
	            var indexLine = linesWrap.selectAll('.nv-indexLine')
	                .data([index]);
	            indexLine.enter().append('rect').attr('class', 'nv-indexLine')
	                .attr('width', 3)
	                .attr('x', -2)
	                .attr('fill', 'red')
	                .attr('fill-opacity', .5)
	                .style("pointer-events","all")
	                .call(indexDrag);
	
	            indexLine
	                .attr('transform', function(d) { return 'translate(' + dx(d.i) + ',0)' })
	                .attr('height', availableHeight);
	
	            // Setup Axes
	            if (showXAxis) {
	                xAxis
	                    .scale(x)
	                    ._ticks( nv.utils.calcTicksX(availableWidth/70, data) )
	                    .tickSize(-availableHeight, 0);
	
	                g.select('.nv-x.nv-axis')
	                    .attr('transform', 'translate(0,' + y.range()[0] + ')');
	                g.select('.nv-x.nv-axis')
	                    .call(xAxis);
	            }
	
	            if (showYAxis) {
	                yAxis
	                    .scale(y)
	                    ._ticks( nv.utils.calcTicksY(availableHeight/36, data) )
	                    .tickSize( -availableWidth, 0);
	
	                g.select('.nv-y.nv-axis')
	                    .call(yAxis);
	            }
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            function updateZero() {
	                indexLine
	                    .data([index]);
	
	                //When dragging the index line, turn off line transitions.
	                // Then turn them back on when done dragging.
	                var oldDuration = chart.duration();
	                chart.duration(0);
	                chart.update();
	                chart.duration(oldDuration);
	            }
	
	            g.select('.nv-background rect')
	                .on('click', function() {
	                    index.x = d3.mouse(this)[0];
	                    index.i = Math.round(dx.invert(index.x));
	
	                    // update state and send stateChange with new index
	                    state.index = index.i;
	                    dispatch.stateChange(state);
	
	                    updateZero();
	                });
	
	            lines.dispatch.on('elementClick', function(e) {
	                index.i = e.pointIndex;
	                index.x = dx(index.i);
	
	                // update state and send stateChange with new index
	                state.index = index.i;
	                dispatch.stateChange(state);
	
	                updateZero();
	            });
	
	            controls.dispatch.on('legendClick', function(d,i) {
	                d.disabled = !d.disabled;
	                rescaleY = !d.disabled;
	                state.rescaleY = rescaleY;
	                if (!rescaleY) {
	                    currentYDomain = getCurrentYDomain(data); // rescale is turned off, so set the currentYDomain
	                }
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            legend.dispatch.on('stateChange', function(newState) {
	                for (var key in newState)
	                    state[key] = newState[key];
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            interactiveLayer.dispatch.on('elementMousemove', function(e) {
	                lines.clearHighlights();
	                var singlePoint, pointIndex, pointXLocation, allData = [];
	
	                data
	                    .filter(function(series, i) {
	                        series.seriesIndex = i;
	                        return !(series.disabled || series.tempDisabled);
	                    })
	                    .forEach(function(series,i) {
	                        pointIndex = nv.interactiveBisect(series.values, e.pointXValue, chart.x());
	                        lines.highlightPoint(i, pointIndex, true);
	                        var point = series.values[pointIndex];
	                        if (typeof point === 'undefined') return;
	                        if (typeof singlePoint === 'undefined') singlePoint = point;
	                        if (typeof pointXLocation === 'undefined') pointXLocation = chart.xScale()(chart.x()(point,pointIndex));
	                        allData.push({
	                            key: series.key,
	                            value: chart.y()(point, pointIndex),
	                            color: color(series,series.seriesIndex)
	                        });
	                    });
	
	                //Highlight the tooltip entry based on which point the mouse is closest to.
	                if (allData.length > 2) {
	                    var yValue = chart.yScale().invert(e.mouseY);
	                    var domainExtent = Math.abs(chart.yScale().domain()[0] - chart.yScale().domain()[1]);
	                    var threshold = 0.03 * domainExtent;
	                    var indexToHighlight = nv.nearestValueIndex(allData.map(function(d){return d.value}),yValue,threshold);
	                    if (indexToHighlight !== null)
	                        allData[indexToHighlight].highlight = true;
	                }
	
	                var xValue = xAxis.tickFormat()(chart.x()(singlePoint,pointIndex), pointIndex);
	                interactiveLayer.tooltip
	                    .valueFormatter(function(d,i) {
	                        return yAxis.tickFormat()(d);
	                    })
	                    .data(
	                    {
	                        value: xValue,
	                        series: allData
	                    }
	                )();
	
	                interactiveLayer.renderGuideLine(pointXLocation);
	            });
	
	            interactiveLayer.dispatch.on("elementMouseout",function(e) {
	                lines.clearHighlights();
	            });
	
	            // Update chart from a state object passed to event handler
	            dispatch.on('changeState', function(e) {
	                if (typeof e.disabled !== 'undefined') {
	                    data.forEach(function(series,i) {
	                        series.disabled = e.disabled[i];
	                    });
	
	                    state.disabled = e.disabled;
	                }
	
	                if (typeof e.index !== 'undefined') {
	                    index.i = e.index;
	                    index.x = dx(index.i);
	
	                    state.index = e.index;
	
	                    indexLine
	                        .data([index]);
	                }
	
	                if (typeof e.rescaleY !== 'undefined') {
	                    rescaleY = e.rescaleY;
	                }
	
	                chart.update();
	            });
	
	        });
	
	        renderWatch.renderEnd('cumulativeLineChart immediate');
	
	        return chart;
	    }
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    lines.dispatch.on('elementMouseover.tooltip', function(evt) {
	        var point = {
	            x: chart.x()(evt.point),
	            y: chart.y()(evt.point),
	            color: evt.point.color
	        };
	        evt.point = point;
	        tooltip.data(evt).hidden(false);
	    });
	
	    lines.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true)
	    });
	
	    //============================================================
	    // Functions
	    //------------------------------------------------------------
	
	    var indexifyYGetter = null;
	    /* Normalize the data according to an index point. */
	    function indexify(idx, data) {
	        if (!indexifyYGetter) indexifyYGetter = lines.y();
	        return data.map(function(line, i) {
	            if (!line.values) {
	                return line;
	            }
	            var indexValue = line.values[idx];
	            if (indexValue == null) {
	                return line;
	            }
	            var v = indexifyYGetter(indexValue, idx);
	
	            // avoid divide by zero
	            if (Math.abs(v) < 0.00001 && !noErrorCheck) {
	                line.tempDisabled = true;
	                return line;
	            }
	
	            line.tempDisabled = false;
	
	            line.values = line.values.map(function(point, pointIndex) {
	                point.display = {'y': (indexifyYGetter(point, pointIndex) - v) / v };
	                return point;
	            });
	
	            return line;
	        })
	    }
	
	    function getCurrentYDomain(data) {
	        var seriesDomains = data
	            .filter(function(series) { return !(series.disabled || series.tempDisabled)})
	            .map(function(series,i) {
	                return d3.extent(series.values, function (d) { return d.display.y });
	            });
	
	        return [
	            d3.min(seriesDomains, function(d) { return d[0] }),
	            d3.max(seriesDomains, function(d) { return d[1] })
	        ];
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.lines = lines;
	    chart.legend = legend;
	    chart.controls = controls;
	    chart.xAxis = xAxis;
	    chart.yAxis = yAxis;
	    chart.interactiveLayer = interactiveLayer;
	    chart.state = state;
	    chart.tooltip = tooltip;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        showControls:     {get: function(){return showControls;}, set: function(_){showControls=_;}},
	        showLegend: {get: function(){return showLegend;}, set: function(_){showLegend=_;}},
	        average: {get: function(){return average;}, set: function(_){average=_;}},
	        defaultState:    {get: function(){return defaultState;}, set: function(_){defaultState=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	        showXAxis:    {get: function(){return showXAxis;}, set: function(_){showXAxis=_;}},
	        showYAxis:    {get: function(){return showYAxis;}, set: function(_){showYAxis=_;}},
	        noErrorCheck:    {get: function(){return noErrorCheck;}, set: function(_){noErrorCheck=_;}},
	
	        // options that require extra logic in the setter
	        rescaleY:     {get: function(){return rescaleY;}, set: function(_){
	            rescaleY = _;
	            chart.state.rescaleY = _; // also update state
	        }},
	        margin: {get: function(){return margin;}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            legend.color(color);
	        }},
	        useInteractiveGuideline: {get: function(){return useInteractiveGuideline;}, set: function(_){
	            useInteractiveGuideline = _;
	            if (_ === true) {
	                chart.interactive(false);
	                chart.useVoronoi(false);
	            }
	        }},
	        rightAlignYAxis: {get: function(){return rightAlignYAxis;}, set: function(_){
	            rightAlignYAxis = _;
	            yAxis.orient( (_) ? 'right' : 'left');
	        }},
	        duration:    {get: function(){return duration;}, set: function(_){
	            duration = _;
	            lines.duration(duration);
	            xAxis.duration(duration);
	            yAxis.duration(duration);
	            renderWatch.reset(duration);
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, lines);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	//TODO: consider deprecating by adding necessary features to multiBar model
	nv.models.discreteBar = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = 960
	        , height = 500
	        , id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
	        , container
	        , x = d3.scale.ordinal()
	        , y = d3.scale.linear()
	        , getX = function(d) { return d.x }
	        , getY = function(d) { return d.y }
	        , forceY = [0] // 0 is forced by default.. this makes sense for the majority of bar graphs... user can always do chart.forceY([]) to remove
	        , color = nv.utils.defaultColor()
	        , showValues = false
	        , valueFormat = d3.format(',.2f')
	        , xDomain
	        , yDomain
	        , xRange
	        , yRange
	        , dispatch = d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd')
	        , rectClass = 'discreteBar'
	        , duration = 250
	        ;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var x0, y0;
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    function chart(selection) {
	        renderWatch.reset();
	        selection.each(function(data) {
	            var availableWidth = width - margin.left - margin.right,
	                availableHeight = height - margin.top - margin.bottom;
	
	            container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            //add series index to each data point for reference
	            data.forEach(function(series, i) {
	                series.values.forEach(function(point) {
	                    point.series = i;
	                });
	            });
	
	            // Setup Scales
	            // remap and flatten the data for use in calculating the scales' domains
	            var seriesData = (xDomain && yDomain) ? [] : // if we know xDomain and yDomain, no need to calculate
	                data.map(function(d) {
	                    return d.values.map(function(d,i) {
	                        return { x: getX(d,i), y: getY(d,i), y0: d.y0 }
	                    })
	                });
	
	            x   .domain(xDomain || d3.merge(seriesData).map(function(d) { return d.x }))
	                .rangeBands(xRange || [0, availableWidth], .1);
	            y   .domain(yDomain || d3.extent(d3.merge(seriesData).map(function(d) { return d.y }).concat(forceY)));
	
	            // If showValues, pad the Y axis range to account for label height
	            if (showValues) y.range(yRange || [availableHeight - (y.domain()[0] < 0 ? 12 : 0), y.domain()[1] > 0 ? 12 : 0]);
	            else y.range(yRange || [availableHeight, 0]);
	
	            //store old scales if they exist
	            x0 = x0 || x;
	            y0 = y0 || y.copy().range([y(0),y(0)]);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-discretebar').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-discretebar');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-groups');
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            //TODO: by definition, the discrete bar should not have multiple groups, will modify/remove later
	            var groups = wrap.select('.nv-groups').selectAll('.nv-group')
	                .data(function(d) { return d }, function(d) { return d.key });
	            groups.enter().append('g')
	                .style('stroke-opacity', 1e-6)
	                .style('fill-opacity', 1e-6);
	            groups.exit()
	                .watchTransition(renderWatch, 'discreteBar: exit groups')
	                .style('stroke-opacity', 1e-6)
	                .style('fill-opacity', 1e-6)
	                .remove();
	            groups
	                .attr('class', function(d,i) { return 'nv-group nv-series-' + i })
	                .classed('hover', function(d) { return d.hover });
	            groups
	                .watchTransition(renderWatch, 'discreteBar: groups')
	                .style('stroke-opacity', 1)
	                .style('fill-opacity', .75);
	
	            var bars = groups.selectAll('g.nv-bar')
	                .data(function(d) { return d.values });
	            bars.exit().remove();
	
	            var barsEnter = bars.enter().append('g')
	                .attr('transform', function(d,i,j) {
	                    return 'translate(' + (x(getX(d,i)) + x.rangeBand() * .05 ) + ', ' + y(0) + ')'
	                })
	                .on('mouseover', function(d,i) { //TODO: figure out why j works above, but not here
	                    d3.select(this).classed('hover', true);
	                    dispatch.elementMouseover({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('mouseout', function(d,i) {
	                    d3.select(this).classed('hover', false);
	                    dispatch.elementMouseout({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('mousemove', function(d,i) {
	                    dispatch.elementMousemove({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('click', function(d,i) {
	                    var element = this;
	                    dispatch.elementClick({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill"),
	                        event: d3.event,
	                        element: element
	                    });
	                    d3.event.stopPropagation();
	                })
	                .on('dblclick', function(d,i) {
	                    dispatch.elementDblClick({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                    d3.event.stopPropagation();
	                });
	
	            barsEnter.append('rect')
	                .attr('height', 0)
	                .attr('width', x.rangeBand() * .9 / data.length )
	
	            if (showValues) {
	                barsEnter.append('text')
	                    .attr('text-anchor', 'middle')
	                ;
	
	                bars.select('text')
	                    .text(function(d,i) { return valueFormat(getY(d,i)) })
	                    .watchTransition(renderWatch, 'discreteBar: bars text')
	                    .attr('x', x.rangeBand() * .9 / 2)
	                    .attr('y', function(d,i) { return getY(d,i) < 0 ? y(getY(d,i)) - y(0) + 12 : -4 })
	
	                ;
	            } else {
	                bars.selectAll('text').remove();
	            }
	
	            bars
	                .attr('class', function(d,i) { return getY(d,i) < 0 ? 'nv-bar negative' : 'nv-bar positive' })
	                .style('fill', function(d,i) { return d.color || color(d,i) })
	                .style('stroke', function(d,i) { return d.color || color(d,i) })
	                .select('rect')
	                .attr('class', rectClass)
	                .watchTransition(renderWatch, 'discreteBar: bars rect')
	                .attr('width', x.rangeBand() * .9 / data.length);
	            bars.watchTransition(renderWatch, 'discreteBar: bars')
	                //.delay(function(d,i) { return i * 1200 / data[0].values.length })
	                .attr('transform', function(d,i) {
	                    var left = x(getX(d,i)) + x.rangeBand() * .05,
	                        top = getY(d,i) < 0 ?
	                            y(0) :
	                                y(0) - y(getY(d,i)) < 1 ?
	                            y(0) - 1 : //make 1 px positive bars show up above y=0
	                            y(getY(d,i));
	
	                    return 'translate(' + left + ', ' + top + ')'
	                })
	                .select('rect')
	                .attr('height', function(d,i) {
	                    return  Math.max(Math.abs(y(getY(d,i)) - y(0)), 1)
	                });
	
	
	            //store old scales for use in transitions on update
	            x0 = x.copy();
	            y0 = y.copy();
	
	        });
	
	        renderWatch.renderEnd('discreteBar immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:   {get: function(){return width;}, set: function(_){width=_;}},
	        height:  {get: function(){return height;}, set: function(_){height=_;}},
	        forceY:  {get: function(){return forceY;}, set: function(_){forceY=_;}},
	        showValues: {get: function(){return showValues;}, set: function(_){showValues=_;}},
	        x:       {get: function(){return getX;}, set: function(_){getX=_;}},
	        y:       {get: function(){return getY;}, set: function(_){getY=_;}},
	        xScale:  {get: function(){return x;}, set: function(_){x=_;}},
	        yScale:  {get: function(){return y;}, set: function(_){y=_;}},
	        xDomain: {get: function(){return xDomain;}, set: function(_){xDomain=_;}},
	        yDomain: {get: function(){return yDomain;}, set: function(_){yDomain=_;}},
	        xRange:  {get: function(){return xRange;}, set: function(_){xRange=_;}},
	        yRange:  {get: function(){return yRange;}, set: function(_){yRange=_;}},
	        valueFormat:    {get: function(){return valueFormat;}, set: function(_){valueFormat=_;}},
	        id:          {get: function(){return id;}, set: function(_){id=_;}},
	        rectClass: {get: function(){return rectClass;}, set: function(_){rectClass=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.discreteBarChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var discretebar = nv.models.discreteBar()
	        , xAxis = nv.models.axis()
	        , yAxis = nv.models.axis()
		, legend = nv.models.legend()
	        , tooltip = nv.models.tooltip()
	        ;
	
	    var margin = {top: 15, right: 10, bottom: 50, left: 60}
	        , marginTop = null
	        , width = null
	        , height = null
	        , color = nv.utils.getColor()
		, showLegend = false
	        , showXAxis = true
	        , showYAxis = true
	        , rightAlignYAxis = false
	        , staggerLabels = false
	        , wrapLabels = false
	        , rotateLabels = 0
	        , x
	        , y
	        , noData = null
	        , dispatch = d3.dispatch('beforeUpdate','renderEnd')
	        , duration = 250
	        ;
	
	    xAxis
	        .orient('bottom')
	        .showMaxMin(false)
	        .tickFormat(function(d) { return d })
	    ;
	    yAxis
	        .orient((rightAlignYAxis) ? 'right' : 'left')
	        .tickFormat(d3.format(',.1f'))
	    ;
	
	    tooltip
	        .duration(0)
	        .headerEnabled(false)
	        .valueFormatter(function(d, i) {
	            return yAxis.tickFormat()(d, i);
	        })
	        .keyFormatter(function(d, i) {
	            return xAxis.tickFormat()(d, i);
	        });
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(discretebar);
	        if (showXAxis) renderWatch.models(xAxis);
	        if (showYAxis) renderWatch.models(yAxis);
	
	        selection.each(function(data) {
	            var container = d3.select(this),
	                that = this;
	            nv.utils.initSVG(container);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            chart.update = function() {
	                dispatch.beforeUpdate();
	                container.transition().duration(duration).call(chart);
	            };
	            chart.container = this;
	
	            // Display No Data message if there's nothing to show.
	            if (!data || !data.length || !data.filter(function(d) { return d.values.length }).length) {
	                nv.utils.noData(chart, container);
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            // Setup Scales
	            x = discretebar.xScale();
	            y = discretebar.yScale().clamp(true);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-discreteBarWithAxes').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-discreteBarWithAxes').append('g');
	            var defsEnter = gEnter.append('defs');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-x nv-axis');
	            gEnter.append('g').attr('class', 'nv-y nv-axis')
	                .append('g').attr('class', 'nv-zeroLine')
	                .append('line');
	
	            gEnter.append('g').attr('class', 'nv-barsWrap');
		    gEnter.append('g').attr('class', 'nv-legendWrap');
	
	            g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            // Legend
	            if (!showLegend) {
	                g.select('.nv-legendWrap').selectAll('*').remove();
	            } else {
	                legend.width(availableWidth);
	
	                g.select('.nv-legendWrap')
	                    .datum(data)
	                    .call(legend);
	
	                if (!marginTop && legend.height() !== margin.top) {
	                    margin.top = legend.height();
	                    availableHeight = nv.utils.availableHeight(height, container, margin);
	                }
	
	                wrap.select('.nv-legendWrap')
	                    .attr('transform', 'translate(0,' + (-margin.top) +')')
	            }
	
	            if (rightAlignYAxis) {
	                g.select(".nv-y.nv-axis")
	                    .attr("transform", "translate(" + availableWidth + ",0)");
	            }
	
	            // Main Chart Component(s)
	            discretebar
	                .width(availableWidth)
	                .height(availableHeight);
	
	            var barsWrap = g.select('.nv-barsWrap')
	                .datum(data.filter(function(d) { return !d.disabled }));
	
	            barsWrap.transition().call(discretebar);
	
	
	            defsEnter.append('clipPath')
	                .attr('id', 'nv-x-label-clip-' + discretebar.id())
	                .append('rect');
	
	            g.select('#nv-x-label-clip-' + discretebar.id() + ' rect')
	                .attr('width', x.rangeBand() * (staggerLabels ? 2 : 1))
	                .attr('height', 16)
	                .attr('x', -x.rangeBand() / (staggerLabels ? 1 : 2 ));
	
	            // Setup Axes
	            if (showXAxis) {
	                xAxis
	                    .scale(x)
	                    ._ticks( nv.utils.calcTicksX(availableWidth/100, data) )
	                    .tickSize(-availableHeight, 0);
	
	                g.select('.nv-x.nv-axis')
	                    .attr('transform', 'translate(0,' + (y.range()[0] + ((discretebar.showValues() && y.domain()[0] < 0) ? 16 : 0)) + ')');
	                g.select('.nv-x.nv-axis').call(xAxis);
	
	                var xTicks = g.select('.nv-x.nv-axis').selectAll('g');
	                if (staggerLabels) {
	                    xTicks
	                        .selectAll('text')
	                        .attr('transform', function(d,i,j) { return 'translate(0,' + (j % 2 == 0 ? '5' : '17') + ')' })
	                }
	
	                if (rotateLabels) {
	                    xTicks
	                        .selectAll('.tick text')
	                        .attr('transform', 'rotate(' + rotateLabels + ' 0,0)')
	                        .style('text-anchor', rotateLabels > 0 ? 'start' : 'end');
	                }
	
	                if (wrapLabels) {
	                    g.selectAll('.tick text')
	                        .call(nv.utils.wrapTicks, chart.xAxis.rangeBand())
	                }
	            }
	
	            if (showYAxis) {
	                yAxis
	                    .scale(y)
	                    ._ticks( nv.utils.calcTicksY(availableHeight/36, data) )
	                    .tickSize( -availableWidth, 0);
	
	                g.select('.nv-y.nv-axis').call(yAxis);
	            }
	
	            // Zero line
	            g.select(".nv-zeroLine line")
	                .attr("x1",0)
	                .attr("x2",(rightAlignYAxis) ? -availableWidth : availableWidth)
	                .attr("y1", y(0))
	                .attr("y2", y(0))
	            ;
	        });
	
	        renderWatch.renderEnd('discreteBar chart immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    discretebar.dispatch.on('elementMouseover.tooltip', function(evt) {
	        evt['series'] = {
	            key: chart.x()(evt.data),
	            value: chart.y()(evt.data),
	            color: evt.color
	        };
	        tooltip.data(evt).hidden(false);
	    });
	
	    discretebar.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true);
	    });
	
	    discretebar.dispatch.on('elementMousemove.tooltip', function(evt) {
	        tooltip();
	    });
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.discretebar = discretebar;
	    chart.legend = legend;
	    chart.xAxis = xAxis;
	    chart.yAxis = yAxis;
	    chart.tooltip = tooltip;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
		showLegend: {get: function(){return showLegend;}, set: function(_){showLegend=_;}},
	        staggerLabels: {get: function(){return staggerLabels;}, set: function(_){staggerLabels=_;}},
	        rotateLabels:  {get: function(){return rotateLabels;}, set: function(_){rotateLabels=_;}},
	        wrapLabels:  {get: function(){return wrapLabels;}, set: function(_){wrapLabels=!!_;}},
	        showXAxis: {get: function(){return showXAxis;}, set: function(_){showXAxis=_;}},
	        showYAxis: {get: function(){return showYAxis;}, set: function(_){showYAxis=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	            discretebar.duration(duration);
	            xAxis.duration(duration);
	            yAxis.duration(duration);
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            discretebar.color(color);
		    legend.color(color);
	        }},
	        rightAlignYAxis: {get: function(){return rightAlignYAxis;}, set: function(_){
	            rightAlignYAxis = _;
	            yAxis.orient( (_) ? 'right' : 'left');
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, discretebar);
	    nv.utils.initOptions(chart);
	
	    return chart;
	}
	
	nv.models.distribution = function() {
	    "use strict";
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = 400 //technically width or height depending on x or y....
	        , size = 8
	        , axis = 'x' // 'x' or 'y'... horizontal or vertical
	        , getData = function(d) { return d[axis] }  // defaults d.x or d.y
	        , color = nv.utils.defaultColor()
	        , scale = d3.scale.linear()
	        , domain
	        , duration = 250
	        , dispatch = d3.dispatch('renderEnd')
	        ;
	
	    //============================================================
	
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var scale0;
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    //============================================================
	
	
	    function chart(selection) {
	        renderWatch.reset();
	        selection.each(function(data) {
	            var availableLength = width - (axis === 'x' ? margin.left + margin.right : margin.top + margin.bottom),
	                naxis = axis == 'x' ? 'y' : 'x',
	                container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            //------------------------------------------------------------
	            // Setup Scales
	
	            scale0 = scale0 || scale;
	
	            //------------------------------------------------------------
	
	
	            //------------------------------------------------------------
	            // Setup containers and skeleton of chart
	
	            var wrap = container.selectAll('g.nv-distribution').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-distribution');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
	
	            //------------------------------------------------------------
	
	
	            var distWrap = g.selectAll('g.nv-dist')
	                .data(function(d) { return d }, function(d) { return d.key });
	
	            distWrap.enter().append('g');
	            distWrap
	                .attr('class', function(d,i) { return 'nv-dist nv-series-' + i })
	                .style('stroke', function(d,i) { return color(d, i) });
	
	            var dist = distWrap.selectAll('line.nv-dist' + axis)
	                .data(function(d) { return d.values })
	            dist.enter().append('line')
	                .attr(axis + '1', function(d,i) { return scale0(getData(d,i)) })
	                .attr(axis + '2', function(d,i) { return scale0(getData(d,i)) })
	            renderWatch.transition(distWrap.exit().selectAll('line.nv-dist' + axis), 'dist exit')
	                // .transition()
	                .attr(axis + '1', function(d,i) { return scale(getData(d,i)) })
	                .attr(axis + '2', function(d,i) { return scale(getData(d,i)) })
	                .style('stroke-opacity', 0)
	                .remove();
	            dist
	                .attr('class', function(d,i) { return 'nv-dist' + axis + ' nv-dist' + axis + '-' + i })
	                .attr(naxis + '1', 0)
	                .attr(naxis + '2', size);
	            renderWatch.transition(dist, 'dist')
	                // .transition()
	                .attr(axis + '1', function(d,i) { return scale(getData(d,i)) })
	                .attr(axis + '2', function(d,i) { return scale(getData(d,i)) })
	
	
	            scale0 = scale.copy();
	
	        });
	        renderWatch.renderEnd('distribution immediate');
	        return chart;
	    }
	
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	    chart.options = nv.utils.optionsFunc.bind(chart);
	    chart.dispatch = dispatch;
	
	    chart.margin = function(_) {
	        if (!arguments.length) return margin;
	        margin.top    = typeof _.top    != 'undefined' ? _.top    : margin.top;
	        margin.right  = typeof _.right  != 'undefined' ? _.right  : margin.right;
	        margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
	        margin.left   = typeof _.left   != 'undefined' ? _.left   : margin.left;
	        return chart;
	    };
	
	    chart.width = function(_) {
	        if (!arguments.length) return width;
	        width = _;
	        return chart;
	    };
	
	    chart.axis = function(_) {
	        if (!arguments.length) return axis;
	        axis = _;
	        return chart;
	    };
	
	    chart.size = function(_) {
	        if (!arguments.length) return size;
	        size = _;
	        return chart;
	    };
	
	    chart.getData = function(_) {
	        if (!arguments.length) return getData;
	        getData = d3.functor(_);
	        return chart;
	    };
	
	    chart.scale = function(_) {
	        if (!arguments.length) return scale;
	        scale = _;
	        return chart;
	    };
	
	    chart.color = function(_) {
	        if (!arguments.length) return color;
	        color = nv.utils.getColor(_);
	        return chart;
	    };
	
	    chart.duration = function(_) {
	        if (!arguments.length) return duration;
	        duration = _;
	        renderWatch.reset(duration);
	        return chart;
	    };
	    //============================================================
	
	
	    return chart;
	}
	nv.models.focus = function(content) {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var content = content || nv.models.line()
	        , xAxis = nv.models.axis()
	        , yAxis = nv.models.axis()
	        , brush = d3.svg.brush()
	        ;
	
	    var margin = {top: 10, right: 0, bottom: 30, left: 0}
	        , color = nv.utils.defaultColor()
	        , width = null
	        , height = 70
	        , showXAxis = true
	        , showYAxis = false
	        , rightAlignYAxis = false
	        , ticks = null
	        , x
	        , y
	        , brushExtent = null
	        , duration = 250
	        , dispatch = d3.dispatch('brush', 'onBrush', 'renderEnd')
	        , syncBrushing = true
	        ;
	
	    content.interactive(false);
	    content.pointActive(function(d) { return false; });
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(content);
	        if (showXAxis) renderWatch.models(xAxis);
	        if (showYAxis) renderWatch.models(yAxis);
	
	        selection.each(function(data) {
	            var container = d3.select(this);
	            nv.utils.initSVG(container);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = height - margin.top - margin.bottom;
	
	            chart.update = function() { 
	                if( duration === 0 ) {
	                    container.call( chart );
	                } else {
	                    container.transition().duration(duration).call(chart);
	                }
	            };
	            chart.container = this;
	
	            // Setup Scales
	            x = content.xScale();
	            y = content.yScale();
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-focus').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-focus').append('g');
	            var g = wrap.select('g');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            gEnter.append('g').attr('class', 'nv-background').append('rect');
	            gEnter.append('g').attr('class', 'nv-x nv-axis');
	            gEnter.append('g').attr('class', 'nv-y nv-axis');
	            gEnter.append('g').attr('class', 'nv-contentWrap');
	            gEnter.append('g').attr('class', 'nv-brushBackground');
	            gEnter.append('g').attr('class', 'nv-x nv-brush');
	
	            if (rightAlignYAxis) {
	                g.select(".nv-y.nv-axis")
	                    .attr("transform", "translate(" + availableWidth + ",0)");
	            }
	
	            g.select('.nv-background rect')
	                .attr('width', availableWidth)
	                .attr('height', availableHeight);
	                
	            content
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(data.map(function(d,i) {
	                    return d.color || color(d, i);
	                }).filter(function(d,i) { return !data[i].disabled; }));
	
	            var contentWrap = g.select('.nv-contentWrap')
	                .datum(data.filter(function(d) { return !d.disabled; }));
	
	            d3.transition(contentWrap).call(content);
	            
	            // Setup Brush
	            brush
	                .x(x)
	                .on('brush', function() {
	                    onBrush(syncBrushing);
	                });
	
	            brush.on('brushend', function () {
	                if (!syncBrushing) {
	                    dispatch.onBrush(brush.empty() ? x.domain() : brush.extent());
	                }
	            });
	
	            if (brushExtent) brush.extent(brushExtent);
	
	            var brushBG = g.select('.nv-brushBackground').selectAll('g')
	                .data([brushExtent || brush.extent()]);
	    
	            var brushBGenter = brushBG.enter()
	                .append('g');
	
	            brushBGenter.append('rect')
	                .attr('class', 'left')
	                .attr('x', 0)
	                .attr('y', 0)
	                .attr('height', availableHeight);
	
	            brushBGenter.append('rect')
	                .attr('class', 'right')
	                .attr('x', 0)
	                .attr('y', 0)
	                .attr('height', availableHeight);
	
	            var gBrush = g.select('.nv-x.nv-brush')
	                .call(brush);
	            gBrush.selectAll('rect')
	                .attr('height', availableHeight);
	            gBrush.selectAll('.resize').append('path').attr('d', resizePath);
	
	            onBrush(true);
	
	            g.select('.nv-background rect')
	                .attr('width', availableWidth)
	                .attr('height', availableHeight);
	
	            if (showXAxis) {
	                xAxis.scale(x)
	                    ._ticks( nv.utils.calcTicksX(availableWidth/100, data) )
	                    .tickSize(-availableHeight, 0);
	  
	                g.select('.nv-x.nv-axis')
	                    .attr('transform', 'translate(0,' + y.range()[0] + ')');
	                d3.transition(g.select('.nv-x.nv-axis'))
	                    .call(xAxis);
	            }
	
	            if (showYAxis) {
	                yAxis
	                    .scale(y)
	                    ._ticks( nv.utils.calcTicksY(availableHeight/36, data) )
	                    .tickSize( -availableWidth, 0);
	
	                d3.transition(g.select('.nv-y.nv-axis'))
	                    .call(yAxis);
	            }
	            
	            g.select('.nv-x.nv-axis')
	                .attr('transform', 'translate(0,' + y.range()[0] + ')');
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            //============================================================
	            // Functions
	            //------------------------------------------------------------
	    
	            // Taken from crossfilter (http://square.github.com/crossfilter/)
	            function resizePath(d) {
	                var e = +(d == 'e'),
	                    x = e ? 1 : -1,
	                    y = availableHeight / 3;
	                return 'M' + (0.5 * x) + ',' + y
	                    + 'A6,6 0 0 ' + e + ' ' + (6.5 * x) + ',' + (y + 6)
	                    + 'V' + (2 * y - 6)
	                    + 'A6,6 0 0 ' + e + ' ' + (0.5 * x) + ',' + (2 * y)
	                    + 'Z'
	                    + 'M' + (2.5 * x) + ',' + (y + 8)
	                    + 'V' + (2 * y - 8)
	                    + 'M' + (4.5 * x) + ',' + (y + 8)
	                    + 'V' + (2 * y - 8);
	            }
	    
	    
	            function updateBrushBG() {
	                if (!brush.empty()) brush.extent(brushExtent);
	                brushBG
	                    .data([brush.empty() ? x.domain() : brushExtent])
	                    .each(function(d,i) {
	                        var leftWidth = x(d[0]) - x.range()[0],
	                            rightWidth = availableWidth - x(d[1]);
	                        d3.select(this).select('.left')
	                            .attr('width',  leftWidth < 0 ? 0 : leftWidth);
	    
	                        d3.select(this).select('.right')
	                            .attr('x', x(d[1]))
	                            .attr('width', rightWidth < 0 ? 0 : rightWidth);
	                    });
	            }
	
	
	            function onBrush(shouldDispatch) {
	                brushExtent = brush.empty() ? null : brush.extent();
	                var extent = brush.empty() ? x.domain() : brush.extent();
	                dispatch.brush({extent: extent, brush: brush});
	                updateBrushBG();
	                if (shouldDispatch) {
	                    dispatch.onBrush(extent);
	                }
	            }
	        });
	
	        renderWatch.renderEnd('focus immediate');
	        return chart;
	    }
	
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.content = content;
	    chart.brush = brush;
	    chart.xAxis = xAxis;
	    chart.yAxis = yAxis;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        showXAxis:      {get: function(){return showXAxis;}, set: function(_){showXAxis=_;}},
	        showYAxis:    {get: function(){return showYAxis;}, set: function(_){showYAxis=_;}},
	        brushExtent: {get: function(){return brushExtent;}, set: function(_){brushExtent=_;}},
	        syncBrushing: {get: function(){return syncBrushing;}, set: function(_){syncBrushing=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	            content.duration(duration);
	            xAxis.duration(duration);
	            yAxis.duration(duration);
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            content.color(color);
	        }},
	        interpolate: {get: function(){return content.interpolate();}, set: function(_){
	            content.interpolate(_);
	        }},
	        xTickFormat: {get: function(){return xAxis.tickFormat();}, set: function(_){
	            xAxis.tickFormat(_);
	        }},
	        yTickFormat: {get: function(){return yAxis.tickFormat();}, set: function(_){
	            yAxis.tickFormat(_);
	        }},
	        x: {get: function(){return content.x();}, set: function(_){
	            content.x(_);
	        }},
	        y: {get: function(){return content.y();}, set: function(_){
	            content.y(_);
	        }},
	        rightAlignYAxis: {get: function(){return rightAlignYAxis;}, set: function(_){
	            rightAlignYAxis = _;
	            yAxis.orient( rightAlignYAxis ? 'right' : 'left');
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, content);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	nv.models.forceDirectedGraph = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	    var margin = {top: 2, right: 0, bottom: 2, left: 0}
	        , width = 400
	        , height = 32
	        , container = null
	        , dispatch = d3.dispatch('renderEnd')
	        , color = nv.utils.getColor(['#000'])
	        , tooltip      = nv.models.tooltip()
	        , noData = null
	        // Force directed graph specific parameters [default values]
	        , linkStrength = 0.1
	        , friction = 0.9
	        , linkDist = 30
	        , charge = -120
	        , gravity = 0.1
	        , theta = 0.8
	        , alpha = 0.1
	        , radius = 5
	        // These functions allow to add extra attributes to ndes and links
	        ,nodeExtras = function(nodes) { /* Do nothing */ }
	        ,linkExtras = function(links) { /* Do nothing */ }
	        , getX=d3.functor(0.0)
	        , getY=d3.functor(0.0)
	        ;
	
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch);
	
	    function chart(selection) {
	        renderWatch.reset();
	
	        selection.each(function(data) {
	          container = d3.select(this);
	          nv.utils.initSVG(container);
	
	          var availableWidth = nv.utils.availableWidth(width, container, margin),
	              availableHeight = nv.utils.availableHeight(height, container, margin);
	
	          container
	                  .attr("width", availableWidth)
	                  .attr("height", availableHeight);
	
	          // Display No Data message if there's nothing to show.
	          if (!data || !data.links || !data.nodes) {
	              nv.utils.noData(chart, container)
	              return chart;
	          } else {
	              container.selectAll('.nv-noData').remove();
	          }
	          container.selectAll('*').remove();
	
	          // Collect names of all fields in the nodes
	          var nodeFieldSet = new Set();
	          data.nodes.forEach(function(node) {
	            var keys = Object.keys(node);
	            keys.forEach(function(key) {
	              nodeFieldSet.add(key);
	            });
	          });
	
	          var force = d3.layout.force()
	                .nodes(data.nodes)
	                .links(data.links)
	                .size([availableWidth, availableHeight])
	                .linkStrength(linkStrength)
	                .friction(friction)
	                .linkDistance(linkDist)
	                .charge(charge)
	                .gravity(gravity)
	                .theta(theta)
	                .alpha(alpha)
	                .start();
	
	          var link = container.selectAll(".link")
	                .data(data.links)
	                .enter().append("line")
	                .attr("class", "nv-force-link")
	                .style("stroke-width", function(d) { return Math.sqrt(d.value); });
	
	          var node = container.selectAll(".node")
	                .data(data.nodes)
	                .enter()
	                .append("g")
	                .attr("class", "nv-force-node")
	                .call(force.drag);
	
	          node
	            .append("circle")
	            .attr("r", radius)
	            .style("fill", function(d) { return color(d) } )
	            .on("mouseover", function(evt) {
	              container.select('.nv-series-' + evt.seriesIndex + ' .nv-distx-' + evt.pointIndex)
	                  .attr('y1', evt.py);
	              container.select('.nv-series-' + evt.seriesIndex + ' .nv-disty-' + evt.pointIndex)
	                  .attr('x2', evt.px);
	
	              // Add 'series' object to
	              var nodeColor = color(evt);
	              evt.series = [];
	              nodeFieldSet.forEach(function(field) {
	                evt.series.push({
	                  color: nodeColor,
	                  key:   field,
	                  value: evt[field]
	                });
	              });
	              tooltip.data(evt).hidden(false);
	            })
	            .on("mouseout",  function(d) {
	              tooltip.hidden(true);
	            });
	
	          tooltip.headerFormatter(function(d) {return "Node";});
	
	          // Apply extra attributes to nodes and links (if any)
	          linkExtras(link);
	          nodeExtras(node);
	
	          force.on("tick", function() {
	              link.attr("x1", function(d) { return d.source.x; })
	                  .attr("y1", function(d) { return d.source.y; })
	                  .attr("x2", function(d) { return d.target.x; })
	                  .attr("y2", function(d) { return d.target.y; });
	
	              node.attr("transform", function(d) {
	                return "translate(" + d.x + ", " + d.y + ")";
	              });
	            });
	        });
	
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:     {get: function(){return width;}, set: function(_){width=_;}},
	        height:    {get: function(){return height;}, set: function(_){height=_;}},
	
	        // Force directed graph specific parameters
	        linkStrength:{get: function(){return linkStrength;}, set: function(_){linkStrength=_;}},
	        friction:    {get: function(){return friction;}, set: function(_){friction=_;}},
	        linkDist:    {get: function(){return linkDist;}, set: function(_){linkDist=_;}},
	        charge:      {get: function(){return charge;}, set: function(_){charge=_;}},
	        gravity:     {get: function(){return gravity;}, set: function(_){gravity=_;}},
	        theta:       {get: function(){return theta;}, set: function(_){theta=_;}},
	        alpha:       {get: function(){return alpha;}, set: function(_){alpha=_;}},
	        radius:      {get: function(){return radius;}, set: function(_){radius=_;}},
	
	        //functor options
	        x: {get: function(){return getX;}, set: function(_){getX=d3.functor(_);}},
	        y: {get: function(){return getY;}, set: function(_){getY=d3.functor(_);}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	        nodeExtras: {get: function(){return nodeExtras;}, set: function(_){
	            nodeExtras = _;
	        }},
	        linkExtras: {get: function(){return linkExtras;}, set: function(_){
	            linkExtras = _;
	        }}
	    });
	
	    chart.dispatch = dispatch;
	    chart.tooltip = tooltip;
	    nv.utils.initOptions(chart);
	    return chart;
	};
	nv.models.furiousLegend = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 5, right: 0, bottom: 5, left: 0}
	        , width = 400
	        , height = 20
	        , getKey = function(d) { return d.key }
	        , keyFormatter = function (d) { return d }
	        , color = nv.utils.getColor()
	        , maxKeyLength = 20 //default value for key lengths
	        , align = true
	        , padding = 28 //define how much space between legend items. - recommend 32 for furious version
	        , rightAlign = true
	        , updateState = true   //If true, legend will update data.disabled and trigger a 'stateChange' dispatch.
	        , radioButtonMode = false   //If true, clicking legend items will cause it to behave like a radio button. (only one can be selected at a time)
	        , expanded = false
	        , dispatch = d3.dispatch('legendClick', 'legendDblclick', 'legendMouseover', 'legendMouseout', 'stateChange')
	        , vers = 'classic' //Options are "classic" and "furious"
	        ;
	
	    function chart(selection) {
	        selection.each(function(data) {
	            var availableWidth = width - margin.left - margin.right,
	                container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-legend').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-legend').append('g');
	            var g = wrap.select('g');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            var series = g.selectAll('.nv-series')
	                .data(function(d) {
	                    if(vers != 'furious') return d;
	
	                    return d.filter(function(n) {
	                        return expanded ? true : !n.disengaged;
	                    });
	                });
	            var seriesEnter = series.enter().append('g').attr('class', 'nv-series')
	
	            var seriesShape;
	
	            if(vers == 'classic') {
	                seriesEnter.append('circle')
	                    .style('stroke-width', 2)
	                    .attr('class','nv-legend-symbol')
	                    .attr('r', 5);
	
	                seriesShape = series.select('circle');
	            } else if (vers == 'furious') {
	                seriesEnter.append('rect')
	                    .style('stroke-width', 2)
	                    .attr('class','nv-legend-symbol')
	                    .attr('rx', 3)
	                    .attr('ry', 3);
	
	                seriesShape = series.select('rect');
	
	                seriesEnter.append('g')
	                    .attr('class', 'nv-check-box')
	                    .property('innerHTML','<path d="M0.5,5 L22.5,5 L22.5,26.5 L0.5,26.5 L0.5,5 Z" class="nv-box"></path><path d="M5.5,12.8618467 L11.9185089,19.2803556 L31,0.198864511" class="nv-check"></path>')
	                    .attr('transform', 'translate(-10,-8)scale(0.5)');
	
	                var seriesCheckbox = series.select('.nv-check-box');
	
	                seriesCheckbox.each(function(d,i) {
	                    d3.select(this).selectAll('path')
	                        .attr('stroke', setTextColor(d,i));
	                });
	            }
	
	            seriesEnter.append('text')
	                .attr('text-anchor', 'start')
	                .attr('class','nv-legend-text')
	                .attr('dy', '.32em')
	                .attr('dx', '8');
	
	            var seriesText = series.select('text.nv-legend-text');
	
	            series
	                .on('mouseover', function(d,i) {
	                    dispatch.legendMouseover(d,i);  //TODO: Make consistent with other event objects
	                })
	                .on('mouseout', function(d,i) {
	                    dispatch.legendMouseout(d,i);
	                })
	                .on('click', function(d,i) {
	                    dispatch.legendClick(d,i);
	                    // make sure we re-get data in case it was modified
	                    var data = series.data();
	                    if (updateState) {
	                        if(vers =='classic') {
	                            if (radioButtonMode) {
	                                //Radio button mode: set every series to disabled,
	                                //  and enable the clicked series.
	                                data.forEach(function(series) { series.disabled = true});
	                                d.disabled = false;
	                            }
	                            else {
	                                d.disabled = !d.disabled;
	                                if (data.every(function(series) { return series.disabled})) {
	                                    //the default behavior of NVD3 legends is, if every single series
	                                    // is disabled, turn all series' back on.
	                                    data.forEach(function(series) { series.disabled = false});
	                                }
	                            }
	                        } else if(vers == 'furious') {
	                            if(expanded) {
	                                d.disengaged = !d.disengaged;
	                                d.userDisabled = d.userDisabled == undefined ? !!d.disabled : d.userDisabled;
	                                d.disabled = d.disengaged || d.userDisabled;
	                            } else if (!expanded) {
	                                d.disabled = !d.disabled;
	                                d.userDisabled = d.disabled;
	                                var engaged = data.filter(function(d) { return !d.disengaged; });
	                                if (engaged.every(function(series) { return series.userDisabled })) {
	                                    //the default behavior of NVD3 legends is, if every single series
	                                    // is disabled, turn all series' back on.
	                                    data.forEach(function(series) {
	                                        series.disabled = series.userDisabled = false;
	                                    });
	                                }
	                            }
	                        }
	                        dispatch.stateChange({
	                            disabled: data.map(function(d) { return !!d.disabled }),
	                            disengaged: data.map(function(d) { return !!d.disengaged })
	                        });
	
	                    }
	                })
	                .on('dblclick', function(d,i) {
	                    if(vers == 'furious' && expanded) return;
	                    dispatch.legendDblclick(d,i);
	                    if (updateState) {
	                        // make sure we re-get data in case it was modified
	                        var data = series.data();
	                        //the default behavior of NVD3 legends, when double clicking one,
	                        // is to set all other series' to false, and make the double clicked series enabled.
	                        data.forEach(function(series) {
	                            series.disabled = true;
	                            if(vers == 'furious') series.userDisabled = series.disabled;
	                        });
	                        d.disabled = false;
	                        if(vers == 'furious') d.userDisabled = d.disabled;
	                        dispatch.stateChange({
	                            disabled: data.map(function(d) { return !!d.disabled })
	                        });
	                    }
	                });
	
	            series.classed('nv-disabled', function(d) { return d.userDisabled });
	            series.exit().remove();
	
	            seriesText
	                .attr('fill', setTextColor)
	                .text(function (d) { return keyFormatter(getKey(d)) });
	
	            //TODO: implement fixed-width and max-width options (max-width is especially useful with the align option)
	            // NEW ALIGNING CODE, TODO: clean up
	
	            var versPadding;
	            switch(vers) {
	                case 'furious' :
	                    versPadding = 23;
	                    break;
	                case 'classic' :
	                    versPadding = 20;
	            }
	
	            if (align) {
	
	                var seriesWidths = [];
	                series.each(function(d,i) {
	                    var legendText;
	                    if (keyFormatter(getKey(d)) && keyFormatter(getKey(d)).length > maxKeyLength) {
	                        var trimmedKey = keyFormatter(getKey(d)).substring(0, maxKeyLength);
	                        legendText = d3.select(this).select('text').text(trimmedKey + "...");
	                        d3.select(this).append("svg:title").text(keyFormatter(getKey(d)));
	                    } else {
	                        legendText = d3.select(this).select('text');
	                    }
	                    var nodeTextLength;
	                    try {
	                        nodeTextLength = legendText.node().getComputedTextLength();
	                        // If the legendText is display:none'd (nodeTextLength == 0), simulate an error so we approximate, instead
	                        if(nodeTextLength <= 0) throw Error();
	                    }
	                    catch(e) {
	                        nodeTextLength = nv.utils.calcApproxTextWidth(legendText);
	                    }
	
	                    seriesWidths.push(nodeTextLength + padding);
	                });
	
	                var seriesPerRow = 0;
	                var legendWidth = 0;
	                var columnWidths = [];
	
	                while ( legendWidth < availableWidth && seriesPerRow < seriesWidths.length) {
	                    columnWidths[seriesPerRow] = seriesWidths[seriesPerRow];
	                    legendWidth += seriesWidths[seriesPerRow++];
	                }
	                if (seriesPerRow === 0) seriesPerRow = 1; //minimum of one series per row
	
	                while ( legendWidth > availableWidth && seriesPerRow > 1 ) {
	                    columnWidths = [];
	                    seriesPerRow--;
	
	                    for (var k = 0; k < seriesWidths.length; k++) {
	                        if (seriesWidths[k] > (columnWidths[k % seriesPerRow] || 0) )
	                            columnWidths[k % seriesPerRow] = seriesWidths[k];
	                    }
	
	                    legendWidth = columnWidths.reduce(function(prev, cur, index, array) {
	                        return prev + cur;
	                    });
	                }
	
	                var xPositions = [];
	                for (var i = 0, curX = 0; i < seriesPerRow; i++) {
	                    xPositions[i] = curX;
	                    curX += columnWidths[i];
	                }
	
	                series
	                    .attr('transform', function(d, i) {
	                        return 'translate(' + xPositions[i % seriesPerRow] + ',' + (5 + Math.floor(i / seriesPerRow) * versPadding) + ')';
	                    });
	
	                //position legend as far right as possible within the total width
	                if (rightAlign) {
	                    g.attr('transform', 'translate(' + (width - margin.right - legendWidth) + ',' + margin.top + ')');
	                }
	                else {
	                    g.attr('transform', 'translate(0' + ',' + margin.top + ')');
	                }
	
	                height = margin.top + margin.bottom + (Math.ceil(seriesWidths.length / seriesPerRow) * versPadding);
	
	            } else {
	
	                var ypos = 5,
	                    newxpos = 5,
	                    maxwidth = 0,
	                    xpos;
	                series
	                    .attr('transform', function(d, i) {
	                        var length = d3.select(this).select('text').node().getComputedTextLength() + padding;
	                        xpos = newxpos;
	
	                        if (width < margin.left + margin.right + xpos + length) {
	                            newxpos = xpos = 5;
	                            ypos += versPadding;
	                        }
	
	                        newxpos += length;
	                        if (newxpos > maxwidth) maxwidth = newxpos;
	
	                        return 'translate(' + xpos + ',' + ypos + ')';
	                    });
	
	                //position legend as far right as possible within the total width
	                g.attr('transform', 'translate(' + (width - margin.right - maxwidth) + ',' + margin.top + ')');
	
	                height = margin.top + margin.bottom + ypos + 15;
	            }
	
	            if(vers == 'furious') {
	                // Size rectangles after text is placed
	                seriesShape
	                    .attr('width', function(d,i) {
	                        return seriesText[0][i].getComputedTextLength() + 27;
	                    })
	                    .attr('height', 18)
	                    .attr('y', -9)
	                    .attr('x', -15)
	            }
	
	            seriesShape
	                .style('fill', setBGColor)
	                .style('stroke', function(d,i) { return d.color || color(d, i) });
	        });
	
	        function setTextColor(d,i) {
	            if(vers != 'furious') return '#000';
	            if(expanded) {
	                return d.disengaged ? color(d,i) : '#fff';
	            } else if (!expanded) {
	                return !!d.disabled ? color(d,i) : '#fff';
	            }
	        }
	
	        function setBGColor(d,i) {
	            if(expanded && vers == 'furious') {
	                return d.disengaged ? '#fff' : color(d,i);
	            } else {
	                return !!d.disabled ? '#fff' : color(d,i);
	            }
	        }
	
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:          {get: function(){return width;}, set: function(_){width=_;}},
	        height:         {get: function(){return height;}, set: function(_){height=_;}},
	        key:            {get: function(){return getKey;}, set: function(_){getKey=_;}},
	        keyFormatter:   {get: function(){return keyFormatter;}, set: function(_){keyFormatter=_;}},
	        align:          {get: function(){return align;}, set: function(_){align=_;}},
	        rightAlign:     {get: function(){return rightAlign;}, set: function(_){rightAlign=_;}},
	        maxKeyLength:   {get: function(){return maxKeyLength;}, set: function(_){maxKeyLength=_;}},
	        padding:        {get: function(){return padding;}, set: function(_){padding=_;}},
	        updateState:    {get: function(){return updateState;}, set: function(_){updateState=_;}},
	        radioButtonMode:{get: function(){return radioButtonMode;}, set: function(_){radioButtonMode=_;}},
	        expanded:       {get: function(){return expanded;}, set: function(_){expanded=_;}},
	        vers:           {get: function(){return vers;}, set: function(_){vers=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	//TODO: consider deprecating and using multibar with single series for this
	nv.models.historicalBar = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = null
	        , height = null
	        , id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
	        , container = null
	        , x = d3.scale.linear()
	        , y = d3.scale.linear()
	        , getX = function(d) { return d.x }
	        , getY = function(d) { return d.y }
	        , forceX = []
	        , forceY = [0]
	        , padData = false
	        , clipEdge = true
	        , color = nv.utils.defaultColor()
	        , xDomain
	        , yDomain
	        , xRange
	        , yRange
	        , dispatch = d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd')
	        , interactive = true
	        ;
	
	    var renderWatch = nv.utils.renderWatch(dispatch, 0);
	
	    function chart(selection) {
	        selection.each(function(data) {
	            renderWatch.reset();
	
	            container = d3.select(this);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            nv.utils.initSVG(container);
	
	            // Setup Scales
	            x.domain(xDomain || d3.extent(data[0].values.map(getX).concat(forceX) ));
	
	            if (padData)
	                x.range(xRange || [availableWidth * .5 / data[0].values.length, availableWidth * (data[0].values.length - .5)  / data[0].values.length ]);
	            else
	                x.range(xRange || [0, availableWidth]);
	
	            y.domain(yDomain || d3.extent(data[0].values.map(getY).concat(forceY) ))
	                .range(yRange || [availableHeight, 0]);
	
	            // If scale's domain don't have a range, slightly adjust to make one... so a chart can show a single data point
	            if (x.domain()[0] === x.domain()[1])
	                x.domain()[0] ?
	                    x.domain([x.domain()[0] - x.domain()[0] * 0.01, x.domain()[1] + x.domain()[1] * 0.01])
	                    : x.domain([-1,1]);
	
	            if (y.domain()[0] === y.domain()[1])
	                y.domain()[0] ?
	                    y.domain([y.domain()[0] + y.domain()[0] * 0.01, y.domain()[1] - y.domain()[1] * 0.01])
	                    : y.domain([-1,1]);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-historicalBar-' + id).data([data[0].values]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-historicalBar-' + id);
	            var defsEnter = wrapEnter.append('defs');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-bars');
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            container
	                .on('click', function(d,i) {
	                    dispatch.chartClick({
	                        data: d,
	                        index: i,
	                        pos: d3.event,
	                        id: id
	                    });
	                });
	
	            defsEnter.append('clipPath')
	                .attr('id', 'nv-chart-clip-path-' + id)
	                .append('rect');
	
	            wrap.select('#nv-chart-clip-path-' + id + ' rect')
	                .attr('width', availableWidth)
	                .attr('height', availableHeight);
	
	            g.attr('clip-path', clipEdge ? 'url(#nv-chart-clip-path-' + id + ')' : '');
	
	            var bars = wrap.select('.nv-bars').selectAll('.nv-bar')
	                .data(function(d) { return d }, function(d,i) {return getX(d,i)});
	            bars.exit().remove();
	
	            bars.enter().append('rect')
	                .attr('x', 0 )
	                .attr('y', function(d,i) {  return nv.utils.NaNtoZero(y(Math.max(0, getY(d,i)))) })
	                .attr('height', function(d,i) { return nv.utils.NaNtoZero(Math.abs(y(getY(d,i)) - y(0))) })
	                .attr('transform', function(d,i) { return 'translate(' + (x(getX(d,i)) - availableWidth / data[0].values.length * .45) + ',0)'; })
	                .on('mouseover', function(d,i) {
	                    if (!interactive) return;
	                    d3.select(this).classed('hover', true);
	                    dispatch.elementMouseover({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	
	                })
	                .on('mouseout', function(d,i) {
	                    if (!interactive) return;
	                    d3.select(this).classed('hover', false);
	                    dispatch.elementMouseout({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('mousemove', function(d,i) {
	                    if (!interactive) return;
	                    dispatch.elementMousemove({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('click', function(d,i) {
	                    if (!interactive) return;
	                    var element = this;
	                    dispatch.elementClick({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill"),
	                        event: d3.event,
	                        element: element
	                    });
	                    d3.event.stopPropagation();
	                })
	                .on('dblclick', function(d,i) {
	                    if (!interactive) return;
	                    dispatch.elementDblClick({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                    d3.event.stopPropagation();
	                });
	
	            bars
	                .attr('fill', function(d,i) { return color(d, i); })
	                .attr('class', function(d,i,j) { return (getY(d,i) < 0 ? 'nv-bar negative' : 'nv-bar positive') + ' nv-bar-' + j + '-' + i })
	                .watchTransition(renderWatch, 'bars')
	                .attr('transform', function(d,i) { return 'translate(' + (x(getX(d,i)) - availableWidth / data[0].values.length * .45) + ',0)'; })
	                //TODO: better width calculations that don't assume always uniform data spacing;w
	                .attr('width', (availableWidth / data[0].values.length) * .9 );
	
	            bars.watchTransition(renderWatch, 'bars')
	                .attr('y', function(d,i) {
	                    var rval = getY(d,i) < 0 ?
	                        y(0) :
	                            y(0) - y(getY(d,i)) < 1 ?
	                        y(0) - 1 :
	                        y(getY(d,i));
	                    return nv.utils.NaNtoZero(rval);
	                })
	                .attr('height', function(d,i) { return nv.utils.NaNtoZero(Math.max(Math.abs(y(getY(d,i)) - y(0)),1)) });
	
	        });
	
	        renderWatch.renderEnd('historicalBar immediate');
	        return chart;
	    }
	
	    //Create methods to allow outside functions to highlight a specific bar.
	    chart.highlightPoint = function(pointIndex, isHoverOver) {
	        container
	            .select(".nv-bars .nv-bar-0-" + pointIndex)
	            .classed("hover", isHoverOver)
	        ;
	    };
	
	    chart.clearHighlights = function() {
	        container
	            .select(".nv-bars .nv-bar.hover")
	            .classed("hover", false)
	        ;
	    };
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:   {get: function(){return width;}, set: function(_){width=_;}},
	        height:  {get: function(){return height;}, set: function(_){height=_;}},
	        forceX:  {get: function(){return forceX;}, set: function(_){forceX=_;}},
	        forceY:  {get: function(){return forceY;}, set: function(_){forceY=_;}},
	        padData: {get: function(){return padData;}, set: function(_){padData=_;}},
	        x:       {get: function(){return getX;}, set: function(_){getX=_;}},
	        y:       {get: function(){return getY;}, set: function(_){getY=_;}},
	        xScale:  {get: function(){return x;}, set: function(_){x=_;}},
	        yScale:  {get: function(){return y;}, set: function(_){y=_;}},
	        xDomain: {get: function(){return xDomain;}, set: function(_){xDomain=_;}},
	        yDomain: {get: function(){return yDomain;}, set: function(_){yDomain=_;}},
	        xRange:  {get: function(){return xRange;}, set: function(_){xRange=_;}},
	        yRange:  {get: function(){return yRange;}, set: function(_){yRange=_;}},
	        clipEdge:    {get: function(){return clipEdge;}, set: function(_){clipEdge=_;}},
	        id:          {get: function(){return id;}, set: function(_){id=_;}},
	        interactive: {get: function(){return interactive;}, set: function(_){interactive=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.historicalBarChart = function(bar_model) {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var bars = bar_model || nv.models.historicalBar()
	        , xAxis = nv.models.axis()
	        , yAxis = nv.models.axis()
	        , legend = nv.models.legend()
	        , interactiveLayer = nv.interactiveGuideline()
	        , tooltip = nv.models.tooltip()
	        ;
	
	
	    var margin = {top: 30, right: 90, bottom: 50, left: 90}
	        , marginTop = null
	        , color = nv.utils.defaultColor()
	        , width = null
	        , height = null
	        , showLegend = false
	        , showXAxis = true
	        , showYAxis = true
	        , rightAlignYAxis = false
	        , useInteractiveGuideline = false
	        , x
	        , y
	        , state = {}
	        , defaultState = null
	        , noData = null
	        , dispatch = d3.dispatch('tooltipHide', 'stateChange', 'changeState', 'renderEnd')
	        , transitionDuration = 250
	        ;
	
	    xAxis.orient('bottom').tickPadding(7);
	    yAxis.orient( (rightAlignYAxis) ? 'right' : 'left');
	    tooltip
	        .duration(0)
	        .headerEnabled(false)
	        .valueFormatter(function(d, i) {
	            return yAxis.tickFormat()(d, i);
	        })
	        .headerFormatter(function(d, i) {
	            return xAxis.tickFormat()(d, i);
	        });
	
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch, 0);
	
	    function chart(selection) {
	        selection.each(function(data) {
	            renderWatch.reset();
	            renderWatch.models(bars);
	            if (showXAxis) renderWatch.models(xAxis);
	            if (showYAxis) renderWatch.models(yAxis);
	
	            var container = d3.select(this),
	                that = this;
	            nv.utils.initSVG(container);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            chart.update = function() { container.transition().duration(transitionDuration).call(chart) };
	            chart.container = this;
	
	            //set state.disabled
	            state.disabled = data.map(function(d) { return !!d.disabled });
	
	            if (!defaultState) {
	                var key;
	                defaultState = {};
	                for (key in state) {
	                    if (state[key] instanceof Array)
	                        defaultState[key] = state[key].slice(0);
	                    else
	                        defaultState[key] = state[key];
	                }
	            }
	
	            // Display noData message if there's nothing to show.
	            if (!data || !data.length || !data.filter(function(d) { return d.values.length }).length) {
	                nv.utils.noData(chart, container)
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            // Setup Scales
	            x = bars.xScale();
	            y = bars.yScale();
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-historicalBarChart').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-historicalBarChart').append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-x nv-axis');
	            gEnter.append('g').attr('class', 'nv-y nv-axis');
	            gEnter.append('g').attr('class', 'nv-barsWrap');
	            gEnter.append('g').attr('class', 'nv-legendWrap');
	            gEnter.append('g').attr('class', 'nv-interactive');
	
	            // Legend
	            if (!showLegend) {
	                g.select('.nv-legendWrap').selectAll('*').remove();
	            } else {
	                legend.width(availableWidth);
	
	                g.select('.nv-legendWrap')
	                    .datum(data)
	                    .call(legend);
	
	                if (!marginTop && legend.height() !== margin.top) {
	                    margin.top = legend.height();
	                    availableHeight = nv.utils.availableHeight(height, container, margin);
	                }
	
	                wrap.select('.nv-legendWrap')
	                    .attr('transform', 'translate(0,' + (-margin.top) +')')
	            }
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            if (rightAlignYAxis) {
	                g.select(".nv-y.nv-axis")
	                    .attr("transform", "translate(" + availableWidth + ",0)");
	            }
	
	            //Set up interactive layer
	            if (useInteractiveGuideline) {
	                interactiveLayer
	                    .width(availableWidth)
	                    .height(availableHeight)
	                    .margin({left:margin.left, top:margin.top})
	                    .svgContainer(container)
	                    .xScale(x);
	                wrap.select(".nv-interactive").call(interactiveLayer);
	            }
	            bars
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(data.map(function(d,i) {
	                    return d.color || color(d, i);
	                }).filter(function(d,i) { return !data[i].disabled }));
	
	            var barsWrap = g.select('.nv-barsWrap')
	                .datum(data.filter(function(d) { return !d.disabled }));
	            barsWrap.transition().call(bars);
	
	            // Setup Axes
	            if (showXAxis) {
	                xAxis
	                    .scale(x)
	                    ._ticks( nv.utils.calcTicksX(availableWidth/100, data) )
	                    .tickSize(-availableHeight, 0);
	
	                g.select('.nv-x.nv-axis')
	                    .attr('transform', 'translate(0,' + y.range()[0] + ')');
	                g.select('.nv-x.nv-axis')
	                    .transition()
	                    .call(xAxis);
	            }
	
	            if (showYAxis) {
	                yAxis
	                    .scale(y)
	                    ._ticks( nv.utils.calcTicksY(availableHeight/36, data) )
	                    .tickSize( -availableWidth, 0);
	
	                g.select('.nv-y.nv-axis')
	                    .transition()
	                    .call(yAxis);
	            }
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            interactiveLayer.dispatch.on('elementMousemove', function(e) {
	                bars.clearHighlights();
	
	                var singlePoint, pointIndex, pointXLocation, allData = [];
	                data
	                    .filter(function(series, i) {
	                        series.seriesIndex = i;
	                        return !series.disabled;
	                    })
	                    .forEach(function(series,i) {
	                        pointIndex = nv.interactiveBisect(series.values, e.pointXValue, chart.x());
	                        bars.highlightPoint(pointIndex,true);
	                        var point = series.values[pointIndex];
	                        if (point === undefined) return;
	                        if (singlePoint === undefined) singlePoint = point;
	                        if (pointXLocation === undefined) pointXLocation = chart.xScale()(chart.x()(point,pointIndex));
	                        allData.push({
	                            key: series.key,
	                            value: chart.y()(point, pointIndex),
	                            color: color(series,series.seriesIndex),
	                            data: series.values[pointIndex]
	                        });
	                    });
	
	                var xValue = xAxis.tickFormat()(chart.x()(singlePoint,pointIndex));
	                interactiveLayer.tooltip
	                    .valueFormatter(function(d,i) {
	                        return yAxis.tickFormat()(d);
	                    })
	                    .data({
	                        value: xValue,
	                        index: pointIndex,
	                        series: allData
	                    })();
	
	                interactiveLayer.renderGuideLine(pointXLocation);
	
	            });
	
	            interactiveLayer.dispatch.on("elementMouseout",function(e) {
	                dispatch.tooltipHide();
	                bars.clearHighlights();
	            });
	
	            legend.dispatch.on('legendClick', function(d,i) {
	                d.disabled = !d.disabled;
	
	                if (!data.filter(function(d) { return !d.disabled }).length) {
	                    data.map(function(d) {
	                        d.disabled = false;
	                        wrap.selectAll('.nv-series').classed('disabled', false);
	                        return d;
	                    });
	                }
	
	                state.disabled = data.map(function(d) { return !!d.disabled });
	                dispatch.stateChange(state);
	
	                selection.transition().call(chart);
	            });
	
	            legend.dispatch.on('legendDblclick', function(d) {
	                //Double clicking should always enable current series, and disabled all others.
	                data.forEach(function(d) {
	                    d.disabled = true;
	                });
	                d.disabled = false;
	
	                state.disabled = data.map(function(d) { return !!d.disabled });
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            dispatch.on('changeState', function(e) {
	                if (typeof e.disabled !== 'undefined') {
	                    data.forEach(function(series,i) {
	                        series.disabled = e.disabled[i];
	                    });
	
	                    state.disabled = e.disabled;
	                }
	
	                chart.update();
	            });
	        });
	
	        renderWatch.renderEnd('historicalBarChart immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    bars.dispatch.on('elementMouseover.tooltip', function(evt) {
	        evt['series'] = {
	            key: chart.x()(evt.data),
	            value: chart.y()(evt.data),
	            color: evt.color
	        };
	        tooltip.data(evt).hidden(false);
	    });
	
	    bars.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true);
	    });
	
	    bars.dispatch.on('elementMousemove.tooltip', function(evt) {
	        tooltip();
	    });
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.bars = bars;
	    chart.legend = legend;
	    chart.xAxis = xAxis;
	    chart.yAxis = yAxis;
	    chart.interactiveLayer = interactiveLayer;
	    chart.tooltip = tooltip;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        showLegend: {get: function(){return showLegend;}, set: function(_){showLegend=_;}},
	        showXAxis: {get: function(){return showXAxis;}, set: function(_){showXAxis=_;}},
	        showYAxis: {get: function(){return showYAxis;}, set: function(_){showYAxis=_;}},
	        defaultState:    {get: function(){return defaultState;}, set: function(_){defaultState=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            legend.color(color);
	            bars.color(color);
	        }},
	        duration:    {get: function(){return transitionDuration;}, set: function(_){
	            transitionDuration=_;
	            renderWatch.reset(transitionDuration);
	            yAxis.duration(transitionDuration);
	            xAxis.duration(transitionDuration);
	        }},
	        rightAlignYAxis: {get: function(){return rightAlignYAxis;}, set: function(_){
	            rightAlignYAxis = _;
	            yAxis.orient( (_) ? 'right' : 'left');
	        }},
	        useInteractiveGuideline: {get: function(){return useInteractiveGuideline;}, set: function(_){
	            useInteractiveGuideline = _;
	            if (_ === true) {
	                chart.interactive(false);
	            }
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, bars);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	
	// ohlcChart is just a historical chart with ohlc bars and some tweaks
	nv.models.ohlcBarChart = function() {
	    var chart = nv.models.historicalBarChart(nv.models.ohlcBar());
	
	    // special default tooltip since we show multiple values per x
	    chart.useInteractiveGuideline(true);
	    chart.interactiveLayer.tooltip.contentGenerator(function(data) {
	        // we assume only one series exists for this chart
	        var d = data.series[0].data;
	        // match line colors as defined in nv.d3.css
	        var color = d.open < d.close ? "2ca02c" : "d62728";
	        return '' +
	            '<h3 style="color: #' + color + '">' + data.value + '</h3>' +
	            '<table>' +
	            '<tr><td>open:</td><td>' + chart.yAxis.tickFormat()(d.open) + '</td></tr>' +
	            '<tr><td>close:</td><td>' + chart.yAxis.tickFormat()(d.close) + '</td></tr>' +
	            '<tr><td>high</td><td>' + chart.yAxis.tickFormat()(d.high) + '</td></tr>' +
	            '<tr><td>low:</td><td>' + chart.yAxis.tickFormat()(d.low) + '</td></tr>' +
	            '</table>';
	    });
	    return chart;
	};
	
	// candlestickChart is just a historical chart with candlestick bars and some tweaks
	nv.models.candlestickBarChart = function() {
	    var chart = nv.models.historicalBarChart(nv.models.candlestickBar());
	
	    // special default tooltip since we show multiple values per x
	    chart.useInteractiveGuideline(true);
	    chart.interactiveLayer.tooltip.contentGenerator(function(data) {
	        // we assume only one series exists for this chart
	        var d = data.series[0].data;
	        // match line colors as defined in nv.d3.css
	        var color = d.open < d.close ? "2ca02c" : "d62728";
	        return '' +
	            '<h3 style="color: #' + color + '">' + data.value + '</h3>' +
	            '<table>' +
	            '<tr><td>open:</td><td>' + chart.yAxis.tickFormat()(d.open) + '</td></tr>' +
	            '<tr><td>close:</td><td>' + chart.yAxis.tickFormat()(d.close) + '</td></tr>' +
	            '<tr><td>high</td><td>' + chart.yAxis.tickFormat()(d.high) + '</td></tr>' +
	            '<tr><td>low:</td><td>' + chart.yAxis.tickFormat()(d.low) + '</td></tr>' +
	            '</table>';
	    });
	    return chart;
	};
	nv.models.legend = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 5, right: 0, bottom: 5, left: 0}
	        , width = 400
	        , height = 20
	        , getKey = function(d) { return d.key }
	        , keyFormatter = function (d) { return d }
	        , color = nv.utils.getColor()
	        , maxKeyLength = 20 //default value for key lengths
	        , align = true
	        , padding = 32 //define how much space between legend items. - recommend 32 for furious version
	        , rightAlign = true
	        , updateState = true   //If true, legend will update data.disabled and trigger a 'stateChange' dispatch.
	        , enableDoubleClick = true   //If true, legend will enable double click handling
	        , radioButtonMode = false   //If true, clicking legend items will cause it to behave like a radio button. (only one can be selected at a time)
	        , expanded = false
	        , dispatch = d3.dispatch('legendClick', 'legendDblclick', 'legendMouseover', 'legendMouseout', 'stateChange')
	        , vers = 'classic' //Options are "classic" and "furious"
	        ;
	
	    function chart(selection) {
	        selection.each(function(data) {
	            var availableWidth = width - margin.left - margin.right,
	                container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-legend').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-legend').append('g');
	            var g = wrap.select('g');
	
	            if (rightAlign)
	                wrap.attr('transform', 'translate(' + (- margin.right) + ',' + margin.top + ')');
	            else
	                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            var series = g.selectAll('.nv-series')
	                .data(function(d) {
	                    if(vers != 'furious') return d;
	
	                    return d.filter(function(n) {
	                        return expanded ? true : !n.disengaged;
	                    });
	                });
	
	            var seriesEnter = series.enter().append('g').attr('class', 'nv-series');
	            var seriesShape;
	
	            var versPadding;
	            switch(vers) {
	                case 'furious' :
	                    versPadding = 23;
	                    break;
	                case 'classic' :
	                    versPadding = 20;
	            }
	
	            if(vers == 'classic') {
	                seriesEnter.append('circle')
	                    .style('stroke-width', 2)
	                    .attr('class','nv-legend-symbol')
	                    .attr('r', 5);
	
	                seriesShape = series.select('.nv-legend-symbol');
	            } else if (vers == 'furious') {
	                seriesEnter.append('rect')
	                    .style('stroke-width', 2)
	                    .attr('class','nv-legend-symbol')
	                    .attr('rx', 3)
	                    .attr('ry', 3);
	                seriesShape = series.select('.nv-legend-symbol');
	
	                seriesEnter.append('g')
	                    .attr('class', 'nv-check-box')
	                    .property('innerHTML','<path d="M0.5,5 L22.5,5 L22.5,26.5 L0.5,26.5 L0.5,5 Z" class="nv-box"></path><path d="M5.5,12.8618467 L11.9185089,19.2803556 L31,0.198864511" class="nv-check"></path>')
	                    .attr('transform', 'translate(-10,-8)scale(0.5)');
	
	                var seriesCheckbox = series.select('.nv-check-box');
	
	                seriesCheckbox.each(function(d,i) {
	                    d3.select(this).selectAll('path')
	                        .attr('stroke', setTextColor(d,i));
	                });
	            }
	
	            seriesEnter.append('text')
	                .attr('text-anchor', 'start')
	                .attr('class','nv-legend-text')
	                .attr('dy', '.32em')
	                .attr('dx', '8');
	
	            var seriesText = series.select('text.nv-legend-text');
	
	            series
	                .on('mouseover', function(d,i) {
	                    dispatch.legendMouseover(d,i);  //TODO: Make consistent with other event objects
	                })
	                .on('mouseout', function(d,i) {
	                    dispatch.legendMouseout(d,i);
	                })
	                .on('click', function(d,i) {
	                    dispatch.legendClick(d,i);
	                    // make sure we re-get data in case it was modified
	                    var data = series.data();
	                    if (updateState) {
	                        if(vers =='classic') {
	                            if (radioButtonMode) {
	                                //Radio button mode: set every series to disabled,
	                                //  and enable the clicked series.
	                                data.forEach(function(series) { series.disabled = true});
	                                d.disabled = false;
	                            }
	                            else {
	                                d.disabled = !d.disabled;
	                                if (data.every(function(series) { return series.disabled})) {
	                                    //the default behavior of NVD3 legends is, if every single series
	                                    // is disabled, turn all series' back on.
	                                    data.forEach(function(series) { series.disabled = false});
	                                }
	                            }
	                        } else if(vers == 'furious') {
	                            if(expanded) {
	                                d.disengaged = !d.disengaged;
	                                d.userDisabled = d.userDisabled == undefined ? !!d.disabled : d.userDisabled;
	                                d.disabled = d.disengaged || d.userDisabled;
	                            } else if (!expanded) {
	                                d.disabled = !d.disabled;
	                                d.userDisabled = d.disabled;
	                                var engaged = data.filter(function(d) { return !d.disengaged; });
	                                if (engaged.every(function(series) { return series.userDisabled })) {
	                                    //the default behavior of NVD3 legends is, if every single series
	                                    // is disabled, turn all series' back on.
	                                    data.forEach(function(series) {
	                                        series.disabled = series.userDisabled = false;
	                                    });
	                                }
	                            }
	                        }
	                        dispatch.stateChange({
	                            disabled: data.map(function(d) { return !!d.disabled }),
	                            disengaged: data.map(function(d) { return !!d.disengaged })
	                        });
	
	                    }
	                })
	                .on('dblclick', function(d,i) {
	                    if (enableDoubleClick) {
	                        if (vers == 'furious' && expanded) return;
	                        dispatch.legendDblclick(d, i);
	                        if (updateState) {
	                            // make sure we re-get data in case it was modified
	                            var data = series.data();
	                            //the default behavior of NVD3 legends, when double clicking one,
	                            // is to set all other series' to false, and make the double clicked series enabled.
	                            data.forEach(function (series) {
	                                series.disabled = true;
	                                if (vers == 'furious') series.userDisabled = series.disabled;
	                            });
	                            d.disabled = false;
	                            if (vers == 'furious') d.userDisabled = d.disabled;
	                            dispatch.stateChange({
	                                disabled: data.map(function (d) {
	                                    return !!d.disabled
	                                })
	                            });
	                        }
	                    }
	                });
	
	            series.classed('nv-disabled', function(d) { return d.userDisabled });
	            series.exit().remove();
	
	            seriesText
	                .attr('fill', setTextColor)
	                .text(function (d) { return keyFormatter(getKey(d)) });
	
	            //TODO: implement fixed-width and max-width options (max-width is especially useful with the align option)
	            // NEW ALIGNING CODE, TODO: clean up
	            var legendWidth = 0;
	            if (align) {
	
	                var seriesWidths = [];
	                series.each(function(d,i) {
	                    var legendText;
	                    if (keyFormatter(getKey(d)) && keyFormatter(getKey(d)).length > maxKeyLength) {
	                        var trimmedKey = keyFormatter(getKey(d)).substring(0, maxKeyLength);
	                        legendText = d3.select(this).select('text').text(trimmedKey + "...");
	                        d3.select(this).append("svg:title").text(keyFormatter(getKey(d)));
	                    } else {
	                        legendText = d3.select(this).select('text');
	                    }
	                    var nodeTextLength;
	                    try {
	                        nodeTextLength = legendText.node().getComputedTextLength();
	                        // If the legendText is display:none'd (nodeTextLength == 0), simulate an error so we approximate, instead
	                        if(nodeTextLength <= 0) throw Error();
	                    }
	                    catch(e) {
	                        nodeTextLength = nv.utils.calcApproxTextWidth(legendText);
	                    }
	
	                    seriesWidths.push(nodeTextLength + padding);
	                });
	
	                var seriesPerRow = 0;
	                var columnWidths = [];
	                legendWidth = 0;
	
	                while ( legendWidth < availableWidth && seriesPerRow < seriesWidths.length) {
	                    columnWidths[seriesPerRow] = seriesWidths[seriesPerRow];
	                    legendWidth += seriesWidths[seriesPerRow++];
	                }
	                if (seriesPerRow === 0) seriesPerRow = 1; //minimum of one series per row
	
	                while ( legendWidth > availableWidth && seriesPerRow > 1 ) {
	                    columnWidths = [];
	                    seriesPerRow--;
	
	                    for (var k = 0; k < seriesWidths.length; k++) {
	                        if (seriesWidths[k] > (columnWidths[k % seriesPerRow] || 0) )
	                            columnWidths[k % seriesPerRow] = seriesWidths[k];
	                    }
	
	                    legendWidth = columnWidths.reduce(function(prev, cur, index, array) {
	                        return prev + cur;
	                    });
	                }
	
	                var xPositions = [];
	                for (var i = 0, curX = 0; i < seriesPerRow; i++) {
	                    xPositions[i] = curX;
	                    curX += columnWidths[i];
	                }
	
	                series
	                    .attr('transform', function(d, i) {
	                        return 'translate(' + xPositions[i % seriesPerRow] + ',' + (5 + Math.floor(i / seriesPerRow) * versPadding) + ')';
	                    });
	
	                //position legend as far right as possible within the total width
	                if (rightAlign) {
	                    g.attr('transform', 'translate(' + (width - margin.right - legendWidth) + ',' + margin.top + ')');
	                }
	                else {
	                    g.attr('transform', 'translate(0' + ',' + margin.top + ')');
	                }
	
	                height = margin.top + margin.bottom + (Math.ceil(seriesWidths.length / seriesPerRow) * versPadding);
	
	            } else {
	
	                var ypos = 5,
	                    newxpos = 5,
	                    maxwidth = 0,
	                    xpos;
	                series
	                    .attr('transform', function(d, i) {
	                        var length = d3.select(this).select('text').node().getComputedTextLength() + padding;
	                        xpos = newxpos;
	
	                        if (width < margin.left + margin.right + xpos + length) {
	                            newxpos = xpos = 5;
	                            ypos += versPadding;
	                        }
	
	                        newxpos += length;
	                        if (newxpos > maxwidth) maxwidth = newxpos;
	
	                        if(legendWidth < xpos + maxwidth) {
	                            legendWidth = xpos + maxwidth;
	                        }
	                        return 'translate(' + xpos + ',' + ypos + ')';
	                    });
	
	                //position legend as far right as possible within the total width
	                g.attr('transform', 'translate(' + (width - margin.right - maxwidth) + ',' + margin.top + ')');
	
	                height = margin.top + margin.bottom + ypos + 15;
	            }
	
	            if(vers == 'furious') {
	                // Size rectangles after text is placed
	                seriesShape
	                    .attr('width', function(d,i) {
	                        return seriesText[0][i].getComputedTextLength() + 27;
	                    })
	                    .attr('height', 18)
	                    .attr('y', -9)
	                    .attr('x', -15);
	
	                // The background for the expanded legend (UI)
	                gEnter.insert('rect',':first-child')
	                    .attr('class', 'nv-legend-bg')
	                    .attr('fill', '#eee')
	                    // .attr('stroke', '#444')
	                    .attr('opacity',0);
	
	                var seriesBG = g.select('.nv-legend-bg');
	
	                seriesBG
	                .transition().duration(300)
	                    .attr('x', -versPadding )
	                    .attr('width', legendWidth + versPadding - 12)
	                    .attr('height', height + 10)
	                    .attr('y', -margin.top - 10)
	                    .attr('opacity', expanded ? 1 : 0);
	
	
	            }
	
	            seriesShape
	                .style('fill', setBGColor)
	                .style('fill-opacity', setBGOpacity)
	                .style('stroke', setBGColor);
	        });
	
	        function setTextColor(d,i) {
	            if(vers != 'furious') return '#000';
	            if(expanded) {
	                return d.disengaged ? '#000' : '#fff';
	            } else if (!expanded) {
	                if(!d.color) d.color = color(d,i);
	                return !!d.disabled ? d.color : '#fff';
	            }
	        }
	
	        function setBGColor(d,i) {
	            if(expanded && vers == 'furious') {
	                return d.disengaged ? '#eee' : d.color || color(d,i);
	            } else {
	                return d.color || color(d,i);
	            }
	        }
	
	
	        function setBGOpacity(d,i) {
	            if(expanded && vers == 'furious') {
	                return 1;
	            } else {
	                return !!d.disabled ? 0 : 1;
	            }
	        }
	
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:          {get: function(){return width;}, set: function(_){width=_;}},
	        height:         {get: function(){return height;}, set: function(_){height=_;}},
	        key:            {get: function(){return getKey;}, set: function(_){getKey=_;}},
	        keyFormatter:   {get: function(){return keyFormatter;}, set: function(_){keyFormatter=_;}},
	        align:          {get: function(){return align;}, set: function(_){align=_;}},
	        maxKeyLength:   {get: function(){return maxKeyLength;}, set: function(_){maxKeyLength=_;}},
	        rightAlign:     {get: function(){return rightAlign;}, set: function(_){rightAlign=_;}},
	        padding:        {get: function(){return padding;}, set: function(_){padding=_;}},
	        updateState:    {get: function(){return updateState;}, set: function(_){updateState=_;}},
	        enableDoubleClick: {get: function(){return enableDoubleClick;}, set: function(_){enableDoubleClick=_;}},
	        radioButtonMode:{get: function(){return radioButtonMode;}, set: function(_){radioButtonMode=_;}},
	        expanded:       {get: function(){return expanded;}, set: function(_){expanded=_;}},
	        vers:           {get: function(){return vers;}, set: function(_){vers=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.line = function() {
	    "use strict";
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var  scatter = nv.models.scatter()
	        ;
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = 960
	        , height = 500
	        , container = null
	        , strokeWidth = 1.5
	        , color = nv.utils.defaultColor() // a function that returns a color
	        , getX = function(d) { return d.x } // accessor to get the x value from a data point
	        , getY = function(d) { return d.y } // accessor to get the y value from a data point
	        , defined = function(d,i) { return !isNaN(getY(d,i)) && getY(d,i) !== null } // allows a line to be not continuous when it is not defined
	        , isArea = function(d) { return d.area } // decides if a line is an area or just a line
	        , clipEdge = false // if true, masks lines within x and y scale
	        , x //can be accessed via chart.xScale()
	        , y //can be accessed via chart.yScale()
	        , interpolate = "linear" // controls the line interpolation
	        , duration = 250
	        , dispatch = d3.dispatch('elementClick', 'elementMouseover', 'elementMouseout', 'renderEnd')
	        ;
	
	    scatter
	        .pointSize(16) // default size
	        .pointDomain([16,256]) //set to speed up calculation, needs to be unset if there is a custom size accessor
	    ;
	
	    //============================================================
	
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var x0, y0 //used to store previous scales
	        , renderWatch = nv.utils.renderWatch(dispatch, duration)
	        ;
	
	    //============================================================
	
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(scatter);
	        selection.each(function(data) {
	            container = d3.select(this);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	            nv.utils.initSVG(container);
	
	            // Setup Scales
	            x = scatter.xScale();
	            y = scatter.yScale();
	
	            x0 = x0 || x;
	            y0 = y0 || y;
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-line').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-line');
	            var defsEnter = wrapEnter.append('defs');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-groups');
	            gEnter.append('g').attr('class', 'nv-scatterWrap');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            scatter
	                .width(availableWidth)
	                .height(availableHeight);
	
	            var scatterWrap = wrap.select('.nv-scatterWrap');
	            scatterWrap.call(scatter);
	
	            defsEnter.append('clipPath')
	                .attr('id', 'nv-edge-clip-' + scatter.id())
	                .append('rect');
	
	            wrap.select('#nv-edge-clip-' + scatter.id() + ' rect')
	                .attr('width', availableWidth)
	                .attr('height', (availableHeight > 0) ? availableHeight : 0);
	
	            g   .attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + scatter.id() + ')' : '');
	            scatterWrap
	                .attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + scatter.id() + ')' : '');
	
	            var groups = wrap.select('.nv-groups').selectAll('.nv-group')
	                .data(function(d) { return d }, function(d) { return d.key });
	            groups.enter().append('g')
	                .style('stroke-opacity', 1e-6)
	                .style('stroke-width', function(d) { return d.strokeWidth || strokeWidth })
	                .style('fill-opacity', 1e-6);
	
	            groups.exit().remove();
	
	            groups
	                .attr('class', function(d,i) {
	                    return (d.classed || '') + ' nv-group nv-series-' + i;
	                })
	                .classed('hover', function(d) { return d.hover })
	                .style('fill', function(d,i){ return color(d, i) })
	                .style('stroke', function(d,i){ return color(d, i)});
	            groups.watchTransition(renderWatch, 'line: groups')
	                .style('stroke-opacity', 1)
	                .style('fill-opacity', function(d) { return d.fillOpacity || .5});
	
	            var areaPaths = groups.selectAll('path.nv-area')
	                .data(function(d) { return isArea(d) ? [d] : [] }); // this is done differently than lines because I need to check if series is an area
	            areaPaths.enter().append('path')
	                .attr('class', 'nv-area')
	                .attr('d', function(d) {
	                    return d3.svg.area()
	                        .interpolate(interpolate)
	                        .defined(defined)
	                        .x(function(d,i) { return nv.utils.NaNtoZero(x0(getX(d,i))) })
	                        .y0(function(d,i) { return nv.utils.NaNtoZero(y0(getY(d,i))) })
	                        .y1(function(d,i) { return y0( y.domain()[0] <= 0 ? y.domain()[1] >= 0 ? 0 : y.domain()[1] : y.domain()[0] ) })
	                        //.y1(function(d,i) { return y0(0) }) //assuming 0 is within y domain.. may need to tweak this
	                        .apply(this, [d.values])
	                });
	            groups.exit().selectAll('path.nv-area')
	                .remove();
	
	            areaPaths.watchTransition(renderWatch, 'line: areaPaths')
	                .attr('d', function(d) {
	                    return d3.svg.area()
	                        .interpolate(interpolate)
	                        .defined(defined)
	                        .x(function(d,i) { return nv.utils.NaNtoZero(x(getX(d,i))) })
	                        .y0(function(d,i) { return nv.utils.NaNtoZero(y(getY(d,i))) })
	                        .y1(function(d,i) { return y( y.domain()[0] <= 0 ? y.domain()[1] >= 0 ? 0 : y.domain()[1] : y.domain()[0] ) })
	                        //.y1(function(d,i) { return y0(0) }) //assuming 0 is within y domain.. may need to tweak this
	                        .apply(this, [d.values])
	                });
	
	            var linePaths = groups.selectAll('path.nv-line')
	                .data(function(d) { return [d.values] });
	
	            linePaths.enter().append('path')
	                .attr('class', 'nv-line')
	                .attr('d',
	                    d3.svg.line()
	                    .interpolate(interpolate)
	                    .defined(defined)
	                    .x(function(d,i) { return nv.utils.NaNtoZero(x0(getX(d,i))) })
	                    .y(function(d,i) { return nv.utils.NaNtoZero(y0(getY(d,i))) })
	            );
	
	            linePaths.watchTransition(renderWatch, 'line: linePaths')
	                .attr('d',
	                    d3.svg.line()
	                    .interpolate(interpolate)
	                    .defined(defined)
	                    .x(function(d,i) { return nv.utils.NaNtoZero(x(getX(d,i))) })
	                    .y(function(d,i) { return nv.utils.NaNtoZero(y(getY(d,i))) })
	            );
	
	            //store old scales for use in transitions on update
	            x0 = x.copy();
	            y0 = y.copy();
	        });
	        renderWatch.renderEnd('line immediate');
	        return chart;
	    }
	
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.scatter = scatter;
	    // Pass through events
	    scatter.dispatch.on('elementClick', function(){ dispatch.elementClick.apply(this, arguments); });
	    scatter.dispatch.on('elementMouseover', function(){ dispatch.elementMouseover.apply(this, arguments); });
	    scatter.dispatch.on('elementMouseout', function(){ dispatch.elementMouseout.apply(this, arguments); });
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        defined: {get: function(){return defined;}, set: function(_){defined=_;}},
	        interpolate:      {get: function(){return interpolate;}, set: function(_){interpolate=_;}},
	        clipEdge:    {get: function(){return clipEdge;}, set: function(_){clipEdge=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	            scatter.duration(duration);
	        }},
	        isArea: {get: function(){return isArea;}, set: function(_){
	            isArea = d3.functor(_);
	        }},
	        x: {get: function(){return getX;}, set: function(_){
	            getX = _;
	            scatter.x(_);
	        }},
	        y: {get: function(){return getY;}, set: function(_){
	            getY = _;
	            scatter.y(_);
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            scatter.color(color);
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, scatter);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	nv.models.lineChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var lines = nv.models.line()
	        , xAxis = nv.models.axis()
	        , yAxis = nv.models.axis()
	        , legend = nv.models.legend()
	        , interactiveLayer = nv.interactiveGuideline()
	        , tooltip = nv.models.tooltip()
	        , focus = nv.models.focus(nv.models.line())
	        ;
	
	    var margin = {top: 30, right: 20, bottom: 50, left: 60}
	        , marginTop = null
	        , color = nv.utils.defaultColor()
	        , width = null
	        , height = null
	        , showLegend = true
	        , legendPosition = 'top'
	        , showXAxis = true
	        , showYAxis = true
	        , rightAlignYAxis = false
	        , useInteractiveGuideline = false
	        , x
	        , y
	        , focusEnable = false
	        , state = nv.utils.state()
	        , defaultState = null
	        , noData = null
	        , dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd')
	        , duration = 250
	        ;
	
	    // set options on sub-objects for this chart
	    xAxis.orient('bottom').tickPadding(7);
	    yAxis.orient(rightAlignYAxis ? 'right' : 'left');
	
	    lines.clipEdge(true).duration(0);
	
	    tooltip.valueFormatter(function(d, i) {
	        return yAxis.tickFormat()(d, i);
	    }).headerFormatter(function(d, i) {
	        return xAxis.tickFormat()(d, i);
	    });
	
	    interactiveLayer.tooltip.valueFormatter(function(d, i) {
	        return yAxis.tickFormat()(d, i);
	    }).headerFormatter(function(d, i) {
	        return xAxis.tickFormat()(d, i);
	    });
	
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    var stateGetter = function(data) {
	        return function(){
	            return {
	                active: data.map(function(d) { return !d.disabled; })
	            };
	        };
	    };
	
	    var stateSetter = function(data) {
	        return function(state) {
	            if (state.active !== undefined)
	                data.forEach(function(series,i) {
	                    series.disabled = !state.active[i];
	                });
	        };
	    };
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(lines);
	        if (showXAxis) renderWatch.models(xAxis);
	        if (showYAxis) renderWatch.models(yAxis);
	
	        selection.each(function(data) {
	            var container = d3.select(this);
	            nv.utils.initSVG(container);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin) - (focusEnable ? focus.height() : 0);
	            chart.update = function() {
	                if( duration === 0 ) {
	                    container.call( chart );
	                } else {
	                    container.transition().duration(duration).call(chart);
	                }
	            };
	            chart.container = this;
	
	            state
	                .setter(stateSetter(data), chart.update)
	                .getter(stateGetter(data))
	                .update();
	
	            // DEPRECATED set state.disabled
	            state.disabled = data.map(function(d) { return !!d.disabled; });
	
	            if (!defaultState) {
	                var key;
	                defaultState = {};
	                for (key in state) {
	                    if (state[key] instanceof Array)
	                        defaultState[key] = state[key].slice(0);
	                    else
	                        defaultState[key] = state[key];
	                }
	            }
	
	            // Display noData message if there's nothing to show.
	            if (!data || !data.length || !data.filter(function(d) { return d.values.length; }).length) {
	                nv.utils.noData(chart, container);
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            /* Update `main' graph on brush update. */
	            focus.dispatch.on("onBrush", function(extent) {
	                onBrush(extent);
	            });
	
	            // Setup Scales
	            x = lines.xScale();
	            y = lines.yScale();
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-lineChart').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-lineChart').append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-legendWrap');
	
	            var focusEnter = gEnter.append('g').attr('class', 'nv-focus');
	            focusEnter.append('g').attr('class', 'nv-background').append('rect');
	            focusEnter.append('g').attr('class', 'nv-x nv-axis');
	            focusEnter.append('g').attr('class', 'nv-y nv-axis');
	            focusEnter.append('g').attr('class', 'nv-linesWrap');
	            focusEnter.append('g').attr('class', 'nv-interactive');
	
	            var contextEnter = gEnter.append('g').attr('class', 'nv-focusWrap');
	
	            // Legend
	            if (!showLegend) {
	                g.select('.nv-legendWrap').selectAll('*').remove();
	            } else {
	                legend.width(availableWidth);
	
	                g.select('.nv-legendWrap')
	                    .datum(data)
	                    .call(legend);
	
	                if (legendPosition === 'bottom') {
	                     margin.bottom = xAxis.height() + legend.height();
	                     availableHeight = nv.utils.availableHeight(height, container, margin);
	                     g.select('.nv-legendWrap')
	                         .attr('transform', 'translate(0,' + (availableHeight + xAxis.height())  +')');
	                } else if (legendPosition === 'top') {
	                    if (!marginTop && legend.height() !== margin.top) {
	                        margin.top = legend.height();
	                        availableHeight = nv.utils.availableHeight(height, container, margin) - (focusEnable ? focus.height() : 0);
	                    }
	
	                    wrap.select('.nv-legendWrap')
	                        .attr('transform', 'translate(0,' + (-margin.top) +')');
	                }
	            }
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            if (rightAlignYAxis) {
	                g.select(".nv-y.nv-axis")
	                    .attr("transform", "translate(" + availableWidth + ",0)");
	            }
	
	            //Set up interactive layer
	            if (useInteractiveGuideline) {
	                interactiveLayer
	                    .width(availableWidth)
	                    .height(availableHeight)
	                    .margin({left:margin.left, top:margin.top})
	                    .svgContainer(container)
	                    .xScale(x);
	                wrap.select(".nv-interactive").call(interactiveLayer);
	            }
	
	            g.select('.nv-focus .nv-background rect')
	                .attr('width', availableWidth)
	                .attr('height', availableHeight);
	
	            lines
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(data.map(function(d,i) {
	                    return d.color || color(d, i);
	                }).filter(function(d,i) { return !data[i].disabled; }));
	
	            var linesWrap = g.select('.nv-linesWrap')
	                .datum(data.filter(function(d) { return !d.disabled; }));
	
	
	            // Setup Main (Focus) Axes
	            if (showXAxis) {
	                xAxis
	                    .scale(x)
	                    ._ticks(nv.utils.calcTicksX(availableWidth/100, data) )
	                    .tickSize(-availableHeight, 0);
	            }
	
	            if (showYAxis) {
	                yAxis
	                    .scale(y)
	                    ._ticks( nv.utils.calcTicksY(availableHeight/36, data) )
	                    .tickSize( -availableWidth, 0);
	            }
	
	            //============================================================
	            // Update Axes
	            //============================================================
	            function updateXAxis() {
	              if(showXAxis) {
	                g.select('.nv-focus .nv-x.nv-axis')
	                  .transition()
	                  .duration(duration)
	                  .call(xAxis)
	                ;
	              }
	            }
	
	            function updateYAxis() {
	              if(showYAxis) {
	                g.select('.nv-focus .nv-y.nv-axis')
	                  .transition()
	                  .duration(duration)
	                  .call(yAxis)
	                ;
	              }
	            }
	
	            g.select('.nv-focus .nv-x.nv-axis')
	                .attr('transform', 'translate(0,' + availableHeight + ')');
	
	            //============================================================
	            // Update Focus
	            //============================================================
	            if (!focusEnable && focus.brush.extent() === null) {
	                linesWrap.call(lines);
	                updateXAxis();
	                updateYAxis();
	            } else {
	                focus.width(availableWidth);
	                g.select('.nv-focusWrap')
	                    .style('display', focusEnable ? 'initial' : 'none')
	                    .attr('transform', 'translate(0,' + ( availableHeight + margin.bottom + focus.margin().top) + ')')
	                    .call(focus);
	                var extent = focus.brush.empty() ? focus.xDomain() : focus.brush.extent();
	                if (extent !== null) {
	                    onBrush(extent);
	                }
	            }
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            legend.dispatch.on('stateChange', function(newState) {
	                for (var key in newState)
	                    state[key] = newState[key];
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            interactiveLayer.dispatch.on('elementMousemove', function(e) {
	                lines.clearHighlights();
	                var singlePoint, pointIndex, pointXLocation, allData = [];
	                data
	                    .filter(function(series, i) {
	                        series.seriesIndex = i;
	                        return !series.disabled && !series.disableTooltip;
	                    })
	                    .forEach(function(series,i) {
	                        var extent = focus.brush.extent() !== null ? (focus.brush.empty() ? focus.xScale().domain() : focus.brush.extent()) : x.domain();
	                        var currentValues = series.values.filter(function(d,i) {
	                            // Checks if the x point is between the extents, handling case where extent[0] is greater than extent[1]
	                            // (e.g. x domain is manually set to reverse the x-axis)
	                            if(extent[0] <= extent[1]) {
	                                return lines.x()(d,i) >= extent[0] && lines.x()(d,i) <= extent[1];
	                            } else {
	                                return lines.x()(d,i) >= extent[1] && lines.x()(d,i) <= extent[0];
	                            }
	                        });
	
	                        pointIndex = nv.interactiveBisect(currentValues, e.pointXValue, lines.x());
	                        var point = currentValues[pointIndex];
	                        var pointYValue = chart.y()(point, pointIndex);
	                        if (pointYValue !== null) {
	                            lines.highlightPoint(i, pointIndex, true);
	                        }
	                        if (point === undefined) return;
	                        if (singlePoint === undefined) singlePoint = point;
	                        if (pointXLocation === undefined) pointXLocation = chart.xScale()(chart.x()(point,pointIndex));
	                        allData.push({
	                            key: series.key,
	                            value: pointYValue,
	                            color: color(series,series.seriesIndex),
	                            data: point
	                        });
	                    });
	                //Highlight the tooltip entry based on which point the mouse is closest to.
	                if (allData.length > 2) {
	                    var yValue = chart.yScale().invert(e.mouseY);
	                    var domainExtent = Math.abs(chart.yScale().domain()[0] - chart.yScale().domain()[1]);
	                    var threshold = 0.03 * domainExtent;
	                    var indexToHighlight = nv.nearestValueIndex(allData.map(function(d){return d.value;}),yValue,threshold);
	                    if (indexToHighlight !== null)
	                        allData[indexToHighlight].highlight = true;
	                }
	
	                var defaultValueFormatter = function(d,i) {
	                    return d == null ? "N/A" : yAxis.tickFormat()(d);
	                };
	
	                interactiveLayer.tooltip
	                    .valueFormatter(interactiveLayer.tooltip.valueFormatter() || defaultValueFormatter)
	                    .data({
	                        value: chart.x()( singlePoint,pointIndex ),
	                        index: pointIndex,
	                        series: allData
	                    })();
	
	                interactiveLayer.renderGuideLine(pointXLocation);
	
	            });
	
	            interactiveLayer.dispatch.on('elementClick', function(e) {
	                var pointXLocation, allData = [];
	
	                data.filter(function(series, i) {
	                    series.seriesIndex = i;
	                    return !series.disabled;
	                }).forEach(function(series) {
	                    var pointIndex = nv.interactiveBisect(series.values, e.pointXValue, chart.x());
	                    var point = series.values[pointIndex];
	                    if (typeof point === 'undefined') return;
	                    if (typeof pointXLocation === 'undefined') pointXLocation = chart.xScale()(chart.x()(point,pointIndex));
	                    var yPos = chart.yScale()(chart.y()(point,pointIndex));
	                    allData.push({
	                        point: point,
	                        pointIndex: pointIndex,
	                        pos: [pointXLocation, yPos],
	                        seriesIndex: series.seriesIndex,
	                        series: series
	                    });
	                });
	
	                lines.dispatch.elementClick(allData);
	            });
	
	            interactiveLayer.dispatch.on("elementMouseout",function(e) {
	                lines.clearHighlights();
	            });
	
	            dispatch.on('changeState', function(e) {
	                if (typeof e.disabled !== 'undefined' && data.length === e.disabled.length) {
	                    data.forEach(function(series,i) {
	                        series.disabled = e.disabled[i];
	                    });
	
	                    state.disabled = e.disabled;
	                }
	                chart.update();
	            });
	
	            //============================================================
	            // Functions
	            //------------------------------------------------------------
	
	            // Taken from crossfilter (http://square.github.com/crossfilter/)
	            function resizePath(d) {
	                var e = +(d == 'e'),
	                    x = e ? 1 : -1,
	                    y = availableHeight / 3;
	                return 'M' + (0.5 * x) + ',' + y
	                    + 'A6,6 0 0 ' + e + ' ' + (6.5 * x) + ',' + (y + 6)
	                    + 'V' + (2 * y - 6)
	                    + 'A6,6 0 0 ' + e + ' ' + (0.5 * x) + ',' + (2 * y)
	                    + 'Z'
	                    + 'M' + (2.5 * x) + ',' + (y + 8)
	                    + 'V' + (2 * y - 8)
	                    + 'M' + (4.5 * x) + ',' + (y + 8)
	                    + 'V' + (2 * y - 8);
	            }
	
	            function onBrush(extent) {
	                // Update Main (Focus)
	                var focusLinesWrap = g.select('.nv-focus .nv-linesWrap')
	                    .datum(
	                    data.filter(function(d) { return !d.disabled; })
	                        .map(function(d,i) {
	                            return {
	                                key: d.key,
	                                area: d.area,
	                                classed: d.classed,
	                                values: d.values.filter(function(d,i) {
	                                    return lines.x()(d,i) >= extent[0] && lines.x()(d,i) <= extent[1];
	                                }),
	                                disableTooltip: d.disableTooltip
	                            };
	                        })
	                );
	                focusLinesWrap.transition().duration(duration).call(lines);
	
	                // Update Main (Focus) Axes
	                updateXAxis();
	                updateYAxis();
	            }
	        });
	
	        renderWatch.renderEnd('lineChart immediate');
	        return chart;
	    }
	
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    lines.dispatch.on('elementMouseover.tooltip', function(evt) {
	        if(!evt.series.disableTooltip){
	            tooltip.data(evt).hidden(false);
	        }
	    });
	
	    lines.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true);
	    });
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.lines = lines;
	    chart.legend = legend;
	    chart.focus = focus;
	    chart.xAxis = xAxis;
	    chart.x2Axis = focus.xAxis
	    chart.yAxis = yAxis;
	    chart.y2Axis = focus.yAxis
	    chart.interactiveLayer = interactiveLayer;
	    chart.tooltip = tooltip;
	    chart.state = state;
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        showLegend: {get: function(){return showLegend;}, set: function(_){showLegend=_;}},
	        legendPosition: {get: function(){return legendPosition;}, set: function(_){legendPosition=_;}},
	        showXAxis:      {get: function(){return showXAxis;}, set: function(_){showXAxis=_;}},
	        showYAxis:    {get: function(){return showYAxis;}, set: function(_){showYAxis=_;}},
	        defaultState:    {get: function(){return defaultState;}, set: function(_){defaultState=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	        // Focus options, mostly passed onto focus model.
	        focusEnable:    {get: function(){return focusEnable;}, set: function(_){focusEnable=_;}},
	        focusHeight:     {get: function(){return focus.height();}, set: function(_){focus.height(_);}},
	        focusShowAxisX:    {get: function(){return focus.showXAxis();}, set: function(_){focus.showXAxis(_);}},
	        focusShowAxisY:    {get: function(){return focus.showYAxis();}, set: function(_){focus.showYAxis(_);}},
	        brushExtent: {get: function(){return focus.brushExtent();}, set: function(_){focus.brushExtent(_);}},
	
	        // options that require extra logic in the setter
	        focusMargin: {get: function(){return focus.margin}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            focus.margin.right  = _.right  !== undefined ? _.right  : focus.margin.right;
	            focus.margin.bottom = _.bottom !== undefined ? _.bottom : focus.margin.bottom;
	            focus.margin.left   = _.left   !== undefined ? _.left   : focus.margin.left;
	        }},
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	            lines.duration(duration);
	            focus.duration(duration);
	            xAxis.duration(duration);
	            yAxis.duration(duration);
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            legend.color(color);
	            lines.color(color);
	            focus.color(color);
	        }},
	        interpolate: {get: function(){return lines.interpolate();}, set: function(_){
	            lines.interpolate(_);
	            focus.interpolate(_);
	        }},
	        xTickFormat: {get: function(){return xAxis.tickFormat();}, set: function(_){
	            xAxis.tickFormat(_);
	            focus.xTickFormat(_);
	        }},
	        yTickFormat: {get: function(){return yAxis.tickFormat();}, set: function(_){
	            yAxis.tickFormat(_);
	            focus.yTickFormat(_);
	        }},
	        x: {get: function(){return lines.x();}, set: function(_){
	            lines.x(_);
	            focus.x(_);
	        }},
	        y: {get: function(){return lines.y();}, set: function(_){
	            lines.y(_);
	            focus.y(_);
	        }},
	        rightAlignYAxis: {get: function(){return rightAlignYAxis;}, set: function(_){
	            rightAlignYAxis = _;
	            yAxis.orient( rightAlignYAxis ? 'right' : 'left');
	        }},
	        useInteractiveGuideline: {get: function(){return useInteractiveGuideline;}, set: function(_){
	            useInteractiveGuideline = _;
	            if (useInteractiveGuideline) {
	                lines.interactive(false);
	                lines.useVoronoi(false);
	            }
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, lines);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.lineWithFocusChart = function() {
	  return nv.models.lineChart()
	    .margin({ bottom: 30 })
	    .focusEnable( true );
	};
	nv.models.linePlusBarChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var lines = nv.models.line()
	        , lines2 = nv.models.line()
	        , bars = nv.models.historicalBar()
	        , bars2 = nv.models.historicalBar()
	        , xAxis = nv.models.axis()
	        , x2Axis = nv.models.axis()
	        , y1Axis = nv.models.axis()
	        , y2Axis = nv.models.axis()
	        , y3Axis = nv.models.axis()
	        , y4Axis = nv.models.axis()
	        , legend = nv.models.legend()
	        , brush = d3.svg.brush()
	        , tooltip = nv.models.tooltip()
	        ;
	
	    var margin = {top: 30, right: 30, bottom: 30, left: 60}
	        , marginTop = null
	        , margin2 = {top: 0, right: 30, bottom: 20, left: 60}
	        , width = null
	        , height = null
	        , getX = function(d) { return d.x }
	        , getY = function(d) { return d.y }
	        , color = nv.utils.defaultColor()
	        , showLegend = true
	        , focusEnable = true
	        , focusShowAxisY = false
	        , focusShowAxisX = true
	        , focusHeight = 50
	        , extent
	        , brushExtent = null
	        , x
	        , x2
	        , y1
	        , y2
	        , y3
	        , y4
	        , noData = null
	        , dispatch = d3.dispatch('brush', 'stateChange', 'changeState')
	        , transitionDuration = 0
	        , state = nv.utils.state()
	        , defaultState = null
	        , legendLeftAxisHint = ' (left axis)'
	        , legendRightAxisHint = ' (right axis)'
	        , switchYAxisOrder = false
	        ;
	
	    lines.clipEdge(true);
	    lines2.interactive(false);
	    // We don't want any points emitted for the focus chart's scatter graph.
	    lines2.pointActive(function(d) { return false });
	    xAxis.orient('bottom').tickPadding(5);
	    y1Axis.orient('left');
	    y2Axis.orient('right');
	    x2Axis.orient('bottom').tickPadding(5);
	    y3Axis.orient('left');
	    y4Axis.orient('right');
	
	    tooltip.headerEnabled(true).headerFormatter(function(d, i) {
	        return xAxis.tickFormat()(d, i);
	    });
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var getBarsAxis = function() {
	        return switchYAxisOrder
	            ? { main: y2Axis, focus: y4Axis }
	            : { main: y1Axis, focus: y3Axis }
	    }
	
	    var getLinesAxis = function() {
	        return switchYAxisOrder
	            ? { main: y1Axis, focus: y3Axis }
	            : { main: y2Axis, focus: y4Axis }
	    }
	
	    var stateGetter = function(data) {
	        return function(){
	            return {
	                active: data.map(function(d) { return !d.disabled })
	            };
	        }
	    };
	
	    var stateSetter = function(data) {
	        return function(state) {
	            if (state.active !== undefined)
	                data.forEach(function(series,i) {
	                    series.disabled = !state.active[i];
	                });
	        }
	    };
	
	    var allDisabled = function(data) {
	      return data.every(function(series) {
	        return series.disabled;
	      });
	    }
	
	    function chart(selection) {
	        selection.each(function(data) {
	            var container = d3.select(this),
	                that = this;
	            nv.utils.initSVG(container);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight1 = nv.utils.availableHeight(height, container, margin)
	                    - (focusEnable ? focusHeight : 0),
	                availableHeight2 = focusHeight - margin2.top - margin2.bottom;
	
	            chart.update = function() { container.transition().duration(transitionDuration).call(chart); };
	            chart.container = this;
	
	            state
	                .setter(stateSetter(data), chart.update)
	                .getter(stateGetter(data))
	                .update();
	
	            // DEPRECATED set state.disableddisabled
	            state.disabled = data.map(function(d) { return !!d.disabled });
	
	            if (!defaultState) {
	                var key;
	                defaultState = {};
	                for (key in state) {
	                    if (state[key] instanceof Array)
	                        defaultState[key] = state[key].slice(0);
	                    else
	                        defaultState[key] = state[key];
	                }
	            }
	
	            // Display No Data message if there's nothing to show.
	            if (!data || !data.length || !data.filter(function(d) { return d.values.length }).length) {
	                nv.utils.noData(chart, container)
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            // Setup Scales
	            var dataBars = data.filter(function(d) { return !d.disabled && d.bar });
	            var dataLines = data.filter(function(d) { return !d.bar }); // removed the !d.disabled clause here to fix Issue #240
	
	            if (dataBars.length && !switchYAxisOrder) {
	                x = bars.xScale();
	            } else {
	                x = lines.xScale();
	            }
	
	            x2 = x2Axis.scale();
	
	            // select the scales and series based on the position of the yAxis
	            y1 = switchYAxisOrder ? lines.yScale() : bars.yScale();
	            y2 = switchYAxisOrder ? bars.yScale() : lines.yScale();
	            y3 = switchYAxisOrder ? lines2.yScale() : bars2.yScale();
	            y4 = switchYAxisOrder ? bars2.yScale() : lines2.yScale();
	
	            var series1 = data
	                .filter(function(d) { return !d.disabled && (switchYAxisOrder ? !d.bar : d.bar) })
	                .map(function(d) {
	                    return d.values.map(function(d,i) {
	                        return { x: getX(d,i), y: getY(d,i) }
	                    })
	                });
	
	            var series2 = data
	                .filter(function(d) { return !d.disabled && (switchYAxisOrder ? d.bar : !d.bar) })
	                .map(function(d) {
	                    return d.values.map(function(d,i) {
	                        return { x: getX(d,i), y: getY(d,i) }
	                    })
	                });
	
	            x.range([0, availableWidth]);
	
	            x2  .domain(d3.extent(d3.merge(series1.concat(series2)), function(d) { return d.x } ))
	                .range([0, availableWidth]);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-linePlusBar').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-linePlusBar').append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-legendWrap');
	
	            // this is the main chart
	            var focusEnter = gEnter.append('g').attr('class', 'nv-focus');
	            focusEnter.append('g').attr('class', 'nv-x nv-axis');
	            focusEnter.append('g').attr('class', 'nv-y1 nv-axis');
	            focusEnter.append('g').attr('class', 'nv-y2 nv-axis');
	            focusEnter.append('g').attr('class', 'nv-barsWrap');
	            focusEnter.append('g').attr('class', 'nv-linesWrap');
	
	            // context chart is where you can focus in
	            var contextEnter = gEnter.append('g').attr('class', 'nv-context');
	            contextEnter.append('g').attr('class', 'nv-x nv-axis');
	            contextEnter.append('g').attr('class', 'nv-y1 nv-axis');
	            contextEnter.append('g').attr('class', 'nv-y2 nv-axis');
	            contextEnter.append('g').attr('class', 'nv-barsWrap');
	            contextEnter.append('g').attr('class', 'nv-linesWrap');
	            contextEnter.append('g').attr('class', 'nv-brushBackground');
	            contextEnter.append('g').attr('class', 'nv-x nv-brush');
	
	            //============================================================
	            // Legend
	            //------------------------------------------------------------
	
	            if (!showLegend) {
	                g.select('.nv-legendWrap').selectAll('*').remove();
	            } else {
	                var legendWidth = legend.align() ? availableWidth / 2 : availableWidth;
	                var legendXPosition = legend.align() ? legendWidth : 0;
	
	                legend.width(legendWidth);
	
	                g.select('.nv-legendWrap')
	                    .datum(data.map(function(series) {
	                        series.originalKey = series.originalKey === undefined ? series.key : series.originalKey;
	                        if(switchYAxisOrder) {
	                            series.key = series.originalKey + (series.bar ? legendRightAxisHint : legendLeftAxisHint);
	                        } else {
	                            series.key = series.originalKey + (series.bar ? legendLeftAxisHint : legendRightAxisHint);
	                        }
	                        return series;
	                    }))
	                    .call(legend);
	
	                if (!marginTop && legend.height() !== margin.top) {
	                    margin.top = legend.height();
	                    // FIXME: shouldn't this be "- (focusEnabled ? focusHeight : 0)"?
	                    availableHeight1 = nv.utils.availableHeight(height, container, margin) - focusHeight;
	                }
	
	                g.select('.nv-legendWrap')
	                    .attr('transform', 'translate(' + legendXPosition + ',' + (-margin.top) +')');
	            }
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            //============================================================
	            // Context chart (focus chart) components
	            //------------------------------------------------------------
	
	            // hide or show the focus context chart
	            g.select('.nv-context').style('display', focusEnable ? 'initial' : 'none');
	
	            bars2
	                .width(availableWidth)
	                .height(availableHeight2)
	                .color(data.map(function (d, i) {
	                    return d.color || color(d, i);
	                }).filter(function (d, i) {
	                    return !data[i].disabled && data[i].bar
	                }));
	            lines2
	                .width(availableWidth)
	                .height(availableHeight2)
	                .color(data.map(function (d, i) {
	                    return d.color || color(d, i);
	                }).filter(function (d, i) {
	                    return !data[i].disabled && !data[i].bar
	                }));
	
	            var bars2Wrap = g.select('.nv-context .nv-barsWrap')
	                .datum(dataBars.length ? dataBars : [
	                    {values: []}
	                ]);
	            var lines2Wrap = g.select('.nv-context .nv-linesWrap')
	                .datum(allDisabled(dataLines) ?
	                       [{values: []}] :
	                       dataLines.filter(function(dataLine) {
	                         return !dataLine.disabled;
	                       }));
	
	            g.select('.nv-context')
	                .attr('transform', 'translate(0,' + ( availableHeight1 + margin.bottom + margin2.top) + ')');
	
	            bars2Wrap.transition().call(bars2);
	            lines2Wrap.transition().call(lines2);
	
	            // context (focus chart) axis controls
	            if (focusShowAxisX) {
	                x2Axis
	                    ._ticks( nv.utils.calcTicksX(availableWidth / 100, data))
	                    .tickSize(-availableHeight2, 0);
	                g.select('.nv-context .nv-x.nv-axis')
	                    .attr('transform', 'translate(0,' + y3.range()[0] + ')');
	                g.select('.nv-context .nv-x.nv-axis').transition()
	                    .call(x2Axis);
	            }
	
	            if (focusShowAxisY) {
	                y3Axis
	                    .scale(y3)
	                    ._ticks( availableHeight2 / 36 )
	                    .tickSize( -availableWidth, 0);
	                y4Axis
	                    .scale(y4)
	                    ._ticks( availableHeight2 / 36 )
	                    .tickSize(dataBars.length ? 0 : -availableWidth, 0); // Show the y2 rules only if y1 has none
	
	                g.select('.nv-context .nv-y3.nv-axis')
	                    .style('opacity', dataBars.length ? 1 : 0)
	                    .attr('transform', 'translate(0,' + x2.range()[0] + ')');
	                g.select('.nv-context .nv-y2.nv-axis')
	                    .style('opacity', dataLines.length ? 1 : 0)
	                    .attr('transform', 'translate(' + x2.range()[1] + ',0)');
	
	                g.select('.nv-context .nv-y1.nv-axis').transition()
	                    .call(y3Axis);
	                g.select('.nv-context .nv-y2.nv-axis').transition()
	                    .call(y4Axis);
	            }
	
	            // Setup Brush
	            brush.x(x2).on('brush', onBrush);
	
	            if (brushExtent) brush.extent(brushExtent);
	
	            var brushBG = g.select('.nv-brushBackground').selectAll('g')
	                .data([brushExtent || brush.extent()]);
	
	            var brushBGenter = brushBG.enter()
	                .append('g');
	
	            brushBGenter.append('rect')
	                .attr('class', 'left')
	                .attr('x', 0)
	                .attr('y', 0)
	                .attr('height', availableHeight2);
	
	            brushBGenter.append('rect')
	                .attr('class', 'right')
	                .attr('x', 0)
	                .attr('y', 0)
	                .attr('height', availableHeight2);
	
	            var gBrush = g.select('.nv-x.nv-brush')
	                .call(brush);
	            gBrush.selectAll('rect')
	                //.attr('y', -5)
	                .attr('height', availableHeight2);
	            gBrush.selectAll('.resize').append('path').attr('d', resizePath);
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            legend.dispatch.on('stateChange', function(newState) {
	                for (var key in newState)
	                    state[key] = newState[key];
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            // Update chart from a state object passed to event handler
	            dispatch.on('changeState', function(e) {
	                if (typeof e.disabled !== 'undefined') {
	                    data.forEach(function(series,i) {
	                        series.disabled = e.disabled[i];
	                    });
	                    state.disabled = e.disabled;
	                }
	                chart.update();
	            });
	
	            //============================================================
	            // Functions
	            //------------------------------------------------------------
	
	            // Taken from crossfilter (http://square.github.com/crossfilter/)
	            function resizePath(d) {
	                var e = +(d == 'e'),
	                    x = e ? 1 : -1,
	                    y = availableHeight2 / 3;
	                return 'M' + (.5 * x) + ',' + y
	                    + 'A6,6 0 0 ' + e + ' ' + (6.5 * x) + ',' + (y + 6)
	                    + 'V' + (2 * y - 6)
	                    + 'A6,6 0 0 ' + e + ' ' + (.5 * x) + ',' + (2 * y)
	                    + 'Z'
	                    + 'M' + (2.5 * x) + ',' + (y + 8)
	                    + 'V' + (2 * y - 8)
	                    + 'M' + (4.5 * x) + ',' + (y + 8)
	                    + 'V' + (2 * y - 8);
	            }
	
	
	            function updateBrushBG() {
	                if (!brush.empty()) brush.extent(brushExtent);
	                brushBG
	                    .data([brush.empty() ? x2.domain() : brushExtent])
	                    .each(function(d,i) {
	                        var leftWidth = x2(d[0]) - x2.range()[0],
	                            rightWidth = x2.range()[1] - x2(d[1]);
	                        d3.select(this).select('.left')
	                            .attr('width',  leftWidth < 0 ? 0 : leftWidth);
	
	                        d3.select(this).select('.right')
	                            .attr('x', x2(d[1]))
	                            .attr('width', rightWidth < 0 ? 0 : rightWidth);
	                    });
	            }
	
	            function onBrush() {
	                brushExtent = brush.empty() ? null : brush.extent();
	                extent = brush.empty() ? x2.domain() : brush.extent();
	                dispatch.brush({extent: extent, brush: brush});
	                updateBrushBG();
	
	                // Prepare Main (Focus) Bars and Lines
	                bars
	                    .width(availableWidth)
	                    .height(availableHeight1)
	                    .color(data.map(function(d,i) {
	                        return d.color || color(d, i);
	                    }).filter(function(d,i) { return !data[i].disabled && data[i].bar }));
	
	                lines
	                    .width(availableWidth)
	                    .height(availableHeight1)
	                    .color(data.map(function(d,i) {
	                        return d.color || color(d, i);
	                    }).filter(function(d,i) { return !data[i].disabled && !data[i].bar }));
	
	                var focusBarsWrap = g.select('.nv-focus .nv-barsWrap')
	                    .datum(!dataBars.length ? [{values:[]}] :
	                        dataBars
	                            .map(function(d,i) {
	                                return {
	                                    key: d.key,
	                                    values: d.values.filter(function(d,i) {
	                                        return bars.x()(d,i) >= extent[0] && bars.x()(d,i) <= extent[1];
	                                    })
	                                }
	                            })
	                );
	
	                var focusLinesWrap = g.select('.nv-focus .nv-linesWrap')
	                    .datum(allDisabled(dataLines) ? [{values:[]}] :
	                           dataLines
	                           .filter(function(dataLine) { return !dataLine.disabled; })
	                           .map(function(d,i) {
	                                return {
	                                    area: d.area,
	                                    fillOpacity: d.fillOpacity,
	                                    strokeWidth: d.strokeWidth,
	                                    key: d.key,
	                                    values: d.values.filter(function(d,i) {
	                                        return lines.x()(d,i) >= extent[0] && lines.x()(d,i) <= extent[1];
	                                    })
	                                }
	                            })
	                );
	
	                // Update Main (Focus) X Axis
	                if (dataBars.length && !switchYAxisOrder) {
	                    x = bars.xScale();
	                } else {
	                    x = lines.xScale();
	                }
	
	                xAxis
	                    .scale(x)
	                    ._ticks( nv.utils.calcTicksX(availableWidth/100, data) )
	                    .tickSize(-availableHeight1, 0);
	
	                xAxis.domain([Math.ceil(extent[0]), Math.floor(extent[1])]);
	
	                g.select('.nv-x.nv-axis').transition().duration(transitionDuration)
	                    .call(xAxis);
	
	                // Update Main (Focus) Bars and Lines
	                focusBarsWrap.transition().duration(transitionDuration).call(bars);
	                focusLinesWrap.transition().duration(transitionDuration).call(lines);
	
	                // Setup and Update Main (Focus) Y Axes
	                g.select('.nv-focus .nv-x.nv-axis')
	                    .attr('transform', 'translate(0,' + y1.range()[0] + ')');
	
	                y1Axis
	                    .scale(y1)
	                    ._ticks( nv.utils.calcTicksY(availableHeight1/36, data) )
	                    .tickSize(-availableWidth, 0);
	                y2Axis
	                    .scale(y2)
	                    ._ticks( nv.utils.calcTicksY(availableHeight1/36, data) );
	
	                // Show the y2 rules only if y1 has none
	                if(!switchYAxisOrder) {
	                    y2Axis.tickSize(dataBars.length ? 0 : -availableWidth, 0);
	                } else {
	                    y2Axis.tickSize(dataLines.length ? 0 : -availableWidth, 0);
	                }
	
	                // Calculate opacity of the axis
	                var barsOpacity = dataBars.length ? 1 : 0;
	                var linesOpacity = dataLines.length && !allDisabled(dataLines) ? 1 : 0;
	
	                var y1Opacity = switchYAxisOrder ? linesOpacity : barsOpacity;
	                var y2Opacity = switchYAxisOrder ? barsOpacity : linesOpacity;
	
	                g.select('.nv-focus .nv-y1.nv-axis')
	                    .style('opacity', y1Opacity);
	                g.select('.nv-focus .nv-y2.nv-axis')
	                    .style('opacity', y2Opacity)
	                    .attr('transform', 'translate(' + x.range()[1] + ',0)');
	
	                g.select('.nv-focus .nv-y1.nv-axis').transition().duration(transitionDuration)
	                    .call(y1Axis);
	                g.select('.nv-focus .nv-y2.nv-axis').transition().duration(transitionDuration)
	                    .call(y2Axis);
	            }
	
	            onBrush();
	
	        });
	
	        return chart;
	    }
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    lines.dispatch.on('elementMouseover.tooltip', function(evt) {
	        tooltip
	            .duration(100)
	            .valueFormatter(function(d, i) {
	                return getLinesAxis().main.tickFormat()(d, i);
	            })
	            .data(evt)
	            .hidden(false);
	    });
	
	    lines.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true)
	    });
	
	    bars.dispatch.on('elementMouseover.tooltip', function(evt) {
	        evt.value = chart.x()(evt.data);
	        evt['series'] = {
	            value: chart.y()(evt.data),
	            color: evt.color
	        };
	        tooltip
	            .duration(0)
	            .valueFormatter(function(d, i) {
	                return getBarsAxis().main.tickFormat()(d, i);
	            })
	            .data(evt)
	            .hidden(false);
	    });
	
	    bars.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true);
	    });
	
	    bars.dispatch.on('elementMousemove.tooltip', function(evt) {
	        tooltip();
	    });
	
	    //============================================================
	
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.legend = legend;
	    chart.lines = lines;
	    chart.lines2 = lines2;
	    chart.bars = bars;
	    chart.bars2 = bars2;
	    chart.xAxis = xAxis;
	    chart.x2Axis = x2Axis;
	    chart.y1Axis = y1Axis;
	    chart.y2Axis = y2Axis;
	    chart.y3Axis = y3Axis;
	    chart.y4Axis = y4Axis;
	    chart.tooltip = tooltip;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        showLegend: {get: function(){return showLegend;}, set: function(_){showLegend=_;}},
	        brushExtent:    {get: function(){return brushExtent;}, set: function(_){brushExtent=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	        focusEnable:    {get: function(){return focusEnable;}, set: function(_){focusEnable=_;}},
	        focusHeight:    {get: function(){return focusHeight;}, set: function(_){focusHeight=_;}},
	        focusShowAxisX:    {get: function(){return focusShowAxisX;}, set: function(_){focusShowAxisX=_;}},
	        focusShowAxisY:    {get: function(){return focusShowAxisY;}, set: function(_){focusShowAxisY=_;}},
	        legendLeftAxisHint:    {get: function(){return legendLeftAxisHint;}, set: function(_){legendLeftAxisHint=_;}},
	        legendRightAxisHint:    {get: function(){return legendRightAxisHint;}, set: function(_){legendRightAxisHint=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        focusMargin: {get: function(){return margin2;}, set: function(_){
	            margin2.top    = _.top    !== undefined ? _.top    : margin2.top;
	            margin2.right  = _.right  !== undefined ? _.right  : margin2.right;
	            margin2.bottom = _.bottom !== undefined ? _.bottom : margin2.bottom;
	            margin2.left   = _.left   !== undefined ? _.left   : margin2.left;
	        }},
	        duration: {get: function(){return transitionDuration;}, set: function(_){
	            transitionDuration = _;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            legend.color(color);
	        }},
	        x: {get: function(){return getX;}, set: function(_){
	            getX = _;
	            lines.x(_);
	            lines2.x(_);
	            bars.x(_);
	            bars2.x(_);
	        }},
	        y: {get: function(){return getY;}, set: function(_){
	            getY = _;
	            lines.y(_);
	            lines2.y(_);
	            bars.y(_);
	            bars2.y(_);
	        }},
	        switchYAxisOrder:    {get: function(){return switchYAxisOrder;}, set: function(_){
	            // Switch the tick format for the yAxis
	            if(switchYAxisOrder !== _) {
	                var y1 = y1Axis;
	                y1Axis = y2Axis;
	                y2Axis = y1;
	
	                var y3 = y3Axis;
	                y3Axis = y4Axis;
	                y4Axis = y3;
	            }
	            switchYAxisOrder=_;
	
	            y1Axis.orient('left');
	            y2Axis.orient('right');
	            y3Axis.orient('left');
	            y4Axis.orient('right');
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, lines);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.multiBar = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = 960
	        , height = 500
	        , x = d3.scale.ordinal()
	        , y = d3.scale.linear()
	        , id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
	        , container = null
	        , getX = function(d) { return d.x }
	        , getY = function(d) { return d.y }
	        , forceY = [0] // 0 is forced by default.. this makes sense for the majority of bar graphs... user can always do chart.forceY([]) to remove
	        , clipEdge = true
	        , stacked = false
	        , stackOffset = 'zero' // options include 'silhouette', 'wiggle', 'expand', 'zero', or a custom function
	        , color = nv.utils.defaultColor()
	        , hideable = false
	        , barColor = null // adding the ability to set the color for each rather than the whole group
	        , disabled // used in conjunction with barColor to communicate from multiBarHorizontalChart what series are disabled
	        , duration = 500
	        , xDomain
	        , yDomain
	        , xRange
	        , yRange
	        , groupSpacing = 0.1
	        , fillOpacity = 0.75
	        , dispatch = d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd')
	        ;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var x0, y0 //used to store previous scales
	        , renderWatch = nv.utils.renderWatch(dispatch, duration)
	        ;
	
	    var last_datalength = 0;
	
	    function chart(selection) {
	        renderWatch.reset();
	        selection.each(function(data) {
	            var availableWidth = width - margin.left - margin.right,
	                availableHeight = height - margin.top - margin.bottom;
	
	            container = d3.select(this);
	            nv.utils.initSVG(container);
	            var nonStackableCount = 0;
	            // This function defines the requirements for render complete
	            var endFn = function(d, i) {
	                if (d.series === data.length - 1 && i === data[0].values.length - 1)
	                    return true;
	                return false;
	            };
	
	            if(hideable && data.length) hideable = [{
	                values: data[0].values.map(function(d) {
	                        return {
	                            x: d.x,
	                            y: 0,
	                            series: d.series,
	                            size: 0.01
	                        };}
	                )}];
	
	            if (stacked) {
	                var parsed = d3.layout.stack()
	                    .offset(stackOffset)
	                    .values(function(d){ return d.values })
	                    .y(getY)
	                (!data.length && hideable ? hideable : data);
	
	                parsed.forEach(function(series, i){
	                    // if series is non-stackable, use un-parsed data
	                    if (series.nonStackable) {
	                        data[i].nonStackableSeries = nonStackableCount++;
	                        parsed[i] = data[i];
	                    } else {
	                        // don't stack this seires on top of the nonStackable seriees
	                        if (i > 0 && parsed[i - 1].nonStackable){
	                            parsed[i].values.map(function(d,j){
	                                d.y0 -= parsed[i - 1].values[j].y;
	                                d.y1 = d.y0 + d.y;
	                            });
	                        }
	                    }
	                });
	                data = parsed;
	            }
	            //add series index and key to each data point for reference
	            data.forEach(function(series, i) {
	                series.values.forEach(function(point) {
	                    point.series = i;
	                    point.key = series.key;
	                });
	            });
	
	            // HACK for negative value stacking
	            if (stacked && data.length > 0) {
	                data[0].values.map(function(d,i) {
	                    var posBase = 0, negBase = 0;
	                    data.map(function(d, idx) {
	                        if (!data[idx].nonStackable) {
	                            var f = d.values[i]
	                            f.size = Math.abs(f.y);
	                            if (f.y<0)  {
	                                f.y1 = negBase;
	                                negBase = negBase - f.size;
	                            } else
	                            {
	                                f.y1 = f.size + posBase;
	                                posBase = posBase + f.size;
	                            }
	                        }
	
	                    });
	                });
	            }
	            // Setup Scales
	            // remap and flatten the data for use in calculating the scales' domains
	            var seriesData = (xDomain && yDomain) ? [] : // if we know xDomain and yDomain, no need to calculate
	                data.map(function(d, idx) {
	                    return d.values.map(function(d,i) {
	                        return { x: getX(d,i), y: getY(d,i), y0: d.y0, y1: d.y1, idx:idx }
	                    })
	                });
	
	            x.domain(xDomain || d3.merge(seriesData).map(function(d) { return d.x }))
	                .rangeBands(xRange || [0, availableWidth], groupSpacing);
	
	            y.domain(yDomain || d3.extent(d3.merge(seriesData).map(function(d) {
	                var domain = d.y;
	                // increase the domain range if this series is stackable
	                if (stacked && !data[d.idx].nonStackable) {
	                    if (d.y > 0){
	                        domain = d.y1
	                    } else {
	                        domain = d.y1 + d.y
	                    }
	                }
	                return domain;
	            }).concat(forceY)))
	            .range(yRange || [availableHeight, 0]);
	
	            // If scale's domain don't have a range, slightly adjust to make one... so a chart can show a single data point
	            if (x.domain()[0] === x.domain()[1])
	                x.domain()[0] ?
	                    x.domain([x.domain()[0] - x.domain()[0] * 0.01, x.domain()[1] + x.domain()[1] * 0.01])
	                    : x.domain([-1,1]);
	
	            if (y.domain()[0] === y.domain()[1])
	                y.domain()[0] ?
	                    y.domain([y.domain()[0] + y.domain()[0] * 0.01, y.domain()[1] - y.domain()[1] * 0.01])
	                    : y.domain([-1,1]);
	
	            x0 = x0 || x;
	            y0 = y0 || y;
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-multibar').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multibar');
	            var defsEnter = wrapEnter.append('defs');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-groups');
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            defsEnter.append('clipPath')
	                .attr('id', 'nv-edge-clip-' + id)
	                .append('rect');
	            wrap.select('#nv-edge-clip-' + id + ' rect')
	                .attr('width', availableWidth)
	                .attr('height', availableHeight);
	
	            g.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + id + ')' : '');
	
	            var groups = wrap.select('.nv-groups').selectAll('.nv-group')
	                .data(function(d) { return d }, function(d,i) { return i });
	            groups.enter().append('g')
	                .style('stroke-opacity', 1e-6)
	                .style('fill-opacity', 1e-6);
	
	            var exitTransition = renderWatch
	                .transition(groups.exit().selectAll('rect.nv-bar'), 'multibarExit', Math.min(100, duration))
	                .attr('y', function(d, i, j) {
	                    var yVal = y0(0) || 0;
	                    if (stacked) {
	                        if (data[d.series] && !data[d.series].nonStackable) {
	                            yVal = y0(d.y0);
	                        }
	                    }
	                    return yVal;
	                })
	                .attr('height', 0)
	                .remove();
	            if (exitTransition.delay)
	                exitTransition.delay(function(d,i) {
	                    var delay = i * (duration / (last_datalength + 1)) - i;
	                    return delay;
	                });
	            groups
	                .attr('class', function(d,i) { return 'nv-group nv-series-' + i })
	                .classed('hover', function(d) { return d.hover })
	                .style('fill', function(d,i){ return color(d, i) })
	                .style('stroke', function(d,i){ return color(d, i) });
	            groups
	                .style('stroke-opacity', 1)
	                .style('fill-opacity', fillOpacity);
	
	            var bars = groups.selectAll('rect.nv-bar')
	                .data(function(d) { return (hideable && !data.length) ? hideable.values : d.values });
	            bars.exit().remove();
	
	            var barsEnter = bars.enter().append('rect')
	                    .attr('class', function(d,i) { return getY(d,i) < 0 ? 'nv-bar negative' : 'nv-bar positive'})
	                    .attr('x', function(d,i,j) {
	                        return stacked && !data[j].nonStackable ? 0 : (j * x.rangeBand() / data.length )
	                    })
	                    .attr('y', function(d,i,j) { return y0(stacked && !data[j].nonStackable ? d.y0 : 0) || 0 })
	                    .attr('height', 0)
	                    .attr('width', function(d,i,j) { return x.rangeBand() / (stacked && !data[j].nonStackable ? 1 : data.length) })
	                    .attr('transform', function(d,i) { return 'translate(' + x(getX(d,i)) + ',0)'; })
	                ;
	            bars
	                .style('fill', function(d,i,j){ return color(d, j, i);  })
	                .style('stroke', function(d,i,j){ return color(d, j, i); })
	                .on('mouseover', function(d,i,j) {
	                    d3.select(this).classed('hover', true);
	                    dispatch.elementMouseover({
	                        data: d,
	                        index: i,
	                        series: data[j],
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('mouseout', function(d,i,j) {
	                    d3.select(this).classed('hover', false);
	                    dispatch.elementMouseout({
	                        data: d,
	                        index: i,
	                        series: data[j],
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('mousemove', function(d,i,j) {
	                    dispatch.elementMousemove({
	                        data: d,
	                        index: i,
	                        series: data[j],
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('click', function(d,i,j) {
	                    var element = this;
	                    dispatch.elementClick({
	                        data: d,
	                        index: i,
	                        series: data[j],
	                        color: d3.select(this).style("fill"),
	                        event: d3.event,
	                        element: element
	                    });
	                    d3.event.stopPropagation();
	                })
	                .on('dblclick', function(d,i,j) {
	                    dispatch.elementDblClick({
	                        data: d,
	                        index: i,
	                        series: data[j],
	                        color: d3.select(this).style("fill")
	                    });
	                    d3.event.stopPropagation();
	                });
	            bars
	                .attr('class', function(d,i) { return getY(d,i) < 0 ? 'nv-bar negative' : 'nv-bar positive'})
	                .attr('transform', function(d,i) { return 'translate(' + x(getX(d,i)) + ',0)'; })
	
	            if (barColor) {
	                if (!disabled) disabled = data.map(function() { return true });
	                bars
	                    .style('fill', function(d,i,j) { return d3.rgb(barColor(d,i)).darker(  disabled.map(function(d,i) { return i }).filter(function(d,i){ return !disabled[i]  })[j]   ).toString(); })
	                    .style('stroke', function(d,i,j) { return d3.rgb(barColor(d,i)).darker(  disabled.map(function(d,i) { return i }).filter(function(d,i){ return !disabled[i]  })[j]   ).toString(); });
	            }
	
	            var barSelection =
	                bars.watchTransition(renderWatch, 'multibar', Math.min(250, duration))
	                    .delay(function(d,i) {
	                        return i * duration / data[0].values.length;
	                    });
	            if (stacked){
	                barSelection
	                    .attr('y', function(d,i,j) {
	                        var yVal = 0;
	                        // if stackable, stack it on top of the previous series
	                        if (!data[j].nonStackable) {
	                            yVal = y(d.y1);
	                        } else {
	                            if (getY(d,i) < 0){
	                                yVal = y(0);
	                            } else {
	                                if (y(0) - y(getY(d,i)) < -1){
	                                    yVal = y(0) - 1;
	                                } else {
	                                    yVal = y(getY(d, i)) || 0;
	                                }
	                            }
	                        }
	                        return yVal;
	                    })
	                    .attr('height', function(d,i,j) {
	                        if (!data[j].nonStackable) {
	                            return Math.max(Math.abs(y(d.y+d.y0) - y(d.y0)), 0);
	                        } else {
	                            return Math.max(Math.abs(y(getY(d,i)) - y(0)), 0) || 0;
	                        }
	                    })
	                    .attr('x', function(d,i,j) {
	                        var width = 0;
	                        if (data[j].nonStackable) {
	                            width = d.series * x.rangeBand() / data.length;
	                            if (data.length !== nonStackableCount){
	                                width = data[j].nonStackableSeries * x.rangeBand()/(nonStackableCount*2);
	                            }
	                        }
	                        return width;
	                    })
	                    .attr('width', function(d,i,j){
	                        if (!data[j].nonStackable) {
	                            return x.rangeBand();
	                        } else {
	                            // if all series are nonStacable, take the full width
	                            var width = (x.rangeBand() / nonStackableCount);
	                            // otherwise, nonStackable graph will be only taking the half-width
	                            // of the x rangeBand
	                            if (data.length !== nonStackableCount) {
	                                width = x.rangeBand()/(nonStackableCount*2);
	                            }
	                            return width;
	                        }
	                    });
	            }
	            else {
	                barSelection
	                    .attr('x', function(d,i) {
	                        return d.series * x.rangeBand() / data.length;
	                    })
	                    .attr('width', x.rangeBand() / data.length)
	                    .attr('y', function(d,i) {
	                        return getY(d,i) < 0 ?
	                            y(0) :
	                                y(0) - y(getY(d,i)) < 1 ?
	                            y(0) - 1 :
	                            y(getY(d,i)) || 0;
	                    })
	                    .attr('height', function(d,i) {
	                        return Math.max(Math.abs(y(getY(d,i)) - y(0)),1) || 0;
	                    });
	            }
	
	            //store old scales for use in transitions on update
	            x0 = x.copy();
	            y0 = y.copy();
	
	            // keep track of the last data value length for transition calculations
	            if (data[0] && data[0].values) {
	                last_datalength = data[0].values.length;
	            }
	
	        });
	
	        renderWatch.renderEnd('multibar immediate');
	
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:   {get: function(){return width;}, set: function(_){width=_;}},
	        height:  {get: function(){return height;}, set: function(_){height=_;}},
	        x:       {get: function(){return getX;}, set: function(_){getX=_;}},
	        y:       {get: function(){return getY;}, set: function(_){getY=_;}},
	        xScale:  {get: function(){return x;}, set: function(_){x=_;}},
	        yScale:  {get: function(){return y;}, set: function(_){y=_;}},
	        xDomain: {get: function(){return xDomain;}, set: function(_){xDomain=_;}},
	        yDomain: {get: function(){return yDomain;}, set: function(_){yDomain=_;}},
	        xRange:  {get: function(){return xRange;}, set: function(_){xRange=_;}},
	        yRange:  {get: function(){return yRange;}, set: function(_){yRange=_;}},
	        forceY:  {get: function(){return forceY;}, set: function(_){forceY=_;}},
	        stacked: {get: function(){return stacked;}, set: function(_){stacked=_;}},
	        stackOffset: {get: function(){return stackOffset;}, set: function(_){stackOffset=_;}},
	        clipEdge:    {get: function(){return clipEdge;}, set: function(_){clipEdge=_;}},
	        disabled:    {get: function(){return disabled;}, set: function(_){disabled=_;}},
	        id:          {get: function(){return id;}, set: function(_){id=_;}},
	        hideable:    {get: function(){return hideable;}, set: function(_){hideable=_;}},
	        groupSpacing:{get: function(){return groupSpacing;}, set: function(_){groupSpacing=_;}},
	        fillOpacity: {get: function(){return fillOpacity;}, set: function(_){fillOpacity=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }},
	        barColor:  {get: function(){return barColor;}, set: function(_){
	            barColor = _ ? nv.utils.getColor(_) : null;
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	nv.models.multiBarChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var multibar = nv.models.multiBar()
	        , xAxis = nv.models.axis()
	        , yAxis = nv.models.axis()
	        , interactiveLayer = nv.interactiveGuideline()
	        , legend = nv.models.legend()
	        , controls = nv.models.legend()
	        , tooltip = nv.models.tooltip()
	        ;
	
	    var margin = {top: 30, right: 20, bottom: 50, left: 60}
	        , marginTop = null
	        , width = null
	        , height = null
	        , color = nv.utils.defaultColor()
	        , showControls = true
	        , controlLabels = {}
	        , showLegend = true
	        , legendPosition = null
	        , showXAxis = true
	        , showYAxis = true
	        , rightAlignYAxis = false
	        , reduceXTicks = true // if false a tick will show for every data point
	        , staggerLabels = false
	        , wrapLabels = false
	        , rotateLabels = 0
	        , x //can be accessed via chart.xScale()
	        , y //can be accessed via chart.yScale()
	        , state = nv.utils.state()
	        , defaultState = null
	        , noData = null
	        , dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd')
	        , controlWidth = function() { return showControls ? 180 : 0 }
	        , duration = 250
	        , useInteractiveGuideline = false
	        ;
	
	    state.stacked = false // DEPRECATED Maintained for backward compatibility
	
	    multibar.stacked(false);
	    xAxis
	        .orient('bottom')
	        .tickPadding(7)
	        .showMaxMin(false)
	        .tickFormat(function(d) { return d })
	    ;
	    yAxis
	        .orient((rightAlignYAxis) ? 'right' : 'left')
	        .tickFormat(d3.format(',.1f'))
	    ;
	
	    tooltip
	        .duration(0)
	        .valueFormatter(function(d, i) {
	            return yAxis.tickFormat()(d, i);
	        })
	        .headerFormatter(function(d, i) {
	            return xAxis.tickFormat()(d, i);
	        });
	
	    interactiveLayer.tooltip
	        .valueFormatter(function(d, i) {
	            return d == null ? "N/A" : yAxis.tickFormat()(d, i);
	        })
	        .headerFormatter(function(d, i) {
	            return xAxis.tickFormat()(d, i);
	        });
	
	    interactiveLayer.tooltip
	        .valueFormatter(function (d, i) {
	            return d == null ? "N/A" : yAxis.tickFormat()(d, i);
	        })
	        .headerFormatter(function (d, i) {
	            return xAxis.tickFormat()(d, i);
	        });
	
	    interactiveLayer.tooltip
	        .duration(0)
	        .valueFormatter(function(d, i) {
	            return yAxis.tickFormat()(d, i);
	        })
	        .headerFormatter(function(d, i) {
	            return xAxis.tickFormat()(d, i);
	        });
	
	    controls.updateState(false);
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch);
	    var stacked = false;
	
	    var stateGetter = function(data) {
	        return function(){
	            return {
	                active: data.map(function(d) { return !d.disabled }),
	                stacked: stacked
	            };
	        }
	    };
	
	    var stateSetter = function(data) {
	        return function(state) {
	            if (state.stacked !== undefined)
	                stacked = state.stacked;
	            if (state.active !== undefined)
	                data.forEach(function(series,i) {
	                    series.disabled = !state.active[i];
	                });
	        }
	    };
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(multibar);
	        if (showXAxis) renderWatch.models(xAxis);
	        if (showYAxis) renderWatch.models(yAxis);
	
	        selection.each(function(data) {
	            var container = d3.select(this),
	                that = this;
	            nv.utils.initSVG(container);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            chart.update = function() {
	                if (duration === 0)
	                    container.call(chart);
	                else
	                    container.transition()
	                        .duration(duration)
	                        .call(chart);
	            };
	            chart.container = this;
	
	            state
	                .setter(stateSetter(data), chart.update)
	                .getter(stateGetter(data))
	                .update();
	
	            // DEPRECATED set state.disableddisabled
	            state.disabled = data.map(function(d) { return !!d.disabled });
	
	            if (!defaultState) {
	                var key;
	                defaultState = {};
	                for (key in state) {
	                    if (state[key] instanceof Array)
	                        defaultState[key] = state[key].slice(0);
	                    else
	                        defaultState[key] = state[key];
	                }
	            }
	
	            // Display noData message if there's nothing to show.
	            if (!data || !data.length || !data.filter(function(d) { return d.values.length }).length) {
	                nv.utils.noData(chart, container)
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            // Setup Scales
	            x = multibar.xScale();
	            y = multibar.yScale();
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-multiBarWithLegend').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multiBarWithLegend').append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-x nv-axis');
	            gEnter.append('g').attr('class', 'nv-y nv-axis');
	            gEnter.append('g').attr('class', 'nv-barsWrap');
	            gEnter.append('g').attr('class', 'nv-legendWrap');
	            gEnter.append('g').attr('class', 'nv-controlsWrap');
	            gEnter.append('g').attr('class', 'nv-interactive');
	
	            // Legend
	            if (!showLegend) {
	                g.select('.nv-legendWrap').selectAll('*').remove();
	            } else {
	                if (legendPosition === 'bottom') {
	                    legend.width(availableWidth - margin.right);
	
	                     g.select('.nv-legendWrap')
	                         .datum(data)
	                         .call(legend);
	
	                     margin.bottom = xAxis.height() + legend.height();
	                     availableHeight = nv.utils.availableHeight(height, container, margin);
	                     g.select('.nv-legendWrap')
	                         .attr('transform', 'translate(0,' + (availableHeight + xAxis.height())  +')');
	                } else {
	                    legend.width(availableWidth - controlWidth());
	
	                    g.select('.nv-legendWrap')
	                        .datum(data)
	                        .call(legend);
	
	                    if (!marginTop && legend.height() !== margin.top) {
	                        margin.top = legend.height();
	                        availableHeight = nv.utils.availableHeight(height, container, margin);
	                    }
	
	                    g.select('.nv-legendWrap')
	                        .attr('transform', 'translate(' + controlWidth() + ',' + (-margin.top) +')');
	                }
	            }
	
	            // Controls
	            if (!showControls) {
	                 g.select('.nv-controlsWrap').selectAll('*').remove();
	            } else {
	                var controlsData = [
	                    { key: controlLabels.grouped || 'Grouped', disabled: multibar.stacked() },
	                    { key: controlLabels.stacked || 'Stacked', disabled: !multibar.stacked() }
	                ];
	
	                controls.width(controlWidth()).color(['#444', '#444', '#444']);
	                g.select('.nv-controlsWrap')
	                    .datum(controlsData)
	                    .attr('transform', 'translate(0,' + (-margin.top) +')')
	                    .call(controls);
	            }
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	            if (rightAlignYAxis) {
	                g.select(".nv-y.nv-axis")
	                    .attr("transform", "translate(" + availableWidth + ",0)");
	            }
	
	            // Main Chart Component(s)
	            multibar
	                .disabled(data.map(function(series) { return series.disabled }))
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(data.map(function(d,i) {
	                    return d.color || color(d, i);
	                }).filter(function(d,i) { return !data[i].disabled }));
	
	
	            var barsWrap = g.select('.nv-barsWrap')
	                .datum(data.filter(function(d) { return !d.disabled }));
	
	            barsWrap.call(multibar);
	
	            // Setup Axes
	            if (showXAxis) {
	                xAxis
	                    .scale(x)
	                    ._ticks( nv.utils.calcTicksX(availableWidth/100, data) )
	                    .tickSize(-availableHeight, 0);
	
	                g.select('.nv-x.nv-axis')
	                    .attr('transform', 'translate(0,' + y.range()[0] + ')');
	                g.select('.nv-x.nv-axis')
	                    .call(xAxis);
	
	                var xTicks = g.select('.nv-x.nv-axis > g').selectAll('g');
	
	                xTicks
	                    .selectAll('line, text')
	                    .style('opacity', 1)
	
	                if (staggerLabels) {
	                    var getTranslate = function(x,y) {
	                        return "translate(" + x + "," + y + ")";
	                    };
	
	                    var staggerUp = 5, staggerDown = 17;  //pixels to stagger by
	                    // Issue #140
	                    xTicks
	                        .selectAll("text")
	                        .attr('transform', function(d,i,j) {
	                            return  getTranslate(0, (j % 2 == 0 ? staggerUp : staggerDown));
	                        });
	
	                    var totalInBetweenTicks = d3.selectAll(".nv-x.nv-axis .nv-wrap g g text")[0].length;
	                    g.selectAll(".nv-x.nv-axis .nv-axisMaxMin text")
	                        .attr("transform", function(d,i) {
	                            return getTranslate(0, (i === 0 || totalInBetweenTicks % 2 !== 0) ? staggerDown : staggerUp);
	                        });
	                }
	
	                if (wrapLabels) {
	                    g.selectAll('.tick text')
	                        .call(nv.utils.wrapTicks, chart.xAxis.rangeBand())
	                }
	
	                if (reduceXTicks)
	                    xTicks
	                        .filter(function(d,i) {
	                            return i % Math.ceil(data[0].values.length / (availableWidth / 100)) !== 0;
	                        })
	                        .selectAll('text, line')
	                        .style('opacity', 0);
	
	                if(rotateLabels)
	                    xTicks
	                        .selectAll('.tick text')
	                        .attr('transform', 'rotate(' + rotateLabels + ' 0,0)')
	                        .style('text-anchor', rotateLabels > 0 ? 'start' : 'end');
	
	                g.select('.nv-x.nv-axis').selectAll('g.nv-axisMaxMin text')
	                    .style('opacity', 1);
	            }
	
	            if (showYAxis) {
	                yAxis
	                    .scale(y)
	                    ._ticks( nv.utils.calcTicksY(availableHeight/36, data) )
	                    .tickSize( -availableWidth, 0);
	
	                g.select('.nv-y.nv-axis')
	                    .call(yAxis);
	            }
	
	            //Set up interactive layer
	            if (useInteractiveGuideline) {
	                interactiveLayer
	                    .width(availableWidth)
	                    .height(availableHeight)
	                    .margin({left:margin.left, top:margin.top})
	                    .svgContainer(container)
	                    .xScale(x);
	                wrap.select(".nv-interactive").call(interactiveLayer);
	            }
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            legend.dispatch.on('stateChange', function(newState) {
	                for (var key in newState)
	                    state[key] = newState[key];
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            controls.dispatch.on('legendClick', function(d,i) {
	                if (!d.disabled) return;
	                controlsData = controlsData.map(function(s) {
	                    s.disabled = true;
	                    return s;
	                });
	                d.disabled = false;
	
	                switch (d.key) {
	                    case 'Grouped':
	                    case controlLabels.grouped:
	                        multibar.stacked(false);
	                        break;
	                    case 'Stacked':
	                    case controlLabels.stacked:
	                        multibar.stacked(true);
	                        break;
	                }
	
	                state.stacked = multibar.stacked();
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            // Update chart from a state object passed to event handler
	            dispatch.on('changeState', function(e) {
	                if (typeof e.disabled !== 'undefined') {
	                    data.forEach(function(series,i) {
	                        series.disabled = e.disabled[i];
	                    });
	                    state.disabled = e.disabled;
	                }
	                if (typeof e.stacked !== 'undefined') {
	                    multibar.stacked(e.stacked);
	                    state.stacked = e.stacked;
	                    stacked = e.stacked;
	                }
	                chart.update();
	            });
	
	            if (useInteractiveGuideline) {
	                interactiveLayer.dispatch.on('elementMousemove', function(e) {
	                    if (e.pointXValue == undefined) return;
	
	                    var singlePoint, pointIndex, pointXLocation, xValue, allData = [];
	                    data
	                        .filter(function(series, i) {
	                            series.seriesIndex = i;
	                            return !series.disabled;
	                        })
	                        .forEach(function(series,i) {
	                            pointIndex = x.domain().indexOf(e.pointXValue)
	
	                            var point = series.values[pointIndex];
	                            if (point === undefined) return;
	
	                            xValue = point.x;
	                            if (singlePoint === undefined) singlePoint = point;
	                            if (pointXLocation === undefined) pointXLocation = e.mouseX
	                            allData.push({
	                                key: series.key,
	                                value: chart.y()(point, pointIndex),
	                                color: color(series,series.seriesIndex),
	                                data: series.values[pointIndex]
	                            });
	                        });
	
	                    interactiveLayer.tooltip
	                        .data({
	                            value: xValue,
	                            index: pointIndex,
	                            series: allData
	                        })();
	
	                    interactiveLayer.renderGuideLine(pointXLocation);
	                });
	
	                interactiveLayer.dispatch.on("elementMouseout",function(e) {
	                    interactiveLayer.tooltip.hidden(true);
	                });
	            }
	            else {
	                multibar.dispatch.on('elementMouseover.tooltip', function(evt) {
	                    evt.value = chart.x()(evt.data);
	                    evt['series'] = {
	                        key: evt.data.key,
	                        value: chart.y()(evt.data),
	                        color: evt.color
	                    };
	                    tooltip.data(evt).hidden(false);
	                });
	
	                multibar.dispatch.on('elementMouseout.tooltip', function(evt) {
	                    tooltip.hidden(true);
	                });
	
	                multibar.dispatch.on('elementMousemove.tooltip', function(evt) {
	                    tooltip();
	                });
	            }
	        });
	
	        renderWatch.renderEnd('multibarchart immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.multibar = multibar;
	    chart.legend = legend;
	    chart.controls = controls;
	    chart.xAxis = xAxis;
	    chart.yAxis = yAxis;
	    chart.state = state;
	    chart.tooltip = tooltip;
	    chart.interactiveLayer = interactiveLayer;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        showLegend: {get: function(){return showLegend;}, set: function(_){showLegend=_;}},
	        legendPosition: {get: function(){return legendPosition;}, set: function(_){legendPosition=_;}},
	        showControls: {get: function(){return showControls;}, set: function(_){showControls=_;}},
	        controlLabels: {get: function(){return controlLabels;}, set: function(_){controlLabels=_;}},
	        showXAxis:      {get: function(){return showXAxis;}, set: function(_){showXAxis=_;}},
	        showYAxis:    {get: function(){return showYAxis;}, set: function(_){showYAxis=_;}},
	        defaultState:    {get: function(){return defaultState;}, set: function(_){defaultState=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	        reduceXTicks:    {get: function(){return reduceXTicks;}, set: function(_){reduceXTicks=_;}},
	        rotateLabels:    {get: function(){return rotateLabels;}, set: function(_){rotateLabels=_;}},
	        staggerLabels:    {get: function(){return staggerLabels;}, set: function(_){staggerLabels=_;}},
	        wrapLabels:   {get: function(){return wrapLabels;}, set: function(_){wrapLabels=!!_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            multibar.duration(duration);
	            xAxis.duration(duration);
	            yAxis.duration(duration);
	            renderWatch.reset(duration);
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            legend.color(color);
	        }},
	        rightAlignYAxis: {get: function(){return rightAlignYAxis;}, set: function(_){
	            rightAlignYAxis = _;
	            yAxis.orient( rightAlignYAxis ? 'right' : 'left');
	        }},
	        useInteractiveGuideline: {get: function(){return useInteractiveGuideline;}, set: function(_){
	            useInteractiveGuideline = _;
	        }},
	        barColor:  {get: function(){return multibar.barColor;}, set: function(_){
	            multibar.barColor(_);
	            legend.color(function(d,i) {return d3.rgb('#ccc').darker(i * 1.5).toString();})
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, multibar);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.multiBarHorizontal = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = 960
	        , height = 500
	        , id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
	        , container = null
	        , x = d3.scale.ordinal()
	        , y = d3.scale.linear()
	        , getX = function(d) { return d.x }
	        , getY = function(d) { return d.y }
	        , getYerr = function(d) { return d.yErr }
	        , forceY = [0] // 0 is forced by default.. this makes sense for the majority of bar graphs... user can always do chart.forceY([]) to remove
	        , color = nv.utils.defaultColor()
	        , barColor = null // adding the ability to set the color for each rather than the whole group
	        , disabled // used in conjunction with barColor to communicate from multiBarHorizontalChart what series are disabled
	        , stacked = false
	        , showValues = false
	        , showBarLabels = false
	        , valuePadding = 60
	        , groupSpacing = 0.1
	        , fillOpacity = 0.75
	        , valueFormat = d3.format(',.2f')
	        , delay = 1200
	        , xDomain
	        , yDomain
	        , xRange
	        , yRange
	        , duration = 250
	        , dispatch = d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd')
	        ;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var x0, y0; //used to store previous scales
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    function chart(selection) {
	        renderWatch.reset();
	        selection.each(function(data) {
	            var availableWidth = width - margin.left - margin.right,
	                availableHeight = height - margin.top - margin.bottom;
	
	            container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            if (stacked)
	                data = d3.layout.stack()
	                    .offset('zero')
	                    .values(function(d){ return d.values })
	                    .y(getY)
	                (data);
	
	            //add series index and key to each data point for reference
	            data.forEach(function(series, i) {
	                series.values.forEach(function(point) {
	                    point.series = i;
	                    point.key = series.key;
	                });
	            });
	
	            // HACK for negative value stacking
	            if (stacked)
	                data[0].values.map(function(d,i) {
	                    var posBase = 0, negBase = 0;
	                    data.map(function(d) {
	                        var f = d.values[i]
	                        f.size = Math.abs(f.y);
	                        if (f.y<0)  {
	                            f.y1 = negBase - f.size;
	                            negBase = negBase - f.size;
	                        } else
	                        {
	                            f.y1 = posBase;
	                            posBase = posBase + f.size;
	                        }
	                    });
	                });
	
	            // Setup Scales
	            // remap and flatten the data for use in calculating the scales' domains
	            var seriesData = (xDomain && yDomain) ? [] : // if we know xDomain and yDomain, no need to calculate
	                data.map(function(d) {
	                    return d.values.map(function(d,i) {
	                        return { x: getX(d,i), y: getY(d,i), y0: d.y0, y1: d.y1 }
	                    })
	                });
	
	            x.domain(xDomain || d3.merge(seriesData).map(function(d) { return d.x }))
	                .rangeBands(xRange || [0, availableHeight], groupSpacing);
	
	            y.domain(yDomain || d3.extent(d3.merge(seriesData).map(function(d) { return stacked ? (d.y > 0 ? d.y1 + d.y : d.y1 ) : d.y }).concat(forceY)))
	
	            if (showValues && !stacked)
	                y.range(yRange || [(y.domain()[0] < 0 ? valuePadding : 0), availableWidth - (y.domain()[1] > 0 ? valuePadding : 0) ]);
	            else
	                y.range(yRange || [0, availableWidth]);
	
	            x0 = x0 || x;
	            y0 = y0 || d3.scale.linear().domain(y.domain()).range([y(0),y(0)]);
	
	            // Setup containers and skeleton of chart
	            var wrap = d3.select(this).selectAll('g.nv-wrap.nv-multibarHorizontal').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multibarHorizontal');
	            var defsEnter = wrapEnter.append('defs');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-groups');
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            var groups = wrap.select('.nv-groups').selectAll('.nv-group')
	                .data(function(d) { return d }, function(d,i) { return i });
	            groups.enter().append('g')
	                .style('stroke-opacity', 1e-6)
	                .style('fill-opacity', 1e-6);
	            groups.exit().watchTransition(renderWatch, 'multibarhorizontal: exit groups')
	                .style('stroke-opacity', 1e-6)
	                .style('fill-opacity', 1e-6)
	                .remove();
	            groups
	                .attr('class', function(d,i) { return 'nv-group nv-series-' + i })
	                .classed('hover', function(d) { return d.hover })
	                .style('fill', function(d,i){ return color(d, i) })
	                .style('stroke', function(d,i){ return color(d, i) });
	            groups.watchTransition(renderWatch, 'multibarhorizontal: groups')
	                .style('stroke-opacity', 1)
	                .style('fill-opacity', fillOpacity);
	
	            var bars = groups.selectAll('g.nv-bar')
	                .data(function(d) { return d.values });
	            bars.exit().remove();
	
	            var barsEnter = bars.enter().append('g')
	                .attr('transform', function(d,i,j) {
	                    return 'translate(' + y0(stacked ? d.y0 : 0) + ',' + (stacked ? 0 : (j * x.rangeBand() / data.length ) + x(getX(d,i))) + ')'
	                });
	
	            barsEnter.append('rect')
	                .attr('width', 0)
	                .attr('height', x.rangeBand() / (stacked ? 1 : data.length) )
	
	            bars
	                .on('mouseover', function(d,i) { //TODO: figure out why j works above, but not here
	                    d3.select(this).classed('hover', true);
	                    dispatch.elementMouseover({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('mouseout', function(d,i) {
	                    d3.select(this).classed('hover', false);
	                    dispatch.elementMouseout({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('mouseout', function(d,i) {
	                    dispatch.elementMouseout({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('mousemove', function(d,i) {
	                    dispatch.elementMousemove({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                })
	                .on('click', function(d,i) {
	                    var element = this;
	                    dispatch.elementClick({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill"),
	                        event: d3.event,
	                        element: element
	                    });
	                    d3.event.stopPropagation();
	                })
	                .on('dblclick', function(d,i) {
	                    dispatch.elementDblClick({
	                        data: d,
	                        index: i,
	                        color: d3.select(this).style("fill")
	                    });
	                    d3.event.stopPropagation();
	                });
	
	            if (getYerr(data[0],0)) {
	                barsEnter.append('polyline');
	
	                bars.select('polyline')
	                    .attr('fill', 'none')
	                    .attr('points', function(d,i) {
	                        var xerr = getYerr(d,i)
	                            , mid = 0.8 * x.rangeBand() / ((stacked ? 1 : data.length) * 2);
	                        xerr = xerr.length ? xerr : [-Math.abs(xerr), Math.abs(xerr)];
	                        xerr = xerr.map(function(e) { return y(e + ((getY(d,i) < 0) ? 0 : getY(d,i))) - y(0); });
	                        var a = [[xerr[0],-mid], [xerr[0],mid], [xerr[0],0], [xerr[1],0], [xerr[1],-mid], [xerr[1],mid]];
	                        return a.map(function (path) { return path.join(',') }).join(' ');
	                    })
	                    .attr('transform', function(d,i) {
	                        var mid = x.rangeBand() / ((stacked ? 1 : data.length) * 2);
	                        return 'translate(0, ' + mid + ')';
	                    });
	            }
	
	            barsEnter.append('text');
	
	            if (showValues && !stacked) {
	                bars.select('text')
	                    .attr('text-anchor', function(d,i) { return getY(d,i) < 0 ? 'end' : 'start' })
	                    .attr('y', x.rangeBand() / (data.length * 2))
	                    .attr('dy', '.32em')
	                    .text(function(d,i) {
	                        var t = valueFormat(getY(d,i))
	                            , yerr = getYerr(d,i);
	                        if (yerr === undefined)
	                            return t;
	                        if (!yerr.length)
	                            return t + '±' + valueFormat(Math.abs(yerr));
	                        return t + '+' + valueFormat(Math.abs(yerr[1])) + '-' + valueFormat(Math.abs(yerr[0]));
	                    });
	                bars.watchTransition(renderWatch, 'multibarhorizontal: bars')
	                    .select('text')
	                    .attr('x', function(d,i) { return getY(d,i) < 0 ? -4 : y(getY(d,i)) - y(0) + 4 })
	            } else {
	                bars.selectAll('text').text('');
	            }
	
	            if (showBarLabels && !stacked) {
	                barsEnter.append('text').classed('nv-bar-label',true);
	                bars.select('text.nv-bar-label')
	                    .attr('text-anchor', function(d,i) { return getY(d,i) < 0 ? 'start' : 'end' })
	                    .attr('y', x.rangeBand() / (data.length * 2))
	                    .attr('dy', '.32em')
	                    .text(function(d,i) { return getX(d,i) });
	                bars.watchTransition(renderWatch, 'multibarhorizontal: bars')
	                    .select('text.nv-bar-label')
	                    .attr('x', function(d,i) { return getY(d,i) < 0 ? y(0) - y(getY(d,i)) + 4 : -4 });
	            }
	            else {
	                bars.selectAll('text.nv-bar-label').text('');
	            }
	
	            bars
	                .attr('class', function(d,i) { return getY(d,i) < 0 ? 'nv-bar negative' : 'nv-bar positive'})
	
	            if (barColor) {
	                if (!disabled) disabled = data.map(function() { return true });
	                bars
	                    .style('fill', function(d,i,j) { return d3.rgb(barColor(d,i)).darker(  disabled.map(function(d,i) { return i }).filter(function(d,i){ return !disabled[i]  })[j]   ).toString(); })
	                    .style('stroke', function(d,i,j) { return d3.rgb(barColor(d,i)).darker(  disabled.map(function(d,i) { return i }).filter(function(d,i){ return !disabled[i]  })[j]   ).toString(); });
	            }
	
	            if (stacked)
	                bars.watchTransition(renderWatch, 'multibarhorizontal: bars')
	                    .attr('transform', function(d,i) {
	                        return 'translate(' + y(d.y1) + ',' + x(getX(d,i)) + ')'
	                    })
	                    .select('rect')
	                    .attr('width', function(d,i) {
	                        return Math.abs(y(getY(d,i) + d.y0) - y(d.y0)) || 0
	                    })
	                    .attr('height', x.rangeBand() );
	            else
	                bars.watchTransition(renderWatch, 'multibarhorizontal: bars')
	                    .attr('transform', function(d,i) {
	                        //TODO: stacked must be all positive or all negative, not both?
	                        return 'translate(' +
	                            (getY(d,i) < 0 ? y(getY(d,i)) : y(0))
	                            + ',' +
	                            (d.series * x.rangeBand() / data.length
	                                +
	                                x(getX(d,i)) )
	                            + ')'
	                    })
	                    .select('rect')
	                    .attr('height', x.rangeBand() / data.length )
	                    .attr('width', function(d,i) {
	                        return Math.max(Math.abs(y(getY(d,i)) - y(0)),1) || 0
	                    });
	
	            //store old scales for use in transitions on update
	            x0 = x.copy();
	            y0 = y.copy();
	
	        });
	
	        renderWatch.renderEnd('multibarHorizontal immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:   {get: function(){return width;}, set: function(_){width=_;}},
	        height:  {get: function(){return height;}, set: function(_){height=_;}},
	        x:       {get: function(){return getX;}, set: function(_){getX=_;}},
	        y:       {get: function(){return getY;}, set: function(_){getY=_;}},
	        yErr:       {get: function(){return getYerr;}, set: function(_){getYerr=_;}},
	        xScale:  {get: function(){return x;}, set: function(_){x=_;}},
	        yScale:  {get: function(){return y;}, set: function(_){y=_;}},
	        xDomain: {get: function(){return xDomain;}, set: function(_){xDomain=_;}},
	        yDomain: {get: function(){return yDomain;}, set: function(_){yDomain=_;}},
	        xRange:  {get: function(){return xRange;}, set: function(_){xRange=_;}},
	        yRange:  {get: function(){return yRange;}, set: function(_){yRange=_;}},
	        forceY:  {get: function(){return forceY;}, set: function(_){forceY=_;}},
	        stacked: {get: function(){return stacked;}, set: function(_){stacked=_;}},
	        showValues: {get: function(){return showValues;}, set: function(_){showValues=_;}},
	        // this shows the group name, seems pointless?
	        //showBarLabels:    {get: function(){return showBarLabels;}, set: function(_){showBarLabels=_;}},
	        disabled:     {get: function(){return disabled;}, set: function(_){disabled=_;}},
	        id:           {get: function(){return id;}, set: function(_){id=_;}},
	        valueFormat:  {get: function(){return valueFormat;}, set: function(_){valueFormat=_;}},
	        valuePadding: {get: function(){return valuePadding;}, set: function(_){valuePadding=_;}},
	        groupSpacing: {get: function(){return groupSpacing;}, set: function(_){groupSpacing=_;}},
	        fillOpacity:  {get: function(){return fillOpacity;}, set: function(_){fillOpacity=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }},
	        barColor:  {get: function(){return barColor;}, set: function(_){
	            barColor = _ ? nv.utils.getColor(_) : null;
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.multiBarHorizontalChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var multibar = nv.models.multiBarHorizontal()
	        , xAxis = nv.models.axis()
	        , yAxis = nv.models.axis()
	        , legend = nv.models.legend().height(30)
	        , controls = nv.models.legend().height(30)
	        , tooltip = nv.models.tooltip()
	        ;
	
	    var margin = {top: 30, right: 20, bottom: 50, left: 60}
	        , marginTop = null
	        , width = null
	        , height = null
	        , color = nv.utils.defaultColor()
	        , showControls = true
	        , controlsPosition = 'top'        
	        , controlLabels = {}
	        , showLegend = true
	        , legendPosition = 'top'
	        , showXAxis = true
	        , showYAxis = true
	        , stacked = false
	        , x //can be accessed via chart.xScale()
	        , y //can be accessed via chart.yScale()
	        , state = nv.utils.state()
	        , defaultState = null
	        , noData = null
	        , dispatch = d3.dispatch('stateChange', 'changeState','renderEnd')
	        , controlWidth = function() { return showControls ? 180 : 0 }
	        , duration = 250
	        ;
	
	    state.stacked = false; // DEPRECATED Maintained for backward compatibility
	
	    multibar.stacked(stacked);
	
	    xAxis
	        .orient('left')
	        .tickPadding(5)
	        .showMaxMin(false)
	        .tickFormat(function(d) { return d })
	    ;
	    yAxis
	        .orient('bottom')
	        .tickFormat(d3.format(',.1f'))
	    ;
	
	    tooltip
	        .duration(0)
	        .valueFormatter(function(d, i) {
	            return yAxis.tickFormat()(d, i);
	        })
	        .headerFormatter(function(d, i) {
	            return xAxis.tickFormat()(d, i);
	        });
	
	    controls.updateState(false);
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var stateGetter = function(data) {
	        return function(){
	            return {
	                active: data.map(function(d) { return !d.disabled }),
	                stacked: stacked
	            };
	        }
	    };
	
	    var stateSetter = function(data) {
	        return function(state) {
	            if (state.stacked !== undefined)
	                stacked = state.stacked;
	            if (state.active !== undefined)
	                data.forEach(function(series,i) {
	                    series.disabled = !state.active[i];
	                });
	        }
	    };
	
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(multibar);
	        if (showXAxis) renderWatch.models(xAxis);
	        if (showYAxis) renderWatch.models(yAxis);
	
	        selection.each(function(data) {
	            var container = d3.select(this),
	                that = this;
	            nv.utils.initSVG(container);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            chart.update = function() { container.transition().duration(duration).call(chart) };
	            chart.container = this;
	
	            stacked = multibar.stacked();
	
	            state
	                .setter(stateSetter(data), chart.update)
	                .getter(stateGetter(data))
	                .update();
	
	            // DEPRECATED set state.disableddisabled
	            state.disabled = data.map(function(d) { return !!d.disabled });
	
	            if (!defaultState) {
	                var key;
	                defaultState = {};
	                for (key in state) {
	                    if (state[key] instanceof Array)
	                        defaultState[key] = state[key].slice(0);
	                    else
	                        defaultState[key] = state[key];
	                }
	            }
	
	            // Display No Data message if there's nothing to show.
	            if (!data || !data.length || !data.filter(function(d) { return d.values.length }).length) {
	                nv.utils.noData(chart, container)
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            // Setup Scales
	            x = multibar.xScale();
	            y = multibar.yScale().clamp(true);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-multiBarHorizontalChart').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-multiBarHorizontalChart').append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-x nv-axis');
	            gEnter.append('g').attr('class', 'nv-y nv-axis')
	                .append('g').attr('class', 'nv-zeroLine')
	                .append('line');
	            gEnter.append('g').attr('class', 'nv-barsWrap');
	            gEnter.append('g').attr('class', 'nv-legendWrap');
	            gEnter.append('g').attr('class', 'nv-controlsWrap');
	
	            // Legend
	            if (!showLegend) {
	                g.select('.nv-legendWrap').selectAll('*').remove();
	            } else {
	                legend.width(availableWidth - controlWidth());
	
	                g.select('.nv-legendWrap')
	                    .datum(data)
	                    .call(legend);
	                if (legendPosition === 'bottom') {
	                     margin.bottom = xAxis.height() + legend.height();
	                     availableHeight = nv.utils.availableHeight(height, container, margin);
	                     g.select('.nv-legendWrap')
	                         .attr('transform', 'translate(' + controlWidth() + ',' + (availableHeight + xAxis.height())  +')');
	                } else if (legendPosition === 'top') {
	
	                    if (!marginTop && legend.height() !== margin.top) {
	                        margin.top = legend.height();
	                        availableHeight = nv.utils.availableHeight(height, container, margin);
	                    }
	
	                    g.select('.nv-legendWrap')
	                        .attr('transform', 'translate(' + controlWidth() + ',' + (-margin.top) +')');
	                }                    
	            }
	
	            // Controls
	            if (!showControls) {
	                 g.select('.nv-controlsWrap').selectAll('*').remove();
	            } else {
	                var controlsData = [
	                    { key: controlLabels.grouped || 'Grouped', disabled: multibar.stacked() },
	                    { key: controlLabels.stacked || 'Stacked', disabled: !multibar.stacked() }
	                ];
	
	                controls.width(controlWidth()).color(['#444', '#444', '#444']);
	
	                if (controlsPosition === 'bottom') {
	                     margin.bottom = xAxis.height() + legend.height();
	                     availableHeight = nv.utils.availableHeight(height, container, margin);
	                    g.select('.nv-controlsWrap')
	                        .datum(controlsData)
	                        .attr('transform', 'translate(0,' + (availableHeight + xAxis.height()) +')')
	                        .call(controls);  
	
	                } else if (controlsPosition === 'top') {
	                    g.select('.nv-controlsWrap')
	                        .datum(controlsData)
	                        .attr('transform', 'translate(0,' + (-margin.top) +')')
	                        .call(controls);                        
	                }
	            }
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            // Main Chart Component(s)
	            multibar
	                .disabled(data.map(function(series) { return series.disabled }))
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(data.map(function(d,i) {
	                    return d.color || color(d, i);
	                }).filter(function(d,i) { return !data[i].disabled }));
	
	            var barsWrap = g.select('.nv-barsWrap')
	                .datum(data.filter(function(d) { return !d.disabled }));
	
	            barsWrap.transition().call(multibar);
	
	            // Setup Axes
	            if (showXAxis) {
	                xAxis
	                    .scale(x)
	                    ._ticks( nv.utils.calcTicksY(availableHeight/24, data) )
	                    .tickSize(-availableWidth, 0);
	
	                g.select('.nv-x.nv-axis').call(xAxis);
	
	                var xTicks = g.select('.nv-x.nv-axis').selectAll('g');
	
	                xTicks
	                    .selectAll('line, text');
	            }
	
	            if (showYAxis) {
	                yAxis
	                    .scale(y)
	                    ._ticks( nv.utils.calcTicksX(availableWidth/100, data) )
	                    .tickSize( -availableHeight, 0);
	
	                g.select('.nv-y.nv-axis')
	                    .attr('transform', 'translate(0,' + availableHeight + ')');
	                g.select('.nv-y.nv-axis').call(yAxis);
	            }
	
	            // Zero line
	            g.select(".nv-zeroLine line")
	                .attr("x1", y(0))
	                .attr("x2", y(0))
	                .attr("y1", 0)
	                .attr("y2", -availableHeight)
	            ;
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            legend.dispatch.on('stateChange', function(newState) {
	                for (var key in newState)
	                    state[key] = newState[key];
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            controls.dispatch.on('legendClick', function(d,i) {
	                if (!d.disabled) return;
	                controlsData = controlsData.map(function(s) {
	                    s.disabled = true;
	                    return s;
	                });
	                d.disabled = false;
	
	                switch (d.key) {
	                    case 'Grouped':
	                    case controlLabels.grouped:
	                        multibar.stacked(false);
	                        break;
	                    case 'Stacked':
	                    case controlLabels.stacked:
	                        multibar.stacked(true);
	                        break;
	                }
	
	                state.stacked = multibar.stacked();
	                dispatch.stateChange(state);
	                stacked = multibar.stacked();
	
	                chart.update();
	            });
	
	            // Update chart from a state object passed to event handler
	            dispatch.on('changeState', function(e) {
	
	                if (typeof e.disabled !== 'undefined') {
	                    data.forEach(function(series,i) {
	                        series.disabled = e.disabled[i];
	                    });
	
	                    state.disabled = e.disabled;
	                }
	
	                if (typeof e.stacked !== 'undefined') {
	                    multibar.stacked(e.stacked);
	                    state.stacked = e.stacked;
	                    stacked = e.stacked;
	                }
	
	                chart.update();
	            });
	        });
	        renderWatch.renderEnd('multibar horizontal chart immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    multibar.dispatch.on('elementMouseover.tooltip', function(evt) {
	        evt.value = chart.x()(evt.data);
	        evt['series'] = {
	            key: evt.data.key,
	            value: chart.y()(evt.data),
	            color: evt.color
	        };
	        tooltip.data(evt).hidden(false);
	    });
	
	    multibar.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true);
	    });
	
	    multibar.dispatch.on('elementMousemove.tooltip', function(evt) {
	        tooltip();
	    });
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.multibar = multibar;
	    chart.legend = legend;
	    chart.controls = controls;
	    chart.xAxis = xAxis;
	    chart.yAxis = yAxis;
	    chart.state = state;
	    chart.tooltip = tooltip;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        showLegend: {get: function(){return showLegend;}, set: function(_){showLegend=_;}},
	        legendPosition: {get: function(){return legendPosition;}, set: function(_){legendPosition=_;}},
	        controlsPosition: {get: function(){return controlsPosition;}, set: function(_){controlsPosition=_;}},
	        showControls: {get: function(){return showControls;}, set: function(_){showControls=_;}},
	        controlLabels: {get: function(){return controlLabels;}, set: function(_){controlLabels=_;}},
	        showXAxis:      {get: function(){return showXAxis;}, set: function(_){showXAxis=_;}},
	        showYAxis:    {get: function(){return showYAxis;}, set: function(_){showYAxis=_;}},
	        defaultState:    {get: function(){return defaultState;}, set: function(_){defaultState=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	            multibar.duration(duration);
	            xAxis.duration(duration);
	            yAxis.duration(duration);
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            legend.color(color);
	        }},
	        barColor:  {get: function(){return multibar.barColor;}, set: function(_){
	            multibar.barColor(_);
	            legend.color(function(d,i) {return d3.rgb('#ccc').darker(i * 1.5).toString();})
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, multibar);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	nv.models.multiChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 30, right: 20, bottom: 50, left: 60},
	        marginTop = null,
	        color = nv.utils.defaultColor(),
	        width = null,
	        height = null,
	        showLegend = true,
	        noData = null,
	        yDomain1,
	        yDomain2,
	        getX = function(d) { return d.x },
	        getY = function(d) { return d.y},
	        interpolate = 'linear',
	        useVoronoi = true,
	        interactiveLayer = nv.interactiveGuideline(),
	        useInteractiveGuideline = false,
	        legendRightAxisHint = ' (right axis)',
	        duration = 250
	        ;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var x = d3.scale.linear(),
	        yScale1 = d3.scale.linear(),
	        yScale2 = d3.scale.linear(),
	
	        lines1 = nv.models.line().yScale(yScale1).duration(duration),
	        lines2 = nv.models.line().yScale(yScale2).duration(duration),
	
	        scatters1 = nv.models.scatter().yScale(yScale1).duration(duration),
	        scatters2 = nv.models.scatter().yScale(yScale2).duration(duration),
	
	        bars1 = nv.models.multiBar().stacked(false).yScale(yScale1).duration(duration),
	        bars2 = nv.models.multiBar().stacked(false).yScale(yScale2).duration(duration),
	
	        stack1 = nv.models.stackedArea().yScale(yScale1).duration(duration),
	        stack2 = nv.models.stackedArea().yScale(yScale2).duration(duration),
	
	        xAxis = nv.models.axis().scale(x).orient('bottom').tickPadding(5).duration(duration),
	        yAxis1 = nv.models.axis().scale(yScale1).orient('left').duration(duration),
	        yAxis2 = nv.models.axis().scale(yScale2).orient('right').duration(duration),
	
	        legend = nv.models.legend().height(30),
	        tooltip = nv.models.tooltip(),
	        dispatch = d3.dispatch();
	
	    var charts = [lines1, lines2, scatters1, scatters2, bars1, bars2, stack1, stack2];
	
	    function chart(selection) {
	        selection.each(function(data) {
	            var container = d3.select(this),
	                that = this;
	            nv.utils.initSVG(container);
	
	            chart.update = function() { container.transition().call(chart); };
	            chart.container = this;
	
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            var dataLines1 = data.filter(function(d) {return d.type == 'line' && d.yAxis == 1});
	            var dataLines2 = data.filter(function(d) {return d.type == 'line' && d.yAxis == 2});
	            var dataScatters1 = data.filter(function(d) {return d.type == 'scatter' && d.yAxis == 1});
	            var dataScatters2 = data.filter(function(d) {return d.type == 'scatter' && d.yAxis == 2});
	            var dataBars1 =  data.filter(function(d) {return d.type == 'bar'  && d.yAxis == 1});
	            var dataBars2 =  data.filter(function(d) {return d.type == 'bar'  && d.yAxis == 2});
	            var dataStack1 = data.filter(function(d) {return d.type == 'area' && d.yAxis == 1});
	            var dataStack2 = data.filter(function(d) {return d.type == 'area' && d.yAxis == 2});
	
	            // Display noData message if there's nothing to show.
	            if (!data || !data.length || !data.filter(function(d) { return d.values.length }).length) {
	                nv.utils.noData(chart, container);
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            var series1 = data.filter(function(d) {return !d.disabled && d.yAxis == 1})
	                .map(function(d) {
	                    return d.values.map(function(d,i) {
	                        return { x: getX(d), y: getY(d) }
	                    })
	                });
	
	            var series2 = data.filter(function(d) {return !d.disabled && d.yAxis == 2})
	                .map(function(d) {
	                    return d.values.map(function(d,i) {
	                        return { x: getX(d), y: getY(d) }
	                    })
	                });
	
	            x   .domain(d3.extent(d3.merge(series1.concat(series2)), function(d) { return d.x }))
	                .range([0, availableWidth]);
	
	            var wrap = container.selectAll('g.wrap.multiChart').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'wrap nvd3 multiChart').append('g');
	
	            gEnter.append('g').attr('class', 'nv-x nv-axis');
	            gEnter.append('g').attr('class', 'nv-y1 nv-axis');
	            gEnter.append('g').attr('class', 'nv-y2 nv-axis');
	            gEnter.append('g').attr('class', 'stack1Wrap');
	            gEnter.append('g').attr('class', 'stack2Wrap');
	            gEnter.append('g').attr('class', 'bars1Wrap');
	            gEnter.append('g').attr('class', 'bars2Wrap');
	            gEnter.append('g').attr('class', 'scatters1Wrap');
	            gEnter.append('g').attr('class', 'scatters2Wrap');
	            gEnter.append('g').attr('class', 'lines1Wrap');
	            gEnter.append('g').attr('class', 'lines2Wrap');
	            gEnter.append('g').attr('class', 'legendWrap');
	            gEnter.append('g').attr('class', 'nv-interactive');
	
	            var g = wrap.select('g');
	
	            var color_array = data.map(function(d,i) {
	                return data[i].color || color(d, i);
	            });
	
	            // Legend
	            if (!showLegend) {
	                g.select('.legendWrap').selectAll('*').remove();
	            } else {
	                var legendWidth = legend.align() ? availableWidth / 2 : availableWidth;
	                var legendXPosition = legend.align() ? legendWidth : 0;
	
	                legend.width(legendWidth);
	                legend.color(color_array);
	
	                g.select('.legendWrap')
	                    .datum(data.map(function(series) {
	                        series.originalKey = series.originalKey === undefined ? series.key : series.originalKey;
	                        series.key = series.originalKey + (series.yAxis == 1 ? '' : legendRightAxisHint);
	                        return series;
	                    }))
	                    .call(legend);
	
	                if (!marginTop && legend.height() !== margin.top) {
	                    margin.top = legend.height();
	                    availableHeight = nv.utils.availableHeight(height, container, margin);
	                }
	
	                g.select('.legendWrap')
	                    .attr('transform', 'translate(' + legendXPosition + ',' + (-margin.top) +')');
	            }
	
	            lines1
	                .width(availableWidth)
	                .height(availableHeight)
	                .interpolate(interpolate)
	                .color(color_array.filter(function(d,i) { return !data[i].disabled && data[i].yAxis == 1 && data[i].type == 'line'}));
	            lines2
	                .width(availableWidth)
	                .height(availableHeight)
	                .interpolate(interpolate)
	                .color(color_array.filter(function(d,i) { return !data[i].disabled && data[i].yAxis == 2 && data[i].type == 'line'}));
	            scatters1
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(color_array.filter(function(d,i) { return !data[i].disabled && data[i].yAxis == 1 && data[i].type == 'scatter'}));
	            scatters2
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(color_array.filter(function(d,i) { return !data[i].disabled && data[i].yAxis == 2 && data[i].type == 'scatter'}));
	            bars1
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(color_array.filter(function(d,i) { return !data[i].disabled && data[i].yAxis == 1 && data[i].type == 'bar'}));
	            bars2
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(color_array.filter(function(d,i) { return !data[i].disabled && data[i].yAxis == 2 && data[i].type == 'bar'}));
	            stack1
	                .width(availableWidth)
	                .height(availableHeight)
	                .interpolate(interpolate)
	                .color(color_array.filter(function(d,i) { return !data[i].disabled && data[i].yAxis == 1 && data[i].type == 'area'}));
	            stack2
	                .width(availableWidth)
	                .height(availableHeight)
	                .interpolate(interpolate)
	                .color(color_array.filter(function(d,i) { return !data[i].disabled && data[i].yAxis == 2 && data[i].type == 'area'}));
	
	            g.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            var lines1Wrap = g.select('.lines1Wrap')
	                .datum(dataLines1.filter(function(d){return !d.disabled}));
	            var scatters1Wrap = g.select('.scatters1Wrap')
	                .datum(dataScatters1.filter(function(d){return !d.disabled}));
	            var bars1Wrap = g.select('.bars1Wrap')
	                .datum(dataBars1.filter(function(d){return !d.disabled}));
	            var stack1Wrap = g.select('.stack1Wrap')
	                .datum(dataStack1.filter(function(d){return !d.disabled}));
	            var lines2Wrap = g.select('.lines2Wrap')
	                .datum(dataLines2.filter(function(d){return !d.disabled}));
	            var scatters2Wrap = g.select('.scatters2Wrap')
	                .datum(dataScatters2.filter(function(d){return !d.disabled}));
	            var bars2Wrap = g.select('.bars2Wrap')
	                .datum(dataBars2.filter(function(d){return !d.disabled}));
	            var stack2Wrap = g.select('.stack2Wrap')
	                .datum(dataStack2.filter(function(d){return !d.disabled}));
	
	            var extraValue1BarStacked = [];
	            if (bars1.stacked() && dataBars1.length) {
	                var extraValue1BarStacked = dataBars1.filter(function(d){return !d.disabled}).map(function(a){return a.values});
	                
	                if (extraValue1BarStacked.length > 0)
	                    extraValue1BarStacked = extraValue1BarStacked.reduce(function(a,b){
	                        return a.map(function(aVal,i){return {x: aVal.x, y: aVal.y + b[i].y}})
	                    });
	            }
	            if (dataBars1.length) {
	                extraValue1BarStacked.push({x:0, y:0});
	            }
	            
	            var extraValue2BarStacked = [];
	            if (bars2.stacked() && dataBars2.length) {
	                var extraValue2BarStacked = dataBars2.filter(function(d){return !d.disabled}).map(function(a){return a.values});
	                
	                if (extraValue2BarStacked.length > 0)
	                    extraValue2BarStacked = extraValue2BarStacked.reduce(function(a,b){
	                        return a.map(function(aVal,i){return {x: aVal.x, y: aVal.y + b[i].y}})
	                    });
	            }
	            if (dataBars2.length) {
	                extraValue2BarStacked.push({x:0, y:0});
	            }
	            
	            yScale1 .domain(yDomain1 || d3.extent(d3.merge(series1).concat(extraValue1BarStacked), function(d) { return d.y } ))
	                .range([0, availableHeight]);
	
	            yScale2 .domain(yDomain2 || d3.extent(d3.merge(series2).concat(extraValue2BarStacked), function(d) { return d.y } ))
	                .range([0, availableHeight]);
	
	            lines1.yDomain(yScale1.domain());
	            scatters1.yDomain(yScale1.domain());
	            bars1.yDomain(yScale1.domain());
	            stack1.yDomain(yScale1.domain());
	
	            lines2.yDomain(yScale2.domain());
	            scatters2.yDomain(yScale2.domain());
	            bars2.yDomain(yScale2.domain());
	            stack2.yDomain(yScale2.domain());
	
	            if(dataStack1.length){d3.transition(stack1Wrap).call(stack1);}
	            if(dataStack2.length){d3.transition(stack2Wrap).call(stack2);}
	
	            if(dataBars1.length){d3.transition(bars1Wrap).call(bars1);}
	            if(dataBars2.length){d3.transition(bars2Wrap).call(bars2);}
	
	            if(dataLines1.length){d3.transition(lines1Wrap).call(lines1);}
	            if(dataLines2.length){d3.transition(lines2Wrap).call(lines2);}
	
	            if(dataScatters1.length){d3.transition(scatters1Wrap).call(scatters1);}
	            if(dataScatters2.length){d3.transition(scatters2Wrap).call(scatters2);}
	
	            xAxis
	                ._ticks( nv.utils.calcTicksX(availableWidth/100, data) )
	                .tickSize(-availableHeight, 0);
	
	            g.select('.nv-x.nv-axis')
	                .attr('transform', 'translate(0,' + availableHeight + ')');
	            d3.transition(g.select('.nv-x.nv-axis'))
	                .call(xAxis);
	
	            yAxis1
	                ._ticks( nv.utils.calcTicksY(availableHeight/36, data) )
	                .tickSize( -availableWidth, 0);
	
	
	            d3.transition(g.select('.nv-y1.nv-axis'))
	                .call(yAxis1);
	
	            yAxis2
	                ._ticks( nv.utils.calcTicksY(availableHeight/36, data) )
	                .tickSize( -availableWidth, 0);
	
	            d3.transition(g.select('.nv-y2.nv-axis'))
	                .call(yAxis2);
	
	            g.select('.nv-y1.nv-axis')
	                .classed('nv-disabled', series1.length ? false : true)
	                .attr('transform', 'translate(' + x.range()[0] + ',0)');
	
	            g.select('.nv-y2.nv-axis')
	                .classed('nv-disabled', series2.length ? false : true)
	                .attr('transform', 'translate(' + x.range()[1] + ',0)');
	
	            legend.dispatch.on('stateChange', function(newState) {
	                chart.update();
	            });
	
	            if(useInteractiveGuideline){
	                interactiveLayer
	                    .width(availableWidth)
	                    .height(availableHeight)
	                    .margin({left:margin.left, top:margin.top})
	                    .svgContainer(container)
	                    .xScale(x);
	                wrap.select(".nv-interactive").call(interactiveLayer);
	            }
	
	            //============================================================
	            // Event Handling/Dispatching
	            //------------------------------------------------------------
	
	            function mouseover_line(evt) {
	                var yaxis = evt.series.yAxis === 2 ? yAxis2 : yAxis1;
	                evt.value = evt.point.x;
	                evt.series = {
	                    value: evt.point.y,
	                    color: evt.point.color,
	                    key: evt.series.key
	                };
	                tooltip
	                    .duration(0)
	                    .headerFormatter(function(d, i) {
	                    	return xAxis.tickFormat()(d, i);
	                    })
	                    .valueFormatter(function(d, i) {
	                        return yaxis.tickFormat()(d, i);
	                    })
	                    .data(evt)
	                    .hidden(false);
	            }
	
	            function mouseover_scatter(evt) {
	                var yaxis = evt.series.yAxis === 2 ? yAxis2 : yAxis1;
	                evt.value = evt.point.x;
	                evt.series = {
	                    value: evt.point.y,
	                    color: evt.point.color,
	                    key: evt.series.key
	                };
	                tooltip
	                    .duration(100)
	                    .headerFormatter(function(d, i) {
	                    	return xAxis.tickFormat()(d, i);
	                    })
	                    .valueFormatter(function(d, i) {
	                        return yaxis.tickFormat()(d, i);
	                    })
	                    .data(evt)
	                    .hidden(false);
	            }
	
	            function mouseover_stack(evt) {
	                var yaxis = evt.series.yAxis === 2 ? yAxis2 : yAxis1;
	                evt.point['x'] = stack1.x()(evt.point);
	                evt.point['y'] = stack1.y()(evt.point);
	                tooltip
	                    .duration(0)
	                    .headerFormatter(function(d, i) {
	                    	return xAxis.tickFormat()(d, i);
	                    })
	                    .valueFormatter(function(d, i) {
	                        return yaxis.tickFormat()(d, i);
	                    })
	                    .data(evt)
	                    .hidden(false);
	            }
	
	            function mouseover_bar(evt) {
	                var yaxis = evt.series.yAxis === 2 ? yAxis2 : yAxis1;
	
	                evt.value = bars1.x()(evt.data);
	                evt['series'] = {
	                    value: bars1.y()(evt.data),
	                    color: evt.color,
	                    key: evt.data.key
	                };
	                tooltip
	                    .duration(0)
	                    .headerFormatter(function(d, i) {
	                    	return xAxis.tickFormat()(d, i);
	                    })
	                    .valueFormatter(function(d, i) {
	                        return yaxis.tickFormat()(d, i);
	                    })
	                    .data(evt)
	                    .hidden(false);
	            }
	
	
	
	            function clearHighlights() {
	              for(var i=0, il=charts.length; i < il; i++){
	                var chart = charts[i];
	                try {
	                  chart.clearHighlights();
	                } catch(e){}
	              }
	            }
	
	            function highlightPoint(serieIndex, pointIndex, b){
	              for(var i=0, il=charts.length; i < il; i++){
	                var chart = charts[i];
	                try {
	                  chart.highlightPoint(serieIndex, pointIndex, b);
	                } catch(e){}
	              }
	            }
	
	            if(useInteractiveGuideline){
	                interactiveLayer.dispatch.on('elementMousemove', function(e) {
	                    clearHighlights();
	                    var singlePoint, pointIndex, pointXLocation, allData = [];
	                    data
	                    .filter(function(series, i) {
	                        series.seriesIndex = i;
	                        return !series.disabled;
	                    })
	                    .forEach(function(series,i) {
	                        var extent = x.domain();
	                        var currentValues = series.values.filter(function(d,i) {
	                            return chart.x()(d,i) >= extent[0] && chart.x()(d,i) <= extent[1];
	                        });
	
	                        pointIndex = nv.interactiveBisect(currentValues, e.pointXValue, chart.x());
	                        var point = currentValues[pointIndex];
	                        var pointYValue = chart.y()(point, pointIndex);
	                        if (pointYValue !== null) {
	                            highlightPoint(i, pointIndex, true);
	                        }
	                        if (point === undefined) return;
	                        if (singlePoint === undefined) singlePoint = point;
	                        if (pointXLocation === undefined) pointXLocation = x(chart.x()(point,pointIndex));
	                        allData.push({
	                            key: series.key,
	                            value: pointYValue,
	                            color: color(series,series.seriesIndex),
	                            data: point,
	                            yAxis: series.yAxis == 2 ? yAxis2 : yAxis1
	                        });
	                    });
	
	                    var defaultValueFormatter = function(d,i) {
	                        var yAxis = allData[i].yAxis;
	                        return d == null ? "N/A" : yAxis.tickFormat()(d);
	                    };
	
	                    interactiveLayer.tooltip
	                        .headerFormatter(function(d, i) {
	                            return xAxis.tickFormat()(d, i);
	                        })
	                        .valueFormatter(interactiveLayer.tooltip.valueFormatter() || defaultValueFormatter)
	                        .data({
	                            value: chart.x()( singlePoint,pointIndex ),
	                            index: pointIndex,
	                            series: allData
	                        })();
	
	                    interactiveLayer.renderGuideLine(pointXLocation);
	                });
	
	                interactiveLayer.dispatch.on("elementMouseout",function(e) {
	                    clearHighlights();
	                });
	            } else {
	                lines1.dispatch.on('elementMouseover.tooltip', mouseover_line);
	                lines2.dispatch.on('elementMouseover.tooltip', mouseover_line);
	                lines1.dispatch.on('elementMouseout.tooltip', function(evt) {
	                    tooltip.hidden(true)
	                });
	                lines2.dispatch.on('elementMouseout.tooltip', function(evt) {
	                    tooltip.hidden(true)
	                });
	
	                scatters1.dispatch.on('elementMouseover.tooltip', mouseover_scatter);
	                scatters2.dispatch.on('elementMouseover.tooltip', mouseover_scatter);
	                scatters1.dispatch.on('elementMouseout.tooltip', function(evt) {
	                    tooltip.hidden(true)
	                });
	                scatters2.dispatch.on('elementMouseout.tooltip', function(evt) {
	                    tooltip.hidden(true)
	                });
	
	                stack1.dispatch.on('elementMouseover.tooltip', mouseover_stack);
	                stack2.dispatch.on('elementMouseover.tooltip', mouseover_stack);
	                stack1.dispatch.on('elementMouseout.tooltip', function(evt) {
	                    tooltip.hidden(true)
	                });
	                stack2.dispatch.on('elementMouseout.tooltip', function(evt) {
	                    tooltip.hidden(true)
	                });
	
	                bars1.dispatch.on('elementMouseover.tooltip', mouseover_bar);
	                bars2.dispatch.on('elementMouseover.tooltip', mouseover_bar);
	
	                bars1.dispatch.on('elementMouseout.tooltip', function(evt) {
	                    tooltip.hidden(true);
	                });
	                bars2.dispatch.on('elementMouseout.tooltip', function(evt) {
	                    tooltip.hidden(true);
	                });
	                bars1.dispatch.on('elementMousemove.tooltip', function(evt) {
	                    tooltip();
	                });
	                bars2.dispatch.on('elementMousemove.tooltip', function(evt) {
	                    tooltip();
	                });
	            }
	        });
	
	        return chart;
	    }
	
	    //============================================================
	    // Global getters and setters
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.legend = legend;
	    chart.lines1 = lines1;
	    chart.lines2 = lines2;
	    chart.scatters1 = scatters1;
	    chart.scatters2 = scatters2;
	    chart.bars1 = bars1;
	    chart.bars2 = bars2;
	    chart.stack1 = stack1;
	    chart.stack2 = stack2;
	    chart.xAxis = xAxis;
	    chart.yAxis1 = yAxis1;
	    chart.yAxis2 = yAxis2;
	    chart.tooltip = tooltip;
	    chart.interactiveLayer = interactiveLayer;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        showLegend: {get: function(){return showLegend;}, set: function(_){showLegend=_;}},
	        yDomain1:      {get: function(){return yDomain1;}, set: function(_){yDomain1=_;}},
	        yDomain2:    {get: function(){return yDomain2;}, set: function(_){yDomain2=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	        interpolate:    {get: function(){return interpolate;}, set: function(_){interpolate=_;}},
	        legendRightAxisHint:    {get: function(){return legendRightAxisHint;}, set: function(_){legendRightAxisHint=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }},
	        x: {get: function(){return getX;}, set: function(_){
	            getX = _;
	            lines1.x(_);
	            lines2.x(_);
	            scatters1.x(_);
	            scatters2.x(_);
	            bars1.x(_);
	            bars2.x(_);
	            stack1.x(_);
	            stack2.x(_);
	        }},
	        y: {get: function(){return getY;}, set: function(_){
	            getY = _;
	            lines1.y(_);
	            lines2.y(_);
	            scatters1.y(_);
	            scatters2.y(_);
	            stack1.y(_);
	            stack2.y(_);
	            bars1.y(_);
	            bars2.y(_);
	        }},
	        useVoronoi: {get: function(){return useVoronoi;}, set: function(_){
	            useVoronoi=_;
	            lines1.useVoronoi(_);
	            lines2.useVoronoi(_);
	            stack1.useVoronoi(_);
	            stack2.useVoronoi(_);
	        }},
	
	        useInteractiveGuideline: {get: function(){return useInteractiveGuideline;}, set: function(_){
	            useInteractiveGuideline = _;
	            if (useInteractiveGuideline) {
	                lines1.interactive(false);
	                lines1.useVoronoi(false);
	                lines2.interactive(false);
	                lines2.useVoronoi(false);
	                stack1.interactive(false);
	                stack1.useVoronoi(false);
	                stack2.interactive(false);
	                stack2.useVoronoi(false);
	                scatters1.interactive(false);
	                scatters2.interactive(false);
	            }
	        }},
	
	        duration: {get: function(){return duration;}, set: function(_) {
	            duration = _;
	            [lines1, lines2, stack1, stack2, scatters1, scatters2, xAxis, yAxis1, yAxis2].forEach(function(model){
	              model.duration(duration);
	            });
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.ohlcBar = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = null
	        , height = null
	        , id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
	        , container = null
	        , x = d3.scale.linear()
	        , y = d3.scale.linear()
	        , getX = function(d) { return d.x }
	        , getY = function(d) { return d.y }
	        , getOpen = function(d) { return d.open }
	        , getClose = function(d) { return d.close }
	        , getHigh = function(d) { return d.high }
	        , getLow = function(d) { return d.low }
	        , forceX = []
	        , forceY = []
	        , padData     = false // If true, adds half a data points width to front and back, for lining up a line chart with a bar chart
	        , clipEdge = true
	        , color = nv.utils.defaultColor()
	        , interactive = false
	        , xDomain
	        , yDomain
	        , xRange
	        , yRange
	        , dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd', 'chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove')
	        ;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    function chart(selection) {
	        selection.each(function(data) {
	            container = d3.select(this);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            nv.utils.initSVG(container);
	
	            // ohlc bar width.
	            var w = (availableWidth / data[0].values.length) * .9;
	
	            // Setup Scales
	            x.domain(xDomain || d3.extent(data[0].values.map(getX).concat(forceX) ));
	
	            if (padData)
	                x.range(xRange || [availableWidth * .5 / data[0].values.length, availableWidth * (data[0].values.length - .5)  / data[0].values.length ]);
	            else
	                x.range(xRange || [5 + w/2, availableWidth - w/2 - 5]);
	
	            y.domain(yDomain || [
	                    d3.min(data[0].values.map(getLow).concat(forceY)),
	                    d3.max(data[0].values.map(getHigh).concat(forceY))
	                ]
	            ).range(yRange || [availableHeight, 0]);
	
	            // If scale's domain don't have a range, slightly adjust to make one... so a chart can show a single data point
	            if (x.domain()[0] === x.domain()[1])
	                x.domain()[0] ?
	                    x.domain([x.domain()[0] - x.domain()[0] * 0.01, x.domain()[1] + x.domain()[1] * 0.01])
	                    : x.domain([-1,1]);
	
	            if (y.domain()[0] === y.domain()[1])
	                y.domain()[0] ?
	                    y.domain([y.domain()[0] + y.domain()[0] * 0.01, y.domain()[1] - y.domain()[1] * 0.01])
	                    : y.domain([-1,1]);
	
	            // Setup containers and skeleton of chart
	            var wrap = d3.select(this).selectAll('g.nv-wrap.nv-ohlcBar').data([data[0].values]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-ohlcBar');
	            var defsEnter = wrapEnter.append('defs');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-ticks');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            container
	                .on('click', function(d,i) {
	                    dispatch.chartClick({
	                        data: d,
	                        index: i,
	                        pos: d3.event,
	                        id: id
	                    });
	                });
	
	            defsEnter.append('clipPath')
	                .attr('id', 'nv-chart-clip-path-' + id)
	                .append('rect');
	
	            wrap.select('#nv-chart-clip-path-' + id + ' rect')
	                .attr('width', availableWidth)
	                .attr('height', availableHeight);
	
	            g   .attr('clip-path', clipEdge ? 'url(#nv-chart-clip-path-' + id + ')' : '');
	
	            var ticks = wrap.select('.nv-ticks').selectAll('.nv-tick')
	                .data(function(d) { return d });
	            ticks.exit().remove();
	
	            ticks.enter().append('path')
	                .attr('class', function(d,i,j) { return (getOpen(d,i) > getClose(d,i) ? 'nv-tick negative' : 'nv-tick positive') + ' nv-tick-' + j + '-' + i })
	                .attr('d', function(d,i) {
	                    return 'm0,0l0,'
	                        + (y(getOpen(d,i))
	                            - y(getHigh(d,i)))
	                        + 'l'
	                        + (-w/2)
	                        + ',0l'
	                        + (w/2)
	                        + ',0l0,'
	                        + (y(getLow(d,i)) - y(getOpen(d,i)))
	                        + 'l0,'
	                        + (y(getClose(d,i))
	                            - y(getLow(d,i)))
	                        + 'l'
	                        + (w/2)
	                        + ',0l'
	                        + (-w/2)
	                        + ',0z';
	                })
	                .attr('transform', function(d,i) { return 'translate(' + x(getX(d,i)) + ',' + y(getHigh(d,i)) + ')'; })
	                .attr('fill', function(d,i) { return color[0]; })
	                .attr('stroke', function(d,i) { return color[0]; })
	                .attr('x', 0 )
	                .attr('y', function(d,i) {  return y(Math.max(0, getY(d,i))) })
	                .attr('height', function(d,i) { return Math.abs(y(getY(d,i)) - y(0)) });
	
	            // the bar colors are controlled by CSS currently
	            ticks.attr('class', function(d,i,j) {
	                return (getOpen(d,i) > getClose(d,i) ? 'nv-tick negative' : 'nv-tick positive') + ' nv-tick-' + j + '-' + i;
	            });
	
	            d3.transition(ticks)
	                .attr('transform', function(d,i) { return 'translate(' + x(getX(d,i)) + ',' + y(getHigh(d,i)) + ')'; })
	                .attr('d', function(d,i) {
	                    var w = (availableWidth / data[0].values.length) * .9;
	                    return 'm0,0l0,'
	                        + (y(getOpen(d,i))
	                            - y(getHigh(d,i)))
	                        + 'l'
	                        + (-w/2)
	                        + ',0l'
	                        + (w/2)
	                        + ',0l0,'
	                        + (y(getLow(d,i))
	                            - y(getOpen(d,i)))
	                        + 'l0,'
	                        + (y(getClose(d,i))
	                            - y(getLow(d,i)))
	                        + 'l'
	                        + (w/2)
	                        + ',0l'
	                        + (-w/2)
	                        + ',0z';
	                });
	        });
	
	        return chart;
	    }
	
	
	    //Create methods to allow outside functions to highlight a specific bar.
	    chart.highlightPoint = function(pointIndex, isHoverOver) {
	        chart.clearHighlights();
	        container.select(".nv-ohlcBar .nv-tick-0-" + pointIndex)
	            .classed("hover", isHoverOver)
	        ;
	    };
	
	    chart.clearHighlights = function() {
	        container.select(".nv-ohlcBar .nv-tick.hover")
	            .classed("hover", false)
	        ;
	    };
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:    {get: function(){return width;}, set: function(_){width=_;}},
	        height:   {get: function(){return height;}, set: function(_){height=_;}},
	        xScale:   {get: function(){return x;}, set: function(_){x=_;}},
	        yScale:   {get: function(){return y;}, set: function(_){y=_;}},
	        xDomain:  {get: function(){return xDomain;}, set: function(_){xDomain=_;}},
	        yDomain:  {get: function(){return yDomain;}, set: function(_){yDomain=_;}},
	        xRange:   {get: function(){return xRange;}, set: function(_){xRange=_;}},
	        yRange:   {get: function(){return yRange;}, set: function(_){yRange=_;}},
	        forceX:   {get: function(){return forceX;}, set: function(_){forceX=_;}},
	        forceY:   {get: function(){return forceY;}, set: function(_){forceY=_;}},
	        padData:  {get: function(){return padData;}, set: function(_){padData=_;}},
	        clipEdge: {get: function(){return clipEdge;}, set: function(_){clipEdge=_;}},
	        id:       {get: function(){return id;}, set: function(_){id=_;}},
	        interactive: {get: function(){return interactive;}, set: function(_){interactive=_;}},
	
	        x:     {get: function(){return getX;}, set: function(_){getX=_;}},
	        y:     {get: function(){return getY;}, set: function(_){getY=_;}},
	        open:  {get: function(){return getOpen();}, set: function(_){getOpen=_;}},
	        close: {get: function(){return getClose();}, set: function(_){getClose=_;}},
	        high:  {get: function(){return getHigh;}, set: function(_){getHigh=_;}},
	        low:   {get: function(){return getLow;}, set: function(_){getLow=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    != undefined ? _.top    : margin.top;
	            margin.right  = _.right  != undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom != undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   != undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	    return chart;
	};
	// Code adapted from Jason Davies' "Parallel Coordinates"
	// http://bl.ocks.org/jasondavies/1341281
	nv.models.parallelCoordinates = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 30, right: 0, bottom: 10, left: 0}
	        , width = null
	        , height = null
	        , availableWidth = null
	        , availableHeight = null
	        , x = d3.scale.ordinal()
	        , y = {}
	        , undefinedValuesLabel = "undefined values"
	        , dimensionData = []
	        , enabledDimensions = []
	        , dimensionNames = []
	        , displayBrush = true
	        , color = nv.utils.defaultColor()
	        , filters = []
	        , active = []
	        , dragging = []
	        , axisWithUndefinedValues = []
	        , lineTension = 1
	        , foreground
	        , background
	        , dimensions
	        , line = d3.svg.line()
	        , axis = d3.svg.axis()
	        , dispatch = d3.dispatch('brushstart', 'brush', 'brushEnd', 'dimensionsOrder', "stateChange", 'elementClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd', 'activeChanged')
	        ;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch);
	
	    function chart(selection) {
	        renderWatch.reset();
	        selection.each(function(data) {
	            var container = d3.select(this);
	            availableWidth = nv.utils.availableWidth(width, container, margin);
	            availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            nv.utils.initSVG(container);
	
	           //Convert old data to new format (name, values)
	            if (data[0].values === undefined) {
	                var newData = [];
	                data.forEach(function (d) {
	                        var val = {};
	                        var key = Object.keys(d);
	                        key.forEach(function (k) { if (k !== "name") val[k] = d[k] });
	                        newData.push({ key: d.name, values: val });
	                });
	                data = newData;
	            }
	
	            var dataValues = data.map(function (d) {return d.values});
	            if (active.length === 0) {
	                active = data;
	            }; //set all active before first brush call
	            
	            dimensionNames = dimensionData.sort(function (a, b) { return a.currentPosition - b.currentPosition; }).map(function (d) { return d.key });
	            enabledDimensions = dimensionData.filter(function (d) { return !d.disabled; });
	            
	            // Setup Scales
	            x.rangePoints([0, availableWidth], 1).domain(enabledDimensions.map(function (d) { return d.key; }));
	
	            //Set as true if all values on an axis are missing.
	            // Extract the list of dimensions and create a scale for each.
	            var oldDomainMaxValue = {};
	            var displayMissingValuesline = false;
	            var currentTicks = [];
	            
	            dimensionNames.forEach(function(d) {
	                var extent = d3.extent(dataValues, function (p) { return +p[d]; });
	                var min = extent[0];
	                var max = extent[1];
	                var onlyUndefinedValues = false;
	                //If there is no values to display on an axis, set the extent to 0
	                if (isNaN(min) || isNaN(max)) {
	                    onlyUndefinedValues = true;
	                    min = 0;
	                    max = 0;
	                }
	                //Scale axis if there is only one value
	                if (min === max) {
	                    min = min - 1;
	                    max = max + 1;
	                }
	                var f = filters.filter(function (k) { return k.dimension == d; });
	                if (f.length !== 0) {
	                    //If there is only NaN values, keep the existing domain.
	                    if (onlyUndefinedValues) {
	                        min = y[d].domain()[0];
	                        max = y[d].domain()[1];
	                    }
	                        //If the brush extent is > max (< min), keep the extent value.
	                    else if (!f[0].hasOnlyNaN && displayBrush) {
	                        min = min > f[0].extent[0] ? f[0].extent[0] : min;
	                        max = max < f[0].extent[1] ? f[0].extent[1] : max;
	                    }
	                        //If there is NaN values brushed be sure the brush extent is on the domain.
	                    else if (f[0].hasNaN) {
	                        max = max < f[0].extent[1] ? f[0].extent[1] : max;
	                        oldDomainMaxValue[d] = y[d].domain()[1];
	                        displayMissingValuesline = true;
	                    }
	                }
	                //Use 90% of (availableHeight - 12) for the axis range, 12 reprensenting the space necessary to display "undefined values" text.
	                //The remaining 10% are used to display the missingValue line.
	                y[d] = d3.scale.linear()
	                    .domain([min, max])
	                    .range([(availableHeight - 12) * 0.9, 0]);
	
	                axisWithUndefinedValues = [];
	                y[d].brush = d3.svg.brush().y(y[d]).on('brushstart', brushstart).on('brush', brush).on('brushend', brushend);
	            });
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-parallelCoordinates').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-parallelCoordinates');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-parallelCoordinates background');
	            gEnter.append('g').attr('class', 'nv-parallelCoordinates foreground');
	            gEnter.append('g').attr('class', 'nv-parallelCoordinates missingValuesline');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            line.interpolate('cardinal').tension(lineTension);
	            axis.orient('left');
	            var axisDrag = d3.behavior.drag()
	                        .on('dragstart', dragStart)
	                        .on('drag', dragMove)
	                        .on('dragend', dragEnd);
	
	            //Add missing value line at the bottom of the chart
	            var missingValuesline, missingValueslineText;
	            var step = x.range()[1] - x.range()[0];
	            step = isNaN(step) ? x.range()[0] : step;
	            if (!isNaN(step)) {
	                var lineData = [0 + step / 2, availableHeight - 12, availableWidth - step / 2, availableHeight - 12];
	                missingValuesline = wrap.select('.missingValuesline').selectAll('line').data([lineData]);
	                missingValuesline.enter().append('line');
	                missingValuesline.exit().remove();
	                missingValuesline.attr("x1", function(d) { return d[0]; })
	                        .attr("y1", function(d) { return d[1]; })
	                        .attr("x2", function(d) { return d[2]; })
	                        .attr("y2", function(d) { return d[3]; });
	    
	                //Add the text "undefined values" under the missing value line
	                missingValueslineText = wrap.select('.missingValuesline').selectAll('text').data([undefinedValuesLabel]);
	                missingValueslineText.append('text').data([undefinedValuesLabel]);
	                missingValueslineText.enter().append('text');
	                missingValueslineText.exit().remove();
	                missingValueslineText.attr("y", availableHeight)
	                        //To have the text right align with the missingValues line, substract 92 representing the text size.
	                        .attr("x", availableWidth - 92 - step / 2)
	                        .text(function(d) { return d; });
	            }
	            // Add grey background lines for context.
	            background = wrap.select('.background').selectAll('path').data(data);
	            background.enter().append('path');
	            background.exit().remove();
	            background.attr('d', path);
	
	            // Add blue foreground lines for focus.
	            foreground = wrap.select('.foreground').selectAll('path').data(data);
	            foreground.enter().append('path')
	            foreground.exit().remove();
	            foreground.attr('d', path)
	                .style("stroke-width", function (d, i) {
	                if (isNaN(d.strokeWidth)) { d.strokeWidth = 1;} return d.strokeWidth;})
	                .attr('stroke', function (d, i) { return d.color || color(d, i); });
	            foreground.on("mouseover", function (d, i) {
	                d3.select(this).classed('hover', true).style("stroke-width", d.strokeWidth + 2 + "px").style("stroke-opacity", 1);
	                dispatch.elementMouseover({
	                    label: d.name,
	                    color: d.color || color(d, i),
	                    values: d.values,
	                    dimensions: enabledDimensions
	                });
	
	            });
	            foreground.on("mouseout", function (d, i) {
	                d3.select(this).classed('hover', false).style("stroke-width", d.strokeWidth + "px").style("stroke-opacity", 0.7);
	                dispatch.elementMouseout({
	                    label: d.name,
	                    index: i
	                });
	            });
	            foreground.on('mousemove', function (d, i) {
	                dispatch.elementMousemove();
	            });
	            foreground.on('click', function (d) {
	                dispatch.elementClick({
	                    id: d.id
	                });
	            });
	            // Add a group element for each dimension.
	            dimensions = g.selectAll('.dimension').data(enabledDimensions);
	            var dimensionsEnter = dimensions.enter().append('g').attr('class', 'nv-parallelCoordinates dimension');
	
	            dimensions.attr('transform', function(d) { return 'translate(' + x(d.key) + ',0)'; });
	            dimensionsEnter.append('g').attr('class', 'nv-axis');
	
	            // Add an axis and title.
	            dimensionsEnter.append('text')
	                .attr('class', 'nv-label')
	                .style("cursor", "move")
	                .attr('dy', '-1em')
	                .attr('text-anchor', 'middle')
	                .on("mouseover", function(d, i) {
	                    dispatch.elementMouseover({
	                        label: d.tooltip || d.key,
	                        color: d.color 
	                    });
	                })
	                .on("mouseout", function(d, i) {
	                    dispatch.elementMouseout({
	                        label: d.tooltip
	                    });
	                })
	                .on('mousemove', function (d, i) {
	                    dispatch.elementMousemove();
	                })
	                .call(axisDrag);
	
	            dimensionsEnter.append('g').attr('class', 'nv-brushBackground');
	            dimensions.exit().remove();
	            dimensions.select('.nv-label').text(function (d) { return d.key });
	
	            // Add and store a brush for each axis.
	            restoreBrush(displayBrush);
	
	            var actives = dimensionNames.filter(function (p) { return !y[p].brush.empty(); }),
	                    extents = actives.map(function (p) { return y[p].brush.extent(); });
	            var formerActive = active.slice(0);
	
	            //Restore active values
	            active = [];
	            foreground.style("display", function (d) {
	                var isActive = actives.every(function (p, i) {
	                    if ((isNaN(d.values[p]) || isNaN(parseFloat(d.values[p]))) && extents[i][0] == y[p].brush.y().domain()[0]) {
	                        return true;
	                    }
	                    return (extents[i][0] <= d.values[p] && d.values[p] <= extents[i][1]) && !isNaN(parseFloat(d.values[p]));
	                });
	                if (isActive)
	                    active.push(d);
	                return !isActive ? "none" : null;
	
	            });
	
	            if (filters.length > 0 || !nv.utils.arrayEquals(active, formerActive)) {
	               dispatch.activeChanged(active);
	            }
	
	            // Returns the path for a given data point.
	            function path(d) {
	                return line(enabledDimensions.map(function (p) {
	                    //If value if missing, put the value on the missing value line
	                    if (isNaN(d.values[p.key]) || isNaN(parseFloat(d.values[p.key])) || displayMissingValuesline) {
	                        var domain = y[p.key].domain();
	                        var range = y[p.key].range();
	                        var min = domain[0] - (domain[1] - domain[0]) / 9;
	
	                        //If it's not already the case, allow brush to select undefined values
	                        if (axisWithUndefinedValues.indexOf(p.key) < 0) {
	
	                            var newscale = d3.scale.linear().domain([min, domain[1]]).range([availableHeight - 12, range[1]]);
	                            y[p.key].brush.y(newscale);
	                            axisWithUndefinedValues.push(p.key);
	                        }
	                        if (isNaN(d.values[p.key]) || isNaN(parseFloat(d.values[p.key]))) {
	                            return [x(p.key), y[p.key](min)];
	                        }
	                    }
	
	                    //If parallelCoordinate contain missing values show the missing values line otherwise, hide it.
	                    if (missingValuesline !== undefined) {
	                        if (axisWithUndefinedValues.length > 0 || displayMissingValuesline) {
	                            missingValuesline.style("display", "inline");
	                            missingValueslineText.style("display", "inline");
	                        } else {
	                            missingValuesline.style("display", "none");
	                            missingValueslineText.style("display", "none");
	                        }
	                    }
	                    return [x(p.key), y[p.key](d.values[p.key])];
	                }));
	            }
	
	            function restoreBrush(visible) {
	                filters.forEach(function (f) {
	                    //If filter brushed NaN values, keep the brush on the bottom of the axis.
	                    var brushDomain = y[f.dimension].brush.y().domain();
	                    if (f.hasOnlyNaN) {
	                        f.extent[1] = (y[f.dimension].domain()[1] - brushDomain[0]) * (f.extent[1] - f.extent[0]) / (oldDomainMaxValue[f.dimension] - f.extent[0]) + brushDomain[0];
	                    }
	                    if (f.hasNaN) {
	                        f.extent[0] = brushDomain[0];
	                    }
	                    if (visible)
	                        y[f.dimension].brush.extent(f.extent);
	                });
	                
	                dimensions.select('.nv-brushBackground')
	                    .each(function (d) {
	                        d3.select(this).call(y[d.key].brush);
	
	                    })
	                    .selectAll('rect')
	                    .attr('x', -8)
	                    .attr('width', 16);
	                
	                updateTicks();
	            }
	            
	            // Handles a brush event, toggling the display of foreground lines.
	            function brushstart() {
	                //If brush aren't visible, show it before brushing again.
	                if (displayBrush === false) {
	                    displayBrush = true;
	                    restoreBrush(true);
	                }
	            }
	            
	            // Handles a brush event, toggling the display of foreground lines.
	            function brush() {
	                actives = dimensionNames.filter(function (p) { return !y[p].brush.empty(); });
	                extents = actives.map(function(p) { return y[p].brush.extent(); });
	
	                filters = []; //erase current filters
	                actives.forEach(function(d,i) {
	                    filters[i] = {
	                        dimension: d,
	                        extent: extents[i],
	                        hasNaN: false,
	                        hasOnlyNaN: false
	                    }
	                });
	
	                active = []; //erase current active list
	                foreground.style('display', function(d) {
	                    var isActive = actives.every(function(p, i) {
	                        if ((isNaN(d.values[p]) || isNaN(parseFloat(d.values[p]))) && extents[i][0] == y[p].brush.y().domain()[0]) return true;
	                        return (extents[i][0] <= d.values[p] && d.values[p] <= extents[i][1]) && !isNaN(parseFloat(d.values[p]));
	                    });
	                    if (isActive) active.push(d);
	                    return isActive ? null : 'none';
	                });
	                
	                updateTicks();
	                
	                dispatch.brush({
	                    filters: filters,
	                    active: active
	                });
	            }
	            function brushend() {
	                var hasActiveBrush = actives.length > 0 ? true : false;
	                filters.forEach(function (f) {
	                    if (f.extent[0] === y[f.dimension].brush.y().domain()[0] && axisWithUndefinedValues.indexOf(f.dimension) >= 0)
	                        f.hasNaN = true;
	                    if (f.extent[1] < y[f.dimension].domain()[0])
	                        f.hasOnlyNaN = true;
	                });
	                dispatch.brushEnd(active, hasActiveBrush);
	            }           
	            function updateTicks() {
	                dimensions.select('.nv-axis')
	                    .each(function (d, i) {
	                        var f = filters.filter(function (k) { return k.dimension == d.key; });
	                        currentTicks[d.key] = y[d.key].domain();
	                        
	                        //If brush are available, display brush extent
	                        if (f.length != 0 && displayBrush)
	                        {
	                            currentTicks[d.key] = [];
	                            if (f[0].extent[1] > y[d.key].domain()[0]) 
	                                currentTicks[d.key] = [f[0].extent[1]];
	                            if (f[0].extent[0] >= y[d.key].domain()[0])
	                                currentTicks[d.key].push(f[0].extent[0]);    
	                        }
	                            
	                        d3.select(this).call(axis.scale(y[d.key]).tickFormat(d.format).tickValues(currentTicks[d.key]));
	                });
	            }
	            function dragStart(d) {
	                dragging[d.key] = this.parentNode.__origin__ = x(d.key);
	                background.attr("visibility", "hidden");
	            }
	            function dragMove(d) {
	                dragging[d.key] = Math.min(availableWidth, Math.max(0, this.parentNode.__origin__ += d3.event.x));
	                foreground.attr("d", path);
	                enabledDimensions.sort(function (a, b) { return dimensionPosition(a.key) - dimensionPosition(b.key); });
	                enabledDimensions.forEach(function (d, i) { return d.currentPosition = i; });
	                x.domain(enabledDimensions.map(function (d) { return d.key; }));
	                dimensions.attr("transform", function(d) { return "translate(" + dimensionPosition(d.key) + ")"; });
	            }
	            function dragEnd(d, i) {
	                delete this.parentNode.__origin__;
	                delete dragging[d.key];
	                d3.select(this.parentNode).attr("transform", "translate(" + x(d.key) + ")");
	                foreground
	                  .attr("d", path);
	                background
	                  .attr("d", path)
	                  .attr("visibility", null);
	
	                dispatch.dimensionsOrder(enabledDimensions);
	            }
	            function dimensionPosition(d) {
	                var v = dragging[d];
	                return v == null ? x(d) : v;
	            }
	        });
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:         {get: function(){return width;},           set: function(_){width= _;}},
	        height:        {get: function(){return height;},          set: function(_){height= _;}},
	        dimensionData: { get: function () { return dimensionData; }, set: function (_) { dimensionData = _; } },
	        displayBrush: { get: function () { return displayBrush; }, set: function (_) { displayBrush = _; } },
	        filters: { get: function () { return filters; }, set: function (_) { filters = _; } },
	        active: { get: function () { return active; }, set: function (_) { active = _; } },
	        lineTension:   {get: function(){return lineTension;},     set: function(_){lineTension = _;}},
	        undefinedValuesLabel : {get: function(){return undefinedValuesLabel;}, set: function(_){undefinedValuesLabel=_;}},
	        
	        // deprecated options
	        dimensions: {get: function () { return dimensionData.map(function (d){return d.key}); }, set: function (_) {
	            // deprecated after 1.8.1
	            nv.deprecated('dimensions', 'use dimensionData instead');
	            if (dimensionData.length === 0) {
	                _.forEach(function (k) { dimensionData.push({ key: k }) })
	            } else {
	                _.forEach(function (k, i) { dimensionData[i].key= k })
	            }
	        }},
	        dimensionNames: {get: function () { return dimensionData.map(function (d){return d.key}); }, set: function (_) {
	            // deprecated after 1.8.1
	            nv.deprecated('dimensionNames', 'use dimensionData instead');
	            dimensionNames = [];
	            if (dimensionData.length === 0) {
	                _.forEach(function (k) { dimensionData.push({ key: k }) })
	            } else {
	                _.forEach(function (k, i) { dimensionData[i].key = k })
	            }
	 
	        }},
	        dimensionFormats: {get: function () { return dimensionData.map(function (d) { return d.format }); }, set: function (_) {
	            // deprecated after 1.8.1
	            nv.deprecated('dimensionFormats', 'use dimensionData instead');
	            if (dimensionData.length === 0) {
	                _.forEach(function (f) { dimensionData.push({ format: f }) })
	            } else {
	                _.forEach(function (f, i) { dimensionData[i].format = f })
	            }
	
	        }},
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    =  _.top    !== undefined ? _.top    : margin.top;
	            margin.right  =  _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom =  _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   =  _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }}
	    });
	    nv.utils.initOptions(chart);
	    return chart;
	};
	nv.models.parallelCoordinatesChart = function () {
	        "use strict";
	        //============================================================
	        // Public Variables with Default Settings
	        //------------------------------------------------------------
	
	        var parallelCoordinates = nv.models.parallelCoordinates()
	        var legend = nv.models.legend()
	        var tooltip = nv.models.tooltip();
	        var dimensionTooltip = nv.models.tooltip();
	
	        var margin = { top: 0, right: 0, bottom: 0, left: 0 }
	        , marginTop = null
	        , width = null
	        , height = null
	        , showLegend = true
	        , color = nv.utils.defaultColor()
	        , state = nv.utils.state()
	        , dimensionData = []
	        , displayBrush = true
	        , defaultState = null
	        , noData = null
	        , nanValue = "undefined"
	        , dispatch = d3.dispatch('dimensionsOrder', 'brushEnd', 'stateChange', 'changeState', 'renderEnd')
	        , controlWidth = function () { return showControls ? 180 : 0 }
	        ;
	
		    //============================================================
	
			//============================================================
	        // Private Variables
	        //------------------------------------------------------------
	
	        var renderWatch = nv.utils.renderWatch(dispatch);
	
	        var stateGetter = function(data) {
	            return function() {
	                return {
	                    active: data.map(function(d) { return !d.disabled })
	                };
	            }
	        };
	
	        var stateSetter = function(data) {
	            return function(state) {
	                if(state.active !== undefined) {
	                    data.forEach(function(series, i) {
	                        series.disabled = !state.active[i];
	                    });
	                }
	            }
	        };
	
	        tooltip.contentGenerator(function(data) {
	            var str = '<table><thead><tr><td class="legend-color-guide"><div style="background-color:' + data.color + '"></div></td><td><strong>' + data.key + '</strong></td></tr></thead>';
	            if(data.series.length !== 0)
	            {
	                str = str + '<tbody><tr><td height ="10px"></td></tr>';
	                data.series.forEach(function(d){
	                    str = str + '<tr><td class="legend-color-guide"><div style="background-color:' + d.color + '"></div></td><td class="key">' + d.key + '</td><td class="value">' + d.value + '</td></tr>';
	                });
	                str = str + '</tbody>';
	            }
	            str = str + '</table>';
	            return str;
	        });
	
	        //============================================================
	        // Chart function
	        //------------------------------------------------------------
	
	        function chart(selection) {
	            renderWatch.reset();
	            renderWatch.models(parallelCoordinates);
	
	            selection.each(function(data) {
	                var container = d3.select(this);
	                nv.utils.initSVG(container);
	
	                var that = this;
	
	                var availableWidth = nv.utils.availableWidth(width, container, margin),
	                    availableHeight = nv.utils.availableHeight(height, container, margin);
	
	                chart.update = function() { container.call(chart); };
	                chart.container = this;
	
	                state.setter(stateSetter(dimensionData), chart.update)
	                    .getter(stateGetter(dimensionData))
	                    .update();
	
	                //set state.disabled
	                state.disabled = dimensionData.map(function (d) { return !!d.disabled });
	
	                //Keep dimensions position in memory
	                dimensionData = dimensionData.map(function (d) {d.disabled = !!d.disabled; return d});
	                dimensionData.forEach(function (d, i) {
	                    d.originalPosition = isNaN(d.originalPosition) ? i : d.originalPosition;
	                    d.currentPosition = isNaN(d.currentPosition) ? i : d.currentPosition;
	                });
	
	               if (!defaultState) {
	                    var key;
	                    defaultState = {};
	                    for(key in state) {
	                        if(state[key] instanceof Array)
	                            defaultState[key] = state[key].slice(0);
	                        else
	                            defaultState[key] = state[key];
	                    }
	                }
	
	                // Display No Data message if there's nothing to show.
	                if(!data || !data.length) {
	                    nv.utils.noData(chart, container);
	                    return chart;
	                } else {
	                    container.selectAll('.nv-noData').remove();
	                }
	
	                //------------------------------------------------------------
	                // Setup containers and skeleton of chart
	
	                var wrap = container.selectAll('g.nv-wrap.nv-parallelCoordinatesChart').data([data]);
	                var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-parallelCoordinatesChart').append('g');
	
	                var g = wrap.select('g');
	
	                gEnter.append('g').attr('class', 'nv-parallelCoordinatesWrap');
	                gEnter.append('g').attr('class', 'nv-legendWrap');
	
	                g.select("rect")
	                    .attr("width", availableWidth)
	                    .attr("height", (availableHeight > 0) ? availableHeight : 0);
	
	                // Legend
	                if (!showLegend) {
	                    g.select('.nv-legendWrap').selectAll('*').remove();
	                } else {
	                    legend.width(availableWidth)
	                        .color(function (d) { return "rgb(188,190,192)"; });
	
	                    g.select('.nv-legendWrap')
	                        .datum(dimensionData.sort(function (a, b) { return a.originalPosition - b.originalPosition; }))
	                        .call(legend);
	
	                    if (!marginTop && legend.height() !== margin.top) {
	                        margin.top = legend.height();
	                        availableHeight = nv.utils.availableHeight(height, container, margin);
	                    }
	                    wrap.select('.nv-legendWrap')
	                       .attr('transform', 'translate( 0 ,' + (-margin.top) + ')');
	                }
	                wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	                // Main Chart Component(s)
	                parallelCoordinates
	                    .width(availableWidth)
	                    .height(availableHeight)
	                    .dimensionData(dimensionData)
	                    .displayBrush(displayBrush);
	
			        var parallelCoordinatesWrap = g.select('.nv-parallelCoordinatesWrap ')
	                  .datum(data);
	
			        parallelCoordinatesWrap.transition().call(parallelCoordinates);
	
					//============================================================
	                // Event Handling/Dispatching (in chart's scope)
	                //------------------------------------------------------------
	                //Display reset brush button
			        parallelCoordinates.dispatch.on('brushEnd', function (active, hasActiveBrush) {
			            if (hasActiveBrush) {
			                displayBrush = true;
			                dispatch.brushEnd(active);
			            } else {
	
			                displayBrush = false;
			            }
			        });
	
			        legend.dispatch.on('stateChange', function(newState) {
			            for(var key in newState) {
			                state[key] = newState[key];
			            }
			            dispatch.stateChange(state);
			            chart.update();
			        });
	
	                //Update dimensions order and display reset sorting button
			        parallelCoordinates.dispatch.on('dimensionsOrder', function (e) {
			            dimensionData.sort(function (a, b) { return a.currentPosition - b.currentPosition; });
			            var isSorted = false;
			            dimensionData.forEach(function (d, i) {
			                d.currentPosition = i;
			                if (d.currentPosition !== d.originalPosition)
			                    isSorted = true;
			            });
			            dispatch.dimensionsOrder(dimensionData, isSorted);
			        });
	
					// Update chart from a state object passed to event handler
	                dispatch.on('changeState', function (e) {
	
	                    if (typeof e.disabled !== 'undefined') {
	                        dimensionData.forEach(function (series, i) {
	                            series.disabled = e.disabled[i];
	                        });
	                        state.disabled = e.disabled;
	                    }
	                    chart.update();
	                });
	            });
	
	            renderWatch.renderEnd('parraleleCoordinateChart immediate');
	            return chart;
	        }
	
			//============================================================
	        // Event Handling/Dispatching (out of chart's scope)
	        //------------------------------------------------------------
	
	        parallelCoordinates.dispatch.on('elementMouseover.tooltip', function (evt) {
	            var tp = {
	                key: evt.label,
	                color: evt.color,
	                series: []
	             }
	            if(evt.values){
	                Object.keys(evt.values).forEach(function (d) {
	                    var dim = evt.dimensions.filter(function (dd) {return dd.key === d;})[0];
	                    if(dim){
	                        var v;
	                        if (isNaN(evt.values[d]) || isNaN(parseFloat(evt.values[d]))) {
	                            v = nanValue;
	                        } else {
	                            v = dim.format(evt.values[d]);
	                        }
	                        tp.series.push({ idx: dim.currentPosition, key: d, value: v, color: dim.color });
	                    }
	                });
	                tp.series.sort(function(a,b) {return a.idx - b.idx});
	             }
	            tooltip.data(tp).hidden(false);
	        });
	
	        parallelCoordinates.dispatch.on('elementMouseout.tooltip', function(evt) {
	            tooltip.hidden(true)
	        });
	
	        parallelCoordinates.dispatch.on('elementMousemove.tooltip', function () {
	            tooltip();
	        });
			 //============================================================
	        // Expose Public Variables
	        //------------------------------------------------------------
	
			// expose chart's sub-components
	        chart.dispatch = dispatch;
	        chart.parallelCoordinates = parallelCoordinates;
	        chart.legend = legend;
	        chart.tooltip = tooltip;
	        chart.options = nv.utils.optionsFunc.bind(chart);
	
	        chart._options = Object.create({}, {
	            // simple options, just get/set the necessary values
	            width: { get: function () { return width; }, set: function (_) { width = _; } },
	            height: { get: function () { return height; }, set: function (_) { height = _; } },
	            showLegend: { get: function () { return showLegend; }, set: function (_) { showLegend = _; } },
	            defaultState: { get: function () { return defaultState; }, set: function (_) { defaultState = _; } },
	            dimensionData: { get: function () { return dimensionData; }, set: function (_) { dimensionData = _; } },
	            displayBrush: { get: function () { return displayBrush; }, set: function (_) { displayBrush = _; } },
	            noData: { get: function () { return noData; }, set: function (_) { noData = _; } },
	            nanValue: { get: function () { return nanValue; }, set: function (_) { nanValue = _; } },
	
	            // options that require extra logic in the setter
	            margin: {
	                get: function () { return margin; },
	                set: function (_) {
	                    if (_.top !== undefined) {
	                        margin.top = _.top;
	                        marginTop = _.top;
	                    }
	                    margin.right = _.right !== undefined ? _.right : margin.right;
	                    margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	                    margin.left = _.left !== undefined ? _.left : margin.left;
	                }
	            },
	            color: {get: function(){return color;}, set: function(_){
	                    color = nv.utils.getColor(_);
	                    legend.color(color);
	                    parallelCoordinates.color(color);
	                }}
	        });
	
	        nv.utils.inheritOptions(chart, parallelCoordinates);
	        nv.utils.initOptions(chart);
	
	        return chart;
	    };
	nv.models.pie = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = 500
	        , height = 500
	        , getX = function(d) { return d.x }
	        , getY = function(d) { return d.y }
	        , id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
	        , container = null
	        , color = nv.utils.defaultColor()
	        , valueFormat = d3.format(',.2f')
	        , showLabels = true
	        , labelsOutside = false
	        , labelType = "key"
	        , labelThreshold = .02 //if slice percentage is under this, don't show label
	        , hideOverlapLabels = false //Hide labels that don't fit in slice
	        , donut = false
	        , title = false
	        , growOnHover = true
	        , titleOffset = 0
	        , labelSunbeamLayout = false
	        , startAngle = false
	        , padAngle = false
	        , endAngle = false
	        , cornerRadius = 0
	        , donutRatio = 0.5
	        , duration = 250
	        , arcsRadius = []
	        , dispatch = d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'elementMousemove', 'renderEnd')
	        ;
	
	    var arcs = [];
	    var arcsOver = [];
	
	    //============================================================
	    // chart function
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch);
	
	    function chart(selection) {
	        renderWatch.reset();
	        selection.each(function(data) {
	            var availableWidth = width - margin.left - margin.right
	                , availableHeight = height - margin.top - margin.bottom
	                , radius = Math.min(availableWidth, availableHeight) / 2
	                , arcsRadiusOuter = []
	                , arcsRadiusInner = []
	                ;
	
	            container = d3.select(this)
	            if (arcsRadius.length === 0) {
	                var outer = radius - radius / 10;
	                var inner = donutRatio * radius;
	                for (var i = 0; i < data[0].length; i++) {
	                    arcsRadiusOuter.push(outer);
	                    arcsRadiusInner.push(inner);
	                }
	            } else {
	                if(growOnHover){
	                    arcsRadiusOuter = arcsRadius.map(function (d) { return (d.outer - d.outer / 10) * radius; });
	                    arcsRadiusInner = arcsRadius.map(function (d) { return (d.inner - d.inner / 10) * radius; });
	                    donutRatio = d3.min(arcsRadius.map(function (d) { return (d.inner - d.inner / 10); }));
	                } else {
	                    arcsRadiusOuter = arcsRadius.map(function (d) { return d.outer * radius; });
	                    arcsRadiusInner = arcsRadius.map(function (d) { return d.inner * radius; });
	                    donutRatio = d3.min(arcsRadius.map(function (d) { return d.inner; }));
	                }
	            }
	            nv.utils.initSVG(container);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('.nv-wrap.nv-pie').data(data);
	            var wrapEnter = wrap.enter().append('g').attr('class','nvd3 nv-wrap nv-pie nv-chart-' + id);
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	            var g_pie = gEnter.append('g').attr('class', 'nv-pie');
	            gEnter.append('g').attr('class', 'nv-pieLabels');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	            g.select('.nv-pie').attr('transform', 'translate(' + availableWidth / 2 + ',' + availableHeight / 2 + ')');
	            g.select('.nv-pieLabels').attr('transform', 'translate(' + availableWidth / 2 + ',' + availableHeight / 2 + ')');
	
	            //
	            container.on('click', function(d,i) {
	                dispatch.chartClick({
	                    data: d,
	                    index: i,
	                    pos: d3.event,
	                    id: id
	                });
	            });
	
	            arcs = [];
	            arcsOver = [];
	            for (var i = 0; i < data[0].length; i++) {
	
	                var arc = d3.svg.arc().outerRadius(arcsRadiusOuter[i]);
	                var arcOver = d3.svg.arc().outerRadius(arcsRadiusOuter[i] + 5);
	
	                if (startAngle !== false) {
	                    arc.startAngle(startAngle);
	                    arcOver.startAngle(startAngle);
	                }
	                if (endAngle !== false) {
	                    arc.endAngle(endAngle);
	                    arcOver.endAngle(endAngle);
	                }
	                if (donut) {
	                    arc.innerRadius(arcsRadiusInner[i]);
	                    arcOver.innerRadius(arcsRadiusInner[i]);
	                }
	
	                if (arc.cornerRadius && cornerRadius) {
	                    arc.cornerRadius(cornerRadius);
	                    arcOver.cornerRadius(cornerRadius);
	                }
	
	                arcs.push(arc);
	                arcsOver.push(arcOver);
	            }
	
	            // Setup the Pie chart and choose the data element
	            var pie = d3.layout.pie()
	                .sort(null)
	                .value(function(d) { return d.disabled ? 0 : getY(d) });
	
	            // padAngle added in d3 3.5
	            if (pie.padAngle && padAngle) {
	                pie.padAngle(padAngle);
	            }
	
	            // if title is specified and donut, put it in the middle
	            if (donut && title) {
	                g_pie.append("text").attr('class', 'nv-pie-title');
	
	                wrap.select('.nv-pie-title')
	                    .style("text-anchor", "middle")
	                    .text(function (d) {
	                        return title;
	                    })
	                    .style("font-size", (Math.min(availableWidth, availableHeight)) * donutRatio * 2 / (title.length + 2) + "px")
	                    .attr("dy", "0.35em") // trick to vertically center text
	                    .attr('transform', function(d, i) {
	                        return 'translate(0, '+ titleOffset + ')';
	                    });
	            }
	
	            var slices = wrap.select('.nv-pie').selectAll('.nv-slice').data(pie);
	            var pieLabels = wrap.select('.nv-pieLabels').selectAll('.nv-label').data(pie);
	
	            slices.exit().remove();
	            pieLabels.exit().remove();
	
	            var ae = slices.enter().append('g');
	            ae.attr('class', 'nv-slice');
	            ae.on('mouseover', function(d, i) {
	                d3.select(this).classed('hover', true);
	                if (growOnHover) {
	                    d3.select(this).select("path").transition()
	                        .duration(70)
	                        .attr("d", arcsOver[i]);
	                }
	                dispatch.elementMouseover({
	                    data: d.data,
	                    index: i,
	                    color: d3.select(this).style("fill"),
	                    percent: (d.endAngle - d.startAngle) / (2 * Math.PI)
	                });
	            });
	            ae.on('mouseout', function(d, i) {
	                d3.select(this).classed('hover', false);
	                if (growOnHover) {
	                    d3.select(this).select("path").transition()
	                        .duration(50)
	                        .attr("d", arcs[i]);
	                }
	                dispatch.elementMouseout({data: d.data, index: i});
	            });
	            ae.on('mousemove', function(d, i) {
	                dispatch.elementMousemove({data: d.data, index: i});
	            });
	            ae.on('click', function(d, i) {
	                var element = this;
	                dispatch.elementClick({
	                    data: d.data,
	                    index: i,
	                    color: d3.select(this).style("fill"),
	                    event: d3.event,
	                    element: element
	                });
	            });
	            ae.on('dblclick', function(d, i) {
	                dispatch.elementDblClick({
	                    data: d.data,
	                    index: i,
	                    color: d3.select(this).style("fill")
	                });
	            });
	
	            slices.attr('fill', function(d,i) { return color(d.data, i); });
	            slices.attr('stroke', function(d,i) { return color(d.data, i); });
	
	            var paths = ae.append('path').each(function(d) {
	                this._current = d;
	            });
	
	            slices.select('path')
	                .transition()
	                .duration(duration)
	                .attr('d', function (d, i) { return arcs[i](d); })
	                .attrTween('d', arcTween);
	
	            if (showLabels) {
	                // This does the normal label
	                var labelsArc = [];
	                for (var i = 0; i < data[0].length; i++) {
	                    labelsArc.push(arcs[i]);
	
	                    if (labelsOutside) {
	                        if (donut) {
	                            labelsArc[i] = d3.svg.arc().outerRadius(arcs[i].outerRadius());
	                            if (startAngle !== false) labelsArc[i].startAngle(startAngle);
	                            if (endAngle !== false) labelsArc[i].endAngle(endAngle);
	                        }
	                    } else if (!donut) {
	                            labelsArc[i].innerRadius(0);
	                    }
	                }
	
	                pieLabels.enter().append("g").classed("nv-label",true).each(function(d,i) {
	                    var group = d3.select(this);
	
	                    group.attr('transform', function (d, i) {
	                        if (labelSunbeamLayout) {
	                            d.outerRadius = arcsRadiusOuter[i] + 10; // Set Outer Coordinate
	                            d.innerRadius = arcsRadiusOuter[i] + 15; // Set Inner Coordinate
	                            var rotateAngle = (d.startAngle + d.endAngle) / 2 * (180 / Math.PI);
	                            if ((d.startAngle + d.endAngle) / 2 < Math.PI) {
	                                rotateAngle -= 90;
	                            } else {
	                                rotateAngle += 90;
	                            }
	                            return 'translate(' + labelsArc[i].centroid(d) + ') rotate(' + rotateAngle + ')';
	                        } else {
	                            d.outerRadius = radius + 10; // Set Outer Coordinate
	                            d.innerRadius = radius + 15; // Set Inner Coordinate
	                            return 'translate(' + labelsArc[i].centroid(d) + ')'
	                        }
	                    });
	
	                    group.append('rect')
	                        .style('stroke', '#fff')
	                        .style('fill', '#fff')
	                        .attr("rx", 3)
	                        .attr("ry", 3);
	
	                    group.append('text')
	                        .style('text-anchor', labelSunbeamLayout ? ((d.startAngle + d.endAngle) / 2 < Math.PI ? 'start' : 'end') : 'middle') //center the text on it's origin or begin/end if orthogonal aligned
	                        .style('fill', '#000')
	                });
	
	                var labelLocationHash = {};
	                var avgHeight = 14;
	                var avgWidth = 140;
	                var createHashKey = function(coordinates) {
	                    return Math.floor(coordinates[0]/avgWidth) * avgWidth + ',' + Math.floor(coordinates[1]/avgHeight) * avgHeight;
	                };
	                var getSlicePercentage = function(d) {
	                    return (d.endAngle - d.startAngle) / (2 * Math.PI);
	                };
	
	                pieLabels.watchTransition(renderWatch, 'pie labels').attr('transform', function (d, i) {
	                    if (labelSunbeamLayout) {
	                        d.outerRadius = arcsRadiusOuter[i] + 10; // Set Outer Coordinate
	                        d.innerRadius = arcsRadiusOuter[i] + 15; // Set Inner Coordinate
	                        var rotateAngle = (d.startAngle + d.endAngle) / 2 * (180 / Math.PI);
	                        if ((d.startAngle + d.endAngle) / 2 < Math.PI) {
	                            rotateAngle -= 90;
	                        } else {
	                            rotateAngle += 90;
	                        }
	                        return 'translate(' + labelsArc[i].centroid(d) + ') rotate(' + rotateAngle + ')';
	                    } else {
	                        d.outerRadius = radius + 10; // Set Outer Coordinate
	                        d.innerRadius = radius + 15; // Set Inner Coordinate
	
	                        /*
	                        Overlapping pie labels are not good. What this attempts to do is, prevent overlapping.
	                        Each label location is hashed, and if a hash collision occurs, we assume an overlap.
	                        Adjust the label's y-position to remove the overlap.
	                        */
	                        var center = labelsArc[i].centroid(d);
	                        var percent = getSlicePercentage(d);
	                        if (d.value && percent >= labelThreshold) {
	                            var hashKey = createHashKey(center);
	                            if (labelLocationHash[hashKey]) {
	                                center[1] -= avgHeight;
	                            }
	                            labelLocationHash[createHashKey(center)] = true;
	                        }
	                        return 'translate(' + center + ')'
	                    }
	                });
	
	                pieLabels.select(".nv-label text")
	                    .style('text-anchor', function(d,i) {
	                        //center the text on it's origin or begin/end if orthogonal aligned
	                        return labelSunbeamLayout ? ((d.startAngle + d.endAngle) / 2 < Math.PI ? 'start' : 'end') : 'middle';
	                    })
	                    .text(function(d, i) {
	                        var percent = getSlicePercentage(d);
	                        var label = '';
	                        if (!d.value || percent < labelThreshold) return '';
	
	                        if(typeof labelType === 'function') {
	                            label = labelType(d, i, {
	                                'key': getX(d.data),
	                                'value': getY(d.data),
	                                'percent': valueFormat(percent)
	                            });
	                        } else {
	                            switch (labelType) {
	                                case 'key':
	                                    label = getX(d.data);
	                                    break;
	                                case 'value':
	                                    label = valueFormat(getY(d.data));
	                                    break;
	                                case 'percent':
	                                    label = d3.format('%')(percent);
	                                    break;
	                            }
	                        }
	                        return label;
	                    })
	                ;
	
	                if (hideOverlapLabels) {
	                    pieLabels
	                        .each(function (d, i) {
	                            if (!this.getBBox) return;
	                            var bb = this.getBBox(),
	                            center = labelsArc[i].centroid(d);
	                            var topLeft = {
	                              x : center[0] + bb.x,
	                              y : center[1] + bb.y
	                            };
	
	                            var topRight = {
	                              x : topLeft.x + bb.width,
	                              y : topLeft.y
	                            };
	
	                            var bottomLeft = {
	                              x : topLeft.x,
	                              y : topLeft.y + bb.height
	                            };
	
	                            var bottomRight = {
	                              x : topLeft.x + bb.width,
	                              y : topLeft.y + bb.height
	                            };
	
	                            d.visible = nv.utils.pointIsInArc(topLeft, d, arc) &&
	                            nv.utils.pointIsInArc(topRight, d, arc) &&
	                            nv.utils.pointIsInArc(bottomLeft, d, arc) &&
	                            nv.utils.pointIsInArc(bottomRight, d, arc);
	                        })
	                        .style('display', function (d) {
	                            return d.visible ? null : 'none';
	                        })
	                    ;
	                }
	
	            }
	
	
	            // Computes the angle of an arc, converting from radians to degrees.
	            function angle(d) {
	                var a = (d.startAngle + d.endAngle) * 90 / Math.PI - 90;
	                return a > 90 ? a - 180 : a;
	            }
	
	            function arcTween(a, idx) {
	                a.endAngle = isNaN(a.endAngle) ? 0 : a.endAngle;
	                a.startAngle = isNaN(a.startAngle) ? 0 : a.startAngle;
	                if (!donut) a.innerRadius = 0;
	                var i = d3.interpolate(this._current, a);
	                this._current = i(0);
	                return function (t) {
	                    return arcs[idx](i(t));
	                };
	            }
	        });
	
	        renderWatch.renderEnd('pie immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        arcsRadius: { get: function () { return arcsRadius; }, set: function (_) { arcsRadius = _; } },
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        showLabels: {get: function(){return showLabels;}, set: function(_){showLabels=_;}},
	        title:      {get: function(){return title;}, set: function(_){title=_;}},
	        titleOffset:    {get: function(){return titleOffset;}, set: function(_){titleOffset=_;}},
	        labelThreshold: {get: function(){return labelThreshold;}, set: function(_){labelThreshold=_;}},
	        hideOverlapLabels: {get: function(){return hideOverlapLabels;}, set: function(_){hideOverlapLabels=_;}},
	        valueFormat:    {get: function(){return valueFormat;}, set: function(_){valueFormat=_;}},
	        x:          {get: function(){return getX;}, set: function(_){getX=_;}},
	        id:         {get: function(){return id;}, set: function(_){id=_;}},
	        endAngle:   {get: function(){return endAngle;}, set: function(_){endAngle=_;}},
	        startAngle: {get: function(){return startAngle;}, set: function(_){startAngle=_;}},
	        padAngle:   {get: function(){return padAngle;}, set: function(_){padAngle=_;}},
	        cornerRadius: {get: function(){return cornerRadius;}, set: function(_){cornerRadius=_;}},
	        donutRatio:   {get: function(){return donutRatio;}, set: function(_){donutRatio=_;}},
	        labelsOutside: {get: function(){return labelsOutside;}, set: function(_){labelsOutside=_;}},
	        labelSunbeamLayout: {get: function(){return labelSunbeamLayout;}, set: function(_){labelSunbeamLayout=_;}},
	        donut:              {get: function(){return donut;}, set: function(_){donut=_;}},
	        growOnHover:        {get: function(){return growOnHover;}, set: function(_){growOnHover=_;}},
	
	        // depreciated after 1.7.1
	        pieLabelsOutside: {get: function(){return labelsOutside;}, set: function(_){
	            labelsOutside=_;
	            nv.deprecated('pieLabelsOutside', 'use labelsOutside instead');
	        }},
	        // depreciated after 1.7.1
	        donutLabelsOutside: {get: function(){return labelsOutside;}, set: function(_){
	            labelsOutside=_;
	            nv.deprecated('donutLabelsOutside', 'use labelsOutside instead');
	        }},
	        // deprecated after 1.7.1
	        labelFormat: {get: function(){ return valueFormat;}, set: function(_) {
	            valueFormat=_;
	            nv.deprecated('labelFormat','use valueFormat instead');
	        }},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = typeof _.top    != 'undefined' ? _.top    : margin.top;
	            margin.right  = typeof _.right  != 'undefined' ? _.right  : margin.right;
	            margin.bottom = typeof _.bottom != 'undefined' ? _.bottom : margin.bottom;
	            margin.left   = typeof _.left   != 'undefined' ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	        }},
	        y: {get: function(){return getY;}, set: function(_){
	            getY=d3.functor(_);
	        }},
	        color: {get: function(){return color;}, set: function(_){
	            color=nv.utils.getColor(_);
	        }},
	        labelType:          {get: function(){return labelType;}, set: function(_){
	            labelType= _ || 'key';
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	    return chart;
	};
	nv.models.pieChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var pie = nv.models.pie();
	    var legend = nv.models.legend();
	    var tooltip = nv.models.tooltip();
	
	    var margin = {top: 30, right: 20, bottom: 20, left: 20}
	        , marginTop = null
	        , width = null
	        , height = null
	        , showTooltipPercent = false
	        , showLegend = true
	        , legendPosition = "top"
	        , color = nv.utils.defaultColor()
	        , state = nv.utils.state()
	        , defaultState = null
	        , noData = null
	        , duration = 250
	        , dispatch = d3.dispatch('stateChange', 'changeState','renderEnd')
	        ;
	
	    tooltip
	        .duration(0)
	        .headerEnabled(false)
	        .valueFormatter(function(d, i) {
	            return pie.valueFormat()(d, i);
	        });
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch);
	
	    var stateGetter = function(data) {
	        return function(){
	            return {
	                active: data.map(function(d) { return !d.disabled })
	            };
	        }
	    };
	
	    var stateSetter = function(data) {
	        return function(state) {
	            if (state.active !== undefined) {
	                data.forEach(function (series, i) {
	                    series.disabled = !state.active[i];
	                });
	            }
	        }
	    };
	
	    //============================================================
	    // Chart function
	    //------------------------------------------------------------
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(pie);
	
	        selection.each(function(data) {
	            var container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            var that = this;
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            chart.update = function() { container.transition().call(chart); };
	            chart.container = this;
	
	            state.setter(stateSetter(data), chart.update)
	                .getter(stateGetter(data))
	                .update();
	
	            //set state.disabled
	            state.disabled = data.map(function(d) { return !!d.disabled });
	
	            if (!defaultState) {
	                var key;
	                defaultState = {};
	                for (key in state) {
	                    if (state[key] instanceof Array)
	                        defaultState[key] = state[key].slice(0);
	                    else
	                        defaultState[key] = state[key];
	                }
	            }
	
	            // Display No Data message if there's nothing to show.
	            if (!data || !data.length) {
	                nv.utils.noData(chart, container);
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-pieChart').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-pieChart').append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-pieWrap');
	            gEnter.append('g').attr('class', 'nv-legendWrap');
	
	            // Legend
	            if (!showLegend) {
	                g.select('.nv-legendWrap').selectAll('*').remove();
	            } else {
	                if (legendPosition === "top") {
	                    legend.width( availableWidth ).key(pie.x());
	
	                    wrap.select('.nv-legendWrap')
	                        .datum(data)
	                        .call(legend);
	
	                    if (!marginTop && legend.height() !== margin.top) {
	                        margin.top = legend.height();
	                        availableHeight = nv.utils.availableHeight(height, container, margin);
	                    }
	
	                    wrap.select('.nv-legendWrap')
	                        .attr('transform', 'translate(0,' + (-margin.top) +')');
	                } else if (legendPosition === "right") {
	                    var legendWidth = nv.models.legend().width();
	                    if (availableWidth / 2 < legendWidth) {
	                        legendWidth = (availableWidth / 2)
	                    }
	                    legend.height(availableHeight).key(pie.x());
	                    legend.width(legendWidth);
	                    availableWidth -= legend.width();
	
	                    wrap.select('.nv-legendWrap')
	                        .datum(data)
	                        .call(legend)
	                        .attr('transform', 'translate(' + (availableWidth) +',0)');
	                } else if (legendPosition === "bottom") {
	                    legend.width( availableWidth ).key(pie.x());
	                    wrap.select('.nv-legendWrap')
	                        .datum(data)
	                        .call(legend);
	
	                    margin.bottom = legend.height();
	                    availableHeight = nv.utils.availableHeight(height, container, margin);
	                    wrap.select('.nv-legendWrap')
	                        .attr('transform', 'translate(0,' + availableHeight +')');
	                }
	            }
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            // Main Chart Component(s)
	            pie.width(availableWidth).height(availableHeight);
	            var pieWrap = g.select('.nv-pieWrap').datum([data]);
	            d3.transition(pieWrap).call(pie);
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            legend.dispatch.on('stateChange', function(newState) {
	                for (var key in newState) {
	                    state[key] = newState[key];
	                }
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            // Update chart from a state object passed to event handler
	            dispatch.on('changeState', function(e) {
	                if (typeof e.disabled !== 'undefined') {
	                    data.forEach(function(series,i) {
	                        series.disabled = e.disabled[i];
	                    });
	                    state.disabled = e.disabled;
	                }
	                chart.update();
	            });
	        });
	
	        renderWatch.renderEnd('pieChart immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    pie.dispatch.on('elementMouseover.tooltip', function(evt) {
	        evt['series'] = {
	            key: chart.x()(evt.data),
	            value: chart.y()(evt.data),
	            color: evt.color,
	            percent: evt.percent
	        };
	        if (!showTooltipPercent) {
	            delete evt.percent;
	            delete evt.series.percent;
	        }
	        tooltip.data(evt).hidden(false);
	    });
	
	    pie.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true);
	    });
	
	    pie.dispatch.on('elementMousemove.tooltip', function(evt) {
	        tooltip();
	    });
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.legend = legend;
	    chart.dispatch = dispatch;
	    chart.pie = pie;
	    chart.tooltip = tooltip;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    // use Object get/set functionality to map between vars and chart functions
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:              {get: function(){return width;},                set: function(_){width=_;}},
	        height:             {get: function(){return height;},               set: function(_){height=_;}},
	        noData:             {get: function(){return noData;},               set: function(_){noData=_;}},
	        showTooltipPercent: {get: function(){return showTooltipPercent;},   set: function(_){showTooltipPercent=_;}},
	        showLegend:         {get: function(){return showLegend;},           set: function(_){showLegend=_;}},
	        legendPosition:     {get: function(){return legendPosition;},       set: function(_){legendPosition=_;}},
	        defaultState:       {get: function(){return defaultState;},         set: function(_){defaultState=_;}},
	
	        // options that require extra logic in the setter
	        color: {get: function(){return color;}, set: function(_){
	            color = _;
	            legend.color(color);
	            pie.color(color);
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	            pie.duration(duration);
	        }},
	        margin: {get: function(){return margin;}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }}
	    });
	    nv.utils.inheritOptions(chart, pie);
	    nv.utils.initOptions(chart);
	    return chart;
	};
	nv.models.sankey = function() {
	    'use strict';
	
	    // Sources:
	    // - https://bost.ocks.org/mike/sankey/
	    // - https://github.com/soxofaan/d3-plugin-captain-sankey
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var sankey = {},
	        nodeWidth = 24,
	        nodePadding = 8,
	        size = [1, 1],
	        nodes = [],
	        links = [],
	        sinksRight = true;
	
	    var layout = function(iterations) {
	        computeNodeLinks();
	        computeNodeValues();
	        computeNodeBreadths();
	        computeNodeDepths(iterations);
	    };
	
	    var relayout = function() {
	        computeLinkDepths();
	    };
	
	    // SVG path data generator, to be used as 'd' attribute on 'path' element selection.
	    var link = function() {
	        var curvature = .5;
	
	        function link(d) {
	
	            var x0 = d.source.x + d.source.dx,
	                x1 = d.target.x,
	                xi = d3.interpolateNumber(x0, x1),
	                x2 = xi(curvature),
	                x3 = xi(1 - curvature),
	                y0 = d.source.y + d.sy + d.dy / 2,
	                y1 = d.target.y + d.ty + d.dy / 2;
	            var linkPath = 'M' + x0 + ',' + y0
	                + 'C' + x2 + ',' + y0
	                + ' ' + x3 + ',' + y1
	                + ' ' + x1 + ',' + y1;
	            return linkPath;
	        }
	
	        link.curvature = function(_) {
	            if (!arguments.length) return curvature;
	            curvature = +_;
	            return link;
	        };
	
	        return link;
	    };
	
	    // Y-position of the middle of a node.
	    var center = function(node) {
	        return node.y + node.dy / 2;
	    };
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    // Populate the sourceLinks and targetLinks for each node.
	    // Also, if the source and target are not objects, assume they are indices.
	    function computeNodeLinks() {
	        nodes.forEach(function(node) {
	            // Links that have this node as source.
	            node.sourceLinks = [];
	            // Links that have this node as target.
	            node.targetLinks = [];
	        });
	        links.forEach(function(link) {
	            var source = link.source,
	                target = link.target;
	            if (typeof source === 'number') source = link.source = nodes[link.source];
	            if (typeof target === 'number') target = link.target = nodes[link.target];
	            source.sourceLinks.push(link);
	            target.targetLinks.push(link);
	        });
	    }
	
	    // Compute the value (size) of each node by summing the associated links.
	    function computeNodeValues() {
	        nodes.forEach(function(node) {
	            node.value = Math.max(
	                d3.sum(node.sourceLinks, value),
	                d3.sum(node.targetLinks, value)
	            );
	        });
	    }
	
	    // Iteratively assign the breadth (x-position) for each node.
	    // Nodes are assigned the maximum breadth of incoming neighbors plus one;
	    // nodes with no incoming links are assigned breadth zero, while
	    // nodes with no outgoing links are assigned the maximum breadth.
	    function computeNodeBreadths() {
	        //
	        var remainingNodes = nodes,
	            nextNodes,
	            x = 0;
	
	        // Work from left to right.
	        // Keep updating the breath (x-position) of nodes that are target of recently updated nodes.
	        //
	        while (remainingNodes.length && x < nodes.length) {
	            nextNodes = [];
	            remainingNodes.forEach(function(node) {
	                node.x = x;
	                node.dx = nodeWidth;
	                node.sourceLinks.forEach(function(link) {
	                    if (nextNodes.indexOf(link.target) < 0) {
	                        nextNodes.push(link.target);
	                    }
	                });
	            });
	            remainingNodes = nextNodes;
	            ++x;
	            //
	        }
	
	        // Optionally move pure sinks always to the right.
	        if (sinksRight) {
	            moveSinksRight(x);
	        }
	
	        scaleNodeBreadths((size[0] - nodeWidth) / (x - 1));
	    }
	
	    function moveSourcesRight() {
	        nodes.forEach(function(node) {
	            if (!node.targetLinks.length) {
	                node.x = d3.min(node.sourceLinks, function(d) { return d.target.x; }) - 1;
	            }
	        });
	    }
	
	    function moveSinksRight(x) {
	        nodes.forEach(function(node) {
	            if (!node.sourceLinks.length) {
	                node.x = x - 1;
	            }
	        });
	    }
	
	    function scaleNodeBreadths(kx) {
	        nodes.forEach(function(node) {
	            node.x *= kx;
	        });
	    }
	
	    // Compute the depth (y-position) for each node.
	    function computeNodeDepths(iterations) {
	        // Group nodes by breath.
	        var nodesByBreadth = d3.nest()
	            .key(function(d) { return d.x; })
	            .sortKeys(d3.ascending)
	            .entries(nodes)
	            .map(function(d) { return d.values; });
	
	        //
	        initializeNodeDepth();
	        resolveCollisions();
	        computeLinkDepths();
	        for (var alpha = 1; iterations > 0; --iterations) {
	            relaxRightToLeft(alpha *= .99);
	            resolveCollisions();
	            computeLinkDepths();
	            relaxLeftToRight(alpha);
	            resolveCollisions();
	            computeLinkDepths();
	        }
	
	        function initializeNodeDepth() {
	            // Calculate vertical scaling factor.
	            var ky = d3.min(nodesByBreadth, function(nodes) {
	                return (size[1] - (nodes.length - 1) * nodePadding) / d3.sum(nodes, value);
	            });
	
	            nodesByBreadth.forEach(function(nodes) {
	                nodes.forEach(function(node, i) {
	                    node.y = i;
	                    node.dy = node.value * ky;
	                });
	            });
	
	            links.forEach(function(link) {
	                link.dy = link.value * ky;
	            });
	        }
	
	        function relaxLeftToRight(alpha) {
	            nodesByBreadth.forEach(function(nodes, breadth) {
	                nodes.forEach(function(node) {
	                    if (node.targetLinks.length) {
	                        // Value-weighted average of the y-position of source node centers linked to this node.
	                        var y = d3.sum(node.targetLinks, weightedSource) / d3.sum(node.targetLinks, value);
	                        node.y += (y - center(node)) * alpha;
	                    }
	                });
	            });
	
	            function weightedSource(link) {
	                return (link.source.y + link.sy + link.dy / 2) * link.value;
	            }
	        }
	
	        function relaxRightToLeft(alpha) {
	            nodesByBreadth.slice().reverse().forEach(function(nodes) {
	                nodes.forEach(function(node) {
	                    if (node.sourceLinks.length) {
	                        // Value-weighted average of the y-positions of target nodes linked to this node.
	                        var y = d3.sum(node.sourceLinks, weightedTarget) / d3.sum(node.sourceLinks, value);
	                        node.y += (y - center(node)) * alpha;
	                    }
	                });
	            });
	
	            function weightedTarget(link) {
	                return (link.target.y + link.ty + link.dy / 2) * link.value;
	            }
	        }
	
	        function resolveCollisions() {
	            nodesByBreadth.forEach(function(nodes) {
	                var node,
	                    dy,
	                    y0 = 0,
	                    n = nodes.length,
	                    i;
	
	                // Push any overlapping nodes down.
	                nodes.sort(ascendingDepth);
	                for (i = 0; i < n; ++i) {
	                    node = nodes[i];
	                    dy = y0 - node.y;
	                    if (dy > 0) node.y += dy;
	                    y0 = node.y + node.dy + nodePadding;
	                }
	
	                // If the bottommost node goes outside the bounds, push it back up.
	                dy = y0 - nodePadding - size[1];
	                if (dy > 0) {
	                    y0 = node.y -= dy;
	
	                    // Push any overlapping nodes back up.
	                    for (i = n - 2; i >= 0; --i) {
	                        node = nodes[i];
	                        dy = node.y + node.dy + nodePadding - y0;
	                        if (dy > 0) node.y -= dy;
	                        y0 = node.y;
	                    }
	                }
	            });
	        }
	
	        function ascendingDepth(a, b) {
	            return a.y - b.y;
	        }
	    }
	
	    // Compute y-offset of the source endpoint (sy) and target endpoints (ty) of links,
	    // relative to the source/target node's y-position.
	    function computeLinkDepths() {
	        nodes.forEach(function(node) {
	            node.sourceLinks.sort(ascendingTargetDepth);
	            node.targetLinks.sort(ascendingSourceDepth);
	        });
	        nodes.forEach(function(node) {
	            var sy = 0, ty = 0;
	            node.sourceLinks.forEach(function(link) {
	                link.sy = sy;
	                sy += link.dy;
	            });
	            node.targetLinks.forEach(function(link) {
	                link.ty = ty;
	                ty += link.dy;
	            });
	        });
	
	        function ascendingSourceDepth(a, b) {
	            return a.source.y - b.source.y;
	        }
	
	        function ascendingTargetDepth(a, b) {
	            return a.target.y - b.target.y;
	        }
	    }
	
	    // Value property accessor.
	    function value(x) {
	        return x.value;
	    }
	
	    sankey.options = nv.utils.optionsFunc.bind(sankey);
	    sankey._options = Object.create({}, {
	        nodeWidth:    {get: function(){return nodeWidth;},   set: function(_){nodeWidth=+_;}},
	        nodePadding:  {get: function(){return nodePadding;}, set: function(_){nodePadding=_;}},
	        nodes:        {get: function(){return nodes;},       set: function(_){nodes=_;}},
	        links:        {get: function(){return links ;},      set: function(_){links=_;}},
	        size:         {get: function(){return size;},        set: function(_){size=_;}},
	        sinksRight:   {get: function(){return sinksRight;},  set: function(_){sinksRight=_;}},
	
	        layout:       {get: function(){layout(32);},         set: function(_){layout(_);}},
	        relayout:     {get: function(){relayout();},         set: function(_){}},
	        center:       {get: function(){return center();},    set: function(_){
	            if(typeof _ === 'function'){
	                center=_;
	            }
	        }},
	        link:         {get: function(){return link();},      set: function(_){
	            if(typeof _ === 'function'){
	                link=_;
	            }
	            return link();
	        }}
	    });
	
	    nv.utils.initOptions(sankey);
	
	    return sankey;
	};
	nv.models.sankeyChart = function() {
	    "use strict";
	
	    // Sources:
	    // - https://bost.ocks.org/mike/sankey/
	    // - https://github.com/soxofaan/d3-plugin-captain-sankey
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 5, right: 0, bottom: 5, left: 0}
	        , sankey = nv.models.sankey()
	        , width = 600
	        , height = 400
	        , nodeWidth = 36
	        , nodePadding =  40
	        , units = 'units'
	        , center = undefined
	        ;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var formatNumber = d3.format(',.0f');    // zero decimal places
	    var format = function(d) {
	        return formatNumber(d) + ' ' + units;
	    };
	    var color = d3.scale.category20();
	    var linkTitle = function(d){
	        return d.source.name + ' → ' + d.target.name + '\n' + format(d.value);
	    };
	    var nodeFillColor = function(d){
	        return d.color = color(d.name.replace(/ .*/, ''));
	    };
	    var nodeStrokeColor = function(d){
	        return d3.rgb(d.color).darker(2);
	    };
	    var nodeTitle = function(d){
	        return d.name + '\n' + format(d.value);
	    };
	
	    var showError = function(element, message) {
	        element.append('text')
	            .attr('x', 0)
	            .attr('y', 0)
	            .attr('class', 'nvd3-sankey-chart-error')
	            .attr('text-anchor', 'middle')
	            .text(message);
	    };
	
	    function chart(selection) {
	        selection.each(function(data) {
	
	            var testData = {
	                nodes:
	                    [
	                        {'node': 1, 'name': 'Test 1'},
	                        {'node': 2, 'name': 'Test 2'},
	                        {'node': 3, 'name': 'Test 3'},
	                        {'node': 4, 'name': 'Test 4'},
	                        {'node': 5, 'name': 'Test 5'},
	                        {'node': 6, 'name': 'Test 6'}
	                    ],
	                links:
	                    [
	                        {'source': 0, 'target': 1, 'value': 2295},
	                        {'source': 0, 'target': 5, 'value': 1199},
	                        {'source': 1, 'target': 2, 'value': 1119},
	                        {'source': 1, 'target': 5, 'value': 1176},
	                        {'source': 2, 'target': 3, 'value': 487},
	                        {'source': 2, 'target': 5, 'value': 632},
	                        {'source': 3, 'target': 4, 'value': 301},
	                        {'source': 3, 'target': 5, 'value': 186}
	                    ]
	            };
	
	            // Error handling
	            var isDataValid = false;
	            var dataAvailable = false;
	
	            // check if data is valid
	            if(
	                (typeof data['nodes'] === 'object' && data['nodes'].length) >= 0 &&
	                (typeof data['links'] === 'object' && data['links'].length) >= 0
	            ){
	                isDataValid = true;
	            }
	
	            // check if data is available
	            if(
	                data['nodes'] && data['nodes'].length > 0 &&
	                data['links'] && data['links'].length > 0
	            ) {
	                dataAvailable = true;
	            }
	
	            // show error
	            if(!isDataValid) {
	                console.error('NVD3 Sankey chart error:', 'invalid data format for', data);
	                console.info('Valid data format is: ', testData, JSON.stringify(testData));
	                showError(selection, 'Error loading chart, data is invalid');
	                return false;
	            }
	
	            // TODO use nv.utils.noData
	            if(!dataAvailable) {
	                showError(selection, 'No data available');
	                return false;
	            }
	
	            // No errors, continue
	
	            // append the svg canvas to the page
	            var svg = selection.append('svg')
	                .attr('width', width)
	                .attr('height', height)
	                .append('g')
	                .attr('class', 'nvd3 nv-wrap nv-sankeyChart');
	
	            // Set the sankey diagram properties
	            sankey
	                .nodeWidth(nodeWidth)
	                .nodePadding(nodePadding)
	                .size([width, height]);
	
	            var path = sankey.link();
	
	            sankey
	                .nodes(data.nodes)
	                .links(data.links)
	                .layout(32)
	                .center(center);
	
	            // add in the links
	            var link = svg.append('g').selectAll('.link')
	                .data(data.links)
	                .enter().append('path')
	                .attr('class', 'link')
	                .attr('d', path)
	                .style('stroke-width', function(d) { return Math.max(1, d.dy); })
	            .sort(function(a,b) { return b.dy - a.dy; });
	
	            // add the link titles
	            link.append('title')
	                .text(linkTitle);
	
	            // add in the nodes
	            var node = svg.append('g').selectAll('.node')
	                .data(data.nodes)
	                .enter().append('g')
	                .attr('class', 'node')
	                .attr('transform', function(d) { return 'translate(' + d.x + ',' + d.y + ')'; })
	                .call(
	                    d3.behavior
	                        .drag()
	                        .origin(function(d) { return d; })
	                        .on('dragstart', function() {
	                            this.parentNode.appendChild(this);
	                        })
	                        .on('drag', dragmove)
	                );
	
	            // add the rectangles for the nodes
	            node.append('rect')
	                .attr('height', function(d) { return d.dy; })
	                .attr('width', sankey.nodeWidth())
	                .style('fill', nodeFillColor)
	                .style('stroke', nodeStrokeColor)
	                .append('title')
	                .text(nodeTitle);
	
	            // add in the title for the nodes
	            node.append('text')
	                .attr('x', -6)
	                .attr('y', function(d) { return d.dy / 2; })
	                .attr('dy', '.35em')
	                .attr('text-anchor', 'end')
	                .attr('transform', null)
	                .text(function(d) { return d.name; })
	                .filter(function(d) { return d.x < width / 2; })
	                .attr('x', 6 + sankey.nodeWidth())
	                .attr('text-anchor', 'start');
	
	            // the function for moving the nodes
	            function dragmove(d) {
	                d3.select(this).attr('transform',
	                'translate(' + d.x + ',' + (
	                    d.y = Math.max(0, Math.min(height - d.dy, d3.event.y))
	                ) + ')');
	                sankey.relayout();
	                link.attr('d', path);
	            }
	        });
	
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        units:           {get: function(){return units;},       set: function(_){units=_;}},
	        width:           {get: function(){return width;},       set: function(_){width=_;}},
	        height:          {get: function(){return height;},      set: function(_){height=_;}},
	        format:          {get: function(){return format;},      set: function(_){format=_;}},
	        linkTitle:       {get: function(){return linkTitle;},   set: function(_){linkTitle=_;}},
	        nodeWidth:       {get: function(){return nodeWidth;},   set: function(_){nodeWidth=_;}},
	        nodePadding:     {get: function(){return nodePadding;}, set: function(_){nodePadding=_;}},
	        center:          {get: function(){return center},       set: function(_){center=_}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        nodeStyle: {get: function(){return {};}, set: function(_){
	            nodeFillColor   = _.fillColor   !== undefined ? _.fillColor   : nodeFillColor;
	            nodeStrokeColor = _.strokeColor !== undefined ? _.strokeColor : nodeStrokeColor;
	            nodeTitle       = _.title       !== undefined ? _.title       : nodeTitle;
	        }}
	
	    });
	
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.scatter = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin       = {top: 0, right: 0, bottom: 0, left: 0}
	        , width        = null
	        , height       = null
	        , color        = nv.utils.defaultColor() // chooses color
	        , pointBorderColor = null
	        , id           = Math.floor(Math.random() * 100000) //Create semi-unique ID incase user doesn't select one
	        , container    = null
	        , x            = d3.scale.linear()
	        , y            = d3.scale.linear()
	        , z            = d3.scale.linear() //linear because d3.svg.shape.size is treated as area
	        , getX         = function(d) { return d.x } // accessor to get the x value
	        , getY         = function(d) { return d.y } // accessor to get the y value
	        , getSize      = function(d) { return d.size || 1} // accessor to get the point size
	        , getShape     = function(d) { return d.shape || 'circle' } // accessor to get point shape
	        , forceX       = [] // List of numbers to Force into the X scale (ie. 0, or a max / min, etc.)
	        , forceY       = [] // List of numbers to Force into the Y scale
	        , forceSize    = [] // List of numbers to Force into the Size scale
	        , interactive  = true // If true, plots a voronoi overlay for advanced point intersection
	        , pointActive  = function(d) { return !d.notActive } // any points that return false will be filtered out
	        , padData      = false // If true, adds half a data points width to front and back, for lining up a line chart with a bar chart
	        , padDataOuter = .1 //outerPadding to imitate ordinal scale outer padding
	        , clipEdge     = false // if true, masks points within x and y scale
	        , clipVoronoi  = true // if true, masks each point with a circle... can turn off to slightly increase performance
	        , showVoronoi  = false // display the voronoi areas
	        , clipRadius   = function() { return 25 } // function to get the radius for voronoi point clips
	        , xDomain      = null // Override x domain (skips the calculation from data)
	        , yDomain      = null // Override y domain
	        , xRange       = null // Override x range
	        , yRange       = null // Override y range
	        , sizeDomain   = null // Override point size domain
	        , sizeRange    = null
	        , singlePoint  = false
	        , dispatch     = d3.dispatch('elementClick', 'elementDblClick', 'elementMouseover', 'elementMouseout', 'renderEnd')
	        , useVoronoi   = true
	        , duration     = 250
	        , interactiveUpdateDelay = 300
	        , showLabels    = false
	        ;
	
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var x0, y0, z0 // used to store previous scales
	        , xDom, yDom // used to store previous domains
	        , width0
	        , height0
	        , timeoutID
	        , needsUpdate = false // Flag for when the points are visually updating, but the interactive layer is behind, to disable tooltips
	        , renderWatch = nv.utils.renderWatch(dispatch, duration)
	        , _sizeRange_def = [16, 256]
	        , _cache = {}
	        ;
	
	    //============================================================
	    // Diff and Cache Utilities
	    //------------------------------------------------------------
	    // getDiffs is used to filter unchanged points from the update
	    // selection. It implicitly updates it's cache when called and
	    // therefor the diff is based upon the previous invocation NOT
	    // the previous update.
	    //
	    // getDiffs takes a point as its first argument followed by n
	    // key getter pairs (d, [key, get... key, get]) this approach
	    // was chosen for efficiency. (The filter will call it a LOT).
	    //
	    // It is important to call delCache on point exit to prevent a
	    // memory leak. It is also needed to prevent invalid caches if
	    // a new point uses the same series and point id key.
	    //
	    // Argument Performance Concerns:
	    // - Object property lists for key getter pairs would be very
	    // expensive (points * objects for the GC every update).
	    // - ES6 function names for implicit keys would be nice but
	    // they are not guaranteed to be unique.
	    // - function.toString to obtain implicit keys is possible
	    // but long object keys are not free (internal hash).
	    // - Explicit key without objects are the most efficient.
	
	    function getCache(d) {
	        var key, val;
	        key = d[0].series + ':' + d[1];
	        val = _cache[key] = _cache[key] || {};
	        return val;
	    }
	
	    function delCache(d) {
	        var key, val;
	        key = d[0].series + ':' + d[1];
	        delete _cache[key];
	    }
	
	    function getDiffs(d) {
	        var i, key, val,
	            cache = getCache(d),
	            diffs = false;
	        for (i = 1; i < arguments.length; i += 2) {
	            key = arguments[i];
	            val = arguments[i + 1](d[0], d[1]);
	            if (cache[key] !== val || !cache.hasOwnProperty(key)) {
	                cache[key] = val;
	                diffs = true;
	            }
	        }
	        return diffs;
	    }
	
	    function chart(selection) {
	        renderWatch.reset();
	        selection.each(function(data) {
	            container = d3.select(this);
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            nv.utils.initSVG(container);
	
	            //add series index to each data point for reference
	            data.forEach(function(series, i) {
	                series.values.forEach(function(point) {
	                    point.series = i;
	                });
	            });
	
	            // Setup Scales
	            var logScale = (typeof(chart.yScale().base) === "function"); // Only log scale has a method "base()"
	            // remap and flatten the data for use in calculating the scales' domains
	            var seriesData = (xDomain && yDomain && sizeDomain) ? [] : // if we know xDomain and yDomain and sizeDomain, no need to calculate.... if Size is constant remember to set sizeDomain to speed up performance
	                d3.merge(
	                    data.map(function(d) {
	                        return d.values.map(function(d,i) {
	                            return { x: getX(d,i), y: getY(d,i), size: getSize(d,i) }
	                        })
	                    })
	                );
	
	            x   .domain(xDomain || d3.extent(seriesData.map(function(d) { return d.x; }).concat(forceX)))
	
	            if (padData && data[0])
	                x.range(xRange || [(availableWidth * padDataOuter +  availableWidth) / (2 *data[0].values.length), availableWidth - availableWidth * (1 + padDataOuter) / (2 * data[0].values.length)  ]);
	            //x.range([availableWidth * .5 / data[0].values.length, availableWidth * (data[0].values.length - .5)  / data[0].values.length ]);
	            else
	                x.range(xRange || [0, availableWidth]);
	
	             if (logScale) {
	                    var min = d3.min(seriesData.map(function(d) { if (d.y !== 0) return d.y; }));
	                    y.clamp(true)
	                        .domain(yDomain || d3.extent(seriesData.map(function(d) {
	                            if (d.y !== 0) return d.y;
	                            else return min * 0.1;
	                        }).concat(forceY)))
	                        .range(yRange || [availableHeight, 0]);
	                } else {
	                        y.domain(yDomain || d3.extent(seriesData.map(function (d) { return d.y;}).concat(forceY)))
	                        .range(yRange || [availableHeight, 0]);
	                }
	
	            z   .domain(sizeDomain || d3.extent(seriesData.map(function(d) { return d.size }).concat(forceSize)))
	                .range(sizeRange || _sizeRange_def);
	
	            // If scale's domain don't have a range, slightly adjust to make one... so a chart can show a single data point
	            singlePoint = x.domain()[0] === x.domain()[1] || y.domain()[0] === y.domain()[1];
	
	            if (x.domain()[0] === x.domain()[1])
	                x.domain()[0] ?
	                    x.domain([x.domain()[0] - x.domain()[0] * 0.01, x.domain()[1] + x.domain()[1] * 0.01])
	                    : x.domain([-1,1]);
	
	            if (y.domain()[0] === y.domain()[1])
	                y.domain()[0] ?
	                    y.domain([y.domain()[0] - y.domain()[0] * 0.01, y.domain()[1] + y.domain()[1] * 0.01])
	                    : y.domain([-1,1]);
	
	            if ( isNaN(x.domain()[0])) {
	                x.domain([-1,1]);
	            }
	
	            if ( isNaN(y.domain()[0])) {
	                y.domain([-1,1]);
	            }
	
	            x0 = x0 || x;
	            y0 = y0 || y;
	            z0 = z0 || z;
	
	            var scaleDiff = x(1) !== x0(1) || y(1) !== y0(1) || z(1) !== z0(1);
	
	            width0 = width0 || width;
	            height0 = height0 || height;
	
	            var sizeDiff = width0 !== width || height0 !== height;
	
	            // Domain Diffs
	
	            xDom = xDom || [];
	            var domainDiff = xDom[0] !== x.domain()[0] || xDom[1] !== x.domain()[1];
	            xDom = x.domain();
	
	            yDom = yDom || [];
	            domainDiff = domainDiff || yDom[0] !== y.domain()[0] || yDom[1] !== y.domain()[1];
	            yDom = y.domain();
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-scatter').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-scatter nv-chart-' + id);
	            var defsEnter = wrapEnter.append('defs');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            wrap.classed('nv-single-point', singlePoint);
	            gEnter.append('g').attr('class', 'nv-groups');
	            gEnter.append('g').attr('class', 'nv-point-paths');
	            wrapEnter.append('g').attr('class', 'nv-point-clips');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            defsEnter.append('clipPath')
	                .attr('id', 'nv-edge-clip-' + id)
	                .append('rect')
	                .attr('transform', 'translate( -10, -10)');
	
	            wrap.select('#nv-edge-clip-' + id + ' rect')
	                .attr('width', availableWidth + 20)
	                .attr('height', (availableHeight > 0) ? availableHeight + 20 : 0);
	
	            g.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + id + ')' : '');
	
	            function updateInteractiveLayer() {
	                // Always clear needs-update flag regardless of whether or not
	                // we will actually do anything (avoids needless invocations).
	                needsUpdate = false;
	
	                if (!interactive) return false;
	
	                // inject series and point index for reference into voronoi
	                if (useVoronoi === true) {
	
	                    // nuke all voronoi paths on reload and recreate them
	                    wrap.select('.nv-point-paths').selectAll('path').remove();
	
	                    var vertices = d3.merge(data.map(function(group, groupIndex) {
	                            return group.values
	                                .map(function(point, pointIndex) {
	                                    // *Adding noise to make duplicates very unlikely
	                                    // *Injecting series and point index for reference
	                                    // *Adding a 'jitter' to the points, because there's an issue in d3.geom.voronoi.
	                                    var pX = getX(point,pointIndex);
	                                    var pY = getY(point,pointIndex);
	
	                                    return [nv.utils.NaNtoZero(x(pX)) + Math.random() * 1e-4,
	                                            nv.utils.NaNtoZero(y(pY)) + Math.random() * 1e-4,
	                                        groupIndex,
	                                        pointIndex, point];
	                                })
	                                .filter(function(pointArray, pointIndex) {
	                                    return pointActive(pointArray[4], pointIndex); // Issue #237.. move filter to after map, so pointIndex is correct!
	                                })
	                        })
	                    );
	
	                    if (vertices.length == 0) return false;  // No active points, we're done
	                    if (vertices.length < 3) {
	                        // Issue #283 - Adding 2 dummy points to the voronoi b/c voronoi requires min 3 points to work
	                        vertices.push([x.range()[0] - 20, y.range()[0] - 20, null, null]);
	                        vertices.push([x.range()[1] + 20, y.range()[1] + 20, null, null]);
	                        vertices.push([x.range()[0] - 20, y.range()[0] + 20, null, null]);
	                        vertices.push([x.range()[1] + 20, y.range()[1] - 20, null, null]);
	                    }
	
	                    // keep voronoi sections from going more than 10 outside of graph
	                    // to avoid overlap with other things like legend etc
	                    var bounds = d3.geom.polygon([
	                        [-10,-10],
	                        [-10,height + 10],
	                        [width + 10,height + 10],
	                        [width + 10,-10]
	                    ]);
	
	                    // delete duplicates from vertices - essential assumption for d3.geom.voronoi
	                    var epsilon = 1e-4; // Uses 1e-4 to determine equivalence.
	                    vertices = vertices.sort(function(a,b){return ((a[0] - b[0]) || (a[1] - b[1]))});
	                    for (var i = 0; i < vertices.length - 1; ) {
	                        if ((Math.abs(vertices[i][0] - vertices[i+1][0]) < epsilon) &&
	                        (Math.abs(vertices[i][1] - vertices[i+1][1]) < epsilon)) {
	                            vertices.splice(i+1, 1);
	                        } else {
	                            i++;
	                        }
	                    }
	
	                    var voronoi = d3.geom.voronoi(vertices).map(function(d, i) {
	                        return {
	                            'data': bounds.clip(d),
	                            'series': vertices[i][2],
	                            'point': vertices[i][3]
	                        }
	                    });
	
	                    var pointPaths = wrap.select('.nv-point-paths').selectAll('path').data(voronoi);
	                    var vPointPaths = pointPaths
	                        .enter().append("svg:path")
	                        .attr("d", function(d) {
	                            if (!d || !d.data || d.data.length === 0)
	                                return 'M 0 0';
	                            else
	                                return "M" + d.data.join(",") + "Z";
	                        })
	                        .attr("id", function(d,i) {
	                            return "nv-path-"+i; })
	                        .attr("clip-path", function(d,i) { return "url(#nv-clip-"+id+"-"+i+")"; })
	                        ;
	
	                    // good for debugging point hover issues
	                    if (showVoronoi) {
	                        vPointPaths.style("fill", d3.rgb(230, 230, 230))
	                            .style('fill-opacity', 0.4)
	                            .style('stroke-opacity', 1)
	                            .style("stroke", d3.rgb(200,200,200));
	                    }
	
	                    if (clipVoronoi) {
	                        // voronoi sections are already set to clip,
	                        // just create the circles with the IDs they expect
	                        wrap.select('.nv-point-clips').selectAll('*').remove(); // must do * since it has sub-dom
	                        var pointClips = wrap.select('.nv-point-clips').selectAll('clipPath').data(vertices);
	                        var vPointClips = pointClips
	                            .enter().append("svg:clipPath")
	                            .attr("id", function(d, i) { return "nv-clip-"+id+"-"+i;})
	                            .append("svg:circle")
	                            .attr('cx', function(d) { return d[0]; })
	                            .attr('cy', function(d) { return d[1]; })
	                            .attr('r', clipRadius);
	                    }
	
	                    var mouseEventCallback = function(el, d, mDispatch) {
	                        if (needsUpdate) return 0;
	                        var series = data[d.series];
	                        if (series === undefined) return;
	                        var point  = series.values[d.point];
	                        point['color'] = color(series, d.series);
	
	                        // standardize attributes for tooltip.
	                        point['x'] = getX(point);
	                        point['y'] = getY(point);
	
	                        // can't just get box of event node since it's actually a voronoi polygon
	                        var box = container.node().getBoundingClientRect();
	                        var scrollTop  = window.pageYOffset || document.documentElement.scrollTop;
	                        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
	
	                        var pos = {
	                            left: x(getX(point, d.point)) + box.left + scrollLeft + margin.left + 10,
	                            top: y(getY(point, d.point)) + box.top + scrollTop + margin.top + 10
	                        };
	
	                        mDispatch({
	                            point: point,
	                            series: series,
	                            pos: pos,
	                            relativePos: [x(getX(point, d.point)) + margin.left, y(getY(point, d.point)) + margin.top],
	                            seriesIndex: d.series,
	                            pointIndex: d.point,
	                            event: d3.event,
	                            element: el
	                        });
	                    };
	
	                    pointPaths
	                        .on('click', function(d) {
	                            mouseEventCallback(this, d, dispatch.elementClick);
	                        })
	                        .on('dblclick', function(d) {
	                            mouseEventCallback(this, d, dispatch.elementDblClick);
	                        })
	                        .on('mouseover', function(d) {
	                            mouseEventCallback(this, d, dispatch.elementMouseover);
	                        })
	                        .on('mouseout', function(d, i) {
	                            mouseEventCallback(this, d, dispatch.elementMouseout);
	                        });
	
	                } else {
	                    // add event handlers to points instead voronoi paths
	                    wrap.select('.nv-groups').selectAll('.nv-group')
	                        .selectAll('.nv-point')
	                        //.data(dataWithPoints)
	                        //.style('pointer-events', 'auto') // recativate events, disabled by css
	                        .on('click', function(d,i) {
	                            //nv.log('test', d, i);
	                            if (needsUpdate || !data[d.series]) return 0; //check if this is a dummy point
	                            var series = data[d.series],
	                                point  = series.values[i];
	                            var element = this;
	                            dispatch.elementClick({
	                                point: point,
	                                series: series,
	                                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top], //TODO: make this pos base on the page
	                                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
	                                seriesIndex: d.series,
	                                pointIndex: i,
	                                event: d3.event,
	                                element: element
	                            });
	                        })
	                        .on('dblclick', function(d,i) {
	                            if (needsUpdate || !data[d.series]) return 0; //check if this is a dummy point
	                            var series = data[d.series],
	                                point  = series.values[i];
	
	                            dispatch.elementDblClick({
	                                point: point,
	                                series: series,
	                                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],//TODO: make this pos base on the page
	                                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
	                                seriesIndex: d.series,
	                                pointIndex: i
	                            });
	                        })
	                        .on('mouseover', function(d,i) {
	                            if (needsUpdate || !data[d.series]) return 0; //check if this is a dummy point
	                            var series = data[d.series],
	                                point  = series.values[i];
	
	                            dispatch.elementMouseover({
	                                point: point,
	                                series: series,
	                                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],//TODO: make this pos base on the page
	                                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
	                                seriesIndex: d.series,
	                                pointIndex: i,
	                                color: color(d, i)
	                            });
	                        })
	                        .on('mouseout', function(d,i) {
	                            if (needsUpdate || !data[d.series]) return 0; //check if this is a dummy point
	                            var series = data[d.series],
	                                point  = series.values[i];
	
	                            dispatch.elementMouseout({
	                                point: point,
	                                series: series,
	                                pos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],//TODO: make this pos base on the page
	                                relativePos: [x(getX(point, i)) + margin.left, y(getY(point, i)) + margin.top],
	                                seriesIndex: d.series,
	                                pointIndex: i,
	                                color: color(d, i)
	                            });
	                        });
	                }
	            }
	
	            needsUpdate = true;
	            var groups = wrap.select('.nv-groups').selectAll('.nv-group')
	                .data(function(d) { return d }, function(d) { return d.key });
	            groups.enter().append('g')
	                .style('stroke-opacity', 1e-6)
	                .style('fill-opacity', 1e-6);
	            groups.exit()
	                .remove();
	            groups
	                .attr('class', function(d,i) {
	                    return (d.classed || '') + ' nv-group nv-series-' + i;
	                })
	                .classed('nv-noninteractive', !interactive)
	                .classed('hover', function(d) { return d.hover });
	            groups.watchTransition(renderWatch, 'scatter: groups')
	                .style('fill', function(d,i) { return color(d, i) })
	                .style('stroke', function(d,i) { return d.pointBorderColor || pointBorderColor || color(d, i) })
	                .style('stroke-opacity', 1)
	                .style('fill-opacity', .5);
	
	            // create the points, maintaining their IDs from the original data set
	            var points = groups.selectAll('path.nv-point')
	                .data(function(d) {
	                    return d.values.map(
	                        function (point, pointIndex) {
	                            return [point, pointIndex]
	                        }).filter(
	                            function(pointArray, pointIndex) {
	                                return pointActive(pointArray[0], pointIndex)
	                            })
	                    });
	            points.enter().append('path')
	                .attr('class', function (d) {
	                    return 'nv-point nv-point-' + d[1];
	                })
	                .style('fill', function (d) { return d.color })
	                .style('stroke', function (d) { return d.color })
	                .attr('transform', function(d) {
	                    return 'translate(' + nv.utils.NaNtoZero(x0(getX(d[0],d[1]))) + ',' + nv.utils.NaNtoZero(y0(getY(d[0],d[1]))) + ')'
	                })
	                .attr('d',
	                    nv.utils.symbol()
	                    .type(function(d) { return getShape(d[0]); })
	                    .size(function(d) { return z(getSize(d[0],d[1])) })
	            );
	            points.exit().each(delCache).remove();
	            groups.exit().selectAll('path.nv-point')
	                .watchTransition(renderWatch, 'scatter exit')
	                .attr('transform', function(d) {
	                    return 'translate(' + nv.utils.NaNtoZero(x(getX(d[0],d[1]))) + ',' + nv.utils.NaNtoZero(y(getY(d[0],d[1]))) + ')'
	                })
	                .remove();
	
	            //============================================================
	            // Point Update Optimisation Notes
	            //------------------------------------------------------------
	            // The following update selections are filtered with getDiffs
	            // (defined at the top of this file) this brings a performance
	            // benefit for charts with large data sets that accumulate a
	            // subset of changes or additions over time.
	            //
	            // Uneccesary and expensive DOM calls are avoided by culling
	            // unchanged points from the selection in exchange for the
	            // cheaper overhead of caching and diffing each point first.
	            //
	            // Due to the way D3 and NVD3 work, other global changes need
	            // to be considered in addition to local point properties.
	            // This is a potential source of bugs (if any of the global
	            // changes that possibly affect points are missed).
	
	            // Update Point Positions [x, y]
	            points.filter(function (d) {
	                // getDiffs must always be called to update cache
	                return getDiffs(d, 'x', getX, 'y', getY) ||
	                    scaleDiff || sizeDiff || domainDiff;
	            })
	            .watchTransition(renderWatch, 'scatter points')
	            .attr('transform', function (d) {
	                return 'translate(' +
	                    nv.utils.NaNtoZero(x(getX(d[0], d[1]))) + ',' +
	                    nv.utils.NaNtoZero(y(getY(d[0], d[1]))) + ')'
	            });
	
	            // Update Point Appearance [shape, size]
	            points.filter(function (d) {
	                // getDiffs must always be called to update cache
	                return getDiffs(d, 'shape', getShape, 'size', getSize) ||
	                    scaleDiff || sizeDiff || domainDiff;
	            })
	            .watchTransition(renderWatch, 'scatter points')
	            .attr('d', nv.utils.symbol()
	                .type(function (d) { return getShape(d[0]) })
	                .size(function (d) { return z(getSize(d[0], d[1])) })
	            );
	
	            // add label a label to scatter chart
	            if(showLabels)
	            {
	                var titles =  groups.selectAll('.nv-label')
	                    .data(function(d) {
	                        return d.values.map(
	                            function (point, pointIndex) {
	                                return [point, pointIndex]
	                            }).filter(
	                                function(pointArray, pointIndex) {
	                                    return pointActive(pointArray[0], pointIndex)
	                                })
	                        });
	
	                titles.enter().append('text')
	                    .style('fill', function (d,i) {
	                        return d.color })
	                    .style('stroke-opacity', 0)
	                    .style('fill-opacity', 1)
	                    .attr('transform', function(d) {
	                        var dx = nv.utils.NaNtoZero(x0(getX(d[0],d[1]))) + Math.sqrt(z(getSize(d[0],d[1]))/Math.PI) + 2;
	                        return 'translate(' + dx + ',' + nv.utils.NaNtoZero(y0(getY(d[0],d[1]))) + ')';
	                    })
	                    .text(function(d,i){
	                        return d[0].label;});
	
	                titles.exit().remove();
	                groups.exit().selectAll('path.nv-label')
	                    .watchTransition(renderWatch, 'scatter exit')
	                    .attr('transform', function(d) {
	                        var dx = nv.utils.NaNtoZero(x(getX(d[0],d[1])))+ Math.sqrt(z(getSize(d[0],d[1]))/Math.PI)+2;
	                        return 'translate(' + dx + ',' + nv.utils.NaNtoZero(y(getY(d[0],d[1]))) + ')';
	                    })
	                    .remove();
	               titles.each(function(d) {
	                  d3.select(this)
	                    .classed('nv-label', true)
	                    .classed('nv-label-' + d[1], false)
	                    .classed('hover',false);
	                });
	                titles.watchTransition(renderWatch, 'scatter labels')
	                    .attr('transform', function(d) {
	                        var dx = nv.utils.NaNtoZero(x(getX(d[0],d[1])))+ Math.sqrt(z(getSize(d[0],d[1]))/Math.PI)+2;
	                        return 'translate(' + dx + ',' + nv.utils.NaNtoZero(y(getY(d[0],d[1]))) + ')'
	                    });
	            }
	
	            // Delay updating the invisible interactive layer for smoother animation
	            if( interactiveUpdateDelay )
	            {
	                clearTimeout(timeoutID); // stop repeat calls to updateInteractiveLayer
	                timeoutID = setTimeout(updateInteractiveLayer, interactiveUpdateDelay );
	            }
	            else
	            {
	                updateInteractiveLayer();
	            }
	
	            //store old scales for use in transitions on update
	            x0 = x.copy();
	            y0 = y.copy();
	            z0 = z.copy();
	
	            width0 = width;
	            height0 = height;
	
	        });
	        renderWatch.renderEnd('scatter immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    // utility function calls provided by this chart
	    chart._calls = new function() {
	        this.clearHighlights = function () {
	            nv.dom.write(function() {
	                container.selectAll(".nv-point.hover").classed("hover", false);
	            });
	            return null;
	        };
	        this.highlightPoint = function (seriesIndex, pointIndex, isHoverOver) {
	            nv.dom.write(function() {
	                container.select('.nv-groups')
	                  .selectAll(".nv-series-" + seriesIndex)
	                  .selectAll(".nv-point-" + pointIndex)
	                  .classed("hover", isHoverOver);
	            });
	        };
	    };
	
	    // trigger calls from events too
	    dispatch.on('elementMouseover.point', function(d) {
	        if (interactive) chart._calls.highlightPoint(d.seriesIndex,d.pointIndex,true);
	    });
	
	    dispatch.on('elementMouseout.point', function(d) {
	        if (interactive) chart._calls.highlightPoint(d.seriesIndex,d.pointIndex,false);
	    });
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:        {get: function(){return width;}, set: function(_){width=_;}},
	        height:       {get: function(){return height;}, set: function(_){height=_;}},
	        xScale:       {get: function(){return x;}, set: function(_){x=_;}},
	        yScale:       {get: function(){return y;}, set: function(_){y=_;}},
	        pointScale:   {get: function(){return z;}, set: function(_){z=_;}},
	        xDomain:      {get: function(){return xDomain;}, set: function(_){xDomain=_;}},
	        yDomain:      {get: function(){return yDomain;}, set: function(_){yDomain=_;}},
	        pointDomain:  {get: function(){return sizeDomain;}, set: function(_){sizeDomain=_;}},
	        xRange:       {get: function(){return xRange;}, set: function(_){xRange=_;}},
	        yRange:       {get: function(){return yRange;}, set: function(_){yRange=_;}},
	        pointRange:   {get: function(){return sizeRange;}, set: function(_){sizeRange=_;}},
	        forceX:       {get: function(){return forceX;}, set: function(_){forceX=_;}},
	        forceY:       {get: function(){return forceY;}, set: function(_){forceY=_;}},
	        forcePoint:   {get: function(){return forceSize;}, set: function(_){forceSize=_;}},
	        interactive:  {get: function(){return interactive;}, set: function(_){interactive=_;}},
	        pointActive:  {get: function(){return pointActive;}, set: function(_){pointActive=_;}},
	        padDataOuter: {get: function(){return padDataOuter;}, set: function(_){padDataOuter=_;}},
	        padData:      {get: function(){return padData;}, set: function(_){padData=_;}},
	        clipEdge:     {get: function(){return clipEdge;}, set: function(_){clipEdge=_;}},
	        clipVoronoi:  {get: function(){return clipVoronoi;}, set: function(_){clipVoronoi=_;}},
	        clipRadius:   {get: function(){return clipRadius;}, set: function(_){clipRadius=_;}},
	        showVoronoi:   {get: function(){return showVoronoi;}, set: function(_){showVoronoi=_;}},
	        id:           {get: function(){return id;}, set: function(_){id=_;}},
	        interactiveUpdateDelay: {get:function(){return interactiveUpdateDelay;}, set: function(_){interactiveUpdateDelay=_;}},
	        showLabels: {get: function(){return showLabels;}, set: function(_){ showLabels = _;}},
	        pointBorderColor: {get: function(){return pointBorderColor;}, set: function(_){pointBorderColor=_;}},
	
	        // simple functor options
	        x:     {get: function(){return getX;}, set: function(_){getX = d3.functor(_);}},
	        y:     {get: function(){return getY;}, set: function(_){getY = d3.functor(_);}},
	        pointSize: {get: function(){return getSize;}, set: function(_){getSize = d3.functor(_);}},
	        pointShape: {get: function(){return getShape;}, set: function(_){getShape = d3.functor(_);}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	        }},
	        color: {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }},
	        useVoronoi: {get: function(){return useVoronoi;}, set: function(_){
	            useVoronoi = _;
	            if (useVoronoi === false) {
	                clipVoronoi = false;
	            }
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	    return chart;
	};
	
	nv.models.scatterChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var scatter      = nv.models.scatter()
	        , xAxis        = nv.models.axis()
	        , yAxis        = nv.models.axis()
	        , legend       = nv.models.legend()
	        , distX        = nv.models.distribution()
	        , distY        = nv.models.distribution()
	        , tooltip      = nv.models.tooltip()
	        ;
	
	    var margin       = {top: 30, right: 20, bottom: 50, left: 75}
	        , marginTop = null
	        , width        = null
	        , height       = null
	        , container    = null
	        , color        = nv.utils.defaultColor()
	        , x            = scatter.xScale()
	        , y            = scatter.yScale()
	        , showDistX    = false
	        , showDistY    = false
	        , showLegend   = true
	        , showXAxis    = true
	        , showYAxis    = true
	        , rightAlignYAxis = false
	        , state = nv.utils.state()
	        , defaultState = null
	        , dispatch = d3.dispatch('stateChange', 'changeState', 'renderEnd')
	        , noData       = null
	        , duration = 250
	        , showLabels    = false
	        ;
	
	    scatter.xScale(x).yScale(y);
	    xAxis.orient('bottom').tickPadding(10);
	    yAxis
	        .orient((rightAlignYAxis) ? 'right' : 'left')
	        .tickPadding(10)
	    ;
	    distX.axis('x');
	    distY.axis('y');
	    tooltip
	        .headerFormatter(function(d, i) {
	            return xAxis.tickFormat()(d, i);
	        })
	        .valueFormatter(function(d, i) {
	            return yAxis.tickFormat()(d, i);
	        });
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var x0, y0
	        , renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    var stateGetter = function(data) {
	        return function(){
	            return {
	                active: data.map(function(d) { return !d.disabled })
	            };
	        }
	    };
	
	    var stateSetter = function(data) {
	        return function(state) {
	            if (state.active !== undefined)
	                data.forEach(function(series,i) {
	                    series.disabled = !state.active[i];
	                });
	        }
	    };
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(scatter);
	        if (showXAxis) renderWatch.models(xAxis);
	        if (showYAxis) renderWatch.models(yAxis);
	        if (showDistX) renderWatch.models(distX);
	        if (showDistY) renderWatch.models(distY);
	
	        selection.each(function(data) {
	            var that = this;
	
	            container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            chart.update = function() {
	                if (duration === 0)
	                    container.call(chart);
	                else
	                    container.transition().duration(duration).call(chart);
	            };
	            chart.container = this;
	
	            state
	                .setter(stateSetter(data), chart.update)
	                .getter(stateGetter(data))
	                .update();
	
	            // DEPRECATED set state.disableddisabled
	            state.disabled = data.map(function(d) { return !!d.disabled });
	
	            if (!defaultState) {
	                var key;
	                defaultState = {};
	                for (key in state) {
	                    if (state[key] instanceof Array)
	                        defaultState[key] = state[key].slice(0);
	                    else
	                        defaultState[key] = state[key];
	                }
	            }
	
	            // Display noData message if there's nothing to show.
	            if (!data || !data.length || !data.filter(function(d) { return d.values.length }).length) {
	                nv.utils.noData(chart, container);
	                renderWatch.renderEnd('scatter immediate');
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            // Setup Scales
	            x = scatter.xScale();
	            y = scatter.yScale();
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-scatterChart').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-scatterChart nv-chart-' + scatter.id());
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            // background for pointer events
	            gEnter.append('rect').attr('class', 'nvd3 nv-background').style("pointer-events","none");
	
	            gEnter.append('g').attr('class', 'nv-x nv-axis');
	            gEnter.append('g').attr('class', 'nv-y nv-axis');
	            gEnter.append('g').attr('class', 'nv-scatterWrap');
	            gEnter.append('g').attr('class', 'nv-regressionLinesWrap');
	            gEnter.append('g').attr('class', 'nv-distWrap');
	            gEnter.append('g').attr('class', 'nv-legendWrap');
	
	            if (rightAlignYAxis) {
	                g.select(".nv-y.nv-axis")
	                    .attr("transform", "translate(" + availableWidth + ",0)");
	            }
	
	            // Legend
	            if (!showLegend) {
	                g.select('.nv-legendWrap').selectAll('*').remove();
	            } else {
	                var legendWidth = availableWidth;
	                legend.width(legendWidth);
	
	                wrap.select('.nv-legendWrap')
	                    .datum(data)
	                    .call(legend);
	
	                if (!marginTop && legend.height() !== margin.top) {
	                    margin.top = legend.height();
	                    availableHeight = nv.utils.availableHeight(height, container, margin);
	                }
	
	                wrap.select('.nv-legendWrap')
	                    .attr('transform', 'translate(0' + ',' + (-margin.top) +')');
	            }
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            // Main Chart Component(s)
	            scatter
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(data.map(function(d,i) {
	                    d.color = d.color || color(d, i);
	                    return d.color;
	                }).filter(function(d,i) { return !data[i].disabled }))
	                .showLabels(showLabels);
	
	            wrap.select('.nv-scatterWrap')
	                .datum(data.filter(function(d) { return !d.disabled }))
	                .call(scatter);
	
	
	            wrap.select('.nv-regressionLinesWrap')
	                .attr('clip-path', 'url(#nv-edge-clip-' + scatter.id() + ')');
	
	            var regWrap = wrap.select('.nv-regressionLinesWrap').selectAll('.nv-regLines')
	                .data(function (d) {
	                    return d;
	                });
	
	            regWrap.enter().append('g').attr('class', 'nv-regLines');
	
	            var regLine = regWrap.selectAll('.nv-regLine')
	                .data(function (d) {
	                    return [d]
	                });
	
	            regLine.enter()
	                .append('line').attr('class', 'nv-regLine')
	                .style('stroke-opacity', 0);
	
	            // don't add lines unless we have slope and intercept to use
	            regLine.filter(function(d) {
	                return d.intercept && d.slope;
	            })
	                .watchTransition(renderWatch, 'scatterPlusLineChart: regline')
	                .attr('x1', x.range()[0])
	                .attr('x2', x.range()[1])
	                .attr('y1', function (d, i) {
	                    return y(x.domain()[0] * d.slope + d.intercept)
	                })
	                .attr('y2', function (d, i) {
	                    return y(x.domain()[1] * d.slope + d.intercept)
	                })
	                .style('stroke', function (d, i, j) {
	                    return color(d, j)
	                })
	                .style('stroke-opacity', function (d, i) {
	                    return (d.disabled || typeof d.slope === 'undefined' || typeof d.intercept === 'undefined') ? 0 : 1
	                });
	
	            // Setup Axes
	            if (showXAxis) {
	                xAxis
	                    .scale(x)
	                    ._ticks( nv.utils.calcTicksX(availableWidth/100, data) )
	                    .tickSize( -availableHeight , 0);
	
	                g.select('.nv-x.nv-axis')
	                    .attr('transform', 'translate(0,' + y.range()[0] + ')')
	                    .call(xAxis);
	            }
	
	            if (showYAxis) {
	                yAxis
	                    .scale(y)
	                    ._ticks( nv.utils.calcTicksY(availableHeight/36, data) )
	                    .tickSize( -availableWidth, 0);
	
	                g.select('.nv-y.nv-axis')
	                    .call(yAxis);
	            }
	
	            // Setup Distribution
	            if (showDistX) {
	                distX
	                    .getData(scatter.x())
	                    .scale(x)
	                    .width(availableWidth)
	                    .color(data.map(function(d,i) {
	                        return d.color || color(d, i);
	                    }).filter(function(d,i) { return !data[i].disabled }));
	                gEnter.select('.nv-distWrap').append('g')
	                    .attr('class', 'nv-distributionX');
	                g.select('.nv-distributionX')
	                    .attr('transform', 'translate(0,' + y.range()[0] + ')')
	                    .datum(data.filter(function(d) { return !d.disabled }))
	                    .call(distX);
	            }
	
	            if (showDistY) {
	                distY
	                    .getData(scatter.y())
	                    .scale(y)
	                    .width(availableHeight)
	                    .color(data.map(function(d,i) {
	                        return d.color || color(d, i);
	                    }).filter(function(d,i) { return !data[i].disabled }));
	                gEnter.select('.nv-distWrap').append('g')
	                    .attr('class', 'nv-distributionY');
	                g.select('.nv-distributionY')
	                    .attr('transform', 'translate(' + (rightAlignYAxis ? availableWidth : -distY.size() ) + ',0)')
	                    .datum(data.filter(function(d) { return !d.disabled }))
	                    .call(distY);
	            }
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            legend.dispatch.on('stateChange', function(newState) {
	                for (var key in newState)
	                    state[key] = newState[key];
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            // Update chart from a state object passed to event handler
	            dispatch.on('changeState', function(e) {
	                if (typeof e.disabled !== 'undefined') {
	                    data.forEach(function(series,i) {
	                        series.disabled = e.disabled[i];
	                    });
	                    state.disabled = e.disabled;
	                }
	                chart.update();
	            });
	
	            // mouseover needs availableHeight so we just keep scatter mouse events inside the chart block
	            scatter.dispatch.on('elementMouseout.tooltip', function(evt) {
	                tooltip.hidden(true);
	                container.select('.nv-chart-' + scatter.id() + ' .nv-series-' + evt.seriesIndex + ' .nv-distx-' + evt.pointIndex)
	                    .attr('y1', 0);
	                container.select('.nv-chart-' + scatter.id() + ' .nv-series-' + evt.seriesIndex + ' .nv-disty-' + evt.pointIndex)
	                    .attr('x2', distY.size());
	            });
	
	            scatter.dispatch.on('elementMouseover.tooltip', function(evt) {
	                container.select('.nv-series-' + evt.seriesIndex + ' .nv-distx-' + evt.pointIndex)
	                    .attr('y1', evt.relativePos[1] - availableHeight);
	                container.select('.nv-series-' + evt.seriesIndex + ' .nv-disty-' + evt.pointIndex)
	                    .attr('x2', evt.relativePos[0] + distX.size());
	                tooltip.data(evt).hidden(false);
	            });
	
	            //store old scales for use in transitions on update
	            x0 = x.copy();
	            y0 = y.copy();
	
	        });
	
	        renderWatch.renderEnd('scatter with line immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.scatter = scatter;
	    chart.legend = legend;
	    chart.xAxis = xAxis;
	    chart.yAxis = yAxis;
	    chart.distX = distX;
	    chart.distY = distY;
	    chart.tooltip = tooltip;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        container:  {get: function(){return container;}, set: function(_){container=_;}},
	        showDistX:  {get: function(){return showDistX;}, set: function(_){showDistX=_;}},
	        showDistY:  {get: function(){return showDistY;}, set: function(_){showDistY=_;}},
	        showLegend: {get: function(){return showLegend;}, set: function(_){showLegend=_;}},
	        showXAxis:  {get: function(){return showXAxis;}, set: function(_){showXAxis=_;}},
	        showYAxis:  {get: function(){return showYAxis;}, set: function(_){showYAxis=_;}},
	        defaultState:     {get: function(){return defaultState;}, set: function(_){defaultState=_;}},
	        noData:     {get: function(){return noData;}, set: function(_){noData=_;}},
	        duration:   {get: function(){return duration;}, set: function(_){duration=_;}},
	        showLabels: {get: function(){return showLabels;}, set: function(_){showLabels=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        rightAlignYAxis: {get: function(){return rightAlignYAxis;}, set: function(_){
	            rightAlignYAxis = _;
	            yAxis.orient( (_) ? 'right' : 'left');
	        }},
	        color: {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            legend.color(color);
	            distX.color(color);
	            distY.color(color);
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, scatter);
	    nv.utils.initOptions(chart);
	    return chart;
	};
	
	nv.models.sparkline = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 2, right: 0, bottom: 2, left: 0}
	        , width = 400
	        , height = 32
	        , container = null
	        , animate = true
	        , x = d3.scale.linear()
	        , y = d3.scale.linear()
	        , getX = function(d) { return d.x }
	        , getY = function(d) { return d.y }
	        , color = nv.utils.getColor(['#000'])
	        , xDomain
	        , yDomain
	        , xRange
	        , yRange
	        , showMinMaxPoints = true
	        , showCurrentPoint = true
	        , dispatch = d3.dispatch('renderEnd')
	        ;
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch);
	    
	    function chart(selection) {
	        renderWatch.reset();
	        selection.each(function(data) {
	            var availableWidth = width - margin.left - margin.right,
	                availableHeight = height - margin.top - margin.bottom;
	
	            container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            // Setup Scales
	            x   .domain(xDomain || d3.extent(data, getX ))
	                .range(xRange || [0, availableWidth]);
	
	            y   .domain(yDomain || d3.extent(data, getY ))
	                .range(yRange || [availableHeight, 0]);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-sparkline').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-sparkline');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')')
	
	            var paths = wrap.selectAll('path')
	                .data(function(d) { return [d] });
	            paths.enter().append('path');
	            paths.exit().remove();
	            paths
	                .style('stroke', function(d,i) { return d.color || color(d, i) })
	                .attr('d', d3.svg.line()
	                    .x(function(d,i) { return x(getX(d,i)) })
	                    .y(function(d,i) { return y(getY(d,i)) })
	            );
	
	            // TODO: Add CURRENT data point (Need Min, Mac, Current / Most recent)
	            var points = wrap.selectAll('circle.nv-point')
	                .data(function(data) {
	                    var yValues = data.map(function(d, i) { return getY(d,i); });
	                    function pointIndex(index) {
	                        if (index != -1) {
	                            var result = data[index];
	                            result.pointIndex = index;
	                            return result;
	                        } else {
	                            return null;
	                        }
	                    }
	                    var maxPoint = pointIndex(yValues.lastIndexOf(y.domain()[1])),
	                        minPoint = pointIndex(yValues.indexOf(y.domain()[0])),
	                        currentPoint = pointIndex(yValues.length - 1);
	                    return [(showMinMaxPoints ? minPoint : null), (showMinMaxPoints ? maxPoint : null), (showCurrentPoint ? currentPoint : null)].filter(function (d) {return d != null;});
	                });
	            points.enter().append('circle');
	            points.exit().remove();
	            points
	                .attr('cx', function(d,i) { return x(getX(d,d.pointIndex)) })
	                .attr('cy', function(d,i) { return y(getY(d,d.pointIndex)) })
	                .attr('r', 2)
	                .attr('class', function(d,i) {
	                    return getX(d, d.pointIndex) == x.domain()[1] ? 'nv-point nv-currentValue' :
	                            getY(d, d.pointIndex) == y.domain()[0] ? 'nv-point nv-minValue' : 'nv-point nv-maxValue'
	                });
	        });
	        
	        renderWatch.renderEnd('sparkline immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:            {get: function(){return width;}, set: function(_){width=_;}},
	        height:           {get: function(){return height;}, set: function(_){height=_;}},
	        xDomain:          {get: function(){return xDomain;}, set: function(_){xDomain=_;}},
	        yDomain:          {get: function(){return yDomain;}, set: function(_){yDomain=_;}},
	        xRange:           {get: function(){return xRange;}, set: function(_){xRange=_;}},
	        yRange:           {get: function(){return yRange;}, set: function(_){yRange=_;}},
	        xScale:           {get: function(){return x;}, set: function(_){x=_;}},
	        yScale:           {get: function(){return y;}, set: function(_){y=_;}},
	        animate:          {get: function(){return animate;}, set: function(_){animate=_;}},
	        showMinMaxPoints: {get: function(){return showMinMaxPoints;}, set: function(_){showMinMaxPoints=_;}},
	        showCurrentPoint: {get: function(){return showCurrentPoint;}, set: function(_){showCurrentPoint=_;}},
	
	        //functor options
	        x: {get: function(){return getX;}, set: function(_){getX=d3.functor(_);}},
	        y: {get: function(){return getY;}, set: function(_){getY=d3.functor(_);}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }}
	    });
	
	    chart.dispatch = dispatch;
	    nv.utils.initOptions(chart);
	    return chart;
	};
	
	nv.models.sparklinePlus = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var sparkline = nv.models.sparkline();
	
	    var margin = {top: 15, right: 100, bottom: 10, left: 50}
	        , width = null
	        , height = null
	        , x
	        , y
	        , index = []
	        , paused = false
	        , xTickFormat = d3.format(',r')
	        , yTickFormat = d3.format(',.2f')
	        , showLastValue = true
	        , alignValue = true
	        , rightAlignValue = false
	        , noData = null
	        , dispatch = d3.dispatch('renderEnd')
	        ;
	        
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch);
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(sparkline);
	        selection.each(function(data) {
	            var container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            chart.update = function() { container.call(chart); };
	            chart.container = this;
	
	            // Display No Data message if there's nothing to show.
	            if (!data || !data.length) {
	                nv.utils.noData(chart, container)
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            var currentValue = sparkline.y()(data[data.length-1], data.length-1);
	
	            // Setup Scales
	            x = sparkline.xScale();
	            y = sparkline.yScale();
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-sparklineplus').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-sparklineplus');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-sparklineWrap');
	            gEnter.append('g').attr('class', 'nv-valueWrap');
	            gEnter.append('g').attr('class', 'nv-hoverArea');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            // Main Chart Component(s)
	            var sparklineWrap = g.select('.nv-sparklineWrap');
	
	            sparkline.width(availableWidth).height(availableHeight);
	            sparklineWrap.call(sparkline);
	
	            if (showLastValue) {
	                var valueWrap = g.select('.nv-valueWrap');
	                var value = valueWrap.selectAll('.nv-currentValue')
	                    .data([currentValue]);
	
	                value.enter().append('text').attr('class', 'nv-currentValue')
	                    .attr('dx', rightAlignValue ? -8 : 8)
	                    .attr('dy', '.9em')
	                    .style('text-anchor', rightAlignValue ? 'end' : 'start');
	
	                value
	                    .attr('x', availableWidth + (rightAlignValue ? margin.right : 0))
	                    .attr('y', alignValue ? function (d) {
	                        return y(d)
	                    } : 0)
	                    .style('fill', sparkline.color()(data[data.length - 1], data.length - 1))
	                    .text(yTickFormat(currentValue));
	            }
	
	            gEnter.select('.nv-hoverArea').append('rect')
	                .on('mousemove', sparklineHover)
	                .on('click', function() { paused = !paused })
	                .on('mouseout', function() { index = []; updateValueLine(); });
	
	            g.select('.nv-hoverArea rect')
	                .attr('transform', function(d) { return 'translate(' + -margin.left + ',' + -margin.top + ')' })
	                .attr('width', availableWidth + margin.left + margin.right)
	                .attr('height', availableHeight + margin.top);
	
	            //index is currently global (within the chart), may or may not keep it that way
	            function updateValueLine() {
	                if (paused) return;
	
	                var hoverValue = g.selectAll('.nv-hoverValue').data(index);
	
	                var hoverEnter = hoverValue.enter()
	                    .append('g').attr('class', 'nv-hoverValue')
	                    .style('stroke-opacity', 0)
	                    .style('fill-opacity', 0);
	
	                hoverValue.exit()
	                    .transition().duration(250)
	                    .style('stroke-opacity', 0)
	                    .style('fill-opacity', 0)
	                    .remove();
	
	                hoverValue
	                    .attr('transform', function(d) { return 'translate(' + x(sparkline.x()(data[d],d)) + ',0)' })
	                    .transition().duration(250)
	                    .style('stroke-opacity', 1)
	                    .style('fill-opacity', 1);
	
	                if (!index.length) return;
	
	                hoverEnter.append('line')
	                    .attr('x1', 0)
	                    .attr('y1', -margin.top)
	                    .attr('x2', 0)
	                    .attr('y2', availableHeight);
	
	                hoverEnter.append('text').attr('class', 'nv-xValue')
	                    .attr('x', -6)
	                    .attr('y', -margin.top)
	                    .attr('text-anchor', 'end')
	                    .attr('dy', '.9em');
	
	                g.select('.nv-hoverValue .nv-xValue')
	                    .text(xTickFormat(sparkline.x()(data[index[0]], index[0])));
	
	                hoverEnter.append('text').attr('class', 'nv-yValue')
	                    .attr('x', 6)
	                    .attr('y', -margin.top)
	                    .attr('text-anchor', 'start')
	                    .attr('dy', '.9em');
	
	                g.select('.nv-hoverValue .nv-yValue')
	                    .text(yTickFormat(sparkline.y()(data[index[0]], index[0])));
	            }
	
	            function sparklineHover() {
	                if (paused) return;
	
	                var pos = d3.mouse(this)[0] - margin.left;
	
	                function getClosestIndex(data, x) {
	                    var distance = Math.abs(sparkline.x()(data[0], 0) - x);
	                    var closestIndex = 0;
	                    for (var i = 0; i < data.length; i++){
	                        if (Math.abs(sparkline.x()(data[i], i) - x) < distance) {
	                            distance = Math.abs(sparkline.x()(data[i], i) - x);
	                            closestIndex = i;
	                        }
	                    }
	                    return closestIndex;
	                }
	
	                index = [getClosestIndex(data, Math.round(x.invert(pos)))];
	                updateValueLine();
	            }
	
	        });
	        renderWatch.renderEnd('sparklinePlus immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.sparkline = sparkline;
	
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:           {get: function(){return width;}, set: function(_){width=_;}},
	        height:          {get: function(){return height;}, set: function(_){height=_;}},
	        xTickFormat:     {get: function(){return xTickFormat;}, set: function(_){xTickFormat=_;}},
	        yTickFormat:     {get: function(){return yTickFormat;}, set: function(_){yTickFormat=_;}},
	        showLastValue:   {get: function(){return showLastValue;}, set: function(_){showLastValue=_;}},
	        alignValue:      {get: function(){return alignValue;}, set: function(_){alignValue=_;}},
	        rightAlignValue: {get: function(){return rightAlignValue;}, set: function(_){rightAlignValue=_;}},
	        noData:          {get: function(){return noData;}, set: function(_){noData=_;}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, sparkline);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.stackedArea = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = 960
	        , height = 500
	        , color = nv.utils.defaultColor() // a function that computes the color
	        , id = Math.floor(Math.random() * 100000) //Create semi-unique ID incase user doesn't selet one
	        , container = null
	        , getX = function(d) { return d.x } // accessor to get the x value from a data point
	        , getY = function(d) { return d.y } // accessor to get the y value from a data point
	        , defined = function(d,i) { return !isNaN(getY(d,i)) && getY(d,i) !== null } // allows a line to be not continuous when it is not defined
	        , style = 'stack'
	        , offset = 'zero'
	        , order = 'default'
	        , interpolate = 'linear'  // controls the line interpolation
	        , clipEdge = false // if true, masks lines within x and y scale
	        , x //can be accessed via chart.xScale()
	        , y //can be accessed via chart.yScale()
	        , scatter = nv.models.scatter()
	        , duration = 250
	        , dispatch =  d3.dispatch('areaClick', 'areaMouseover', 'areaMouseout','renderEnd', 'elementClick', 'elementMouseover', 'elementMouseout')
	        ;
	
	    scatter
	        .pointSize(2.2) // default size
	        .pointDomain([2.2, 2.2]) // all the same size by default
	    ;
	
	    /************************************
	     * offset:
	     *   'wiggle' (stream)
	     *   'zero' (stacked)
	     *   'expand' (normalize to 100%)
	     *   'silhouette' (simple centered)
	     *
	     * order:
	     *   'inside-out' (stream)
	     *   'default' (input order)
	     ************************************/
	
	    var renderWatch = nv.utils.renderWatch(dispatch, duration);
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(scatter);
	        selection.each(function(data) {
	            var availableWidth = width - margin.left - margin.right,
	                availableHeight = height - margin.top - margin.bottom;
	
	            container = d3.select(this);
	            nv.utils.initSVG(container);
	
	            // Setup Scales
	            x = scatter.xScale();
	            y = scatter.yScale();
	
	            var dataRaw = data;
	            // Injecting point index into each point because d3.layout.stack().out does not give index
	            data.forEach(function(aseries, i) {
	                aseries.seriesIndex = i;
	                aseries.values = aseries.values.map(function(d, j) {
	                    d.index = j;
	                    d.seriesIndex = i;
	                    return d;
	                });
	            });
	
	            var dataFiltered = data.filter(function(series) {
	                return !series.disabled;
	            });
	
	            data = d3.layout.stack()
	                .order(order)
	                .offset(offset)
	                .values(function(d) { return d.values })  //TODO: make values customizeable in EVERY model in this fashion
	                .x(getX)
	                .y(getY)
	                .out(function(d, y0, y) {
	                    d.display = {
	                        y: y,
	                        y0: y0
	                    };
	                })
	            (dataFiltered);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-stackedarea').data([data]);
	            var wrapEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-stackedarea');
	            var defsEnter = wrapEnter.append('defs');
	            var gEnter = wrapEnter.append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-areaWrap');
	            gEnter.append('g').attr('class', 'nv-scatterWrap');
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	            
	            // If the user has not specified forceY, make sure 0 is included in the domain
	            // Otherwise, use user-specified values for forceY
	            if (scatter.forceY().length == 0) {
	                scatter.forceY().push(0);
	            }
	            
	            scatter
	                .width(availableWidth)
	                .height(availableHeight)
	                .x(getX)
	                .y(function(d) {
	                    if (d.display !== undefined) { return d.display.y + d.display.y0; }
	                })
	                .color(data.map(function(d,i) {
	                    d.color = d.color || color(d, d.seriesIndex);
	                    return d.color;
	                }));
	
	            var scatterWrap = g.select('.nv-scatterWrap')
	                .datum(data);
	
	            scatterWrap.call(scatter);
	
	            defsEnter.append('clipPath')
	                .attr('id', 'nv-edge-clip-' + id)
	                .append('rect');
	
	            wrap.select('#nv-edge-clip-' + id + ' rect')
	                .attr('width', availableWidth)
	                .attr('height', availableHeight);
	
	            g.attr('clip-path', clipEdge ? 'url(#nv-edge-clip-' + id + ')' : '');
	
	            var area = d3.svg.area()
	                .defined(defined)
	                .x(function(d,i)  { return x(getX(d,i)) })
	                .y0(function(d) {
	                    return y(d.display.y0)
	                })
	                .y1(function(d) {
	                    return y(d.display.y + d.display.y0)
	                })
	                .interpolate(interpolate);
	
	            var zeroArea = d3.svg.area()
	                .defined(defined)
	                .x(function(d,i)  { return x(getX(d,i)) })
	                .y0(function(d) { return y(d.display.y0) })
	                .y1(function(d) { return y(d.display.y0) });
	
	            var path = g.select('.nv-areaWrap').selectAll('path.nv-area')
	                .data(function(d) { return d });
	
	            path.enter().append('path').attr('class', function(d,i) { return 'nv-area nv-area-' + i })
	                .attr('d', function(d,i){
	                    return zeroArea(d.values, d.seriesIndex);
	                })
	                .on('mouseover', function(d,i) {
	                    d3.select(this).classed('hover', true);
	                    dispatch.areaMouseover({
	                        point: d,
	                        series: d.key,
	                        pos: [d3.event.pageX, d3.event.pageY],
	                        seriesIndex: d.seriesIndex
	                    });
	                })
	                .on('mouseout', function(d,i) {
	                    d3.select(this).classed('hover', false);
	                    dispatch.areaMouseout({
	                        point: d,
	                        series: d.key,
	                        pos: [d3.event.pageX, d3.event.pageY],
	                        seriesIndex: d.seriesIndex
	                    });
	                })
	                .on('click', function(d,i) {
	                    d3.select(this).classed('hover', false);
	                    dispatch.areaClick({
	                        point: d,
	                        series: d.key,
	                        pos: [d3.event.pageX, d3.event.pageY],
	                        seriesIndex: d.seriesIndex
	                    });
	                });
	
	            path.exit().remove();
	            path.style('fill', function(d,i){
	                    return d.color || color(d, d.seriesIndex)
	                })
	                .style('stroke', function(d,i){ return d.color || color(d, d.seriesIndex) });
	            path.watchTransition(renderWatch,'stackedArea path')
	                .attr('d', function(d,i) {
	                    return area(d.values,i)
	                });
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            scatter.dispatch.on('elementMouseover.area', function(e) {
	                g.select('.nv-chart-' + id + ' .nv-area-' + e.seriesIndex).classed('hover', true);
	            });
	            scatter.dispatch.on('elementMouseout.area', function(e) {
	                g.select('.nv-chart-' + id + ' .nv-area-' + e.seriesIndex).classed('hover', false);
	            });
	
	            //Special offset functions
	            chart.d3_stackedOffset_stackPercent = function(stackData) {
	                var n = stackData.length,    //How many series
	                    m = stackData[0].length,     //how many points per series
	                    i,
	                    j,
	                    o,
	                    y0 = [];
	
	                for (j = 0; j < m; ++j) { //Looping through all points
	                    for (i = 0, o = 0; i < dataRaw.length; i++) { //looping through all series
	                        o += getY(dataRaw[i].values[j]); //total y value of all series at a certian point in time.
	                    }
	
	                    if (o) for (i = 0; i < n; i++) { //(total y value of all series at point in time i) != 0
	                        stackData[i][j][1] /= o;
	                    } else { //(total y value of all series at point in time i) == 0
	                        for (i = 0; i < n; i++) {
	                            stackData[i][j][1] = 0;
	                        }
	                    }
	                }
	                for (j = 0; j < m; ++j) y0[j] = 0;
	                return y0;
	            };
	
	        });
	
	        renderWatch.renderEnd('stackedArea immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Global getters and setters
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.scatter = scatter;
	
	    scatter.dispatch.on('elementClick', function(){ dispatch.elementClick.apply(this, arguments); });
	    scatter.dispatch.on('elementMouseover', function(){ dispatch.elementMouseover.apply(this, arguments); });
	    scatter.dispatch.on('elementMouseout', function(){ dispatch.elementMouseout.apply(this, arguments); });
	
	    chart.interpolate = function(_) {
	        if (!arguments.length) return interpolate;
	        interpolate = _;
	        return chart;
	    };
	
	    chart.duration = function(_) {
	        if (!arguments.length) return duration;
	        duration = _;
	        renderWatch.reset(duration);
	        scatter.duration(duration);
	        return chart;
	    };
	
	    chart.dispatch = dispatch;
	    chart.scatter = scatter;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        defined: {get: function(){return defined;}, set: function(_){defined=_;}},
	        clipEdge: {get: function(){return clipEdge;}, set: function(_){clipEdge=_;}},
	        offset:      {get: function(){return offset;}, set: function(_){offset=_;}},
	        order:    {get: function(){return order;}, set: function(_){order=_;}},
	        interpolate:    {get: function(){return interpolate;}, set: function(_){interpolate=_;}},
	
	        // simple functor options
	        x:     {get: function(){return getX;}, set: function(_){getX = d3.functor(_);}},
	        y:     {get: function(){return getY;}, set: function(_){getY = d3.functor(_);}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	        }},
	        style: {get: function(){return style;}, set: function(_){
	            style = _;
	            switch (style) {
	                case 'stack':
	                    chart.offset('zero');
	                    chart.order('default');
	                    break;
	                case 'stream':
	                    chart.offset('wiggle');
	                    chart.order('inside-out');
	                    break;
	                case 'stream-center':
	                    chart.offset('silhouette');
	                    chart.order('inside-out');
	                    break;
	                case 'expand':
	                    chart.offset('expand');
	                    chart.order('default');
	                    break;
	                case 'stack_percent':
	                    chart.offset(chart.d3_stackedOffset_stackPercent);
	                    chart.order('default');
	                    break;
	            }
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	            scatter.duration(duration);
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, scatter);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.stackedAreaChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var stacked = nv.models.stackedArea()
	        , xAxis = nv.models.axis()
	        , yAxis = nv.models.axis()
	        , legend = nv.models.legend()
	        , controls = nv.models.legend()
	        , interactiveLayer = nv.interactiveGuideline()
	        , tooltip = nv.models.tooltip()
	        , focus = nv.models.focus(nv.models.stackedArea())
	        ;
	
	    var margin = {top: 10, right: 25, bottom: 50, left: 60}
	        , marginTop = null
	        , width = null
	        , height = null
	        , color = nv.utils.defaultColor()
	        , showControls = true
	        , showLegend = true
	        , legendPosition = 'top'
	        , showXAxis = true
	        , showYAxis = true
	        , rightAlignYAxis = false
	        , focusEnable = false
	        , useInteractiveGuideline = false
	        , showTotalInTooltip = true
	        , totalLabel = 'TOTAL'
	        , x //can be accessed via chart.xScale()
	        , y //can be accessed via chart.yScale()
	        , state = nv.utils.state()
	        , defaultState = null
	        , noData = null
	        , dispatch = d3.dispatch('stateChange', 'changeState','renderEnd')
	        , controlWidth = 250
	        , controlOptions = ['Stacked','Stream','Expanded']
	        , controlLabels = {}
	        , duration = 250
	        ;
	
	    state.style = stacked.style();
	    xAxis.orient('bottom').tickPadding(7);
	    yAxis.orient((rightAlignYAxis) ? 'right' : 'left');
	
	    tooltip
	        .headerFormatter(function(d, i) {
	            return xAxis.tickFormat()(d, i);
	        })
	        .valueFormatter(function(d, i) {
	            return yAxis.tickFormat()(d, i);
	        });
	
	    interactiveLayer.tooltip
	        .headerFormatter(function(d, i) {
	            return xAxis.tickFormat()(d, i);
	        })
	        .valueFormatter(function(d, i) {
	            return d == null ? "N/A" : yAxis.tickFormat()(d, i);
	        });
	
	    var oldYTickFormat = null,
	        oldValueFormatter = null;
	
	    controls.updateState(false);
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch);
	    var style = stacked.style();
	
	    var stateGetter = function(data) {
	        return function(){
	            return {
	                active: data.map(function(d) { return !d.disabled }),
	                style: stacked.style()
	            };
	        }
	    };
	
	    var stateSetter = function(data) {
	        return function(state) {
	            if (state.style !== undefined)
	                style = state.style;
	            if (state.active !== undefined)
	                data.forEach(function(series,i) {
	                    series.disabled = !state.active[i];
	                });
	        }
	    };
	
	    var percentFormatter = d3.format('%');
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(stacked);
	        if (showXAxis) renderWatch.models(xAxis);
	        if (showYAxis) renderWatch.models(yAxis);
	
	        selection.each(function(data) {
	            var container = d3.select(this),
	                that = this;
	            nv.utils.initSVG(container);
	
	            var availableWidth = nv.utils.availableWidth(width, container, margin),
	                availableHeight = nv.utils.availableHeight(height, container, margin) - (focusEnable ? focus.height() : 0);
	
	            chart.update = function() { container.transition().duration(duration).call(chart); };
	            chart.container = this;
	
	            state
	                .setter(stateSetter(data), chart.update)
	                .getter(stateGetter(data))
	                .update();
	
	            // DEPRECATED set state.disabled
	            state.disabled = data.map(function(d) { return !!d.disabled });
	
	            if (!defaultState) {
	                var key;
	                defaultState = {};
	                for (key in state) {
	                    if (state[key] instanceof Array)
	                        defaultState[key] = state[key].slice(0);
	                    else
	                        defaultState[key] = state[key];
	                }
	            }
	
	            // Display No Data message if there's nothing to show.
	            if (!data || !data.length || !data.filter(function(d) { return d.values.length }).length) {
	                nv.utils.noData(chart, container)
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	            // Setup Scales
	            x = stacked.xScale();
	            y = stacked.yScale();
	
	            // Setup containers and skeleton of chart
	            var wrap = container.selectAll('g.nv-wrap.nv-stackedAreaChart').data([data]);
	            var gEnter = wrap.enter().append('g').attr('class', 'nvd3 nv-wrap nv-stackedAreaChart').append('g');
	            var g = wrap.select('g');
	
	            gEnter.append('g').attr('class', 'nv-legendWrap');
	            gEnter.append('g').attr('class', 'nv-controlsWrap');
	
	            var focusEnter = gEnter.append('g').attr('class', 'nv-focus');
	            focusEnter.append('g').attr('class', 'nv-background').append('rect');
	            focusEnter.append('g').attr('class', 'nv-x nv-axis');
	            focusEnter.append('g').attr('class', 'nv-y nv-axis');
	            focusEnter.append('g').attr('class', 'nv-stackedWrap');
	            focusEnter.append('g').attr('class', 'nv-interactive');
	
	            // g.select("rect").attr("width",availableWidth).attr("height",availableHeight);
	
	            var contextEnter = gEnter.append('g').attr('class', 'nv-focusWrap');
	
	            // Legend
	            if (!showLegend) {
	                g.select('.nv-legendWrap').selectAll('*').remove();
	            } else {
	                var legendWidth = (showControls && legendPosition === 'top') ? availableWidth - controlWidth : availableWidth;
	
	                legend.width(legendWidth);
	                g.select('.nv-legendWrap').datum(data).call(legend);
	
	                if (legendPosition === 'bottom') {
	                	// constant from axis.js, plus some margin for better layout
	                	var xAxisHeight = (showXAxis ? 12 : 0) + 10;
	                   	margin.bottom = Math.max(legend.height() + xAxisHeight, margin.bottom);
	                   	availableHeight = nv.utils.availableHeight(height, container, margin) - (focusEnable ? focus.height() : 0);
	                	var legendTop = availableHeight + xAxisHeight;
	                    g.select('.nv-legendWrap')
	                        .attr('transform', 'translate(0,' + legendTop +')');
	                } else if (legendPosition === 'top') {
	                    if (!marginTop && margin.top != legend.height()) {
	                        margin.top = legend.height();
	                        availableHeight = nv.utils.availableHeight(height, container, margin) - (focusEnable ? focus.height() : 0);
	                    }
	
	                    g.select('.nv-legendWrap')
	                    	.attr('transform', 'translate(' + (availableWidth-legendWidth) + ',' + (-margin.top) +')');
	                }
	            }
	
	            // Controls
	            if (!showControls) {
	                 g.select('.nv-controlsWrap').selectAll('*').remove();
	            } else {
	                var controlsData = [
	                    {
	                        key: controlLabels.stacked || 'Stacked',
	                        metaKey: 'Stacked',
	                        disabled: stacked.style() != 'stack',
	                        style: 'stack'
	                    },
	                    {
	                        key: controlLabels.stream || 'Stream',
	                        metaKey: 'Stream',
	                        disabled: stacked.style() != 'stream',
	                        style: 'stream'
	                    },
	                    {
	                        key: controlLabels.expanded || 'Expanded',
	                        metaKey: 'Expanded',
	                        disabled: stacked.style() != 'expand',
	                        style: 'expand'
	                    },
	                    {
	                        key: controlLabels.stack_percent || 'Stack %',
	                        metaKey: 'Stack_Percent',
	                        disabled: stacked.style() != 'stack_percent',
	                        style: 'stack_percent'
	                    }
	                ];
	
	                controlWidth = (controlOptions.length/3) * 260;
	                controlsData = controlsData.filter(function(d) {
	                    return controlOptions.indexOf(d.metaKey) !== -1;
	                });
	
	                controls
	                    .width( controlWidth )
	                    .color(['#444', '#444', '#444']);
	
	                g.select('.nv-controlsWrap')
	                    .datum(controlsData)
	                    .call(controls);
	
	                var requiredTop = Math.max(controls.height(), showLegend && (legendPosition === 'top') ? legend.height() : 0);
	
	                if ( margin.top != requiredTop ) {
	                    margin.top = requiredTop;
	                    availableHeight = nv.utils.availableHeight(height, container, margin) - (focusEnable ? focus.height() : 0);
	                }
	
	                g.select('.nv-controlsWrap')
	                    .attr('transform', 'translate(0,' + (-margin.top) +')');
	            }
	
	            wrap.attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
	
	            if (rightAlignYAxis) {
	                g.select(".nv-y.nv-axis")
	                    .attr("transform", "translate(" + availableWidth + ",0)");
	            }
	
	            //Set up interactive layer
	            if (useInteractiveGuideline) {
	                interactiveLayer
	                    .width(availableWidth)
	                    .height(availableHeight)
	                    .margin({left: margin.left, top: margin.top})
	                    .svgContainer(container)
	                    .xScale(x);
	                wrap.select(".nv-interactive").call(interactiveLayer);
	            }
	
	            g.select('.nv-focus .nv-background rect')
	                .attr('width', availableWidth)
	                .attr('height', availableHeight);
	
	            stacked
	                .width(availableWidth)
	                .height(availableHeight)
	                .color(data.map(function(d,i) {
	                    return d.color || color(d, i);
	                }).filter(function(d,i) { return !data[i].disabled; }));
	
	            var stackedWrap = g.select('.nv-focus .nv-stackedWrap')
	                .datum(data.filter(function(d) { return !d.disabled; }));
	
	            // Setup Axes
	            if (showXAxis) {
	                xAxis.scale(x)
	                    ._ticks( nv.utils.calcTicksX(availableWidth/100, data) )
	                    .tickSize( -availableHeight, 0);
	            }
	
	            if (showYAxis) {
	                var ticks;
	                if (stacked.offset() === 'wiggle') {
	                    ticks = 0;
	                }
	                else {
	                    ticks = nv.utils.calcTicksY(availableHeight/36, data);
	                }
	                yAxis.scale(y)
	                    ._ticks(ticks)
	                    .tickSize(-availableWidth, 0);
	            }
	
	            //============================================================
	            // Update Axes
	            //============================================================
	            function updateXAxis() {
	                if(showXAxis) {
	                    g.select('.nv-focus .nv-x.nv-axis')
	                        .attr('transform', 'translate(0,' + availableHeight + ')')
	                        .transition()
	                        .duration(duration)
	                        .call(xAxis)
	                        ;
	                }
	            }
	
	            function updateYAxis() {
	                if(showYAxis) {
	                    if (stacked.style() === 'expand' || stacked.style() === 'stack_percent') {
	                        var currentFormat = yAxis.tickFormat();
	
	                        if ( !oldYTickFormat || currentFormat !== percentFormatter )
	                            oldYTickFormat = currentFormat;
	
	                        //Forces the yAxis to use percentage in 'expand' mode.
	                        yAxis.tickFormat(percentFormatter);
	                    }
	                    else {
	                        if (oldYTickFormat) {
	                            yAxis.tickFormat(oldYTickFormat);
	                            oldYTickFormat = null;
	                        }
	                    }
	
	                    g.select('.nv-focus .nv-y.nv-axis')
	                    .transition().duration(0)
	                    .call(yAxis);
	                }
	            }
	
	            //============================================================
	            // Update Focus
	            //============================================================
	            if(!focusEnable) {
	                stackedWrap.transition().call(stacked);
	                updateXAxis();
	                updateYAxis();
	            } else {
	                focus.width(availableWidth);
	                g.select('.nv-focusWrap')
	                    .attr('transform', 'translate(0,' + ( availableHeight + margin.bottom + focus.margin().top) + ')')
	                    .datum(data.filter(function(d) { return !d.disabled; }))
	                    .call(focus);
	                var extent = focus.brush.empty() ? focus.xDomain() : focus.brush.extent();
	                if(extent !== null){
	                    onBrush(extent);
	                }
	            }
	
	            //============================================================
	            // Event Handling/Dispatching (in chart's scope)
	            //------------------------------------------------------------
	
	            stacked.dispatch.on('areaClick.toggle', function(e) {
	                if (data.filter(function(d) { return !d.disabled }).length === 1)
	                    data.forEach(function(d) {
	                        d.disabled = false;
	                    });
	                else
	                    data.forEach(function(d,i) {
	                        d.disabled = (i != e.seriesIndex);
	                    });
	
	                state.disabled = data.map(function(d) { return !!d.disabled });
	                dispatch.stateChange(state);
	
	                chart.update();
	            });
	
	            legend.dispatch.on('stateChange', function(newState) {
	                for (var key in newState)
	                    state[key] = newState[key];
	                dispatch.stateChange(state);
	                chart.update();
	            });
	
	            controls.dispatch.on('legendClick', function(d,i) {
	                if (!d.disabled) return;
	
	                controlsData = controlsData.map(function(s) {
	                    s.disabled = true;
	                    return s;
	                });
	                d.disabled = false;
	
	                stacked.style(d.style);
	
	
	                state.style = stacked.style();
	                dispatch.stateChange(state);
	
	                chart.update();
	            });
	
	            interactiveLayer.dispatch.on('elementMousemove', function(e) {
	                stacked.clearHighlights();
	                var singlePoint, pointIndex, pointXLocation, allData = [], valueSum = 0, allNullValues = true, atleastOnePoint = false;
	                data
	                    .filter(function(series, i) {
	                        series.seriesIndex = i;
	                        return !series.disabled;
	                    })
	                    .forEach(function(series,i) {
	                        pointIndex = nv.interactiveBisect(series.values, e.pointXValue, chart.x());
	                        var point = series.values[pointIndex];
	                        var pointYValue = chart.y()(point, pointIndex);
	                        if (pointYValue != null && pointYValue > 0) {
	                            stacked.highlightPoint(i, pointIndex, true);
	                            atleastOnePoint = true;
	                        }
	                    
	                        // Draw at least one point if all values are zero.
	                        if (i === (data.length - 1) && !atleastOnePoint) {
	                            stacked.highlightPoint(i, pointIndex, true);
	                        }
	                        if (typeof point === 'undefined') return;
	                        if (typeof singlePoint === 'undefined') singlePoint = point;
	                        if (typeof pointXLocation === 'undefined') pointXLocation = chart.xScale()(chart.x()(point,pointIndex));
	
	                        //If we are in 'expand' mode, use the stacked percent value instead of raw value.
	                        var tooltipValue = (stacked.style() == 'expand') ? point.display.y : chart.y()(point,pointIndex);
	                        allData.push({
	                            key: series.key,
	                            value: tooltipValue,
	                            color: color(series,series.seriesIndex),
	                            point: point
	                        });
	
	                        if (showTotalInTooltip && stacked.style() != 'expand' && tooltipValue != null) {
	                          valueSum += tooltipValue;
	                          allNullValues = false;
	                        };
	                    });
	
	                allData.reverse();
	
	                //Highlight the tooltip entry based on which stack the mouse is closest to.
	                if (allData.length > 2) {
	                    var yValue = chart.yScale().invert(e.mouseY);
	                    var yDistMax = Infinity, indexToHighlight = null;
	                    allData.forEach(function(series,i) {
	
	                        //To handle situation where the stacked area chart is negative, we need to use absolute values
	                        //when checking if the mouse Y value is within the stack area.
	                        yValue = Math.abs(yValue);
	                        var stackedY0 = Math.abs(series.point.display.y0);
	                        var stackedY = Math.abs(series.point.display.y);
	                        if ( yValue >= stackedY0 && yValue <= (stackedY + stackedY0))
	                        {
	                            indexToHighlight = i;
	                            return;
	                        }
	                    });
	                    if (indexToHighlight != null)
	                        allData[indexToHighlight].highlight = true;
	                }
	
	                //If we are not in 'expand' mode, add a 'Total' row to the tooltip.
	                if (showTotalInTooltip && stacked.style() != 'expand' && allData.length >= 2 && !allNullValues) {
	                    allData.push({
	                        key: totalLabel,
	                        value: valueSum,
	                        total: true
	                    });
	                }
	
	                var xValue = chart.x()(singlePoint,pointIndex);
	
	                var valueFormatter = interactiveLayer.tooltip.valueFormatter();
	                // Keeps track of the tooltip valueFormatter if the chart changes to expanded view
	                if (stacked.style() === 'expand' || stacked.style() === 'stack_percent') {
	                    if ( !oldValueFormatter ) {
	                        oldValueFormatter = valueFormatter;
	                    }
	                    //Forces the tooltip to use percentage in 'expand' mode.
	                    valueFormatter = d3.format(".1%");
	                }
	                else {
	                    if (oldValueFormatter) {
	                        valueFormatter = oldValueFormatter;
	                        oldValueFormatter = null;
	                    }
	                }
	
	                interactiveLayer.tooltip
	                    .valueFormatter(valueFormatter)
	                    .data(
	                    {
	                        value: xValue,
	                        series: allData
	                    }
	                )();
	
	                interactiveLayer.renderGuideLine(pointXLocation);
	
	            });
	
	            interactiveLayer.dispatch.on("elementMouseout",function(e) {
	                stacked.clearHighlights();
	            });
	
	            /* Update `main' graph on brush update. */
	            focus.dispatch.on("onBrush", function(extent) {
	                onBrush(extent);
	            });
	
	            // Update chart from a state object passed to event handler
	            dispatch.on('changeState', function(e) {
	
	                if (typeof e.disabled !== 'undefined' && data.length === e.disabled.length) {
	                    data.forEach(function(series,i) {
	                        series.disabled = e.disabled[i];
	                    });
	
	                    state.disabled = e.disabled;
	                }
	
	                if (typeof e.style !== 'undefined') {
	                    stacked.style(e.style);
	                    style = e.style;
	                }
	
	                chart.update();
	            });
	
	            //============================================================
	            // Functions
	            //------------------------------------------------------------
	
	            function onBrush(extent) {
	                // Update Main (Focus)
	                var stackedWrap = g.select('.nv-focus .nv-stackedWrap')
	                    .datum(
	                    data.filter(function(d) { return !d.disabled; })
	                        .map(function(d,i) {
	                            return {
	                                key: d.key,
	                                area: d.area,
	                                classed: d.classed,
	                                values: d.values.filter(function(d,i) {
	                                    return stacked.x()(d,i) >= extent[0] && stacked.x()(d,i) <= extent[1];
	                                }),
	                                disableTooltip: d.disableTooltip
	                            };
	                        })
	                );
	                stackedWrap.transition().duration(duration).call(stacked);
	
	                // Update Main (Focus) Axes
	                updateXAxis();
	                updateYAxis();
	            }
	
	        });
	
	        renderWatch.renderEnd('stacked Area chart immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    stacked.dispatch.on('elementMouseover.tooltip', function(evt) {
	        evt.point['x'] = stacked.x()(evt.point);
	        evt.point['y'] = stacked.y()(evt.point);
	        tooltip.data(evt).hidden(false);
	    });
	
	    stacked.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true)
	    });
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.stacked = stacked;
	    chart.legend = legend;
	    chart.controls = controls;
	    chart.xAxis = xAxis;
	    chart.x2Axis = focus.xAxis;
	    chart.yAxis = yAxis;
	    chart.y2Axis = focus.yAxis;
	    chart.interactiveLayer = interactiveLayer;
	    chart.tooltip = tooltip;
	    chart.focus = focus;
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        showLegend: {get: function(){return showLegend;}, set: function(_){showLegend=_;}},
	        legendPosition: {get: function(){return legendPosition;}, set: function(_){legendPosition=_;}},
	        showXAxis:      {get: function(){return showXAxis;}, set: function(_){showXAxis=_;}},
	        showYAxis:    {get: function(){return showYAxis;}, set: function(_){showYAxis=_;}},
	        defaultState:    {get: function(){return defaultState;}, set: function(_){defaultState=_;}},
	        noData:    {get: function(){return noData;}, set: function(_){noData=_;}},
	        showControls:    {get: function(){return showControls;}, set: function(_){showControls=_;}},
	        controlLabels:    {get: function(){return controlLabels;}, set: function(_){controlLabels=_;}},
	        controlOptions:    {get: function(){return controlOptions;}, set: function(_){controlOptions=_;}},
	        showTotalInTooltip:      {get: function(){return showTotalInTooltip;}, set: function(_){showTotalInTooltip=_;}},
	        totalLabel:      {get: function(){return totalLabel;}, set: function(_){totalLabel=_;}},
	        focusEnable:    {get: function(){return focusEnable;}, set: function(_){focusEnable=_;}},
	        focusHeight:     {get: function(){return focus.height();}, set: function(_){focus.height(_);}},
	        brushExtent: {get: function(){return focus.brushExtent();}, set: function(_){focus.brushExtent(_);}},
	
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            if (_.top !== undefined) {
	                margin.top = _.top;
	                marginTop = _.top;
	            }
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	        }},
	        focusMargin: {get: function(){return focus.margin}, set: function(_){
	            focus.margin.top    = _.top    !== undefined ? _.top    : focus.margin.top;
	            focus.margin.right  = _.right  !== undefined ? _.right  : focus.margin.right;
	            focus.margin.bottom = _.bottom !== undefined ? _.bottom : focus.margin.bottom;
	            focus.margin.left   = _.left   !== undefined ? _.left   : focus.margin.left;
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	            stacked.duration(duration);
	            xAxis.duration(duration);
	            yAxis.duration(duration);
	        }},
	        color:  {get: function(){return color;}, set: function(_){
	            color = nv.utils.getColor(_);
	            legend.color(color);
	            stacked.color(color);
	            focus.color(color);
	        }},
	        x: {get: function(){return stacked.x();}, set: function(_){
	            stacked.x(_);
	            focus.x(_);
	        }},
	        y: {get: function(){return stacked.y();}, set: function(_){
	            stacked.y(_);
	            focus.y(_);
	        }},
	        rightAlignYAxis: {get: function(){return rightAlignYAxis;}, set: function(_){
	            rightAlignYAxis = _;
	            yAxis.orient( rightAlignYAxis ? 'right' : 'left');
	        }},
	        useInteractiveGuideline: {get: function(){return useInteractiveGuideline;}, set: function(_){
	            useInteractiveGuideline = !!_;
	            chart.interactive(!_);
	            chart.useVoronoi(!_);
	            stacked.scatter.interactive(!_);
	        }}
	    });
	
	    nv.utils.inheritOptions(chart, stacked);
	    nv.utils.initOptions(chart);
	
	    return chart;
	};
	
	nv.models.stackedAreaWithFocusChart = function() {
	  return nv.models.stackedAreaChart()
	    .margin({ bottom: 30 })
	    .focusEnable( true );
	};
	// based on http://bl.ocks.org/kerryrodden/477c1bfb081b783f80ad
	nv.models.sunburst = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var margin = {top: 0, right: 0, bottom: 0, left: 0}
	        , width = 600
	        , height = 600
	        , mode = "count"
	        , modes = {count: function(d) { return 1; }, value: function(d) { return d.value || d.size }, size: function(d) { return d.value || d.size }}
	        , id = Math.floor(Math.random() * 10000) //Create semi-unique ID in case user doesn't select one
	        , container = null
	        , color = nv.utils.defaultColor()
	        , showLabels = false
	        , labelFormat = function(d){if(mode === 'count'){return d.name + ' #' + d.value}else{return d.name + ' ' + (d.value || d.size)}}
	        , labelThreshold = 0.02
	        , sort = function(d1, d2){return d1.name > d2.name;}
	        , key = function(d,i){
	            if (d.parent !== undefined) {
	                return d.name + '-' + d.parent.name + '-' + i;
	            } else {
	                return d.name;
	            }
	        }
	        , groupColorByParent = true
	        , duration = 500
	        , dispatch = d3.dispatch('chartClick', 'elementClick', 'elementDblClick', 'elementMousemove', 'elementMouseover', 'elementMouseout', 'renderEnd');
	
	    //============================================================
	    // aux functions and setup
	    //------------------------------------------------------------
	
	    var x = d3.scale.linear().range([0, 2 * Math.PI]);
	    var y = d3.scale.sqrt();
	
	    var partition = d3.layout.partition().sort(sort);
	
	    var node, availableWidth, availableHeight, radius;
	    var prevPositions = {};
	
	    var arc = d3.svg.arc()
	        .startAngle(function(d) {return Math.max(0, Math.min(2 * Math.PI, x(d.x))) })
	        .endAngle(function(d) {return Math.max(0, Math.min(2 * Math.PI, x(d.x + d.dx))) })
	        .innerRadius(function(d) {return Math.max(0, y(d.y)) })
	        .outerRadius(function(d) {return Math.max(0, y(d.y + d.dy)) });
	
	    function rotationToAvoidUpsideDown(d) {
	        var centerAngle = computeCenterAngle(d);
	        if(centerAngle > 90){
	            return 180;
	        }
	        else {
	            return 0;
	        }
	    }
	
	    function computeCenterAngle(d) {
	        var startAngle = Math.max(0, Math.min(2 * Math.PI, x(d.x)));
	        var endAngle = Math.max(0, Math.min(2 * Math.PI, x(d.x + d.dx)));
	        var centerAngle = (((startAngle + endAngle) / 2) * (180 / Math.PI)) - 90;
	        return centerAngle;
	    }
	
	    function computeNodePercentage(d) {
	        var startAngle = Math.max(0, Math.min(2 * Math.PI, x(d.x)));
	        var endAngle = Math.max(0, Math.min(2 * Math.PI, x(d.x + d.dx)));
	        return (endAngle - startAngle) / (2 * Math.PI);
	    }
	
	    function labelThresholdMatched(d) {
	        var startAngle = Math.max(0, Math.min(2 * Math.PI, x(d.x)));
	        var endAngle = Math.max(0, Math.min(2 * Math.PI, x(d.x + d.dx)));
	
	        var size = endAngle - startAngle;
	        return size > labelThreshold;
	    }
	
	    // When zooming: interpolate the scales.
	    function arcTweenZoom(e,i) {
	        var xd = d3.interpolate(x.domain(), [node.x, node.x + node.dx]),
	        yd = d3.interpolate(y.domain(), [node.y, 1]),
	        yr = d3.interpolate(y.range(), [node.y ? 20 : 0, radius]);
	
	        if (i === 0) {
	            return function() {return arc(e);}
	        }
	        else {
	            return function (t) {
	                x.domain(xd(t));
	                y.domain(yd(t)).range(yr(t));
	                return arc(e);
	            }
	        };
	    }
	
	    function arcTweenUpdate(d) {
	        var ipo = d3.interpolate({x: d.x0, dx: d.dx0, y: d.y0, dy: d.dy0}, d);
	
	        return function (t) {
	            var b = ipo(t);
	
	            d.x0 = b.x;
	            d.dx0 = b.dx;
	            d.y0 = b.y;
	            d.dy0 = b.dy;
	
	            return arc(b);
	        };
	    }
	
	    function updatePrevPosition(node) {
	        var k = key(node);
	        if(! prevPositions[k]) prevPositions[k] = {};
	        var pP = prevPositions[k];
	        pP.dx = node.dx;
	        pP.x = node.x;
	        pP.dy = node.dy;
	        pP.y = node.y;
	    }
	
	    function storeRetrievePrevPositions(nodes) {
	        nodes.forEach(function(n){
	            var k = key(n);
	            var pP = prevPositions[k];
	            //console.log(k,n,pP);
	            if( pP ){
	                n.dx0 = pP.dx;
	                n.x0 = pP.x;
	                n.dy0 = pP.dy;
	                n.y0 = pP.y;
	            }
	            else {
	                n.dx0 = n.dx;
	                n.x0 = n.x;
	                n.dy0 = n.dy;
	                n.y0 = n.y;
	            }
	            updatePrevPosition(n);
	        });
	    }
	
	    function zoomClick(d) {
	        var labels = container.selectAll('text')
	        var path = container.selectAll('path')
	
	        // fade out all text elements
	        labels.transition().attr("opacity",0);
	
	        // to allow reference to the new center node
	        node = d;
	
	        path.transition()
	            .duration(duration)
	            .attrTween("d", arcTweenZoom)
	            .each('end', function(e) {
	                // partially taken from here: http://bl.ocks.org/metmajer/5480307
	                // check if the animated element's data e lies within the visible angle span given in d
	                if(e.x >= d.x && e.x < (d.x + d.dx) ){
	                    if(e.depth >= d.depth){
	                        // get a selection of the associated text element
	                        var parentNode = d3.select(this.parentNode);
	                        var arcText = parentNode.select('text');
	
	                        // fade in the text element and recalculate positions
	                        arcText.transition().duration(duration)
	                        .text( function(e){return labelFormat(e) })
	                        .attr("opacity", function(d){
	                            if(labelThresholdMatched(d)) {
	                                return 1;
	                            }
	                            else {
	                                return 0;
	                            }
	                        })
	                        .attr("transform", function() {
	                            var width = this.getBBox().width;
	                            if(e.depth === 0)
	                            return "translate(" + (width / 2 * - 1) + ",0)";
	                            else if(e.depth === d.depth){
	                                return "translate(" + (y(e.y) + 5) + ",0)";
	                            }
	                            else {
	                                var centerAngle = computeCenterAngle(e);
	                                var rotation = rotationToAvoidUpsideDown(e);
	                                if (rotation === 0) {
	                                    return 'rotate('+ centerAngle +')translate(' + (y(e.y) + 5) + ',0)';
	                                }
	                                else {
	                                    return 'rotate('+ centerAngle +')translate(' + (y(e.y) + width + 5) + ',0)rotate(' + rotation + ')';
	                                }
	                            }
	                        });
	                    }
	                }
	            })
	    }
	
	    //============================================================
	    // chart function
	    //------------------------------------------------------------
	    var renderWatch = nv.utils.renderWatch(dispatch);
	
	    function chart(selection) {
	        renderWatch.reset();
	
	        selection.each(function(data) {
	            container = d3.select(this);
	            availableWidth = nv.utils.availableWidth(width, container, margin);
	            availableHeight = nv.utils.availableHeight(height, container, margin);
	            radius = Math.min(availableWidth, availableHeight) / 2;
	
	            y.range([0, radius]);
	
	            // Setup containers and skeleton of chart
	            var wrap = container.select('g.nvd3.nv-wrap.nv-sunburst');
	            if( !wrap[0][0] ) {
	                wrap = container.append('g')
	                    .attr('class', 'nvd3 nv-wrap nv-sunburst nv-chart-' + id)
	                    .attr('transform', 'translate(' + ((availableWidth / 2) + margin.left + margin.right) + ',' + ((availableHeight / 2) + margin.top + margin.bottom) + ')');
	            } else {
	                wrap.attr('transform', 'translate(' + ((availableWidth / 2) + margin.left + margin.right) + ',' + ((availableHeight / 2) + margin.top + margin.bottom) + ')');
	            }
	
	            container.on('click', function (d, i) {
	                dispatch.chartClick({
	                    data: d,
	                    index: i,
	                    pos: d3.event,
	                    id: id
	                });
	            });
	
	            partition.value(modes[mode] || modes["count"]);
	
	            //reverse the drawing order so that the labels of inner
	            //arcs are drawn on top of the outer arcs.
	            var nodes = partition.nodes(data[0]).reverse()
	
	            storeRetrievePrevPositions(nodes);
	            var cG = wrap.selectAll('.arc-container').data(nodes, key)
	
	            //handle new datapoints
	            var cGE = cG.enter()
	                .append("g")
	                .attr("class",'arc-container')
	
	            cGE.append("path")
	                .attr("d", arc)
	                .style("fill", function (d) {
	                    if (d.color) {
	                        return d.color;
	                    }
	                    else if (groupColorByParent) {
	                        return color((d.children ? d : d.parent).name);
	                    }
	                    else {
	                        return color(d.name);
	                    }
	                })
	                .style("stroke", "#FFF")
	                .on("click", function(d,i){
	                    zoomClick(d);
	                    dispatch.elementClick({
	                        data: d,
	                        index: i
	                    })
	                })
	                .on('mouseover', function(d,i){
	                    d3.select(this).classed('hover', true).style('opacity', 0.8);
	                    dispatch.elementMouseover({
	                        data: d,
	                        color: d3.select(this).style("fill"),
	                        percent: computeNodePercentage(d)
	                    });
	                })
	                .on('mouseout', function(d,i){
	                    d3.select(this).classed('hover', false).style('opacity', 1);
	                    dispatch.elementMouseout({
	                        data: d
	                    });
	                })
	                .on('mousemove', function(d,i){
	                    dispatch.elementMousemove({
	                        data: d
	                    });
	                });
	
	            ///Iterating via each and selecting based on the this
	            ///makes it work ... a cG.selectAll('path') doesn't.
	            ///Without iteration the data (in the element) didn't update.
	            cG.each(function(d){
	                d3.select(this).select('path')
	                    .transition()
	                    .duration(duration)
	                    .attrTween('d', arcTweenUpdate);
	            });
	
	            if(showLabels){
	                //remove labels first and add them back
	                cG.selectAll('text').remove();
	
	                //this way labels are on top of newly added arcs
	                cG.append('text')
	                    .text( function(e){ return labelFormat(e)})
	                    .transition()
	                    .duration(duration)
	                    .attr("opacity", function(d){
	                        if(labelThresholdMatched(d)) {
	                            return 1;
	                        }
	                        else {
	                            return 0;
	                        }
	                    })
	                    .attr("transform", function(d) {
	                        var width = this.getBBox().width;
	                        if(d.depth === 0){
	                            return "rotate(0)translate(" + (width / 2 * -1) + ",0)";
	                        }
	                        else {
	                            var centerAngle = computeCenterAngle(d);
	                            var rotation = rotationToAvoidUpsideDown(d);
	                            if (rotation === 0) {
	                                return 'rotate('+ centerAngle +')translate(' + (y(d.y) + 5) + ',0)';
	                            }
	                            else {
	                                return 'rotate('+ centerAngle +')translate(' + (y(d.y) + width + 5) + ',0)rotate(' + rotation + ')';
	                            }
	                        }
	                    });
	            }
	
	            //zoom out to the center when the data is updated.
	            zoomClick(nodes[nodes.length - 1])
	
	
	            //remove unmatched elements ...
	            cG.exit()
	                .transition()
	                .duration(duration)
	                .attr('opacity',0)
	                .each('end',function(d){
	                    var k = key(d);
	                    prevPositions[k] = undefined;
	                })
	                .remove();
	        });
	
	
	        renderWatch.renderEnd('sunburst immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    chart.dispatch = dispatch;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        width:      {get: function(){return width;}, set: function(_){width=_;}},
	        height:     {get: function(){return height;}, set: function(_){height=_;}},
	        mode:       {get: function(){return mode;}, set: function(_){mode=_;}},
	        id:         {get: function(){return id;}, set: function(_){id=_;}},
	        duration:   {get: function(){return duration;}, set: function(_){duration=_;}},
	        groupColorByParent: {get: function(){return groupColorByParent;}, set: function(_){groupColorByParent=!!_;}},
	        showLabels: {get: function(){return showLabels;}, set: function(_){showLabels=!!_}},
	        labelFormat: {get: function(){return labelFormat;}, set: function(_){labelFormat=_}},
	        labelThreshold: {get: function(){return labelThreshold;}, set: function(_){labelThreshold=_}},
	        sort: {get: function(){return sort;}, set: function(_){sort=_}},
	        key: {get: function(){return key;}, set: function(_){key=_}},
	        // options that require extra logic in the setter
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    != undefined ? _.top    : margin.top;
	            margin.right  = _.right  != undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom != undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   != undefined ? _.left   : margin.left;
	        }},
	        color: {get: function(){return color;}, set: function(_){
	            color=nv.utils.getColor(_);
	        }}
	    });
	
	    nv.utils.initOptions(chart);
	    return chart;
	};
	nv.models.sunburstChart = function() {
	    "use strict";
	
	    //============================================================
	    // Public Variables with Default Settings
	    //------------------------------------------------------------
	
	    var sunburst = nv.models.sunburst();
	    var tooltip = nv.models.tooltip();
	
	    var margin = {top: 30, right: 20, bottom: 20, left: 20}
	        , width = null
	        , height = null
	        , color = nv.utils.defaultColor()
	        , showTooltipPercent = false
	        , id = Math.round(Math.random() * 100000)
	        , defaultState = null
	        , noData = null
	        , duration = 250
	        , dispatch = d3.dispatch('stateChange', 'changeState','renderEnd');
	
	
	    //============================================================
	    // Private Variables
	    //------------------------------------------------------------
	
	    var renderWatch = nv.utils.renderWatch(dispatch);
	
	    tooltip
	        .duration(0)
	        .headerEnabled(false)
	        .valueFormatter(function(d){return d;});
	
	    //============================================================
	    // Chart function
	    //------------------------------------------------------------
	
	    function chart(selection) {
	        renderWatch.reset();
	        renderWatch.models(sunburst);
	
	        selection.each(function(data) {
	            var container = d3.select(this);
	
	            nv.utils.initSVG(container);
	
	            var availableWidth = nv.utils.availableWidth(width, container, margin);
	            var availableHeight = nv.utils.availableHeight(height, container, margin);
	
	            chart.update = function() {
	                if (duration === 0) {
	                    container.call(chart);
	                } else {
	                    container.transition().duration(duration).call(chart);
	                }
	            };
	            chart.container = container;
	
	            // Display No Data message if there's nothing to show.
	            if (!data || !data.length) {
	                nv.utils.noData(chart, container);
	                return chart;
	            } else {
	                container.selectAll('.nv-noData').remove();
	            }
	
	            sunburst.width(availableWidth).height(availableHeight).margin(margin);
	            container.call(sunburst);
	        });
	
	        renderWatch.renderEnd('sunburstChart immediate');
	        return chart;
	    }
	
	    //============================================================
	    // Event Handling/Dispatching (out of chart's scope)
	    //------------------------------------------------------------
	
	    sunburst.dispatch.on('elementMouseover.tooltip', function(evt) {
	        evt.series = {
	            key: evt.data.name,
	            value: (evt.data.value || evt.data.size),
	            color: evt.color,
	            percent: evt.percent
	        };
	        if (!showTooltipPercent) {
	            delete evt.percent;
	            delete evt.series.percent;
	        }
	        tooltip.data(evt).hidden(false);
	    });
	
	    sunburst.dispatch.on('elementMouseout.tooltip', function(evt) {
	        tooltip.hidden(true);
	    });
	
	    sunburst.dispatch.on('elementMousemove.tooltip', function(evt) {
	        tooltip();
	    });
	
	    //============================================================
	    // Expose Public Variables
	    //------------------------------------------------------------
	
	    // expose chart's sub-components
	    chart.dispatch = dispatch;
	    chart.sunburst = sunburst;
	    chart.tooltip = tooltip;
	    chart.options = nv.utils.optionsFunc.bind(chart);
	
	    // use Object get/set functionality to map between vars and chart functions
	    chart._options = Object.create({}, {
	        // simple options, just get/set the necessary values
	        noData:             {get: function(){return noData;},               set: function(_){noData=_;}},
	        defaultState:       {get: function(){return defaultState;},         set: function(_){defaultState=_;}},
	        showTooltipPercent: {get: function(){return showTooltipPercent;},   set: function(_){showTooltipPercent=_;}},
	
	        // options that require extra logic in the setter
	        color: {get: function(){return color;}, set: function(_){
	            color = _;
	            sunburst.color(color);
	        }},
	        duration: {get: function(){return duration;}, set: function(_){
	            duration = _;
	            renderWatch.reset(duration);
	            sunburst.duration(duration);
	        }},
	        margin: {get: function(){return margin;}, set: function(_){
	            margin.top    = _.top    !== undefined ? _.top    : margin.top;
	            margin.right  = _.right  !== undefined ? _.right  : margin.right;
	            margin.bottom = _.bottom !== undefined ? _.bottom : margin.bottom;
	            margin.left   = _.left   !== undefined ? _.left   : margin.left;
	            sunburst.margin(margin);
	        }}
	    });
	    nv.utils.inheritOptions(chart, sunburst);
	    nv.utils.initOptions(chart);
	    return chart;
	
	};
	
	nv.version = "1.8.6";
	})();
	//# sourceMappingURL=nv.d3.js.map
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = nv;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	/* 
	 * An Angular service which helps with creating recursive directives.
	 * @author Mark Lagendijk
	 * @license MIT
	 */
	angular.module('RecursionHelper', []).factory('RecursionHelper', ['$compile', function($compile){
		return {
			/**
			 * Manually compiles the element, fixing the recursion loop.
			 * @param element
			 * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
			 * @returns An object containing the linking functions.
			 */
			compile: function(element, link){
				// Normalize the link parameter
				if(angular.isFunction(link)){
					link = { post: link };
				}
	
				// Break the recursion loop by removing the contents
				var contents = element.contents().remove();
				var compiledContents;
				return {
					pre: (link && link.pre) ? link.pre : null,
					/**
					 * Compiles and re-adds the contents
					 */
					post: function(scope, element){
						// Compile the contents
						if(!compiledContents){
							compiledContents = $compile(contents);
						}
						// Re-add the compiled contents to the element
						compiledContents(scope, function(clone){
							element.append(clone);
						});
	
						// Call the post-linking function, if any
						if(link && link.post){
							link.post.apply(null, arguments);
						}
					}
				};
			}
		};
	}]);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// vendor-2.0.88.bundle.js